(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire31d0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire31d0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("460Qg", function(module, exports) {
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './blockly'
    ], factory);
    else module.exports = factory((parcelRequire("fhxSA")));
})(module.exports, function(Blockly) {
    /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly core module for the browser. It includes blockly.js
 *               and adds a helper method for setting the locale.
 */ /* eslint-disable */ 'use strict';
    // Add a helper method to set the Blockly locale.
    Blockly.setLocale = function(locale) {
        Blockly.Msg = Blockly.Msg || {};
        Object.keys(locale).forEach(function(k) {
            Blockly.Msg[k] = locale[k];
        });
    };
    return Blockly;
});

});
parcelRegister("fhxSA", function(module, exports) {
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './blockly_compressed'
    ], factory);
    else module.exports = factory((parcelRequire("6CdWE")));
})(module.exports, function(Blockly) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly module.
 */ /* eslint-disable */ 'use strict';
    return Blockly;
});

});
parcelRegister("6CdWE", function(module, exports) {
// Do not edit this file; automatically generated by gulp.
/* eslint-disable */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define([], factory);
    else module.exports = factory();
})(module.exports, function() {
    'use strict';
    var Blockly = {
        connectionTypes: {
            INPUT_VALUE: 1,
            OUTPUT_VALUE: 2,
            NEXT_STATEMENT: 3,
            PREVIOUS_STATEMENT: 4
        }
    };
    Blockly.constants = {};
    Blockly.LINE_MODE_MULTIPLIER = 40;
    Blockly.PAGE_MODE_MULTIPLIER = 125;
    Blockly.DRAG_RADIUS = 5;
    Blockly.FLYOUT_DRAG_RADIUS = 10;
    Blockly.SNAP_RADIUS = 28;
    Blockly.CONNECTING_SNAP_RADIUS = Blockly.SNAP_RADIUS;
    Blockly.CURRENT_CONNECTION_PREFERENCE = 8;
    Blockly.BUMP_DELAY = 250;
    Blockly.BUMP_RANDOMNESS = 10;
    Blockly.COLLAPSE_CHARS = 30;
    Blockly.LONGPRESS = 750;
    Blockly.SOUND_LIMIT = 100;
    Blockly.DRAG_STACK = !0;
    Blockly.HSV_SATURATION = .45;
    Blockly.HSV_VALUE = .65;
    Blockly.SPRITE = {
        width: 96,
        height: 124,
        url: "sprites.png"
    };
    Blockly.constants.ALIGN = {
        LEFT: -1,
        CENTRE: 0,
        RIGHT: 1
    };
    Blockly.DRAG_NONE = 0;
    Blockly.DRAG_STICKY = 1;
    Blockly.DRAG_BEGIN = 1;
    Blockly.DRAG_FREE = 2;
    Blockly.OPPOSITE_TYPE = [];
    Blockly.OPPOSITE_TYPE[Blockly.connectionTypes.INPUT_VALUE] = Blockly.connectionTypes.OUTPUT_VALUE;
    Blockly.OPPOSITE_TYPE[Blockly.connectionTypes.OUTPUT_VALUE] = Blockly.connectionTypes.INPUT_VALUE;
    Blockly.OPPOSITE_TYPE[Blockly.connectionTypes.NEXT_STATEMENT] = Blockly.connectionTypes.PREVIOUS_STATEMENT;
    Blockly.OPPOSITE_TYPE[Blockly.connectionTypes.PREVIOUS_STATEMENT] = Blockly.connectionTypes.NEXT_STATEMENT;
    Blockly.DELETE_AREA_NONE = null;
    Blockly.DELETE_AREA_TRASH = 1;
    Blockly.DELETE_AREA_TOOLBOX = 2;
    Blockly.VARIABLE_CATEGORY_NAME = "VARIABLE";
    Blockly.VARIABLE_DYNAMIC_CATEGORY_NAME = "VARIABLE_DYNAMIC";
    Blockly.PROCEDURE_CATEGORY_NAME = "PROCEDURE";
    Blockly.RENAME_VARIABLE_ID = "RENAME_VARIABLE_ID";
    Blockly.DELETE_VARIABLE_ID = "DELETE_VARIABLE_ID";
    Blockly.constants.COLLAPSED_INPUT_NAME = "_TEMP_COLLAPSED_INPUT";
    Blockly.constants.COLLAPSED_FIELD_NAME = "_TEMP_COLLAPSED_FIELD";
    Blockly.utils = {};
    Blockly.utils.global = function() {
        return "object" === typeof self ? self : "object" === typeof window ? window : "object" === typeof $parcel$global ? $parcel$global : this;
    }();
    Blockly.Msg = {};
    Blockly.utils.global.Blockly || (Blockly.utils.global.Blockly = {});
    Blockly.utils.global.Blockly.Msg || (Blockly.utils.global.Blockly.Msg = Blockly.Msg);
    Blockly.utils.colour = {};
    Blockly.utils.colour.parse = function(a) {
        a = String(a).toLowerCase().trim();
        var b = Blockly.utils.colour.names[a];
        if (b) return b;
        b = "0x" == a.substring(0, 2) ? "#" + a.substring(2) : a;
        b = "#" == b[0] ? b : "#" + b;
        if (/^#[0-9a-f]{6}$/.test(b)) return b;
        if (/^#[0-9a-f]{3}$/.test(b)) return [
            "#",
            b[1],
            b[1],
            b[2],
            b[2],
            b[3],
            b[3]
        ].join("");
        var c = a.match(/^(?:rgb)?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
        return c && (a = Number(c[1]), b = Number(c[2]), c = Number(c[3]), 0 <= a && 256 > a && 0 <= b && 256 > b && 0 <= c && 256 > c) ? Blockly.utils.colour.rgbToHex(a, b, c) : null;
    };
    Blockly.utils.colour.rgbToHex = function(a, b, c) {
        b = a << 16 | b << 8 | c;
        return 16 > a ? "#" + (16777216 | b).toString(16).substr(1) : "#" + b.toString(16);
    };
    Blockly.utils.colour.hexToRgb = function(a) {
        a = Blockly.utils.colour.parse(a);
        if (!a) return [
            0,
            0,
            0
        ];
        a = parseInt(a.substr(1), 16);
        return [
            a >> 16,
            a >> 8 & 255,
            a & 255
        ];
    };
    Blockly.utils.colour.hsvToHex = function(a, b, c) {
        var d = 0, e = 0, f = 0;
        if (0 == b) f = e = d = c;
        else {
            var g = Math.floor(a / 60), h = a / 60 - g;
            a = c * (1 - b);
            var k = c * (1 - b * h);
            b = c * (1 - b * (1 - h));
            switch(g){
                case 1:
                    d = k;
                    e = c;
                    f = a;
                    break;
                case 2:
                    d = a;
                    e = c;
                    f = b;
                    break;
                case 3:
                    d = a;
                    e = k;
                    f = c;
                    break;
                case 4:
                    d = b;
                    e = a;
                    f = c;
                    break;
                case 5:
                    d = c;
                    e = a;
                    f = k;
                    break;
                case 6:
                case 0:
                    d = c, e = b, f = a;
            }
        }
        return Blockly.utils.colour.rgbToHex(Math.floor(d), Math.floor(e), Math.floor(f));
    };
    Blockly.utils.colour.blend = function(a, b, c) {
        a = Blockly.utils.colour.parse(a);
        if (!a) return null;
        b = Blockly.utils.colour.parse(b);
        if (!b) return null;
        a = Blockly.utils.colour.hexToRgb(a);
        b = Blockly.utils.colour.hexToRgb(b);
        return Blockly.utils.colour.rgbToHex(Math.round(b[0] + c * (a[0] - b[0])), Math.round(b[1] + c * (a[1] - b[1])), Math.round(b[2] + c * (a[2] - b[2])));
    };
    Blockly.utils.colour.names = {
        aqua: "#00ffff",
        black: "#000000",
        blue: "#0000ff",
        fuchsia: "#ff00ff",
        gray: "#808080",
        green: "#008000",
        lime: "#00ff00",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        purple: "#800080",
        red: "#ff0000",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#ffffff",
        yellow: "#ffff00"
    };
    Blockly.utils.Coordinate = function(a, b) {
        this.x = a;
        this.y = b;
    };
    Blockly.utils.Coordinate.equals = function(a, b) {
        return a == b ? !0 : a && b ? a.x == b.x && a.y == b.y : !1;
    };
    Blockly.utils.Coordinate.distance = function(a, b) {
        var c = a.x - b.x;
        a = a.y - b.y;
        return Math.sqrt(c * c + a * a);
    };
    Blockly.utils.Coordinate.magnitude = function(a) {
        return Math.sqrt(a.x * a.x + a.y * a.y);
    };
    Blockly.utils.Coordinate.difference = function(a, b) {
        return new Blockly.utils.Coordinate(a.x - b.x, a.y - b.y);
    };
    Blockly.utils.Coordinate.sum = function(a, b) {
        return new Blockly.utils.Coordinate(a.x + b.x, a.y + b.y);
    };
    Blockly.utils.Coordinate.prototype.scale = function(a) {
        this.x *= a;
        this.y *= a;
        return this;
    };
    Blockly.utils.Coordinate.prototype.translate = function(a, b) {
        this.x += a;
        this.y += b;
        return this;
    };
    Blockly.utils.Rect = function(a, b, c, d) {
        this.top = a;
        this.bottom = b;
        this.left = c;
        this.right = d;
    };
    Blockly.utils.Rect.prototype.contains = function(a, b) {
        return a >= this.left && a <= this.right && b >= this.top && b <= this.bottom;
    };
    Blockly.utils.Rect.prototype.intersects = function(a) {
        return !(this.left > a.right || this.right < a.left || this.top > a.bottom || this.bottom < a.top);
    };
    Blockly.utils.string = {};
    Blockly.utils.string.startsWith = function(a, b) {
        return 0 == a.lastIndexOf(b, 0);
    };
    Blockly.utils.string.shortestStringLength = function(a) {
        return a.length ? a.reduce(function(b, c) {
            return b.length < c.length ? b : c;
        }).length : 0;
    };
    Blockly.utils.string.commonWordPrefix = function(a, b) {
        if (!a.length) return 0;
        if (1 == a.length) return a[0].length;
        var c = 0;
        b = b || Blockly.utils.string.shortestStringLength(a);
        for(var d = 0; d < b; d++){
            for(var e = a[0][d], f = 1; f < a.length; f++)if (e != a[f][d]) return c;
            " " == e && (c = d + 1);
        }
        for(f = 1; f < a.length; f++)if ((e = a[f][d]) && " " != e) return c;
        return b;
    };
    Blockly.utils.string.commonWordSuffix = function(a, b) {
        if (!a.length) return 0;
        if (1 == a.length) return a[0].length;
        var c = 0;
        b = b || Blockly.utils.string.shortestStringLength(a);
        for(var d = 0; d < b; d++){
            for(var e = a[0].substr(-d - 1, 1), f = 1; f < a.length; f++)if (e != a[f].substr(-d - 1, 1)) return c;
            " " == e && (c = d + 1);
        }
        for(f = 1; f < a.length; f++)if ((e = a[f].charAt(a[f].length - d - 1)) && " " != e) return c;
        return b;
    };
    Blockly.utils.string.wrap = function(a, b) {
        a = a.split("\n");
        for(var c = 0; c < a.length; c++)a[c] = Blockly.utils.string.wrapLine_(a[c], b);
        return a.join("\n");
    };
    Blockly.utils.string.wrapLine_ = function(a, b) {
        if (a.length <= b) return a;
        for(var c = a.trim().split(/\s+/), d = 0; d < c.length; d++)c[d].length > b && (b = c[d].length);
        d = -Infinity;
        var e = 1;
        do {
            var f = d;
            var g = a;
            a = [];
            var h = c.length / e, k = 1;
            for(d = 0; d < c.length - 1; d++)k < (d + 1.5) / h ? (k++, a[d] = !0) : a[d] = !1;
            a = Blockly.utils.string.wrapMutate_(c, a, b);
            d = Blockly.utils.string.wrapScore_(c, a, b);
            a = Blockly.utils.string.wrapToText_(c, a);
            e++;
        }while (d > f);
        return g;
    };
    Blockly.utils.string.wrapScore_ = function(a, b, c) {
        for(var d = [
            0
        ], e = [], f = 0; f < a.length; f++)d[d.length - 1] += a[f].length, !0 === b[f] ? (d.push(0), e.push(a[f].charAt(a[f].length - 1))) : !1 === b[f] && d[d.length - 1]++;
        a = Math.max.apply(Math, d);
        for(f = b = 0; f < d.length; f++)b -= 2 * Math.pow(Math.abs(c - d[f]), 1.5), b -= Math.pow(a - d[f], 1.5), -1 != ".?!".indexOf(e[f]) ? b += c / 3 : -1 != ",;)]}".indexOf(e[f]) && (b += c / 4);
        1 < d.length && d[d.length - 1] <= d[d.length - 2] && (b += .5);
        return b;
    };
    Blockly.utils.string.wrapMutate_ = function(a, b, c) {
        for(var d = Blockly.utils.string.wrapScore_(a, b, c), e, f = 0; f < b.length - 1; f++)if (b[f] != b[f + 1]) {
            var g = [].concat(b);
            g[f] = !g[f];
            g[f + 1] = !g[f + 1];
            var h = Blockly.utils.string.wrapScore_(a, g, c);
            h > d && (d = h, e = g);
        }
        return e ? Blockly.utils.string.wrapMutate_(a, e, c) : b;
    };
    Blockly.utils.string.wrapToText_ = function(a, b) {
        for(var c = [], d = 0; d < a.length; d++)c.push(a[d]), void 0 !== b[d] && c.push(b[d] ? "\n" : " ");
        return c.join("");
    };
    Blockly.utils.Size = function(a, b) {
        this.width = a;
        this.height = b;
    };
    Blockly.utils.Size.equals = function(a, b) {
        return a == b ? !0 : a && b ? a.width == b.width && a.height == b.height : !1;
    };
    Blockly.utils.style = {};
    Blockly.utils.style.getSize = function(a) {
        if ("none" != Blockly.utils.style.getStyle_(a, "display")) return Blockly.utils.style.getSizeWithDisplay_(a);
        var b = a.style, c = b.display, d = b.visibility, e = b.position;
        b.visibility = "hidden";
        b.position = "absolute";
        b.display = "inline";
        var f = a.offsetWidth;
        a = a.offsetHeight;
        b.display = c;
        b.position = e;
        b.visibility = d;
        return new Blockly.utils.Size(f, a);
    };
    Blockly.utils.style.getSizeWithDisplay_ = function(a) {
        return new Blockly.utils.Size(a.offsetWidth, a.offsetHeight);
    };
    Blockly.utils.style.getStyle_ = function(a, b) {
        return Blockly.utils.style.getComputedStyle(a, b) || Blockly.utils.style.getCascadedStyle(a, b) || a.style && a.style[b];
    };
    Blockly.utils.style.getComputedStyle = function(a, b) {
        return document.defaultView && document.defaultView.getComputedStyle && (a = document.defaultView.getComputedStyle(a, null)) ? a[b] || a.getPropertyValue(b) || "" : "";
    };
    Blockly.utils.style.getCascadedStyle = function(a, b) {
        return a.currentStyle ? a.currentStyle[b] : null;
    };
    Blockly.utils.style.getPageOffset = function(a) {
        var b = new Blockly.utils.Coordinate(0, 0);
        a = a.getBoundingClientRect();
        var c = document.documentElement;
        c = new Blockly.utils.Coordinate(window.pageXOffset || c.scrollLeft, window.pageYOffset || c.scrollTop);
        b.x = a.left + c.x;
        b.y = a.top + c.y;
        return b;
    };
    Blockly.utils.style.getViewportPageOffset = function() {
        var a = document.body, b = document.documentElement;
        return new Blockly.utils.Coordinate(a.scrollLeft || b.scrollLeft, a.scrollTop || b.scrollTop);
    };
    Blockly.utils.style.setElementShown = function(a, b) {
        a.style.display = b ? "" : "none";
    };
    Blockly.utils.style.isRightToLeft = function(a) {
        return "rtl" == Blockly.utils.style.getStyle_(a, "direction");
    };
    Blockly.utils.style.getBorderBox = function(a) {
        var b = Blockly.utils.style.getComputedStyle(a, "borderLeftWidth"), c = Blockly.utils.style.getComputedStyle(a, "borderRightWidth"), d = Blockly.utils.style.getComputedStyle(a, "borderTopWidth");
        a = Blockly.utils.style.getComputedStyle(a, "borderBottomWidth");
        return {
            top: parseFloat(d),
            right: parseFloat(c),
            bottom: parseFloat(a),
            left: parseFloat(b)
        };
    };
    Blockly.utils.style.scrollIntoContainerView = function(a, b, c) {
        a = Blockly.utils.style.getContainerOffsetToScrollInto(a, b, c);
        b.scrollLeft = a.x;
        b.scrollTop = a.y;
    };
    Blockly.utils.style.getContainerOffsetToScrollInto = function(a, b, c) {
        var d = Blockly.utils.style.getPageOffset(a), e = Blockly.utils.style.getPageOffset(b), f = Blockly.utils.style.getBorderBox(b), g = d.x - e.x - f.left;
        d = d.y - e.y - f.top;
        e = Blockly.utils.style.getSizeWithDisplay_(a);
        a = b.clientWidth - e.width;
        e = b.clientHeight - e.height;
        f = b.scrollLeft;
        b = b.scrollTop;
        c ? (f += g - a / 2, b += d - e / 2) : (f += Math.min(g, Math.max(g - a, 0)), b += Math.min(d, Math.max(d - e, 0)));
        return new Blockly.utils.Coordinate(f, b);
    };
    Blockly.utils.userAgent = {};
    (function(a) {
        function b(d) {
            return -1 != c.indexOf(d.toUpperCase());
        }
        Blockly.utils.userAgent.raw = a;
        var c = Blockly.utils.userAgent.raw.toUpperCase();
        Blockly.utils.userAgent.IE = b("Trident") || b("MSIE");
        Blockly.utils.userAgent.EDGE = b("Edge");
        Blockly.utils.userAgent.JAVA_FX = b("JavaFX");
        Blockly.utils.userAgent.CHROME = (b("Chrome") || b("CriOS")) && !Blockly.utils.userAgent.EDGE;
        Blockly.utils.userAgent.WEBKIT = b("WebKit") && !Blockly.utils.userAgent.EDGE;
        Blockly.utils.userAgent.GECKO = b("Gecko") && !Blockly.utils.userAgent.WEBKIT && !Blockly.utils.userAgent.IE && !Blockly.utils.userAgent.EDGE;
        Blockly.utils.userAgent.ANDROID = b("Android");
        Blockly.utils.userAgent.IPAD = b("iPad");
        Blockly.utils.userAgent.IPOD = b("iPod");
        Blockly.utils.userAgent.IPHONE = b("iPhone") && !Blockly.utils.userAgent.IPAD && !Blockly.utils.userAgent.IPOD;
        Blockly.utils.userAgent.MAC = b("Macintosh");
        Blockly.utils.userAgent.TABLET = Blockly.utils.userAgent.IPAD || Blockly.utils.userAgent.ANDROID && !b("Mobile") || b("Silk");
        Blockly.utils.userAgent.MOBILE = !Blockly.utils.userAgent.TABLET && (Blockly.utils.userAgent.IPOD || Blockly.utils.userAgent.IPHONE || Blockly.utils.userAgent.ANDROID || b("IEMobile"));
    })(Blockly.utils.global.navigator && Blockly.utils.global.navigator.userAgent || "");
    Blockly.utils.noEvent = function(a) {
        a.preventDefault();
        a.stopPropagation();
    };
    Blockly.utils.isTargetInput = function(a) {
        return "textarea" == a.target.type || "text" == a.target.type || "number" == a.target.type || "email" == a.target.type || "password" == a.target.type || "search" == a.target.type || "tel" == a.target.type || "url" == a.target.type || a.target.isContentEditable || a.target.dataset && "true" == a.target.dataset.isTextInput;
    };
    Blockly.utils.getRelativeXY = function(a) {
        var b = new Blockly.utils.Coordinate(0, 0), c = a.getAttribute("x");
        c && (b.x = parseInt(c, 10));
        if (c = a.getAttribute("y")) b.y = parseInt(c, 10);
        if (c = (c = a.getAttribute("transform")) && c.match(Blockly.utils.getRelativeXY.XY_REGEX_)) b.x += Number(c[1]), c[3] && (b.y += Number(c[3]));
        (a = a.getAttribute("style")) && -1 < a.indexOf("translate") && (a = a.match(Blockly.utils.getRelativeXY.XY_STYLE_REGEX_)) && (b.x += Number(a[1]), a[3] && (b.y += Number(a[3])));
        return b;
    };
    Blockly.utils.getInjectionDivXY_ = function(a) {
        for(var b = 0, c = 0; a;){
            var d = Blockly.utils.getRelativeXY(a);
            b += d.x;
            c += d.y;
            if (-1 != (" " + (a.getAttribute("class") || "") + " ").indexOf(" injectionDiv ")) break;
            a = a.parentNode;
        }
        return new Blockly.utils.Coordinate(b, c);
    };
    Blockly.utils.getRelativeXY.XY_REGEX_ = /translate\(\s*([-+\d.e]+)([ ,]\s*([-+\d.e]+)\s*)?/;
    Blockly.utils.getRelativeXY.XY_STYLE_REGEX_ = /transform:\s*translate(?:3d)?\(\s*([-+\d.e]+)\s*px([ ,]\s*([-+\d.e]+)\s*px)?/;
    Blockly.utils.isRightButton = function(a) {
        return a.ctrlKey && Blockly.utils.userAgent.MAC ? !0 : 2 == a.button;
    };
    Blockly.utils.mouseToSvg = function(a, b, c) {
        var d = b.createSVGPoint();
        d.x = a.clientX;
        d.y = a.clientY;
        c || (c = b.getScreenCTM().inverse());
        return d.matrixTransform(c);
    };
    Blockly.utils.getScrollDeltaPixels = function(a) {
        switch(a.deltaMode){
            default:
                return {
                    x: a.deltaX,
                    y: a.deltaY
                };
            case 1:
                return {
                    x: a.deltaX * Blockly.LINE_MODE_MULTIPLIER,
                    y: a.deltaY * Blockly.LINE_MODE_MULTIPLIER
                };
            case 2:
                return {
                    x: a.deltaX * Blockly.PAGE_MODE_MULTIPLIER,
                    y: a.deltaY * Blockly.PAGE_MODE_MULTIPLIER
                };
        }
    };
    Blockly.utils.tokenizeInterpolation = function(a) {
        return Blockly.utils.tokenizeInterpolation_(a, !0);
    };
    Blockly.utils.replaceMessageReferences = function(a) {
        if ("string" != typeof a) return a;
        a = Blockly.utils.tokenizeInterpolation_(a, !1);
        return a.length ? String(a[0]) : "";
    };
    Blockly.utils.checkMessageReferences = function(a) {
        for(var b = !0, c = Blockly.Msg, d = a.match(/%{BKY_[A-Z]\w*}/ig), e = 0; e < d.length; e++){
            var f = d[e].toUpperCase();
            void 0 == c[f.slice(6, -1)] && (console.warn("No message string for " + d[e] + " in " + a), b = !1);
        }
        return b;
    };
    Blockly.utils.tokenizeInterpolation_ = function(a, b) {
        var c = [], d = a.split("");
        d.push("");
        var e = 0;
        a = [];
        for(var f = null, g = 0; g < d.length; g++){
            var h = d[g];
            0 == e ? "%" == h ? ((h = a.join("")) && c.push(h), a.length = 0, e = 1) : a.push(h) : 1 == e ? "%" == h ? (a.push(h), e = 0) : b && "0" <= h && "9" >= h ? (e = 2, f = h, (h = a.join("")) && c.push(h), a.length = 0) : "{" == h ? e = 3 : (a.push("%", h), e = 0) : 2 == e ? "0" <= h && "9" >= h ? f += h : (c.push(parseInt(f, 10)), g--, e = 0) : 3 == e && ("" == h ? (a.splice(0, 0, "%{"), g--, e = 0) : "}" != h ? a.push(h) : (e = a.join(""), /[A-Z]\w*/i.test(e) ? (h = e.toUpperCase(), (h = Blockly.utils.string.startsWith(h, "BKY_") ? h.substring(4) : null) && h in Blockly.Msg ? (e = Blockly.Msg[h], "string" == typeof e ? Array.prototype.push.apply(c, Blockly.utils.tokenizeInterpolation_(e, b)) : b ? c.push(String(e)) : c.push(e)) : c.push("%{" + e + "}")) : c.push("%{" + e + "}"), e = a.length = 0));
        }
        (h = a.join("")) && c.push(h);
        b = [];
        for(g = a.length = 0; g < c.length; ++g)"string" == typeof c[g] ? a.push(c[g]) : ((h = a.join("")) && b.push(h), a.length = 0, b.push(c[g]));
        (h = a.join("")) && b.push(h);
        a.length = 0;
        return b;
    };
    Blockly.utils.genUid = function() {
        for(var a = Blockly.utils.genUid.soup_.length, b = [], c = 0; 20 > c; c++)b[c] = Blockly.utils.genUid.soup_.charAt(Math.random() * a);
        return b.join("");
    };
    Blockly.utils.genUid.soup_ = "!#$%()*+,-./:;=?@[]^_`{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    Blockly.utils.is3dSupported = function() {
        if (void 0 !== Blockly.utils.is3dSupported.cached_) return Blockly.utils.is3dSupported.cached_;
        if (!Blockly.utils.global.getComputedStyle) return !1;
        var a = document.createElement("p"), b = "none", c = {
            webkitTransform: "-webkit-transform",
            OTransform: "-o-transform",
            msTransform: "-ms-transform",
            MozTransform: "-moz-transform",
            transform: "transform"
        };
        document.body.insertBefore(a, null);
        for(var d in c)if (void 0 !== a.style[d]) {
            a.style[d] = "translate3d(1px,1px,1px)";
            b = Blockly.utils.global.getComputedStyle(a);
            if (!b) return document.body.removeChild(a), !1;
            b = b.getPropertyValue(c[d]);
        }
        document.body.removeChild(a);
        Blockly.utils.is3dSupported.cached_ = "none" !== b;
        return Blockly.utils.is3dSupported.cached_;
    };
    Blockly.utils.runAfterPageLoad = function(a) {
        if ("object" != typeof document) throw Error("Blockly.utils.runAfterPageLoad() requires browser document.");
        if ("complete" == document.readyState) a();
        else var b = setInterval(function() {
            "complete" == document.readyState && (clearInterval(b), a());
        }, 10);
    };
    Blockly.utils.getViewportBBox = function() {
        var a = Blockly.utils.style.getViewportPageOffset();
        return new Blockly.utils.Rect(a.y, document.documentElement.clientHeight + a.y, a.x, document.documentElement.clientWidth + a.x);
    };
    Blockly.utils.arrayRemove = function(a, b) {
        b = a.indexOf(b);
        if (-1 == b) return !1;
        a.splice(b, 1);
        return !0;
    };
    Blockly.utils.getDocumentScroll = function() {
        var a = document.documentElement, b = window;
        return Blockly.utils.userAgent.IE && b.pageYOffset != a.scrollTop ? new Blockly.utils.Coordinate(a.scrollLeft, a.scrollTop) : new Blockly.utils.Coordinate(b.pageXOffset || a.scrollLeft, b.pageYOffset || a.scrollTop);
    };
    Blockly.utils.getBlockTypeCounts = function(a, b) {
        var c = Object.create(null), d = a.getDescendants(!0);
        b && (a = a.getNextBlock()) && (a = d.indexOf(a), d.splice(a, d.length - a));
        for(a = 0; b = d[a]; a++)c[b.type] ? c[b.type]++ : c[b.type] = 1;
        return c;
    };
    Blockly.utils.screenToWsCoordinates = function(a, b) {
        var c = b.x;
        b = b.y;
        var d = a.getInjectionDiv().getBoundingClientRect();
        c = new Blockly.utils.Coordinate(c - d.left, b - d.top);
        b = a.getOriginOffsetInPixels();
        return Blockly.utils.Coordinate.difference(c, b).scale(1 / a.scale);
    };
    Blockly.utils.parseBlockColour = function(a) {
        var b = "string" == typeof a ? Blockly.utils.replaceMessageReferences(a) : a, c = Number(b);
        if (!isNaN(c) && 0 <= c && 360 >= c) return {
            hue: c,
            hex: Blockly.utils.colour.hsvToHex(c, Blockly.HSV_SATURATION, 255 * Blockly.HSV_VALUE)
        };
        if (c = Blockly.utils.colour.parse(b)) return {
            hue: null,
            hex: c
        };
        c = 'Invalid colour: "' + b + '"';
        a != b && (c += ' (from "' + a + '")');
        throw Error(c);
    };
    Blockly.Touch = {};
    Blockly.Touch.TOUCH_ENABLED = "ontouchstart" in Blockly.utils.global || !!(Blockly.utils.global.document && document.documentElement && "ontouchstart" in document.documentElement) || !(!Blockly.utils.global.navigator || !Blockly.utils.global.navigator.maxTouchPoints && !Blockly.utils.global.navigator.msMaxTouchPoints);
    Blockly.Touch.touchIdentifier_ = null;
    Blockly.Touch.TOUCH_MAP = {};
    Blockly.utils.global.PointerEvent ? Blockly.Touch.TOUCH_MAP = {
        mousedown: [
            "pointerdown"
        ],
        mouseenter: [
            "pointerenter"
        ],
        mouseleave: [
            "pointerleave"
        ],
        mousemove: [
            "pointermove"
        ],
        mouseout: [
            "pointerout"
        ],
        mouseover: [
            "pointerover"
        ],
        mouseup: [
            "pointerup",
            "pointercancel"
        ],
        touchend: [
            "pointerup"
        ],
        touchcancel: [
            "pointercancel"
        ]
    } : Blockly.Touch.TOUCH_ENABLED && (Blockly.Touch.TOUCH_MAP = {
        mousedown: [
            "touchstart"
        ],
        mousemove: [
            "touchmove"
        ],
        mouseup: [
            "touchend",
            "touchcancel"
        ]
    });
    Blockly.longPid_ = 0;
    Blockly.longStart = function(a, b) {
        Blockly.longStop_();
        a.changedTouches && 1 != a.changedTouches.length || (Blockly.longPid_ = setTimeout(function() {
            a.changedTouches && (a.button = 2, a.clientX = a.changedTouches[0].clientX, a.clientY = a.changedTouches[0].clientY);
            b && b.handleRightClick(a);
        }, Blockly.LONGPRESS));
    };
    Blockly.longStop_ = function() {
        Blockly.longPid_ && (clearTimeout(Blockly.longPid_), Blockly.longPid_ = 0);
    };
    Blockly.Touch.clearTouchIdentifier = function() {
        Blockly.Touch.touchIdentifier_ = null;
    };
    Blockly.Touch.shouldHandleEvent = function(a) {
        return !Blockly.Touch.isMouseOrTouchEvent(a) || Blockly.Touch.checkTouchIdentifier(a);
    };
    Blockly.Touch.getTouchIdentifierFromEvent = function(a) {
        return void 0 != a.pointerId ? a.pointerId : a.changedTouches && a.changedTouches[0] && void 0 !== a.changedTouches[0].identifier && null !== a.changedTouches[0].identifier ? a.changedTouches[0].identifier : "mouse";
    };
    Blockly.Touch.checkTouchIdentifier = function(a) {
        var b = Blockly.Touch.getTouchIdentifierFromEvent(a);
        return void 0 !== Blockly.Touch.touchIdentifier_ && null !== Blockly.Touch.touchIdentifier_ ? Blockly.Touch.touchIdentifier_ == b : "mousedown" == a.type || "touchstart" == a.type || "pointerdown" == a.type ? (Blockly.Touch.touchIdentifier_ = b, !0) : !1;
    };
    Blockly.Touch.setClientFromTouch = function(a) {
        if (Blockly.utils.string.startsWith(a.type, "touch")) {
            var b = a.changedTouches[0];
            a.clientX = b.clientX;
            a.clientY = b.clientY;
        }
    };
    Blockly.Touch.isMouseOrTouchEvent = function(a) {
        return Blockly.utils.string.startsWith(a.type, "touch") || Blockly.utils.string.startsWith(a.type, "mouse") || Blockly.utils.string.startsWith(a.type, "pointer");
    };
    Blockly.Touch.isTouchEvent = function(a) {
        return Blockly.utils.string.startsWith(a.type, "touch") || Blockly.utils.string.startsWith(a.type, "pointer");
    };
    Blockly.Touch.splitEventByTouches = function(a) {
        var b = [];
        if (a.changedTouches) for(var c = 0; c < a.changedTouches.length; c++)b[c] = {
            type: a.type,
            changedTouches: [
                a.changedTouches[c]
            ],
            target: a.target,
            stopPropagation: function() {
                a.stopPropagation();
            },
            preventDefault: function() {
                a.preventDefault();
            }
        };
        else b.push(a);
        return b;
    };
    Blockly.browserEvents = {};
    Blockly.browserEvents.conditionalBind = function(a, b, c, d, e, f) {
        var g = !1, h = function(p) {
            var q = !e;
            p = Blockly.Touch.splitEventByTouches(p);
            for(var t = 0, r; r = p[t]; t++)if (!q || Blockly.Touch.shouldHandleEvent(r)) Blockly.Touch.setClientFromTouch(r), c ? d.call(c, r) : d(r), g = !0;
        }, k = [];
        if (Blockly.utils.global.PointerEvent && b in Blockly.Touch.TOUCH_MAP) for(var l = 0, m; m = Blockly.Touch.TOUCH_MAP[b][l]; l++)a.addEventListener(m, h, !1), k.push([
            a,
            m,
            h
        ]);
        else if (a.addEventListener(b, h, !1), k.push([
            a,
            b,
            h
        ]), b in Blockly.Touch.TOUCH_MAP) {
            var n = function(p) {
                h(p);
                var q = !f;
                g && q && p.preventDefault();
            };
            for(l = 0; m = Blockly.Touch.TOUCH_MAP[b][l]; l++)a.addEventListener(m, n, !1), k.push([
                a,
                m,
                n
            ]);
        }
        return k;
    };
    Blockly.browserEvents.bind = function(a, b, c, d) {
        var e = function(l) {
            c ? d.call(c, l) : d(l);
        }, f = [];
        if (Blockly.utils.global.PointerEvent && b in Blockly.Touch.TOUCH_MAP) for(var g = 0, h; h = Blockly.Touch.TOUCH_MAP[b][g]; g++)a.addEventListener(h, e, !1), f.push([
            a,
            h,
            e
        ]);
        else if (a.addEventListener(b, e, !1), f.push([
            a,
            b,
            e
        ]), b in Blockly.Touch.TOUCH_MAP) {
            var k = function(l) {
                if (l.changedTouches && 1 == l.changedTouches.length) {
                    var m = l.changedTouches[0];
                    l.clientX = m.clientX;
                    l.clientY = m.clientY;
                }
                e(l);
                l.preventDefault();
            };
            for(g = 0; h = Blockly.Touch.TOUCH_MAP[b][g]; g++)a.addEventListener(h, k, !1), f.push([
                a,
                h,
                k
            ]);
        }
        return f;
    };
    Blockly.browserEvents.unbind = function(a) {
        for(; a.length;){
            var b = a.pop(), c = b[2];
            b[0].removeEventListener(b[1], c, !1);
        }
        return c;
    };
    Blockly.registry = {};
    Blockly.registry.typeMap_ = {};
    Blockly.registry.DEFAULT = "default";
    Blockly.registry.Type = function(a) {
        this.name_ = a;
    };
    Blockly.registry.Type.prototype.toString = function() {
        return this.name_;
    };
    Blockly.registry.Type.CONNECTION_CHECKER = new Blockly.registry.Type("connectionChecker");
    Blockly.registry.Type.CURSOR = new Blockly.registry.Type("cursor");
    Blockly.registry.Type.EVENT = new Blockly.registry.Type("event");
    Blockly.registry.Type.FIELD = new Blockly.registry.Type("field");
    Blockly.registry.Type.RENDERER = new Blockly.registry.Type("renderer");
    Blockly.registry.Type.TOOLBOX = new Blockly.registry.Type("toolbox");
    Blockly.registry.Type.THEME = new Blockly.registry.Type("theme");
    Blockly.registry.Type.TOOLBOX_ITEM = new Blockly.registry.Type("toolboxItem");
    Blockly.registry.Type.FLYOUTS_VERTICAL_TOOLBOX = new Blockly.registry.Type("flyoutsVerticalToolbox");
    Blockly.registry.Type.FLYOUTS_HORIZONTAL_TOOLBOX = new Blockly.registry.Type("flyoutsHorizontalToolbox");
    Blockly.registry.Type.METRICS_MANAGER = new Blockly.registry.Type("metricsManager");
    Blockly.registry.register = function(a, b, c, d) {
        if (!(a instanceof Blockly.registry.Type) && "string" != typeof a || "" == String(a).trim()) throw Error('Invalid type "' + a + '". The type must be a non-empty string or a Blockly.registry.Type.');
        a = String(a).toLowerCase();
        if ("string" != typeof b || "" == b.trim()) throw Error('Invalid name "' + b + '". The name must be a non-empty string.');
        b = b.toLowerCase();
        if (!c) throw Error("Can not register a null value");
        var e = Blockly.registry.typeMap_[a];
        e || (e = Blockly.registry.typeMap_[a] = {});
        Blockly.registry.validate_(a, c);
        if (!d && e[b]) throw Error('Name "' + b + '" with type "' + a + '" already registered.');
        e[b] = c;
    };
    Blockly.registry.validate_ = function(a, b) {
        switch(a){
            case String(Blockly.registry.Type.FIELD):
                if ("function" != typeof b.fromJson) throw Error('Type "' + a + '" must have a fromJson function');
        }
    };
    Blockly.registry.unregister = function(a, b) {
        a = String(a).toLowerCase();
        b = b.toLowerCase();
        var c = Blockly.registry.typeMap_[a];
        c && c[b] ? delete Blockly.registry.typeMap_[a][b] : console.warn("Unable to unregister [" + b + "][" + a + "] from the registry.");
    };
    Blockly.registry.getItem_ = function(a, b, c) {
        a = String(a).toLowerCase();
        b = b.toLowerCase();
        var d = Blockly.registry.typeMap_[a];
        if (!d || !d[b]) {
            b = "Unable to find [" + b + "][" + a + "] in the registry.";
            if (c) throw Error(b + " You must require or register a " + a + " plugin.");
            console.warn(b);
            return null;
        }
        return d[b];
    };
    Blockly.registry.hasItem = function(a, b) {
        a = String(a).toLowerCase();
        b = b.toLowerCase();
        return (a = Blockly.registry.typeMap_[a]) ? !!a[b] : !1;
    };
    Blockly.registry.getClass = function(a, b, c) {
        return Blockly.registry.getItem_(a, b, c);
    };
    Blockly.registry.getObject = function(a, b, c) {
        return Blockly.registry.getItem_(a, b, c);
    };
    Blockly.registry.getClassFromOptions = function(a, b, c) {
        b = b.plugins[a.toString()] || Blockly.registry.DEFAULT;
        return "function" == typeof b ? b : Blockly.registry.getClass(a, b, c);
    };
    Blockly.Events = {};
    Blockly.Events.group_ = "";
    Blockly.Events.recordUndo = !0;
    Blockly.Events.disabled_ = 0;
    Blockly.Events.CREATE = "create";
    Blockly.Events.BLOCK_CREATE = Blockly.Events.CREATE;
    Blockly.Events.DELETE = "delete";
    Blockly.Events.BLOCK_DELETE = Blockly.Events.DELETE;
    Blockly.Events.CHANGE = "change";
    Blockly.Events.BLOCK_CHANGE = Blockly.Events.CHANGE;
    Blockly.Events.MOVE = "move";
    Blockly.Events.BLOCK_MOVE = Blockly.Events.MOVE;
    Blockly.Events.VAR_CREATE = "var_create";
    Blockly.Events.VAR_DELETE = "var_delete";
    Blockly.Events.VAR_RENAME = "var_rename";
    Blockly.Events.UI = "ui";
    Blockly.Events.BLOCK_DRAG = "drag";
    Blockly.Events.SELECTED = "selected";
    Blockly.Events.CLICK = "click";
    Blockly.Events.MARKER_MOVE = "marker_move";
    Blockly.Events.BUBBLE_OPEN = "bubble_open";
    Blockly.Events.TRASHCAN_OPEN = "trashcan_open";
    Blockly.Events.TOOLBOX_ITEM_SELECT = "toolbox_item_select";
    Blockly.Events.THEME_CHANGE = "theme_change";
    Blockly.Events.VIEWPORT_CHANGE = "viewport_change";
    Blockly.Events.COMMENT_CREATE = "comment_create";
    Blockly.Events.COMMENT_DELETE = "comment_delete";
    Blockly.Events.COMMENT_CHANGE = "comment_change";
    Blockly.Events.COMMENT_MOVE = "comment_move";
    Blockly.Events.FINISHED_LOADING = "finished_loading";
    Blockly.Events.BUMP_EVENTS = [
        Blockly.Events.BLOCK_CREATE,
        Blockly.Events.BLOCK_MOVE,
        Blockly.Events.COMMENT_CREATE,
        Blockly.Events.COMMENT_MOVE
    ];
    Blockly.Events.FIRE_QUEUE_ = [];
    Blockly.Events.fire = function(a) {
        Blockly.Events.isEnabled() && (Blockly.Events.FIRE_QUEUE_.length || setTimeout(Blockly.Events.fireNow_, 0), Blockly.Events.FIRE_QUEUE_.push(a));
    };
    Blockly.Events.fireNow_ = function() {
        for(var a = Blockly.Events.filter(Blockly.Events.FIRE_QUEUE_, !0), b = Blockly.Events.FIRE_QUEUE_.length = 0, c; c = a[b]; b++)if (c.workspaceId) {
            var d = Blockly.Workspace.getById(c.workspaceId);
            d && d.fireChangeListener(c);
        }
    };
    Blockly.Events.filter = function(a, b) {
        a = a.slice();
        b || a.reverse();
        for(var c = [], d = Object.create(null), e = 0, f; f = a[e]; e++)if (!f.isNull()) {
            var g = [
                f.isUiEvent ? Blockly.Events.UI : f.type,
                f.blockId,
                f.workspaceId
            ].join(" "), h = d[g], k = h ? h.event : null;
            if (!h) d[g] = {
                event: f,
                index: e
            }, c.push(f);
            else if (f.type == Blockly.Events.MOVE && h.index == e - 1) k.newParentId = f.newParentId, k.newInputName = f.newInputName, k.newCoordinate = f.newCoordinate, h.index = e;
            else if (f.type == Blockly.Events.CHANGE && f.element == k.element && f.name == k.name) k.newValue = f.newValue;
            else if (f.type != Blockly.Events.CLICK || k.type != Blockly.Events.BUBBLE_OPEN) d[g] = {
                event: f,
                index: e
            }, c.push(f);
        }
        a = c.filter(function(l) {
            return !l.isNull();
        });
        b || a.reverse();
        for(e = 1; f = a[e]; e++)f.type == Blockly.Events.CHANGE && "mutation" == f.element && a.unshift(a.splice(e, 1)[0]);
        return a;
    };
    Blockly.Events.clearPendingUndo = function() {
        for(var a = 0, b; b = Blockly.Events.FIRE_QUEUE_[a]; a++)b.recordUndo = !1;
    };
    Blockly.Events.disable = function() {
        Blockly.Events.disabled_++;
    };
    Blockly.Events.enable = function() {
        Blockly.Events.disabled_--;
    };
    Blockly.Events.isEnabled = function() {
        return 0 == Blockly.Events.disabled_;
    };
    Blockly.Events.getGroup = function() {
        return Blockly.Events.group_;
    };
    Blockly.Events.setGroup = function(a) {
        Blockly.Events.group_ = "boolean" == typeof a ? a ? Blockly.utils.genUid() : "" : a;
    };
    Blockly.Events.getDescendantIds = function(a) {
        var b = [];
        a = a.getDescendants(!1);
        for(var c = 0, d; d = a[c]; c++)b[c] = d.id;
        return b;
    };
    Blockly.Events.fromJson = function(a, b) {
        var c = Blockly.Events.get(a.type);
        if (!c) throw Error("Unknown event type.");
        c = new c;
        c.fromJson(a);
        c.workspaceId = b.id;
        return c;
    };
    Blockly.Events.get = function(a) {
        return Blockly.registry.getClass(Blockly.registry.Type.EVENT, a);
    };
    Blockly.Events.disableOrphans = function(a) {
        if ((a.type == Blockly.Events.MOVE || a.type == Blockly.Events.CREATE) && a.workspaceId) {
            var b = Blockly.Workspace.getById(a.workspaceId), c = b.getBlockById(a.blockId);
            if (c) {
                a = Blockly.Events.recordUndo;
                try {
                    Blockly.Events.recordUndo = !1;
                    var d = c.getParent();
                    if (d && d.isEnabled()) {
                        var e = c.getDescendants(!1);
                        b = 0;
                        for(var f; f = e[b]; b++)f.setEnabled(!0);
                    } else if ((c.outputConnection || c.previousConnection) && !b.isDragging()) do c.setEnabled(!1), c = c.getNextBlock();
                    while (c);
                } finally{
                    Blockly.Events.recordUndo = a;
                }
            }
        }
    };
    Blockly.Events.Abstract = function() {
        this.isBlank = null;
        this.workspaceId = void 0;
        this.group = Blockly.Events.getGroup();
        this.recordUndo = Blockly.Events.recordUndo;
    };
    Blockly.Events.Abstract.prototype.isUiEvent = !1;
    Blockly.Events.Abstract.prototype.toJson = function() {
        var a = {
            type: this.type
        };
        this.group && (a.group = this.group);
        return a;
    };
    Blockly.Events.Abstract.prototype.fromJson = function(a) {
        this.isBlank = !1;
        this.group = a.group;
    };
    Blockly.Events.Abstract.prototype.isNull = function() {
        return !1;
    };
    Blockly.Events.Abstract.prototype.run = function(a) {};
    Blockly.Events.Abstract.prototype.getEventWorkspace_ = function() {
        if (this.workspaceId) var a = Blockly.Workspace.getById(this.workspaceId);
        if (!a) throw Error("Workspace is null. Event must have been generated from real Blockly events.");
        return a;
    };
    Blockly.utils.object = {};
    Blockly.utils.object.inherits = function(a, b) {
        a.superClass_ = b.prototype;
        a.prototype = Object.create(b.prototype);
        a.prototype.constructor = a;
    };
    Blockly.utils.object.mixin = function(a, b) {
        for(var c in b)a[c] = b[c];
    };
    Blockly.utils.object.deepMerge = function(a, b) {
        for(var c in b)a[c] = null != b[c] && "object" === typeof b[c] ? Blockly.utils.object.deepMerge(a[c] || Object.create(null), b[c]) : b[c];
        return a;
    };
    Blockly.utils.object.values = function(a) {
        return Object.values ? Object.values(a) : Object.keys(a).map(function(b) {
            return a[b];
        });
    };
    Blockly.utils.xml = {};
    Blockly.utils.xml.NAME_SPACE = "https://developers.google.com/blockly/xml";
    Blockly.utils.xml.document = function() {
        return document;
    };
    Blockly.utils.xml.createElement = function(a) {
        return Blockly.utils.xml.document().createElementNS(Blockly.utils.xml.NAME_SPACE, a);
    };
    Blockly.utils.xml.createTextNode = function(a) {
        return Blockly.utils.xml.document().createTextNode(a);
    };
    Blockly.utils.xml.textToDomDocument = function(a) {
        return (new DOMParser).parseFromString(a, "text/xml");
    };
    Blockly.utils.xml.domToText = function(a) {
        return (new XMLSerializer).serializeToString(a);
    };
    Blockly.inputTypes = {
        VALUE: Blockly.connectionTypes.INPUT_VALUE,
        STATEMENT: Blockly.connectionTypes.NEXT_STATEMENT,
        DUMMY: 5
    };
    Blockly.utils.Svg = function(a) {
        this.tagName_ = a;
    };
    Blockly.utils.Svg.prototype.toString = function() {
        return this.tagName_;
    };
    Blockly.utils.Svg.ANIMATE = new Blockly.utils.Svg("animate");
    Blockly.utils.Svg.CIRCLE = new Blockly.utils.Svg("circle");
    Blockly.utils.Svg.CLIPPATH = new Blockly.utils.Svg("clipPath");
    Blockly.utils.Svg.DEFS = new Blockly.utils.Svg("defs");
    Blockly.utils.Svg.FECOMPOSITE = new Blockly.utils.Svg("feComposite");
    Blockly.utils.Svg.FECOMPONENTTRANSFER = new Blockly.utils.Svg("feComponentTransfer");
    Blockly.utils.Svg.FEFLOOD = new Blockly.utils.Svg("feFlood");
    Blockly.utils.Svg.FEFUNCA = new Blockly.utils.Svg("feFuncA");
    Blockly.utils.Svg.FEGAUSSIANBLUR = new Blockly.utils.Svg("feGaussianBlur");
    Blockly.utils.Svg.FEPOINTLIGHT = new Blockly.utils.Svg("fePointLight");
    Blockly.utils.Svg.FESPECULARLIGHTING = new Blockly.utils.Svg("feSpecularLighting");
    Blockly.utils.Svg.FILTER = new Blockly.utils.Svg("filter");
    Blockly.utils.Svg.FOREIGNOBJECT = new Blockly.utils.Svg("foreignObject");
    Blockly.utils.Svg.G = new Blockly.utils.Svg("g");
    Blockly.utils.Svg.IMAGE = new Blockly.utils.Svg("image");
    Blockly.utils.Svg.LINE = new Blockly.utils.Svg("line");
    Blockly.utils.Svg.PATH = new Blockly.utils.Svg("path");
    Blockly.utils.Svg.PATTERN = new Blockly.utils.Svg("pattern");
    Blockly.utils.Svg.POLYGON = new Blockly.utils.Svg("polygon");
    Blockly.utils.Svg.RECT = new Blockly.utils.Svg("rect");
    Blockly.utils.Svg.SVG = new Blockly.utils.Svg("svg");
    Blockly.utils.Svg.TEXT = new Blockly.utils.Svg("text");
    Blockly.utils.Svg.TSPAN = new Blockly.utils.Svg("tspan");
    Blockly.utils.dom = {};
    Blockly.utils.dom.SVG_NS = "http://www.w3.org/2000/svg";
    Blockly.utils.dom.HTML_NS = "http://www.w3.org/1999/xhtml";
    Blockly.utils.dom.XLINK_NS = "http://www.w3.org/1999/xlink";
    Blockly.utils.dom.NodeType = {
        ELEMENT_NODE: 1,
        TEXT_NODE: 3,
        COMMENT_NODE: 8,
        DOCUMENT_POSITION_CONTAINED_BY: 16
    };
    Blockly.utils.dom.cacheWidths_ = null;
    Blockly.utils.dom.cacheReference_ = 0;
    Blockly.utils.dom.canvasContext_ = null;
    Blockly.utils.dom.createSvgElement = function(a, b, c) {
        a = document.createElementNS(Blockly.utils.dom.SVG_NS, String(a));
        for(var d in b)a.setAttribute(d, b[d]);
        document.body.runtimeStyle && (a.runtimeStyle = a.currentStyle = a.style);
        c && c.appendChild(a);
        return a;
    };
    Blockly.utils.dom.addClass = function(a, b) {
        var c = a.getAttribute("class") || "";
        if (-1 != (" " + c + " ").indexOf(" " + b + " ")) return !1;
        c && (c += " ");
        a.setAttribute("class", c + b);
        return !0;
    };
    Blockly.utils.dom.removeClasses = function(a, b) {
        b = b.split(" ");
        for(var c = 0; c < b.length; c++)Blockly.utils.dom.removeClass(a, b[c]);
    };
    Blockly.utils.dom.removeClass = function(a, b) {
        var c = a.getAttribute("class");
        if (-1 == (" " + c + " ").indexOf(" " + b + " ")) return !1;
        c = c.split(/\s+/);
        for(var d = 0; d < c.length; d++)c[d] && c[d] != b || (c.splice(d, 1), d--);
        c.length ? a.setAttribute("class", c.join(" ")) : a.removeAttribute("class");
        return !0;
    };
    Blockly.utils.dom.hasClass = function(a, b) {
        return -1 != (" " + a.getAttribute("class") + " ").indexOf(" " + b + " ");
    };
    Blockly.utils.dom.removeNode = function(a) {
        return a && a.parentNode ? a.parentNode.removeChild(a) : null;
    };
    Blockly.utils.dom.insertAfter = function(a, b) {
        var c = b.nextSibling;
        b = b.parentNode;
        if (!b) throw Error("Reference node has no parent.");
        c ? b.insertBefore(a, c) : b.appendChild(a);
    };
    Blockly.utils.dom.containsNode = function(a, b) {
        return !!(a.compareDocumentPosition(b) & Blockly.utils.dom.NodeType.DOCUMENT_POSITION_CONTAINED_BY);
    };
    Blockly.utils.dom.setCssTransform = function(a, b) {
        a.style.transform = b;
        a.style["-webkit-transform"] = b;
    };
    Blockly.utils.dom.startTextWidthCache = function() {
        Blockly.utils.dom.cacheReference_++;
        Blockly.utils.dom.cacheWidths_ || (Blockly.utils.dom.cacheWidths_ = {});
    };
    Blockly.utils.dom.stopTextWidthCache = function() {
        Blockly.utils.dom.cacheReference_--;
        Blockly.utils.dom.cacheReference_ || (Blockly.utils.dom.cacheWidths_ = null);
    };
    Blockly.utils.dom.getTextWidth = function(a) {
        var b = a.textContent + "\n" + a.className.baseVal, c;
        if (Blockly.utils.dom.cacheWidths_ && (c = Blockly.utils.dom.cacheWidths_[b])) return c;
        try {
            c = Blockly.utils.userAgent.IE || Blockly.utils.userAgent.EDGE ? a.getBBox().width : a.getComputedTextLength();
        } catch (d) {
            return 8 * a.textContent.length;
        }
        Blockly.utils.dom.cacheWidths_ && (Blockly.utils.dom.cacheWidths_[b] = c);
        return c;
    };
    Blockly.utils.dom.getFastTextWidth = function(a, b, c, d) {
        return Blockly.utils.dom.getFastTextWidthWithSizeString(a, b + "pt", c, d);
    };
    Blockly.utils.dom.getFastTextWidthWithSizeString = function(a, b, c, d) {
        var e = a.textContent;
        a = e + "\n" + a.className.baseVal;
        var f;
        if (Blockly.utils.dom.cacheWidths_ && (f = Blockly.utils.dom.cacheWidths_[a])) return f;
        Blockly.utils.dom.canvasContext_ || (f = document.createElement("canvas"), f.className = "blocklyComputeCanvas", document.body.appendChild(f), Blockly.utils.dom.canvasContext_ = f.getContext("2d"));
        Blockly.utils.dom.canvasContext_.font = c + " " + b + " " + d;
        f = Blockly.utils.dom.canvasContext_.measureText(e).width;
        Blockly.utils.dom.cacheWidths_ && (Blockly.utils.dom.cacheWidths_[a] = f);
        return f;
    };
    Blockly.utils.dom.measureFontMetrics = function(a, b, c, d) {
        var e = document.createElement("span");
        e.style.font = c + " " + b + " " + d;
        e.textContent = a;
        a = document.createElement("div");
        a.style.width = "1px";
        a.style.height = "0px";
        b = document.createElement("div");
        b.setAttribute("style", "position: fixed; top: 0; left: 0; display: flex;");
        b.appendChild(e);
        b.appendChild(a);
        document.body.appendChild(b);
        try {
            c = {}, b.style.alignItems = "baseline", c.baseline = a.offsetTop - e.offsetTop, b.style.alignItems = "flex-end", c.height = a.offsetTop - e.offsetTop;
        } finally{
            document.body.removeChild(b);
        }
        return c;
    };
    Blockly.Xml = {};
    Blockly.Xml.workspaceToDom = function(a, b) {
        var c = Blockly.utils.xml.createElement("xml"), d = Blockly.Xml.variablesToDom(Blockly.Variables.allUsedVarModels(a));
        d.hasChildNodes() && c.appendChild(d);
        var e = a.getTopComments(!0);
        d = 0;
        for(var f; f = e[d]; d++)c.appendChild(f.toXmlWithXY(b));
        a = a.getTopBlocks(!0);
        for(d = 0; e = a[d]; d++)c.appendChild(Blockly.Xml.blockToDomWithXY(e, b));
        return c;
    };
    Blockly.Xml.variablesToDom = function(a) {
        for(var b = Blockly.utils.xml.createElement("variables"), c = 0, d; d = a[c]; c++){
            var e = Blockly.utils.xml.createElement("variable");
            e.appendChild(Blockly.utils.xml.createTextNode(d.name));
            d.type && e.setAttribute("type", d.type);
            e.id = d.getId();
            b.appendChild(e);
        }
        return b;
    };
    Blockly.Xml.blockToDomWithXY = function(a, b) {
        if (a.isInsertionMarker() && (a = a.getChildren(!1)[0], !a)) return new DocumentFragment;
        var c;
        a.workspace.RTL && (c = a.workspace.getWidth());
        b = Blockly.Xml.blockToDom(a, b);
        var d = a.getRelativeToSurfaceXY();
        b.setAttribute("x", Math.round(a.workspace.RTL ? c - d.x : d.x));
        b.setAttribute("y", Math.round(d.y));
        return b;
    };
    Blockly.Xml.fieldToDom_ = function(a) {
        if (a.isSerializable()) {
            var b = Blockly.utils.xml.createElement("field");
            b.setAttribute("name", a.name || "");
            return a.toXml(b);
        }
        return null;
    };
    Blockly.Xml.allFieldsToDom_ = function(a, b) {
        for(var c = 0, d; d = a.inputList[c]; c++)for(var e = 0, f; f = d.fieldRow[e]; e++)(f = Blockly.Xml.fieldToDom_(f)) && b.appendChild(f);
    };
    Blockly.Xml.blockToDom = function(a, b) {
        if (a.isInsertionMarker()) return (a = a.getChildren(!1)[0]) ? Blockly.Xml.blockToDom(a) : new DocumentFragment;
        var c = Blockly.utils.xml.createElement(a.isShadow() ? "shadow" : "block");
        c.setAttribute("type", a.type);
        b || c.setAttribute("id", a.id);
        if (a.mutationToDom) {
            var d = a.mutationToDom();
            d && (d.hasChildNodes() || d.hasAttributes()) && c.appendChild(d);
        }
        Blockly.Xml.allFieldsToDom_(a, c);
        if (d = a.getCommentText()) {
            var e = a.commentModel.size, f = a.commentModel.pinned, g = Blockly.utils.xml.createElement("comment");
            g.appendChild(Blockly.utils.xml.createTextNode(d));
            g.setAttribute("pinned", f);
            g.setAttribute("h", e.height);
            g.setAttribute("w", e.width);
            c.appendChild(g);
        }
        a.data && (d = Blockly.utils.xml.createElement("data"), d.appendChild(Blockly.utils.xml.createTextNode(a.data)), c.appendChild(d));
        for(d = 0; e = a.inputList[d]; d++){
            var h;
            f = !0;
            if (e.type != Blockly.inputTypes.DUMMY) {
                var k = e.connection.targetBlock();
                e.type == Blockly.inputTypes.VALUE ? h = Blockly.utils.xml.createElement("value") : e.type == Blockly.inputTypes.STATEMENT && (h = Blockly.utils.xml.createElement("statement"));
                g = e.connection.getShadowDom();
                !g || k && k.isShadow() || h.appendChild(Blockly.Xml.cloneShadow_(g, b));
                k && (g = Blockly.Xml.blockToDom(k, b), g.nodeType == Blockly.utils.dom.NodeType.ELEMENT_NODE && (h.appendChild(g), f = !1));
                h.setAttribute("name", e.name);
                f || c.appendChild(h);
            }
        }
        void 0 != a.inputsInline && a.inputsInline != a.inputsInlineDefault && c.setAttribute("inline", a.inputsInline);
        a.isCollapsed() && c.setAttribute("collapsed", !0);
        a.isEnabled() || c.setAttribute("disabled", !0);
        a.isDeletable() || a.isShadow() || c.setAttribute("deletable", !1);
        a.isMovable() || a.isShadow() || c.setAttribute("movable", !1);
        a.isEditable() || c.setAttribute("editable", !1);
        if (d = a.getNextBlock()) g = Blockly.Xml.blockToDom(d, b), g.nodeType == Blockly.utils.dom.NodeType.ELEMENT_NODE && (h = Blockly.utils.xml.createElement("next"), h.appendChild(g), c.appendChild(h));
        g = a.nextConnection && a.nextConnection.getShadowDom();
        !g || d && d.isShadow() || h.appendChild(Blockly.Xml.cloneShadow_(g, b));
        return c;
    };
    Blockly.Xml.cloneShadow_ = function(a, b) {
        for(var c = a = a.cloneNode(!0), d; c;)if (b && "shadow" == c.nodeName && c.removeAttribute("id"), c.firstChild) c = c.firstChild;
        else {
            for(; c && !c.nextSibling;)d = c, c = c.parentNode, d.nodeType == Blockly.utils.dom.NodeType.TEXT_NODE && "" == d.data.trim() && c.firstChild != d && Blockly.utils.dom.removeNode(d);
            c && (d = c, c = c.nextSibling, d.nodeType == Blockly.utils.dom.NodeType.TEXT_NODE && "" == d.data.trim() && Blockly.utils.dom.removeNode(d));
        }
        return a;
    };
    Blockly.Xml.domToText = function(a) {
        return Blockly.utils.xml.domToText(a).replace(/<(\w+)([^<]*)\/>/g, "<$1$2></$1>");
    };
    Blockly.Xml.domToPrettyText = function(a) {
        a = Blockly.Xml.domToText(a).split("<");
        for(var b = "", c = 1; c < a.length; c++){
            var d = a[c];
            "/" == d[0] && (b = b.substring(2));
            a[c] = b + "<" + d;
            "/" != d[0] && "/>" != d.slice(-2) && (b += "  ");
        }
        a = a.join("\n");
        a = a.replace(/(<(\w+)\b[^>]*>[^\n]*)\n *<\/\2>/g, "$1</$2>");
        return a.replace(/^\n/, "");
    };
    Blockly.Xml.textToDom = function(a) {
        var b = Blockly.utils.xml.textToDomDocument(a);
        if (!b || !b.documentElement || b.getElementsByTagName("parsererror").length) throw Error("textToDom was unable to parse: " + a);
        return b.documentElement;
    };
    Blockly.Xml.clearWorkspaceAndLoadFromXml = function(a, b) {
        b.setResizesEnabled(!1);
        b.clear();
        a = Blockly.Xml.domToWorkspace(a, b);
        b.setResizesEnabled(!0);
        return a;
    };
    Blockly.Xml.domToWorkspace = function(a, b) {
        if (a instanceof Blockly.Workspace) {
            var c = a;
            a = b;
            b = c;
            console.warn("Deprecated call to Blockly.Xml.domToWorkspace, swap the arguments.");
        }
        var d;
        b.RTL && (d = b.getWidth());
        c = [];
        Blockly.utils.dom.startTextWidthCache();
        var e = Blockly.Events.getGroup();
        e || Blockly.Events.setGroup(!0);
        b.setResizesEnabled && b.setResizesEnabled(!1);
        var f = !0;
        try {
            for(var g = 0, h; h = a.childNodes[g]; g++){
                var k = h.nodeName.toLowerCase(), l = h;
                if ("block" == k || "shadow" == k && !Blockly.Events.recordUndo) {
                    var m = Blockly.Xml.domToBlock(l, b);
                    c.push(m.id);
                    var n = l.hasAttribute("x") ? parseInt(l.getAttribute("x"), 10) : 10, p = l.hasAttribute("y") ? parseInt(l.getAttribute("y"), 10) : 10;
                    isNaN(n) || isNaN(p) || m.moveBy(b.RTL ? d - n : n, p);
                    f = !1;
                } else {
                    if ("shadow" == k) throw TypeError("Shadow block cannot be a top-level block.");
                    if ("comment" == k) b.rendered ? Blockly.WorkspaceCommentSvg ? Blockly.WorkspaceCommentSvg.fromXml(l, b, d) : console.warn("Missing require for Blockly.WorkspaceCommentSvg, ignoring workspace comment.") : Blockly.WorkspaceComment ? Blockly.WorkspaceComment.fromXml(l, b) : console.warn("Missing require for Blockly.WorkspaceComment, ignoring workspace comment.");
                    else if ("variables" == k) {
                        if (f) Blockly.Xml.domToVariables(l, b);
                        else throw Error("'variables' tag must exist once before block and shadow tag elements in the workspace XML, but it was found in another location.");
                        f = !1;
                    }
                }
            }
        } finally{
            e || Blockly.Events.setGroup(!1), Blockly.utils.dom.stopTextWidthCache();
        }
        b.setResizesEnabled && b.setResizesEnabled(!0);
        Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.FINISHED_LOADING))(b));
        return c;
    };
    Blockly.Xml.appendDomToWorkspace = function(a, b) {
        var c;
        Object.prototype.hasOwnProperty.call(b, "scale") && (c = b.getBlocksBoundingBox());
        a = Blockly.Xml.domToWorkspace(a, b);
        if (c && c.top != c.bottom) {
            var d = c.bottom;
            var e = b.RTL ? c.right : c.left;
            var f = Infinity, g = -Infinity, h = Infinity;
            for(c = 0; c < a.length; c++){
                var k = b.getBlockById(a[c]).getRelativeToSurfaceXY();
                k.y < h && (h = k.y);
                k.x < f && (f = k.x);
                k.x > g && (g = k.x);
            }
            d = d - h + 10;
            e = b.RTL ? e - g : e - f;
            for(c = 0; c < a.length; c++)b.getBlockById(a[c]).moveBy(e, d);
        }
        return a;
    };
    Blockly.Xml.domToBlock = function(a, b) {
        if (a instanceof Blockly.Workspace) {
            var c = a;
            a = b;
            b = c;
            console.warn("Deprecated call to Blockly.Xml.domToBlock, swap the arguments.");
        }
        Blockly.Events.disable();
        c = b.getAllVariables();
        try {
            var d = Blockly.Xml.domToBlockHeadless_(a, b), e = d.getDescendants(!1);
            if (b.rendered) {
                d.setConnectionTracking(!1);
                for(var f = e.length - 1; 0 <= f; f--)e[f].initSvg();
                for(f = e.length - 1; 0 <= f; f--)e[f].render(!1);
                setTimeout(function() {
                    d.disposed || d.setConnectionTracking(!0);
                }, 1);
                d.updateDisabled();
                b.resizeContents();
            } else for(f = e.length - 1; 0 <= f; f--)e[f].initModel();
        } finally{
            Blockly.Events.enable();
        }
        if (Blockly.Events.isEnabled()) {
            a = Blockly.Variables.getAddedVariables(b, c);
            for(f = 0; f < a.length; f++)b = a[f], Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.VAR_CREATE))(b));
            Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.CREATE))(d));
        }
        return d;
    };
    Blockly.Xml.domToVariables = function(a, b) {
        for(var c = 0, d; d = a.childNodes[c]; c++)if (d.nodeType == Blockly.utils.dom.NodeType.ELEMENT_NODE) {
            var e = d.getAttribute("type"), f = d.getAttribute("id");
            b.createVariable(d.textContent, e, f);
        }
    };
    Blockly.Xml.mapSupportedXmlTags_ = function(a) {
        for(var b = {
            mutation: [],
            comment: [],
            data: [],
            field: [],
            input: [],
            next: []
        }, c = 0, d; d = a.childNodes[c]; c++)if (d.nodeType != Blockly.utils.dom.NodeType.TEXT_NODE) switch(d.nodeName.toLowerCase()){
            case "mutation":
                b.mutation.push(d);
                break;
            case "comment":
                if (!Blockly.Comment) {
                    console.warn("Missing require for Blockly.Comment, ignoring block comment.");
                    break;
                }
                b.comment.push(d);
                break;
            case "data":
                b.data.push(d);
                break;
            case "title":
            case "field":
                b.field.push(d);
                break;
            case "value":
            case "statement":
                b.input.push(d);
                break;
            case "next":
                b.next.push(d);
                break;
            default:
                console.warn("Ignoring unknown tag: " + d.nodeName);
        }
        return b;
    };
    Blockly.Xml.applyMutationTagNodes_ = function(a, b) {
        for(var c = !1, d = 0, e; e = a[d]; d++)b.domToMutation && (b.domToMutation(e), b.initSvg && (c = !0));
        return c;
    };
    Blockly.Xml.applyCommentTagNodes_ = function(a, b) {
        for(var c = 0, d; d = a[c]; c++){
            var e = d.textContent, f = "true" == d.getAttribute("pinned"), g = parseInt(d.getAttribute("w"), 10);
            d = parseInt(d.getAttribute("h"), 10);
            b.setCommentText(e);
            b.commentModel.pinned = f;
            isNaN(g) || isNaN(d) || (b.commentModel.size = new Blockly.utils.Size(g, d));
            f && b.getCommentIcon && !b.isInFlyout && setTimeout(function() {
                b.getCommentIcon().setVisible(!0);
            }, 1);
        }
    };
    Blockly.Xml.applyDataTagNodes_ = function(a, b) {
        for(var c = 0, d; d = a[c]; c++)b.data = d.textContent;
    };
    Blockly.Xml.applyFieldTagNodes_ = function(a, b) {
        for(var c = 0, d; d = a[c]; c++){
            var e = d.getAttribute("name");
            Blockly.Xml.domToField_(b, e, d);
        }
    };
    Blockly.Xml.findChildBlocks_ = function(a) {
        for(var b = {
            childBlockElement: null,
            childShadowElement: null
        }, c = 0, d; d = a.childNodes[c]; c++)d.nodeType == Blockly.utils.dom.NodeType.ELEMENT_NODE && ("block" == d.nodeName.toLowerCase() ? b.childBlockElement = d : "shadow" == d.nodeName.toLowerCase() && (b.childShadowElement = d));
        return b;
    };
    Blockly.Xml.applyInputTagNodes_ = function(a, b, c, d) {
        for(var e = 0, f; f = a[e]; e++){
            var g = f.getAttribute("name"), h = c.getInput(g);
            if (!h) {
                console.warn("Ignoring non-existent input " + g + " in block " + d);
                break;
            }
            f = Blockly.Xml.findChildBlocks_(f);
            if (f.childBlockElement) {
                if (!h.connection) throw TypeError("Input connection does not exist.");
                Blockly.Xml.domToBlockHeadless_(f.childBlockElement, b, h.connection, !1);
            }
            f.childShadowElement && h.connection.setShadowDom(f.childShadowElement);
        }
    };
    Blockly.Xml.applyNextTagNodes_ = function(a, b, c) {
        for(var d = 0, e; e = a[d]; d++){
            e = Blockly.Xml.findChildBlocks_(e);
            if (e.childBlockElement) {
                if (!c.nextConnection) throw TypeError("Next statement does not exist.");
                if (c.nextConnection.isConnected()) throw TypeError("Next statement is already connected.");
                Blockly.Xml.domToBlockHeadless_(e.childBlockElement, b, c.nextConnection, !0);
            }
            e.childShadowElement && c.nextConnection && c.nextConnection.setShadowDom(e.childShadowElement);
        }
    };
    Blockly.Xml.domToBlockHeadless_ = function(a, b, c, d) {
        var e = a.getAttribute("type");
        if (!e) throw TypeError("Block type unspecified: " + a.outerHTML);
        var f = a.getAttribute("id");
        f = b.newBlock(e, f);
        var g = Blockly.Xml.mapSupportedXmlTags_(a), h = Blockly.Xml.applyMutationTagNodes_(g.mutation, f);
        Blockly.Xml.applyCommentTagNodes_(g.comment, f);
        Blockly.Xml.applyDataTagNodes_(g.data, f);
        if (c) {
            if (d) {
                if (f.previousConnection) c.connect(f.previousConnection);
                else throw TypeError("Next block does not have previous statement.");
            } else if (f.outputConnection) c.connect(f.outputConnection);
            else if (f.previousConnection) c.connect(f.previousConnection);
            else throw TypeError("Child block does not have output or previous statement.");
        }
        Blockly.Xml.applyFieldTagNodes_(g.field, f);
        Blockly.Xml.applyInputTagNodes_(g.input, b, f, e);
        Blockly.Xml.applyNextTagNodes_(g.next, b, f);
        h && f.initSvg();
        (b = a.getAttribute("inline")) && f.setInputsInline("true" == b);
        (b = a.getAttribute("disabled")) && f.setEnabled("true" != b && "disabled" != b);
        (b = a.getAttribute("deletable")) && f.setDeletable("true" == b);
        (b = a.getAttribute("movable")) && f.setMovable("true" == b);
        (b = a.getAttribute("editable")) && f.setEditable("true" == b);
        (b = a.getAttribute("collapsed")) && f.setCollapsed("true" == b);
        if ("shadow" == a.nodeName.toLowerCase()) {
            a = f.getChildren(!1);
            for(b = 0; c = a[b]; b++)if (!c.isShadow()) throw TypeError("Shadow block not allowed non-shadow child.");
            if (f.getVarModels().length) throw TypeError("Shadow blocks cannot have variable references.");
            f.setShadow(!0);
        }
        return f;
    };
    Blockly.Xml.domToField_ = function(a, b, c) {
        var d = a.getField(b);
        d ? d.fromXml(c) : console.warn("Ignoring non-existent field " + b + " in block " + a.type);
    };
    Blockly.Xml.deleteNext = function(a) {
        for(var b = 0, c; c = a.childNodes[b]; b++)if ("next" == c.nodeName.toLowerCase()) {
            a.removeChild(c);
            break;
        }
    };
    Blockly.Events.BlockBase = function(a) {
        Blockly.Events.BlockBase.superClass_.constructor.call(this);
        this.blockId = (this.isBlank = "undefined" == typeof a) ? "" : a.id;
        this.workspaceId = this.isBlank ? "" : a.workspace.id;
    };
    Blockly.utils.object.inherits(Blockly.Events.BlockBase, Blockly.Events.Abstract);
    Blockly.Events.BlockBase.prototype.toJson = function() {
        var a = Blockly.Events.BlockBase.superClass_.toJson.call(this);
        a.blockId = this.blockId;
        return a;
    };
    Blockly.Events.BlockBase.prototype.fromJson = function(a) {
        Blockly.Events.BlockBase.superClass_.fromJson.call(this, a);
        this.blockId = a.blockId;
    };
    Blockly.Events.Change = function(a, b, c, d, e) {
        Blockly.Events.Change.superClass_.constructor.call(this, a);
        a && (this.element = "undefined" == typeof b ? "" : b, this.name = "undefined" == typeof c ? "" : c, this.oldValue = "undefined" == typeof d ? "" : d, this.newValue = "undefined" == typeof e ? "" : e);
    };
    Blockly.utils.object.inherits(Blockly.Events.Change, Blockly.Events.BlockBase);
    Blockly.Events.BlockChange = Blockly.Events.Change;
    Blockly.Events.Change.prototype.type = Blockly.Events.CHANGE;
    Blockly.Events.Change.prototype.toJson = function() {
        var a = Blockly.Events.Change.superClass_.toJson.call(this);
        a.element = this.element;
        this.name && (a.name = this.name);
        a.oldValue = this.oldValue;
        a.newValue = this.newValue;
        return a;
    };
    Blockly.Events.Change.prototype.fromJson = function(a) {
        Blockly.Events.Change.superClass_.fromJson.call(this, a);
        this.element = a.element;
        this.name = a.name;
        this.oldValue = a.oldValue;
        this.newValue = a.newValue;
    };
    Blockly.Events.Change.prototype.isNull = function() {
        return this.oldValue == this.newValue;
    };
    Blockly.Events.Change.prototype.run = function(a) {
        var b = this.getEventWorkspace_().getBlockById(this.blockId);
        if (b) switch(b.mutator && b.mutator.setVisible(!1), a = a ? this.newValue : this.oldValue, this.element){
            case "field":
                (b = b.getField(this.name)) ? b.setValue(a) : console.warn("Can't set non-existent field: " + this.name);
                break;
            case "comment":
                b.setCommentText(a || null);
                break;
            case "collapsed":
                b.setCollapsed(!!a);
                break;
            case "disabled":
                b.setEnabled(!a);
                break;
            case "inline":
                b.setInputsInline(!!a);
                break;
            case "mutation":
                var c = "";
                b.mutationToDom && (c = (c = b.mutationToDom()) && Blockly.Xml.domToText(c));
                if (b.domToMutation) {
                    var d = Blockly.Xml.textToDom(a || "<mutation/>");
                    b.domToMutation(d);
                }
                Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.CHANGE))(b, "mutation", null, c, a));
                break;
            default:
                console.warn("Unknown change type: " + this.element);
        }
        else console.warn("Can't change non-existent block: " + this.blockId);
    };
    Blockly.Events.Create = function(a) {
        Blockly.Events.Create.superClass_.constructor.call(this, a);
        a && (a.isShadow() && (this.recordUndo = !1), this.xml = a.workspace.rendered ? Blockly.Xml.blockToDomWithXY(a) : Blockly.Xml.blockToDom(a), this.ids = Blockly.Events.getDescendantIds(a));
    };
    Blockly.utils.object.inherits(Blockly.Events.Create, Blockly.Events.BlockBase);
    Blockly.Events.BlockCreate = Blockly.Events.Create;
    Blockly.Events.Create.prototype.type = Blockly.Events.CREATE;
    Blockly.Events.Create.prototype.toJson = function() {
        var a = Blockly.Events.Create.superClass_.toJson.call(this);
        a.xml = Blockly.Xml.domToText(this.xml);
        a.ids = this.ids;
        this.recordUndo || (a.recordUndo = this.recordUndo);
        return a;
    };
    Blockly.Events.Create.prototype.fromJson = function(a) {
        Blockly.Events.Create.superClass_.fromJson.call(this, a);
        this.xml = Blockly.Xml.textToDom(a.xml);
        this.ids = a.ids;
        void 0 !== a.recordUndo && (this.recordUndo = a.recordUndo);
    };
    Blockly.Events.Create.prototype.run = function(a) {
        var b = this.getEventWorkspace_();
        if (a) a = Blockly.utils.xml.createElement("xml"), a.appendChild(this.xml), Blockly.Xml.domToWorkspace(a, b);
        else {
            a = 0;
            for(var c; c = this.ids[a]; a++){
                var d = b.getBlockById(c);
                d ? d.dispose(!1) : c == this.blockId && console.warn("Can't uncreate non-existent block: " + c);
            }
        }
    };
    Blockly.Events.Delete = function(a) {
        Blockly.Events.Delete.superClass_.constructor.call(this, a);
        if (a) {
            if (a.getParent()) throw Error("Connected blocks cannot be deleted.");
            a.isShadow() && (this.recordUndo = !1);
            this.oldXml = a.workspace.rendered ? Blockly.Xml.blockToDomWithXY(a) : Blockly.Xml.blockToDom(a);
            this.ids = Blockly.Events.getDescendantIds(a);
        }
    };
    Blockly.utils.object.inherits(Blockly.Events.Delete, Blockly.Events.BlockBase);
    Blockly.Events.BlockDelete = Blockly.Events.Delete;
    Blockly.Events.Delete.prototype.type = Blockly.Events.DELETE;
    Blockly.Events.Delete.prototype.toJson = function() {
        var a = Blockly.Events.Delete.superClass_.toJson.call(this);
        a.oldXml = Blockly.Xml.domToText(this.oldXml);
        a.ids = this.ids;
        this.recordUndo || (a.recordUndo = this.recordUndo);
        return a;
    };
    Blockly.Events.Delete.prototype.fromJson = function(a) {
        Blockly.Events.Delete.superClass_.fromJson.call(this, a);
        this.oldXml = Blockly.Xml.textToDom(a.oldXml);
        this.ids = a.ids;
        void 0 !== a.recordUndo && (this.recordUndo = a.recordUndo);
    };
    Blockly.Events.Delete.prototype.run = function(a) {
        var b = this.getEventWorkspace_();
        if (a) {
            a = 0;
            for(var c; c = this.ids[a]; a++){
                var d = b.getBlockById(c);
                d ? d.dispose(!1) : c == this.blockId && console.warn("Can't delete non-existent block: " + c);
            }
        } else a = Blockly.utils.xml.createElement("xml"), a.appendChild(this.oldXml), Blockly.Xml.domToWorkspace(a, b);
    };
    Blockly.Events.Move = function(a) {
        Blockly.Events.Move.superClass_.constructor.call(this, a);
        a && (a.isShadow() && (this.recordUndo = !1), a = this.currentLocation_(), this.oldParentId = a.parentId, this.oldInputName = a.inputName, this.oldCoordinate = a.coordinate);
    };
    Blockly.utils.object.inherits(Blockly.Events.Move, Blockly.Events.BlockBase);
    Blockly.Events.BlockMove = Blockly.Events.Move;
    Blockly.Events.Move.prototype.type = Blockly.Events.MOVE;
    Blockly.Events.Move.prototype.toJson = function() {
        var a = Blockly.Events.Move.superClass_.toJson.call(this);
        this.newParentId && (a.newParentId = this.newParentId);
        this.newInputName && (a.newInputName = this.newInputName);
        this.newCoordinate && (a.newCoordinate = Math.round(this.newCoordinate.x) + "," + Math.round(this.newCoordinate.y));
        this.recordUndo || (a.recordUndo = this.recordUndo);
        return a;
    };
    Blockly.Events.Move.prototype.fromJson = function(a) {
        Blockly.Events.Move.superClass_.fromJson.call(this, a);
        this.newParentId = a.newParentId;
        this.newInputName = a.newInputName;
        if (a.newCoordinate) {
            var b = a.newCoordinate.split(",");
            this.newCoordinate = new Blockly.utils.Coordinate(Number(b[0]), Number(b[1]));
        }
        void 0 !== a.recordUndo && (this.recordUndo = a.recordUndo);
    };
    Blockly.Events.Move.prototype.recordNew = function() {
        var a = this.currentLocation_();
        this.newParentId = a.parentId;
        this.newInputName = a.inputName;
        this.newCoordinate = a.coordinate;
    };
    Blockly.Events.Move.prototype.currentLocation_ = function() {
        var a = this.getEventWorkspace_().getBlockById(this.blockId), b = {}, c = a.getParent();
        if (c) {
            if (b.parentId = c.id, a = c.getInputWithBlock(a)) b.inputName = a.name;
        } else b.coordinate = a.getRelativeToSurfaceXY();
        return b;
    };
    Blockly.Events.Move.prototype.isNull = function() {
        return this.oldParentId == this.newParentId && this.oldInputName == this.newInputName && Blockly.utils.Coordinate.equals(this.oldCoordinate, this.newCoordinate);
    };
    Blockly.Events.Move.prototype.run = function(a) {
        var b = this.getEventWorkspace_(), c = b.getBlockById(this.blockId);
        if (c) {
            var d = a ? this.newParentId : this.oldParentId, e = a ? this.newInputName : this.oldInputName, f = a ? this.newCoordinate : this.oldCoordinate;
            a = null;
            if (d && (a = b.getBlockById(d), !a)) {
                console.warn("Can't connect to non-existent block: " + d);
                return;
            }
            c.getParent() && c.unplug();
            if (f) e = c.getRelativeToSurfaceXY(), c.moveBy(f.x - e.x, f.y - e.y);
            else {
                c = c.outputConnection || c.previousConnection;
                b = c.type;
                if (e) {
                    if (a = a.getInput(e)) var g = a.connection;
                } else b == Blockly.connectionTypes.PREVIOUS_STATEMENT && (g = a.nextConnection);
                g ? c.connect(g) : console.warn("Can't connect to non-existent input: " + e);
            }
        } else console.warn("Can't move non-existent block: " + this.blockId);
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.CREATE, Blockly.Events.Create);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.DELETE, Blockly.Events.Delete);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.CHANGE, Blockly.Events.Change);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.MOVE, Blockly.Events.Move);
    Blockly.Events.FinishedLoading = function(a) {
        this.isBlank = "undefined" == typeof a;
        this.workspaceId = a ? a.id : "";
        this.group = Blockly.Events.getGroup();
        this.recordUndo = !1;
    };
    Blockly.utils.object.inherits(Blockly.Events.FinishedLoading, Blockly.Events.Abstract);
    Blockly.Events.FinishedLoading.prototype.type = Blockly.Events.FINISHED_LOADING;
    Blockly.Events.FinishedLoading.prototype.toJson = function() {
        var a = {
            type: this.type
        };
        this.group && (a.group = this.group);
        this.workspaceId && (a.workspaceId = this.workspaceId);
        return a;
    };
    Blockly.Events.FinishedLoading.prototype.fromJson = function(a) {
        this.isBlank = !1;
        this.workspaceId = a.workspaceId;
        this.group = a.group;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.FINISHED_LOADING, Blockly.Events.FinishedLoading);
    Blockly.Events.UiBase = function(a) {
        Blockly.Events.UiBase.superClass_.constructor.call(this);
        this.isBlank = "undefined" == typeof a;
        this.workspaceId = a ? a : "";
        this.recordUndo = !1;
    };
    Blockly.utils.object.inherits(Blockly.Events.UiBase, Blockly.Events.Abstract);
    Blockly.Events.UiBase.prototype.isUiEvent = !0;
    Blockly.Events.Ui = function(a, b, c, d) {
        Blockly.Events.Ui.superClass_.constructor.call(this, a ? a.workspace.id : void 0);
        this.blockId = a ? a.id : null;
        this.element = "undefined" == typeof b ? "" : b;
        this.oldValue = "undefined" == typeof c ? "" : c;
        this.newValue = "undefined" == typeof d ? "" : d;
    };
    Blockly.utils.object.inherits(Blockly.Events.Ui, Blockly.Events.UiBase);
    Blockly.Events.Ui.prototype.type = Blockly.Events.UI;
    Blockly.Events.Ui.prototype.toJson = function() {
        var a = Blockly.Events.Ui.superClass_.toJson.call(this);
        a.element = this.element;
        void 0 !== this.newValue && (a.newValue = this.newValue);
        this.blockId && (a.blockId = this.blockId);
        return a;
    };
    Blockly.Events.Ui.prototype.fromJson = function(a) {
        Blockly.Events.Ui.superClass_.fromJson.call(this, a);
        this.element = a.element;
        this.newValue = a.newValue;
        this.blockId = a.blockId;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.UI, Blockly.Events.Ui);
    Blockly.Events.VarBase = function(a) {
        Blockly.Events.VarBase.superClass_.constructor.call(this);
        this.varId = (this.isBlank = "undefined" == typeof a) ? "" : a.getId();
        this.workspaceId = this.isBlank ? "" : a.workspace.id;
    };
    Blockly.utils.object.inherits(Blockly.Events.VarBase, Blockly.Events.Abstract);
    Blockly.Events.VarBase.prototype.toJson = function() {
        var a = Blockly.Events.VarBase.superClass_.toJson.call(this);
        a.varId = this.varId;
        return a;
    };
    Blockly.Events.VarBase.prototype.fromJson = function(a) {
        Blockly.Events.VarBase.superClass_.toJson.call(this);
        this.varId = a.varId;
    };
    Blockly.Events.VarCreate = function(a) {
        Blockly.Events.VarCreate.superClass_.constructor.call(this, a);
        a && (this.varType = a.type, this.varName = a.name);
    };
    Blockly.utils.object.inherits(Blockly.Events.VarCreate, Blockly.Events.VarBase);
    Blockly.Events.VarCreate.prototype.type = Blockly.Events.VAR_CREATE;
    Blockly.Events.VarCreate.prototype.toJson = function() {
        var a = Blockly.Events.VarCreate.superClass_.toJson.call(this);
        a.varType = this.varType;
        a.varName = this.varName;
        return a;
    };
    Blockly.Events.VarCreate.prototype.fromJson = function(a) {
        Blockly.Events.VarCreate.superClass_.fromJson.call(this, a);
        this.varType = a.varType;
        this.varName = a.varName;
    };
    Blockly.Events.VarCreate.prototype.run = function(a) {
        var b = this.getEventWorkspace_();
        a ? b.createVariable(this.varName, this.varType, this.varId) : b.deleteVariableById(this.varId);
    };
    Blockly.Events.VarDelete = function(a) {
        Blockly.Events.VarDelete.superClass_.constructor.call(this, a);
        a && (this.varType = a.type, this.varName = a.name);
    };
    Blockly.utils.object.inherits(Blockly.Events.VarDelete, Blockly.Events.VarBase);
    Blockly.Events.VarDelete.prototype.type = Blockly.Events.VAR_DELETE;
    Blockly.Events.VarDelete.prototype.toJson = function() {
        var a = Blockly.Events.VarDelete.superClass_.toJson.call(this);
        a.varType = this.varType;
        a.varName = this.varName;
        return a;
    };
    Blockly.Events.VarDelete.prototype.fromJson = function(a) {
        Blockly.Events.VarDelete.superClass_.fromJson.call(this, a);
        this.varType = a.varType;
        this.varName = a.varName;
    };
    Blockly.Events.VarDelete.prototype.run = function(a) {
        var b = this.getEventWorkspace_();
        a ? b.deleteVariableById(this.varId) : b.createVariable(this.varName, this.varType, this.varId);
    };
    Blockly.Events.VarRename = function(a, b) {
        Blockly.Events.VarRename.superClass_.constructor.call(this, a);
        a && (this.oldName = a.name, this.newName = "undefined" == typeof b ? "" : b);
    };
    Blockly.utils.object.inherits(Blockly.Events.VarRename, Blockly.Events.VarBase);
    Blockly.Events.VarRename.prototype.type = Blockly.Events.VAR_RENAME;
    Blockly.Events.VarRename.prototype.toJson = function() {
        var a = Blockly.Events.VarRename.superClass_.toJson.call(this);
        a.oldName = this.oldName;
        a.newName = this.newName;
        return a;
    };
    Blockly.Events.VarRename.prototype.fromJson = function(a) {
        Blockly.Events.VarRename.superClass_.fromJson.call(this, a);
        this.oldName = a.oldName;
        this.newName = a.newName;
    };
    Blockly.Events.VarRename.prototype.run = function(a) {
        var b = this.getEventWorkspace_();
        a ? b.renameVariableById(this.varId, this.newName) : b.renameVariableById(this.varId, this.oldName);
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.VAR_CREATE, Blockly.Events.VarCreate);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.VAR_DELETE, Blockly.Events.VarDelete);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.VAR_RENAME, Blockly.Events.VarRename);
    Blockly.BlockDragSurfaceSvg = function(a) {
        this.container_ = a;
        this.createDom();
    };
    Blockly.BlockDragSurfaceSvg.prototype.SVG_ = null;
    Blockly.BlockDragSurfaceSvg.prototype.dragGroup_ = null;
    Blockly.BlockDragSurfaceSvg.prototype.container_ = null;
    Blockly.BlockDragSurfaceSvg.prototype.scale_ = 1;
    Blockly.BlockDragSurfaceSvg.prototype.surfaceXY_ = null;
    Blockly.BlockDragSurfaceSvg.prototype.createDom = function() {
        this.SVG_ || (this.SVG_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
            xmlns: Blockly.utils.dom.SVG_NS,
            "xmlns:html": Blockly.utils.dom.HTML_NS,
            "xmlns:xlink": Blockly.utils.dom.XLINK_NS,
            version: "1.1",
            "class": "blocklyBlockDragSurface"
        }, this.container_), this.dragGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, this.SVG_));
    };
    Blockly.BlockDragSurfaceSvg.prototype.setBlocksAndShow = function(a) {
        if (this.dragGroup_.childNodes.length) throw Error("Already dragging a block.");
        this.dragGroup_.appendChild(a);
        this.SVG_.style.display = "block";
        this.surfaceXY_ = new Blockly.utils.Coordinate(0, 0);
    };
    Blockly.BlockDragSurfaceSvg.prototype.translateAndScaleGroup = function(a, b, c) {
        this.scale_ = c;
        a = a.toFixed(0);
        b = b.toFixed(0);
        this.dragGroup_.setAttribute("transform", "translate(" + a + "," + b + ") scale(" + c + ")");
    };
    Blockly.BlockDragSurfaceSvg.prototype.translateSurfaceInternal_ = function() {
        var a = this.surfaceXY_.x, b = this.surfaceXY_.y;
        a = a.toFixed(0);
        b = b.toFixed(0);
        this.SVG_.style.display = "block";
        Blockly.utils.dom.setCssTransform(this.SVG_, "translate3d(" + a + "px, " + b + "px, 0px)");
    };
    Blockly.BlockDragSurfaceSvg.prototype.translateSurface = function(a, b) {
        this.surfaceXY_ = new Blockly.utils.Coordinate(a * this.scale_, b * this.scale_);
        this.translateSurfaceInternal_();
    };
    Blockly.BlockDragSurfaceSvg.prototype.getSurfaceTranslation = function() {
        var a = Blockly.utils.getRelativeXY(this.SVG_);
        return new Blockly.utils.Coordinate(a.x / this.scale_, a.y / this.scale_);
    };
    Blockly.BlockDragSurfaceSvg.prototype.getGroup = function() {
        return this.dragGroup_;
    };
    Blockly.BlockDragSurfaceSvg.prototype.getCurrentBlock = function() {
        return this.dragGroup_.firstChild;
    };
    Blockly.BlockDragSurfaceSvg.prototype.clearAndHide = function(a) {
        a ? a.appendChild(this.getCurrentBlock()) : this.dragGroup_.removeChild(this.getCurrentBlock());
        this.SVG_.style.display = "none";
        if (this.dragGroup_.childNodes.length) throw Error("Drag group was not cleared.");
        this.surfaceXY_ = null;
    };
    Blockly.Css = {};
    Blockly.Css.injected_ = !1;
    Blockly.Css.register = function(a) {
        if (Blockly.Css.injected_) throw Error("CSS already injected");
        Array.prototype.push.apply(Blockly.Css.CONTENT, a);
        a.length = 0;
    };
    Blockly.Css.inject = function(a, b) {
        if (!Blockly.Css.injected_) {
            Blockly.Css.injected_ = !0;
            var c = Blockly.Css.CONTENT.join("\n");
            Blockly.Css.CONTENT.length = 0;
            a && (a = b.replace(/[\\/]$/, ""), c = c.replace(/<<<PATH>>>/g, a), a = document.createElement("style"), a.id = "blockly-common-style", c = document.createTextNode(c), a.appendChild(c), document.head.insertBefore(a, document.head.firstChild));
        }
    };
    Blockly.Css.CONTENT = [
        ".blocklySvg {",
        "background-color: #fff;",
        "outline: none;",
        "overflow: hidden;",
        "position: absolute;",
        "display: block;",
        "}",
        ".blocklyWidgetDiv {",
        "display: none;",
        "position: absolute;",
        "z-index: 99999;",
        "}",
        ".injectionDiv {",
        "height: 100%;",
        "position: relative;",
        "overflow: hidden;",
        "touch-action: none;",
        "}",
        ".blocklyNonSelectable {",
        "user-select: none;",
        "-ms-user-select: none;",
        "-webkit-user-select: none;",
        "}",
        ".blocklyWsDragSurface {",
        "display: none;",
        "position: absolute;",
        "top: 0;",
        "left: 0;",
        "}",
        ".blocklyWsDragSurface.blocklyOverflowVisible {",
        "overflow: visible;",
        "}",
        ".blocklyBlockDragSurface {",
        "display: none;",
        "position: absolute;",
        "top: 0;",
        "left: 0;",
        "right: 0;",
        "bottom: 0;",
        "overflow: visible !important;",
        "z-index: 50;",
        "}",
        ".blocklyBlockCanvas.blocklyCanvasTransitioning,",
        ".blocklyBubbleCanvas.blocklyCanvasTransitioning {",
        "transition: transform .5s;",
        "}",
        ".blocklyTooltipDiv {",
        "background-color: #ffffc7;",
        "border: 1px solid #ddc;",
        "box-shadow: 4px 4px 20px 1px rgba(0,0,0,.15);",
        "color: #000;",
        "display: none;",
        "font: 9pt sans-serif;",
        "opacity: .9;",
        "padding: 2px;",
        "position: absolute;",
        "z-index: 100000;",
        "}",
        ".blocklyDropDownDiv {",
        "position: absolute;",
        "left: 0;",
        "top: 0;",
        "z-index: 1000;",
        "display: none;",
        "border: 1px solid;",
        "border-color: #dadce0;",
        "background-color: #fff;",
        "border-radius: 2px;",
        "padding: 4px;",
        "box-shadow: 0 0 3px 1px rgba(0,0,0,.3);",
        "}",
        ".blocklyDropDownDiv.blocklyFocused {",
        "box-shadow: 0 0 6px 1px rgba(0,0,0,.3);",
        "}",
        ".blocklyDropDownContent {",
        "max-height: 300px;",
        "overflow: auto;",
        "overflow-x: hidden;",
        "position: relative;",
        "}",
        ".blocklyDropDownArrow {",
        "position: absolute;",
        "left: 0;",
        "top: 0;",
        "width: 16px;",
        "height: 16px;",
        "z-index: -1;",
        "background-color: inherit;",
        "border-color: inherit;",
        "}",
        ".blocklyDropDownButton {",
        "display: inline-block;",
        "float: left;",
        "padding: 0;",
        "margin: 4px;",
        "border-radius: 4px;",
        "outline: none;",
        "border: 1px solid;",
        "transition: box-shadow .1s;",
        "cursor: pointer;",
        "}",
        ".blocklyArrowTop {",
        "border-top: 1px solid;",
        "border-left: 1px solid;",
        "border-top-left-radius: 4px;",
        "border-color: inherit;",
        "}",
        ".blocklyArrowBottom {",
        "border-bottom: 1px solid;",
        "border-right: 1px solid;",
        "border-bottom-right-radius: 4px;",
        "border-color: inherit;",
        "}",
        ".blocklyResizeSE {",
        "cursor: se-resize;",
        "fill: #aaa;",
        "}",
        ".blocklyResizeSW {",
        "cursor: sw-resize;",
        "fill: #aaa;",
        "}",
        ".blocklyResizeLine {",
        "stroke: #515A5A;",
        "stroke-width: 1;",
        "}",
        ".blocklyHighlightedConnectionPath {",
        "fill: none;",
        "stroke: #fc3;",
        "stroke-width: 4px;",
        "}",
        ".blocklyPathLight {",
        "fill: none;",
        "stroke-linecap: round;",
        "stroke-width: 1;",
        "}",
        ".blocklySelected>.blocklyPathLight {",
        "display: none;",
        "}",
        ".blocklyDraggable {",
        'cursor: url("<<<PATH>>>/handopen.cur"), auto;',
        "cursor: grab;",
        "cursor: -webkit-grab;",
        "}",
        ".blocklyDragging {",
        'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',
        "cursor: grabbing;",
        "cursor: -webkit-grabbing;",
        "}",
        ".blocklyDraggable:active {",
        'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',
        "cursor: grabbing;",
        "cursor: -webkit-grabbing;",
        "}",
        ".blocklyBlockDragSurface .blocklyDraggable {",
        'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',
        "cursor: grabbing;",
        "cursor: -webkit-grabbing;",
        "}",
        ".blocklyDragging.blocklyDraggingDelete {",
        'cursor: url("<<<PATH>>>/handdelete.cur"), auto;',
        "}",
        ".blocklyDragging>.blocklyPath,",
        ".blocklyDragging>.blocklyPathLight {",
        "fill-opacity: .8;",
        "stroke-opacity: .8;",
        "}",
        ".blocklyDragging>.blocklyPathDark {",
        "display: none;",
        "}",
        ".blocklyDisabled>.blocklyPath {",
        "fill-opacity: .5;",
        "stroke-opacity: .5;",
        "}",
        ".blocklyDisabled>.blocklyPathLight,",
        ".blocklyDisabled>.blocklyPathDark {",
        "display: none;",
        "}",
        ".blocklyInsertionMarker>.blocklyPath,",
        ".blocklyInsertionMarker>.blocklyPathLight,",
        ".blocklyInsertionMarker>.blocklyPathDark {",
        "fill-opacity: .2;",
        "stroke: none;",
        "}",
        ".blocklyMultilineText {",
        "font-family: monospace;",
        "}",
        ".blocklyNonEditableText>text {",
        "pointer-events: none;",
        "}",
        ".blocklyFlyout {",
        "position: absolute;",
        "z-index: 20;",
        "}",
        ".blocklyText text {",
        "cursor: default;",
        "}",
        ".blocklySvg text,",
        ".blocklyBlockDragSurface text {",
        "user-select: none;",
        "-ms-user-select: none;",
        "-webkit-user-select: none;",
        "cursor: inherit;",
        "}",
        ".blocklyHidden {",
        "display: none;",
        "}",
        ".blocklyFieldDropdown:not(.blocklyHidden) {",
        "display: block;",
        "}",
        ".blocklyIconGroup {",
        "cursor: default;",
        "}",
        ".blocklyIconGroup:not(:hover),",
        ".blocklyIconGroupReadonly {",
        "opacity: .6;",
        "}",
        ".blocklyIconShape {",
        "fill: #00f;",
        "stroke: #fff;",
        "stroke-width: 1px;",
        "}",
        ".blocklyIconSymbol {",
        "fill: #fff;",
        "}",
        ".blocklyMinimalBody {",
        "margin: 0;",
        "padding: 0;",
        "}",
        ".blocklyHtmlInput {",
        "border: none;",
        "border-radius: 4px;",
        "height: 100%;",
        "margin: 0;",
        "outline: none;",
        "padding: 0;",
        "width: 100%;",
        "text-align: center;",
        "display: block;",
        "box-sizing: border-box;",
        "}",
        ".blocklyHtmlInput::-ms-clear {",
        "display: none;",
        "}",
        ".blocklyMainBackground {",
        "stroke-width: 1;",
        "stroke: #c6c6c6;",
        "}",
        ".blocklyMutatorBackground {",
        "fill: #fff;",
        "stroke: #ddd;",
        "stroke-width: 1;",
        "}",
        ".blocklyFlyoutBackground {",
        "fill: #ddd;",
        "fill-opacity: .8;",
        "}",
        ".blocklyMainWorkspaceScrollbar {",
        "z-index: 20;",
        "}",
        ".blocklyFlyoutScrollbar {",
        "z-index: 30;",
        "}",
        ".blocklyScrollbarHorizontal,",
        ".blocklyScrollbarVertical {",
        "position: absolute;",
        "outline: none;",
        "}",
        ".blocklyScrollbarBackground {",
        "opacity: 0;",
        "}",
        ".blocklyScrollbarHandle {",
        "fill: #ccc;",
        "}",
        ".blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,",
        ".blocklyScrollbarHandle:hover {",
        "fill: #bbb;",
        "}",
        ".blocklyFlyout .blocklyScrollbarHandle {",
        "fill: #bbb;",
        "}",
        ".blocklyFlyout .blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,",
        ".blocklyFlyout .blocklyScrollbarHandle:hover {",
        "fill: #aaa;",
        "}",
        ".blocklyInvalidInput {",
        "background: #faa;",
        "}",
        ".blocklyVerticalMarker {",
        "stroke-width: 3px;",
        "fill: rgba(255,255,255,.5);",
        "pointer-events: none;",
        "}",
        ".blocklyComputeCanvas {",
        "position: absolute;",
        "width: 0;",
        "height: 0;",
        "}",
        ".blocklyNoPointerEvents {",
        "pointer-events: none;",
        "}",
        ".blocklyContextMenu {",
        "border-radius: 4px;",
        "max-height: 100%;",
        "}",
        ".blocklyDropdownMenu {",
        "border-radius: 2px;",
        "padding: 0 !important;",
        "}",
        ".blocklyDropdownMenu .blocklyMenuItem {",
        "padding-left: 28px;",
        "}",
        ".blocklyDropdownMenu .blocklyMenuItemRtl {",
        "padding-left: 5px;",
        "padding-right: 28px;",
        "}",
        ".blocklyWidgetDiv .blocklyMenu {",
        "background: #fff;",
        "border: 1px solid transparent;",
        "box-shadow: 0 0 3px 1px rgba(0,0,0,.3);",
        "font: normal 13px Arial, sans-serif;",
        "margin: 0;",
        "outline: none;",
        "padding: 4px 0;",
        "position: absolute;",
        "overflow-y: auto;",
        "overflow-x: hidden;",
        "max-height: 100%;",
        "z-index: 20000;",
        "}",
        ".blocklyWidgetDiv .blocklyMenu.blocklyFocused {",
        "box-shadow: 0 0 6px 1px rgba(0,0,0,.3);",
        "}",
        ".blocklyDropDownDiv .blocklyMenu {",
        "background: inherit;",
        "border: inherit;",
        'font: normal 13px "Helvetica Neue", Helvetica, sans-serif;',
        "outline: none;",
        "position: relative;",
        "z-index: 20000;",
        "}",
        ".blocklyMenuItem {",
        "border: none;",
        "color: #000;",
        "cursor: pointer;",
        "list-style: none;",
        "margin: 0;",
        "min-width: 7em;",
        "padding: 6px 15px;",
        "white-space: nowrap;",
        "}",
        ".blocklyMenuItemDisabled {",
        "color: #ccc;",
        "cursor: inherit;",
        "}",
        ".blocklyMenuItemHighlight {",
        "background-color: rgba(0,0,0,.1);",
        "}",
        ".blocklyMenuItemCheckbox {",
        "height: 16px;",
        "position: absolute;",
        "width: 16px;",
        "}",
        ".blocklyMenuItemSelected .blocklyMenuItemCheckbox {",
        "background: url(<<<PATH>>>/sprites.png) no-repeat -48px -16px;",
        "float: left;",
        "margin-left: -24px;",
        "position: static;",
        "}",
        ".blocklyMenuItemRtl .blocklyMenuItemCheckbox {",
        "float: right;",
        "margin-right: -24px;",
        "}"
    ];
    Blockly.utils.math = {};
    Blockly.utils.math.toRadians = function(a) {
        return a * Math.PI / 180;
    };
    Blockly.utils.math.toDegrees = function(a) {
        return 180 * a / Math.PI;
    };
    Blockly.utils.math.clamp = function(a, b, c) {
        if (c < a) {
            var d = c;
            c = a;
            a = d;
        }
        return Math.max(a, Math.min(b, c));
    };
    Blockly.DropDownDiv = function() {};
    Blockly.DropDownDiv.boundsElement_ = null;
    Blockly.DropDownDiv.owner_ = null;
    Blockly.DropDownDiv.positionToField_ = null;
    Blockly.DropDownDiv.ARROW_SIZE = 16;
    Blockly.DropDownDiv.BORDER_SIZE = 1;
    Blockly.DropDownDiv.ARROW_HORIZONTAL_PADDING = 12;
    Blockly.DropDownDiv.PADDING_Y = 16;
    Blockly.DropDownDiv.ANIMATION_TIME = .25;
    Blockly.DropDownDiv.animateOutTimer_ = null;
    Blockly.DropDownDiv.onHide_ = null;
    Blockly.DropDownDiv.rendererClassName_ = "";
    Blockly.DropDownDiv.themeClassName_ = "";
    Blockly.DropDownDiv.createDom = function() {
        if (!Blockly.DropDownDiv.DIV_) {
            var a = document.createElement("div");
            a.className = "blocklyDropDownDiv";
            (Blockly.parentContainer || document.body).appendChild(a);
            Blockly.DropDownDiv.DIV_ = a;
            var b = document.createElement("div");
            b.className = "blocklyDropDownContent";
            a.appendChild(b);
            Blockly.DropDownDiv.content_ = b;
            b = document.createElement("div");
            b.className = "blocklyDropDownArrow";
            a.appendChild(b);
            Blockly.DropDownDiv.arrow_ = b;
            Blockly.DropDownDiv.DIV_.style.opacity = 0;
            Blockly.DropDownDiv.DIV_.style.transition = "transform " + Blockly.DropDownDiv.ANIMATION_TIME + "s, opacity " + Blockly.DropDownDiv.ANIMATION_TIME + "s";
            a.addEventListener("focusin", function() {
                Blockly.utils.dom.addClass(a, "blocklyFocused");
            });
            a.addEventListener("focusout", function() {
                Blockly.utils.dom.removeClass(a, "blocklyFocused");
            });
        }
    };
    Blockly.DropDownDiv.setBoundsElement = function(a) {
        Blockly.DropDownDiv.boundsElement_ = a;
    };
    Blockly.DropDownDiv.getContentDiv = function() {
        return Blockly.DropDownDiv.content_;
    };
    Blockly.DropDownDiv.clearContent = function() {
        Blockly.DropDownDiv.content_.textContent = "";
        Blockly.DropDownDiv.content_.style.width = "";
    };
    Blockly.DropDownDiv.setColour = function(a, b) {
        Blockly.DropDownDiv.DIV_.style.backgroundColor = a;
        Blockly.DropDownDiv.DIV_.style.borderColor = b;
    };
    Blockly.DropDownDiv.showPositionedByBlock = function(a, b, c, d) {
        return Blockly.DropDownDiv.showPositionedByRect_(Blockly.DropDownDiv.getScaledBboxOfBlock_(b), a, c, d);
    };
    Blockly.DropDownDiv.showPositionedByField = function(a, b, c) {
        Blockly.DropDownDiv.positionToField_ = !0;
        return Blockly.DropDownDiv.showPositionedByRect_(Blockly.DropDownDiv.getScaledBboxOfField_(a), a, b, c);
    };
    Blockly.DropDownDiv.getScaledBboxOfBlock_ = function(a) {
        var b = a.getSvgRoot(), c = b.getBBox(), d = a.workspace.scale;
        a = c.height * d;
        c = c.width * d;
        b = Blockly.utils.style.getPageOffset(b);
        return new Blockly.utils.Rect(b.y, b.y + a, b.x, b.x + c);
    };
    Blockly.DropDownDiv.getScaledBboxOfField_ = function(a) {
        a = a.getScaledBBox();
        return new Blockly.utils.Rect(a.top, a.bottom, a.left, a.right);
    };
    Blockly.DropDownDiv.showPositionedByRect_ = function(a, b, c, d) {
        var e = a.left + (a.right - a.left) / 2, f = a.bottom;
        a = a.top;
        d && (a += d);
        d = b.getSourceBlock();
        for(var g = d.workspace; g.options.parentWorkspace;)g = g.options.parentWorkspace;
        Blockly.DropDownDiv.setBoundsElement(g.getParentSvg().parentNode);
        return Blockly.DropDownDiv.show(b, d.RTL, e, f, e, a, c);
    };
    Blockly.DropDownDiv.show = function(a, b, c, d, e, f, g) {
        Blockly.DropDownDiv.owner_ = a;
        Blockly.DropDownDiv.onHide_ = g || null;
        a = Blockly.DropDownDiv.DIV_;
        a.style.direction = b ? "rtl" : "ltr";
        b = Blockly.getMainWorkspace();
        Blockly.DropDownDiv.rendererClassName_ = b.getRenderer().getClassName();
        Blockly.DropDownDiv.themeClassName_ = b.getTheme().getClassName();
        Blockly.utils.dom.addClass(a, Blockly.DropDownDiv.rendererClassName_);
        Blockly.utils.dom.addClass(a, Blockly.DropDownDiv.themeClassName_);
        return Blockly.DropDownDiv.positionInternal_(c, d, e, f);
    };
    Blockly.DropDownDiv.getBoundsInfo_ = function() {
        var a = Blockly.utils.style.getPageOffset(Blockly.DropDownDiv.boundsElement_), b = Blockly.utils.style.getSize(Blockly.DropDownDiv.boundsElement_);
        return {
            left: a.x,
            right: a.x + b.width,
            top: a.y,
            bottom: a.y + b.height,
            width: b.width,
            height: b.height
        };
    };
    Blockly.DropDownDiv.getPositionMetrics_ = function(a, b, c, d) {
        var e = Blockly.DropDownDiv.getBoundsInfo_(), f = Blockly.utils.style.getSize(Blockly.DropDownDiv.DIV_);
        return b + f.height < e.bottom ? Blockly.DropDownDiv.getPositionBelowMetrics_(a, b, e, f) : d - f.height > e.top ? Blockly.DropDownDiv.getPositionAboveMetrics_(c, d, e, f) : b + f.height < document.documentElement.clientHeight ? Blockly.DropDownDiv.getPositionBelowMetrics_(a, b, e, f) : d - f.height > document.documentElement.clientTop ? Blockly.DropDownDiv.getPositionAboveMetrics_(c, d, e, f) : Blockly.DropDownDiv.getPositionTopOfPageMetrics_(a, e, f);
    };
    Blockly.DropDownDiv.getPositionBelowMetrics_ = function(a, b, c, d) {
        a = Blockly.DropDownDiv.getPositionX(a, c.left, c.right, d.width);
        return {
            initialX: a.divX,
            initialY: b,
            finalX: a.divX,
            finalY: b + Blockly.DropDownDiv.PADDING_Y,
            arrowX: a.arrowX,
            arrowY: -(Blockly.DropDownDiv.ARROW_SIZE / 2 + Blockly.DropDownDiv.BORDER_SIZE),
            arrowAtTop: !0,
            arrowVisible: !0
        };
    };
    Blockly.DropDownDiv.getPositionAboveMetrics_ = function(a, b, c, d) {
        a = Blockly.DropDownDiv.getPositionX(a, c.left, c.right, d.width);
        return {
            initialX: a.divX,
            initialY: b - d.height,
            finalX: a.divX,
            finalY: b - d.height - Blockly.DropDownDiv.PADDING_Y,
            arrowX: a.arrowX,
            arrowY: d.height - 2 * Blockly.DropDownDiv.BORDER_SIZE - Blockly.DropDownDiv.ARROW_SIZE / 2,
            arrowAtTop: !1,
            arrowVisible: !0
        };
    };
    Blockly.DropDownDiv.getPositionTopOfPageMetrics_ = function(a, b, c) {
        a = Blockly.DropDownDiv.getPositionX(a, b.left, b.right, c.width);
        return {
            initialX: a.divX,
            initialY: 0,
            finalX: a.divX,
            finalY: 0,
            arrowAtTop: null,
            arrowX: null,
            arrowY: null,
            arrowVisible: !1
        };
    };
    Blockly.DropDownDiv.getPositionX = function(a, b, c, d) {
        var e = a;
        a = Blockly.utils.math.clamp(b, a - d / 2, c - d);
        e -= Blockly.DropDownDiv.ARROW_SIZE / 2;
        b = Blockly.DropDownDiv.ARROW_HORIZONTAL_PADDING;
        d = Blockly.utils.math.clamp(b, e - a, d - b - Blockly.DropDownDiv.ARROW_SIZE);
        return {
            arrowX: d,
            divX: a
        };
    };
    Blockly.DropDownDiv.isVisible = function() {
        return !!Blockly.DropDownDiv.owner_;
    };
    Blockly.DropDownDiv.hideIfOwner = function(a, b) {
        return Blockly.DropDownDiv.owner_ === a ? (b ? Blockly.DropDownDiv.hideWithoutAnimation() : Blockly.DropDownDiv.hide(), !0) : !1;
    };
    Blockly.DropDownDiv.hide = function() {
        var a = Blockly.DropDownDiv.DIV_;
        a.style.transform = "translate(0, 0)";
        a.style.opacity = 0;
        Blockly.DropDownDiv.animateOutTimer_ = setTimeout(function() {
            Blockly.DropDownDiv.hideWithoutAnimation();
        }, 1E3 * Blockly.DropDownDiv.ANIMATION_TIME);
        Blockly.DropDownDiv.onHide_ && (Blockly.DropDownDiv.onHide_(), Blockly.DropDownDiv.onHide_ = null);
    };
    Blockly.DropDownDiv.hideWithoutAnimation = function() {
        if (Blockly.DropDownDiv.isVisible()) {
            Blockly.DropDownDiv.animateOutTimer_ && clearTimeout(Blockly.DropDownDiv.animateOutTimer_);
            var a = Blockly.DropDownDiv.DIV_;
            a.style.transform = "";
            a.style.left = "";
            a.style.top = "";
            a.style.opacity = 0;
            a.style.display = "none";
            a.style.backgroundColor = "";
            a.style.borderColor = "";
            Blockly.DropDownDiv.onHide_ && (Blockly.DropDownDiv.onHide_(), Blockly.DropDownDiv.onHide_ = null);
            Blockly.DropDownDiv.clearContent();
            Blockly.DropDownDiv.owner_ = null;
            Blockly.DropDownDiv.rendererClassName_ && (Blockly.utils.dom.removeClass(a, Blockly.DropDownDiv.rendererClassName_), Blockly.DropDownDiv.rendererClassName_ = "");
            Blockly.DropDownDiv.themeClassName_ && (Blockly.utils.dom.removeClass(a, Blockly.DropDownDiv.themeClassName_), Blockly.DropDownDiv.themeClassName_ = "");
            Blockly.getMainWorkspace().markFocused();
        }
    };
    Blockly.DropDownDiv.positionInternal_ = function(a, b, c, d) {
        a = Blockly.DropDownDiv.getPositionMetrics_(a, b, c, d);
        a.arrowVisible ? (Blockly.DropDownDiv.arrow_.style.display = "", Blockly.DropDownDiv.arrow_.style.transform = "translate(" + a.arrowX + "px," + a.arrowY + "px) rotate(45deg)", Blockly.DropDownDiv.arrow_.setAttribute("class", a.arrowAtTop ? "blocklyDropDownArrow blocklyArrowTop" : "blocklyDropDownArrow blocklyArrowBottom")) : Blockly.DropDownDiv.arrow_.style.display = "none";
        b = Math.floor(a.initialX);
        c = Math.floor(a.initialY);
        d = Math.floor(a.finalX);
        var e = Math.floor(a.finalY), f = Blockly.DropDownDiv.DIV_;
        f.style.left = b + "px";
        f.style.top = c + "px";
        f.style.display = "block";
        f.style.opacity = 1;
        f.style.transform = "translate(" + (d - b) + "px," + (e - c) + "px)";
        return !!a.arrowAtTop;
    };
    Blockly.DropDownDiv.repositionForWindowResize = function() {
        if (Blockly.DropDownDiv.owner_) {
            var a = Blockly.DropDownDiv.owner_, b = a.getSourceBlock();
            a = Blockly.DropDownDiv.positionToField_ ? Blockly.DropDownDiv.getScaledBboxOfField_(a) : Blockly.DropDownDiv.getScaledBboxOfBlock_(b);
            b = a.left + (a.right - a.left) / 2;
            Blockly.DropDownDiv.positionInternal_(b, a.bottom, b, a.top);
        } else Blockly.DropDownDiv.hide();
    };
    Blockly.Grid = function(a, b) {
        this.gridPattern_ = a;
        this.spacing_ = b.spacing;
        this.length_ = b.length;
        this.line2_ = (this.line1_ = a.firstChild) && this.line1_.nextSibling;
        this.snapToGrid_ = b.snap;
    };
    Blockly.Grid.prototype.scale_ = 1;
    Blockly.Grid.prototype.dispose = function() {
        this.gridPattern_ = null;
    };
    Blockly.Grid.prototype.shouldSnap = function() {
        return this.snapToGrid_;
    };
    Blockly.Grid.prototype.getSpacing = function() {
        return this.spacing_;
    };
    Blockly.Grid.prototype.getPatternId = function() {
        return this.gridPattern_.id;
    };
    Blockly.Grid.prototype.update = function(a) {
        this.scale_ = a;
        var b = this.spacing_ * a || 100;
        this.gridPattern_.setAttribute("width", b);
        this.gridPattern_.setAttribute("height", b);
        b = Math.floor(this.spacing_ / 2) + .5;
        var c = b - this.length_ / 2, d = b + this.length_ / 2;
        b *= a;
        c *= a;
        d *= a;
        this.setLineAttributes_(this.line1_, a, c, d, b, b);
        this.setLineAttributes_(this.line2_, a, b, b, c, d);
    };
    Blockly.Grid.prototype.setLineAttributes_ = function(a, b, c, d, e, f) {
        a && (a.setAttribute("stroke-width", b), a.setAttribute("x1", c), a.setAttribute("y1", e), a.setAttribute("x2", d), a.setAttribute("y2", f));
    };
    Blockly.Grid.prototype.moveTo = function(a, b) {
        this.gridPattern_.setAttribute("x", a);
        this.gridPattern_.setAttribute("y", b);
        (Blockly.utils.userAgent.IE || Blockly.utils.userAgent.EDGE) && this.update(this.scale_);
    };
    Blockly.Grid.createDom = function(a, b, c) {
        a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATTERN, {
            id: "blocklyGridPattern" + a,
            patternUnits: "userSpaceOnUse"
        }, c);
        0 < b.length && 0 < b.spacing ? (Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {
            stroke: b.colour
        }, a), 1 < b.length && Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {
            stroke: b.colour
        }, a)) : Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {}, a);
        return a;
    };
    Blockly.Theme = function(a, b, c, d) {
        this.name = a;
        this.blockStyles = b || Object.create(null);
        this.categoryStyles = c || Object.create(null);
        this.componentStyles = d || Object.create(null);
        this.fontStyle = Object.create(null);
        this.startHats = null;
        Blockly.registry.register(Blockly.registry.Type.THEME, a, this);
    };
    Blockly.Theme.prototype.getClassName = function() {
        return this.name + "-theme";
    };
    Blockly.Theme.prototype.setBlockStyle = function(a, b) {
        this.blockStyles[a] = b;
    };
    Blockly.Theme.prototype.setCategoryStyle = function(a, b) {
        this.categoryStyles[a] = b;
    };
    Blockly.Theme.prototype.getComponentStyle = function(a) {
        return (a = this.componentStyles[a]) && "string" == typeof a && this.getComponentStyle(a) ? this.getComponentStyle(a) : a ? String(a) : null;
    };
    Blockly.Theme.prototype.setComponentStyle = function(a, b) {
        this.componentStyles[a] = b;
    };
    Blockly.Theme.prototype.setFontStyle = function(a) {
        this.fontStyle = a;
    };
    Blockly.Theme.prototype.setStartHats = function(a) {
        this.startHats = a;
    };
    Blockly.Theme.defineTheme = function(a, b) {
        var c = new Blockly.Theme(a), d = b.base;
        d && ("string" == typeof d && (d = Blockly.registry.getObject(Blockly.registry.Type.THEME, d)), d instanceof Blockly.Theme && (Blockly.utils.object.deepMerge(c, d), c.name = a));
        Blockly.utils.object.deepMerge(c.blockStyles, b.blockStyles);
        Blockly.utils.object.deepMerge(c.categoryStyles, b.categoryStyles);
        Blockly.utils.object.deepMerge(c.componentStyles, b.componentStyles);
        Blockly.utils.object.deepMerge(c.fontStyle, b.fontStyle);
        null != b.startHats && (c.startHats = b.startHats);
        return c;
    };
    Blockly.Themes = {};
    Blockly.Themes.Classic = {};
    Blockly.Themes.Classic.defaultBlockStyles = {
        colour_blocks: {
            colourPrimary: "20"
        },
        list_blocks: {
            colourPrimary: "260"
        },
        logic_blocks: {
            colourPrimary: "210"
        },
        loop_blocks: {
            colourPrimary: "120"
        },
        math_blocks: {
            colourPrimary: "230"
        },
        procedure_blocks: {
            colourPrimary: "290"
        },
        text_blocks: {
            colourPrimary: "160"
        },
        variable_blocks: {
            colourPrimary: "330"
        },
        variable_dynamic_blocks: {
            colourPrimary: "310"
        },
        hat_blocks: {
            colourPrimary: "330",
            hat: "cap"
        }
    };
    Blockly.Themes.Classic.categoryStyles = {
        colour_category: {
            colour: "20"
        },
        list_category: {
            colour: "260"
        },
        logic_category: {
            colour: "210"
        },
        loop_category: {
            colour: "120"
        },
        math_category: {
            colour: "230"
        },
        procedure_category: {
            colour: "290"
        },
        text_category: {
            colour: "160"
        },
        variable_category: {
            colour: "330"
        },
        variable_dynamic_category: {
            colour: "310"
        }
    };
    Blockly.Themes.Classic = new Blockly.Theme("classic", Blockly.Themes.Classic.defaultBlockStyles, Blockly.Themes.Classic.categoryStyles);
    Blockly.utils.IdGenerator = {};
    Blockly.utils.IdGenerator.nextId_ = 0;
    Blockly.utils.IdGenerator.getNextUniqueId = function() {
        return "blockly-" + (Blockly.utils.IdGenerator.nextId_++).toString(36);
    };
    Blockly.utils.Metrics = function() {};
    Blockly.utils.toolbox = {};
    Blockly.utils.toolbox.CATEGORY_TOOLBOX_KIND = "categoryToolbox";
    Blockly.utils.toolbox.FLYOUT_TOOLBOX_KIND = "flyoutToolbox";
    Blockly.utils.toolbox.Position = {
        TOP: 0,
        BOTTOM: 1,
        LEFT: 2,
        RIGHT: 3
    };
    Blockly.utils.toolbox.convertToolboxDefToJson = function(a) {
        if (!a) return null;
        if (a instanceof Element || "string" == typeof a) a = Blockly.utils.toolbox.parseToolboxTree(a), a = Blockly.utils.toolbox.convertToToolboxJson_(a);
        Blockly.utils.toolbox.validateToolbox_(a);
        return a;
    };
    Blockly.utils.toolbox.validateToolbox_ = function(a) {
        var b = a.kind;
        a = a.contents;
        if (b && b != Blockly.utils.toolbox.FLYOUT_TOOLBOX_KIND && b != Blockly.utils.toolbox.CATEGORY_TOOLBOX_KIND) throw Error("Invalid toolbox kind " + b + ". Please supply either " + Blockly.utils.toolbox.FLYOUT_TOOLBOX_KIND + " or " + Blockly.utils.toolbox.CATEGORY_TOOLBOX_KIND);
        if (!a) throw Error("Toolbox must have a contents attribute.");
    };
    Blockly.utils.toolbox.convertFlyoutDefToJsonArray = function(a) {
        return a ? a.contents ? a.contents : Array.isArray(a) && 0 < a.length && !a[0].nodeType ? a : Blockly.utils.toolbox.xmlToJsonArray_(a) : [];
    };
    Blockly.utils.toolbox.hasCategories = function(a) {
        if (!a) return !1;
        var b = a.kind;
        return b ? b == Blockly.utils.toolbox.CATEGORY_TOOLBOX_KIND : !!a.contents.filter(function(c) {
            return "CATEGORY" == c.kind.toUpperCase();
        }).length;
    };
    Blockly.utils.toolbox.isCategoryCollapsible = function(a) {
        return a && a.contents ? !!a.contents.filter(function(b) {
            return "CATEGORY" == b.kind.toUpperCase();
        }).length : !1;
    };
    Blockly.utils.toolbox.convertToToolboxJson_ = function(a) {
        var b = {
            contents: Blockly.utils.toolbox.xmlToJsonArray_(a)
        };
        a instanceof Node && Blockly.utils.toolbox.addAttributes_(a, b);
        return b;
    };
    Blockly.utils.toolbox.xmlToJsonArray_ = function(a) {
        var b = [], c = a.childNodes;
        c || (c = a);
        a = 0;
        for(var d; d = c[a]; a++)if (d.tagName) {
            var e = {}, f = d.tagName.toUpperCase();
            e.kind = f;
            "BLOCK" == f ? e.blockxml = d : d.childNodes && 0 < d.childNodes.length && (e.contents = Blockly.utils.toolbox.xmlToJsonArray_(d));
            Blockly.utils.toolbox.addAttributes_(d, e);
            b.push(e);
        }
        return b;
    };
    Blockly.utils.toolbox.addAttributes_ = function(a, b) {
        for(var c = 0; c < a.attributes.length; c++){
            var d = a.attributes[c];
            -1 < d.nodeName.indexOf("css-") ? (b.cssconfig = b.cssconfig || {}, b.cssconfig[d.nodeName.replace("css-", "")] = d.value) : b[d.nodeName] = d.value;
        }
    };
    Blockly.utils.toolbox.parseToolboxTree = function(a) {
        if (a) {
            if ("string" != typeof a && (Blockly.utils.userAgent.IE && a.outerHTML ? a = a.outerHTML : a instanceof Element || (a = null)), "string" == typeof a && (a = Blockly.Xml.textToDom(a), "xml" != a.nodeName.toLowerCase())) throw TypeError("Toolbox should be an <xml> document.");
        } else a = null;
        return a;
    };
    Blockly.Options = function(a) {
        var b = !!a.readOnly;
        if (b) var c = null, d = !1, e = !1, f = !1, g = !1, h = !1, k = !1;
        else {
            c = Blockly.utils.toolbox.convertToolboxDefToJson(a.toolbox);
            d = Blockly.utils.toolbox.hasCategories(c);
            e = a.trashcan;
            void 0 === e && (e = d);
            var l = a.maxTrashcanContents;
            e ? void 0 === l && (l = 32) : l = 0;
            f = a.collapse;
            void 0 === f && (f = d);
            g = a.comments;
            void 0 === g && (g = d);
            h = a.disable;
            void 0 === h && (h = d);
            k = a.sounds;
            void 0 === k && (k = !0);
        }
        var m = !!a.rtl, n = a.horizontalLayout;
        void 0 === n && (n = !1);
        var p = a.toolboxPosition;
        p = "end" !== p;
        p = n ? p ? Blockly.utils.toolbox.Position.TOP : Blockly.utils.toolbox.Position.BOTTOM : p == m ? Blockly.utils.toolbox.Position.RIGHT : Blockly.utils.toolbox.Position.LEFT;
        var q = a.css;
        void 0 === q && (q = !0);
        var t = "https://blockly-demo.appspot.com/static/media/";
        a.media ? t = a.media : a.path && (t = a.path + "media/");
        var r = void 0 === a.oneBasedIndex ? !0 : !!a.oneBasedIndex, u = a.renderer || "geras", v = a.plugins || {};
        this.RTL = m;
        this.oneBasedIndex = r;
        this.collapse = f;
        this.comments = g;
        this.disable = h;
        this.readOnly = b;
        this.maxBlocks = a.maxBlocks || Infinity;
        this.maxInstances = a.maxInstances;
        this.pathToMedia = t;
        this.hasCategories = d;
        this.moveOptions = Blockly.Options.parseMoveOptions_(a, d);
        this.hasScrollbars = !!this.moveOptions.scrollbars;
        this.hasTrashcan = e;
        this.maxTrashcanContents = l;
        this.hasSounds = k;
        this.hasCss = q;
        this.horizontalLayout = n;
        this.languageTree = c;
        this.gridOptions = Blockly.Options.parseGridOptions_(a);
        this.zoomOptions = Blockly.Options.parseZoomOptions_(a);
        this.toolboxPosition = p;
        this.theme = Blockly.Options.parseThemeOptions_(a);
        this.renderer = u;
        this.rendererOverrides = a.rendererOverrides;
        this.gridPattern = null;
        this.parentWorkspace = a.parentWorkspace;
        this.plugins = v;
    };
    Blockly.BlocklyOptions = function() {};
    Blockly.Options.parseMoveOptions_ = function(a, b) {
        var c = a.move || {}, d = {};
        void 0 === c.scrollbars && void 0 === a.scrollbars ? d.scrollbars = b : "object" == typeof c.scrollbars ? (d.scrollbars = {}, d.scrollbars.horizontal = !!c.scrollbars.horizontal, d.scrollbars.vertical = !!c.scrollbars.vertical, d.scrollbars.horizontal && d.scrollbars.vertical ? d.scrollbars = !0 : d.scrollbars.horizontal || d.scrollbars.vertical || (d.scrollbars = !1)) : d.scrollbars = !!c.scrollbars || !!a.scrollbars;
        d.wheel = d.scrollbars && void 0 !== c.wheel ? !!c.wheel : "object" == typeof d.scrollbars;
        d.drag = d.scrollbars ? void 0 === c.drag ? !0 : !!c.drag : !1;
        return d;
    };
    Blockly.Options.parseZoomOptions_ = function(a) {
        a = a.zoom || {};
        var b = {};
        b.controls = void 0 === a.controls ? !1 : !!a.controls;
        b.wheel = void 0 === a.wheel ? !1 : !!a.wheel;
        b.startScale = void 0 === a.startScale ? 1 : Number(a.startScale);
        b.maxScale = void 0 === a.maxScale ? 3 : Number(a.maxScale);
        b.minScale = void 0 === a.minScale ? .3 : Number(a.minScale);
        b.scaleSpeed = void 0 === a.scaleSpeed ? 1.2 : Number(a.scaleSpeed);
        b.pinch = void 0 === a.pinch ? b.wheel || b.controls : !!a.pinch;
        return b;
    };
    Blockly.Options.parseGridOptions_ = function(a) {
        a = a.grid || {};
        var b = {};
        b.spacing = Number(a.spacing) || 0;
        b.colour = a.colour || "#888";
        b.length = void 0 === a.length ? 1 : Number(a.length);
        b.snap = 0 < b.spacing && !!a.snap;
        return b;
    };
    Blockly.Options.parseThemeOptions_ = function(a) {
        a = a.theme || Blockly.Themes.Classic;
        return "string" == typeof a ? Blockly.registry.getObject(Blockly.registry.Type.THEME, a) : a instanceof Blockly.Theme ? a : Blockly.Theme.defineTheme(a.name || "builtin" + Blockly.utils.IdGenerator.getNextUniqueId(), a);
    };
    Blockly.Options.parseToolboxTree = function(a) {
        Blockly.utils.deprecation.warn("Blockly.Options.parseToolboxTree", "September 2020", "September 2021", "Blockly.utils.toolbox.parseToolboxTree");
        return Blockly.utils.toolbox.parseToolboxTree(a);
    };
    Blockly.ScrollbarPair = function(a, b, c, d) {
        this.workspace_ = a;
        b = void 0 === b ? !0 : b;
        c = void 0 === c ? !0 : c;
        var e = b && c;
        b && (this.hScroll = new Blockly.Scrollbar(a, !0, e, d));
        c && (this.vScroll = new Blockly.Scrollbar(a, !1, e, d));
        e && (this.corner_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            height: Blockly.Scrollbar.scrollbarThickness,
            width: Blockly.Scrollbar.scrollbarThickness,
            "class": "blocklyScrollbarBackground"
        }, null), Blockly.utils.dom.insertAfter(this.corner_, a.getBubbleCanvas()));
        this.oldHostMetrics_ = null;
    };
    Blockly.ScrollbarPair.prototype.dispose = function() {
        Blockly.utils.dom.removeNode(this.corner_);
        this.oldHostMetrics_ = this.workspace_ = this.corner_ = null;
        this.hScroll && (this.hScroll.dispose(), this.hScroll = null);
        this.vScroll && (this.vScroll.dispose(), this.vScroll = null);
    };
    Blockly.ScrollbarPair.prototype.resize = function() {
        var a = this.workspace_.getMetrics();
        if (a) {
            var b = !1, c = !1;
            this.oldHostMetrics_ && this.oldHostMetrics_.viewWidth == a.viewWidth && this.oldHostMetrics_.viewHeight == a.viewHeight && this.oldHostMetrics_.absoluteTop == a.absoluteTop && this.oldHostMetrics_.absoluteLeft == a.absoluteLeft ? (this.oldHostMetrics_ && this.oldHostMetrics_.scrollWidth == a.scrollWidth && this.oldHostMetrics_.viewLeft == a.viewLeft && this.oldHostMetrics_.scrollLeft == a.scrollLeft || (b = !0), this.oldHostMetrics_ && this.oldHostMetrics_.scrollHeight == a.scrollHeight && this.oldHostMetrics_.viewTop == a.viewTop && this.oldHostMetrics_.scrollTop == a.scrollTop || (c = !0)) : c = b = !0;
            if (b || c) {
                try {
                    Blockly.Events.disable(), this.hScroll && b && this.hScroll.resize(a), this.vScroll && c && this.vScroll.resize(a);
                } finally{
                    Blockly.Events.enable();
                }
                this.workspace_.maybeFireViewportChangeEvent();
            }
            this.hScroll && this.vScroll && (this.oldHostMetrics_ && this.oldHostMetrics_.viewWidth == a.viewWidth && this.oldHostMetrics_.absoluteLeft == a.absoluteLeft || this.corner_.setAttribute("x", this.vScroll.position.x), this.oldHostMetrics_ && this.oldHostMetrics_.viewHeight == a.viewHeight && this.oldHostMetrics_.absoluteTop == a.absoluteTop || this.corner_.setAttribute("y", this.hScroll.position.y));
            this.oldHostMetrics_ = a;
        }
    };
    Blockly.ScrollbarPair.prototype.canScrollHorizontally = function() {
        return !!this.hScroll;
    };
    Blockly.ScrollbarPair.prototype.canScrollVertically = function() {
        return !!this.vScroll;
    };
    Blockly.ScrollbarPair.prototype.setOrigin = function(a, b) {
        this.hScroll && this.hScroll.setOrigin(a, b);
        this.vScroll && this.vScroll.setOrigin(a, b);
    };
    Blockly.ScrollbarPair.prototype.set = function(a, b, c) {
        this.hScroll && this.hScroll.set(a, !1);
        this.vScroll && this.vScroll.set(b, !1);
        if (c || void 0 === c) a = {}, this.hScroll && (a.x = this.hScroll.getRatio_()), this.vScroll && (a.y = this.vScroll.getRatio_()), this.workspace_.setMetrics(a);
    };
    Blockly.ScrollbarPair.prototype.setX = function(a) {
        this.hScroll && this.hScroll.set(a, !0);
    };
    Blockly.ScrollbarPair.prototype.setY = function(a) {
        this.vScroll && this.vScroll.set(a, !0);
    };
    Blockly.ScrollbarPair.prototype.setContainerVisible = function(a) {
        this.hScroll && this.hScroll.setContainerVisible(a);
        this.vScroll && this.vScroll.setContainerVisible(a);
    };
    Blockly.ScrollbarPair.prototype.isVisible = function() {
        var a = !1;
        this.hScroll && (a = this.hScroll.isVisible());
        this.vScroll && (a = a || this.vScroll.isVisible());
        return a;
    };
    Blockly.ScrollbarPair.prototype.resizeContent = function(a) {
        this.hScroll && this.hScroll.resizeContentHorizontal(a);
        this.vScroll && this.vScroll.resizeContentVertical(a);
    };
    Blockly.ScrollbarPair.prototype.resizeView = function(a) {
        this.hScroll && this.hScroll.resizeViewHorizontal(a);
        this.vScroll && this.vScroll.resizeViewVertical(a);
    };
    Blockly.Scrollbar = function(a, b, c, d) {
        this.workspace_ = a;
        this.pair_ = c || !1;
        this.horizontal_ = b;
        this.ratio = this.oldHostMetrics_ = null;
        this.createDom_(d);
        this.position = new Blockly.utils.Coordinate(0, 0);
        a = Blockly.Scrollbar.scrollbarThickness;
        b ? (this.svgBackground_.setAttribute("height", a), this.outerSvg_.setAttribute("height", a), this.svgHandle_.setAttribute("height", a - 5), this.svgHandle_.setAttribute("y", 2.5), this.lengthAttribute_ = "width", this.positionAttribute_ = "x") : (this.svgBackground_.setAttribute("width", a), this.outerSvg_.setAttribute("width", a), this.svgHandle_.setAttribute("width", a - 5), this.svgHandle_.setAttribute("x", 2.5), this.lengthAttribute_ = "height", this.positionAttribute_ = "y");
        this.onMouseDownBarWrapper_ = Blockly.browserEvents.conditionalBind(this.svgBackground_, "mousedown", this, this.onMouseDownBar_);
        this.onMouseDownHandleWrapper_ = Blockly.browserEvents.conditionalBind(this.svgHandle_, "mousedown", this, this.onMouseDownHandle_);
    };
    Blockly.Scrollbar.prototype.origin_ = new Blockly.utils.Coordinate(0, 0);
    Blockly.Scrollbar.prototype.startDragMouse_ = 0;
    Blockly.Scrollbar.prototype.scrollbarLength_ = 0;
    Blockly.Scrollbar.prototype.handleLength_ = 0;
    Blockly.Scrollbar.prototype.handlePosition_ = 0;
    Blockly.Scrollbar.prototype.isVisible_ = !0;
    Blockly.Scrollbar.prototype.containerVisible_ = !0;
    Blockly.Scrollbar.scrollbarThickness = 15;
    Blockly.Touch.TOUCH_ENABLED && (Blockly.Scrollbar.scrollbarThickness = 25);
    Blockly.Scrollbar.SCROLLBAR_MARGIN = .5;
    Blockly.Scrollbar.metricsAreEquivalent_ = function(a, b) {
        return a && b && a.viewWidth == b.viewWidth && a.viewHeight == b.viewHeight && a.viewLeft == b.viewLeft && a.viewTop == b.viewTop && a.absoluteTop == b.absoluteTop && a.absoluteLeft == b.absoluteLeft && a.scrollWidth == b.scrollWidth && a.scrollHeight == b.scrollHeight && a.scrollLeft == b.scrollLeft && a.scrollTop == b.scrollTop ? !0 : !1;
    };
    Blockly.Scrollbar.prototype.dispose = function() {
        this.cleanUp_();
        Blockly.browserEvents.unbind(this.onMouseDownBarWrapper_);
        this.onMouseDownBarWrapper_ = null;
        Blockly.browserEvents.unbind(this.onMouseDownHandleWrapper_);
        this.onMouseDownHandleWrapper_ = null;
        Blockly.utils.dom.removeNode(this.outerSvg_);
        this.svgBackground_ = this.svgGroup_ = this.outerSvg_ = null;
        this.svgHandle_ && (this.workspace_.getThemeManager().unsubscribe(this.svgHandle_), this.svgHandle_ = null);
        this.workspace_ = null;
    };
    Blockly.Scrollbar.prototype.constrainHandleLength_ = function(a) {
        return a = 0 >= a || isNaN(a) ? 0 : Math.min(a, this.scrollbarLength_);
    };
    Blockly.Scrollbar.prototype.setHandleLength_ = function(a) {
        this.handleLength_ = a;
        this.svgHandle_.setAttribute(this.lengthAttribute_, this.handleLength_);
    };
    Blockly.Scrollbar.prototype.constrainHandlePosition_ = function(a) {
        return a = 0 >= a || isNaN(a) ? 0 : Math.min(a, this.scrollbarLength_ - this.handleLength_);
    };
    Blockly.Scrollbar.prototype.setHandlePosition = function(a) {
        this.handlePosition_ = a;
        this.svgHandle_.setAttribute(this.positionAttribute_, this.handlePosition_);
    };
    Blockly.Scrollbar.prototype.setScrollbarLength_ = function(a) {
        this.scrollbarLength_ = a;
        this.outerSvg_.setAttribute(this.lengthAttribute_, this.scrollbarLength_);
        this.svgBackground_.setAttribute(this.lengthAttribute_, this.scrollbarLength_);
    };
    Blockly.Scrollbar.prototype.setPosition = function(a, b) {
        this.position.x = a;
        this.position.y = b;
        Blockly.utils.dom.setCssTransform(this.outerSvg_, "translate(" + (this.position.x + this.origin_.x) + "px," + (this.position.y + this.origin_.y) + "px)");
    };
    Blockly.Scrollbar.prototype.resize = function(a) {
        if (!a && (a = this.workspace_.getMetrics(), !a)) return;
        Blockly.Scrollbar.metricsAreEquivalent_(a, this.oldHostMetrics_) || (this.horizontal_ ? this.resizeHorizontal_(a) : this.resizeVertical_(a), this.oldHostMetrics_ = a, this.updateMetrics_());
    };
    Blockly.Scrollbar.prototype.requiresViewResize_ = function(a) {
        return this.oldHostMetrics_ ? this.oldHostMetrics_.viewWidth !== a.viewWidth || this.oldHostMetrics_.viewHeight !== a.viewHeight || this.oldHostMetrics_.absoluteLeft !== a.absoluteLeft || this.oldHostMetrics_.absoluteTop !== a.absoluteTop : !0;
    };
    Blockly.Scrollbar.prototype.resizeHorizontal_ = function(a) {
        this.requiresViewResize_(a) ? this.resizeViewHorizontal(a) : this.resizeContentHorizontal(a);
    };
    Blockly.Scrollbar.prototype.resizeViewHorizontal = function(a) {
        var b = a.viewWidth - 2 * Blockly.Scrollbar.SCROLLBAR_MARGIN;
        this.pair_ && (b -= Blockly.Scrollbar.scrollbarThickness);
        this.setScrollbarLength_(Math.max(0, b));
        b = a.absoluteLeft + Blockly.Scrollbar.SCROLLBAR_MARGIN;
        this.pair_ && this.workspace_.RTL && (b += Blockly.Scrollbar.scrollbarThickness);
        this.setPosition(b, a.absoluteTop + a.viewHeight - Blockly.Scrollbar.scrollbarThickness - Blockly.Scrollbar.SCROLLBAR_MARGIN);
        this.resizeContentHorizontal(a);
    };
    Blockly.Scrollbar.prototype.resizeContentHorizontal = function(a) {
        if (a.viewWidth >= a.scrollWidth) this.setHandleLength_(this.scrollbarLength_), this.setHandlePosition(0), this.pair_ || this.setVisible(!1);
        else {
            this.pair_ || this.setVisible(!0);
            var b = this.scrollbarLength_ * a.viewWidth / a.scrollWidth;
            b = this.constrainHandleLength_(b);
            this.setHandleLength_(b);
            b = a.scrollWidth - a.viewWidth;
            var c = this.scrollbarLength_ - this.handleLength_;
            a = (a.viewLeft - a.scrollLeft) / b * c;
            a = this.constrainHandlePosition_(a);
            this.setHandlePosition(a);
            this.ratio = c / b;
        }
    };
    Blockly.Scrollbar.prototype.resizeVertical_ = function(a) {
        this.requiresViewResize_(a) ? this.resizeViewVertical(a) : this.resizeContentVertical(a);
    };
    Blockly.Scrollbar.prototype.resizeViewVertical = function(a) {
        var b = a.viewHeight - 2 * Blockly.Scrollbar.SCROLLBAR_MARGIN;
        this.pair_ && (b -= Blockly.Scrollbar.scrollbarThickness);
        this.setScrollbarLength_(Math.max(0, b));
        this.setPosition(this.workspace_.RTL ? a.absoluteLeft + Blockly.Scrollbar.SCROLLBAR_MARGIN : a.absoluteLeft + a.viewWidth - Blockly.Scrollbar.scrollbarThickness - Blockly.Scrollbar.SCROLLBAR_MARGIN, a.absoluteTop + Blockly.Scrollbar.SCROLLBAR_MARGIN);
        this.resizeContentVertical(a);
    };
    Blockly.Scrollbar.prototype.resizeContentVertical = function(a) {
        if (a.viewHeight >= a.scrollHeight) this.setHandleLength_(this.scrollbarLength_), this.setHandlePosition(0), this.pair_ || this.setVisible(!1);
        else {
            this.pair_ || this.setVisible(!0);
            var b = this.scrollbarLength_ * a.viewHeight / a.scrollHeight;
            b = this.constrainHandleLength_(b);
            this.setHandleLength_(b);
            b = a.scrollHeight - a.viewHeight;
            var c = this.scrollbarLength_ - this.handleLength_;
            a = (a.viewTop - a.scrollTop) / b * c;
            a = this.constrainHandlePosition_(a);
            this.setHandlePosition(a);
            this.ratio = c / b;
        }
    };
    Blockly.Scrollbar.prototype.createDom_ = function(a) {
        var b = "blocklyScrollbar" + (this.horizontal_ ? "Horizontal" : "Vertical");
        a && (b += " " + a);
        this.outerSvg_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
            "class": b
        }, null);
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, this.outerSvg_);
        this.svgBackground_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyScrollbarBackground"
        }, this.svgGroup_);
        a = Math.floor((Blockly.Scrollbar.scrollbarThickness - 5) / 2);
        this.svgHandle_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyScrollbarHandle",
            rx: a,
            ry: a
        }, this.svgGroup_);
        this.workspace_.getThemeManager().subscribe(this.svgHandle_, "scrollbarColour", "fill");
        this.workspace_.getThemeManager().subscribe(this.svgHandle_, "scrollbarOpacity", "fill-opacity");
        Blockly.utils.dom.insertAfter(this.outerSvg_, this.workspace_.getParentSvg());
    };
    Blockly.Scrollbar.prototype.isVisible = function() {
        return this.isVisible_;
    };
    Blockly.Scrollbar.prototype.setContainerVisible = function(a) {
        var b = a != this.containerVisible_;
        this.containerVisible_ = a;
        b && this.updateDisplay_();
    };
    Blockly.Scrollbar.prototype.setVisible = function(a) {
        var b = a != this.isVisible();
        if (this.pair_) throw Error("Unable to toggle visibility of paired scrollbars.");
        this.isVisible_ = a;
        b && this.updateDisplay_();
    };
    Blockly.Scrollbar.prototype.updateDisplay_ = function() {
        this.containerVisible_ && this.isVisible() ? this.outerSvg_.setAttribute("display", "block") : this.outerSvg_.setAttribute("display", "none");
    };
    Blockly.Scrollbar.prototype.onMouseDownBar_ = function(a) {
        this.workspace_.markFocused();
        Blockly.Touch.clearTouchIdentifier();
        this.cleanUp_();
        if (Blockly.utils.isRightButton(a)) a.stopPropagation();
        else {
            var b = Blockly.utils.mouseToSvg(a, this.workspace_.getParentSvg(), this.workspace_.getInverseScreenCTM());
            b = this.horizontal_ ? b.x : b.y;
            var c = Blockly.utils.getInjectionDivXY_(this.svgHandle_);
            c = this.horizontal_ ? c.x : c.y;
            var d = this.handlePosition_, e = .95 * this.handleLength_;
            b <= c ? d -= e : b >= c + this.handleLength_ && (d += e);
            this.setHandlePosition(this.constrainHandlePosition_(d));
            this.updateMetrics_();
            a.stopPropagation();
            a.preventDefault();
        }
    };
    Blockly.Scrollbar.prototype.onMouseDownHandle_ = function(a) {
        this.workspace_.markFocused();
        this.cleanUp_();
        Blockly.utils.isRightButton(a) ? a.stopPropagation() : (this.startDragHandle = this.handlePosition_, this.workspace_.setupDragSurface(), this.startDragMouse_ = this.horizontal_ ? a.clientX : a.clientY, Blockly.Scrollbar.onMouseUpWrapper_ = Blockly.browserEvents.conditionalBind(document, "mouseup", this, this.onMouseUpHandle_), Blockly.Scrollbar.onMouseMoveWrapper_ = Blockly.browserEvents.conditionalBind(document, "mousemove", this, this.onMouseMoveHandle_), a.stopPropagation(), a.preventDefault());
    };
    Blockly.Scrollbar.prototype.onMouseMoveHandle_ = function(a) {
        this.setHandlePosition(this.constrainHandlePosition_(this.startDragHandle + ((this.horizontal_ ? a.clientX : a.clientY) - this.startDragMouse_)));
        this.updateMetrics_();
    };
    Blockly.Scrollbar.prototype.onMouseUpHandle_ = function() {
        this.workspace_.resetDragSurface();
        Blockly.Touch.clearTouchIdentifier();
        this.cleanUp_();
    };
    Blockly.Scrollbar.prototype.cleanUp_ = function() {
        Blockly.hideChaff(!0);
        Blockly.Scrollbar.onMouseUpWrapper_ && (Blockly.browserEvents.unbind(Blockly.Scrollbar.onMouseUpWrapper_), Blockly.Scrollbar.onMouseUpWrapper_ = null);
        Blockly.Scrollbar.onMouseMoveWrapper_ && (Blockly.browserEvents.unbind(Blockly.Scrollbar.onMouseMoveWrapper_), Blockly.Scrollbar.onMouseMoveWrapper_ = null);
    };
    Blockly.Scrollbar.prototype.getRatio_ = function() {
        var a = this.handlePosition_ / (this.scrollbarLength_ - this.handleLength_);
        isNaN(a) && (a = 0);
        return a;
    };
    Blockly.Scrollbar.prototype.updateMetrics_ = function() {
        var a = this.getRatio_(), b = {};
        this.horizontal_ ? b.x = a : b.y = a;
        this.workspace_.setMetrics(b);
    };
    Blockly.Scrollbar.prototype.set = function(a, b) {
        this.setHandlePosition(this.constrainHandlePosition_(a * this.ratio));
        (b || void 0 === b) && this.updateMetrics_();
    };
    Blockly.Scrollbar.prototype.setOrigin = function(a, b) {
        this.origin_ = new Blockly.utils.Coordinate(a, b);
    };
    Blockly.Tooltip = {};
    Blockly.Tooltip.visible = !1;
    Blockly.Tooltip.blocked_ = !1;
    Blockly.Tooltip.LIMIT = 50;
    Blockly.Tooltip.mouseOutPid_ = 0;
    Blockly.Tooltip.showPid_ = 0;
    Blockly.Tooltip.lastX_ = 0;
    Blockly.Tooltip.lastY_ = 0;
    Blockly.Tooltip.element_ = null;
    Blockly.Tooltip.poisonedElement_ = null;
    Blockly.Tooltip.OFFSET_X = 0;
    Blockly.Tooltip.OFFSET_Y = 10;
    Blockly.Tooltip.RADIUS_OK = 10;
    Blockly.Tooltip.HOVER_MS = 750;
    Blockly.Tooltip.MARGINS = 5;
    Blockly.Tooltip.DIV = null;
    Blockly.Tooltip.getTooltipOfObject = function(a) {
        if (a = Blockly.Tooltip.getTargetObject_(a)) {
            for(a = a.tooltip; "function" == typeof a;)a = a();
            if ("string" != typeof a) throw Error("Tooltip function must return a string.");
            return a;
        }
        return "";
    };
    Blockly.Tooltip.getTargetObject_ = function(a) {
        for(; a && a.tooltip;){
            if ("string" == typeof a.tooltip || "function" == typeof a.tooltip) return a;
            a = a.tooltip;
        }
        return null;
    };
    Blockly.Tooltip.createDom = function() {
        Blockly.Tooltip.DIV || (Blockly.Tooltip.DIV = document.createElement("div"), Blockly.Tooltip.DIV.className = "blocklyTooltipDiv", (Blockly.parentContainer || document.body).appendChild(Blockly.Tooltip.DIV));
    };
    Blockly.Tooltip.bindMouseEvents = function(a) {
        a.mouseOverWrapper_ = Blockly.browserEvents.bind(a, "mouseover", null, Blockly.Tooltip.onMouseOver_);
        a.mouseOutWrapper_ = Blockly.browserEvents.bind(a, "mouseout", null, Blockly.Tooltip.onMouseOut_);
        a.addEventListener("mousemove", Blockly.Tooltip.onMouseMove_, !1);
    };
    Blockly.Tooltip.unbindMouseEvents = function(a) {
        a && (Blockly.browserEvents.unbind(a.mouseOverWrapper_), Blockly.browserEvents.unbind(a.mouseOutWrapper_), a.removeEventListener("mousemove", Blockly.Tooltip.onMouseMove_));
    };
    Blockly.Tooltip.onMouseOver_ = function(a) {
        Blockly.Tooltip.blocked_ || (a = Blockly.Tooltip.getTargetObject_(a.currentTarget), Blockly.Tooltip.element_ != a && (Blockly.Tooltip.hide(), Blockly.Tooltip.poisonedElement_ = null, Blockly.Tooltip.element_ = a), clearTimeout(Blockly.Tooltip.mouseOutPid_));
    };
    Blockly.Tooltip.onMouseOut_ = function(a) {
        Blockly.Tooltip.blocked_ || (Blockly.Tooltip.mouseOutPid_ = setTimeout(function() {
            Blockly.Tooltip.element_ = null;
            Blockly.Tooltip.poisonedElement_ = null;
            Blockly.Tooltip.hide();
        }, 1), clearTimeout(Blockly.Tooltip.showPid_));
    };
    Blockly.Tooltip.onMouseMove_ = function(a) {
        if (Blockly.Tooltip.element_ && Blockly.Tooltip.element_.tooltip && !Blockly.Tooltip.blocked_) {
            if (Blockly.Tooltip.visible) {
                var b = Blockly.Tooltip.lastX_ - a.pageX;
                a = Blockly.Tooltip.lastY_ - a.pageY;
                Math.sqrt(b * b + a * a) > Blockly.Tooltip.RADIUS_OK && Blockly.Tooltip.hide();
            } else Blockly.Tooltip.poisonedElement_ != Blockly.Tooltip.element_ && (clearTimeout(Blockly.Tooltip.showPid_), Blockly.Tooltip.lastX_ = a.pageX, Blockly.Tooltip.lastY_ = a.pageY, Blockly.Tooltip.showPid_ = setTimeout(Blockly.Tooltip.show_, Blockly.Tooltip.HOVER_MS));
        }
    };
    Blockly.Tooltip.dispose = function() {
        Blockly.Tooltip.element_ = null;
        Blockly.Tooltip.poisonedElement_ = null;
        Blockly.Tooltip.hide();
    };
    Blockly.Tooltip.hide = function() {
        Blockly.Tooltip.visible && (Blockly.Tooltip.visible = !1, Blockly.Tooltip.DIV && (Blockly.Tooltip.DIV.style.display = "none"));
        Blockly.Tooltip.showPid_ && clearTimeout(Blockly.Tooltip.showPid_);
    };
    Blockly.Tooltip.block = function() {
        Blockly.Tooltip.hide();
        Blockly.Tooltip.blocked_ = !0;
    };
    Blockly.Tooltip.unblock = function() {
        Blockly.Tooltip.blocked_ = !1;
    };
    Blockly.Tooltip.show_ = function() {
        if (!Blockly.Tooltip.blocked_ && (Blockly.Tooltip.poisonedElement_ = Blockly.Tooltip.element_, Blockly.Tooltip.DIV)) {
            Blockly.Tooltip.DIV.textContent = "";
            var a = Blockly.Tooltip.getTooltipOfObject(Blockly.Tooltip.element_);
            a = Blockly.utils.string.wrap(a, Blockly.Tooltip.LIMIT);
            a = a.split("\n");
            for(var b = 0; b < a.length; b++){
                var c = document.createElement("div");
                c.appendChild(document.createTextNode(a[b]));
                Blockly.Tooltip.DIV.appendChild(c);
            }
            a = Blockly.Tooltip.element_.RTL;
            b = document.documentElement.clientWidth;
            c = document.documentElement.clientHeight;
            Blockly.Tooltip.DIV.style.direction = a ? "rtl" : "ltr";
            Blockly.Tooltip.DIV.style.display = "block";
            Blockly.Tooltip.visible = !0;
            var d = Blockly.Tooltip.lastX_;
            d = a ? d - (Blockly.Tooltip.OFFSET_X + Blockly.Tooltip.DIV.offsetWidth) : d + Blockly.Tooltip.OFFSET_X;
            var e = Blockly.Tooltip.lastY_ + Blockly.Tooltip.OFFSET_Y;
            e + Blockly.Tooltip.DIV.offsetHeight > c + window.scrollY && (e -= Blockly.Tooltip.DIV.offsetHeight + 2 * Blockly.Tooltip.OFFSET_Y);
            a ? d = Math.max(Blockly.Tooltip.MARGINS - window.scrollX, d) : d + Blockly.Tooltip.DIV.offsetWidth > b + window.scrollX - 2 * Blockly.Tooltip.MARGINS && (d = b - Blockly.Tooltip.DIV.offsetWidth - 2 * Blockly.Tooltip.MARGINS);
            Blockly.Tooltip.DIV.style.top = e + "px";
            Blockly.Tooltip.DIV.style.left = d + "px";
        }
    };
    Blockly.utils.aria = {};
    Blockly.utils.aria.ARIA_PREFIX_ = "aria-";
    Blockly.utils.aria.ROLE_ATTRIBUTE_ = "role";
    Blockly.utils.aria.Role = {
        GRID: "grid",
        GRIDCELL: "gridcell",
        GROUP: "group",
        LISTBOX: "listbox",
        MENU: "menu",
        MENUITEM: "menuitem",
        MENUITEMCHECKBOX: "menuitemcheckbox",
        OPTION: "option",
        PRESENTATION: "presentation",
        ROW: "row",
        TREE: "tree",
        TREEITEM: "treeitem"
    };
    Blockly.utils.aria.State = {
        ACTIVEDESCENDANT: "activedescendant",
        COLCOUNT: "colcount",
        DISABLED: "disabled",
        EXPANDED: "expanded",
        INVALID: "invalid",
        LABEL: "label",
        LABELLEDBY: "labelledby",
        LEVEL: "level",
        ORIENTATION: "orientation",
        POSINSET: "posinset",
        ROWCOUNT: "rowcount",
        SELECTED: "selected",
        SETSIZE: "setsize",
        VALUEMAX: "valuemax",
        VALUEMIN: "valuemin"
    };
    Blockly.utils.aria.setRole = function(a, b) {
        a.setAttribute(Blockly.utils.aria.ROLE_ATTRIBUTE_, b);
    };
    Blockly.utils.aria.setState = function(a, b, c) {
        Array.isArray(c) && (c = c.join(" "));
        a.setAttribute(Blockly.utils.aria.ARIA_PREFIX_ + b, c);
    };
    Blockly.WorkspaceDragSurfaceSvg = function(a) {
        this.container_ = a;
        this.createDom();
    };
    Blockly.WorkspaceDragSurfaceSvg.prototype.SVG_ = null;
    Blockly.WorkspaceDragSurfaceSvg.prototype.container_ = null;
    Blockly.WorkspaceDragSurfaceSvg.prototype.createDom = function() {
        this.SVG_ || (this.SVG_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
            xmlns: Blockly.utils.dom.SVG_NS,
            "xmlns:html": Blockly.utils.dom.HTML_NS,
            "xmlns:xlink": Blockly.utils.dom.XLINK_NS,
            version: "1.1",
            "class": "blocklyWsDragSurface blocklyOverflowVisible"
        }, null), this.container_.appendChild(this.SVG_));
    };
    Blockly.WorkspaceDragSurfaceSvg.prototype.translateSurface = function(a, b) {
        a = a.toFixed(0);
        b = b.toFixed(0);
        this.SVG_.style.display = "block";
        Blockly.utils.dom.setCssTransform(this.SVG_, "translate3d(" + a + "px, " + b + "px, 0px)");
    };
    Blockly.WorkspaceDragSurfaceSvg.prototype.getSurfaceTranslation = function() {
        return Blockly.utils.getRelativeXY(this.SVG_);
    };
    Blockly.WorkspaceDragSurfaceSvg.prototype.clearAndHide = function(a) {
        if (!a) throw Error("Couldn't clear and hide the drag surface: missing new surface.");
        var b = this.SVG_.childNodes[0], c = this.SVG_.childNodes[1];
        if (!(b && c && Blockly.utils.dom.hasClass(b, "blocklyBlockCanvas") && Blockly.utils.dom.hasClass(c, "blocklyBubbleCanvas"))) throw Error("Couldn't clear and hide the drag surface. A node was missing.");
        null != this.previousSibling_ ? Blockly.utils.dom.insertAfter(b, this.previousSibling_) : a.insertBefore(b, a.firstChild);
        Blockly.utils.dom.insertAfter(c, b);
        this.SVG_.style.display = "none";
        if (this.SVG_.childNodes.length) throw Error("Drag surface was not cleared.");
        Blockly.utils.dom.setCssTransform(this.SVG_, "");
        this.previousSibling_ = null;
    };
    Blockly.WorkspaceDragSurfaceSvg.prototype.setContentsAndShow = function(a, b, c, d, e, f) {
        if (this.SVG_.childNodes.length) throw Error("Already dragging a block.");
        this.previousSibling_ = c;
        a.setAttribute("transform", "translate(0, 0) scale(" + f + ")");
        b.setAttribute("transform", "translate(0, 0) scale(" + f + ")");
        this.SVG_.setAttribute("width", d);
        this.SVG_.setAttribute("height", e);
        this.SVG_.appendChild(a);
        this.SVG_.appendChild(b);
        this.SVG_.style.display = "block";
    };
    Blockly.blockRendering = {};
    Blockly.blockRendering.useDebugger = !1;
    Blockly.blockRendering.register = function(a, b) {
        Blockly.registry.register(Blockly.registry.Type.RENDERER, a, b);
    };
    Blockly.blockRendering.unregister = function(a) {
        Blockly.registry.unregister(Blockly.registry.Type.RENDERER, a);
    };
    Blockly.blockRendering.startDebugger = function() {
        Blockly.blockRendering.useDebugger = !0;
    };
    Blockly.blockRendering.stopDebugger = function() {
        Blockly.blockRendering.useDebugger = !1;
    };
    Blockly.blockRendering.init = function(a, b, c) {
        a = new (Blockly.registry.getClass(Blockly.registry.Type.RENDERER, a))(a);
        a.init(b, c);
        return a;
    };
    Blockly.ASTNode = function(a, b, c) {
        if (!b) throw Error("Cannot create a node without a location.");
        this.type_ = a;
        this.isConnection_ = Blockly.ASTNode.isConnectionType_(a);
        this.location_ = b;
        this.wsCoordinate_ = null;
        this.processParams_(c || null);
    };
    Blockly.ASTNode.types = {
        FIELD: "field",
        BLOCK: "block",
        INPUT: "input",
        OUTPUT: "output",
        NEXT: "next",
        PREVIOUS: "previous",
        STACK: "stack",
        WORKSPACE: "workspace"
    };
    Blockly.ASTNode.NAVIGATE_ALL_FIELDS = !1;
    Blockly.ASTNode.DEFAULT_OFFSET_Y = -20;
    Blockly.ASTNode.isConnectionType_ = function(a) {
        switch(a){
            case Blockly.ASTNode.types.PREVIOUS:
            case Blockly.ASTNode.types.NEXT:
            case Blockly.ASTNode.types.INPUT:
            case Blockly.ASTNode.types.OUTPUT:
                return !0;
        }
        return !1;
    };
    Blockly.ASTNode.createFieldNode = function(a) {
        return a ? new Blockly.ASTNode(Blockly.ASTNode.types.FIELD, a) : null;
    };
    Blockly.ASTNode.createConnectionNode = function(a) {
        if (!a) return null;
        var b = a.type;
        return b == Blockly.connectionTypes.INPUT_VALUE || b == Blockly.connectionTypes.NEXT_STATEMENT && a.getParentInput() ? Blockly.ASTNode.createInputNode(a.getParentInput()) : b == Blockly.connectionTypes.NEXT_STATEMENT ? new Blockly.ASTNode(Blockly.ASTNode.types.NEXT, a) : b == Blockly.connectionTypes.OUTPUT_VALUE ? new Blockly.ASTNode(Blockly.ASTNode.types.OUTPUT, a) : b == Blockly.connectionTypes.PREVIOUS_STATEMENT ? new Blockly.ASTNode(Blockly.ASTNode.types.PREVIOUS, a) : null;
    };
    Blockly.ASTNode.createInputNode = function(a) {
        return a && a.connection ? new Blockly.ASTNode(Blockly.ASTNode.types.INPUT, a.connection) : null;
    };
    Blockly.ASTNode.createBlockNode = function(a) {
        return a ? new Blockly.ASTNode(Blockly.ASTNode.types.BLOCK, a) : null;
    };
    Blockly.ASTNode.createStackNode = function(a) {
        return a ? new Blockly.ASTNode(Blockly.ASTNode.types.STACK, a) : null;
    };
    Blockly.ASTNode.createWorkspaceNode = function(a, b) {
        return b && a ? new Blockly.ASTNode(Blockly.ASTNode.types.WORKSPACE, a, {
            wsCoordinate: b
        }) : null;
    };
    Blockly.ASTNode.createTopNode = function(a) {
        var b = a.previousConnection || a.outputConnection;
        return b ? Blockly.ASTNode.createConnectionNode(b) : Blockly.ASTNode.createBlockNode(a);
    };
    Blockly.ASTNode.prototype.processParams_ = function(a) {
        a && a.wsCoordinate && (this.wsCoordinate_ = a.wsCoordinate);
    };
    Blockly.ASTNode.prototype.getLocation = function() {
        return this.location_;
    };
    Blockly.ASTNode.prototype.getType = function() {
        return this.type_;
    };
    Blockly.ASTNode.prototype.getWsCoordinate = function() {
        return this.wsCoordinate_;
    };
    Blockly.ASTNode.prototype.isConnection = function() {
        return this.isConnection_;
    };
    Blockly.ASTNode.prototype.findNextForInput_ = function() {
        var a = this.location_.getParentInput(), b = a.getSourceBlock();
        a = b.inputList.indexOf(a) + 1;
        for(var c; c = b.inputList[a]; a++){
            for(var d = c.fieldRow, e = 0, f; f = d[e]; e++)if (f.isClickable() || Blockly.ASTNode.NAVIGATE_ALL_FIELDS) return Blockly.ASTNode.createFieldNode(f);
            if (c.connection) return Blockly.ASTNode.createInputNode(c);
        }
        return null;
    };
    Blockly.ASTNode.prototype.findNextForField_ = function() {
        var a = this.location_, b = a.getParentInput(), c = a.getSourceBlock(), d = c.inputList.indexOf(b);
        for(a = b.fieldRow.indexOf(a) + 1; b = c.inputList[d]; d++){
            for(var e = b.fieldRow; a < e.length;){
                if (e[a].isClickable() || Blockly.ASTNode.NAVIGATE_ALL_FIELDS) return Blockly.ASTNode.createFieldNode(e[a]);
                a++;
            }
            a = 0;
            if (b.connection) return Blockly.ASTNode.createInputNode(b);
        }
        return null;
    };
    Blockly.ASTNode.prototype.findPrevForInput_ = function() {
        for(var a = this.location_.getParentInput(), b = a.getSourceBlock(), c = b.inputList.indexOf(a), d; d = b.inputList[c]; c--){
            if (d.connection && d !== a) return Blockly.ASTNode.createInputNode(d);
            d = d.fieldRow;
            for(var e = d.length - 1, f; f = d[e]; e--)if (f.isClickable() || Blockly.ASTNode.NAVIGATE_ALL_FIELDS) return Blockly.ASTNode.createFieldNode(f);
        }
        return null;
    };
    Blockly.ASTNode.prototype.findPrevForField_ = function() {
        var a = this.location_, b = a.getParentInput(), c = a.getSourceBlock(), d = c.inputList.indexOf(b);
        a = b.fieldRow.indexOf(a) - 1;
        for(var e; e = c.inputList[d]; d--){
            if (e.connection && e !== b) return Blockly.ASTNode.createInputNode(e);
            for(e = e.fieldRow; -1 < a;){
                if (e[a].isClickable() || Blockly.ASTNode.NAVIGATE_ALL_FIELDS) return Blockly.ASTNode.createFieldNode(e[a]);
                a--;
            }
            0 <= d - 1 && (a = c.inputList[d - 1].fieldRow.length - 1);
        }
        return null;
    };
    Blockly.ASTNode.prototype.navigateBetweenStacks_ = function(a) {
        var b = this.getLocation();
        b instanceof Blockly.Block || (b = b.getSourceBlock());
        if (!b || !b.workspace) return null;
        var c = b.getRootBlock();
        b = c.workspace.getTopBlocks(!0);
        for(var d = 0, e; e = b[d]; d++)if (c.id == e.id) return a = d + (a ? 1 : -1), -1 == a || a == b.length ? null : Blockly.ASTNode.createStackNode(b[a]);
        throw Error("Couldn't find " + (a ? "next" : "previous") + " stack?!");
    };
    Blockly.ASTNode.prototype.findTopASTNodeForBlock_ = function(a) {
        var b = a.previousConnection || a.outputConnection;
        return b ? Blockly.ASTNode.createConnectionNode(b) : Blockly.ASTNode.createBlockNode(a);
    };
    Blockly.ASTNode.prototype.getOutAstNodeForBlock_ = function(a) {
        if (!a) return null;
        a = a.getTopStackBlock();
        var b = a.previousConnection || a.outputConnection;
        return b && b.targetConnection && b.targetConnection.getParentInput() ? Blockly.ASTNode.createInputNode(b.targetConnection.getParentInput()) : Blockly.ASTNode.createStackNode(a);
    };
    Blockly.ASTNode.prototype.findFirstFieldOrInput_ = function(a) {
        a = a.inputList;
        for(var b = 0, c; c = a[b]; b++){
            for(var d = c.fieldRow, e = 0, f; f = d[e]; e++)if (f.isClickable() || Blockly.ASTNode.NAVIGATE_ALL_FIELDS) return Blockly.ASTNode.createFieldNode(f);
            if (c.connection) return Blockly.ASTNode.createInputNode(c);
        }
        return null;
    };
    Blockly.ASTNode.prototype.getSourceBlock = function() {
        return this.getType() === Blockly.ASTNode.types.BLOCK ? this.getLocation() : this.getType() === Blockly.ASTNode.types.STACK ? this.getLocation() : this.getType() === Blockly.ASTNode.types.WORKSPACE ? null : this.getLocation().getSourceBlock();
    };
    Blockly.ASTNode.prototype.next = function() {
        switch(this.type_){
            case Blockly.ASTNode.types.STACK:
                return this.navigateBetweenStacks_(!0);
            case Blockly.ASTNode.types.OUTPUT:
                var a = this.location_;
                return Blockly.ASTNode.createBlockNode(a.getSourceBlock());
            case Blockly.ASTNode.types.FIELD:
                return this.findNextForField_();
            case Blockly.ASTNode.types.INPUT:
                return this.findNextForInput_();
            case Blockly.ASTNode.types.BLOCK:
                return Blockly.ASTNode.createConnectionNode(this.location_.nextConnection);
            case Blockly.ASTNode.types.PREVIOUS:
                return a = this.location_, Blockly.ASTNode.createBlockNode(a.getSourceBlock());
            case Blockly.ASTNode.types.NEXT:
                return a = this.location_, Blockly.ASTNode.createConnectionNode(a.targetConnection);
        }
        return null;
    };
    Blockly.ASTNode.prototype.in = function() {
        switch(this.type_){
            case Blockly.ASTNode.types.WORKSPACE:
                var a = this.location_.getTopBlocks(!0);
                if (0 < a.length) return Blockly.ASTNode.createStackNode(a[0]);
                break;
            case Blockly.ASTNode.types.STACK:
                return a = this.location_, this.findTopASTNodeForBlock_(a);
            case Blockly.ASTNode.types.BLOCK:
                return a = this.location_, this.findFirstFieldOrInput_(a);
            case Blockly.ASTNode.types.INPUT:
                return Blockly.ASTNode.createConnectionNode(this.location_.targetConnection);
        }
        return null;
    };
    Blockly.ASTNode.prototype.prev = function() {
        switch(this.type_){
            case Blockly.ASTNode.types.STACK:
                return this.navigateBetweenStacks_(!1);
            case Blockly.ASTNode.types.FIELD:
                return this.findPrevForField_();
            case Blockly.ASTNode.types.INPUT:
                return this.findPrevForInput_();
            case Blockly.ASTNode.types.BLOCK:
                var a = this.location_;
                return Blockly.ASTNode.createConnectionNode(a.previousConnection || a.outputConnection);
            case Blockly.ASTNode.types.PREVIOUS:
                a = this.location_;
                if ((a = a.targetConnection) && !a.getParentInput()) return Blockly.ASTNode.createConnectionNode(a);
                break;
            case Blockly.ASTNode.types.NEXT:
                return a = this.location_, Blockly.ASTNode.createBlockNode(a.getSourceBlock());
        }
        return null;
    };
    Blockly.ASTNode.prototype.out = function() {
        switch(this.type_){
            case Blockly.ASTNode.types.STACK:
                var a = this.location_, b = a.getRelativeToSurfaceXY();
                b = new Blockly.utils.Coordinate(b.x, b.y + Blockly.ASTNode.DEFAULT_OFFSET_Y);
                return Blockly.ASTNode.createWorkspaceNode(a.workspace, b);
            case Blockly.ASTNode.types.OUTPUT:
                return a = this.location_, (b = a.targetConnection) ? Blockly.ASTNode.createConnectionNode(b) : Blockly.ASTNode.createStackNode(a.getSourceBlock());
            case Blockly.ASTNode.types.FIELD:
                return Blockly.ASTNode.createBlockNode(this.location_.getSourceBlock());
            case Blockly.ASTNode.types.INPUT:
                return a = this.location_, Blockly.ASTNode.createBlockNode(a.getSourceBlock());
            case Blockly.ASTNode.types.BLOCK:
                return a = this.location_, this.getOutAstNodeForBlock_(a);
            case Blockly.ASTNode.types.PREVIOUS:
                return a = this.location_, this.getOutAstNodeForBlock_(a.getSourceBlock());
            case Blockly.ASTNode.types.NEXT:
                return a = this.location_, this.getOutAstNodeForBlock_(a.getSourceBlock());
        }
        return null;
    };
    Blockly.Blocks = Object.create(null);
    Blockly.utils.deprecation = {};
    Blockly.utils.deprecation.warn = function(a, b, c, d) {
        a = a + " was deprecated on " + b + " and will be deleted on " + c + ".";
        d && (a += "\nUse " + d + " instead.");
        console.warn(a);
    };
    Blockly.Connection = function(a, b) {
        this.sourceBlock_ = a;
        this.type = b;
    };
    Blockly.Connection.CAN_CONNECT = 0;
    Blockly.Connection.REASON_SELF_CONNECTION = 1;
    Blockly.Connection.REASON_WRONG_TYPE = 2;
    Blockly.Connection.REASON_TARGET_NULL = 3;
    Blockly.Connection.REASON_CHECKS_FAILED = 4;
    Blockly.Connection.REASON_DIFFERENT_WORKSPACES = 5;
    Blockly.Connection.REASON_SHADOW_PARENT = 6;
    Blockly.Connection.REASON_DRAG_CHECKS_FAILED = 7;
    Blockly.Connection.prototype.targetConnection = null;
    Blockly.Connection.prototype.disposed = !1;
    Blockly.Connection.prototype.check_ = null;
    Blockly.Connection.prototype.shadowDom_ = null;
    Blockly.Connection.prototype.x = 0;
    Blockly.Connection.prototype.y = 0;
    Blockly.Connection.prototype.connect_ = function(a) {
        var b = this, c = b.getSourceBlock(), d = a.getSourceBlock();
        a.isConnected() && a.disconnect();
        if (b.isConnected()) {
            var e = b.targetBlock(), f = b.getShadowDom();
            b.shadowDom_ = null;
            if (e.isShadow()) f = Blockly.Xml.blockToDom(e), e.dispose(!1), e = null;
            else if (b.type == Blockly.connectionTypes.INPUT_VALUE) {
                if (!e.outputConnection) throw Error("Orphan block does not have an output connection.");
                var g = Blockly.Connection.lastConnectionInRow(d, e);
                g && (e.outputConnection.connect(g), e = null);
            } else if (b.type == Blockly.connectionTypes.NEXT_STATEMENT) {
                if (!e.previousConnection) throw Error("Orphan block does not have a previous connection.");
                for(g = d; g.nextConnection;){
                    var h = g.getNextBlock();
                    if (h && !h.isShadow()) g = h;
                    else {
                        e.workspace.connectionChecker.canConnect(e.previousConnection, g.nextConnection, !1) && (g.nextConnection.connect(e.previousConnection), e = null);
                        break;
                    }
                }
            }
            if (e && (b.disconnect(), Blockly.Events.recordUndo)) {
                var k = Blockly.Events.getGroup();
                setTimeout(function() {
                    if (e.workspace && !e.getParent()) {
                        Blockly.Events.setGroup(k);
                        if (e.outputConnection) e.outputConnection.onFailedConnect(b);
                        else if (e.previousConnection) e.previousConnection.onFailedConnect(b);
                        Blockly.Events.setGroup(!1);
                    }
                }, Blockly.BUMP_DELAY);
            }
            b.shadowDom_ = f;
        }
        var l;
        Blockly.Events.isEnabled() && (l = new (Blockly.Events.get(Blockly.Events.BLOCK_MOVE))(d));
        Blockly.Connection.connectReciprocally_(b, a);
        d.setParent(c);
        l && (l.recordNew(), Blockly.Events.fire(l));
    };
    Blockly.Connection.prototype.dispose = function() {
        if (this.isConnected()) {
            this.setShadowDom(null);
            var a = this.targetBlock();
            a && a.unplug();
        }
        this.disposed = !0;
    };
    Blockly.Connection.prototype.getSourceBlock = function() {
        return this.sourceBlock_;
    };
    Blockly.Connection.prototype.isSuperior = function() {
        return this.type == Blockly.connectionTypes.INPUT_VALUE || this.type == Blockly.connectionTypes.NEXT_STATEMENT;
    };
    Blockly.Connection.prototype.isConnected = function() {
        return !!this.targetConnection;
    };
    Blockly.Connection.prototype.canConnectWithReason = function(a) {
        Blockly.utils.deprecation.warn("Connection.prototype.canConnectWithReason", "July 2020", "July 2021", "the workspace's connection checker");
        return this.getConnectionChecker().canConnectWithReason(this, a, !1);
    };
    Blockly.Connection.prototype.checkConnection = function(a) {
        Blockly.utils.deprecation.warn("Connection.prototype.checkConnection", "July 2020", "July 2021", "the workspace's connection checker");
        var b = this.getConnectionChecker(), c = b.canConnectWithReason(this, a, !1);
        if (c != Blockly.Connection.CAN_CONNECT) throw Error(b.getErrorMessage(c, this, a));
    };
    Blockly.Connection.prototype.getConnectionChecker = function() {
        return this.sourceBlock_.workspace.connectionChecker;
    };
    Blockly.Connection.prototype.isConnectionAllowed = function(a) {
        Blockly.utils.deprecation.warn("Connection.prototype.isConnectionAllowed", "July 2020", "July 2021", "the workspace's connection checker");
        return this.getConnectionChecker().canConnect(this, a, !0);
    };
    Blockly.Connection.prototype.onFailedConnect = function(a) {};
    Blockly.Connection.prototype.connect = function(a) {
        if (this.targetConnection != a && this.getConnectionChecker().canConnect(this, a, !1)) {
            var b = Blockly.Events.getGroup();
            b || Blockly.Events.setGroup(!0);
            this.isSuperior() ? this.connect_(a) : a.connect_(this);
            b || Blockly.Events.setGroup(!1);
        }
    };
    Blockly.Connection.connectReciprocally_ = function(a, b) {
        if (!a || !b) throw Error("Cannot connect null connections.");
        a.targetConnection = b;
        b.targetConnection = a;
    };
    Blockly.Connection.singleConnection_ = function(a, b) {
        var c = null;
        b = b.outputConnection;
        for(var d = 0; d < a.inputList.length; d++){
            var e = a.inputList[d].connection, f = b.getConnectionChecker();
            if (e && e.type == Blockly.connectionTypes.INPUT_VALUE && f.canConnect(b, e, !1)) {
                if (c) return null;
                c = e;
            }
        }
        return c;
    };
    Blockly.Connection.lastConnectionInRow = function(a, b) {
        for(var c; c = Blockly.Connection.singleConnection_(a, b);)if (a = c.targetBlock(), !a || a.isShadow()) return c;
        return null;
    };
    Blockly.Connection.prototype.disconnect = function() {
        var a = this.targetConnection;
        if (!a) throw Error("Source connection not connected.");
        if (a.targetConnection != this) throw Error("Target connection not connected to source connection.");
        if (this.isSuperior()) {
            var b = this.sourceBlock_;
            var c = a.getSourceBlock();
            a = this;
        } else b = a.getSourceBlock(), c = this.sourceBlock_;
        var d = Blockly.Events.getGroup();
        d || Blockly.Events.setGroup(!0);
        this.disconnectInternal_(b, c);
        c.isShadow() || a.respawnShadow_();
        d || Blockly.Events.setGroup(!1);
    };
    Blockly.Connection.prototype.disconnectInternal_ = function(a, b) {
        var c;
        Blockly.Events.isEnabled() && (c = new (Blockly.Events.get(Blockly.Events.BLOCK_MOVE))(b));
        this.targetConnection = this.targetConnection.targetConnection = null;
        b.setParent(null);
        c && (c.recordNew(), Blockly.Events.fire(c));
    };
    Blockly.Connection.prototype.respawnShadow_ = function() {
        var a = this.getSourceBlock(), b = this.getShadowDom();
        if (a.workspace && b) {
            if (a = Blockly.Xml.domToBlock(b, a.workspace), a.outputConnection) this.connect(a.outputConnection);
            else if (a.previousConnection) this.connect(a.previousConnection);
            else throw Error("Child block does not have output or previous statement.");
        }
    };
    Blockly.Connection.prototype.targetBlock = function() {
        return this.isConnected() ? this.targetConnection.getSourceBlock() : null;
    };
    Blockly.Connection.prototype.checkType = function(a) {
        Blockly.utils.deprecation.warn("Connection.prototype.checkType", "October 2019", "January 2021", "the workspace's connection checker");
        return this.getConnectionChecker().canConnect(this, a, !1);
    };
    Blockly.Connection.prototype.checkType_ = function(a) {
        Blockly.utils.deprecation.warn("Connection.prototype.checkType_", "October 2019", "January 2021", "the workspace's connection checker");
        return this.checkType(a);
    };
    Blockly.Connection.prototype.onCheckChanged_ = function() {
        !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || (this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug();
    };
    Blockly.Connection.prototype.setCheck = function(a) {
        a ? (Array.isArray(a) || (a = [
            a
        ]), this.check_ = a, this.onCheckChanged_()) : this.check_ = null;
        return this;
    };
    Blockly.Connection.prototype.getCheck = function() {
        return this.check_;
    };
    Blockly.Connection.prototype.setShadowDom = function(a) {
        this.shadowDom_ = a;
        a = this.targetBlock();
        a ? a.isShadow() && (a.dispose(!1), this.respawnShadow_()) : this.respawnShadow_();
    };
    Blockly.Connection.prototype.getShadowDom = function() {
        return this.shadowDom_;
    };
    Blockly.Connection.prototype.neighbours = function(a) {
        return [];
    };
    Blockly.Connection.prototype.getParentInput = function() {
        for(var a = null, b = this.sourceBlock_, c = b.inputList, d = 0; d < b.inputList.length; d++)if (c[d].connection === this) {
            a = c[d];
            break;
        }
        return a;
    };
    Blockly.Connection.prototype.toString = function() {
        var a = this.sourceBlock_;
        if (a) {
            if (a.outputConnection == this) var b = "Output Connection of ";
            else if (a.previousConnection == this) b = "Previous Connection of ";
            else if (a.nextConnection == this) b = "Next Connection of ";
            else {
                b = null;
                for(var c = 0, d; d = a.inputList[c]; c++)if (d.connection == this) {
                    b = d;
                    break;
                }
                if (b) b = 'Input "' + b.name + '" connection on ';
                else return console.warn("Connection not actually connected to sourceBlock_"), "Orphan Connection";
            }
        } else return "Orphan Connection";
        return b + a.toDevString();
    };
    Blockly.Extensions = {};
    Blockly.Extensions.ALL_ = {};
    Blockly.Extensions.register = function(a, b) {
        if ("string" != typeof a || "" == a.trim()) throw Error('Error: Invalid extension name "' + a + '"');
        if (Blockly.Extensions.ALL_[a]) throw Error('Error: Extension "' + a + '" is already registered.');
        if ("function" != typeof b) throw Error('Error: Extension "' + a + '" must be a function');
        Blockly.Extensions.ALL_[a] = b;
    };
    Blockly.Extensions.registerMixin = function(a, b) {
        if (!b || "object" != typeof b) throw Error('Error: Mixin "' + a + '" must be a object');
        Blockly.Extensions.register(a, function() {
            this.mixin(b);
        });
    };
    Blockly.Extensions.registerMutator = function(a, b, c, d) {
        var e = 'Error when registering mutator "' + a + '": ';
        Blockly.Extensions.checkHasFunction_(e, b.domToMutation, "domToMutation");
        Blockly.Extensions.checkHasFunction_(e, b.mutationToDom, "mutationToDom");
        var f = Blockly.Extensions.checkMutatorDialog_(b, e);
        if (c && "function" != typeof c) throw Error('Extension "' + a + '" is not a function');
        Blockly.Extensions.register(a, function() {
            if (f) {
                if (!Blockly.Mutator) throw Error(e + "Missing require for Blockly.Mutator");
                this.setMutator(new Blockly.Mutator(d || []));
            }
            this.mixin(b);
            c && c.apply(this);
        });
    };
    Blockly.Extensions.unregister = function(a) {
        Blockly.Extensions.ALL_[a] ? delete Blockly.Extensions.ALL_[a] : console.warn('No extension mapping for name "' + a + '" found to unregister');
    };
    Blockly.Extensions.apply = function(a, b, c) {
        var d = Blockly.Extensions.ALL_[a];
        if ("function" != typeof d) throw Error('Error: Extension "' + a + '" not found.');
        if (c) Blockly.Extensions.checkNoMutatorProperties_(a, b);
        else var e = Blockly.Extensions.getMutatorProperties_(b);
        d.apply(b);
        if (c) Blockly.Extensions.checkBlockHasMutatorProperties_('Error after applying mutator "' + a + '": ', b);
        else if (!Blockly.Extensions.mutatorPropertiesMatch_(e, b)) throw Error('Error when applying extension "' + a + '": mutation properties changed when applying a non-mutator extension.');
    };
    Blockly.Extensions.checkHasFunction_ = function(a, b, c) {
        if (!b) throw Error(a + 'missing required property "' + c + '"');
        if ("function" != typeof b) throw Error(a + '" required property "' + c + '" must be a function');
    };
    Blockly.Extensions.checkNoMutatorProperties_ = function(a, b) {
        if (Blockly.Extensions.getMutatorProperties_(b).length) throw Error('Error: tried to apply mutation "' + a + '" to a block that already has mutator functions.  Block id: ' + b.id);
    };
    Blockly.Extensions.checkMutatorDialog_ = function(a, b) {
        var c = void 0 !== a.compose, d = void 0 !== a.decompose;
        if (c && d) {
            if ("function" != typeof a.compose) throw Error(b + "compose must be a function.");
            if ("function" != typeof a.decompose) throw Error(b + "decompose must be a function.");
            return !0;
        }
        if (c || d) throw Error(b + 'Must have both or neither of "compose" and "decompose"');
        return !1;
    };
    Blockly.Extensions.checkBlockHasMutatorProperties_ = function(a, b) {
        if ("function" != typeof b.domToMutation) throw Error(a + 'Applying a mutator didn\'t add "domToMutation"');
        if ("function" != typeof b.mutationToDom) throw Error(a + 'Applying a mutator didn\'t add "mutationToDom"');
        Blockly.Extensions.checkMutatorDialog_(b, a);
    };
    Blockly.Extensions.getMutatorProperties_ = function(a) {
        var b = [];
        void 0 !== a.domToMutation && b.push(a.domToMutation);
        void 0 !== a.mutationToDom && b.push(a.mutationToDom);
        void 0 !== a.compose && b.push(a.compose);
        void 0 !== a.decompose && b.push(a.decompose);
        return b;
    };
    Blockly.Extensions.mutatorPropertiesMatch_ = function(a, b) {
        b = Blockly.Extensions.getMutatorProperties_(b);
        if (b.length != a.length) return !1;
        for(var c = 0; c < b.length; c++)if (a[c] != b[c]) return !1;
        return !0;
    };
    Blockly.Extensions.buildTooltipForDropdown = function(a, b) {
        var c = [];
        "object" == typeof document && Blockly.utils.runAfterPageLoad(function() {
            for(var d in b)Blockly.utils.checkMessageReferences(b[d]);
        });
        return function() {
            this.type && -1 == c.indexOf(this.type) && (Blockly.Extensions.checkDropdownOptionsInTable_(this, a, b), c.push(this.type));
            this.setTooltip((function() {
                var d = String(this.getFieldValue(a)), e = b[d];
                null == e ? -1 == c.indexOf(this.type) && (d = "No tooltip mapping for value " + d + " of field " + a, null != this.type && (d += " of block type " + this.type), console.warn(d + ".")) : e = Blockly.utils.replaceMessageReferences(e);
                return e;
            }).bind(this));
        };
    };
    Blockly.Extensions.checkDropdownOptionsInTable_ = function(a, b, c) {
        var d = a.getField(b);
        if (!d.isOptionListDynamic()) {
            d = d.getOptions();
            for(var e = 0; e < d.length; ++e){
                var f = d[e][1];
                null == c[f] && console.warn("No tooltip mapping for value " + f + " of field " + b + " of block type " + a.type);
            }
        }
    };
    Blockly.Extensions.buildTooltipWithFieldText = function(a, b) {
        "object" == typeof document && Blockly.utils.runAfterPageLoad(function() {
            Blockly.utils.checkMessageReferences(a);
        });
        return function() {
            this.setTooltip((function() {
                var c = this.getField(b);
                return Blockly.utils.replaceMessageReferences(a).replace("%1", c ? c.getText() : "");
            }).bind(this));
        };
    };
    Blockly.Extensions.extensionParentTooltip_ = function() {
        this.tooltipWhenNotConnected_ = this.tooltip;
        this.setTooltip((function() {
            var a = this.getParent();
            return a && a.getInputsInline() && a.tooltip || this.tooltipWhenNotConnected_;
        }).bind(this));
    };
    Blockly.Extensions.register("parent_tooltip_when_inline", Blockly.Extensions.extensionParentTooltip_);
    Blockly.fieldRegistry = {};
    Blockly.fieldRegistry.register = function(a, b) {
        Blockly.registry.register(Blockly.registry.Type.FIELD, a, b);
    };
    Blockly.fieldRegistry.unregister = function(a) {
        Blockly.registry.unregister(Blockly.registry.Type.FIELD, a);
    };
    Blockly.fieldRegistry.fromJson = function(a) {
        var b = Blockly.registry.getObject(Blockly.registry.Type.FIELD, a.type);
        return b ? b.fromJson(a) : (console.warn("Blockly could not create a field of type " + a.type + ". The field is probably not being registered. This could be because the file is not loaded, the field does not register itself (Issue #1584), or the registration is not being reached."), null);
    };
    Blockly.blockAnimations = {};
    Blockly.blockAnimations.disconnectPid_ = 0;
    Blockly.blockAnimations.disconnectGroup_ = null;
    Blockly.blockAnimations.disposeUiEffect = function(a) {
        var b = a.workspace, c = a.getSvgRoot();
        b.getAudioManager().play("delete");
        a = b.getSvgXY(c);
        c = c.cloneNode(!0);
        c.translateX_ = a.x;
        c.translateY_ = a.y;
        c.setAttribute("transform", "translate(" + a.x + "," + a.y + ")");
        b.getParentSvg().appendChild(c);
        c.bBox_ = c.getBBox();
        Blockly.blockAnimations.disposeUiStep_(c, b.RTL, new Date, b.scale);
    };
    Blockly.blockAnimations.disposeUiStep_ = function(a, b, c, d) {
        var e = (new Date - c) / 150;
        1 < e ? Blockly.utils.dom.removeNode(a) : (a.setAttribute("transform", "translate(" + (a.translateX_ + (b ? -1 : 1) * a.bBox_.width * d / 2 * e) + "," + (a.translateY_ + a.bBox_.height * d * e) + ") scale(" + (1 - e) * d + ")"), setTimeout(Blockly.blockAnimations.disposeUiStep_, 10, a, b, c, d));
    };
    Blockly.blockAnimations.connectionUiEffect = function(a) {
        var b = a.workspace, c = b.scale;
        b.getAudioManager().play("click");
        if (!(1 > c)) {
            var d = b.getSvgXY(a.getSvgRoot());
            a.outputConnection ? (d.x += (a.RTL ? 3 : -3) * c, d.y += 13 * c) : a.previousConnection && (d.x += (a.RTL ? -23 : 23) * c, d.y += 3 * c);
            a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CIRCLE, {
                cx: d.x,
                cy: d.y,
                r: 0,
                fill: "none",
                stroke: "#888",
                "stroke-width": 10
            }, b.getParentSvg());
            Blockly.blockAnimations.connectionUiStep_(a, new Date, c);
        }
    };
    Blockly.blockAnimations.connectionUiStep_ = function(a, b, c) {
        var d = (new Date - b) / 150;
        1 < d ? Blockly.utils.dom.removeNode(a) : (a.setAttribute("r", 25 * d * c), a.style.opacity = 1 - d, Blockly.blockAnimations.disconnectPid_ = setTimeout(Blockly.blockAnimations.connectionUiStep_, 10, a, b, c));
    };
    Blockly.blockAnimations.disconnectUiEffect = function(a) {
        a.workspace.getAudioManager().play("disconnect");
        if (!(1 > a.workspace.scale)) {
            var b = a.getHeightWidth().height;
            b = Math.atan(10 / b) / Math.PI * 180;
            a.RTL || (b *= -1);
            Blockly.blockAnimations.disconnectUiStep_(a.getSvgRoot(), b, new Date);
        }
    };
    Blockly.blockAnimations.disconnectUiStep_ = function(a, b, c) {
        var d = (new Date - c) / 200;
        1 < d ? a.skew_ = "" : (a.skew_ = "skewX(" + Math.round(Math.sin(d * Math.PI * 3) * (1 - d) * b) + ")", Blockly.blockAnimations.disconnectGroup_ = a, Blockly.blockAnimations.disconnectPid_ = setTimeout(Blockly.blockAnimations.disconnectUiStep_, 10, a, b, c));
        a.setAttribute("transform", a.translate_ + a.skew_);
    };
    Blockly.blockAnimations.disconnectUiStop = function() {
        if (Blockly.blockAnimations.disconnectGroup_) {
            clearTimeout(Blockly.blockAnimations.disconnectPid_);
            var a = Blockly.blockAnimations.disconnectGroup_;
            a.skew_ = "";
            a.setAttribute("transform", a.translate_);
            Blockly.blockAnimations.disconnectGroup_ = null;
        }
    };
    Blockly.Events.BlockDrag = function(a, b, c) {
        Blockly.Events.BlockDrag.superClass_.constructor.call(this, a ? a.workspace.id : void 0);
        this.blockId = a ? a.id : null;
        this.isStart = b;
        this.blocks = c;
    };
    Blockly.utils.object.inherits(Blockly.Events.BlockDrag, Blockly.Events.UiBase);
    Blockly.Events.BlockDrag.prototype.type = Blockly.Events.BLOCK_DRAG;
    Blockly.Events.BlockDrag.prototype.toJson = function() {
        var a = Blockly.Events.BlockDrag.superClass_.toJson.call(this);
        a.isStart = this.isStart;
        a.blockId = this.blockId;
        a.blocks = this.blocks;
        return a;
    };
    Blockly.Events.BlockDrag.prototype.fromJson = function(a) {
        Blockly.Events.BlockDrag.superClass_.fromJson.call(this, a);
        this.isStart = a.isStart;
        this.blockId = a.blockId;
        this.blocks = a.blocks;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.BLOCK_DRAG, Blockly.Events.BlockDrag);
    Blockly.InsertionMarkerManager = function(a) {
        this.topBlock_ = Blockly.selected = a;
        this.workspace_ = a.workspace;
        this.lastMarker_ = this.lastOnStack_ = null;
        this.firstMarker_ = this.createMarkerBlock_(this.topBlock_);
        this.localConnection_ = this.closestConnection_ = null;
        this.wouldDeleteBlock_ = !1;
        this.fadedBlock_ = this.highlightedBlock_ = this.markerConnection_ = null;
        this.availableConnections_ = this.initAvailableConnections_();
    };
    Blockly.InsertionMarkerManager.PREVIEW_TYPE = {
        INSERTION_MARKER: 0,
        INPUT_OUTLINE: 1,
        REPLACEMENT_FADE: 2
    };
    Blockly.InsertionMarkerManager.prototype.dispose = function() {
        this.availableConnections_.length = 0;
        Blockly.Events.disable();
        try {
            this.firstMarker_ && this.firstMarker_.dispose(), this.lastMarker_ && this.lastMarker_.dispose();
        } finally{
            Blockly.Events.enable();
        }
    };
    Blockly.InsertionMarkerManager.prototype.updateAvailableConnections = function() {
        this.availableConnections_ = this.initAvailableConnections_();
    };
    Blockly.InsertionMarkerManager.prototype.wouldDeleteBlock = function() {
        return this.wouldDeleteBlock_;
    };
    Blockly.InsertionMarkerManager.prototype.wouldConnectBlock = function() {
        return !!this.closestConnection_;
    };
    Blockly.InsertionMarkerManager.prototype.applyConnections = function() {
        if (this.closestConnection_ && (Blockly.Events.disable(), this.hidePreview_(), Blockly.Events.enable(), this.localConnection_.connect(this.closestConnection_), this.topBlock_.rendered)) {
            var a = this.localConnection_.isSuperior() ? this.closestConnection_ : this.localConnection_;
            Blockly.blockAnimations.connectionUiEffect(a.getSourceBlock());
            this.topBlock_.getRootBlock().bringToFront();
        }
    };
    Blockly.InsertionMarkerManager.prototype.update = function(a, b) {
        var c = this.getCandidate_(a);
        if ((this.wouldDeleteBlock_ = this.shouldDelete_(c, b)) || this.shouldUpdatePreviews_(c, a)) Blockly.Events.disable(), this.maybeHidePreview_(c), this.maybeShowPreview_(c), Blockly.Events.enable();
    };
    Blockly.InsertionMarkerManager.prototype.createMarkerBlock_ = function(a) {
        var b = a.type;
        Blockly.Events.disable();
        try {
            var c = this.workspace_.newBlock(b);
            c.setInsertionMarker(!0);
            if (a.mutationToDom) {
                var d = a.mutationToDom();
                d && c.domToMutation(d);
            }
            for(b = 0; b < a.inputList.length; b++){
                var e = a.inputList[b];
                if (e.name != Blockly.constants.COLLAPSED_INPUT_NAME) {
                    var f = c.inputList[b];
                    for(d = 0; d < e.fieldRow.length; d++)f.fieldRow[d].setValue(e.fieldRow[d].getValue());
                }
            }
            c.setCollapsed(a.isCollapsed());
            c.setInputsInline(a.getInputsInline());
            c.initSvg();
            c.getSvgRoot().setAttribute("visibility", "hidden");
        } finally{
            Blockly.Events.enable();
        }
        return c;
    };
    Blockly.InsertionMarkerManager.prototype.initAvailableConnections_ = function() {
        var a = this.topBlock_.getConnections_(!1), b = this.topBlock_.lastConnectionInStack();
        if (b && b != this.topBlock_.nextConnection) {
            a.push(b);
            this.lastOnStack_ = b;
            if (this.lastMarker_) {
                Blockly.Events.disable();
                try {
                    this.lastMarker_.dispose();
                } finally{
                    Blockly.Events.enable();
                }
            }
            this.lastMarker_ = this.createMarkerBlock_(b.getSourceBlock());
        }
        return a;
    };
    Blockly.InsertionMarkerManager.prototype.shouldUpdatePreviews_ = function(a, b) {
        var c = a.local, d = a.closest;
        a = a.radius;
        if (c && d) {
            if (this.localConnection_ && this.closestConnection_) {
                if (this.closestConnection_ == d && this.localConnection_ == c) return !1;
                c = this.localConnection_.x + b.x - this.closestConnection_.x;
                b = this.localConnection_.y + b.y - this.closestConnection_.y;
                b = Math.sqrt(c * c + b * b);
                return !(d && a > b - Blockly.CURRENT_CONNECTION_PREFERENCE);
            }
            if (this.localConnection_ || this.closestConnection_) console.error("Only one of localConnection_ and closestConnection_ was set.");
            else return !0;
        } else return !(!this.localConnection_ || !this.closestConnection_);
        console.error("Returning true from shouldUpdatePreviews, but it's not clear why.");
        return !0;
    };
    Blockly.InsertionMarkerManager.prototype.getCandidate_ = function(a) {
        for(var b = this.getStartRadius_(), c = null, d = null, e = 0; e < this.availableConnections_.length; e++){
            var f = this.availableConnections_[e], g = f.closest(b, a);
            g.connection && (c = g.connection, d = f, b = g.radius);
        }
        return {
            closest: c,
            local: d,
            radius: b
        };
    };
    Blockly.InsertionMarkerManager.prototype.getStartRadius_ = function() {
        return this.closestConnection_ && this.localConnection_ ? Blockly.CONNECTING_SNAP_RADIUS : Blockly.SNAP_RADIUS;
    };
    Blockly.InsertionMarkerManager.prototype.shouldDelete_ = function(a, b) {
        a = a && !!a.closest && b != Blockly.DELETE_AREA_TOOLBOX;
        return !!b && !this.topBlock_.getParent() && this.topBlock_.isDeletable() && !a;
    };
    Blockly.InsertionMarkerManager.prototype.maybeShowPreview_ = function(a) {
        if (!this.wouldDeleteBlock_) {
            var b = a.closest;
            a = a.local;
            b && (b == this.closestConnection_ || b.getSourceBlock().isInsertionMarker() ? console.log("Trying to connect to an insertion marker") : (this.closestConnection_ = b, this.localConnection_ = a, this.showPreview_()));
        }
    };
    Blockly.InsertionMarkerManager.prototype.showPreview_ = function() {
        var a = this.closestConnection_, b = this.workspace_.getRenderer();
        switch(b.getConnectionPreviewMethod(a, this.localConnection_, this.topBlock_)){
            case Blockly.InsertionMarkerManager.PREVIEW_TYPE.INPUT_OUTLINE:
                this.showInsertionInputOutline_();
                break;
            case Blockly.InsertionMarkerManager.PREVIEW_TYPE.INSERTION_MARKER:
                this.showInsertionMarker_();
                break;
            case Blockly.InsertionMarkerManager.PREVIEW_TYPE.REPLACEMENT_FADE:
                this.showReplacementFade_();
        }
        a && b.shouldHighlightConnection(a) && a.highlight();
    };
    Blockly.InsertionMarkerManager.prototype.maybeHidePreview_ = function(a) {
        if (a.closest) {
            var b = this.closestConnection_ != a.closest;
            a = this.localConnection_ != a.local;
            this.closestConnection_ && this.localConnection_ && (b || a || this.wouldDeleteBlock_) && this.hidePreview_();
        } else this.hidePreview_();
        this.localConnection_ = this.closestConnection_ = this.markerConnection_ = null;
    };
    Blockly.InsertionMarkerManager.prototype.hidePreview_ = function() {
        this.closestConnection_ && this.closestConnection_.targetBlock() && this.workspace_.getRenderer().shouldHighlightConnection(this.closestConnection_) && this.closestConnection_.unhighlight();
        this.fadedBlock_ ? this.hideReplacementFade_() : this.highlightedBlock_ ? this.hideInsertionInputOutline_() : this.markerConnection_ && this.hideInsertionMarker_();
    };
    Blockly.InsertionMarkerManager.prototype.showInsertionMarker_ = function() {
        var a = this.localConnection_, b = this.closestConnection_, c = this.lastOnStack_ && a == this.lastOnStack_ ? this.lastMarker_ : this.firstMarker_;
        a = c.getMatchingConnection(a.getSourceBlock(), a);
        if (a == this.markerConnection_) throw Error("Made it to showInsertionMarker_ even though the marker isn't changing");
        c.render();
        c.rendered = !0;
        c.getSvgRoot().setAttribute("visibility", "visible");
        a && b && c.positionNearConnection(a, b);
        b && a.connect(b);
        this.markerConnection_ = a;
    };
    Blockly.InsertionMarkerManager.prototype.hideInsertionMarker_ = function() {
        if (this.markerConnection_) {
            var a = this.markerConnection_, b = a.getSourceBlock(), c = b.nextConnection, d = b.previousConnection, e = b.outputConnection;
            e = a.type == Blockly.connectionTypes.INPUT_VALUE && !(e && e.targetConnection);
            !(a != c || d && d.targetConnection) || e ? a.targetBlock().unplug(!1) : a.type == Blockly.connectionTypes.NEXT_STATEMENT && a != c ? (c = a.targetConnection, c.getSourceBlock().unplug(!1), d = d ? d.targetConnection : null, b.unplug(!0), d && d.connect(c)) : b.unplug(!0);
            if (a.targetConnection) throw Error("markerConnection_ still connected at the end of disconnectInsertionMarker");
            this.markerConnection_ = null;
            b.getSvgRoot().setAttribute("visibility", "hidden");
        } else console.log("No insertion marker connection to disconnect");
    };
    Blockly.InsertionMarkerManager.prototype.showInsertionInputOutline_ = function() {
        var a = this.closestConnection_;
        this.highlightedBlock_ = a.getSourceBlock();
        this.highlightedBlock_.highlightShapeForInput(a, !0);
    };
    Blockly.InsertionMarkerManager.prototype.hideInsertionInputOutline_ = function() {
        this.highlightedBlock_.highlightShapeForInput(this.closestConnection_, !1);
        this.highlightedBlock_ = null;
    };
    Blockly.InsertionMarkerManager.prototype.showReplacementFade_ = function() {
        this.fadedBlock_ = this.closestConnection_.targetBlock();
        this.fadedBlock_.fadeForReplacement(!0);
    };
    Blockly.InsertionMarkerManager.prototype.hideReplacementFade_ = function() {
        this.fadedBlock_.fadeForReplacement(!1);
        this.fadedBlock_ = null;
    };
    Blockly.InsertionMarkerManager.prototype.getInsertionMarkers = function() {
        var a = [];
        this.firstMarker_ && a.push(this.firstMarker_);
        this.lastMarker_ && a.push(this.lastMarker_);
        return a;
    };
    Blockly.BlockDragger = function(a, b) {
        this.draggingBlock_ = a;
        this.workspace_ = b;
        this.draggedConnectionManager_ = new Blockly.InsertionMarkerManager(this.draggingBlock_);
        this.deleteArea_ = null;
        this.wouldDeleteBlock_ = !1;
        this.startXY_ = this.draggingBlock_.getRelativeToSurfaceXY();
        this.dragIconData_ = Blockly.BlockDragger.initIconData_(a);
    };
    Blockly.BlockDragger.prototype.dispose = function() {
        this.dragIconData_.length = 0;
        this.draggedConnectionManager_ && this.draggedConnectionManager_.dispose();
    };
    Blockly.BlockDragger.initIconData_ = function(a) {
        var b = [];
        a = a.getDescendants(!1);
        for(var c = 0, d; d = a[c]; c++){
            d = d.getIcons();
            for(var e = 0; e < d.length; e++){
                var f = {
                    location: d[e].getIconLocation(),
                    icon: d[e]
                };
                b.push(f);
            }
        }
        return b;
    };
    Blockly.BlockDragger.prototype.startBlockDrag = function(a, b) {
        Blockly.Events.getGroup() || Blockly.Events.setGroup(!0);
        this.fireDragStartEvent_();
        this.workspace_.isMutator && this.draggingBlock_.bringToFront();
        Blockly.utils.dom.startTextWidthCache();
        this.workspace_.setResizesEnabled(!1);
        Blockly.blockAnimations.disconnectUiStop();
        if (this.draggingBlock_.getParent() || b && this.draggingBlock_.nextConnection && this.draggingBlock_.nextConnection.targetBlock()) this.draggingBlock_.unplug(b), a = this.pixelsToWorkspaceUnits_(a), a = Blockly.utils.Coordinate.sum(this.startXY_, a), this.draggingBlock_.translate(a.x, a.y), Blockly.blockAnimations.disconnectUiEffect(this.draggingBlock_), this.draggedConnectionManager_.updateAvailableConnections();
        this.draggingBlock_.setDragging(!0);
        this.draggingBlock_.moveToDragSurface();
        (a = this.workspace_.getToolbox()) && "function" == typeof a.addStyle && (b = this.draggingBlock_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab", a.addStyle(b));
    };
    Blockly.BlockDragger.prototype.fireDragStartEvent_ = function() {
        var a = new (Blockly.Events.get(Blockly.Events.BLOCK_DRAG))(this.draggingBlock_, !0, this.draggingBlock_.getDescendants(!1));
        Blockly.Events.fire(a);
    };
    Blockly.BlockDragger.prototype.dragBlock = function(a, b) {
        b = this.pixelsToWorkspaceUnits_(b);
        var c = Blockly.utils.Coordinate.sum(this.startXY_, b);
        this.draggingBlock_.moveDuringDrag(c);
        this.dragIcons_(b);
        this.deleteArea_ = this.workspace_.isDeleteArea(a);
        this.draggedConnectionManager_.update(b, this.deleteArea_);
        this.updateCursorDuringBlockDrag_();
    };
    Blockly.BlockDragger.prototype.endBlockDrag = function(a, b) {
        this.dragBlock(a, b);
        this.dragIconData_ = [];
        this.fireDragEndEvent_();
        Blockly.utils.dom.stopTextWidthCache();
        Blockly.blockAnimations.disconnectUiStop();
        a = this.pixelsToWorkspaceUnits_(b);
        b = Blockly.utils.Coordinate.sum(this.startXY_, a);
        this.draggingBlock_.moveOffDragSurface(b);
        this.maybeDeleteBlock_() || (this.draggingBlock_.moveConnections(a.x, a.y), this.draggingBlock_.setDragging(!1), this.fireMoveEvent_(), this.draggedConnectionManager_.wouldConnectBlock() ? this.draggedConnectionManager_.applyConnections() : this.draggingBlock_.render(), this.draggingBlock_.scheduleSnapAndBump());
        this.workspace_.setResizesEnabled(!0);
        (a = this.workspace_.getToolbox()) && "function" == typeof a.removeStyle && (b = this.draggingBlock_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab", a.removeStyle(b));
        Blockly.Events.setGroup(!1);
    };
    Blockly.BlockDragger.prototype.fireDragEndEvent_ = function() {
        var a = new (Blockly.Events.get(Blockly.Events.BLOCK_DRAG))(this.draggingBlock_, !1, this.draggingBlock_.getDescendants(!1));
        Blockly.Events.fire(a);
    };
    Blockly.BlockDragger.prototype.fireMoveEvent_ = function() {
        var a = new (Blockly.Events.get(Blockly.Events.BLOCK_MOVE))(this.draggingBlock_);
        a.oldCoordinate = this.startXY_;
        a.recordNew();
        Blockly.Events.fire(a);
    };
    Blockly.BlockDragger.prototype.maybeDeleteBlock_ = function() {
        var a = this.workspace_.trashcan;
        this.wouldDeleteBlock_ ? (a && setTimeout(a.closeLid.bind(a), 100), this.fireMoveEvent_(), this.draggingBlock_.dispose(!1, !0), Blockly.draggingConnections = []) : a && a.closeLid();
        return this.wouldDeleteBlock_;
    };
    Blockly.BlockDragger.prototype.updateCursorDuringBlockDrag_ = function() {
        this.wouldDeleteBlock_ = this.draggedConnectionManager_.wouldDeleteBlock();
        var a = this.workspace_.trashcan;
        this.wouldDeleteBlock_ ? (this.draggingBlock_.setDeleteStyle(!0), this.deleteArea_ == Blockly.DELETE_AREA_TRASH && a && a.setLidOpen(!0)) : (this.draggingBlock_.setDeleteStyle(!1), a && a.setLidOpen(!1));
    };
    Blockly.BlockDragger.prototype.pixelsToWorkspaceUnits_ = function(a) {
        a = new Blockly.utils.Coordinate(a.x / this.workspace_.scale, a.y / this.workspace_.scale);
        this.workspace_.isMutator && a.scale(1 / this.workspace_.options.parentWorkspace.scale);
        return a;
    };
    Blockly.BlockDragger.prototype.dragIcons_ = function(a) {
        for(var b = 0; b < this.dragIconData_.length; b++){
            var c = this.dragIconData_[b];
            c.icon.setIconLocation(Blockly.utils.Coordinate.sum(c.location, a));
        }
    };
    Blockly.BlockDragger.prototype.getInsertionMarkers = function() {
        return this.draggedConnectionManager_ && this.draggedConnectionManager_.getInsertionMarkers ? this.draggedConnectionManager_.getInsertionMarkers() : [];
    };
    Blockly.IConnectionChecker = function() {};
    Blockly.ConnectionChecker = function() {};
    Blockly.ConnectionChecker.prototype.canConnect = function(a, b, c, d) {
        return this.canConnectWithReason(a, b, c, d) == Blockly.Connection.CAN_CONNECT;
    };
    Blockly.ConnectionChecker.prototype.canConnectWithReason = function(a, b, c, d) {
        var e = this.doSafetyChecks(a, b);
        return e != Blockly.Connection.CAN_CONNECT ? e : this.doTypeChecks(a, b) ? c && !this.doDragChecks(a, b, d || 0) ? Blockly.Connection.REASON_DRAG_CHECKS_FAILED : Blockly.Connection.CAN_CONNECT : Blockly.Connection.REASON_CHECKS_FAILED;
    };
    Blockly.ConnectionChecker.prototype.getErrorMessage = function(a, b, c) {
        switch(a){
            case Blockly.Connection.REASON_SELF_CONNECTION:
                return "Attempted to connect a block to itself.";
            case Blockly.Connection.REASON_DIFFERENT_WORKSPACES:
                return "Blocks not on same workspace.";
            case Blockly.Connection.REASON_WRONG_TYPE:
                return "Attempt to connect incompatible types.";
            case Blockly.Connection.REASON_TARGET_NULL:
                return "Target connection is null.";
            case Blockly.Connection.REASON_CHECKS_FAILED:
                return "Connection checks failed. " + (b + " expected " + b.getCheck() + ", found " + c.getCheck());
            case Blockly.Connection.REASON_SHADOW_PARENT:
                return "Connecting non-shadow to shadow block.";
            case Blockly.Connection.REASON_DRAG_CHECKS_FAILED:
                return "Drag checks failed.";
            default:
                return "Unknown connection failure: this should never happen!";
        }
    };
    Blockly.ConnectionChecker.prototype.doSafetyChecks = function(a, b) {
        if (!a || !b) return Blockly.Connection.REASON_TARGET_NULL;
        if (a.isSuperior()) var c = a.getSourceBlock(), d = b.getSourceBlock();
        else d = a.getSourceBlock(), c = b.getSourceBlock();
        return c == d ? Blockly.Connection.REASON_SELF_CONNECTION : b.type != Blockly.OPPOSITE_TYPE[a.type] ? Blockly.Connection.REASON_WRONG_TYPE : c.workspace !== d.workspace ? Blockly.Connection.REASON_DIFFERENT_WORKSPACES : c.isShadow() && !d.isShadow() ? Blockly.Connection.REASON_SHADOW_PARENT : Blockly.Connection.CAN_CONNECT;
    };
    Blockly.ConnectionChecker.prototype.doTypeChecks = function(a, b) {
        a = a.getCheck();
        b = b.getCheck();
        if (!a || !b) return !0;
        for(var c = 0; c < a.length; c++)if (-1 != b.indexOf(a[c])) return !0;
        return !1;
    };
    Blockly.ConnectionChecker.prototype.doDragChecks = function(a, b, c) {
        if (a.distanceFrom(b) > c || b.getSourceBlock().isInsertionMarker()) return !1;
        switch(b.type){
            case Blockly.connectionTypes.PREVIOUS_STATEMENT:
                return this.canConnectToPrevious_(a, b);
            case Blockly.connectionTypes.OUTPUT_VALUE:
                if (b.isConnected() && !b.targetBlock().isInsertionMarker() || a.isConnected()) return !1;
                break;
            case Blockly.connectionTypes.INPUT_VALUE:
                if (b.isConnected() && !b.targetBlock().isMovable() && !b.targetBlock().isShadow()) return !1;
                break;
            case Blockly.connectionTypes.NEXT_STATEMENT:
                if (b.isConnected() && !a.getSourceBlock().nextConnection && !b.targetBlock().isShadow() && b.targetBlock().nextConnection) return !1;
                break;
            default:
                return !1;
        }
        return -1 != Blockly.draggingConnections.indexOf(b) ? !1 : !0;
    };
    Blockly.ConnectionChecker.prototype.canConnectToPrevious_ = function(a, b) {
        if (a.targetConnection || -1 != Blockly.draggingConnections.indexOf(b)) return !1;
        if (!b.targetConnection) return !0;
        a = b.targetBlock();
        return a.isInsertionMarker() ? !a.getPreviousBlock() : !1;
    };
    Blockly.registry.register(Blockly.registry.Type.CONNECTION_CHECKER, Blockly.registry.DEFAULT, Blockly.ConnectionChecker);
    Blockly.VariableMap = function(a) {
        this.variableMap_ = Object.create(null);
        this.workspace = a;
    };
    Blockly.VariableMap.prototype.clear = function() {
        this.variableMap_ = Object.create(null);
    };
    Blockly.VariableMap.prototype.renameVariable = function(a, b) {
        var c = this.getVariable(b, a.type), d = this.workspace.getAllBlocks(!1);
        Blockly.Events.setGroup(!0);
        try {
            c && c.getId() != a.getId() ? this.renameVariableWithConflict_(a, b, c, d) : this.renameVariableAndUses_(a, b, d);
        } finally{
            Blockly.Events.setGroup(!1);
        }
    };
    Blockly.VariableMap.prototype.renameVariableById = function(a, b) {
        var c = this.getVariableById(a);
        if (!c) throw Error("Tried to rename a variable that didn't exist. ID: " + a);
        this.renameVariable(c, b);
    };
    Blockly.VariableMap.prototype.renameVariableAndUses_ = function(a, b, c) {
        Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.VAR_RENAME))(a, b));
        a.name = b;
        for(b = 0; b < c.length; b++)c[b].updateVarName(a);
    };
    Blockly.VariableMap.prototype.renameVariableWithConflict_ = function(a, b, c, d) {
        var e = a.type;
        b != c.name && this.renameVariableAndUses_(c, b, d);
        for(b = 0; b < d.length; b++)d[b].renameVarById(a.getId(), c.getId());
        Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.VAR_DELETE))(a));
        a = this.getVariablesOfType(e).indexOf(a);
        this.variableMap_[e].splice(a, 1);
    };
    Blockly.VariableMap.prototype.createVariable = function(a, b, c) {
        var d = this.getVariable(a, b);
        if (d) {
            if (c && d.getId() != c) throw Error('Variable "' + a + '" is already in use and its id is "' + d.getId() + '" which conflicts with the passed in id, "' + c + '".');
            return d;
        }
        if (c && this.getVariableById(c)) throw Error('Variable id, "' + c + '", is already in use.');
        d = c || Blockly.utils.genUid();
        b = b || "";
        d = new Blockly.VariableModel(this.workspace, a, b, d);
        a = this.variableMap_[b] || [];
        a.push(d);
        delete this.variableMap_[b];
        this.variableMap_[b] = a;
        return d;
    };
    Blockly.VariableMap.prototype.deleteVariable = function(a) {
        for(var b = this.variableMap_[a.type], c = 0, d; d = b[c]; c++)if (d.getId() == a.getId()) {
            b.splice(c, 1);
            Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.VAR_DELETE))(a));
            break;
        }
    };
    Blockly.VariableMap.prototype.deleteVariableById = function(a) {
        var b = this.getVariableById(a);
        if (b) {
            var c = b.name, d = this.getVariableUsesById(a);
            a = 0;
            for(var e; e = d[a]; a++)if ("procedures_defnoreturn" == e.type || "procedures_defreturn" == e.type) {
                a = e.getFieldValue("NAME");
                c = Blockly.Msg.CANNOT_DELETE_VARIABLE_PROCEDURE.replace("%1", c).replace("%2", a);
                Blockly.alert(c);
                return;
            }
            var f = this;
            1 < d.length ? (c = Blockly.Msg.DELETE_VARIABLE_CONFIRMATION.replace("%1", String(d.length)).replace("%2", c), Blockly.confirm(c, function(g) {
                g && b && f.deleteVariableInternal(b, d);
            })) : f.deleteVariableInternal(b, d);
        } else console.warn("Can't delete non-existent variable: " + a);
    };
    Blockly.VariableMap.prototype.deleteVariableInternal = function(a, b) {
        var c = Blockly.Events.getGroup();
        c || Blockly.Events.setGroup(!0);
        try {
            for(var d = 0; d < b.length; d++)b[d].dispose(!0);
            this.deleteVariable(a);
        } finally{
            c || Blockly.Events.setGroup(!1);
        }
    };
    Blockly.VariableMap.prototype.getVariable = function(a, b) {
        if (b = this.variableMap_[b || ""]) {
            for(var c = 0, d; d = b[c]; c++)if (Blockly.Names.equals(d.name, a)) return d;
        }
        return null;
    };
    Blockly.VariableMap.prototype.getVariableById = function(a) {
        for(var b = Object.keys(this.variableMap_), c = 0; c < b.length; c++)for(var d = b[c], e = 0, f; f = this.variableMap_[d][e]; e++)if (f.getId() == a) return f;
        return null;
    };
    Blockly.VariableMap.prototype.getVariablesOfType = function(a) {
        return (a = this.variableMap_[a || ""]) ? a.slice() : [];
    };
    Blockly.VariableMap.prototype.getVariableTypes = function(a) {
        var b = {};
        Blockly.utils.object.mixin(b, this.variableMap_);
        a && a.getPotentialVariableMap() && Blockly.utils.object.mixin(b, a.getPotentialVariableMap().variableMap_);
        a = Object.keys(b);
        b = !1;
        for(var c = 0; c < a.length; c++)"" == a[c] && (b = !0);
        b || a.push("");
        return a;
    };
    Blockly.VariableMap.prototype.getAllVariables = function() {
        var a = [], b;
        for(b in this.variableMap_)a = a.concat(this.variableMap_[b]);
        return a;
    };
    Blockly.VariableMap.prototype.getAllVariableNames = function() {
        var a = [], b;
        for(b in this.variableMap_)for(var c = this.variableMap_[b], d = 0, e; e = c[d]; d++)a.push(e.name);
        return a;
    };
    Blockly.VariableMap.prototype.getVariableUsesById = function(a) {
        for(var b = [], c = this.workspace.getAllBlocks(!1), d = 0; d < c.length; d++){
            var e = c[d].getVarModels();
            if (e) for(var f = 0; f < e.length; f++)e[f].getId() == a && b.push(c[d]);
        }
        return b;
    };
    Blockly.Workspace = function(a) {
        this.id = Blockly.utils.genUid();
        Blockly.Workspace.WorkspaceDB_[this.id] = this;
        this.options = a || new Blockly.Options({});
        this.RTL = !!this.options.RTL;
        this.horizontalLayout = !!this.options.horizontalLayout;
        this.toolboxPosition = this.options.toolboxPosition;
        this.connectionChecker = new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.CONNECTION_CHECKER, this.options, !0))(this);
        this.topBlocks_ = [];
        this.topComments_ = [];
        this.commentDB_ = Object.create(null);
        this.listeners_ = [];
        this.undoStack_ = [];
        this.redoStack_ = [];
        this.blockDB_ = Object.create(null);
        this.typedBlocksDB_ = Object.create(null);
        this.variableMap_ = new Blockly.VariableMap(this);
        this.potentialVariableMap_ = null;
    };
    Blockly.Workspace.prototype.rendered = !1;
    Blockly.Workspace.prototype.isClearing = !1;
    Blockly.Workspace.prototype.MAX_UNDO = 1024;
    Blockly.Workspace.prototype.connectionDBList = null;
    Blockly.Workspace.prototype.dispose = function() {
        this.listeners_.length = 0;
        this.clear();
        delete Blockly.Workspace.WorkspaceDB_[this.id];
    };
    Blockly.Workspace.SCAN_ANGLE = 3;
    Blockly.Workspace.prototype.sortObjects_ = function(a, b) {
        a = a.getRelativeToSurfaceXY();
        b = b.getRelativeToSurfaceXY();
        return a.y + Blockly.Workspace.prototype.sortObjects_.offset * a.x - (b.y + Blockly.Workspace.prototype.sortObjects_.offset * b.x);
    };
    Blockly.Workspace.prototype.addTopBlock = function(a) {
        this.topBlocks_.push(a);
    };
    Blockly.Workspace.prototype.removeTopBlock = function(a) {
        if (!Blockly.utils.arrayRemove(this.topBlocks_, a)) throw Error("Block not present in workspace's list of top-most blocks.");
    };
    Blockly.Workspace.prototype.getTopBlocks = function(a) {
        var b = [].concat(this.topBlocks_);
        a && 1 < b.length && (this.sortObjects_.offset = Math.sin(Blockly.utils.math.toRadians(Blockly.Workspace.SCAN_ANGLE)), this.RTL && (this.sortObjects_.offset *= -1), b.sort(this.sortObjects_));
        return b;
    };
    Blockly.Workspace.prototype.addTypedBlock = function(a) {
        this.typedBlocksDB_[a.type] || (this.typedBlocksDB_[a.type] = []);
        this.typedBlocksDB_[a.type].push(a);
    };
    Blockly.Workspace.prototype.removeTypedBlock = function(a) {
        this.typedBlocksDB_[a.type].splice(this.typedBlocksDB_[a.type].indexOf(a), 1);
        this.typedBlocksDB_[a.type].length || delete this.typedBlocksDB_[a.type];
    };
    Blockly.Workspace.prototype.getBlocksByType = function(a, b) {
        if (!this.typedBlocksDB_[a]) return [];
        a = this.typedBlocksDB_[a].slice(0);
        b && 1 < a.length && (this.sortObjects_.offset = Math.sin(Blockly.utils.math.toRadians(Blockly.Workspace.SCAN_ANGLE)), this.RTL && (this.sortObjects_.offset *= -1), a.sort(this.sortObjects_));
        return a;
    };
    Blockly.Workspace.prototype.addTopComment = function(a) {
        this.topComments_.push(a);
        this.commentDB_[a.id] && console.warn('Overriding an existing comment on this workspace, with id "' + a.id + '"');
        this.commentDB_[a.id] = a;
    };
    Blockly.Workspace.prototype.removeTopComment = function(a) {
        if (!Blockly.utils.arrayRemove(this.topComments_, a)) throw Error("Comment not present in workspace's list of top-most comments.");
        delete this.commentDB_[a.id];
    };
    Blockly.Workspace.prototype.getTopComments = function(a) {
        var b = [].concat(this.topComments_);
        a && 1 < b.length && (this.sortObjects_.offset = Math.sin(Blockly.utils.math.toRadians(Blockly.Workspace.SCAN_ANGLE)), this.RTL && (this.sortObjects_.offset *= -1), b.sort(this.sortObjects_));
        return b;
    };
    Blockly.Workspace.prototype.getAllBlocks = function(a) {
        if (a) {
            a = this.getTopBlocks(!0);
            for(var b = [], c = 0; c < a.length; c++)b.push.apply(b, a[c].getDescendants(!0));
        } else for(b = this.getTopBlocks(!1), c = 0; c < b.length; c++)b.push.apply(b, b[c].getChildren(!1));
        return b.filter(function(d) {
            return !d.isInsertionMarker();
        });
    };
    Blockly.Workspace.prototype.clear = function() {
        this.isClearing = !0;
        try {
            var a = Blockly.Events.getGroup();
            for(a || Blockly.Events.setGroup(!0); this.topBlocks_.length;)this.topBlocks_[0].dispose(!1);
            for(; this.topComments_.length;)this.topComments_[this.topComments_.length - 1].dispose(!1);
            a || Blockly.Events.setGroup(!1);
            this.variableMap_.clear();
            this.potentialVariableMap_ && this.potentialVariableMap_.clear();
        } finally{
            this.isClearing = !1;
        }
    };
    Blockly.Workspace.prototype.renameVariableById = function(a, b) {
        this.variableMap_.renameVariableById(a, b);
    };
    Blockly.Workspace.prototype.createVariable = function(a, b, c) {
        return this.variableMap_.createVariable(a, b, c);
    };
    Blockly.Workspace.prototype.getVariableUsesById = function(a) {
        return this.variableMap_.getVariableUsesById(a);
    };
    Blockly.Workspace.prototype.deleteVariableById = function(a) {
        this.variableMap_.deleteVariableById(a);
    };
    Blockly.Workspace.prototype.getVariable = function(a, b) {
        return this.variableMap_.getVariable(a, b);
    };
    Blockly.Workspace.prototype.getVariableById = function(a) {
        return this.variableMap_.getVariableById(a);
    };
    Blockly.Workspace.prototype.getVariablesOfType = function(a) {
        return this.variableMap_.getVariablesOfType(a);
    };
    Blockly.Workspace.prototype.getVariableTypes = function() {
        return this.variableMap_.getVariableTypes(this);
    };
    Blockly.Workspace.prototype.getAllVariables = function() {
        return this.variableMap_.getAllVariables();
    };
    Blockly.Workspace.prototype.getAllVariableNames = function() {
        return this.variableMap_.getAllVariableNames();
    };
    Blockly.Workspace.prototype.getWidth = function() {
        return 0;
    };
    Blockly.Workspace.prototype.newBlock = function(a, b) {
        return new Blockly.Block(this, a, b);
    };
    Blockly.Workspace.prototype.remainingCapacity = function() {
        return isNaN(this.options.maxBlocks) ? Infinity : this.options.maxBlocks - this.getAllBlocks(!1).length;
    };
    Blockly.Workspace.prototype.remainingCapacityOfType = function(a) {
        return this.options.maxInstances ? (void 0 !== this.options.maxInstances[a] ? this.options.maxInstances[a] : Infinity) - this.getBlocksByType(a, !1).length : Infinity;
    };
    Blockly.Workspace.prototype.isCapacityAvailable = function(a) {
        if (!this.hasBlockLimits()) return !0;
        var b = 0, c;
        for(c in a){
            if (a[c] > this.remainingCapacityOfType(c)) return !1;
            b += a[c];
        }
        return b > this.remainingCapacity() ? !1 : !0;
    };
    Blockly.Workspace.prototype.hasBlockLimits = function() {
        return Infinity != this.options.maxBlocks || !!this.options.maxInstances;
    };
    Blockly.Workspace.prototype.getUndoStack = function() {
        return this.undoStack_;
    };
    Blockly.Workspace.prototype.getRedoStack = function() {
        return this.redoStack_;
    };
    Blockly.Workspace.prototype.undo = function(a) {
        var b = a ? this.redoStack_ : this.undoStack_, c = a ? this.undoStack_ : this.redoStack_, d = b.pop();
        if (d) {
            for(var e = [
                d
            ]; b.length && d.group && d.group == b[b.length - 1].group;)e.push(b.pop());
            for(b = 0; d = e[b]; b++)c.push(d);
            e = Blockly.Events.filter(e, a);
            Blockly.Events.recordUndo = !1;
            try {
                for(b = 0; d = e[b]; b++)d.run(a);
            } finally{
                Blockly.Events.recordUndo = !0;
            }
        }
    };
    Blockly.Workspace.prototype.clearUndo = function() {
        this.undoStack_.length = 0;
        this.redoStack_.length = 0;
        Blockly.Events.clearPendingUndo();
    };
    Blockly.Workspace.prototype.addChangeListener = function(a) {
        this.listeners_.push(a);
        return a;
    };
    Blockly.Workspace.prototype.removeChangeListener = function(a) {
        Blockly.utils.arrayRemove(this.listeners_, a);
    };
    Blockly.Workspace.prototype.fireChangeListener = function(a) {
        if (a.recordUndo) for(this.undoStack_.push(a), this.redoStack_.length = 0; this.undoStack_.length > this.MAX_UNDO && 0 <= this.MAX_UNDO;)this.undoStack_.shift();
        for(var b = 0, c; c = this.listeners_[b]; b++)c(a);
    };
    Blockly.Workspace.prototype.getBlockById = function(a) {
        return this.blockDB_[a] || null;
    };
    Blockly.Workspace.prototype.setBlockById = function(a, b) {
        this.blockDB_[a] = b;
    };
    Blockly.Workspace.prototype.removeBlockById = function(a) {
        delete this.blockDB_[a];
    };
    Blockly.Workspace.prototype.getCommentById = function(a) {
        return this.commentDB_[a] || null;
    };
    Blockly.Workspace.prototype.allInputsFilled = function(a) {
        for(var b = this.getTopBlocks(!1), c = 0, d; d = b[c]; c++)if (!d.allInputsFilled(a)) return !1;
        return !0;
    };
    Blockly.Workspace.prototype.getPotentialVariableMap = function() {
        return this.potentialVariableMap_;
    };
    Blockly.Workspace.prototype.createPotentialVariableMap = function() {
        this.potentialVariableMap_ = new Blockly.VariableMap(this);
    };
    Blockly.Workspace.prototype.getVariableMap = function() {
        return this.variableMap_;
    };
    Blockly.Workspace.prototype.setVariableMap = function(a) {
        this.variableMap_ = a;
    };
    Blockly.Workspace.WorkspaceDB_ = Object.create(null);
    Blockly.Workspace.getById = function(a) {
        return Blockly.Workspace.WorkspaceDB_[a] || null;
    };
    Blockly.Workspace.getAll = function() {
        var a = [], b;
        for(b in Blockly.Workspace.WorkspaceDB_)a.push(Blockly.Workspace.WorkspaceDB_[b]);
        return a;
    };
    Blockly.Bubble = function(a, b, c, d, e, f) {
        this.workspace_ = a;
        this.content_ = b;
        this.shape_ = c;
        this.onMouseDownResizeWrapper_ = this.onMouseDownBubbleWrapper_ = this.moveCallback_ = this.resizeCallback_ = null;
        this.disposed = !1;
        c = Blockly.Bubble.ARROW_ANGLE;
        this.workspace_.RTL && (c = -c);
        this.arrow_radians_ = Blockly.utils.math.toRadians(c);
        a.getBubbleCanvas().appendChild(this.createDom_(b, !(!e || !f)));
        this.setAnchorLocation(d);
        e && f || (a = this.content_.getBBox(), e = a.width + 2 * Blockly.Bubble.BORDER_WIDTH, f = a.height + 2 * Blockly.Bubble.BORDER_WIDTH);
        this.setBubbleSize(e, f);
        this.positionBubble_();
        this.renderArrow_();
        this.rendered_ = !0;
    };
    Blockly.Bubble.BORDER_WIDTH = 6;
    Blockly.Bubble.ARROW_THICKNESS = 5;
    Blockly.Bubble.ARROW_ANGLE = 20;
    Blockly.Bubble.ARROW_BEND = 4;
    Blockly.Bubble.ANCHOR_RADIUS = 8;
    Blockly.Bubble.onMouseUpWrapper_ = null;
    Blockly.Bubble.onMouseMoveWrapper_ = null;
    Blockly.Bubble.unbindDragEvents_ = function() {
        Blockly.Bubble.onMouseUpWrapper_ && (Blockly.browserEvents.unbind(Blockly.Bubble.onMouseUpWrapper_), Blockly.Bubble.onMouseUpWrapper_ = null);
        Blockly.Bubble.onMouseMoveWrapper_ && (Blockly.browserEvents.unbind(Blockly.Bubble.onMouseMoveWrapper_), Blockly.Bubble.onMouseMoveWrapper_ = null);
    };
    Blockly.Bubble.bubbleMouseUp_ = function(a) {
        Blockly.Touch.clearTouchIdentifier();
        Blockly.Bubble.unbindDragEvents_();
    };
    Blockly.Bubble.prototype.rendered_ = !1;
    Blockly.Bubble.prototype.anchorXY_ = null;
    Blockly.Bubble.prototype.relativeLeft_ = 0;
    Blockly.Bubble.prototype.relativeTop_ = 0;
    Blockly.Bubble.prototype.width_ = 0;
    Blockly.Bubble.prototype.height_ = 0;
    Blockly.Bubble.prototype.autoLayout_ = !0;
    Blockly.Bubble.prototype.createDom_ = function(a, b) {
        this.bubbleGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, null);
        var c = {
            filter: "url(#" + this.workspace_.getRenderer().getConstants().embossFilterId + ")"
        };
        Blockly.utils.userAgent.JAVA_FX && (c = {});
        c = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, c, this.bubbleGroup_);
        this.bubbleArrow_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {}, c);
        this.bubbleBack_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyDraggable",
            x: 0,
            y: 0,
            rx: Blockly.Bubble.BORDER_WIDTH,
            ry: Blockly.Bubble.BORDER_WIDTH
        }, c);
        b ? (this.resizeGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": this.workspace_.RTL ? "blocklyResizeSW" : "blocklyResizeSE"
        }, this.bubbleGroup_), b = 2 * Blockly.Bubble.BORDER_WIDTH, Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.POLYGON, {
            points: "0,x x,x x,0".replace(/x/g, b.toString())
        }, this.resizeGroup_), Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {
            "class": "blocklyResizeLine",
            x1: b / 3,
            y1: b - 1,
            x2: b - 1,
            y2: b / 3
        }, this.resizeGroup_), Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {
            "class": "blocklyResizeLine",
            x1: 2 * b / 3,
            y1: b - 1,
            x2: b - 1,
            y2: 2 * b / 3
        }, this.resizeGroup_)) : this.resizeGroup_ = null;
        this.workspace_.options.readOnly || (this.onMouseDownBubbleWrapper_ = Blockly.browserEvents.conditionalBind(this.bubbleBack_, "mousedown", this, this.bubbleMouseDown_), this.resizeGroup_ && (this.onMouseDownResizeWrapper_ = Blockly.browserEvents.conditionalBind(this.resizeGroup_, "mousedown", this, this.resizeMouseDown_)));
        this.bubbleGroup_.appendChild(a);
        return this.bubbleGroup_;
    };
    Blockly.Bubble.prototype.getSvgRoot = function() {
        return this.bubbleGroup_;
    };
    Blockly.Bubble.prototype.setSvgId = function(a) {
        this.bubbleGroup_.dataset && (this.bubbleGroup_.dataset.blockId = a);
    };
    Blockly.Bubble.prototype.bubbleMouseDown_ = function(a) {
        var b = this.workspace_.getGesture(a);
        b && b.handleBubbleStart(a, this);
    };
    Blockly.Bubble.prototype.showContextMenu = function(a) {};
    Blockly.Bubble.prototype.isDeletable = function() {
        return !1;
    };
    Blockly.Bubble.prototype.setDeleteStyle = function(a) {};
    Blockly.Bubble.prototype.resizeMouseDown_ = function(a) {
        this.promote();
        Blockly.Bubble.unbindDragEvents_();
        Blockly.utils.isRightButton(a) || (this.workspace_.startDrag(a, new Blockly.utils.Coordinate(this.workspace_.RTL ? -this.width_ : this.width_, this.height_)), Blockly.Bubble.onMouseUpWrapper_ = Blockly.browserEvents.conditionalBind(document, "mouseup", this, Blockly.Bubble.bubbleMouseUp_), Blockly.Bubble.onMouseMoveWrapper_ = Blockly.browserEvents.conditionalBind(document, "mousemove", this, this.resizeMouseMove_), Blockly.hideChaff());
        a.stopPropagation();
    };
    Blockly.Bubble.prototype.resizeMouseMove_ = function(a) {
        this.autoLayout_ = !1;
        a = this.workspace_.moveDrag(a);
        this.setBubbleSize(this.workspace_.RTL ? -a.x : a.x, a.y);
        this.workspace_.RTL && this.positionBubble_();
    };
    Blockly.Bubble.prototype.registerResizeEvent = function(a) {
        this.resizeCallback_ = a;
    };
    Blockly.Bubble.prototype.registerMoveEvent = function(a) {
        this.moveCallback_ = a;
    };
    Blockly.Bubble.prototype.promote = function() {
        var a = this.bubbleGroup_.parentNode;
        return a.lastChild !== this.bubbleGroup_ ? (a.appendChild(this.bubbleGroup_), !0) : !1;
    };
    Blockly.Bubble.prototype.setAnchorLocation = function(a) {
        this.anchorXY_ = a;
        this.rendered_ && this.positionBubble_();
    };
    Blockly.Bubble.prototype.layoutBubble_ = function() {
        var a = this.workspace_.getMetricsManager().getViewMetrics(!0), b = this.getOptimalRelativeLeft_(a), c = this.getOptimalRelativeTop_(a), d = this.shape_.getBBox(), e = {
            x: b,
            y: -this.height_ - this.workspace_.getRenderer().getConstants().MIN_BLOCK_HEIGHT
        }, f = {
            x: -this.width_ - 30,
            y: c
        };
        c = {
            x: d.width,
            y: c
        };
        var g = {
            x: b,
            y: d.height
        };
        b = d.width < d.height ? c : g;
        d = d.width < d.height ? g : c;
        c = this.getOverlap_(e, a);
        g = this.getOverlap_(f, a);
        var h = this.getOverlap_(b, a);
        a = this.getOverlap_(d, a);
        a = Math.max(c, g, h, a);
        c == a ? (this.relativeLeft_ = e.x, this.relativeTop_ = e.y) : g == a ? (this.relativeLeft_ = f.x, this.relativeTop_ = f.y) : h == a ? (this.relativeLeft_ = b.x, this.relativeTop_ = b.y) : (this.relativeLeft_ = d.x, this.relativeTop_ = d.y);
    };
    Blockly.Bubble.prototype.getOverlap_ = function(a, b) {
        var c = this.workspace_.RTL ? this.anchorXY_.x - a.x - this.width_ : a.x + this.anchorXY_.x;
        a = a.y + this.anchorXY_.y;
        return Math.max(0, Math.min(1, (Math.min(c + this.width_, b.left + b.width) - Math.max(c, b.left)) * (Math.min(a + this.height_, b.top + b.height) - Math.max(a, b.top)) / (this.width_ * this.height_)));
    };
    Blockly.Bubble.prototype.getOptimalRelativeLeft_ = function(a) {
        var b = -this.width_ / 4;
        if (this.width_ > a.width) return b;
        if (this.workspace_.RTL) var c = this.anchorXY_.x - b, d = c - this.width_, e = a.left + a.width, f = a.left + Blockly.Scrollbar.scrollbarThickness / this.workspace_.scale;
        else d = b + this.anchorXY_.x, c = d + this.width_, f = a.left, e = a.left + a.width - Blockly.Scrollbar.scrollbarThickness / this.workspace_.scale;
        this.workspace_.RTL ? d < f ? b = -(f - this.anchorXY_.x + this.width_) : c > e && (b = -(e - this.anchorXY_.x)) : d < f ? b = f - this.anchorXY_.x : c > e && (b = e - this.anchorXY_.x - this.width_);
        return b;
    };
    Blockly.Bubble.prototype.getOptimalRelativeTop_ = function(a) {
        var b = -this.height_ / 4;
        if (this.height_ > a.height) return b;
        var c = this.anchorXY_.y + b, d = c + this.height_, e = a.top;
        a = a.top + a.height - Blockly.Scrollbar.scrollbarThickness / this.workspace_.scale;
        var f = this.anchorXY_.y;
        c < e ? b = e - f : d > a && (b = a - f - this.height_);
        return b;
    };
    Blockly.Bubble.prototype.positionBubble_ = function() {
        var a = this.anchorXY_.x;
        a = this.workspace_.RTL ? a - (this.relativeLeft_ + this.width_) : a + this.relativeLeft_;
        this.moveTo(a, this.relativeTop_ + this.anchorXY_.y);
    };
    Blockly.Bubble.prototype.moveTo = function(a, b) {
        this.bubbleGroup_.setAttribute("transform", "translate(" + a + "," + b + ")");
    };
    Blockly.Bubble.prototype.setDragging = function(a) {
        !a && this.moveCallback_ && this.moveCallback_();
    };
    Blockly.Bubble.prototype.getBubbleSize = function() {
        return new Blockly.utils.Size(this.width_, this.height_);
    };
    Blockly.Bubble.prototype.setBubbleSize = function(a, b) {
        var c = 2 * Blockly.Bubble.BORDER_WIDTH;
        a = Math.max(a, c + 45);
        b = Math.max(b, c + 20);
        this.width_ = a;
        this.height_ = b;
        this.bubbleBack_.setAttribute("width", a);
        this.bubbleBack_.setAttribute("height", b);
        this.resizeGroup_ && (this.workspace_.RTL ? this.resizeGroup_.setAttribute("transform", "translate(" + 2 * Blockly.Bubble.BORDER_WIDTH + "," + (b - c) + ") scale(-1 1)") : this.resizeGroup_.setAttribute("transform", "translate(" + (a - c) + "," + (b - c) + ")"));
        this.autoLayout_ && this.layoutBubble_();
        this.positionBubble_();
        this.renderArrow_();
        this.resizeCallback_ && this.resizeCallback_();
    };
    Blockly.Bubble.prototype.renderArrow_ = function() {
        var a = [], b = this.width_ / 2, c = this.height_ / 2, d = -this.relativeLeft_, e = -this.relativeTop_;
        if (b == d && c == e) a.push("M " + b + "," + c);
        else {
            e -= c;
            d -= b;
            this.workspace_.RTL && (d *= -1);
            var f = Math.sqrt(e * e + d * d), g = Math.acos(d / f);
            0 > e && (g = 2 * Math.PI - g);
            var h = g + Math.PI / 2;
            h > 2 * Math.PI && (h -= 2 * Math.PI);
            var k = Math.sin(h), l = Math.cos(h), m = this.getBubbleSize();
            h = (m.width + m.height) / Blockly.Bubble.ARROW_THICKNESS;
            h = Math.min(h, m.width, m.height) / 4;
            m = 1 - Blockly.Bubble.ANCHOR_RADIUS / f;
            d = b + m * d;
            e = c + m * e;
            m = b + h * l;
            var n = c + h * k;
            b -= h * l;
            c -= h * k;
            k = g + this.arrow_radians_;
            k > 2 * Math.PI && (k -= 2 * Math.PI);
            g = Math.sin(k) * f / Blockly.Bubble.ARROW_BEND;
            f = Math.cos(k) * f / Blockly.Bubble.ARROW_BEND;
            a.push("M" + m + "," + n);
            a.push("C" + (m + f) + "," + (n + g) + " " + d + "," + e + " " + d + "," + e);
            a.push("C" + d + "," + e + " " + (b + f) + "," + (c + g) + " " + b + "," + c);
        }
        a.push("z");
        this.bubbleArrow_.setAttribute("d", a.join(" "));
    };
    Blockly.Bubble.prototype.setColour = function(a) {
        this.bubbleBack_.setAttribute("fill", a);
        this.bubbleArrow_.setAttribute("fill", a);
    };
    Blockly.Bubble.prototype.dispose = function() {
        this.onMouseDownBubbleWrapper_ && Blockly.browserEvents.unbind(this.onMouseDownBubbleWrapper_);
        this.onMouseDownResizeWrapper_ && Blockly.browserEvents.unbind(this.onMouseDownResizeWrapper_);
        Blockly.Bubble.unbindDragEvents_();
        Blockly.utils.dom.removeNode(this.bubbleGroup_);
        this.disposed = !0;
    };
    Blockly.Bubble.prototype.moveDuringDrag = function(a, b) {
        a ? a.translateSurface(b.x, b.y) : this.moveTo(b.x, b.y);
        this.relativeLeft_ = this.workspace_.RTL ? this.anchorXY_.x - b.x - this.width_ : b.x - this.anchorXY_.x;
        this.relativeTop_ = b.y - this.anchorXY_.y;
        this.renderArrow_();
    };
    Blockly.Bubble.prototype.getRelativeToSurfaceXY = function() {
        return new Blockly.utils.Coordinate(this.workspace_.RTL ? -this.relativeLeft_ + this.anchorXY_.x - this.width_ : this.anchorXY_.x + this.relativeLeft_, this.anchorXY_.y + this.relativeTop_);
    };
    Blockly.Bubble.prototype.setAutoLayout = function(a) {
        this.autoLayout_ = a;
    };
    Blockly.Bubble.textToDom = function(a) {
        var b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TEXT, {
            "class": "blocklyText blocklyBubbleText blocklyNoPointerEvents",
            y: Blockly.Bubble.BORDER_WIDTH
        }, null);
        a = a.split("\n");
        for(var c = 0; c < a.length; c++){
            var d = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TSPAN, {
                dy: "1em",
                x: Blockly.Bubble.BORDER_WIDTH
            }, b), e = document.createTextNode(a[c]);
            d.appendChild(e);
        }
        return b;
    };
    Blockly.Bubble.createNonEditableBubble = function(a, b, c) {
        c = new Blockly.Bubble(b.workspace, a, b.pathObject.svgPath, c, null, null);
        c.setSvgId(b.id);
        if (b.RTL) {
            b = a.getBBox().width;
            for(var d = 0, e; e = a.childNodes[d]; d++)e.setAttribute("text-anchor", "end"), e.setAttribute("x", b + Blockly.Bubble.BORDER_WIDTH);
        }
        return c;
    };
    Blockly.Events.CommentBase = function(a) {
        this.commentId = (this.isBlank = "undefined" == typeof a) ? "" : a.id;
        this.workspaceId = this.isBlank ? "" : a.workspace.id;
        this.group = Blockly.Events.getGroup();
        this.recordUndo = Blockly.Events.recordUndo;
    };
    Blockly.utils.object.inherits(Blockly.Events.CommentBase, Blockly.Events.Abstract);
    Blockly.Events.CommentBase.prototype.toJson = function() {
        var a = Blockly.Events.CommentBase.superClass_.toJson.call(this);
        this.commentId && (a.commentId = this.commentId);
        return a;
    };
    Blockly.Events.CommentBase.prototype.fromJson = function(a) {
        Blockly.Events.CommentBase.superClass_.fromJson.call(this, a);
        this.commentId = a.commentId;
    };
    Blockly.Events.CommentChange = function(a, b, c) {
        Blockly.Events.CommentChange.superClass_.constructor.call(this, a);
        a && (this.oldContents_ = "undefined" == typeof b ? "" : b, this.newContents_ = "undefined" == typeof c ? "" : c);
    };
    Blockly.utils.object.inherits(Blockly.Events.CommentChange, Blockly.Events.CommentBase);
    Blockly.Events.CommentChange.prototype.type = Blockly.Events.COMMENT_CHANGE;
    Blockly.Events.CommentChange.prototype.toJson = function() {
        var a = Blockly.Events.CommentChange.superClass_.toJson.call(this);
        a.oldContents = this.oldContents_;
        a.newContents = this.newContents_;
        return a;
    };
    Blockly.Events.CommentChange.prototype.fromJson = function(a) {
        Blockly.Events.CommentChange.superClass_.fromJson.call(this, a);
        this.oldContents_ = a.oldContents;
        this.newContents_ = a.newContents;
    };
    Blockly.Events.CommentChange.prototype.isNull = function() {
        return this.oldContents_ == this.newContents_;
    };
    Blockly.Events.CommentChange.prototype.run = function(a) {
        var b = this.getEventWorkspace_().getCommentById(this.commentId);
        b ? b.setContent(a ? this.newContents_ : this.oldContents_) : console.warn("Can't change non-existent comment: " + this.commentId);
    };
    Blockly.Events.CommentCreate = function(a) {
        Blockly.Events.CommentCreate.superClass_.constructor.call(this, a);
        a && (this.xml = a.toXmlWithXY());
    };
    Blockly.utils.object.inherits(Blockly.Events.CommentCreate, Blockly.Events.CommentBase);
    Blockly.Events.CommentCreate.prototype.type = Blockly.Events.COMMENT_CREATE;
    Blockly.Events.CommentCreate.prototype.toJson = function() {
        var a = Blockly.Events.CommentCreate.superClass_.toJson.call(this);
        a.xml = Blockly.Xml.domToText(this.xml);
        return a;
    };
    Blockly.Events.CommentCreate.prototype.fromJson = function(a) {
        Blockly.Events.CommentCreate.superClass_.fromJson.call(this, a);
        this.xml = Blockly.Xml.textToDom(a.xml);
    };
    Blockly.Events.CommentCreate.prototype.run = function(a) {
        Blockly.Events.CommentCreateDeleteHelper(this, a);
    };
    Blockly.Events.CommentCreateDeleteHelper = function(a, b) {
        var c = a.getEventWorkspace_();
        b ? (b = Blockly.utils.xml.createElement("xml"), b.appendChild(a.xml), Blockly.Xml.domToWorkspace(b, c)) : (c = c.getCommentById(a.commentId)) ? c.dispose(!1, !1) : console.warn("Can't uncreate non-existent comment: " + a.commentId);
    };
    Blockly.Events.CommentDelete = function(a) {
        Blockly.Events.CommentDelete.superClass_.constructor.call(this, a);
        a && (this.xml = a.toXmlWithXY());
    };
    Blockly.utils.object.inherits(Blockly.Events.CommentDelete, Blockly.Events.CommentBase);
    Blockly.Events.CommentDelete.prototype.type = Blockly.Events.COMMENT_DELETE;
    Blockly.Events.CommentDelete.prototype.toJson = function() {
        return Blockly.Events.CommentDelete.superClass_.toJson.call(this);
    };
    Blockly.Events.CommentDelete.prototype.fromJson = function(a) {
        Blockly.Events.CommentDelete.superClass_.fromJson.call(this, a);
    };
    Blockly.Events.CommentDelete.prototype.run = function(a) {
        Blockly.Events.CommentCreateDeleteHelper(this, !a);
    };
    Blockly.Events.CommentMove = function(a) {
        Blockly.Events.CommentMove.superClass_.constructor.call(this, a);
        a && (this.comment_ = a, this.oldCoordinate_ = a.getXY(), this.newCoordinate_ = null);
    };
    Blockly.utils.object.inherits(Blockly.Events.CommentMove, Blockly.Events.CommentBase);
    Blockly.Events.CommentMove.prototype.recordNew = function() {
        if (!this.comment_) throw Error("Tried to record the new position of a comment on the same event twice.");
        this.newCoordinate_ = this.comment_.getXY();
        this.comment_ = null;
    };
    Blockly.Events.CommentMove.prototype.type = Blockly.Events.COMMENT_MOVE;
    Blockly.Events.CommentMove.prototype.setOldCoordinate = function(a) {
        this.oldCoordinate_ = a;
    };
    Blockly.Events.CommentMove.prototype.toJson = function() {
        var a = Blockly.Events.CommentMove.superClass_.toJson.call(this);
        this.oldCoordinate_ && (a.oldCoordinate = Math.round(this.oldCoordinate_.x) + "," + Math.round(this.oldCoordinate_.y));
        this.newCoordinate_ && (a.newCoordinate = Math.round(this.newCoordinate_.x) + "," + Math.round(this.newCoordinate_.y));
        return a;
    };
    Blockly.Events.CommentMove.prototype.fromJson = function(a) {
        Blockly.Events.CommentMove.superClass_.fromJson.call(this, a);
        if (a.oldCoordinate) {
            var b = a.oldCoordinate.split(",");
            this.oldCoordinate_ = new Blockly.utils.Coordinate(Number(b[0]), Number(b[1]));
        }
        a.newCoordinate && (b = a.newCoordinate.split(","), this.newCoordinate_ = new Blockly.utils.Coordinate(Number(b[0]), Number(b[1])));
    };
    Blockly.Events.CommentMove.prototype.isNull = function() {
        return Blockly.utils.Coordinate.equals(this.oldCoordinate_, this.newCoordinate_);
    };
    Blockly.Events.CommentMove.prototype.run = function(a) {
        var b = this.getEventWorkspace_().getCommentById(this.commentId);
        if (b) {
            a = a ? this.newCoordinate_ : this.oldCoordinate_;
            var c = b.getXY();
            b.moveBy(a.x - c.x, a.y - c.y);
        } else console.warn("Can't move non-existent comment: " + this.commentId);
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.COMMENT_CREATE, Blockly.Events.CommentCreate);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.COMMENT_CHANGE, Blockly.Events.CommentChange);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.COMMENT_MOVE, Blockly.Events.CommentMove);
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.COMMENT_DELETE, Blockly.Events.CommentDelete);
    Blockly.BubbleDragger = function(a, b) {
        this.draggingBubble_ = a;
        this.workspace_ = b;
        this.deleteArea_ = null;
        this.wouldDeleteBubble_ = !1;
        this.startXY_ = this.draggingBubble_.getRelativeToSurfaceXY();
        this.dragSurface_ = Blockly.utils.is3dSupported() && b.getBlockDragSurface() ? b.getBlockDragSurface() : null;
    };
    Blockly.BubbleDragger.prototype.dispose = function() {
        this.dragSurface_ = this.workspace_ = this.draggingBubble_ = null;
    };
    Blockly.BubbleDragger.prototype.startBubbleDrag = function() {
        Blockly.Events.getGroup() || Blockly.Events.setGroup(!0);
        this.workspace_.setResizesEnabled(!1);
        this.draggingBubble_.setAutoLayout(!1);
        this.dragSurface_ && this.moveToDragSurface_();
        this.draggingBubble_.setDragging && this.draggingBubble_.setDragging(!0);
        var a = this.workspace_.getToolbox();
        if (a && "function" == typeof a.addStyle) {
            var b = this.draggingBubble_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
            a.addStyle(b);
        }
    };
    Blockly.BubbleDragger.prototype.dragBubble = function(a, b) {
        b = this.pixelsToWorkspaceUnits_(b);
        b = Blockly.utils.Coordinate.sum(this.startXY_, b);
        this.draggingBubble_.moveDuringDrag(this.dragSurface_, b);
        this.draggingBubble_.isDeletable() && (this.deleteArea_ = this.workspace_.isDeleteArea(a), this.updateCursorDuringBubbleDrag_());
    };
    Blockly.BubbleDragger.prototype.maybeDeleteBubble_ = function() {
        var a = this.workspace_.trashcan;
        this.wouldDeleteBubble_ ? (a && setTimeout(a.closeLid.bind(a), 100), this.fireMoveEvent_(), this.draggingBubble_.dispose(!1, !0)) : a && a.closeLid();
        return this.wouldDeleteBubble_;
    };
    Blockly.BubbleDragger.prototype.updateCursorDuringBubbleDrag_ = function() {
        this.wouldDeleteBubble_ = this.deleteArea_ != Blockly.DELETE_AREA_NONE;
        var a = this.workspace_.trashcan;
        this.wouldDeleteBubble_ ? (this.draggingBubble_.setDeleteStyle(!0), this.deleteArea_ == Blockly.DELETE_AREA_TRASH && a && a.setLidOpen(!0)) : (this.draggingBubble_.setDeleteStyle(!1), a && a.setLidOpen(!1));
    };
    Blockly.BubbleDragger.prototype.endBubbleDrag = function(a, b) {
        this.dragBubble(a, b);
        a = this.pixelsToWorkspaceUnits_(b);
        a = Blockly.utils.Coordinate.sum(this.startXY_, a);
        this.draggingBubble_.moveTo(a.x, a.y);
        this.maybeDeleteBubble_() || (this.dragSurface_ && this.dragSurface_.clearAndHide(this.workspace_.getBubbleCanvas()), this.draggingBubble_.setDragging && this.draggingBubble_.setDragging(!1), this.fireMoveEvent_());
        this.workspace_.setResizesEnabled(!0);
        (a = this.workspace_.getToolbox()) && "function" == typeof a.removeStyle && (b = this.draggingBubble_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab", a.removeStyle(b));
        Blockly.Events.setGroup(!1);
    };
    Blockly.BubbleDragger.prototype.fireMoveEvent_ = function() {
        if (this.draggingBubble_.isComment) {
            var a = new (Blockly.Events.get(Blockly.Events.COMMENT_MOVE))(this.draggingBubble_);
            a.setOldCoordinate(this.startXY_);
            a.recordNew();
            Blockly.Events.fire(a);
        }
    };
    Blockly.BubbleDragger.prototype.pixelsToWorkspaceUnits_ = function(a) {
        a = new Blockly.utils.Coordinate(a.x / this.workspace_.scale, a.y / this.workspace_.scale);
        this.workspace_.isMutator && a.scale(1 / this.workspace_.options.parentWorkspace.scale);
        return a;
    };
    Blockly.BubbleDragger.prototype.moveToDragSurface_ = function() {
        this.draggingBubble_.moveTo(0, 0);
        this.dragSurface_.translateSurface(this.startXY_.x, this.startXY_.y);
        this.dragSurface_.setBlocksAndShow(this.draggingBubble_.getSvgRoot());
    };
    Blockly.Events.Click = function(a, b, c) {
        Blockly.Events.Click.superClass_.constructor.call(this, a ? a.workspace.id : b);
        this.blockId = a ? a.id : null;
        this.targetType = c;
    };
    Blockly.utils.object.inherits(Blockly.Events.Click, Blockly.Events.UiBase);
    Blockly.Events.Click.prototype.type = Blockly.Events.CLICK;
    Blockly.Events.Click.prototype.toJson = function() {
        var a = Blockly.Events.Click.superClass_.toJson.call(this);
        a.targetType = this.targetType;
        this.blockId && (a.blockId = this.blockId);
        return a;
    };
    Blockly.Events.Click.prototype.fromJson = function(a) {
        Blockly.Events.Click.superClass_.fromJson.call(this, a);
        this.targetType = a.targetType;
        this.blockId = a.blockId;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.CLICK, Blockly.Events.Click);
    Blockly.WorkspaceDragger = function(a) {
        this.workspace_ = a;
        this.horizontalScrollEnabled_ = this.workspace_.isMovableHorizontally();
        this.verticalScrollEnabled_ = this.workspace_.isMovableVertically();
        this.startScrollXY_ = new Blockly.utils.Coordinate(a.scrollX, a.scrollY);
    };
    Blockly.WorkspaceDragger.prototype.dispose = function() {
        this.workspace_ = null;
    };
    Blockly.WorkspaceDragger.prototype.startDrag = function() {
        Blockly.selected && Blockly.selected.unselect();
        this.workspace_.setupDragSurface();
    };
    Blockly.WorkspaceDragger.prototype.endDrag = function(a) {
        this.drag(a);
        this.workspace_.resetDragSurface();
    };
    Blockly.WorkspaceDragger.prototype.drag = function(a) {
        a = Blockly.utils.Coordinate.sum(this.startScrollXY_, a);
        if (this.horizontalScrollEnabled_ && this.verticalScrollEnabled_) this.workspace_.scroll(a.x, a.y);
        else if (this.horizontalScrollEnabled_) this.workspace_.scroll(a.x, this.workspace_.scrollY);
        else if (this.verticalScrollEnabled_) this.workspace_.scroll(this.workspace_.scrollX, a.y);
        else throw new TypeError("Invalid state.");
    };
    Blockly.Gesture = function(a, b) {
        this.mouseDownXY_ = null;
        this.currentDragDeltaXY_ = new Blockly.utils.Coordinate(0, 0);
        this.startWorkspace_ = this.targetBlock_ = this.startBlock_ = this.startField_ = this.startBubble_ = null;
        this.creatorWorkspace_ = b;
        this.isDraggingBubble_ = this.isDraggingBlock_ = this.isDraggingWorkspace_ = this.hasExceededDragRadius_ = !1;
        this.mostRecentEvent_ = a;
        this.flyout_ = this.workspaceDragger_ = this.blockDragger_ = this.bubbleDragger_ = this.onUpWrapper_ = this.onMoveWrapper_ = null;
        this.isEnding_ = this.hasStarted_ = this.calledUpdateIsDragging_ = !1;
        this.healStack_ = !Blockly.DRAG_STACK;
    };
    Blockly.Gesture.prototype.dispose = function() {
        Blockly.Touch.clearTouchIdentifier();
        Blockly.Tooltip.unblock();
        this.creatorWorkspace_.clearGesture();
        this.onMoveWrapper_ && Blockly.browserEvents.unbind(this.onMoveWrapper_);
        this.onUpWrapper_ && Blockly.browserEvents.unbind(this.onUpWrapper_);
        this.blockDragger_ && this.blockDragger_.dispose();
        this.workspaceDragger_ && this.workspaceDragger_.dispose();
        this.bubbleDragger_ && this.bubbleDragger_.dispose();
    };
    Blockly.Gesture.prototype.updateFromEvent_ = function(a) {
        var b = new Blockly.utils.Coordinate(a.clientX, a.clientY);
        this.updateDragDelta_(b) && (this.updateIsDragging_(), Blockly.longStop_());
        this.mostRecentEvent_ = a;
    };
    Blockly.Gesture.prototype.updateDragDelta_ = function(a) {
        this.currentDragDeltaXY_ = Blockly.utils.Coordinate.difference(a, this.mouseDownXY_);
        return this.hasExceededDragRadius_ ? !1 : this.hasExceededDragRadius_ = Blockly.utils.Coordinate.magnitude(this.currentDragDeltaXY_) > (this.flyout_ ? Blockly.FLYOUT_DRAG_RADIUS : Blockly.DRAG_RADIUS);
    };
    Blockly.Gesture.prototype.updateIsDraggingFromFlyout_ = function() {
        return this.targetBlock_ && this.flyout_.isBlockCreatable_(this.targetBlock_) ? !this.flyout_.isScrollable() || this.flyout_.isDragTowardWorkspace(this.currentDragDeltaXY_) ? (this.startWorkspace_ = this.flyout_.targetWorkspace, this.startWorkspace_.updateScreenCalculationsIfScrolled(), Blockly.Events.getGroup() || Blockly.Events.setGroup(!0), this.startBlock_ = null, this.targetBlock_ = this.flyout_.createBlock(this.targetBlock_), this.targetBlock_.select(), !0) : !1 : !1;
    };
    Blockly.Gesture.prototype.updateIsDraggingBubble_ = function() {
        if (!this.startBubble_) return !1;
        this.isDraggingBubble_ = !0;
        this.startDraggingBubble_();
        return !0;
    };
    Blockly.Gesture.prototype.updateIsDraggingBlock_ = function() {
        if (!this.targetBlock_) return !1;
        this.flyout_ ? this.isDraggingBlock_ = this.updateIsDraggingFromFlyout_() : this.targetBlock_.isMovable() && (this.isDraggingBlock_ = !0);
        return this.isDraggingBlock_ ? (this.startDraggingBlock_(), !0) : !1;
    };
    Blockly.Gesture.prototype.updateIsDraggingWorkspace_ = function() {
        if (this.flyout_ ? this.flyout_.isScrollable() : this.startWorkspace_ && this.startWorkspace_.isDraggable()) this.workspaceDragger_ = new Blockly.WorkspaceDragger(this.startWorkspace_), this.isDraggingWorkspace_ = !0, this.workspaceDragger_.startDrag();
    };
    Blockly.Gesture.prototype.updateIsDragging_ = function() {
        if (this.calledUpdateIsDragging_) throw Error("updateIsDragging_ should only be called once per gesture.");
        this.calledUpdateIsDragging_ = !0;
        this.updateIsDraggingBubble_() || this.updateIsDraggingBlock_() || this.updateIsDraggingWorkspace_();
    };
    Blockly.Gesture.prototype.startDraggingBlock_ = function() {
        this.blockDragger_ = new Blockly.BlockDragger(this.targetBlock_, this.startWorkspace_);
        this.blockDragger_.startBlockDrag(this.currentDragDeltaXY_, this.healStack_);
        this.blockDragger_.dragBlock(this.mostRecentEvent_, this.currentDragDeltaXY_);
    };
    Blockly.Gesture.prototype.startDraggingBubble_ = function() {
        this.bubbleDragger_ = new Blockly.BubbleDragger(this.startBubble_, this.startWorkspace_);
        this.bubbleDragger_.startBubbleDrag();
        this.bubbleDragger_.dragBubble(this.mostRecentEvent_, this.currentDragDeltaXY_);
    };
    Blockly.Gesture.prototype.doStart = function(a) {
        Blockly.utils.isTargetInput(a) ? this.cancel() : (this.hasStarted_ = !0, Blockly.blockAnimations.disconnectUiStop(), this.startWorkspace_.updateScreenCalculationsIfScrolled(), this.startWorkspace_.isMutator && this.startWorkspace_.resize(), Blockly.hideChaff(!!this.flyout_), this.startWorkspace_.markFocused(), this.mostRecentEvent_ = a, Blockly.Tooltip.block(), this.targetBlock_ && this.targetBlock_.select(), Blockly.utils.isRightButton(a) ? this.handleRightClick(a) : ("touchstart" != a.type.toLowerCase() && "pointerdown" != a.type.toLowerCase() || "mouse" == a.pointerType || Blockly.longStart(a, this), this.mouseDownXY_ = new Blockly.utils.Coordinate(a.clientX, a.clientY), this.healStack_ = a.altKey || a.ctrlKey || a.metaKey, this.bindMouseEvents(a)));
    };
    Blockly.Gesture.prototype.bindMouseEvents = function(a) {
        this.onMoveWrapper_ = Blockly.browserEvents.conditionalBind(document, "mousemove", null, this.handleMove.bind(this));
        this.onUpWrapper_ = Blockly.browserEvents.conditionalBind(document, "mouseup", null, this.handleUp.bind(this));
        a.preventDefault();
        a.stopPropagation();
    };
    Blockly.Gesture.prototype.handleMove = function(a) {
        this.updateFromEvent_(a);
        this.isDraggingWorkspace_ ? this.workspaceDragger_.drag(this.currentDragDeltaXY_) : this.isDraggingBlock_ ? this.blockDragger_.dragBlock(this.mostRecentEvent_, this.currentDragDeltaXY_) : this.isDraggingBubble_ && this.bubbleDragger_.dragBubble(this.mostRecentEvent_, this.currentDragDeltaXY_);
        a.preventDefault();
        a.stopPropagation();
    };
    Blockly.Gesture.prototype.handleUp = function(a) {
        this.updateFromEvent_(a);
        Blockly.longStop_();
        this.isEnding_ ? console.log("Trying to end a gesture recursively.") : (this.isEnding_ = !0, this.isDraggingBubble_ ? this.bubbleDragger_.endBubbleDrag(a, this.currentDragDeltaXY_) : this.isDraggingBlock_ ? this.blockDragger_.endBlockDrag(a, this.currentDragDeltaXY_) : this.isDraggingWorkspace_ ? this.workspaceDragger_.endDrag(this.currentDragDeltaXY_) : this.isBubbleClick_() ? this.doBubbleClick_() : this.isFieldClick_() ? this.doFieldClick_() : this.isBlockClick_() ? this.doBlockClick_() : this.isWorkspaceClick_() && this.doWorkspaceClick_(a), a.preventDefault(), a.stopPropagation(), this.dispose());
    };
    Blockly.Gesture.prototype.cancel = function() {
        this.isEnding_ || (Blockly.longStop_(), this.isDraggingBubble_ ? this.bubbleDragger_.endBubbleDrag(this.mostRecentEvent_, this.currentDragDeltaXY_) : this.isDraggingBlock_ ? this.blockDragger_.endBlockDrag(this.mostRecentEvent_, this.currentDragDeltaXY_) : this.isDraggingWorkspace_ && this.workspaceDragger_.endDrag(this.currentDragDeltaXY_), this.dispose());
    };
    Blockly.Gesture.prototype.handleRightClick = function(a) {
        this.targetBlock_ ? (this.bringBlockToFront_(), Blockly.hideChaff(!!this.flyout_), this.targetBlock_.showContextMenu(a)) : this.startBubble_ ? this.startBubble_.showContextMenu(a) : this.startWorkspace_ && !this.flyout_ && (Blockly.hideChaff(), this.startWorkspace_.showContextMenu(a));
        a.preventDefault();
        a.stopPropagation();
        this.dispose();
    };
    Blockly.Gesture.prototype.handleWsStart = function(a, b) {
        if (this.hasStarted_) throw Error("Tried to call gesture.handleWsStart, but the gesture had already been started.");
        this.setStartWorkspace_(b);
        this.mostRecentEvent_ = a;
        this.doStart(a);
    };
    Blockly.Gesture.prototype.fireWorkspaceClick_ = function(a) {
        Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.CLICK))(null, a.id, "workspace"));
    };
    Blockly.Gesture.prototype.handleFlyoutStart = function(a, b) {
        if (this.hasStarted_) throw Error("Tried to call gesture.handleFlyoutStart, but the gesture had already been started.");
        this.setStartFlyout_(b);
        this.handleWsStart(a, b.getWorkspace());
    };
    Blockly.Gesture.prototype.handleBlockStart = function(a, b) {
        if (this.hasStarted_) throw Error("Tried to call gesture.handleBlockStart, but the gesture had already been started.");
        this.setStartBlock(b);
        this.mostRecentEvent_ = a;
    };
    Blockly.Gesture.prototype.handleBubbleStart = function(a, b) {
        if (this.hasStarted_) throw Error("Tried to call gesture.handleBubbleStart, but the gesture had already been started.");
        this.setStartBubble(b);
        this.mostRecentEvent_ = a;
    };
    Blockly.Gesture.prototype.doBubbleClick_ = function() {
        this.startBubble_.setFocus && this.startBubble_.setFocus();
        this.startBubble_.select && this.startBubble_.select();
    };
    Blockly.Gesture.prototype.doFieldClick_ = function() {
        this.startField_.showEditor(this.mostRecentEvent_);
        this.bringBlockToFront_();
    };
    Blockly.Gesture.prototype.doBlockClick_ = function() {
        if (this.flyout_ && this.flyout_.autoClose) this.targetBlock_.isEnabled() && (Blockly.Events.getGroup() || Blockly.Events.setGroup(!0), this.flyout_.createBlock(this.targetBlock_).scheduleSnapAndBump());
        else {
            var a = new (Blockly.Events.get(Blockly.Events.CLICK))(this.startBlock_, this.startWorkspace_.id, "block");
            Blockly.Events.fire(a);
        }
        this.bringBlockToFront_();
        Blockly.Events.setGroup(!1);
    };
    Blockly.Gesture.prototype.doWorkspaceClick_ = function(a) {
        a = this.creatorWorkspace_;
        Blockly.selected && Blockly.selected.unselect();
        this.fireWorkspaceClick_(this.startWorkspace_ || a);
    };
    Blockly.Gesture.prototype.bringBlockToFront_ = function() {
        this.targetBlock_ && !this.flyout_ && this.targetBlock_.bringToFront();
    };
    Blockly.Gesture.prototype.setStartField = function(a) {
        if (this.hasStarted_) throw Error("Tried to call gesture.setStartField, but the gesture had already been started.");
        this.startField_ || (this.startField_ = a);
    };
    Blockly.Gesture.prototype.setStartBubble = function(a) {
        this.startBubble_ || (this.startBubble_ = a);
    };
    Blockly.Gesture.prototype.setStartBlock = function(a) {
        this.startBlock_ || this.startBubble_ || (this.startBlock_ = a, a.isInFlyout && a != a.getRootBlock() ? this.setTargetBlock_(a.getRootBlock()) : this.setTargetBlock_(a));
    };
    Blockly.Gesture.prototype.setTargetBlock_ = function(a) {
        a.isShadow() ? this.setTargetBlock_(a.getParent()) : this.targetBlock_ = a;
    };
    Blockly.Gesture.prototype.setStartWorkspace_ = function(a) {
        this.startWorkspace_ || (this.startWorkspace_ = a);
    };
    Blockly.Gesture.prototype.setStartFlyout_ = function(a) {
        this.flyout_ || (this.flyout_ = a);
    };
    Blockly.Gesture.prototype.isBubbleClick_ = function() {
        return !!this.startBubble_ && !this.hasExceededDragRadius_;
    };
    Blockly.Gesture.prototype.isBlockClick_ = function() {
        return !!this.startBlock_ && !this.hasExceededDragRadius_ && !this.isFieldClick_();
    };
    Blockly.Gesture.prototype.isFieldClick_ = function() {
        return (this.startField_ ? this.startField_.isClickable() : !1) && !this.hasExceededDragRadius_ && (!this.flyout_ || !this.flyout_.autoClose);
    };
    Blockly.Gesture.prototype.isWorkspaceClick_ = function() {
        return !this.startBlock_ && !this.startBubble_ && !this.startField_ && !this.hasExceededDragRadius_;
    };
    Blockly.Gesture.prototype.isDragging = function() {
        return this.isDraggingWorkspace_ || this.isDraggingBlock_ || this.isDraggingBubble_;
    };
    Blockly.Gesture.prototype.hasStarted = function() {
        return this.hasStarted_;
    };
    Blockly.Gesture.prototype.getInsertionMarkers = function() {
        return this.blockDragger_ ? this.blockDragger_.getInsertionMarkers() : [];
    };
    Blockly.Gesture.inProgress = function() {
        for(var a = Blockly.Workspace.getAll(), b = 0, c; c = a[b]; b++)if (c.currentGesture_) return !0;
        return !1;
    };
    Blockly.Field = function(a, b, c) {
        this.value_ = this.DEFAULT_VALUE;
        this.tooltip_ = this.validator_ = null;
        this.size_ = new Blockly.utils.Size(0, 0);
        this.constants_ = this.mouseDownWrapper_ = this.textContent_ = this.textElement_ = this.borderRect_ = this.fieldGroup_ = this.markerSvg_ = this.cursorSvg_ = null;
        c && this.configure_(c);
        this.setValue(a);
        b && this.setValidator(b);
    };
    Blockly.Field.prototype.DEFAULT_VALUE = null;
    Blockly.Field.prototype.name = void 0;
    Blockly.Field.prototype.disposed = !1;
    Blockly.Field.prototype.maxDisplayLength = 50;
    Blockly.Field.prototype.sourceBlock_ = null;
    Blockly.Field.prototype.isDirty_ = !0;
    Blockly.Field.prototype.visible_ = !0;
    Blockly.Field.prototype.clickTarget_ = null;
    Blockly.Field.NBSP = "\u00a0";
    Blockly.Field.prototype.EDITABLE = !0;
    Blockly.Field.prototype.SERIALIZABLE = !1;
    Blockly.Field.prototype.configure_ = function(a) {
        var b = a.tooltip;
        "string" == typeof b && (b = Blockly.utils.replaceMessageReferences(a.tooltip));
        b && this.setTooltip(b);
    };
    Blockly.Field.prototype.setSourceBlock = function(a) {
        if (this.sourceBlock_) throw Error("Field already bound to a block.");
        this.sourceBlock_ = a;
    };
    Blockly.Field.prototype.getConstants = function() {
        !this.constants_ && this.sourceBlock_ && this.sourceBlock_.workspace && this.sourceBlock_.workspace.rendered && (this.constants_ = this.sourceBlock_.workspace.getRenderer().getConstants());
        return this.constants_;
    };
    Blockly.Field.prototype.getSourceBlock = function() {
        return this.sourceBlock_;
    };
    Blockly.Field.prototype.init = function() {
        this.fieldGroup_ || (this.fieldGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, null), this.isVisible() || (this.fieldGroup_.style.display = "none"), this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_), this.initView(), this.updateEditable(), this.setTooltip(this.tooltip_), this.bindEvents_(), this.initModel());
    };
    Blockly.Field.prototype.initView = function() {
        this.createBorderRect_();
        this.createTextElement_();
    };
    Blockly.Field.prototype.initModel = function() {};
    Blockly.Field.prototype.createBorderRect_ = function() {
        this.borderRect_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            rx: this.getConstants().FIELD_BORDER_RECT_RADIUS,
            ry: this.getConstants().FIELD_BORDER_RECT_RADIUS,
            x: 0,
            y: 0,
            height: this.size_.height,
            width: this.size_.width,
            "class": "blocklyFieldRect"
        }, this.fieldGroup_);
    };
    Blockly.Field.prototype.createTextElement_ = function() {
        this.textElement_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TEXT, {
            "class": "blocklyText"
        }, this.fieldGroup_);
        this.getConstants().FIELD_TEXT_BASELINE_CENTER && this.textElement_.setAttribute("dominant-baseline", "central");
        this.textContent_ = document.createTextNode("");
        this.textElement_.appendChild(this.textContent_);
    };
    Blockly.Field.prototype.bindEvents_ = function() {
        Blockly.Tooltip.bindMouseEvents(this.getClickTarget_());
        this.mouseDownWrapper_ = Blockly.browserEvents.conditionalBind(this.getClickTarget_(), "mousedown", this, this.onMouseDown_);
    };
    Blockly.Field.prototype.fromXml = function(a) {
        this.setValue(a.textContent);
    };
    Blockly.Field.prototype.toXml = function(a) {
        a.textContent = this.getValue();
        return a;
    };
    Blockly.Field.prototype.dispose = function() {
        Blockly.DropDownDiv.hideIfOwner(this);
        Blockly.WidgetDiv.hideIfOwner(this);
        Blockly.Tooltip.unbindMouseEvents(this.getClickTarget_());
        this.mouseDownWrapper_ && Blockly.browserEvents.unbind(this.mouseDownWrapper_);
        Blockly.utils.dom.removeNode(this.fieldGroup_);
        this.disposed = !0;
    };
    Blockly.Field.prototype.updateEditable = function() {
        var a = this.fieldGroup_;
        this.EDITABLE && a && (this.sourceBlock_.isEditable() ? (Blockly.utils.dom.addClass(a, "blocklyEditableText"), Blockly.utils.dom.removeClass(a, "blocklyNonEditableText"), a.style.cursor = this.CURSOR) : (Blockly.utils.dom.addClass(a, "blocklyNonEditableText"), Blockly.utils.dom.removeClass(a, "blocklyEditableText"), a.style.cursor = ""));
    };
    Blockly.Field.prototype.isClickable = function() {
        return !!this.sourceBlock_ && this.sourceBlock_.isEditable() && !!this.showEditor_ && "function" === typeof this.showEditor_;
    };
    Blockly.Field.prototype.isCurrentlyEditable = function() {
        return this.EDITABLE && !!this.sourceBlock_ && this.sourceBlock_.isEditable();
    };
    Blockly.Field.prototype.isSerializable = function() {
        var a = !1;
        this.name && (this.SERIALIZABLE ? a = !0 : this.EDITABLE && (console.warn("Detected an editable field that was not serializable. Please define SERIALIZABLE property as true on all editable custom fields. Proceeding with serialization."), a = !0));
        return a;
    };
    Blockly.Field.prototype.isVisible = function() {
        return this.visible_;
    };
    Blockly.Field.prototype.setVisible = function(a) {
        if (this.visible_ != a) {
            this.visible_ = a;
            var b = this.getSvgRoot();
            b && (b.style.display = a ? "block" : "none");
        }
    };
    Blockly.Field.prototype.setValidator = function(a) {
        this.validator_ = a;
    };
    Blockly.Field.prototype.getValidator = function() {
        return this.validator_;
    };
    Blockly.Field.prototype.getSvgRoot = function() {
        return this.fieldGroup_;
    };
    Blockly.Field.prototype.applyColour = function() {};
    Blockly.Field.prototype.render_ = function() {
        this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_());
        this.updateSize_();
    };
    Blockly.Field.prototype.showEditor = function(a) {
        this.isClickable() && this.showEditor_(a);
    };
    Blockly.Field.prototype.updateSize_ = function(a) {
        var b = this.getConstants();
        a = void 0 != a ? a : this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
        var c = 2 * a, d = b.FIELD_TEXT_HEIGHT, e = 0;
        this.textElement_ && (e = Blockly.utils.dom.getFastTextWidth(this.textElement_, b.FIELD_TEXT_FONTSIZE, b.FIELD_TEXT_FONTWEIGHT, b.FIELD_TEXT_FONTFAMILY), c += e);
        this.borderRect_ && (d = Math.max(d, b.FIELD_BORDER_RECT_HEIGHT));
        this.size_.height = d;
        this.size_.width = c;
        this.positionTextElement_(a, e);
        this.positionBorderRect_();
    };
    Blockly.Field.prototype.positionTextElement_ = function(a, b) {
        if (this.textElement_) {
            var c = this.getConstants(), d = this.size_.height / 2;
            this.textElement_.setAttribute("x", this.sourceBlock_.RTL ? this.size_.width - b - a : a);
            this.textElement_.setAttribute("y", c.FIELD_TEXT_BASELINE_CENTER ? d : d - c.FIELD_TEXT_HEIGHT / 2 + c.FIELD_TEXT_BASELINE);
        }
    };
    Blockly.Field.prototype.positionBorderRect_ = function() {
        this.borderRect_ && (this.borderRect_.setAttribute("width", this.size_.width), this.borderRect_.setAttribute("height", this.size_.height), this.borderRect_.setAttribute("rx", this.getConstants().FIELD_BORDER_RECT_RADIUS), this.borderRect_.setAttribute("ry", this.getConstants().FIELD_BORDER_RECT_RADIUS));
    };
    Blockly.Field.prototype.getSize = function() {
        if (!this.isVisible()) return new Blockly.utils.Size(0, 0);
        this.isDirty_ ? (this.render_(), this.isDirty_ = !1) : this.visible_ && 0 == this.size_.width && (console.warn("Deprecated use of setting size_.width to 0 to rerender a field. Set field.isDirty_ to true instead."), this.render_());
        return this.size_;
    };
    Blockly.Field.prototype.getScaledBBox = function() {
        if (this.borderRect_) a = this.borderRect_.getBoundingClientRect(), c = Blockly.utils.style.getPageOffset(this.borderRect_), d = a.width, a = a.height;
        else {
            var a = this.sourceBlock_.getHeightWidth(), b = this.sourceBlock_.workspace.scale, c = this.getAbsoluteXY_(), d = a.width * b;
            a = a.height * b;
            Blockly.utils.userAgent.GECKO ? (c.x += 1.5 * b, c.y += 1.5 * b) : Blockly.utils.userAgent.EDGE || Blockly.utils.userAgent.IE || (c.x -= .5 * b, c.y -= .5 * b);
            d += 1 * b;
            a += 1 * b;
        }
        return new Blockly.utils.Rect(c.y, c.y + a, c.x, c.x + d);
    };
    Blockly.Field.prototype.getDisplayText_ = function() {
        var a = this.getText();
        if (!a) return Blockly.Field.NBSP;
        a.length > this.maxDisplayLength && (a = a.substring(0, this.maxDisplayLength - 2) + "\u2026");
        a = a.replace(/\s/g, Blockly.Field.NBSP);
        this.sourceBlock_ && this.sourceBlock_.RTL && (a += "\u200f");
        return a;
    };
    Blockly.Field.prototype.getText = function() {
        if (this.getText_) {
            var a = this.getText_.call(this);
            if (null !== a) return String(a);
        }
        return String(this.getValue());
    };
    Blockly.Field.prototype.markDirty = function() {
        this.isDirty_ = !0;
        this.constants_ = null;
    };
    Blockly.Field.prototype.forceRerender = function() {
        this.isDirty_ = !0;
        this.sourceBlock_ && this.sourceBlock_.rendered && (this.sourceBlock_.render(), this.sourceBlock_.bumpNeighbours(), this.updateMarkers_());
    };
    Blockly.Field.prototype.setValue = function(a) {
        if (null !== a) {
            var b = this.doClassValidation_(a);
            a = this.processValidation_(a, b);
            if (!(a instanceof Error)) {
                if (b = this.getValidator()) {
                    if (b = b.call(this, a), a = this.processValidation_(a, b), a instanceof Error) return;
                }
                b = this.sourceBlock_;
                if (!b || !b.disposed) {
                    var c = this.getValue();
                    c === a ? this.doValueUpdate_(a) : (b && Blockly.Events.isEnabled() && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(b, "field", this.name || null, c, a)), this.doValueUpdate_(a), this.isDirty_ && this.forceRerender());
                }
            }
        }
    };
    Blockly.Field.prototype.processValidation_ = function(a, b) {
        if (null === b) return this.doValueInvalid_(a), this.isDirty_ && this.forceRerender(), Error();
        void 0 !== b && (a = b);
        return a;
    };
    Blockly.Field.prototype.getValue = function() {
        return this.value_;
    };
    Blockly.Field.prototype.doClassValidation_ = function(a) {
        return null === a || void 0 === a ? null : a;
    };
    Blockly.Field.prototype.doValueUpdate_ = function(a) {
        this.value_ = a;
        this.isDirty_ = !0;
    };
    Blockly.Field.prototype.doValueInvalid_ = function(a) {};
    Blockly.Field.prototype.onMouseDown_ = function(a) {
        this.sourceBlock_ && this.sourceBlock_.workspace && (a = this.sourceBlock_.workspace.getGesture(a)) && a.setStartField(this);
    };
    Blockly.Field.prototype.setTooltip = function(a) {
        a || "" === a || (a = this.sourceBlock_);
        var b = this.getClickTarget_();
        b ? b.tooltip = a : this.tooltip_ = a;
    };
    Blockly.Field.prototype.getTooltip = function() {
        var a = this.getClickTarget_();
        return a ? Blockly.Tooltip.getTooltipOfObject(a) : Blockly.Tooltip.getTooltipOfObject({
            tooltip: this.tooltip_
        });
    };
    Blockly.Field.prototype.getClickTarget_ = function() {
        return this.clickTarget_ || this.getSvgRoot();
    };
    Blockly.Field.prototype.getAbsoluteXY_ = function() {
        return Blockly.utils.style.getPageOffset(this.getClickTarget_());
    };
    Blockly.Field.prototype.referencesVariables = function() {
        return !1;
    };
    Blockly.Field.prototype.getParentInput = function() {
        for(var a = null, b = this.sourceBlock_, c = b.inputList, d = 0; d < b.inputList.length; d++)for(var e = c[d], f = e.fieldRow, g = 0; g < f.length; g++)if (f[g] === this) {
            a = e;
            break;
        }
        return a;
    };
    Blockly.Field.prototype.getFlipRtl = function() {
        return !1;
    };
    Blockly.Field.prototype.isTabNavigable = function() {
        return !1;
    };
    Blockly.Field.prototype.onShortcut = function(a) {
        return !1;
    };
    Blockly.Field.prototype.setCursorSvg = function(a) {
        a ? (this.fieldGroup_.appendChild(a), this.cursorSvg_ = a) : this.cursorSvg_ = null;
    };
    Blockly.Field.prototype.setMarkerSvg = function(a) {
        a ? (this.fieldGroup_.appendChild(a), this.markerSvg_ = a) : this.markerSvg_ = null;
    };
    Blockly.Field.prototype.updateMarkers_ = function() {
        var a = this.sourceBlock_.workspace;
        a.keyboardAccessibilityMode && this.cursorSvg_ && a.getCursor().draw();
        a.keyboardAccessibilityMode && this.markerSvg_ && a.getMarker(Blockly.MarkerManager.LOCAL_MARKER).draw();
    };
    Blockly.FieldLabel = function(a, b, c) {
        this.class_ = null;
        Blockly.FieldLabel.superClass_.constructor.call(this, a, null, c);
        c || (this.class_ = b || null);
    };
    Blockly.utils.object.inherits(Blockly.FieldLabel, Blockly.Field);
    Blockly.FieldLabel.prototype.DEFAULT_VALUE = "";
    Blockly.FieldLabel.fromJson = function(a) {
        var b = Blockly.utils.replaceMessageReferences(a.text);
        return new Blockly.FieldLabel(b, void 0, a);
    };
    Blockly.FieldLabel.prototype.EDITABLE = !1;
    Blockly.FieldLabel.prototype.configure_ = function(a) {
        Blockly.FieldLabel.superClass_.configure_.call(this, a);
        this.class_ = a["class"];
    };
    Blockly.FieldLabel.prototype.initView = function() {
        this.createTextElement_();
        this.class_ && Blockly.utils.dom.addClass(this.textElement_, this.class_);
    };
    Blockly.FieldLabel.prototype.doClassValidation_ = function(a) {
        return null === a || void 0 === a ? null : String(a);
    };
    Blockly.FieldLabel.prototype.setClass = function(a) {
        this.textElement_ && (this.class_ && Blockly.utils.dom.removeClass(this.textElement_, this.class_), a && Blockly.utils.dom.addClass(this.textElement_, a));
        this.class_ = a;
    };
    Blockly.fieldRegistry.register("field_label", Blockly.FieldLabel);
    Blockly.Input = function(a, b, c, d) {
        if (a != Blockly.inputTypes.DUMMY && !b) throw Error("Value inputs and statement inputs must have non-empty name.");
        this.type = a;
        this.name = b;
        this.sourceBlock_ = c;
        this.connection = d;
        this.fieldRow = [];
    };
    Blockly.Input.prototype.align = Blockly.constants.ALIGN.LEFT;
    Blockly.Input.prototype.visible_ = !0;
    Blockly.Input.prototype.getSourceBlock = function() {
        return this.sourceBlock_;
    };
    Blockly.Input.prototype.appendField = function(a, b) {
        this.insertFieldAt(this.fieldRow.length, a, b);
        return this;
    };
    Blockly.Input.prototype.insertFieldAt = function(a, b, c) {
        if (0 > a || a > this.fieldRow.length) throw Error("index " + a + " out of bounds.");
        if (!(b || "" == b && c)) return a;
        "string" == typeof b && (b = Blockly.fieldRegistry.fromJson({
            type: "field_label",
            text: b
        }));
        b.setSourceBlock(this.sourceBlock_);
        this.sourceBlock_.rendered && (b.init(), b.applyColour());
        b.name = c;
        b.setVisible(this.isVisible());
        b.prefixField && (a = this.insertFieldAt(a, b.prefixField));
        this.fieldRow.splice(a, 0, b);
        ++a;
        b.suffixField && (a = this.insertFieldAt(a, b.suffixField));
        this.sourceBlock_.rendered && (this.sourceBlock_ = this.sourceBlock_, this.sourceBlock_.render(), this.sourceBlock_.bumpNeighbours());
        return a;
    };
    Blockly.Input.prototype.removeField = function(a, b) {
        for(var c = 0, d; d = this.fieldRow[c]; c++)if (d.name === a) return d.dispose(), this.fieldRow.splice(c, 1), this.sourceBlock_.rendered && (this.sourceBlock_ = this.sourceBlock_, this.sourceBlock_.render(), this.sourceBlock_.bumpNeighbours()), !0;
        if (b) return !1;
        throw Error('Field "' + a + '" not found.');
    };
    Blockly.Input.prototype.isVisible = function() {
        return this.visible_;
    };
    Blockly.Input.prototype.setVisible = function(a) {
        var b = [];
        if (this.visible_ == a) return b;
        this.visible_ = a;
        for(var c = 0, d; d = this.fieldRow[c]; c++)d.setVisible(a);
        this.connection && (this.connection = this.connection, a ? b = this.connection.startTrackingAll() : this.connection.stopTrackingAll(), c = this.connection.targetBlock()) && (c.getSvgRoot().style.display = a ? "block" : "none");
        return b;
    };
    Blockly.Input.prototype.markDirty = function() {
        for(var a = 0, b; b = this.fieldRow[a]; a++)b.markDirty();
    };
    Blockly.Input.prototype.setCheck = function(a) {
        if (!this.connection) throw Error("This input does not have a connection.");
        this.connection.setCheck(a);
        return this;
    };
    Blockly.Input.prototype.setAlign = function(a) {
        this.align = a;
        this.sourceBlock_.rendered && (this.sourceBlock_ = this.sourceBlock_, this.sourceBlock_.render());
        return this;
    };
    Blockly.Input.prototype.setShadowDom = function(a) {
        if (!this.connection) throw Error("This input does not have a connection.");
        this.connection.setShadowDom(a);
        return this;
    };
    Blockly.Input.prototype.getShadowDom = function() {
        if (!this.connection) throw Error("This input does not have a connection.");
        return this.connection.getShadowDom();
    };
    Blockly.Input.prototype.init = function() {
        if (this.sourceBlock_.workspace.rendered) for(var a = 0; a < this.fieldRow.length; a++)this.fieldRow[a].init();
    };
    Blockly.Input.prototype.dispose = function() {
        for(var a = 0, b; b = this.fieldRow[a]; a++)b.dispose();
        this.connection && this.connection.dispose();
        this.sourceBlock_ = null;
    };
    Blockly.Block = function(a, b, c) {
        if (Blockly.Generator && "undefined" != typeof Blockly.Generator.prototype[b]) throw Error('Block prototypeName "' + b + '" conflicts with Blockly.Generator members.');
        this.id = c && !a.getBlockById(c) ? c : Blockly.utils.genUid();
        a.setBlockById(this.id, this);
        this.previousConnection = this.nextConnection = this.outputConnection = null;
        this.inputList = [];
        this.inputsInline = void 0;
        this.disabled = !1;
        this.tooltip = "";
        this.contextMenu = !0;
        this.parentBlock_ = null;
        this.childBlocks_ = [];
        this.editable_ = this.movable_ = this.deletable_ = !0;
        this.collapsed_ = this.isShadow_ = !1;
        this.comment = this.outputShape_ = null;
        this.commentModel = {
            text: null,
            pinned: !1,
            size: new Blockly.utils.Size(160, 80)
        };
        this.xy_ = new Blockly.utils.Coordinate(0, 0);
        this.workspace = a;
        this.isInFlyout = a.isFlyout;
        this.isInMutator = a.isMutator;
        this.RTL = a.RTL;
        this.isInsertionMarker_ = !1;
        this.hat = void 0;
        this.rendered = null;
        this.statementInputCount = 0;
        if (b) {
            this.type = b;
            c = Blockly.Blocks[b];
            if (!c || "object" != typeof c) throw TypeError("Unknown block type: " + b);
            Blockly.utils.object.mixin(this, c);
        }
        a.addTopBlock(this);
        a.addTypedBlock(this);
        (a = Blockly.Events.getGroup()) || Blockly.Events.setGroup(!0);
        b = Blockly.Events.recordUndo;
        try {
            "function" == typeof this.init && (Blockly.Events.recordUndo = !1, this.init(), Blockly.Events.recordUndo = b), Blockly.Events.isEnabled() && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CREATE))(this));
        } finally{
            a || Blockly.Events.setGroup(!1), Blockly.Events.recordUndo = b;
        }
        this.inputsInlineDefault = this.inputsInline;
        "function" == typeof this.onchange && this.setOnChange(this.onchange);
    };
    Blockly.Block.COLLAPSED_INPUT_NAME = Blockly.constants.COLLAPSED_INPUT_NAME;
    Blockly.Block.COLLAPSED_FIELD_NAME = Blockly.constants.COLLAPSED_FIELD_NAME;
    Blockly.Block.prototype.data = null;
    Blockly.Block.prototype.disposed = !1;
    Blockly.Block.prototype.hue_ = null;
    Blockly.Block.prototype.colour_ = "#000000";
    Blockly.Block.prototype.styleName_ = null;
    Blockly.Block.prototype.dispose = function(a) {
        if (this.workspace) {
            this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_);
            this.unplug(a);
            Blockly.Events.isEnabled() && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_DELETE))(this));
            Blockly.Events.disable();
            try {
                this.workspace && (this.workspace.removeTopBlock(this), this.workspace.removeTypedBlock(this), this.workspace.removeBlockById(this.id), this.workspace = null);
                Blockly.selected == this && (Blockly.selected = null);
                for(var b = this.childBlocks_.length - 1; 0 <= b; b--)this.childBlocks_[b].dispose(!1);
                b = 0;
                for(var c; c = this.inputList[b]; b++)c.dispose();
                this.inputList.length = 0;
                var d = this.getConnections_(!0);
                b = 0;
                for(var e; e = d[b]; b++)e.dispose();
            } finally{
                Blockly.Events.enable(), this.disposed = !0;
            }
        }
    };
    Blockly.Block.prototype.initModel = function() {
        for(var a = 0, b; b = this.inputList[a]; a++)for(var c = 0, d; d = b.fieldRow[c]; c++)d.initModel && d.initModel();
    };
    Blockly.Block.prototype.unplug = function(a) {
        this.outputConnection ? this.unplugFromRow_(a) : this.previousConnection && this.unplugFromStack_(a);
    };
    Blockly.Block.prototype.unplugFromRow_ = function(a) {
        var b = null;
        this.outputConnection.isConnected() && (b = this.outputConnection.targetConnection, this.outputConnection.disconnect());
        if (b && a && (a = this.getOnlyValueConnection_()) && a.isConnected() && !a.targetBlock().isShadow()) {
            if (a = a.targetConnection, a.disconnect(), this.workspace.connectionChecker.canConnect(a, b, !1)) b.connect(a);
            else a.onFailedConnect(b);
        }
    };
    Blockly.Block.prototype.getOnlyValueConnection_ = function() {
        for(var a = null, b = 0; b < this.inputList.length; b++){
            var c = this.inputList[b].connection;
            if (c && c.type == Blockly.connectionTypes.INPUT_VALUE && c.targetConnection) {
                if (a) return null;
                a = c;
            }
        }
        return a;
    };
    Blockly.Block.prototype.unplugFromStack_ = function(a) {
        var b = null;
        this.previousConnection.isConnected() && (b = this.previousConnection.targetConnection, this.previousConnection.disconnect());
        var c = this.getNextBlock();
        a && c && !c.isShadow() && (a = this.nextConnection.targetConnection, a.disconnect(), b && this.workspace.connectionChecker.canConnect(b, a, !1) && b.connect(a));
    };
    Blockly.Block.prototype.getConnections_ = function(a) {
        a = [];
        this.outputConnection && a.push(this.outputConnection);
        this.previousConnection && a.push(this.previousConnection);
        this.nextConnection && a.push(this.nextConnection);
        for(var b = 0, c; c = this.inputList[b]; b++)c.connection && a.push(c.connection);
        return a;
    };
    Blockly.Block.prototype.lastConnectionInStack = function() {
        for(var a = this.nextConnection; a;){
            var b = a.targetBlock();
            if (!b) return a;
            a = b.nextConnection;
        }
        return null;
    };
    Blockly.Block.prototype.bumpNeighbours = function() {};
    Blockly.Block.prototype.getParent = function() {
        return this.parentBlock_;
    };
    Blockly.Block.prototype.getInputWithBlock = function(a) {
        for(var b = 0, c; c = this.inputList[b]; b++)if (c.connection && c.connection.targetBlock() == a) return c;
        return null;
    };
    Blockly.Block.prototype.getSurroundParent = function() {
        var a = this;
        do {
            var b = a;
            a = a.getParent();
            if (!a) return null;
        }while (a.getNextBlock() == b);
        return a;
    };
    Blockly.Block.prototype.getNextBlock = function() {
        return this.nextConnection && this.nextConnection.targetBlock();
    };
    Blockly.Block.prototype.getPreviousBlock = function() {
        return this.previousConnection && this.previousConnection.targetBlock();
    };
    Blockly.Block.prototype.getFirstStatementConnection = function() {
        for(var a = 0, b; b = this.inputList[a]; a++)if (b.connection && b.connection.type == Blockly.connectionTypes.NEXT_STATEMENT) return b.connection;
        return null;
    };
    Blockly.Block.prototype.getRootBlock = function() {
        var a = this;
        do {
            var b = a;
            a = b.parentBlock_;
        }while (a);
        return b;
    };
    Blockly.Block.prototype.getTopStackBlock = function() {
        var a = this;
        do var b = a.getPreviousBlock();
        while (b && b.getNextBlock() == a && (a = b));
        return a;
    };
    Blockly.Block.prototype.getChildren = function(a) {
        if (!a) return this.childBlocks_;
        a = [];
        for(var b = 0, c; c = this.inputList[b]; b++)c.connection && (c = c.connection.targetBlock()) && a.push(c);
        (b = this.getNextBlock()) && a.push(b);
        return a;
    };
    Blockly.Block.prototype.setParent = function(a) {
        if (a != this.parentBlock_) {
            if (this.parentBlock_) {
                Blockly.utils.arrayRemove(this.parentBlock_.childBlocks_, this);
                if (this.previousConnection && this.previousConnection.isConnected()) throw Error("Still connected to previous block.");
                if (this.outputConnection && this.outputConnection.isConnected()) throw Error("Still connected to parent block.");
                this.parentBlock_ = null;
            } else this.workspace.removeTopBlock(this);
            (this.parentBlock_ = a) ? a.childBlocks_.push(this) : this.workspace.addTopBlock(this);
        }
    };
    Blockly.Block.prototype.getDescendants = function(a) {
        for(var b = [
            this
        ], c = this.getChildren(a), d, e = 0; d = c[e]; e++)b.push.apply(b, d.getDescendants(a));
        return b;
    };
    Blockly.Block.prototype.isDeletable = function() {
        return this.deletable_ && !this.isShadow_ && !(this.workspace && this.workspace.options.readOnly);
    };
    Blockly.Block.prototype.setDeletable = function(a) {
        this.deletable_ = a;
    };
    Blockly.Block.prototype.isMovable = function() {
        return this.movable_ && !this.isShadow_ && !(this.workspace && this.workspace.options.readOnly);
    };
    Blockly.Block.prototype.setMovable = function(a) {
        this.movable_ = a;
    };
    Blockly.Block.prototype.isDuplicatable = function() {
        return this.workspace.hasBlockLimits() ? this.workspace.isCapacityAvailable(Blockly.utils.getBlockTypeCounts(this, !0)) : !0;
    };
    Blockly.Block.prototype.isShadow = function() {
        return this.isShadow_;
    };
    Blockly.Block.prototype.setShadow = function(a) {
        this.isShadow_ = a;
    };
    Blockly.Block.prototype.isInsertionMarker = function() {
        return this.isInsertionMarker_;
    };
    Blockly.Block.prototype.setInsertionMarker = function(a) {
        this.isInsertionMarker_ = a;
    };
    Blockly.Block.prototype.isEditable = function() {
        return this.editable_ && !(this.workspace && this.workspace.options.readOnly);
    };
    Blockly.Block.prototype.setEditable = function(a) {
        this.editable_ = a;
        a = 0;
        for(var b; b = this.inputList[a]; a++)for(var c = 0, d; d = b.fieldRow[c]; c++)d.updateEditable();
    };
    Blockly.Block.prototype.isDisposed = function() {
        return this.disposed;
    };
    Blockly.Block.prototype.getMatchingConnection = function(a, b) {
        var c = this.getConnections_(!0);
        a = a.getConnections_(!0);
        if (c.length != a.length) throw Error("Connection lists did not match in length.");
        for(var d = 0; d < a.length; d++)if (a[d] == b) return c[d];
        return null;
    };
    Blockly.Block.prototype.setHelpUrl = function(a) {
        this.helpUrl = a;
    };
    Blockly.Block.prototype.setTooltip = function(a) {
        this.tooltip = a;
    };
    Blockly.Block.prototype.getTooltip = function() {
        return Blockly.Tooltip.getTooltipOfObject(this);
    };
    Blockly.Block.prototype.getColour = function() {
        return this.colour_;
    };
    Blockly.Block.prototype.getStyleName = function() {
        return this.styleName_;
    };
    Blockly.Block.prototype.getHue = function() {
        return this.hue_;
    };
    Blockly.Block.prototype.setColour = function(a) {
        a = Blockly.utils.parseBlockColour(a);
        this.hue_ = a.hue;
        this.colour_ = a.hex;
    };
    Blockly.Block.prototype.setStyle = function(a) {
        this.styleName_ = a;
    };
    Blockly.Block.prototype.setOnChange = function(a) {
        if (a && "function" != typeof a) throw Error("onchange must be a function.");
        this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_);
        if (this.onchange = a) this.onchangeWrapper_ = a.bind(this), this.workspace.addChangeListener(this.onchangeWrapper_);
    };
    Blockly.Block.prototype.getField = function(a) {
        for(var b = 0, c; c = this.inputList[b]; b++)for(var d = 0, e; e = c.fieldRow[d]; d++)if (e.name == a) return e;
        return null;
    };
    Blockly.Block.prototype.getVars = function() {
        for(var a = [], b = 0, c; c = this.inputList[b]; b++)for(var d = 0, e; e = c.fieldRow[d]; d++)e.referencesVariables() && a.push(e.getValue());
        return a;
    };
    Blockly.Block.prototype.getVarModels = function() {
        for(var a = [], b = 0, c; c = this.inputList[b]; b++)for(var d = 0, e; e = c.fieldRow[d]; d++)e.referencesVariables() && (e = this.workspace.getVariableById(e.getValue())) && a.push(e);
        return a;
    };
    Blockly.Block.prototype.updateVarName = function(a) {
        for(var b = 0, c; c = this.inputList[b]; b++)for(var d = 0, e; e = c.fieldRow[d]; d++)e.referencesVariables() && a.getId() == e.getValue() && e.refreshVariableName();
    };
    Blockly.Block.prototype.renameVarById = function(a, b) {
        for(var c = 0, d; d = this.inputList[c]; c++)for(var e = 0, f; f = d.fieldRow[e]; e++)f.referencesVariables() && a == f.getValue() && f.setValue(b);
    };
    Blockly.Block.prototype.getFieldValue = function(a) {
        return (a = this.getField(a)) ? a.getValue() : null;
    };
    Blockly.Block.prototype.setFieldValue = function(a, b) {
        var c = this.getField(b);
        if (!c) throw Error('Field "' + b + '" not found.');
        c.setValue(a);
    };
    Blockly.Block.prototype.setPreviousStatement = function(a, b) {
        if (a) {
            void 0 === b && (b = null);
            if (!this.previousConnection) {
                if (this.outputConnection) throw Error("Remove output connection prior to adding previous connection.");
                this.previousConnection = this.makeConnection_(Blockly.connectionTypes.PREVIOUS_STATEMENT);
            }
            this.previousConnection.setCheck(b);
        } else if (this.previousConnection) {
            if (this.previousConnection.isConnected()) throw Error("Must disconnect previous statement before removing connection.");
            this.previousConnection.dispose();
            this.previousConnection = null;
        }
    };
    Blockly.Block.prototype.setNextStatement = function(a, b) {
        if (a) void 0 === b && (b = null), this.nextConnection || (this.nextConnection = this.makeConnection_(Blockly.connectionTypes.NEXT_STATEMENT)), this.nextConnection.setCheck(b);
        else if (this.nextConnection) {
            if (this.nextConnection.isConnected()) throw Error("Must disconnect next statement before removing connection.");
            this.nextConnection.dispose();
            this.nextConnection = null;
        }
    };
    Blockly.Block.prototype.setOutput = function(a, b) {
        if (a) {
            void 0 === b && (b = null);
            if (!this.outputConnection) {
                if (this.previousConnection) throw Error("Remove previous connection prior to adding output connection.");
                this.outputConnection = this.makeConnection_(Blockly.connectionTypes.OUTPUT_VALUE);
            }
            this.outputConnection.setCheck(b);
        } else if (this.outputConnection) {
            if (this.outputConnection.isConnected()) throw Error("Must disconnect output value before removing connection.");
            this.outputConnection.dispose();
            this.outputConnection = null;
        }
    };
    Blockly.Block.prototype.setInputsInline = function(a) {
        this.inputsInline != a && (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(this, "inline", null, this.inputsInline, a)), this.inputsInline = a);
    };
    Blockly.Block.prototype.getInputsInline = function() {
        if (void 0 != this.inputsInline) return this.inputsInline;
        for(var a = 1; a < this.inputList.length; a++)if (this.inputList[a - 1].type == Blockly.inputTypes.DUMMY && this.inputList[a].type == Blockly.inputTypes.DUMMY) return !1;
        for(a = 1; a < this.inputList.length; a++)if (this.inputList[a - 1].type == Blockly.inputTypes.VALUE && this.inputList[a].type == Blockly.inputTypes.DUMMY) return !0;
        return !1;
    };
    Blockly.Block.prototype.setOutputShape = function(a) {
        this.outputShape_ = a;
    };
    Blockly.Block.prototype.getOutputShape = function() {
        return this.outputShape_;
    };
    Blockly.Block.prototype.isEnabled = function() {
        return !this.disabled;
    };
    Blockly.Block.prototype.setEnabled = function(a) {
        this.isEnabled() != a && (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(this, "disabled", null, this.disabled, !a)), this.disabled = !a);
    };
    Blockly.Block.prototype.getInheritedDisabled = function() {
        for(var a = this.getSurroundParent(); a;){
            if (a.disabled) return !0;
            a = a.getSurroundParent();
        }
        return !1;
    };
    Blockly.Block.prototype.isCollapsed = function() {
        return this.collapsed_;
    };
    Blockly.Block.prototype.setCollapsed = function(a) {
        this.collapsed_ != a && (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(this, "collapsed", null, this.collapsed_, a)), this.collapsed_ = a);
    };
    Blockly.Block.prototype.toString = function(a, b) {
        function c(l) {
            var m = l.getCheck();
            !m && l.targetConnection && (m = l.targetConnection.getCheck());
            return !!m && (-1 != m.indexOf("Boolean") || -1 != m.indexOf("Number"));
        }
        function d() {
            g && g.getType() == h.getType() && g.getLocation() == h.getLocation() && (g = null);
        }
        var e = [];
        b = b || "?";
        var f = Blockly.ASTNode.NAVIGATE_ALL_FIELDS;
        Blockly.ASTNode.NAVIGATE_ALL_FIELDS = !0;
        for(var g = Blockly.ASTNode.createBlockNode(this), h = g; g;){
            switch(g.getType()){
                case Blockly.ASTNode.types.INPUT:
                    var k = g.getLocation();
                    g.in() ? c(k) && e.push("(") : e.push(b);
                    break;
                case Blockly.ASTNode.types.FIELD:
                    k = g.getLocation(), k.name != Blockly.constants.COLLAPSED_FIELD_NAME && e.push(k.getText());
            }
            k = g;
            g = k.in() || k.next();
            if (!g) {
                g = k.out();
                for(d(); g && !g.next();)g = g.out(), d(), g && g.getType() == Blockly.ASTNode.types.INPUT && c(g.getLocation()) && e.push(")");
                g && (g = g.next());
            }
        }
        Blockly.ASTNode.NAVIGATE_ALL_FIELDS = f;
        b = 2;
        for(f = e.length; b < f; b++)"(" == e[b - 2] && ")" == e[b] && (e[b - 2] = e[b - 1], e.splice(b - 1, 2), f -= 2);
        e = e.join(" ").replace(/(\() | (\))/gmi, "$1$2").trim() || "???";
        a && e.length > a && (e = e.substring(0, a - 3) + "...");
        return e;
    };
    Blockly.Block.prototype.appendValueInput = function(a) {
        return this.appendInput_(Blockly.inputTypes.VALUE, a);
    };
    Blockly.Block.prototype.appendStatementInput = function(a) {
        return this.appendInput_(Blockly.inputTypes.STATEMENT, a);
    };
    Blockly.Block.prototype.appendDummyInput = function(a) {
        return this.appendInput_(Blockly.inputTypes.DUMMY, a || "");
    };
    Blockly.Block.prototype.jsonInit = function(a) {
        var b = a.type ? 'Block "' + a.type + '": ' : "";
        if (a.output && a.previousStatement) throw Error(b + "Must not have both an output and a previousStatement.");
        a.style && a.style.hat && (this.hat = a.style.hat, a.style = null);
        if (a.style && a.colour) throw Error(b + "Must not have both a colour and a style.");
        a.style ? this.jsonInitStyle_(a, b) : this.jsonInitColour_(a, b);
        for(var c = 0; void 0 !== a["message" + c];)this.interpolate_(a["message" + c], a["args" + c] || [], a["lastDummyAlign" + c], b), c++;
        void 0 !== a.inputsInline && this.setInputsInline(a.inputsInline);
        void 0 !== a.output && this.setOutput(!0, a.output);
        void 0 !== a.outputShape && this.setOutputShape(a.outputShape);
        void 0 !== a.previousStatement && this.setPreviousStatement(!0, a.previousStatement);
        void 0 !== a.nextStatement && this.setNextStatement(!0, a.nextStatement);
        void 0 !== a.tooltip && (c = a.tooltip, c = Blockly.utils.replaceMessageReferences(c), this.setTooltip(c));
        void 0 !== a.enableContextMenu && (c = a.enableContextMenu, this.contextMenu = !!c);
        void 0 !== a.helpUrl && (c = a.helpUrl, c = Blockly.utils.replaceMessageReferences(c), this.setHelpUrl(c));
        "string" == typeof a.extensions && (console.warn(b + "JSON attribute 'extensions' should be an array of strings. Found raw string in JSON for '" + a.type + "' block."), a.extensions = [
            a.extensions
        ]);
        void 0 !== a.mutator && Blockly.Extensions.apply(a.mutator, this, !0);
        if (Array.isArray(a.extensions)) for(a = a.extensions, b = 0; b < a.length; ++b)Blockly.Extensions.apply(a[b], this, !1);
    };
    Blockly.Block.prototype.jsonInitColour_ = function(a, b) {
        if ("colour" in a) {
            if (void 0 === a.colour) console.warn(b + "Undefined colour value.");
            else {
                a = a.colour;
                try {
                    this.setColour(a);
                } catch (c) {
                    console.warn(b + "Illegal colour value: ", a);
                }
            }
        }
    };
    Blockly.Block.prototype.jsonInitStyle_ = function(a, b) {
        a = a.style;
        try {
            this.setStyle(a);
        } catch (c) {
            console.warn(b + "Style does not exist: ", a);
        }
    };
    Blockly.Block.prototype.mixin = function(a, b) {
        if (void 0 !== b && "boolean" != typeof b) throw Error("opt_disableCheck must be a boolean if provided");
        if (!b) {
            b = [];
            for(var c in a)void 0 !== this[c] && b.push(c);
            if (b.length) throw Error("Mixin will overwrite block members: " + JSON.stringify(b));
        }
        Blockly.utils.object.mixin(this, a);
    };
    Blockly.Block.prototype.interpolate_ = function(a, b, c, d) {
        a = Blockly.utils.tokenizeInterpolation(a);
        this.validateTokens_(a, b.length);
        b = this.interpolateArguments_(a, b, c);
        c = [];
        a = 0;
        for(var e; e = b[a]; a++)if (this.isInputKeyword_(e.type)) {
            if (e = this.inputFromJson_(e, d)) {
                for(var f = 0, g; g = c[f]; f++)e.appendField(g[0], g[1]);
                c.length = 0;
            }
        } else (f = this.fieldFromJson_(e)) && c.push([
            f,
            e.name
        ]);
    };
    Blockly.Block.prototype.validateTokens_ = function(a, b) {
        for(var c = [], d = 0, e = 0; e < a.length; e++){
            var f = a[e];
            if ("number" == typeof f) {
                if (1 > f || f > b) throw Error('Block "' + this.type + '": Message index %' + f + " out of range.");
                if (c[f]) throw Error('Block "' + this.type + '": Message index %' + f + " duplicated.");
                c[f] = !0;
                d++;
            }
        }
        if (d != b) throw Error('Block "' + this.type + '": Message does not reference all ' + b + " arg(s).");
    };
    Blockly.Block.prototype.interpolateArguments_ = function(a, b, c) {
        for(var d = [], e = 0; e < a.length; e++){
            var f = a[e];
            "number" == typeof f && (f = b[f - 1]);
            if ("string" == typeof f && (f = this.stringToFieldJson_(f), !f)) continue;
            d.push(f);
        }
        (a = d.length) && !this.isInputKeyword_(d[a - 1].type) && (a = {
            type: "input_dummy"
        }, c && (a.align = c), d.push(a));
        return d;
    };
    Blockly.Block.prototype.fieldFromJson_ = function(a) {
        var b = Blockly.fieldRegistry.fromJson(a);
        return !b && a.alt ? "string" == typeof a.alt ? (a = this.stringToFieldJson_(a.alt)) ? this.fieldFromJson_(a) : null : this.fieldFromJson_(a.alt) : b;
    };
    Blockly.Block.prototype.inputFromJson_ = function(a, b) {
        var c = {
            LEFT: Blockly.constants.ALIGN.LEFT,
            RIGHT: Blockly.constants.ALIGN.RIGHT,
            CENTRE: Blockly.constants.ALIGN.CENTRE,
            CENTER: Blockly.constants.ALIGN.CENTRE
        }, d = null;
        switch(a.type){
            case "input_value":
                d = this.appendValueInput(a.name);
                break;
            case "input_statement":
                d = this.appendStatementInput(a.name);
                break;
            case "input_dummy":
                d = this.appendDummyInput(a.name);
        }
        if (!d) return null;
        a.check && d.setCheck(a.check);
        a.align && (c = c[a.align.toUpperCase()], void 0 === c ? console.warn(b + "Illegal align value: ", a.align) : d.setAlign(c));
        return d;
    };
    Blockly.Block.prototype.isInputKeyword_ = function(a) {
        return "input_value" == a || "input_statement" == a || "input_dummy" == a;
    };
    Blockly.Block.prototype.stringToFieldJson_ = function(a) {
        return (a = a.trim()) ? {
            type: "field_label",
            text: a
        } : null;
    };
    Blockly.Block.prototype.appendInput_ = function(a, b) {
        var c = null;
        if (a == Blockly.inputTypes.VALUE || a == Blockly.inputTypes.STATEMENT) c = this.makeConnection_(a);
        a == Blockly.inputTypes.STATEMENT && this.statementInputCount++;
        a = new Blockly.Input(a, b, this, c);
        this.inputList.push(a);
        return a;
    };
    Blockly.Block.prototype.moveInputBefore = function(a, b) {
        if (a != b) {
            for(var c = -1, d = b ? -1 : this.inputList.length, e = 0, f; f = this.inputList[e]; e++)if (f.name == a) {
                if (c = e, -1 != d) break;
            } else if (b && f.name == b && (d = e, -1 != c)) break;
            if (-1 == c) throw Error('Named input "' + a + '" not found.');
            if (-1 == d) throw Error('Reference input "' + b + '" not found.');
            this.moveNumberedInputBefore(c, d);
        }
    };
    Blockly.Block.prototype.moveNumberedInputBefore = function(a, b) {
        if (a == b) throw Error("Can't move input to itself.");
        if (a >= this.inputList.length) throw RangeError("Input index " + a + " out of bounds.");
        if (b > this.inputList.length) throw RangeError("Reference input " + b + " out of bounds.");
        var c = this.inputList[a];
        this.inputList.splice(a, 1);
        a < b && b--;
        this.inputList.splice(b, 0, c);
    };
    Blockly.Block.prototype.removeInput = function(a, b) {
        for(var c = 0, d; d = this.inputList[c]; c++)if (d.name == a) return d.type == Blockly.inputTypes.STATEMENT && this.statementInputCount--, d.dispose(), this.inputList.splice(c, 1), !0;
        if (b) return !1;
        throw Error("Input not found: " + a);
    };
    Blockly.Block.prototype.getInput = function(a) {
        for(var b = 0, c; c = this.inputList[b]; b++)if (c.name == a) return c;
        return null;
    };
    Blockly.Block.prototype.getInputTargetBlock = function(a) {
        return (a = this.getInput(a)) && a.connection && a.connection.targetBlock();
    };
    Blockly.Block.prototype.getCommentText = function() {
        return this.commentModel.text;
    };
    Blockly.Block.prototype.setCommentText = function(a) {
        this.commentModel.text != a && (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(this, "comment", null, this.commentModel.text, a)), this.comment = this.commentModel.text = a);
    };
    Blockly.Block.prototype.setWarningText = function(a, b) {};
    Blockly.Block.prototype.setMutator = function(a) {};
    Blockly.Block.prototype.getRelativeToSurfaceXY = function() {
        return this.xy_;
    };
    Blockly.Block.prototype.moveBy = function(a, b) {
        if (this.parentBlock_) throw Error("Block has parent.");
        var c = new (Blockly.Events.get(Blockly.Events.BLOCK_MOVE))(this);
        this.xy_.translate(a, b);
        c.recordNew();
        Blockly.Events.fire(c);
    };
    Blockly.Block.prototype.makeConnection_ = function(a) {
        return new Blockly.Connection(this, a);
    };
    Blockly.Block.prototype.allInputsFilled = function(a) {
        void 0 === a && (a = !0);
        if (!a && this.isShadow()) return !1;
        for(var b = 0, c; c = this.inputList[b]; b++)if (c.connection && (c = c.connection.targetBlock(), !c || !c.allInputsFilled(a))) return !1;
        return (b = this.getNextBlock()) ? b.allInputsFilled(a) : !0;
    };
    Blockly.Block.prototype.toDevString = function() {
        var a = this.type ? '"' + this.type + '" block' : "Block";
        this.id && (a += ' (id="' + this.id + '")');
        return a;
    };
    Blockly.blockRendering.IPathObject = function(a, b) {};
    Blockly.utils.KeyCodes = {
        WIN_KEY_FF_LINUX: 0,
        MAC_ENTER: 3,
        BACKSPACE: 8,
        TAB: 9,
        NUM_CENTER: 12,
        ENTER: 13,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAUSE: 19,
        CAPS_LOCK: 20,
        ESC: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        PLUS_SIGN: 43,
        PRINT_SCREEN: 44,
        INSERT: 45,
        DELETE: 46,
        ZERO: 48,
        ONE: 49,
        TWO: 50,
        THREE: 51,
        FOUR: 52,
        FIVE: 53,
        SIX: 54,
        SEVEN: 55,
        EIGHT: 56,
        NINE: 57,
        FF_SEMICOLON: 59,
        FF_EQUALS: 61,
        FF_DASH: 173,
        FF_HASH: 163,
        QUESTION_MARK: 63,
        AT_SIGN: 64,
        A: 65,
        B: 66,
        C: 67,
        D: 68,
        E: 69,
        F: 70,
        G: 71,
        H: 72,
        I: 73,
        J: 74,
        K: 75,
        L: 76,
        M: 77,
        N: 78,
        O: 79,
        P: 80,
        Q: 81,
        R: 82,
        S: 83,
        T: 84,
        U: 85,
        V: 86,
        W: 87,
        X: 88,
        Y: 89,
        Z: 90,
        META: 91,
        WIN_KEY_RIGHT: 92,
        CONTEXT_MENU: 93,
        NUM_ZERO: 96,
        NUM_ONE: 97,
        NUM_TWO: 98,
        NUM_THREE: 99,
        NUM_FOUR: 100,
        NUM_FIVE: 101,
        NUM_SIX: 102,
        NUM_SEVEN: 103,
        NUM_EIGHT: 104,
        NUM_NINE: 105,
        NUM_MULTIPLY: 106,
        NUM_PLUS: 107,
        NUM_MINUS: 109,
        NUM_PERIOD: 110,
        NUM_DIVISION: 111,
        F1: 112,
        F2: 113,
        F3: 114,
        F4: 115,
        F5: 116,
        F6: 117,
        F7: 118,
        F8: 119,
        F9: 120,
        F10: 121,
        F11: 122,
        F12: 123,
        NUMLOCK: 144,
        SCROLL_LOCK: 145,
        FIRST_MEDIA_KEY: 166,
        LAST_MEDIA_KEY: 183,
        SEMICOLON: 186,
        DASH: 189,
        EQUALS: 187,
        COMMA: 188,
        PERIOD: 190,
        SLASH: 191,
        APOSTROPHE: 192,
        TILDE: 192,
        SINGLE_QUOTE: 222,
        OPEN_SQUARE_BRACKET: 219,
        BACKSLASH: 220,
        CLOSE_SQUARE_BRACKET: 221,
        WIN_KEY: 224,
        MAC_FF_META: 224,
        MAC_WK_CMD_LEFT: 91,
        MAC_WK_CMD_RIGHT: 93,
        WIN_IME: 229,
        VK_NONAME: 252,
        PHANTOM: 255
    };
    Blockly.Menu = function() {
        this.menuItems_ = [];
        this.roleName_ = this.element_ = this.onKeyDownHandler_ = this.mouseLeaveHandler_ = this.mouseEnterHandler_ = this.clickHandler_ = this.mouseOverHandler_ = this.highlightedItem_ = this.openingCoords = null;
    };
    Blockly.Menu.prototype.addChild = function(a) {
        this.menuItems_.push(a);
    };
    Blockly.Menu.prototype.render = function(a) {
        var b = document.createElement("div");
        b.className = "blocklyMenu goog-menu blocklyNonSelectable";
        b.tabIndex = 0;
        this.roleName_ && Blockly.utils.aria.setRole(b, this.roleName_);
        this.element_ = b;
        for(var c = 0, d; d = this.menuItems_[c]; c++)b.appendChild(d.createDom());
        this.mouseOverHandler_ = Blockly.browserEvents.conditionalBind(b, "mouseover", this, this.handleMouseOver_, !0);
        this.clickHandler_ = Blockly.browserEvents.conditionalBind(b, "click", this, this.handleClick_, !0);
        this.mouseEnterHandler_ = Blockly.browserEvents.conditionalBind(b, "mouseenter", this, this.handleMouseEnter_, !0);
        this.mouseLeaveHandler_ = Blockly.browserEvents.conditionalBind(b, "mouseleave", this, this.handleMouseLeave_, !0);
        this.onKeyDownHandler_ = Blockly.browserEvents.conditionalBind(b, "keydown", this, this.handleKeyEvent_);
        a.appendChild(b);
    };
    Blockly.Menu.prototype.getElement = function() {
        return this.element_;
    };
    Blockly.Menu.prototype.focus = function() {
        var a = this.getElement();
        a && (a.focus({
            preventScroll: !0
        }), Blockly.utils.dom.addClass(a, "blocklyFocused"));
    };
    Blockly.Menu.prototype.blur_ = function() {
        var a = this.getElement();
        a && (a.blur(), Blockly.utils.dom.removeClass(a, "blocklyFocused"));
    };
    Blockly.Menu.prototype.setRole = function(a) {
        this.roleName_ = a;
    };
    Blockly.Menu.prototype.dispose = function() {
        this.mouseOverHandler_ && (Blockly.browserEvents.unbind(this.mouseOverHandler_), this.mouseOverHandler_ = null);
        this.clickHandler_ && (Blockly.browserEvents.unbind(this.clickHandler_), this.clickHandler_ = null);
        this.mouseEnterHandler_ && (Blockly.browserEvents.unbind(this.mouseEnterHandler_), this.mouseEnterHandler_ = null);
        this.mouseLeaveHandler_ && (Blockly.browserEvents.unbind(this.mouseLeaveHandler_), this.mouseLeaveHandler_ = null);
        this.onKeyDownHandler_ && (Blockly.browserEvents.unbind(this.onKeyDownHandler_), this.onKeyDownHandler_ = null);
        for(var a = 0, b; b = this.menuItems_[a]; a++)b.dispose();
        this.element_ = null;
    };
    Blockly.Menu.prototype.getMenuItem_ = function(a) {
        for(var b = this.getElement(); a && a != b;){
            if (Blockly.utils.dom.hasClass(a, "blocklyMenuItem")) {
                for(var c = 0, d; d = this.menuItems_[c]; c++)if (d.getElement() == a) return d;
            }
            a = a.parentElement;
        }
        return null;
    };
    Blockly.Menu.prototype.setHighlighted = function(a) {
        var b = this.highlightedItem_;
        b && (b.setHighlighted(!1), this.highlightedItem_ = null);
        a && (a.setHighlighted(!0), this.highlightedItem_ = a, b = this.getElement(), Blockly.utils.style.scrollIntoContainerView(a.getElement(), b), Blockly.utils.aria.setState(b, Blockly.utils.aria.State.ACTIVEDESCENDANT, a.getId()));
    };
    Blockly.Menu.prototype.highlightNext = function() {
        var a = this.menuItems_.indexOf(this.highlightedItem_);
        this.highlightHelper_(a, 1);
    };
    Blockly.Menu.prototype.highlightPrevious = function() {
        var a = this.menuItems_.indexOf(this.highlightedItem_);
        this.highlightHelper_(0 > a ? this.menuItems_.length : a, -1);
    };
    Blockly.Menu.prototype.highlightFirst_ = function() {
        this.highlightHelper_(-1, 1);
    };
    Blockly.Menu.prototype.highlightLast_ = function() {
        this.highlightHelper_(this.menuItems_.length, -1);
    };
    Blockly.Menu.prototype.highlightHelper_ = function(a, b) {
        a += b;
        for(var c; c = this.menuItems_[a];){
            if (c.isEnabled()) {
                this.setHighlighted(c);
                break;
            }
            a += b;
        }
    };
    Blockly.Menu.prototype.handleMouseOver_ = function(a) {
        (a = this.getMenuItem_(a.target)) && (a.isEnabled() ? this.highlightedItem_ != a && this.setHighlighted(a) : this.setHighlighted(null));
    };
    Blockly.Menu.prototype.handleClick_ = function(a) {
        var b = this.openingCoords;
        this.openingCoords = null;
        if (b && "number" == typeof a.clientX) {
            var c = new Blockly.utils.Coordinate(a.clientX, a.clientY);
            if (1 > Blockly.utils.Coordinate.distance(b, c)) return;
        }
        (a = this.getMenuItem_(a.target)) && a.performAction();
    };
    Blockly.Menu.prototype.handleMouseEnter_ = function(a) {
        this.focus();
    };
    Blockly.Menu.prototype.handleMouseLeave_ = function(a) {
        this.getElement() && (this.blur_(), this.setHighlighted(null));
    };
    Blockly.Menu.prototype.handleKeyEvent_ = function(a) {
        if (this.menuItems_.length && !(a.shiftKey || a.ctrlKey || a.metaKey || a.altKey)) {
            var b = this.highlightedItem_;
            switch(a.keyCode){
                case Blockly.utils.KeyCodes.ENTER:
                case Blockly.utils.KeyCodes.SPACE:
                    b && b.performAction();
                    break;
                case Blockly.utils.KeyCodes.UP:
                    this.highlightPrevious();
                    break;
                case Blockly.utils.KeyCodes.DOWN:
                    this.highlightNext();
                    break;
                case Blockly.utils.KeyCodes.PAGE_UP:
                case Blockly.utils.KeyCodes.HOME:
                    this.highlightFirst_();
                    break;
                case Blockly.utils.KeyCodes.PAGE_DOWN:
                case Blockly.utils.KeyCodes.END:
                    this.highlightLast_();
                    break;
                default:
                    return;
            }
            a.preventDefault();
            a.stopPropagation();
        }
    };
    Blockly.Menu.prototype.getSize = function() {
        var a = this.getElement(), b = Blockly.utils.style.getSize(a);
        b.height = a.scrollHeight;
        return b;
    };
    Blockly.MenuItem = function(a, b) {
        this.content_ = a;
        this.value_ = b;
        this.enabled_ = !0;
        this.element_ = null;
        this.rightToLeft_ = !1;
        this.roleName_ = null;
        this.highlight_ = this.checked_ = this.checkable_ = !1;
        this.actionHandler_ = null;
    };
    Blockly.MenuItem.prototype.createDom = function() {
        var a = document.createElement("div");
        a.id = Blockly.utils.IdGenerator.getNextUniqueId();
        this.element_ = a;
        a.className = "blocklyMenuItem goog-menuitem " + (this.enabled_ ? "" : "blocklyMenuItemDisabled goog-menuitem-disabled ") + (this.checked_ ? "blocklyMenuItemSelected goog-option-selected " : "") + (this.highlight_ ? "blocklyMenuItemHighlight goog-menuitem-highlight " : "") + (this.rightToLeft_ ? "blocklyMenuItemRtl goog-menuitem-rtl " : "");
        var b = document.createElement("div");
        b.className = "blocklyMenuItemContent goog-menuitem-content";
        if (this.checkable_) {
            var c = document.createElement("div");
            c.className = "blocklyMenuItemCheckbox goog-menuitem-checkbox";
            b.appendChild(c);
        }
        c = this.content_;
        "string" == typeof this.content_ && (c = document.createTextNode(this.content_));
        b.appendChild(c);
        a.appendChild(b);
        this.roleName_ && Blockly.utils.aria.setRole(a, this.roleName_);
        Blockly.utils.aria.setState(a, Blockly.utils.aria.State.SELECTED, this.checkable_ && this.checked_ || !1);
        Blockly.utils.aria.setState(a, Blockly.utils.aria.State.DISABLED, !this.enabled_);
        return a;
    };
    Blockly.MenuItem.prototype.dispose = function() {
        this.element_ = null;
    };
    Blockly.MenuItem.prototype.getElement = function() {
        return this.element_;
    };
    Blockly.MenuItem.prototype.getId = function() {
        return this.element_.id;
    };
    Blockly.MenuItem.prototype.getValue = function() {
        return this.value_;
    };
    Blockly.MenuItem.prototype.setRightToLeft = function(a) {
        this.rightToLeft_ = a;
    };
    Blockly.MenuItem.prototype.setRole = function(a) {
        this.roleName_ = a;
    };
    Blockly.MenuItem.prototype.setCheckable = function(a) {
        this.checkable_ = a;
    };
    Blockly.MenuItem.prototype.setChecked = function(a) {
        this.checked_ = a;
    };
    Blockly.MenuItem.prototype.setHighlighted = function(a) {
        this.highlight_ = a;
        var b = this.getElement();
        b && this.isEnabled() && (a ? (Blockly.utils.dom.addClass(b, "blocklyMenuItemHighlight"), Blockly.utils.dom.addClass(b, "goog-menuitem-highlight")) : (Blockly.utils.dom.removeClass(b, "blocklyMenuItemHighlight"), Blockly.utils.dom.removeClass(b, "goog-menuitem-highlight")));
    };
    Blockly.MenuItem.prototype.isEnabled = function() {
        return this.enabled_;
    };
    Blockly.MenuItem.prototype.setEnabled = function(a) {
        this.enabled_ = a;
    };
    Blockly.MenuItem.prototype.performAction = function() {
        this.isEnabled() && this.actionHandler_ && this.actionHandler_(this);
    };
    Blockly.MenuItem.prototype.onAction = function(a, b) {
        this.actionHandler_ = a.bind(b);
    };
    Blockly.WidgetDiv = {};
    Blockly.WidgetDiv.owner_ = null;
    Blockly.WidgetDiv.dispose_ = null;
    Blockly.WidgetDiv.rendererClassName_ = "";
    Blockly.WidgetDiv.themeClassName_ = "";
    Blockly.WidgetDiv.createDom = function() {
        Blockly.WidgetDiv.DIV || (Blockly.WidgetDiv.DIV = document.createElement("div"), Blockly.WidgetDiv.DIV.className = "blocklyWidgetDiv", (Blockly.parentContainer || document.body).appendChild(Blockly.WidgetDiv.DIV));
    };
    Blockly.WidgetDiv.show = function(a, b, c) {
        Blockly.WidgetDiv.hide();
        Blockly.WidgetDiv.owner_ = a;
        Blockly.WidgetDiv.dispose_ = c;
        a = Blockly.WidgetDiv.DIV;
        a.style.direction = b ? "rtl" : "ltr";
        a.style.display = "block";
        b = Blockly.getMainWorkspace();
        Blockly.WidgetDiv.rendererClassName_ = b.getRenderer().getClassName();
        Blockly.WidgetDiv.themeClassName_ = b.getTheme().getClassName();
        Blockly.utils.dom.addClass(a, Blockly.WidgetDiv.rendererClassName_);
        Blockly.utils.dom.addClass(a, Blockly.WidgetDiv.themeClassName_);
    };
    Blockly.WidgetDiv.hide = function() {
        if (Blockly.WidgetDiv.isVisible()) {
            Blockly.WidgetDiv.owner_ = null;
            var a = Blockly.WidgetDiv.DIV;
            a.style.display = "none";
            a.style.left = "";
            a.style.top = "";
            Blockly.WidgetDiv.dispose_ && Blockly.WidgetDiv.dispose_();
            Blockly.WidgetDiv.dispose_ = null;
            a.textContent = "";
            Blockly.WidgetDiv.rendererClassName_ && (Blockly.utils.dom.removeClass(a, Blockly.WidgetDiv.rendererClassName_), Blockly.WidgetDiv.rendererClassName_ = "");
            Blockly.WidgetDiv.themeClassName_ && (Blockly.utils.dom.removeClass(a, Blockly.WidgetDiv.themeClassName_), Blockly.WidgetDiv.themeClassName_ = "");
            Blockly.getMainWorkspace().markFocused();
        }
    };
    Blockly.WidgetDiv.isVisible = function() {
        return !!Blockly.WidgetDiv.owner_;
    };
    Blockly.WidgetDiv.hideIfOwner = function(a) {
        Blockly.WidgetDiv.owner_ == a && Blockly.WidgetDiv.hide();
    };
    Blockly.WidgetDiv.positionInternal_ = function(a, b, c) {
        Blockly.WidgetDiv.DIV.style.left = a + "px";
        Blockly.WidgetDiv.DIV.style.top = b + "px";
        Blockly.WidgetDiv.DIV.style.height = c + "px";
    };
    Blockly.WidgetDiv.positionWithAnchor = function(a, b, c, d) {
        var e = Blockly.WidgetDiv.calculateY_(a, b, c);
        a = Blockly.WidgetDiv.calculateX_(a, b, c, d);
        0 > e ? Blockly.WidgetDiv.positionInternal_(a, 0, c.height + e) : Blockly.WidgetDiv.positionInternal_(a, e, c.height);
    };
    Blockly.WidgetDiv.calculateX_ = function(a, b, c, d) {
        if (d) return b = Math.max(b.right - c.width, a.left), Math.min(b, a.right - c.width);
        b = Math.min(b.left, a.right - c.width);
        return Math.max(b, a.left);
    };
    Blockly.WidgetDiv.calculateY_ = function(a, b, c) {
        return b.bottom + c.height >= a.bottom ? b.top - c.height : b.bottom;
    };
    Blockly.ContextMenu = {};
    Blockly.ContextMenu.currentBlock = null;
    Blockly.ContextMenu.menu_ = null;
    Blockly.ContextMenu.show = function(a, b, c) {
        Blockly.WidgetDiv.show(Blockly.ContextMenu, c, Blockly.ContextMenu.dispose);
        if (b.length) {
            var d = Blockly.ContextMenu.populate_(b, c);
            Blockly.ContextMenu.menu_ = d;
            Blockly.ContextMenu.position_(d, a, c);
            setTimeout(function() {
                d.focus();
            }, 1);
            Blockly.ContextMenu.currentBlock = null;
        } else Blockly.ContextMenu.hide();
    };
    Blockly.ContextMenu.populate_ = function(a, b) {
        var c = new Blockly.Menu;
        c.setRole(Blockly.utils.aria.Role.MENU);
        for(var d = 0, e; e = a[d]; d++){
            var f = new Blockly.MenuItem(e.text);
            f.setRightToLeft(b);
            f.setRole(Blockly.utils.aria.Role.MENUITEM);
            c.addChild(f);
            f.setEnabled(e.enabled);
            if (e.enabled) f.onAction(function(g) {
                Blockly.ContextMenu.hide();
                this.callback(this.scope);
            }, e);
        }
        return c;
    };
    Blockly.ContextMenu.position_ = function(a, b, c) {
        var d = Blockly.utils.getViewportBBox();
        b = new Blockly.utils.Rect(b.clientY + d.top, b.clientY + d.top, b.clientX + d.left, b.clientX + d.left);
        Blockly.ContextMenu.createWidget_(a);
        var e = a.getSize();
        c && (b.left += e.width, b.right += e.width, d.left += e.width, d.right += e.width);
        Blockly.WidgetDiv.positionWithAnchor(d, b, e, c);
        a.focus();
    };
    Blockly.ContextMenu.createWidget_ = function(a) {
        a.render(Blockly.WidgetDiv.DIV);
        var b = a.getElement();
        Blockly.utils.dom.addClass(b, "blocklyContextMenu");
        Blockly.browserEvents.conditionalBind(b, "contextmenu", null, Blockly.utils.noEvent);
        a.focus();
    };
    Blockly.ContextMenu.hide = function() {
        Blockly.WidgetDiv.hideIfOwner(Blockly.ContextMenu);
        Blockly.ContextMenu.currentBlock = null;
    };
    Blockly.ContextMenu.dispose = function() {
        Blockly.ContextMenu.menu_ && (Blockly.ContextMenu.menu_.dispose(), Blockly.ContextMenu.menu_ = null);
    };
    Blockly.ContextMenu.callbackFactory = function(a, b) {
        return function() {
            Blockly.Events.disable();
            try {
                var c = Blockly.Xml.domToBlock(b, a.workspace), d = a.getRelativeToSurfaceXY();
                d.x = a.RTL ? d.x - Blockly.SNAP_RADIUS : d.x + Blockly.SNAP_RADIUS;
                d.y += 2 * Blockly.SNAP_RADIUS;
                c.moveBy(d.x, d.y);
            } finally{
                Blockly.Events.enable();
            }
            Blockly.Events.isEnabled() && !c.isShadow() && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CREATE))(c));
            c.select();
        };
    };
    Blockly.ContextMenu.commentDeleteOption = function(a) {
        return {
            text: Blockly.Msg.REMOVE_COMMENT,
            enabled: !0,
            callback: function() {
                Blockly.Events.setGroup(!0);
                a.dispose(!0, !0);
                Blockly.Events.setGroup(!1);
            }
        };
    };
    Blockly.ContextMenu.commentDuplicateOption = function(a) {
        return {
            text: Blockly.Msg.DUPLICATE_COMMENT,
            enabled: !0,
            callback: function() {
                Blockly.duplicate(a);
            }
        };
    };
    Blockly.ContextMenu.workspaceCommentOption = function(a, b) {
        if (!Blockly.WorkspaceCommentSvg) throw Error("Missing require for Blockly.WorkspaceCommentSvg");
        var c = {
            enabled: !Blockly.utils.userAgent.IE
        };
        c.text = Blockly.Msg.ADD_COMMENT;
        c.callback = function() {
            var d = new Blockly.WorkspaceCommentSvg(a, Blockly.Msg.WORKSPACE_COMMENT_DEFAULT_TEXT, Blockly.WorkspaceCommentSvg.DEFAULT_SIZE, Blockly.WorkspaceCommentSvg.DEFAULT_SIZE), e = a.getInjectionDiv().getBoundingClientRect();
            e = new Blockly.utils.Coordinate(b.clientX - e.left, b.clientY - e.top);
            var f = a.getOriginOffsetInPixels();
            e = Blockly.utils.Coordinate.difference(e, f);
            e.scale(1 / a.scale);
            d.moveBy(e.x, e.y);
            a.rendered && (d.initSvg(), d.render(), d.select());
        };
        return c;
    };
    Blockly.ContextMenuRegistry = function() {
        Blockly.ContextMenuRegistry.registry = this;
        this.registry_ = {};
    };
    Blockly.ContextMenuRegistry.ScopeType = {
        BLOCK: "block",
        WORKSPACE: "workspace"
    };
    Blockly.ContextMenuRegistry.registry = null;
    Blockly.ContextMenuRegistry.prototype.register = function(a) {
        if (this.registry_[a.id]) throw Error('Menu item with id "' + a.id + '" is already registered.');
        this.registry_[a.id] = a;
    };
    Blockly.ContextMenuRegistry.prototype.unregister = function(a) {
        if (this.registry_[a]) delete this.registry_[a];
        else throw Error('Menu item with id "' + a + '" not found.');
    };
    Blockly.ContextMenuRegistry.prototype.getItem = function(a) {
        return this.registry_[a] ? this.registry_[a] : null;
    };
    Blockly.ContextMenuRegistry.prototype.getContextMenuOptions = function(a, b) {
        var c = [], d = this.registry_;
        Object.keys(d).forEach(function(e) {
            e = d[e];
            if (a == e.scopeType) {
                var f = e.preconditionFn(b);
                "hidden" != f && (e = {
                    text: "function" == typeof e.displayText ? e.displayText(b) : e.displayText,
                    enabled: "enabled" == f,
                    callback: e.callback,
                    scope: b,
                    weight: e.weight
                }, c.push(e));
            }
        });
        c.sort(function(e, f) {
            return e.weight - f.weight;
        });
        return c;
    };
    new Blockly.ContextMenuRegistry;
    Blockly.Events.Selected = function(a, b, c) {
        Blockly.Events.Selected.superClass_.constructor.call(this, c);
        this.oldElementId = a;
        this.newElementId = b;
    };
    Blockly.utils.object.inherits(Blockly.Events.Selected, Blockly.Events.UiBase);
    Blockly.Events.Selected.prototype.type = Blockly.Events.SELECTED;
    Blockly.Events.Selected.prototype.toJson = function() {
        var a = Blockly.Events.Selected.superClass_.toJson.call(this);
        a.oldElementId = this.oldElementId;
        a.newElementId = this.newElementId;
        return a;
    };
    Blockly.Events.Selected.prototype.fromJson = function(a) {
        Blockly.Events.Selected.superClass_.fromJson.call(this, a);
        this.oldElementId = a.oldElementId;
        this.newElementId = a.newElementId;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.SELECTED, Blockly.Events.Selected);
    Blockly.RenderedConnection = function(a, b) {
        Blockly.RenderedConnection.superClass_.constructor.call(this, a, b);
        this.db_ = a.workspace.connectionDBList[b];
        this.dbOpposite_ = a.workspace.connectionDBList[Blockly.OPPOSITE_TYPE[b]];
        this.offsetInBlock_ = new Blockly.utils.Coordinate(0, 0);
        this.trackedState_ = Blockly.RenderedConnection.TrackedState.WILL_TRACK;
        this.targetConnection = null;
    };
    Blockly.utils.object.inherits(Blockly.RenderedConnection, Blockly.Connection);
    Blockly.RenderedConnection.TrackedState = {
        WILL_TRACK: -1,
        UNTRACKED: 0,
        TRACKED: 1
    };
    Blockly.RenderedConnection.prototype.dispose = function() {
        Blockly.RenderedConnection.superClass_.dispose.call(this);
        this.trackedState_ == Blockly.RenderedConnection.TrackedState.TRACKED && this.db_.removeConnection(this, this.y);
    };
    Blockly.RenderedConnection.prototype.getSourceBlock = function() {
        return Blockly.RenderedConnection.superClass_.getSourceBlock.call(this);
    };
    Blockly.RenderedConnection.prototype.targetBlock = function() {
        return Blockly.RenderedConnection.superClass_.targetBlock.call(this);
    };
    Blockly.RenderedConnection.prototype.distanceFrom = function(a) {
        var b = this.x - a.x;
        a = this.y - a.y;
        return Math.sqrt(b * b + a * a);
    };
    Blockly.RenderedConnection.prototype.bumpAwayFrom = function(a) {
        if (!this.sourceBlock_.workspace.isDragging()) {
            var b = this.sourceBlock_.getRootBlock();
            if (!b.isInFlyout) {
                var c = !1;
                if (!b.isMovable()) {
                    b = a.getSourceBlock().getRootBlock();
                    if (!b.isMovable()) return;
                    a = this;
                    c = !0;
                }
                var d = Blockly.selected == b;
                d || b.addSelect();
                var e = a.x + Blockly.SNAP_RADIUS + Math.floor(Math.random() * Blockly.BUMP_RANDOMNESS) - this.x, f = a.y + Blockly.SNAP_RADIUS + Math.floor(Math.random() * Blockly.BUMP_RANDOMNESS) - this.y;
                c && (f = -f);
                b.RTL && (e = a.x - Blockly.SNAP_RADIUS - Math.floor(Math.random() * Blockly.BUMP_RANDOMNESS) - this.x);
                b.moveBy(e, f);
                d || b.removeSelect();
            }
        }
    };
    Blockly.RenderedConnection.prototype.moveTo = function(a, b) {
        this.trackedState_ == Blockly.RenderedConnection.TrackedState.WILL_TRACK ? (this.db_.addConnection(this, b), this.trackedState_ = Blockly.RenderedConnection.TrackedState.TRACKED) : this.trackedState_ == Blockly.RenderedConnection.TrackedState.TRACKED && (this.db_.removeConnection(this, this.y), this.db_.addConnection(this, b));
        this.x = a;
        this.y = b;
    };
    Blockly.RenderedConnection.prototype.moveBy = function(a, b) {
        this.moveTo(this.x + a, this.y + b);
    };
    Blockly.RenderedConnection.prototype.moveToOffset = function(a) {
        this.moveTo(a.x + this.offsetInBlock_.x, a.y + this.offsetInBlock_.y);
    };
    Blockly.RenderedConnection.prototype.setOffsetInBlock = function(a, b) {
        this.offsetInBlock_.x = a;
        this.offsetInBlock_.y = b;
    };
    Blockly.RenderedConnection.prototype.getOffsetInBlock = function() {
        return this.offsetInBlock_;
    };
    Blockly.RenderedConnection.prototype.tighten = function() {
        var a = this.targetConnection.x - this.x, b = this.targetConnection.y - this.y;
        if (0 != a || 0 != b) {
            var c = this.targetBlock(), d = c.getSvgRoot();
            if (!d) throw Error("block is not rendered.");
            d = Blockly.utils.getRelativeXY(d);
            c.getSvgRoot().setAttribute("transform", "translate(" + (d.x - a) + "," + (d.y - b) + ")");
            c.moveConnections(-a, -b);
        }
    };
    Blockly.RenderedConnection.prototype.closest = function(a, b) {
        return this.dbOpposite_.searchForClosest(this, a, b);
    };
    Blockly.RenderedConnection.prototype.highlight = function() {
        var a = this.sourceBlock_.workspace.getRenderer().getConstants();
        var b = a.shapeFor(this);
        this.type == Blockly.connectionTypes.INPUT_VALUE || this.type == Blockly.connectionTypes.OUTPUT_VALUE ? (a = a.TAB_OFFSET_FROM_TOP, b = Blockly.utils.svgPaths.moveBy(0, -a) + Blockly.utils.svgPaths.lineOnAxis("v", a) + b.pathDown + Blockly.utils.svgPaths.lineOnAxis("v", a)) : (a = a.NOTCH_OFFSET_LEFT - a.CORNER_RADIUS, b = Blockly.utils.svgPaths.moveBy(-a, 0) + Blockly.utils.svgPaths.lineOnAxis("h", a) + b.pathLeft + Blockly.utils.svgPaths.lineOnAxis("h", a));
        a = this.sourceBlock_.getRelativeToSurfaceXY();
        Blockly.Connection.highlightedPath_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyHighlightedConnectionPath",
            d: b,
            transform: "translate(" + (this.x - a.x) + "," + (this.y - a.y) + ")" + (this.sourceBlock_.RTL ? " scale(-1 1)" : "")
        }, this.sourceBlock_.getSvgRoot());
    };
    Blockly.RenderedConnection.prototype.unhighlight = function() {
        Blockly.utils.dom.removeNode(Blockly.Connection.highlightedPath_);
        delete Blockly.Connection.highlightedPath_;
    };
    Blockly.RenderedConnection.prototype.setTracking = function(a) {
        a && this.trackedState_ == Blockly.RenderedConnection.TrackedState.TRACKED || !a && this.trackedState_ == Blockly.RenderedConnection.TrackedState.UNTRACKED || this.sourceBlock_.isInFlyout || (a ? (this.db_.addConnection(this, this.y), this.trackedState_ = Blockly.RenderedConnection.TrackedState.TRACKED) : (this.trackedState_ == Blockly.RenderedConnection.TrackedState.TRACKED && this.db_.removeConnection(this, this.y), this.trackedState_ = Blockly.RenderedConnection.TrackedState.UNTRACKED));
    };
    Blockly.RenderedConnection.prototype.stopTrackingAll = function() {
        this.setTracking(!1);
        if (this.targetConnection) for(var a = this.targetBlock().getDescendants(!1), b = 0; b < a.length; b++){
            for(var c = a[b], d = c.getConnections_(!0), e = 0; e < d.length; e++)d[e].setTracking(!1);
            c = c.getIcons();
            for(e = 0; e < c.length; e++)c[e].setVisible(!1);
        }
    };
    Blockly.RenderedConnection.prototype.startTrackingAll = function() {
        this.setTracking(!0);
        var a = [];
        if (this.type != Blockly.connectionTypes.INPUT_VALUE && this.type != Blockly.connectionTypes.NEXT_STATEMENT) return a;
        var b = this.targetBlock();
        if (b) {
            if (b.isCollapsed()) {
                var c = [];
                b.outputConnection && c.push(b.outputConnection);
                b.nextConnection && c.push(b.nextConnection);
                b.previousConnection && c.push(b.previousConnection);
            } else c = b.getConnections_(!0);
            for(var d = 0; d < c.length; d++)a.push.apply(a, c[d].startTrackingAll());
            a.length || (a[0] = b);
        }
        return a;
    };
    Blockly.RenderedConnection.prototype.isConnectionAllowed = function(a, b) {
        Blockly.utils.deprecation.warn("RenderedConnection.prototype.isConnectionAllowed", "July 2020", "July 2021", "Blockly.Workspace.prototype.getConnectionChecker().canConnect");
        return this.distanceFrom(a) > b ? !1 : Blockly.RenderedConnection.superClass_.isConnectionAllowed.call(this, a);
    };
    Blockly.RenderedConnection.prototype.onFailedConnect = function(a) {
        this.bumpAwayFrom(a);
    };
    Blockly.RenderedConnection.prototype.disconnectInternal_ = function(a, b) {
        Blockly.RenderedConnection.superClass_.disconnectInternal_.call(this, a, b);
        a.rendered && a.render();
        b.rendered && (b.updateDisabled(), b.render(), b.getSvgRoot().style.display = "block");
    };
    Blockly.RenderedConnection.prototype.respawnShadow_ = function() {
        Blockly.RenderedConnection.superClass_.respawnShadow_.call(this);
        var a = this.targetBlock();
        a && (a.initSvg(), a.render(!1), a = this.getSourceBlock(), a.rendered && a.render());
    };
    Blockly.RenderedConnection.prototype.neighbours = function(a) {
        return this.dbOpposite_.getNeighbours(this, a);
    };
    Blockly.RenderedConnection.prototype.connect_ = function(a) {
        Blockly.RenderedConnection.superClass_.connect_.call(this, a);
        var b = this.getSourceBlock();
        a = a.getSourceBlock();
        var c = b.rendered, d = a.rendered;
        c && b.updateDisabled();
        d && a.updateDisabled();
        c && d && (this.type == Blockly.connectionTypes.NEXT_STATEMENT || this.type == Blockly.connectionTypes.PREVIOUS_STATEMENT ? a.render() : b.render());
        if (b = b.getInputWithBlock(a)) b = b.isVisible(), a.getSvgRoot().style.display = b ? "block" : "none";
    };
    Blockly.RenderedConnection.prototype.onCheckChanged_ = function() {
        !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || ((this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug(), this.sourceBlock_.bumpNeighbours());
    };
    Blockly.Marker = function() {
        this.drawer_ = this.curNode_ = this.colour = null;
        this.type = "marker";
    };
    Blockly.Marker.prototype.setDrawer = function(a) {
        this.drawer_ = a;
    };
    Blockly.Marker.prototype.getDrawer = function() {
        return this.drawer_;
    };
    Blockly.Marker.prototype.getCurNode = function() {
        return this.curNode_;
    };
    Blockly.Marker.prototype.setCurNode = function(a) {
        var b = this.curNode_;
        this.curNode_ = a;
        this.drawer_ && this.drawer_.draw(b, this.curNode_);
    };
    Blockly.Marker.prototype.draw = function() {
        this.drawer_ && this.drawer_.draw(this.curNode_, this.curNode_);
    };
    Blockly.Marker.prototype.hide = function() {
        this.drawer_ && this.drawer_.hide();
    };
    Blockly.Marker.prototype.dispose = function() {
        this.getDrawer() && this.getDrawer().dispose();
    };
    Blockly.Cursor = function() {
        Blockly.Cursor.superClass_.constructor.call(this);
        this.type = "cursor";
    };
    Blockly.utils.object.inherits(Blockly.Cursor, Blockly.Marker);
    Blockly.Cursor.prototype.next = function() {
        var a = this.getCurNode();
        if (!a) return null;
        for(a = a.next(); a && a.next() && (a.getType() == Blockly.ASTNode.types.NEXT || a.getType() == Blockly.ASTNode.types.BLOCK);)a = a.next();
        a && this.setCurNode(a);
        return a;
    };
    Blockly.Cursor.prototype.in = function() {
        var a = this.getCurNode();
        if (!a) return null;
        if (a.getType() == Blockly.ASTNode.types.PREVIOUS || a.getType() == Blockly.ASTNode.types.OUTPUT) a = a.next();
        (a = a.in()) && this.setCurNode(a);
        return a;
    };
    Blockly.Cursor.prototype.prev = function() {
        var a = this.getCurNode();
        if (!a) return null;
        for(a = a.prev(); a && a.prev() && (a.getType() == Blockly.ASTNode.types.NEXT || a.getType() == Blockly.ASTNode.types.BLOCK);)a = a.prev();
        a && this.setCurNode(a);
        return a;
    };
    Blockly.Cursor.prototype.out = function() {
        var a = this.getCurNode();
        if (!a) return null;
        (a = a.out()) && a.getType() == Blockly.ASTNode.types.BLOCK && (a = a.prev() || a);
        a && this.setCurNode(a);
        return a;
    };
    Blockly.registry.register(Blockly.registry.Type.CURSOR, Blockly.registry.DEFAULT, Blockly.Cursor);
    Blockly.BasicCursor = function() {
        Blockly.BasicCursor.superClass_.constructor.call(this);
    };
    Blockly.utils.object.inherits(Blockly.BasicCursor, Blockly.Cursor);
    Blockly.BasicCursor.registrationName = "basicCursor";
    Blockly.BasicCursor.prototype.next = function() {
        var a = this.getCurNode();
        if (!a) return null;
        (a = this.getNextNode_(a, this.validNode_)) && this.setCurNode(a);
        return a;
    };
    Blockly.BasicCursor.prototype.in = function() {
        return this.next();
    };
    Blockly.BasicCursor.prototype.prev = function() {
        var a = this.getCurNode();
        if (!a) return null;
        (a = this.getPreviousNode_(a, this.validNode_)) && this.setCurNode(a);
        return a;
    };
    Blockly.BasicCursor.prototype.out = function() {
        return this.prev();
    };
    Blockly.BasicCursor.prototype.getNextNode_ = function(a, b) {
        if (!a) return null;
        var c = a.in() || a.next();
        if (b(c)) return c;
        if (c) return this.getNextNode_(c, b);
        a = this.findSiblingOrParent_(a.out());
        return b(a) ? a : a ? this.getNextNode_(a, b) : null;
    };
    Blockly.BasicCursor.prototype.getPreviousNode_ = function(a, b) {
        if (!a) return null;
        var c = a.prev();
        c = c ? this.getRightMostChild_(c) : a.out();
        return b(c) ? c : c ? this.getPreviousNode_(c, b) : null;
    };
    Blockly.BasicCursor.prototype.validNode_ = function(a) {
        var b = !1;
        a = a && a.getType();
        if (a == Blockly.ASTNode.types.OUTPUT || a == Blockly.ASTNode.types.INPUT || a == Blockly.ASTNode.types.FIELD || a == Blockly.ASTNode.types.NEXT || a == Blockly.ASTNode.types.PREVIOUS || a == Blockly.ASTNode.types.WORKSPACE) b = !0;
        return b;
    };
    Blockly.BasicCursor.prototype.findSiblingOrParent_ = function(a) {
        if (!a) return null;
        var b = a.next();
        return b ? b : this.findSiblingOrParent_(a.out());
    };
    Blockly.BasicCursor.prototype.getRightMostChild_ = function(a) {
        if (!a.in()) return a;
        for(a = a.in(); a.next();)a = a.next();
        return this.getRightMostChild_(a);
    };
    Blockly.registry.register(Blockly.registry.Type.CURSOR, Blockly.BasicCursor.registrationName, Blockly.BasicCursor);
    Blockly.TabNavigateCursor = function() {
        Blockly.TabNavigateCursor.superClass_.constructor.call(this);
    };
    Blockly.utils.object.inherits(Blockly.TabNavigateCursor, Blockly.BasicCursor);
    Blockly.TabNavigateCursor.prototype.validNode_ = function(a) {
        var b = !1, c = a && a.getType();
        a && (a = a.getLocation(), c == Blockly.ASTNode.types.FIELD && a && a.isTabNavigable() && a.isClickable() && (b = !0));
        return b;
    };
    Blockly.BlockSvg = function(a, b, c) {
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, null);
        this.svgGroup_.translate_ = "";
        this.style = a.getRenderer().getConstants().getBlockStyle(null);
        this.pathObject = a.getRenderer().makePathObject(this.svgGroup_, this.style);
        this.renderIsInProgress_ = this.rendered = !1;
        this.workspace = a;
        this.previousConnection = this.nextConnection = this.outputConnection = null;
        this.useDragSurface_ = Blockly.utils.is3dSupported() && !!a.getBlockDragSurface();
        var d = this.pathObject.svgPath;
        d.tooltip = this;
        Blockly.Tooltip.bindMouseEvents(d);
        Blockly.BlockSvg.superClass_.constructor.call(this, a, b, c);
        this.svgGroup_.dataset ? this.svgGroup_.dataset.id = this.id : Blockly.utils.userAgent.IE && this.svgGroup_.setAttribute("data-id", this.id);
    };
    Blockly.utils.object.inherits(Blockly.BlockSvg, Blockly.Block);
    Blockly.BlockSvg.prototype.height = 0;
    Blockly.BlockSvg.prototype.width = 0;
    Blockly.BlockSvg.prototype.warningTextDb_ = null;
    Blockly.BlockSvg.INLINE = -1;
    Blockly.BlockSvg.COLLAPSED_WARNING_ID = "TEMP_COLLAPSED_WARNING_";
    Blockly.BlockSvg.prototype.initSvg = function() {
        if (!this.workspace.rendered) throw TypeError("Workspace is headless.");
        for(var a = 0, b; b = this.inputList[a]; a++)b.init();
        b = this.getIcons();
        for(a = 0; a < b.length; a++)b[a].createIcon();
        this.applyColour();
        this.pathObject.updateMovable(this.isMovable());
        a = this.getSvgRoot();
        this.workspace.options.readOnly || this.eventsInit_ || !a || Blockly.browserEvents.conditionalBind(a, "mousedown", this, this.onMouseDown_);
        this.eventsInit_ = !0;
        a.parentNode || this.workspace.getCanvas().appendChild(a);
    };
    Blockly.BlockSvg.prototype.getColourSecondary = function() {
        return this.style.colourSecondary;
    };
    Blockly.BlockSvg.prototype.getColourTertiary = function() {
        return this.style.colourTertiary;
    };
    Blockly.BlockSvg.prototype.getColourShadow = function() {
        Blockly.utils.deprecation.warn("BlockSvg.prototype.getColourShadow", "January 2020", "January 2021", "style.colourSecondary");
        return this.getColourSecondary();
    };
    Blockly.BlockSvg.prototype.getColourBorder = function() {
        Blockly.utils.deprecation.warn("BlockSvg.prototype.getColourBorder", "January 2020", "January 2021", "style.colourTertiary");
        return {
            colourBorder: this.getColourTertiary(),
            colourLight: null,
            colourDark: null
        };
    };
    Blockly.BlockSvg.prototype.select = function() {
        if (this.isShadow() && this.getParent()) this.getParent().select();
        else if (Blockly.selected != this) {
            var a = null;
            if (Blockly.selected) {
                a = Blockly.selected.id;
                Blockly.Events.disable();
                try {
                    Blockly.selected.unselect();
                } finally{
                    Blockly.Events.enable();
                }
            }
            a = new (Blockly.Events.get(Blockly.Events.SELECTED))(a, this.id, this.workspace.id);
            Blockly.Events.fire(a);
            Blockly.selected = this;
            this.addSelect();
        }
    };
    Blockly.BlockSvg.prototype.unselect = function() {
        if (Blockly.selected == this) {
            var a = new (Blockly.Events.get(Blockly.Events.SELECTED))(this.id, null, this.workspace.id);
            a.workspaceId = this.workspace.id;
            Blockly.Events.fire(a);
            Blockly.selected = null;
            this.removeSelect();
        }
    };
    Blockly.BlockSvg.prototype.mutator = null;
    Blockly.BlockSvg.prototype.comment = null;
    Blockly.BlockSvg.prototype.commentIcon_ = null;
    Blockly.BlockSvg.prototype.warning = null;
    Blockly.BlockSvg.prototype.getIcons = function() {
        var a = [];
        this.mutator && a.push(this.mutator);
        this.commentIcon_ && a.push(this.commentIcon_);
        this.warning && a.push(this.warning);
        return a;
    };
    Blockly.BlockSvg.prototype.setParent = function(a) {
        var b = this.parentBlock_;
        if (a != b) {
            Blockly.utils.dom.startTextWidthCache();
            Blockly.BlockSvg.superClass_.setParent.call(this, a);
            Blockly.utils.dom.stopTextWidthCache();
            var c = this.getSvgRoot();
            if (!this.workspace.isClearing && c) {
                var d = this.getRelativeToSurfaceXY();
                a ? (a.getSvgRoot().appendChild(c), a = this.getRelativeToSurfaceXY(), this.moveConnections(a.x - d.x, a.y - d.y)) : b && (this.workspace.getCanvas().appendChild(c), this.translate(d.x, d.y));
                this.applyColour();
            }
        }
    };
    Blockly.BlockSvg.prototype.getRelativeToSurfaceXY = function() {
        var a = 0, b = 0, c = this.useDragSurface_ ? this.workspace.getBlockDragSurface().getGroup() : null, d = this.getSvgRoot();
        if (d) do {
            var e = Blockly.utils.getRelativeXY(d);
            a += e.x;
            b += e.y;
            this.useDragSurface_ && this.workspace.getBlockDragSurface().getCurrentBlock() == d && (e = this.workspace.getBlockDragSurface().getSurfaceTranslation(), a += e.x, b += e.y);
            d = d.parentNode;
        }while (d && d != this.workspace.getCanvas() && d != c);
        return new Blockly.utils.Coordinate(a, b);
    };
    Blockly.BlockSvg.prototype.moveBy = function(a, b) {
        if (this.parentBlock_) throw Error("Block has parent.");
        var c = Blockly.Events.isEnabled();
        if (c) var d = new (Blockly.Events.get(Blockly.Events.BLOCK_MOVE))(this);
        var e = this.getRelativeToSurfaceXY();
        this.translate(e.x + a, e.y + b);
        this.moveConnections(a, b);
        c && (d.recordNew(), Blockly.Events.fire(d));
        this.workspace.resizeContents();
    };
    Blockly.BlockSvg.prototype.translate = function(a, b) {
        this.getSvgRoot().setAttribute("transform", "translate(" + a + "," + b + ")");
    };
    Blockly.BlockSvg.prototype.moveToDragSurface = function() {
        if (this.useDragSurface_) {
            var a = this.getRelativeToSurfaceXY();
            this.clearTransformAttributes_();
            this.workspace.getBlockDragSurface().translateSurface(a.x, a.y);
            (a = this.getSvgRoot()) && this.workspace.getBlockDragSurface().setBlocksAndShow(a);
        }
    };
    Blockly.BlockSvg.prototype.moveTo = function(a) {
        var b = this.getRelativeToSurfaceXY();
        this.moveBy(a.x - b.x, a.y - b.y);
    };
    Blockly.BlockSvg.prototype.moveOffDragSurface = function(a) {
        this.useDragSurface_ && (this.translate(a.x, a.y), this.workspace.getBlockDragSurface().clearAndHide(this.workspace.getCanvas()));
    };
    Blockly.BlockSvg.prototype.moveDuringDrag = function(a) {
        this.useDragSurface_ ? this.workspace.getBlockDragSurface().translateSurface(a.x, a.y) : (this.svgGroup_.translate_ = "translate(" + a.x + "," + a.y + ")", this.svgGroup_.setAttribute("transform", this.svgGroup_.translate_ + this.svgGroup_.skew_));
    };
    Blockly.BlockSvg.prototype.clearTransformAttributes_ = function() {
        this.getSvgRoot().removeAttribute("transform");
    };
    Blockly.BlockSvg.prototype.snapToGrid = function() {
        if (this.workspace && !this.workspace.isDragging() && !this.getParent() && !this.isInFlyout) {
            var a = this.workspace.getGrid();
            if (a && a.shouldSnap()) {
                var b = a.getSpacing(), c = b / 2, d = this.getRelativeToSurfaceXY();
                a = Math.round((d.x - c) / b) * b + c - d.x;
                b = Math.round((d.y - c) / b) * b + c - d.y;
                a = Math.round(a);
                b = Math.round(b);
                0 == a && 0 == b || this.moveBy(a, b);
            }
        }
    };
    Blockly.BlockSvg.prototype.getBoundingRectangle = function() {
        var a = this.getRelativeToSurfaceXY(), b = this.getHeightWidth();
        if (this.RTL) {
            var c = a.x - b.width;
            var d = a.x;
        } else c = a.x, d = a.x + b.width;
        return new Blockly.utils.Rect(a.y, a.y + b.height, c, d);
    };
    Blockly.BlockSvg.prototype.markDirty = function() {
        this.pathObject.constants = this.workspace.getRenderer().getConstants();
        for(var a = 0, b; b = this.inputList[a]; a++)b.markDirty();
    };
    Blockly.BlockSvg.prototype.setCollapsed = function(a) {
        this.collapsed_ != a && (Blockly.BlockSvg.superClass_.setCollapsed.call(this, a), a ? this.rendered && this.render() : this.updateCollapsed_());
    };
    Blockly.BlockSvg.prototype.updateCollapsed_ = function() {
        for(var a = this.isCollapsed(), b = Blockly.constants.COLLAPSED_INPUT_NAME, c = Blockly.constants.COLLAPSED_FIELD_NAME, d = 0, e; e = this.inputList[d]; d++)e.name != b && e.setVisible(!a);
        if (a) {
            e = this.getIcons();
            for(d = 0; a = e[d]; d++)a.setVisible(!1);
            d = this.toString(Blockly.COLLAPSE_CHARS);
            (e = this.getField(c)) ? e.setValue(d) : (e = this.getInput(b) || this.appendDummyInput(b), e.appendField(new Blockly.FieldLabel(d), c));
        } else this.updateDisabled(), this.removeInput(b);
    };
    Blockly.BlockSvg.prototype.tab = function(a, b) {
        var c = new Blockly.TabNavigateCursor;
        c.setCurNode(Blockly.ASTNode.createFieldNode(a));
        a = c.getCurNode();
        b ? c.next() : c.prev();
        (b = c.getCurNode()) && b !== a && (b.getLocation().showEditor(), this.workspace.keyboardAccessibilityMode && this.workspace.getCursor().setCurNode(b));
    };
    Blockly.BlockSvg.prototype.onMouseDown_ = function(a) {
        var b = this.workspace && this.workspace.getGesture(a);
        b && b.handleBlockStart(a, this);
    };
    Blockly.BlockSvg.prototype.showHelp = function() {
        var a = "function" == typeof this.helpUrl ? this.helpUrl() : this.helpUrl;
        a && window.open(a);
    };
    Blockly.BlockSvg.prototype.generateContextMenu = function() {
        if (this.workspace.options.readOnly || !this.contextMenu) return null;
        var a = Blockly.ContextMenuRegistry.registry.getContextMenuOptions(Blockly.ContextMenuRegistry.ScopeType.BLOCK, {
            block: this
        });
        this.customContextMenu && this.customContextMenu(a);
        return a;
    };
    Blockly.BlockSvg.prototype.showContextMenu = function(a) {
        var b = this.generateContextMenu();
        b && b.length && (Blockly.ContextMenu.show(a, b, this.RTL), Blockly.ContextMenu.currentBlock = this);
    };
    Blockly.BlockSvg.prototype.moveConnections = function(a, b) {
        if (this.rendered) {
            for(var c = this.getConnections_(!1), d = 0; d < c.length; d++)c[d].moveBy(a, b);
            c = this.getIcons();
            for(d = 0; d < c.length; d++)c[d].computeIconLocation();
            for(d = 0; d < this.childBlocks_.length; d++)this.childBlocks_[d].moveConnections(a, b);
        }
    };
    Blockly.BlockSvg.prototype.setDragging = function(a) {
        if (a) {
            var b = this.getSvgRoot();
            b.translate_ = "";
            b.skew_ = "";
            Blockly.draggingConnections = Blockly.draggingConnections.concat(this.getConnections_(!0));
            Blockly.utils.dom.addClass(this.svgGroup_, "blocklyDragging");
        } else Blockly.draggingConnections = [], Blockly.utils.dom.removeClass(this.svgGroup_, "blocklyDragging");
        for(b = 0; b < this.childBlocks_.length; b++)this.childBlocks_[b].setDragging(a);
    };
    Blockly.BlockSvg.prototype.setMovable = function(a) {
        Blockly.BlockSvg.superClass_.setMovable.call(this, a);
        this.pathObject.updateMovable(a);
    };
    Blockly.BlockSvg.prototype.setEditable = function(a) {
        Blockly.BlockSvg.superClass_.setEditable.call(this, a);
        a = this.getIcons();
        for(var b = 0; b < a.length; b++)a[b].updateEditable();
    };
    Blockly.BlockSvg.prototype.setShadow = function(a) {
        Blockly.BlockSvg.superClass_.setShadow.call(this, a);
        this.applyColour();
    };
    Blockly.BlockSvg.prototype.setInsertionMarker = function(a) {
        this.isInsertionMarker_ != a && (this.isInsertionMarker_ = a) && (this.setColour(this.workspace.getRenderer().getConstants().INSERTION_MARKER_COLOUR), this.pathObject.updateInsertionMarker(!0));
    };
    Blockly.BlockSvg.prototype.getSvgRoot = function() {
        return this.svgGroup_;
    };
    Blockly.BlockSvg.prototype.dispose = function(a, b) {
        if (this.workspace) {
            Blockly.Tooltip.dispose();
            Blockly.Tooltip.unbindMouseEvents(this.pathObject.svgPath);
            Blockly.utils.dom.startTextWidthCache();
            var c = this.workspace;
            Blockly.selected == this && (this.unselect(), this.workspace.cancelCurrentGesture());
            Blockly.ContextMenu.currentBlock == this && Blockly.ContextMenu.hide();
            b && this.rendered && (this.unplug(a), Blockly.blockAnimations.disposeUiEffect(this));
            this.rendered = !1;
            if (this.warningTextDb_) {
                for(var d in this.warningTextDb_)clearTimeout(this.warningTextDb_[d]);
                this.warningTextDb_ = null;
            }
            b = this.getIcons();
            for(d = 0; d < b.length; d++)b[d].dispose();
            Blockly.BlockSvg.superClass_.dispose.call(this, !!a);
            Blockly.utils.dom.removeNode(this.svgGroup_);
            c.resizeContents();
            this.svgGroup_ = null;
            Blockly.utils.dom.stopTextWidthCache();
        }
    };
    Blockly.BlockSvg.prototype.toCopyData = function() {
        if (this.isInsertionMarker_) return null;
        var a = Blockly.Xml.blockToDom(this, !0);
        Blockly.Xml.deleteNext(a);
        var b = this.getRelativeToSurfaceXY();
        a.setAttribute("x", this.RTL ? -b.x : b.x);
        a.setAttribute("y", b.y);
        return {
            xml: a,
            source: this.workspace,
            typeCounts: Blockly.utils.getBlockTypeCounts(this, !0)
        };
    };
    Blockly.BlockSvg.prototype.applyColour = function() {
        this.pathObject.applyColour(this);
        for(var a = this.getIcons(), b = 0; b < a.length; b++)a[b].applyColour();
        for(a = 0; b = this.inputList[a]; a++)for(var c = 0, d; d = b.fieldRow[c]; c++)d.applyColour();
    };
    Blockly.BlockSvg.prototype.updateDisabled = function() {
        var a = this.getChildren(!1);
        this.applyColour();
        if (!this.isCollapsed()) for(var b = 0, c; c = a[b]; b++)c.rendered && c.updateDisabled();
    };
    Blockly.BlockSvg.prototype.getCommentIcon = function() {
        return this.commentIcon_;
    };
    Blockly.BlockSvg.prototype.setCommentText = function(a) {
        if (!Blockly.Comment) throw Error("Missing require for Blockly.Comment");
        this.commentModel.text != a && (Blockly.BlockSvg.superClass_.setCommentText.call(this, a), a = null != a, !!this.commentIcon_ == a ? this.commentIcon_.updateText() : (a ? this.comment = this.commentIcon_ = new Blockly.Comment(this) : (this.commentIcon_.dispose(), this.comment = this.commentIcon_ = null), this.rendered && (this.render(), this.bumpNeighbours())));
    };
    Blockly.BlockSvg.prototype.setWarningText = function(a, b) {
        if (!Blockly.Warning) throw Error("Missing require for Blockly.Warning");
        this.warningTextDb_ || (this.warningTextDb_ = Object.create(null));
        var c = b || "";
        if (c) this.warningTextDb_[c] && (clearTimeout(this.warningTextDb_[c]), delete this.warningTextDb_[c]);
        else for(var d in this.warningTextDb_)clearTimeout(this.warningTextDb_[d]), delete this.warningTextDb_[d];
        if (this.workspace.isDragging()) {
            var e = this;
            this.warningTextDb_[c] = setTimeout(function() {
                e.workspace && (delete e.warningTextDb_[c], e.setWarningText(a, c));
            }, 100);
        } else {
            this.isInFlyout && (a = null);
            b = !1;
            if ("string" == typeof a) {
                d = this.getSurroundParent();
                for(var f = null; d;)d.isCollapsed() && (f = d), d = d.getSurroundParent();
                f && f.setWarningText(Blockly.Msg.COLLAPSED_WARNINGS_WARNING, Blockly.BlockSvg.COLLAPSED_WARNING_ID);
                this.warning || (this.warning = new Blockly.Warning(this), b = !0);
                this.warning.setText(a, c);
            } else this.warning && !c ? (this.warning.dispose(), b = !0) : this.warning && (b = this.warning.getText(), this.warning.setText("", c), (d = this.warning.getText()) || this.warning.dispose(), b = b != d);
            b && this.rendered && (this.render(), this.bumpNeighbours());
        }
    };
    Blockly.BlockSvg.prototype.setMutator = function(a) {
        this.mutator && this.mutator !== a && this.mutator.dispose();
        a && (a.setBlock(this), this.mutator = a, a.createIcon());
        this.rendered && (this.render(), this.bumpNeighbours());
    };
    Blockly.BlockSvg.prototype.setEnabled = function(a) {
        this.isEnabled() != a && (Blockly.BlockSvg.superClass_.setEnabled.call(this, a), this.rendered && !this.getInheritedDisabled() && this.updateDisabled());
    };
    Blockly.BlockSvg.prototype.setHighlighted = function(a) {
        this.rendered && this.pathObject.updateHighlighted(a);
    };
    Blockly.BlockSvg.prototype.addSelect = function() {
        this.pathObject.updateSelected(!0);
    };
    Blockly.BlockSvg.prototype.removeSelect = function() {
        this.pathObject.updateSelected(!1);
    };
    Blockly.BlockSvg.prototype.setDeleteStyle = function(a) {
        this.pathObject.updateDraggingDelete(a);
    };
    Blockly.BlockSvg.prototype.getColour = function() {
        return this.style.colourPrimary;
    };
    Blockly.BlockSvg.prototype.setColour = function(a) {
        Blockly.BlockSvg.superClass_.setColour.call(this, a);
        a = this.workspace.getRenderer().getConstants().getBlockStyleForColour(this.colour_);
        this.pathObject.setStyle(a.style);
        this.style = a.style;
        this.styleName_ = a.name;
        this.applyColour();
    };
    Blockly.BlockSvg.prototype.setStyle = function(a) {
        var b = this.workspace.getRenderer().getConstants().getBlockStyle(a);
        this.styleName_ = a;
        if (b) this.hat = b.hat, this.pathObject.setStyle(b), this.colour_ = b.colourPrimary, this.style = b, this.applyColour();
        else throw Error("Invalid style name: " + a);
    };
    Blockly.BlockSvg.prototype.bringToFront = function() {
        var a = this;
        do {
            var b = a.getSvgRoot(), c = b.parentNode, d = c.childNodes;
            d[d.length - 1] !== b && c.appendChild(b);
            a = a.getParent();
        }while (a);
    };
    Blockly.BlockSvg.prototype.setPreviousStatement = function(a, b) {
        Blockly.BlockSvg.superClass_.setPreviousStatement.call(this, a, b);
        this.rendered && (this.render(), this.bumpNeighbours());
    };
    Blockly.BlockSvg.prototype.setNextStatement = function(a, b) {
        Blockly.BlockSvg.superClass_.setNextStatement.call(this, a, b);
        this.rendered && (this.render(), this.bumpNeighbours());
    };
    Blockly.BlockSvg.prototype.setOutput = function(a, b) {
        Blockly.BlockSvg.superClass_.setOutput.call(this, a, b);
        this.rendered && (this.render(), this.bumpNeighbours());
    };
    Blockly.BlockSvg.prototype.setInputsInline = function(a) {
        Blockly.BlockSvg.superClass_.setInputsInline.call(this, a);
        this.rendered && (this.render(), this.bumpNeighbours());
    };
    Blockly.BlockSvg.prototype.removeInput = function(a, b) {
        a = Blockly.BlockSvg.superClass_.removeInput.call(this, a, b);
        this.rendered && (this.render(), this.bumpNeighbours());
        return a;
    };
    Blockly.BlockSvg.prototype.moveNumberedInputBefore = function(a, b) {
        Blockly.BlockSvg.superClass_.moveNumberedInputBefore.call(this, a, b);
        this.rendered && (this.render(), this.bumpNeighbours());
    };
    Blockly.BlockSvg.prototype.appendInput_ = function(a, b) {
        a = Blockly.BlockSvg.superClass_.appendInput_.call(this, a, b);
        this.rendered && (this.render(), this.bumpNeighbours());
        return a;
    };
    Blockly.BlockSvg.prototype.setConnectionTracking = function(a) {
        this.previousConnection && this.previousConnection.setTracking(a);
        this.outputConnection && this.outputConnection.setTracking(a);
        if (this.nextConnection) {
            this.nextConnection.setTracking(a);
            var b = this.nextConnection.targetBlock();
            b && b.setConnectionTracking(a);
        }
        if (!this.collapsed_) for(b = 0; b < this.inputList.length; b++){
            var c = this.inputList[b].connection;
            c && (c.setTracking(a), (c = c.targetBlock()) && c.setConnectionTracking(a));
        }
    };
    Blockly.BlockSvg.prototype.getConnections_ = function(a) {
        var b = [];
        if (a || this.rendered) {
            if (this.outputConnection && b.push(this.outputConnection), this.previousConnection && b.push(this.previousConnection), this.nextConnection && b.push(this.nextConnection), a || !this.collapsed_) {
                a = 0;
                for(var c; c = this.inputList[a]; a++)c.connection && b.push(c.connection);
            }
        }
        return b;
    };
    Blockly.BlockSvg.prototype.lastConnectionInStack = function() {
        return Blockly.BlockSvg.superClass_.lastConnectionInStack.call(this);
    };
    Blockly.BlockSvg.prototype.getMatchingConnection = function(a, b) {
        return Blockly.BlockSvg.superClass_.getMatchingConnection.call(this, a, b);
    };
    Blockly.BlockSvg.prototype.makeConnection_ = function(a) {
        return new Blockly.RenderedConnection(this, a);
    };
    Blockly.BlockSvg.prototype.bumpNeighbours = function() {
        if (this.workspace && !this.workspace.isDragging()) {
            var a = this.getRootBlock();
            if (!a.isInFlyout) for(var b = this.getConnections_(!1), c = 0, d; d = b[c]; c++){
                d.isConnected() && d.isSuperior() && d.targetBlock().bumpNeighbours();
                for(var e = d.neighbours(Blockly.SNAP_RADIUS), f = 0, g; g = e[f]; f++)d.isConnected() && g.isConnected() || g.getSourceBlock().getRootBlock() != a && (d.isSuperior() ? g.bumpAwayFrom(d) : d.bumpAwayFrom(g));
            }
        }
    };
    Blockly.BlockSvg.prototype.scheduleSnapAndBump = function() {
        var a = this, b = Blockly.Events.getGroup();
        setTimeout(function() {
            Blockly.Events.setGroup(b);
            a.snapToGrid();
            Blockly.Events.setGroup(!1);
        }, Blockly.BUMP_DELAY / 2);
        setTimeout(function() {
            Blockly.Events.setGroup(b);
            a.bumpNeighbours();
            Blockly.Events.setGroup(!1);
        }, Blockly.BUMP_DELAY);
    };
    Blockly.BlockSvg.prototype.positionNearConnection = function(a, b) {
        a.type != Blockly.connectionTypes.NEXT_STATEMENT && a.type != Blockly.connectionTypes.INPUT_VALUE || this.moveBy(b.x - a.x, b.y - a.y);
    };
    Blockly.BlockSvg.prototype.getParent = function() {
        return Blockly.BlockSvg.superClass_.getParent.call(this);
    };
    Blockly.BlockSvg.prototype.getRootBlock = function() {
        return Blockly.BlockSvg.superClass_.getRootBlock.call(this);
    };
    Blockly.BlockSvg.prototype.render = function(a) {
        if (!this.renderIsInProgress_) {
            this.renderIsInProgress_ = !0;
            try {
                this.rendered = !0;
                Blockly.utils.dom.startTextWidthCache();
                this.isCollapsed() && this.updateCollapsed_();
                this.workspace.getRenderer().render(this);
                this.updateConnectionLocations_();
                if (!1 !== a) {
                    var b = this.getParent();
                    b ? b.render(!0) : this.workspace.resizeContents();
                }
                Blockly.utils.dom.stopTextWidthCache();
                this.updateMarkers_();
            } finally{
                this.renderIsInProgress_ = !1;
            }
        }
    };
    Blockly.BlockSvg.prototype.updateMarkers_ = function() {
        this.workspace.keyboardAccessibilityMode && this.pathObject.cursorSvg && this.workspace.getCursor().draw();
        this.workspace.keyboardAccessibilityMode && this.pathObject.markerSvg && this.workspace.getMarker(Blockly.MarkerManager.LOCAL_MARKER).draw();
    };
    Blockly.BlockSvg.prototype.updateConnectionLocations_ = function() {
        var a = this.getRelativeToSurfaceXY();
        this.previousConnection && this.previousConnection.moveToOffset(a);
        this.outputConnection && this.outputConnection.moveToOffset(a);
        for(var b = 0; b < this.inputList.length; b++){
            var c = this.inputList[b].connection;
            c && (c.moveToOffset(a), c.isConnected() && c.tighten());
        }
        this.nextConnection && (this.nextConnection.moveToOffset(a), this.nextConnection.isConnected() && this.nextConnection.tighten());
    };
    Blockly.BlockSvg.prototype.setCursorSvg = function(a) {
        this.pathObject.setCursorSvg(a);
    };
    Blockly.BlockSvg.prototype.setMarkerSvg = function(a) {
        this.pathObject.setMarkerSvg(a);
    };
    Blockly.BlockSvg.prototype.getHeightWidth = function() {
        var a = this.height, b = this.width, c = this.getNextBlock();
        if (c) {
            c = c.getHeightWidth();
            var d = this.workspace.getRenderer().getConstants().NOTCH_HEIGHT;
            a += c.height - d;
            b = Math.max(b, c.width);
        }
        return {
            height: a,
            width: b
        };
    };
    Blockly.BlockSvg.prototype.fadeForReplacement = function(a) {
        this.pathObject.updateReplacementFade(a);
    };
    Blockly.BlockSvg.prototype.highlightShapeForInput = function(a, b) {
        this.pathObject.updateShapeForInputHighlight(a, b);
    };
    Blockly.ConnectionDB = function(a) {
        this.connections_ = [];
        this.connectionChecker_ = a;
    };
    Blockly.ConnectionDB.prototype.addConnection = function(a, b) {
        b = this.calculateIndexForYPos_(b);
        this.connections_.splice(b, 0, a);
    };
    Blockly.ConnectionDB.prototype.findIndexOfConnection_ = function(a, b) {
        if (!this.connections_.length) return -1;
        var c = this.calculateIndexForYPos_(b);
        if (c >= this.connections_.length) return -1;
        b = a.y;
        for(var d = c; 0 <= d && this.connections_[d].y == b;){
            if (this.connections_[d] == a) return d;
            d--;
        }
        for(; c < this.connections_.length && this.connections_[c].y == b;){
            if (this.connections_[c] == a) return c;
            c++;
        }
        return -1;
    };
    Blockly.ConnectionDB.prototype.calculateIndexForYPos_ = function(a) {
        if (!this.connections_.length) return 0;
        for(var b = 0, c = this.connections_.length; b < c;){
            var d = Math.floor((b + c) / 2);
            if (this.connections_[d].y < a) b = d + 1;
            else if (this.connections_[d].y > a) c = d;
            else {
                b = d;
                break;
            }
        }
        return b;
    };
    Blockly.ConnectionDB.prototype.removeConnection = function(a, b) {
        a = this.findIndexOfConnection_(a, b);
        if (-1 == a) throw Error("Unable to find connection in connectionDB.");
        this.connections_.splice(a, 1);
    };
    Blockly.ConnectionDB.prototype.getNeighbours = function(a, b) {
        function c(l) {
            var m = e - d[l].x, n = f - d[l].y;
            Math.sqrt(m * m + n * n) <= b && k.push(d[l]);
            return n < b;
        }
        var d = this.connections_, e = a.x, f = a.y;
        a = 0;
        for(var g = d.length - 2, h = g; a < h;)d[h].y < f ? a = h : g = h, h = Math.floor((a + g) / 2);
        var k = [];
        g = a = h;
        if (d.length) {
            for(; 0 <= a && c(a);)a--;
            do g++;
            while (g < d.length && c(g));
        }
        return k;
    };
    Blockly.ConnectionDB.prototype.isInYRange_ = function(a, b, c) {
        return Math.abs(this.connections_[a].y - b) <= c;
    };
    Blockly.ConnectionDB.prototype.searchForClosest = function(a, b, c) {
        if (!this.connections_.length) return {
            connection: null,
            radius: b
        };
        var d = a.y, e = a.x;
        a.x = e + c.x;
        a.y = d + c.y;
        var f = this.calculateIndexForYPos_(a.y);
        c = null;
        for(var g = b, h, k = f - 1; 0 <= k && this.isInYRange_(k, a.y, b);)h = this.connections_[k], this.connectionChecker_.canConnect(a, h, !0, g) && (c = h, g = h.distanceFrom(a)), k--;
        for(; f < this.connections_.length && this.isInYRange_(f, a.y, b);)h = this.connections_[f], this.connectionChecker_.canConnect(a, h, !0, g) && (c = h, g = h.distanceFrom(a)), f++;
        a.x = e;
        a.y = d;
        return {
            connection: c,
            radius: g
        };
    };
    Blockly.ConnectionDB.init = function(a) {
        var b = [];
        b[Blockly.connectionTypes.INPUT_VALUE] = new Blockly.ConnectionDB(a);
        b[Blockly.connectionTypes.OUTPUT_VALUE] = new Blockly.ConnectionDB(a);
        b[Blockly.connectionTypes.NEXT_STATEMENT] = new Blockly.ConnectionDB(a);
        b[Blockly.connectionTypes.PREVIOUS_STATEMENT] = new Blockly.ConnectionDB(a);
        return b;
    };
    Blockly.Events.ThemeChange = function(a, b) {
        Blockly.Events.ThemeChange.superClass_.constructor.call(this, b);
        this.themeName = a;
    };
    Blockly.utils.object.inherits(Blockly.Events.ThemeChange, Blockly.Events.UiBase);
    Blockly.Events.ThemeChange.prototype.type = Blockly.Events.THEME_CHANGE;
    Blockly.Events.ThemeChange.prototype.toJson = function() {
        var a = Blockly.Events.ThemeChange.superClass_.toJson.call(this);
        a.themeName = this.themeName;
        return a;
    };
    Blockly.Events.ThemeChange.prototype.fromJson = function(a) {
        Blockly.Events.ThemeChange.superClass_.fromJson.call(this, a);
        this.themeName = a.themeName;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.THEME_CHANGE, Blockly.Events.ThemeChange);
    Blockly.Events.ViewportChange = function(a, b, c, d, e) {
        Blockly.Events.ViewportChange.superClass_.constructor.call(this, d);
        this.viewTop = a;
        this.viewLeft = b;
        this.scale = c;
        this.oldScale = e;
    };
    Blockly.utils.object.inherits(Blockly.Events.ViewportChange, Blockly.Events.UiBase);
    Blockly.Events.ViewportChange.prototype.type = Blockly.Events.VIEWPORT_CHANGE;
    Blockly.Events.ViewportChange.prototype.toJson = function() {
        var a = Blockly.Events.ViewportChange.superClass_.toJson.call(this);
        a.viewTop = this.viewTop;
        a.viewLeft = this.viewLeft;
        a.scale = this.scale;
        a.oldScale = this.oldScale;
        return a;
    };
    Blockly.Events.ViewportChange.prototype.fromJson = function(a) {
        Blockly.Events.ViewportChange.superClass_.fromJson.call(this, a);
        this.viewTop = a.viewTop;
        this.viewLeft = a.viewLeft;
        this.scale = a.scale;
        this.oldScale = a.oldScale;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.VIEWPORT_CHANGE, Blockly.Events.ViewportChange);
    Blockly.MarkerManager = function(a) {
        this.cursorSvg_ = this.cursor_ = null;
        this.markers_ = {};
        this.workspace_ = a;
    };
    Blockly.MarkerManager.LOCAL_MARKER = "local_marker_1";
    Blockly.MarkerManager.prototype.registerMarker = function(a, b) {
        this.markers_[a] && this.unregisterMarker(a);
        b.setDrawer(this.workspace_.getRenderer().makeMarkerDrawer(this.workspace_, b));
        this.setMarkerSvg(b.getDrawer().createDom());
        this.markers_[a] = b;
    };
    Blockly.MarkerManager.prototype.unregisterMarker = function(a) {
        var b = this.markers_[a];
        if (b) b.dispose(), delete this.markers_[a];
        else throw Error("Marker with id " + a + " does not exist. Can only unregistermarkers that exist.");
    };
    Blockly.MarkerManager.prototype.getCursor = function() {
        return this.cursor_;
    };
    Blockly.MarkerManager.prototype.getMarker = function(a) {
        return this.markers_[a];
    };
    Blockly.MarkerManager.prototype.setCursor = function(a) {
        this.cursor_ && this.cursor_.getDrawer() && this.cursor_.getDrawer().dispose();
        if (this.cursor_ = a) a = this.workspace_.getRenderer().makeMarkerDrawer(this.workspace_, this.cursor_), this.cursor_.setDrawer(a), this.setCursorSvg(this.cursor_.getDrawer().createDom());
    };
    Blockly.MarkerManager.prototype.setCursorSvg = function(a) {
        a ? (this.workspace_.getBlockCanvas().appendChild(a), this.cursorSvg_ = a) : this.cursorSvg_ = null;
    };
    Blockly.MarkerManager.prototype.setMarkerSvg = function(a) {
        a ? this.workspace_.getBlockCanvas() && (this.cursorSvg_ ? this.workspace_.getBlockCanvas().insertBefore(a, this.cursorSvg_) : this.workspace_.getBlockCanvas().appendChild(a)) : this.markerSvg_ = null;
    };
    Blockly.MarkerManager.prototype.updateMarkers = function() {
        this.workspace_.keyboardAccessibilityMode && this.cursorSvg_ && this.workspace_.getCursor().draw();
    };
    Blockly.MarkerManager.prototype.dispose = function() {
        for(var a = Object.keys(this.markers_), b = 0, c; c = a[b]; b++)this.unregisterMarker(c);
        this.markers_ = null;
        this.cursor_ && (this.cursor_.dispose(), this.cursor_ = null);
    };
    Blockly.IMetricsManager = function() {};
    Blockly.MetricsManager = function(a) {
        this.workspace_ = a;
    };
    Blockly.MetricsManager.prototype.getDimensionsPx_ = function(a) {
        var b = 0, c = 0;
        a && (b = a.getWidth(), c = a.getHeight());
        return new Blockly.utils.Size(b, c);
    };
    Blockly.MetricsManager.prototype.getFlyoutMetrics = function(a) {
        a = this.getDimensionsPx_(this.workspace_.getFlyout(a));
        return {
            width: a.width,
            height: a.height,
            position: this.workspace_.toolboxPosition
        };
    };
    Blockly.MetricsManager.prototype.getToolboxMetrics = function() {
        var a = this.getDimensionsPx_(this.workspace_.getToolbox());
        return {
            width: a.width,
            height: a.height,
            position: this.workspace_.toolboxPosition
        };
    };
    Blockly.MetricsManager.prototype.getSvgMetrics = function() {
        return this.workspace_.getCachedParentSvgSize();
    };
    Blockly.MetricsManager.prototype.getAbsoluteMetrics = function() {
        var a = 0, b = this.getToolboxMetrics(), c = this.getFlyoutMetrics(!0), d = !!this.workspace_.getToolbox(), e = !!this.workspace_.getFlyout(!0), f = d ? b.position : c.position, g = f == Blockly.utils.toolbox.Position.LEFT;
        f = f == Blockly.utils.toolbox.Position.TOP;
        d && g ? a = b.width : e && g && (a = c.width);
        g = 0;
        d && f ? g = b.height : e && f && (g = c.height);
        return {
            top: g,
            left: a
        };
    };
    Blockly.MetricsManager.prototype.getViewMetrics = function(a) {
        a = a ? this.workspace_.scale : 1;
        var b = this.getSvgMetrics(), c = this.getToolboxMetrics(), d = this.getFlyoutMetrics(!0), e = this.workspace_.getToolbox() ? c.position : d.position;
        if (this.workspace_.getToolbox()) {
            if (e == Blockly.utils.toolbox.Position.TOP || e == Blockly.utils.toolbox.Position.BOTTOM) b.height -= c.height;
            else if (e == Blockly.utils.toolbox.Position.LEFT || e == Blockly.utils.toolbox.Position.RIGHT) b.width -= c.width;
        } else if (this.workspace_.getFlyout(!0)) {
            if (e == Blockly.utils.toolbox.Position.TOP || e == Blockly.utils.toolbox.Position.BOTTOM) b.height -= d.height;
            else if (e == Blockly.utils.toolbox.Position.LEFT || e == Blockly.utils.toolbox.Position.RIGHT) b.width -= d.width;
        }
        return {
            height: b.height / a,
            width: b.width / a,
            top: -this.workspace_.scrollY / a,
            left: -this.workspace_.scrollX / a
        };
    };
    Blockly.MetricsManager.prototype.getContentMetrics = function(a) {
        a = a ? 1 : this.workspace_.scale;
        var b = this.workspace_.getBlocksBoundingBox();
        return {
            height: (b.bottom - b.top) * a,
            width: (b.right - b.left) * a,
            top: b.top * a,
            left: b.left * a
        };
    };
    Blockly.MetricsManager.prototype.hasFixedEdges = function() {
        return !this.workspace_.isMovableHorizontally() || !this.workspace_.isMovableVertically();
    };
    Blockly.MetricsManager.prototype.getComputedFixedEdges_ = function(a) {
        if (!this.hasFixedEdges()) return {};
        var b = this.workspace_.isMovableHorizontally(), c = this.workspace_.isMovableVertically();
        a = a || this.getViewMetrics(!1);
        var d = {};
        c || (d.top = a.top, d.bottom = a.top + a.height);
        b || (d.left = a.left, d.right = a.left + a.width);
        return d;
    };
    Blockly.MetricsManager.prototype.getPaddedContent_ = function(a, b) {
        var c = b.top + b.height, d = b.left + b.width, e = a.width;
        a = a.height;
        var f = e / 2, g = a / 2;
        return {
            top: Math.min(b.top - g, c - a),
            bottom: Math.max(c + g, b.top + a),
            left: Math.min(b.left - f, d - e),
            right: Math.max(d + f, b.left + e)
        };
    };
    Blockly.MetricsManager.prototype.getScrollMetrics = function(a, b, c) {
        a = a ? this.workspace_.scale : 1;
        b = b || this.getViewMetrics(!1);
        var d = c || this.getContentMetrics();
        c = this.getComputedFixedEdges_(b);
        b = this.getPaddedContent_(b, d);
        d = void 0 !== c.top ? c.top : b.top;
        var e = void 0 !== c.left ? c.left : b.left;
        return {
            top: d / a,
            left: e / a,
            width: ((void 0 !== c.right ? c.right : b.right) - e) / a,
            height: ((void 0 !== c.bottom ? c.bottom : b.bottom) - d) / a
        };
    };
    Blockly.MetricsManager.prototype.getUiMetrics = function() {
        return {
            viewMetrics: this.getViewMetrics(),
            absoluteMetrics: this.getAbsoluteMetrics(),
            toolboxMetrics: this.getToolboxMetrics()
        };
    };
    Blockly.MetricsManager.prototype.getMetrics = function() {
        var a = this.getToolboxMetrics(), b = this.getFlyoutMetrics(!0), c = this.getSvgMetrics(), d = this.getAbsoluteMetrics(), e = this.getViewMetrics(), f = this.getContentMetrics(), g = this.getScrollMetrics(!1, e, f);
        return {
            contentHeight: f.height,
            contentWidth: f.width,
            contentTop: f.top,
            contentLeft: f.left,
            scrollHeight: g.height,
            scrollWidth: g.width,
            scrollTop: g.top,
            scrollLeft: g.left,
            viewHeight: e.height,
            viewWidth: e.width,
            viewTop: e.top,
            viewLeft: e.left,
            absoluteTop: d.top,
            absoluteLeft: d.left,
            svgHeight: c.height,
            svgWidth: c.width,
            toolboxWidth: a.width,
            toolboxHeight: a.height,
            toolboxPosition: a.position,
            flyoutWidth: b.width,
            flyoutHeight: b.height
        };
    };
    Blockly.registry.register(Blockly.registry.Type.METRICS_MANAGER, Blockly.registry.DEFAULT, Blockly.MetricsManager);
    Blockly.FlyoutMetricsManager = function(a, b) {
        this.flyout_ = b;
        Blockly.FlyoutMetricsManager.superClass_.constructor.call(this, a);
    };
    Blockly.utils.object.inherits(Blockly.FlyoutMetricsManager, Blockly.MetricsManager);
    Blockly.FlyoutMetricsManager.prototype.getBoundingBox_ = function() {
        try {
            var a = this.workspace_.getCanvas().getBBox();
        } catch (b) {
            a = {
                height: 0,
                y: 0,
                width: 0,
                x: 0
            };
        }
        return a;
    };
    Blockly.FlyoutMetricsManager.prototype.getContentMetrics = function(a) {
        var b = this.getBoundingBox_();
        a = a ? 1 : this.workspace_.scale;
        return {
            height: b.height * a,
            width: b.width * a,
            top: b.y * a,
            left: b.x * a
        };
    };
    Blockly.FlyoutMetricsManager.prototype.getScrollMetrics = function(a, b, c) {
        b = c || this.getContentMetrics();
        c = this.flyout_.MARGIN * this.workspace_.scale;
        a = a ? this.workspace_.scale : 1;
        return {
            height: (b.height + 2 * c) / a,
            width: (b.width + b.left + c) / a,
            top: 0,
            left: 0
        };
    };
    Blockly.FlyoutMetricsManager.prototype.getViewMetrics = function(a) {
        var b = this.getSvgMetrics();
        a = a ? this.workspace_.scale : 1;
        if (this.flyout_.horizontalLayout) {
            var c = b.width - 2 * this.flyout_.SCROLLBAR_PADDING;
            b = b.height - this.flyout_.SCROLLBAR_PADDING;
        } else c = b.width - this.flyout_.SCROLLBAR_PADDING, b = b.height - 2 * this.flyout_.SCROLLBAR_PADDING;
        return {
            height: b / a,
            width: c / a,
            top: -this.workspace_.scrollY / a,
            left: -this.workspace_.scrollX / a
        };
    };
    Blockly.FlyoutMetricsManager.prototype.getAbsoluteMetrics = function() {
        var a = this.flyout_.SCROLLBAR_PADDING;
        return this.flyout_.horizontalLayout ? {
            top: 0,
            left: a
        } : {
            top: a,
            left: 0
        };
    };
    Blockly.PluginManager = function() {
        this.pluginData_ = {};
        this.typeToPluginIds_ = {};
    };
    Blockly.PluginManager.prototype.addPlugin = function(a) {
        this.pluginData_[a.id] = a;
        for(var b = 0, c; c = a.types[b]; b++)c = String(c).toLowerCase(), void 0 === this.typeToPluginIds_[c] ? this.typeToPluginIds_[c] = [
            a.id
        ] : this.typeToPluginIds_[c].push(a.id);
    };
    Blockly.PluginManager.prototype.getPlugin = function(a) {
        return this.pluginData_[a] && this.pluginData_[a].plugin;
    };
    Blockly.PluginManager.prototype.getPlugins = function(a, b) {
        a = String(a).toLowerCase();
        a = this.typeToPluginIds_[a];
        if (!a) return [];
        var c = [];
        if (b) {
            var d = [], e = this.pluginData_;
            a.forEach(function(f) {
                d.push(e[f]);
            });
            d.sort(function(f, g) {
                return f.weight - g.weight;
            });
            d.forEach(function(f) {
                c.push(f.plugin);
            });
        } else e = this.pluginData_, a.forEach(function(f) {
            c.push(e[f].plugin);
        });
        return c;
    };
    Blockly.PluginManager.Type = function(a) {
        this.name_ = a;
    };
    Blockly.PluginManager.Type.prototype.toString = function() {
        return this.name_;
    };
    Blockly.PluginManager.Type.POSITIONABLE = new Blockly.PluginManager.Type("positionable");
    Blockly.ThemeManager = function(a, b) {
        this.workspace_ = a;
        this.theme_ = b;
        this.subscribedWorkspaces_ = [];
        this.componentDB_ = Object.create(null);
    };
    Blockly.ThemeManager.prototype.getTheme = function() {
        return this.theme_;
    };
    Blockly.ThemeManager.prototype.setTheme = function(a) {
        var b = this.theme_;
        this.theme_ = a;
        if (a = this.workspace_.getInjectionDiv()) b && Blockly.utils.dom.removeClass(a, b.getClassName()), Blockly.utils.dom.addClass(a, this.theme_.getClassName());
        for(b = 0; a = this.subscribedWorkspaces_[b]; b++)a.refreshTheme();
        b = 0;
        a = Object.keys(this.componentDB_);
        for(var c; c = a[b]; b++)for(var d = 0, e; e = this.componentDB_[c][d]; d++){
            var f = e.element;
            e = e.propertyName;
            var g = this.theme_ && this.theme_.getComponentStyle(c);
            f.style[e] = g || "";
        }
        Blockly.hideChaff();
    };
    Blockly.ThemeManager.prototype.subscribeWorkspace = function(a) {
        this.subscribedWorkspaces_.push(a);
    };
    Blockly.ThemeManager.prototype.unsubscribeWorkspace = function(a) {
        a = this.subscribedWorkspaces_.indexOf(a);
        if (0 > a) throw Error("Cannot unsubscribe a workspace that hasn't been subscribed.");
        this.subscribedWorkspaces_.splice(a, 1);
    };
    Blockly.ThemeManager.prototype.subscribe = function(a, b, c) {
        this.componentDB_[b] || (this.componentDB_[b] = []);
        this.componentDB_[b].push({
            element: a,
            propertyName: c
        });
        b = this.theme_ && this.theme_.getComponentStyle(b);
        a.style[c] = b || "";
    };
    Blockly.ThemeManager.prototype.unsubscribe = function(a) {
        if (a) for(var b = Object.keys(this.componentDB_), c = 0, d; d = b[c]; c++){
            for(var e = this.componentDB_[d], f = e.length - 1; 0 <= f; f--)e[f].element === a && e.splice(f, 1);
            this.componentDB_[d].length || delete this.componentDB_[d];
        }
    };
    Blockly.ThemeManager.prototype.dispose = function() {
        this.componentDB_ = this.subscribedWorkspaces_ = this.theme_ = this.owner_ = null;
    };
    Blockly.TouchGesture = function(a, b) {
        Blockly.TouchGesture.superClass_.constructor.call(this, a, b);
        this.isMultiTouch_ = !1;
        this.cachedPoints_ = Object.create(null);
        this.startDistance_ = this.previousScale_ = 0;
        this.isPinchZoomEnabled_ = this.onStartWrapper_ = null;
    };
    Blockly.utils.object.inherits(Blockly.TouchGesture, Blockly.Gesture);
    Blockly.TouchGesture.ZOOM_IN_MULTIPLIER = 5;
    Blockly.TouchGesture.ZOOM_OUT_MULTIPLIER = 6;
    Blockly.TouchGesture.prototype.doStart = function(a) {
        this.isPinchZoomEnabled_ = this.startWorkspace_.options.zoomOptions && this.startWorkspace_.options.zoomOptions.pinch;
        Blockly.TouchGesture.superClass_.doStart.call(this, a);
        !this.isEnding_ && Blockly.Touch.isTouchEvent(a) && this.handleTouchStart(a);
    };
    Blockly.TouchGesture.prototype.bindMouseEvents = function(a) {
        this.onStartWrapper_ = Blockly.browserEvents.conditionalBind(document, "mousedown", null, this.handleStart.bind(this), !0);
        this.onMoveWrapper_ = Blockly.browserEvents.conditionalBind(document, "mousemove", null, this.handleMove.bind(this), !0);
        this.onUpWrapper_ = Blockly.browserEvents.conditionalBind(document, "mouseup", null, this.handleUp.bind(this), !0);
        a.preventDefault();
        a.stopPropagation();
    };
    Blockly.TouchGesture.prototype.handleStart = function(a) {
        !this.isDragging() && Blockly.Touch.isTouchEvent(a) && (this.handleTouchStart(a), this.isMultiTouch() && Blockly.longStop_());
    };
    Blockly.TouchGesture.prototype.handleMove = function(a) {
        this.isDragging() ? Blockly.Touch.shouldHandleEvent(a) && Blockly.TouchGesture.superClass_.handleMove.call(this, a) : this.isMultiTouch() ? (Blockly.Touch.isTouchEvent(a) && this.handleTouchMove(a), Blockly.longStop_()) : Blockly.TouchGesture.superClass_.handleMove.call(this, a);
    };
    Blockly.TouchGesture.prototype.handleUp = function(a) {
        Blockly.Touch.isTouchEvent(a) && !this.isDragging() && this.handleTouchEnd(a);
        !this.isMultiTouch() || this.isDragging() ? Blockly.Touch.shouldHandleEvent(a) && Blockly.TouchGesture.superClass_.handleUp.call(this, a) : (a.preventDefault(), a.stopPropagation(), this.dispose());
    };
    Blockly.TouchGesture.prototype.isMultiTouch = function() {
        return this.isMultiTouch_;
    };
    Blockly.TouchGesture.prototype.dispose = function() {
        Blockly.TouchGesture.superClass_.dispose.call(this);
        this.onStartWrapper_ && Blockly.browserEvents.unbind(this.onStartWrapper_);
    };
    Blockly.TouchGesture.prototype.handleTouchStart = function(a) {
        var b = Blockly.Touch.getTouchIdentifierFromEvent(a);
        this.cachedPoints_[b] = this.getTouchPoint(a);
        b = Object.keys(this.cachedPoints_);
        2 == b.length && (this.startDistance_ = Blockly.utils.Coordinate.distance(this.cachedPoints_[b[0]], this.cachedPoints_[b[1]]), this.isMultiTouch_ = !0, a.preventDefault());
    };
    Blockly.TouchGesture.prototype.handleTouchMove = function(a) {
        var b = Blockly.Touch.getTouchIdentifierFromEvent(a);
        this.cachedPoints_[b] = this.getTouchPoint(a);
        b = Object.keys(this.cachedPoints_);
        this.isPinchZoomEnabled_ && 2 === b.length ? this.handlePinch_(a) : Blockly.TouchGesture.superClass_.handleMove.call(this, a);
    };
    Blockly.TouchGesture.prototype.handlePinch_ = function(a) {
        var b = Object.keys(this.cachedPoints_);
        b = Blockly.utils.Coordinate.distance(this.cachedPoints_[b[0]], this.cachedPoints_[b[1]]) / this.startDistance_;
        if (0 < this.previousScale_ && Infinity > this.previousScale_) {
            var c = b - this.previousScale_;
            c = 0 < c ? c * Blockly.TouchGesture.ZOOM_IN_MULTIPLIER : c * Blockly.TouchGesture.ZOOM_OUT_MULTIPLIER;
            var d = this.startWorkspace_, e = Blockly.utils.mouseToSvg(a, d.getParentSvg(), d.getInverseScreenCTM());
            d.zoom(e.x, e.y, c);
        }
        this.previousScale_ = b;
        a.preventDefault();
    };
    Blockly.TouchGesture.prototype.handleTouchEnd = function(a) {
        a = Blockly.Touch.getTouchIdentifierFromEvent(a);
        this.cachedPoints_[a] && delete this.cachedPoints_[a];
        2 > Object.keys(this.cachedPoints_).length && (this.cachedPoints_ = Object.create(null), this.previousScale_ = 0);
    };
    Blockly.TouchGesture.prototype.getTouchPoint = function(a) {
        return this.startWorkspace_ ? new Blockly.utils.Coordinate(a.pageX ? a.pageX : a.changedTouches[0].pageX, a.pageY ? a.pageY : a.changedTouches[0].pageY) : null;
    };
    Blockly.WorkspaceAudio = function(a) {
        this.parentWorkspace_ = a;
        this.SOUNDS_ = Object.create(null);
    };
    Blockly.WorkspaceAudio.prototype.lastSound_ = null;
    Blockly.WorkspaceAudio.prototype.dispose = function() {
        this.SOUNDS_ = this.parentWorkspace_ = null;
    };
    Blockly.WorkspaceAudio.prototype.load = function(a, b) {
        if (a.length) {
            try {
                var c = new Blockly.utils.global.Audio;
            } catch (h) {
                return;
            }
            for(var d, e = 0; e < a.length; e++){
                var f = a[e], g = f.match(/\.(\w+)$/);
                if (g && c.canPlayType("audio/" + g[1])) {
                    d = new Blockly.utils.global.Audio(f);
                    break;
                }
            }
            d && d.play && (this.SOUNDS_[b] = d);
        }
    };
    Blockly.WorkspaceAudio.prototype.preload = function() {
        for(var a in this.SOUNDS_){
            var b = this.SOUNDS_[a];
            b.volume = .01;
            var c = b.play();
            void 0 !== c ? c.then(b.pause).catch(function() {}) : b.pause();
            if (Blockly.utils.userAgent.IPAD || Blockly.utils.userAgent.IPHONE) break;
        }
    };
    Blockly.WorkspaceAudio.prototype.play = function(a, b) {
        var c = this.SOUNDS_[a];
        c ? (a = new Date, null != this.lastSound_ && a - this.lastSound_ < Blockly.SOUND_LIMIT || (this.lastSound_ = a, c = Blockly.utils.userAgent.IPAD || Blockly.utils.userAgent.ANDROID ? c : c.cloneNode(), c.volume = void 0 === b ? 1 : b, c.play())) : this.parentWorkspace_ && this.parentWorkspace_.getAudioManager().play(a, b);
    };
    Blockly.WorkspaceSvg = function(a, b, c) {
        Blockly.WorkspaceSvg.superClass_.constructor.call(this, a);
        this.metricsManager_ = new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.METRICS_MANAGER, a, !0))(this);
        this.getMetrics = a.getMetrics || this.metricsManager_.getMetrics.bind(this.metricsManager_);
        this.setMetrics = a.setMetrics || Blockly.WorkspaceSvg.setTopLevelWorkspaceMetrics_;
        this.pluginManager_ = new Blockly.PluginManager;
        this.connectionDBList = Blockly.ConnectionDB.init(this.connectionChecker);
        b && (this.blockDragSurface_ = b);
        c && (this.workspaceDragSurface_ = c);
        this.useWorkspaceDragSurface_ = !!this.workspaceDragSurface_ && Blockly.utils.is3dSupported();
        this.highlightedBlocks_ = [];
        this.audioManager_ = new Blockly.WorkspaceAudio(a.parentWorkspace);
        this.grid_ = this.options.gridPattern ? new Blockly.Grid(this.options.gridPattern, a.gridOptions) : null;
        this.markerManager_ = new Blockly.MarkerManager(this);
        this.toolboxCategoryCallbacks_ = {};
        this.flyoutButtonCallbacks_ = {};
        Blockly.Variables && Blockly.Variables.flyoutCategory && this.registerToolboxCategoryCallback(Blockly.VARIABLE_CATEGORY_NAME, Blockly.Variables.flyoutCategory);
        Blockly.VariablesDynamic && Blockly.VariablesDynamic.flyoutCategory && this.registerToolboxCategoryCallback(Blockly.VARIABLE_DYNAMIC_CATEGORY_NAME, Blockly.VariablesDynamic.flyoutCategory);
        Blockly.Procedures && Blockly.Procedures.flyoutCategory && (this.registerToolboxCategoryCallback(Blockly.PROCEDURE_CATEGORY_NAME, Blockly.Procedures.flyoutCategory), this.addChangeListener(Blockly.Procedures.mutatorOpenListener));
        this.themeManager_ = this.options.parentWorkspace ? this.options.parentWorkspace.getThemeManager() : new Blockly.ThemeManager(this, this.options.theme || Blockly.Themes.Classic);
        this.themeManager_.subscribeWorkspace(this);
        this.renderer_ = Blockly.blockRendering.init(this.options.renderer || "geras", this.getTheme(), this.options.rendererOverrides);
        this.cachedParentSvg_ = null;
        this.keyboardAccessibilityMode = !1;
        this.topBoundedElements_ = [];
        this.cachedParentSvgSize_ = new Blockly.utils.Size(0, 0);
    };
    Blockly.utils.object.inherits(Blockly.WorkspaceSvg, Blockly.Workspace);
    Blockly.WorkspaceSvg.prototype.resizeHandlerWrapper_ = null;
    Blockly.WorkspaceSvg.prototype.rendered = !0;
    Blockly.WorkspaceSvg.prototype.isVisible_ = !0;
    Blockly.WorkspaceSvg.prototype.isFlyout = !1;
    Blockly.WorkspaceSvg.prototype.isMutator = !1;
    Blockly.WorkspaceSvg.prototype.resizesEnabled_ = !0;
    Blockly.WorkspaceSvg.prototype.scrollX = 0;
    Blockly.WorkspaceSvg.prototype.scrollY = 0;
    Blockly.WorkspaceSvg.prototype.startScrollX = 0;
    Blockly.WorkspaceSvg.prototype.startScrollY = 0;
    Blockly.WorkspaceSvg.prototype.dragDeltaXY_ = null;
    Blockly.WorkspaceSvg.prototype.scale = 1;
    Blockly.WorkspaceSvg.prototype.oldScale_ = 1;
    Blockly.WorkspaceSvg.prototype.oldTop_ = 0;
    Blockly.WorkspaceSvg.prototype.oldLeft_ = 0;
    Blockly.WorkspaceSvg.prototype.trashcan = null;
    Blockly.WorkspaceSvg.prototype.scrollbar = null;
    Blockly.WorkspaceSvg.prototype.flyout_ = null;
    Blockly.WorkspaceSvg.prototype.toolbox_ = null;
    Blockly.WorkspaceSvg.prototype.currentGesture_ = null;
    Blockly.WorkspaceSvg.prototype.blockDragSurface_ = null;
    Blockly.WorkspaceSvg.prototype.workspaceDragSurface_ = null;
    Blockly.WorkspaceSvg.prototype.useWorkspaceDragSurface_ = !1;
    Blockly.WorkspaceSvg.prototype.isDragSurfaceActive_ = !1;
    Blockly.WorkspaceSvg.prototype.injectionDiv_ = null;
    Blockly.WorkspaceSvg.prototype.lastRecordedPageScroll_ = null;
    Blockly.WorkspaceSvg.prototype.targetWorkspace = null;
    Blockly.WorkspaceSvg.prototype.inverseScreenCTM_ = null;
    Blockly.WorkspaceSvg.prototype.inverseScreenCTMDirty_ = !0;
    Blockly.WorkspaceSvg.prototype.getMarkerManager = function() {
        return this.markerManager_;
    };
    Blockly.WorkspaceSvg.prototype.getMetricsManager = function() {
        return this.metricsManager_;
    };
    Blockly.WorkspaceSvg.prototype.setMetricsManager = function(a) {
        this.metricsManager_ = a;
        this.getMetrics = this.metricsManager_.getMetrics.bind(this.metricsManager_);
    };
    Blockly.WorkspaceSvg.prototype.getPluginManager = function() {
        return this.pluginManager_;
    };
    Blockly.WorkspaceSvg.prototype.setCursorSvg = function(a) {
        this.markerManager_.setCursorSvg(a);
    };
    Blockly.WorkspaceSvg.prototype.setMarkerSvg = function(a) {
        this.markerManager_.setMarkerSvg(a);
    };
    Blockly.WorkspaceSvg.prototype.getMarker = function(a) {
        return this.markerManager_ ? this.markerManager_.getMarker(a) : null;
    };
    Blockly.WorkspaceSvg.prototype.getCursor = function() {
        return this.markerManager_ ? this.markerManager_.getCursor() : null;
    };
    Blockly.WorkspaceSvg.prototype.getRenderer = function() {
        return this.renderer_;
    };
    Blockly.WorkspaceSvg.prototype.getThemeManager = function() {
        return this.themeManager_;
    };
    Blockly.WorkspaceSvg.prototype.getTheme = function() {
        return this.themeManager_.getTheme();
    };
    Blockly.WorkspaceSvg.prototype.setTheme = function(a) {
        a || (a = Blockly.Themes.Classic);
        this.themeManager_.setTheme(a);
    };
    Blockly.WorkspaceSvg.prototype.refreshTheme = function() {
        this.svgGroup_ && this.renderer_.refreshDom(this.svgGroup_, this.getTheme());
        this.updateBlockStyles_(this.getAllBlocks(!1).filter(function(b) {
            return void 0 !== b.getStyleName();
        }));
        this.refreshToolboxSelection();
        this.toolbox_ && this.toolbox_.refreshTheme();
        this.isVisible() && this.setVisible(!0);
        var a = new (Blockly.Events.get(Blockly.Events.THEME_CHANGE))(this.getTheme().name, this.id);
        Blockly.Events.fire(a);
    };
    Blockly.WorkspaceSvg.prototype.updateBlockStyles_ = function(a) {
        for(var b = 0, c; c = a[b]; b++){
            var d = c.getStyleName();
            d && (c.setStyle(d), c.mutator && c.mutator.updateBlockStyle());
        }
    };
    Blockly.WorkspaceSvg.prototype.getInverseScreenCTM = function() {
        if (this.inverseScreenCTMDirty_) {
            var a = this.getParentSvg().getScreenCTM();
            a && (this.inverseScreenCTM_ = a.inverse(), this.inverseScreenCTMDirty_ = !1);
        }
        return this.inverseScreenCTM_;
    };
    Blockly.WorkspaceSvg.prototype.updateInverseScreenCTM = function() {
        this.inverseScreenCTMDirty_ = !0;
    };
    Blockly.WorkspaceSvg.prototype.isVisible = function() {
        return this.isVisible_;
    };
    Blockly.WorkspaceSvg.prototype.getSvgXY = function(a) {
        var b = 0, c = 0, d = 1;
        if (Blockly.utils.dom.containsNode(this.getCanvas(), a) || Blockly.utils.dom.containsNode(this.getBubbleCanvas(), a)) d = this.scale;
        do {
            var e = Blockly.utils.getRelativeXY(a);
            if (a == this.getCanvas() || a == this.getBubbleCanvas()) d = 1;
            b += e.x * d;
            c += e.y * d;
            a = a.parentNode;
        }while (a && a != this.getParentSvg());
        return new Blockly.utils.Coordinate(b, c);
    };
    Blockly.WorkspaceSvg.prototype.getCachedParentSvgSize = function() {
        var a = this.cachedParentSvgSize_;
        return new Blockly.utils.Size(a.width, a.height);
    };
    Blockly.WorkspaceSvg.prototype.getOriginOffsetInPixels = function() {
        return Blockly.utils.getInjectionDivXY_(this.getCanvas());
    };
    Blockly.WorkspaceSvg.prototype.getInjectionDiv = function() {
        if (!this.injectionDiv_) for(var a = this.svgGroup_; a;){
            if (-1 != (" " + (a.getAttribute("class") || "") + " ").indexOf(" injectionDiv ")) {
                this.injectionDiv_ = a;
                break;
            }
            a = a.parentNode;
        }
        return this.injectionDiv_;
    };
    Blockly.WorkspaceSvg.prototype.getBlockCanvas = function() {
        return this.svgBlockCanvas_;
    };
    Blockly.WorkspaceSvg.prototype.setResizeHandlerWrapper = function(a) {
        this.resizeHandlerWrapper_ = a;
    };
    Blockly.WorkspaceSvg.prototype.createDom = function(a) {
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyWorkspace"
        }, null);
        a && (this.svgBackground_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            height: "100%",
            width: "100%",
            "class": a
        }, this.svgGroup_), "blocklyMainBackground" == a && this.grid_ ? this.svgBackground_.style.fill = "url(#" + this.grid_.getPatternId() + ")" : this.themeManager_.subscribe(this.svgBackground_, "workspaceBackgroundColour", "fill"));
        this.svgBlockCanvas_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyBlockCanvas"
        }, this.svgGroup_);
        this.svgBubbleCanvas_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyBubbleCanvas"
        }, this.svgGroup_);
        this.isFlyout || (Blockly.browserEvents.conditionalBind(this.svgGroup_, "mousedown", this, this.onMouseDown_, !1, !0), Blockly.browserEvents.conditionalBind(this.svgGroup_, "wheel", this, this.onMouseWheel_));
        this.options.hasCategories && (this.toolbox_ = new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.TOOLBOX, this.options, !0))(this));
        this.grid_ && this.grid_.update(this.scale);
        this.recordDeleteAreas();
        (a = Blockly.registry.getClassFromOptions(Blockly.registry.Type.CURSOR, this.options)) && this.markerManager_.setCursor(new a);
        this.renderer_.createDom(this.svgGroup_, this.getTheme());
        return this.svgGroup_;
    };
    Blockly.WorkspaceSvg.prototype.dispose = function() {
        this.rendered = !1;
        this.currentGesture_ && this.currentGesture_.cancel();
        this.svgGroup_ && (Blockly.utils.dom.removeNode(this.svgGroup_), this.svgGroup_ = null);
        this.svgBubbleCanvas_ = this.svgBlockCanvas_ = null;
        this.toolbox_ && (this.toolbox_.dispose(), this.toolbox_ = null);
        this.flyout_ && (this.flyout_.dispose(), this.flyout_ = null);
        this.trashcan && (this.trashcan.dispose(), this.trashcan = null);
        this.scrollbar && (this.scrollbar.dispose(), this.scrollbar = null);
        this.zoomControls_ && (this.zoomControls_.dispose(), this.zoomControls_ = null);
        this.audioManager_ && (this.audioManager_.dispose(), this.audioManager_ = null);
        this.grid_ && (this.grid_.dispose(), this.grid_ = null);
        this.renderer_.dispose();
        this.markerManager_ && (this.markerManager_.dispose(), this.markerManager_ = null);
        Blockly.WorkspaceSvg.superClass_.dispose.call(this);
        this.themeManager_ && (this.themeManager_.unsubscribeWorkspace(this), this.themeManager_.unsubscribe(this.svgBackground_), this.options.parentWorkspace || (this.themeManager_.dispose(), this.themeManager_ = null));
        this.flyoutButtonCallbacks_ = this.toolboxCategoryCallbacks_ = this.connectionDBList = null;
        if (!this.options.parentWorkspace) {
            var a = this.getParentSvg();
            a && a.parentNode && Blockly.utils.dom.removeNode(a.parentNode);
        }
        this.resizeHandlerWrapper_ && (Blockly.browserEvents.unbind(this.resizeHandlerWrapper_), this.resizeHandlerWrapper_ = null);
    };
    Blockly.WorkspaceSvg.prototype.newBlock = function(a, b) {
        return new Blockly.BlockSvg(this, a, b);
    };
    Blockly.WorkspaceSvg.prototype.addTrashcan = function() {
        if (!Blockly.Trashcan) throw Error("Missing require for Blockly.Trashcan");
        this.trashcan = new Blockly.Trashcan(this);
        var a = this.trashcan.createDom();
        this.svgGroup_.insertBefore(a, this.svgBlockCanvas_);
        this.pluginManager_.addPlugin({
            id: "trashcan",
            plugin: this.trashcan,
            weight: 1,
            types: [
                Blockly.PluginManager.Type.POSITIONABLE
            ]
        });
    };
    Blockly.WorkspaceSvg.prototype.addZoomControls = function() {
        if (!Blockly.ZoomControls) throw Error("Missing require for Blockly.ZoomControls");
        this.zoomControls_ = new Blockly.ZoomControls(this);
        var a = this.zoomControls_.createDom();
        this.svgGroup_.appendChild(a);
        this.pluginManager_.addPlugin({
            id: "zoomControls",
            plugin: this.zoomControls_,
            weight: 2,
            types: [
                Blockly.PluginManager.Type.POSITIONABLE
            ]
        });
    };
    Blockly.WorkspaceSvg.prototype.addFlyout = function(a) {
        var b = new Blockly.Options({
            parentWorkspace: this,
            rtl: this.RTL,
            oneBasedIndex: this.options.oneBasedIndex,
            horizontalLayout: this.horizontalLayout,
            renderer: this.options.renderer,
            rendererOverrides: this.options.rendererOverrides,
            move: {
                scrollbars: !0
            }
        });
        b.toolboxPosition = this.options.toolboxPosition;
        this.flyout_ = this.horizontalLayout ? new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.FLYOUTS_HORIZONTAL_TOOLBOX, this.options, !0))(b) : new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.FLYOUTS_VERTICAL_TOOLBOX, this.options, !0))(b);
        this.flyout_.autoClose = !1;
        this.flyout_.getWorkspace().setVisible(!0);
        return this.flyout_.createDom(a);
    };
    Blockly.WorkspaceSvg.prototype.getFlyout = function(a) {
        return this.flyout_ || a ? this.flyout_ : this.toolbox_ ? this.toolbox_.getFlyout() : null;
    };
    Blockly.WorkspaceSvg.prototype.getToolbox = function() {
        return this.toolbox_;
    };
    Blockly.WorkspaceSvg.prototype.updateScreenCalculations_ = function() {
        this.updateInverseScreenCTM();
        this.recordDeleteAreas();
    };
    Blockly.WorkspaceSvg.prototype.resizeContents = function() {
        this.resizesEnabled_ && this.rendered && (this.scrollbar && this.scrollbar.resize(), this.updateInverseScreenCTM());
    };
    Blockly.WorkspaceSvg.prototype.resize = function() {
        this.toolbox_ && this.toolbox_.position();
        this.flyout_ && this.flyout_.position();
        for(var a = this.pluginManager_.getPlugins(Blockly.PluginManager.Type.POSITIONABLE, !0), b = this.getMetricsManager().getUiMetrics(), c = [], d = 0, e; e = a[d]; d++)e.position(b, c), c.push(e.getBoundingRectangle());
        this.scrollbar && this.scrollbar.resize();
        this.updateScreenCalculations_();
    };
    Blockly.WorkspaceSvg.prototype.updateScreenCalculationsIfScrolled = function() {
        var a = Blockly.utils.getDocumentScroll();
        Blockly.utils.Coordinate.equals(this.lastRecordedPageScroll_, a) || (this.lastRecordedPageScroll_ = a, this.updateScreenCalculations_());
    };
    Blockly.WorkspaceSvg.prototype.getCanvas = function() {
        return this.svgBlockCanvas_;
    };
    Blockly.WorkspaceSvg.prototype.setCachedParentSvgSize = function(a, b) {
        var c = this.getParentSvg();
        a && (this.cachedParentSvgSize_.width = a, c.cachedWidth_ = a);
        b && (this.cachedParentSvgSize_.height = b, c.cachedHeight_ = b);
    };
    Blockly.WorkspaceSvg.prototype.getBubbleCanvas = function() {
        return this.svgBubbleCanvas_;
    };
    Blockly.WorkspaceSvg.prototype.getParentSvg = function() {
        if (!this.cachedParentSvg_) for(var a = this.svgGroup_; a;){
            if ("svg" == a.tagName) {
                this.cachedParentSvg_ = a;
                break;
            }
            a = a.parentNode;
        }
        return this.cachedParentSvg_;
    };
    Blockly.WorkspaceSvg.prototype.maybeFireViewportChangeEvent = function() {
        if (Blockly.Events.isEnabled()) {
            var a = this.scale, b = -this.scrollY, c = -this.scrollX;
            if (!(a == this.oldScale_ && 1 > Math.abs(b - this.oldTop_) && 1 > Math.abs(c - this.oldLeft_))) {
                var d = new (Blockly.Events.get(Blockly.Events.VIEWPORT_CHANGE))(b, c, a, this.id, this.oldScale_);
                this.oldScale_ = a;
                this.oldTop_ = b;
                this.oldLeft_ = c;
                Blockly.Events.fire(d);
            }
        }
    };
    Blockly.WorkspaceSvg.prototype.translate = function(a, b) {
        if (this.useWorkspaceDragSurface_ && this.isDragSurfaceActive_) this.workspaceDragSurface_.translateSurface(a, b);
        else {
            var c = "translate(" + a + "," + b + ") scale(" + this.scale + ")";
            this.svgBlockCanvas_.setAttribute("transform", c);
            this.svgBubbleCanvas_.setAttribute("transform", c);
        }
        this.blockDragSurface_ && this.blockDragSurface_.translateAndScaleGroup(a, b, this.scale);
        this.grid_ && this.grid_.moveTo(a, b);
        this.maybeFireViewportChangeEvent();
    };
    Blockly.WorkspaceSvg.prototype.resetDragSurface = function() {
        if (this.useWorkspaceDragSurface_) {
            this.isDragSurfaceActive_ = !1;
            var a = this.workspaceDragSurface_.getSurfaceTranslation();
            this.workspaceDragSurface_.clearAndHide(this.svgGroup_);
            a = "translate(" + a.x + "," + a.y + ") scale(" + this.scale + ")";
            this.svgBlockCanvas_.setAttribute("transform", a);
            this.svgBubbleCanvas_.setAttribute("transform", a);
        }
    };
    Blockly.WorkspaceSvg.prototype.setupDragSurface = function() {
        if (this.useWorkspaceDragSurface_ && !this.isDragSurfaceActive_) {
            this.isDragSurfaceActive_ = !0;
            var a = this.svgBlockCanvas_.previousSibling, b = parseInt(this.getParentSvg().getAttribute("width"), 10), c = parseInt(this.getParentSvg().getAttribute("height"), 10), d = Blockly.utils.getRelativeXY(this.getCanvas());
            this.workspaceDragSurface_.setContentsAndShow(this.getCanvas(), this.getBubbleCanvas(), a, b, c, this.scale);
            this.workspaceDragSurface_.translateSurface(d.x, d.y);
        }
    };
    Blockly.WorkspaceSvg.prototype.getBlockDragSurface = function() {
        return this.blockDragSurface_;
    };
    Blockly.WorkspaceSvg.prototype.getWidth = function() {
        var a = this.getMetrics();
        return a ? a.viewWidth / this.scale : 0;
    };
    Blockly.WorkspaceSvg.prototype.setVisible = function(a) {
        this.isVisible_ = a;
        if (this.svgGroup_) {
            if (this.scrollbar && this.scrollbar.setContainerVisible(a), this.getFlyout() && this.getFlyout().setContainerVisible(a), this.getParentSvg().style.display = a ? "block" : "none", this.toolbox_ && this.toolbox_.setVisible(a), a) {
                a = this.getAllBlocks(!1);
                for(var b = a.length - 1; 0 <= b; b--)a[b].markDirty();
                this.render();
                this.toolbox_ && this.toolbox_.position();
            } else Blockly.hideChaff(!0);
        }
    };
    Blockly.WorkspaceSvg.prototype.render = function() {
        for(var a = this.getAllBlocks(!1), b = a.length - 1; 0 <= b; b--)a[b].render(!1);
        if (this.currentGesture_) for(a = this.currentGesture_.getInsertionMarkers(), b = 0; b < a.length; b++)a[b].render(!1);
        this.markerManager_.updateMarkers();
    };
    Blockly.WorkspaceSvg.prototype.highlightBlock = function(a, b) {
        if (void 0 === b) {
            for(var c = 0, d; d = this.highlightedBlocks_[c]; c++)d.setHighlighted(!1);
            this.highlightedBlocks_.length = 0;
        }
        if (d = a ? this.getBlockById(a) : null) (a = void 0 === b || b) ? -1 == this.highlightedBlocks_.indexOf(d) && this.highlightedBlocks_.push(d) : Blockly.utils.arrayRemove(this.highlightedBlocks_, d), d.setHighlighted(a);
    };
    Blockly.WorkspaceSvg.prototype.paste = function(a) {
        !this.rendered || !a.tagName || a.getElementsByTagName("block").length >= this.remainingCapacity() || (this.currentGesture_ && this.currentGesture_.cancel(), "comment" == a.tagName.toLowerCase() ? this.pasteWorkspaceComment_(a) : this.pasteBlock_(a));
    };
    Blockly.WorkspaceSvg.prototype.pasteBlock_ = function(a) {
        Blockly.Events.disable();
        try {
            var b = Blockly.Xml.domToBlock(a, this), c = parseInt(a.getAttribute("x"), 10), d = parseInt(a.getAttribute("y"), 10);
            if (!isNaN(c) && !isNaN(d)) {
                this.RTL && (c = -c);
                do {
                    a = !1;
                    for(var e = this.getAllBlocks(!1), f = 0, g; g = e[f]; f++){
                        var h = g.getRelativeToSurfaceXY();
                        if (1 >= Math.abs(c - h.x) && 1 >= Math.abs(d - h.y)) {
                            a = !0;
                            break;
                        }
                    }
                    if (!a) {
                        var k = b.getConnections_(!1);
                        f = 0;
                        for(var l; l = k[f]; f++)if (l.closest(Blockly.SNAP_RADIUS, new Blockly.utils.Coordinate(c, d)).connection) {
                            a = !0;
                            break;
                        }
                    }
                    a && (c = this.RTL ? c - Blockly.SNAP_RADIUS : c + Blockly.SNAP_RADIUS, d += 2 * Blockly.SNAP_RADIUS);
                }while (a);
                b.moveBy(c, d);
            }
        } finally{
            Blockly.Events.enable();
        }
        Blockly.Events.isEnabled() && !b.isShadow() && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CREATE))(b));
        b.select();
    };
    Blockly.WorkspaceSvg.prototype.pasteWorkspaceComment_ = function(a) {
        Blockly.Events.disable();
        try {
            var b = Blockly.WorkspaceCommentSvg.fromXml(a, this), c = parseInt(a.getAttribute("x"), 10), d = parseInt(a.getAttribute("y"), 10);
            isNaN(c) || isNaN(d) || (this.RTL && (c = -c), b.moveBy(c + 50, d + 50));
        } finally{
            Blockly.Events.enable();
        }
        Blockly.Events.isEnabled() && Blockly.WorkspaceComment.fireCreateEvent(b);
        b.select();
    };
    Blockly.WorkspaceSvg.prototype.refreshToolboxSelection = function() {
        var a = this.isFlyout ? this.targetWorkspace : this;
        a && !a.currentGesture_ && a.toolbox_ && a.toolbox_.getFlyout() && a.toolbox_.refreshSelection();
    };
    Blockly.WorkspaceSvg.prototype.renameVariableById = function(a, b) {
        Blockly.WorkspaceSvg.superClass_.renameVariableById.call(this, a, b);
        this.refreshToolboxSelection();
    };
    Blockly.WorkspaceSvg.prototype.deleteVariableById = function(a) {
        Blockly.WorkspaceSvg.superClass_.deleteVariableById.call(this, a);
        this.refreshToolboxSelection();
    };
    Blockly.WorkspaceSvg.prototype.createVariable = function(a, b, c) {
        a = Blockly.WorkspaceSvg.superClass_.createVariable.call(this, a, b, c);
        this.refreshToolboxSelection();
        return a;
    };
    Blockly.WorkspaceSvg.prototype.recordDeleteAreas = function() {
        this.deleteAreaTrash_ = this.trashcan && this.svgGroup_.parentNode ? this.trashcan.getClientRect() : null;
        this.deleteAreaToolbox_ = this.flyout_ ? this.flyout_.getClientRect() : this.toolbox_ && "function" == typeof this.toolbox_.getClientRect ? this.toolbox_.getClientRect() : null;
    };
    Blockly.WorkspaceSvg.prototype.isDeleteArea = function(a) {
        return this.deleteAreaTrash_ && this.deleteAreaTrash_.contains(a.clientX, a.clientY) ? Blockly.DELETE_AREA_TRASH : this.deleteAreaToolbox_ && this.deleteAreaToolbox_.contains(a.clientX, a.clientY) ? Blockly.DELETE_AREA_TOOLBOX : Blockly.DELETE_AREA_NONE;
    };
    Blockly.WorkspaceSvg.prototype.onMouseDown_ = function(a) {
        var b = this.getGesture(a);
        b && b.handleWsStart(a, this);
    };
    Blockly.WorkspaceSvg.prototype.startDrag = function(a, b) {
        a = Blockly.utils.mouseToSvg(a, this.getParentSvg(), this.getInverseScreenCTM());
        a.x /= this.scale;
        a.y /= this.scale;
        this.dragDeltaXY_ = Blockly.utils.Coordinate.difference(b, a);
    };
    Blockly.WorkspaceSvg.prototype.moveDrag = function(a) {
        a = Blockly.utils.mouseToSvg(a, this.getParentSvg(), this.getInverseScreenCTM());
        a.x /= this.scale;
        a.y /= this.scale;
        return Blockly.utils.Coordinate.sum(this.dragDeltaXY_, a);
    };
    Blockly.WorkspaceSvg.prototype.isDragging = function() {
        return null != this.currentGesture_ && this.currentGesture_.isDragging();
    };
    Blockly.WorkspaceSvg.prototype.isDraggable = function() {
        return this.options.moveOptions && this.options.moveOptions.drag;
    };
    Blockly.WorkspaceSvg.prototype.isMovable = function() {
        return this.options.moveOptions && !!this.options.moveOptions.scrollbars || this.options.moveOptions && this.options.moveOptions.wheel || this.options.moveOptions && this.options.moveOptions.drag || this.options.zoomOptions && this.options.zoomOptions.wheel || this.options.zoomOptions && this.options.zoomOptions.pinch;
    };
    Blockly.WorkspaceSvg.prototype.isMovableHorizontally = function() {
        var a = !!this.scrollbar;
        return this.isMovable() && (!a || a && this.scrollbar.canScrollHorizontally());
    };
    Blockly.WorkspaceSvg.prototype.isMovableVertically = function() {
        var a = !!this.scrollbar;
        return this.isMovable() && (!a || a && this.scrollbar.canScrollVertically());
    };
    Blockly.WorkspaceSvg.prototype.onMouseWheel_ = function(a) {
        if (Blockly.Gesture.inProgress()) a.preventDefault(), a.stopPropagation();
        else {
            var b = this.options.zoomOptions && this.options.zoomOptions.wheel, c = this.options.moveOptions && this.options.moveOptions.wheel;
            if (b || c) {
                var d = Blockly.utils.getScrollDeltaPixels(a);
                !b || !a.ctrlKey && c ? (b = this.scrollX - d.x, c = this.scrollY - d.y, a.shiftKey && !d.x && (b = this.scrollX - d.y, c = this.scrollY), this.scroll(b, c)) : (d = -d.y / 50, b = Blockly.utils.mouseToSvg(a, this.getParentSvg(), this.getInverseScreenCTM()), this.zoom(b.x, b.y, d));
                a.preventDefault();
            }
        }
    };
    Blockly.WorkspaceSvg.prototype.getBlocksBoundingBox = function() {
        var a = this.getTopBoundedElements();
        if (!a.length) return new Blockly.utils.Rect(0, 0, 0, 0);
        for(var b = a[0].getBoundingRectangle(), c = 1; c < a.length; c++){
            var d = a[c];
            d.isInsertionMarker && d.isInsertionMarker() || (d = d.getBoundingRectangle(), d.top < b.top && (b.top = d.top), d.bottom > b.bottom && (b.bottom = d.bottom), d.left < b.left && (b.left = d.left), d.right > b.right && (b.right = d.right));
        }
        return b;
    };
    Blockly.WorkspaceSvg.prototype.cleanUp = function() {
        this.setResizesEnabled(!1);
        Blockly.Events.setGroup(!0);
        for(var a = this.getTopBlocks(!0), b = 0, c = 0, d; d = a[c]; c++)if (d.isMovable()) {
            var e = d.getRelativeToSurfaceXY();
            d.moveBy(-e.x, b - e.y);
            d.snapToGrid();
            b = d.getRelativeToSurfaceXY().y + d.getHeightWidth().height + this.renderer_.getConstants().MIN_BLOCK_HEIGHT;
        }
        Blockly.Events.setGroup(!1);
        this.setResizesEnabled(!0);
    };
    Blockly.WorkspaceSvg.prototype.showContextMenu = function(a) {
        if (!this.options.readOnly && !this.isFlyout) {
            var b = Blockly.ContextMenuRegistry.registry.getContextMenuOptions(Blockly.ContextMenuRegistry.ScopeType.WORKSPACE, {
                workspace: this
            });
            this.configureContextMenu && this.configureContextMenu(b, a);
            Blockly.ContextMenu.show(a, b, this.RTL);
        }
    };
    Blockly.WorkspaceSvg.prototype.updateToolbox = function(a) {
        if (a = Blockly.utils.toolbox.convertToolboxDefToJson(a)) {
            if (!this.options.languageTree) throw Error("Existing toolbox is null.  Can't create new toolbox.");
            if (Blockly.utils.toolbox.hasCategories(a)) {
                if (!this.toolbox_) throw Error("Existing toolbox has no categories.  Can't change mode.");
                this.options.languageTree = a;
                this.toolbox_.render(a);
            } else {
                if (!this.flyout_) throw Error("Existing toolbox has categories.  Can't change mode.");
                this.options.languageTree = a;
                this.flyout_.show(a);
            }
        } else if (this.options.languageTree) throw Error("Can't nullify an existing toolbox.");
    };
    Blockly.WorkspaceSvg.prototype.markFocused = function() {
        this.options.parentWorkspace ? this.options.parentWorkspace.markFocused() : (Blockly.mainWorkspace = this, this.setBrowserFocus());
    };
    Blockly.WorkspaceSvg.prototype.setBrowserFocus = function() {
        document.activeElement && document.activeElement.blur && document.activeElement.blur();
        try {
            this.getParentSvg().focus({
                preventScroll: !0
            });
        } catch (a) {
            try {
                this.getParentSvg().parentNode.setActive();
            } catch (b) {
                this.getParentSvg().parentNode.focus({
                    preventScroll: !0
                });
            }
        }
    };
    Blockly.WorkspaceSvg.prototype.zoom = function(a, b, c) {
        c = Math.pow(this.options.zoomOptions.scaleSpeed, c);
        var d = this.scale * c;
        if (this.scale != d) {
            d > this.options.zoomOptions.maxScale ? c = this.options.zoomOptions.maxScale / this.scale : d < this.options.zoomOptions.minScale && (c = this.options.zoomOptions.minScale / this.scale);
            var e = this.getCanvas().getCTM(), f = this.getParentSvg().createSVGPoint();
            f.x = a;
            f.y = b;
            f = f.matrixTransform(e.inverse());
            a = f.x;
            b = f.y;
            e = e.translate(a * (1 - c), b * (1 - c)).scale(c);
            this.scrollX = e.e;
            this.scrollY = e.f;
            this.setScale(d);
        }
    };
    Blockly.WorkspaceSvg.prototype.zoomCenter = function(a) {
        var b = this.getMetrics();
        if (this.flyout_) {
            var c = b.svgWidth ? b.svgWidth / 2 : 0;
            b = b.svgHeight ? b.svgHeight / 2 : 0;
        } else c = b.viewWidth / 2 + b.absoluteLeft, b = b.viewHeight / 2 + b.absoluteTop;
        this.zoom(c, b, a);
    };
    Blockly.WorkspaceSvg.prototype.zoomToFit = function() {
        if (this.isMovable()) {
            var a = this.getMetrics(), b = a.viewWidth;
            a = a.viewHeight;
            var c = this.getBlocksBoundingBox(), d = c.right - c.left;
            c = c.bottom - c.top;
            if (d) {
                this.flyout_ && (this.horizontalLayout ? (a += this.flyout_.getHeight(), c += this.flyout_.getHeight() / this.scale) : (b += this.flyout_.getWidth(), d += this.flyout_.getWidth() / this.scale));
                b /= d;
                a /= c;
                Blockly.Events.disable();
                try {
                    this.setScale(Math.min(b, a)), this.scrollCenter();
                } finally{
                    Blockly.Events.enable();
                }
                this.maybeFireViewportChangeEvent();
            }
        } else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
    };
    Blockly.WorkspaceSvg.prototype.beginCanvasTransition = function() {
        Blockly.utils.dom.addClass(this.svgBlockCanvas_, "blocklyCanvasTransitioning");
        Blockly.utils.dom.addClass(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
    };
    Blockly.WorkspaceSvg.prototype.endCanvasTransition = function() {
        Blockly.utils.dom.removeClass(this.svgBlockCanvas_, "blocklyCanvasTransitioning");
        Blockly.utils.dom.removeClass(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
    };
    Blockly.WorkspaceSvg.prototype.scrollCenter = function() {
        if (this.isMovable()) {
            var a = this.getMetrics(), b = (a.scrollWidth - a.viewWidth) / 2, c = (a.scrollHeight - a.viewHeight) / 2;
            b = -b - a.scrollLeft;
            c = -c - a.scrollTop;
            this.scroll(b, c);
        } else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
    };
    Blockly.WorkspaceSvg.prototype.centerOnBlock = function(a) {
        if (this.isMovable()) {
            if (a = a ? this.getBlockById(a) : null) {
                var b = a.getRelativeToSurfaceXY(), c = a.getHeightWidth(), d = this.scale;
                a = (b.x + (this.RTL ? -1 : 1) * c.width / 2) * d;
                b = (b.y + c.height / 2) * d;
                c = this.getMetrics();
                this.scroll(-(a - c.viewWidth / 2), -(b - c.viewHeight / 2));
            }
        } else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
    };
    Blockly.WorkspaceSvg.prototype.setScale = function(a) {
        this.options.zoomOptions.maxScale && a > this.options.zoomOptions.maxScale ? a = this.options.zoomOptions.maxScale : this.options.zoomOptions.minScale && a < this.options.zoomOptions.minScale && (a = this.options.zoomOptions.minScale);
        this.scale = a;
        Blockly.hideChaff(!1);
        this.flyout_ && (this.flyout_.reflow(), this.recordDeleteAreas());
        this.grid_ && this.grid_.update(this.scale);
        a = this.getMetrics();
        this.scrollX -= a.absoluteLeft;
        this.scrollY -= a.absoluteTop;
        a.viewLeft += a.absoluteLeft;
        a.viewTop += a.absoluteTop;
        this.scroll(this.scrollX, this.scrollY);
        this.scrollbar && (this.flyout_ ? this.scrollbar.resizeView(a) : this.scrollbar.resizeContent(a));
    };
    Blockly.WorkspaceSvg.prototype.getScale = function() {
        return this.options.parentWorkspace ? this.options.parentWorkspace.getScale() : this.scale;
    };
    Blockly.WorkspaceSvg.prototype.scroll = function(a, b) {
        Blockly.hideChaff(!0);
        var c = this.getMetrics();
        a = Math.min(a, -c.scrollLeft);
        b = Math.min(b, -c.scrollTop);
        var d = c.scrollTop + Math.max(0, c.scrollHeight - c.viewHeight);
        a = Math.max(a, -(c.scrollLeft + Math.max(0, c.scrollWidth - c.viewWidth)));
        b = Math.max(b, -d);
        this.scrollX = a;
        this.scrollY = b;
        this.scrollbar && this.scrollbar.set(-(a + c.scrollLeft), -(b + c.scrollTop), !1);
        a += c.absoluteLeft;
        b += c.absoluteTop;
        this.translate(a, b);
    };
    Blockly.WorkspaceSvg.setTopLevelWorkspaceMetrics_ = function(a) {
        var b = this.getMetrics();
        "number" == typeof a.x && (this.scrollX = -(b.scrollLeft + (b.scrollWidth - b.viewWidth) * a.x));
        "number" == typeof a.y && (this.scrollY = -(b.scrollTop + (b.scrollHeight - b.viewHeight) * a.y));
        this.translate(this.scrollX + b.absoluteLeft, this.scrollY + b.absoluteTop);
    };
    Blockly.WorkspaceSvg.prototype.getBlockById = function(a) {
        return Blockly.WorkspaceSvg.superClass_.getBlockById.call(this, a);
    };
    Blockly.WorkspaceSvg.prototype.getTopBlocks = function(a) {
        return Blockly.WorkspaceSvg.superClass_.getTopBlocks.call(this, a);
    };
    Blockly.WorkspaceSvg.prototype.addTopBlock = function(a) {
        this.addTopBoundedElement(a);
        Blockly.WorkspaceSvg.superClass_.addTopBlock.call(this, a);
    };
    Blockly.WorkspaceSvg.prototype.removeTopBlock = function(a) {
        this.removeTopBoundedElement(a);
        Blockly.WorkspaceSvg.superClass_.removeTopBlock.call(this, a);
    };
    Blockly.WorkspaceSvg.prototype.addTopComment = function(a) {
        this.addTopBoundedElement(a);
        Blockly.WorkspaceSvg.superClass_.addTopComment.call(this, a);
    };
    Blockly.WorkspaceSvg.prototype.removeTopComment = function(a) {
        this.removeTopBoundedElement(a);
        Blockly.WorkspaceSvg.superClass_.removeTopComment.call(this, a);
    };
    Blockly.WorkspaceSvg.prototype.addTopBoundedElement = function(a) {
        this.topBoundedElements_.push(a);
    };
    Blockly.WorkspaceSvg.prototype.removeTopBoundedElement = function(a) {
        Blockly.utils.arrayRemove(this.topBoundedElements_, a);
    };
    Blockly.WorkspaceSvg.prototype.getTopBoundedElements = function() {
        return [].concat(this.topBoundedElements_);
    };
    Blockly.WorkspaceSvg.prototype.setResizesEnabled = function(a) {
        var b = !this.resizesEnabled_ && a;
        this.resizesEnabled_ = a;
        b && this.resizeContents();
    };
    Blockly.WorkspaceSvg.prototype.clear = function() {
        this.setResizesEnabled(!1);
        Blockly.WorkspaceSvg.superClass_.clear.call(this);
        this.topBoundedElements_ = [];
        this.setResizesEnabled(!0);
    };
    Blockly.WorkspaceSvg.prototype.registerButtonCallback = function(a, b) {
        if ("function" != typeof b) throw TypeError("Button callbacks must be functions.");
        this.flyoutButtonCallbacks_[a] = b;
    };
    Blockly.WorkspaceSvg.prototype.getButtonCallback = function(a) {
        return (a = this.flyoutButtonCallbacks_[a]) ? a : null;
    };
    Blockly.WorkspaceSvg.prototype.removeButtonCallback = function(a) {
        this.flyoutButtonCallbacks_[a] = null;
    };
    Blockly.WorkspaceSvg.prototype.registerToolboxCategoryCallback = function(a, b) {
        if ("function" != typeof b) throw TypeError("Toolbox category callbacks must be functions.");
        this.toolboxCategoryCallbacks_[a] = b;
    };
    Blockly.WorkspaceSvg.prototype.getToolboxCategoryCallback = function(a) {
        return this.toolboxCategoryCallbacks_[a] || null;
    };
    Blockly.WorkspaceSvg.prototype.removeToolboxCategoryCallback = function(a) {
        this.toolboxCategoryCallbacks_[a] = null;
    };
    Blockly.WorkspaceSvg.prototype.getGesture = function(a) {
        var b = "mousedown" == a.type || "touchstart" == a.type || "pointerdown" == a.type, c = this.currentGesture_;
        return c ? b && c.hasStarted() ? (console.warn("Tried to start the same gesture twice."), c.cancel(), null) : c : b ? this.currentGesture_ = new Blockly.TouchGesture(a, this) : null;
    };
    Blockly.WorkspaceSvg.prototype.clearGesture = function() {
        this.currentGesture_ = null;
    };
    Blockly.WorkspaceSvg.prototype.cancelCurrentGesture = function() {
        this.currentGesture_ && this.currentGesture_.cancel();
    };
    Blockly.WorkspaceSvg.prototype.getAudioManager = function() {
        return this.audioManager_;
    };
    Blockly.WorkspaceSvg.prototype.getGrid = function() {
        return this.grid_;
    };
    Blockly.inject = function(a, b) {
        Blockly.checkBlockColourConstants();
        "string" == typeof a && (a = document.getElementById(a) || document.querySelector(a));
        if (!a || !Blockly.utils.dom.containsNode(document, a)) throw Error("Error: container is not in current document.");
        b = new Blockly.Options(b || {});
        var c = document.createElement("div");
        c.className = "injectionDiv";
        c.tabIndex = 0;
        Blockly.utils.aria.setState(c, Blockly.utils.aria.State.LABEL, Blockly.Msg.WORKSPACE_ARIA_LABEL);
        a.appendChild(c);
        a = Blockly.createDom_(c, b);
        var d = new Blockly.BlockDragSurfaceSvg(c), e = new Blockly.WorkspaceDragSurfaceSvg(c), f = Blockly.createMainWorkspace_(a, b, d, e);
        Blockly.init_(f);
        Blockly.mainWorkspace = f;
        Blockly.svgResize(f);
        c.addEventListener("focusin", function() {
            Blockly.mainWorkspace = f;
        });
        return f;
    };
    Blockly.createDom_ = function(a, b) {
        a.setAttribute("dir", "LTR");
        Blockly.Css.inject(b.hasCss, b.pathToMedia);
        a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
            xmlns: Blockly.utils.dom.SVG_NS,
            "xmlns:html": Blockly.utils.dom.HTML_NS,
            "xmlns:xlink": Blockly.utils.dom.XLINK_NS,
            version: "1.1",
            "class": "blocklySvg",
            tabindex: "0"
        }, a);
        var c = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.DEFS, {}, a), d = String(Math.random()).substring(2);
        b.gridPattern = Blockly.Grid.createDom(d, b.gridOptions, c);
        return a;
    };
    Blockly.createMainWorkspace_ = function(a, b, c, d) {
        b.parentWorkspace = null;
        b = new Blockly.WorkspaceSvg(b, c, d);
        c = b.options;
        b.scale = c.zoomOptions.startScale;
        a.appendChild(b.createDom("blocklyMainBackground"));
        Blockly.utils.dom.addClass(b.getInjectionDiv(), b.getRenderer().getClassName());
        Blockly.utils.dom.addClass(b.getInjectionDiv(), b.getTheme().getClassName());
        !c.hasCategories && c.languageTree && (d = b.addFlyout(Blockly.utils.Svg.SVG), Blockly.utils.dom.insertAfter(d, a));
        c.hasTrashcan && b.addTrashcan();
        c.zoomOptions && c.zoomOptions.controls && b.addZoomControls();
        b.getThemeManager().subscribe(a, "workspaceBackgroundColour", "background-color");
        b.translate(0, 0);
        b.addChangeListener(Blockly.bumpIntoBoundsHandler_(b));
        Blockly.svgResize(b);
        Blockly.WidgetDiv.createDom();
        Blockly.DropDownDiv.createDom();
        Blockly.Tooltip.createDom();
        return b;
    };
    Blockly.extractObjectFromEvent_ = function(a, b) {
        var c = null;
        switch(b.type){
            case Blockly.Events.BLOCK_CREATE:
            case Blockly.Events.BLOCK_MOVE:
                (c = a.getBlockById(b.blockId)) && (c = c.getRootBlock());
                break;
            case Blockly.Events.COMMENT_CREATE:
            case Blockly.Events.COMMENT_MOVE:
                c = a.getCommentById(b.commentId);
        }
        return c;
    };
    Blockly.bumpTopObjectsIntoBounds_ = function(a) {
        var b = a.getMetricsManager();
        if (b.hasFixedEdges() && !a.isDragging()) {
            b = b.getScrollMetrics(!0);
            for(var c = a.getTopBoundedElements(), d = 0, e; e = c[d]; d++)Blockly.bumpObjectIntoBounds_(a, b, e);
        }
    };
    Blockly.bumpIntoBoundsHandler_ = function(a) {
        return function(b) {
            var c = a.getMetricsManager();
            if (c.hasFixedEdges && !a.isDragging()) {
                if (-1 !== Blockly.Events.BUMP_EVENTS.indexOf(b.type)) {
                    c = c.getScrollMetrics(!0);
                    var d = Blockly.extractObjectFromEvent_(a, b);
                    if (d) {
                        var e = Blockly.Events.getGroup();
                        Blockly.Events.setGroup(b.group);
                        Blockly.bumpObjectIntoBounds_(a, c, d) && !b.group && console.warn("Moved object in bounds but there was no event group. This may break undo.");
                        null !== e && Blockly.Events.setGroup(e);
                    }
                } else b.type === Blockly.Events.VIEWPORT_CHANGE && b.scale > b.oldScale && Blockly.bumpTopObjectsIntoBounds_(a);
            }
        };
    };
    Blockly.bumpObjectIntoBounds_ = function(a, b, c) {
        var d = c.getBoundingRectangle(), e = d.right - d.left, f = Blockly.utils.math.clamp(b.top, d.top, b.top + b.height - (d.bottom - d.top)) - d.top, g = b.left;
        b = b.left + b.width - e;
        a.RTL ? g = Math.min(b, g) : b = Math.max(g, b);
        return (a = Blockly.utils.math.clamp(g, d.left, b) - d.left) || f ? (c.moveBy(a, f), !0) : !1;
    };
    Blockly.init_ = function(a) {
        var b = a.options, c = a.getParentSvg();
        Blockly.browserEvents.conditionalBind(c.parentNode, "contextmenu", null, function(e) {
            Blockly.utils.isTargetInput(e) || e.preventDefault();
        });
        c = Blockly.browserEvents.conditionalBind(window, "resize", null, function() {
            Blockly.hideChaff(!0);
            Blockly.svgResize(a);
            Blockly.bumpTopObjectsIntoBounds_(a);
        });
        a.setResizeHandlerWrapper(c);
        Blockly.inject.bindDocumentEvents_();
        if (b.languageTree) {
            c = a.getToolbox();
            var d = a.getFlyout(!0);
            c ? c.init() : d && (d.init(a), d.show(b.languageTree), "function" == typeof d.scrollToStart && d.scrollToStart());
        }
        c = Blockly.Scrollbar.scrollbarThickness;
        b.hasTrashcan && (c = a.trashcan.init(c));
        b.zoomOptions && b.zoomOptions.controls && a.zoomControls_.init(c);
        b.moveOptions && b.moveOptions.scrollbars ? (a.scrollbar = new Blockly.ScrollbarPair(a, !0 === b.moveOptions.scrollbars || !!b.moveOptions.scrollbars.horizontal, !0 === b.moveOptions.scrollbars || !!b.moveOptions.scrollbars.vertical, "blocklyMainWorkspaceScrollbar"), a.scrollbar.resize()) : a.setMetrics({
            x: .5,
            y: .5
        });
        b.hasSounds && Blockly.inject.loadSounds_(b.pathToMedia, a);
    };
    Blockly.inject.bindDocumentEvents_ = function() {
        Blockly.documentEventsBound_ || (Blockly.browserEvents.conditionalBind(document, "scroll", null, function() {
            for(var a = Blockly.Workspace.getAll(), b = 0, c; c = a[b]; b++)c.updateInverseScreenCTM && c.updateInverseScreenCTM();
        }), Blockly.browserEvents.conditionalBind(document, "keydown", null, Blockly.onKeyDown), Blockly.browserEvents.bind(document, "touchend", null, Blockly.longStop_), Blockly.browserEvents.bind(document, "touchcancel", null, Blockly.longStop_), Blockly.utils.userAgent.IPAD && Blockly.browserEvents.conditionalBind(window, "orientationchange", document, function() {
            Blockly.svgResize(Blockly.getMainWorkspace());
        }));
        Blockly.documentEventsBound_ = !0;
    };
    Blockly.inject.loadSounds_ = function(a, b) {
        var c = b.getAudioManager();
        c.load([
            a + "click.mp3",
            a + "click.wav",
            a + "click.ogg"
        ], "click");
        c.load([
            a + "disconnect.wav",
            a + "disconnect.mp3",
            a + "disconnect.ogg"
        ], "disconnect");
        c.load([
            a + "delete.mp3",
            a + "delete.ogg",
            a + "delete.wav"
        ], "delete");
        var d = [];
        a = function() {
            for(; d.length;)Blockly.browserEvents.unbind(d.pop());
            c.preload();
        };
        d.push(Blockly.browserEvents.conditionalBind(document, "mousemove", null, a, !0));
        d.push(Blockly.browserEvents.conditionalBind(document, "touchstart", null, a, !0));
    };
    Blockly.Names = function(a, b) {
        this.variablePrefix_ = b || "";
        this.reservedDict_ = Object.create(null);
        if (a) for(a = a.split(","), b = 0; b < a.length; b++)this.reservedDict_[a[b]] = !0;
        this.reset();
    };
    Blockly.Names.DEVELOPER_VARIABLE_TYPE = "DEVELOPER_VARIABLE";
    Blockly.Names.prototype.reset = function() {
        this.db_ = Object.create(null);
        this.dbReverse_ = Object.create(null);
        this.variableMap_ = null;
    };
    Blockly.Names.prototype.setVariableMap = function(a) {
        this.variableMap_ = a;
    };
    Blockly.Names.prototype.getNameForUserVariable_ = function(a) {
        return this.variableMap_ ? (a = this.variableMap_.getVariableById(a)) ? a.name : null : (console.log("Deprecated call to Blockly.Names.prototype.getName without defining a variable map. To fix, add the following code in your generator's init() function:\nBlockly.YourGeneratorName.variableDB_.setVariableMap(workspace.getVariableMap());"), null);
    };
    Blockly.Names.prototype.getName = function(a, b) {
        if (b == Blockly.VARIABLE_CATEGORY_NAME) {
            var c = this.getNameForUserVariable_(a);
            c && (a = c);
        }
        c = a.toLowerCase() + "_" + b;
        var d = b == Blockly.VARIABLE_CATEGORY_NAME || b == Blockly.Names.DEVELOPER_VARIABLE_TYPE ? this.variablePrefix_ : "";
        if (c in this.db_) return d + this.db_[c];
        a = this.getDistinctName(a, b);
        this.db_[c] = a.substr(d.length);
        return a;
    };
    Blockly.Names.prototype.getDistinctName = function(a, b) {
        a = this.safeName_(a);
        for(var c = ""; this.dbReverse_[a + c] || a + c in this.reservedDict_;)c = c ? c + 1 : 2;
        a += c;
        this.dbReverse_[a] = !0;
        return (b == Blockly.VARIABLE_CATEGORY_NAME || b == Blockly.Names.DEVELOPER_VARIABLE_TYPE ? this.variablePrefix_ : "") + a;
    };
    Blockly.Names.prototype.safeName_ = function(a) {
        a ? (a = encodeURI(a.replace(/ /g, "_")).replace(/[^\w]/g, "_"), -1 != "0123456789".indexOf(a[0]) && (a = "my_" + a)) : a = Blockly.Msg.UNNAMED_KEY || "unnamed";
        return a;
    };
    Blockly.Names.equals = function(a, b) {
        return a.toLowerCase() == b.toLowerCase();
    };
    Blockly.Procedures = {};
    Blockly.Procedures.NAME_TYPE = Blockly.PROCEDURE_CATEGORY_NAME;
    Blockly.Procedures.DEFAULT_ARG = "x";
    Blockly.Procedures.allProcedures = function(a) {
        var b = a.getBlocksByType("procedures_defnoreturn", !1).map(function(c) {
            return c.getProcedureDef();
        });
        a = a.getBlocksByType("procedures_defreturn", !1).map(function(c) {
            return c.getProcedureDef();
        });
        b.sort(Blockly.Procedures.procTupleComparator_);
        a.sort(Blockly.Procedures.procTupleComparator_);
        return [
            b,
            a
        ];
    };
    Blockly.Procedures.procTupleComparator_ = function(a, b) {
        return a[0].toLowerCase().localeCompare(b[0].toLowerCase());
    };
    Blockly.Procedures.findLegalName = function(a, b) {
        if (b.isInFlyout) return a;
        for(a = a || Blockly.Msg.UNNAMED_KEY || "unnamed"; !Blockly.Procedures.isLegalName_(a, b.workspace, b);){
            var c = a.match(/^(.*?)(\d+)$/);
            a = c ? c[1] + (parseInt(c[2], 10) + 1) : a + "2";
        }
        return a;
    };
    Blockly.Procedures.isLegalName_ = function(a, b, c) {
        return !Blockly.Procedures.isNameUsed(a, b, c);
    };
    Blockly.Procedures.isNameUsed = function(a, b, c) {
        b = b.getAllBlocks(!1);
        for(var d = 0; d < b.length; d++)if (b[d] != c && b[d].getProcedureDef) {
            var e = b[d].getProcedureDef();
            if (Blockly.Names.equals(e[0], a)) return !0;
        }
        return !1;
    };
    Blockly.Procedures.rename = function(a) {
        a = a.trim();
        var b = Blockly.Procedures.findLegalName(a, this.getSourceBlock()), c = this.getValue();
        if (c != a && c != b) {
            a = this.getSourceBlock().workspace.getAllBlocks(!1);
            for(var d = 0; d < a.length; d++)a[d].renameProcedure && a[d].renameProcedure(c, b);
        }
        return b;
    };
    Blockly.Procedures.flyoutCategory = function(a) {
        function b(f, g) {
            for(var h = 0; h < f.length; h++){
                var k = f[h][0], l = f[h][1], m = Blockly.utils.xml.createElement("block");
                m.setAttribute("type", g);
                m.setAttribute("gap", 16);
                var n = Blockly.utils.xml.createElement("mutation");
                n.setAttribute("name", k);
                m.appendChild(n);
                for(k = 0; k < l.length; k++){
                    var p = Blockly.utils.xml.createElement("arg");
                    p.setAttribute("name", l[k]);
                    n.appendChild(p);
                }
                c.push(m);
            }
        }
        var c = [];
        if (Blockly.Blocks.procedures_defnoreturn) {
            var d = Blockly.utils.xml.createElement("block");
            d.setAttribute("type", "procedures_defnoreturn");
            d.setAttribute("gap", 16);
            var e = Blockly.utils.xml.createElement("field");
            e.setAttribute("name", "NAME");
            e.appendChild(Blockly.utils.xml.createTextNode(Blockly.Msg.PROCEDURES_DEFNORETURN_PROCEDURE));
            d.appendChild(e);
            c.push(d);
        }
        Blockly.Blocks.procedures_defreturn && (d = Blockly.utils.xml.createElement("block"), d.setAttribute("type", "procedures_defreturn"), d.setAttribute("gap", 16), e = Blockly.utils.xml.createElement("field"), e.setAttribute("name", "NAME"), e.appendChild(Blockly.utils.xml.createTextNode(Blockly.Msg.PROCEDURES_DEFRETURN_PROCEDURE)), d.appendChild(e), c.push(d));
        Blockly.Blocks.procedures_ifreturn && (d = Blockly.utils.xml.createElement("block"), d.setAttribute("type", "procedures_ifreturn"), d.setAttribute("gap", 16), c.push(d));
        c.length && c[c.length - 1].setAttribute("gap", 24);
        a = Blockly.Procedures.allProcedures(a);
        b(a[0], "procedures_callnoreturn");
        b(a[1], "procedures_callreturn");
        return c;
    };
    Blockly.Procedures.updateMutatorFlyout_ = function(a) {
        for(var b = [], c = a.getBlocksByType("procedures_mutatorarg", !1), d = 0, e; e = c[d]; d++)b.push(e.getFieldValue("NAME"));
        c = Blockly.utils.xml.createElement("xml");
        d = Blockly.utils.xml.createElement("block");
        d.setAttribute("type", "procedures_mutatorarg");
        e = Blockly.utils.xml.createElement("field");
        e.setAttribute("name", "NAME");
        b = Blockly.Variables.generateUniqueNameFromOptions(Blockly.Procedures.DEFAULT_ARG, b);
        b = Blockly.utils.xml.createTextNode(b);
        e.appendChild(b);
        d.appendChild(e);
        c.appendChild(d);
        a.updateToolbox(c);
    };
    Blockly.Procedures.mutatorOpenListener = function(a) {
        if (a.type == Blockly.Events.BUBBLE_OPEN && "mutator" === a.bubbleType && a.isOpen) {
            a = Blockly.Workspace.getById(a.workspaceId).getBlockById(a.blockId);
            var b = a.type;
            if ("procedures_defnoreturn" == b || "procedures_defreturn" == b) a = a.mutator.getWorkspace(), Blockly.Procedures.updateMutatorFlyout_(a), a.addChangeListener(Blockly.Procedures.mutatorChangeListener_);
        }
    };
    Blockly.Procedures.mutatorChangeListener_ = function(a) {
        if (a.type == Blockly.Events.BLOCK_CREATE || a.type == Blockly.Events.BLOCK_DELETE || a.type == Blockly.Events.BLOCK_CHANGE) a = Blockly.Workspace.getById(a.workspaceId), Blockly.Procedures.updateMutatorFlyout_(a);
    };
    Blockly.Procedures.getCallers = function(a, b) {
        var c = [];
        b = b.getAllBlocks(!1);
        for(var d = 0; d < b.length; d++)if (b[d].getProcedureCall) {
            var e = b[d].getProcedureCall();
            e && Blockly.Names.equals(e, a) && c.push(b[d]);
        }
        return c;
    };
    Blockly.Procedures.mutateCallers = function(a) {
        var b = Blockly.Events.recordUndo, c = a.getProcedureDef()[0], d = a.mutationToDom(!0);
        a = Blockly.Procedures.getCallers(c, a.workspace);
        c = 0;
        for(var e; e = a[c]; c++){
            var f = e.mutationToDom();
            f = f && Blockly.Xml.domToText(f);
            e.domToMutation(d);
            var g = e.mutationToDom();
            g = g && Blockly.Xml.domToText(g);
            f != g && (Blockly.Events.recordUndo = !1, Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(e, "mutation", null, f, g)), Blockly.Events.recordUndo = b);
        }
    };
    Blockly.Procedures.getDefinition = function(a, b) {
        b = b.getTopBlocks(!1);
        for(var c = 0; c < b.length; c++)if (b[c].getProcedureDef) {
            var d = b[c].getProcedureDef();
            if (d && Blockly.Names.equals(d[0], a)) return b[c];
        }
        return null;
    };
    Blockly.ShortcutRegistry = function() {
        Blockly.ShortcutRegistry.registry = this;
        this.registry_ = Object.create(null);
        this.keyMap_ = Object.create(null);
    };
    Blockly.ShortcutRegistry.modifierKeys = {
        Shift: Blockly.utils.KeyCodes.SHIFT,
        Control: Blockly.utils.KeyCodes.CTRL,
        Alt: Blockly.utils.KeyCodes.ALT,
        Meta: Blockly.utils.KeyCodes.META
    };
    Blockly.ShortcutRegistry.prototype.register = function(a, b) {
        if (this.registry_[a.name] && !b) throw Error('Shortcut with name "' + a.name + '" already exists.');
        this.registry_[a.name] = a;
    };
    Blockly.ShortcutRegistry.prototype.unregister = function(a) {
        if (!this.registry_[a]) return console.warn('Keyboard shortcut with name "' + a + '" not found.'), !1;
        this.removeAllKeyMappings(a);
        delete this.registry_[a];
        return !0;
    };
    Blockly.ShortcutRegistry.prototype.addKeyMapping = function(a, b, c) {
        a = String(a);
        var d = this.keyMap_[a];
        if (d && !c) throw Error('Shortcut with name "' + b + '" collides with shortcuts ' + d.toString());
        d && c ? d.unshift(b) : this.keyMap_[a] = [
            b
        ];
    };
    Blockly.ShortcutRegistry.prototype.removeKeyMapping = function(a, b, c) {
        var d = this.keyMap_[a];
        if (!d && !c) return console.warn('No keyboard shortcut with name "' + b + '" registered with key code "' + a + '"'), !1;
        var e = d.indexOf(b);
        if (-1 < e) return d.splice(e, 1), 0 == d.length && delete this.keyMap_[a], !0;
        c || console.warn('No keyboard shortcut with name "' + b + '" registered with key code "' + a + '"');
        return !1;
    };
    Blockly.ShortcutRegistry.prototype.removeAllKeyMappings = function(a) {
        for(var b in this.keyMap_)this.removeKeyMapping(b, a, !0);
    };
    Blockly.ShortcutRegistry.prototype.setKeyMap = function(a) {
        this.keyMap_ = a;
    };
    Blockly.ShortcutRegistry.prototype.getKeyMap = function() {
        return Blockly.utils.object.deepMerge(Object.create(null), this.keyMap_);
    };
    Blockly.ShortcutRegistry.prototype.getRegistry = function() {
        return Blockly.utils.object.deepMerge(Object.create(null), this.registry_);
    };
    Blockly.ShortcutRegistry.prototype.onKeyDown = function(a, b) {
        var c = this.serializeKeyEvent_(b);
        c = this.getShortcutNamesByKeyCode(c);
        if (!c) return !1;
        for(var d = 0, e; e = c[d]; d++)if (e = this.registry_[e], (!e.preconditionFn || e.preconditionFn(a)) && e.callback && e.callback(a, b, e)) return !0;
        return !1;
    };
    Blockly.ShortcutRegistry.prototype.getShortcutNamesByKeyCode = function(a) {
        return this.keyMap_[a] || [];
    };
    Blockly.ShortcutRegistry.prototype.getKeyCodesByShortcutName = function(a) {
        var b = [], c;
        for(c in this.keyMap_)-1 < this.keyMap_[c].indexOf(a) && b.push(c);
        return b;
    };
    Blockly.ShortcutRegistry.prototype.serializeKeyEvent_ = function(a) {
        var b = "", c;
        for(c in Blockly.ShortcutRegistry.modifierKeys)a.getModifierState(c) && ("" != b && (b += "+"), b += c);
        "" != b && a.keyCode ? b = b + "+" + a.keyCode : a.keyCode && (b = a.keyCode.toString());
        return b;
    };
    Blockly.ShortcutRegistry.prototype.checkModifiers_ = function(a) {
        for(var b = Blockly.utils.object.values(Blockly.ShortcutRegistry.modifierKeys), c = 0, d; d = a[c]; c++)if (0 > b.indexOf(d)) throw Error(d + " is not a valid modifier key.");
    };
    Blockly.ShortcutRegistry.prototype.createSerializedKey = function(a, b) {
        var c = "";
        if (b) {
            this.checkModifiers_(b);
            for(var d in Blockly.ShortcutRegistry.modifierKeys)-1 < b.indexOf(Blockly.ShortcutRegistry.modifierKeys[d]) && ("" != c && (c += "+"), c += d);
        }
        "" != c && a ? c = c + "+" + a : a && (c = a.toString());
        return c;
    };
    new Blockly.ShortcutRegistry;
    Blockly.VariableModel = function(a, b, c, d) {
        this.workspace = a;
        this.name = b;
        this.type = c || "";
        this.id_ = d || Blockly.utils.genUid();
        Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.VAR_CREATE))(this));
    };
    Blockly.VariableModel.prototype.getId = function() {
        return this.id_;
    };
    Blockly.VariableModel.compareByName = function(a, b) {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a < b ? -1 : a == b ? 0 : 1;
    };
    Blockly.Variables = {};
    Blockly.Variables.NAME_TYPE = Blockly.VARIABLE_CATEGORY_NAME;
    Blockly.Variables.allUsedVarModels = function(a) {
        var b = a.getAllBlocks(!1);
        a = Object.create(null);
        for(var c = 0; c < b.length; c++){
            var d = b[c].getVarModels();
            if (d) for(var e = 0; e < d.length; e++){
                var f = d[e], g = f.getId();
                g && (a[g] = f);
            }
        }
        b = [];
        for(g in a)b.push(a[g]);
        return b;
    };
    Blockly.Variables.ALL_DEVELOPER_VARS_WARNINGS_BY_BLOCK_TYPE_ = {};
    Blockly.Variables.allDeveloperVariables = function(a) {
        a = a.getAllBlocks(!1);
        for(var b = Object.create(null), c = 0, d; d = a[c]; c++){
            var e = d.getDeveloperVariables;
            !e && d.getDeveloperVars && (e = d.getDeveloperVars, Blockly.Variables.ALL_DEVELOPER_VARS_WARNINGS_BY_BLOCK_TYPE_[d.type] || (console.warn("Function getDeveloperVars() deprecated. Use getDeveloperVariables() (block type '" + d.type + "')"), Blockly.Variables.ALL_DEVELOPER_VARS_WARNINGS_BY_BLOCK_TYPE_[d.type] = !0));
            if (e) for(d = e(), e = 0; e < d.length; e++)b[d[e]] = !0;
        }
        return Object.keys(b);
    };
    Blockly.Variables.flyoutCategory = function(a) {
        var b = [], c = document.createElement("button");
        c.setAttribute("text", "%{BKY_NEW_VARIABLE}");
        c.setAttribute("callbackKey", "CREATE_VARIABLE");
        a.registerButtonCallback("CREATE_VARIABLE", function(d) {
            Blockly.Variables.createVariableButtonHandler(d.getTargetWorkspace());
        });
        b.push(c);
        a = Blockly.Variables.flyoutCategoryBlocks(a);
        return b = b.concat(a);
    };
    Blockly.Variables.flyoutCategoryBlocks = function(a) {
        a = a.getVariablesOfType("");
        var b = [];
        if (0 < a.length) {
            var c = a[a.length - 1];
            if (Blockly.Blocks.variables_set) {
                var d = Blockly.utils.xml.createElement("block");
                d.setAttribute("type", "variables_set");
                d.setAttribute("gap", Blockly.Blocks.math_change ? 8 : 24);
                d.appendChild(Blockly.Variables.generateVariableFieldDom(c));
                b.push(d);
            }
            Blockly.Blocks.math_change && (d = Blockly.utils.xml.createElement("block"), d.setAttribute("type", "math_change"), d.setAttribute("gap", Blockly.Blocks.variables_get ? 20 : 8), d.appendChild(Blockly.Variables.generateVariableFieldDom(c)), c = Blockly.Xml.textToDom('<value name="DELTA"><shadow type="math_number"><field name="NUM">1</field></shadow></value>'), d.appendChild(c), b.push(d));
            if (Blockly.Blocks.variables_get) {
                a.sort(Blockly.VariableModel.compareByName);
                c = 0;
                for(var e; e = a[c]; c++)d = Blockly.utils.xml.createElement("block"), d.setAttribute("type", "variables_get"), d.setAttribute("gap", 8), d.appendChild(Blockly.Variables.generateVariableFieldDom(e)), b.push(d);
            }
        }
        return b;
    };
    Blockly.Variables.VAR_LETTER_OPTIONS = "ijkmnopqrstuvwxyzabcdefgh";
    Blockly.Variables.generateUniqueName = function(a) {
        return Blockly.Variables.generateUniqueNameFromOptions(Blockly.Variables.VAR_LETTER_OPTIONS.charAt(0), a.getAllVariableNames());
    };
    Blockly.Variables.generateUniqueNameFromOptions = function(a, b) {
        if (!b.length) return a;
        for(var c = Blockly.Variables.VAR_LETTER_OPTIONS, d = "", e = c.indexOf(a);;){
            for(var f = !1, g = 0; g < b.length; g++)if (b[g].toLowerCase() == a) {
                f = !0;
                break;
            }
            if (!f) return a;
            e++;
            e == c.length && (e = 0, d = Number(d) + 1);
            a = c.charAt(e) + d;
        }
    };
    Blockly.Variables.createVariableButtonHandler = function(a, b, c) {
        var d = c || "", e = function(f) {
            Blockly.Variables.promptName(Blockly.Msg.NEW_VARIABLE_TITLE, f, function(g) {
                if (g) {
                    var h = Blockly.Variables.nameUsedWithAnyType(g, a);
                    if (h) {
                        if (h.type == d) var k = Blockly.Msg.VARIABLE_ALREADY_EXISTS.replace("%1", h.name);
                        else k = Blockly.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE, k = k.replace("%1", h.name).replace("%2", h.type);
                        Blockly.alert(k, function() {
                            e(g);
                        });
                    } else a.createVariable(g, d), b && b(g);
                } else b && b(null);
            });
        };
        e("");
    };
    Blockly.Variables.createVariable = Blockly.Variables.createVariableButtonHandler;
    Blockly.Variables.renameVariable = function(a, b, c) {
        var d = function(e) {
            var f = Blockly.Msg.RENAME_VARIABLE_TITLE.replace("%1", b.name);
            Blockly.Variables.promptName(f, e, function(g) {
                if (g) {
                    var h = Blockly.Variables.nameUsedWithOtherType_(g, b.type, a);
                    h ? (h = Blockly.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE.replace("%1", h.name).replace("%2", h.type), Blockly.alert(h, function() {
                        d(g);
                    })) : (a.renameVariableById(b.getId(), g), c && c(g));
                } else c && c(null);
            });
        };
        d("");
    };
    Blockly.Variables.promptName = function(a, b, c) {
        Blockly.prompt(a, b, function(d) {
            d && (d = d.replace(/[\s\xa0]+/g, " ").trim(), d == Blockly.Msg.RENAME_VARIABLE || d == Blockly.Msg.NEW_VARIABLE) && (d = null);
            c(d);
        });
    };
    Blockly.Variables.nameUsedWithOtherType_ = function(a, b, c) {
        c = c.getVariableMap().getAllVariables();
        a = a.toLowerCase();
        for(var d = 0, e; e = c[d]; d++)if (e.name.toLowerCase() == a && e.type != b) return e;
        return null;
    };
    Blockly.Variables.nameUsedWithAnyType = function(a, b) {
        b = b.getVariableMap().getAllVariables();
        a = a.toLowerCase();
        for(var c = 0, d; d = b[c]; c++)if (d.name.toLowerCase() == a) return d;
        return null;
    };
    Blockly.Variables.generateVariableFieldDom = function(a) {
        var b = Blockly.utils.xml.createElement("field");
        b.setAttribute("name", "VAR");
        b.setAttribute("id", a.getId());
        b.setAttribute("variabletype", a.type);
        a = Blockly.utils.xml.createTextNode(a.name);
        b.appendChild(a);
        return b;
    };
    Blockly.Variables.getOrCreateVariablePackage = function(a, b, c, d) {
        var e = Blockly.Variables.getVariable(a, b, c, d);
        e || (e = Blockly.Variables.createVariable_(a, b, c, d));
        return e;
    };
    Blockly.Variables.getVariable = function(a, b, c, d) {
        var e = a.getPotentialVariableMap(), f = null;
        if (b && (f = a.getVariableById(b), !f && e && (f = e.getVariableById(b)), f)) return f;
        if (c) {
            if (void 0 == d) throw Error("Tried to look up a variable by name without a type");
            f = a.getVariable(c, d);
            !f && e && (f = e.getVariable(c, d));
        }
        return f;
    };
    Blockly.Variables.createVariable_ = function(a, b, c, d) {
        var e = a.getPotentialVariableMap();
        c || (c = Blockly.Variables.generateUniqueName(a.isFlyout ? a.targetWorkspace : a));
        return e ? e.createVariable(c, d, b) : a.createVariable(c, d, b);
    };
    Blockly.Variables.getAddedVariables = function(a, b) {
        a = a.getAllVariables();
        var c = [];
        if (b.length != a.length) for(var d = 0; d < a.length; d++){
            var e = a[d];
            -1 == b.indexOf(e) && c.push(e);
        }
        return c;
    };
    Blockly.VERSION = "5.20210325.1";
    Blockly.mainWorkspace = null;
    Blockly.selected = null;
    Blockly.draggingConnections = [];
    Blockly.clipboardXml_ = null;
    Blockly.clipboardSource_ = null;
    Blockly.clipboardTypeCounts_ = null;
    Blockly.cache3dSupported_ = null;
    Blockly.parentContainer = null;
    Blockly.svgSize = function(a) {
        Blockly.utils.deprecation.warn("Blockly.svgSize", "March 2021", "March 2022", "workspace.getCachedParentSvgSize");
        return new Blockly.utils.Size(a.cachedWidth_, a.cachedHeight_);
    };
    Blockly.resizeSvgContents = function(a) {
        a.resizeContents();
    };
    Blockly.svgResize = function(a) {
        for(; a.options.parentWorkspace;)a = a.options.parentWorkspace;
        var b = a.getParentSvg(), c = a.getCachedParentSvgSize(), d = b.parentNode;
        if (d) {
            var e = d.offsetWidth;
            d = d.offsetHeight;
            c.width != e && (b.setAttribute("width", e + "px"), a.setCachedParentSvgSize(e, null));
            c.height != d && (b.setAttribute("height", d + "px"), a.setCachedParentSvgSize(null, d));
            a.resize();
        }
    };
    Blockly.onKeyDown = function(a) {
        var b = Blockly.mainWorkspace;
        if (b && !(Blockly.utils.isTargetInput(a) || b.rendered && !b.isVisible())) Blockly.ShortcutRegistry.registry.onKeyDown(b, a);
    };
    Blockly.deleteBlock = function(a) {
        a.workspace.isFlyout || (Blockly.Events.setGroup(!0), Blockly.hideChaff(), a.dispose(!0, !0), Blockly.Events.setGroup(!1));
    };
    Blockly.copy = function(a) {
        if (a = a.toCopyData()) Blockly.clipboardXml_ = a.xml, Blockly.clipboardSource_ = a.source, Blockly.clipboardTypeCounts_ = a.typeCounts;
    };
    Blockly.paste = function() {
        if (!Blockly.clipboardXml_) return !1;
        var a = Blockly.clipboardSource_;
        a.isFlyout && (a = a.targetWorkspace);
        return Blockly.clipboardTypeCounts_ && a.isCapacityAvailable(Blockly.clipboardTypeCounts_) ? (Blockly.Events.setGroup(!0), a.paste(Blockly.clipboardXml_), Blockly.Events.setGroup(!1), !0) : !1;
    };
    Blockly.duplicate = function(a) {
        var b = Blockly.clipboardXml_, c = Blockly.clipboardSource_;
        Blockly.copy(a);
        a.workspace.paste(Blockly.clipboardXml_);
        Blockly.clipboardXml_ = b;
        Blockly.clipboardSource_ = c;
    };
    Blockly.onContextMenu_ = function(a) {
        Blockly.utils.isTargetInput(a) || a.preventDefault();
    };
    Blockly.hideChaff = function(a) {
        Blockly.Tooltip.hide();
        Blockly.WidgetDiv.hide();
        Blockly.DropDownDiv.hideWithoutAnimation();
        a || (a = Blockly.getMainWorkspace(), a.trashcan && a.trashcan.flyout && a.trashcan.closeFlyout(), (a = a.getToolbox()) && a.getFlyout() && a.getFlyout().autoClose && a.clearSelection());
    };
    Blockly.getMainWorkspace = function() {
        return Blockly.mainWorkspace;
    };
    Blockly.alert = function(a, b) {
        alert(a);
        b && b();
    };
    Blockly.confirm = function(a, b) {
        b(confirm(a));
    };
    Blockly.prompt = function(a, b, c) {
        c(prompt(a, b));
    };
    Blockly.jsonInitFactory_ = function(a) {
        return function() {
            this.jsonInit(a);
        };
    };
    Blockly.defineBlocksWithJsonArray = function(a) {
        for(var b = 0; b < a.length; b++){
            var c = a[b];
            if (c) {
                var d = c.type;
                null == d || "" === d ? console.warn("Block definition #" + b + " in JSON array is missing a type attribute. Skipping.") : (Blockly.Blocks[d] && console.warn("Block definition #" + b + ' in JSON array overwrites prior definition of "' + d + '".'), Blockly.Blocks[d] = {
                    init: Blockly.jsonInitFactory_(c)
                });
            } else console.warn("Block definition #" + b + " in JSON array is " + c + ". Skipping.");
        }
    };
    Blockly.isNumber = function(a) {
        return /^\s*-?\d+(\.\d+)?\s*$/.test(a);
    };
    Blockly.hueToHex = function(a) {
        return Blockly.utils.colour.hsvToHex(a, Blockly.HSV_SATURATION, 255 * Blockly.HSV_VALUE);
    };
    Blockly.checkBlockColourConstants = function() {
        Blockly.checkBlockColourConstant_("LOGIC_HUE", [
            "Blocks",
            "logic",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("LOGIC_HUE", [
            "Constants",
            "Logic",
            "HUE"
        ], 210);
        Blockly.checkBlockColourConstant_("LOOPS_HUE", [
            "Blocks",
            "loops",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("LOOPS_HUE", [
            "Constants",
            "Loops",
            "HUE"
        ], 120);
        Blockly.checkBlockColourConstant_("MATH_HUE", [
            "Blocks",
            "math",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("MATH_HUE", [
            "Constants",
            "Math",
            "HUE"
        ], 230);
        Blockly.checkBlockColourConstant_("TEXTS_HUE", [
            "Blocks",
            "texts",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("TEXTS_HUE", [
            "Constants",
            "Text",
            "HUE"
        ], 160);
        Blockly.checkBlockColourConstant_("LISTS_HUE", [
            "Blocks",
            "lists",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("LISTS_HUE", [
            "Constants",
            "Lists",
            "HUE"
        ], 260);
        Blockly.checkBlockColourConstant_("COLOUR_HUE", [
            "Blocks",
            "colour",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("COLOUR_HUE", [
            "Constants",
            "Colour",
            "HUE"
        ], 20);
        Blockly.checkBlockColourConstant_("VARIABLES_HUE", [
            "Blocks",
            "variables",
            "HUE"
        ], void 0);
        Blockly.checkBlockColourConstant_("VARIABLES_HUE", [
            "Constants",
            "Variables",
            "HUE"
        ], 330);
        Blockly.checkBlockColourConstant_("VARIABLES_DYNAMIC_HUE", [
            "Constants",
            "VariablesDynamic",
            "HUE"
        ], 310);
        Blockly.checkBlockColourConstant_("PROCEDURES_HUE", [
            "Blocks",
            "procedures",
            "HUE"
        ], void 0);
    };
    Blockly.checkBlockColourConstant_ = function(a, b, c) {
        for(var d = "Blockly", e = Blockly, f = 0; f < b.length; ++f)d += "." + b[f], e && (e = e[b[f]]);
        e && e !== c && (a = (void 0 === c ? '%1 has been removed. Use Blockly.Msg["%2"].' : '%1 is deprecated and unused. Override Blockly.Msg["%2"].').replace("%1", d).replace("%2", a), console.warn(a));
    };
    Blockly.setParentContainer = function(a) {
        Blockly.parentContainer = a;
    };
    Blockly.bindEvent_ = Blockly.browserEvents.bind;
    Blockly.unbindEvent_ = Blockly.browserEvents.unbind;
    Blockly.bindEventWithChecks_ = Blockly.browserEvents.conditionalBind;
    Blockly.ALIGN_LEFT = Blockly.constants.ALIGN.LEFT;
    Blockly.ALIGN_CENTRE = Blockly.constants.ALIGN.CENTRE;
    Blockly.ALIGN_RIGHT = Blockly.constants.ALIGN.RIGHT;
    Blockly.INPUT_VALUE = Blockly.connectionTypes.INPUT_VALUE;
    Blockly.OUTPUT_VALUE = Blockly.connectionTypes.OUTPUT_VALUE;
    Blockly.NEXT_STATEMENT = Blockly.connectionTypes.NEXT_STATEMENT;
    Blockly.PREVIOUS_STATEMENT = Blockly.connectionTypes.PREVIOUS_STATEMENT;
    Blockly.DUMMY_INPUT = Blockly.inputTypes.DUMMY;
    Blockly.TOOLBOX_AT_TOP = Blockly.utils.toolbox.Position.TOP;
    Blockly.TOOLBOX_AT_BOTTOM = Blockly.utils.toolbox.Position.BOTTOM;
    Blockly.TOOLBOX_AT_LEFT = Blockly.utils.toolbox.Position.LEFT;
    Blockly.TOOLBOX_AT_RIGHT = Blockly.utils.toolbox.Position.RIGHT;
    Blockly.Events.BubbleOpen = function(a, b, c) {
        Blockly.Events.BubbleOpen.superClass_.constructor.call(this, a ? a.workspace.id : void 0);
        this.blockId = a ? a.id : null;
        this.isOpen = b;
        this.bubbleType = c;
    };
    Blockly.utils.object.inherits(Blockly.Events.BubbleOpen, Blockly.Events.UiBase);
    Blockly.Events.BubbleOpen.prototype.type = Blockly.Events.BUBBLE_OPEN;
    Blockly.Events.BubbleOpen.prototype.toJson = function() {
        var a = Blockly.Events.BubbleOpen.superClass_.toJson.call(this);
        a.isOpen = this.isOpen;
        a.bubbleType = this.bubbleType;
        a.blockId = this.blockId;
        return a;
    };
    Blockly.Events.BubbleOpen.prototype.fromJson = function(a) {
        Blockly.Events.BubbleOpen.superClass_.fromJson.call(this, a);
        this.isOpen = a.isOpen;
        this.bubbleType = a.bubbleType;
        this.blockId = a.blockId;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.BUBBLE_OPEN, Blockly.Events.BubbleOpen);
    Blockly.Icon = function(a) {
        this.block_ = a;
        this.iconGroup_ = null;
    };
    Blockly.Icon.prototype.collapseHidden = !0;
    Blockly.Icon.prototype.SIZE = 17;
    Blockly.Icon.prototype.bubble_ = null;
    Blockly.Icon.prototype.iconXY_ = null;
    Blockly.Icon.prototype.createIcon = function() {
        this.iconGroup_ || (this.iconGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyIconGroup"
        }, null), this.block_.isInFlyout && Blockly.utils.dom.addClass(this.iconGroup_, "blocklyIconGroupReadonly"), this.drawIcon_(this.iconGroup_), this.block_.getSvgRoot().appendChild(this.iconGroup_), Blockly.browserEvents.conditionalBind(this.iconGroup_, "mouseup", this, this.iconClick_), this.updateEditable());
    };
    Blockly.Icon.prototype.dispose = function() {
        Blockly.utils.dom.removeNode(this.iconGroup_);
        this.iconGroup_ = null;
        this.setVisible(!1);
        this.block_ = null;
    };
    Blockly.Icon.prototype.updateEditable = function() {};
    Blockly.Icon.prototype.isVisible = function() {
        return !!this.bubble_;
    };
    Blockly.Icon.prototype.iconClick_ = function(a) {
        this.block_.workspace.isDragging() || this.block_.isInFlyout || Blockly.utils.isRightButton(a) || this.setVisible(!this.isVisible());
    };
    Blockly.Icon.prototype.applyColour = function() {
        this.isVisible() && this.bubble_.setColour(this.block_.style.colourPrimary);
    };
    Blockly.Icon.prototype.setIconLocation = function(a) {
        this.iconXY_ = a;
        this.isVisible() && this.bubble_.setAnchorLocation(a);
    };
    Blockly.Icon.prototype.computeIconLocation = function() {
        var a = this.block_.getRelativeToSurfaceXY(), b = Blockly.utils.getRelativeXY(this.iconGroup_);
        a = new Blockly.utils.Coordinate(a.x + b.x + this.SIZE / 2, a.y + b.y + this.SIZE / 2);
        Blockly.utils.Coordinate.equals(this.getIconLocation(), a) || this.setIconLocation(a);
    };
    Blockly.Icon.prototype.getIconLocation = function() {
        return this.iconXY_;
    };
    Blockly.Icon.prototype.getCorrectedSize = function() {
        return new Blockly.utils.Size(Blockly.Icon.prototype.SIZE, Blockly.Icon.prototype.SIZE - 2);
    };
    Blockly.Warning = function(a) {
        Blockly.Warning.superClass_.constructor.call(this, a);
        this.createIcon();
        this.text_ = {};
    };
    Blockly.utils.object.inherits(Blockly.Warning, Blockly.Icon);
    Blockly.Warning.prototype.collapseHidden = !1;
    Blockly.Warning.prototype.drawIcon_ = function(a) {
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyIconShape",
            d: "M2,15Q-1,15 0.5,12L6.5,1.7Q8,-1 9.5,1.7L15.5,12Q17,15 14,15z"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyIconSymbol",
            d: "m7,4.8v3.16l0.27,2.27h1.46l0.27,-2.27v-3.16z"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyIconSymbol",
            x: "7",
            y: "11",
            height: "2",
            width: "2"
        }, a);
    };
    Blockly.Warning.prototype.setVisible = function(a) {
        a != this.isVisible() && (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BUBBLE_OPEN))(this.block_, a, "warning")), a ? this.createBubble_() : this.disposeBubble_());
    };
    Blockly.Warning.prototype.createBubble_ = function() {
        this.paragraphElement_ = Blockly.Bubble.textToDom(this.getText());
        this.bubble_ = Blockly.Bubble.createNonEditableBubble(this.paragraphElement_, this.block_, this.iconXY_);
        this.applyColour();
    };
    Blockly.Warning.prototype.disposeBubble_ = function() {
        this.bubble_.dispose();
        this.paragraphElement_ = this.bubble_ = null;
    };
    Blockly.Warning.prototype.setText = function(a, b) {
        this.text_[b] != a && (a ? this.text_[b] = a : delete this.text_[b], this.isVisible() && (this.setVisible(!1), this.setVisible(!0)));
    };
    Blockly.Warning.prototype.getText = function() {
        var a = [], b;
        for(b in this.text_)a.push(this.text_[b]);
        return a.join("\n");
    };
    Blockly.Warning.prototype.dispose = function() {
        this.block_.warning = null;
        Blockly.Icon.prototype.dispose.call(this);
    };
    Blockly.Comment = function(a) {
        Blockly.Comment.superClass_.constructor.call(this, a);
        this.model_ = a.commentModel;
        this.model_.text = this.model_.text || "";
        this.cachedText_ = "";
        this.onInputWrapper_ = this.onChangeWrapper_ = this.onWheelWrapper_ = this.onMouseUpWrapper_ = null;
        this.createIcon();
    };
    Blockly.utils.object.inherits(Blockly.Comment, Blockly.Icon);
    Blockly.Comment.prototype.drawIcon_ = function(a) {
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CIRCLE, {
            "class": "blocklyIconShape",
            r: "8",
            cx: "8",
            cy: "8"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyIconSymbol",
            d: "m6.8,10h2c0.003,-0.617 0.271,-0.962 0.633,-1.266 2.875,-2.4050.607,-5.534 -3.765,-3.874v1.7c3.12,-1.657 3.698,0.118 2.336,1.25-1.201,0.998 -1.201,1.528 -1.204,2.19z"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyIconSymbol",
            x: "6.8",
            y: "10.78",
            height: "2",
            width: "2"
        }, a);
    };
    Blockly.Comment.prototype.createEditor_ = function() {
        this.foreignObject_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FOREIGNOBJECT, {
            x: Blockly.Bubble.BORDER_WIDTH,
            y: Blockly.Bubble.BORDER_WIDTH
        }, null);
        var a = document.createElementNS(Blockly.utils.dom.HTML_NS, "body");
        a.setAttribute("xmlns", Blockly.utils.dom.HTML_NS);
        a.className = "blocklyMinimalBody";
        var b = this.textarea_ = document.createElementNS(Blockly.utils.dom.HTML_NS, "textarea");
        b.className = "blocklyCommentTextarea";
        b.setAttribute("dir", this.block_.RTL ? "RTL" : "LTR");
        b.value = this.model_.text;
        this.resizeTextarea_();
        a.appendChild(b);
        this.foreignObject_.appendChild(a);
        this.onMouseUpWrapper_ = Blockly.browserEvents.conditionalBind(b, "mouseup", this, this.startEdit_, !0, !0);
        this.onWheelWrapper_ = Blockly.browserEvents.conditionalBind(b, "wheel", this, function(c) {
            c.stopPropagation();
        });
        this.onChangeWrapper_ = Blockly.browserEvents.conditionalBind(b, "change", this, function(c) {
            this.cachedText_ != this.model_.text && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(this.block_, "comment", null, this.cachedText_, this.model_.text));
        });
        this.onInputWrapper_ = Blockly.browserEvents.conditionalBind(b, "input", this, function(c) {
            this.model_.text = b.value;
        });
        setTimeout(b.focus.bind(b), 0);
        return this.foreignObject_;
    };
    Blockly.Comment.prototype.updateEditable = function() {
        Blockly.Comment.superClass_.updateEditable.call(this);
        this.isVisible() && (this.disposeBubble_(), this.createBubble_());
    };
    Blockly.Comment.prototype.onBubbleResize_ = function() {
        this.isVisible() && (this.model_.size = this.bubble_.getBubbleSize(), this.resizeTextarea_());
    };
    Blockly.Comment.prototype.resizeTextarea_ = function() {
        var a = this.model_.size, b = 2 * Blockly.Bubble.BORDER_WIDTH, c = a.width - b;
        a = a.height - b;
        this.foreignObject_.setAttribute("width", c);
        this.foreignObject_.setAttribute("height", a);
        this.textarea_.style.width = c - 4 + "px";
        this.textarea_.style.height = a - 4 + "px";
    };
    Blockly.Comment.prototype.setVisible = function(a) {
        a != this.isVisible() && (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BUBBLE_OPEN))(this.block_, a, "comment")), (this.model_.pinned = a) ? this.createBubble_() : this.disposeBubble_());
    };
    Blockly.Comment.prototype.createBubble_ = function() {
        !this.block_.isEditable() || Blockly.utils.userAgent.IE ? this.createNonEditableBubble_() : this.createEditableBubble_();
    };
    Blockly.Comment.prototype.createEditableBubble_ = function() {
        this.bubble_ = new Blockly.Bubble(this.block_.workspace, this.createEditor_(), this.block_.pathObject.svgPath, this.iconXY_, this.model_.size.width, this.model_.size.height);
        this.bubble_.setSvgId(this.block_.id);
        this.bubble_.registerResizeEvent(this.onBubbleResize_.bind(this));
        this.applyColour();
    };
    Blockly.Comment.prototype.createNonEditableBubble_ = function() {
        this.paragraphElement_ = Blockly.Bubble.textToDom(this.block_.getCommentText());
        this.bubble_ = Blockly.Bubble.createNonEditableBubble(this.paragraphElement_, this.block_, this.iconXY_);
        this.applyColour();
    };
    Blockly.Comment.prototype.disposeBubble_ = function() {
        this.onMouseUpWrapper_ && (Blockly.browserEvents.unbind(this.onMouseUpWrapper_), this.onMouseUpWrapper_ = null);
        this.onWheelWrapper_ && (Blockly.browserEvents.unbind(this.onWheelWrapper_), this.onWheelWrapper_ = null);
        this.onChangeWrapper_ && (Blockly.browserEvents.unbind(this.onChangeWrapper_), this.onChangeWrapper_ = null);
        this.onInputWrapper_ && (Blockly.browserEvents.unbind(this.onInputWrapper_), this.onInputWrapper_ = null);
        this.bubble_.dispose();
        this.paragraphElement_ = this.foreignObject_ = this.textarea_ = this.bubble_ = null;
    };
    Blockly.Comment.prototype.startEdit_ = function(a) {
        this.bubble_.promote() && this.textarea_.focus();
        this.cachedText_ = this.model_.text;
    };
    Blockly.Comment.prototype.getBubbleSize = function() {
        return this.model_.size;
    };
    Blockly.Comment.prototype.setBubbleSize = function(a, b) {
        this.bubble_ ? this.bubble_.setBubbleSize(a, b) : (this.model_.size.width = a, this.model_.size.height = b);
    };
    Blockly.Comment.prototype.updateText = function() {
        this.textarea_ ? this.textarea_.value = this.model_.text : this.paragraphElement_ && (this.paragraphElement_.firstChild.textContent = this.model_.text);
    };
    Blockly.Comment.prototype.dispose = function() {
        this.block_.comment = null;
        Blockly.Icon.prototype.dispose.call(this);
    };
    Blockly.Css.register(".blocklyCommentTextarea {,background-color: #fef49c;,border: 0;,outline: 0;,margin: 0;,padding: 3px;,resize: none;,display: block;,text-overflow: hidden;,}".split(","));
    Blockly.Flyout = function(a) {
        a.setMetrics = this.setMetrics_.bind(this);
        this.workspace_ = new Blockly.WorkspaceSvg(a);
        this.workspace_.setMetricsManager(new Blockly.FlyoutMetricsManager(this.workspace_, this));
        this.workspace_.isFlyout = !0;
        this.workspace_.setVisible(this.isVisible_);
        this.RTL = !!a.RTL;
        this.horizontalLayout = !1;
        this.toolboxPosition_ = a.toolboxPosition;
        this.eventWrappers_ = [];
        this.mats_ = [];
        this.buttons_ = [];
        this.listeners_ = [];
        this.permanentlyDisabled_ = [];
        this.tabWidth_ = this.workspace_.getRenderer().getConstants().TAB_WIDTH;
        this.targetWorkspace = null;
    };
    Blockly.Flyout.prototype.autoClose = !0;
    Blockly.Flyout.prototype.isVisible_ = !1;
    Blockly.Flyout.prototype.containerVisible_ = !0;
    Blockly.Flyout.prototype.CORNER_RADIUS = 8;
    Blockly.Flyout.prototype.MARGIN = Blockly.Flyout.prototype.CORNER_RADIUS;
    Blockly.Flyout.prototype.GAP_X = 3 * Blockly.Flyout.prototype.MARGIN;
    Blockly.Flyout.prototype.GAP_Y = 3 * Blockly.Flyout.prototype.MARGIN;
    Blockly.Flyout.prototype.SCROLLBAR_PADDING = 2;
    Blockly.Flyout.prototype.width_ = 0;
    Blockly.Flyout.prototype.height_ = 0;
    Blockly.Flyout.prototype.dragAngleRange_ = 70;
    Blockly.Flyout.prototype.createDom = function(a) {
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(a, {
            "class": "blocklyFlyout",
            style: "display: none"
        }, null);
        this.svgBackground_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyFlyoutBackground"
        }, this.svgGroup_);
        this.svgGroup_.appendChild(this.workspace_.createDom());
        this.workspace_.getThemeManager().subscribe(this.svgBackground_, "flyoutBackgroundColour", "fill");
        this.workspace_.getThemeManager().subscribe(this.svgBackground_, "flyoutOpacity", "fill-opacity");
        return this.svgGroup_;
    };
    Blockly.Flyout.prototype.init = function(a) {
        this.targetWorkspace = a;
        this.workspace_.targetWorkspace = a;
        this.workspace_.scrollbar = new Blockly.ScrollbarPair(this.workspace_, this.horizontalLayout, !this.horizontalLayout, "blocklyFlyoutScrollbar");
        this.hide();
        Array.prototype.push.apply(this.eventWrappers_, Blockly.browserEvents.conditionalBind(this.svgGroup_, "wheel", this, this.wheel_));
        this.autoClose || (this.filterWrapper_ = this.filterForCapacity_.bind(this), this.targetWorkspace.addChangeListener(this.filterWrapper_));
        Array.prototype.push.apply(this.eventWrappers_, Blockly.browserEvents.conditionalBind(this.svgBackground_, "mousedown", this, this.onMouseDown_));
        this.workspace_.getGesture = this.targetWorkspace.getGesture.bind(this.targetWorkspace);
        this.workspace_.setVariableMap(this.targetWorkspace.getVariableMap());
        this.workspace_.createPotentialVariableMap();
    };
    Blockly.Flyout.prototype.dispose = function() {
        this.hide();
        Blockly.browserEvents.unbind(this.eventWrappers_);
        this.filterWrapper_ && (this.targetWorkspace.removeChangeListener(this.filterWrapper_), this.filterWrapper_ = null);
        this.workspace_ && (this.workspace_.getThemeManager().unsubscribe(this.svgBackground_), this.workspace_.targetWorkspace = null, this.workspace_.dispose(), this.workspace_ = null);
        this.svgGroup_ && (Blockly.utils.dom.removeNode(this.svgGroup_), this.svgGroup_ = null);
        this.targetWorkspace = this.svgBackground_ = null;
    };
    Blockly.Flyout.prototype.getWidth = function() {
        return this.width_;
    };
    Blockly.Flyout.prototype.getHeight = function() {
        return this.height_;
    };
    Blockly.Flyout.prototype.getFlyoutScale = function() {
        return this.targetWorkspace.scale;
    };
    Blockly.Flyout.prototype.getWorkspace = function() {
        return this.workspace_;
    };
    Blockly.Flyout.prototype.isVisible = function() {
        return this.isVisible_;
    };
    Blockly.Flyout.prototype.setVisible = function(a) {
        var b = a != this.isVisible();
        this.isVisible_ = a;
        b && this.updateDisplay_();
    };
    Blockly.Flyout.prototype.setContainerVisible = function(a) {
        var b = a != this.containerVisible_;
        this.containerVisible_ = a;
        b && this.updateDisplay_();
    };
    Blockly.Flyout.prototype.updateDisplay_ = function() {
        var a = this.containerVisible_ ? this.isVisible() : !1;
        this.svgGroup_.style.display = a ? "block" : "none";
        this.workspace_.scrollbar.setContainerVisible(a);
    };
    Blockly.Flyout.prototype.positionAt_ = function(a, b, c, d) {
        this.svgGroup_.setAttribute("width", a);
        this.svgGroup_.setAttribute("height", b);
        this.workspace_.setCachedParentSvgSize(a, b);
        "svg" == this.svgGroup_.tagName ? Blockly.utils.dom.setCssTransform(this.svgGroup_, "translate(" + c + "px," + d + "px)") : this.svgGroup_.setAttribute("transform", "translate(" + c + "," + d + ")");
        if (a = this.workspace_.scrollbar) a.setOrigin(c, d), a.resize(), a.hScroll && a.hScroll.setPosition(a.hScroll.position.x, a.hScroll.position.y), a.vScroll && a.vScroll.setPosition(a.vScroll.position.x, a.vScroll.position.y);
    };
    Blockly.Flyout.prototype.hide = function() {
        if (this.isVisible()) {
            this.setVisible(!1);
            for(var a = 0, b; b = this.listeners_[a]; a++)Blockly.browserEvents.unbind(b);
            this.listeners_.length = 0;
            this.reflowWrapper_ && (this.workspace_.removeChangeListener(this.reflowWrapper_), this.reflowWrapper_ = null);
        }
    };
    Blockly.Flyout.prototype.show = function(a) {
        this.workspace_.setResizesEnabled(!1);
        this.hide();
        this.clearOldBlocks_();
        "string" == typeof a && (a = this.getDynamicCategoryContents_(a));
        this.setVisible(!0);
        a = Blockly.utils.toolbox.convertFlyoutDefToJsonArray(a);
        a = this.createFlyoutInfo_(a);
        this.layout_(a.contents, a.gaps);
        this.listeners_.push(Blockly.browserEvents.conditionalBind(this.svgBackground_, "mouseover", this, function() {
            for(var b = this.workspace_.getTopBlocks(!1), c = 0, d; d = b[c]; c++)d.removeSelect();
        }));
        this.horizontalLayout ? this.height_ = 0 : this.width_ = 0;
        this.workspace_.setResizesEnabled(!0);
        this.reflow();
        this.filterForCapacity_();
        this.position();
        this.reflowWrapper_ = this.reflow.bind(this);
        this.workspace_.addChangeListener(this.reflowWrapper_);
    };
    Blockly.Flyout.prototype.createFlyoutInfo_ = function(a) {
        var b = [], c = [];
        this.permanentlyDisabled_.length = 0;
        for(var d = this.horizontalLayout ? this.GAP_X : this.GAP_Y, e = 0, f; f = a[e]; e++)switch(f.custom && (f = this.getDynamicCategoryContents_(f.custom), f = Blockly.utils.toolbox.convertFlyoutDefToJsonArray(f), a.splice.apply(a, [
            e,
            1
        ].concat(f)), f = a[e]), f.kind.toUpperCase()){
            case "BLOCK":
                var g = f, h = this.getBlockXml_(g);
                f = this.createBlock_(h);
                g = parseInt(g.gap || h.getAttribute("gap"), 10);
                c.push(isNaN(g) ? d : g);
                b.push({
                    type: "block",
                    block: f
                });
                break;
            case "SEP":
                this.addSeparatorGap_(f, c, d);
                break;
            case "LABEL":
                f = this.createButton_(f, !0);
                b.push({
                    type: "button",
                    button: f
                });
                c.push(d);
                break;
            case "BUTTON":
                f = this.createButton_(f, !1), b.push({
                    type: "button",
                    button: f
                }), c.push(d);
        }
        return {
            contents: b,
            gaps: c
        };
    };
    Blockly.Flyout.prototype.getDynamicCategoryContents_ = function(a) {
        a = this.workspace_.targetWorkspace.getToolboxCategoryCallback(a);
        if ("function" != typeof a) throw TypeError("Couldn't find a callback function when opening a toolbox category.");
        a = a(this.workspace_.targetWorkspace);
        if (!Array.isArray(a)) throw new TypeError("Result of toolbox category callback must be an array.");
        return a;
    };
    Blockly.Flyout.prototype.createButton_ = function(a, b) {
        if (!Blockly.FlyoutButton) throw Error("Missing require for Blockly.FlyoutButton");
        return new Blockly.FlyoutButton(this.workspace_, this.targetWorkspace, a, b);
    };
    Blockly.Flyout.prototype.createBlock_ = function(a) {
        a = Blockly.Xml.domToBlock(a, this.workspace_);
        a.isEnabled() || this.permanentlyDisabled_.push(a);
        return a;
    };
    Blockly.Flyout.prototype.getBlockXml_ = function(a) {
        var b = null, c = a.blockxml;
        c && "string" != typeof c ? b = c : c && "string" == typeof c ? (b = Blockly.Xml.textToDom(c), a.blockxml = b) : a.type && (b = Blockly.utils.xml.createElement("xml"), b.setAttribute("type", a.type), b.setAttribute("disabled", a.disabled), a.blockxml = b);
        if (!b) throw Error("Error: Invalid block definition. Block definition must have blockxml or type.");
        return b;
    };
    Blockly.Flyout.prototype.addSeparatorGap_ = function(a, b, c) {
        a = parseInt(a.gap, 10);
        !isNaN(a) && 0 < b.length ? b[b.length - 1] = a : b.push(c);
    };
    Blockly.Flyout.prototype.clearOldBlocks_ = function() {
        for(var a = this.workspace_.getTopBlocks(!1), b = 0, c; c = a[b]; b++)c.workspace == this.workspace_ && c.dispose(!1, !1);
        for(b = 0; b < this.mats_.length; b++)if (a = this.mats_[b]) Blockly.Tooltip.unbindMouseEvents(a), Blockly.utils.dom.removeNode(a);
        for(b = this.mats_.length = 0; a = this.buttons_[b]; b++)a.dispose();
        this.buttons_.length = 0;
        this.workspace_.getPotentialVariableMap().clear();
    };
    Blockly.Flyout.prototype.addBlockListeners_ = function(a, b, c) {
        this.listeners_.push(Blockly.browserEvents.conditionalBind(a, "mousedown", null, this.blockMouseDown_(b)));
        this.listeners_.push(Blockly.browserEvents.conditionalBind(c, "mousedown", null, this.blockMouseDown_(b)));
        this.listeners_.push(Blockly.browserEvents.bind(a, "mouseenter", b, b.addSelect));
        this.listeners_.push(Blockly.browserEvents.bind(a, "mouseleave", b, b.removeSelect));
        this.listeners_.push(Blockly.browserEvents.bind(c, "mouseenter", b, b.addSelect));
        this.listeners_.push(Blockly.browserEvents.bind(c, "mouseleave", b, b.removeSelect));
    };
    Blockly.Flyout.prototype.blockMouseDown_ = function(a) {
        var b = this;
        return function(c) {
            var d = b.targetWorkspace.getGesture(c);
            d && (d.setStartBlock(a), d.handleFlyoutStart(c, b));
        };
    };
    Blockly.Flyout.prototype.onMouseDown_ = function(a) {
        var b = this.targetWorkspace.getGesture(a);
        b && b.handleFlyoutStart(a, this);
    };
    Blockly.Flyout.prototype.isBlockCreatable_ = function(a) {
        return a.isEnabled();
    };
    Blockly.Flyout.prototype.createBlock = function(a) {
        var b = null;
        Blockly.Events.disable();
        var c = this.targetWorkspace.getAllVariables();
        this.targetWorkspace.setResizesEnabled(!1);
        try {
            b = this.placeNewBlock_(a);
        } finally{
            Blockly.Events.enable();
        }
        Blockly.hideChaff();
        a = Blockly.Variables.getAddedVariables(this.targetWorkspace, c);
        if (Blockly.Events.isEnabled()) {
            Blockly.Events.setGroup(!0);
            for(c = 0; c < a.length; c++){
                var d = a[c];
                Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.VAR_CREATE))(d));
            }
            Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CREATE))(b));
        }
        this.autoClose ? this.hide() : this.filterForCapacity_();
        return b;
    };
    Blockly.Flyout.prototype.initFlyoutButton_ = function(a, b, c) {
        var d = a.createDom();
        a.moveTo(b, c);
        a.show();
        this.listeners_.push(Blockly.browserEvents.conditionalBind(d, "mousedown", this, this.onMouseDown_));
        this.buttons_.push(a);
    };
    Blockly.Flyout.prototype.createRect_ = function(a, b, c, d, e) {
        b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "fill-opacity": 0,
            x: b,
            y: c,
            height: d.height,
            width: d.width
        }, null);
        b.tooltip = a;
        Blockly.Tooltip.bindMouseEvents(b);
        this.workspace_.getCanvas().insertBefore(b, a.getSvgRoot());
        a.flyoutRect_ = b;
        return this.mats_[e] = b;
    };
    Blockly.Flyout.prototype.moveRectToBlock_ = function(a, b) {
        var c = b.getHeightWidth();
        a.setAttribute("width", c.width);
        a.setAttribute("height", c.height);
        b = b.getRelativeToSurfaceXY();
        a.setAttribute("y", b.y);
        a.setAttribute("x", this.RTL ? b.x - c.width : b.x);
    };
    Blockly.Flyout.prototype.filterForCapacity_ = function() {
        for(var a = this.workspace_.getTopBlocks(!1), b = 0, c; c = a[b]; b++)if (-1 == this.permanentlyDisabled_.indexOf(c)) for(var d = this.targetWorkspace.isCapacityAvailable(Blockly.utils.getBlockTypeCounts(c)); c;)c.setEnabled(d), c = c.getNextBlock();
    };
    Blockly.Flyout.prototype.reflow = function() {
        this.reflowWrapper_ && this.workspace_.removeChangeListener(this.reflowWrapper_);
        this.reflowInternal_();
        this.reflowWrapper_ && this.workspace_.addChangeListener(this.reflowWrapper_);
    };
    Blockly.Flyout.prototype.isScrollable = function() {
        return this.workspace_.scrollbar ? this.workspace_.scrollbar.isVisible() : !1;
    };
    Blockly.Flyout.prototype.placeNewBlock_ = function(a) {
        var b = this.targetWorkspace;
        if (!a.getSvgRoot()) throw Error("oldBlock is not rendered.");
        var c = Blockly.Xml.blockToDom(a, !0);
        b.setResizesEnabled(!1);
        c = Blockly.Xml.domToBlock(c, b);
        if (!c.getSvgRoot()) throw Error("block is not rendered.");
        var d = b.getOriginOffsetInPixels(), e = this.workspace_.getOriginOffsetInPixels();
        a = a.getRelativeToSurfaceXY();
        a.scale(this.workspace_.scale);
        a = Blockly.utils.Coordinate.sum(e, a);
        d = Blockly.utils.Coordinate.difference(a, d);
        d.scale(1 / b.scale);
        c.moveBy(d.x, d.y);
        return c;
    };
    Blockly.HorizontalFlyout = function(a) {
        Blockly.HorizontalFlyout.superClass_.constructor.call(this, a);
        this.horizontalLayout = !0;
    };
    Blockly.utils.object.inherits(Blockly.HorizontalFlyout, Blockly.Flyout);
    Blockly.HorizontalFlyout.prototype.setMetrics_ = function(a) {
        if (this.isVisible()) {
            var b = this.workspace_.getMetricsManager(), c = b.getScrollMetrics(), d = b.getViewMetrics();
            b = b.getAbsoluteMetrics();
            "number" == typeof a.x && (this.workspace_.scrollX = -(c.left + (c.width - d.width) * a.x));
            this.workspace_.translate(this.workspace_.scrollX + b.left, this.workspace_.scrollY + b.top);
        }
    };
    Blockly.HorizontalFlyout.prototype.getX = function() {
        return 0;
    };
    Blockly.HorizontalFlyout.prototype.getY = function() {
        if (!this.isVisible()) return 0;
        var a = this.targetWorkspace.getMetricsManager(), b = a.getAbsoluteMetrics(), c = a.getViewMetrics();
        a = a.getToolboxMetrics();
        var d = this.toolboxPosition_ == Blockly.utils.toolbox.Position.TOP;
        return this.targetWorkspace.toolboxPosition == this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? d ? a.height : c.height - this.height_ : d ? 0 : c.height : d ? 0 : c.height + b.top - this.height_;
    };
    Blockly.HorizontalFlyout.prototype.position = function() {
        if (this.isVisible() && this.targetWorkspace.isVisible()) {
            var a = this.targetWorkspace.getMetricsManager().getViewMetrics();
            this.width_ = a.width;
            this.setBackgroundPath_(a.width - 2 * this.CORNER_RADIUS, this.height_ - this.CORNER_RADIUS);
            a = this.getX();
            var b = this.getY();
            this.positionAt_(this.width_, this.height_, a, b);
        }
    };
    Blockly.HorizontalFlyout.prototype.setBackgroundPath_ = function(a, b) {
        var c = this.toolboxPosition_ == Blockly.utils.toolbox.Position.TOP, d = [
            "M 0," + (c ? 0 : this.CORNER_RADIUS)
        ];
        c ? (d.push("h", a + 2 * this.CORNER_RADIUS), d.push("v", b), d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, -this.CORNER_RADIUS, this.CORNER_RADIUS), d.push("h", -a), d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, -this.CORNER_RADIUS, -this.CORNER_RADIUS)) : (d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, -this.CORNER_RADIUS), d.push("h", a), d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, this.CORNER_RADIUS), d.push("v", b), d.push("h", -a - 2 * this.CORNER_RADIUS));
        d.push("z");
        this.svgBackground_.setAttribute("d", d.join(" "));
    };
    Blockly.HorizontalFlyout.prototype.scrollToStart = function() {
        this.workspace_.scrollbar.setX(this.RTL ? Infinity : 0);
    };
    Blockly.HorizontalFlyout.prototype.wheel_ = function(a) {
        var b = Blockly.utils.getScrollDeltaPixels(a);
        if (b = b.x || b.y) {
            var c = this.workspace_.getMetricsManager(), d = c.getScrollMetrics();
            b = c.getViewMetrics().left - d.left + b;
            this.workspace_.scrollbar.setX(b);
            Blockly.WidgetDiv.hide();
            Blockly.DropDownDiv.hideWithoutAnimation();
        }
        a.preventDefault();
        a.stopPropagation();
    };
    Blockly.HorizontalFlyout.prototype.layout_ = function(a, b) {
        this.workspace_.scale = this.targetWorkspace.scale;
        var c = this.MARGIN, d = c + this.tabWidth_;
        this.RTL && (a = a.reverse());
        for(var e = 0, f; f = a[e]; e++)if ("block" == f.type) {
            f = f.block;
            for(var g = f.getDescendants(!1), h = 0, k; k = g[h]; h++)k.isInFlyout = !0;
            f.render();
            g = f.getSvgRoot();
            h = f.getHeightWidth();
            k = f.outputConnection ? this.tabWidth_ : 0;
            k = this.RTL ? d + h.width : d - k;
            f.moveBy(k, c);
            k = this.createRect_(f, k, c, h, e);
            d += h.width + b[e];
            this.addBlockListeners_(g, f, k);
        } else "button" == f.type && (this.initFlyoutButton_(f.button, d, c), d += f.button.width + b[e]);
    };
    Blockly.HorizontalFlyout.prototype.isDragTowardWorkspace = function(a) {
        a = Math.atan2(a.y, a.x) / Math.PI * 180;
        var b = this.dragAngleRange_;
        return a < 90 + b && a > 90 - b || a > -90 - b && a < -90 + b ? !0 : !1;
    };
    Blockly.HorizontalFlyout.prototype.getClientRect = function() {
        if (!this.svgGroup_) return null;
        var a = this.svgGroup_.getBoundingClientRect(), b = a.top;
        return this.toolboxPosition_ == Blockly.utils.toolbox.Position.TOP ? new Blockly.utils.Rect(-1000000000, b + a.height, -1000000000, 1E9) : new Blockly.utils.Rect(b, 1E9, -1000000000, 1E9);
    };
    Blockly.HorizontalFlyout.prototype.reflowInternal_ = function() {
        this.workspace_.scale = this.getFlyoutScale();
        for(var a = 0, b = this.workspace_.getTopBlocks(!1), c = 0, d; d = b[c]; c++)a = Math.max(a, d.getHeightWidth().height);
        a += 1.5 * this.MARGIN;
        a *= this.workspace_.scale;
        a += Blockly.Scrollbar.scrollbarThickness;
        if (this.height_ != a) {
            for(c = 0; d = b[c]; c++)d.flyoutRect_ && this.moveRectToBlock_(d.flyoutRect_, d);
            this.targetWorkspace.toolboxPosition != this.toolboxPosition_ || this.toolboxPosition_ != Blockly.utils.toolbox.Position.TOP || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX, this.targetWorkspace.scrollY + a);
            this.height_ = a;
            this.position();
        }
    };
    Blockly.registry.register(Blockly.registry.Type.FLYOUTS_HORIZONTAL_TOOLBOX, Blockly.registry.DEFAULT, Blockly.HorizontalFlyout);
    Blockly.VerticalFlyout = function(a) {
        Blockly.VerticalFlyout.superClass_.constructor.call(this, a);
    };
    Blockly.utils.object.inherits(Blockly.VerticalFlyout, Blockly.Flyout);
    Blockly.VerticalFlyout.registryName = "verticalFlyout";
    Blockly.VerticalFlyout.prototype.setMetrics_ = function(a) {
        if (this.isVisible()) {
            var b = this.workspace_.getMetricsManager(), c = b.getScrollMetrics(), d = b.getViewMetrics();
            b = b.getAbsoluteMetrics();
            "number" == typeof a.y && (this.workspace_.scrollY = -(c.top + (c.height - d.height) * a.y));
            this.workspace_.translate(this.workspace_.scrollX + b.left, this.workspace_.scrollY + b.top);
        }
    };
    Blockly.VerticalFlyout.prototype.getX = function() {
        if (!this.isVisible()) return 0;
        var a = this.targetWorkspace.getMetricsManager(), b = a.getAbsoluteMetrics(), c = a.getViewMetrics();
        a = a.getToolboxMetrics();
        return this.targetWorkspace.toolboxPosition == this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? this.toolboxPosition_ == Blockly.utils.toolbox.Position.LEFT ? a.width : c.width - this.width_ : this.toolboxPosition_ == Blockly.utils.toolbox.Position.LEFT ? 0 : c.width : this.toolboxPosition_ == Blockly.utils.toolbox.Position.LEFT ? 0 : c.width + b.left - this.width_;
    };
    Blockly.VerticalFlyout.prototype.getY = function() {
        return 0;
    };
    Blockly.VerticalFlyout.prototype.position = function() {
        if (this.isVisible() && this.targetWorkspace.isVisible()) {
            var a = this.targetWorkspace.getMetricsManager().getViewMetrics();
            this.height_ = a.height;
            this.setBackgroundPath_(this.width_ - this.CORNER_RADIUS, a.height - 2 * this.CORNER_RADIUS);
            a = this.getX();
            var b = this.getY();
            this.positionAt_(this.width_, this.height_, a, b);
        }
    };
    Blockly.VerticalFlyout.prototype.setBackgroundPath_ = function(a, b) {
        var c = this.toolboxPosition_ == Blockly.utils.toolbox.Position.RIGHT, d = a + this.CORNER_RADIUS;
        d = [
            "M " + (c ? d : 0) + ",0"
        ];
        d.push("h", c ? -a : a);
        d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, c ? 0 : 1, c ? -this.CORNER_RADIUS : this.CORNER_RADIUS, this.CORNER_RADIUS);
        d.push("v", Math.max(0, b));
        d.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, c ? 0 : 1, c ? this.CORNER_RADIUS : -this.CORNER_RADIUS, this.CORNER_RADIUS);
        d.push("h", c ? a : -a);
        d.push("z");
        this.svgBackground_.setAttribute("d", d.join(" "));
    };
    Blockly.VerticalFlyout.prototype.scrollToStart = function() {
        this.workspace_.scrollbar.setY(0);
    };
    Blockly.VerticalFlyout.prototype.wheel_ = function(a) {
        var b = Blockly.utils.getScrollDeltaPixels(a);
        if (b.y) {
            var c = this.workspace_.getMetricsManager(), d = c.getScrollMetrics();
            b = c.getViewMetrics().top - d.top + b.y;
            this.workspace_.scrollbar.setY(b);
            Blockly.WidgetDiv.hide();
            Blockly.DropDownDiv.hideWithoutAnimation();
        }
        a.preventDefault();
        a.stopPropagation();
    };
    Blockly.VerticalFlyout.prototype.layout_ = function(a, b) {
        this.workspace_.scale = this.targetWorkspace.scale;
        for(var c = this.MARGIN, d = this.RTL ? c : c + this.tabWidth_, e = 0, f; f = a[e]; e++)if ("block" == f.type) {
            f = f.block;
            for(var g = f.getDescendants(!1), h = 0, k; k = g[h]; h++)k.isInFlyout = !0;
            f.render();
            g = f.getSvgRoot();
            h = f.getHeightWidth();
            k = f.outputConnection ? d - this.tabWidth_ : d;
            f.moveBy(k, c);
            k = this.createRect_(f, this.RTL ? k - h.width : k, c, h, e);
            this.addBlockListeners_(g, f, k);
            c += h.height + b[e];
        } else "button" == f.type && (this.initFlyoutButton_(f.button, d, c), c += f.button.height + b[e]);
    };
    Blockly.VerticalFlyout.prototype.isDragTowardWorkspace = function(a) {
        a = Math.atan2(a.y, a.x) / Math.PI * 180;
        var b = this.dragAngleRange_;
        return a < b && a > -b || a < -180 + b || a > 180 - b ? !0 : !1;
    };
    Blockly.VerticalFlyout.prototype.getClientRect = function() {
        if (!this.svgGroup_) return null;
        var a = this.svgGroup_.getBoundingClientRect(), b = a.left;
        return this.toolboxPosition_ == Blockly.utils.toolbox.Position.LEFT ? new Blockly.utils.Rect(-1000000000, 1E9, -1000000000, b + a.width) : new Blockly.utils.Rect(-1000000000, 1E9, b, 1E9);
    };
    Blockly.VerticalFlyout.prototype.reflowInternal_ = function() {
        this.workspace_.scale = this.getFlyoutScale();
        for(var a = 0, b = this.workspace_.getTopBlocks(!1), c = 0, d; d = b[c]; c++){
            var e = d.getHeightWidth().width;
            d.outputConnection && (e -= this.tabWidth_);
            a = Math.max(a, e);
        }
        for(c = 0; d = this.buttons_[c]; c++)a = Math.max(a, d.width);
        a += 1.5 * this.MARGIN + this.tabWidth_;
        a *= this.workspace_.scale;
        a += Blockly.Scrollbar.scrollbarThickness;
        if (this.width_ != a) {
            for(c = 0; d = b[c]; c++){
                if (this.RTL) {
                    e = d.getRelativeToSurfaceXY().x;
                    var f = a / this.workspace_.scale - this.MARGIN;
                    d.outputConnection || (f -= this.tabWidth_);
                    d.moveBy(f - e, 0);
                }
                d.flyoutRect_ && this.moveRectToBlock_(d.flyoutRect_, d);
            }
            if (this.RTL) for(c = 0; d = this.buttons_[c]; c++)b = d.getPosition().y, d.moveTo(a / this.workspace_.scale - d.width - this.MARGIN - this.tabWidth_, b);
            this.targetWorkspace.toolboxPosition != this.toolboxPosition_ || this.toolboxPosition_ != Blockly.utils.toolbox.Position.LEFT || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX + a, this.targetWorkspace.scrollY);
            this.width_ = a;
            this.position();
        }
    };
    Blockly.registry.register(Blockly.registry.Type.FLYOUTS_VERTICAL_TOOLBOX, Blockly.registry.DEFAULT, Blockly.VerticalFlyout);
    Blockly.FlyoutButton = function(a, b, c, d) {
        this.workspace_ = a;
        this.targetWorkspace_ = b;
        this.text_ = c.text;
        this.position_ = new Blockly.utils.Coordinate(0, 0);
        this.isLabel_ = d;
        this.callbackKey_ = c.callbackKey || c.callbackkey;
        this.cssClass_ = c["web-class"] || null;
        this.onMouseUpWrapper_ = null;
        this.info = c;
    };
    Blockly.FlyoutButton.MARGIN_X = 5;
    Blockly.FlyoutButton.MARGIN_Y = 2;
    Blockly.FlyoutButton.prototype.width = 0;
    Blockly.FlyoutButton.prototype.height = 0;
    Blockly.FlyoutButton.prototype.createDom = function() {
        var a = this.isLabel_ ? "blocklyFlyoutLabel" : "blocklyFlyoutButton";
        this.cssClass_ && (a += " " + this.cssClass_);
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": a
        }, this.workspace_.getCanvas());
        if (!this.isLabel_) var b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyFlyoutButtonShadow",
            rx: 4,
            ry: 4,
            x: 1,
            y: 1
        }, this.svgGroup_);
        a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": this.isLabel_ ? "blocklyFlyoutLabelBackground" : "blocklyFlyoutButtonBackground",
            rx: 4,
            ry: 4
        }, this.svgGroup_);
        var c = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TEXT, {
            "class": this.isLabel_ ? "blocklyFlyoutLabelText" : "blocklyText",
            x: 0,
            y: 0,
            "text-anchor": "middle"
        }, this.svgGroup_), d = Blockly.utils.replaceMessageReferences(this.text_);
        this.workspace_.RTL && (d += "\u200f");
        c.textContent = d;
        this.isLabel_ && (this.svgText_ = c, this.workspace_.getThemeManager().subscribe(this.svgText_, "flyoutForegroundColour", "fill"));
        var e = Blockly.utils.style.getComputedStyle(c, "fontSize"), f = Blockly.utils.style.getComputedStyle(c, "fontWeight"), g = Blockly.utils.style.getComputedStyle(c, "fontFamily");
        this.width = Blockly.utils.dom.getFastTextWidthWithSizeString(c, e, f, g);
        d = Blockly.utils.dom.measureFontMetrics(d, e, f, g);
        this.height = d.height;
        this.isLabel_ || (this.width += 2 * Blockly.FlyoutButton.MARGIN_X, this.height += 2 * Blockly.FlyoutButton.MARGIN_Y, b.setAttribute("width", this.width), b.setAttribute("height", this.height));
        a.setAttribute("width", this.width);
        a.setAttribute("height", this.height);
        c.setAttribute("x", this.width / 2);
        c.setAttribute("y", this.height / 2 - d.height / 2 + d.baseline);
        this.updateTransform_();
        this.onMouseUpWrapper_ = Blockly.browserEvents.conditionalBind(this.svgGroup_, "mouseup", this, this.onMouseUp_);
        return this.svgGroup_;
    };
    Blockly.FlyoutButton.prototype.show = function() {
        this.updateTransform_();
        this.svgGroup_.setAttribute("display", "block");
    };
    Blockly.FlyoutButton.prototype.updateTransform_ = function() {
        this.svgGroup_.setAttribute("transform", "translate(" + this.position_.x + "," + this.position_.y + ")");
    };
    Blockly.FlyoutButton.prototype.moveTo = function(a, b) {
        this.position_.x = a;
        this.position_.y = b;
        this.updateTransform_();
    };
    Blockly.FlyoutButton.prototype.isLabel = function() {
        return this.isLabel_;
    };
    Blockly.FlyoutButton.prototype.getPosition = function() {
        return this.position_;
    };
    Blockly.FlyoutButton.prototype.getButtonText = function() {
        return this.text_;
    };
    Blockly.FlyoutButton.prototype.getTargetWorkspace = function() {
        return this.targetWorkspace_;
    };
    Blockly.FlyoutButton.prototype.dispose = function() {
        this.onMouseUpWrapper_ && Blockly.browserEvents.unbind(this.onMouseUpWrapper_);
        this.svgGroup_ && Blockly.utils.dom.removeNode(this.svgGroup_);
        this.svgText_ && this.workspace_.getThemeManager().unsubscribe(this.svgText_);
    };
    Blockly.FlyoutButton.prototype.onMouseUp_ = function(a) {
        (a = this.targetWorkspace_.getGesture(a)) && a.cancel();
        this.isLabel_ && this.callbackKey_ ? console.warn("Labels should not have callbacks. Label text: " + this.text_) : this.isLabel_ || this.callbackKey_ && this.targetWorkspace_.getButtonCallback(this.callbackKey_) ? this.isLabel_ || this.targetWorkspace_.getButtonCallback(this.callbackKey_)(this) : console.warn("Buttons should have callbacks. Button text: " + this.text_);
    };
    Blockly.Css.register(".blocklyFlyoutButton {,fill: #888;,cursor: default;,},.blocklyFlyoutButtonShadow {,fill: #666;,},.blocklyFlyoutButton:hover {,fill: #aaa;,},.blocklyFlyoutLabel {,cursor: default;,},.blocklyFlyoutLabelBackground {,opacity: 0;,}".split(","));
    Blockly.Generator = function(a) {
        this.name_ = a;
        this.FUNCTION_NAME_PLACEHOLDER_REGEXP_ = new RegExp(this.FUNCTION_NAME_PLACEHOLDER_, "g");
    };
    Blockly.Generator.NAME_TYPE = "generated_function";
    Blockly.Generator.prototype.INFINITE_LOOP_TRAP = null;
    Blockly.Generator.prototype.STATEMENT_PREFIX = null;
    Blockly.Generator.prototype.STATEMENT_SUFFIX = null;
    Blockly.Generator.prototype.INDENT = "  ";
    Blockly.Generator.prototype.COMMENT_WRAP = 60;
    Blockly.Generator.prototype.ORDER_OVERRIDES = [];
    Blockly.Generator.prototype.isInitialized = null;
    Blockly.Generator.prototype.workspaceToCode = function(a) {
        a || (console.warn("No workspace specified in workspaceToCode call.  Guessing."), a = Blockly.getMainWorkspace());
        var b = [];
        this.init(a);
        a = a.getTopBlocks(!0);
        for(var c = 0, d; d = a[c]; c++){
            var e = this.blockToCode(d);
            Array.isArray(e) && (e = e[0]);
            e && (d.outputConnection && (e = this.scrubNakedValue(e), this.STATEMENT_PREFIX && !d.suppressPrefixSuffix && (e = this.injectId(this.STATEMENT_PREFIX, d) + e), this.STATEMENT_SUFFIX && !d.suppressPrefixSuffix && (e += this.injectId(this.STATEMENT_SUFFIX, d))), b.push(e));
        }
        b = b.join("\n");
        b = this.finish(b);
        b = b.replace(/^\s+\n/, "");
        b = b.replace(/\n\s+$/, "\n");
        return b = b.replace(/[ \t]+\n/g, "\n");
    };
    Blockly.Generator.prototype.prefixLines = function(a, b) {
        return b + a.replace(/(?!\n$)\n/g, "\n" + b);
    };
    Blockly.Generator.prototype.allNestedComments = function(a) {
        var b = [];
        a = a.getDescendants(!0);
        for(var c = 0; c < a.length; c++){
            var d = a[c].getCommentText();
            d && b.push(d);
        }
        b.length && b.push("");
        return b.join("\n");
    };
    Blockly.Generator.prototype.blockToCode = function(a, b) {
        !1 === this.isInitialized && console.warn("Generator init was not called before blockToCode was called.");
        if (!a) return "";
        if (!a.isEnabled()) return b ? "" : this.blockToCode(a.getNextBlock());
        if (a.isInsertionMarker()) return b ? "" : this.blockToCode(a.getChildren(!1)[0]);
        var c = this[a.type];
        if ("function" != typeof c) throw Error('Language "' + this.name_ + '" does not know how to generate  code for block type "' + a.type + '".');
        c = c.call(a, a);
        if (Array.isArray(c)) {
            if (!a.outputConnection) throw TypeError("Expecting string from statement block: " + a.type);
            return [
                this.scrub_(a, c[0], b),
                c[1]
            ];
        }
        if ("string" == typeof c) return this.STATEMENT_PREFIX && !a.suppressPrefixSuffix && (c = this.injectId(this.STATEMENT_PREFIX, a) + c), this.STATEMENT_SUFFIX && !a.suppressPrefixSuffix && (c += this.injectId(this.STATEMENT_SUFFIX, a)), this.scrub_(a, c, b);
        if (null === c) return "";
        throw SyntaxError("Invalid code generated: " + c);
    };
    Blockly.Generator.prototype.valueToCode = function(a, b, c) {
        if (isNaN(c)) throw TypeError("Expecting valid order from block: " + a.type);
        var d = a.getInputTargetBlock(b);
        if (!d) return "";
        b = this.blockToCode(d);
        if ("" === b) return "";
        if (!Array.isArray(b)) throw TypeError("Expecting tuple from value block: " + d.type);
        a = b[0];
        b = b[1];
        if (isNaN(b)) throw TypeError("Expecting valid order from value block: " + d.type);
        if (!a) return "";
        d = !1;
        var e = Math.floor(c), f = Math.floor(b);
        if (e <= f && (e != f || 0 != e && 99 != e)) {
            for(d = !0, e = 0; e < this.ORDER_OVERRIDES.length; e++)if (this.ORDER_OVERRIDES[e][0] == c && this.ORDER_OVERRIDES[e][1] == b) {
                d = !1;
                break;
            }
        }
        d && (a = "(" + a + ")");
        return a;
    };
    Blockly.Generator.prototype.statementToCode = function(a, b) {
        a = a.getInputTargetBlock(b);
        b = this.blockToCode(a);
        if ("string" != typeof b) throw TypeError("Expecting code from statement block: " + (a && a.type));
        b && (b = this.prefixLines(b, this.INDENT));
        return b;
    };
    Blockly.Generator.prototype.addLoopTrap = function(a, b) {
        this.INFINITE_LOOP_TRAP && (a = this.prefixLines(this.injectId(this.INFINITE_LOOP_TRAP, b), this.INDENT) + a);
        this.STATEMENT_SUFFIX && !b.suppressPrefixSuffix && (a = this.prefixLines(this.injectId(this.STATEMENT_SUFFIX, b), this.INDENT) + a);
        this.STATEMENT_PREFIX && !b.suppressPrefixSuffix && (a += this.prefixLines(this.injectId(this.STATEMENT_PREFIX, b), this.INDENT));
        return a;
    };
    Blockly.Generator.prototype.injectId = function(a, b) {
        b = b.id.replace(/\$/g, "$$$$");
        return a.replace(/%1/g, "'" + b + "'");
    };
    Blockly.Generator.prototype.RESERVED_WORDS_ = "";
    Blockly.Generator.prototype.addReservedWords = function(a) {
        this.RESERVED_WORDS_ += a + ",";
    };
    Blockly.Generator.prototype.FUNCTION_NAME_PLACEHOLDER_ = "{leCUI8hutHZI4480Dc}";
    Blockly.Generator.prototype.provideFunction_ = function(a, b) {
        if (!this.definitions_[a]) {
            var c = this.variableDB_.getDistinctName(a, Blockly.PROCEDURE_CATEGORY_NAME);
            this.functionNames_[a] = c;
            b = b.join("\n").replace(this.FUNCTION_NAME_PLACEHOLDER_REGEXP_, c);
            for(var d; d != b;)d = b, b = b.replace(/^(( {2})*) {2}/gm, "$1\x00");
            b = b.replace(/\0/g, this.INDENT);
            this.definitions_[a] = b;
        }
        return this.functionNames_[a];
    };
    Blockly.Generator.prototype.init = function(a) {};
    Blockly.Generator.prototype.scrub_ = function(a, b, c) {
        return b;
    };
    Blockly.Generator.prototype.finish = function(a) {
        return a;
    };
    Blockly.Generator.prototype.scrubNakedValue = function(a) {
        return a;
    };
    Blockly.ToolboxItem = function(a, b, c) {
        this.id_ = a.toolboxitemid || Blockly.utils.IdGenerator.getNextUniqueId();
        this.level_ = (this.parent_ = c || null) ? this.parent_.getLevel() + 1 : 0;
        this.toolboxItemDef_ = a;
        this.parentToolbox_ = b;
        this.workspace_ = this.parentToolbox_.getWorkspace();
    };
    Blockly.ToolboxItem.prototype.init = function() {};
    Blockly.ToolboxItem.prototype.getDiv = function() {
        return null;
    };
    Blockly.ToolboxItem.prototype.getId = function() {
        return this.id_;
    };
    Blockly.ToolboxItem.prototype.getParent = function() {
        return null;
    };
    Blockly.ToolboxItem.prototype.getLevel = function() {
        return this.level_;
    };
    Blockly.ToolboxItem.prototype.isSelectable = function() {
        return !1;
    };
    Blockly.ToolboxItem.prototype.isCollapsible = function() {
        return !1;
    };
    Blockly.ToolboxItem.prototype.dispose = function() {};
    Blockly.ToolboxCategory = function(a, b, c) {
        Blockly.ToolboxCategory.superClass_.constructor.call(this, a, b, c);
        this.name_ = Blockly.utils.replaceMessageReferences(a.name);
        this.colour_ = this.getColour_(a);
        this.labelDom_ = this.iconDom_ = this.rowContents_ = this.rowDiv_ = this.htmlDiv_ = null;
        this.cssConfig_ = this.makeDefaultCssConfig_();
        Blockly.utils.object.mixin(this.cssConfig_, a.cssconfig || a.cssConfig);
        this.isDisabled_ = this.isHidden_ = !1;
        this.flyoutItems_ = [];
        this.parseContents_(a);
    };
    Blockly.utils.object.inherits(Blockly.ToolboxCategory, Blockly.ToolboxItem);
    Blockly.ToolboxCategory.registrationName = "category";
    Blockly.ToolboxCategory.nestedPadding = 19;
    Blockly.ToolboxCategory.borderWidth = 8;
    Blockly.ToolboxCategory.defaultBackgroundColour = "#57e";
    Blockly.ToolboxCategory.prototype.makeDefaultCssConfig_ = function() {
        return {
            container: "blocklyToolboxCategory",
            row: "blocklyTreeRow",
            rowcontentcontainer: "blocklyTreeRowContentContainer",
            icon: "blocklyTreeIcon",
            label: "blocklyTreeLabel",
            contents: "blocklyToolboxContents",
            selected: "blocklyTreeSelected",
            openicon: "blocklyTreeIconOpen",
            closedicon: "blocklyTreeIconClosed"
        };
    };
    Blockly.ToolboxCategory.prototype.parseContents_ = function(a) {
        var b = a.contents;
        if (a.custom) this.flyoutItems_ = a.custom;
        else if (b) {
            a = 0;
            for(var c; c = b[a]; a++)this.flyoutItems_.push(c);
        }
    };
    Blockly.ToolboxCategory.prototype.init = function() {
        this.createDom_();
        "true" == this.toolboxItemDef_.hidden && this.hide();
    };
    Blockly.ToolboxCategory.prototype.createDom_ = function() {
        this.htmlDiv_ = this.createContainer_();
        Blockly.utils.aria.setRole(this.htmlDiv_, Blockly.utils.aria.Role.TREEITEM);
        Blockly.utils.aria.setState(this.htmlDiv_, Blockly.utils.aria.State.SELECTED, !1);
        Blockly.utils.aria.setState(this.htmlDiv_, Blockly.utils.aria.State.LEVEL, this.level_);
        this.rowDiv_ = this.createRowContainer_();
        this.rowDiv_.style.pointerEvents = "auto";
        this.htmlDiv_.appendChild(this.rowDiv_);
        this.rowContents_ = this.createRowContentsContainer_();
        this.rowContents_.style.pointerEvents = "none";
        this.rowDiv_.appendChild(this.rowContents_);
        this.iconDom_ = this.createIconDom_();
        Blockly.utils.aria.setRole(this.iconDom_, Blockly.utils.aria.Role.PRESENTATION);
        this.rowContents_.appendChild(this.iconDom_);
        this.labelDom_ = this.createLabelDom_(this.name_);
        this.rowContents_.appendChild(this.labelDom_);
        Blockly.utils.aria.setState(this.htmlDiv_, Blockly.utils.aria.State.LABELLEDBY, this.labelDom_.getAttribute("id"));
        this.addColourBorder_(this.colour_);
        return this.htmlDiv_;
    };
    Blockly.ToolboxCategory.prototype.createContainer_ = function() {
        var a = document.createElement("div");
        Blockly.utils.dom.addClass(a, this.cssConfig_.container);
        return a;
    };
    Blockly.ToolboxCategory.prototype.createRowContainer_ = function() {
        var a = document.createElement("div");
        Blockly.utils.dom.addClass(a, this.cssConfig_.row);
        var b = Blockly.ToolboxCategory.nestedPadding * this.getLevel();
        b = b.toString() + "px";
        this.workspace_.RTL ? a.style.paddingRight = b : a.style.paddingLeft = b;
        return a;
    };
    Blockly.ToolboxCategory.prototype.createRowContentsContainer_ = function() {
        var a = document.createElement("div");
        Blockly.utils.dom.addClass(a, this.cssConfig_.rowcontentcontainer);
        return a;
    };
    Blockly.ToolboxCategory.prototype.createIconDom_ = function() {
        var a = document.createElement("span");
        this.parentToolbox_.isHorizontal() || Blockly.utils.dom.addClass(a, this.cssConfig_.icon);
        a.style.display = "inline-block";
        return a;
    };
    Blockly.ToolboxCategory.prototype.createLabelDom_ = function(a) {
        var b = document.createElement("span");
        b.setAttribute("id", this.getId() + ".label");
        b.textContent = a;
        Blockly.utils.dom.addClass(b, this.cssConfig_.label);
        return b;
    };
    Blockly.ToolboxCategory.prototype.refreshTheme = function() {
        this.colour_ = this.getColour_(this.toolboxItemDef_);
        this.addColourBorder_(this.colour_);
    };
    Blockly.ToolboxCategory.prototype.addColourBorder_ = function(a) {
        a && (a = Blockly.ToolboxCategory.borderWidth + "px solid " + (a || "#ddd"), this.workspace_.RTL ? this.rowDiv_.style.borderRight = a : this.rowDiv_.style.borderLeft = a);
    };
    Blockly.ToolboxCategory.prototype.getColour_ = function(a) {
        var b = a.categorystyle || a.categoryStyle;
        if ((a = a.colour) && b) console.warn('Toolbox category "' + this.name_ + '" must not have both a style and a colour');
        else return b ? this.getColourfromStyle_(b) : this.parseColour_(a);
        return "";
    };
    Blockly.ToolboxCategory.prototype.getColourfromStyle_ = function(a) {
        var b = this.workspace_.getTheme();
        if (a && b) {
            if ((b = b.categoryStyles[a]) && b.colour) return this.parseColour_(b.colour);
            console.warn('Style "' + a + '" must exist and contain a colour value');
        }
        return "";
    };
    Blockly.ToolboxCategory.prototype.getClickTarget = function() {
        return this.rowDiv_;
    };
    Blockly.ToolboxCategory.prototype.parseColour_ = function(a) {
        a = Blockly.utils.replaceMessageReferences(a);
        if (null == a || "" === a) return "";
        var b = Number(a);
        if (isNaN(b)) {
            if (b = Blockly.utils.colour.parse(a)) return b;
            console.warn('Toolbox category "' + this.name_ + '" has unrecognized colour attribute: ' + a);
            return "";
        }
        return Blockly.hueToHex(b);
    };
    Blockly.ToolboxCategory.prototype.openIcon_ = function(a) {
        a && (Blockly.utils.dom.removeClasses(a, this.cssConfig_.closedicon), Blockly.utils.dom.addClass(a, this.cssConfig_.openicon));
    };
    Blockly.ToolboxCategory.prototype.closeIcon_ = function(a) {
        a && (Blockly.utils.dom.removeClasses(a, this.cssConfig_.openicon), Blockly.utils.dom.addClass(a, this.cssConfig_.closedicon));
    };
    Blockly.ToolboxCategory.prototype.setVisible_ = function(a) {
        this.htmlDiv_.style.display = a ? "block" : "none";
        this.isHidden_ = !a;
        this.parentToolbox_.getSelectedItem() == this && this.parentToolbox_.clearSelection();
    };
    Blockly.ToolboxCategory.prototype.hide = function() {
        this.setVisible_(!1);
    };
    Blockly.ToolboxCategory.prototype.show = function() {
        this.setVisible_(!0);
    };
    Blockly.ToolboxCategory.prototype.isVisible = function() {
        return !this.isHidden_ && this.allAncestorsExpanded_();
    };
    Blockly.ToolboxCategory.prototype.allAncestorsExpanded_ = function() {
        for(var a = this; a.getParent();)if (a = a.getParent(), !a.isExpanded()) return !1;
        return !0;
    };
    Blockly.ToolboxCategory.prototype.isSelectable = function() {
        return this.isVisible() && !this.isDisabled_;
    };
    Blockly.ToolboxCategory.prototype.onClick = function(a) {};
    Blockly.ToolboxCategory.prototype.setSelected = function(a) {
        if (a) {
            var b = this.parseColour_(Blockly.ToolboxCategory.defaultBackgroundColour);
            this.rowDiv_.style.backgroundColor = this.colour_ || b;
            Blockly.utils.dom.addClass(this.rowDiv_, this.cssConfig_.selected);
        } else this.rowDiv_.style.backgroundColor = "", Blockly.utils.dom.removeClass(this.rowDiv_, this.cssConfig_.selected);
        Blockly.utils.aria.setState(this.htmlDiv_, Blockly.utils.aria.State.SELECTED, a);
    };
    Blockly.ToolboxCategory.prototype.setDisabled = function(a) {
        this.isDisabled_ = a;
        this.getDiv().setAttribute("disabled", a);
        a ? this.getDiv().setAttribute("disabled", "true") : this.getDiv().removeAttribute("disabled");
    };
    Blockly.ToolboxCategory.prototype.getName = function() {
        return this.name_;
    };
    Blockly.ToolboxCategory.prototype.getParent = function() {
        return this.parent_;
    };
    Blockly.ToolboxCategory.prototype.getDiv = function() {
        return this.htmlDiv_;
    };
    Blockly.ToolboxCategory.prototype.getContents = function() {
        return this.flyoutItems_;
    };
    Blockly.ToolboxCategory.prototype.updateFlyoutContents = function(a) {
        this.flyoutItems_ = [];
        "string" == typeof a ? this.toolboxItemDef_.custom = a : (delete this.toolboxItemDef_.custom, this.toolboxItemDef_.contents = Blockly.utils.toolbox.convertFlyoutDefToJsonArray(a));
        this.parseContents_(this.toolboxItemDef_);
    };
    Blockly.ToolboxCategory.prototype.dispose = function() {
        Blockly.utils.dom.removeNode(this.htmlDiv_);
    };
    Blockly.Css.register([
        ".blocklyTreeRow:not(.blocklyTreeSelected):hover {",
        "background-color: rgba(255, 255, 255, 0.2);",
        "}",
        '.blocklyToolboxDiv[layout="h"] .blocklyToolboxCategory {',
        "margin: 1px 5px 1px 0;",
        "}",
        '.blocklyToolboxDiv[dir="RTL"][layout="h"] .blocklyToolboxCategory {',
        "margin: 1px 0 1px 5px;",
        "}",
        ".blocklyTreeRow {",
        "height: 22px;",
        "line-height: 22px;",
        "margin-bottom: 3px;",
        "padding-right: 8px;",
        "white-space: nowrap;",
        "}",
        '.blocklyToolboxDiv[dir="RTL"] .blocklyTreeRow {',
        "margin-left: 8px;",
        "padding-right: 0px",
        "}",
        ".blocklyTreeIcon {",
        "background-image: url(<<<PATH>>>/sprites.png);",
        "height: 16px;",
        "vertical-align: middle;",
        "visibility: hidden;",
        "width: 16px;",
        "}",
        ".blocklyTreeIconClosed {",
        "background-position: -32px -1px;",
        "}",
        '.blocklyToolboxDiv[dir="RTL"] .blocklyTreeIconClosed {',
        "background-position: 0 -1px;",
        "}",
        ".blocklyTreeSelected>.blocklyTreeIconClosed {",
        "background-position: -32px -17px;",
        "}",
        '.blocklyToolboxDiv[dir="RTL"] .blocklyTreeSelected>.blocklyTreeIconClosed {',
        "background-position: 0 -17px;",
        "}",
        ".blocklyTreeIconOpen {",
        "background-position: -16px -1px;",
        "}",
        ".blocklyTreeSelected>.blocklyTreeIconOpen {",
        "background-position: -16px -17px;",
        "}",
        ".blocklyTreeLabel {",
        "cursor: default;",
        "font: 16px sans-serif;",
        "padding: 0 3px;",
        "vertical-align: middle;",
        "}",
        ".blocklyToolboxDelete .blocklyTreeLabel {",
        'cursor: url("<<<PATH>>>/handdelete.cur"), auto;',
        "}",
        ".blocklyTreeSelected .blocklyTreeLabel {",
        "color: #fff;",
        "}"
    ]);
    Blockly.registry.register(Blockly.registry.Type.TOOLBOX_ITEM, Blockly.ToolboxCategory.registrationName, Blockly.ToolboxCategory);
    Blockly.ToolboxSeparator = function(a, b) {
        Blockly.ToolboxSeparator.superClass_.constructor.call(this, a, b);
        this.cssConfig_ = {
            container: "blocklyTreeSeparator"
        };
        Blockly.utils.object.mixin(this.cssConfig_, a.cssconfig || a.cssConfig);
    };
    Blockly.utils.object.inherits(Blockly.ToolboxSeparator, Blockly.ToolboxItem);
    Blockly.ToolboxSeparator.registrationName = "sep";
    Blockly.ToolboxSeparator.prototype.init = function() {
        this.createDom_();
    };
    Blockly.ToolboxSeparator.prototype.createDom_ = function() {
        var a = document.createElement("div");
        Blockly.utils.dom.addClass(a, this.cssConfig_.container);
        return this.htmlDiv_ = a;
    };
    Blockly.ToolboxSeparator.prototype.getDiv = function() {
        return this.htmlDiv_;
    };
    Blockly.ToolboxSeparator.prototype.dispose = function() {
        Blockly.utils.dom.removeNode(this.htmlDiv_);
    };
    Blockly.Css.register('.blocklyTreeSeparator {,border-bottom: solid #e5e5e5 1px;,height: 0;,margin: 5px 0;,},.blocklyToolboxDiv[layout="h"] .blocklyTreeSeparator {,border-right: solid #e5e5e5 1px;,border-bottom: none;,height: auto;,margin: 0 5px 0 5px;,padding: 5px 0;,width: 0;,}'.split(","));
    Blockly.registry.register(Blockly.registry.Type.TOOLBOX_ITEM, Blockly.ToolboxSeparator.registrationName, Blockly.ToolboxSeparator);
    Blockly.CollapsibleToolboxCategory = function(a, b, c) {
        this.subcategoriesDiv_ = null;
        this.expanded_ = !1;
        this.toolboxItems_ = [];
        Blockly.CollapsibleToolboxCategory.superClass_.constructor.call(this, a, b, c);
    };
    Blockly.utils.object.inherits(Blockly.CollapsibleToolboxCategory, Blockly.ToolboxCategory);
    Blockly.CollapsibleToolboxCategory.registrationName = "collapsibleCategory";
    Blockly.CollapsibleToolboxCategory.prototype.makeDefaultCssConfig_ = function() {
        var a = Blockly.CollapsibleToolboxCategory.superClass_.makeDefaultCssConfig_.call(this);
        a.contents = "blocklyToolboxContents";
        return a;
    };
    Blockly.CollapsibleToolboxCategory.prototype.parseContents_ = function(a) {
        var b = a.contents, c = !0;
        if (a.custom) this.flyoutItems_ = a.custom;
        else if (b) {
            a = 0;
            for(var d; d = b[a]; a++)!Blockly.registry.hasItem(Blockly.registry.Type.TOOLBOX_ITEM, d.kind) || d.kind.toLowerCase() == Blockly.ToolboxSeparator.registrationName && c ? (this.flyoutItems_.push(d), c = !0) : (this.createToolboxItem_(d), c = !1);
        }
    };
    Blockly.CollapsibleToolboxCategory.prototype.createToolboxItem_ = function(a) {
        var b = a.kind;
        "CATEGORY" == b.toUpperCase() && Blockly.utils.toolbox.isCategoryCollapsible(a) && (b = Blockly.CollapsibleToolboxCategory.registrationName);
        a = new (Blockly.registry.getClass(Blockly.registry.Type.TOOLBOX_ITEM, b))(a, this.parentToolbox_, this);
        this.toolboxItems_.push(a);
    };
    Blockly.CollapsibleToolboxCategory.prototype.init = function() {
        Blockly.CollapsibleToolboxCategory.superClass_.init.call(this);
        this.setExpanded("true" == this.toolboxItemDef_.expanded || this.toolboxItemDef_.expanded);
    };
    Blockly.CollapsibleToolboxCategory.prototype.createDom_ = function() {
        Blockly.CollapsibleToolboxCategory.superClass_.createDom_.call(this);
        var a = this.getChildToolboxItems();
        this.subcategoriesDiv_ = this.createSubCategoriesDom_(a);
        Blockly.utils.aria.setRole(this.subcategoriesDiv_, Blockly.utils.aria.Role.GROUP);
        this.htmlDiv_.appendChild(this.subcategoriesDiv_);
        return this.htmlDiv_;
    };
    Blockly.CollapsibleToolboxCategory.prototype.createIconDom_ = function() {
        var a = document.createElement("span");
        this.parentToolbox_.isHorizontal() || (Blockly.utils.dom.addClass(a, this.cssConfig_.icon), a.style.visibility = "visible");
        a.style.display = "inline-block";
        return a;
    };
    Blockly.CollapsibleToolboxCategory.prototype.createSubCategoriesDom_ = function(a) {
        var b = document.createElement("div");
        Blockly.utils.dom.addClass(b, this.cssConfig_.contents);
        for(var c = 0; c < a.length; c++){
            var d = a[c];
            d.init();
            var e = d.getDiv();
            b.appendChild(e);
            d.getClickTarget && d.getClickTarget().setAttribute("id", d.getId());
        }
        return b;
    };
    Blockly.CollapsibleToolboxCategory.prototype.setExpanded = function(a) {
        this.expanded_ != a && ((this.expanded_ = a) ? (this.subcategoriesDiv_.style.display = "block", this.openIcon_(this.iconDom_)) : (this.subcategoriesDiv_.style.display = "none", this.closeIcon_(this.iconDom_)), Blockly.utils.aria.setState(this.htmlDiv_, Blockly.utils.aria.State.EXPANDED, a), this.parentToolbox_.handleToolboxItemResize());
    };
    Blockly.CollapsibleToolboxCategory.prototype.setVisible_ = function(a) {
        this.htmlDiv_.style.display = a ? "block" : "none";
        for(var b = 0, c; c = this.getChildToolboxItems()[b]; b++)c.setVisible_(a);
        this.isHidden_ = !a;
        this.parentToolbox_.getSelectedItem() == this && this.parentToolbox_.clearSelection();
    };
    Blockly.CollapsibleToolboxCategory.prototype.isExpanded = function() {
        return this.expanded_;
    };
    Blockly.CollapsibleToolboxCategory.prototype.isCollapsible = function() {
        return !0;
    };
    Blockly.CollapsibleToolboxCategory.prototype.onClick = function(a) {
        this.toggleExpanded();
    };
    Blockly.CollapsibleToolboxCategory.prototype.toggleExpanded = function() {
        this.setExpanded(!this.expanded_);
    };
    Blockly.CollapsibleToolboxCategory.prototype.getDiv = function() {
        return this.htmlDiv_;
    };
    Blockly.CollapsibleToolboxCategory.prototype.getChildToolboxItems = function() {
        return this.toolboxItems_;
    };
    Blockly.registry.register(Blockly.registry.Type.TOOLBOX_ITEM, Blockly.CollapsibleToolboxCategory.registrationName, Blockly.CollapsibleToolboxCategory);
    Blockly.Events.ToolboxItemSelect = function(a, b, c) {
        Blockly.Events.ToolboxItemSelect.superClass_.constructor.call(this, c);
        this.oldItem = a;
        this.newItem = b;
    };
    Blockly.utils.object.inherits(Blockly.Events.ToolboxItemSelect, Blockly.Events.UiBase);
    Blockly.Events.ToolboxItemSelect.prototype.type = Blockly.Events.TOOLBOX_ITEM_SELECT;
    Blockly.Events.ToolboxItemSelect.prototype.toJson = function() {
        var a = Blockly.Events.ToolboxItemSelect.superClass_.toJson.call(this);
        a.oldItem = this.oldItem;
        a.newItem = this.newItem;
        return a;
    };
    Blockly.Events.ToolboxItemSelect.prototype.fromJson = function(a) {
        Blockly.Events.ToolboxItemSelect.superClass_.fromJson.call(this, a);
        this.oldItem = a.oldItem;
        this.newItem = a.newItem;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.TOOLBOX_ITEM_SELECT, Blockly.Events.ToolboxItemSelect);
    Blockly.Toolbox = function(a) {
        this.workspace_ = a;
        this.toolboxDef_ = a.options.languageTree || {
            contents: []
        };
        this.horizontalLayout_ = a.options.horizontalLayout;
        this.contentsDiv_ = this.HtmlDiv = null;
        this.contents_ = [];
        this.height_ = this.width_ = 0;
        this.RTL = a.options.RTL;
        this.flyout_ = null;
        this.contentMap_ = {};
        this.toolboxPosition = a.options.toolboxPosition;
        this.previouslySelectedItem_ = this.selectedItem_ = null;
        this.boundEvents_ = [];
    };
    Blockly.Toolbox.prototype.onShortcut = function(a) {
        return !1;
    };
    Blockly.Toolbox.prototype.init = function() {
        var a = this.workspace_, b = a.getParentSvg();
        this.flyout_ = this.createFlyout_();
        this.HtmlDiv = this.createDom_(this.workspace_);
        Blockly.utils.dom.insertAfter(this.flyout_.createDom("svg"), b);
        this.flyout_.init(a);
        this.render(this.toolboxDef_);
        a = a.getThemeManager();
        a.subscribe(this.HtmlDiv, "toolboxBackgroundColour", "background-color");
        a.subscribe(this.HtmlDiv, "toolboxForegroundColour", "color");
    };
    Blockly.Toolbox.prototype.createDom_ = function(a) {
        a = a.getParentSvg();
        var b = this.createContainer_();
        this.contentsDiv_ = this.createContentsContainer_();
        this.contentsDiv_.tabIndex = 0;
        Blockly.utils.aria.setRole(this.contentsDiv_, Blockly.utils.aria.Role.TREE);
        b.appendChild(this.contentsDiv_);
        a.parentNode.insertBefore(b, a);
        this.attachEvents_(b, this.contentsDiv_);
        return b;
    };
    Blockly.Toolbox.prototype.createContainer_ = function() {
        var a = document.createElement("div");
        a.setAttribute("layout", this.isHorizontal() ? "h" : "v");
        Blockly.utils.dom.addClass(a, "blocklyToolboxDiv");
        Blockly.utils.dom.addClass(a, "blocklyNonSelectable");
        a.setAttribute("dir", this.RTL ? "RTL" : "LTR");
        return a;
    };
    Blockly.Toolbox.prototype.createContentsContainer_ = function() {
        var a = document.createElement("div");
        Blockly.utils.dom.addClass(a, "blocklyToolboxContents");
        this.isHorizontal() && (a.style.flexDirection = "row");
        return a;
    };
    Blockly.Toolbox.prototype.attachEvents_ = function(a, b) {
        a = Blockly.browserEvents.conditionalBind(a, "click", this, this.onClick_, !1, !0);
        this.boundEvents_.push(a);
        b = Blockly.browserEvents.conditionalBind(b, "keydown", this, this.onKeyDown_, !1, !0);
        this.boundEvents_.push(b);
    };
    Blockly.Toolbox.prototype.onClick_ = function(a) {
        if (Blockly.utils.isRightButton(a) || a.target == this.HtmlDiv) Blockly.hideChaff(!1);
        else {
            var b = a.target.getAttribute("id");
            b && (b = this.getToolboxItemById(b), b.isSelectable() && (this.setSelectedItem(b), b.onClick(a)));
            Blockly.hideChaff(!0);
        }
        Blockly.Touch.clearTouchIdentifier();
    };
    Blockly.Toolbox.prototype.onKeyDown_ = function(a) {
        var b = !1;
        switch(a.keyCode){
            case Blockly.utils.KeyCodes.DOWN:
                b = this.selectNext_();
                break;
            case Blockly.utils.KeyCodes.UP:
                b = this.selectPrevious_();
                break;
            case Blockly.utils.KeyCodes.LEFT:
                b = this.selectParent_();
                break;
            case Blockly.utils.KeyCodes.RIGHT:
                b = this.selectChild_();
                break;
            case Blockly.utils.KeyCodes.ENTER:
            case Blockly.utils.KeyCodes.SPACE:
                this.selectedItem_ && this.selectedItem_.isCollapsible() && (this.selectedItem_.toggleExpanded(), b = !0);
                break;
            default:
                b = !1;
        }
        !b && this.selectedItem_ && this.selectedItem_.onKeyDown && (b = this.selectedItem_.onKeyDown(a));
        b && a.preventDefault();
    };
    Blockly.Toolbox.prototype.createFlyout_ = function() {
        var a = this.workspace_, b = new Blockly.Options({
            parentWorkspace: a,
            rtl: a.RTL,
            oneBasedIndex: a.options.oneBasedIndex,
            horizontalLayout: a.horizontalLayout,
            renderer: a.options.renderer,
            rendererOverrides: a.options.rendererOverrides,
            move: {
                scrollbars: !0
            }
        });
        b.toolboxPosition = a.options.toolboxPosition;
        return new (a.horizontalLayout ? Blockly.registry.getClassFromOptions(Blockly.registry.Type.FLYOUTS_HORIZONTAL_TOOLBOX, a.options, !0) : Blockly.registry.getClassFromOptions(Blockly.registry.Type.FLYOUTS_VERTICAL_TOOLBOX, a.options, !0))(b);
    };
    Blockly.Toolbox.prototype.render = function(a) {
        this.toolboxDef_ = a;
        for(var b = 0; b < this.contents_.length; b++){
            var c = this.contents_[b];
            c && c.dispose();
        }
        this.contents_ = [];
        this.contentMap_ = {};
        this.renderContents_(a.contents);
        this.position();
    };
    Blockly.Toolbox.prototype.renderContents_ = function(a) {
        for(var b = document.createDocumentFragment(), c = 0, d; d = a[c]; c++)this.createToolboxItem_(d, b);
        this.contentsDiv_.appendChild(b);
    };
    Blockly.Toolbox.prototype.createToolboxItem_ = function(a, b) {
        var c = a.kind;
        "CATEGORY" == c.toUpperCase() && Blockly.utils.toolbox.isCategoryCollapsible(a) && (c = Blockly.CollapsibleToolboxCategory.registrationName);
        if (c = Blockly.registry.getClass(Blockly.registry.Type.TOOLBOX_ITEM, c.toLowerCase())) a = new c(a, this), this.addToolboxItem_(a), a.init(), (c = a.getDiv()) && b.appendChild(c), a.getClickTarget && a.getClickTarget().setAttribute("id", a.getId());
    };
    Blockly.Toolbox.prototype.addToolboxItem_ = function(a) {
        this.contents_.push(a);
        this.contentMap_[a.getId()] = a;
        if (a.isCollapsible()) for(var b = 0, c; c = a.getChildToolboxItems()[b]; b++)this.addToolboxItem_(c);
    };
    Blockly.Toolbox.prototype.getToolboxItems = function() {
        return this.contents_;
    };
    Blockly.Toolbox.prototype.addStyle = function(a) {
        Blockly.utils.dom.addClass(this.HtmlDiv, a);
    };
    Blockly.Toolbox.prototype.removeStyle = function(a) {
        Blockly.utils.dom.removeClass(this.HtmlDiv, a);
    };
    Blockly.Toolbox.prototype.getClientRect = function() {
        if (!this.HtmlDiv) return null;
        var a = this.HtmlDiv.getBoundingClientRect(), b = a.top, c = b + a.height, d = a.left;
        a = d + a.width;
        return this.toolboxPosition == Blockly.utils.toolbox.Position.TOP ? new Blockly.utils.Rect(-10000000, c, -10000000, 1E7) : this.toolboxPosition == Blockly.utils.toolbox.Position.BOTTOM ? new Blockly.utils.Rect(b, 1E7, -10000000, 1E7) : this.toolboxPosition == Blockly.utils.toolbox.Position.LEFT ? new Blockly.utils.Rect(-10000000, 1E7, -10000000, a) : new Blockly.utils.Rect(-10000000, 1E7, d, 1E7);
    };
    Blockly.Toolbox.prototype.getToolboxItemById = function(a) {
        return this.contentMap_[a];
    };
    Blockly.Toolbox.prototype.getWidth = function() {
        return this.width_;
    };
    Blockly.Toolbox.prototype.getHeight = function() {
        return this.height_;
    };
    Blockly.Toolbox.prototype.getFlyout = function() {
        return this.flyout_;
    };
    Blockly.Toolbox.prototype.getWorkspace = function() {
        return this.workspace_;
    };
    Blockly.Toolbox.prototype.getSelectedItem = function() {
        return this.selectedItem_;
    };
    Blockly.Toolbox.prototype.getPreviouslySelectedItem = function() {
        return this.previouslySelectedItem_;
    };
    Blockly.Toolbox.prototype.isHorizontal = function() {
        return this.horizontalLayout_;
    };
    Blockly.Toolbox.prototype.position = function() {
        var a = this.workspace_.getMetrics(), b = this.HtmlDiv;
        b && (this.horizontalLayout_ ? (b.style.left = "0", b.style.height = "auto", b.style.width = "100%", this.height_ = b.offsetHeight, this.width_ = a.viewWidth, this.toolboxPosition == Blockly.utils.toolbox.Position.TOP ? b.style.top = "0" : b.style.bottom = "0") : (this.toolboxPosition == Blockly.utils.toolbox.Position.RIGHT ? b.style.right = "0" : b.style.left = "0", b.style.height = "100%", this.width_ = b.offsetWidth, this.height_ = a.viewHeight), this.flyout_.position());
    };
    Blockly.Toolbox.prototype.handleToolboxItemResize = function() {
        var a = this.workspace_, b = this.HtmlDiv.getBoundingClientRect();
        a.translate(this.toolboxPosition == Blockly.utils.toolbox.Position.LEFT ? a.scrollX + b.width : a.scrollX, this.toolboxPosition == Blockly.utils.toolbox.Position.TOP ? a.scrollY + b.height : a.scrollY);
        Blockly.svgResize(a);
    };
    Blockly.Toolbox.prototype.clearSelection = function() {
        this.setSelectedItem(null);
    };
    Blockly.Toolbox.prototype.refreshTheme = function() {
        for(var a = 0; a < this.contents_.length; a++){
            var b = this.contents_[a];
            b.refreshTheme && b.refreshTheme();
        }
    };
    Blockly.Toolbox.prototype.refreshSelection = function() {
        this.selectedItem_ && this.selectedItem_.isSelectable() && this.selectedItem_.getContents().length && this.flyout_.show(this.selectedItem_.getContents());
    };
    Blockly.Toolbox.prototype.setVisible = function(a) {
        this.HtmlDiv.style.display = a ? "block" : "none";
    };
    Blockly.Toolbox.prototype.setSelectedItem = function(a) {
        var b = this.selectedItem_;
        !a && !b || a && !a.isSelectable() || (this.shouldDeselectItem_(b, a) && null != b && this.deselectItem_(b), this.shouldSelectItem_(b, a) && null != a && this.selectItem_(b, a), this.updateFlyout_(b, a), this.fireSelectEvent_(b, a));
    };
    Blockly.Toolbox.prototype.shouldDeselectItem_ = function(a, b) {
        return null != a && (!a.isCollapsible() || a != b);
    };
    Blockly.Toolbox.prototype.shouldSelectItem_ = function(a, b) {
        return null != b && b != a;
    };
    Blockly.Toolbox.prototype.deselectItem_ = function(a) {
        this.selectedItem_ = null;
        this.previouslySelectedItem_ = a;
        a.setSelected(!1);
        Blockly.utils.aria.setState(this.contentsDiv_, Blockly.utils.aria.State.ACTIVEDESCENDANT, "");
    };
    Blockly.Toolbox.prototype.selectItem_ = function(a, b) {
        this.selectedItem_ = b;
        this.previouslySelectedItem_ = a;
        b.setSelected(!0);
        Blockly.utils.aria.setState(this.contentsDiv_, Blockly.utils.aria.State.ACTIVEDESCENDANT, b.getId());
    };
    Blockly.Toolbox.prototype.selectItemByPosition = function(a) {
        -1 < a && a < this.contents_.length && (a = this.contents_[a], a.isSelectable() && this.setSelectedItem(a));
    };
    Blockly.Toolbox.prototype.updateFlyout_ = function(a, b) {
        (a != b || b.isCollapsible()) && b && b.getContents().length ? (this.flyout_.show(b.getContents()), this.flyout_.scrollToStart()) : this.flyout_.hide();
    };
    Blockly.Toolbox.prototype.fireSelectEvent_ = function(a, b) {
        var c = a && a.getName(), d = b && b.getName();
        a == b && (d = null);
        a = new (Blockly.Events.get(Blockly.Events.TOOLBOX_ITEM_SELECT))(c, d, this.workspace_.id);
        Blockly.Events.fire(a);
    };
    Blockly.Toolbox.prototype.selectParent_ = function() {
        return this.selectedItem_ ? this.selectedItem_.isCollapsible() && this.selectedItem_.isExpanded() ? (this.selectedItem_.setExpanded(!1), !0) : this.selectedItem_.getParent() && this.selectedItem_.getParent().isSelectable() ? (this.setSelectedItem(this.selectedItem_.getParent()), !0) : !1 : !1;
    };
    Blockly.Toolbox.prototype.selectChild_ = function() {
        if (!this.selectedItem_ || !this.selectedItem_.isCollapsible()) return !1;
        var a = this.selectedItem_;
        a.isExpanded() ? this.selectNext_() : a.setExpanded(!0);
        return !0;
    };
    Blockly.Toolbox.prototype.selectNext_ = function() {
        if (!this.selectedItem_) return !1;
        var a = this.contents_.indexOf(this.selectedItem_) + 1;
        if (-1 < a && a < this.contents_.length) {
            for(var b = this.contents_[a]; b && !b.isSelectable();)b = this.contents_[++a];
            if (b && b.isSelectable()) return this.setSelectedItem(b), !0;
        }
        return !1;
    };
    Blockly.Toolbox.prototype.selectPrevious_ = function() {
        if (!this.selectedItem_) return !1;
        var a = this.contents_.indexOf(this.selectedItem_) - 1;
        if (-1 < a && a < this.contents_.length) {
            for(var b = this.contents_[a]; b && !b.isSelectable();)b = this.contents_[--a];
            if (b && b.isSelectable()) return this.setSelectedItem(b), !0;
        }
        return !1;
    };
    Blockly.Toolbox.prototype.dispose = function() {
        this.flyout_.dispose();
        for(var a = 0; a < this.contents_.length; a++)this.contents_[a].dispose();
        for(a = 0; a < this.boundEvents_.length; a++)Blockly.browserEvents.unbind(this.boundEvents_[a]);
        this.boundEvents_ = [];
        this.contents_ = [];
        this.workspace_.getThemeManager().unsubscribe(this.HtmlDiv);
        Blockly.utils.dom.removeNode(this.HtmlDiv);
    };
    Blockly.Css.register([
        ".blocklyToolboxDelete {",
        'cursor: url("<<<PATH>>>/handdelete.cur"), auto;',
        "}",
        ".blocklyToolboxGrab {",
        'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',
        "cursor: grabbing;",
        "cursor: -webkit-grabbing;",
        "}",
        ".blocklyToolboxDiv {",
        "background-color: #ddd;",
        "overflow-x: visible;",
        "overflow-y: auto;",
        "padding: 4px 0 4px 0;",
        "position: absolute;",
        "z-index: 70;",
        "-webkit-tap-highlight-color: transparent;",
        "}",
        ".blocklyToolboxContents {",
        "display: flex;",
        "flex-wrap: wrap;",
        "flex-direction: column;",
        "}",
        ".blocklyToolboxContents:focus {",
        "outline: none;",
        "}"
    ]);
    Blockly.registry.register(Blockly.registry.Type.TOOLBOX, Blockly.registry.DEFAULT, Blockly.Toolbox);
    Blockly.Events.TrashcanOpen = function(a, b) {
        Blockly.Events.TrashcanOpen.superClass_.constructor.call(this, b);
        this.isOpen = a;
    };
    Blockly.utils.object.inherits(Blockly.Events.TrashcanOpen, Blockly.Events.UiBase);
    Blockly.Events.TrashcanOpen.prototype.type = Blockly.Events.TRASHCAN_OPEN;
    Blockly.Events.TrashcanOpen.prototype.toJson = function() {
        var a = Blockly.Events.TrashcanOpen.superClass_.toJson.call(this);
        a.isOpen = this.isOpen;
        return a;
    };
    Blockly.Events.TrashcanOpen.prototype.fromJson = function(a) {
        Blockly.Events.TrashcanOpen.superClass_.fromJson.call(this, a);
        this.isOpen = a.isOpen;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.TRASHCAN_OPEN, Blockly.Events.TrashcanOpen);
    Blockly.IPlugin = function() {};
    Blockly.IPositionable = function() {};
    Blockly.Trashcan = function(a) {
        this.workspace_ = a;
        this.contents_ = [];
        this.flyout = null;
        0 >= this.workspace_.options.maxTrashcanContents || (a = new Blockly.Options({
            scrollbars: !0,
            parentWorkspace: this.workspace_,
            rtl: this.workspace_.RTL,
            oneBasedIndex: this.workspace_.options.oneBasedIndex,
            renderer: this.workspace_.options.renderer,
            rendererOverrides: this.workspace_.options.rendererOverrides,
            move: {
                scrollbars: !0
            }
        }), this.workspace_.horizontalLayout ? (a.toolboxPosition = this.workspace_.toolboxPosition == Blockly.utils.toolbox.Position.TOP ? Blockly.utils.toolbox.Position.BOTTOM : Blockly.utils.toolbox.Position.TOP, this.flyout = new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.FLYOUTS_HORIZONTAL_TOOLBOX, this.workspace_.options, !0))(a)) : (a.toolboxPosition = this.workspace_.toolboxPosition == Blockly.utils.toolbox.Position.RIGHT ? Blockly.utils.toolbox.Position.LEFT : Blockly.utils.toolbox.Position.RIGHT, this.flyout = new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.FLYOUTS_VERTICAL_TOOLBOX, this.workspace_.options, !0))(a)), this.workspace_.addChangeListener(this.onDelete_.bind(this)));
    };
    Blockly.Trashcan.prototype.WIDTH_ = 47;
    Blockly.Trashcan.prototype.BODY_HEIGHT_ = 44;
    Blockly.Trashcan.prototype.LID_HEIGHT_ = 16;
    Blockly.Trashcan.prototype.MARGIN_BOTTOM_ = 20;
    Blockly.Trashcan.prototype.MARGIN_SIDE_ = 20;
    Blockly.Trashcan.prototype.MARGIN_HOTSPOT_ = 10;
    Blockly.Trashcan.prototype.SPRITE_LEFT_ = 0;
    Blockly.Trashcan.prototype.SPRITE_TOP_ = 32;
    Blockly.Trashcan.prototype.HAS_BLOCKS_LID_ANGLE_ = .1;
    Blockly.Trashcan.ANIMATION_LENGTH_ = 80;
    Blockly.Trashcan.ANIMATION_FRAMES_ = 4;
    Blockly.Trashcan.OPACITY_MIN_ = .4;
    Blockly.Trashcan.OPACITY_MAX_ = .8;
    Blockly.Trashcan.MAX_LID_ANGLE_ = 45;
    Blockly.Trashcan.prototype.isLidOpen = !1;
    Blockly.Trashcan.prototype.minOpenness_ = 0;
    Blockly.Trashcan.prototype.svgGroup_ = null;
    Blockly.Trashcan.prototype.svgLid_ = null;
    Blockly.Trashcan.prototype.lidTask_ = 0;
    Blockly.Trashcan.prototype.lidOpen_ = 0;
    Blockly.Trashcan.prototype.left_ = 0;
    Blockly.Trashcan.prototype.top_ = 0;
    Blockly.Trashcan.prototype.createDom = function() {
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyTrash"
        }, null);
        var a = String(Math.random()).substring(2);
        var b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CLIPPATH, {
            id: "blocklyTrashBodyClipPath" + a
        }, this.svgGroup_);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: this.WIDTH_,
            height: this.BODY_HEIGHT_,
            y: this.LID_HEIGHT_
        }, b);
        var c = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            width: Blockly.SPRITE.width,
            x: -this.SPRITE_LEFT_,
            height: Blockly.SPRITE.height,
            y: -this.SPRITE_TOP_,
            "clip-path": "url(#blocklyTrashBodyClipPath" + a + ")"
        }, this.svgGroup_);
        c.setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.workspace_.options.pathToMedia + Blockly.SPRITE.url);
        b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CLIPPATH, {
            id: "blocklyTrashLidClipPath" + a
        }, this.svgGroup_);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: this.WIDTH_,
            height: this.LID_HEIGHT_
        }, b);
        this.svgLid_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            width: Blockly.SPRITE.width,
            x: -this.SPRITE_LEFT_,
            height: Blockly.SPRITE.height,
            y: -this.SPRITE_TOP_,
            "clip-path": "url(#blocklyTrashLidClipPath" + a + ")"
        }, this.svgGroup_);
        this.svgLid_.setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.workspace_.options.pathToMedia + Blockly.SPRITE.url);
        Blockly.browserEvents.bind(this.svgGroup_, "mousedown", this, this.blockMouseDownWhenOpenable_);
        Blockly.browserEvents.bind(this.svgGroup_, "mouseup", this, this.click);
        Blockly.browserEvents.bind(c, "mouseover", this, this.mouseOver_);
        Blockly.browserEvents.bind(c, "mouseout", this, this.mouseOut_);
        this.animateLid_();
        return this.svgGroup_;
    };
    Blockly.Trashcan.prototype.init = function(a) {
        0 < this.workspace_.options.maxTrashcanContents && (Blockly.utils.dom.insertAfter(this.flyout.createDom(Blockly.utils.Svg.SVG), this.workspace_.getParentSvg()), this.flyout.init(this.workspace_));
        this.verticalSpacing_ = this.MARGIN_BOTTOM_ + a;
        this.setLidOpen(!1);
        return this.verticalSpacing_ + this.BODY_HEIGHT_ + this.LID_HEIGHT_;
    };
    Blockly.Trashcan.prototype.dispose = function() {
        this.svgGroup_ && (Blockly.utils.dom.removeNode(this.svgGroup_), this.svgGroup_ = null);
        this.workspace_ = this.svgLid_ = null;
        clearTimeout(this.lidTask_);
    };
    Blockly.Trashcan.prototype.hasContents_ = function() {
        return !!this.contents_.length;
    };
    Blockly.Trashcan.prototype.contentsIsOpen = function() {
        return this.flyout.isVisible();
    };
    Blockly.Trashcan.prototype.openFlyout = function() {
        if (!this.contentsIsOpen()) {
            for(var a = [], b = 0, c; c = this.contents_[b]; b++)a[b] = Blockly.Xml.textToDom(c);
            this.flyout.show(a);
            this.fireUiEvent_(!0);
        }
    };
    Blockly.Trashcan.prototype.closeFlyout = function() {
        this.contentsIsOpen() && (this.flyout.hide(), this.fireUiEvent_(!1));
    };
    Blockly.Trashcan.prototype.emptyContents = function() {
        this.hasContents_() && (this.contents_.length = 0, this.setMinOpenness_(0), this.closeFlyout());
    };
    Blockly.Trashcan.prototype.position = function(a, b) {
        if (this.verticalSpacing_) {
            this.left_ = a.toolboxMetrics.position == Blockly.utils.toolbox.Position.LEFT || this.workspace_.horizontalLayout && !this.workspace_.RTL ? a.viewMetrics.width + a.absoluteMetrics.left - this.WIDTH_ - this.MARGIN_SIDE_ - Blockly.Scrollbar.scrollbarThickness : this.MARGIN_SIDE_ + Blockly.Scrollbar.scrollbarThickness;
            var c = this.BODY_HEIGHT_ + this.LID_HEIGHT_, d = this.top_ = a.absoluteMetrics.top + this.verticalSpacing_, e = a.absoluteMetrics.top + a.viewMetrics.height - c - this.verticalSpacing_;
            this.top_ = (a = a.toolboxMetrics.position !== Blockly.utils.toolbox.Position.BOTTOM) ? e : d;
            for(var f = this.getBoundingRectangle(), g = 0, h; h = b[g]; g++)f.intersects(h) && (this.top_ = a ? h.top - c - this.MARGIN_BOTTOM_ : h.bottom + this.MARGIN_BOTTOM_, f = this.getBoundingRectangle(), g = -1);
            this.top_ = Blockly.utils.math.clamp(d, this.top_, e);
            this.svgGroup_.setAttribute("transform", "translate(" + this.left_ + "," + this.top_ + ")");
        }
    };
    Blockly.Trashcan.prototype.getBoundingRectangle = function() {
        return new Blockly.utils.Rect(this.top_, this.top_ + this.BODY_HEIGHT_ + this.LID_HEIGHT_, this.left_, this.left_ + this.WIDTH_);
    };
    Blockly.Trashcan.prototype.getClientRect = function() {
        if (!this.svgGroup_) return null;
        var a = this.svgGroup_.getBoundingClientRect(), b = a.top + this.SPRITE_TOP_ - this.MARGIN_HOTSPOT_;
        a = a.left + this.SPRITE_LEFT_ - this.MARGIN_HOTSPOT_;
        return new Blockly.utils.Rect(b, b + this.LID_HEIGHT_ + this.BODY_HEIGHT_ + 2 * this.MARGIN_HOTSPOT_, a, a + this.WIDTH_ + 2 * this.MARGIN_HOTSPOT_);
    };
    Blockly.Trashcan.prototype.setLidOpen = function(a) {
        this.isLidOpen != a && (clearTimeout(this.lidTask_), this.isLidOpen = a, this.animateLid_());
    };
    Blockly.Trashcan.prototype.animateLid_ = function() {
        var a = Blockly.Trashcan.ANIMATION_FRAMES_, b = 1 / (a + 1);
        this.lidOpen_ += this.isLidOpen ? b : -b;
        this.lidOpen_ = Math.min(Math.max(this.lidOpen_, this.minOpenness_), 1);
        this.setLidAngle_(this.lidOpen_ * Blockly.Trashcan.MAX_LID_ANGLE_);
        b = Blockly.Trashcan.OPACITY_MIN_;
        this.svgGroup_.style.opacity = b + this.lidOpen_ * (Blockly.Trashcan.OPACITY_MAX_ - b);
        this.lidOpen_ > this.minOpenness_ && 1 > this.lidOpen_ && (this.lidTask_ = setTimeout(this.animateLid_.bind(this), Blockly.Trashcan.ANIMATION_LENGTH_ / a));
    };
    Blockly.Trashcan.prototype.setLidAngle_ = function(a) {
        var b = this.workspace_.toolboxPosition == Blockly.utils.toolbox.Position.RIGHT || this.workspace_.horizontalLayout && this.workspace_.RTL;
        this.svgLid_.setAttribute("transform", "rotate(" + (b ? -a : a) + "," + (b ? 4 : this.WIDTH_ - 4) + "," + (this.LID_HEIGHT_ - 2) + ")");
    };
    Blockly.Trashcan.prototype.setMinOpenness_ = function(a) {
        this.minOpenness_ = a;
        this.isLidOpen || this.setLidAngle_(a * Blockly.Trashcan.MAX_LID_ANGLE_);
    };
    Blockly.Trashcan.prototype.closeLid = function() {
        this.setLidOpen(!1);
    };
    Blockly.Trashcan.prototype.click = function() {
        this.hasContents_() && this.openFlyout();
    };
    Blockly.Trashcan.prototype.fireUiEvent_ = function(a) {
        a = new (Blockly.Events.get(Blockly.Events.TRASHCAN_OPEN))(a, this.workspace_.id);
        Blockly.Events.fire(a);
    };
    Blockly.Trashcan.prototype.blockMouseDownWhenOpenable_ = function(a) {
        !this.contentsIsOpen() && this.hasContents_() && a.stopPropagation();
    };
    Blockly.Trashcan.prototype.mouseOver_ = function() {
        this.hasContents_() && this.setLidOpen(!0);
    };
    Blockly.Trashcan.prototype.mouseOut_ = function() {
        this.setLidOpen(!1);
    };
    Blockly.Trashcan.prototype.onDelete_ = function(a) {
        if (!(0 >= this.workspace_.options.maxTrashcanContents) && a.type == Blockly.Events.BLOCK_DELETE && a.oldXml.tagName && "shadow" != a.oldXml.tagName.toLowerCase() && (a = this.cleanBlockXML_(a.oldXml), -1 == this.contents_.indexOf(a))) {
            for(this.contents_.unshift(a); this.contents_.length > this.workspace_.options.maxTrashcanContents;)this.contents_.pop();
            this.setMinOpenness_(this.HAS_BLOCKS_LID_ANGLE_);
        }
    };
    Blockly.Trashcan.prototype.cleanBlockXML_ = function(a) {
        for(var b = a = a.cloneNode(!0); b;){
            b.removeAttribute && (b.removeAttribute("x"), b.removeAttribute("y"), b.removeAttribute("id"), b.removeAttribute("disabled"), "comment" == b.nodeName && (b.removeAttribute("h"), b.removeAttribute("w"), b.removeAttribute("pinned")));
            var c = b.firstChild || b.nextSibling;
            if (!c) for(c = b.parentNode; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break;
                }
                c = c.parentNode;
            }
            b = c;
        }
        return Blockly.Xml.domToText(a);
    };
    Blockly.VariablesDynamic = {};
    Blockly.VariablesDynamic.onCreateVariableButtonClick_String = function(a) {
        Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace(), void 0, "String");
    };
    Blockly.VariablesDynamic.onCreateVariableButtonClick_Number = function(a) {
        Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace(), void 0, "Number");
    };
    Blockly.VariablesDynamic.onCreateVariableButtonClick_Colour = function(a) {
        Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace(), void 0, "Colour");
    };
    Blockly.VariablesDynamic.flyoutCategory = function(a) {
        var b = [], c = document.createElement("button");
        c.setAttribute("text", Blockly.Msg.NEW_STRING_VARIABLE);
        c.setAttribute("callbackKey", "CREATE_VARIABLE_STRING");
        b.push(c);
        c = document.createElement("button");
        c.setAttribute("text", Blockly.Msg.NEW_NUMBER_VARIABLE);
        c.setAttribute("callbackKey", "CREATE_VARIABLE_NUMBER");
        b.push(c);
        c = document.createElement("button");
        c.setAttribute("text", Blockly.Msg.NEW_COLOUR_VARIABLE);
        c.setAttribute("callbackKey", "CREATE_VARIABLE_COLOUR");
        b.push(c);
        a.registerButtonCallback("CREATE_VARIABLE_STRING", Blockly.VariablesDynamic.onCreateVariableButtonClick_String);
        a.registerButtonCallback("CREATE_VARIABLE_NUMBER", Blockly.VariablesDynamic.onCreateVariableButtonClick_Number);
        a.registerButtonCallback("CREATE_VARIABLE_COLOUR", Blockly.VariablesDynamic.onCreateVariableButtonClick_Colour);
        a = Blockly.VariablesDynamic.flyoutCategoryBlocks(a);
        return b = b.concat(a);
    };
    Blockly.VariablesDynamic.flyoutCategoryBlocks = function(a) {
        a = a.getAllVariables();
        var b = [];
        if (0 < a.length) {
            if (Blockly.Blocks.variables_set_dynamic) {
                var c = a[a.length - 1], d = Blockly.utils.xml.createElement("block");
                d.setAttribute("type", "variables_set_dynamic");
                d.setAttribute("gap", 24);
                d.appendChild(Blockly.Variables.generateVariableFieldDom(c));
                b.push(d);
            }
            if (Blockly.Blocks.variables_get_dynamic) {
                a.sort(Blockly.VariableModel.compareByName);
                c = 0;
                for(var e; e = a[c]; c++)d = Blockly.utils.xml.createElement("block"), d.setAttribute("type", "variables_get_dynamic"), d.setAttribute("gap", 8), d.appendChild(Blockly.Variables.generateVariableFieldDom(e)), b.push(d);
            }
        }
        return b;
    };
    Blockly.ZoomControls = function(a) {
        this.workspace_ = a;
        this.zoomResetGroup_ = this.zoomOutGroup_ = this.zoomInGroup_ = this.verticalSpacing_ = this.onZoomOutWrapper_ = this.onZoomInWrapper_ = this.onZoomResetWrapper_ = null;
    };
    Blockly.ZoomControls.prototype.WIDTH_ = 32;
    Blockly.ZoomControls.prototype.HEIGHT_ = 110;
    Blockly.ZoomControls.prototype.MARGIN_BOTTOM_ = 20;
    Blockly.ZoomControls.prototype.MARGIN_SIDE_ = 20;
    Blockly.ZoomControls.prototype.svgGroup_ = null;
    Blockly.ZoomControls.prototype.left_ = 0;
    Blockly.ZoomControls.prototype.top_ = 0;
    Blockly.ZoomControls.prototype.createDom = function() {
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {}, null);
        var a = String(Math.random()).substring(2);
        this.createZoomOutSvg_(a);
        this.createZoomInSvg_(a);
        this.workspace_.isMovable() && this.createZoomResetSvg_(a);
        return this.svgGroup_;
    };
    Blockly.ZoomControls.prototype.init = function(a) {
        this.verticalSpacing_ = this.MARGIN_BOTTOM_ + a;
        return this.verticalSpacing_ + this.HEIGHT_;
    };
    Blockly.ZoomControls.prototype.dispose = function() {
        this.svgGroup_ && Blockly.utils.dom.removeNode(this.svgGroup_);
        this.onZoomResetWrapper_ && Blockly.browserEvents.unbind(this.onZoomResetWrapper_);
        this.onZoomInWrapper_ && Blockly.browserEvents.unbind(this.onZoomInWrapper_);
        this.onZoomOutWrapper_ && Blockly.browserEvents.unbind(this.onZoomOutWrapper_);
    };
    Blockly.ZoomControls.prototype.getBoundingRectangle = function() {
        return new Blockly.utils.Rect(this.top_, this.top_ + this.HEIGHT_, this.left_, this.left_ + this.WIDTH_);
    };
    Blockly.ZoomControls.prototype.position = function(a, b) {
        if (this.verticalSpacing_) {
            this.left_ = a.toolboxMetrics.position == Blockly.utils.toolbox.Position.LEFT || this.workspace_.horizontalLayout && !this.workspace_.RTL ? a.viewMetrics.width + a.absoluteMetrics.left - this.WIDTH_ - this.MARGIN_SIDE_ - Blockly.Scrollbar.scrollbarThickness : this.MARGIN_SIDE_ + Blockly.Scrollbar.scrollbarThickness;
            var c = this.top_ = a.absoluteMetrics.top + this.verticalSpacing_, d = a.absoluteMetrics.top + a.viewMetrics.height - this.HEIGHT_ - this.verticalSpacing_;
            this.top_ = (a = a.toolboxMetrics.position !== Blockly.utils.toolbox.Position.BOTTOM) ? d : c;
            a ? (this.zoomInGroup_.setAttribute("transform", "translate(0, 43)"), this.zoomOutGroup_.setAttribute("transform", "translate(0, 77)")) : (this.zoomInGroup_.setAttribute("transform", "translate(0, 34)"), this.zoomResetGroup_ && this.zoomResetGroup_.setAttribute("transform", "translate(0, 77)"));
            for(var e = this.getBoundingRectangle(), f = 0, g; g = b[f]; f++)e.intersects(g) && (this.top_ = a ? g.top - this.HEIGHT_ - this.MARGIN_BOTTOM_ : g.bottom + this.MARGIN_BOTTOM_, e = this.getBoundingRectangle(), f = -1);
            this.top_ = Blockly.utils.math.clamp(c, this.top_, d);
            this.svgGroup_.setAttribute("transform", "translate(" + this.left_ + "," + this.top_ + ")");
        }
    };
    Blockly.ZoomControls.prototype.createZoomOutSvg_ = function(a) {
        this.zoomOutGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyZoom"
        }, this.svgGroup_);
        var b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CLIPPATH, {
            id: "blocklyZoomoutClipPath" + a
        }, this.zoomOutGroup_);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: 32,
            height: 32
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            width: Blockly.SPRITE.width,
            height: Blockly.SPRITE.height,
            x: -64,
            y: -92,
            "clip-path": "url(#blocklyZoomoutClipPath" + a + ")"
        }, this.zoomOutGroup_).setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.workspace_.options.pathToMedia + Blockly.SPRITE.url);
        this.onZoomOutWrapper_ = Blockly.browserEvents.conditionalBind(this.zoomOutGroup_, "mousedown", null, this.zoom_.bind(this, -1));
    };
    Blockly.ZoomControls.prototype.createZoomInSvg_ = function(a) {
        this.zoomInGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyZoom"
        }, this.svgGroup_);
        var b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CLIPPATH, {
            id: "blocklyZoominClipPath" + a
        }, this.zoomInGroup_);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: 32,
            height: 32
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            width: Blockly.SPRITE.width,
            height: Blockly.SPRITE.height,
            x: -32,
            y: -92,
            "clip-path": "url(#blocklyZoominClipPath" + a + ")"
        }, this.zoomInGroup_).setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.workspace_.options.pathToMedia + Blockly.SPRITE.url);
        this.onZoomInWrapper_ = Blockly.browserEvents.conditionalBind(this.zoomInGroup_, "mousedown", null, this.zoom_.bind(this, 1));
    };
    Blockly.ZoomControls.prototype.zoom_ = function(a, b) {
        this.workspace_.markFocused();
        this.workspace_.zoomCenter(a);
        this.fireZoomEvent_();
        Blockly.Touch.clearTouchIdentifier();
        b.stopPropagation();
        b.preventDefault();
    };
    Blockly.ZoomControls.prototype.createZoomResetSvg_ = function(a) {
        this.zoomResetGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyZoom"
        }, this.svgGroup_);
        var b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CLIPPATH, {
            id: "blocklyZoomresetClipPath" + a
        }, this.zoomResetGroup_);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: 32,
            height: 32
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            width: Blockly.SPRITE.width,
            height: Blockly.SPRITE.height,
            y: -92,
            "clip-path": "url(#blocklyZoomresetClipPath" + a + ")"
        }, this.zoomResetGroup_).setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.workspace_.options.pathToMedia + Blockly.SPRITE.url);
        this.onZoomResetWrapper_ = Blockly.browserEvents.conditionalBind(this.zoomResetGroup_, "mousedown", null, this.resetZoom_.bind(this));
    };
    Blockly.ZoomControls.prototype.resetZoom_ = function(a) {
        this.workspace_.markFocused();
        var b = Math.log(this.workspace_.options.zoomOptions.startScale / this.workspace_.scale) / Math.log(this.workspace_.options.zoomOptions.scaleSpeed);
        this.workspace_.beginCanvasTransition();
        this.workspace_.zoomCenter(b);
        this.workspace_.scrollCenter();
        setTimeout(this.workspace_.endCanvasTransition.bind(this.workspace_), 500);
        this.fireZoomEvent_();
        Blockly.Touch.clearTouchIdentifier();
        a.stopPropagation();
        a.preventDefault();
    };
    Blockly.ZoomControls.prototype.fireZoomEvent_ = function() {
        var a = new (Blockly.Events.get(Blockly.Events.CLICK))(null, this.workspace_.id, "zoom_controls");
        Blockly.Events.fire(a);
    };
    Blockly.Css.register([
        ".blocklyZoom>image, .blocklyZoom>svg>image {",
        "opacity: .4;",
        "}",
        ".blocklyZoom>image:hover, .blocklyZoom>svg>image:hover {",
        "opacity: .6;",
        "}",
        ".blocklyZoom>image:active, .blocklyZoom>svg>image:active {",
        "opacity: .8;",
        "}"
    ]);
    Blockly.ShortcutItems = {};
    Blockly.ShortcutItems.names = {
        ESCAPE: "escape",
        DELETE: "delete",
        COPY: "copy",
        CUT: "cut",
        PASTE: "paste",
        UNDO: "undo",
        REDO: "redo"
    };
    Blockly.ShortcutItems.registerEscape = function() {
        var a = {
            name: Blockly.ShortcutItems.names.ESCAPE,
            preconditionFn: function(b) {
                return !b.options.readOnly;
            },
            callback: function() {
                Blockly.hideChaff();
                return !0;
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        Blockly.ShortcutRegistry.registry.addKeyMapping(Blockly.utils.KeyCodes.ESC, a.name);
    };
    Blockly.ShortcutItems.registerDelete = function() {
        var a = {
            name: Blockly.ShortcutItems.names.DELETE,
            preconditionFn: function(b) {
                return !b.options.readOnly && Blockly.selected && Blockly.selected.isDeletable();
            },
            callback: function(b, c) {
                c.preventDefault();
                if (Blockly.Gesture.inProgress()) return !1;
                Blockly.deleteBlock(Blockly.selected);
                return !0;
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        Blockly.ShortcutRegistry.registry.addKeyMapping(Blockly.utils.KeyCodes.DELETE, a.name);
        Blockly.ShortcutRegistry.registry.addKeyMapping(Blockly.utils.KeyCodes.BACKSPACE, a.name);
    };
    Blockly.ShortcutItems.registerCopy = function() {
        var a = {
            name: Blockly.ShortcutItems.names.COPY,
            preconditionFn: function(c) {
                return !c.options.readOnly && !Blockly.Gesture.inProgress() && Blockly.selected && Blockly.selected.isDeletable() && Blockly.selected.isMovable();
            },
            callback: function() {
                Blockly.hideChaff();
                Blockly.copy(Blockly.selected);
                return !0;
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        var b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.C, [
            Blockly.utils.KeyCodes.CTRL
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.C, [
            Blockly.utils.KeyCodes.ALT
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.C, [
            Blockly.utils.KeyCodes.META
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
    };
    Blockly.ShortcutItems.registerCut = function() {
        var a = {
            name: Blockly.ShortcutItems.names.CUT,
            preconditionFn: function(c) {
                return !c.options.readOnly && !Blockly.Gesture.inProgress() && Blockly.selected && Blockly.selected.isDeletable() && Blockly.selected.isMovable() && !Blockly.selected.workspace.isFlyout;
            },
            callback: function() {
                Blockly.copy(Blockly.selected);
                Blockly.deleteBlock(Blockly.selected);
                return !0;
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        var b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.X, [
            Blockly.utils.KeyCodes.CTRL
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.X, [
            Blockly.utils.KeyCodes.ALT
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.X, [
            Blockly.utils.KeyCodes.META
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
    };
    Blockly.ShortcutItems.registerPaste = function() {
        var a = {
            name: Blockly.ShortcutItems.names.PASTE,
            preconditionFn: function(c) {
                return !c.options.readOnly && !Blockly.Gesture.inProgress();
            },
            callback: function() {
                return Blockly.paste();
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        var b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.V, [
            Blockly.utils.KeyCodes.CTRL
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.V, [
            Blockly.utils.KeyCodes.ALT
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.V, [
            Blockly.utils.KeyCodes.META
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
    };
    Blockly.ShortcutItems.registerUndo = function() {
        var a = {
            name: Blockly.ShortcutItems.names.UNDO,
            preconditionFn: function(c) {
                return !c.options.readOnly && !Blockly.Gesture.inProgress();
            },
            callback: function(c) {
                Blockly.hideChaff();
                c.undo(!1);
                return !0;
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        var b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Z, [
            Blockly.utils.KeyCodes.CTRL
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Z, [
            Blockly.utils.KeyCodes.ALT
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Z, [
            Blockly.utils.KeyCodes.META
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
    };
    Blockly.ShortcutItems.registerRedo = function() {
        var a = {
            name: Blockly.ShortcutItems.names.REDO,
            preconditionFn: function(c) {
                return !Blockly.Gesture.inProgress() && !c.options.readOnly;
            },
            callback: function(c) {
                Blockly.hideChaff();
                c.undo(!0);
                return !0;
            }
        };
        Blockly.ShortcutRegistry.registry.register(a);
        var b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Z, [
            Blockly.utils.KeyCodes.SHIFT,
            Blockly.utils.KeyCodes.CTRL
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Z, [
            Blockly.utils.KeyCodes.SHIFT,
            Blockly.utils.KeyCodes.ALT
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Z, [
            Blockly.utils.KeyCodes.SHIFT,
            Blockly.utils.KeyCodes.META
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
        b = Blockly.ShortcutRegistry.registry.createSerializedKey(Blockly.utils.KeyCodes.Y, [
            Blockly.utils.KeyCodes.CTRL
        ]);
        Blockly.ShortcutRegistry.registry.addKeyMapping(b, a.name);
    };
    Blockly.ShortcutItems.registerDefaultShortcuts = function() {
        Blockly.ShortcutItems.registerEscape();
        Blockly.ShortcutItems.registerDelete();
        Blockly.ShortcutItems.registerCopy();
        Blockly.ShortcutItems.registerCut();
        Blockly.ShortcutItems.registerPaste();
        Blockly.ShortcutItems.registerUndo();
        Blockly.ShortcutItems.registerRedo();
    };
    Blockly.ShortcutItems.registerDefaultShortcuts();
    Blockly.ContextMenuItems = {};
    Blockly.ContextMenuItems.registerUndo = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.UNDO;
            },
            preconditionFn: function(a) {
                return 0 < a.workspace.getUndoStack().length ? "enabled" : "disabled";
            },
            callback: function(a) {
                a.workspace.undo(!1);
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
            id: "undoWorkspace",
            weight: 1
        });
    };
    Blockly.ContextMenuItems.registerRedo = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.REDO;
            },
            preconditionFn: function(a) {
                return 0 < a.workspace.getRedoStack().length ? "enabled" : "disabled";
            },
            callback: function(a) {
                a.workspace.undo(!0);
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
            id: "redoWorkspace",
            weight: 2
        });
    };
    Blockly.ContextMenuItems.registerCleanup = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.CLEAN_UP;
            },
            preconditionFn: function(a) {
                return a.workspace.isMovable() ? 1 < a.workspace.getTopBlocks(!1).length ? "enabled" : "disabled" : "hidden";
            },
            callback: function(a) {
                a.workspace.cleanUp();
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
            id: "cleanWorkspace",
            weight: 3
        });
    };
    Blockly.ContextMenuItems.toggleOption_ = function(a, b) {
        for(var c = 0, d = 0; d < b.length; d++)for(var e = b[d]; e;)setTimeout(e.setCollapsed.bind(e, a), c), e = e.getNextBlock(), c += 10;
    };
    Blockly.ContextMenuItems.registerCollapse = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.COLLAPSE_ALL;
            },
            preconditionFn: function(a) {
                if (a.workspace.options.collapse) {
                    a = a.workspace.getTopBlocks(!1);
                    for(var b = 0; b < a.length; b++)for(var c = a[b]; c;){
                        if (!c.isCollapsed()) return "enabled";
                        c = c.getNextBlock();
                    }
                    return "disabled";
                }
                return "hidden";
            },
            callback: function(a) {
                Blockly.ContextMenuItems.toggleOption_(!0, a.workspace.getTopBlocks(!0));
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
            id: "collapseWorkspace",
            weight: 4
        });
    };
    Blockly.ContextMenuItems.registerExpand = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.EXPAND_ALL;
            },
            preconditionFn: function(a) {
                if (a.workspace.options.collapse) {
                    a = a.workspace.getTopBlocks(!1);
                    for(var b = 0; b < a.length; b++)for(var c = a[b]; c;){
                        if (c.isCollapsed()) return "enabled";
                        c = c.getNextBlock();
                    }
                    return "disabled";
                }
                return "hidden";
            },
            callback: function(a) {
                Blockly.ContextMenuItems.toggleOption_(!1, a.workspace.getTopBlocks(!0));
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
            id: "expandWorkspace",
            weight: 5
        });
    };
    Blockly.ContextMenuItems.addDeletableBlocks_ = function(a, b) {
        if (a.isDeletable()) Array.prototype.push.apply(b, a.getDescendants(!1));
        else {
            a = a.getChildren(!1);
            for(var c = 0; c < a.length; c++)Blockly.ContextMenuItems.addDeletableBlocks_(a[c], b);
        }
    };
    Blockly.ContextMenuItems.getDeletableBlocks_ = function(a) {
        var b = [];
        a = a.getTopBlocks(!0);
        for(var c = 0; c < a.length; c++)Blockly.ContextMenuItems.addDeletableBlocks_(a[c], b);
        return b;
    };
    Blockly.ContextMenuItems.deleteNext_ = function(a, b) {
        Blockly.Events.setGroup(b);
        var c = a.shift();
        c && (c.workspace ? (c.dispose(!1, !0), setTimeout(Blockly.ContextMenuItems.deleteNext_, 10, a, b)) : Blockly.ContextMenuItems.deleteNext_(a, b));
        Blockly.Events.setGroup(!1);
    };
    Blockly.ContextMenuItems.registerDeleteAll = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function(a) {
                if (a.workspace) return a = Blockly.ContextMenuItems.getDeletableBlocks_(a.workspace).length, 1 == a ? Blockly.Msg.DELETE_BLOCK : Blockly.Msg.DELETE_X_BLOCKS.replace("%1", String(a));
            },
            preconditionFn: function(a) {
                if (a.workspace) return 0 < Blockly.ContextMenuItems.getDeletableBlocks_(a.workspace).length ? "enabled" : "disabled";
            },
            callback: function(a) {
                if (a.workspace) {
                    a.workspace.cancelCurrentGesture();
                    var b = Blockly.ContextMenuItems.getDeletableBlocks_(a.workspace), c = Blockly.utils.genUid();
                    2 > b.length ? Blockly.ContextMenuItems.deleteNext_(b, c) : Blockly.confirm(Blockly.Msg.DELETE_ALL_BLOCKS.replace("%1", b.length), function(d) {
                        d && Blockly.ContextMenuItems.deleteNext_(b, c);
                    });
                }
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
            id: "workspaceDelete",
            weight: 6
        });
    };
    Blockly.ContextMenuItems.registerWorkspaceOptions_ = function() {
        Blockly.ContextMenuItems.registerUndo();
        Blockly.ContextMenuItems.registerRedo();
        Blockly.ContextMenuItems.registerCleanup();
        Blockly.ContextMenuItems.registerCollapse();
        Blockly.ContextMenuItems.registerExpand();
        Blockly.ContextMenuItems.registerDeleteAll();
    };
    Blockly.ContextMenuItems.registerDuplicate = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.DUPLICATE_BLOCK;
            },
            preconditionFn: function(a) {
                a = a.block;
                return !a.isInFlyout && a.isDeletable() && a.isMovable() ? a.isDuplicatable() ? "enabled" : "disabled" : "hidden";
            },
            callback: function(a) {
                a.block && Blockly.duplicate(a.block);
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockDuplicate",
            weight: 1
        });
    };
    Blockly.ContextMenuItems.registerComment = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function(a) {
                return a.block.getCommentIcon() ? Blockly.Msg.REMOVE_COMMENT : Blockly.Msg.ADD_COMMENT;
            },
            preconditionFn: function(a) {
                a = a.block;
                return Blockly.utils.userAgent.IE || a.isInFlyout || !a.workspace.options.comments || a.isCollapsed() || !a.isEditable() ? "hidden" : "enabled";
            },
            callback: function(a) {
                a = a.block;
                a.getCommentIcon() ? a.setCommentText(null) : a.setCommentText("");
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockComment",
            weight: 2
        });
    };
    Blockly.ContextMenuItems.registerInline = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function(a) {
                return a.block.getInputsInline() ? Blockly.Msg.EXTERNAL_INPUTS : Blockly.Msg.INLINE_INPUTS;
            },
            preconditionFn: function(a) {
                a = a.block;
                if (!a.isInFlyout && a.isMovable() && !a.isCollapsed()) {
                    for(var b = 1; b < a.inputList.length; b++)if (a.inputList[b - 1].type != Blockly.inputTypes.STATEMENT && a.inputList[b].type != Blockly.inputTypes.STATEMENT) return "enabled";
                }
                return "hidden";
            },
            callback: function(a) {
                a.block.setInputsInline(!a.block.getInputsInline());
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockInline",
            weight: 3
        });
    };
    Blockly.ContextMenuItems.registerCollapseExpandBlock = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function(a) {
                return a.block.isCollapsed() ? Blockly.Msg.EXPAND_BLOCK : Blockly.Msg.COLLAPSE_BLOCK;
            },
            preconditionFn: function(a) {
                a = a.block;
                return !a.isInFlyout && a.isMovable() ? "enabled" : "hidden";
            },
            callback: function(a) {
                a.block.setCollapsed(!a.block.isCollapsed());
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockCollapseExpand",
            weight: 4
        });
    };
    Blockly.ContextMenuItems.registerDisable = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function(a) {
                return a.block.isEnabled() ? Blockly.Msg.DISABLE_BLOCK : Blockly.Msg.ENABLE_BLOCK;
            },
            preconditionFn: function(a) {
                a = a.block;
                return !a.isInFlyout && a.workspace.options.disable && a.isEditable() ? a.getInheritedDisabled() ? "disabled" : "enabled" : "hidden";
            },
            callback: function(a) {
                a = a.block;
                var b = Blockly.Events.getGroup();
                b || Blockly.Events.setGroup(!0);
                a.setEnabled(!a.isEnabled());
                b || Blockly.Events.setGroup(!1);
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockDisable",
            weight: 5
        });
    };
    Blockly.ContextMenuItems.registerDelete = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function(a) {
                var b = a.block;
                a = b.getDescendants(!1).length;
                (b = b.getNextBlock()) && (a -= b.getDescendants(!1).length);
                return 1 == a ? Blockly.Msg.DELETE_BLOCK : Blockly.Msg.DELETE_X_BLOCKS.replace("%1", String(a));
            },
            preconditionFn: function(a) {
                return !a.block.isInFlyout && a.block.isDeletable() ? "enabled" : "hidden";
            },
            callback: function(a) {
                Blockly.Events.setGroup(!0);
                a.block.dispose(!0, !0);
                Blockly.Events.setGroup(!1);
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockDelete",
            weight: 6
        });
    };
    Blockly.ContextMenuItems.registerHelp = function() {
        Blockly.ContextMenuRegistry.registry.register({
            displayText: function() {
                return Blockly.Msg.HELP;
            },
            preconditionFn: function(a) {
                a = a.block;
                return ("function" == typeof a.helpUrl ? a.helpUrl() : a.helpUrl) ? "enabled" : "hidden";
            },
            callback: function(a) {
                a.block.showHelp();
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: "blockHelp",
            weight: 7
        });
    };
    Blockly.ContextMenuItems.registerBlockOptions_ = function() {
        Blockly.ContextMenuItems.registerDuplicate();
        Blockly.ContextMenuItems.registerComment();
        Blockly.ContextMenuItems.registerInline();
        Blockly.ContextMenuItems.registerCollapseExpandBlock();
        Blockly.ContextMenuItems.registerDisable();
        Blockly.ContextMenuItems.registerDelete();
        Blockly.ContextMenuItems.registerHelp();
    };
    Blockly.ContextMenuItems.registerDefaultOptions = function() {
        Blockly.ContextMenuItems.registerWorkspaceOptions_();
        Blockly.ContextMenuItems.registerBlockOptions_();
    };
    Blockly.ContextMenuItems.registerDefaultOptions();
    Blockly.Mutator = function(a) {
        Blockly.Mutator.superClass_.constructor.call(this, null);
        this.quarkNames_ = a;
    };
    Blockly.utils.object.inherits(Blockly.Mutator, Blockly.Icon);
    Blockly.Mutator.prototype.workspaceWidth_ = 0;
    Blockly.Mutator.prototype.workspaceHeight_ = 0;
    Blockly.Mutator.prototype.setBlock = function(a) {
        this.block_ = a;
    };
    Blockly.Mutator.prototype.getWorkspace = function() {
        return this.workspace_;
    };
    Blockly.Mutator.prototype.drawIcon_ = function(a) {
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyIconShape",
            rx: "4",
            ry: "4",
            height: "16",
            width: "16"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyIconSymbol",
            d: "m4.203,7.296 0,1.368 -0.92,0.677 -0.11,0.41 0.9,1.559 0.41,0.11 1.043,-0.457 1.187,0.683 0.127,1.134 0.3,0.3 1.8,0 0.3,-0.299 0.127,-1.138 1.185,-0.682 1.046,0.458 0.409,-0.11 0.9,-1.559 -0.11,-0.41 -0.92,-0.677 0,-1.366 0.92,-0.677 0.11,-0.41 -0.9,-1.559 -0.409,-0.109 -1.046,0.458 -1.185,-0.682 -0.127,-1.138 -0.3,-0.299 -1.8,0 -0.3,0.3 -0.126,1.135 -1.187,0.682 -1.043,-0.457 -0.41,0.11 -0.899,1.559 0.108,0.409z"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CIRCLE, {
            "class": "blocklyIconShape",
            r: "2.7",
            cx: "8",
            cy: "8"
        }, a);
    };
    Blockly.Mutator.prototype.iconClick_ = function(a) {
        this.block_.isEditable() && Blockly.Icon.prototype.iconClick_.call(this, a);
    };
    Blockly.Mutator.prototype.createEditor_ = function() {
        this.svgDialog_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
            x: Blockly.Bubble.BORDER_WIDTH,
            y: Blockly.Bubble.BORDER_WIDTH
        }, null);
        if (this.quarkNames_.length) for(var a = Blockly.utils.xml.createElement("xml"), b = 0, c; c = this.quarkNames_[b]; b++){
            var d = Blockly.utils.xml.createElement("block");
            d.setAttribute("type", c);
            a.appendChild(d);
        }
        else a = null;
        b = new Blockly.Options({
            disable: !1,
            parentWorkspace: this.block_.workspace,
            media: this.block_.workspace.options.pathToMedia,
            rtl: this.block_.RTL,
            horizontalLayout: !1,
            renderer: this.block_.workspace.options.renderer,
            rendererOverrides: this.block_.workspace.options.rendererOverrides
        });
        b.toolboxPosition = this.block_.RTL ? Blockly.utils.toolbox.Position.RIGHT : Blockly.utils.toolbox.Position.LEFT;
        if (c = !!a) b.languageTree = Blockly.utils.toolbox.convertToolboxDefToJson(a);
        this.workspace_ = new Blockly.WorkspaceSvg(b);
        this.workspace_.isMutator = !0;
        this.workspace_.addChangeListener(Blockly.Events.disableOrphans);
        a = c ? this.workspace_.addFlyout(Blockly.utils.Svg.G) : null;
        b = this.workspace_.createDom("blocklyMutatorBackground");
        a && b.insertBefore(a, this.workspace_.svgBlockCanvas_);
        this.svgDialog_.appendChild(b);
        return this.svgDialog_;
    };
    Blockly.Mutator.prototype.updateEditable = function() {
        Blockly.Mutator.superClass_.updateEditable.call(this);
        this.block_.isInFlyout || (this.block_.isEditable() ? this.iconGroup_ && Blockly.utils.dom.removeClass(this.iconGroup_, "blocklyIconGroupReadonly") : (this.setVisible(!1), this.iconGroup_ && Blockly.utils.dom.addClass(this.iconGroup_, "blocklyIconGroupReadonly")));
    };
    Blockly.Mutator.prototype.resizeBubble_ = function() {
        var a = 2 * Blockly.Bubble.BORDER_WIDTH, b = this.workspace_.getCanvas().getBBox(), c = b.width + b.x, d = b.height + 3 * a, e = this.workspace_.getFlyout();
        if (e) {
            var f = e.getWorkspace().getMetricsManager().getScrollMetrics();
            d = Math.max(d, f.height + 20);
            c += e.getWidth();
        }
        this.block_.RTL && (c = -b.x);
        c += 3 * a;
        if (Math.abs(this.workspaceWidth_ - c) > a || Math.abs(this.workspaceHeight_ - d) > a) this.workspaceWidth_ = c, this.workspaceHeight_ = d, this.bubble_.setBubbleSize(c + a, d + a), this.svgDialog_.setAttribute("width", this.workspaceWidth_), this.svgDialog_.setAttribute("height", this.workspaceHeight_), this.workspace_.setCachedParentSvgSize(this.workspaceWidth_, this.workspaceHeight_);
        this.block_.RTL && (a = "translate(" + this.workspaceWidth_ + ",0)", this.workspace_.getCanvas().setAttribute("transform", a));
        this.workspace_.resize();
    };
    Blockly.Mutator.prototype.onBubbleMove_ = function() {
        this.workspace_ && this.workspace_.recordDeleteAreas();
    };
    Blockly.Mutator.prototype.setVisible = function(a) {
        if (a != this.isVisible()) {
            if (Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BUBBLE_OPEN))(this.block_, a, "mutator")), a) {
                this.bubble_ = new Blockly.Bubble(this.block_.workspace, this.createEditor_(), this.block_.pathObject.svgPath, this.iconXY_, null, null);
                this.bubble_.setSvgId(this.block_.id);
                this.bubble_.registerMoveEvent(this.onBubbleMove_.bind(this));
                var b = this.workspace_.options.languageTree;
                a = this.workspace_.getFlyout();
                b && (a.init(this.workspace_), a.show(b));
                this.rootBlock_ = this.block_.decompose(this.workspace_);
                b = this.rootBlock_.getDescendants(!1);
                for(var c = 0, d; d = b[c]; c++)d.render();
                this.rootBlock_.setMovable(!1);
                this.rootBlock_.setDeletable(!1);
                a ? (b = 2 * a.CORNER_RADIUS, a = this.rootBlock_.RTL ? a.getWidth() + b : b) : a = b = 16;
                this.block_.RTL && (a = -a);
                this.rootBlock_.moveBy(a, b);
                if (this.block_.saveConnections) {
                    var e = this, f = this.block_;
                    f.saveConnections(this.rootBlock_);
                    this.sourceListener_ = function() {
                        f.saveConnections(e.rootBlock_);
                    };
                    this.block_.workspace.addChangeListener(this.sourceListener_);
                }
                this.resizeBubble_();
                this.workspace_.addChangeListener(this.workspaceChanged_.bind(this));
                this.applyColour();
            } else this.svgDialog_ = null, this.workspace_.dispose(), this.rootBlock_ = this.workspace_ = null, this.bubble_.dispose(), this.bubble_ = null, this.workspaceHeight_ = this.workspaceWidth_ = 0, this.sourceListener_ && (this.block_.workspace.removeChangeListener(this.sourceListener_), this.sourceListener_ = null);
        }
    };
    Blockly.Mutator.prototype.workspaceChanged_ = function(a) {
        if (!(a.isUiEvent || a.type == Blockly.Events.CHANGE && "disabled" == a.element)) {
            if (!this.workspace_.isDragging()) {
                a = this.workspace_.getTopBlocks(!1);
                for(var b = 0, c; c = a[b]; b++){
                    var d = c.getRelativeToSurfaceXY();
                    20 > d.y && c.moveBy(0, 20 - d.y);
                    if (c.RTL) {
                        var e = -20, f = this.workspace_.getFlyout();
                        f && (e -= f.getWidth());
                        d.x > e && c.moveBy(e - d.x, 0);
                    } else 20 > d.x && c.moveBy(20 - d.x, 0);
                }
            }
            if (this.rootBlock_.workspace == this.workspace_) {
                Blockly.Events.setGroup(!0);
                c = this.block_;
                a = (a = c.mutationToDom()) && Blockly.Xml.domToText(a);
                b = c.rendered;
                c.rendered = !1;
                c.compose(this.rootBlock_);
                c.rendered = b;
                c.initSvg();
                c.rendered && c.render();
                b = (b = c.mutationToDom()) && Blockly.Xml.domToText(b);
                if (a != b) {
                    Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(c, "mutation", null, a, b));
                    var g = Blockly.Events.getGroup();
                    setTimeout(function() {
                        Blockly.Events.setGroup(g);
                        c.bumpNeighbours();
                        Blockly.Events.setGroup(!1);
                    }, Blockly.BUMP_DELAY);
                }
                this.workspace_.isDragging() || this.resizeBubble_();
                Blockly.Events.setGroup(!1);
            }
        }
    };
    Blockly.Mutator.prototype.dispose = function() {
        this.block_.mutator = null;
        Blockly.Icon.prototype.dispose.call(this);
    };
    Blockly.Mutator.prototype.updateBlockStyle = function() {
        var a = this.workspace_;
        if (a && a.getAllBlocks(!1)) {
            for(var b = a.getAllBlocks(!1), c = 0; c < b.length; c++){
                var d = b[c];
                d.setStyle(d.getStyleName());
            }
            if (c = a.getFlyout()) for(a = c.workspace_.getAllBlocks(!1), c = 0; c < a.length; c++)d = a[c], d.setStyle(d.getStyleName());
        }
    };
    Blockly.Mutator.reconnect = function(a, b, c) {
        if (!a || !a.getSourceBlock().workspace) return !1;
        c = b.getInput(c).connection;
        var d = a.targetBlock();
        return d && d != b || c.targetConnection == a ? !1 : (c.isConnected() && c.disconnect(), c.connect(a), !0);
    };
    Blockly.Mutator.findParentWs = function(a) {
        var b = null;
        if (a && a.options) {
            var c = a.options.parentWorkspace;
            a.isFlyout ? c && c.options && (b = c.options.parentWorkspace) : c && (b = c);
        }
        return b;
    };
    Blockly.FieldTextInput = function(a, b, c) {
        this.spellcheck_ = !0;
        Blockly.FieldTextInput.superClass_.constructor.call(this, a, b, c);
        this.onKeyInputWrapper_ = this.onKeyDownWrapper_ = this.htmlInput_ = null;
        this.fullBlockClickTarget_ = !1;
        this.workspace_ = null;
    };
    Blockly.utils.object.inherits(Blockly.FieldTextInput, Blockly.Field);
    Blockly.FieldTextInput.prototype.DEFAULT_VALUE = "";
    Blockly.FieldTextInput.fromJson = function(a) {
        var b = Blockly.utils.replaceMessageReferences(a.text);
        return new Blockly.FieldTextInput(b, void 0, a);
    };
    Blockly.FieldTextInput.prototype.SERIALIZABLE = !0;
    Blockly.FieldTextInput.BORDERRADIUS = 4;
    Blockly.FieldTextInput.prototype.CURSOR = "text";
    Blockly.FieldTextInput.prototype.configure_ = function(a) {
        Blockly.FieldTextInput.superClass_.configure_.call(this, a);
        "boolean" == typeof a.spellcheck && (this.spellcheck_ = a.spellcheck);
    };
    Blockly.FieldTextInput.prototype.initView = function() {
        if (this.getConstants().FULL_BLOCK_FIELDS) {
            for(var a = 0, b = 0, c = 0, d; d = this.sourceBlock_.inputList[c]; c++){
                for(var e = 0; d.fieldRow[e]; e++)a++;
                d.connection && b++;
            }
            this.fullBlockClickTarget_ = 1 >= a && this.sourceBlock_.outputConnection && !b;
        } else this.fullBlockClickTarget_ = !1;
        this.fullBlockClickTarget_ ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : this.createBorderRect_();
        this.createTextElement_();
    };
    Blockly.FieldTextInput.prototype.doClassValidation_ = function(a) {
        return null === a || void 0 === a ? null : String(a);
    };
    Blockly.FieldTextInput.prototype.doValueInvalid_ = function(a) {
        this.isBeingEdited_ && (this.isTextValid_ = !1, a = this.value_, this.value_ = this.htmlInput_.untypedDefaultValue_, this.sourceBlock_ && Blockly.Events.isEnabled() && Blockly.Events.fire(new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(this.sourceBlock_, "field", this.name || null, a, this.value_)));
    };
    Blockly.FieldTextInput.prototype.doValueUpdate_ = function(a) {
        this.isTextValid_ = !0;
        this.value_ = a;
        this.isBeingEdited_ || (this.isDirty_ = !0);
    };
    Blockly.FieldTextInput.prototype.applyColour = function() {
        this.sourceBlock_ && this.getConstants().FULL_BLOCK_FIELDS && (this.borderRect_ ? this.borderRect_.setAttribute("stroke", this.sourceBlock_.style.colourTertiary) : this.sourceBlock_.pathObject.svgPath.setAttribute("fill", this.getConstants().FIELD_BORDER_RECT_COLOUR));
    };
    Blockly.FieldTextInput.prototype.render_ = function() {
        Blockly.FieldTextInput.superClass_.render_.call(this);
        if (this.isBeingEdited_) {
            this.resizeEditor_();
            var a = this.htmlInput_;
            this.isTextValid_ ? (Blockly.utils.dom.removeClass(a, "blocklyInvalidInput"), Blockly.utils.aria.setState(a, Blockly.utils.aria.State.INVALID, !1)) : (Blockly.utils.dom.addClass(a, "blocklyInvalidInput"), Blockly.utils.aria.setState(a, Blockly.utils.aria.State.INVALID, !0));
        }
    };
    Blockly.FieldTextInput.prototype.setSpellcheck = function(a) {
        a != this.spellcheck_ && (this.spellcheck_ = a, this.htmlInput_ && this.htmlInput_.setAttribute("spellcheck", this.spellcheck_));
    };
    Blockly.FieldTextInput.prototype.showEditor_ = function(a, b) {
        this.workspace_ = this.sourceBlock_.workspace;
        a = b || !1;
        !a && (Blockly.utils.userAgent.MOBILE || Blockly.utils.userAgent.ANDROID || Blockly.utils.userAgent.IPAD) ? this.showPromptEditor_() : this.showInlineEditor_(a);
    };
    Blockly.FieldTextInput.prototype.showPromptEditor_ = function() {
        Blockly.prompt(Blockly.Msg.CHANGE_VALUE_TITLE, this.getText(), (function(a) {
            this.setValue(this.getValueFromEditorText_(a));
        }).bind(this));
    };
    Blockly.FieldTextInput.prototype.showInlineEditor_ = function(a) {
        Blockly.WidgetDiv.show(this, this.sourceBlock_.RTL, this.widgetDispose_.bind(this));
        this.htmlInput_ = this.widgetCreate_();
        this.isBeingEdited_ = !0;
        a || (this.htmlInput_.focus({
            preventScroll: !0
        }), this.htmlInput_.select());
    };
    Blockly.FieldTextInput.prototype.widgetCreate_ = function() {
        var a = Blockly.WidgetDiv.DIV;
        Blockly.utils.dom.addClass(this.getClickTarget_(), "editing");
        var b = document.createElement("input");
        b.className = "blocklyHtmlInput";
        b.setAttribute("spellcheck", this.spellcheck_);
        var c = this.workspace_.getScale(), d = this.getConstants().FIELD_TEXT_FONTSIZE * c + "pt";
        a.style.fontSize = d;
        b.style.fontSize = d;
        d = Blockly.FieldTextInput.BORDERRADIUS * c + "px";
        if (this.fullBlockClickTarget_) {
            d = this.getScaledBBox();
            d = (d.bottom - d.top) / 2 + "px";
            var e = this.sourceBlock_.getParent() ? this.sourceBlock_.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary;
            b.style.border = 1 * c + "px solid " + e;
            a.style.borderRadius = d;
            a.style.transition = "box-shadow 0.25s ease 0s";
            this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW && (a.style.boxShadow = "rgba(255, 255, 255, 0.3) 0px 0px 0px " + 4 * c + "px");
        }
        b.style.borderRadius = d;
        a.appendChild(b);
        b.value = b.defaultValue = this.getEditorText_(this.value_);
        b.untypedDefaultValue_ = this.value_;
        b.oldValue_ = null;
        this.resizeEditor_();
        this.bindInputEvents_(b);
        return b;
    };
    Blockly.FieldTextInput.prototype.widgetDispose_ = function() {
        this.isBeingEdited_ = !1;
        this.isTextValid_ = !0;
        this.forceRerender();
        if (this.onFinishEditing_) this.onFinishEditing_(this.value_);
        this.unbindInputEvents_();
        var a = Blockly.WidgetDiv.DIV.style;
        a.width = "auto";
        a.height = "auto";
        a.fontSize = "";
        a.transition = "";
        a.boxShadow = "";
        this.htmlInput_ = null;
        Blockly.utils.dom.removeClass(this.getClickTarget_(), "editing");
    };
    Blockly.FieldTextInput.prototype.bindInputEvents_ = function(a) {
        this.onKeyDownWrapper_ = Blockly.browserEvents.conditionalBind(a, "keydown", this, this.onHtmlInputKeyDown_);
        this.onKeyInputWrapper_ = Blockly.browserEvents.conditionalBind(a, "input", this, this.onHtmlInputChange_);
    };
    Blockly.FieldTextInput.prototype.unbindInputEvents_ = function() {
        this.onKeyDownWrapper_ && (Blockly.browserEvents.unbind(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null);
        this.onKeyInputWrapper_ && (Blockly.browserEvents.unbind(this.onKeyInputWrapper_), this.onKeyInputWrapper_ = null);
    };
    Blockly.FieldTextInput.prototype.onHtmlInputKeyDown_ = function(a) {
        a.keyCode == Blockly.utils.KeyCodes.ENTER ? (Blockly.WidgetDiv.hide(), Blockly.DropDownDiv.hideWithoutAnimation()) : a.keyCode == Blockly.utils.KeyCodes.ESC ? (this.htmlInput_.value = this.htmlInput_.defaultValue, Blockly.WidgetDiv.hide(), Blockly.DropDownDiv.hideWithoutAnimation()) : a.keyCode == Blockly.utils.KeyCodes.TAB && (Blockly.WidgetDiv.hide(), Blockly.DropDownDiv.hideWithoutAnimation(), this.sourceBlock_.tab(this, !a.shiftKey), a.preventDefault());
    };
    Blockly.FieldTextInput.prototype.onHtmlInputChange_ = function(a) {
        a = this.htmlInput_.value;
        a !== this.htmlInput_.oldValue_ && (this.htmlInput_.oldValue_ = a, Blockly.Events.setGroup(!0), a = this.getValueFromEditorText_(a), this.setValue(a), this.forceRerender(), this.resizeEditor_(), Blockly.Events.setGroup(!1));
    };
    Blockly.FieldTextInput.prototype.setEditorValue_ = function(a) {
        this.isDirty_ = !0;
        this.isBeingEdited_ && (this.htmlInput_.value = this.getEditorText_(a));
        this.setValue(a);
    };
    Blockly.FieldTextInput.prototype.resizeEditor_ = function() {
        var a = Blockly.WidgetDiv.DIV, b = this.getScaledBBox();
        a.style.width = b.right - b.left + "px";
        a.style.height = b.bottom - b.top + "px";
        b = new Blockly.utils.Coordinate(this.sourceBlock_.RTL ? b.right - a.offsetWidth : b.left, b.top);
        a.style.left = b.x + "px";
        a.style.top = b.y + "px";
    };
    Blockly.FieldTextInput.prototype.isTabNavigable = function() {
        return !0;
    };
    Blockly.FieldTextInput.prototype.getText_ = function() {
        return this.isBeingEdited_ && this.htmlInput_ ? this.htmlInput_.value : null;
    };
    Blockly.FieldTextInput.prototype.getEditorText_ = function(a) {
        return String(a);
    };
    Blockly.FieldTextInput.prototype.getValueFromEditorText_ = function(a) {
        return a;
    };
    Blockly.fieldRegistry.register("field_input", Blockly.FieldTextInput);
    Blockly.FieldAngle = function(a, b, c) {
        this.clockwise_ = Blockly.FieldAngle.CLOCKWISE;
        this.offset_ = Blockly.FieldAngle.OFFSET;
        this.wrap_ = Blockly.FieldAngle.WRAP;
        this.round_ = Blockly.FieldAngle.ROUND;
        Blockly.FieldAngle.superClass_.constructor.call(this, a, b, c);
        this.moveSurfaceWrapper_ = this.clickSurfaceWrapper_ = this.clickWrapper_ = this.line_ = this.gauge_ = null;
    };
    Blockly.utils.object.inherits(Blockly.FieldAngle, Blockly.FieldTextInput);
    Blockly.FieldAngle.prototype.DEFAULT_VALUE = 0;
    Blockly.FieldAngle.fromJson = function(a) {
        return new Blockly.FieldAngle(a.angle, void 0, a);
    };
    Blockly.FieldAngle.prototype.SERIALIZABLE = !0;
    Blockly.FieldAngle.ROUND = 15;
    Blockly.FieldAngle.HALF = 50;
    Blockly.FieldAngle.CLOCKWISE = !1;
    Blockly.FieldAngle.OFFSET = 0;
    Blockly.FieldAngle.WRAP = 360;
    Blockly.FieldAngle.RADIUS = Blockly.FieldAngle.HALF - 1;
    Blockly.FieldAngle.prototype.configure_ = function(a) {
        Blockly.FieldAngle.superClass_.configure_.call(this, a);
        switch(a.mode){
            case "compass":
                this.clockwise_ = !0;
                this.offset_ = 90;
                break;
            case "protractor":
                this.clockwise_ = !1, this.offset_ = 0;
        }
        var b = a.clockwise;
        "boolean" == typeof b && (this.clockwise_ = b);
        b = a.offset;
        null != b && (b = Number(b), isNaN(b) || (this.offset_ = b));
        b = a.wrap;
        null != b && (b = Number(b), isNaN(b) || (this.wrap_ = b));
        a = a.round;
        null != a && (a = Number(a), isNaN(a) || (this.round_ = a));
    };
    Blockly.FieldAngle.prototype.initView = function() {
        Blockly.FieldAngle.superClass_.initView.call(this);
        this.symbol_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TSPAN, {}, null);
        this.symbol_.appendChild(document.createTextNode("\u00b0"));
        this.textElement_.appendChild(this.symbol_);
    };
    Blockly.FieldAngle.prototype.render_ = function() {
        Blockly.FieldAngle.superClass_.render_.call(this);
        this.updateGraph_();
    };
    Blockly.FieldAngle.prototype.showEditor_ = function(a) {
        Blockly.FieldAngle.superClass_.showEditor_.call(this, a, Blockly.utils.userAgent.MOBILE || Blockly.utils.userAgent.ANDROID || Blockly.utils.userAgent.IPAD);
        a = this.dropdownCreate_();
        Blockly.DropDownDiv.getContentDiv().appendChild(a);
        Blockly.DropDownDiv.setColour(this.sourceBlock_.style.colourPrimary, this.sourceBlock_.style.colourTertiary);
        Blockly.DropDownDiv.showPositionedByField(this, this.dropdownDispose_.bind(this));
        this.updateGraph_();
    };
    Blockly.FieldAngle.prototype.dropdownCreate_ = function() {
        var a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.SVG, {
            xmlns: Blockly.utils.dom.SVG_NS,
            "xmlns:html": Blockly.utils.dom.HTML_NS,
            "xmlns:xlink": Blockly.utils.dom.XLINK_NS,
            version: "1.1",
            height: 2 * Blockly.FieldAngle.HALF + "px",
            width: 2 * Blockly.FieldAngle.HALF + "px",
            style: "touch-action: none"
        }, null), b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CIRCLE, {
            cx: Blockly.FieldAngle.HALF,
            cy: Blockly.FieldAngle.HALF,
            r: Blockly.FieldAngle.RADIUS,
            "class": "blocklyAngleCircle"
        }, a);
        this.gauge_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyAngleGauge"
        }, a);
        this.line_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {
            x1: Blockly.FieldAngle.HALF,
            y1: Blockly.FieldAngle.HALF,
            "class": "blocklyAngleLine"
        }, a);
        for(var c = 0; 360 > c; c += 15)Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.LINE, {
            x1: Blockly.FieldAngle.HALF + Blockly.FieldAngle.RADIUS,
            y1: Blockly.FieldAngle.HALF,
            x2: Blockly.FieldAngle.HALF + Blockly.FieldAngle.RADIUS - (0 == c % 45 ? 10 : 5),
            y2: Blockly.FieldAngle.HALF,
            "class": "blocklyAngleMarks",
            transform: "rotate(" + c + "," + Blockly.FieldAngle.HALF + "," + Blockly.FieldAngle.HALF + ")"
        }, a);
        this.clickWrapper_ = Blockly.browserEvents.conditionalBind(a, "click", this, this.hide_);
        this.clickSurfaceWrapper_ = Blockly.browserEvents.conditionalBind(b, "click", this, this.onMouseMove_, !0, !0);
        this.moveSurfaceWrapper_ = Blockly.browserEvents.conditionalBind(b, "mousemove", this, this.onMouseMove_, !0, !0);
        return a;
    };
    Blockly.FieldAngle.prototype.dropdownDispose_ = function() {
        this.clickWrapper_ && (Blockly.browserEvents.unbind(this.clickWrapper_), this.clickWrapper_ = null);
        this.clickSurfaceWrapper_ && (Blockly.browserEvents.unbind(this.clickSurfaceWrapper_), this.clickSurfaceWrapper_ = null);
        this.moveSurfaceWrapper_ && (Blockly.browserEvents.unbind(this.moveSurfaceWrapper_), this.moveSurfaceWrapper_ = null);
        this.line_ = this.gauge_ = null;
    };
    Blockly.FieldAngle.prototype.hide_ = function() {
        Blockly.DropDownDiv.hideIfOwner(this);
        Blockly.WidgetDiv.hide();
    };
    Blockly.FieldAngle.prototype.onMouseMove_ = function(a) {
        var b = this.gauge_.ownerSVGElement.getBoundingClientRect(), c = a.clientX - b.left - Blockly.FieldAngle.HALF;
        a = a.clientY - b.top - Blockly.FieldAngle.HALF;
        b = Math.atan(-a / c);
        isNaN(b) || (b = Blockly.utils.math.toDegrees(b), 0 > c ? b += 180 : 0 < a && (b += 360), b = this.clockwise_ ? this.offset_ + 360 - b : 360 - (this.offset_ - b), this.displayMouseOrKeyboardValue_(b));
    };
    Blockly.FieldAngle.prototype.displayMouseOrKeyboardValue_ = function(a) {
        this.round_ && (a = Math.round(a / this.round_) * this.round_);
        a = this.wrapValue_(a);
        a != this.value_ && this.setEditorValue_(a);
    };
    Blockly.FieldAngle.prototype.updateGraph_ = function() {
        if (this.gauge_) {
            var a = Number(this.getText()) + this.offset_, b = Blockly.utils.math.toRadians(a % 360);
            a = [
                "M ",
                Blockly.FieldAngle.HALF,
                ",",
                Blockly.FieldAngle.HALF
            ];
            var c = Blockly.FieldAngle.HALF, d = Blockly.FieldAngle.HALF;
            if (!isNaN(b)) {
                var e = Number(this.clockwise_), f = Blockly.utils.math.toRadians(this.offset_), g = Math.cos(f) * Blockly.FieldAngle.RADIUS, h = Math.sin(f) * -Blockly.FieldAngle.RADIUS;
                e && (b = 2 * f - b);
                c += Math.cos(b) * Blockly.FieldAngle.RADIUS;
                d -= Math.sin(b) * Blockly.FieldAngle.RADIUS;
                b = Math.abs(Math.floor((b - f) / Math.PI) % 2);
                e && (b = 1 - b);
                a.push(" l ", g, ",", h, " A ", Blockly.FieldAngle.RADIUS, ",", Blockly.FieldAngle.RADIUS, " 0 ", b, " ", e, " ", c, ",", d, " z");
            }
            this.gauge_.setAttribute("d", a.join(""));
            this.line_.setAttribute("x2", c);
            this.line_.setAttribute("y2", d);
        }
    };
    Blockly.FieldAngle.prototype.onHtmlInputKeyDown_ = function(a) {
        Blockly.FieldAngle.superClass_.onHtmlInputKeyDown_.call(this, a);
        var b;
        a.keyCode === Blockly.utils.KeyCodes.LEFT ? b = this.sourceBlock_.RTL ? 1 : -1 : a.keyCode === Blockly.utils.KeyCodes.RIGHT ? b = this.sourceBlock_.RTL ? -1 : 1 : a.keyCode === Blockly.utils.KeyCodes.DOWN ? b = -1 : a.keyCode === Blockly.utils.KeyCodes.UP && (b = 1);
        if (b) {
            var c = this.getValue();
            this.displayMouseOrKeyboardValue_(c + b * this.round_);
            a.preventDefault();
            a.stopPropagation();
        }
    };
    Blockly.FieldAngle.prototype.doClassValidation_ = function(a) {
        a = Number(a);
        return isNaN(a) || !isFinite(a) ? null : this.wrapValue_(a);
    };
    Blockly.FieldAngle.prototype.wrapValue_ = function(a) {
        a %= 360;
        0 > a && (a += 360);
        a > this.wrap_ && (a -= 360);
        return a;
    };
    Blockly.Css.register(".blocklyAngleCircle {,stroke: #444;,stroke-width: 1;,fill: #ddd;,fill-opacity: .8;,},.blocklyAngleMarks {,stroke: #444;,stroke-width: 1;,},.blocklyAngleGauge {,fill: #f88;,fill-opacity: .8;,pointer-events: none;,},.blocklyAngleLine {,stroke: #f00;,stroke-width: 2;,stroke-linecap: round;,pointer-events: none;,}".split(","));
    Blockly.fieldRegistry.register("field_angle", Blockly.FieldAngle);
    Blockly.FieldCheckbox = function(a, b, c) {
        this.checkChar_ = null;
        Blockly.FieldCheckbox.superClass_.constructor.call(this, a, b, c);
    };
    Blockly.utils.object.inherits(Blockly.FieldCheckbox, Blockly.Field);
    Blockly.FieldCheckbox.prototype.DEFAULT_VALUE = !1;
    Blockly.FieldCheckbox.fromJson = function(a) {
        return new Blockly.FieldCheckbox(a.checked, void 0, a);
    };
    Blockly.FieldCheckbox.CHECK_CHAR = "\u2713";
    Blockly.FieldCheckbox.prototype.SERIALIZABLE = !0;
    Blockly.FieldCheckbox.prototype.CURSOR = "default";
    Blockly.FieldCheckbox.prototype.configure_ = function(a) {
        Blockly.FieldCheckbox.superClass_.configure_.call(this, a);
        a.checkCharacter && (this.checkChar_ = a.checkCharacter);
    };
    Blockly.FieldCheckbox.prototype.initView = function() {
        Blockly.FieldCheckbox.superClass_.initView.call(this);
        Blockly.utils.dom.addClass(this.textElement_, "blocklyCheckbox");
        this.textElement_.style.display = this.value_ ? "block" : "none";
    };
    Blockly.FieldCheckbox.prototype.render_ = function() {
        this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_());
        this.updateSize_(this.getConstants().FIELD_CHECKBOX_X_OFFSET);
    };
    Blockly.FieldCheckbox.prototype.getDisplayText_ = function() {
        return this.checkChar_ || Blockly.FieldCheckbox.CHECK_CHAR;
    };
    Blockly.FieldCheckbox.prototype.setCheckCharacter = function(a) {
        this.checkChar_ = a;
        this.forceRerender();
    };
    Blockly.FieldCheckbox.prototype.showEditor_ = function() {
        this.setValue(!this.value_);
    };
    Blockly.FieldCheckbox.prototype.doClassValidation_ = function(a) {
        return !0 === a || "TRUE" === a ? "TRUE" : !1 === a || "FALSE" === a ? "FALSE" : null;
    };
    Blockly.FieldCheckbox.prototype.doValueUpdate_ = function(a) {
        this.value_ = this.convertValueToBool_(a);
        this.textElement_ && (this.textElement_.style.display = this.value_ ? "block" : "none");
    };
    Blockly.FieldCheckbox.prototype.getValue = function() {
        return this.value_ ? "TRUE" : "FALSE";
    };
    Blockly.FieldCheckbox.prototype.getValueBoolean = function() {
        return this.value_;
    };
    Blockly.FieldCheckbox.prototype.getText = function() {
        return String(this.convertValueToBool_(this.value_));
    };
    Blockly.FieldCheckbox.prototype.convertValueToBool_ = function(a) {
        return "string" == typeof a ? "TRUE" == a : !!a;
    };
    Blockly.fieldRegistry.register("field_checkbox", Blockly.FieldCheckbox);
    Blockly.FieldColour = function(a, b, c) {
        Blockly.FieldColour.superClass_.constructor.call(this, a, b, c);
        this.onKeyDownWrapper_ = this.onMouseLeaveWrapper_ = this.onMouseEnterWrapper_ = this.onMouseMoveWrapper_ = this.onClickWrapper_ = this.highlightedIndex_ = this.picker_ = null;
    };
    Blockly.utils.object.inherits(Blockly.FieldColour, Blockly.Field);
    Blockly.FieldColour.fromJson = function(a) {
        return new Blockly.FieldColour(a.colour, void 0, a);
    };
    Blockly.FieldColour.prototype.SERIALIZABLE = !0;
    Blockly.FieldColour.prototype.CURSOR = "default";
    Blockly.FieldColour.prototype.isDirty_ = !1;
    Blockly.FieldColour.prototype.colours_ = null;
    Blockly.FieldColour.prototype.titles_ = null;
    Blockly.FieldColour.prototype.columns_ = 0;
    Blockly.FieldColour.prototype.configure_ = function(a) {
        Blockly.FieldColour.superClass_.configure_.call(this, a);
        a.colourOptions && (this.colours_ = a.colourOptions, this.titles_ = a.colourTitles);
        a.columns && (this.columns_ = a.columns);
    };
    Blockly.FieldColour.prototype.initView = function() {
        this.size_ = new Blockly.utils.Size(this.getConstants().FIELD_COLOUR_DEFAULT_WIDTH, this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT);
        this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : (this.createBorderRect_(), this.borderRect_.style.fillOpacity = "1");
    };
    Blockly.FieldColour.prototype.applyColour = function() {
        this.getConstants().FIELD_COLOUR_FULL_BLOCK ? (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", this.getValue()), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff")) : this.borderRect_ && (this.borderRect_.style.fill = this.getValue());
    };
    Blockly.FieldColour.prototype.doClassValidation_ = function(a) {
        return "string" != typeof a ? null : Blockly.utils.colour.parse(a);
    };
    Blockly.FieldColour.prototype.doValueUpdate_ = function(a) {
        this.value_ = a;
        this.borderRect_ ? this.borderRect_.style.fill = a : this.sourceBlock_ && this.sourceBlock_.rendered && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", a), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff"));
    };
    Blockly.FieldColour.prototype.getText = function() {
        var a = this.value_;
        /^#(.)\1(.)\2(.)\3$/.test(a) && (a = "#" + a[1] + a[3] + a[5]);
        return a;
    };
    Blockly.FieldColour.COLOURS = "#ffffff #cccccc #c0c0c0 #999999 #666666 #333333 #000000 #ffcccc #ff6666 #ff0000 #cc0000 #990000 #660000 #330000 #ffcc99 #ff9966 #ff9900 #ff6600 #cc6600 #993300 #663300 #ffff99 #ffff66 #ffcc66 #ffcc33 #cc9933 #996633 #663333 #ffffcc #ffff33 #ffff00 #ffcc00 #999900 #666600 #333300 #99ff99 #66ff99 #33ff33 #33cc00 #009900 #006600 #003300 #99ffff #33ffff #66cccc #00cccc #339999 #336666 #003333 #ccffff #66ffff #33ccff #3366ff #3333ff #000099 #000066 #ccccff #9999ff #6666cc #6633ff #6600cc #333399 #330099 #ffccff #ff99ff #cc66cc #cc33cc #993399 #663366 #330033".split(" ");
    Blockly.FieldColour.prototype.DEFAULT_VALUE = Blockly.FieldColour.COLOURS[0];
    Blockly.FieldColour.TITLES = [];
    Blockly.FieldColour.COLUMNS = 7;
    Blockly.FieldColour.prototype.setColours = function(a, b) {
        this.colours_ = a;
        b && (this.titles_ = b);
        return this;
    };
    Blockly.FieldColour.prototype.setColumns = function(a) {
        this.columns_ = a;
        return this;
    };
    Blockly.FieldColour.prototype.showEditor_ = function() {
        this.picker_ = this.dropdownCreate_();
        Blockly.DropDownDiv.getContentDiv().appendChild(this.picker_);
        Blockly.DropDownDiv.showPositionedByField(this, this.dropdownDispose_.bind(this));
        this.picker_.focus({
            preventScroll: !0
        });
    };
    Blockly.FieldColour.prototype.onClick_ = function(a) {
        a = (a = a.target) && a.label;
        null !== a && (this.setValue(a), Blockly.DropDownDiv.hideIfOwner(this));
    };
    Blockly.FieldColour.prototype.onKeyDown_ = function(a) {
        var b = !1;
        if (a.keyCode === Blockly.utils.KeyCodes.UP) this.moveHighlightBy_(0, -1), b = !0;
        else if (a.keyCode === Blockly.utils.KeyCodes.DOWN) this.moveHighlightBy_(0, 1), b = !0;
        else if (a.keyCode === Blockly.utils.KeyCodes.LEFT) this.moveHighlightBy_(-1, 0), b = !0;
        else if (a.keyCode === Blockly.utils.KeyCodes.RIGHT) this.moveHighlightBy_(1, 0), b = !0;
        else if (a.keyCode === Blockly.utils.KeyCodes.ENTER) {
            if (b = this.getHighlighted_()) b = b && b.label, null !== b && this.setValue(b);
            Blockly.DropDownDiv.hideWithoutAnimation();
            b = !0;
        }
        b && a.stopPropagation();
    };
    Blockly.FieldColour.prototype.moveHighlightBy_ = function(a, b) {
        var c = this.colours_ || Blockly.FieldColour.COLOURS, d = this.columns_ || Blockly.FieldColour.COLUMNS, e = this.highlightedIndex_ % d, f = Math.floor(this.highlightedIndex_ / d);
        e += a;
        f += b;
        0 > a ? 0 > e && 0 < f ? (e = d - 1, f--) : 0 > e && (e = 0) : 0 < a ? e > d - 1 && f < Math.floor(c.length / d) - 1 ? (e = 0, f++) : e > d - 1 && e-- : 0 > b ? 0 > f && (f = 0) : 0 < b && f > Math.floor(c.length / d) - 1 && (f = Math.floor(c.length / d) - 1);
        this.setHighlightedCell_(this.picker_.childNodes[f].childNodes[e], f * d + e);
    };
    Blockly.FieldColour.prototype.onMouseMove_ = function(a) {
        var b = (a = a.target) && Number(a.getAttribute("data-index"));
        null !== b && b !== this.highlightedIndex_ && this.setHighlightedCell_(a, b);
    };
    Blockly.FieldColour.prototype.onMouseEnter_ = function() {
        this.picker_.focus({
            preventScroll: !0
        });
    };
    Blockly.FieldColour.prototype.onMouseLeave_ = function() {
        this.picker_.blur();
        var a = this.getHighlighted_();
        a && Blockly.utils.dom.removeClass(a, "blocklyColourHighlighted");
    };
    Blockly.FieldColour.prototype.getHighlighted_ = function() {
        var a = this.columns_ || Blockly.FieldColour.COLUMNS, b = this.picker_.childNodes[Math.floor(this.highlightedIndex_ / a)];
        return b ? b.childNodes[this.highlightedIndex_ % a] : null;
    };
    Blockly.FieldColour.prototype.setHighlightedCell_ = function(a, b) {
        var c = this.getHighlighted_();
        c && Blockly.utils.dom.removeClass(c, "blocklyColourHighlighted");
        Blockly.utils.dom.addClass(a, "blocklyColourHighlighted");
        this.highlightedIndex_ = b;
        Blockly.utils.aria.setState(this.picker_, Blockly.utils.aria.State.ACTIVEDESCENDANT, a.getAttribute("id"));
    };
    Blockly.FieldColour.prototype.dropdownCreate_ = function() {
        var a = this.columns_ || Blockly.FieldColour.COLUMNS, b = this.colours_ || Blockly.FieldColour.COLOURS, c = this.titles_ || Blockly.FieldColour.TITLES, d = this.getValue(), e = document.createElement("table");
        e.className = "blocklyColourTable";
        e.tabIndex = 0;
        e.dir = "ltr";
        Blockly.utils.aria.setRole(e, Blockly.utils.aria.Role.GRID);
        Blockly.utils.aria.setState(e, Blockly.utils.aria.State.EXPANDED, !0);
        Blockly.utils.aria.setState(e, Blockly.utils.aria.State.ROWCOUNT, Math.floor(b.length / a));
        Blockly.utils.aria.setState(e, Blockly.utils.aria.State.COLCOUNT, a);
        for(var f, g = 0; g < b.length; g++){
            0 == g % a && (f = document.createElement("tr"), Blockly.utils.aria.setRole(f, Blockly.utils.aria.Role.ROW), e.appendChild(f));
            var h = document.createElement("td");
            f.appendChild(h);
            h.label = b[g];
            h.title = c[g] || b[g];
            h.id = Blockly.utils.IdGenerator.getNextUniqueId();
            h.setAttribute("data-index", g);
            Blockly.utils.aria.setRole(h, Blockly.utils.aria.Role.GRIDCELL);
            Blockly.utils.aria.setState(h, Blockly.utils.aria.State.LABEL, b[g]);
            Blockly.utils.aria.setState(h, Blockly.utils.aria.State.SELECTED, b[g] == d);
            h.style.backgroundColor = b[g];
            b[g] == d && (h.className = "blocklyColourSelected", this.highlightedIndex_ = g);
        }
        this.onClickWrapper_ = Blockly.browserEvents.conditionalBind(e, "click", this, this.onClick_, !0);
        this.onMouseMoveWrapper_ = Blockly.browserEvents.conditionalBind(e, "mousemove", this, this.onMouseMove_, !0);
        this.onMouseEnterWrapper_ = Blockly.browserEvents.conditionalBind(e, "mouseenter", this, this.onMouseEnter_, !0);
        this.onMouseLeaveWrapper_ = Blockly.browserEvents.conditionalBind(e, "mouseleave", this, this.onMouseLeave_, !0);
        this.onKeyDownWrapper_ = Blockly.browserEvents.conditionalBind(e, "keydown", this, this.onKeyDown_);
        return e;
    };
    Blockly.FieldColour.prototype.dropdownDispose_ = function() {
        this.onClickWrapper_ && (Blockly.browserEvents.unbind(this.onClickWrapper_), this.onClickWrapper_ = null);
        this.onMouseMoveWrapper_ && (Blockly.browserEvents.unbind(this.onMouseMoveWrapper_), this.onMouseMoveWrapper_ = null);
        this.onMouseEnterWrapper_ && (Blockly.browserEvents.unbind(this.onMouseEnterWrapper_), this.onMouseEnterWrapper_ = null);
        this.onMouseLeaveWrapper_ && (Blockly.browserEvents.unbind(this.onMouseLeaveWrapper_), this.onMouseLeaveWrapper_ = null);
        this.onKeyDownWrapper_ && (Blockly.browserEvents.unbind(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null);
        this.highlightedIndex_ = this.picker_ = null;
    };
    Blockly.Css.register([
        ".blocklyColourTable {",
        "border-collapse: collapse;",
        "display: block;",
        "outline: none;",
        "padding: 1px;",
        "}",
        ".blocklyColourTable>tr>td {",
        "border: .5px solid #888;",
        "box-sizing: border-box;",
        "cursor: pointer;",
        "display: inline-block;",
        "height: 20px;",
        "padding: 0;",
        "width: 20px;",
        "}",
        ".blocklyColourTable>tr>td.blocklyColourHighlighted {",
        "border-color: #eee;",
        "box-shadow: 2px 2px 7px 2px rgba(0,0,0,.3);",
        "position: relative;",
        "}",
        ".blocklyColourSelected, .blocklyColourSelected:hover {",
        "border-color: #eee !important;",
        "outline: 1px solid #333;",
        "position: relative;",
        "}"
    ]);
    Blockly.fieldRegistry.register("field_colour", Blockly.FieldColour);
    Blockly.FieldDropdown = function(a, b, c) {
        "function" != typeof a && Blockly.FieldDropdown.validateOptions_(a);
        this.menuGenerator_ = a;
        this.suffixField = this.prefixField = this.generatedOptions_ = null;
        this.trimOptions_();
        this.selectedOption_ = this.getOptions(!1)[0];
        Blockly.FieldDropdown.superClass_.constructor.call(this, this.selectedOption_[1], b, c);
        this.svgArrow_ = this.arrow_ = this.imageElement_ = this.menu_ = this.selectedMenuItem_ = null;
    };
    Blockly.utils.object.inherits(Blockly.FieldDropdown, Blockly.Field);
    Blockly.FieldDropdown.fromJson = function(a) {
        return new Blockly.FieldDropdown(a.options, void 0, a);
    };
    Blockly.FieldDropdown.prototype.fromXml = function(a) {
        this.isOptionListDynamic() && this.getOptions(!1);
        this.setValue(a.textContent);
    };
    Blockly.FieldDropdown.prototype.SERIALIZABLE = !0;
    Blockly.FieldDropdown.CHECKMARK_OVERHANG = 25;
    Blockly.FieldDropdown.MAX_MENU_HEIGHT_VH = .45;
    Blockly.FieldDropdown.IMAGE_Y_OFFSET = 5;
    Blockly.FieldDropdown.IMAGE_Y_PADDING = 2 * Blockly.FieldDropdown.IMAGE_Y_OFFSET;
    Blockly.FieldDropdown.ARROW_CHAR = Blockly.utils.userAgent.ANDROID ? "\u25bc" : "\u25be";
    Blockly.FieldDropdown.prototype.CURSOR = "default";
    Blockly.FieldDropdown.prototype.initView = function() {
        this.shouldAddBorderRect_() ? this.createBorderRect_() : this.clickTarget_ = this.sourceBlock_.getSvgRoot();
        this.createTextElement_();
        this.imageElement_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {}, this.fieldGroup_);
        this.getConstants().FIELD_DROPDOWN_SVG_ARROW ? this.createSVGArrow_() : this.createTextArrow_();
        this.borderRect_ && Blockly.utils.dom.addClass(this.borderRect_, "blocklyDropdownRect");
    };
    Blockly.FieldDropdown.prototype.shouldAddBorderRect_ = function() {
        return !this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW && !this.sourceBlock_.isShadow();
    };
    Blockly.FieldDropdown.prototype.createTextArrow_ = function() {
        this.arrow_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TSPAN, {}, this.textElement_);
        this.arrow_.appendChild(document.createTextNode(this.sourceBlock_.RTL ? Blockly.FieldDropdown.ARROW_CHAR + " " : " " + Blockly.FieldDropdown.ARROW_CHAR));
        this.sourceBlock_.RTL ? this.textElement_.insertBefore(this.arrow_, this.textContent_) : this.textElement_.appendChild(this.arrow_);
    };
    Blockly.FieldDropdown.prototype.createSVGArrow_ = function() {
        this.svgArrow_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            height: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px",
            width: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px"
        }, this.fieldGroup_);
        this.svgArrow_.setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.getConstants().FIELD_DROPDOWN_SVG_ARROW_DATAURI);
    };
    Blockly.FieldDropdown.prototype.showEditor_ = function(a) {
        this.menu_ = this.dropdownCreate_();
        this.menu_.openingCoords = a && "number" === typeof a.clientX ? new Blockly.utils.Coordinate(a.clientX, a.clientY) : null;
        this.menu_.render(Blockly.DropDownDiv.getContentDiv());
        a = this.menu_.getElement();
        Blockly.utils.dom.addClass(a, "blocklyDropdownMenu");
        if (this.getConstants().FIELD_DROPDOWN_COLOURED_DIV) {
            a = this.sourceBlock_.isShadow() ? this.sourceBlock_.getParent().getColour() : this.sourceBlock_.getColour();
            var b = this.sourceBlock_.isShadow() ? this.sourceBlock_.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary;
            Blockly.DropDownDiv.setColour(a, b);
        }
        Blockly.DropDownDiv.showPositionedByField(this, this.dropdownDispose_.bind(this));
        this.menu_.focus();
        this.selectedMenuItem_ && this.menu_.setHighlighted(this.selectedMenuItem_);
        this.applyColour();
    };
    Blockly.FieldDropdown.prototype.dropdownCreate_ = function() {
        var a = new Blockly.Menu;
        a.setRole(Blockly.utils.aria.Role.LISTBOX);
        var b = this.getOptions(!1);
        this.selectedMenuItem_ = null;
        for(var c = 0; c < b.length; c++){
            var d = b[c][0], e = b[c][1];
            if ("object" == typeof d) {
                var f = new Image(d.width, d.height);
                f.src = d.src;
                f.alt = d.alt || "";
                d = f;
            }
            d = new Blockly.MenuItem(d, e);
            d.setRole(Blockly.utils.aria.Role.OPTION);
            d.setRightToLeft(this.sourceBlock_.RTL);
            d.setCheckable(!0);
            a.addChild(d);
            d.setChecked(e == this.value_);
            e == this.value_ && (this.selectedMenuItem_ = d);
            d.onAction(this.handleMenuActionEvent_, this);
        }
        return a;
    };
    Blockly.FieldDropdown.prototype.dropdownDispose_ = function() {
        this.menu_ && this.menu_.dispose();
        this.selectedMenuItem_ = this.menu_ = null;
        this.applyColour();
    };
    Blockly.FieldDropdown.prototype.handleMenuActionEvent_ = function(a) {
        Blockly.DropDownDiv.hideIfOwner(this, !0);
        this.onItemSelected_(this.menu_, a);
    };
    Blockly.FieldDropdown.prototype.onItemSelected_ = function(a, b) {
        this.setValue(b.getValue());
    };
    Blockly.FieldDropdown.prototype.trimOptions_ = function() {
        var a = this.menuGenerator_;
        if (Array.isArray(a)) {
            for(var b = !1, c = 0; c < a.length; c++){
                var d = a[c][0];
                "string" == typeof d ? a[c][0] = Blockly.utils.replaceMessageReferences(d) : (null != d.alt && (a[c][0].alt = Blockly.utils.replaceMessageReferences(d.alt)), b = !0);
            }
            if (!(b || 2 > a.length)) {
                b = [];
                for(c = 0; c < a.length; c++)b.push(a[c][0]);
                c = Blockly.utils.string.shortestStringLength(b);
                d = Blockly.utils.string.commonWordPrefix(b, c);
                var e = Blockly.utils.string.commonWordSuffix(b, c);
                !d && !e || c <= d + e || (d && (this.prefixField = b[0].substring(0, d - 1)), e && (this.suffixField = b[0].substr(1 - e)), this.menuGenerator_ = Blockly.FieldDropdown.applyTrim_(a, d, e));
            }
        }
    };
    Blockly.FieldDropdown.applyTrim_ = function(a, b, c) {
        for(var d = [], e = 0; e < a.length; e++){
            var f = a[e][0], g = a[e][1];
            f = f.substring(b, f.length - c);
            d[e] = [
                f,
                g
            ];
        }
        return d;
    };
    Blockly.FieldDropdown.prototype.isOptionListDynamic = function() {
        return "function" == typeof this.menuGenerator_;
    };
    Blockly.FieldDropdown.prototype.getOptions = function(a) {
        return this.isOptionListDynamic() ? (this.generatedOptions_ && a || (this.generatedOptions_ = this.menuGenerator_.call(this), Blockly.FieldDropdown.validateOptions_(this.generatedOptions_)), this.generatedOptions_) : this.menuGenerator_;
    };
    Blockly.FieldDropdown.prototype.doClassValidation_ = function(a) {
        for(var b = !1, c = this.getOptions(!0), d = 0, e; e = c[d]; d++)if (e[1] == a) {
            b = !0;
            break;
        }
        return b ? a : (this.sourceBlock_ && console.warn("Cannot set the dropdown's value to an unavailable option. Block type: " + this.sourceBlock_.type + ", Field name: " + this.name + ", Value: " + a), null);
    };
    Blockly.FieldDropdown.prototype.doValueUpdate_ = function(a) {
        Blockly.FieldDropdown.superClass_.doValueUpdate_.call(this, a);
        a = this.getOptions(!0);
        for(var b = 0, c; c = a[b]; b++)c[1] == this.value_ && (this.selectedOption_ = c);
    };
    Blockly.FieldDropdown.prototype.applyColour = function() {
        this.borderRect_ && (this.borderRect_.setAttribute("stroke", this.sourceBlock_.style.colourTertiary), this.menu_ ? this.borderRect_.setAttribute("fill", this.sourceBlock_.style.colourTertiary) : this.borderRect_.setAttribute("fill", "transparent"));
        this.sourceBlock_ && this.arrow_ && (this.sourceBlock_.isShadow() ? this.arrow_.style.fill = this.sourceBlock_.style.colourSecondary : this.arrow_.style.fill = this.sourceBlock_.style.colourPrimary);
    };
    Blockly.FieldDropdown.prototype.render_ = function() {
        this.textContent_.nodeValue = "";
        this.imageElement_.style.display = "none";
        var a = this.selectedOption_ && this.selectedOption_[0];
        a && "object" == typeof a ? this.renderSelectedImage_(a) : this.renderSelectedText_();
        this.positionBorderRect_();
    };
    Blockly.FieldDropdown.prototype.renderSelectedImage_ = function(a) {
        this.imageElement_.style.display = "";
        this.imageElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", a.src);
        this.imageElement_.setAttribute("height", a.height);
        this.imageElement_.setAttribute("width", a.width);
        var b = Number(a.height);
        a = Number(a.width);
        var c = !!this.borderRect_, d = Math.max(c ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, b + Blockly.FieldDropdown.IMAGE_Y_PADDING);
        c = c ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
        var e = this.svgArrow_ ? this.positionSVGArrow_(a + c, d / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2) : Blockly.utils.dom.getFastTextWidth(this.arrow_, this.getConstants().FIELD_TEXT_FONTSIZE, this.getConstants().FIELD_TEXT_FONTWEIGHT, this.getConstants().FIELD_TEXT_FONTFAMILY);
        this.size_.width = a + e + 2 * c;
        this.size_.height = d;
        var f = 0;
        this.sourceBlock_.RTL ? this.imageElement_.setAttribute("x", c + e) : (f = a + e, this.textElement_.setAttribute("text-anchor", "end"), this.imageElement_.setAttribute("x", c));
        this.imageElement_.setAttribute("y", d / 2 - b / 2);
        this.positionTextElement_(f + c, a + e);
    };
    Blockly.FieldDropdown.prototype.renderSelectedText_ = function() {
        this.textContent_.nodeValue = this.getDisplayText_();
        Blockly.utils.dom.addClass(this.textElement_, "blocklyDropdownText");
        this.textElement_.setAttribute("text-anchor", "start");
        var a = !!this.borderRect_, b = Math.max(a ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, this.getConstants().FIELD_TEXT_HEIGHT), c = Blockly.utils.dom.getFastTextWidth(this.textElement_, this.getConstants().FIELD_TEXT_FONTSIZE, this.getConstants().FIELD_TEXT_FONTWEIGHT, this.getConstants().FIELD_TEXT_FONTFAMILY);
        a = a ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
        var d = 0;
        this.svgArrow_ && (d = this.positionSVGArrow_(c + a, b / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2));
        this.size_.width = c + d + 2 * a;
        this.size_.height = b;
        this.positionTextElement_(a, c);
    };
    Blockly.FieldDropdown.prototype.positionSVGArrow_ = function(a, b) {
        if (!this.svgArrow_) return 0;
        var c = this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0, d = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING, e = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE;
        this.svgArrow_.setAttribute("transform", "translate(" + (this.sourceBlock_.RTL ? c : a + d) + "," + b + ")");
        return e + d;
    };
    Blockly.FieldDropdown.prototype.getText_ = function() {
        if (!this.selectedOption_) return null;
        var a = this.selectedOption_[0];
        return "object" == typeof a ? a.alt : a;
    };
    Blockly.FieldDropdown.validateOptions_ = function(a) {
        if (!Array.isArray(a)) throw TypeError("FieldDropdown options must be an array.");
        if (!a.length) throw TypeError("FieldDropdown options must not be an empty array.");
        for(var b = !1, c = 0; c < a.length; ++c){
            var d = a[c];
            Array.isArray(d) ? "string" != typeof d[1] ? (b = !0, console.error("Invalid option[" + c + "]: Each FieldDropdown option id must be a string. Found " + d[1] + " in: ", d)) : d[0] && "string" != typeof d[0] && "string" != typeof d[0].src && (b = !0, console.error("Invalid option[" + c + "]: Each FieldDropdown option must have a string label or image description. Found" + d[0] + " in: ", d)) : (b = !0, console.error("Invalid option[" + c + "]: Each FieldDropdown option must be an array. Found: ", d));
        }
        if (b) throw TypeError("Found invalid FieldDropdown options.");
    };
    Blockly.fieldRegistry.register("field_dropdown", Blockly.FieldDropdown);
    Blockly.FieldLabelSerializable = function(a, b, c) {
        Blockly.FieldLabelSerializable.superClass_.constructor.call(this, a, b, c);
    };
    Blockly.utils.object.inherits(Blockly.FieldLabelSerializable, Blockly.FieldLabel);
    Blockly.FieldLabelSerializable.fromJson = function(a) {
        var b = Blockly.utils.replaceMessageReferences(a.text);
        return new Blockly.FieldLabelSerializable(b, void 0, a);
    };
    Blockly.FieldLabelSerializable.prototype.EDITABLE = !1;
    Blockly.FieldLabelSerializable.prototype.SERIALIZABLE = !0;
    Blockly.fieldRegistry.register("field_label_serializable", Blockly.FieldLabelSerializable);
    Blockly.FieldImage = function(a, b, c, d, e, f, g) {
        if (!a) throw Error("Src value of an image field is required");
        a = Blockly.utils.replaceMessageReferences(a);
        c = Number(Blockly.utils.replaceMessageReferences(c));
        b = Number(Blockly.utils.replaceMessageReferences(b));
        if (isNaN(c) || isNaN(b)) throw Error("Height and width values of an image field must cast to numbers.");
        if (0 >= c || 0 >= b) throw Error("Height and width values of an image field must be greater than 0.");
        this.flipRtl_ = !1;
        this.altText_ = "";
        Blockly.FieldImage.superClass_.constructor.call(this, a, null, g);
        g || (this.flipRtl_ = !!f, this.altText_ = Blockly.utils.replaceMessageReferences(d) || "");
        this.size_ = new Blockly.utils.Size(b, c + Blockly.FieldImage.Y_PADDING);
        this.imageHeight_ = c;
        this.clickHandler_ = null;
        "function" == typeof e && (this.clickHandler_ = e);
        this.imageElement_ = null;
    };
    Blockly.utils.object.inherits(Blockly.FieldImage, Blockly.Field);
    Blockly.FieldImage.prototype.DEFAULT_VALUE = "";
    Blockly.FieldImage.fromJson = function(a) {
        return new Blockly.FieldImage(a.src, a.width, a.height, void 0, void 0, void 0, a);
    };
    Blockly.FieldImage.Y_PADDING = 1;
    Blockly.FieldImage.prototype.EDITABLE = !1;
    Blockly.FieldImage.prototype.isDirty_ = !1;
    Blockly.FieldImage.prototype.configure_ = function(a) {
        Blockly.FieldImage.superClass_.configure_.call(this, a);
        this.flipRtl_ = !!a.flipRtl;
        this.altText_ = Blockly.utils.replaceMessageReferences(a.alt) || "";
    };
    Blockly.FieldImage.prototype.initView = function() {
        this.imageElement_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.IMAGE, {
            height: this.imageHeight_ + "px",
            width: this.size_.width + "px",
            alt: this.altText_
        }, this.fieldGroup_);
        this.imageElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", this.value_);
        this.clickHandler_ && (this.imageElement_.style.cursor = "pointer");
    };
    Blockly.FieldImage.prototype.updateSize_ = function() {};
    Blockly.FieldImage.prototype.doClassValidation_ = function(a) {
        return "string" != typeof a ? null : a;
    };
    Blockly.FieldImage.prototype.doValueUpdate_ = function(a) {
        this.value_ = a;
        this.imageElement_ && this.imageElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS, "xlink:href", String(this.value_));
    };
    Blockly.FieldImage.prototype.getFlipRtl = function() {
        return this.flipRtl_;
    };
    Blockly.FieldImage.prototype.setAlt = function(a) {
        a != this.altText_ && (this.altText_ = a || "", this.imageElement_ && this.imageElement_.setAttribute("alt", this.altText_));
    };
    Blockly.FieldImage.prototype.showEditor_ = function() {
        this.clickHandler_ && this.clickHandler_(this);
    };
    Blockly.FieldImage.prototype.setOnClickHandler = function(a) {
        this.clickHandler_ = a;
    };
    Blockly.FieldImage.prototype.getText_ = function() {
        return this.altText_;
    };
    Blockly.fieldRegistry.register("field_image", Blockly.FieldImage);
    Blockly.FieldMultilineInput = function(a, b, c) {
        Blockly.FieldMultilineInput.superClass_.constructor.call(this, a, b, c);
        this.textGroup_ = null;
        this.maxLines_ = Infinity;
        this.isOverflowedY_ = !1;
    };
    Blockly.utils.object.inherits(Blockly.FieldMultilineInput, Blockly.FieldTextInput);
    Blockly.FieldMultilineInput.prototype.configure_ = function(a) {
        Blockly.FieldMultilineInput.superClass_.configure_.call(this, a);
        a.maxLines && this.setMaxLines(a.maxLines);
    };
    Blockly.FieldMultilineInput.fromJson = function(a) {
        var b = Blockly.utils.replaceMessageReferences(a.text);
        return new Blockly.FieldMultilineInput(b, void 0, a);
    };
    Blockly.FieldMultilineInput.prototype.toXml = function(a) {
        a.textContent = this.getValue().replace(/\n/g, "&#10;");
        return a;
    };
    Blockly.FieldMultilineInput.prototype.fromXml = function(a) {
        this.setValue(a.textContent.replace(/&#10;/g, "\n"));
    };
    Blockly.FieldMultilineInput.prototype.initView = function() {
        this.createBorderRect_();
        this.textGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": "blocklyEditableText"
        }, this.fieldGroup_);
    };
    Blockly.FieldMultilineInput.prototype.getDisplayText_ = function() {
        var a = this.getText();
        if (!a) return Blockly.Field.NBSP;
        var b = a.split("\n");
        a = "";
        for(var c = this.isOverflowedY_ ? this.maxLines_ : b.length, d = 0; d < c; d++){
            var e = b[d];
            e.length > this.maxDisplayLength ? e = e.substring(0, this.maxDisplayLength - 4) + "..." : this.isOverflowedY_ && d === c - 1 && (e = e.substring(0, e.length - 3) + "...");
            e = e.replace(/\s/g, Blockly.Field.NBSP);
            a += e;
            d !== c - 1 && (a += "\n");
        }
        this.sourceBlock_.RTL && (a += "\u200f");
        return a;
    };
    Blockly.FieldMultilineInput.prototype.doValueUpdate_ = function(a) {
        Blockly.FieldMultilineInput.superClass_.doValueUpdate_.call(this, a);
        this.isOverflowedY_ = this.value_.split("\n").length > this.maxLines_;
    };
    Blockly.FieldMultilineInput.prototype.render_ = function() {
        for(var a; a = this.textGroup_.firstChild;)this.textGroup_.removeChild(a);
        a = this.getDisplayText_().split("\n");
        for(var b = 0, c = 0; c < a.length; c++){
            var d = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
            Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TEXT, {
                "class": "blocklyText blocklyMultilineText",
                x: this.getConstants().FIELD_BORDER_RECT_X_PADDING,
                y: b + this.getConstants().FIELD_BORDER_RECT_Y_PADDING,
                dy: this.getConstants().FIELD_TEXT_BASELINE
            }, this.textGroup_).appendChild(document.createTextNode(a[c]));
            b += d;
        }
        this.isBeingEdited_ && (a = this.htmlInput_, this.isOverflowedY_ ? Blockly.utils.dom.addClass(a, "blocklyHtmlTextAreaInputOverflowedY") : Blockly.utils.dom.removeClass(a, "blocklyHtmlTextAreaInputOverflowedY"));
        this.updateSize_();
        this.isBeingEdited_ && (this.sourceBlock_.RTL ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_(), a = this.htmlInput_, this.isTextValid_ ? (Blockly.utils.dom.removeClass(a, "blocklyInvalidInput"), Blockly.utils.aria.setState(a, Blockly.utils.aria.State.INVALID, !1)) : (Blockly.utils.dom.addClass(a, "blocklyInvalidInput"), Blockly.utils.aria.setState(a, Blockly.utils.aria.State.INVALID, !0)));
    };
    Blockly.FieldMultilineInput.prototype.updateSize_ = function() {
        for(var a = this.textGroup_.childNodes, b = 0, c = 0, d = 0; d < a.length; d++){
            var e = Blockly.utils.dom.getTextWidth(a[d]);
            e > b && (b = e);
            c += this.getConstants().FIELD_TEXT_HEIGHT + (0 < d ? this.getConstants().FIELD_BORDER_RECT_Y_PADDING : 0);
        }
        if (this.isBeingEdited_) {
            a = this.value_.split("\n");
            e = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.TEXT, {
                "class": "blocklyText blocklyMultilineText"
            });
            var f = this.getConstants().FIELD_TEXT_FONTSIZE, g = this.getConstants().FIELD_TEXT_FONTWEIGHT, h = this.getConstants().FIELD_TEXT_FONTFAMILY;
            for(d = 0; d < a.length; d++){
                a[d].length > this.maxDisplayLength && (a[d] = a[d].substring(0, this.maxDisplayLength));
                e.textContent = a[d];
                var k = Blockly.utils.dom.getFastTextWidth(e, f, g, h);
                k > b && (b = k);
            }
            b += this.htmlInput_.offsetWidth - this.htmlInput_.clientWidth;
        }
        this.borderRect_ && (c += 2 * this.getConstants().FIELD_BORDER_RECT_Y_PADDING, b += 2 * this.getConstants().FIELD_BORDER_RECT_X_PADDING, this.borderRect_.setAttribute("width", b), this.borderRect_.setAttribute("height", c));
        this.size_.width = b;
        this.size_.height = c;
        this.positionBorderRect_();
    };
    Blockly.FieldMultilineInput.prototype.showEditor_ = function(a, b) {
        Blockly.FieldMultilineInput.superClass_.showEditor_.call(this, a, b);
        this.forceRerender();
    };
    Blockly.FieldMultilineInput.prototype.widgetCreate_ = function() {
        var a = Blockly.WidgetDiv.DIV, b = this.workspace_.getScale(), c = document.createElement("textarea");
        c.className = "blocklyHtmlInput blocklyHtmlTextAreaInput";
        c.setAttribute("spellcheck", this.spellcheck_);
        var d = this.getConstants().FIELD_TEXT_FONTSIZE * b + "pt";
        a.style.fontSize = d;
        c.style.fontSize = d;
        c.style.borderRadius = Blockly.FieldTextInput.BORDERRADIUS * b + "px";
        d = this.getConstants().FIELD_BORDER_RECT_X_PADDING * b;
        var e = this.getConstants().FIELD_BORDER_RECT_Y_PADDING * b / 2;
        c.style.padding = e + "px " + d + "px " + e + "px " + d + "px";
        d = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
        c.style.lineHeight = d * b + "px";
        a.appendChild(c);
        c.value = c.defaultValue = this.getEditorText_(this.value_);
        c.untypedDefaultValue_ = this.value_;
        c.oldValue_ = null;
        Blockly.utils.userAgent.GECKO ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_();
        this.bindInputEvents_(c);
        return c;
    };
    Blockly.FieldMultilineInput.prototype.setMaxLines = function(a) {
        "number" === typeof a && 0 < a && a !== this.maxLines_ && (this.maxLines_ = a, this.forceRerender());
    };
    Blockly.FieldMultilineInput.prototype.getMaxLines = function() {
        return this.maxLines_;
    };
    Blockly.FieldMultilineInput.prototype.onHtmlInputKeyDown_ = function(a) {
        a.keyCode !== Blockly.utils.KeyCodes.ENTER && Blockly.FieldMultilineInput.superClass_.onHtmlInputKeyDown_.call(this, a);
    };
    Blockly.Css.register(".blocklyHtmlTextAreaInput {,font-family: monospace;,resize: none;,overflow: hidden;,height: 100%;,text-align: left;,},.blocklyHtmlTextAreaInputOverflowedY {,overflow-y: scroll;,}".split(","));
    Blockly.fieldRegistry.register("field_multilinetext", Blockly.FieldMultilineInput);
    Blockly.FieldNumber = function(a, b, c, d, e, f) {
        this.min_ = -Infinity;
        this.max_ = Infinity;
        this.precision_ = 0;
        this.decimalPlaces_ = null;
        Blockly.FieldNumber.superClass_.constructor.call(this, a, e, f);
        f || this.setConstraints(b, c, d);
    };
    Blockly.utils.object.inherits(Blockly.FieldNumber, Blockly.FieldTextInput);
    Blockly.FieldNumber.prototype.DEFAULT_VALUE = 0;
    Blockly.FieldNumber.fromJson = function(a) {
        return new Blockly.FieldNumber(a.value, void 0, void 0, void 0, void 0, a);
    };
    Blockly.FieldNumber.prototype.SERIALIZABLE = !0;
    Blockly.FieldNumber.prototype.configure_ = function(a) {
        Blockly.FieldNumber.superClass_.configure_.call(this, a);
        this.setMinInternal_(a.min);
        this.setMaxInternal_(a.max);
        this.setPrecisionInternal_(a.precision);
    };
    Blockly.FieldNumber.prototype.setConstraints = function(a, b, c) {
        this.setMinInternal_(a);
        this.setMaxInternal_(b);
        this.setPrecisionInternal_(c);
        this.setValue(this.getValue());
    };
    Blockly.FieldNumber.prototype.setMin = function(a) {
        this.setMinInternal_(a);
        this.setValue(this.getValue());
    };
    Blockly.FieldNumber.prototype.setMinInternal_ = function(a) {
        null == a ? this.min_ = -Infinity : (a = Number(a), isNaN(a) || (this.min_ = a));
    };
    Blockly.FieldNumber.prototype.getMin = function() {
        return this.min_;
    };
    Blockly.FieldNumber.prototype.setMax = function(a) {
        this.setMaxInternal_(a);
        this.setValue(this.getValue());
    };
    Blockly.FieldNumber.prototype.setMaxInternal_ = function(a) {
        null == a ? this.max_ = Infinity : (a = Number(a), isNaN(a) || (this.max_ = a));
    };
    Blockly.FieldNumber.prototype.getMax = function() {
        return this.max_;
    };
    Blockly.FieldNumber.prototype.setPrecision = function(a) {
        this.setPrecisionInternal_(a);
        this.setValue(this.getValue());
    };
    Blockly.FieldNumber.prototype.setPrecisionInternal_ = function(a) {
        null == a ? this.precision_ = 0 : (a = Number(a), isNaN(a) || (this.precision_ = a));
        var b = this.precision_.toLocaleString("en-US", {
            maximumFractionDigits: 20
        }), c = b.indexOf(".");
        this.decimalPlaces_ = -1 == c ? a ? 0 : null : b.length - c - 1;
    };
    Blockly.FieldNumber.prototype.getPrecision = function() {
        return this.precision_;
    };
    Blockly.FieldNumber.prototype.doClassValidation_ = function(a) {
        if (null === a) return null;
        a = String(a);
        a = a.replace(/O/ig, "0");
        a = a.replace(/,/g, "");
        a = a.replace(/infinity/i, "Infinity");
        a = Number(a || 0);
        if (isNaN(a)) return null;
        a = Math.min(Math.max(a, this.min_), this.max_);
        this.precision_ && isFinite(a) && (a = Math.round(a / this.precision_) * this.precision_);
        null != this.decimalPlaces_ && (a = Number(a.toFixed(this.decimalPlaces_)));
        return a;
    };
    Blockly.FieldNumber.prototype.widgetCreate_ = function() {
        var a = Blockly.FieldNumber.superClass_.widgetCreate_.call(this);
        -Infinity < this.min_ && Blockly.utils.aria.setState(a, Blockly.utils.aria.State.VALUEMIN, this.min_);
        Infinity > this.max_ && Blockly.utils.aria.setState(a, Blockly.utils.aria.State.VALUEMAX, this.max_);
        return a;
    };
    Blockly.fieldRegistry.register("field_number", Blockly.FieldNumber);
    Blockly.FieldVariable = function(a, b, c, d, e) {
        this.menuGenerator_ = Blockly.FieldVariable.dropdownCreate;
        this.defaultVariableName = "string" === typeof a ? a : "";
        this.size_ = new Blockly.utils.Size(0, 0);
        e && this.configure_(e);
        b && this.setValidator(b);
        e || this.setTypes_(c, d);
    };
    Blockly.utils.object.inherits(Blockly.FieldVariable, Blockly.FieldDropdown);
    Blockly.FieldVariable.fromJson = function(a) {
        var b = Blockly.utils.replaceMessageReferences(a.variable);
        return new Blockly.FieldVariable(b, void 0, void 0, void 0, a);
    };
    Blockly.FieldVariable.prototype.SERIALIZABLE = !0;
    Blockly.FieldVariable.prototype.configure_ = function(a) {
        Blockly.FieldVariable.superClass_.configure_.call(this, a);
        this.setTypes_(a.variableTypes, a.defaultType);
    };
    Blockly.FieldVariable.prototype.initModel = function() {
        if (!this.variable_) {
            var a = Blockly.Variables.getOrCreateVariablePackage(this.sourceBlock_.workspace, null, this.defaultVariableName, this.defaultType_);
            this.doValueUpdate_(a.getId());
        }
    };
    Blockly.FieldVariable.prototype.shouldAddBorderRect_ = function() {
        return Blockly.FieldVariable.superClass_.shouldAddBorderRect_.call(this) && (!this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || "variables_get" != this.sourceBlock_.type);
    };
    Blockly.FieldVariable.prototype.fromXml = function(a) {
        var b = a.getAttribute("id"), c = a.textContent, d = a.getAttribute("variabletype") || a.getAttribute("variableType") || "";
        b = Blockly.Variables.getOrCreateVariablePackage(this.sourceBlock_.workspace, b, c, d);
        if (null != d && d !== b.type) throw Error("Serialized variable type with id '" + b.getId() + "' had type " + b.type + ", and does not match variable field that references it: " + Blockly.Xml.domToText(a) + ".");
        this.setValue(b.getId());
    };
    Blockly.FieldVariable.prototype.toXml = function(a) {
        this.initModel();
        a.id = this.variable_.getId();
        a.textContent = this.variable_.name;
        this.variable_.type && a.setAttribute("variabletype", this.variable_.type);
        return a;
    };
    Blockly.FieldVariable.prototype.setSourceBlock = function(a) {
        if (a.isShadow()) throw Error("Variable fields are not allowed to exist on shadow blocks.");
        Blockly.FieldVariable.superClass_.setSourceBlock.call(this, a);
    };
    Blockly.FieldVariable.prototype.getValue = function() {
        return this.variable_ ? this.variable_.getId() : null;
    };
    Blockly.FieldVariable.prototype.getText = function() {
        return this.variable_ ? this.variable_.name : "";
    };
    Blockly.FieldVariable.prototype.getVariable = function() {
        return this.variable_;
    };
    Blockly.FieldVariable.prototype.getValidator = function() {
        return this.variable_ ? this.validator_ : null;
    };
    Blockly.FieldVariable.prototype.doClassValidation_ = function(a) {
        if (null === a) return null;
        var b = Blockly.Variables.getVariable(this.sourceBlock_.workspace, a);
        if (!b) return console.warn("Variable id doesn't point to a real variable! ID was " + a), null;
        b = b.type;
        return this.typeIsAllowed_(b) ? a : (console.warn("Variable type doesn't match this field!  Type was " + b), null);
    };
    Blockly.FieldVariable.prototype.doValueUpdate_ = function(a) {
        this.variable_ = Blockly.Variables.getVariable(this.sourceBlock_.workspace, a);
        Blockly.FieldVariable.superClass_.doValueUpdate_.call(this, a);
    };
    Blockly.FieldVariable.prototype.typeIsAllowed_ = function(a) {
        var b = this.getVariableTypes_();
        if (!b) return !0;
        for(var c = 0; c < b.length; c++)if (a == b[c]) return !0;
        return !1;
    };
    Blockly.FieldVariable.prototype.getVariableTypes_ = function() {
        var a = this.variableTypes;
        if (null === a && this.sourceBlock_ && this.sourceBlock_.workspace) return this.sourceBlock_.workspace.getVariableTypes();
        a = a || [
            ""
        ];
        if (0 == a.length) throw a = this.getText(), Error("'variableTypes' of field variable " + a + " was an empty list");
        return a;
    };
    Blockly.FieldVariable.prototype.setTypes_ = function(a, b) {
        b = b || "";
        if (null == a || void 0 == a) a = null;
        else if (Array.isArray(a)) {
            for(var c = !1, d = 0; d < a.length; d++)a[d] == b && (c = !0);
            if (!c) throw Error("Invalid default type '" + b + "' in the definition of a FieldVariable");
        } else throw Error("'variableTypes' was not an array in the definition of a FieldVariable");
        this.defaultType_ = b;
        this.variableTypes = a;
    };
    Blockly.FieldVariable.prototype.refreshVariableName = function() {
        this.forceRerender();
    };
    Blockly.FieldVariable.dropdownCreate = function() {
        if (!this.variable_) throw Error("Tried to call dropdownCreate on a variable field with no variable selected.");
        var a = this.getText(), b = [];
        if (this.sourceBlock_ && this.sourceBlock_.workspace) for(var c = this.getVariableTypes_(), d = 0; d < c.length; d++){
            var e = this.sourceBlock_.workspace.getVariablesOfType(c[d]);
            b = b.concat(e);
        }
        b.sort(Blockly.VariableModel.compareByName);
        c = [];
        for(d = 0; d < b.length; d++)c[d] = [
            b[d].name,
            b[d].getId()
        ];
        c.push([
            Blockly.Msg.RENAME_VARIABLE,
            Blockly.RENAME_VARIABLE_ID
        ]);
        Blockly.Msg.DELETE_VARIABLE && c.push([
            Blockly.Msg.DELETE_VARIABLE.replace("%1", a),
            Blockly.DELETE_VARIABLE_ID
        ]);
        return c;
    };
    Blockly.FieldVariable.prototype.onItemSelected_ = function(a, b) {
        a = b.getValue();
        if (this.sourceBlock_ && this.sourceBlock_.workspace) {
            if (a == Blockly.RENAME_VARIABLE_ID) {
                Blockly.Variables.renameVariable(this.sourceBlock_.workspace, this.variable_);
                return;
            }
            if (a == Blockly.DELETE_VARIABLE_ID) {
                this.sourceBlock_.workspace.deleteVariableById(this.variable_.getId());
                return;
            }
        }
        this.setValue(a);
    };
    Blockly.FieldVariable.prototype.referencesVariables = function() {
        return !0;
    };
    Blockly.fieldRegistry.register("field_variable", Blockly.FieldVariable);
    Blockly.utils.svgPaths = {};
    Blockly.utils.svgPaths.point = function(a, b) {
        return " " + a + "," + b + " ";
    };
    Blockly.utils.svgPaths.curve = function(a, b) {
        return " " + a + b.join("");
    };
    Blockly.utils.svgPaths.moveTo = function(a, b) {
        return " M " + a + "," + b + " ";
    };
    Blockly.utils.svgPaths.moveBy = function(a, b) {
        return " m " + a + "," + b + " ";
    };
    Blockly.utils.svgPaths.lineTo = function(a, b) {
        return " l " + a + "," + b + " ";
    };
    Blockly.utils.svgPaths.line = function(a) {
        return " l" + a.join("");
    };
    Blockly.utils.svgPaths.lineOnAxis = function(a, b) {
        return " " + a + " " + b + " ";
    };
    Blockly.utils.svgPaths.arc = function(a, b, c, d) {
        return a + " " + c + " " + c + " " + b + d;
    };
    Blockly.blockRendering.ConstantProvider = function() {
        this.NO_PADDING = 0;
        this.SMALL_PADDING = 3;
        this.MEDIUM_PADDING = 5;
        this.MEDIUM_LARGE_PADDING = 8;
        this.LARGE_PADDING = 10;
        this.TALL_INPUT_FIELD_OFFSET_Y = this.MEDIUM_PADDING;
        this.TAB_HEIGHT = 15;
        this.TAB_OFFSET_FROM_TOP = 5;
        this.TAB_VERTICAL_OVERLAP = 2.5;
        this.TAB_WIDTH = 8;
        this.NOTCH_WIDTH = 15;
        this.NOTCH_HEIGHT = 4;
        this.MIN_BLOCK_WIDTH = 12;
        this.EMPTY_BLOCK_SPACER_HEIGHT = 16;
        this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = this.DUMMY_INPUT_MIN_HEIGHT = this.TAB_HEIGHT;
        this.CORNER_RADIUS = 8;
        this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT = 15;
        this.STATEMENT_BOTTOM_SPACER = 0;
        this.STATEMENT_INPUT_PADDING_LEFT = 20;
        this.BETWEEN_STATEMENT_PADDING_Y = 4;
        this.TOP_ROW_MIN_HEIGHT = this.MEDIUM_PADDING;
        this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING;
        this.BOTTOM_ROW_MIN_HEIGHT = this.MEDIUM_PADDING;
        this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING;
        this.ADD_START_HATS = !1;
        this.START_HAT_HEIGHT = 15;
        this.START_HAT_WIDTH = 100;
        this.SPACER_DEFAULT_HEIGHT = 15;
        this.MIN_BLOCK_HEIGHT = 24;
        this.EMPTY_INLINE_INPUT_PADDING = 14.5;
        this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 11;
        this.EXTERNAL_VALUE_INPUT_PADDING = 2;
        this.EMPTY_STATEMENT_INPUT_HEIGHT = this.MIN_BLOCK_HEIGHT;
        this.START_POINT = Blockly.utils.svgPaths.moveBy(0, 0);
        this.JAGGED_TEETH_HEIGHT = 12;
        this.JAGGED_TEETH_WIDTH = 6;
        this.FIELD_TEXT_FONTSIZE = 11;
        this.FIELD_TEXT_FONTWEIGHT = "normal";
        this.FIELD_TEXT_FONTFAMILY = "sans-serif";
        this.FIELD_TEXT_BASELINE = this.FIELD_TEXT_HEIGHT = -1;
        this.FIELD_BORDER_RECT_RADIUS = 4;
        this.FIELD_BORDER_RECT_HEIGHT = 16;
        this.FIELD_BORDER_RECT_X_PADDING = 5;
        this.FIELD_BORDER_RECT_Y_PADDING = 3;
        this.FIELD_BORDER_RECT_COLOUR = "#fff";
        this.FIELD_TEXT_BASELINE_CENTER = !Blockly.utils.userAgent.IE && !Blockly.utils.userAgent.EDGE;
        this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT;
        this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !1;
        this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING;
        this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 12;
        this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MSIgaGVpZ2h0PSI4Ljc5IiB2aWV3Qm94PSIwIDAgMTIuNzEgOC43OSI+PHRpdGxlPmRyb3Bkb3duLWFycm93PC90aXRsZT48ZyBvcGFjaXR5PSIwLjEiPjxwYXRoIGQ9Ik0xMi43MSwyLjQ0QTIuNDEsMi40MSwwLDAsMSwxMiw0LjE2TDguMDgsOC4wOGEyLjQ1LDIuNDUsMCwwLDEtMy40NSwwTDAuNzIsNC4xNkEyLjQyLDIuNDIsMCwwLDEsMCwyLjQ0LDIuNDgsMi40OCwwLDAsMSwuNzEuNzFDMSwwLjQ3LDEuNDMsMCw2LjM2LDBTMTEuNzUsMC40NiwxMiwuNzFBMi40NCwyLjQ0LDAsMCwxLDEyLjcxLDIuNDRaIiBmaWxsPSIjMjMxZjIwIi8+PC9nPjxwYXRoIGQ9Ik02LjM2LDcuNzlhMS40MywxLjQzLDAsMCwxLTEtLjQyTDEuNDIsMy40NWExLjQ0LDEuNDQsMCwwLDEsMC0yYzAuNTYtLjU2LDkuMzEtMC41Niw5Ljg3LDBhMS40NCwxLjQ0LDAsMCwxLDAsMkw3LjM3LDcuMzdBMS40MywxLjQzLDAsMCwxLDYuMzYsNy43OVoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
        this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = !1;
        this.FIELD_COLOUR_DEFAULT_WIDTH = 26;
        this.FIELD_COLOUR_DEFAULT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT;
        this.FIELD_CHECKBOX_X_OFFSET = this.FIELD_BORDER_RECT_X_PADDING - 3;
        this.randomIdentifier = String(Math.random()).substring(2);
        this.embossFilterId = "";
        this.embossFilter_ = null;
        this.disabledPatternId = "";
        this.disabledPattern_ = null;
        this.debugFilterId = "";
        this.cssNode_ = this.debugFilter_ = null;
        this.CURSOR_COLOUR = "#cc0a0a";
        this.MARKER_COLOUR = "#4286f4";
        this.CURSOR_WS_WIDTH = 100;
        this.WS_CURSOR_HEIGHT = 5;
        this.CURSOR_STACK_PADDING = 10;
        this.CURSOR_BLOCK_PADDING = 2;
        this.CURSOR_STROKE_WIDTH = 4;
        this.FULL_BLOCK_FIELDS = !1;
        this.INSERTION_MARKER_COLOUR = "#000000";
        this.INSERTION_MARKER_OPACITY = .2;
        this.SHAPES = {
            PUZZLE: 1,
            NOTCH: 2
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.init = function() {
        this.JAGGED_TEETH = this.makeJaggedTeeth();
        this.NOTCH = this.makeNotch();
        this.START_HAT = this.makeStartHat();
        this.PUZZLE_TAB = this.makePuzzleTab();
        this.INSIDE_CORNERS = this.makeInsideCorners();
        this.OUTSIDE_CORNERS = this.makeOutsideCorners();
    };
    Blockly.blockRendering.ConstantProvider.prototype.setTheme = function(a) {
        this.blockStyles = {};
        var b = a.blockStyles, c;
        for(c in b)this.blockStyles[c] = this.validatedBlockStyle_(b[c]);
        this.setDynamicProperties_(a);
    };
    Blockly.blockRendering.ConstantProvider.prototype.setDynamicProperties_ = function(a) {
        this.setFontConstants_(a);
        this.setComponentConstants_(a);
        this.ADD_START_HATS = null != a.startHats ? a.startHats : this.ADD_START_HATS;
    };
    Blockly.blockRendering.ConstantProvider.prototype.setFontConstants_ = function(a) {
        this.FIELD_TEXT_FONTFAMILY = a.fontStyle && void 0 != a.fontStyle.family ? a.fontStyle.family : this.FIELD_TEXT_FONTFAMILY;
        this.FIELD_TEXT_FONTWEIGHT = a.fontStyle && void 0 != a.fontStyle.weight ? a.fontStyle.weight : this.FIELD_TEXT_FONTWEIGHT;
        this.FIELD_TEXT_FONTSIZE = a.fontStyle && void 0 != a.fontStyle.size ? a.fontStyle.size : this.FIELD_TEXT_FONTSIZE;
        a = Blockly.utils.dom.measureFontMetrics("Hg", this.FIELD_TEXT_FONTSIZE + "pt", this.FIELD_TEXT_FONTWEIGHT, this.FIELD_TEXT_FONTFAMILY);
        this.FIELD_TEXT_HEIGHT = a.height;
        this.FIELD_TEXT_BASELINE = a.baseline;
    };
    Blockly.blockRendering.ConstantProvider.prototype.setComponentConstants_ = function(a) {
        this.CURSOR_COLOUR = a.getComponentStyle("cursorColour") || this.CURSOR_COLOUR;
        this.MARKER_COLOUR = a.getComponentStyle("markerColour") || this.MARKER_COLOUR;
        this.INSERTION_MARKER_COLOUR = a.getComponentStyle("insertionMarkerColour") || this.INSERTION_MARKER_COLOUR;
        this.INSERTION_MARKER_OPACITY = Number(a.getComponentStyle("insertionMarkerOpacity")) || this.INSERTION_MARKER_OPACITY;
    };
    Blockly.blockRendering.ConstantProvider.prototype.getBlockStyleForColour = function(a) {
        var b = "auto_" + a;
        this.blockStyles[b] || (this.blockStyles[b] = this.createBlockStyle_(a));
        return {
            style: this.blockStyles[b],
            name: b
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.getBlockStyle = function(a) {
        return this.blockStyles[a || ""] || (a && 0 == a.indexOf("auto_") ? this.getBlockStyleForColour(a.substring(5)).style : this.createBlockStyle_("#000000"));
    };
    Blockly.blockRendering.ConstantProvider.prototype.createBlockStyle_ = function(a) {
        return this.validatedBlockStyle_({
            colourPrimary: a
        });
    };
    Blockly.blockRendering.ConstantProvider.prototype.validatedBlockStyle_ = function(a) {
        var b = {};
        a && Blockly.utils.object.mixin(b, a);
        a = Blockly.utils.parseBlockColour(b.colourPrimary || "#000");
        b.colourPrimary = a.hex;
        b.colourSecondary = b.colourSecondary ? Blockly.utils.parseBlockColour(b.colourSecondary).hex : this.generateSecondaryColour_(b.colourPrimary);
        b.colourTertiary = b.colourTertiary ? Blockly.utils.parseBlockColour(b.colourTertiary).hex : this.generateTertiaryColour_(b.colourPrimary);
        b.hat = b.hat || "";
        return b;
    };
    Blockly.blockRendering.ConstantProvider.prototype.generateSecondaryColour_ = function(a) {
        return Blockly.utils.colour.blend("#fff", a, .6) || a;
    };
    Blockly.blockRendering.ConstantProvider.prototype.generateTertiaryColour_ = function(a) {
        return Blockly.utils.colour.blend("#fff", a, .3) || a;
    };
    Blockly.blockRendering.ConstantProvider.prototype.dispose = function() {
        this.embossFilter_ && Blockly.utils.dom.removeNode(this.embossFilter_);
        this.disabledPattern_ && Blockly.utils.dom.removeNode(this.disabledPattern_);
        this.debugFilter_ && Blockly.utils.dom.removeNode(this.debugFilter_);
        this.cssNode_ = null;
    };
    Blockly.blockRendering.ConstantProvider.prototype.makeJaggedTeeth = function() {
        var a = this.JAGGED_TEETH_HEIGHT, b = this.JAGGED_TEETH_WIDTH, c = Blockly.utils.svgPaths.line([
            Blockly.utils.svgPaths.point(b, a / 4),
            Blockly.utils.svgPaths.point(2 * -b, a / 2),
            Blockly.utils.svgPaths.point(b, a / 4)
        ]);
        return {
            height: a,
            width: b,
            path: c
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.makeStartHat = function() {
        var a = this.START_HAT_HEIGHT, b = this.START_HAT_WIDTH, c = Blockly.utils.svgPaths.curve("c", [
            Blockly.utils.svgPaths.point(30, -a),
            Blockly.utils.svgPaths.point(70, -a),
            Blockly.utils.svgPaths.point(b, 0)
        ]);
        return {
            height: a,
            width: b,
            path: c
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.makePuzzleTab = function() {
        function a(f) {
            f = f ? -1 : 1;
            var g = -f, h = c / 2, k = h + 2.5, l = h + .5, m = Blockly.utils.svgPaths.point(-b, f * h);
            h = Blockly.utils.svgPaths.point(b, f * h);
            return Blockly.utils.svgPaths.curve("c", [
                Blockly.utils.svgPaths.point(0, f * k),
                Blockly.utils.svgPaths.point(-b, g * l),
                m
            ]) + Blockly.utils.svgPaths.curve("s", [
                Blockly.utils.svgPaths.point(b, 2.5 * g),
                h
            ]);
        }
        var b = this.TAB_WIDTH, c = this.TAB_HEIGHT, d = a(!0), e = a(!1);
        return {
            type: this.SHAPES.PUZZLE,
            width: b,
            height: c,
            pathDown: e,
            pathUp: d
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.makeNotch = function() {
        function a(g) {
            return Blockly.utils.svgPaths.line([
                Blockly.utils.svgPaths.point(g * d, c),
                Blockly.utils.svgPaths.point(3 * g, 0),
                Blockly.utils.svgPaths.point(g * d, -c)
            ]);
        }
        var b = this.NOTCH_WIDTH, c = this.NOTCH_HEIGHT, d = (b - 3) / 2, e = a(1), f = a(-1);
        return {
            type: this.SHAPES.NOTCH,
            width: b,
            height: c,
            pathLeft: e,
            pathRight: f
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.makeInsideCorners = function() {
        var a = this.CORNER_RADIUS, b = Blockly.utils.svgPaths.arc("a", "0 0,0", a, Blockly.utils.svgPaths.point(-a, a)), c = Blockly.utils.svgPaths.arc("a", "0 0,0", a, Blockly.utils.svgPaths.point(a, a));
        return {
            width: a,
            height: a,
            pathTop: b,
            pathBottom: c
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.makeOutsideCorners = function() {
        var a = this.CORNER_RADIUS, b = Blockly.utils.svgPaths.moveBy(0, a) + Blockly.utils.svgPaths.arc("a", "0 0,1", a, Blockly.utils.svgPaths.point(a, -a)), c = Blockly.utils.svgPaths.arc("a", "0 0,1", a, Blockly.utils.svgPaths.point(a, a)), d = Blockly.utils.svgPaths.arc("a", "0 0,1", a, Blockly.utils.svgPaths.point(-a, -a)), e = Blockly.utils.svgPaths.arc("a", "0 0,1", a, Blockly.utils.svgPaths.point(-a, a));
        return {
            topLeft: b,
            topRight: c,
            bottomRight: e,
            bottomLeft: d,
            rightHeight: a
        };
    };
    Blockly.blockRendering.ConstantProvider.prototype.shapeFor = function(a) {
        switch(a.type){
            case Blockly.connectionTypes.INPUT_VALUE:
            case Blockly.connectionTypes.OUTPUT_VALUE:
                return this.PUZZLE_TAB;
            case Blockly.connectionTypes.PREVIOUS_STATEMENT:
            case Blockly.connectionTypes.NEXT_STATEMENT:
                return this.NOTCH;
            default:
                throw Error("Unknown connection type");
        }
    };
    Blockly.blockRendering.ConstantProvider.prototype.createDom = function(a, b, c) {
        this.injectCSS_(b, c);
        a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.DEFS, {}, a);
        b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FILTER, {
            id: "blocklyEmbossFilter" + this.randomIdentifier
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEGAUSSIANBLUR, {
            "in": "SourceAlpha",
            stdDeviation: 1,
            result: "blur"
        }, b);
        c = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FESPECULARLIGHTING, {
            "in": "blur",
            surfaceScale: 1,
            specularConstant: .5,
            specularExponent: 10,
            "lighting-color": "white",
            result: "specOut"
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEPOINTLIGHT, {
            x: -5000,
            y: -10000,
            z: 2E4
        }, c);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPOSITE, {
            "in": "specOut",
            in2: "SourceAlpha",
            operator: "in",
            result: "specOut"
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPOSITE, {
            "in": "SourceGraphic",
            in2: "specOut",
            operator: "arithmetic",
            k1: 0,
            k2: 1,
            k3: 1,
            k4: 0
        }, b);
        this.embossFilterId = b.id;
        this.embossFilter_ = b;
        b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATTERN, {
            id: "blocklyDisabledPattern" + this.randomIdentifier,
            patternUnits: "userSpaceOnUse",
            width: 10,
            height: 10
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: 10,
            height: 10,
            fill: "#aaa"
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            d: "M 0 0 L 10 10 M 10 0 L 0 10",
            stroke: "#cc0"
        }, b);
        this.disabledPatternId = b.id;
        this.disabledPattern_ = b;
        Blockly.blockRendering.Debug && (a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FILTER, {
            id: "blocklyDebugFilter" + this.randomIdentifier,
            height: "160%",
            width: "180%",
            y: "-30%",
            x: "-40%"
        }, a), b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPONENTTRANSFER, {
            result: "outBlur"
        }, a), Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
        }, b), Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEFLOOD, {
            "flood-color": "#ff0000",
            "flood-opacity": .5,
            result: "outColor"
        }, a), Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPOSITE, {
            "in": "outColor",
            in2: "outBlur",
            operator: "in",
            result: "outGlow"
        }, a), this.debugFilterId = a.id, this.debugFilter_ = a);
    };
    Blockly.blockRendering.ConstantProvider.prototype.injectCSS_ = function(a, b) {
        b = this.getCSS_(b);
        a = "blockly-renderer-style-" + a;
        this.cssNode_ = document.getElementById(a);
        var c = b.join("\n");
        this.cssNode_ ? this.cssNode_.firstChild.textContent = c : (b = document.createElement("style"), b.id = a, a = document.createTextNode(c), b.appendChild(a), document.head.insertBefore(b, document.head.firstChild), this.cssNode_ = b);
    };
    Blockly.blockRendering.ConstantProvider.prototype.getCSS_ = function(a) {
        return [
            a + " .blocklyText, ",
            a + " .blocklyFlyoutLabelText {",
            "font: " + this.FIELD_TEXT_FONTWEIGHT + " " + this.FIELD_TEXT_FONTSIZE + "pt " + this.FIELD_TEXT_FONTFAMILY + ";",
            "}",
            a + " .blocklyText {",
            "fill: #fff;",
            "}",
            a + " .blocklyNonEditableText>rect,",
            a + " .blocklyEditableText>rect {",
            "fill: " + this.FIELD_BORDER_RECT_COLOUR + ";",
            "fill-opacity: .6;",
            "stroke: none;",
            "}",
            a + " .blocklyNonEditableText>text,",
            a + " .blocklyEditableText>text {",
            "fill: #000;",
            "}",
            a + " .blocklyFlyoutLabelText {",
            "fill: #000;",
            "}",
            a + " .blocklyText.blocklyBubbleText {",
            "fill: #000;",
            "}",
            a + " .blocklyEditableText:not(.editing):hover>rect {",
            "stroke: #fff;",
            "stroke-width: 2;",
            "}",
            a + " .blocklyHtmlInput {",
            "font-family: " + this.FIELD_TEXT_FONTFAMILY + ";",
            "font-weight: " + this.FIELD_TEXT_FONTWEIGHT + ";",
            "}",
            a + " .blocklySelected>.blocklyPath {",
            "stroke: #fc3;",
            "stroke-width: 3px;",
            "}",
            a + " .blocklyHighlightedConnectionPath {",
            "stroke: #fc3;",
            "}",
            a + " .blocklyReplaceable .blocklyPath {",
            "fill-opacity: .5;",
            "}",
            a + " .blocklyReplaceable .blocklyPathLight,",
            a + " .blocklyReplaceable .blocklyPathDark {",
            "display: none;",
            "}",
            a + " .blocklyInsertionMarker>.blocklyPath {",
            "fill-opacity: " + this.INSERTION_MARKER_OPACITY + ";",
            "stroke: none;",
            "}"
        ];
    };
    Blockly.blockRendering.Types = {
        NONE: 0,
        FIELD: 1,
        HAT: 2,
        ICON: 4,
        SPACER: 8,
        BETWEEN_ROW_SPACER: 16,
        IN_ROW_SPACER: 32,
        EXTERNAL_VALUE_INPUT: 64,
        INPUT: 128,
        INLINE_INPUT: 256,
        STATEMENT_INPUT: 512,
        CONNECTION: 1024,
        PREVIOUS_CONNECTION: 2048,
        NEXT_CONNECTION: 4096,
        OUTPUT_CONNECTION: 8192,
        CORNER: 16384,
        LEFT_SQUARE_CORNER: 32768,
        LEFT_ROUND_CORNER: 65536,
        RIGHT_SQUARE_CORNER: 131072,
        RIGHT_ROUND_CORNER: 262144,
        JAGGED_EDGE: 524288,
        ROW: 1048576,
        TOP_ROW: 2097152,
        BOTTOM_ROW: 4194304,
        INPUT_ROW: 8388608
    };
    Blockly.blockRendering.Types.LEFT_CORNER = Blockly.blockRendering.Types.LEFT_SQUARE_CORNER | Blockly.blockRendering.Types.LEFT_ROUND_CORNER;
    Blockly.blockRendering.Types.RIGHT_CORNER = Blockly.blockRendering.Types.RIGHT_SQUARE_CORNER | Blockly.blockRendering.Types.RIGHT_ROUND_CORNER;
    Blockly.blockRendering.Types.nextTypeValue_ = 16777216;
    Blockly.blockRendering.Types.getType = function(a) {
        Object.prototype.hasOwnProperty.call(Blockly.blockRendering.Types, a) || (Blockly.blockRendering.Types[a] = Blockly.blockRendering.Types.nextTypeValue_, Blockly.blockRendering.Types.nextTypeValue_ <<= 1);
        return Blockly.blockRendering.Types[a];
    };
    Blockly.blockRendering.Types.isField = function(a) {
        return a.type & Blockly.blockRendering.Types.FIELD;
    };
    Blockly.blockRendering.Types.isHat = function(a) {
        return a.type & Blockly.blockRendering.Types.HAT;
    };
    Blockly.blockRendering.Types.isIcon = function(a) {
        return a.type & Blockly.blockRendering.Types.ICON;
    };
    Blockly.blockRendering.Types.isSpacer = function(a) {
        return a.type & Blockly.blockRendering.Types.SPACER;
    };
    Blockly.blockRendering.Types.isInRowSpacer = function(a) {
        return a.type & Blockly.blockRendering.Types.IN_ROW_SPACER;
    };
    Blockly.blockRendering.Types.isInput = function(a) {
        return a.type & Blockly.blockRendering.Types.INPUT;
    };
    Blockly.blockRendering.Types.isExternalInput = function(a) {
        return a.type & Blockly.blockRendering.Types.EXTERNAL_VALUE_INPUT;
    };
    Blockly.blockRendering.Types.isInlineInput = function(a) {
        return a.type & Blockly.blockRendering.Types.INLINE_INPUT;
    };
    Blockly.blockRendering.Types.isStatementInput = function(a) {
        return a.type & Blockly.blockRendering.Types.STATEMENT_INPUT;
    };
    Blockly.blockRendering.Types.isPreviousConnection = function(a) {
        return a.type & Blockly.blockRendering.Types.PREVIOUS_CONNECTION;
    };
    Blockly.blockRendering.Types.isNextConnection = function(a) {
        return a.type & Blockly.blockRendering.Types.NEXT_CONNECTION;
    };
    Blockly.blockRendering.Types.isPreviousOrNextConnection = function(a) {
        return a.type & (Blockly.blockRendering.Types.PREVIOUS_CONNECTION | Blockly.blockRendering.Types.NEXT_CONNECTION);
    };
    Blockly.blockRendering.Types.isLeftRoundedCorner = function(a) {
        return a.type & Blockly.blockRendering.Types.LEFT_ROUND_CORNER;
    };
    Blockly.blockRendering.Types.isRightRoundedCorner = function(a) {
        return a.type & Blockly.blockRendering.Types.RIGHT_ROUND_CORNER;
    };
    Blockly.blockRendering.Types.isLeftSquareCorner = function(a) {
        return a.type & Blockly.blockRendering.Types.LEFT_SQUARE_CORNER;
    };
    Blockly.blockRendering.Types.isRightSquareCorner = function(a) {
        return a.type & Blockly.blockRendering.Types.RIGHT_SQUARE_CORNER;
    };
    Blockly.blockRendering.Types.isCorner = function(a) {
        return a.type & Blockly.blockRendering.Types.CORNER;
    };
    Blockly.blockRendering.Types.isJaggedEdge = function(a) {
        return a.type & Blockly.blockRendering.Types.JAGGED_EDGE;
    };
    Blockly.blockRendering.Types.isRow = function(a) {
        return a.type & Blockly.blockRendering.Types.ROW;
    };
    Blockly.blockRendering.Types.isBetweenRowSpacer = function(a) {
        return a.type & Blockly.blockRendering.Types.BETWEEN_ROW_SPACER;
    };
    Blockly.blockRendering.Types.isTopRow = function(a) {
        return a.type & Blockly.blockRendering.Types.TOP_ROW;
    };
    Blockly.blockRendering.Types.isBottomRow = function(a) {
        return a.type & Blockly.blockRendering.Types.BOTTOM_ROW;
    };
    Blockly.blockRendering.Types.isTopOrBottomRow = function(a) {
        return a.type & (Blockly.blockRendering.Types.TOP_ROW | Blockly.blockRendering.Types.BOTTOM_ROW);
    };
    Blockly.blockRendering.Types.isInputRow = function(a) {
        return a.type & Blockly.blockRendering.Types.INPUT_ROW;
    };
    Blockly.blockRendering.Measurable = function(a) {
        this.height = this.width = 0;
        this.type = Blockly.blockRendering.Types.NONE;
        this.centerline = this.xPos = 0;
        this.constants_ = a;
        this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
    };
    Blockly.blockRendering.Connection = function(a, b) {
        Blockly.blockRendering.Connection.superClass_.constructor.call(this, a);
        this.connectionModel = b;
        this.shape = this.constants_.shapeFor(b);
        this.isDynamicShape = !!this.shape.isDynamic;
        this.type |= Blockly.blockRendering.Types.CONNECTION;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.Connection, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.OutputConnection = function(a, b) {
        Blockly.blockRendering.OutputConnection.superClass_.constructor.call(this, a, b);
        this.type |= Blockly.blockRendering.Types.OUTPUT_CONNECTION;
        this.height = this.isDynamicShape ? 0 : this.shape.height;
        this.startX = this.width = this.isDynamicShape ? 0 : this.shape.width;
        this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP;
        this.connectionOffsetX = 0;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.OutputConnection, Blockly.blockRendering.Connection);
    Blockly.blockRendering.PreviousConnection = function(a, b) {
        Blockly.blockRendering.PreviousConnection.superClass_.constructor.call(this, a, b);
        this.type |= Blockly.blockRendering.Types.PREVIOUS_CONNECTION;
        this.height = this.shape.height;
        this.width = this.shape.width;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.PreviousConnection, Blockly.blockRendering.Connection);
    Blockly.blockRendering.NextConnection = function(a, b) {
        Blockly.blockRendering.NextConnection.superClass_.constructor.call(this, a, b);
        this.type |= Blockly.blockRendering.Types.NEXT_CONNECTION;
        this.height = this.shape.height;
        this.width = this.shape.width;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.NextConnection, Blockly.blockRendering.Connection);
    Blockly.blockRendering.InputConnection = function(a, b) {
        Blockly.blockRendering.InputConnection.superClass_.constructor.call(this, a, b.connection);
        this.type |= Blockly.blockRendering.Types.INPUT;
        this.input = b;
        this.align = b.align;
        (this.connectedBlock = b.connection && b.connection.targetBlock() ? b.connection.targetBlock() : null) ? (a = this.connectedBlock.getHeightWidth(), this.connectedBlockWidth = a.width, this.connectedBlockHeight = a.height) : this.connectedBlockHeight = this.connectedBlockWidth = 0;
        this.connectionOffsetY = this.connectionOffsetX = 0;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.InputConnection, Blockly.blockRendering.Connection);
    Blockly.blockRendering.InlineInput = function(a, b) {
        Blockly.blockRendering.InlineInput.superClass_.constructor.call(this, a, b);
        this.type |= Blockly.blockRendering.Types.INLINE_INPUT;
        this.connectedBlock ? (this.width = this.connectedBlockWidth, this.height = this.connectedBlockHeight) : (this.height = this.constants_.EMPTY_INLINE_INPUT_HEIGHT, this.width = this.constants_.EMPTY_INLINE_INPUT_PADDING);
        this.connectionHeight = this.isDynamicShape ? this.shape.height(this.height) : this.shape.height;
        this.connectionWidth = this.isDynamicShape ? this.shape.width(this.height) : this.shape.width;
        this.connectedBlock || (this.width += this.connectionWidth * (this.isDynamicShape ? 2 : 1));
        this.connectionOffsetY = this.isDynamicShape ? this.shape.connectionOffsetY(this.connectionHeight) : this.constants_.TAB_OFFSET_FROM_TOP;
        this.connectionOffsetX = this.isDynamicShape ? this.shape.connectionOffsetX(this.connectionWidth) : 0;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.InlineInput, Blockly.blockRendering.InputConnection);
    Blockly.blockRendering.StatementInput = function(a, b) {
        Blockly.blockRendering.StatementInput.superClass_.constructor.call(this, a, b);
        this.type |= Blockly.blockRendering.Types.STATEMENT_INPUT;
        this.height = this.connectedBlock ? this.connectedBlockHeight + this.constants_.STATEMENT_BOTTOM_SPACER : this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT;
        this.width = this.constants_.STATEMENT_INPUT_NOTCH_OFFSET + this.shape.width;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.StatementInput, Blockly.blockRendering.InputConnection);
    Blockly.blockRendering.ExternalValueInput = function(a, b) {
        Blockly.blockRendering.ExternalValueInput.superClass_.constructor.call(this, a, b);
        this.type |= Blockly.blockRendering.Types.EXTERNAL_VALUE_INPUT;
        this.height = this.connectedBlock ? this.connectedBlockHeight - this.constants_.TAB_OFFSET_FROM_TOP - this.constants_.MEDIUM_PADDING : this.shape.height;
        this.width = this.shape.width + this.constants_.EXTERNAL_VALUE_INPUT_PADDING;
        this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP;
        this.connectionHeight = this.shape.height;
        this.connectionWidth = this.shape.width;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.ExternalValueInput, Blockly.blockRendering.InputConnection);
    Blockly.blockRendering.Icon = function(a, b) {
        Blockly.blockRendering.Icon.superClass_.constructor.call(this, a);
        this.icon = b;
        this.isVisible = b.isVisible();
        this.type |= Blockly.blockRendering.Types.ICON;
        a = b.getCorrectedSize();
        this.height = a.height;
        this.width = a.width;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.Icon, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.JaggedEdge = function(a) {
        Blockly.blockRendering.JaggedEdge.superClass_.constructor.call(this, a);
        this.type |= Blockly.blockRendering.Types.JAGGED_EDGE;
        this.height = this.constants_.JAGGED_TEETH.height;
        this.width = this.constants_.JAGGED_TEETH.width;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.JaggedEdge, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.Field = function(a, b, c) {
        Blockly.blockRendering.Field.superClass_.constructor.call(this, a);
        this.field = b;
        this.isEditable = b.EDITABLE;
        this.flipRtl = b.getFlipRtl();
        this.type |= Blockly.blockRendering.Types.FIELD;
        a = this.field.getSize();
        this.height = a.height;
        this.width = a.width;
        this.parentInput = c;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.Field, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.Hat = function(a) {
        Blockly.blockRendering.Hat.superClass_.constructor.call(this, a);
        this.type |= Blockly.blockRendering.Types.HAT;
        this.height = this.constants_.START_HAT.height;
        this.width = this.constants_.START_HAT.width;
        this.ascenderHeight = this.height;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.Hat, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.SquareCorner = function(a, b) {
        Blockly.blockRendering.SquareCorner.superClass_.constructor.call(this, a);
        this.type = (b && "left" != b ? Blockly.blockRendering.Types.RIGHT_SQUARE_CORNER : Blockly.blockRendering.Types.LEFT_SQUARE_CORNER) | Blockly.blockRendering.Types.CORNER;
        this.width = this.height = this.constants_.NO_PADDING;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.SquareCorner, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.RoundCorner = function(a, b) {
        Blockly.blockRendering.RoundCorner.superClass_.constructor.call(this, a);
        this.type = (b && "left" != b ? Blockly.blockRendering.Types.RIGHT_ROUND_CORNER : Blockly.blockRendering.Types.LEFT_ROUND_CORNER) | Blockly.blockRendering.Types.CORNER;
        this.width = this.constants_.CORNER_RADIUS;
        this.height = this.constants_.CORNER_RADIUS / 2;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.RoundCorner, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.InRowSpacer = function(a, b) {
        Blockly.blockRendering.InRowSpacer.superClass_.constructor.call(this, a);
        this.type = this.type | Blockly.blockRendering.Types.SPACER | Blockly.blockRendering.Types.IN_ROW_SPACER;
        this.width = b;
        this.height = this.constants_.SPACER_DEFAULT_HEIGHT;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.InRowSpacer, Blockly.blockRendering.Measurable);
    Blockly.blockRendering.Row = function(a) {
        this.type = Blockly.blockRendering.Types.ROW;
        this.elements = [];
        this.xPos = this.yPos = this.widthWithConnectedBlocks = this.minWidth = this.minHeight = this.width = this.height = 0;
        this.hasJaggedEdge = this.hasDummyInput = this.hasInlineInput = this.hasStatement = this.hasExternalInput = !1;
        this.constants_ = a;
        this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        this.align = null;
    };
    Blockly.blockRendering.Row.prototype.measure = function() {
        throw Error("Unexpected attempt to measure a base Row.");
    };
    Blockly.blockRendering.Row.prototype.getLastInput = function() {
        for(var a = this.elements.length - 1, b; b = this.elements[a]; a--)if (Blockly.blockRendering.Types.isInput(b)) return b;
        return null;
    };
    Blockly.blockRendering.Row.prototype.startsWithElemSpacer = function() {
        return !0;
    };
    Blockly.blockRendering.Row.prototype.endsWithElemSpacer = function() {
        return !0;
    };
    Blockly.blockRendering.Row.prototype.getFirstSpacer = function() {
        for(var a = 0, b; b = this.elements[a]; a++)if (Blockly.blockRendering.Types.isSpacer(b)) return b;
        return null;
    };
    Blockly.blockRendering.Row.prototype.getLastSpacer = function() {
        for(var a = this.elements.length - 1, b; b = this.elements[a]; a--)if (Blockly.blockRendering.Types.isSpacer(b)) return b;
        return null;
    };
    Blockly.blockRendering.TopRow = function(a) {
        Blockly.blockRendering.TopRow.superClass_.constructor.call(this, a);
        this.type |= Blockly.blockRendering.Types.TOP_ROW;
        this.ascenderHeight = this.capline = 0;
        this.hasPreviousConnection = !1;
        this.connection = null;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.TopRow, Blockly.blockRendering.Row);
    Blockly.blockRendering.TopRow.prototype.hasLeftSquareCorner = function(a) {
        var b = (a.hat ? "cap" === a.hat : this.constants_.ADD_START_HATS) && !a.outputConnection && !a.previousConnection, c = a.getPreviousBlock();
        return !!a.outputConnection || b || (c ? c.getNextBlock() == a : !1);
    };
    Blockly.blockRendering.TopRow.prototype.hasRightSquareCorner = function(a) {
        return !0;
    };
    Blockly.blockRendering.TopRow.prototype.measure = function() {
        for(var a = 0, b = 0, c = 0, d = 0, e; e = this.elements[d]; d++)b += e.width, Blockly.blockRendering.Types.isSpacer(e) || (Blockly.blockRendering.Types.isHat(e) ? c = Math.max(c, e.ascenderHeight) : a = Math.max(a, e.height));
        this.width = Math.max(this.minWidth, b);
        this.height = Math.max(this.minHeight, a) + c;
        this.capline = this.ascenderHeight = c;
        this.widthWithConnectedBlocks = this.width;
    };
    Blockly.blockRendering.TopRow.prototype.startsWithElemSpacer = function() {
        return !1;
    };
    Blockly.blockRendering.TopRow.prototype.endsWithElemSpacer = function() {
        return !1;
    };
    Blockly.blockRendering.BottomRow = function(a) {
        Blockly.blockRendering.BottomRow.superClass_.constructor.call(this, a);
        this.type |= Blockly.blockRendering.Types.BOTTOM_ROW;
        this.hasNextConnection = !1;
        this.connection = null;
        this.baseline = this.descenderHeight = 0;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.BottomRow, Blockly.blockRendering.Row);
    Blockly.blockRendering.BottomRow.prototype.hasLeftSquareCorner = function(a) {
        return !!a.outputConnection || !!a.getNextBlock();
    };
    Blockly.blockRendering.BottomRow.prototype.hasRightSquareCorner = function(a) {
        return !0;
    };
    Blockly.blockRendering.BottomRow.prototype.measure = function() {
        for(var a = 0, b = 0, c = 0, d = 0, e; e = this.elements[d]; d++)b += e.width, Blockly.blockRendering.Types.isSpacer(e) || (Blockly.blockRendering.Types.isNextConnection(e) ? c = Math.max(c, e.height) : a = Math.max(a, e.height));
        this.width = Math.max(this.minWidth, b);
        this.height = Math.max(this.minHeight, a) + c;
        this.descenderHeight = c;
        this.widthWithConnectedBlocks = this.width;
    };
    Blockly.blockRendering.BottomRow.prototype.startsWithElemSpacer = function() {
        return !1;
    };
    Blockly.blockRendering.BottomRow.prototype.endsWithElemSpacer = function() {
        return !1;
    };
    Blockly.blockRendering.SpacerRow = function(a, b, c) {
        Blockly.blockRendering.SpacerRow.superClass_.constructor.call(this, a);
        this.type = this.type | Blockly.blockRendering.Types.SPACER | Blockly.blockRendering.Types.BETWEEN_ROW_SPACER;
        this.width = c;
        this.height = b;
        this.followsStatement = !1;
        this.widthWithConnectedBlocks = 0;
        this.elements = [
            new Blockly.blockRendering.InRowSpacer(this.constants_, c)
        ];
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.SpacerRow, Blockly.blockRendering.Row);
    Blockly.blockRendering.SpacerRow.prototype.measure = function() {};
    Blockly.blockRendering.InputRow = function(a) {
        Blockly.blockRendering.InputRow.superClass_.constructor.call(this, a);
        this.type |= Blockly.blockRendering.Types.INPUT_ROW;
        this.connectedBlockWidths = 0;
    };
    Blockly.utils.object.inherits(Blockly.blockRendering.InputRow, Blockly.blockRendering.Row);
    Blockly.blockRendering.InputRow.prototype.measure = function() {
        this.width = this.minWidth;
        this.height = this.minHeight;
        for(var a = 0, b = 0, c; c = this.elements[b]; b++)this.width += c.width, Blockly.blockRendering.Types.isInput(c) && (Blockly.blockRendering.Types.isStatementInput(c) ? a += c.connectedBlockWidth : Blockly.blockRendering.Types.isExternalInput(c) && 0 != c.connectedBlockWidth && (a += c.connectedBlockWidth - c.connectionWidth)), Blockly.blockRendering.Types.isSpacer(c) || (this.height = Math.max(this.height, c.height));
        this.connectedBlockWidths = a;
        this.widthWithConnectedBlocks = this.width + a;
    };
    Blockly.blockRendering.InputRow.prototype.endsWithElemSpacer = function() {
        return !this.hasExternalInput && !this.hasStatement;
    };
    Blockly.blockRendering.RenderInfo = function(a, b) {
        this.block_ = b;
        this.renderer_ = a;
        this.constants_ = this.renderer_.getConstants();
        this.outputConnection = b.outputConnection ? new Blockly.blockRendering.OutputConnection(this.constants_, b.outputConnection) : null;
        this.isInline = b.getInputsInline() && !b.isCollapsed();
        this.isCollapsed = b.isCollapsed();
        this.isInsertionMarker = b.isInsertionMarker();
        this.RTL = b.RTL;
        this.statementEdge = this.width = this.widthWithChildren = this.height = 0;
        this.rows = [];
        this.inputRows = [];
        this.hiddenIcons = [];
        this.topRow = new Blockly.blockRendering.TopRow(this.constants_);
        this.bottomRow = new Blockly.blockRendering.BottomRow(this.constants_);
        this.startY = this.startX = 0;
    };
    Blockly.blockRendering.RenderInfo.prototype.getRenderer = function() {
        return this.renderer_;
    };
    Blockly.blockRendering.RenderInfo.prototype.measure = function() {
        this.createRows_();
        this.addElemSpacing_();
        this.addRowSpacing_();
        this.computeBounds_();
        this.alignRowElements_();
        this.finalize_();
    };
    Blockly.blockRendering.RenderInfo.prototype.createRows_ = function() {
        this.populateTopRow_();
        this.rows.push(this.topRow);
        var a = new Blockly.blockRendering.InputRow(this.constants_);
        this.inputRows.push(a);
        var b = this.block_.getIcons();
        if (b.length) for(var c = 0, d; d = b[c]; c++){
            var e = new Blockly.blockRendering.Icon(this.constants_, d);
            this.isCollapsed && d.collapseHidden ? this.hiddenIcons.push(e) : a.elements.push(e);
        }
        d = null;
        for(c = 0; b = this.block_.inputList[c]; c++)if (b.isVisible()) {
            this.shouldStartNewRow_(b, d) && (this.rows.push(a), a = new Blockly.blockRendering.InputRow(this.constants_), this.inputRows.push(a));
            for(d = 0; e = b.fieldRow[d]; d++)a.elements.push(new Blockly.blockRendering.Field(this.constants_, e, b));
            this.addInput_(b, a);
            d = b;
        }
        this.isCollapsed && (a.hasJaggedEdge = !0, a.elements.push(new Blockly.blockRendering.JaggedEdge(this.constants_)));
        (a.elements.length || a.hasDummyInput) && this.rows.push(a);
        this.populateBottomRow_();
        this.rows.push(this.bottomRow);
    };
    Blockly.blockRendering.RenderInfo.prototype.populateTopRow_ = function() {
        var a = !!this.block_.previousConnection, b = (this.block_.hat ? "cap" === this.block_.hat : this.constants_.ADD_START_HATS) && !this.outputConnection && !a;
        this.topRow.hasLeftSquareCorner(this.block_) ? this.topRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_)) : this.topRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_));
        b ? (a = new Blockly.blockRendering.Hat(this.constants_), this.topRow.elements.push(a), this.topRow.capline = a.ascenderHeight) : a && (this.topRow.hasPreviousConnection = !0, this.topRow.connection = new Blockly.blockRendering.PreviousConnection(this.constants_, this.block_.previousConnection), this.topRow.elements.push(this.topRow.connection));
        this.block_.inputList.length && this.block_.inputList[0].type == Blockly.inputTypes.STATEMENT && !this.block_.isCollapsed() ? this.topRow.minHeight = this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT : this.topRow.minHeight = this.constants_.TOP_ROW_MIN_HEIGHT;
        this.topRow.hasRightSquareCorner(this.block_) ? this.topRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_, "right")) : this.topRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_, "right"));
    };
    Blockly.blockRendering.RenderInfo.prototype.populateBottomRow_ = function() {
        this.bottomRow.hasNextConnection = !!this.block_.nextConnection;
        this.bottomRow.minHeight = this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1].type == Blockly.inputTypes.STATEMENT ? this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT : this.constants_.BOTTOM_ROW_MIN_HEIGHT;
        this.bottomRow.hasLeftSquareCorner(this.block_) ? this.bottomRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_)) : this.bottomRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_));
        this.bottomRow.hasNextConnection && (this.bottomRow.connection = new Blockly.blockRendering.NextConnection(this.constants_, this.block_.nextConnection), this.bottomRow.elements.push(this.bottomRow.connection));
        this.bottomRow.hasRightSquareCorner(this.block_) ? this.bottomRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_, "right")) : this.bottomRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_, "right"));
    };
    Blockly.blockRendering.RenderInfo.prototype.addInput_ = function(a, b) {
        this.isInline && a.type == Blockly.inputTypes.VALUE ? (b.elements.push(new Blockly.blockRendering.InlineInput(this.constants_, a)), b.hasInlineInput = !0) : a.type == Blockly.inputTypes.STATEMENT ? (b.elements.push(new Blockly.blockRendering.StatementInput(this.constants_, a)), b.hasStatement = !0) : a.type == Blockly.inputTypes.VALUE ? (b.elements.push(new Blockly.blockRendering.ExternalValueInput(this.constants_, a)), b.hasExternalInput = !0) : a.type == Blockly.inputTypes.DUMMY && (b.minHeight = Math.max(b.minHeight, a.getSourceBlock() && a.getSourceBlock().isShadow() ? this.constants_.DUMMY_INPUT_SHADOW_MIN_HEIGHT : this.constants_.DUMMY_INPUT_MIN_HEIGHT), b.hasDummyInput = !0);
        null == b.align && (b.align = a.align);
    };
    Blockly.blockRendering.RenderInfo.prototype.shouldStartNewRow_ = function(a, b) {
        return b ? a.type == Blockly.inputTypes.STATEMENT || b.type == Blockly.inputTypes.STATEMENT ? !0 : a.type == Blockly.inputTypes.VALUE || a.type == Blockly.inputTypes.DUMMY ? !this.isInline : !1 : !1;
    };
    Blockly.blockRendering.RenderInfo.prototype.addElemSpacing_ = function() {
        for(var a = 0, b; b = this.rows[a]; a++){
            var c = b.elements;
            b.elements = [];
            b.startsWithElemSpacer() && b.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, this.getInRowSpacing_(null, c[0])));
            if (c.length) {
                for(var d = 0; d < c.length - 1; d++){
                    b.elements.push(c[d]);
                    var e = this.getInRowSpacing_(c[d], c[d + 1]);
                    b.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, e));
                }
                b.elements.push(c[c.length - 1]);
                b.endsWithElemSpacer() && b.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, this.getInRowSpacing_(c[c.length - 1], null)));
            }
        }
    };
    Blockly.blockRendering.RenderInfo.prototype.getInRowSpacing_ = function(a, b) {
        if (!a && b && Blockly.blockRendering.Types.isStatementInput(b)) return this.constants_.STATEMENT_INPUT_PADDING_LEFT;
        if (a && Blockly.blockRendering.Types.isInput(a) && !b) {
            if (Blockly.blockRendering.Types.isExternalInput(a)) return this.constants_.NO_PADDING;
            if (Blockly.blockRendering.Types.isInlineInput(a)) return this.constants_.LARGE_PADDING;
            if (Blockly.blockRendering.Types.isStatementInput(a)) return this.constants_.NO_PADDING;
        }
        return a && Blockly.blockRendering.Types.isLeftSquareCorner(a) && b && (Blockly.blockRendering.Types.isPreviousConnection(b) || Blockly.blockRendering.Types.isNextConnection(b)) ? b.notchOffset : a && Blockly.blockRendering.Types.isLeftRoundedCorner(a) && b && (Blockly.blockRendering.Types.isPreviousConnection(b) || Blockly.blockRendering.Types.isNextConnection(b)) ? b.notchOffset - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
    };
    Blockly.blockRendering.RenderInfo.prototype.computeBounds_ = function() {
        for(var a = 0, b = 0, c = 0, d = 0, e; e = this.rows[d]; d++){
            e.measure();
            b = Math.max(b, e.width);
            if (e.hasStatement) {
                var f = e.getLastInput();
                a = Math.max(a, e.width - f.width);
            }
            c = Math.max(c, e.widthWithConnectedBlocks);
        }
        this.statementEdge = a;
        this.width = b;
        for(d = 0; e = this.rows[d]; d++)e.hasStatement && (e.statementEdge = this.statementEdge);
        this.widthWithChildren = Math.max(b, c);
        this.outputConnection && (this.startX = this.outputConnection.width, this.width += this.outputConnection.width, this.widthWithChildren += this.outputConnection.width);
    };
    Blockly.blockRendering.RenderInfo.prototype.alignRowElements_ = function() {
        for(var a = 0, b; b = this.rows[a]; a++)if (b.hasStatement) this.alignStatementRow_(b);
        else {
            var c = b.width;
            c = this.getDesiredRowWidth_(b) - c;
            0 < c && this.addAlignmentPadding_(b, c);
            Blockly.blockRendering.Types.isTopOrBottomRow(b) && (b.widthWithConnectedBlocks = b.width);
        }
    };
    Blockly.blockRendering.RenderInfo.prototype.getDesiredRowWidth_ = function(a) {
        return this.width - this.startX;
    };
    Blockly.blockRendering.RenderInfo.prototype.addAlignmentPadding_ = function(a, b) {
        var c = a.getFirstSpacer(), d = a.getLastSpacer();
        if (a.hasExternalInput || a.hasStatement) a.widthWithConnectedBlocks += b;
        a.align == Blockly.constants.ALIGN.LEFT ? d.width += b : a.align == Blockly.constants.ALIGN.CENTRE ? (c.width += b / 2, d.width += b / 2) : a.align == Blockly.constants.ALIGN.RIGHT ? c.width += b : d.width += b;
        a.width += b;
    };
    Blockly.blockRendering.RenderInfo.prototype.alignStatementRow_ = function(a) {
        var b = a.getLastInput(), c = a.width - b.width, d = this.statementEdge;
        c = d - c;
        0 < c && this.addAlignmentPadding_(a, c);
        c = a.width;
        d = this.getDesiredRowWidth_(a);
        b.width += d - c;
        b.height = Math.max(b.height, a.height);
        a.width += d - c;
        a.widthWithConnectedBlocks = Math.max(a.width, this.statementEdge + a.connectedBlockWidths);
    };
    Blockly.blockRendering.RenderInfo.prototype.addRowSpacing_ = function() {
        var a = this.rows;
        this.rows = [];
        for(var b = 0; b < a.length; b++)this.rows.push(a[b]), b != a.length - 1 && this.rows.push(this.makeSpacerRow_(a[b], a[b + 1]));
    };
    Blockly.blockRendering.RenderInfo.prototype.makeSpacerRow_ = function(a, b) {
        var c = this.getSpacerRowHeight_(a, b), d = this.getSpacerRowWidth_(a, b);
        c = new Blockly.blockRendering.SpacerRow(this.constants_, c, d);
        a.hasStatement && (c.followsStatement = !0);
        b.hasStatement && (c.precedesStatement = !0);
        return c;
    };
    Blockly.blockRendering.RenderInfo.prototype.getSpacerRowWidth_ = function(a, b) {
        return this.width - this.startX;
    };
    Blockly.blockRendering.RenderInfo.prototype.getSpacerRowHeight_ = function(a, b) {
        return this.constants_.MEDIUM_PADDING;
    };
    Blockly.blockRendering.RenderInfo.prototype.getElemCenterline_ = function(a, b) {
        return Blockly.blockRendering.Types.isSpacer(b) ? a.yPos + b.height / 2 : Blockly.blockRendering.Types.isBottomRow(a) ? (a = a.yPos + a.height - a.descenderHeight, Blockly.blockRendering.Types.isNextConnection(b) ? a + b.height / 2 : a - b.height / 2) : Blockly.blockRendering.Types.isTopRow(a) ? Blockly.blockRendering.Types.isHat(b) ? a.capline - b.height / 2 : a.capline + b.height / 2 : a.yPos + a.height / 2;
    };
    Blockly.blockRendering.RenderInfo.prototype.recordElemPositions_ = function(a) {
        for(var b = a.xPos, c = 0, d; d = a.elements[c]; c++)Blockly.blockRendering.Types.isSpacer(d) && (d.height = a.height), d.xPos = b, d.centerline = this.getElemCenterline_(a, d), b += d.width;
    };
    Blockly.blockRendering.RenderInfo.prototype.finalize_ = function() {
        for(var a = 0, b = 0, c = 0, d; d = this.rows[c]; c++)d.yPos = b, d.xPos = this.startX, b += d.height, a = Math.max(a, d.widthWithConnectedBlocks), this.recordElemPositions_(d);
        this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (a = Math.max(a, this.block_.nextConnection.targetBlock().getHeightWidth().width));
        this.widthWithChildren = a + this.startX;
        this.height = b;
        this.startY = this.topRow.capline;
        this.bottomRow.baseline = b - this.bottomRow.descenderHeight;
    };
    Blockly.blockRendering.Debug = function(a) {
        this.debugElements_ = [];
        this.svgRoot_ = null;
        this.constants_ = a;
    };
    Blockly.blockRendering.Debug.config = {
        rowSpacers: !0,
        elemSpacers: !0,
        rows: !0,
        elems: !0,
        connections: !0,
        blockBounds: !0,
        connectedBlockBounds: !0,
        render: !0
    };
    Blockly.blockRendering.Debug.prototype.clearElems = function() {
        for(var a = 0, b; b = this.debugElements_[a]; a++)Blockly.utils.dom.removeNode(b);
        this.debugElements_ = [];
    };
    Blockly.blockRendering.Debug.prototype.drawSpacerRow = function(a, b, c) {
        if (Blockly.blockRendering.Debug.config.rowSpacers) {
            var d = Math.abs(a.height), e = 0 > a.height;
            e && (b -= d);
            this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
                "class": "rowSpacerRect blockRenderDebug",
                x: c ? -(a.xPos + a.width) : a.xPos,
                y: b,
                width: a.width,
                height: d,
                stroke: e ? "black" : "blue",
                fill: "blue",
                "fill-opacity": "0.5",
                "stroke-width": "1px"
            }, this.svgRoot_));
        }
    };
    Blockly.blockRendering.Debug.prototype.drawSpacerElem = function(a, b, c) {
        if (Blockly.blockRendering.Debug.config.elemSpacers) {
            b = Math.abs(a.width);
            var d = 0 > a.width, e = d ? a.xPos - b : a.xPos;
            c && (e = -(e + b));
            this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
                "class": "elemSpacerRect blockRenderDebug",
                x: e,
                y: a.centerline - a.height / 2,
                width: b,
                height: a.height,
                stroke: "pink",
                fill: d ? "black" : "pink",
                "fill-opacity": "0.5",
                "stroke-width": "1px"
            }, this.svgRoot_));
        }
    };
    Blockly.blockRendering.Debug.prototype.drawRenderedElem = function(a, b) {
        if (Blockly.blockRendering.Debug.config.elems) {
            var c = a.xPos;
            b && (c = -(c + a.width));
            b = a.centerline - a.height / 2;
            this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
                "class": "rowRenderingRect blockRenderDebug",
                x: c,
                y: b,
                width: a.width,
                height: a.height,
                stroke: "black",
                fill: "none",
                "stroke-width": "1px"
            }, this.svgRoot_));
            Blockly.blockRendering.Types.isField(a) && a.field instanceof Blockly.FieldLabel && this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
                "class": "rowRenderingRect blockRenderDebug",
                x: c,
                y: b + this.constants_.FIELD_TEXT_BASELINE,
                width: a.width,
                height: "0.1px",
                stroke: "red",
                fill: "none",
                "stroke-width": "0.5px"
            }, this.svgRoot_));
        }
        Blockly.blockRendering.Types.isInput(a) && Blockly.blockRendering.Debug.config.connections && this.drawConnection(a.connectionModel);
    };
    Blockly.blockRendering.Debug.prototype.drawConnection = function(a) {
        if (Blockly.blockRendering.Debug.config.connections) {
            if (a.type == Blockly.connectionTypes.INPUT_VALUE) {
                var b = 4;
                var c = "magenta";
                var d = "none";
            } else a.type == Blockly.connectionTypes.OUTPUT_VALUE ? (b = 2, d = c = "magenta") : a.type == Blockly.connectionTypes.NEXT_STATEMENT ? (b = 4, c = "goldenrod", d = "none") : a.type == Blockly.connectionTypes.PREVIOUS_STATEMENT && (b = 2, d = c = "goldenrod");
            this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CIRCLE, {
                "class": "blockRenderDebug",
                cx: a.offsetInBlock_.x,
                cy: a.offsetInBlock_.y,
                r: b,
                fill: d,
                stroke: c
            }, this.svgRoot_));
        }
    };
    Blockly.blockRendering.Debug.prototype.drawRenderedRow = function(a, b, c) {
        Blockly.blockRendering.Debug.config.rows && (this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "elemRenderingRect blockRenderDebug",
            x: c ? -(a.xPos + a.width) : a.xPos,
            y: a.yPos,
            width: a.width,
            height: a.height,
            stroke: "red",
            fill: "none",
            "stroke-width": "1px"
        }, this.svgRoot_)), Blockly.blockRendering.Types.isTopOrBottomRow(a) || Blockly.blockRendering.Debug.config.connectedBlockBounds && this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "connectedBlockWidth blockRenderDebug",
            x: c ? -(a.xPos + a.widthWithConnectedBlocks) : a.xPos,
            y: a.yPos,
            width: a.widthWithConnectedBlocks,
            height: a.height,
            stroke: this.randomColour_,
            fill: "none",
            "stroke-width": "1px",
            "stroke-dasharray": "3,3"
        }, this.svgRoot_)));
    };
    Blockly.blockRendering.Debug.prototype.drawRowWithElements = function(a, b, c) {
        for(var d = 0, e = a.elements.length; d < e; d++){
            var f = a.elements[d];
            f ? Blockly.blockRendering.Types.isSpacer(f) ? this.drawSpacerElem(f, a.height, c) : this.drawRenderedElem(f, c) : console.warn("A row has an undefined or null element.", a, f);
        }
        this.drawRenderedRow(a, b, c);
    };
    Blockly.blockRendering.Debug.prototype.drawBoundingBox = function(a) {
        if (Blockly.blockRendering.Debug.config.blockBounds) {
            var b = a.RTL ? -a.width : 0;
            this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
                "class": "blockBoundingBox blockRenderDebug",
                x: b,
                y: 0,
                width: a.width,
                height: a.height,
                stroke: "black",
                fill: "none",
                "stroke-width": "1px",
                "stroke-dasharray": "5,5"
            }, this.svgRoot_));
            Blockly.blockRendering.Debug.config.connectedBlockBounds && (b = a.RTL ? -a.widthWithChildren : 0, this.debugElements_.push(Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
                "class": "blockRenderDebug",
                x: b,
                y: 0,
                width: a.widthWithChildren,
                height: a.height,
                stroke: "#DF57BC",
                fill: "none",
                "stroke-width": "1px",
                "stroke-dasharray": "3,3"
            }, this.svgRoot_)));
        }
    };
    Blockly.blockRendering.Debug.prototype.drawDebug = function(a, b) {
        this.clearElems();
        this.svgRoot_ = a.getSvgRoot();
        this.randomColour_ = "#" + Math.floor(16777215 * Math.random()).toString(16);
        for(var c = 0, d = 0, e; e = b.rows[d]; d++)Blockly.blockRendering.Types.isBetweenRowSpacer(e) ? this.drawSpacerRow(e, c, b.RTL) : this.drawRowWithElements(e, c, b.RTL), c += e.height;
        a.previousConnection && this.drawConnection(a.previousConnection);
        a.nextConnection && this.drawConnection(a.nextConnection);
        a.outputConnection && this.drawConnection(a.outputConnection);
        b.rightSide && this.drawRenderedElem(b.rightSide, b.RTL);
        this.drawBoundingBox(b);
        this.drawRender(a.pathObject.svgPath);
    };
    Blockly.blockRendering.Debug.prototype.drawRender = function(a) {
        Blockly.blockRendering.Debug.config.render && (a.setAttribute("filter", "url(#" + this.constants_.debugFilterId + ")"), setTimeout(function() {
            a.setAttribute("filter", "");
        }, 100));
    };
    Blockly.blockRendering.Drawer = function(a, b) {
        this.block_ = a;
        this.info_ = b;
        this.topLeft_ = a.getRelativeToSurfaceXY();
        this.inlinePath_ = this.outlinePath_ = "";
        this.constants_ = b.getRenderer().getConstants();
    };
    Blockly.blockRendering.Drawer.prototype.draw = function() {
        this.hideHiddenIcons_();
        this.drawOutline_();
        this.drawInternals_();
        this.block_.pathObject.setPath(this.outlinePath_ + "\n" + this.inlinePath_);
        this.info_.RTL && this.block_.pathObject.flipRTL();
        Blockly.blockRendering.useDebugger && this.block_.renderingDebugger.drawDebug(this.block_, this.info_);
        this.recordSizeOnBlock_();
    };
    Blockly.blockRendering.Drawer.prototype.recordSizeOnBlock_ = function() {
        this.block_.height = this.info_.height;
        this.block_.width = this.info_.widthWithChildren;
    };
    Blockly.blockRendering.Drawer.prototype.hideHiddenIcons_ = function() {
        for(var a = 0, b; b = this.info_.hiddenIcons[a]; a++)b.icon.iconGroup_.setAttribute("display", "none");
    };
    Blockly.blockRendering.Drawer.prototype.drawOutline_ = function() {
        this.drawTop_();
        for(var a = 1; a < this.info_.rows.length - 1; a++){
            var b = this.info_.rows[a];
            b.hasJaggedEdge ? this.drawJaggedEdge_(b) : b.hasStatement ? this.drawStatementInput_(b) : b.hasExternalInput ? this.drawValueInput_(b) : this.drawRightSideRow_(b);
        }
        this.drawBottom_();
        this.drawLeft_();
    };
    Blockly.blockRendering.Drawer.prototype.drawTop_ = function() {
        var a = this.info_.topRow, b = a.elements;
        this.positionPreviousConnection_();
        this.outlinePath_ += Blockly.utils.svgPaths.moveBy(a.xPos, this.info_.startY);
        for(var c = 0, d; d = b[c]; c++)Blockly.blockRendering.Types.isLeftRoundedCorner(d) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topLeft : Blockly.blockRendering.Types.isRightRoundedCorner(d) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topRight : Blockly.blockRendering.Types.isPreviousConnection(d) ? this.outlinePath_ += d.shape.pathLeft : Blockly.blockRendering.Types.isHat(d) ? this.outlinePath_ += this.constants_.START_HAT.path : Blockly.blockRendering.Types.isSpacer(d) && (this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("h", d.width));
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("v", a.height);
    };
    Blockly.blockRendering.Drawer.prototype.drawJaggedEdge_ = function(a) {
        this.outlinePath_ += this.constants_.JAGGED_TEETH.path + Blockly.utils.svgPaths.lineOnAxis("v", a.height - this.constants_.JAGGED_TEETH.height);
    };
    Blockly.blockRendering.Drawer.prototype.drawValueInput_ = function(a) {
        var b = a.getLastInput();
        this.positionExternalValueConnection_(a);
        var c = "function" == typeof b.shape.pathDown ? b.shape.pathDown(b.height) : b.shape.pathDown;
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("H", b.xPos + b.width) + c + Blockly.utils.svgPaths.lineOnAxis("v", a.height - b.connectionHeight);
    };
    Blockly.blockRendering.Drawer.prototype.drawStatementInput_ = function(a) {
        var b = a.getLastInput(), c = b.xPos + b.notchOffset + b.shape.width;
        b = b.shape.pathRight + Blockly.utils.svgPaths.lineOnAxis("h", -(b.notchOffset - this.constants_.INSIDE_CORNERS.width)) + this.constants_.INSIDE_CORNERS.pathTop;
        var d = a.height - 2 * this.constants_.INSIDE_CORNERS.height;
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("H", c) + b + Blockly.utils.svgPaths.lineOnAxis("v", d) + this.constants_.INSIDE_CORNERS.pathBottom + Blockly.utils.svgPaths.lineOnAxis("H", a.xPos + a.width);
        this.positionStatementInputConnection_(a);
    };
    Blockly.blockRendering.Drawer.prototype.drawRightSideRow_ = function(a) {
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("V", a.yPos + a.height);
    };
    Blockly.blockRendering.Drawer.prototype.drawBottom_ = function() {
        var a = this.info_.bottomRow, b = a.elements;
        this.positionNextConnection_();
        for(var c = 0, d = "", e = b.length - 1, f; f = b[e]; e--)Blockly.blockRendering.Types.isNextConnection(f) ? d += f.shape.pathRight : Blockly.blockRendering.Types.isLeftSquareCorner(f) ? d += Blockly.utils.svgPaths.lineOnAxis("H", a.xPos) : Blockly.blockRendering.Types.isLeftRoundedCorner(f) ? d += this.constants_.OUTSIDE_CORNERS.bottomLeft : Blockly.blockRendering.Types.isRightRoundedCorner(f) ? (d += this.constants_.OUTSIDE_CORNERS.bottomRight, c = this.constants_.OUTSIDE_CORNERS.rightHeight) : Blockly.blockRendering.Types.isSpacer(f) && (d += Blockly.utils.svgPaths.lineOnAxis("h", -1 * f.width));
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("V", a.baseline - c);
        this.outlinePath_ += d;
    };
    Blockly.blockRendering.Drawer.prototype.drawLeft_ = function() {
        var a = this.info_.outputConnection;
        this.positionOutputConnection_();
        if (a) {
            var b = a.connectionOffsetY + a.height;
            a = "function" == typeof a.shape.pathUp ? a.shape.pathUp(a.height) : a.shape.pathUp;
            this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("V", b) + a;
        }
        this.outlinePath_ += "z";
    };
    Blockly.blockRendering.Drawer.prototype.drawInternals_ = function() {
        for(var a = 0, b; b = this.info_.rows[a]; a++)for(var c = 0, d; d = b.elements[c]; c++)Blockly.blockRendering.Types.isInlineInput(d) ? this.drawInlineInput_(d) : (Blockly.blockRendering.Types.isIcon(d) || Blockly.blockRendering.Types.isField(d)) && this.layoutField_(d);
    };
    Blockly.blockRendering.Drawer.prototype.layoutField_ = function(a) {
        if (Blockly.blockRendering.Types.isField(a)) var b = a.field.getSvgRoot();
        else Blockly.blockRendering.Types.isIcon(a) && (b = a.icon.iconGroup_);
        var c = a.centerline - a.height / 2, d = a.xPos, e = "";
        this.info_.RTL && (d = -(d + a.width), a.flipRtl && (d += a.width, e = "scale(-1 1)"));
        Blockly.blockRendering.Types.isIcon(a) ? (b.setAttribute("display", "block"), b.setAttribute("transform", "translate(" + d + "," + c + ")"), a.icon.computeIconLocation()) : b.setAttribute("transform", "translate(" + d + "," + c + ")" + e);
        this.info_.isInsertionMarker && b.setAttribute("display", "none");
    };
    Blockly.blockRendering.Drawer.prototype.drawInlineInput_ = function(a) {
        var b = a.width, c = a.height, d = a.connectionOffsetY, e = a.connectionHeight + d;
        this.inlinePath_ += Blockly.utils.svgPaths.moveTo(a.xPos + a.connectionWidth, a.centerline - c / 2) + Blockly.utils.svgPaths.lineOnAxis("v", d) + a.shape.pathDown + Blockly.utils.svgPaths.lineOnAxis("v", c - e) + Blockly.utils.svgPaths.lineOnAxis("h", b - a.connectionWidth) + Blockly.utils.svgPaths.lineOnAxis("v", -c) + "z";
        this.positionInlineInputConnection_(a);
    };
    Blockly.blockRendering.Drawer.prototype.positionInlineInputConnection_ = function(a) {
        var b = a.centerline - a.height / 2;
        if (a.connectionModel) {
            var c = a.xPos + a.connectionWidth + a.connectionOffsetX;
            this.info_.RTL && (c *= -1);
            a.connectionModel.setOffsetInBlock(c, b + a.connectionOffsetY);
        }
    };
    Blockly.blockRendering.Drawer.prototype.positionStatementInputConnection_ = function(a) {
        var b = a.getLastInput();
        if (b.connectionModel) {
            var c = a.xPos + a.statementEdge + b.notchOffset;
            this.info_.RTL && (c *= -1);
            b.connectionModel.setOffsetInBlock(c, a.yPos);
        }
    };
    Blockly.blockRendering.Drawer.prototype.positionExternalValueConnection_ = function(a) {
        var b = a.getLastInput();
        if (b.connectionModel) {
            var c = a.xPos + a.width;
            this.info_.RTL && (c *= -1);
            b.connectionModel.setOffsetInBlock(c, a.yPos);
        }
    };
    Blockly.blockRendering.Drawer.prototype.positionPreviousConnection_ = function() {
        var a = this.info_.topRow;
        if (a.connection) {
            var b = a.xPos + a.notchOffset;
            a.connection.connectionModel.setOffsetInBlock(this.info_.RTL ? -b : b, 0);
        }
    };
    Blockly.blockRendering.Drawer.prototype.positionNextConnection_ = function() {
        var a = this.info_.bottomRow;
        if (a.connection) {
            var b = a.connection, c = b.xPos;
            b.connectionModel.setOffsetInBlock(this.info_.RTL ? -c : c, a.baseline);
        }
    };
    Blockly.blockRendering.Drawer.prototype.positionOutputConnection_ = function() {
        if (this.info_.outputConnection) {
            var a = this.info_.startX + this.info_.outputConnection.connectionOffsetX;
            this.block_.outputConnection.setOffsetInBlock(this.info_.RTL ? -a : a, this.info_.outputConnection.connectionOffsetY);
        }
    };
    Blockly.Events.MarkerMove = function(a, b, c, d) {
        var e = a ? a.workspace.id : void 0;
        d && d.getType() == Blockly.ASTNode.types.WORKSPACE && (e = d.getLocation().id);
        Blockly.Events.MarkerMove.superClass_.constructor.call(this, e);
        this.blockId = a ? a.id : null;
        this.oldNode = c;
        this.newNode = d;
        this.isCursor = b;
    };
    Blockly.utils.object.inherits(Blockly.Events.MarkerMove, Blockly.Events.UiBase);
    Blockly.Events.MarkerMove.prototype.type = Blockly.Events.MARKER_MOVE;
    Blockly.Events.MarkerMove.prototype.toJson = function() {
        var a = Blockly.Events.MarkerMove.superClass_.toJson.call(this);
        a.isCursor = this.isCursor;
        a.blockId = this.blockId;
        a.oldNode = this.oldNode;
        a.newNode = this.newNode;
        return a;
    };
    Blockly.Events.MarkerMove.prototype.fromJson = function(a) {
        Blockly.Events.MarkerMove.superClass_.fromJson.call(this, a);
        this.isCursor = a.isCursor;
        this.blockId = a.blockId;
        this.oldNode = a.oldNode;
        this.newNode = a.newNode;
    };
    Blockly.registry.register(Blockly.registry.Type.EVENT, Blockly.Events.MARKER_MOVE, Blockly.Events.MarkerMove);
    Blockly.blockRendering.MarkerSvg = function(a, b, c) {
        this.workspace_ = a;
        this.marker_ = c;
        this.parent_ = null;
        this.constants_ = b;
        this.currentMarkerSvg = null;
        a = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR;
        this.colour_ = c.colour || a;
    };
    Blockly.blockRendering.MarkerSvg.CURSOR_CLASS = "blocklyCursor";
    Blockly.blockRendering.MarkerSvg.MARKER_CLASS = "blocklyMarker";
    Blockly.blockRendering.MarkerSvg.HEIGHT_MULTIPLIER = .75;
    Blockly.blockRendering.MarkerSvg.prototype.getSvgRoot = function() {
        return this.svgGroup_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.getMarker = function() {
        return this.marker_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.isCursor = function() {
        return "cursor" == this.marker_.type;
    };
    Blockly.blockRendering.MarkerSvg.prototype.createDom = function() {
        var a = this.isCursor() ? Blockly.blockRendering.MarkerSvg.CURSOR_CLASS : Blockly.blockRendering.MarkerSvg.MARKER_CLASS;
        this.svgGroup_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            "class": a
        }, null);
        this.createDomInternal_();
        return this.svgGroup_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.setParent_ = function(a) {
        this.isCursor() ? (this.parent_ && this.parent_.setCursorSvg(null), a.setCursorSvg(this.getSvgRoot())) : (this.parent_ && this.parent_.setMarkerSvg(null), a.setMarkerSvg(this.getSvgRoot()));
        this.parent_ = a;
    };
    Blockly.blockRendering.MarkerSvg.prototype.draw = function(a, b) {
        if (b) {
            this.constants_ = this.workspace_.getRenderer().getConstants();
            var c = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR;
            this.colour_ = this.marker_.colour || c;
            this.applyColour_(b);
            this.showAtLocation_(b);
            this.fireMarkerEvent_(a, b);
            a = this.currentMarkerSvg.childNodes[0];
            void 0 !== a && a.beginElement && a.beginElement();
        } else this.hide();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showAtLocation_ = function(a) {
        var b = a.getLocation().type;
        a.getType() == Blockly.ASTNode.types.BLOCK ? this.showWithBlock_(a) : a.getType() == Blockly.ASTNode.types.OUTPUT ? this.showWithOutput_(a) : b == Blockly.connectionTypes.INPUT_VALUE ? this.showWithInput_(a) : b == Blockly.connectionTypes.NEXT_STATEMENT ? this.showWithNext_(a) : a.getType() == Blockly.ASTNode.types.PREVIOUS ? this.showWithPrevious_(a) : a.getType() == Blockly.ASTNode.types.FIELD ? this.showWithField_(a) : a.getType() == Blockly.ASTNode.types.WORKSPACE ? this.showWithCoordinates_(a) : a.getType() == Blockly.ASTNode.types.STACK && this.showWithStack_(a);
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithBlockPrevOutput_ = function(a) {
        a = a.getSourceBlock();
        var b = a.width, c = a.height, d = c * Blockly.blockRendering.MarkerSvg.HEIGHT_MULTIPLIER, e = this.constants_.CURSOR_BLOCK_PADDING;
        if (a.previousConnection) {
            var f = this.constants_.shapeFor(a.previousConnection);
            this.positionPrevious_(b, e, d, f);
        } else a.outputConnection ? (f = this.constants_.shapeFor(a.outputConnection), this.positionOutput_(b, c, f)) : this.positionBlock_(b, e, d);
        this.setParent_(a);
        this.showCurrent_();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithBlock_ = function(a) {
        this.showWithBlockPrevOutput_(a);
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithPrevious_ = function(a) {
        this.showWithBlockPrevOutput_(a);
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithOutput_ = function(a) {
        this.showWithBlockPrevOutput_(a);
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithCoordinates_ = function(a) {
        var b = a.getWsCoordinate();
        a = b.x;
        b = b.y;
        this.workspace_.RTL && (a -= this.constants_.CURSOR_WS_WIDTH);
        this.positionLine_(a, b, this.constants_.CURSOR_WS_WIDTH);
        this.setParent_(this.workspace_);
        this.showCurrent_();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithField_ = function(a) {
        a = a.getLocation();
        var b = a.getSize().width, c = a.getSize().height;
        this.positionRect_(0, 0, b, c);
        this.setParent_(a);
        this.showCurrent_();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithInput_ = function(a) {
        a = a.getLocation();
        var b = a.getSourceBlock();
        this.positionInput_(a);
        this.setParent_(b);
        this.showCurrent_();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithNext_ = function(a) {
        var b = a.getLocation();
        a = b.getSourceBlock();
        var c = 0;
        b = b.getOffsetInBlock().y;
        var d = a.getHeightWidth().width;
        this.workspace_.RTL && (c = -d);
        this.positionLine_(c, b, d);
        this.setParent_(a);
        this.showCurrent_();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showWithStack_ = function(a) {
        a = a.getLocation();
        var b = a.getHeightWidth(), c = b.width + this.constants_.CURSOR_STACK_PADDING;
        b = b.height + this.constants_.CURSOR_STACK_PADDING;
        var d = -this.constants_.CURSOR_STACK_PADDING / 2, e = -this.constants_.CURSOR_STACK_PADDING / 2, f = d;
        this.workspace_.RTL && (f = -(c + d));
        this.positionRect_(f, e, c, b);
        this.setParent_(a);
        this.showCurrent_();
    };
    Blockly.blockRendering.MarkerSvg.prototype.showCurrent_ = function() {
        this.hide();
        this.currentMarkerSvg.style.display = "";
    };
    Blockly.blockRendering.MarkerSvg.prototype.positionBlock_ = function(a, b, c) {
        a = Blockly.utils.svgPaths.moveBy(-b, c) + Blockly.utils.svgPaths.lineOnAxis("V", -b) + Blockly.utils.svgPaths.lineOnAxis("H", a + 2 * b) + Blockly.utils.svgPaths.lineOnAxis("V", c);
        this.markerBlock_.setAttribute("d", a);
        this.workspace_.RTL && this.flipRtl_(this.markerBlock_);
        this.currentMarkerSvg = this.markerBlock_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.positionInput_ = function(a) {
        var b = a.getOffsetInBlock().x, c = a.getOffsetInBlock().y;
        a = Blockly.utils.svgPaths.moveTo(0, 0) + this.constants_.shapeFor(a).pathDown;
        this.markerInput_.setAttribute("d", a);
        this.markerInput_.setAttribute("transform", "translate(" + b + "," + c + ")" + (this.workspace_.RTL ? " scale(-1 1)" : ""));
        this.currentMarkerSvg = this.markerInput_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.positionLine_ = function(a, b, c) {
        this.markerSvgLine_.setAttribute("x", a);
        this.markerSvgLine_.setAttribute("y", b);
        this.markerSvgLine_.setAttribute("width", c);
        this.currentMarkerSvg = this.markerSvgLine_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.positionOutput_ = function(a, b, c) {
        a = Blockly.utils.svgPaths.moveBy(a, 0) + Blockly.utils.svgPaths.lineOnAxis("h", -(a - c.width)) + Blockly.utils.svgPaths.lineOnAxis("v", this.constants_.TAB_OFFSET_FROM_TOP) + c.pathDown + Blockly.utils.svgPaths.lineOnAxis("V", b) + Blockly.utils.svgPaths.lineOnAxis("H", a);
        this.markerBlock_.setAttribute("d", a);
        this.workspace_.RTL && this.flipRtl_(this.markerBlock_);
        this.currentMarkerSvg = this.markerBlock_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.positionPrevious_ = function(a, b, c, d) {
        a = Blockly.utils.svgPaths.moveBy(-b, c) + Blockly.utils.svgPaths.lineOnAxis("V", -b) + Blockly.utils.svgPaths.lineOnAxis("H", this.constants_.NOTCH_OFFSET_LEFT) + d.pathLeft + Blockly.utils.svgPaths.lineOnAxis("H", a + 2 * b) + Blockly.utils.svgPaths.lineOnAxis("V", c);
        this.markerBlock_.setAttribute("d", a);
        this.workspace_.RTL && this.flipRtl_(this.markerBlock_);
        this.currentMarkerSvg = this.markerBlock_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.positionRect_ = function(a, b, c, d) {
        this.markerSvgRect_.setAttribute("x", a);
        this.markerSvgRect_.setAttribute("y", b);
        this.markerSvgRect_.setAttribute("width", c);
        this.markerSvgRect_.setAttribute("height", d);
        this.currentMarkerSvg = this.markerSvgRect_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.flipRtl_ = function(a) {
        a.setAttribute("transform", "scale(-1 1)");
    };
    Blockly.blockRendering.MarkerSvg.prototype.hide = function() {
        this.markerSvgLine_.style.display = "none";
        this.markerSvgRect_.style.display = "none";
        this.markerInput_.style.display = "none";
        this.markerBlock_.style.display = "none";
    };
    Blockly.blockRendering.MarkerSvg.prototype.fireMarkerEvent_ = function(a, b) {
        var c = b.getSourceBlock();
        a = new (Blockly.Events.get(Blockly.Events.MARKER_MOVE))(c, this.isCursor(), a, b);
        Blockly.Events.fire(a);
    };
    Blockly.blockRendering.MarkerSvg.prototype.getBlinkProperties_ = function() {
        return {
            attributeType: "XML",
            attributeName: "fill",
            dur: "1s",
            values: this.colour_ + ";transparent;transparent;",
            repeatCount: "indefinite"
        };
    };
    Blockly.blockRendering.MarkerSvg.prototype.createDomInternal_ = function() {
        this.markerSvg_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.G, {
            width: this.constants_.CURSOR_WS_WIDTH,
            height: this.constants_.WS_CURSOR_HEIGHT
        }, this.svgGroup_);
        this.markerSvgLine_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            width: this.constants_.CURSOR_WS_WIDTH,
            height: this.constants_.WS_CURSOR_HEIGHT,
            style: "display: none"
        }, this.markerSvg_);
        this.markerSvgRect_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.RECT, {
            "class": "blocklyVerticalMarker",
            rx: 10,
            ry: 10,
            style: "display: none"
        }, this.markerSvg_);
        this.markerInput_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            transform: "",
            style: "display: none"
        }, this.markerSvg_);
        this.markerBlock_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            transform: "",
            style: "display: none",
            fill: "none",
            "stroke-width": this.constants_.CURSOR_STROKE_WIDTH
        }, this.markerSvg_);
        if (this.isCursor()) {
            var a = this.getBlinkProperties_();
            Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.ANIMATE, a, this.markerSvgLine_);
            Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.ANIMATE, a, this.markerInput_);
            a.attributeName = "stroke";
            Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.ANIMATE, a, this.markerBlock_);
        }
        return this.markerSvg_;
    };
    Blockly.blockRendering.MarkerSvg.prototype.applyColour_ = function(a) {
        this.markerSvgLine_.setAttribute("fill", this.colour_);
        this.markerSvgRect_.setAttribute("stroke", this.colour_);
        this.markerInput_.setAttribute("fill", this.colour_);
        this.markerBlock_.setAttribute("stroke", this.colour_);
        this.isCursor() && (a = this.colour_ + ";transparent;transparent;", this.markerSvgLine_.firstChild.setAttribute("values", a), this.markerInput_.firstChild.setAttribute("values", a), this.markerBlock_.firstChild.setAttribute("values", a));
    };
    Blockly.blockRendering.MarkerSvg.prototype.dispose = function() {
        this.svgGroup_ && Blockly.utils.dom.removeNode(this.svgGroup_);
    };
    Blockly.blockRendering.PathObject = function(a, b, c) {
        this.constants = c;
        this.svgRoot = a;
        this.svgPath = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyPath"
        }, this.svgRoot);
        this.style = b;
        this.markerSvg = this.cursorSvg = null;
    };
    Blockly.blockRendering.PathObject.prototype.setPath = function(a) {
        this.svgPath.setAttribute("d", a);
    };
    Blockly.blockRendering.PathObject.prototype.flipRTL = function() {
        this.svgPath.setAttribute("transform", "scale(-1 1)");
    };
    Blockly.blockRendering.PathObject.prototype.setCursorSvg = function(a) {
        a ? (this.svgRoot.appendChild(a), this.cursorSvg = a) : this.cursorSvg = null;
    };
    Blockly.blockRendering.PathObject.prototype.setMarkerSvg = function(a) {
        a ? (this.cursorSvg ? this.svgRoot.insertBefore(a, this.cursorSvg) : this.svgRoot.appendChild(a), this.markerSvg = a) : this.markerSvg = null;
    };
    Blockly.blockRendering.PathObject.prototype.applyColour = function(a) {
        this.svgPath.setAttribute("stroke", this.style.colourTertiary);
        this.svgPath.setAttribute("fill", this.style.colourPrimary);
        this.updateShadow_(a.isShadow());
        this.updateDisabled_(!a.isEnabled() || a.getInheritedDisabled());
    };
    Blockly.blockRendering.PathObject.prototype.setStyle = function(a) {
        this.style = a;
    };
    Blockly.blockRendering.PathObject.prototype.setClass_ = function(a, b) {
        b ? Blockly.utils.dom.addClass(this.svgRoot, a) : Blockly.utils.dom.removeClass(this.svgRoot, a);
    };
    Blockly.blockRendering.PathObject.prototype.updateHighlighted = function(a) {
        a ? this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")") : this.svgPath.setAttribute("filter", "none");
    };
    Blockly.blockRendering.PathObject.prototype.updateShadow_ = function(a) {
        a && (this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary));
    };
    Blockly.blockRendering.PathObject.prototype.updateDisabled_ = function(a) {
        this.setClass_("blocklyDisabled", a);
        a && this.svgPath.setAttribute("fill", "url(#" + this.constants.disabledPatternId + ")");
    };
    Blockly.blockRendering.PathObject.prototype.updateSelected = function(a) {
        this.setClass_("blocklySelected", a);
    };
    Blockly.blockRendering.PathObject.prototype.updateDraggingDelete = function(a) {
        this.setClass_("blocklyDraggingDelete", a);
    };
    Blockly.blockRendering.PathObject.prototype.updateInsertionMarker = function(a) {
        this.setClass_("blocklyInsertionMarker", a);
    };
    Blockly.blockRendering.PathObject.prototype.updateMovable = function(a) {
        this.setClass_("blocklyDraggable", a);
    };
    Blockly.blockRendering.PathObject.prototype.updateReplacementFade = function(a) {
        this.setClass_("blocklyReplaceable", a);
    };
    Blockly.blockRendering.PathObject.prototype.updateShapeForInputHighlight = function(a, b) {};
    Blockly.IRegistrable = function() {};
    Blockly.blockRendering.Renderer = function(a) {
        this.name = a;
        this.overrides = this.constants_ = null;
    };
    Blockly.blockRendering.Renderer.prototype.getClassName = function() {
        return this.name + "-renderer";
    };
    Blockly.blockRendering.Renderer.prototype.init = function(a, b) {
        this.constants_ = this.makeConstants_();
        b && (this.overrides = b, Blockly.utils.object.mixin(this.constants_, b));
        this.constants_.setTheme(a);
        this.constants_.init();
    };
    Blockly.blockRendering.Renderer.prototype.createDom = function(a, b) {
        this.constants_.createDom(a, this.name + "-" + b.name, "." + this.getClassName() + "." + b.getClassName());
    };
    Blockly.blockRendering.Renderer.prototype.refreshDom = function(a, b) {
        var c = this.getConstants();
        c.dispose();
        this.constants_ = this.makeConstants_();
        this.overrides && Blockly.utils.object.mixin(this.constants_, this.overrides);
        this.constants_.randomIdentifier = c.randomIdentifier;
        this.constants_.setTheme(b);
        this.constants_.init();
        this.createDom(a, b);
    };
    Blockly.blockRendering.Renderer.prototype.dispose = function() {
        this.constants_ && this.constants_.dispose();
    };
    Blockly.blockRendering.Renderer.prototype.makeConstants_ = function() {
        return new Blockly.blockRendering.ConstantProvider;
    };
    Blockly.blockRendering.Renderer.prototype.makeRenderInfo_ = function(a) {
        return new Blockly.blockRendering.RenderInfo(this, a);
    };
    Blockly.blockRendering.Renderer.prototype.makeDrawer_ = function(a, b) {
        return new Blockly.blockRendering.Drawer(a, b);
    };
    Blockly.blockRendering.Renderer.prototype.makeDebugger_ = function() {
        if (!Blockly.blockRendering.Debug) throw Error("Missing require for Blockly.blockRendering.Debug");
        return new Blockly.blockRendering.Debug(this.getConstants());
    };
    Blockly.blockRendering.Renderer.prototype.makeMarkerDrawer = function(a, b) {
        return new Blockly.blockRendering.MarkerSvg(a, this.getConstants(), b);
    };
    Blockly.blockRendering.Renderer.prototype.makePathObject = function(a, b) {
        return new Blockly.blockRendering.PathObject(a, b, this.constants_);
    };
    Blockly.blockRendering.Renderer.prototype.getConstants = function() {
        return this.constants_;
    };
    Blockly.blockRendering.Renderer.prototype.shouldHighlightConnection = function(a) {
        return !0;
    };
    Blockly.blockRendering.Renderer.prototype.orphanCanConnectAtEnd = function(a, b, c) {
        c == Blockly.connectionTypes.OUTPUT_VALUE ? (c = b.outputConnection, a = Blockly.Connection.lastConnectionInRow(a, b)) : (c = b.previousConnection, a = a.lastConnectionInStack());
        return a ? c.getConnectionChecker().canConnect(a, c, !1) : !1;
    };
    Blockly.blockRendering.Renderer.prototype.getConnectionPreviewMethod = function(a, b, c) {
        return b.type == Blockly.connectionTypes.OUTPUT_VALUE || b.type == Blockly.connectionTypes.PREVIOUS_STATEMENT ? !a.isConnected() || this.orphanCanConnectAtEnd(c, a.targetBlock(), b.type) ? Blockly.InsertionMarkerManager.PREVIEW_TYPE.INSERTION_MARKER : Blockly.InsertionMarkerManager.PREVIEW_TYPE.REPLACEMENT_FADE : Blockly.InsertionMarkerManager.PREVIEW_TYPE.INSERTION_MARKER;
    };
    Blockly.blockRendering.Renderer.prototype.render = function(a) {
        Blockly.blockRendering.useDebugger && !a.renderingDebugger && (a.renderingDebugger = this.makeDebugger_());
        var b = this.makeRenderInfo_(a);
        b.measure();
        this.makeDrawer_(a, b).draw();
    };
    Blockly.geras = {};
    Blockly.geras.ConstantProvider = function() {
        Blockly.geras.ConstantProvider.superClass_.constructor.call(this);
        this.FIELD_TEXT_BASELINE_CENTER = !1;
        this.DARK_PATH_OFFSET = 1;
        this.MAX_BOTTOM_WIDTH = 30;
        this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT / 2;
    };
    Blockly.utils.object.inherits(Blockly.geras.ConstantProvider, Blockly.blockRendering.ConstantProvider);
    Blockly.geras.ConstantProvider.prototype.getCSS_ = function(a) {
        return Blockly.geras.ConstantProvider.superClass_.getCSS_.call(this, a).concat([
            a + " .blocklyInsertionMarker>.blocklyPathLight,",
            a + " .blocklyInsertionMarker>.blocklyPathDark {",
            "fill-opacity: " + this.INSERTION_MARKER_OPACITY + ";",
            "stroke: none;",
            "}"
        ]);
    };
    Blockly.geras.Highlighter = function(a) {
        this.info_ = a;
        this.inlineSteps_ = this.steps_ = "";
        this.RTL_ = this.info_.RTL;
        a = a.getRenderer();
        this.constants_ = a.getConstants();
        this.highlightConstants_ = a.getHighlightConstants();
        this.highlightOffset_ = this.highlightConstants_.OFFSET;
        this.outsideCornerPaths_ = this.highlightConstants_.OUTSIDE_CORNER;
        this.insideCornerPaths_ = this.highlightConstants_.INSIDE_CORNER;
        this.puzzleTabPaths_ = this.highlightConstants_.PUZZLE_TAB;
        this.notchPaths_ = this.highlightConstants_.NOTCH;
        this.startPaths_ = this.highlightConstants_.START_HAT;
        this.jaggedTeethPaths_ = this.highlightConstants_.JAGGED_TEETH;
    };
    Blockly.geras.Highlighter.prototype.getPath = function() {
        return this.steps_ + "\n" + this.inlineSteps_;
    };
    Blockly.geras.Highlighter.prototype.drawTopCorner = function(a) {
        this.steps_ += Blockly.utils.svgPaths.moveBy(a.xPos, this.info_.startY);
        for(var b = 0, c; c = a.elements[b]; b++)Blockly.blockRendering.Types.isLeftSquareCorner(c) ? this.steps_ += this.highlightConstants_.START_POINT : Blockly.blockRendering.Types.isLeftRoundedCorner(c) ? this.steps_ += this.outsideCornerPaths_.topLeft(this.RTL_) : Blockly.blockRendering.Types.isPreviousConnection(c) ? this.steps_ += this.notchPaths_.pathLeft : Blockly.blockRendering.Types.isHat(c) ? this.steps_ += this.startPaths_.path(this.RTL_) : Blockly.blockRendering.Types.isSpacer(c) && 0 != c.width && (this.steps_ += Blockly.utils.svgPaths.lineOnAxis("H", c.xPos + c.width - this.highlightOffset_));
        this.steps_ += Blockly.utils.svgPaths.lineOnAxis("H", a.xPos + a.width - this.highlightOffset_);
    };
    Blockly.geras.Highlighter.prototype.drawJaggedEdge_ = function(a) {
        this.info_.RTL && (this.steps_ += this.jaggedTeethPaths_.pathLeft + Blockly.utils.svgPaths.lineOnAxis("v", a.height - this.jaggedTeethPaths_.height - this.highlightOffset_));
    };
    Blockly.geras.Highlighter.prototype.drawValueInput = function(a) {
        var b = a.getLastInput();
        if (this.RTL_) {
            var c = a.height - b.connectionHeight;
            this.steps_ += Blockly.utils.svgPaths.moveTo(b.xPos + b.width - this.highlightOffset_, a.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_) + Blockly.utils.svgPaths.lineOnAxis("v", c);
        } else this.steps_ += Blockly.utils.svgPaths.moveTo(b.xPos + b.width, a.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_);
    };
    Blockly.geras.Highlighter.prototype.drawStatementInput = function(a) {
        var b = a.getLastInput();
        if (this.RTL_) {
            var c = a.height - 2 * this.insideCornerPaths_.height;
            this.steps_ += Blockly.utils.svgPaths.moveTo(b.xPos, a.yPos) + this.insideCornerPaths_.pathTop(this.RTL_) + Blockly.utils.svgPaths.lineOnAxis("v", c) + this.insideCornerPaths_.pathBottom(this.RTL_) + Blockly.utils.svgPaths.lineTo(a.width - b.xPos - this.insideCornerPaths_.width, 0);
        } else this.steps_ += Blockly.utils.svgPaths.moveTo(b.xPos, a.yPos + a.height) + this.insideCornerPaths_.pathBottom(this.RTL_) + Blockly.utils.svgPaths.lineTo(a.width - b.xPos - this.insideCornerPaths_.width, 0);
    };
    Blockly.geras.Highlighter.prototype.drawRightSideRow = function(a) {
        var b = a.xPos + a.width - this.highlightOffset_;
        a.followsStatement && (this.steps_ += Blockly.utils.svgPaths.lineOnAxis("H", b));
        this.RTL_ && (this.steps_ += Blockly.utils.svgPaths.lineOnAxis("H", b), a.height > this.highlightOffset_ && (this.steps_ += Blockly.utils.svgPaths.lineOnAxis("V", a.yPos + a.height - this.highlightOffset_)));
    };
    Blockly.geras.Highlighter.prototype.drawBottomRow = function(a) {
        if (this.RTL_) this.steps_ += Blockly.utils.svgPaths.lineOnAxis("V", a.baseline - this.highlightOffset_);
        else {
            var b = this.info_.bottomRow.elements[0];
            Blockly.blockRendering.Types.isLeftSquareCorner(b) ? this.steps_ += Blockly.utils.svgPaths.moveTo(a.xPos + this.highlightOffset_, a.baseline - this.highlightOffset_) : Blockly.blockRendering.Types.isLeftRoundedCorner(b) && (this.steps_ += Blockly.utils.svgPaths.moveTo(a.xPos, a.baseline), this.steps_ += this.outsideCornerPaths_.bottomLeft());
        }
    };
    Blockly.geras.Highlighter.prototype.drawLeft = function() {
        var a = this.info_.outputConnection;
        a && (a = a.connectionOffsetY + a.height, this.RTL_ ? this.steps_ += Blockly.utils.svgPaths.moveTo(this.info_.startX, a) : (this.steps_ += Blockly.utils.svgPaths.moveTo(this.info_.startX + this.highlightOffset_, this.info_.bottomRow.baseline - this.highlightOffset_), this.steps_ += Blockly.utils.svgPaths.lineOnAxis("V", a)), this.steps_ += this.puzzleTabPaths_.pathUp(this.RTL_));
        this.RTL_ || (a = this.info_.topRow, Blockly.blockRendering.Types.isLeftRoundedCorner(a.elements[0]) ? this.steps_ += Blockly.utils.svgPaths.lineOnAxis("V", this.outsideCornerPaths_.height) : this.steps_ += Blockly.utils.svgPaths.lineOnAxis("V", a.capline + this.highlightOffset_));
    };
    Blockly.geras.Highlighter.prototype.drawInlineInput = function(a) {
        var b = this.highlightOffset_, c = a.xPos + a.connectionWidth, d = a.centerline - a.height / 2, e = a.width - a.connectionWidth, f = d + b;
        this.RTL_ ? (d = a.connectionOffsetY - b, a = a.height - (a.connectionOffsetY + a.connectionHeight) + b, this.inlineSteps_ += Blockly.utils.svgPaths.moveTo(c - b, f) + Blockly.utils.svgPaths.lineOnAxis("v", d) + this.puzzleTabPaths_.pathDown(this.RTL_) + Blockly.utils.svgPaths.lineOnAxis("v", a) + Blockly.utils.svgPaths.lineOnAxis("h", e)) : this.inlineSteps_ += Blockly.utils.svgPaths.moveTo(a.xPos + a.width + b, f) + Blockly.utils.svgPaths.lineOnAxis("v", a.height) + Blockly.utils.svgPaths.lineOnAxis("h", -e) + Blockly.utils.svgPaths.moveTo(c, d + a.connectionOffsetY) + this.puzzleTabPaths_.pathDown(this.RTL_);
    };
    Blockly.geras.InlineInput = function(a, b) {
        Blockly.geras.InlineInput.superClass_.constructor.call(this, a, b);
        this.connectedBlock && (this.width += this.constants_.DARK_PATH_OFFSET, this.height += this.constants_.DARK_PATH_OFFSET);
    };
    Blockly.utils.object.inherits(Blockly.geras.InlineInput, Blockly.blockRendering.InlineInput);
    Blockly.geras.StatementInput = function(a, b) {
        Blockly.geras.StatementInput.superClass_.constructor.call(this, a, b);
        this.connectedBlock && (this.height += this.constants_.DARK_PATH_OFFSET);
    };
    Blockly.utils.object.inherits(Blockly.geras.StatementInput, Blockly.blockRendering.StatementInput);
    Blockly.geras.RenderInfo = function(a, b) {
        Blockly.geras.RenderInfo.superClass_.constructor.call(this, a, b);
    };
    Blockly.utils.object.inherits(Blockly.geras.RenderInfo, Blockly.blockRendering.RenderInfo);
    Blockly.geras.RenderInfo.prototype.getRenderer = function() {
        return this.renderer_;
    };
    Blockly.geras.RenderInfo.prototype.populateBottomRow_ = function() {
        Blockly.geras.RenderInfo.superClass_.populateBottomRow_.call(this);
        this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1].type == Blockly.inputTypes.STATEMENT || (this.bottomRow.minHeight = this.constants_.MEDIUM_PADDING - this.constants_.DARK_PATH_OFFSET);
    };
    Blockly.geras.RenderInfo.prototype.addInput_ = function(a, b) {
        this.isInline && a.type == Blockly.inputTypes.VALUE ? (b.elements.push(new Blockly.geras.InlineInput(this.constants_, a)), b.hasInlineInput = !0) : a.type == Blockly.inputTypes.STATEMENT ? (b.elements.push(new Blockly.geras.StatementInput(this.constants_, a)), b.hasStatement = !0) : a.type == Blockly.inputTypes.VALUE ? (b.elements.push(new Blockly.blockRendering.ExternalValueInput(this.constants_, a)), b.hasExternalInput = !0) : a.type == Blockly.inputTypes.DUMMY && (b.minHeight = Math.max(b.minHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT), b.hasDummyInput = !0);
        this.isInline || null != b.align || (b.align = a.align);
    };
    Blockly.geras.RenderInfo.prototype.addElemSpacing_ = function() {
        for(var a = !1, b = 0, c; c = this.rows[b]; b++)c.hasExternalInput && (a = !0);
        for(b = 0; c = this.rows[b]; b++){
            var d = c.elements;
            c.elements = [];
            c.startsWithElemSpacer() && c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, this.getInRowSpacing_(null, d[0])));
            if (d.length) {
                for(var e = 0; e < d.length - 1; e++){
                    c.elements.push(d[e]);
                    var f = this.getInRowSpacing_(d[e], d[e + 1]);
                    c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, f));
                }
                c.elements.push(d[d.length - 1]);
                c.endsWithElemSpacer() && (f = this.getInRowSpacing_(d[d.length - 1], null), a && c.hasDummyInput && (f += this.constants_.TAB_WIDTH), c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, f)));
            }
        }
    };
    Blockly.geras.RenderInfo.prototype.getInRowSpacing_ = function(a, b) {
        if (!a) return b && Blockly.blockRendering.Types.isField(b) && b.isEditable ? this.constants_.MEDIUM_PADDING : b && Blockly.blockRendering.Types.isInlineInput(b) ? this.constants_.MEDIUM_LARGE_PADDING : b && Blockly.blockRendering.Types.isStatementInput(b) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
        if (!Blockly.blockRendering.Types.isInput(a) && (!b || Blockly.blockRendering.Types.isStatementInput(b))) return Blockly.blockRendering.Types.isField(a) && a.isEditable ? this.constants_.MEDIUM_PADDING : Blockly.blockRendering.Types.isIcon(a) ? 2 * this.constants_.LARGE_PADDING + 1 : Blockly.blockRendering.Types.isHat(a) ? this.constants_.NO_PADDING : Blockly.blockRendering.Types.isPreviousOrNextConnection(a) ? this.constants_.LARGE_PADDING : Blockly.blockRendering.Types.isLeftRoundedCorner(a) ? this.constants_.MIN_BLOCK_WIDTH : Blockly.blockRendering.Types.isJaggedEdge(a) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
        if (Blockly.blockRendering.Types.isInput(a) && !b) {
            if (Blockly.blockRendering.Types.isExternalInput(a)) return this.constants_.NO_PADDING;
            if (Blockly.blockRendering.Types.isInlineInput(a)) return this.constants_.LARGE_PADDING;
            if (Blockly.blockRendering.Types.isStatementInput(a)) return this.constants_.NO_PADDING;
        }
        if (!Blockly.blockRendering.Types.isInput(a) && b && Blockly.blockRendering.Types.isInput(b)) {
            if (Blockly.blockRendering.Types.isField(a) && a.isEditable) {
                if (Blockly.blockRendering.Types.isInlineInput(b) || Blockly.blockRendering.Types.isExternalInput(b)) return this.constants_.SMALL_PADDING;
            } else {
                if (Blockly.blockRendering.Types.isInlineInput(b) || Blockly.blockRendering.Types.isExternalInput(b)) return this.constants_.MEDIUM_LARGE_PADDING;
                if (Blockly.blockRendering.Types.isStatementInput(b)) return this.constants_.LARGE_PADDING;
            }
            return this.constants_.LARGE_PADDING - 1;
        }
        if (Blockly.blockRendering.Types.isIcon(a) && b && !Blockly.blockRendering.Types.isInput(b)) return this.constants_.LARGE_PADDING;
        if (Blockly.blockRendering.Types.isInlineInput(a) && b && Blockly.blockRendering.Types.isField(b)) return b.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
        if (Blockly.blockRendering.Types.isLeftSquareCorner(a) && b) {
            if (Blockly.blockRendering.Types.isHat(b)) return this.constants_.NO_PADDING;
            if (Blockly.blockRendering.Types.isPreviousConnection(b)) return b.notchOffset;
            if (Blockly.blockRendering.Types.isNextConnection(b)) return a = (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2, b.notchOffset + a;
        }
        if (Blockly.blockRendering.Types.isLeftRoundedCorner(a) && b) {
            if (Blockly.blockRendering.Types.isPreviousConnection(b)) return b.notchOffset - this.constants_.CORNER_RADIUS;
            if (Blockly.blockRendering.Types.isNextConnection(b)) return a = (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2, b.notchOffset - this.constants_.CORNER_RADIUS + a;
        }
        return Blockly.blockRendering.Types.isField(a) && b && Blockly.blockRendering.Types.isField(b) && a.isEditable == b.isEditable || b && Blockly.blockRendering.Types.isJaggedEdge(b) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
    };
    Blockly.geras.RenderInfo.prototype.getSpacerRowHeight_ = function(a, b) {
        return Blockly.blockRendering.Types.isTopRow(a) && Blockly.blockRendering.Types.isBottomRow(b) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : Blockly.blockRendering.Types.isTopRow(a) || Blockly.blockRendering.Types.isBottomRow(b) ? this.constants_.NO_PADDING : a.hasExternalInput && b.hasExternalInput ? this.constants_.LARGE_PADDING : !a.hasStatement && b.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : a.hasStatement && b.hasStatement || !a.hasStatement && b.hasDummyInput || a.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
    };
    Blockly.geras.RenderInfo.prototype.getElemCenterline_ = function(a, b) {
        if (Blockly.blockRendering.Types.isSpacer(b)) return a.yPos + b.height / 2;
        if (Blockly.blockRendering.Types.isBottomRow(a)) return a = a.yPos + a.height - a.descenderHeight, Blockly.blockRendering.Types.isNextConnection(b) ? a + b.height / 2 : a - b.height / 2;
        if (Blockly.blockRendering.Types.isTopRow(a)) return Blockly.blockRendering.Types.isHat(b) ? a.capline - b.height / 2 : a.capline + b.height / 2;
        var c = a.yPos;
        Blockly.blockRendering.Types.isField(b) || Blockly.blockRendering.Types.isIcon(b) ? (c += b.height / 2, (a.hasInlineInput || a.hasStatement) && b.height + this.constants_.TALL_INPUT_FIELD_OFFSET_Y <= a.height && (c += this.constants_.TALL_INPUT_FIELD_OFFSET_Y)) : c = Blockly.blockRendering.Types.isInlineInput(b) ? c + b.height / 2 : c + a.height / 2;
        return c;
    };
    Blockly.geras.RenderInfo.prototype.alignRowElements_ = function() {
        if (this.isInline) {
            for(var a = 0, b = null, c = this.rows.length - 1, d; d = this.rows[c]; c--)d.nextRightEdge = a, Blockly.blockRendering.Types.isInputRow(d) && (d.hasStatement && this.alignStatementRow_(d), b && b.hasStatement && d.width < b.width ? d.nextRightEdge = b.width : a = d.width, b = d);
            for(c = a = 0; d = this.rows[c]; c++)d.hasStatement ? a = this.getDesiredRowWidth_(d) : Blockly.blockRendering.Types.isSpacer(d) ? d.width = Math.max(a, d.nextRightEdge) : (a = Math.max(a, d.nextRightEdge) - d.width, 0 < a && this.addAlignmentPadding_(d, a), a = d.width);
        } else Blockly.geras.RenderInfo.superClass_.alignRowElements_.call(this);
    };
    Blockly.geras.RenderInfo.prototype.getDesiredRowWidth_ = function(a) {
        return this.isInline && a.hasStatement ? this.statementEdge + this.constants_.MAX_BOTTOM_WIDTH + this.startX : Blockly.geras.RenderInfo.superClass_.getDesiredRowWidth_.call(this, a);
    };
    Blockly.geras.RenderInfo.prototype.finalize_ = function() {
        for(var a = 0, b = 0, c = 0, d; d = this.rows[c]; c++){
            d.yPos = b;
            d.xPos = this.startX;
            b += d.height;
            a = Math.max(a, d.widthWithConnectedBlocks);
            var e = b - this.topRow.ascenderHeight;
            d == this.bottomRow && e < this.constants_.MIN_BLOCK_HEIGHT && (e = this.constants_.MIN_BLOCK_HEIGHT - e, this.bottomRow.height += e, b += e);
            this.recordElemPositions_(d);
        }
        this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (a = Math.max(a, this.block_.nextConnection.targetBlock().getHeightWidth().width - this.constants_.DARK_PATH_OFFSET));
        this.bottomRow.baseline = b - this.bottomRow.descenderHeight;
        this.widthWithChildren = a + this.startX + this.constants_.DARK_PATH_OFFSET;
        this.width += this.constants_.DARK_PATH_OFFSET;
        this.height = b + this.constants_.DARK_PATH_OFFSET;
        this.startY = this.topRow.capline;
    };
    Blockly.geras.Drawer = function(a, b) {
        Blockly.geras.Drawer.superClass_.constructor.call(this, a, b);
        this.highlighter_ = new Blockly.geras.Highlighter(b);
    };
    Blockly.utils.object.inherits(Blockly.geras.Drawer, Blockly.blockRendering.Drawer);
    Blockly.geras.Drawer.prototype.draw = function() {
        this.hideHiddenIcons_();
        this.drawOutline_();
        this.drawInternals_();
        var a = this.block_.pathObject;
        a.setPath(this.outlinePath_ + "\n" + this.inlinePath_);
        a.setHighlightPath(this.highlighter_.getPath());
        this.info_.RTL && a.flipRTL();
        Blockly.blockRendering.useDebugger && this.block_.renderingDebugger.drawDebug(this.block_, this.info_);
        this.recordSizeOnBlock_();
    };
    Blockly.geras.Drawer.prototype.drawTop_ = function() {
        this.highlighter_.drawTopCorner(this.info_.topRow);
        this.highlighter_.drawRightSideRow(this.info_.topRow);
        Blockly.geras.Drawer.superClass_.drawTop_.call(this);
    };
    Blockly.geras.Drawer.prototype.drawJaggedEdge_ = function(a) {
        this.highlighter_.drawJaggedEdge_(a);
        Blockly.geras.Drawer.superClass_.drawJaggedEdge_.call(this, a);
    };
    Blockly.geras.Drawer.prototype.drawValueInput_ = function(a) {
        this.highlighter_.drawValueInput(a);
        Blockly.geras.Drawer.superClass_.drawValueInput_.call(this, a);
    };
    Blockly.geras.Drawer.prototype.drawStatementInput_ = function(a) {
        this.highlighter_.drawStatementInput(a);
        Blockly.geras.Drawer.superClass_.drawStatementInput_.call(this, a);
    };
    Blockly.geras.Drawer.prototype.drawRightSideRow_ = function(a) {
        this.highlighter_.drawRightSideRow(a);
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("H", a.xPos + a.width) + Blockly.utils.svgPaths.lineOnAxis("V", a.yPos + a.height);
    };
    Blockly.geras.Drawer.prototype.drawBottom_ = function() {
        this.highlighter_.drawBottomRow(this.info_.bottomRow);
        Blockly.geras.Drawer.superClass_.drawBottom_.call(this);
    };
    Blockly.geras.Drawer.prototype.drawLeft_ = function() {
        this.highlighter_.drawLeft();
        Blockly.geras.Drawer.superClass_.drawLeft_.call(this);
    };
    Blockly.geras.Drawer.prototype.drawInlineInput_ = function(a) {
        this.highlighter_.drawInlineInput(a);
        Blockly.geras.Drawer.superClass_.drawInlineInput_.call(this, a);
    };
    Blockly.geras.Drawer.prototype.positionInlineInputConnection_ = function(a) {
        var b = a.centerline - a.height / 2;
        if (a.connectionModel) {
            var c = a.xPos + a.connectionWidth + this.constants_.DARK_PATH_OFFSET;
            this.info_.RTL && (c *= -1);
            a.connectionModel.setOffsetInBlock(c, b + a.connectionOffsetY + this.constants_.DARK_PATH_OFFSET);
        }
    };
    Blockly.geras.Drawer.prototype.positionStatementInputConnection_ = function(a) {
        var b = a.getLastInput();
        if (b.connectionModel) {
            var c = a.xPos + a.statementEdge + b.notchOffset;
            c = this.info_.RTL ? -1 * c : c + this.constants_.DARK_PATH_OFFSET;
            b.connectionModel.setOffsetInBlock(c, a.yPos + this.constants_.DARK_PATH_OFFSET);
        }
    };
    Blockly.geras.Drawer.prototype.positionExternalValueConnection_ = function(a) {
        var b = a.getLastInput();
        if (b.connectionModel) {
            var c = a.xPos + a.width + this.constants_.DARK_PATH_OFFSET;
            this.info_.RTL && (c *= -1);
            b.connectionModel.setOffsetInBlock(c, a.yPos);
        }
    };
    Blockly.geras.Drawer.prototype.positionNextConnection_ = function() {
        var a = this.info_.bottomRow;
        if (a.connection) {
            var b = a.connection, c = b.xPos;
            b.connectionModel.setOffsetInBlock((this.info_.RTL ? -c : c) + this.constants_.DARK_PATH_OFFSET / 2, a.baseline + this.constants_.DARK_PATH_OFFSET);
        }
    };
    Blockly.geras.HighlightConstantProvider = function(a) {
        this.constantProvider = a;
        this.OFFSET = .5;
        this.START_POINT = Blockly.utils.svgPaths.moveBy(this.OFFSET, this.OFFSET);
    };
    Blockly.geras.HighlightConstantProvider.prototype.init = function() {
        this.INSIDE_CORNER = this.makeInsideCorner();
        this.OUTSIDE_CORNER = this.makeOutsideCorner();
        this.PUZZLE_TAB = this.makePuzzleTab();
        this.NOTCH = this.makeNotch();
        this.JAGGED_TEETH = this.makeJaggedTeeth();
        this.START_HAT = this.makeStartHat();
    };
    Blockly.geras.HighlightConstantProvider.prototype.makeInsideCorner = function() {
        var a = this.constantProvider.CORNER_RADIUS, b = this.OFFSET, c = (1 - Math.SQRT1_2) * (a + b) - b, d = Blockly.utils.svgPaths.moveBy(c, c) + Blockly.utils.svgPaths.arc("a", "0 0,0", a, Blockly.utils.svgPaths.point(-c - b, a - c)), e = Blockly.utils.svgPaths.arc("a", "0 0,0", a + b, Blockly.utils.svgPaths.point(a + b, a + b)), f = Blockly.utils.svgPaths.moveBy(c, -c) + Blockly.utils.svgPaths.arc("a", "0 0,0", a + b, Blockly.utils.svgPaths.point(a - c, c + b));
        return {
            width: a + b,
            height: a,
            pathTop: function(g) {
                return g ? d : "";
            },
            pathBottom: function(g) {
                return g ? e : f;
            }
        };
    };
    Blockly.geras.HighlightConstantProvider.prototype.makeOutsideCorner = function() {
        var a = this.constantProvider.CORNER_RADIUS, b = this.OFFSET, c = (1 - Math.SQRT1_2) * (a - b) + b, d = Blockly.utils.svgPaths.moveBy(c, c) + Blockly.utils.svgPaths.arc("a", "0 0,1", a - b, Blockly.utils.svgPaths.point(a - c, -c + b)), e = Blockly.utils.svgPaths.moveBy(b, a) + Blockly.utils.svgPaths.arc("a", "0 0,1", a - b, Blockly.utils.svgPaths.point(a, -a + b)), f = -c, g = Blockly.utils.svgPaths.moveBy(c, f) + Blockly.utils.svgPaths.arc("a", "0 0,1", a - b, Blockly.utils.svgPaths.point(-c + b, -f - a));
        return {
            height: a,
            topLeft: function(h) {
                return h ? d : e;
            },
            bottomLeft: function() {
                return g;
            }
        };
    };
    Blockly.geras.HighlightConstantProvider.prototype.makePuzzleTab = function() {
        var a = this.constantProvider.TAB_WIDTH, b = this.constantProvider.TAB_HEIGHT, c = Blockly.utils.svgPaths.moveBy(-2, -b + 3.4) + Blockly.utils.svgPaths.lineTo(-0.45 * a, -2.1), d = Blockly.utils.svgPaths.lineOnAxis("v", 2.5) + Blockly.utils.svgPaths.moveBy(.97 * -a, 2.5) + Blockly.utils.svgPaths.curve("q", [
            Blockly.utils.svgPaths.point(.05 * -a, 10),
            Blockly.utils.svgPaths.point(.3 * a, 9.5)
        ]) + Blockly.utils.svgPaths.moveBy(.67 * a, -1.9) + Blockly.utils.svgPaths.lineOnAxis("v", 2.5), e = Blockly.utils.svgPaths.lineOnAxis("v", -1.5) + Blockly.utils.svgPaths.moveBy(-0.92 * a, -0.5) + Blockly.utils.svgPaths.curve("q", [
            Blockly.utils.svgPaths.point(-0.19 * a, -5.5),
            Blockly.utils.svgPaths.point(0, -11)
        ]) + Blockly.utils.svgPaths.moveBy(.92 * a, 1), f = Blockly.utils.svgPaths.moveBy(-5, b - .7) + Blockly.utils.svgPaths.lineTo(.46 * a, -2.1);
        return {
            width: a,
            height: b,
            pathUp: function(g) {
                return g ? c : e;
            },
            pathDown: function(g) {
                return g ? d : f;
            }
        };
    };
    Blockly.geras.HighlightConstantProvider.prototype.makeNotch = function() {
        return {
            pathLeft: Blockly.utils.svgPaths.lineOnAxis("h", this.OFFSET) + this.constantProvider.NOTCH.pathLeft
        };
    };
    Blockly.geras.HighlightConstantProvider.prototype.makeJaggedTeeth = function() {
        return {
            pathLeft: Blockly.utils.svgPaths.lineTo(5.1, 2.6) + Blockly.utils.svgPaths.moveBy(-10.2, 6.8) + Blockly.utils.svgPaths.lineTo(5.1, 2.6),
            height: 12,
            width: 10.2
        };
    };
    Blockly.geras.HighlightConstantProvider.prototype.makeStartHat = function() {
        var a = this.constantProvider.START_HAT.height, b = Blockly.utils.svgPaths.moveBy(25, -8.7) + Blockly.utils.svgPaths.curve("c", [
            Blockly.utils.svgPaths.point(29.7, -6.2),
            Blockly.utils.svgPaths.point(57.2, -0.5),
            Blockly.utils.svgPaths.point(75, 8.7)
        ]), c = Blockly.utils.svgPaths.curve("c", [
            Blockly.utils.svgPaths.point(17.8, -9.2),
            Blockly.utils.svgPaths.point(45.3, -14.9),
            Blockly.utils.svgPaths.point(75, -8.7)
        ]) + Blockly.utils.svgPaths.moveTo(100.5, a + .5);
        return {
            path: function(d) {
                return d ? b : c;
            }
        };
    };
    Blockly.geras.PathObject = function(a, b, c) {
        this.constants = c;
        this.svgRoot = a;
        this.svgPathDark = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyPathDark",
            transform: "translate(1,1)"
        }, this.svgRoot);
        this.svgPath = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyPath"
        }, this.svgRoot);
        this.svgPathLight = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyPathLight"
        }, this.svgRoot);
        this.colourDark = "#000000";
        this.style = b;
    };
    Blockly.utils.object.inherits(Blockly.geras.PathObject, Blockly.blockRendering.PathObject);
    Blockly.geras.PathObject.prototype.setPath = function(a) {
        this.svgPath.setAttribute("d", a);
        this.svgPathDark.setAttribute("d", a);
    };
    Blockly.geras.PathObject.prototype.setHighlightPath = function(a) {
        this.svgPathLight.setAttribute("d", a);
    };
    Blockly.geras.PathObject.prototype.flipRTL = function() {
        this.svgPath.setAttribute("transform", "scale(-1 1)");
        this.svgPathLight.setAttribute("transform", "scale(-1 1)");
        this.svgPathDark.setAttribute("transform", "translate(1,1) scale(-1 1)");
    };
    Blockly.geras.PathObject.prototype.applyColour = function(a) {
        this.svgPathLight.style.display = "";
        this.svgPathDark.style.display = "";
        this.svgPathLight.setAttribute("stroke", this.style.colourTertiary);
        this.svgPathDark.setAttribute("fill", this.colourDark);
        Blockly.geras.PathObject.superClass_.applyColour.call(this, a);
        this.svgPath.setAttribute("stroke", "none");
    };
    Blockly.geras.PathObject.prototype.setStyle = function(a) {
        this.style = a;
        this.colourDark = Blockly.utils.colour.blend("#000", this.style.colourPrimary, .2) || this.colourDark;
    };
    Blockly.geras.PathObject.prototype.updateHighlighted = function(a) {
        a ? (this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")"), this.svgPathLight.style.display = "none") : (this.svgPath.setAttribute("filter", "none"), this.svgPathLight.style.display = "inline");
    };
    Blockly.geras.PathObject.prototype.updateShadow_ = function(a) {
        a && (this.svgPathLight.style.display = "none", this.svgPathDark.setAttribute("fill", this.style.colourSecondary), this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary));
    };
    Blockly.geras.PathObject.prototype.updateDisabled_ = function(a) {
        Blockly.geras.PathObject.superClass_.updateDisabled_.call(this, a);
        a && this.svgPath.setAttribute("stroke", "none");
    };
    Blockly.geras.Renderer = function(a) {
        Blockly.geras.Renderer.superClass_.constructor.call(this, a);
        this.highlightConstants_ = null;
    };
    Blockly.utils.object.inherits(Blockly.geras.Renderer, Blockly.blockRendering.Renderer);
    Blockly.geras.Renderer.prototype.init = function(a, b) {
        Blockly.geras.Renderer.superClass_.init.call(this, a, b);
        this.highlightConstants_ = this.makeHighlightConstants_();
        this.highlightConstants_.init();
    };
    Blockly.geras.Renderer.prototype.refreshDom = function(a, b) {
        Blockly.geras.Renderer.superClass_.refreshDom.call(this, a, b);
        this.getHighlightConstants().init();
    };
    Blockly.geras.Renderer.prototype.makeConstants_ = function() {
        return new Blockly.geras.ConstantProvider;
    };
    Blockly.geras.Renderer.prototype.makeRenderInfo_ = function(a) {
        return new Blockly.geras.RenderInfo(this, a);
    };
    Blockly.geras.Renderer.prototype.makeDrawer_ = function(a, b) {
        return new Blockly.geras.Drawer(a, b);
    };
    Blockly.geras.Renderer.prototype.makePathObject = function(a, b) {
        return new Blockly.geras.PathObject(a, b, this.getConstants());
    };
    Blockly.geras.Renderer.prototype.makeHighlightConstants_ = function() {
        return new Blockly.geras.HighlightConstantProvider(this.getConstants());
    };
    Blockly.geras.Renderer.prototype.getHighlightConstants = function() {
        return this.highlightConstants_;
    };
    Blockly.blockRendering.register("geras", Blockly.geras.Renderer);
    Blockly.thrasos = {};
    Blockly.thrasos.RenderInfo = function(a, b) {
        Blockly.thrasos.RenderInfo.superClass_.constructor.call(this, a, b);
    };
    Blockly.utils.object.inherits(Blockly.thrasos.RenderInfo, Blockly.blockRendering.RenderInfo);
    Blockly.thrasos.RenderInfo.prototype.getRenderer = function() {
        return this.renderer_;
    };
    Blockly.thrasos.RenderInfo.prototype.addElemSpacing_ = function() {
        for(var a = !1, b = 0, c; c = this.rows[b]; b++)c.hasExternalInput && (a = !0);
        for(b = 0; c = this.rows[b]; b++){
            var d = c.elements;
            c.elements = [];
            c.startsWithElemSpacer() && c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, this.getInRowSpacing_(null, d[0])));
            for(var e = 0; e < d.length - 1; e++){
                c.elements.push(d[e]);
                var f = this.getInRowSpacing_(d[e], d[e + 1]);
                c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, f));
            }
            c.elements.push(d[d.length - 1]);
            c.endsWithElemSpacer() && (f = this.getInRowSpacing_(d[d.length - 1], null), a && c.hasDummyInput && (f += this.constants_.TAB_WIDTH), c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, f)));
        }
    };
    Blockly.thrasos.RenderInfo.prototype.getInRowSpacing_ = function(a, b) {
        if (!a) return b && Blockly.blockRendering.Types.isField(b) && b.isEditable ? this.constants_.MEDIUM_PADDING : b && Blockly.blockRendering.Types.isInlineInput(b) ? this.constants_.MEDIUM_LARGE_PADDING : b && Blockly.blockRendering.Types.isStatementInput(b) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
        if (!Blockly.blockRendering.Types.isInput(a) && !b) return Blockly.blockRendering.Types.isField(a) && a.isEditable ? this.constants_.MEDIUM_PADDING : Blockly.blockRendering.Types.isIcon(a) ? 2 * this.constants_.LARGE_PADDING + 1 : Blockly.blockRendering.Types.isHat(a) ? this.constants_.NO_PADDING : Blockly.blockRendering.Types.isPreviousOrNextConnection(a) ? this.constants_.LARGE_PADDING : Blockly.blockRendering.Types.isLeftRoundedCorner(a) ? this.constants_.MIN_BLOCK_WIDTH : Blockly.blockRendering.Types.isJaggedEdge(a) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
        if (Blockly.blockRendering.Types.isInput(a) && !b) {
            if (Blockly.blockRendering.Types.isExternalInput(a)) return this.constants_.NO_PADDING;
            if (Blockly.blockRendering.Types.isInlineInput(a)) return this.constants_.LARGE_PADDING;
            if (Blockly.blockRendering.Types.isStatementInput(a)) return this.constants_.NO_PADDING;
        }
        if (!Blockly.blockRendering.Types.isInput(a) && b && Blockly.blockRendering.Types.isInput(b)) {
            if (Blockly.blockRendering.Types.isField(a) && a.isEditable) {
                if (Blockly.blockRendering.Types.isInlineInput(b) || Blockly.blockRendering.Types.isExternalInput(b)) return this.constants_.SMALL_PADDING;
            } else {
                if (Blockly.blockRendering.Types.isInlineInput(b) || Blockly.blockRendering.Types.isExternalInput(b)) return this.constants_.MEDIUM_LARGE_PADDING;
                if (Blockly.blockRendering.Types.isStatementInput(b)) return this.constants_.LARGE_PADDING;
            }
            return this.constants_.LARGE_PADDING - 1;
        }
        if (Blockly.blockRendering.Types.isIcon(a) && b && !Blockly.blockRendering.Types.isInput(b)) return this.constants_.LARGE_PADDING;
        if (Blockly.blockRendering.Types.isInlineInput(a) && b && Blockly.blockRendering.Types.isField(b)) return b.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
        if (Blockly.blockRendering.Types.isLeftSquareCorner(a) && b) {
            if (Blockly.blockRendering.Types.isHat(b)) return this.constants_.NO_PADDING;
            if (Blockly.blockRendering.Types.isPreviousConnection(b) || Blockly.blockRendering.Types.isNextConnection(b)) return b.notchOffset;
        }
        return Blockly.blockRendering.Types.isLeftRoundedCorner(a) && b ? b.notchOffset - this.constants_.CORNER_RADIUS : Blockly.blockRendering.Types.isField(a) && b && Blockly.blockRendering.Types.isField(b) && a.isEditable == b.isEditable || b && Blockly.blockRendering.Types.isJaggedEdge(b) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
    };
    Blockly.thrasos.RenderInfo.prototype.getSpacerRowHeight_ = function(a, b) {
        return Blockly.blockRendering.Types.isTopRow(a) && Blockly.blockRendering.Types.isBottomRow(b) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : Blockly.blockRendering.Types.isTopRow(a) || Blockly.blockRendering.Types.isBottomRow(b) ? this.constants_.NO_PADDING : a.hasExternalInput && b.hasExternalInput ? this.constants_.LARGE_PADDING : !a.hasStatement && b.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : a.hasStatement && b.hasStatement || a.hasDummyInput || b.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
    };
    Blockly.thrasos.RenderInfo.prototype.getElemCenterline_ = function(a, b) {
        if (Blockly.blockRendering.Types.isSpacer(b)) return a.yPos + b.height / 2;
        if (Blockly.blockRendering.Types.isBottomRow(a)) return a = a.yPos + a.height - a.descenderHeight, Blockly.blockRendering.Types.isNextConnection(b) ? a + b.height / 2 : a - b.height / 2;
        if (Blockly.blockRendering.Types.isTopRow(a)) return Blockly.blockRendering.Types.isHat(b) ? a.capline - b.height / 2 : a.capline + b.height / 2;
        var c = a.yPos;
        return c = Blockly.blockRendering.Types.isField(b) && a.hasStatement ? c + (this.constants_.TALL_INPUT_FIELD_OFFSET_Y + b.height / 2) : c + a.height / 2;
    };
    Blockly.thrasos.RenderInfo.prototype.finalize_ = function() {
        for(var a = 0, b = 0, c = 0, d; d = this.rows[c]; c++){
            d.yPos = b;
            d.xPos = this.startX;
            b += d.height;
            a = Math.max(a, d.widthWithConnectedBlocks);
            var e = b - this.topRow.ascenderHeight;
            d == this.bottomRow && e < this.constants_.MIN_BLOCK_HEIGHT && (e = this.constants_.MIN_BLOCK_HEIGHT - e, this.bottomRow.height += e, b += e);
            this.recordElemPositions_(d);
        }
        this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (a = Math.max(a, this.block_.nextConnection.targetBlock().getHeightWidth().width));
        this.bottomRow.baseline = b - this.bottomRow.descenderHeight;
        this.widthWithChildren = a + this.startX;
        this.height = b;
        this.startY = this.topRow.capline;
    };
    Blockly.thrasos.Renderer = function(a) {
        Blockly.thrasos.Renderer.superClass_.constructor.call(this, a);
    };
    Blockly.utils.object.inherits(Blockly.thrasos.Renderer, Blockly.blockRendering.Renderer);
    Blockly.thrasos.Renderer.prototype.makeRenderInfo_ = function(a) {
        return new Blockly.thrasos.RenderInfo(this, a);
    };
    Blockly.blockRendering.register("thrasos", Blockly.thrasos.Renderer);
    Blockly.zelos = {};
    Blockly.zelos.ConstantProvider = function() {
        Blockly.zelos.ConstantProvider.superClass_.constructor.call(this);
        this.SMALL_PADDING = this.GRID_UNIT = 4;
        this.MEDIUM_PADDING = 2 * this.GRID_UNIT;
        this.MEDIUM_LARGE_PADDING = 3 * this.GRID_UNIT;
        this.LARGE_PADDING = 4 * this.GRID_UNIT;
        this.CORNER_RADIUS = 1 * this.GRID_UNIT;
        this.NOTCH_WIDTH = 9 * this.GRID_UNIT;
        this.NOTCH_HEIGHT = 2 * this.GRID_UNIT;
        this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT = 3 * this.GRID_UNIT;
        this.MIN_BLOCK_WIDTH = 2 * this.GRID_UNIT;
        this.MIN_BLOCK_HEIGHT = 12 * this.GRID_UNIT;
        this.EMPTY_STATEMENT_INPUT_HEIGHT = 6 * this.GRID_UNIT;
        this.TAB_OFFSET_FROM_TOP = 0;
        this.TOP_ROW_MIN_HEIGHT = this.CORNER_RADIUS;
        this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING;
        this.BOTTOM_ROW_MIN_HEIGHT = this.CORNER_RADIUS;
        this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = 6 * this.GRID_UNIT;
        this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT;
        this.STATEMENT_INPUT_SPACER_MIN_WIDTH = 40 * this.GRID_UNIT;
        this.STATEMENT_INPUT_PADDING_LEFT = 4 * this.GRID_UNIT;
        this.EMPTY_INLINE_INPUT_PADDING = 4 * this.GRID_UNIT;
        this.EMPTY_INLINE_INPUT_HEIGHT = 8 * this.GRID_UNIT;
        this.DUMMY_INPUT_MIN_HEIGHT = 8 * this.GRID_UNIT;
        this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = 6 * this.GRID_UNIT;
        this.CURSOR_WS_WIDTH = 20 * this.GRID_UNIT;
        this.CURSOR_COLOUR = "#ffa200";
        this.CURSOR_RADIUS = 5;
        this.JAGGED_TEETH_WIDTH = this.JAGGED_TEETH_HEIGHT = 0;
        this.START_HAT_HEIGHT = 22;
        this.START_HAT_WIDTH = 96;
        this.SHAPES = {
            HEXAGONAL: 1,
            ROUND: 2,
            SQUARE: 3,
            PUZZLE: 4,
            NOTCH: 5
        };
        this.SHAPE_IN_SHAPE_PADDING = {
            1: {
                0: 5 * this.GRID_UNIT,
                1: 2 * this.GRID_UNIT,
                2: 5 * this.GRID_UNIT,
                3: 5 * this.GRID_UNIT
            },
            2: {
                0: 3 * this.GRID_UNIT,
                1: 3 * this.GRID_UNIT,
                2: 1 * this.GRID_UNIT,
                3: 2 * this.GRID_UNIT
            },
            3: {
                0: 2 * this.GRID_UNIT,
                1: 2 * this.GRID_UNIT,
                2: 2 * this.GRID_UNIT,
                3: 2 * this.GRID_UNIT
            }
        };
        this.FULL_BLOCK_FIELDS = !0;
        this.FIELD_TEXT_FONTSIZE = 3 * this.GRID_UNIT;
        this.FIELD_TEXT_FONTWEIGHT = "bold";
        this.FIELD_TEXT_FONTFAMILY = '"Helvetica Neue", "Segoe UI", Helvetica, sans-serif';
        this.FIELD_BORDER_RECT_RADIUS = this.CORNER_RADIUS;
        this.FIELD_BORDER_RECT_X_PADDING = 2 * this.GRID_UNIT;
        this.FIELD_BORDER_RECT_Y_PADDING = 1.625 * this.GRID_UNIT;
        this.FIELD_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT;
        this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT;
        this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !0;
        this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING;
        this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = !0;
        this.FIELD_COLOUR_DEFAULT_WIDTH = 2 * this.GRID_UNIT;
        this.FIELD_COLOUR_DEFAULT_HEIGHT = 4 * this.GRID_UNIT;
        this.FIELD_CHECKBOX_X_OFFSET = 1 * this.GRID_UNIT;
        this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH = 12 * this.GRID_UNIT;
        this.SELECTED_GLOW_COLOUR = "#fff200";
        this.SELECTED_GLOW_SIZE = .5;
        this.REPLACEMENT_GLOW_COLOUR = "#fff200";
        this.REPLACEMENT_GLOW_SIZE = 2;
        this.selectedGlowFilterId = "";
        this.selectedGlowFilter_ = null;
        this.replacementGlowFilterId = "";
        this.replacementGlowFilter_ = null;
    };
    Blockly.utils.object.inherits(Blockly.zelos.ConstantProvider, Blockly.blockRendering.ConstantProvider);
    Blockly.zelos.ConstantProvider.prototype.setFontConstants_ = function(a) {
        Blockly.zelos.ConstantProvider.superClass_.setFontConstants_.call(this, a);
        this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT = this.FIELD_TEXT_HEIGHT + 2 * this.FIELD_BORDER_RECT_Y_PADDING;
    };
    Blockly.zelos.ConstantProvider.prototype.init = function() {
        Blockly.zelos.ConstantProvider.superClass_.init.call(this);
        this.HEXAGONAL = this.makeHexagonal();
        this.ROUNDED = this.makeRounded();
        this.SQUARED = this.makeSquared();
        this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT + this.INSIDE_CORNERS.rightWidth;
    };
    Blockly.zelos.ConstantProvider.prototype.setDynamicProperties_ = function(a) {
        Blockly.zelos.ConstantProvider.superClass_.setDynamicProperties_.call(this, a);
        this.SELECTED_GLOW_COLOUR = a.getComponentStyle("selectedGlowColour") || this.SELECTED_GLOW_COLOUR;
        var b = Number(a.getComponentStyle("selectedGlowSize"));
        this.SELECTED_GLOW_SIZE = b && !isNaN(b) ? b : this.SELECTED_GLOW_SIZE;
        this.REPLACEMENT_GLOW_COLOUR = a.getComponentStyle("replacementGlowColour") || this.REPLACEMENT_GLOW_COLOUR;
        this.REPLACEMENT_GLOW_SIZE = (a = Number(a.getComponentStyle("replacementGlowSize"))) && !isNaN(a) ? a : this.REPLACEMENT_GLOW_SIZE;
    };
    Blockly.zelos.ConstantProvider.prototype.dispose = function() {
        Blockly.zelos.ConstantProvider.superClass_.dispose.call(this);
        this.selectedGlowFilter_ && Blockly.utils.dom.removeNode(this.selectedGlowFilter_);
        this.replacementGlowFilter_ && Blockly.utils.dom.removeNode(this.replacementGlowFilter_);
    };
    Blockly.zelos.ConstantProvider.prototype.makeStartHat = function() {
        var a = this.START_HAT_HEIGHT, b = this.START_HAT_WIDTH, c = Blockly.utils.svgPaths.curve("c", [
            Blockly.utils.svgPaths.point(25, -a),
            Blockly.utils.svgPaths.point(71, -a),
            Blockly.utils.svgPaths.point(b, 0)
        ]);
        return {
            height: a,
            width: b,
            path: c
        };
    };
    Blockly.zelos.ConstantProvider.prototype.makeHexagonal = function() {
        function a(c, d, e) {
            var f = c / 2;
            f = f > b ? b : f;
            e = e ? -1 : 1;
            c = (d ? -1 : 1) * c / 2;
            return Blockly.utils.svgPaths.lineTo(-e * f, c) + Blockly.utils.svgPaths.lineTo(e * f, c);
        }
        var b = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH;
        return {
            type: this.SHAPES.HEXAGONAL,
            isDynamic: !0,
            width: function(c) {
                c /= 2;
                return c > b ? b : c;
            },
            height: function(c) {
                return c;
            },
            connectionOffsetY: function(c) {
                return c / 2;
            },
            connectionOffsetX: function(c) {
                return -c;
            },
            pathDown: function(c) {
                return a(c, !1, !1);
            },
            pathUp: function(c) {
                return a(c, !0, !1);
            },
            pathRightDown: function(c) {
                return a(c, !1, !0);
            },
            pathRightUp: function(c) {
                return a(c, !1, !0);
            }
        };
    };
    Blockly.zelos.ConstantProvider.prototype.makeRounded = function() {
        function a(d, e, f) {
            var g = d > c ? d - c : 0;
            d = (d > c ? c : d) / 2;
            return Blockly.utils.svgPaths.arc("a", "0 0,1", d, Blockly.utils.svgPaths.point((e ? -1 : 1) * d, (e ? -1 : 1) * d)) + Blockly.utils.svgPaths.lineOnAxis("v", (f ? 1 : -1) * g) + Blockly.utils.svgPaths.arc("a", "0 0,1", d, Blockly.utils.svgPaths.point((e ? 1 : -1) * d, (e ? -1 : 1) * d));
        }
        var b = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, c = 2 * b;
        return {
            type: this.SHAPES.ROUND,
            isDynamic: !0,
            width: function(d) {
                d /= 2;
                return d > b ? b : d;
            },
            height: function(d) {
                return d;
            },
            connectionOffsetY: function(d) {
                return d / 2;
            },
            connectionOffsetX: function(d) {
                return -d;
            },
            pathDown: function(d) {
                return a(d, !1, !1);
            },
            pathUp: function(d) {
                return a(d, !0, !1);
            },
            pathRightDown: function(d) {
                return a(d, !1, !0);
            },
            pathRightUp: function(d) {
                return a(d, !1, !0);
            }
        };
    };
    Blockly.zelos.ConstantProvider.prototype.makeSquared = function() {
        function a(c, d, e) {
            c -= 2 * b;
            return Blockly.utils.svgPaths.arc("a", "0 0,1", b, Blockly.utils.svgPaths.point((d ? -1 : 1) * b, (d ? -1 : 1) * b)) + Blockly.utils.svgPaths.lineOnAxis("v", (e ? 1 : -1) * c) + Blockly.utils.svgPaths.arc("a", "0 0,1", b, Blockly.utils.svgPaths.point((d ? 1 : -1) * b, (d ? -1 : 1) * b));
        }
        var b = this.CORNER_RADIUS;
        return {
            type: this.SHAPES.SQUARE,
            isDynamic: !0,
            width: function(c) {
                return b;
            },
            height: function(c) {
                return c;
            },
            connectionOffsetY: function(c) {
                return c / 2;
            },
            connectionOffsetX: function(c) {
                return -c;
            },
            pathDown: function(c) {
                return a(c, !1, !1);
            },
            pathUp: function(c) {
                return a(c, !0, !1);
            },
            pathRightDown: function(c) {
                return a(c, !1, !0);
            },
            pathRightUp: function(c) {
                return a(c, !1, !0);
            }
        };
    };
    Blockly.zelos.ConstantProvider.prototype.shapeFor = function(a) {
        var b = a.getCheck();
        !b && a.targetConnection && (b = a.targetConnection.getCheck());
        switch(a.type){
            case Blockly.connectionTypes.INPUT_VALUE:
            case Blockly.connectionTypes.OUTPUT_VALUE:
                a = a.getSourceBlock().getOutputShape();
                if (null != a) switch(a){
                    case this.SHAPES.HEXAGONAL:
                        return this.HEXAGONAL;
                    case this.SHAPES.ROUND:
                        return this.ROUNDED;
                    case this.SHAPES.SQUARE:
                        return this.SQUARED;
                }
                if (b && -1 != b.indexOf("Boolean")) return this.HEXAGONAL;
                if (b && -1 != b.indexOf("Number")) return this.ROUNDED;
                b && b.indexOf("String");
                return this.ROUNDED;
            case Blockly.connectionTypes.PREVIOUS_STATEMENT:
            case Blockly.connectionTypes.NEXT_STATEMENT:
                return this.NOTCH;
            default:
                throw Error("Unknown type");
        }
    };
    Blockly.zelos.ConstantProvider.prototype.makeNotch = function() {
        function a(l) {
            return Blockly.utils.svgPaths.curve("c", [
                Blockly.utils.svgPaths.point(l * e / 2, 0),
                Blockly.utils.svgPaths.point(l * e * 3 / 4, g / 2),
                Blockly.utils.svgPaths.point(l * e, g)
            ]) + Blockly.utils.svgPaths.line([
                Blockly.utils.svgPaths.point(l * e, f)
            ]) + Blockly.utils.svgPaths.curve("c", [
                Blockly.utils.svgPaths.point(l * e / 4, g / 2),
                Blockly.utils.svgPaths.point(l * e / 2, g),
                Blockly.utils.svgPaths.point(l * e, g)
            ]) + Blockly.utils.svgPaths.lineOnAxis("h", l * d) + Blockly.utils.svgPaths.curve("c", [
                Blockly.utils.svgPaths.point(l * e / 2, 0),
                Blockly.utils.svgPaths.point(l * e * 3 / 4, -(g / 2)),
                Blockly.utils.svgPaths.point(l * e, -g)
            ]) + Blockly.utils.svgPaths.line([
                Blockly.utils.svgPaths.point(l * e, -f)
            ]) + Blockly.utils.svgPaths.curve("c", [
                Blockly.utils.svgPaths.point(l * e / 4, -(g / 2)),
                Blockly.utils.svgPaths.point(l * e / 2, -g),
                Blockly.utils.svgPaths.point(l * e, -g)
            ]);
        }
        var b = this.NOTCH_WIDTH, c = this.NOTCH_HEIGHT, d = b / 3, e = d / 3, f = c / 2, g = f / 2, h = a(1), k = a(-1);
        return {
            type: this.SHAPES.NOTCH,
            width: b,
            height: c,
            pathLeft: h,
            pathRight: k
        };
    };
    Blockly.zelos.ConstantProvider.prototype.makeInsideCorners = function() {
        var a = this.CORNER_RADIUS, b = Blockly.utils.svgPaths.arc("a", "0 0,0", a, Blockly.utils.svgPaths.point(-a, a)), c = Blockly.utils.svgPaths.arc("a", "0 0,1", a, Blockly.utils.svgPaths.point(-a, a)), d = Blockly.utils.svgPaths.arc("a", "0 0,0", a, Blockly.utils.svgPaths.point(a, a)), e = Blockly.utils.svgPaths.arc("a", "0 0,1", a, Blockly.utils.svgPaths.point(a, a));
        return {
            width: a,
            height: a,
            pathTop: b,
            pathBottom: d,
            rightWidth: a,
            rightHeight: a,
            pathTopRight: c,
            pathBottomRight: e
        };
    };
    Blockly.zelos.ConstantProvider.prototype.generateSecondaryColour_ = function(a) {
        return Blockly.utils.colour.blend("#000", a, .15) || a;
    };
    Blockly.zelos.ConstantProvider.prototype.generateTertiaryColour_ = function(a) {
        return Blockly.utils.colour.blend("#000", a, .25) || a;
    };
    Blockly.zelos.ConstantProvider.prototype.createDom = function(a, b, c) {
        Blockly.zelos.ConstantProvider.superClass_.createDom.call(this, a, b, c);
        a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.DEFS, {}, a);
        b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FILTER, {
            id: "blocklySelectedGlowFilter" + this.randomIdentifier,
            height: "160%",
            width: "180%",
            y: "-30%",
            x: "-40%"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEGAUSSIANBLUR, {
            "in": "SourceGraphic",
            stdDeviation: this.SELECTED_GLOW_SIZE
        }, b);
        c = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPONENTTRANSFER, {
            result: "outBlur"
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
        }, c);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEFLOOD, {
            "flood-color": this.SELECTED_GLOW_COLOUR,
            "flood-opacity": 1,
            result: "outColor"
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPOSITE, {
            "in": "outColor",
            in2: "outBlur",
            operator: "in",
            result: "outGlow"
        }, b);
        this.selectedGlowFilterId = b.id;
        this.selectedGlowFilter_ = b;
        a = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FILTER, {
            id: "blocklyReplacementGlowFilter" + this.randomIdentifier,
            height: "160%",
            width: "180%",
            y: "-30%",
            x: "-40%"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEGAUSSIANBLUR, {
            "in": "SourceGraphic",
            stdDeviation: this.REPLACEMENT_GLOW_SIZE
        }, a);
        b = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPONENTTRANSFER, {
            result: "outBlur"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
        }, b);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FEFLOOD, {
            "flood-color": this.REPLACEMENT_GLOW_COLOUR,
            "flood-opacity": 1,
            result: "outColor"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPOSITE, {
            "in": "outColor",
            in2: "outBlur",
            operator: "in",
            result: "outGlow"
        }, a);
        Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.FECOMPOSITE, {
            "in": "SourceGraphic",
            in2: "outGlow",
            operator: "over"
        }, a);
        this.replacementGlowFilterId = a.id;
        this.replacementGlowFilter_ = a;
    };
    Blockly.zelos.ConstantProvider.prototype.getCSS_ = function(a) {
        return [
            a + " .blocklyText,",
            a + " .blocklyFlyoutLabelText {",
            "font: " + this.FIELD_TEXT_FONTWEIGHT + " " + this.FIELD_TEXT_FONTSIZE + "pt " + this.FIELD_TEXT_FONTFAMILY + ";",
            "}",
            a + " .blocklyText {",
            "fill: #fff;",
            "}",
            a + " .blocklyNonEditableText>rect:not(.blocklyDropdownRect),",
            a + " .blocklyEditableText>rect:not(.blocklyDropdownRect) {",
            "fill: " + this.FIELD_BORDER_RECT_COLOUR + ";",
            "}",
            a + " .blocklyNonEditableText>text,",
            a + " .blocklyEditableText>text,",
            a + " .blocklyNonEditableText>g>text,",
            a + " .blocklyEditableText>g>text {",
            "fill: #575E75;",
            "}",
            a + " .blocklyFlyoutLabelText {",
            "fill: #575E75;",
            "}",
            a + " .blocklyText.blocklyBubbleText {",
            "fill: #575E75;",
            "}",
            a + " .blocklyDraggable:not(.blocklyDisabled)",
            " .blocklyEditableText:not(.editing):hover>rect,",
            a + " .blocklyDraggable:not(.blocklyDisabled)",
            " .blocklyEditableText:not(.editing):hover>.blocklyPath {",
            "stroke: #fff;",
            "stroke-width: 2;",
            "}",
            a + " .blocklyHtmlInput {",
            "font-family: " + this.FIELD_TEXT_FONTFAMILY + ";",
            "font-weight: " + this.FIELD_TEXT_FONTWEIGHT + ";",
            "color: #575E75;",
            "}",
            a + " .blocklyDropdownText {",
            "fill: #fff !important;",
            "}",
            a + ".blocklyWidgetDiv .goog-menuitem,",
            a + ".blocklyDropDownDiv .goog-menuitem {",
            "font-family: " + this.FIELD_TEXT_FONTFAMILY + ";",
            "}",
            a + ".blocklyDropDownDiv .goog-menuitem-content {",
            "color: #fff;",
            "}",
            a + " .blocklyHighlightedConnectionPath {",
            "stroke: " + this.SELECTED_GLOW_COLOUR + ";",
            "}",
            a + " .blocklyDisabled > .blocklyOutlinePath {",
            "fill: url(#blocklyDisabledPattern" + this.randomIdentifier + ")",
            "}",
            a + " .blocklyInsertionMarker>.blocklyPath {",
            "fill-opacity: " + this.INSERTION_MARKER_OPACITY + ";",
            "stroke: none;",
            "}"
        ];
    };
    Blockly.zelos.TopRow = function(a) {
        Blockly.zelos.TopRow.superClass_.constructor.call(this, a);
    };
    Blockly.utils.object.inherits(Blockly.zelos.TopRow, Blockly.blockRendering.TopRow);
    Blockly.zelos.TopRow.prototype.endsWithElemSpacer = function() {
        return !1;
    };
    Blockly.zelos.TopRow.prototype.hasLeftSquareCorner = function(a) {
        var b = (a.hat ? "cap" === a.hat : this.constants_.ADD_START_HATS) && !a.outputConnection && !a.previousConnection;
        return !!a.outputConnection || b;
    };
    Blockly.zelos.TopRow.prototype.hasRightSquareCorner = function(a) {
        return !!a.outputConnection && !a.statementInputCount && !a.nextConnection;
    };
    Blockly.zelos.BottomRow = function(a) {
        Blockly.zelos.BottomRow.superClass_.constructor.call(this, a);
    };
    Blockly.utils.object.inherits(Blockly.zelos.BottomRow, Blockly.blockRendering.BottomRow);
    Blockly.zelos.BottomRow.prototype.endsWithElemSpacer = function() {
        return !1;
    };
    Blockly.zelos.BottomRow.prototype.hasLeftSquareCorner = function(a) {
        return !!a.outputConnection;
    };
    Blockly.zelos.BottomRow.prototype.hasRightSquareCorner = function(a) {
        return !!a.outputConnection && !a.statementInputCount && !a.nextConnection;
    };
    Blockly.zelos.RightConnectionShape = function(a) {
        Blockly.zelos.RightConnectionShape.superClass_.constructor.call(this, a);
        this.type |= Blockly.blockRendering.Types.getType("RIGHT_CONNECTION");
        this.width = this.height = 0;
    };
    Blockly.utils.object.inherits(Blockly.zelos.RightConnectionShape, Blockly.blockRendering.Measurable);
    Blockly.zelos.RenderInfo = function(a, b) {
        Blockly.zelos.RenderInfo.superClass_.constructor.call(this, a, b);
        this.topRow = new Blockly.zelos.TopRow(this.constants_);
        this.bottomRow = new Blockly.zelos.BottomRow(this.constants_);
        this.isInline = !0;
        this.isMultiRow = !b.getInputsInline() || b.isCollapsed();
        this.hasStatementInput = 0 < b.statementInputCount;
        this.rightSide = this.outputConnection ? new Blockly.zelos.RightConnectionShape(this.constants_) : null;
    };
    Blockly.utils.object.inherits(Blockly.zelos.RenderInfo, Blockly.blockRendering.RenderInfo);
    Blockly.zelos.RenderInfo.prototype.getRenderer = function() {
        return this.renderer_;
    };
    Blockly.zelos.RenderInfo.prototype.measure = function() {
        this.createRows_();
        this.addElemSpacing_();
        this.addRowSpacing_();
        this.adjustXPosition_();
        this.computeBounds_();
        this.alignRowElements_();
        this.finalize_();
    };
    Blockly.zelos.RenderInfo.prototype.shouldStartNewRow_ = function(a, b) {
        return b ? a.type == Blockly.inputTypes.STATEMENT || b.type == Blockly.inputTypes.STATEMENT ? !0 : a.type == Blockly.inputTypes.VALUE || a.type == Blockly.inputTypes.DUMMY ? !this.isInline || this.isMultiRow : !1 : !1;
    };
    Blockly.zelos.RenderInfo.prototype.getDesiredRowWidth_ = function(a) {
        return a.hasStatement ? this.width - this.startX - (this.constants_.INSIDE_CORNERS.rightWidth || 0) : Blockly.zelos.RenderInfo.superClass_.getDesiredRowWidth_.call(this, a);
    };
    Blockly.zelos.RenderInfo.prototype.getInRowSpacing_ = function(a, b) {
        return a && b || !this.outputConnection || !this.outputConnection.isDynamicShape || this.hasStatementInput || this.bottomRow.hasNextConnection ? !a && b && Blockly.blockRendering.Types.isStatementInput(b) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : a && Blockly.blockRendering.Types.isLeftRoundedCorner(a) && b && (Blockly.blockRendering.Types.isPreviousConnection(b) || Blockly.blockRendering.Types.isNextConnection(b)) ? b.notchOffset - this.constants_.CORNER_RADIUS : a && Blockly.blockRendering.Types.isLeftSquareCorner(a) && b && Blockly.blockRendering.Types.isHat(b) ? this.constants_.NO_PADDING : this.constants_.MEDIUM_PADDING : this.constants_.NO_PADDING;
    };
    Blockly.zelos.RenderInfo.prototype.getSpacerRowHeight_ = function(a, b) {
        if (Blockly.blockRendering.Types.isTopRow(a) && Blockly.blockRendering.Types.isBottomRow(b)) return this.constants_.EMPTY_BLOCK_SPACER_HEIGHT;
        var c = Blockly.blockRendering.Types.isInputRow(a) && a.hasStatement, d = Blockly.blockRendering.Types.isInputRow(b) && b.hasStatement;
        return d || c ? (a = Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.INSIDE_CORNERS.rightHeight || 0), d && c ? Math.max(a, this.constants_.DUMMY_INPUT_MIN_HEIGHT) : a) : Blockly.blockRendering.Types.isTopRow(a) ? a.hasPreviousConnection || this.outputConnection && !this.hasStatementInput ? this.constants_.NO_PADDING : Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : Blockly.blockRendering.Types.isBottomRow(b) ? this.outputConnection ? !b.hasNextConnection && this.hasStatementInput ? Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : this.constants_.NO_PADDING : Math.max(this.topRow.minHeight, Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.CORNER_RADIUS)) - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
    };
    Blockly.zelos.RenderInfo.prototype.getSpacerRowWidth_ = function(a, b) {
        var c = this.width - this.startX;
        return Blockly.blockRendering.Types.isInputRow(a) && a.hasStatement || Blockly.blockRendering.Types.isInputRow(b) && b.hasStatement ? Math.max(c, this.constants_.STATEMENT_INPUT_SPACER_MIN_WIDTH) : c;
    };
    Blockly.zelos.RenderInfo.prototype.getElemCenterline_ = function(a, b) {
        if (a.hasStatement && !Blockly.blockRendering.Types.isSpacer(b) && !Blockly.blockRendering.Types.isStatementInput(b)) return a.yPos + this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT / 2;
        if (Blockly.blockRendering.Types.isInlineInput(b)) {
            var c = b.connectedBlock;
            if (c && c.outputConnection && c.nextConnection) return a.yPos + c.height / 2;
        }
        return Blockly.zelos.RenderInfo.superClass_.getElemCenterline_.call(this, a, b);
    };
    Blockly.zelos.RenderInfo.prototype.addInput_ = function(a, b) {
        a.type == Blockly.inputTypes.DUMMY && b.hasDummyInput && b.align == Blockly.constants.ALIGN.LEFT && a.align == Blockly.constants.ALIGN.RIGHT && (b.rightAlignedDummyInput = a);
        Blockly.zelos.RenderInfo.superClass_.addInput_.call(this, a, b);
    };
    Blockly.zelos.RenderInfo.prototype.addAlignmentPadding_ = function(a, b) {
        if (a.rightAlignedDummyInput) {
            for(var c, d = 0, e; (e = a.elements[d]) && (Blockly.blockRendering.Types.isSpacer(e) && (c = e), !Blockly.blockRendering.Types.isField(e) || e.parentInput != a.rightAlignedDummyInput); d++);
            if (c) {
                c.width += b;
                a.width += b;
                return;
            }
        }
        Blockly.zelos.RenderInfo.superClass_.addAlignmentPadding_.call(this, a, b);
    };
    Blockly.zelos.RenderInfo.prototype.adjustXPosition_ = function() {
        for(var a = this.constants_.NOTCH_OFFSET_LEFT + this.constants_.NOTCH_WIDTH, b = a, c = 2; c < this.rows.length - 1; c += 2){
            var d = this.rows[c - 1], e = this.rows[c], f = this.rows[c + 1];
            d = 2 == c ? !!this.topRow.hasPreviousConnection : !!d.followsStatement;
            f = c + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!f.precedesStatement;
            if (Blockly.blockRendering.Types.isInputRow(e) && e.hasStatement) e.measure(), b = e.width - e.getLastInput().width + a;
            else if (d && (2 == c || f) && Blockly.blockRendering.Types.isInputRow(e) && !e.hasStatement) {
                f = e.xPos;
                d = null;
                for(var g = 0, h; h = e.elements[g]; g++)Blockly.blockRendering.Types.isSpacer(h) && (d = h), !(d && (Blockly.blockRendering.Types.isField(h) || Blockly.blockRendering.Types.isInput(h)) && f < b) || Blockly.blockRendering.Types.isField(h) && (h.field instanceof Blockly.FieldLabel || h.field instanceof Blockly.FieldImage) || (d.width += b - f), f += h.width;
            }
        }
    };
    Blockly.zelos.RenderInfo.prototype.finalizeOutputConnection_ = function() {
        if (this.outputConnection && this.outputConnection.isDynamicShape) {
            for(var a = 0, b = 0, c; c = this.rows[b]; b++)c.yPos = a, a += c.height;
            this.height = a;
            b = this.bottomRow.hasNextConnection ? this.height - this.bottomRow.descenderHeight : this.height;
            a = this.outputConnection.shape.height(b);
            b = this.outputConnection.shape.width(b);
            this.outputConnection.height = a;
            this.outputConnection.width = b;
            this.outputConnection.startX = b;
            this.outputConnection.connectionOffsetY = this.outputConnection.shape.connectionOffsetY(a);
            this.outputConnection.connectionOffsetX = this.outputConnection.shape.connectionOffsetX(b);
            c = 0;
            this.hasStatementInput || this.bottomRow.hasNextConnection || (c = b, this.rightSide.height = a, this.rightSide.width = c, this.rightSide.centerline = a / 2, this.rightSide.xPos = this.width + c);
            this.startX = b;
            this.width += b + c;
            this.widthWithChildren += b + c;
        }
    };
    Blockly.zelos.RenderInfo.prototype.finalizeHorizontalAlignment_ = function() {
        if (this.outputConnection && !this.hasStatementInput && !this.bottomRow.hasNextConnection) {
            for(var a = 0, b = 0, c; c = this.rows[b]; b++)if (Blockly.blockRendering.Types.isInputRow(c)) {
                a = c.elements[c.elements.length - 2];
                var d = this.getNegativeSpacing_(c.elements[1]), e = this.getNegativeSpacing_(a);
                a = d + e;
                var f = this.constants_.MIN_BLOCK_WIDTH + 2 * this.outputConnection.width;
                this.width - a < f && (a = this.width - f, d = a / 2, e = a / 2);
                c.elements.unshift(new Blockly.blockRendering.InRowSpacer(this.constants_, -d));
                c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_, -e));
            }
            if (a) for(this.width -= a, this.widthWithChildren -= a, this.rightSide.xPos -= a, b = 0; c = this.rows[b]; b++)Blockly.blockRendering.Types.isTopOrBottomRow(c) && (c.elements[1].width -= a, c.elements[1].widthWithConnectedBlocks -= a), c.width -= a, c.widthWithConnectedBlocks -= a;
        }
    };
    Blockly.zelos.RenderInfo.prototype.getNegativeSpacing_ = function(a) {
        if (!a) return 0;
        var b = this.outputConnection.width, c = this.outputConnection.shape.type, d = this.constants_;
        if (this.isMultiRow && 1 < this.inputRows.length) switch(c){
            case d.SHAPES.ROUND:
                return c = this.constants_.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, c = this.height / 2 > c ? c : this.height / 2, b - c * (1 - Math.sin(Math.acos((c - this.constants_.SMALL_PADDING) / c)));
            default:
                return 0;
        }
        if (Blockly.blockRendering.Types.isInlineInput(a)) {
            var e = a.connectedBlock;
            a = e ? e.pathObject.outputShapeType : a.shape.type;
            return e && e.outputConnection && (e.statementInputCount || e.nextConnection) || c == d.SHAPES.HEXAGONAL && c != a ? 0 : b - this.constants_.SHAPE_IN_SHAPE_PADDING[c][a];
        }
        return Blockly.blockRendering.Types.isField(a) ? c == d.SHAPES.ROUND && a.field instanceof Blockly.FieldTextInput ? b - 2.75 * d.GRID_UNIT : b - this.constants_.SHAPE_IN_SHAPE_PADDING[c][0] : Blockly.blockRendering.Types.isIcon(a) ? this.constants_.SMALL_PADDING : 0;
    };
    Blockly.zelos.RenderInfo.prototype.finalizeVerticalAlignment_ = function() {
        if (!this.outputConnection) for(var a = 2; a < this.rows.length - 1; a += 2){
            var b = this.rows[a - 1], c = this.rows[a], d = this.rows[a + 1], e = 2 == a, f = a + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!d.precedesStatement;
            if (e ? this.topRow.hasPreviousConnection : b.followsStatement) {
                var g = 3 == c.elements.length && (c.elements[1].field instanceof Blockly.FieldLabel || c.elements[1].field instanceof Blockly.FieldImage);
                if (!e && g) b.height -= this.constants_.SMALL_PADDING, d.height -= this.constants_.SMALL_PADDING, c.height -= this.constants_.MEDIUM_PADDING;
                else if (!e && !f) b.height += this.constants_.SMALL_PADDING;
                else if (f) {
                    e = !1;
                    for(f = 0; g = c.elements[f]; f++)if (Blockly.blockRendering.Types.isInlineInput(g) && g.connectedBlock && !g.connectedBlock.isShadow() && 40 <= g.connectedBlock.getHeightWidth().height) {
                        e = !0;
                        break;
                    }
                    e && (b.height -= this.constants_.SMALL_PADDING, d.height -= this.constants_.SMALL_PADDING);
                }
            }
        }
    };
    Blockly.zelos.RenderInfo.prototype.finalize_ = function() {
        this.finalizeOutputConnection_();
        this.finalizeHorizontalAlignment_();
        this.finalizeVerticalAlignment_();
        Blockly.zelos.RenderInfo.superClass_.finalize_.call(this);
        this.rightSide && (this.widthWithChildren += this.rightSide.width);
    };
    Blockly.zelos.Drawer = function(a, b) {
        Blockly.zelos.Drawer.superClass_.constructor.call(this, a, b);
    };
    Blockly.utils.object.inherits(Blockly.zelos.Drawer, Blockly.blockRendering.Drawer);
    Blockly.zelos.Drawer.prototype.draw = function() {
        var a = this.block_.pathObject;
        a.beginDrawing();
        this.hideHiddenIcons_();
        this.drawOutline_();
        this.drawInternals_();
        a.setPath(this.outlinePath_ + "\n" + this.inlinePath_);
        this.info_.RTL && a.flipRTL();
        Blockly.blockRendering.useDebugger && this.block_.renderingDebugger.drawDebug(this.block_, this.info_);
        this.recordSizeOnBlock_();
        this.info_.outputConnection && (a.outputShapeType = this.info_.outputConnection.shape.type);
        a.endDrawing();
    };
    Blockly.zelos.Drawer.prototype.drawOutline_ = function() {
        this.info_.outputConnection && this.info_.outputConnection.isDynamicShape && !this.info_.hasStatementInput && !this.info_.bottomRow.hasNextConnection ? (this.drawFlatTop_(), this.drawRightDynamicConnection_(), this.drawFlatBottom_(), this.drawLeftDynamicConnection_()) : Blockly.zelos.Drawer.superClass_.drawOutline_.call(this);
    };
    Blockly.zelos.Drawer.prototype.drawLeft_ = function() {
        this.info_.outputConnection && this.info_.outputConnection.isDynamicShape ? this.drawLeftDynamicConnection_() : Blockly.zelos.Drawer.superClass_.drawLeft_.call(this);
    };
    Blockly.zelos.Drawer.prototype.drawRightSideRow_ = function(a) {
        if (!(0 >= a.height)) {
            if (a.precedesStatement || a.followsStatement) {
                var b = this.constants_.INSIDE_CORNERS.rightHeight;
                b = a.height - (a.precedesStatement ? b : 0);
                this.outlinePath_ += (a.followsStatement ? this.constants_.INSIDE_CORNERS.pathBottomRight : "") + (0 < b ? Blockly.utils.svgPaths.lineOnAxis("V", a.yPos + b) : "") + (a.precedesStatement ? this.constants_.INSIDE_CORNERS.pathTopRight : "");
            } else this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("V", a.yPos + a.height);
        }
    };
    Blockly.zelos.Drawer.prototype.drawRightDynamicConnection_ = function() {
        this.outlinePath_ += this.info_.outputConnection.shape.pathRightDown(this.info_.outputConnection.height);
    };
    Blockly.zelos.Drawer.prototype.drawLeftDynamicConnection_ = function() {
        this.positionOutputConnection_();
        this.outlinePath_ += this.info_.outputConnection.shape.pathUp(this.info_.outputConnection.height);
        this.outlinePath_ += "z";
    };
    Blockly.zelos.Drawer.prototype.drawFlatTop_ = function() {
        var a = this.info_.topRow;
        this.positionPreviousConnection_();
        this.outlinePath_ += Blockly.utils.svgPaths.moveBy(a.xPos, this.info_.startY);
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("h", a.width);
    };
    Blockly.zelos.Drawer.prototype.drawFlatBottom_ = function() {
        var a = this.info_.bottomRow;
        this.positionNextConnection_();
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("V", a.baseline);
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("h", -a.width);
    };
    Blockly.zelos.Drawer.prototype.drawInlineInput_ = function(a) {
        this.positionInlineInputConnection_(a);
        var b = a.input.name;
        if (!a.connectedBlock && !this.info_.isInsertionMarker) {
            var c = a.width - 2 * a.connectionWidth;
            a = Blockly.utils.svgPaths.moveTo(a.xPos + a.connectionWidth, a.centerline - a.height / 2) + Blockly.utils.svgPaths.lineOnAxis("h", c) + a.shape.pathRightDown(a.height) + Blockly.utils.svgPaths.lineOnAxis("h", -c) + a.shape.pathUp(a.height) + "z";
            this.block_.pathObject.setOutlinePath(b, a);
        }
    };
    Blockly.zelos.Drawer.prototype.drawStatementInput_ = function(a) {
        var b = a.getLastInput(), c = b.xPos + b.notchOffset + b.shape.width, d = b.shape.pathRight + Blockly.utils.svgPaths.lineOnAxis("h", -(b.notchOffset - this.constants_.INSIDE_CORNERS.width)) + this.constants_.INSIDE_CORNERS.pathTop, e = a.height - 2 * this.constants_.INSIDE_CORNERS.height;
        b = this.constants_.INSIDE_CORNERS.pathBottom + Blockly.utils.svgPaths.lineOnAxis("h", b.notchOffset - this.constants_.INSIDE_CORNERS.width) + (b.connectedBottomNextConnection ? "" : b.shape.pathLeft);
        this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis("H", c) + d + Blockly.utils.svgPaths.lineOnAxis("v", e) + b + Blockly.utils.svgPaths.lineOnAxis("H", a.xPos + a.width);
        this.positionStatementInputConnection_(a);
    };
    Blockly.zelos.MarkerSvg = function(a, b, c) {
        Blockly.zelos.MarkerSvg.superClass_.constructor.call(this, a, b, c);
    };
    Blockly.utils.object.inherits(Blockly.zelos.MarkerSvg, Blockly.blockRendering.MarkerSvg);
    Blockly.zelos.MarkerSvg.prototype.showWithInputOutput_ = function(a) {
        var b = a.getSourceBlock();
        a = a.getLocation().getOffsetInBlock();
        this.positionCircle_(a.x, a.y);
        this.setParent_(b);
        this.showCurrent_();
    };
    Blockly.zelos.MarkerSvg.prototype.showWithOutput_ = function(a) {
        this.showWithInputOutput_(a);
    };
    Blockly.zelos.MarkerSvg.prototype.showWithInput_ = function(a) {
        this.showWithInputOutput_(a);
    };
    Blockly.zelos.MarkerSvg.prototype.showWithBlock_ = function(a) {
        a = a.getLocation();
        var b = a.getHeightWidth();
        this.positionRect_(0, 0, b.width, b.height);
        this.setParent_(a);
        this.showCurrent_();
    };
    Blockly.zelos.MarkerSvg.prototype.positionCircle_ = function(a, b) {
        this.markerCircle_.setAttribute("cx", a);
        this.markerCircle_.setAttribute("cy", b);
        this.currentMarkerSvg = this.markerCircle_;
    };
    Blockly.zelos.MarkerSvg.prototype.hide = function() {
        Blockly.zelos.MarkerSvg.superClass_.hide.call(this);
        this.markerCircle_.style.display = "none";
    };
    Blockly.zelos.MarkerSvg.prototype.createDomInternal_ = function() {
        Blockly.zelos.MarkerSvg.superClass_.createDomInternal_.call(this);
        this.markerCircle_ = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.CIRCLE, {
            r: this.constants_.CURSOR_RADIUS,
            style: "display: none",
            "stroke-width": this.constants_.CURSOR_STROKE_WIDTH
        }, this.markerSvg_);
        if (this.isCursor()) {
            var a = this.getBlinkProperties_();
            Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.ANIMATE, a, this.markerCircle_);
        }
        return this.markerSvg_;
    };
    Blockly.zelos.MarkerSvg.prototype.applyColour_ = function(a) {
        Blockly.zelos.MarkerSvg.superClass_.applyColour_.call(this, a);
        this.markerCircle_.setAttribute("fill", this.colour_);
        this.markerCircle_.setAttribute("stroke", this.colour_);
        this.isCursor() && this.markerCircle_.firstChild.setAttribute("values", this.colour_ + ";transparent;transparent;");
    };
    Blockly.zelos.PathObject = function(a, b, c) {
        Blockly.zelos.PathObject.superClass_.constructor.call(this, a, b, c);
        this.constants = c;
        this.svgPathSelected_ = null;
        this.outlines_ = {};
        this.outputShapeType = this.remainingOutlines_ = null;
    };
    Blockly.utils.object.inherits(Blockly.zelos.PathObject, Blockly.blockRendering.PathObject);
    Blockly.zelos.PathObject.prototype.setPath = function(a) {
        Blockly.zelos.PathObject.superClass_.setPath.call(this, a);
        this.svgPathSelected_ && this.svgPathSelected_.setAttribute("d", a);
    };
    Blockly.zelos.PathObject.prototype.applyColour = function(a) {
        Blockly.zelos.PathObject.superClass_.applyColour.call(this, a);
        a.isShadow() && a.getParent() && this.svgPath.setAttribute("stroke", a.getParent().style.colourTertiary);
        a = 0;
        for(var b = Object.keys(this.outlines_), c; c = b[a]; a++)this.outlines_[c].setAttribute("fill", this.style.colourTertiary);
    };
    Blockly.zelos.PathObject.prototype.flipRTL = function() {
        Blockly.zelos.PathObject.superClass_.flipRTL.call(this);
        for(var a = 0, b = Object.keys(this.outlines_), c; c = b[a]; a++)this.outlines_[c].setAttribute("transform", "scale(-1 1)");
    };
    Blockly.zelos.PathObject.prototype.updateSelected = function(a) {
        this.setClass_("blocklySelected", a);
        a ? this.svgPathSelected_ || (this.svgPathSelected_ = this.svgPath.cloneNode(!0), this.svgPathSelected_.setAttribute("fill", "none"), this.svgPathSelected_.setAttribute("filter", "url(#" + this.constants.selectedGlowFilterId + ")"), this.svgRoot.appendChild(this.svgPathSelected_)) : this.svgPathSelected_ && (this.svgRoot.removeChild(this.svgPathSelected_), this.svgPathSelected_ = null);
    };
    Blockly.zelos.PathObject.prototype.updateReplacementFade = function(a) {
        this.setClass_("blocklyReplaceable", a);
        a ? this.svgPath.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : this.svgPath.removeAttribute("filter");
    };
    Blockly.zelos.PathObject.prototype.updateShapeForInputHighlight = function(a, b) {
        a = a.getParentInput().name;
        (a = this.getOutlinePath_(a)) && (b ? a.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : a.removeAttribute("filter"));
    };
    Blockly.zelos.PathObject.prototype.beginDrawing = function() {
        this.remainingOutlines_ = {};
        for(var a = 0, b = Object.keys(this.outlines_), c; c = b[a]; a++)this.remainingOutlines_[c] = 1;
    };
    Blockly.zelos.PathObject.prototype.endDrawing = function() {
        if (this.remainingOutlines_) for(var a = 0, b = Object.keys(this.remainingOutlines_), c; c = b[a]; a++)this.removeOutlinePath_(c);
        this.remainingOutlines_ = null;
    };
    Blockly.zelos.PathObject.prototype.setOutlinePath = function(a, b) {
        a = this.getOutlinePath_(a);
        a.setAttribute("d", b);
        a.setAttribute("fill", this.style.colourTertiary);
    };
    Blockly.zelos.PathObject.prototype.getOutlinePath_ = function(a) {
        this.outlines_[a] || (this.outlines_[a] = Blockly.utils.dom.createSvgElement(Blockly.utils.Svg.PATH, {
            "class": "blocklyOutlinePath",
            d: ""
        }, this.svgRoot));
        this.remainingOutlines_ && delete this.remainingOutlines_[a];
        return this.outlines_[a];
    };
    Blockly.zelos.PathObject.prototype.removeOutlinePath_ = function(a) {
        this.outlines_[a].parentNode.removeChild(this.outlines_[a]);
        delete this.outlines_[a];
    };
    Blockly.zelos.Renderer = function(a) {
        Blockly.zelos.Renderer.superClass_.constructor.call(this, a);
    };
    Blockly.utils.object.inherits(Blockly.zelos.Renderer, Blockly.blockRendering.Renderer);
    Blockly.zelos.Renderer.prototype.makeConstants_ = function() {
        return new Blockly.zelos.ConstantProvider;
    };
    Blockly.zelos.Renderer.prototype.makeRenderInfo_ = function(a) {
        return new Blockly.zelos.RenderInfo(this, a);
    };
    Blockly.zelos.Renderer.prototype.makeDrawer_ = function(a, b) {
        return new Blockly.zelos.Drawer(a, b);
    };
    Blockly.zelos.Renderer.prototype.makeMarkerDrawer = function(a, b) {
        return new Blockly.zelos.MarkerSvg(a, this.getConstants(), b);
    };
    Blockly.zelos.Renderer.prototype.makePathObject = function(a, b) {
        return new Blockly.zelos.PathObject(a, b, this.getConstants());
    };
    Blockly.zelos.Renderer.prototype.shouldHighlightConnection = function(a) {
        return a.type != Blockly.connectionTypes.INPUT_VALUE && a.type !== Blockly.connectionTypes.OUTPUT_VALUE;
    };
    Blockly.zelos.Renderer.prototype.getConnectionPreviewMethod = function(a, b, c) {
        return b.type == Blockly.connectionTypes.OUTPUT_VALUE ? a.isConnected() ? Blockly.InsertionMarkerManager.PREVIEW_TYPE.REPLACEMENT_FADE : Blockly.InsertionMarkerManager.PREVIEW_TYPE.INPUT_OUTLINE : Blockly.zelos.Renderer.superClass_.getConnectionPreviewMethod(a, b, c);
    };
    Blockly.blockRendering.register("zelos", Blockly.zelos.Renderer);
    Blockly.Themes.Dark = Blockly.Theme.defineTheme("dark", {
        base: Blockly.Themes.Classic,
        componentStyles: {
            workspaceBackgroundColour: "#1e1e1e",
            toolboxBackgroundColour: "blackBackground",
            toolboxForegroundColour: "#fff",
            flyoutBackgroundColour: "#252526",
            flyoutForegroundColour: "#ccc",
            flyoutOpacity: 1,
            scrollbarColour: "#797979",
            insertionMarkerColour: "#fff",
            insertionMarkerOpacity: .3,
            scrollbarOpacity: .4,
            cursorColour: "#d0d0d0",
            blackBackground: "#333"
        }
    });
    Blockly.Themes.Deuteranopia = {};
    Blockly.Themes.Deuteranopia.defaultBlockStyles = {
        colour_blocks: {
            colourPrimary: "#f2a72c",
            colourSecondary: "#f1c172",
            colourTertiary: "#da921c"
        },
        list_blocks: {
            colourPrimary: "#7d65ab",
            colourSecondary: "#a88be0",
            colourTertiary: "#66518e"
        },
        logic_blocks: {
            colourPrimary: "#9fd2f1",
            colourSecondary: "#c0e0f4",
            colourTertiary: "#74bae5"
        },
        loop_blocks: {
            colourPrimary: "#795a07",
            colourSecondary: "#ac8726",
            colourTertiary: "#c4a03f"
        },
        math_blocks: {
            colourPrimary: "#e6da39",
            colourSecondary: "#f3ec8e",
            colourTertiary: "#f2eeb7"
        },
        procedure_blocks: {
            colourPrimary: "#590721",
            colourSecondary: "#8c475d",
            colourTertiary: "#885464"
        },
        text_blocks: {
            colourPrimary: "#058863",
            colourSecondary: "#5ecfaf",
            colourTertiary: "#04684c"
        },
        variable_blocks: {
            colourPrimary: "#47025a",
            colourSecondary: "#820fa1",
            colourTertiary: "#8e579d"
        },
        variable_dynamic_blocks: {
            colourPrimary: "#47025a",
            colourSecondary: "#820fa1",
            colourTertiary: "#8e579d"
        }
    };
    Blockly.Themes.Deuteranopia.categoryStyles = {
        colour_category: {
            colour: "#f2a72c"
        },
        list_category: {
            colour: "#7d65ab"
        },
        logic_category: {
            colour: "#9fd2f1"
        },
        loop_category: {
            colour: "#795a07"
        },
        math_category: {
            colour: "#e6da39"
        },
        procedure_category: {
            colour: "#590721"
        },
        text_category: {
            colour: "#058863"
        },
        variable_category: {
            colour: "#47025a"
        },
        variable_dynamic_category: {
            colour: "#47025a"
        }
    };
    Blockly.Themes.Deuteranopia = new Blockly.Theme("deuteranopia", Blockly.Themes.Deuteranopia.defaultBlockStyles, Blockly.Themes.Deuteranopia.categoryStyles);
    Blockly.Themes.HighContrast = {};
    Blockly.Themes.HighContrast.defaultBlockStyles = {
        colour_blocks: {
            colourPrimary: "#a52714",
            colourSecondary: "#FB9B8C",
            colourTertiary: "#FBE1DD"
        },
        list_blocks: {
            colourPrimary: "#4a148c",
            colourSecondary: "#AD7BE9",
            colourTertiary: "#CDB6E9"
        },
        logic_blocks: {
            colourPrimary: "#01579b",
            colourSecondary: "#64C7FF",
            colourTertiary: "#C5EAFF"
        },
        loop_blocks: {
            colourPrimary: "#33691e",
            colourSecondary: "#9AFF78",
            colourTertiary: "#E1FFD7"
        },
        math_blocks: {
            colourPrimary: "#1a237e",
            colourSecondary: "#8A9EFF",
            colourTertiary: "#DCE2FF"
        },
        procedure_blocks: {
            colourPrimary: "#006064",
            colourSecondary: "#77E6EE",
            colourTertiary: "#CFECEE"
        },
        text_blocks: {
            colourPrimary: "#004d40",
            colourSecondary: "#5ae27c",
            colourTertiary: "#D2FFDD"
        },
        variable_blocks: {
            colourPrimary: "#880e4f",
            colourSecondary: "#FF73BE",
            colourTertiary: "#FFD4EB"
        },
        variable_dynamic_blocks: {
            colourPrimary: "#880e4f",
            colourSecondary: "#FF73BE",
            colourTertiary: "#FFD4EB"
        },
        hat_blocks: {
            colourPrimary: "#880e4f",
            colourSecondary: "#FF73BE",
            colourTertiary: "#FFD4EB",
            hat: "cap"
        }
    };
    Blockly.Themes.HighContrast.categoryStyles = {
        colour_category: {
            colour: "#a52714"
        },
        list_category: {
            colour: "#4a148c"
        },
        logic_category: {
            colour: "#01579b"
        },
        loop_category: {
            colour: "#33691e"
        },
        math_category: {
            colour: "#1a237e"
        },
        procedure_category: {
            colour: "#006064"
        },
        text_category: {
            colour: "#004d40"
        },
        variable_category: {
            colour: "#880e4f"
        },
        variable_dynamic_category: {
            colour: "#880e4f"
        }
    };
    Blockly.Themes.HighContrast = new Blockly.Theme("highcontrast", Blockly.Themes.HighContrast.defaultBlockStyles, Blockly.Themes.HighContrast.categoryStyles);
    Blockly.Themes.HighContrast.setComponentStyle("selectedGlowColour", "#000000");
    Blockly.Themes.HighContrast.setComponentStyle("selectedGlowSize", 1);
    Blockly.Themes.HighContrast.setComponentStyle("replacementGlowColour", "#000000");
    Blockly.Themes.HighContrast.setFontStyle({
        family: null,
        weight: null,
        size: 16
    });
    Blockly.Themes.Tritanopia = {};
    Blockly.Themes.Tritanopia.defaultBlockStyles = {
        colour_blocks: {
            colourPrimary: "#05427f",
            colourSecondary: "#2974c0",
            colourTertiary: "#2d74bb"
        },
        list_blocks: {
            colourPrimary: "#b69ce8",
            colourSecondary: "#ccbaef",
            colourTertiary: "#9176c5"
        },
        logic_blocks: {
            colourPrimary: "#9fd2f1",
            colourSecondary: "#c0e0f4",
            colourTertiary: "#74bae5"
        },
        loop_blocks: {
            colourPrimary: "#aa1846",
            colourSecondary: "#d36185",
            colourTertiary: "#7c1636"
        },
        math_blocks: {
            colourPrimary: "#e6da39",
            colourSecondary: "#f3ec8e",
            colourTertiary: "#f2eeb7"
        },
        procedure_blocks: {
            colourPrimary: "#590721",
            colourSecondary: "#8c475d",
            colourTertiary: "#885464"
        },
        text_blocks: {
            colourPrimary: "#058863",
            colourSecondary: "#5ecfaf",
            colourTertiary: "#04684c"
        },
        variable_blocks: {
            colourPrimary: "#4b2d84",
            colourSecondary: "#816ea7",
            colourTertiary: "#83759e"
        },
        variable_dynamic_blocks: {
            colourPrimary: "#4b2d84",
            colourSecondary: "#816ea7",
            colourTertiary: "#83759e"
        }
    };
    Blockly.Themes.Tritanopia.categoryStyles = {
        colour_category: {
            colour: "#05427f"
        },
        list_category: {
            colour: "#b69ce8"
        },
        logic_category: {
            colour: "#9fd2f1"
        },
        loop_category: {
            colour: "#aa1846"
        },
        math_category: {
            colour: "#e6da39"
        },
        procedure_category: {
            colour: "#590721"
        },
        text_category: {
            colour: "#058863"
        },
        variable_category: {
            colour: "#4b2d84"
        },
        variable_dynamic_category: {
            colour: "#4b2d84"
        }
    };
    Blockly.Themes.Tritanopia = new Blockly.Theme("tritanopia", Blockly.Themes.Tritanopia.defaultBlockStyles, Blockly.Themes.Tritanopia.categoryStyles);
    Blockly.requires = {};
    return Blockly;
});

});



parcelRegister("gOITV", function(module, exports) {

$parcel$export(module.exports, "Easing", function () { return Easing; });
$parcel$export(module.exports, "Tween", function () { return Tween; });
$parcel$export(module.exports, "getAll", function () { return getAll; });
$parcel$export(module.exports, "removeAll", function () { return removeAll; });
$parcel$export(module.exports, "update", function () { return update; });
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var Easing = {
    Linear: {
        None: function(amount) {
            return amount;
        }
    },
    Quadratic: {
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    },
    Cubic: {
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    },
    Quartic: {
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    },
    Quintic: {
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    },
    Sinusoidal: {
        In: function(amount) {
            return 1 - Math.cos(amount * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.cos(Math.PI * amount));
        }
    },
    Exponential: {
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    },
    Circular: {
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    },
    Elastic: {
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    },
    Back: {
        In: function(amount) {
            var s = 1.70158;
            return amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    },
    Bounce: {
        In: function(amount) {
            return 1 - Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return Easing.Bounce.In(amount * 2) * 0.5;
            return Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }
};
var now;
// Include a performance.now polyfill.
// In node.js, use process.hrtime.
// eslint-disable-next-line
// @ts-ignore
typeof self;
if (typeof self !== 'undefined' && self.performance !== undefined && self.performance.now !== undefined) // This must be bound, because directly assigning this function
// leads to an invocation exception in Chrome.
now = self.performance.now.bind(self.performance);
else if (Date.now !== undefined) now = Date.now;
else now = function() {
    return new Date().getTime();
};
var now$1 = now;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var Group = /** @class */ function() {
    function Group() {
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function(tween) {
        this._tweens[tween.getId()] = tween;
        this._tweensAddedDuringUpdate[tween.getId()] = tween;
    };
    Group.prototype.remove = function(tween) {
        delete this._tweens[tween.getId()];
        delete this._tweensAddedDuringUpdate[tween.getId()];
    };
    Group.prototype.update = function(time, preserve) {
        if (time === void 0) time = now$1();
        if (preserve === void 0) preserve = false;
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return false;
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                var autoStart = !preserve;
                if (tween && tween.update(time, autoStart) === false && !preserve) delete this._tweens[tweenIds[i]];
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
        return true;
    };
    return Group;
}();
/**
 *
 */ var Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    Sequence._nextId = 0;
    return Sequence;
}();
var mainGroup = new Group();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var Tween = /** @class */ function() {
    function Tween(_object, _group) {
        if (_group === void 0) _group = mainGroup;
        this._object = _object;
        this._group = _group;
        this._isPaused = false;
        this._pauseStart = 0;
        this._valuesStart = {};
        this._valuesEnd = {};
        this._valuesStartRepeat = {};
        this._duration = 1000;
        this._initialRepeat = 0;
        this._repeat = 0;
        this._yoyo = false;
        this._isPlaying = false;
        this._reversed = false;
        this._delayTime = 0;
        this._startTime = 0;
        this._easingFunction = Easing.Linear.None;
        this._interpolationFunction = Interpolation.Linear;
        this._chainedTweens = [];
        this._onStartCallbackFired = false;
        this._id = Sequence.nextId();
        this._isChainStopped = false;
        this._goToEnd = false;
    }
    Tween.prototype.getId = function() {
        return this._id;
    };
    Tween.prototype.isPlaying = function() {
        return this._isPlaying;
    };
    Tween.prototype.isPaused = function() {
        return this._isPaused;
    };
    Tween.prototype.to = function(properties, duration) {
        // TODO? restore this, then update the 07_dynamic_to example to set fox
        // tween's to on each update. That way the behavior is opt-in (there's
        // currently no opt-out).
        // for (const prop in properties) this._valuesEnd[prop] = properties[prop]
        this._valuesEnd = Object.create(properties);
        if (duration !== undefined) this._duration = duration;
        return this;
    };
    Tween.prototype.duration = function(d) {
        this._duration = d;
        return this;
    };
    Tween.prototype.start = function(time) {
        if (this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = time !== undefined ? typeof time === 'string' ? now$1() + parseFloat(time) : time : now$1();
        this._startTime += this._delayTime;
        this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat);
        return this;
    };
    Tween.prototype._setupProperties = function(_object, _valuesStart, _valuesEnd, _valuesStartRepeat) {
        for(var property in _valuesEnd){
            var startValue = _object[property];
            var startValueIsArray = Array.isArray(startValue);
            var propType = startValueIsArray ? 'array' : typeof startValue;
            var isInterpolationList = !startValueIsArray && Array.isArray(_valuesEnd[property]);
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (propType === 'undefined' || propType === 'function') continue;
            // Check if an Array was provided as property value
            if (isInterpolationList) {
                var endValues = _valuesEnd[property];
                if (endValues.length === 0) continue;
                // handle an array of relative values
                endValues = endValues.map(this._handleRelativeValue.bind(this, startValue));
                // Create a local copy of the Array with the start value at the front
                _valuesEnd[property] = [
                    startValue
                ].concat(endValues);
            }
            // handle the deepness of the values
            if ((propType === 'object' || startValueIsArray) && startValue && !isInterpolationList) {
                _valuesStart[property] = startValueIsArray ? [] : {};
                // eslint-disable-next-line
                for(var prop in startValue)// eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property][prop] = startValue[prop];
                _valuesStartRepeat[property] = startValueIsArray ? [] : {}; // TODO? repeat nested values? And yoyo? And array values?
                // eslint-disable-next-line
                // @ts-ignore FIXME?
                this._setupProperties(startValue, _valuesStart[property], _valuesEnd[property], _valuesStartRepeat[property]);
            } else {
                // Save the starting value, but only once.
                if (typeof _valuesStart[property] === 'undefined') _valuesStart[property] = startValue;
                if (!startValueIsArray) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                if (isInterpolationList) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStartRepeat[property] = _valuesEnd[property].slice().reverse();
                else _valuesStartRepeat[property] = _valuesStart[property] || 0;
            }
        }
    };
    Tween.prototype.stop = function() {
        if (!this._isChainStopped) {
            this._isChainStopped = true;
            this.stopChainedTweens();
        }
        if (!this._isPlaying) return this;
        // eslint-disable-next-line
        this._group && this._group.remove(this);
        this._isPlaying = false;
        this._isPaused = false;
        if (this._onStopCallback) this._onStopCallback(this._object);
        return this;
    };
    Tween.prototype.end = function() {
        this._goToEnd = true;
        this.update(Infinity);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (time === void 0) time = now$1();
        if (this._isPaused || !this._isPlaying) return this;
        this._isPaused = true;
        this._pauseStart = time;
        // eslint-disable-next-line
        this._group && this._group.remove(this);
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (time === void 0) time = now$1();
        if (!this._isPaused || !this._isPlaying) return this;
        this._isPaused = false;
        this._startTime += time - this._pauseStart;
        this._pauseStart = 0;
        // eslint-disable-next-line
        this._group && this._group.add(this);
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)this._chainedTweens[i].stop();
        return this;
    };
    Tween.prototype.group = function(group) {
        this._group = group;
        return this;
    };
    Tween.prototype.delay = function(amount) {
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        this._initialRepeat = times;
        this._repeat = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this._repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easingFunction) {
        this._easingFunction = easingFunction;
        return this;
    };
    Tween.prototype.interpolation = function(interpolationFunction) {
        this._interpolationFunction = interpolationFunction;
        return this;
    };
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this._onStopCallback = callback;
        return this;
    };
    /**
     * @returns true if the tween is still playing after the update, false
     * otherwise (calling update on a paused tween still returns true because
     * it is still playing, just paused).
     */ Tween.prototype.update = function(time, autoStart) {
        if (time === void 0) time = now$1();
        if (autoStart === void 0) autoStart = true;
        if (this._isPaused) return true;
        var property;
        var elapsed;
        var endTime = this._startTime + this._duration;
        if (!this._goToEnd && !this._isPlaying) {
            if (time > endTime) return false;
            if (autoStart) this.start(time);
        }
        this._goToEnd = false;
        if (time < this._startTime) return true;
        if (this._onStartCallbackFired === false) {
            if (this._onStartCallback) this._onStartCallback(this._object);
            this._onStartCallbackFired = true;
        }
        elapsed = (time - this._startTime) / this._duration;
        elapsed = this._duration === 0 || elapsed > 1 ? 1 : elapsed;
        var value = this._easingFunction(elapsed);
        // properties transformations
        this._updateProperties(this._object, this._valuesStart, this._valuesEnd, value);
        if (this._onUpdateCallback) this._onUpdateCallback(this._object, elapsed);
        if (elapsed === 1) {
            if (this._repeat > 0) {
                if (isFinite(this._repeat)) this._repeat--;
                // Reassign starting values, restart by making startTime = now
                for(property in this._valuesStartRepeat){
                    if (!this._yoyo && typeof this._valuesEnd[property] === 'string') this._valuesStartRepeat[property] = // eslint-disable-next-line
                    // @ts-ignore FIXME?
                    this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                    if (this._yoyo) this._swapEndStartRepeatValues(property);
                    this._valuesStart[property] = this._valuesStartRepeat[property];
                }
                if (this._yoyo) this._reversed = !this._reversed;
                if (this._repeatDelayTime !== undefined) this._startTime = time + this._repeatDelayTime;
                else this._startTime = time + this._delayTime;
                if (this._onRepeatCallback) this._onRepeatCallback(this._object);
                return true;
            } else {
                if (this._onCompleteCallback) this._onCompleteCallback(this._object);
                for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this._chainedTweens[i].start(this._startTime + this._duration);
                this._isPlaying = false;
                return false;
            }
        }
        return true;
    };
    Tween.prototype._updateProperties = function(_object, _valuesStart, _valuesEnd, value) {
        for(var property in _valuesEnd){
            // Don't update properties that do not exist in the source object
            if (_valuesStart[property] === undefined) continue;
            var start = _valuesStart[property] || 0;
            var end = _valuesEnd[property];
            var startIsArray = Array.isArray(_object[property]);
            var endIsArray = Array.isArray(end);
            var isInterpolationList = !startIsArray && endIsArray;
            if (isInterpolationList) _object[property] = this._interpolationFunction(end, value);
            else if (typeof end === 'object' && end) // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._updateProperties(_object[property], start, end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                end = this._handleRelativeValue(start, end);
                // Protect against non numeric properties.
                if (typeof end === 'number') // eslint-disable-next-line
                // @ts-ignore FIXME?
                _object[property] = start + (end - start) * value;
            }
        }
    };
    Tween.prototype._handleRelativeValue = function(start, end) {
        if (typeof end !== 'string') return end;
        if (end.charAt(0) === '+' || end.charAt(0) === '-') return start + parseFloat(end);
        else return parseFloat(end);
    };
    Tween.prototype._swapEndStartRepeatValues = function(property) {
        var tmp = this._valuesStartRepeat[property];
        var endValue = this._valuesEnd[property];
        if (typeof endValue === 'string') this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(endValue);
        else this._valuesStartRepeat[property] = this._valuesEnd[property];
        this._valuesEnd[property] = tmp;
    };
    return Tween;
}();
var VERSION = '18.6.4';
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var nextId = Sequence.nextId;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tweens.
 */ var TWEEN = mainGroup;
// This is the best way to export things in a way that's compatible with both ES
// Modules and CommonJS, without build hacks, and so as not to break the
// existing API.
// https://github.com/rollup/rollup/issues/1961#issuecomment-423037881
var getAll = TWEEN.getAll.bind(TWEEN);
var removeAll = TWEEN.removeAll.bind(TWEEN);
var add = TWEEN.add.bind(TWEEN);
var remove = TWEEN.remove.bind(TWEEN);
var update = TWEEN.update.bind(TWEEN);
var exports = {
    Easing: Easing,
    Group: Group,
    Interpolation: Interpolation,
    now: now$1,
    Sequence: Sequence,
    nextId: nextId,
    Tween: Tween,
    VERSION: VERSION,
    getAll: getAll,
    removeAll: removeAll,
    add: add,
    remove: remove,
    update: update
};
var $c3e4254807100dd0$export$2e2bcd8739ae039 = exports;

});

parcelRegister("iGskC", function(module, exports) {

var $4cLJb = parcelRequire("4cLJb");
class $d9a220518a37cb05$var$Franka extends (0, $4cLJb.default) {
    constructor(){
        super("Franka", "franka_description", "robots/panda_arm_hand.urdf.xacro");
        this.robotRoot = "panda_link0";
        this.handRoot = "panda_hand";
        this.modelScale = 10;
        this.defaultPose = {
            panda_joint1: 0.5,
            panda_joint2: -0.3,
            panda_joint4: -1.8,
            panda_joint6: 1.5,
            panda_joint7: 1.0
        };
        this.tcp.parent = "panda_hand";
        this.tcp.position = [
            0,
            0,
            0.103394
        ];
        this.ikEnabled = [
            "panda_joint1",
            "panda_joint2",
            // 'panda_joint3',
            "panda_joint4"
        ];
        this.interactionJointLimits = {
            panda_joint4: {
                upper: -Math.PI / 6
            }
        };
    }
}
module.exports = new $d9a220518a37cb05$var$Franka();

});
parcelRegister("4cLJb", function(module, exports) {

$parcel$export(module.exports, "getPackage", function () { return $30fd4e20ba823075$export$3972a8b667a037fb; });
$parcel$export(module.exports, "default", function () { return $30fd4e20ba823075$export$2e2bcd8739ae039; });

var $8TfIJ = parcelRequire("8TfIJ");

var $evpiW = parcelRequire("evpiW");

var $4zEWR = parcelRequire("4zEWR");
const $30fd4e20ba823075$export$e47810f58cc4f450 = $4zEWR.join("/Rocksi", "/models/");
const $30fd4e20ba823075$export$3972a8b667a037fb = (name)=>$4zEWR.join($30fd4e20ba823075$export$e47810f58cc4f450, name);
class $30fd4e20ba823075$export$2e2bcd8739ae039 {
    init(model) {
        this.model = model;
        this.joints = model.joints;
        this.links = model.links;
        this.model.scale.set(this.modelScale, this.modelScale, this.modelScale);
        this.tcp.object.position.set(...this.tcp.position);
        this.tcp.object.quaternion.multiply(new (0, $8TfIJ.Quaternion)().setFromEuler(new (0, $8TfIJ.Euler)().set(...this.tcp.rotation)));
        this.getFrame(this.tcp.parent).add(this.tcp.object);
        // Find all joints and links from the robot root up to the hand root
        this.robotRoot = this.getFrame(this.robotRoot);
        (0, $evpiW.traverse)(this.robotRoot, (obj)=>{
            if (obj.name === this.handRoot) return true;
            this.partNames.arm.push(obj.name);
            if (this.isJoint(obj)) {
                this.arm.joints.push(obj);
                if (this.isMovable(obj)) this.arm.movable.push(obj);
            } else if (this.isLink(obj)) this.arm.links.push(obj);
        });
        // Find all joints and links from the hand root onwards
        this.handRoot = this.getFrame(this.handRoot);
        (0, $evpiW.traverse)(this.handRoot, (obj)=>{
            this.partNames.hand.push(obj.name);
            if (this.isJoint(obj)) {
                this.hand.joints.push(obj);
                if (this.isMovable(obj)) this.hand.movable.push(obj);
            } else if (this.isLink(obj)) this.hand.links.push(obj);
        });
        for (let joint of this.hand.movable)joint.states = {
            closed: this.hand.invertOpenClose ? joint.limit.upper : joint.limit.lower,
            opened: this.hand.invertOpenClose ? joint.limit.lower : joint.limit.upper
        };
    }
    onLoadComplete() {}
    get root() {
        return $30fd4e20ba823075$export$e47810f58cc4f450;
    }
    get package() {
        return $4zEWR.join(this.root, this._package);
    }
    get xacro() {
        return $4zEWR.join(this.package, this._xacro);
    }
    setPose(pose) {
        if (Array.isArray(pose)) {
            if (pose.length !== this.arm.movable.length) throw new Error('Array length must be equal to the number of movable joints');
            for(let i = 0; i < pose.length; i++)this.arm.movable[i].setJointValue(pose[i]);
        } else if (typeof pose === 'object') for (let joint of this.arm.movable){
            let value = pose[joint.name];
            if (typeof value === 'number') joint.setJointValue(value);
        }
        else throw new Error('Invalid pose type "' + typeof pose + '"');
    }
    isJoint(part) {
        return part.type === "URDFJoint";
    }
    isLink(part) {
        return part.type === "URDFLink";
    }
    isArm(part) {
        return this.partNames.arm.includes(part.name);
    }
    isHand(part) {
        return this.partNames.hand.includes(part.name);
    }
    isMovable(part) {
        return this.isJoint(part) && part._jointType !== "fixed";
    }
    isIKEnabled(part) {
        return this.ikEnabled.length > 0 ? this.ikEnabled.includes(part.name) : this.isMovable(part) && this.isArm(part);
    }
    isGripperOpen() {
        return this.getGripperAbduction() >= 0.5;
    }
    getGripperAbduction() {
        if (this.hand.movable.length === 0) return 0;
        // Average abduction of all hand joints
        let abduction = 0.0;
        for (let joint of this.hand.movable){
            let val = joint.angle;
            let upper = joint.limit.upper;
            let lower = joint.limit.lower;
            let rel = (val - lower) / (upper - lower);
            abduction += rel;
        }
        abduction /= this.hand.movable.length;
        return abduction;
    }
    getJointForLink(link) {
        if (typeof link === "string") link = this.model.links[link];
        let p = link.parent;
        while(p){
            if (this.isJoint(p)) return p;
            p = p.parent;
        }
        return null;
    }
    getLinkForJoint(joint) {
        if (typeof joint === "string") joint = this.model.joints[joint];
        for (let c of joint.children){
            if (this.isLink(c)) return c;
        }
        return null;
    }
    getFrame(name) {
        return this.model.frames[name];
    }
    createSkeleton() {
        let pos = new (0, $8TfIJ.Vector3)();
        let parent = new (0, $8TfIJ.Bone)();
        let skeleton = {
            origin: this.model,
            root: parent,
            bones: [],
            tip: this.tcp.object
        };
        for (let joint of this.arm.movable){
            let link = this.getLinkForJoint(joint);
            link.getWorldPosition(pos);
            let bone = new (0, $8TfIJ.Bone)();
            bone.robotJoint = joint;
            parent.add(bone);
            parent.lookAt(pos);
            parent.updateMatrixWorld(); // crucial for worldToLocal!
            bone.position.copy(bone.worldToLocal(pos));
            skeleton.bones.push(bone);
            parent = bone;
        }
        return skeleton;
    }
    constructor(name, packagename, xacro){
        this.name = name;
        this._package = packagename + '/';
        this._xacro = xacro;
        // Whether to use orientation based gripping
        this.useAdvancedGripping = true;
        // This will store the model loaded by URDFLoader
        this.model = {};
        this.links = [];
        this.joints = [];
        // Required for find_package
        this.packages = {
            get [packagename] () {
                return $30fd4e20ba823075$export$3972a8b667a037fb(packagename);
            }
        };
        // Parts of the arm, filled by init()
        this.arm = {
            joints: [],
            movable: [],
            links: []
        };
        // Parts of the hand, filled by init()
        this.hand = {
            joints: [],
            movable: [],
            links: [],
            invertOpenClose: false
        };
        this.robotRoot = "";
        this.handRoot = "";
        /* =============================================================
         * Everything past here should be filled by the deriving classes 
         * ============================================================= */ // Additional macros that will be required for loading the Xacro
        this.rosMacros = {};
        this.modelScale = 1;
        // Names of links and joints grouped by what they belong to
        this.partNames = {
            arm: [],
            hand: []
        };
        // Default pose of the robot
        this.defaultPose = {
        }, // Location of the handle used for moving the robot
        this.tcp = {
            parent: "",
            // Distance and euler angles from hand origin to finger tip
            position: [
                0,
                0,
                0
            ],
            rotation: [
                0,
                0,
                0
            ],
            object: new (0, $8TfIJ.Object3D)()
        };
        // Joint names that the robot is allowed to use for moving
        this.ikEnabled = [];
        // Additional joint limits
        this.interactionJointLimits = {
        };
        // Velocities to move a joint one unit 
        // (m/s for prismatic joints, rad/s for revolute joints)
        this.maxSpeed = {
            move: 1.0,
            gripper: 0.2
        };
        // Blockly Generator instance that can convert the blockly workspace 
        // into code that can be run on the robot
        this.generator = null;
    }
}

});
parcelRegister("8TfIJ", function(module, exports) {

$parcel$export(module.exports, "MOUSE", function () { return $678fa78e22f406a1$export$7177b3e430c2d7ca; });
$parcel$export(module.exports, "TOUCH", function () { return $678fa78e22f406a1$export$d46bd3ead7cc759b; });
$parcel$export(module.exports, "FrontSide", function () { return $678fa78e22f406a1$export$2ede184fc2998901; });
$parcel$export(module.exports, "DoubleSide", function () { return $678fa78e22f406a1$export$3b296b6f144d5b03; });
$parcel$export(module.exports, "RepeatWrapping", function () { return $678fa78e22f406a1$export$533346c8e8dac0f5; });
$parcel$export(module.exports, "ClampToEdgeWrapping", function () { return $678fa78e22f406a1$export$9d9334239a5a5e06; });
$parcel$export(module.exports, "LinearMipmapLinearFilter", function () { return $678fa78e22f406a1$export$5d8599b6a933fb1b; });
$parcel$export(module.exports, "EventDispatcher", function () { return $678fa78e22f406a1$export$ec8b666c5fe2c75a; });
$parcel$export(module.exports, "Vector2", function () { return $678fa78e22f406a1$export$c977b3e384af9ae1; });
$parcel$export(module.exports, "Quaternion", function () { return $678fa78e22f406a1$export$23d6a54f0bbc85a3; });
$parcel$export(module.exports, "Vector3", function () { return $678fa78e22f406a1$export$64b5c384219d3699; });
$parcel$export(module.exports, "Box3", function () { return $678fa78e22f406a1$export$6f7d5a9418ab2aa3; });
$parcel$export(module.exports, "Matrix4", function () { return $678fa78e22f406a1$export$2ae72fc923e5eb5; });
$parcel$export(module.exports, "Euler", function () { return $678fa78e22f406a1$export$d93cc409a0768c5f; });
$parcel$export(module.exports, "Object3D", function () { return $678fa78e22f406a1$export$e4dd07dff30cc924; });
$parcel$export(module.exports, "Plane", function () { return $678fa78e22f406a1$export$7ff5ac152ef991b0; });
$parcel$export(module.exports, "Triangle", function () { return $678fa78e22f406a1$export$5a465592bfe74b48; });
$parcel$export(module.exports, "Material", function () { return $678fa78e22f406a1$export$a2d8b23205c25948; });
$parcel$export(module.exports, "Color", function () { return $678fa78e22f406a1$export$892596cec99bc70e; });
$parcel$export(module.exports, "MeshBasicMaterial", function () { return $678fa78e22f406a1$export$55cbcc9b622fe1f5; });
$parcel$export(module.exports, "BufferAttribute", function () { return $678fa78e22f406a1$export$8dea267bd6bde117; });
$parcel$export(module.exports, "Float32BufferAttribute", function () { return $678fa78e22f406a1$export$cbe7a62641830ebd; });
$parcel$export(module.exports, "BufferGeometry", function () { return $678fa78e22f406a1$export$b7be63a67df8959; });
$parcel$export(module.exports, "Mesh", function () { return $678fa78e22f406a1$export$e176487c05830cc5; });
$parcel$export(module.exports, "BoxBufferGeometry", function () { return $678fa78e22f406a1$export$ab3456a079aa7d80; });
$parcel$export(module.exports, "PerspectiveCamera", function () { return $678fa78e22f406a1$export$74e4ae24825f68d7; });
$parcel$export(module.exports, "Group", function () { return $678fa78e22f406a1$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "WebGLRenderer", function () { return $678fa78e22f406a1$export$f6cc00ef28d7cf97; });
$parcel$export(module.exports, "Scene", function () { return $678fa78e22f406a1$export$38af1803e3442a7f; });
$parcel$export(module.exports, "SkinnedMesh", function () { return $678fa78e22f406a1$export$b303577035157ecf; });
$parcel$export(module.exports, "Bone", function () { return $678fa78e22f406a1$export$b127726e56765aa4; });
$parcel$export(module.exports, "Skeleton", function () { return $678fa78e22f406a1$export$8f31e4c4a37b8e9c; });
$parcel$export(module.exports, "LineBasicMaterial", function () { return $678fa78e22f406a1$export$fbaaa33907730a0c; });
$parcel$export(module.exports, "Line", function () { return $678fa78e22f406a1$export$17d680238e50603e; });
$parcel$export(module.exports, "LineSegments", function () { return $678fa78e22f406a1$export$ff1ed10fedfdd604; });
$parcel$export(module.exports, "PointsMaterial", function () { return $678fa78e22f406a1$export$a178c45366ce5d6b; });
$parcel$export(module.exports, "Points", function () { return $678fa78e22f406a1$export$1c787534cb11aa3e; });
$parcel$export(module.exports, "CylinderBufferGeometry", function () { return $678fa78e22f406a1$export$d4345c83207d7c68; });
$parcel$export(module.exports, "SphereBufferGeometry", function () { return $678fa78e22f406a1$export$d5d06a966fec4192; });
$parcel$export(module.exports, "MeshPhongMaterial", function () { return $678fa78e22f406a1$export$24c72f71cbaf0678; });
$parcel$export(module.exports, "MeshLambertMaterial", function () { return $678fa78e22f406a1$export$5023a9a8114806b8; });
$parcel$export(module.exports, "QuaternionKeyframeTrack", function () { return $678fa78e22f406a1$export$b8043f12b5aafbd7; });
$parcel$export(module.exports, "VectorKeyframeTrack", function () { return $678fa78e22f406a1$export$5ce2dcb4cc9f2bff; });
$parcel$export(module.exports, "AnimationClip", function () { return $678fa78e22f406a1$export$d942c706bf23829c; });
$parcel$export(module.exports, "LoadingManager", function () { return $678fa78e22f406a1$export$99cc795e99919eed; });
$parcel$export(module.exports, "DefaultLoadingManager", function () { return $678fa78e22f406a1$export$b033c3f9a95c6a16; });
$parcel$export(module.exports, "Loader", function () { return $678fa78e22f406a1$export$3b0d6d7590275603; });
$parcel$export(module.exports, "FileLoader", function () { return $678fa78e22f406a1$export$98435a25b5cf7b2b; });
$parcel$export(module.exports, "DataTextureLoader", function () { return $678fa78e22f406a1$export$792d8a18f2c55855; });
$parcel$export(module.exports, "TextureLoader", function () { return $678fa78e22f406a1$export$fd1bfc71f64c538c; });
$parcel$export(module.exports, "HemisphereLight", function () { return $678fa78e22f406a1$export$8d474f55edbb9624; });
$parcel$export(module.exports, "SpotLight", function () { return $678fa78e22f406a1$export$81495cbb73897362; });
$parcel$export(module.exports, "PointLight", function () { return $678fa78e22f406a1$export$4c9c1cb3f0b6f455; });
$parcel$export(module.exports, "OrthographicCamera", function () { return $678fa78e22f406a1$export$9ebf355ee4ed261b; });
$parcel$export(module.exports, "DirectionalLight", function () { return $678fa78e22f406a1$export$3fea33cc9972c868; });
$parcel$export(module.exports, "AmbientLight", function () { return $678fa78e22f406a1$export$af279bfef9ec2c96; });
$parcel$export(module.exports, "LoaderUtils", function () { return $678fa78e22f406a1$export$b5d2dc08d867e41a; });
$parcel$export(module.exports, "Raycaster", function () { return $678fa78e22f406a1$export$8b7aaceff00bd2f; });
$parcel$export(module.exports, "Spherical", function () { return $678fa78e22f406a1$export$d712cd887b4a00f7; });
$parcel$export(module.exports, "Line3", function () { return $678fa78e22f406a1$export$e0ba6359f1954fd3; });
$parcel$export(module.exports, "GridHelper", function () { return $678fa78e22f406a1$export$3875d39926561055; });
$parcel$export(module.exports, "ArrowHelper", function () { return $678fa78e22f406a1$export$a3008e7bd8d2cbe7; });
$parcel$export(module.exports, "BoxGeometry", function () { return $678fa78e22f406a1$export$ab3456a079aa7d80; });
$parcel$export(module.exports, "CylinderGeometry", function () { return $678fa78e22f406a1$export$d4345c83207d7c68; });
$parcel$export(module.exports, "MathUtils", function () { return $678fa78e22f406a1$export$380958644dbbc22b; });
$parcel$export(module.exports, "OctahedronGeometry", function () { return $678fa78e22f406a1$export$8e05fc91596f4752; });
$parcel$export(module.exports, "PlaneGeometry", function () { return $678fa78e22f406a1$export$e789a11a194ca4e0; });
$parcel$export(module.exports, "SphereGeometry", function () { return $678fa78e22f406a1$export$d5d06a966fec4192; });
$parcel$export(module.exports, "TorusGeometry", function () { return $678fa78e22f406a1$export$19d55f905fa4f2cb; });
/**
 * @license
 * Copyright 2010-2021 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $4Z4w2 = parcelRequire("4Z4w2");
const $678fa78e22f406a1$export$3545e07a80636437 = '129';
const $678fa78e22f406a1$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $678fa78e22f406a1$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $678fa78e22f406a1$export$3237e1f2c1ea1f44 = 0;
const $678fa78e22f406a1$export$b9a7b4fc5cb15f9b = 1;
const $678fa78e22f406a1$export$b8058bcc7037d3f3 = 2;
const $678fa78e22f406a1$export$f24be24dcddeac0d = 3;
const $678fa78e22f406a1$export$346307dbae2b7447 = 0;
const $678fa78e22f406a1$export$5813f879eee7cd88 = 1;
const $678fa78e22f406a1$export$a47c4b43a1be34f0 = 2;
const $678fa78e22f406a1$export$896ae1ade6c829c4 = 3;
const $678fa78e22f406a1$export$2ede184fc2998901 = 0;
const $678fa78e22f406a1$export$d9f0486e75b5ace = 1;
const $678fa78e22f406a1$export$3b296b6f144d5b03 = 2;
const $678fa78e22f406a1$export$a62047d29c96d8ff = 1;
const $678fa78e22f406a1$export$fadb74c06a7f490 = 2;
const $678fa78e22f406a1$export$63b8d6b580fc65ba = 0;
const $678fa78e22f406a1$export$5b29a26d96ee6af0 = 1;
const $678fa78e22f406a1$export$777d8f9551c2216b = 2;
const $678fa78e22f406a1$export$cdfa06f868e2e467 = 3;
const $678fa78e22f406a1$export$4138e1c684b46a20 = 4;
const $678fa78e22f406a1$export$eda4864c68df1fa2 = 5;
const $678fa78e22f406a1$export$20183a0484ce21a0 = 100;
const $678fa78e22f406a1$export$73e0df5177988548 = 101;
const $678fa78e22f406a1$export$28e582859cbec660 = 102;
const $678fa78e22f406a1$export$c8c1508da8d0600c = 103;
const $678fa78e22f406a1$export$99948c02fb51055f = 104;
const $678fa78e22f406a1$export$2110f05edf778d3d = 200;
const $678fa78e22f406a1$export$8805bad65e24940e = 201;
const $678fa78e22f406a1$export$7fbe15b28d28cf52 = 202;
const $678fa78e22f406a1$export$947829af9f2c17f6 = 203;
const $678fa78e22f406a1$export$d5773124e86cf28c = 204;
const $678fa78e22f406a1$export$11d468cc7f19e971 = 205;
const $678fa78e22f406a1$export$a78aed1ca2a87192 = 206;
const $678fa78e22f406a1$export$5d0fe17fd8773bac = 207;
const $678fa78e22f406a1$export$ef5f2dd8ffac5574 = 208;
const $678fa78e22f406a1$export$56b85b2686ab16 = 209;
const $678fa78e22f406a1$export$c05e2a1fc8609506 = 210;
const $678fa78e22f406a1$export$69025ce147cee220 = 0;
const $678fa78e22f406a1$export$7182eb52ea3b3f04 = 1;
const $678fa78e22f406a1$export$eedccec66ab7ebe = 2;
const $678fa78e22f406a1$export$296f78a0b892f81a = 3;
const $678fa78e22f406a1$export$a60d398fc7b7590e = 4;
const $678fa78e22f406a1$export$7d7234c1240a1fc4 = 5;
const $678fa78e22f406a1$export$c5e2c52991f30937 = 6;
const $678fa78e22f406a1$export$2f843afa843d8916 = 7;
const $678fa78e22f406a1$export$e50ac29801f1774d = 0;
const $678fa78e22f406a1$export$9f9d94f963c85479 = 1;
const $678fa78e22f406a1$export$e641dc52bc3494aa = 2;
const $678fa78e22f406a1$export$9fcb6b4294603b2 = 0;
const $678fa78e22f406a1$export$98f52c2a46c598ca = 1;
const $678fa78e22f406a1$export$74b25e54b3bcd548 = 2;
const $678fa78e22f406a1$export$932b3dd283d4a366 = 3;
const $678fa78e22f406a1$export$a0d98fe6d7e4af64 = 4;
const $678fa78e22f406a1$export$2c7b09c1e9abfb5e = 5;
const $678fa78e22f406a1$export$1beec6768cbb3d2d = 300;
const $678fa78e22f406a1$export$8759762a6477f2c4 = 301;
const $678fa78e22f406a1$export$dc59f8aed047f61d = 302;
const $678fa78e22f406a1$export$d64030b316d3b087 = 303;
const $678fa78e22f406a1$export$ee99d97d46898098 = 304;
const $678fa78e22f406a1$export$dbf3e70ff37af79 = 306;
const $678fa78e22f406a1$export$76a9f4355364345c = 307;
const $678fa78e22f406a1$export$533346c8e8dac0f5 = 1000;
const $678fa78e22f406a1$export$9d9334239a5a5e06 = 1001;
const $678fa78e22f406a1$export$c7e7c00b14f51a4f = 1002;
const $678fa78e22f406a1$export$727aa5ec3fe39bf0 = 1003;
const $678fa78e22f406a1$export$d129e38cf6feaa8c = 1004;
const $678fa78e22f406a1$export$14a4936464a36496 = 1004;
const $678fa78e22f406a1$export$d2327c1afe5bfdf2 = 1005;
const $678fa78e22f406a1$export$cbc5b7f5647595d8 = 1005;
const $678fa78e22f406a1$export$8a72f490b25c56c8 = 1006;
const $678fa78e22f406a1$export$19a719f377145a13 = 1007;
const $678fa78e22f406a1$export$dbe96bee3fe9dbf0 = 1007;
const $678fa78e22f406a1$export$5d8599b6a933fb1b = 1008;
const $678fa78e22f406a1$export$90d80f1e3506775f = 1008;
const $678fa78e22f406a1$export$2e8ce08d3f6f5e10 = 1009;
const $678fa78e22f406a1$export$545fce0311a9796a = 1010;
const $678fa78e22f406a1$export$88572337f312435f = 1011;
const $678fa78e22f406a1$export$c63dc51868b06a9d = 1012;
const $678fa78e22f406a1$export$5c612977753abe2 = 1013;
const $678fa78e22f406a1$export$c3c7fc4518ebba96 = 1014;
const $678fa78e22f406a1$export$f6d331659b644596 = 1015;
const $678fa78e22f406a1$export$2697304443f382bc = 1016;
const $678fa78e22f406a1$export$b3969b01faf587f2 = 1017;
const $678fa78e22f406a1$export$18886f8ae33e90de = 1018;
const $678fa78e22f406a1$export$cb1fa50553eb14c4 = 1019;
const $678fa78e22f406a1$export$6c8ea339bfab1301 = 1020;
const $678fa78e22f406a1$export$988473390501ed4b = 1021;
const $678fa78e22f406a1$export$7c67423a5ee6f5eb = 1022;
const $678fa78e22f406a1$export$3f8bb04b555a363c = 1023;
const $678fa78e22f406a1$export$cc09ccbf6d1ed449 = 1024;
const $678fa78e22f406a1$export$9053a81c4a69c289 = 1025;
const $678fa78e22f406a1$export$7f419e36e2229a1d = $678fa78e22f406a1$export$3f8bb04b555a363c;
const $678fa78e22f406a1$export$c1b6b5136be58045 = 1026;
const $678fa78e22f406a1$export$1e113ac2d0905829 = 1027;
const $678fa78e22f406a1$export$4e041a7967d15c4b = 1028;
const $678fa78e22f406a1$export$aa92e870a709d190 = 1029;
const $678fa78e22f406a1$export$6cdf0b461c7ce8a0 = 1030;
const $678fa78e22f406a1$export$1ba1c45f9f77d4d7 = 1031;
const $678fa78e22f406a1$export$d1fd40c11bfa798e = 1032;
const $678fa78e22f406a1$export$c200e7d26f592f21 = 1033;
const $678fa78e22f406a1$export$21d1799c6d552fc0 = 33776;
const $678fa78e22f406a1$export$afa304c3e981b668 = 33777;
const $678fa78e22f406a1$export$d2a1a68024a3e56c = 33778;
const $678fa78e22f406a1$export$9a79c424327dacf9 = 33779;
const $678fa78e22f406a1$export$19ada9bbb1af3573 = 35840;
const $678fa78e22f406a1$export$d0f0355bb3d948e4 = 35841;
const $678fa78e22f406a1$export$b82296714358084c = 35842;
const $678fa78e22f406a1$export$b71692456c47b6c3 = 35843;
const $678fa78e22f406a1$export$6ab91af2d757aee7 = 36196;
const $678fa78e22f406a1$export$7800993ef8106a6a = 37492;
const $678fa78e22f406a1$export$23ed8300a860e7d8 = 37496;
const $678fa78e22f406a1$export$dc5570b4a2b92d48 = 37808;
const $678fa78e22f406a1$export$68880cd325f8b2fb = 37809;
const $678fa78e22f406a1$export$7d2c0be323373d95 = 37810;
const $678fa78e22f406a1$export$22b52da301fc3a3e = 37811;
const $678fa78e22f406a1$export$c009e2cb4a66485e = 37812;
const $678fa78e22f406a1$export$118fff5afa255b63 = 37813;
const $678fa78e22f406a1$export$120713c829ae0667 = 37814;
const $678fa78e22f406a1$export$c79eeabbf53313e9 = 37815;
const $678fa78e22f406a1$export$443cf6567cdd6424 = 37816;
const $678fa78e22f406a1$export$6573984fc9840780 = 37817;
const $678fa78e22f406a1$export$e7aee563f30091de = 37818;
const $678fa78e22f406a1$export$2eb8634622ddeab7 = 37819;
const $678fa78e22f406a1$export$202b1ce7b5d25742 = 37820;
const $678fa78e22f406a1$export$18ab77abd087e467 = 37821;
const $678fa78e22f406a1$export$ce40b115e188bc81 = 36492;
const $678fa78e22f406a1$export$4487000d1baf578b = 37840;
const $678fa78e22f406a1$export$4a1746c7512b1ea1 = 37841;
const $678fa78e22f406a1$export$4208debc782f5653 = 37842;
const $678fa78e22f406a1$export$82c5f9d3037aaea3 = 37843;
const $678fa78e22f406a1$export$64e357a152723eb9 = 37844;
const $678fa78e22f406a1$export$1b7711037f5e380e = 37845;
const $678fa78e22f406a1$export$eb234716dfb52c31 = 37846;
const $678fa78e22f406a1$export$8041d2df79c555f = 37847;
const $678fa78e22f406a1$export$27d2c8c0fcc7b83a = 37848;
const $678fa78e22f406a1$export$27b9de07b84a1334 = 37849;
const $678fa78e22f406a1$export$5c2b31a31ccc15c8 = 37850;
const $678fa78e22f406a1$export$5c4d4b335786f8f3 = 37851;
const $678fa78e22f406a1$export$e0c50c800e38be11 = 37852;
const $678fa78e22f406a1$export$9b0442bae422b2db = 37853;
const $678fa78e22f406a1$export$d62fdc9d1b1cccad = 2200;
const $678fa78e22f406a1$export$dfaf4422ce096e29 = 2201;
const $678fa78e22f406a1$export$f8f6f2041b78e210 = 2202;
const $678fa78e22f406a1$export$995b32462a65e855 = 2300;
const $678fa78e22f406a1$export$30fac1aace31cf4d = 2301;
const $678fa78e22f406a1$export$198b11ff4c72bb30 = 2302;
const $678fa78e22f406a1$export$7f795934b84ab523 = 2400;
const $678fa78e22f406a1$export$24a4ccb5099273b5 = 2401;
const $678fa78e22f406a1$export$8e8c3ecdcd8e1fee = 2402;
const $678fa78e22f406a1$export$bcfbbdcf8de7f8cd = 2500;
const $678fa78e22f406a1$export$d875e029ef558d3 = 2501;
const $678fa78e22f406a1$export$4c28c87c2dc84758 = 0;
const $678fa78e22f406a1$export$b23a071aa286eb29 = 1;
const $678fa78e22f406a1$export$f0d8293634f88842 = 2;
const $678fa78e22f406a1$export$7207336e4151a112 = 3000;
const $678fa78e22f406a1$export$f32388edbb32674 = 3001;
const $678fa78e22f406a1$export$eaab32c1bcea1817 = 3007;
const $678fa78e22f406a1$export$3be4c466a12b5dcf = 3002;
const $678fa78e22f406a1$export$8d4cbbeb1eea9f67 = 3003;
const $678fa78e22f406a1$export$2c4bdfd76b188654 = 3004;
const $678fa78e22f406a1$export$48a0051d6a5a9b9 = 3005;
const $678fa78e22f406a1$export$ca2f89b13b49d951 = 3006;
const $678fa78e22f406a1$export$deeb383078690b50 = 3200;
const $678fa78e22f406a1$export$8f910f4c4f73df11 = 3201;
const $678fa78e22f406a1$export$2852a58ebdac27b8 = 0;
const $678fa78e22f406a1$export$9990ad26f9db5b2c = 1;
const $678fa78e22f406a1$export$69433f11f42d5527 = 0;
const $678fa78e22f406a1$export$9f542ae4b5baca34 = 7680;
const $678fa78e22f406a1$export$8a4f28336ef203d3 = 7681;
const $678fa78e22f406a1$export$2928c0231297c036 = 7682;
const $678fa78e22f406a1$export$c0e9611c8a15f9a8 = 7683;
const $678fa78e22f406a1$export$9c2c08927385dcc4 = 34055;
const $678fa78e22f406a1$export$7c74ea00fa1315e6 = 34056;
const $678fa78e22f406a1$export$22e2e5726612443 = 5386;
const $678fa78e22f406a1$export$1343870698229224 = 512;
const $678fa78e22f406a1$export$8e1d8ed281997fa6 = 513;
const $678fa78e22f406a1$export$55648a1cde8329a7 = 514;
const $678fa78e22f406a1$export$2dff107857e6aca2 = 515;
const $678fa78e22f406a1$export$6f93765ab2f451a2 = 516;
const $678fa78e22f406a1$export$6f3fb2d2440f2b76 = 517;
const $678fa78e22f406a1$export$4119cf7b4c98fd5a = 518;
const $678fa78e22f406a1$export$14cf96713ddd97a8 = 519;
const $678fa78e22f406a1$export$763e8360f4d7f77d = 35044;
const $678fa78e22f406a1$export$8505d14ac8546ca = 35048;
const $678fa78e22f406a1$export$721e63549e51d81e = 35040;
const $678fa78e22f406a1$export$415731dc4f48e299 = 35045;
const $678fa78e22f406a1$export$9e809946455f13bc = 35049;
const $678fa78e22f406a1$export$2ed9499a35b5f832 = 35041;
const $678fa78e22f406a1$export$32ab2503ea19469a = 35046;
const $678fa78e22f406a1$export$ab4022c2c3f86315 = 35050;
const $678fa78e22f406a1$export$ba7f1db36a76a970 = 35042;
const $678fa78e22f406a1$export$43600cc67fabd9f = '100';
const $678fa78e22f406a1$export$f63012db5506e7dd = '300 es';
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $678fa78e22f406a1$var$_lut = [];
for(let i = 0; i < 256; i++)$678fa78e22f406a1$var$_lut[i] = (i < 16 ? '0' : '') + i.toString(16);
let $678fa78e22f406a1$var$_seed = 1234567;
const $678fa78e22f406a1$var$DEG2RAD = Math.PI / 180;
const $678fa78e22f406a1$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $678fa78e22f406a1$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $678fa78e22f406a1$var$_lut[d0 & 0xff] + $678fa78e22f406a1$var$_lut[d0 >> 8 & 0xff] + $678fa78e22f406a1$var$_lut[d0 >> 16 & 0xff] + $678fa78e22f406a1$var$_lut[d0 >> 24 & 0xff] + '-' + $678fa78e22f406a1$var$_lut[d1 & 0xff] + $678fa78e22f406a1$var$_lut[d1 >> 8 & 0xff] + '-' + $678fa78e22f406a1$var$_lut[d1 >> 16 & 0x0f | 0x40] + $678fa78e22f406a1$var$_lut[d1 >> 24 & 0xff] + '-' + $678fa78e22f406a1$var$_lut[d2 & 0x3f | 0x80] + $678fa78e22f406a1$var$_lut[d2 >> 8 & 0xff] + '-' + $678fa78e22f406a1$var$_lut[d2 >> 16 & 0xff] + $678fa78e22f406a1$var$_lut[d2 >> 24 & 0xff] + $678fa78e22f406a1$var$_lut[d3 & 0xff] + $678fa78e22f406a1$var$_lut[d3 >> 8 & 0xff] + $678fa78e22f406a1$var$_lut[d3 >> 16 & 0xff] + $678fa78e22f406a1$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
function $678fa78e22f406a1$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidian modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $678fa78e22f406a1$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $678fa78e22f406a1$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $678fa78e22f406a1$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $678fa78e22f406a1$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $678fa78e22f406a1$var$damp(x, y, lambda, dt) {
    return $678fa78e22f406a1$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $678fa78e22f406a1$var$pingpong(x, length = 1) {
    return length - Math.abs($678fa78e22f406a1$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $678fa78e22f406a1$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $678fa78e22f406a1$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $678fa78e22f406a1$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $678fa78e22f406a1$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $678fa78e22f406a1$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $678fa78e22f406a1$var$seededRandom(s) {
    if (s !== undefined) $678fa78e22f406a1$var$_seed = s % 2147483647;
    // Park-Miller algorithm
    $678fa78e22f406a1$var$_seed = $678fa78e22f406a1$var$_seed * 16807 % 2147483647;
    return ($678fa78e22f406a1$var$_seed - 1) / 2147483646;
}
function $678fa78e22f406a1$var$degToRad(degrees) {
    return degrees * $678fa78e22f406a1$var$DEG2RAD;
}
function $678fa78e22f406a1$var$radToDeg(radians) {
    return radians * $678fa78e22f406a1$var$RAD2DEG;
}
function $678fa78e22f406a1$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $678fa78e22f406a1$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $678fa78e22f406a1$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $678fa78e22f406a1$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
var $678fa78e22f406a1$export$380958644dbbc22b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $678fa78e22f406a1$var$DEG2RAD,
    RAD2DEG: $678fa78e22f406a1$var$RAD2DEG,
    generateUUID: $678fa78e22f406a1$var$generateUUID,
    clamp: $678fa78e22f406a1$var$clamp,
    euclideanModulo: $678fa78e22f406a1$var$euclideanModulo,
    mapLinear: $678fa78e22f406a1$var$mapLinear,
    inverseLerp: $678fa78e22f406a1$var$inverseLerp,
    lerp: $678fa78e22f406a1$var$lerp,
    damp: $678fa78e22f406a1$var$damp,
    pingpong: $678fa78e22f406a1$var$pingpong,
    smoothstep: $678fa78e22f406a1$var$smoothstep,
    smootherstep: $678fa78e22f406a1$var$smootherstep,
    randInt: $678fa78e22f406a1$var$randInt,
    randFloat: $678fa78e22f406a1$var$randFloat,
    randFloatSpread: $678fa78e22f406a1$var$randFloatSpread,
    seededRandom: $678fa78e22f406a1$var$seededRandom,
    degToRad: $678fa78e22f406a1$var$degToRad,
    radToDeg: $678fa78e22f406a1$var$radToDeg,
    isPowerOfTwo: $678fa78e22f406a1$var$isPowerOfTwo,
    ceilPowerOfTwo: $678fa78e22f406a1$var$ceilPowerOfTwo,
    floorPowerOfTwo: $678fa78e22f406a1$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $678fa78e22f406a1$var$setQuaternionFromProperEuler
});
class $678fa78e22f406a1$export$c977b3e384af9ae1 {
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector2: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
}
$678fa78e22f406a1$export$c977b3e384af9ae1.prototype.isVector2 = true;
class $678fa78e22f406a1$export$8ff26dafa08918 {
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.');
    }
}
$678fa78e22f406a1$export$8ff26dafa08918.prototype.isMatrix3 = true;
let $678fa78e22f406a1$var$_canvas;
class $678fa78e22f406a1$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($678fa78e22f406a1$var$_canvas === undefined) $678fa78e22f406a1$var$_canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
            $678fa78e22f406a1$var$_canvas.width = image.width;
            $678fa78e22f406a1$var$_canvas.height = image.height;
            const context = $678fa78e22f406a1$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $678fa78e22f406a1$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
}
let $678fa78e22f406a1$var$textureId = 0;
class $678fa78e22f406a1$export$5431306cf43de24a extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.image = source.image;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (this.image !== undefined) {
            // TODO: Move to THREE.Image
            const image = this.image;
            if (image.uuid === undefined) image.uuid = $678fa78e22f406a1$var$generateUUID(); // UGH
            if (!isRootObject && meta.images[image.uuid] === undefined) {
                let url;
                if (Array.isArray(image)) {
                    // process array of images e.g. CubeTexture
                    url = [];
                    for(let i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                    if (image[i].isDataTexture) url.push($678fa78e22f406a1$var$serializeImage(image[i].image));
                    else url.push($678fa78e22f406a1$var$serializeImage(image[i]));
                } else // process single image
                url = $678fa78e22f406a1$var$serializeImage(image);
                meta.images[image.uuid] = {
                    uuid: image.uuid,
                    url: url
                };
            }
            output.image = image.uuid;
        }
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $678fa78e22f406a1$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $678fa78e22f406a1$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $678fa78e22f406a1$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $678fa78e22f406a1$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $678fa78e22f406a1$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $678fa78e22f406a1$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $678fa78e22f406a1$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    constructor(image = $678fa78e22f406a1$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $678fa78e22f406a1$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $678fa78e22f406a1$export$9d9334239a5a5e06, wrapT = $678fa78e22f406a1$export$9d9334239a5a5e06, magFilter = $678fa78e22f406a1$export$8a72f490b25c56c8, minFilter = $678fa78e22f406a1$export$5d8599b6a933fb1b, format = $678fa78e22f406a1$export$3f8bb04b555a363c, type = $678fa78e22f406a1$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $678fa78e22f406a1$export$7207336e4151a112){
        super();
        Object.defineProperty(this, 'id', {
            value: $678fa78e22f406a1$var$textureId++
        });
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        this.name = '';
        this.image = image;
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $678fa78e22f406a1$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.center = new $678fa78e22f406a1$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $678fa78e22f406a1$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.version = 0;
        this.onUpdate = null;
    }
}
$678fa78e22f406a1$export$5431306cf43de24a.DEFAULT_IMAGE = undefined;
$678fa78e22f406a1$export$5431306cf43de24a.DEFAULT_MAPPING = $678fa78e22f406a1$export$1beec6768cbb3d2d;
$678fa78e22f406a1$export$5431306cf43de24a.prototype.isTexture = true;
function $678fa78e22f406a1$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $678fa78e22f406a1$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
class $678fa78e22f406a1$export$fa7daccca11cdbe3 {
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector4: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
}
$678fa78e22f406a1$export$fa7daccca11cdbe3.prototype.isVector4 = true;
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $678fa78e22f406a1$export$3c052beb2e51e23f extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    setTexture(texture) {
        texture.image = {
            width: this.width,
            height: this.height,
            depth: this.depth
        };
        this.texture = texture;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.image = (0, $4Z4w2._)({}, this.texture.image); // See #20328.
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    constructor(width, height, options){
        super();
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 0, width, height);
        options = options || {};
        this.texture = new $678fa78e22f406a1$export$5431306cf43de24a(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.image = {};
        this.texture.image.width = width;
        this.texture.image.height = height;
        this.texture.image.depth = 1;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $678fa78e22f406a1$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    }
}
$678fa78e22f406a1$export$3c052beb2e51e23f.prototype.isWebGLRenderTarget = true;
class $678fa78e22f406a1$export$bd934554fb721730 extends $678fa78e22f406a1$export$3c052beb2e51e23f {
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++)this.texture[i] = source.texture[i].clone();
        return this;
    }
    constructor(width, height, count){
        super(width, height);
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++)this.texture[i] = texture.clone();
    }
}
$678fa78e22f406a1$export$bd934554fb721730.prototype.isWebGLMultipleRenderTargets = true;
class $678fa78e22f406a1$export$cb2022643d3c928d extends $678fa78e22f406a1$export$3c052beb2e51e23f {
    copy(source) {
        super.copy.call(this, source);
        this.samples = source.samples;
        return this;
    }
    constructor(width, height, options){
        super(width, height, options);
        this.samples = 4;
    }
}
$678fa78e22f406a1$export$cb2022643d3c928d.prototype.isWebGLMultisampleRenderTarget = true;
class $678fa78e22f406a1$export$23d6a54f0bbc85a3 {
    static slerp(qa, qb, qm, t) {
        console.warn('THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.');
        return qm.slerpQuaternions(qa, qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error('THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.');
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($678fa78e22f406a1$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn('THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.');
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        this.copy(qa).slerp(qb, t);
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    constructor(x = 0, y = 0, z = 0, w = 1){
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
}
$678fa78e22f406a1$export$23d6a54f0bbc85a3.prototype.isQuaternion = true;
class $678fa78e22f406a1$export$64b5c384219d3699 {
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.');
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error('THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.');
        return this.applyQuaternion($678fa78e22f406a1$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($678fa78e22f406a1$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.');
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $678fa78e22f406a1$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($678fa78e22f406a1$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($678fa78e22f406a1$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($678fa78e22f406a1$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector3: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
$678fa78e22f406a1$export$64b5c384219d3699.prototype.isVector3 = true;
const $678fa78e22f406a1$var$_vector$c = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_quaternion$4 = /*@__PURE__*/ new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
class $678fa78e22f406a1$export$6f7d5a9418ab2aa3 {
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $678fa78e22f406a1$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object) {
        this.makeEmpty();
        return this.expandByObject(object);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .getCenter() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .getSize() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (geometry.boundingBox === null) geometry.computeBoundingBox();
            $678fa78e22f406a1$var$_box$3.copy(geometry.boundingBox);
            $678fa78e22f406a1$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($678fa78e22f406a1$var$_box$3);
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i]);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        if (target === undefined) {
            console.warn('THREE.Box3: .getParameter() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $678fa78e22f406a1$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $678fa78e22f406a1$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($678fa78e22f406a1$var$_center);
        $678fa78e22f406a1$var$_extents.subVectors(this.max, $678fa78e22f406a1$var$_center);
        // translate triangle to aabb origin
        $678fa78e22f406a1$var$_v0$2.subVectors(triangle.a, $678fa78e22f406a1$var$_center);
        $678fa78e22f406a1$var$_v1$7.subVectors(triangle.b, $678fa78e22f406a1$var$_center);
        $678fa78e22f406a1$var$_v2$3.subVectors(triangle.c, $678fa78e22f406a1$var$_center);
        // compute edge vectors for triangle
        $678fa78e22f406a1$var$_f0.subVectors($678fa78e22f406a1$var$_v1$7, $678fa78e22f406a1$var$_v0$2);
        $678fa78e22f406a1$var$_f1.subVectors($678fa78e22f406a1$var$_v2$3, $678fa78e22f406a1$var$_v1$7);
        $678fa78e22f406a1$var$_f2.subVectors($678fa78e22f406a1$var$_v0$2, $678fa78e22f406a1$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$678fa78e22f406a1$var$_f0.z,
            $678fa78e22f406a1$var$_f0.y,
            0,
            -$678fa78e22f406a1$var$_f1.z,
            $678fa78e22f406a1$var$_f1.y,
            0,
            -$678fa78e22f406a1$var$_f2.z,
            $678fa78e22f406a1$var$_f2.y,
            $678fa78e22f406a1$var$_f0.z,
            0,
            -$678fa78e22f406a1$var$_f0.x,
            $678fa78e22f406a1$var$_f1.z,
            0,
            -$678fa78e22f406a1$var$_f1.x,
            $678fa78e22f406a1$var$_f2.z,
            0,
            -$678fa78e22f406a1$var$_f2.x,
            -$678fa78e22f406a1$var$_f0.y,
            $678fa78e22f406a1$var$_f0.x,
            0,
            -$678fa78e22f406a1$var$_f1.y,
            $678fa78e22f406a1$var$_f1.x,
            0,
            -$678fa78e22f406a1$var$_f2.y,
            $678fa78e22f406a1$var$_f2.x,
            0
        ];
        if (!$678fa78e22f406a1$var$satForAxes(axes, $678fa78e22f406a1$var$_v0$2, $678fa78e22f406a1$var$_v1$7, $678fa78e22f406a1$var$_v2$3, $678fa78e22f406a1$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$678fa78e22f406a1$var$satForAxes(axes, $678fa78e22f406a1$var$_v0$2, $678fa78e22f406a1$var$_v1$7, $678fa78e22f406a1$var$_v2$3, $678fa78e22f406a1$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $678fa78e22f406a1$var$_triangleNormal.crossVectors($678fa78e22f406a1$var$_f0, $678fa78e22f406a1$var$_f1);
        axes = [
            $678fa78e22f406a1$var$_triangleNormal.x,
            $678fa78e22f406a1$var$_triangleNormal.y,
            $678fa78e22f406a1$var$_triangleNormal.z
        ];
        return $678fa78e22f406a1$var$satForAxes(axes, $678fa78e22f406a1$var$_v0$2, $678fa78e22f406a1$var$_v1$7, $678fa78e22f406a1$var$_v2$3, $678fa78e22f406a1$var$_extents);
    }
    clampPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .clampPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $678fa78e22f406a1$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        if (target === undefined) console.error('THREE.Box3: .getBoundingSphere() target is now required');
        this.getCenter(target.center);
        target.radius = this.getSize($678fa78e22f406a1$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $678fa78e22f406a1$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $678fa78e22f406a1$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $678fa78e22f406a1$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $678fa78e22f406a1$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $678fa78e22f406a1$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $678fa78e22f406a1$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $678fa78e22f406a1$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $678fa78e22f406a1$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($678fa78e22f406a1$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    constructor(min = new $678fa78e22f406a1$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $678fa78e22f406a1$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
}
$678fa78e22f406a1$export$6f7d5a9418ab2aa3.prototype.isBox3 = true;
const $678fa78e22f406a1$var$_points = [
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699()
];
const $678fa78e22f406a1$var$_vector$b = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_box$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $678fa78e22f406a1$var$_v0$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v1$7 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v2$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
// triangle edge vectors
const $678fa78e22f406a1$var$_f0 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_f1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_f2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_center = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_extents = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_triangleNormal = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_testAxis = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
function $678fa78e22f406a1$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $678fa78e22f406a1$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        const r = extents.x * Math.abs($678fa78e22f406a1$var$_testAxis.x) + extents.y * Math.abs($678fa78e22f406a1$var$_testAxis.y) + extents.z * Math.abs($678fa78e22f406a1$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        const p0 = v0.dot($678fa78e22f406a1$var$_testAxis);
        const p1 = v1.dot($678fa78e22f406a1$var$_testAxis);
        const p2 = v2.dot($678fa78e22f406a1$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
const $678fa78e22f406a1$var$_box$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
const $678fa78e22f406a1$var$_v1$6 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_toFarthestPoint = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_toPoint = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$805e8b72413ccaba {
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $678fa78e22f406a1$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        if (target === undefined) {
            console.warn('THREE.Sphere: .clampPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (target === undefined) {
            console.warn('THREE.Sphere: .getBoundingBox() target is now required');
            target = new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
        }
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $678fa78e22f406a1$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $678fa78e22f406a1$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($678fa78e22f406a1$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        $678fa78e22f406a1$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($678fa78e22f406a1$var$_v1$6.copy(sphere.center).add($678fa78e22f406a1$var$_toFarthestPoint));
        this.expandByPoint($678fa78e22f406a1$var$_v1$6.copy(sphere.center).sub($678fa78e22f406a1$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(center = new $678fa78e22f406a1$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
}
const $678fa78e22f406a1$var$_vector$a = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_segCenter = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_segDir = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_diff = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_edge1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_edge2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_normal$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$a186db52eed6d40e {
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        if (target === undefined) {
            console.warn('THREE.Ray: .at() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $678fa78e22f406a1$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Ray: .closestPointToPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $678fa78e22f406a1$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $678fa78e22f406a1$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $678fa78e22f406a1$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $678fa78e22f406a1$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $678fa78e22f406a1$var$_segDir.copy(v1).sub(v0).normalize();
        $678fa78e22f406a1$var$_diff.copy(this.origin).sub($678fa78e22f406a1$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($678fa78e22f406a1$var$_segDir);
        const b0 = $678fa78e22f406a1$var$_diff.dot(this.direction);
        const b1 = -$678fa78e22f406a1$var$_diff.dot($678fa78e22f406a1$var$_segDir);
        const c = $678fa78e22f406a1$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($678fa78e22f406a1$var$_segDir).multiplyScalar(s1).add($678fa78e22f406a1$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $678fa78e22f406a1$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $678fa78e22f406a1$var$_vector$a.dot(this.direction);
        const d2 = $678fa78e22f406a1$var$_vector$a.dot($678fa78e22f406a1$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $678fa78e22f406a1$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $678fa78e22f406a1$var$_edge1.subVectors(b, a);
        $678fa78e22f406a1$var$_edge2.subVectors(c, a);
        $678fa78e22f406a1$var$_normal$1.crossVectors($678fa78e22f406a1$var$_edge1, $678fa78e22f406a1$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($678fa78e22f406a1$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $678fa78e22f406a1$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($678fa78e22f406a1$var$_edge2.crossVectors($678fa78e22f406a1$var$_diff, $678fa78e22f406a1$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($678fa78e22f406a1$var$_edge1.cross($678fa78e22f406a1$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $678fa78e22f406a1$var$_diff.dot($678fa78e22f406a1$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(origin = new $678fa78e22f406a1$export$64b5c384219d3699(), direction = new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
}
class $678fa78e22f406a1$export$2ae72fc923e5eb5 {
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $678fa78e22f406a1$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $678fa78e22f406a1$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $678fa78e22f406a1$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $678fa78e22f406a1$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error('THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.');
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($678fa78e22f406a1$var$_zero, q, $678fa78e22f406a1$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $678fa78e22f406a1$var$_z.subVectors(eye, target);
        if ($678fa78e22f406a1$var$_z.lengthSq() === 0) // eye and target are in the same position
        $678fa78e22f406a1$var$_z.z = 1;
        $678fa78e22f406a1$var$_z.normalize();
        $678fa78e22f406a1$var$_x.crossVectors(up, $678fa78e22f406a1$var$_z);
        if ($678fa78e22f406a1$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $678fa78e22f406a1$var$_z.x += 0.0001;
            else $678fa78e22f406a1$var$_z.z += 0.0001;
            $678fa78e22f406a1$var$_z.normalize();
            $678fa78e22f406a1$var$_x.crossVectors(up, $678fa78e22f406a1$var$_z);
        }
        $678fa78e22f406a1$var$_x.normalize();
        $678fa78e22f406a1$var$_y.crossVectors($678fa78e22f406a1$var$_z, $678fa78e22f406a1$var$_x);
        te[0] = $678fa78e22f406a1$var$_x.x;
        te[4] = $678fa78e22f406a1$var$_y.x;
        te[8] = $678fa78e22f406a1$var$_z.x;
        te[1] = $678fa78e22f406a1$var$_x.y;
        te[5] = $678fa78e22f406a1$var$_y.y;
        te[9] = $678fa78e22f406a1$var$_z.y;
        te[2] = $678fa78e22f406a1$var$_x.z;
        te[6] = $678fa78e22f406a1$var$_y.z;
        te[10] = $678fa78e22f406a1$var$_z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn('THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.');
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $678fa78e22f406a1$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $678fa78e22f406a1$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $678fa78e22f406a1$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $678fa78e22f406a1$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $678fa78e22f406a1$var$_m1$2.elements[0] *= invSX;
        $678fa78e22f406a1$var$_m1$2.elements[1] *= invSX;
        $678fa78e22f406a1$var$_m1$2.elements[2] *= invSX;
        $678fa78e22f406a1$var$_m1$2.elements[4] *= invSY;
        $678fa78e22f406a1$var$_m1$2.elements[5] *= invSY;
        $678fa78e22f406a1$var$_m1$2.elements[6] *= invSY;
        $678fa78e22f406a1$var$_m1$2.elements[8] *= invSZ;
        $678fa78e22f406a1$var$_m1$2.elements[9] *= invSZ;
        $678fa78e22f406a1$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($678fa78e22f406a1$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn('THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.');
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
    constructor(){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.');
    }
}
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
const $678fa78e22f406a1$var$_v1$5 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_m1$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_zero = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 0);
const $678fa78e22f406a1$var$_one = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(1, 1, 1);
const $678fa78e22f406a1$var$_x = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_y = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_z = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_matrix$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_quaternion$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
class $678fa78e22f406a1$export$d93cc409a0768c5f {
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order || this._order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order, update) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        order = order || this._order;
        switch(order){
            case 'XYZ':
                this._y = Math.asin($678fa78e22f406a1$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$678fa78e22f406a1$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($678fa78e22f406a1$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$678fa78e22f406a1$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($678fa78e22f406a1$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$678fa78e22f406a1$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $678fa78e22f406a1$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($678fa78e22f406a1$var$_matrix$1, order, update);
    }
    setFromVector3(v, order) {
        return this.set(v.x, v.y, v.z, order || this._order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $678fa78e22f406a1$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($678fa78e22f406a1$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    toVector3(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new $678fa78e22f406a1$export$64b5c384219d3699(this._x, this._y, this._z);
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    constructor(x = 0, y = 0, z = 0, order = $678fa78e22f406a1$export$d93cc409a0768c5f.DefaultOrder){
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
}
$678fa78e22f406a1$export$d93cc409a0768c5f.prototype.isEuler = true;
$678fa78e22f406a1$export$d93cc409a0768c5f.DefaultOrder = 'XYZ';
$678fa78e22f406a1$export$d93cc409a0768c5f.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
class $678fa78e22f406a1$export$89312ce47c0ca777 {
    set(channel) {
        this.mask = 1 << channel | 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    constructor(){
        this.mask = 1;
    }
}
let $678fa78e22f406a1$var$_object3DId = 0;
const $678fa78e22f406a1$var$_v1$4 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_q1 = /*@__PURE__*/ new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
const $678fa78e22f406a1$var$_m1$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_target = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_position$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_scale$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_quaternion$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
const $678fa78e22f406a1$var$_xAxis = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(1, 0, 0);
const $678fa78e22f406a1$var$_yAxis = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0);
const $678fa78e22f406a1$var$_zAxis = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 1);
const $678fa78e22f406a1$var$_addedEvent = {
    type: 'added'
};
const $678fa78e22f406a1$var$_removedEvent = {
    type: 'removed'
};
class $678fa78e22f406a1$export$e4dd07dff30cc924 extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $678fa78e22f406a1$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($678fa78e22f406a1$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $678fa78e22f406a1$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($678fa78e22f406a1$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($678fa78e22f406a1$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($678fa78e22f406a1$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($678fa78e22f406a1$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $678fa78e22f406a1$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($678fa78e22f406a1$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($678fa78e22f406a1$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($678fa78e22f406a1$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($678fa78e22f406a1$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($678fa78e22f406a1$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $678fa78e22f406a1$var$_target.copy(x);
        else $678fa78e22f406a1$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $678fa78e22f406a1$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $678fa78e22f406a1$var$_m1$1.lookAt($678fa78e22f406a1$var$_position$3, $678fa78e22f406a1$var$_target, this.up);
        else $678fa78e22f406a1$var$_m1$1.lookAt($678fa78e22f406a1$var$_target, $678fa78e22f406a1$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($678fa78e22f406a1$var$_m1$1);
        if (parent) {
            $678fa78e22f406a1$var$_m1$1.extractRotation(parent.matrixWorld);
            $678fa78e22f406a1$var$_q1.setFromRotationMatrix($678fa78e22f406a1$var$_m1$1);
            this.quaternion.premultiply($678fa78e22f406a1$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($678fa78e22f406a1$var$_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($678fa78e22f406a1$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($678fa78e22f406a1$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        this.updateWorldMatrix(true, false);
        $678fa78e22f406a1$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $678fa78e22f406a1$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($678fa78e22f406a1$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldPosition() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldQuaternion() target is now required');
            target = new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
        }
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($678fa78e22f406a1$var$_position$3, target, $678fa78e22f406a1$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldScale() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($678fa78e22f406a1$var$_position$3, $678fa78e22f406a1$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldDirection() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {}
            };
            output.metadata = {
                version: 4.5,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
    constructor(){
        super();
        Object.defineProperty(this, 'id', {
            value: $678fa78e22f406a1$var$_object3DId++
        });
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $678fa78e22f406a1$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $678fa78e22f406a1$export$64b5c384219d3699();
        const rotation = new $678fa78e22f406a1$export$d93cc409a0768c5f();
        const quaternion = new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
        const scale = new $678fa78e22f406a1$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $678fa78e22f406a1$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $678fa78e22f406a1$export$8ff26dafa08918()
            }
        });
        this.matrix = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        this.matrixWorld = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $678fa78e22f406a1$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $678fa78e22f406a1$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
}
$678fa78e22f406a1$export$e4dd07dff30cc924.DefaultUp = new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0);
$678fa78e22f406a1$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
$678fa78e22f406a1$export$e4dd07dff30cc924.prototype.isObject3D = true;
const $678fa78e22f406a1$var$_vector1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vector2$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_normalMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$8ff26dafa08918();
class $678fa78e22f406a1$export$7ff5ac152ef991b0 {
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $678fa78e22f406a1$var$_vector1.subVectors(c, b).cross($678fa78e22f406a1$var$_vector2$1.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .projectPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .intersectLine() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        const direction = line.delta($678fa78e22f406a1$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .coplanarPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $678fa78e22f406a1$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($678fa78e22f406a1$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(normal = new $678fa78e22f406a1$export$64b5c384219d3699(1, 0, 0), constant = 0){
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
}
$678fa78e22f406a1$export$7ff5ac152ef991b0.prototype.isPlane = true;
const $678fa78e22f406a1$var$_v0$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v1$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v2$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v3$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vab = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vac = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vbc = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vap = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vbp = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vcp = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$5a465592bfe74b48 {
    static getNormal(a, b, c, target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getNormal() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        target.subVectors(c, b);
        $678fa78e22f406a1$var$_v0$1.subVectors(a, b);
        target.cross($678fa78e22f406a1$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $678fa78e22f406a1$var$_v0$1.subVectors(c, a);
        $678fa78e22f406a1$var$_v1$3.subVectors(b, a);
        $678fa78e22f406a1$var$_v2$2.subVectors(point, a);
        const dot00 = $678fa78e22f406a1$var$_v0$1.dot($678fa78e22f406a1$var$_v0$1);
        const dot01 = $678fa78e22f406a1$var$_v0$1.dot($678fa78e22f406a1$var$_v1$3);
        const dot02 = $678fa78e22f406a1$var$_v0$1.dot($678fa78e22f406a1$var$_v2$2);
        const dot11 = $678fa78e22f406a1$var$_v1$3.dot($678fa78e22f406a1$var$_v1$3);
        const dot12 = $678fa78e22f406a1$var$_v1$3.dot($678fa78e22f406a1$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        if (target === undefined) {
            console.warn('THREE.Triangle: .getBarycoord() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $678fa78e22f406a1$var$_v3$1);
        return $678fa78e22f406a1$var$_v3$1.x >= 0 && $678fa78e22f406a1$var$_v3$1.y >= 0 && $678fa78e22f406a1$var$_v3$1.x + $678fa78e22f406a1$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $678fa78e22f406a1$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $678fa78e22f406a1$var$_v3$1.x);
        target.addScaledVector(uv2, $678fa78e22f406a1$var$_v3$1.y);
        target.addScaledVector(uv3, $678fa78e22f406a1$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $678fa78e22f406a1$var$_v0$1.subVectors(c, b);
        $678fa78e22f406a1$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $678fa78e22f406a1$var$_v0$1.cross($678fa78e22f406a1$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $678fa78e22f406a1$var$_v0$1.subVectors(this.c, this.b);
        $678fa78e22f406a1$var$_v1$3.subVectors(this.a, this.b);
        return $678fa78e22f406a1$var$_v0$1.cross($678fa78e22f406a1$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getMidpoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $678fa78e22f406a1$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getPlane() target is now required');
            target = new $678fa78e22f406a1$export$7ff5ac152ef991b0();
        }
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $678fa78e22f406a1$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $678fa78e22f406a1$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $678fa78e22f406a1$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $678fa78e22f406a1$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .closestPointToPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $678fa78e22f406a1$var$_vab.subVectors(b, a);
        $678fa78e22f406a1$var$_vac.subVectors(c, a);
        $678fa78e22f406a1$var$_vap.subVectors(p, a);
        const d1 = $678fa78e22f406a1$var$_vab.dot($678fa78e22f406a1$var$_vap);
        const d2 = $678fa78e22f406a1$var$_vac.dot($678fa78e22f406a1$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $678fa78e22f406a1$var$_vbp.subVectors(p, b);
        const d3 = $678fa78e22f406a1$var$_vab.dot($678fa78e22f406a1$var$_vbp);
        const d4 = $678fa78e22f406a1$var$_vac.dot($678fa78e22f406a1$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($678fa78e22f406a1$var$_vab, v);
        }
        $678fa78e22f406a1$var$_vcp.subVectors(p, c);
        const d5 = $678fa78e22f406a1$var$_vab.dot($678fa78e22f406a1$var$_vcp);
        const d6 = $678fa78e22f406a1$var$_vac.dot($678fa78e22f406a1$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($678fa78e22f406a1$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $678fa78e22f406a1$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($678fa78e22f406a1$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($678fa78e22f406a1$var$_vab, v).addScaledVector($678fa78e22f406a1$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
    constructor(a = new $678fa78e22f406a1$export$64b5c384219d3699(), b = new $678fa78e22f406a1$export$64b5c384219d3699(), c = new $678fa78e22f406a1$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
}
let $678fa78e22f406a1$var$materialId = 0;
class $678fa78e22f406a1$export$a2d8b23205c25948 extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    onBuild() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                continue;
            }
            // for backward compatability if shading is set in the constructor
            if (key === 'shading') {
                console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
                this.flatShading = newValue === $678fa78e22f406a1$export$a62047d29c96d8ff ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen && this.sheen.isColor) data.sheen = this.sheen.getHex();
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $678fa78e22f406a1$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $678fa78e22f406a1$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.morphTargets === true) data.morphTargets = true;
        if (this.morphNormals === true) data.morphNormals = true;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.fog = source.fog;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    constructor(){
        super();
        Object.defineProperty(this, 'id', {
            value: $678fa78e22f406a1$var$materialId++
        });
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.fog = true;
        this.blending = $678fa78e22f406a1$export$5b29a26d96ee6af0;
        this.side = $678fa78e22f406a1$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $678fa78e22f406a1$export$d5773124e86cf28c;
        this.blendDst = $678fa78e22f406a1$export$11d468cc7f19e971;
        this.blendEquation = $678fa78e22f406a1$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $678fa78e22f406a1$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $678fa78e22f406a1$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $678fa78e22f406a1$export$9f542ae4b5baca34;
        this.stencilZFail = $678fa78e22f406a1$export$9f542ae4b5baca34;
        this.stencilZPass = $678fa78e22f406a1$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaTest = 0;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
    }
}
$678fa78e22f406a1$export$a2d8b23205c25948.prototype.isMaterial = true;
const $678fa78e22f406a1$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $678fa78e22f406a1$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $678fa78e22f406a1$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $678fa78e22f406a1$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $678fa78e22f406a1$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $678fa78e22f406a1$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class $678fa78e22f406a1$export$892596cec99bc70e {
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === 'number') this.setHex(value);
        else if (typeof value === 'string') this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        return this;
    }
    setRGB(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    setHSL(h, s, l) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $678fa78e22f406a1$var$euclideanModulo(h, 1);
        s = $678fa78e22f406a1$var$clamp(s, 0, 1);
        l = $678fa78e22f406a1$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $678fa78e22f406a1$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $678fa78e22f406a1$var$hue2rgb(q, p, h);
            this.b = $678fa78e22f406a1$var$hue2rgb(q, p, h - 1 / 3);
        }
        return this;
    }
    setStyle(style) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style);
        return this;
    }
    setColorName(style) {
        // color keywords
        const hex = $678fa78e22f406a1$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copyGammaToLinear(color, gammaFactor = 2.0) {
        this.r = Math.pow(color.r, gammaFactor);
        this.g = Math.pow(color.g, gammaFactor);
        this.b = Math.pow(color.b, gammaFactor);
        return this;
    }
    copyLinearToGamma(color, gammaFactor = 2.0) {
        const safeInverse = gammaFactor > 0 ? 1.0 / gammaFactor : 1.0;
        this.r = Math.pow(color.r, safeInverse);
        this.g = Math.pow(color.g, safeInverse);
        this.b = Math.pow(color.b, safeInverse);
        return this;
    }
    convertGammaToLinear(gammaFactor) {
        this.copyGammaToLinear(this, gammaFactor);
        return this;
    }
    convertLinearToGamma(gammaFactor) {
        this.copyLinearToGamma(this, gammaFactor);
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $678fa78e22f406a1$var$SRGBToLinear(color.r);
        this.g = $678fa78e22f406a1$var$SRGBToLinear(color.g);
        this.b = $678fa78e22f406a1$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $678fa78e22f406a1$var$LinearToSRGB(color.r);
        this.g = $678fa78e22f406a1$var$LinearToSRGB(color.g);
        this.b = $678fa78e22f406a1$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex() {
        return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
    }
    getHexString() {
        return ('000000' + this.getHex().toString(16)).slice(-6);
    }
    getHSL(target) {
        // h,s,l ranges are in 0.0 - 1.0
        if (target === undefined) {
            console.warn('THREE.Color: .getHSL() target is now required');
            target = {
                h: 0,
                s: 0,
                l: 0
            };
        }
        const r = this.r, g = this.g, b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getStyle() {
        return 'rgb(' + (this.r * 255 | 0) + ',' + (this.g * 255 | 0) + ',' + (this.b * 255 | 0) + ')';
    }
    offsetHSL(h, s, l) {
        this.getHSL($678fa78e22f406a1$var$_hslA);
        $678fa78e22f406a1$var$_hslA.h += h;
        $678fa78e22f406a1$var$_hslA.s += s;
        $678fa78e22f406a1$var$_hslA.l += l;
        this.setHSL($678fa78e22f406a1$var$_hslA.h, $678fa78e22f406a1$var$_hslA.s, $678fa78e22f406a1$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($678fa78e22f406a1$var$_hslA);
        color.getHSL($678fa78e22f406a1$var$_hslB);
        const h = $678fa78e22f406a1$var$lerp($678fa78e22f406a1$var$_hslA.h, $678fa78e22f406a1$var$_hslB.h, alpha);
        const s = $678fa78e22f406a1$var$lerp($678fa78e22f406a1$var$_hslA.s, $678fa78e22f406a1$var$_hslB.s, alpha);
        const l = $678fa78e22f406a1$var$lerp($678fa78e22f406a1$var$_hslA.l, $678fa78e22f406a1$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    constructor(r, g, b){
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
}
$678fa78e22f406a1$export$892596cec99bc70e.NAMES = $678fa78e22f406a1$var$_colorKeywords;
$678fa78e22f406a1$export$892596cec99bc70e.prototype.isColor = true;
$678fa78e22f406a1$export$892596cec99bc70e.prototype.r = 1;
$678fa78e22f406a1$export$892596cec99bc70e.prototype.g = 1;
$678fa78e22f406a1$export$892596cec99bc70e.prototype.b = 1;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>
 * }
 */ class $678fa78e22f406a1$export$55cbcc9b622fe1f5 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'MeshBasicMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $678fa78e22f406a1$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.morphTargets = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$55cbcc9b622fe1f5.prototype.isMeshBasicMaterial = true;
const $678fa78e22f406a1$var$_vector$9 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vector2 = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
class $678fa78e22f406a1$export$8dea267bd6bde117 {
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    copyColorsArray(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', i);
                color = new $678fa78e22f406a1$export$892596cec99bc70e();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    }
    copyVector2sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i);
                vector = new $678fa78e22f406a1$export$c977b3e384af9ae1();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    }
    copyVector3sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i);
                vector = new $678fa78e22f406a1$export$64b5c384219d3699();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    }
    copyVector4sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i);
                vector = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector2.fromBufferAttribute(this, i);
            $678fa78e22f406a1$var$_vector2.applyMatrix3(m);
            this.setXY(i, $678fa78e22f406a1$var$_vector2.x, $678fa78e22f406a1$var$_vector2.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$9.fromBufferAttribute(this, i);
            $678fa78e22f406a1$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$9.x, $678fa78e22f406a1$var$_vector$9.y, $678fa78e22f406a1$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$9.x = this.getX(i);
            $678fa78e22f406a1$var$_vector$9.y = this.getY(i);
            $678fa78e22f406a1$var$_vector$9.z = this.getZ(i);
            $678fa78e22f406a1$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$9.x, $678fa78e22f406a1$var$_vector$9.y, $678fa78e22f406a1$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$9.x = this.getX(i);
            $678fa78e22f406a1$var$_vector$9.y = this.getY(i);
            $678fa78e22f406a1$var$_vector$9.z = this.getZ(i);
            $678fa78e22f406a1$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$9.x, $678fa78e22f406a1$var$_vector$9.y, $678fa78e22f406a1$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$9.x = this.getX(i);
            $678fa78e22f406a1$var$_vector$9.y = this.getY(i);
            $678fa78e22f406a1$var$_vector$9.z = this.getZ(i);
            $678fa78e22f406a1$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$9.x, $678fa78e22f406a1$var$_vector$9.y, $678fa78e22f406a1$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        return this.array[index * this.itemSize];
    }
    setX(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        return this.array[index * this.itemSize + 1];
    }
    setY(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        return this.array[index * this.itemSize + 2];
    }
    setZ(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        return this.array[index * this.itemSize + 3];
    }
    setW(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $678fa78e22f406a1$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $678fa78e22f406a1$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
}
$678fa78e22f406a1$export$8dea267bd6bde117.prototype.isBufferAttribute = true;
//
class $678fa78e22f406a1$export$f9ff2d6a20248cbf extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$cacc90cf35d11cdd extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$baaa85a1a812c157 extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$2b755a102ccdcefe extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$640a853f68025f2e extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$46b369aed2968a0a extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$7eb8c9fa25cd5bd6 extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$dbd3698c64958d69 extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
$678fa78e22f406a1$export$dbd3698c64958d69.prototype.isFloat16BufferAttribute = true;
class $678fa78e22f406a1$export$cbe7a62641830ebd extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $678fa78e22f406a1$export$9e0ade74842adbb8 extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
function $678fa78e22f406a1$var$arrayMax(array) {
    if (array.length === 0) return -Infinity;
    let max = array[0];
    for(let i = 1, l = array.length; i < l; ++i)if (array[i] > max) max = array[i];
    return max;
}
const $678fa78e22f406a1$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $678fa78e22f406a1$var$getTypedArray(type, buffer) {
    return new $678fa78e22f406a1$var$TYPED_ARRAYS[type](buffer);
}
let $678fa78e22f406a1$var$_id = 0;
const $678fa78e22f406a1$var$_m1 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_obj = /*@__PURE__*/ new $678fa78e22f406a1$export$e4dd07dff30cc924();
const $678fa78e22f406a1$var$_offset = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_box$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
const $678fa78e22f406a1$var$_boxMorphTargets = /*@__PURE__*/ new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
const $678fa78e22f406a1$var$_vector$8 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$b7be63a67df8959 extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($678fa78e22f406a1$var$arrayMax(index) > 65535 ? $678fa78e22f406a1$export$7eb8c9fa25cd5bd6 : $678fa78e22f406a1$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $678fa78e22f406a1$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $678fa78e22f406a1$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($678fa78e22f406a1$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $678fa78e22f406a1$var$_m1.makeRotationX(angle);
        this.applyMatrix4($678fa78e22f406a1$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $678fa78e22f406a1$var$_m1.makeRotationY(angle);
        this.applyMatrix4($678fa78e22f406a1$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $678fa78e22f406a1$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($678fa78e22f406a1$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $678fa78e22f406a1$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($678fa78e22f406a1$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $678fa78e22f406a1$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($678fa78e22f406a1$var$_m1);
        return this;
    }
    lookAt(vector) {
        $678fa78e22f406a1$var$_obj.lookAt(vector);
        $678fa78e22f406a1$var$_obj.updateMatrix();
        this.applyMatrix4($678fa78e22f406a1$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($678fa78e22f406a1$var$_offset).negate();
        this.translate($678fa78e22f406a1$var$_offset.x, $678fa78e22f406a1$var$_offset.y, $678fa78e22f406a1$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $678fa78e22f406a1$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $678fa78e22f406a1$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $678fa78e22f406a1$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $678fa78e22f406a1$var$_vector$8.addVectors(this.boundingBox.min, $678fa78e22f406a1$var$_box$1.min);
                    this.boundingBox.expandByPoint($678fa78e22f406a1$var$_vector$8);
                    $678fa78e22f406a1$var$_vector$8.addVectors(this.boundingBox.max, $678fa78e22f406a1$var$_box$1.max);
                    this.boundingBox.expandByPoint($678fa78e22f406a1$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($678fa78e22f406a1$var$_box$1.min);
                    this.boundingBox.expandByPoint($678fa78e22f406a1$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $678fa78e22f406a1$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $678fa78e22f406a1$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $678fa78e22f406a1$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $678fa78e22f406a1$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $678fa78e22f406a1$var$_vector$8.addVectors($678fa78e22f406a1$var$_box$1.min, $678fa78e22f406a1$var$_boxMorphTargets.min);
                    $678fa78e22f406a1$var$_box$1.expandByPoint($678fa78e22f406a1$var$_vector$8);
                    $678fa78e22f406a1$var$_vector$8.addVectors($678fa78e22f406a1$var$_box$1.max, $678fa78e22f406a1$var$_boxMorphTargets.max);
                    $678fa78e22f406a1$var$_box$1.expandByPoint($678fa78e22f406a1$var$_vector$8);
                } else {
                    $678fa78e22f406a1$var$_box$1.expandByPoint($678fa78e22f406a1$var$_boxMorphTargets.min);
                    $678fa78e22f406a1$var$_box$1.expandByPoint($678fa78e22f406a1$var$_boxMorphTargets.max);
                }
            }
            $678fa78e22f406a1$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $678fa78e22f406a1$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($678fa78e22f406a1$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $678fa78e22f406a1$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $678fa78e22f406a1$var$_offset.fromBufferAttribute(position, j);
                        $678fa78e22f406a1$var$_vector$8.add($678fa78e22f406a1$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($678fa78e22f406a1$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeFaceNormals() {
    // backwards compatibility
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (attributes.tangent === undefined) this.setAttribute('tangent', new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = attributes.tangent.array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $678fa78e22f406a1$export$64b5c384219d3699();
            tan2[i] = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        const vA = new $678fa78e22f406a1$export$64b5c384219d3699(), vB = new $678fa78e22f406a1$export$64b5c384219d3699(), vC = new $678fa78e22f406a1$export$64b5c384219d3699(), uvA = new $678fa78e22f406a1$export$c977b3e384af9ae1(), uvB = new $678fa78e22f406a1$export$c977b3e384af9ae1(), uvC = new $678fa78e22f406a1$export$c977b3e384af9ae1(), sdir = new $678fa78e22f406a1$export$64b5c384219d3699(), tdir = new $678fa78e22f406a1$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $678fa78e22f406a1$export$64b5c384219d3699(), tmp2 = new $678fa78e22f406a1$export$64b5c384219d3699();
        const n = new $678fa78e22f406a1$export$64b5c384219d3699(), n2 = new $678fa78e22f406a1$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $678fa78e22f406a1$export$64b5c384219d3699(), pB = new $678fa78e22f406a1$export$64b5c384219d3699(), pC = new $678fa78e22f406a1$export$64b5c384219d3699();
            const nA = new $678fa78e22f406a1$export$64b5c384219d3699(), nB = new $678fa78e22f406a1$export$64b5c384219d3699(), nC = new $678fa78e22f406a1$export$64b5c384219d3699();
            const cb = new $678fa78e22f406a1$export$64b5c384219d3699(), ab = new $678fa78e22f406a1$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $678fa78e22f406a1$var$_vector$8.fromBufferAttribute(normals, i);
            $678fa78e22f406a1$var$_vector$8.normalize();
            normals.setXYZ(i, $678fa78e22f406a1$var$_vector$8.x, $678fa78e22f406a1$var$_vector$8.y, $678fa78e22f406a1$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $678fa78e22f406a1$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $678fa78e22f406a1$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        /*
		 // Handle primitives

		 const parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 const values = [];

		 for ( const key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 const geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */ return new $678fa78e22f406a1$export$b7be63a67df8959().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    constructor(){
        super();
        Object.defineProperty(this, 'id', {
            value: $678fa78e22f406a1$var$_id++
        });
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
}
$678fa78e22f406a1$export$b7be63a67df8959.prototype.isBufferGeometry = true;
const $678fa78e22f406a1$var$_inverseMatrix$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_ray$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$a186db52eed6d40e();
const $678fa78e22f406a1$var$_sphere$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$805e8b72413ccaba();
const $678fa78e22f406a1$var$_vA$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vB$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vC$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_tempA = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_tempB = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_tempC = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_morphA = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_morphB = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_morphC = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_uvA$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_uvB$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_uvC$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_intersectionPoint = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_intersectionPointWorld = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$e176487c05830cc5 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    copy(source) {
        super.copy(source);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $678fa78e22f406a1$var$_sphere$3.copy(geometry.boundingSphere);
        $678fa78e22f406a1$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($678fa78e22f406a1$var$_sphere$3) === false) return;
        //
        $678fa78e22f406a1$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $678fa78e22f406a1$var$_ray$2.copy(raycaster.ray).applyMatrix4($678fa78e22f406a1$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($678fa78e22f406a1$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const position = geometry.attributes.position;
            const morphPosition = geometry.morphAttributes.position;
            const morphTargetsRelative = geometry.morphTargetsRelative;
            const uv = geometry.attributes.uv;
            const uv2 = geometry.attributes.uv2;
            const groups = geometry.groups;
            const drawRange = geometry.drawRange;
            if (index !== null) {
                // indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = index.getX(j);
                        const b = index.getX(j + 1);
                        const c = index.getX(j + 2);
                        intersection = $678fa78e22f406a1$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $678fa78e22f406a1$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = index.getX(i);
                        const b = index.getX(i + 1);
                        const c = index.getX(i + 2);
                        intersection = $678fa78e22f406a1$var$checkBufferGeometryIntersection(this, material, raycaster, $678fa78e22f406a1$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            } else if (position !== undefined) {
                // non-indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = j;
                        const b = j + 1;
                        const c = j + 2;
                        intersection = $678fa78e22f406a1$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $678fa78e22f406a1$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(position.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = i;
                        const b = i + 1;
                        const c = i + 2;
                        intersection = $678fa78e22f406a1$var$checkBufferGeometryIntersection(this, material, raycaster, $678fa78e22f406a1$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            }
        } else if (geometry.isGeometry) console.error('THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    }
    constructor(geometry = new $678fa78e22f406a1$export$b7be63a67df8959(), material = new $678fa78e22f406a1$export$55cbcc9b622fe1f5()){
        super();
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
}
$678fa78e22f406a1$export$e176487c05830cc5.prototype.isMesh = true;
function $678fa78e22f406a1$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $678fa78e22f406a1$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $678fa78e22f406a1$var$_intersectionPointWorld.copy(point);
    $678fa78e22f406a1$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($678fa78e22f406a1$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $678fa78e22f406a1$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $678fa78e22f406a1$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $678fa78e22f406a1$var$_vA$1.fromBufferAttribute(position, a);
    $678fa78e22f406a1$var$_vB$1.fromBufferAttribute(position, b);
    $678fa78e22f406a1$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (material.morphTargets && morphPosition && morphInfluences) {
        $678fa78e22f406a1$var$_morphA.set(0, 0, 0);
        $678fa78e22f406a1$var$_morphB.set(0, 0, 0);
        $678fa78e22f406a1$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $678fa78e22f406a1$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $678fa78e22f406a1$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $678fa78e22f406a1$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $678fa78e22f406a1$var$_morphA.addScaledVector($678fa78e22f406a1$var$_tempA, influence);
                $678fa78e22f406a1$var$_morphB.addScaledVector($678fa78e22f406a1$var$_tempB, influence);
                $678fa78e22f406a1$var$_morphC.addScaledVector($678fa78e22f406a1$var$_tempC, influence);
            } else {
                $678fa78e22f406a1$var$_morphA.addScaledVector($678fa78e22f406a1$var$_tempA.sub($678fa78e22f406a1$var$_vA$1), influence);
                $678fa78e22f406a1$var$_morphB.addScaledVector($678fa78e22f406a1$var$_tempB.sub($678fa78e22f406a1$var$_vB$1), influence);
                $678fa78e22f406a1$var$_morphC.addScaledVector($678fa78e22f406a1$var$_tempC.sub($678fa78e22f406a1$var$_vC$1), influence);
            }
        }
        $678fa78e22f406a1$var$_vA$1.add($678fa78e22f406a1$var$_morphA);
        $678fa78e22f406a1$var$_vB$1.add($678fa78e22f406a1$var$_morphB);
        $678fa78e22f406a1$var$_vC$1.add($678fa78e22f406a1$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $678fa78e22f406a1$var$_vA$1);
        object.boneTransform(b, $678fa78e22f406a1$var$_vB$1);
        object.boneTransform(c, $678fa78e22f406a1$var$_vC$1);
    }
    const intersection = $678fa78e22f406a1$var$checkIntersection(object, material, raycaster, ray, $678fa78e22f406a1$var$_vA$1, $678fa78e22f406a1$var$_vB$1, $678fa78e22f406a1$var$_vC$1, $678fa78e22f406a1$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $678fa78e22f406a1$var$_uvA$1.fromBufferAttribute(uv, a);
            $678fa78e22f406a1$var$_uvB$1.fromBufferAttribute(uv, b);
            $678fa78e22f406a1$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $678fa78e22f406a1$export$5a465592bfe74b48.getUV($678fa78e22f406a1$var$_intersectionPoint, $678fa78e22f406a1$var$_vA$1, $678fa78e22f406a1$var$_vB$1, $678fa78e22f406a1$var$_vC$1, $678fa78e22f406a1$var$_uvA$1, $678fa78e22f406a1$var$_uvB$1, $678fa78e22f406a1$var$_uvC$1, new $678fa78e22f406a1$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $678fa78e22f406a1$var$_uvA$1.fromBufferAttribute(uv2, a);
            $678fa78e22f406a1$var$_uvB$1.fromBufferAttribute(uv2, b);
            $678fa78e22f406a1$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $678fa78e22f406a1$export$5a465592bfe74b48.getUV($678fa78e22f406a1$var$_intersectionPoint, $678fa78e22f406a1$var$_vA$1, $678fa78e22f406a1$var$_vB$1, $678fa78e22f406a1$var$_vC$1, $678fa78e22f406a1$var$_uvA$1, $678fa78e22f406a1$var$_uvB$1, $678fa78e22f406a1$var$_uvC$1, new $678fa78e22f406a1$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $678fa78e22f406a1$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $678fa78e22f406a1$export$5a465592bfe74b48.getNormal($678fa78e22f406a1$var$_vA$1, $678fa78e22f406a1$var$_vB$1, $678fa78e22f406a1$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $678fa78e22f406a1$export$ab3456a079aa7d80 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $678fa78e22f406a1$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
}
/**
 * Uniform Utilities
 */ function $678fa78e22f406a1$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $678fa78e22f406a1$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $678fa78e22f406a1$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const $678fa78e22f406a1$export$d8ecdf8615bfea69 = {
    clone: $678fa78e22f406a1$var$cloneUniforms,
    merge: $678fa78e22f406a1$var$mergeUniforms
};
var $678fa78e22f406a1$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $678fa78e22f406a1$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ class $678fa78e22f406a1$export$83c7d75d550a8b0d extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $678fa78e22f406a1$var$cloneUniforms(source.uniforms);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
    constructor(parameters){
        super();
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.vertexShader = $678fa78e22f406a1$var$default_vertex;
        this.fragmentShader = $678fa78e22f406a1$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.morphTargets = false; // set to use morph targets
        this.morphNormals = false; // set to use morph normals
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv2': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error('THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.');
            this.setValues(parameters);
        }
    }
}
$678fa78e22f406a1$export$83c7d75d550a8b0d.prototype.isShaderMaterial = true;
class $678fa78e22f406a1$export$79f141de891a5fed extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        if (target === undefined) {
            console.warn('THREE.Camera: .getWorldDirection() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(){
        super();
        this.type = 'Camera';
        this.matrixWorldInverse = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
    }
}
$678fa78e22f406a1$export$79f141de891a5fed.prototype.isCamera = true;
class $678fa78e22f406a1$export$74e4ae24825f68d7 extends $678fa78e22f406a1$export$79f141de891a5fed {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $678fa78e22f406a1$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($678fa78e22f406a1$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $678fa78e22f406a1$var$RAD2DEG * 2 * Math.atan(Math.tan($678fa78e22f406a1$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($678fa78e22f406a1$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
}
$678fa78e22f406a1$export$74e4ae24825f68d7.prototype.isPerspectiveCamera = true;
const $678fa78e22f406a1$var$fov = 90, $678fa78e22f406a1$var$aspect = 1;
class $678fa78e22f406a1$export$d0cdd0bd804995de extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentXrEnabled = renderer.xr.enabled;
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
    }
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error('THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.');
            return;
        }
        this.renderTarget = renderTarget;
        const cameraPX = new $678fa78e22f406a1$export$74e4ae24825f68d7($678fa78e22f406a1$var$fov, $678fa78e22f406a1$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $678fa78e22f406a1$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $678fa78e22f406a1$export$74e4ae24825f68d7($678fa78e22f406a1$var$fov, $678fa78e22f406a1$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $678fa78e22f406a1$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $678fa78e22f406a1$export$74e4ae24825f68d7($678fa78e22f406a1$var$fov, $678fa78e22f406a1$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $678fa78e22f406a1$export$74e4ae24825f68d7($678fa78e22f406a1$var$fov, $678fa78e22f406a1$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $678fa78e22f406a1$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $678fa78e22f406a1$export$74e4ae24825f68d7($678fa78e22f406a1$var$fov, $678fa78e22f406a1$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $678fa78e22f406a1$export$74e4ae24825f68d7($678fa78e22f406a1$var$fov, $678fa78e22f406a1$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
}
class $678fa78e22f406a1$export$ee2e5a18258a4049 extends $678fa78e22f406a1$export$5431306cf43de24a {
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $678fa78e22f406a1$export$8759762a6477f2c4;
        format = format !== undefined ? format : $678fa78e22f406a1$export$7c67423a5ee6f5eb;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        // Why CubeTexture._needsFlipEnvMap is necessary:
        //
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag _needsFlipEnvMap controls this conversion. The flip is not required (and thus _needsFlipEnvMap is set to false)
        // when using WebGLCubeRenderTarget.texture as a cube texture.
        this._needsFlipEnvMap = true;
        this.flipY = false;
    }
}
$678fa78e22f406a1$export$ee2e5a18258a4049.prototype.isCubeTexture = true;
class $678fa78e22f406a1$export$ac386671d651941e extends $678fa78e22f406a1$export$3c052beb2e51e23f {
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.format = $678fa78e22f406a1$export$3f8bb04b555a363c; // see #18859
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $678fa78e22f406a1$export$ab3456a079aa7d80(5, 5, 5);
        const material = new $678fa78e22f406a1$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $678fa78e22f406a1$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $678fa78e22f406a1$export$d9f0486e75b5ace,
            blending: $678fa78e22f406a1$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $678fa78e22f406a1$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $678fa78e22f406a1$export$5d8599b6a933fb1b) texture.minFilter = $678fa78e22f406a1$export$8a72f490b25c56c8;
        const camera = new $678fa78e22f406a1$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
    constructor(size, options, dummy){
        if (Number.isInteger(options)) {
            console.warn('THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )');
            options = dummy;
        }
        super(size, size, options);
        options = options || {};
        this.texture = new $678fa78e22f406a1$export$ee2e5a18258a4049(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $678fa78e22f406a1$export$8a72f490b25c56c8;
        this.texture._needsFlipEnvMap = false;
    }
}
$678fa78e22f406a1$export$ac386671d651941e.prototype.isWebGLCubeRenderTarget = true;
const $678fa78e22f406a1$var$_sphere$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$805e8b72413ccaba();
const $678fa78e22f406a1$var$_vector$7 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$35efe6f4c85463d2 {
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $678fa78e22f406a1$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($678fa78e22f406a1$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $678fa78e22f406a1$var$_sphere$2.center.set(0, 0, 0);
        $678fa78e22f406a1$var$_sphere$2.radius = 0.7071067811865476;
        $678fa78e22f406a1$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($678fa78e22f406a1$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $678fa78e22f406a1$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $678fa78e22f406a1$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $678fa78e22f406a1$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($678fa78e22f406a1$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(p0 = new $678fa78e22f406a1$export$7ff5ac152ef991b0(), p1 = new $678fa78e22f406a1$export$7ff5ac152ef991b0(), p2 = new $678fa78e22f406a1$export$7ff5ac152ef991b0(), p3 = new $678fa78e22f406a1$export$7ff5ac152ef991b0(), p4 = new $678fa78e22f406a1$export$7ff5ac152ef991b0(), p5 = new $678fa78e22f406a1$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
}
function $678fa78e22f406a1$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $678fa78e22f406a1$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn('THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.');
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $678fa78e22f406a1$export$e789a11a194ca4e0 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
    }
}
var $678fa78e22f406a1$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $678fa78e22f406a1$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $678fa78e22f406a1$var$alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif";
var $678fa78e22f406a1$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif";
var $678fa78e22f406a1$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $678fa78e22f406a1$var$begin_vertex = "vec3 transformed = vec3( position );";
var $678fa78e22f406a1$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $678fa78e22f406a1$var$bsdfs = "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\treturn vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n#else\n\tif( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t}\n\treturn 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n\tvec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n\treturn Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\treturn specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tvec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\tvec3 FssEss = F * brdf.x + brdf.y;\n\tfloat Ess = brdf.x + brdf.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max(1.0 - cos2h, 0.0078125);\treturn (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n\treturn saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var $678fa78e22f406a1$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $678fa78e22f406a1$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $678fa78e22f406a1$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $678fa78e22f406a1$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $678fa78e22f406a1$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $678fa78e22f406a1$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $678fa78e22f406a1$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $678fa78e22f406a1$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $678fa78e22f406a1$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var $678fa78e22f406a1$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $678fa78e22f406a1$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $678fa78e22f406a1$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $678fa78e22f406a1$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $678fa78e22f406a1$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $678fa78e22f406a1$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $678fa78e22f406a1$var$encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var $678fa78e22f406a1$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifndef ENVMAP_TYPE_CUBE_UV\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $678fa78e22f406a1$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $678fa78e22f406a1$var$fog_vertex = "#ifdef USE_FOG\n\tfogDepth = - mvPosition.z;\n#endif";
var $678fa78e22f406a1$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float fogDepth;\n#endif";
var $678fa78e22f406a1$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $678fa78e22f406a1$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}";
var $678fa78e22f406a1$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\treflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif";
var $678fa78e22f406a1$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $678fa78e22f406a1$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $678fa78e22f406a1$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif";
var $678fa78e22f406a1$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat sigma = PI * roughness * roughness / ( 1.0 + roughness );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif";
var $678fa78e22f406a1$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $678fa78e22f406a1$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var $678fa78e22f406a1$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $678fa78e22f406a1$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var $678fa78e22f406a1$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), rawDiffuseColor, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), rawDiffuseColor, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheen;\n#endif";
var $678fa78e22f406a1$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat specularRoughness;\n\tvec3 specularColor;\n#ifdef CLEARCOAT\n\tfloat clearcoat;\n\tfloat clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tvec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = ccDotNL * directLight.color;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tccIrradiance *= PI;\n\t\t#endif\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t\treflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n\t\t\tmaterial.specularRoughness,\n\t\t\tdirectLight.direction,\n\t\t\tgeometry,\n\t\t\tmaterial.sheenColor\n\t\t);\n\t#else\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n\t#endif\n\treflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t\tfloat ccDotNL = ccDotNV;\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\tfloat clearcoatInv = 1.0 - clearcoatDHR;\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tBRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $678fa78e22f406a1$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $678fa78e22f406a1$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n\t#ifdef CLEARCOAT\n\t\tclearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n\t#endif\n#endif";
var $678fa78e22f406a1$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $678fa78e22f406a1$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $678fa78e22f406a1$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $678fa78e22f406a1$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $678fa78e22f406a1$var$map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif";
var $678fa78e22f406a1$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $678fa78e22f406a1$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $678fa78e22f406a1$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $678fa78e22f406a1$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $678fa78e22f406a1$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $678fa78e22f406a1$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var $678fa78e22f406a1$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
var $678fa78e22f406a1$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif";
var $678fa78e22f406a1$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var $678fa78e22f406a1$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $678fa78e22f406a1$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif";
var $678fa78e22f406a1$var$clearcoat_normal_fragment_begin = "#ifdef CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var $678fa78e22f406a1$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif";
var $678fa78e22f406a1$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var $678fa78e22f406a1$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $678fa78e22f406a1$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $678fa78e22f406a1$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $678fa78e22f406a1$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $678fa78e22f406a1$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $678fa78e22f406a1$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $678fa78e22f406a1$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $678fa78e22f406a1$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $678fa78e22f406a1$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $678fa78e22f406a1$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var $678fa78e22f406a1$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $678fa78e22f406a1$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $678fa78e22f406a1$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif";
var $678fa78e22f406a1$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $678fa78e22f406a1$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $678fa78e22f406a1$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $678fa78e22f406a1$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $678fa78e22f406a1$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $678fa78e22f406a1$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $678fa78e22f406a1$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttotalTransmission *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSNMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition.xyz / vWorldPosition.w;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n\tfloat ior = ( 1.0 + 0.4 * reflectivity ) / ( 1.0 - 0.4 * reflectivity );\n\tvec3 f0 = vec3( pow( ior - 1.0, 2.0 ) / pow( ior + 1.0, 2.0 ) );\n\tvec3 f90 = vec3( 1.0 );\n\tvec3 f_transmission = totalTransmission * getIBLVolumeRefraction(\n\t\tnormal, v, viewDir, roughnessFactor, diffuseColor.rgb, f0, f90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance);\n\tdiffuseColor.rgb = mix( diffuseColor.rgb, f_transmission, totalTransmission );\n#endif";
var $678fa78e22f406a1$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec4 vWorldPosition;\n\tvec3 getVolumeTransmissionRay(vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix) {\n\t\tvec3 refractionVector = refract(-v, normalize(n), 1.0 / ior);\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length(vec3(modelMatrix[0].xyz));\n\t\tmodelScale.y = length(vec3(modelMatrix[1].xyz));\n\t\tmodelScale.z = length(vec3(modelMatrix[2].xyz));\n\t\treturn normalize(refractionVector) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness(float roughness, float ior) {\n\t\treturn roughness * clamp(ior * 2.0 - 2.0, 0.0, 1.0);\n\t}\n\tvec3 getTransmissionSample(vec2 fragCoord, float roughness, float ior) {\n\t\tfloat framebufferLod = log2(transmissionSamplerSize.x) * applyIorToRoughness(roughness, ior);\n\t\treturn texture2DLodEXT(transmissionSamplerMap, fragCoord.xy, framebufferLod).rgb;\n\t}\n\tvec3 applyVolumeAttenuation(vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance) {\n\t\tif (attenuationDistance == 0.0) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log(attenuationColor) / attenuationDistance;\n\t\t\tvec3 transmittance = exp(-attenuationCoefficient * transmissionDistance);\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec3 getIBLVolumeRefraction(vec3 n, vec3 v, vec3 viewDir, float perceptualRoughness, vec3 baseColor, vec3 f0, vec3 f90,\n\t\tvec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness, vec3 attenuationColor, float attenuationDistance) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4(refractedRayExit, 1.0);\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec3 transmittedLight = getTransmissionSample(refractionCoords, perceptualRoughness, ior);\n\t\tvec3 attenuatedColor = applyVolumeAttenuation(transmittedLight, length(transmissionRay), attenuationColor, attenuationDistance);\n\t\tfloat NdotV = saturate(dot(n, viewDir));\n\t\tvec2 brdf = integrateSpecularBRDF(NdotV, perceptualRoughness);\n\t\tvec3 specularColor = f0 * brdf.x + f90 * brdf.y;\n\t\treturn (1.0 - specularColor) * attenuatedColor * baseColor;\n\t}\n#endif";
var $678fa78e22f406a1$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var $678fa78e22f406a1$var$uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var $678fa78e22f406a1$var$uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $678fa78e22f406a1$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var $678fa78e22f406a1$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var $678fa78e22f406a1$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $678fa78e22f406a1$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var $678fa78e22f406a1$var$background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var $678fa78e22f406a1$var$background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var $678fa78e22f406a1$var$cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var $678fa78e22f406a1$var$cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var $678fa78e22f406a1$var$depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
var $678fa78e22f406a1$var$depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var $678fa78e22f406a1$var$distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var $678fa78e22f406a1$var$distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var $678fa78e22f406a1$var$equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var $678fa78e22f406a1$var$equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var $678fa78e22f406a1$var$linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $678fa78e22f406a1$var$linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $678fa78e22f406a1$var$meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $678fa78e22f406a1$var$meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $678fa78e22f406a1$var$meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#ifndef FLAT_SHADED\n\t\tvNormal = normalize( transformedNormal );\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var $678fa78e22f406a1$var$meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $678fa78e22f406a1$var$meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $678fa78e22f406a1$var$meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n\t#define REFLECTIVITY\n\t#define CLEARCOAT\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform vec3 attenuationColor;\n\tuniform float attenuationDistance;\n#endif\n#ifdef REFLECTIVITY\n\tuniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <transmission_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#ifdef USE_TRANSMISSION\n\t\tfloat totalTransmission = transmission;\n\t\tfloat thicknessFactor = thickness;\n\t#endif\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\tvec3 rawDiffuseColor = diffuseColor.rgb;\n\t#include <transmission_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $678fa78e22f406a1$var$meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#ifdef USE_TRANSMISSION\n\tvarying vec4 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition;\n#endif\n}";
var $678fa78e22f406a1$var$normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var $678fa78e22f406a1$var$normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var $678fa78e22f406a1$var$points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $678fa78e22f406a1$var$points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var $678fa78e22f406a1$var$shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $678fa78e22f406a1$var$sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var $678fa78e22f406a1$var$sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $678fa78e22f406a1$export$955f9f2e84c43c8b = {
    alphamap_fragment: $678fa78e22f406a1$var$alphamap_fragment,
    alphamap_pars_fragment: $678fa78e22f406a1$var$alphamap_pars_fragment,
    alphatest_fragment: $678fa78e22f406a1$var$alphatest_fragment,
    aomap_fragment: $678fa78e22f406a1$var$aomap_fragment,
    aomap_pars_fragment: $678fa78e22f406a1$var$aomap_pars_fragment,
    begin_vertex: $678fa78e22f406a1$var$begin_vertex,
    beginnormal_vertex: $678fa78e22f406a1$var$beginnormal_vertex,
    bsdfs: $678fa78e22f406a1$var$bsdfs,
    bumpmap_pars_fragment: $678fa78e22f406a1$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $678fa78e22f406a1$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $678fa78e22f406a1$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $678fa78e22f406a1$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $678fa78e22f406a1$var$clipping_planes_vertex,
    color_fragment: $678fa78e22f406a1$var$color_fragment,
    color_pars_fragment: $678fa78e22f406a1$var$color_pars_fragment,
    color_pars_vertex: $678fa78e22f406a1$var$color_pars_vertex,
    color_vertex: $678fa78e22f406a1$var$color_vertex,
    common: $678fa78e22f406a1$var$common,
    cube_uv_reflection_fragment: $678fa78e22f406a1$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $678fa78e22f406a1$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $678fa78e22f406a1$var$displacementmap_pars_vertex,
    displacementmap_vertex: $678fa78e22f406a1$var$displacementmap_vertex,
    emissivemap_fragment: $678fa78e22f406a1$var$emissivemap_fragment,
    emissivemap_pars_fragment: $678fa78e22f406a1$var$emissivemap_pars_fragment,
    encodings_fragment: $678fa78e22f406a1$var$encodings_fragment,
    encodings_pars_fragment: $678fa78e22f406a1$var$encodings_pars_fragment,
    envmap_fragment: $678fa78e22f406a1$var$envmap_fragment,
    envmap_common_pars_fragment: $678fa78e22f406a1$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $678fa78e22f406a1$var$envmap_pars_fragment,
    envmap_pars_vertex: $678fa78e22f406a1$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $678fa78e22f406a1$var$envmap_physical_pars_fragment,
    envmap_vertex: $678fa78e22f406a1$var$envmap_vertex,
    fog_vertex: $678fa78e22f406a1$var$fog_vertex,
    fog_pars_vertex: $678fa78e22f406a1$var$fog_pars_vertex,
    fog_fragment: $678fa78e22f406a1$var$fog_fragment,
    fog_pars_fragment: $678fa78e22f406a1$var$fog_pars_fragment,
    gradientmap_pars_fragment: $678fa78e22f406a1$var$gradientmap_pars_fragment,
    lightmap_fragment: $678fa78e22f406a1$var$lightmap_fragment,
    lightmap_pars_fragment: $678fa78e22f406a1$var$lightmap_pars_fragment,
    lights_lambert_vertex: $678fa78e22f406a1$var$lights_lambert_vertex,
    lights_pars_begin: $678fa78e22f406a1$var$lights_pars_begin,
    lights_toon_fragment: $678fa78e22f406a1$var$lights_toon_fragment,
    lights_toon_pars_fragment: $678fa78e22f406a1$var$lights_toon_pars_fragment,
    lights_phong_fragment: $678fa78e22f406a1$var$lights_phong_fragment,
    lights_phong_pars_fragment: $678fa78e22f406a1$var$lights_phong_pars_fragment,
    lights_physical_fragment: $678fa78e22f406a1$var$lights_physical_fragment,
    lights_physical_pars_fragment: $678fa78e22f406a1$var$lights_physical_pars_fragment,
    lights_fragment_begin: $678fa78e22f406a1$var$lights_fragment_begin,
    lights_fragment_maps: $678fa78e22f406a1$var$lights_fragment_maps,
    lights_fragment_end: $678fa78e22f406a1$var$lights_fragment_end,
    logdepthbuf_fragment: $678fa78e22f406a1$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $678fa78e22f406a1$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $678fa78e22f406a1$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $678fa78e22f406a1$var$logdepthbuf_vertex,
    map_fragment: $678fa78e22f406a1$var$map_fragment,
    map_pars_fragment: $678fa78e22f406a1$var$map_pars_fragment,
    map_particle_fragment: $678fa78e22f406a1$var$map_particle_fragment,
    map_particle_pars_fragment: $678fa78e22f406a1$var$map_particle_pars_fragment,
    metalnessmap_fragment: $678fa78e22f406a1$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $678fa78e22f406a1$var$metalnessmap_pars_fragment,
    morphnormal_vertex: $678fa78e22f406a1$var$morphnormal_vertex,
    morphtarget_pars_vertex: $678fa78e22f406a1$var$morphtarget_pars_vertex,
    morphtarget_vertex: $678fa78e22f406a1$var$morphtarget_vertex,
    normal_fragment_begin: $678fa78e22f406a1$var$normal_fragment_begin,
    normal_fragment_maps: $678fa78e22f406a1$var$normal_fragment_maps,
    normalmap_pars_fragment: $678fa78e22f406a1$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $678fa78e22f406a1$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $678fa78e22f406a1$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $678fa78e22f406a1$var$clearcoat_pars_fragment,
    packing: $678fa78e22f406a1$var$packing,
    premultiplied_alpha_fragment: $678fa78e22f406a1$var$premultiplied_alpha_fragment,
    project_vertex: $678fa78e22f406a1$var$project_vertex,
    dithering_fragment: $678fa78e22f406a1$var$dithering_fragment,
    dithering_pars_fragment: $678fa78e22f406a1$var$dithering_pars_fragment,
    roughnessmap_fragment: $678fa78e22f406a1$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $678fa78e22f406a1$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $678fa78e22f406a1$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $678fa78e22f406a1$var$shadowmap_pars_vertex,
    shadowmap_vertex: $678fa78e22f406a1$var$shadowmap_vertex,
    shadowmask_pars_fragment: $678fa78e22f406a1$var$shadowmask_pars_fragment,
    skinbase_vertex: $678fa78e22f406a1$var$skinbase_vertex,
    skinning_pars_vertex: $678fa78e22f406a1$var$skinning_pars_vertex,
    skinning_vertex: $678fa78e22f406a1$var$skinning_vertex,
    skinnormal_vertex: $678fa78e22f406a1$var$skinnormal_vertex,
    specularmap_fragment: $678fa78e22f406a1$var$specularmap_fragment,
    specularmap_pars_fragment: $678fa78e22f406a1$var$specularmap_pars_fragment,
    tonemapping_fragment: $678fa78e22f406a1$var$tonemapping_fragment,
    tonemapping_pars_fragment: $678fa78e22f406a1$var$tonemapping_pars_fragment,
    transmission_fragment: $678fa78e22f406a1$var$transmission_fragment,
    transmission_pars_fragment: $678fa78e22f406a1$var$transmission_pars_fragment,
    uv_pars_fragment: $678fa78e22f406a1$var$uv_pars_fragment,
    uv_pars_vertex: $678fa78e22f406a1$var$uv_pars_vertex,
    uv_vertex: $678fa78e22f406a1$var$uv_vertex,
    uv2_pars_fragment: $678fa78e22f406a1$var$uv2_pars_fragment,
    uv2_pars_vertex: $678fa78e22f406a1$var$uv2_pars_vertex,
    uv2_vertex: $678fa78e22f406a1$var$uv2_vertex,
    worldpos_vertex: $678fa78e22f406a1$var$worldpos_vertex,
    background_frag: $678fa78e22f406a1$var$background_frag,
    background_vert: $678fa78e22f406a1$var$background_vert,
    cube_frag: $678fa78e22f406a1$var$cube_frag,
    cube_vert: $678fa78e22f406a1$var$cube_vert,
    depth_frag: $678fa78e22f406a1$var$depth_frag,
    depth_vert: $678fa78e22f406a1$var$depth_vert,
    distanceRGBA_frag: $678fa78e22f406a1$var$distanceRGBA_frag,
    distanceRGBA_vert: $678fa78e22f406a1$var$distanceRGBA_vert,
    equirect_frag: $678fa78e22f406a1$var$equirect_frag,
    equirect_vert: $678fa78e22f406a1$var$equirect_vert,
    linedashed_frag: $678fa78e22f406a1$var$linedashed_frag,
    linedashed_vert: $678fa78e22f406a1$var$linedashed_vert,
    meshbasic_frag: $678fa78e22f406a1$var$meshbasic_frag,
    meshbasic_vert: $678fa78e22f406a1$var$meshbasic_vert,
    meshlambert_frag: $678fa78e22f406a1$var$meshlambert_frag,
    meshlambert_vert: $678fa78e22f406a1$var$meshlambert_vert,
    meshmatcap_frag: $678fa78e22f406a1$var$meshmatcap_frag,
    meshmatcap_vert: $678fa78e22f406a1$var$meshmatcap_vert,
    meshtoon_frag: $678fa78e22f406a1$var$meshtoon_frag,
    meshtoon_vert: $678fa78e22f406a1$var$meshtoon_vert,
    meshphong_frag: $678fa78e22f406a1$var$meshphong_frag,
    meshphong_vert: $678fa78e22f406a1$var$meshphong_vert,
    meshphysical_frag: $678fa78e22f406a1$var$meshphysical_frag,
    meshphysical_vert: $678fa78e22f406a1$var$meshphysical_vert,
    normal_frag: $678fa78e22f406a1$var$normal_frag,
    normal_vert: $678fa78e22f406a1$var$normal_vert,
    points_frag: $678fa78e22f406a1$var$points_frag,
    points_vert: $678fa78e22f406a1$var$points_vert,
    shadow_frag: $678fa78e22f406a1$var$shadow_frag,
    shadow_vert: $678fa78e22f406a1$var$shadow_vert,
    sprite_frag: $678fa78e22f406a1$var$sprite_frag,
    sprite_vert: $678fa78e22f406a1$var$sprite_vert
};
/**
 * Uniforms library for shared webgl shaders
 */ const $678fa78e22f406a1$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new $678fa78e22f406a1$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: new $678fa78e22f406a1$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        refractionRatio: {
            value: 0.98
        },
        maxMipLevel: {
            value: 0
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new $678fa78e22f406a1$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new $678fa78e22f406a1$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new $678fa78e22f406a1$export$8ff26dafa08918()
        }
    }
};
const $678fa78e22f406a1$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.specularmap,
            $678fa78e22f406a1$export$6643083551874bf5.envmap,
            $678fa78e22f406a1$export$6643083551874bf5.aomap,
            $678fa78e22f406a1$export$6643083551874bf5.lightmap,
            $678fa78e22f406a1$export$6643083551874bf5.fog
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.specularmap,
            $678fa78e22f406a1$export$6643083551874bf5.envmap,
            $678fa78e22f406a1$export$6643083551874bf5.aomap,
            $678fa78e22f406a1$export$6643083551874bf5.lightmap,
            $678fa78e22f406a1$export$6643083551874bf5.emissivemap,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            $678fa78e22f406a1$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $678fa78e22f406a1$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.specularmap,
            $678fa78e22f406a1$export$6643083551874bf5.envmap,
            $678fa78e22f406a1$export$6643083551874bf5.aomap,
            $678fa78e22f406a1$export$6643083551874bf5.lightmap,
            $678fa78e22f406a1$export$6643083551874bf5.emissivemap,
            $678fa78e22f406a1$export$6643083551874bf5.bumpmap,
            $678fa78e22f406a1$export$6643083551874bf5.normalmap,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            $678fa78e22f406a1$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $678fa78e22f406a1$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: new $678fa78e22f406a1$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.envmap,
            $678fa78e22f406a1$export$6643083551874bf5.aomap,
            $678fa78e22f406a1$export$6643083551874bf5.lightmap,
            $678fa78e22f406a1$export$6643083551874bf5.emissivemap,
            $678fa78e22f406a1$export$6643083551874bf5.bumpmap,
            $678fa78e22f406a1$export$6643083551874bf5.normalmap,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap,
            $678fa78e22f406a1$export$6643083551874bf5.roughnessmap,
            $678fa78e22f406a1$export$6643083551874bf5.metalnessmap,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            $678fa78e22f406a1$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $678fa78e22f406a1$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.aomap,
            $678fa78e22f406a1$export$6643083551874bf5.lightmap,
            $678fa78e22f406a1$export$6643083551874bf5.emissivemap,
            $678fa78e22f406a1$export$6643083551874bf5.bumpmap,
            $678fa78e22f406a1$export$6643083551874bf5.normalmap,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap,
            $678fa78e22f406a1$export$6643083551874bf5.gradientmap,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            $678fa78e22f406a1$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: new $678fa78e22f406a1$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.bumpmap,
            $678fa78e22f406a1$export$6643083551874bf5.normalmap,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.points,
            $678fa78e22f406a1$export$6643083551874bf5.fog
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.bumpmap,
            $678fa78e22f406a1$export$6643083551874bf5.normalmap,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.normal_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.normal_frag
    },
    sprite: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.sprite,
            $678fa78e22f406a1$export$6643083551874bf5.fog
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $678fa78e22f406a1$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.common,
            $678fa78e22f406a1$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: new $678fa78e22f406a1$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: $678fa78e22f406a1$var$mergeUniforms([
            $678fa78e22f406a1$export$6643083551874bf5.lights,
            $678fa78e22f406a1$export$6643083551874bf5.fog,
            {
                color: {
                    value: new $678fa78e22f406a1$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.shadow_frag
    }
};
$678fa78e22f406a1$export$bee4a7d47f8f5014.physical = {
    uniforms: $678fa78e22f406a1$var$mergeUniforms([
        $678fa78e22f406a1$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: new $678fa78e22f406a1$export$892596cec99bc70e(0x000000)
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new $678fa78e22f406a1$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $678fa78e22f406a1$export$892596cec99bc70e(0x000000)
            }
        }
    ]),
    vertexShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $678fa78e22f406a1$export$955f9f2e84c43c8b.meshphysical_frag
};
function $678fa78e22f406a1$var$WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
    const clearColor = new $678fa78e22f406a1$export$892596cec99bc70e(0x000000);
    let clearAlpha = 0;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === 'additive') background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $678fa78e22f406a1$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $678fa78e22f406a1$export$e176487c05830cc5(new $678fa78e22f406a1$export$ab3456a079aa7d80(1, 1, 1), new $678fa78e22f406a1$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $678fa78e22f406a1$var$cloneUniforms($678fa78e22f406a1$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $678fa78e22f406a1$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $678fa78e22f406a1$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $678fa78e22f406a1$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background._needsFlipEnvMap ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $678fa78e22f406a1$export$e176487c05830cc5(new $678fa78e22f406a1$export$e789a11a194ca4e0(2, 2), new $678fa78e22f406a1$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $678fa78e22f406a1$var$cloneUniforms($678fa78e22f406a1$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $678fa78e22f406a1$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $678fa78e22f406a1$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $678fa78e22f406a1$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $678fa78e22f406a1$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in geometryAttributes){
            const cachedAttribute = cachedAttributes[key];
            const geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in attributes){
            const attribute = attributes[key];
            const data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute >= 0) {
                const geometryAttribute = geometryAttributes[name];
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            enableAttributeAndDivisor(programAttribute, data.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, stride * bytesPerElement, offset * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            enableAttributeAndDivisor(programAttribute, geometryAttribute.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, 0, 0);
                    }
                } else if (name === 'instanceMatrix') {
                    const attribute = attributes.get(object.instanceMatrix);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute + 0, 1);
                    enableAttributeAndDivisor(programAttribute + 1, 1);
                    enableAttributeAndDivisor(programAttribute + 2, 1);
                    enableAttributeAndDivisor(programAttribute + 3, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute + 0, 4, type, false, 64, 0);
                    gl.vertexAttribPointer(programAttribute + 1, 4, type, false, 64, 16);
                    gl.vertexAttribPointer(programAttribute + 2, 4, type, false, 64, 32);
                    gl.vertexAttribPointer(programAttribute + 3, 4, type, false, 64, 48);
                } else if (name === 'instanceColor') {
                    const attribute = attributes.get(object.instanceColor);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute, 3, type, false, 12, 0);
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $678fa78e22f406a1$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $678fa78e22f406a1$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    /* eslint-disable no-undef */ const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
    /* eslint-enable no-undef */ let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $678fa78e22f406a1$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $678fa78e22f406a1$export$7ff5ac152ef991b0(), viewNormalMatrix = new $678fa78e22f406a1$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $678fa78e22f406a1$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $678fa78e22f406a1$export$d64030b316d3b087) texture.mapping = $678fa78e22f406a1$export$8759762a6477f2c4;
        else if (mapping === $678fa78e22f406a1$export$ee99d97d46898098) texture.mapping = $678fa78e22f406a1$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === $678fa78e22f406a1$export$d64030b316d3b087 || mapping === $678fa78e22f406a1$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const currentRenderTarget = renderer.getRenderTarget();
                        const renderTarget = new $678fa78e22f406a1$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        renderer.setRenderTarget(currentRenderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $678fa78e22f406a1$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $678fa78e22f406a1$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($678fa78e22f406a1$var$arrayMax(indices) > 65535 ? $678fa78e22f406a1$export$7eb8c9fa25cd5bd6 : $678fa78e22f406a1$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $678fa78e22f406a1$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $678fa78e22f406a1$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $678fa78e22f406a1$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $678fa78e22f406a1$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $678fa78e22f406a1$var$WebGLMorphtargets(gl) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        // When object doesn't have morph target influences defined, we treat it as a 0-length array
        // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
        const length = objectInfluences === undefined ? 0 : objectInfluences.length;
        let influences = influencesList[geometry.id];
        if (influences === undefined) {
            // initialise list
            influences = [];
            for(let i = 0; i < length; i++)influences[i] = [
                i,
                0
            ];
            influencesList[geometry.id] = influences;
        }
        // Collect influences
        for(let i = 0; i < length; i++){
            const influence = influences[i];
            influence[0] = i;
            influence[1] = objectInfluences[i];
        }
        influences.sort($678fa78e22f406a1$var$absNumericalSort);
        for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
            workInfluences[i][0] = influences[i][0];
            workInfluences[i][1] = influences[i][1];
        } else {
            workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
            workInfluences[i][1] = 0;
        }
        workInfluences.sort($678fa78e22f406a1$var$numericalSort);
        const morphTargets = material.morphTargets && geometry.morphAttributes.position;
        const morphNormals = material.morphNormals && geometry.morphAttributes.normal;
        let morphInfluencesSum = 0;
        for(let i = 0; i < 8; i++){
            const influence = workInfluences[i];
            const index = influence[0];
            const value = influence[1];
            if (index !== Number.MAX_SAFE_INTEGER && value) {
                if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                morphInfluences[i] = value;
                morphInfluencesSum += value;
            } else {
                if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                morphInfluences[i] = 0;
            }
        }
        // GLSL shader uses formula baseinfluence * base + sum(target * influence)
        // This allows us to switch between absolute morphs and relative morphs without changing shader code
        // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
        const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
        program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
    }
    return {
        update: update
    };
}
function $678fa78e22f406a1$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
class $678fa78e22f406a1$export$e38bf4541665bbbd extends $678fa78e22f406a1$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.minFilter = $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.wrapR = $678fa78e22f406a1$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.needsUpdate = true;
    }
}
$678fa78e22f406a1$export$e38bf4541665bbbd.prototype.isDataTexture2DArray = true;
class $678fa78e22f406a1$export$ef03cdc98340bab4 extends $678fa78e22f406a1$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.minFilter = $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.wrapR = $678fa78e22f406a1$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.needsUpdate = true;
    }
}
$678fa78e22f406a1$export$ef03cdc98340bab4.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $678fa78e22f406a1$var$emptyTexture = new $678fa78e22f406a1$export$5431306cf43de24a();
const $678fa78e22f406a1$var$emptyTexture2dArray = new $678fa78e22f406a1$export$e38bf4541665bbbd();
const $678fa78e22f406a1$var$emptyTexture3d = new $678fa78e22f406a1$export$ef03cdc98340bab4();
const $678fa78e22f406a1$var$emptyCubeTexture = new $678fa78e22f406a1$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $678fa78e22f406a1$var$arrayCacheF32 = [];
const $678fa78e22f406a1$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $678fa78e22f406a1$var$mat4array = new Float32Array(16);
const $678fa78e22f406a1$var$mat3array = new Float32Array(9);
const $678fa78e22f406a1$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $678fa78e22f406a1$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $678fa78e22f406a1$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $678fa78e22f406a1$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $678fa78e22f406a1$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $678fa78e22f406a1$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $678fa78e22f406a1$var$allocTexUnits(textures, n) {
    let r = $678fa78e22f406a1$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $678fa78e22f406a1$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $678fa78e22f406a1$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $678fa78e22f406a1$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $678fa78e22f406a1$var$copyArray(cache, v);
    }
}
function $678fa78e22f406a1$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $678fa78e22f406a1$var$copyArray(cache, v);
    }
}
function $678fa78e22f406a1$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $678fa78e22f406a1$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $678fa78e22f406a1$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $678fa78e22f406a1$var$copyArray(cache, v);
    } else {
        if ($678fa78e22f406a1$var$arraysEqual(cache, elements)) return;
        $678fa78e22f406a1$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $678fa78e22f406a1$var$mat2array);
        $678fa78e22f406a1$var$copyArray(cache, elements);
    }
}
function $678fa78e22f406a1$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $678fa78e22f406a1$var$copyArray(cache, v);
    } else {
        if ($678fa78e22f406a1$var$arraysEqual(cache, elements)) return;
        $678fa78e22f406a1$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $678fa78e22f406a1$var$mat3array);
        $678fa78e22f406a1$var$copyArray(cache, elements);
    }
}
function $678fa78e22f406a1$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $678fa78e22f406a1$var$copyArray(cache, v);
    } else {
        if ($678fa78e22f406a1$var$arraysEqual(cache, elements)) return;
        $678fa78e22f406a1$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $678fa78e22f406a1$var$mat4array);
        $678fa78e22f406a1$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $678fa78e22f406a1$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $678fa78e22f406a1$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $678fa78e22f406a1$var$copyArray(cache, v);
}
function $678fa78e22f406a1$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $678fa78e22f406a1$var$copyArray(cache, v);
}
function $678fa78e22f406a1$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $678fa78e22f406a1$var$copyArray(cache, v);
}
// Single unsigned integer
function $678fa78e22f406a1$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $678fa78e22f406a1$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $678fa78e22f406a1$var$copyArray(cache, v);
}
function $678fa78e22f406a1$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $678fa78e22f406a1$var$copyArray(cache, v);
}
function $678fa78e22f406a1$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($678fa78e22f406a1$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $678fa78e22f406a1$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $678fa78e22f406a1$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || $678fa78e22f406a1$var$emptyTexture, unit);
}
function $678fa78e22f406a1$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $678fa78e22f406a1$var$emptyTexture3d, unit);
}
function $678fa78e22f406a1$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || $678fa78e22f406a1$var$emptyCubeTexture, unit);
}
function $678fa78e22f406a1$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $678fa78e22f406a1$var$emptyTexture2dArray, unit);
}
// Helper to pick the right setter for the singular case
function $678fa78e22f406a1$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $678fa78e22f406a1$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $678fa78e22f406a1$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $678fa78e22f406a1$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $678fa78e22f406a1$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $678fa78e22f406a1$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $678fa78e22f406a1$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $678fa78e22f406a1$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $678fa78e22f406a1$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $678fa78e22f406a1$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $678fa78e22f406a1$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $678fa78e22f406a1$var$setValueV4i; // _VEC4
        case 0x1405:
            return $678fa78e22f406a1$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $678fa78e22f406a1$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $678fa78e22f406a1$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $678fa78e22f406a1$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $678fa78e22f406a1$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $678fa78e22f406a1$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $678fa78e22f406a1$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $678fa78e22f406a1$var$setValueT2DArray1;
    }
}
// Array of scalars
function $678fa78e22f406a1$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $678fa78e22f406a1$var$setValueV2fArray(gl, v) {
    const data = $678fa78e22f406a1$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $678fa78e22f406a1$var$setValueV3fArray(gl, v) {
    const data = $678fa78e22f406a1$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $678fa78e22f406a1$var$setValueV4fArray(gl, v) {
    const data = $678fa78e22f406a1$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $678fa78e22f406a1$var$setValueM2Array(gl, v) {
    const data = $678fa78e22f406a1$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $678fa78e22f406a1$var$setValueM3Array(gl, v) {
    const data = $678fa78e22f406a1$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $678fa78e22f406a1$var$setValueM4Array(gl, v) {
    const data = $678fa78e22f406a1$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $678fa78e22f406a1$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $678fa78e22f406a1$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $678fa78e22f406a1$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $678fa78e22f406a1$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $678fa78e22f406a1$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $678fa78e22f406a1$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $678fa78e22f406a1$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $678fa78e22f406a1$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / Cube)
function $678fa78e22f406a1$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $678fa78e22f406a1$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || $678fa78e22f406a1$var$emptyTexture, units[i]);
}
function $678fa78e22f406a1$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $678fa78e22f406a1$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || $678fa78e22f406a1$var$emptyCubeTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $678fa78e22f406a1$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $678fa78e22f406a1$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $678fa78e22f406a1$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $678fa78e22f406a1$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $678fa78e22f406a1$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $678fa78e22f406a1$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $678fa78e22f406a1$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $678fa78e22f406a1$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $678fa78e22f406a1$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $678fa78e22f406a1$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $678fa78e22f406a1$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $678fa78e22f406a1$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $678fa78e22f406a1$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $678fa78e22f406a1$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $678fa78e22f406a1$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $678fa78e22f406a1$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $678fa78e22f406a1$var$setValueT1Array;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $678fa78e22f406a1$var$setValueT6Array;
    }
}
// --- Uniform Classes ---
function $678fa78e22f406a1$var$SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = $678fa78e22f406a1$var$getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function $678fa78e22f406a1$var$PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = $678fa78e22f406a1$var$getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
$678fa78e22f406a1$var$PureArrayUniform.prototype.updateCache = function(data) {
    const cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    $678fa78e22f406a1$var$copyArray(cache, data);
};
function $678fa78e22f406a1$var$StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
$678fa78e22f406a1$var$StructuredUniform.prototype.setValue = function(gl, value, textures) {
    const seq = this.seq;
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $678fa78e22f406a1$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $678fa78e22f406a1$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $678fa78e22f406a1$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $678fa78e22f406a1$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $678fa78e22f406a1$var$RePathPart.exec(path), matchEnd = $678fa78e22f406a1$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $678fa78e22f406a1$var$addUniform(container, subscript === undefined ? new $678fa78e22f406a1$var$SingleUniform(id, activeInfo, addr) : new $678fa78e22f406a1$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $678fa78e22f406a1$var$StructuredUniform(id);
                $678fa78e22f406a1$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function $678fa78e22f406a1$var$WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    const n = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < n; ++i){
        const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        $678fa78e22f406a1$var$parseUniform(info, addr, this);
    }
}
$678fa78e22f406a1$var$WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    const u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
$678fa78e22f406a1$var$WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    const v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
$678fa78e22f406a1$var$WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
$678fa78e22f406a1$var$WebGLUniforms.seqWithValue = function(seq, values) {
    const r = [];
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function $678fa78e22f406a1$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $678fa78e22f406a1$var$programIdCount = 0;
function $678fa78e22f406a1$var$addLineNumbers(string) {
    const lines = string.split('\n');
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ': ' + lines[i];
    return lines.join('\n');
}
function $678fa78e22f406a1$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $678fa78e22f406a1$export$7207336e4151a112:
            return [
                'Linear',
                '( value )'
            ];
        case $678fa78e22f406a1$export$f32388edbb32674:
            return [
                'sRGB',
                '( value )'
            ];
        case $678fa78e22f406a1$export$3be4c466a12b5dcf:
            return [
                'RGBE',
                '( value )'
            ];
        case $678fa78e22f406a1$export$2c4bdfd76b188654:
            return [
                'RGBM',
                '( value, 7.0 )'
            ];
        case $678fa78e22f406a1$export$48a0051d6a5a9b9:
            return [
                'RGBM',
                '( value, 16.0 )'
            ];
        case $678fa78e22f406a1$export$ca2f89b13b49d951:
            return [
                'RGBD',
                '( value, 256.0 )'
            ];
        case $678fa78e22f406a1$export$eaab32c1bcea1817:
            return [
                'Gamma',
                '( value, float( GAMMA_FACTOR ) )'
            ];
        case $678fa78e22f406a1$export$8d4cbbeb1eea9f67:
            return [
                'LogLuv',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function $678fa78e22f406a1$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const log = gl.getShaderInfoLog(shader).trim();
    if (status && log === '') return '';
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    const source = gl.getShaderSource(shader);
    return 'THREE.WebGLShader: gl.getShaderInfoLog() ' + type + '\n' + log + $678fa78e22f406a1$var$addLineNumbers(source);
}
function $678fa78e22f406a1$var$getTexelDecodingFunction(functionName, encoding) {
    const components = $678fa78e22f406a1$var$getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return ' + components[0] + 'ToLinear' + components[1] + '; }';
}
function $678fa78e22f406a1$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $678fa78e22f406a1$var$getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function $678fa78e22f406a1$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $678fa78e22f406a1$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $678fa78e22f406a1$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $678fa78e22f406a1$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $678fa78e22f406a1$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $678fa78e22f406a1$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $678fa78e22f406a1$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission > 0.0) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($678fa78e22f406a1$var$filterEmptyLine).join('\n');
}
function $678fa78e22f406a1$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $678fa78e22f406a1$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = gl.getAttribLocation(program, name);
    }
    return attributes;
}
function $678fa78e22f406a1$var$filterEmptyLine(string) {
    return string !== '';
}
function $678fa78e22f406a1$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $678fa78e22f406a1$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $678fa78e22f406a1$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $678fa78e22f406a1$var$resolveIncludes(string) {
    return string.replace($678fa78e22f406a1$var$includePattern, $678fa78e22f406a1$var$includeReplacer);
}
function $678fa78e22f406a1$var$includeReplacer(match, include) {
    const string = $678fa78e22f406a1$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error('Can not resolve #include <' + include + '>');
    return $678fa78e22f406a1$var$resolveIncludes(string);
}
// Unroll Loops
const $678fa78e22f406a1$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const $678fa78e22f406a1$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $678fa78e22f406a1$var$unrollLoops(string) {
    return string.replace($678fa78e22f406a1$var$unrollLoopPattern, $678fa78e22f406a1$var$loopReplacer).replace($678fa78e22f406a1$var$deprecatedUnrollLoopPattern, $678fa78e22f406a1$var$deprecatedLoopReplacer);
}
function $678fa78e22f406a1$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn('WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.');
    return $678fa78e22f406a1$var$loopReplacer(match, start, end, snippet);
}
function $678fa78e22f406a1$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $678fa78e22f406a1$var$generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $678fa78e22f406a1$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $678fa78e22f406a1$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $678fa78e22f406a1$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $678fa78e22f406a1$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $678fa78e22f406a1$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $678fa78e22f406a1$export$8759762a6477f2c4:
        case $678fa78e22f406a1$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $678fa78e22f406a1$export$dbf3e70ff37af79:
        case $678fa78e22f406a1$export$76a9f4355364345c:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $678fa78e22f406a1$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $678fa78e22f406a1$export$dc59f8aed047f61d:
        case $678fa78e22f406a1$export$76a9f4355364345c:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $678fa78e22f406a1$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $678fa78e22f406a1$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $678fa78e22f406a1$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $678fa78e22f406a1$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $678fa78e22f406a1$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $678fa78e22f406a1$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $678fa78e22f406a1$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $678fa78e22f406a1$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $678fa78e22f406a1$var$generateEnvMapBlendingDefine(parameters);
    const gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1.0;
    const customExtensions = parameters.isWebGL2 ? '' : $678fa78e22f406a1$var$generateExtensions(parameters);
    const customDefines = $678fa78e22f406a1$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($678fa78e22f406a1$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($678fa78e22f406a1$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $678fa78e22f406a1$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            '#define MAX_BONES ' + parameters.maxBones,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_MORPHTARGETS',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($678fa78e22f406a1$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $678fa78e22f406a1$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest + (parameters.alphaTest % 1 ? '' : '.0') : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? '#define TEXTURE_LOD_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $678fa78e22f406a1$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $678fa78e22f406a1$export$9fcb6b4294603b2 ? $678fa78e22f406a1$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $678fa78e22f406a1$export$9fcb6b4294603b2 ? $678fa78e22f406a1$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            $678fa78e22f406a1$export$955f9f2e84c43c8b['encodings_pars_fragment'],
            parameters.map ? $678fa78e22f406a1$var$getTexelDecodingFunction('mapTexelToLinear', parameters.mapEncoding) : '',
            parameters.matcap ? $678fa78e22f406a1$var$getTexelDecodingFunction('matcapTexelToLinear', parameters.matcapEncoding) : '',
            parameters.envMap ? $678fa78e22f406a1$var$getTexelDecodingFunction('envMapTexelToLinear', parameters.envMapEncoding) : '',
            parameters.emissiveMap ? $678fa78e22f406a1$var$getTexelDecodingFunction('emissiveMapTexelToLinear', parameters.emissiveMapEncoding) : '',
            parameters.lightMap ? $678fa78e22f406a1$var$getTexelDecodingFunction('lightMapTexelToLinear', parameters.lightMapEncoding) : '',
            $678fa78e22f406a1$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding),
            parameters.depthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($678fa78e22f406a1$var$filterEmptyLine).join('\n');
    }
    vertexShader = $678fa78e22f406a1$var$resolveIncludes(vertexShader);
    vertexShader = $678fa78e22f406a1$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $678fa78e22f406a1$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $678fa78e22f406a1$var$resolveIncludes(fragmentShader);
    fragmentShader = $678fa78e22f406a1$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $678fa78e22f406a1$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $678fa78e22f406a1$var$unrollLoops(vertexShader);
    fragmentShader = $678fa78e22f406a1$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $678fa78e22f406a1$export$f63012db5506e7dd ? '' : 'out highp vec4 pc_fragColor;',
            parameters.glslVersion === $678fa78e22f406a1$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $678fa78e22f406a1$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $678fa78e22f406a1$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $678fa78e22f406a1$var$getShaderErrors(gl, glVertexShader, 'vertex');
            const fragmentErrors = $678fa78e22f406a1$var$getShaderErrors(gl, glFragmentShader, 'fragment');
            console.error('THREE.WebGLProgram: shader error: ', gl.getError(), '35715', gl.getProgramParameter(program, 35715), 'gl.getProgramInfoLog', programLog, vertexErrors, fragmentErrors);
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: gl.getProgramInfoLog()', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $678fa78e22f406a1$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $678fa78e22f406a1$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $678fa78e22f406a1$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
function $678fa78e22f406a1$var$WebGLPrograms(renderer, cubemaps, extensions, capabilities, bindingStates, clipping) {
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const floatVertexTextures = capabilities.floatVertexTextures;
    const maxVertexUniforms = capabilities.maxVertexUniforms;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    const parameterNames = [
        'precision',
        'isWebGL2',
        'supportsVertexTextures',
        'outputEncoding',
        'instancing',
        'instancingColor',
        'map',
        'mapEncoding',
        'matcap',
        'matcapEncoding',
        'envMap',
        'envMapMode',
        'envMapEncoding',
        'envMapCubeUV',
        'lightMap',
        'lightMapEncoding',
        'aoMap',
        'emissiveMap',
        'emissiveMapEncoding',
        'bumpMap',
        'normalMap',
        'objectSpaceNormalMap',
        'tangentSpaceNormalMap',
        'clearcoatMap',
        'clearcoatRoughnessMap',
        'clearcoatNormalMap',
        'displacementMap',
        'specularMap',
        'roughnessMap',
        'metalnessMap',
        'gradientMap',
        'alphaMap',
        'combine',
        'vertexColors',
        'vertexAlphas',
        'vertexTangents',
        'vertexUvs',
        'uvsVertexOnly',
        'fog',
        'useFog',
        'fogExp2',
        'flatShading',
        'sizeAttenuation',
        'logarithmicDepthBuffer',
        'skinning',
        'maxBones',
        'useVertexTexture',
        'morphTargets',
        'morphNormals',
        'premultipliedAlpha',
        'numDirLights',
        'numPointLights',
        'numSpotLights',
        'numHemiLights',
        'numRectAreaLights',
        'numDirLightShadows',
        'numPointLightShadows',
        'numSpotLightShadows',
        'shadowMapEnabled',
        'shadowMapType',
        'toneMapping',
        'physicallyCorrectLights',
        'alphaTest',
        'doubleSided',
        'flipSided',
        'numClippingPlanes',
        'numClipIntersection',
        'depthPacking',
        'dithering',
        'sheen',
        'transmission',
        'transmissionMap',
        'thicknessMap'
    ];
    function getMaxBones(object) {
        const skeleton = object.skeleton;
        const bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            const nVertexUniforms = maxVertexUniforms;
            const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            const maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn('THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.');
                return 0;
            }
            return maxBones;
        }
    }
    function getTextureEncodingFromMap(map) {
        let encoding;
        if (map && map.isTexture) encoding = map.encoding;
        else if (map && map.isWebGLRenderTarget) {
            console.warn('THREE.WebGLPrograms.getTextureEncodingFromMap: don\'t use render targets as textures. Use their .texture property instead.');
            encoding = map.texture.encoding;
        } else encoding = $678fa78e22f406a1$export$7207336e4151a112;
        return encoding;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = cubemaps.get(material.envMap || environment);
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        let vertexShader, fragmentShader;
        if (shaderID) {
            const shader = $678fa78e22f406a1$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
            map: !!material.map,
            mapEncoding: getTextureEncodingFromMap(material.map),
            matcap: !!material.matcap,
            matcapEncoding: getTextureEncodingFromMap(material.matcap),
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapEncoding: getTextureEncodingFromMap(envMap),
            envMapCubeUV: !!envMap && (envMap.mapping === $678fa78e22f406a1$export$dbf3e70ff37af79 || envMap.mapping === $678fa78e22f406a1$export$76a9f4355364345c),
            lightMap: !!material.lightMap,
            lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $678fa78e22f406a1$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $678fa78e22f406a1$export$2852a58ebdac27b8,
            clearcoatMap: !!material.clearcoatMap,
            clearcoatRoughnessMap: !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            alphaMap: !!material.alphaMap,
            gradientMap: !!material.gradientMap,
            sheen: !!material.sheen,
            transmission: !!material.transmission,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: material.normalMap && material.vertexTangents,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmission || !!material.transmissionMap || !!material.thicknessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.transmission || !!material.transmissionMap || !!material.thicknessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: material.morphTargets,
            morphNormals: material.morphNormals,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $678fa78e22f406a1$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            alphaTest: material.alphaTest,
            doubleSided: material.side === $678fa78e22f406a1$export$3b296b6f144d5b03,
            flipSided: material.side === $678fa78e22f406a1$export$d9f0486e75b5ace,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.fragmentShader);
            array.push(parameters.vertexShader);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            for(let i = 0; i < parameterNames.length; i++)array.push(parameters[parameterNames[i]]);
            array.push(renderer.outputEncoding);
            array.push(renderer.gammaFactor);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $678fa78e22f406a1$export$bee4a7d47f8f5014[shaderID];
            uniforms = $678fa78e22f406a1$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $678fa78e22f406a1$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs
    };
}
function $678fa78e22f406a1$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $678fa78e22f406a1$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.program !== b.program) return a.program.id - b.program.id;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $678fa78e22f406a1$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $678fa78e22f406a1$var$WebGLRenderList(properties) {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    const defaultProgram = {
        id: -1
    };
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        const materialProperties = properties.get(material);
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                program: materialProperties.program || defaultProgram,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.program = materialProperties.program || defaultProgram;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $678fa78e22f406a1$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $678fa78e22f406a1$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $678fa78e22f406a1$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.program = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $678fa78e22f406a1$var$WebGLRenderLists(properties) {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        let list;
        if (lists.has(scene) === false) {
            list = new $678fa78e22f406a1$var$WebGLRenderList(properties);
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $678fa78e22f406a1$var$WebGLRenderList(properties);
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $678fa78e22f406a1$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        color: new $678fa78e22f406a1$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        direction: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        color: new $678fa78e22f406a1$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        color: new $678fa78e22f406a1$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        skyColor: new $678fa78e22f406a1$export$892596cec99bc70e(),
                        groundColor: new $678fa78e22f406a1$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $678fa78e22f406a1$export$892596cec99bc70e(),
                        position: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        halfWidth: new $678fa78e22f406a1$export$64b5c384219d3699(),
                        halfHeight: new $678fa78e22f406a1$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $678fa78e22f406a1$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $678fa78e22f406a1$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $678fa78e22f406a1$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $678fa78e22f406a1$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $678fa78e22f406a1$var$nextVersion = 0;
function $678fa78e22f406a1$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $678fa78e22f406a1$var$WebGLLights(extensions, capabilities) {
    const cache = new $678fa78e22f406a1$var$UniformsCache();
    const shadowCache = $678fa78e22f406a1$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $678fa78e22f406a1$export$64b5c384219d3699());
    const vector3 = new $678fa78e22f406a1$export$64b5c384219d3699();
    const matrix4 = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
    const matrix42 = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort($678fa78e22f406a1$var$shadowCastingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $678fa78e22f406a1$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $678fa78e22f406a1$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $678fa78e22f406a1$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $678fa78e22f406a1$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $678fa78e22f406a1$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $678fa78e22f406a1$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $678fa78e22f406a1$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                uniforms.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $678fa78e22f406a1$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $678fa78e22f406a1$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $678fa78e22f406a1$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $678fa78e22f406a1$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $678fa78e22f406a1$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ class $678fa78e22f406a1$export$2698c22ec13825db extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.morphTargets = source.morphTargets;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $678fa78e22f406a1$export$deeb383078690b50;
        this.morphTargets = false;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$2698c22ec13825db.prototype.isMeshDepthMaterial = true;
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  morphTargets: <bool>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ class $678fa78e22f406a1$export$33e187ed002f2a19 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.morphTargets = source.morphTargets;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'MeshDistanceMaterial';
        this.referencePosition = new $678fa78e22f406a1$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.morphTargets = false;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.fog = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$33e187ed002f2a19.prototype.isMeshDistanceMaterial = true;
var $678fa78e22f406a1$var$vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n\tfor ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean * HALF_SAMPLE_RATE;\n\tsquared_mean = squared_mean * HALF_SAMPLE_RATE;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var $678fa78e22f406a1$var$vsm_vert = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
function $678fa78e22f406a1$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $678fa78e22f406a1$export$35efe6f4c85463d2();
    const _shadowMapSize = new $678fa78e22f406a1$export$c977b3e384af9ae1(), _viewportSize = new $678fa78e22f406a1$export$c977b3e384af9ae1(), _viewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3(), _depthMaterials = [], _distanceMaterials = [], _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $678fa78e22f406a1$export$d9f0486e75b5ace,
        1: $678fa78e22f406a1$export$2ede184fc2998901,
        2: $678fa78e22f406a1$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $678fa78e22f406a1$export$83c7d75d550a8b0d({
        defines: {
            SAMPLE_RATE: 0.25,
            HALF_SAMPLE_RATE: 0.125
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $678fa78e22f406a1$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $678fa78e22f406a1$var$vsm_vert,
        fragmentShader: $678fa78e22f406a1$var$vsm_frag
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $678fa78e22f406a1$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $678fa78e22f406a1$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $678fa78e22f406a1$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($678fa78e22f406a1$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === $678fa78e22f406a1$export$896ae1ade6c829c4) {
                const pars = {
                    minFilter: $678fa78e22f406a1$export$8a72f490b25c56c8,
                    magFilter: $678fa78e22f406a1$export$8a72f490b25c56c8,
                    format: $678fa78e22f406a1$export$3f8bb04b555a363c
                };
                shadow.map = new $678fa78e22f406a1$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.mapPass = new $678fa78e22f406a1$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                const pars = {
                    minFilter: $678fa78e22f406a1$export$727aa5ec3fe39bf0,
                    magFilter: $678fa78e22f406a1$export$727aa5ec3fe39bf0,
                    format: $678fa78e22f406a1$export$3f8bb04b555a363c
                };
                shadow.map = new $678fa78e22f406a1$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === $678fa78e22f406a1$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterialVariant(useMorphing) {
        const index = useMorphing << 0;
        let material = _depthMaterials[index];
        if (material === undefined) {
            material = new $678fa78e22f406a1$export$2698c22ec13825db({
                depthPacking: $678fa78e22f406a1$export$8f910f4c4f73df11,
                morphTargets: useMorphing
            });
            _depthMaterials[index] = material;
        }
        return material;
    }
    function getDistanceMaterialVariant(useMorphing) {
        const index = useMorphing << 0;
        let material = _distanceMaterials[index];
        if (material === undefined) {
            material = new $678fa78e22f406a1$export$33e187ed002f2a19({
                morphTargets: useMorphing
            });
            _distanceMaterials[index] = material;
        }
        return material;
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        let getMaterialVariant = getDepthMaterialVariant;
        let customMaterial = object.customDepthMaterial;
        if (light.isPointLight === true) {
            getMaterialVariant = getDistanceMaterialVariant;
            customMaterial = object.customDistanceMaterial;
        }
        if (customMaterial === undefined) {
            let useMorphing = false;
            if (material.morphTargets === true) useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
            result = getMaterialVariant(useMorphing);
        } else result = customMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $678fa78e22f406a1$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $678fa78e22f406a1$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $678fa78e22f406a1$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $678fa78e22f406a1$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $678fa78e22f406a1$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $678fa78e22f406a1$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $678fa78e22f406a1$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $678fa78e22f406a1$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $678fa78e22f406a1$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $678fa78e22f406a1$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $678fa78e22f406a1$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let xrFramebuffer = null;
    let currentBoundFramebuffers = {};
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $678fa78e22f406a1$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($678fa78e22f406a1$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($678fa78e22f406a1$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($678fa78e22f406a1$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindXRFramebuffer(framebuffer) {
        if (framebuffer !== xrFramebuffer) {
            gl.bindFramebuffer(36160, framebuffer);
            xrFramebuffer = framebuffer;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (framebuffer === null && xrFramebuffer !== null) framebuffer = xrFramebuffer; // use active XR framebuffer if available
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$678fa78e22f406a1$export$20183a0484ce21a0]: 32774,
        [$678fa78e22f406a1$export$73e0df5177988548]: 32778,
        [$678fa78e22f406a1$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$678fa78e22f406a1$export$c8c1508da8d0600c] = 32775;
        equationToGL[$678fa78e22f406a1$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$678fa78e22f406a1$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$678fa78e22f406a1$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$678fa78e22f406a1$export$2110f05edf778d3d]: 0,
        [$678fa78e22f406a1$export$8805bad65e24940e]: 1,
        [$678fa78e22f406a1$export$7fbe15b28d28cf52]: 768,
        [$678fa78e22f406a1$export$d5773124e86cf28c]: 770,
        [$678fa78e22f406a1$export$c05e2a1fc8609506]: 776,
        [$678fa78e22f406a1$export$ef5f2dd8ffac5574]: 774,
        [$678fa78e22f406a1$export$a78aed1ca2a87192]: 772,
        [$678fa78e22f406a1$export$947829af9f2c17f6]: 769,
        [$678fa78e22f406a1$export$11d468cc7f19e971]: 771,
        [$678fa78e22f406a1$export$56b85b2686ab16]: 775,
        [$678fa78e22f406a1$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $678fa78e22f406a1$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $678fa78e22f406a1$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $678fa78e22f406a1$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $678fa78e22f406a1$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $678fa78e22f406a1$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $678fa78e22f406a1$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $678fa78e22f406a1$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $678fa78e22f406a1$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $678fa78e22f406a1$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 0, 769, 771);
                        break;
                    case $678fa78e22f406a1$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $678fa78e22f406a1$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $678fa78e22f406a1$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $678fa78e22f406a1$export$cdfa06f868e2e467:
                        gl.blendFunc(0, 769);
                        break;
                    case $678fa78e22f406a1$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $678fa78e22f406a1$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $678fa78e22f406a1$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $678fa78e22f406a1$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($678fa78e22f406a1$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $678fa78e22f406a1$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $678fa78e22f406a1$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $678fa78e22f406a1$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        xrFramebuffer = null;
        currentBoundFramebuffers = {};
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        bindXRFramebuffer: bindXRFramebuffer,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $678fa78e22f406a1$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const _videoTextures = new WeakMap();
    let _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $678fa78e22f406a1$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $678fa78e22f406a1$var$isPowerOfTwo(image.width) && $678fa78e22f406a1$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $678fa78e22f406a1$export$9d9334239a5a5e06 || texture.wrapT !== $678fa78e22f406a1$export$9d9334239a5a5e06 || texture.minFilter !== $678fa78e22f406a1$export$727aa5ec3fe39bf0 && texture.minFilter !== $678fa78e22f406a1$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $678fa78e22f406a1$export$727aa5ec3fe39bf0 && texture.minFilter !== $678fa78e22f406a1$export$8a72f490b25c56c8;
    }
    function generateMipmap(target, texture, width, height) {
        _gl.generateMipmap(target);
        const textureProperties = properties.get(texture);
        textureProperties.__maxMipLevel = Math.log2(Math.max(width, height));
    }
    function getInternalFormat(internalFormatName, glFormat, glType) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 6407) {
            if (glType === 5126) internalFormat = 34837;
            if (glType === 5131) internalFormat = 34843;
            if (glType === 5121) internalFormat = 32849;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = 32856;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $678fa78e22f406a1$export$727aa5ec3fe39bf0 || f === $678fa78e22f406a1$export$d129e38cf6feaa8c || f === $678fa78e22f406a1$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === undefined) console.warn('THREE.WebGLRenderer: Texture marked for update but image is undefined');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$678fa78e22f406a1$export$533346c8e8dac0f5]: 10497,
        [$678fa78e22f406a1$export$9d9334239a5a5e06]: 33071,
        [$678fa78e22f406a1$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$678fa78e22f406a1$export$727aa5ec3fe39bf0]: 9728,
        [$678fa78e22f406a1$export$d129e38cf6feaa8c]: 9984,
        [$678fa78e22f406a1$export$d2327c1afe5bfdf2]: 9986,
        [$678fa78e22f406a1$export$8a72f490b25c56c8]: 9729,
        [$678fa78e22f406a1$export$19a719f377145a13]: 9985,
        [$678fa78e22f406a1$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $678fa78e22f406a1$export$9d9334239a5a5e06 || texture.wrapT !== $678fa78e22f406a1$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $678fa78e22f406a1$export$727aa5ec3fe39bf0 && texture.minFilter !== $678fa78e22f406a1$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.type === $678fa78e22f406a1$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $678fa78e22f406a1$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
        const image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format);
        let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(textureType, texture, supportsMips);
        let mipmap;
        const mipmaps = texture.mipmaps;
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === $678fa78e22f406a1$export$f6d331659b644596) glInternalFormat = 36012;
                else if (texture.type === $678fa78e22f406a1$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                else if (texture.type === $678fa78e22f406a1$export$6c8ea339bfab1301) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === $678fa78e22f406a1$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
            // validation checks for WebGL 1
            if (texture.format === $678fa78e22f406a1$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== $678fa78e22f406a1$export$c63dc51868b06a9d && texture.type !== $678fa78e22f406a1$export$c3c7fc4518ebba96) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                    texture.type = $678fa78e22f406a1$export$c63dc51868b06a9d;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === $678fa78e22f406a1$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== $678fa78e22f406a1$export$6c8ea339bfab1301) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                    texture.type = $678fa78e22f406a1$export$6c8ea339bfab1301;
                    glType = utils.convert(texture.type);
                }
            }
            //
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
                textureProperties.__maxMipLevel = mipmaps.length - 1;
            } else {
                state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
                textureProperties.__maxMipLevel = 0;
            }
        } else if (texture.isCompressedTexture) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                if (texture.format !== $678fa78e22f406a1$export$3f8bb04b555a363c && texture.format !== $678fa78e22f406a1$export$7c67423a5ee6f5eb) {
                    if (glFormat !== null) state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                } else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else if (texture.isDataTexture2DArray) {
            state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else if (texture.isDataTexture3D) {
            state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else // regular Texture (image, video, canvas)
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
            }
            texture.generateMipmaps = false;
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            textureProperties.__maxMipLevel = 0;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        _gl.pixelStorei(37443, 0);
        const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for(let i = 0; i < 6; i++)if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
        else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
        const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(34067, texture, supportsMips);
        let mipmaps;
        if (isCompressed) {
            for(let i = 0; i < 6; i++){
                mipmaps = cubeImage[i].mipmaps;
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (texture.format !== $678fa78e22f406a1$export$3f8bb04b555a363c && texture.format !== $678fa78e22f406a1$export$7c67423a5ee6f5eb) {
                        if (glFormat !== null) state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                    } else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            mipmaps = texture.mipmaps;
            for(let i = 0; i < 6; i++)if (isDataTexture) {
                state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const mipmapImage = mipmap.image[i].image;
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
        else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        state.bindFramebuffer(36160, framebuffer);
        _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $678fa78e22f406a1$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $678fa78e22f406a1$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            // Use the first texture for MRT so far
            const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
            const glFormat = utils.convert(texture.format);
            const glType = utils.convert(texture.type);
            const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        if (renderTarget.depthTexture.format === $678fa78e22f406a1$export$c1b6b5136be58045) _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        else if (renderTarget.depthTexture.format === $678fa78e22f406a1$export$1e113ac2d0905829) _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
        const isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Handles WebGL2 RGBFormat fallback - #18858
        if (isWebGL2 && texture.format === $678fa78e22f406a1$export$7c67423a5ee6f5eb && (texture.type === $678fa78e22f406a1$export$f6d331659b644596 || texture.type === $678fa78e22f406a1$export$2697304443f382bc)) {
            texture.format = $678fa78e22f406a1$export$3f8bb04b555a363c;
            console.warn('THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.');
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            } else if (isMultisample) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    const glFormat = utils.convert(texture.format);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    state.bindFramebuffer(36160, null);
                } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067, texture, renderTarget.width, renderTarget.height);
            state.bindTexture(34067, null);
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553, attachment, renderTarget.width, renderTarget.height);
            }
            state.bindTexture(3553, null);
        } else {
            let glTextureType = 3553;
            if (isRenderTarget3D) {
                // Render targets containing layers, i.e: Texture 3D and 2d arrays
                if (isWebGL2) {
                    const isTexture3D = texture.isDataTexture3D;
                    glTextureType = isTexture3D ? 32879 : 35866;
                } else console.warn('THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(3553, texture, renderTarget.width, renderTarget.height);
            state.bindTexture(3553, null);
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target, texture, renderTarget.width, renderTarget.height);
                state.bindTexture(target, null);
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.isWebGLMultisampleRenderTarget) {
            if (isWebGL2) {
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = 16384;
                if (renderTarget.depthBuffer) mask |= 256;
                if (renderTarget.stencilBuffer) mask |= 1024;
                const renderTargetProperties = properties.get(renderTarget);
                state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                state.bindFramebuffer(36008, null);
                state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
            } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    // backwards compatibility
    let warnedTexture2D = false;
    let warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn('THREE.WebGLTextures.safeSetTexture2D: don\'t use render targets as textures. Use their .texture property instead.');
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn('THREE.WebGLTextures.safeSetTextureCube: don\'t use cube render targets as textures. Use their .texture property instead.');
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function $678fa78e22f406a1$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p) {
        let extension;
        if (p === $678fa78e22f406a1$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $678fa78e22f406a1$export$b3969b01faf587f2) return 32819;
        if (p === $678fa78e22f406a1$export$18886f8ae33e90de) return 32820;
        if (p === $678fa78e22f406a1$export$cb1fa50553eb14c4) return 33635;
        if (p === $678fa78e22f406a1$export$545fce0311a9796a) return 5120;
        if (p === $678fa78e22f406a1$export$88572337f312435f) return 5122;
        if (p === $678fa78e22f406a1$export$c63dc51868b06a9d) return 5123;
        if (p === $678fa78e22f406a1$export$5c612977753abe2) return 5124;
        if (p === $678fa78e22f406a1$export$c3c7fc4518ebba96) return 5125;
        if (p === $678fa78e22f406a1$export$f6d331659b644596) return 5126;
        if (p === $678fa78e22f406a1$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $678fa78e22f406a1$export$988473390501ed4b) return 6406;
        if (p === $678fa78e22f406a1$export$7c67423a5ee6f5eb) return 6407;
        if (p === $678fa78e22f406a1$export$3f8bb04b555a363c) return 6408;
        if (p === $678fa78e22f406a1$export$cc09ccbf6d1ed449) return 6409;
        if (p === $678fa78e22f406a1$export$9053a81c4a69c289) return 6410;
        if (p === $678fa78e22f406a1$export$c1b6b5136be58045) return 6402;
        if (p === $678fa78e22f406a1$export$1e113ac2d0905829) return 34041;
        if (p === $678fa78e22f406a1$export$4e041a7967d15c4b) return 6403;
        // WebGL2 formats.
        if (p === $678fa78e22f406a1$export$aa92e870a709d190) return 36244;
        if (p === $678fa78e22f406a1$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $678fa78e22f406a1$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $678fa78e22f406a1$export$d1fd40c11bfa798e) return 36248;
        if (p === $678fa78e22f406a1$export$c200e7d26f592f21) return 36249;
        if (p === $678fa78e22f406a1$export$21d1799c6d552fc0 || p === $678fa78e22f406a1$export$afa304c3e981b668 || p === $678fa78e22f406a1$export$d2a1a68024a3e56c || p === $678fa78e22f406a1$export$9a79c424327dacf9) {
            extension = extensions.get('WEBGL_compressed_texture_s3tc');
            if (extension !== null) {
                if (p === $678fa78e22f406a1$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (p === $678fa78e22f406a1$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (p === $678fa78e22f406a1$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (p === $678fa78e22f406a1$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (p === $678fa78e22f406a1$export$19ada9bbb1af3573 || p === $678fa78e22f406a1$export$d0f0355bb3d948e4 || p === $678fa78e22f406a1$export$b82296714358084c || p === $678fa78e22f406a1$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $678fa78e22f406a1$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $678fa78e22f406a1$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $678fa78e22f406a1$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $678fa78e22f406a1$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (p === $678fa78e22f406a1$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        if (p === $678fa78e22f406a1$export$7800993ef8106a6a || p === $678fa78e22f406a1$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $678fa78e22f406a1$export$7800993ef8106a6a) return extension.COMPRESSED_RGB8_ETC2;
                if (p === $678fa78e22f406a1$export$23ed8300a860e7d8) return extension.COMPRESSED_RGBA8_ETC2_EAC;
            }
        }
        if (p === $678fa78e22f406a1$export$dc5570b4a2b92d48 || p === $678fa78e22f406a1$export$68880cd325f8b2fb || p === $678fa78e22f406a1$export$7d2c0be323373d95 || p === $678fa78e22f406a1$export$22b52da301fc3a3e || p === $678fa78e22f406a1$export$c009e2cb4a66485e || p === $678fa78e22f406a1$export$118fff5afa255b63 || p === $678fa78e22f406a1$export$120713c829ae0667 || p === $678fa78e22f406a1$export$c79eeabbf53313e9 || p === $678fa78e22f406a1$export$443cf6567cdd6424 || p === $678fa78e22f406a1$export$6573984fc9840780 || p === $678fa78e22f406a1$export$e7aee563f30091de || p === $678fa78e22f406a1$export$2eb8634622ddeab7 || p === $678fa78e22f406a1$export$202b1ce7b5d25742 || p === $678fa78e22f406a1$export$18ab77abd087e467 || p === $678fa78e22f406a1$export$4487000d1baf578b || p === $678fa78e22f406a1$export$4a1746c7512b1ea1 || p === $678fa78e22f406a1$export$4208debc782f5653 || p === $678fa78e22f406a1$export$82c5f9d3037aaea3 || p === $678fa78e22f406a1$export$64e357a152723eb9 || p === $678fa78e22f406a1$export$1b7711037f5e380e || p === $678fa78e22f406a1$export$eb234716dfb52c31 || p === $678fa78e22f406a1$export$8041d2df79c555f || p === $678fa78e22f406a1$export$27d2c8c0fcc7b83a || p === $678fa78e22f406a1$export$27b9de07b84a1334 || p === $678fa78e22f406a1$export$5c2b31a31ccc15c8 || p === $678fa78e22f406a1$export$5c4d4b335786f8f3 || p === $678fa78e22f406a1$export$e0c50c800e38be11 || p === $678fa78e22f406a1$export$9b0442bae422b2db) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === $678fa78e22f406a1$export$ce40b115e188bc81) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === $678fa78e22f406a1$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
class $678fa78e22f406a1$export$56b937d9e5581166 extends $678fa78e22f406a1$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.cameras = array;
    }
}
$678fa78e22f406a1$export$56b937d9e5581166.prototype.isArrayCamera = true;
class $678fa78e22f406a1$export$eb2fcfdbd7ba97d4 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'Group';
    }
}
$678fa78e22f406a1$export$eb2fcfdbd7ba97d4.prototype.isGroup = true;
const $678fa78e22f406a1$var$_moveEvent = {
    type: 'move'
};
class $678fa78e22f406a1$var$WebXRController {
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $678fa78e22f406a1$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $678fa78e22f406a1$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $678fa78e22f406a1$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $678fa78e22f406a1$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $678fa78e22f406a1$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($678fa78e22f406a1$var$_moveEvent);
                }
            }
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $678fa78e22f406a1$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
}
class $678fa78e22f406a1$var$WebXRManager extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        const state = renderer.state;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        let pose = null;
        const controllers = [];
        const inputSourcesMap = new Map();
        //
        const cameraL = new $678fa78e22f406a1$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
        const cameraR = new $678fa78e22f406a1$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $678fa78e22f406a1$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $678fa78e22f406a1$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $678fa78e22f406a1$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $678fa78e22f406a1$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controller = inputSourcesMap.get(event.inputSource);
            if (controller) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            inputSourcesMap.forEach(function(controller, inputSource) {
                controller.disconnect(inputSource);
            });
            inputSourcesMap.clear();
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            state.bindXRFramebuffer(null);
            renderer.setRenderTarget(renderer.getRenderTarget());
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return referenceSpace;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                const attributes = gl.getContextAttributes();
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                const layerInit = {
                    antialias: attributes.antialias,
                    alpha: attributes.alpha,
                    depth: attributes.depth,
                    stencil: attributes.stencil,
                    framebufferScaleFactor: framebufferScaleFactor
                };
                // eslint-disable-next-line no-undef
                const baseLayer = new XRWebGLLayer(session, gl, layerInit);
                session.updateRenderState({
                    baseLayer: baseLayer
                });
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        function onInputSourcesChange(event) {
            const inputSources = session.inputSources;
            // Assign inputSources to available controllers
            for(let i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) {
                    controller.dispatchEvent({
                        type: 'disconnected',
                        data: inputSource
                    });
                    inputSourcesMap.delete(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                const controller = inputSourcesMap.get(inputSource);
                if (controller) controller.dispatchEvent({
                    type: 'connected',
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $678fa78e22f406a1$export$64b5c384219d3699();
        const cameraRPos = new $678fa78e22f406a1$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update camera and its children
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(referenceSpace);
            if (pose !== null) {
                const views = pose.views;
                const baseLayer = session.renderState.baseLayer;
                state.bindXRFramebuffer(baseLayer.framebuffer);
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    const viewport = baseLayer.getViewport(view);
                    const camera = cameras[i];
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            const inputSources = session.inputSources;
            for(let i = 0; i < controllers.length; i++){
                const controller = controllers[i];
                const inputSource = inputSources[i];
                controller.update(inputSource, frame, referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
        }
        const animation = new $678fa78e22f406a1$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $678fa78e22f406a1$var$WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap._needsFlipEnvMap ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.refractionRatio.value = material.refractionRatio;
            const maxMipLevel = properties.get(envMap).__maxMipLevel;
            if (maxMipLevel !== undefined) uniforms.maxMipLevel.value = maxMipLevel;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        refreshUniformsStandard(uniforms, material);
        uniforms.reflectivity.value = material.reflectivity; // also part of uniforms common
        uniforms.clearcoat.value = material.clearcoat;
        uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
        if (material.sheen) uniforms.sheen.value.copy(material.sheen);
        if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
        if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        if (material.clearcoatNormalMap) {
            uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
            uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
        }
        uniforms.transmission.value = material.transmission;
        if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
        if (material.transmission > 0.0) {
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
        }
        uniforms.thickness.value = material.thickness;
        if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
        uniforms.attenuationDistance.value = material.attenuationDistance;
        uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $678fa78e22f406a1$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $678fa78e22f406a1$var$createCanvasElement() {
    const canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    canvas.style.display = 'block';
    return canvas;
}
function $678fa78e22f406a1$export$f6cc00ef28d7cf97(parameters) {
    parameters = parameters || {};
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $678fa78e22f406a1$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default', _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.gammaFactor = 2.0; // for backwards compatibility
    this.outputEncoding = $678fa78e22f406a1$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $678fa78e22f406a1$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
    const _currentScissor = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    //
    const _currentDrawBuffers = [];
    // frustum
    const _frustum = new $678fa78e22f406a1$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
    const _vector3 = new $678fa78e22f406a1$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: _alpha,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener('webglcontextlost', onContextLost, false);
        _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
        if (_gl === null) {
            const contextNames = [
                'webgl2',
                'webgl',
                'experimental-webgl'
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                else throw new Error('Error creating WebGL context.');
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                'rangeMin': 1,
                'rangeMax': 1,
                'precision': 1
            };
        };
    } catch (error) {
        console.error('THREE.WebGLRenderer: ' + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new $678fa78e22f406a1$var$WebGLExtensions(_gl);
        capabilities = new $678fa78e22f406a1$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $678fa78e22f406a1$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $678fa78e22f406a1$var$WebGLState(_gl, extensions, capabilities);
        _currentDrawBuffers[0] = 1029;
        info = new $678fa78e22f406a1$var$WebGLInfo(_gl);
        properties = new $678fa78e22f406a1$var$WebGLProperties();
        textures = new $678fa78e22f406a1$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $678fa78e22f406a1$var$WebGLCubeMaps(_this);
        attributes = new $678fa78e22f406a1$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $678fa78e22f406a1$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $678fa78e22f406a1$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $678fa78e22f406a1$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $678fa78e22f406a1$var$WebGLMorphtargets(_gl);
        clipping = new $678fa78e22f406a1$var$WebGLClipping(properties);
        programCache = new $678fa78e22f406a1$var$WebGLPrograms(_this, cubemaps, extensions, capabilities, bindingStates, clipping);
        materials = new $678fa78e22f406a1$var$WebGLMaterials(properties);
        renderLists = new $678fa78e22f406a1$var$WebGLRenderLists(properties);
        renderStates = new $678fa78e22f406a1$var$WebGLRenderStates(extensions, capabilities);
        background = new $678fa78e22f406a1$var$WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
        shadowMap = new $678fa78e22f406a1$var$WebGLShadowMap(_this, objects, capabilities);
        bufferRenderer = new $678fa78e22f406a1$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $678fa78e22f406a1$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $678fa78e22f406a1$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getsize() now requires a Vector2 as an argument');
            target = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        }
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + 'px';
            _canvas.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getdrawingBufferSize() now requires a Vector2 as an argument');
            target = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        }
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getCurrentViewport() now requires a Vector4 as an argument');
            target = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
        }
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getClearColor() now requires a Color as an argument');
            target = new $678fa78e22f406a1$export$892596cec99bc70e();
        }
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        let bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener('webglcontextlost', onContextLost, false);
        _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        xr.dispose();
        xr.removeEventListener('sessionstart', onXRSessionStart);
        xr.removeEventListener('sessionend', onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log('THREE.WebGLRenderer: Context Lost.');
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log('THREE.WebGLRenderer: Context Restored.');
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) programs.forEach(function(program) {
            programCache.releaseProgram(program);
        });
    }
    // Buffer rendering
    function renderObjectImmediate(object, program) {
        object.render(function(object) {
            _this.renderBufferImmediate(object, program);
        });
    }
    this.renderBufferImmediate = function(object, program) {
        bindingStates.initAttributes();
        const buffers = properties.get(object);
        if (object.hasPositions && !buffers.position) buffers.position = _gl.createBuffer();
        if (object.hasNormals && !buffers.normal) buffers.normal = _gl.createBuffer();
        if (object.hasUvs && !buffers.uv) buffers.uv = _gl.createBuffer();
        if (object.hasColors && !buffers.color) buffers.color = _gl.createBuffer();
        const programAttributes = program.getAttributes();
        if (object.hasPositions) {
            _gl.bindBuffer(34962, buffers.position);
            _gl.bufferData(34962, object.positionArray, 35048);
            bindingStates.enableAttribute(programAttributes.position);
            _gl.vertexAttribPointer(programAttributes.position, 3, 5126, false, 0, 0);
        }
        if (object.hasNormals) {
            _gl.bindBuffer(34962, buffers.normal);
            _gl.bufferData(34962, object.normalArray, 35048);
            bindingStates.enableAttribute(programAttributes.normal);
            _gl.vertexAttribPointer(programAttributes.normal, 3, 5126, false, 0, 0);
        }
        if (object.hasUvs) {
            _gl.bindBuffer(34962, buffers.uv);
            _gl.bufferData(34962, object.uvArray, 35048);
            bindingStates.enableAttribute(programAttributes.uv);
            _gl.vertexAttribPointer(programAttributes.uv, 2, 5126, false, 0, 0);
        }
        if (object.hasColors) {
            _gl.bindBuffer(34962, buffers.color);
            _gl.bufferData(34962, object.colorArray, 35048);
            bindingStates.enableAttribute(programAttributes.color);
            _gl.vertexAttribPointer(programAttributes.color, 3, 5126, false, 0, 0);
        }
        bindingStates.disableUnusedAttributes();
        _gl.drawArrays(4, 0, object.count);
        object.count = 0;
    };
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        if (material.morphTargets || material.morphNormals) morphtargets.update(object, geometry, material, program);
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights();
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $678fa78e22f406a1$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== 'undefined') animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener('sessionstart', onXRSessionStart);
    xr.addEventListener('sessionend', onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        currentRenderState.setupLights();
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isImmediateRenderObject) {
                if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                currentRenderList.push(object, null, object.material, groupOrder, _vector3.z, null);
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderTransmissiveObjects(opaqueObjects, transmissiveObjects, scene, camera) {
        if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $678fa78e22f406a1$export$3c052beb2e51e23f(1024, 1024, {
            generateMipmaps: true,
            minFilter: $678fa78e22f406a1$export$5d8599b6a933fb1b,
            magFilter: $678fa78e22f406a1$export$727aa5ec3fe39bf0,
            wrapS: $678fa78e22f406a1$export$9d9334239a5a5e06,
            wrapT: $678fa78e22f406a1$export$9d9334239a5a5e06
        });
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        renderObjects(opaqueObjects, scene, camera);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
        renderObjects(transmissiveObjects, scene, camera);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let j = 0, jl = cameras.length; j < jl; j++){
                    const camera2 = cameras[j];
                    if (object.layers.test(camera2.layers)) {
                        state.viewport(_currentViewport.copy(camera2.viewport));
                        currentRenderState.setupLightsView(camera2);
                        renderObject(object, scene, camera2, geometry, material, group);
                    }
                }
            } else renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        if (object.isImmediateRenderObject) {
            const program = setProgram(camera, scene, material, object);
            state.setMaterial(material);
            bindingStates.reset();
            renderObjectImmediate(object, program);
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = cubemaps.get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener('dispose', onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $678fa78e22f406a1$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
    }
    function setProgram(camera, scene, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
        const envMap = cubemaps.get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && object.geometry && object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
        }
        // skinning uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone texture must go before other textures
        // otherwise textures used for skinning can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, 'bindMatrix');
            p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, 'boneMatrices');
            }
        }
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $678fa78e22f406a1$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $678fa78e22f406a1$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
        // common matrices
        p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
        p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
        p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        if (renderTarget && properties.get(renderTarget).__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isDataTexture3D || texture.isDataTexture2DArray) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.isWebGLMultisampleRenderTarget) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers) {
            let needsUpdate = false;
            if (renderTarget) {
                if (renderTarget.isWebGLMultipleRenderTargets) {
                    const textures = renderTarget.texture;
                    if (_currentDrawBuffers.length !== textures.length || _currentDrawBuffers[0] !== 36064) {
                        for(let i = 0, il = textures.length; i < il; i++)_currentDrawBuffers[i] = 36064 + i;
                        _currentDrawBuffers.length = textures.length;
                        needsUpdate = true;
                    }
                } else if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 36064) {
                    _currentDrawBuffers[0] = 36064;
                    _currentDrawBuffers.length = 1;
                    needsUpdate = true;
                }
            } else if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 1029) {
                _currentDrawBuffers[0] = 1029;
                _currentDrawBuffers.length = 1;
                needsUpdate = true;
            }
            if (needsUpdate) {
                if (capabilities.isWebGL2) _gl.drawBuffers(_currentDrawBuffers);
                else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(_currentDrawBuffers);
            }
        }
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $678fa78e22f406a1$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                }
                const halfFloatSupportedByExt = textureType === $678fa78e22f406a1$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                if (textureType !== $678fa78e22f406a1$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $678fa78e22f406a1$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error('THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.');
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        let glFormat = utils.convert(texture.format);
        if (capabilities.isWebGL2) {
            // Workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=1120100
            if (glFormat === 6407) glFormat = 32849;
            if (glFormat === 6408) glFormat = 32856;
        }
        textures.setTexture2D(texture, 0);
        _gl.copyTexImage2D(3553, level, glFormat, position.x, position.y, width, height, 0);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
            return;
        }
        const { width: width, height: height, data: data } = srcTexture.image;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isDataTexture3D) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataTexture2DArray) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        _gl.pixelStorei(3314, width);
        _gl.pixelStorei(32878, height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, sourceBox.max.x - sourceBox.min.x + 1, sourceBox.max.y - sourceBox.min.y + 1, sourceBox.max.z - sourceBox.min.z + 1, glFormat, glType, data);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: this
    })); // eslint-disable-line no-undef
}
class $678fa78e22f406a1$export$a2f65229194348f9 extends $678fa78e22f406a1$export$f6cc00ef28d7cf97 {
}
$678fa78e22f406a1$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $678fa78e22f406a1$export$6f1519f023b8d0f6 {
    clone() {
        return new $678fa78e22f406a1$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            color: this.color.getHex(),
            density: this.density
        };
    }
    constructor(color, density = 0.00025){
        this.name = '';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(color);
        this.density = density;
    }
}
$678fa78e22f406a1$export$6f1519f023b8d0f6.prototype.isFogExp2 = true;
class $678fa78e22f406a1$export$3c890837b09508d4 {
    clone() {
        return new $678fa78e22f406a1$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
    constructor(color, near = 1, far = 1000){
        this.name = '';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
}
$678fa78e22f406a1$export$3c890837b09508d4.prototype.isFog = true;
class $678fa78e22f406a1$export$38af1803e3442a7f extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.background !== null) data.object.background = this.background.toJSON(meta);
        if (this.environment !== null) data.object.environment = this.environment.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
    constructor(){
        super();
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        })); // eslint-disable-line no-undef
    }
}
$678fa78e22f406a1$export$38af1803e3442a7f.prototype.isScene = true;
class $678fa78e22f406a1$export$3d5cd879f108f53f {
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $678fa78e22f406a1$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $678fa78e22f406a1$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
    constructor(array, stride){
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $678fa78e22f406a1$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $678fa78e22f406a1$var$generateUUID();
    }
}
$678fa78e22f406a1$export$3d5cd879f108f53f.prototype.isInterleavedBuffer = true;
const $678fa78e22f406a1$var$_vector$6 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$920b6d07334599c7 {
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$6.x = this.getX(i);
            $678fa78e22f406a1$var$_vector$6.y = this.getY(i);
            $678fa78e22f406a1$var$_vector$6.z = this.getZ(i);
            $678fa78e22f406a1$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$6.x, $678fa78e22f406a1$var$_vector$6.y, $678fa78e22f406a1$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$6.x = this.getX(i);
            $678fa78e22f406a1$var$_vector$6.y = this.getY(i);
            $678fa78e22f406a1$var$_vector$6.z = this.getZ(i);
            $678fa78e22f406a1$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$6.x, $678fa78e22f406a1$var$_vector$6.y, $678fa78e22f406a1$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $678fa78e22f406a1$var$_vector$6.x = this.getX(i);
            $678fa78e22f406a1$var$_vector$6.y = this.getY(i);
            $678fa78e22f406a1$var$_vector$6.z = this.getZ(i);
            $678fa78e22f406a1$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $678fa78e22f406a1$var$_vector$6.x, $678fa78e22f406a1$var$_vector$6.y, $678fa78e22f406a1$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        return this.data.array[index * this.data.stride + this.offset];
    }
    getY(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    }
    getZ(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    }
    getW(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $678fa78e22f406a1$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $678fa78e22f406a1$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interlaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
    constructor(interleavedBuffer, itemSize, offset, normalized){
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
}
$678fa78e22f406a1$export$920b6d07334599c7.prototype.isInterleavedBufferAttribute = true;
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ class $678fa78e22f406a1$export$5ec7dd1c6994bf8e extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'SpriteMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$5ec7dd1c6994bf8e.prototype.isSpriteMaterial = true;
let $678fa78e22f406a1$var$_geometry;
const $678fa78e22f406a1$var$_intersectPoint = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_worldScale = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_mvPosition = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_alignedPosition = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_rotatedPosition = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_viewWorldMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_vA = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vB = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_vC = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_uvA = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_uvB = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
const $678fa78e22f406a1$var$_uvC = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
class $678fa78e22f406a1$export$3075603db8e6204c extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $678fa78e22f406a1$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $678fa78e22f406a1$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $678fa78e22f406a1$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $678fa78e22f406a1$var$_worldScale.multiplyScalar(-$678fa78e22f406a1$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $678fa78e22f406a1$var$transformVertex($678fa78e22f406a1$var$_vA.set(-0.5, -0.5, 0), $678fa78e22f406a1$var$_mvPosition, center, $678fa78e22f406a1$var$_worldScale, sin, cos);
        $678fa78e22f406a1$var$transformVertex($678fa78e22f406a1$var$_vB.set(0.5, -0.5, 0), $678fa78e22f406a1$var$_mvPosition, center, $678fa78e22f406a1$var$_worldScale, sin, cos);
        $678fa78e22f406a1$var$transformVertex($678fa78e22f406a1$var$_vC.set(0.5, 0.5, 0), $678fa78e22f406a1$var$_mvPosition, center, $678fa78e22f406a1$var$_worldScale, sin, cos);
        $678fa78e22f406a1$var$_uvA.set(0, 0);
        $678fa78e22f406a1$var$_uvB.set(1, 0);
        $678fa78e22f406a1$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($678fa78e22f406a1$var$_vA, $678fa78e22f406a1$var$_vB, $678fa78e22f406a1$var$_vC, false, $678fa78e22f406a1$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $678fa78e22f406a1$var$transformVertex($678fa78e22f406a1$var$_vB.set(-0.5, 0.5, 0), $678fa78e22f406a1$var$_mvPosition, center, $678fa78e22f406a1$var$_worldScale, sin, cos);
            $678fa78e22f406a1$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($678fa78e22f406a1$var$_vA, $678fa78e22f406a1$var$_vC, $678fa78e22f406a1$var$_vB, false, $678fa78e22f406a1$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($678fa78e22f406a1$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $678fa78e22f406a1$var$_intersectPoint.clone(),
            uv: $678fa78e22f406a1$export$5a465592bfe74b48.getUV($678fa78e22f406a1$var$_intersectPoint, $678fa78e22f406a1$var$_vA, $678fa78e22f406a1$var$_vB, $678fa78e22f406a1$var$_vC, $678fa78e22f406a1$var$_uvA, $678fa78e22f406a1$var$_uvB, $678fa78e22f406a1$var$_uvC, new $678fa78e22f406a1$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source) {
        super.copy(source);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
    constructor(material){
        super();
        this.type = 'Sprite';
        if ($678fa78e22f406a1$var$_geometry === undefined) {
            $678fa78e22f406a1$var$_geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $678fa78e22f406a1$export$3d5cd879f108f53f(float32Array, 5);
            $678fa78e22f406a1$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $678fa78e22f406a1$var$_geometry.setAttribute('position', new $678fa78e22f406a1$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $678fa78e22f406a1$var$_geometry.setAttribute('uv', new $678fa78e22f406a1$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $678fa78e22f406a1$var$_geometry;
        this.material = material !== undefined ? material : new $678fa78e22f406a1$export$5ec7dd1c6994bf8e();
        this.center = new $678fa78e22f406a1$export$c977b3e384af9ae1(0.5, 0.5);
    }
}
$678fa78e22f406a1$export$3075603db8e6204c.prototype.isSprite = true;
function $678fa78e22f406a1$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $678fa78e22f406a1$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $678fa78e22f406a1$var$_rotatedPosition.x = cos * $678fa78e22f406a1$var$_alignedPosition.x - sin * $678fa78e22f406a1$var$_alignedPosition.y;
        $678fa78e22f406a1$var$_rotatedPosition.y = sin * $678fa78e22f406a1$var$_alignedPosition.x + cos * $678fa78e22f406a1$var$_alignedPosition.y;
    } else $678fa78e22f406a1$var$_rotatedPosition.copy($678fa78e22f406a1$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $678fa78e22f406a1$var$_rotatedPosition.x;
    vertexPosition.y += $678fa78e22f406a1$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($678fa78e22f406a1$var$_viewWorldMatrix);
}
const $678fa78e22f406a1$var$_v1$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v2$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$112e7237be0c5f30 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $678fa78e22f406a1$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($678fa78e22f406a1$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $678fa78e22f406a1$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $678fa78e22f406a1$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $678fa78e22f406a1$var$_v1$2.distanceTo($678fa78e22f406a1$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
}
const $678fa78e22f406a1$var$_basePosition = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_skinIndex = /*@__PURE__*/ new $678fa78e22f406a1$export$fa7daccca11cdbe3();
const $678fa78e22f406a1$var$_skinWeight = /*@__PURE__*/ new $678fa78e22f406a1$export$fa7daccca11cdbe3();
const $678fa78e22f406a1$var$_vector$5 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_matrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
class $678fa78e22f406a1$export$b303577035157ecf extends $678fa78e22f406a1$export$e176487c05830cc5 {
    copy(source) {
        super.copy(source);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $678fa78e22f406a1$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.x = skinWeight.getX(i);
            vector.y = skinWeight.getY(i);
            vector.z = skinWeight.getZ(i);
            vector.w = skinWeight.getW(i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $678fa78e22f406a1$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $678fa78e22f406a1$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $678fa78e22f406a1$var$_basePosition.fromBufferAttribute(geometry.attributes.position, index).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $678fa78e22f406a1$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $678fa78e22f406a1$var$_skinIndex.getComponent(i);
                $678fa78e22f406a1$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($678fa78e22f406a1$var$_vector$5.copy($678fa78e22f406a1$var$_basePosition).applyMatrix4($678fa78e22f406a1$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
    constructor(geometry, material){
        super(geometry, material);
        this.type = 'SkinnedMesh';
        this.bindMode = 'attached';
        this.bindMatrix = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
    }
}
$678fa78e22f406a1$export$b303577035157ecf.prototype.isSkinnedMesh = true;
class $678fa78e22f406a1$export$b127726e56765aa4 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'Bone';
    }
}
$678fa78e22f406a1$export$b127726e56765aa4.prototype.isBone = true;
class $678fa78e22f406a1$export$b691f601014eabe1 extends $678fa78e22f406a1$export$5431306cf43de24a {
    constructor(data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            data: data || null,
            width: width || 1,
            height: height || 1
        };
        this.magFilter = magFilter !== undefined ? magFilter : $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.needsUpdate = true;
    }
}
$678fa78e22f406a1$export$b691f601014eabe1.prototype.isDataTexture = true;
const $678fa78e22f406a1$var$_offsetMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_identityMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
class $678fa78e22f406a1$export$8f31e4c4a37b8e9c {
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $678fa78e22f406a1$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $678fa78e22f406a1$var$_identityMatrix;
            $678fa78e22f406a1$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $678fa78e22f406a1$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $678fa78e22f406a1$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $678fa78e22f406a1$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $678fa78e22f406a1$export$b691f601014eabe1(boneMatrices, size, size, $678fa78e22f406a1$export$3f8bb04b555a363c, $678fa78e22f406a1$export$f6d331659b644596);
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $678fa78e22f406a1$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $678fa78e22f406a1$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
    constructor(bones = [], boneInverses = []){
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
}
const $678fa78e22f406a1$var$_instanceLocalMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_instanceWorldMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_instanceIntersects = [];
const $678fa78e22f406a1$var$_mesh = /*@__PURE__*/ new $678fa78e22f406a1$export$e176487c05830cc5();
class $678fa78e22f406a1$export$f3c979c331175ad7 extends $678fa78e22f406a1$export$e176487c05830cc5 {
    copy(source) {
        super.copy(source);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $678fa78e22f406a1$var$_mesh.geometry = this.geometry;
        $678fa78e22f406a1$var$_mesh.material = this.material;
        if ($678fa78e22f406a1$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $678fa78e22f406a1$var$_instanceLocalMatrix);
            $678fa78e22f406a1$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $678fa78e22f406a1$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $678fa78e22f406a1$var$_mesh.matrixWorld = $678fa78e22f406a1$var$_instanceWorldMatrix;
            $678fa78e22f406a1$var$_mesh.raycast(raycaster, $678fa78e22f406a1$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $678fa78e22f406a1$var$_instanceIntersects.length; i < l; i++){
                const intersect = $678fa78e22f406a1$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $678fa78e22f406a1$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array(this.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    constructor(geometry, material, count){
        super(geometry, material);
        this.instanceMatrix = new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
}
$678fa78e22f406a1$export$f3c979c331175ad7.prototype.isInstancedMesh = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ class $678fa78e22f406a1$export$fbaaa33907730a0c extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.morphTargets = source.morphTargets;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'LineBasicMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.morphTargets = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$fbaaa33907730a0c.prototype.isLineBasicMaterial = true;
const $678fa78e22f406a1$var$_start$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_end$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_inverseMatrix$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_ray$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$a186db52eed6d40e();
const $678fa78e22f406a1$var$_sphere$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$805e8b72413ccaba();
class $678fa78e22f406a1$export$17d680238e50603e extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [
                    0
                ];
                for(let i = 1, l = positionAttribute.count; i < l; i++){
                    $678fa78e22f406a1$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                    $678fa78e22f406a1$var$_end$1.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += $678fa78e22f406a1$var$_start$1.distanceTo($678fa78e22f406a1$var$_end$1);
                }
                geometry.setAttribute('lineDistance', new $678fa78e22f406a1$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        } else if (geometry.isGeometry) console.error('THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $678fa78e22f406a1$var$_sphere$1.copy(geometry.boundingSphere);
        $678fa78e22f406a1$var$_sphere$1.applyMatrix4(matrixWorld);
        $678fa78e22f406a1$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($678fa78e22f406a1$var$_sphere$1) === false) return;
        //
        $678fa78e22f406a1$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $678fa78e22f406a1$var$_ray$1.copy(raycaster.ray).applyMatrix4($678fa78e22f406a1$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $678fa78e22f406a1$export$64b5c384219d3699();
        const vEnd = new $678fa78e22f406a1$export$64b5c384219d3699();
        const interSegment = new $678fa78e22f406a1$export$64b5c384219d3699();
        const interRay = new $678fa78e22f406a1$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    const distSq = $678fa78e22f406a1$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end - 1; i < l; i += step){
                    vStart.fromBufferAttribute(positionAttribute, i);
                    vEnd.fromBufferAttribute(positionAttribute, i + 1);
                    const distSq = $678fa78e22f406a1$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
        } else if (geometry.isGeometry) console.error('THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
    constructor(geometry = new $678fa78e22f406a1$export$b7be63a67df8959(), material = new $678fa78e22f406a1$export$fbaaa33907730a0c()){
        super();
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
}
$678fa78e22f406a1$export$17d680238e50603e.prototype.isLine = true;
const $678fa78e22f406a1$var$_start = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_end = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$ff1ed10fedfdd604 extends $678fa78e22f406a1$export$17d680238e50603e {
    computeLineDistances() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [];
                for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                    $678fa78e22f406a1$var$_start.fromBufferAttribute(positionAttribute, i);
                    $678fa78e22f406a1$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + $678fa78e22f406a1$var$_start.distanceTo($678fa78e22f406a1$var$_end);
                }
                geometry.setAttribute('lineDistance', new $678fa78e22f406a1$export$cbe7a62641830ebd(lineDistances, 1));
            } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        } else if (geometry.isGeometry) console.error('THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        return this;
    }
    constructor(geometry, material){
        super(geometry, material);
        this.type = 'LineSegments';
    }
}
$678fa78e22f406a1$export$ff1ed10fedfdd604.prototype.isLineSegments = true;
class $678fa78e22f406a1$export$f85a24d745e4f17d extends $678fa78e22f406a1$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.type = 'LineLoop';
    }
}
$678fa78e22f406a1$export$f85a24d745e4f17d.prototype.isLineLoop = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 *  morphTargets: <bool>
 * }
 */ class $678fa78e22f406a1$export$a178c45366ce5d6b extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.morphTargets = source.morphTargets;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'PointsMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.morphTargets = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$a178c45366ce5d6b.prototype.isPointsMaterial = true;
const $678fa78e22f406a1$var$_inverseMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_ray = /*@__PURE__*/ new $678fa78e22f406a1$export$a186db52eed6d40e();
const $678fa78e22f406a1$var$_sphere = /*@__PURE__*/ new $678fa78e22f406a1$export$805e8b72413ccaba();
const $678fa78e22f406a1$var$_position$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$1c787534cb11aa3e extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    copy(source) {
        super.copy(source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $678fa78e22f406a1$var$_sphere.copy(geometry.boundingSphere);
        $678fa78e22f406a1$var$_sphere.applyMatrix4(matrixWorld);
        $678fa78e22f406a1$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($678fa78e22f406a1$var$_sphere) === false) return;
        //
        $678fa78e22f406a1$var$_inverseMatrix.copy(matrixWorld).invert();
        $678fa78e22f406a1$var$_ray.copy(raycaster.ray).applyMatrix4($678fa78e22f406a1$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i++){
                    const a = index.getX(i);
                    $678fa78e22f406a1$var$_position$2.fromBufferAttribute(positionAttribute, a);
                    $678fa78e22f406a1$var$testPoint($678fa78e22f406a1$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            } else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                for(let i = start, l = end; i < l; i++){
                    $678fa78e22f406a1$var$_position$2.fromBufferAttribute(positionAttribute, i);
                    $678fa78e22f406a1$var$testPoint($678fa78e22f406a1$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            }
        } else console.error('THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
    constructor(geometry = new $678fa78e22f406a1$export$b7be63a67df8959(), material = new $678fa78e22f406a1$export$a178c45366ce5d6b()){
        super();
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
}
$678fa78e22f406a1$export$1c787534cb11aa3e.prototype.isPoints = true;
function $678fa78e22f406a1$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $678fa78e22f406a1$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $678fa78e22f406a1$export$64b5c384219d3699();
        $678fa78e22f406a1$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $678fa78e22f406a1$export$6e09d1edf8d5a25c extends $678fa78e22f406a1$export$5431306cf43de24a {
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.format = format !== undefined ? format : $678fa78e22f406a1$export$7c67423a5ee6f5eb;
        this.minFilter = minFilter !== undefined ? minFilter : $678fa78e22f406a1$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $678fa78e22f406a1$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
}
$678fa78e22f406a1$export$6e09d1edf8d5a25c.prototype.isVideoTexture = true;
class $678fa78e22f406a1$export$3466bac9141a5cc4 extends $678fa78e22f406a1$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
$678fa78e22f406a1$export$3466bac9141a5cc4.prototype.isCompressedTexture = true;
class $678fa78e22f406a1$export$f7189e49152d1c13 extends $678fa78e22f406a1$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.needsUpdate = true;
    }
}
$678fa78e22f406a1$export$f7189e49152d1c13.prototype.isCanvasTexture = true;
class $678fa78e22f406a1$export$fc830aa069cc8c2f extends $678fa78e22f406a1$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $678fa78e22f406a1$export$c1b6b5136be58045;
        if (format !== $678fa78e22f406a1$export$c1b6b5136be58045 && format !== $678fa78e22f406a1$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $678fa78e22f406a1$export$c1b6b5136be58045) type = $678fa78e22f406a1$export$c63dc51868b06a9d;
        if (type === undefined && format === $678fa78e22f406a1$export$1e113ac2d0905829) type = $678fa78e22f406a1$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $678fa78e22f406a1$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
$678fa78e22f406a1$export$fc830aa069cc8c2f.prototype.isDepthTexture = true;
class $678fa78e22f406a1$export$3f74fe60decf7462 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const uv = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $678fa78e22f406a1$export$d4345c83207d7c68 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
            const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $678fa78e22f406a1$export$c977b3e384af9ae1();
            const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
}
class $678fa78e22f406a1$export$59d971120dc8b6e7 extends $678fa78e22f406a1$export$d4345c83207d7c68 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
}
class $678fa78e22f406a1$export$38789b531813345c extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(vertices, indices, radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $678fa78e22f406a1$export$64b5c384219d3699();
            const b = new $678fa78e22f406a1$export$64b5c384219d3699();
            const c = new $678fa78e22f406a1$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $678fa78e22f406a1$export$64b5c384219d3699();
            const b = new $678fa78e22f406a1$export$64b5c384219d3699();
            const c = new $678fa78e22f406a1$export$64b5c384219d3699();
            const centroid = new $678fa78e22f406a1$export$64b5c384219d3699();
            const uvA = new $678fa78e22f406a1$export$c977b3e384af9ae1();
            const uvB = new $678fa78e22f406a1$export$c977b3e384af9ae1();
            const uvC = new $678fa78e22f406a1$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
}
class $678fa78e22f406a1$export$37cd4e52cce48c4c extends $678fa78e22f406a1$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
const $678fa78e22f406a1$var$_v0 = new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v1$1 = new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_normal = new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_triangle = new $678fa78e22f406a1$export$5a465592bfe74b48();
class $678fa78e22f406a1$export$4730b1542707547f extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(geometry, thresholdAngle){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            thresholdAngle: thresholdAngle
        };
        thresholdAngle = thresholdAngle !== undefined ? thresholdAngle : 1;
        if (geometry.isGeometry === true) {
            console.error('THREE.EdgesGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            return;
        }
        const precisionPoints = 4;
        const precision = Math.pow(10, precisionPoints);
        const thresholdDot = Math.cos($678fa78e22f406a1$var$DEG2RAD * thresholdAngle);
        const indexAttr = geometry.getIndex();
        const positionAttr = geometry.getAttribute('position');
        const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
        const indexArr = [
            0,
            0,
            0
        ];
        const vertKeys = [
            'a',
            'b',
            'c'
        ];
        const hashes = new Array(3);
        const edgeData = {};
        const vertices = [];
        for(let i = 0; i < indexCount; i += 3){
            if (indexAttr) {
                indexArr[0] = indexAttr.getX(i);
                indexArr[1] = indexAttr.getX(i + 1);
                indexArr[2] = indexAttr.getX(i + 2);
            } else {
                indexArr[0] = i;
                indexArr[1] = i + 1;
                indexArr[2] = i + 2;
            }
            const { a: a, b: b, c: c } = $678fa78e22f406a1$var$_triangle;
            a.fromBufferAttribute(positionAttr, indexArr[0]);
            b.fromBufferAttribute(positionAttr, indexArr[1]);
            c.fromBufferAttribute(positionAttr, indexArr[2]);
            $678fa78e22f406a1$var$_triangle.getNormal($678fa78e22f406a1$var$_normal);
            // create hashes for the edge from the vertices
            hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
            hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
            hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
            // skip degenerate triangles
            if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
            // iterate over every edge
            for(let j = 0; j < 3; j++){
                // get the first and next vertex making up the edge
                const jNext = (j + 1) % 3;
                const vecHash0 = hashes[j];
                const vecHash1 = hashes[jNext];
                const v0 = $678fa78e22f406a1$var$_triangle[vertKeys[j]];
                const v1 = $678fa78e22f406a1$var$_triangle[vertKeys[jNext]];
                const hash = `${vecHash0}_${vecHash1}`;
                const reverseHash = `${vecHash1}_${vecHash0}`;
                if (reverseHash in edgeData && edgeData[reverseHash]) {
                    // if we found a sibling edge add it into the vertex array if
                    // it meets the angle threshold and delete the edge from the map.
                    if ($678fa78e22f406a1$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                        vertices.push(v0.x, v0.y, v0.z);
                        vertices.push(v1.x, v1.y, v1.z);
                    }
                    edgeData[reverseHash] = null;
                } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                edgeData[hash] = {
                    index0: indexArr[j],
                    index1: indexArr[jNext],
                    normal: $678fa78e22f406a1$var$_normal.clone()
                };
            }
        }
        // iterate over all remaining, unmatched edges and add them to the vertex array
        for(const key in edgeData)if (edgeData[key]) {
            const { index0: index0, index1: index1 } = edgeData[key];
            $678fa78e22f406a1$var$_v0.fromBufferAttribute(positionAttr, index0);
            $678fa78e22f406a1$var$_v1$1.fromBufferAttribute(positionAttr, index1);
            vertices.push($678fa78e22f406a1$var$_v0.x, $678fa78e22f406a1$var$_v0.y, $678fa78e22f406a1$var$_v0.z);
            vertices.push($678fa78e22f406a1$var$_v1$1.x, $678fa78e22f406a1$var$_v1$1.y, $678fa78e22f406a1$var$_v1$1.z);
        }
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $678fa78e22f406a1$var$Earcut = {
    triangulate: function(data, holeIndices, dim) {
        dim = dim || 2;
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $678fa78e22f406a1$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $678fa78e22f406a1$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $678fa78e22f406a1$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $678fa78e22f406a1$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $678fa78e22f406a1$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $678fa78e22f406a1$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $678fa78e22f406a1$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $678fa78e22f406a1$var$equals(last, last.next)) {
        $678fa78e22f406a1$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $678fa78e22f406a1$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($678fa78e22f406a1$var$equals(p, p.next) || $678fa78e22f406a1$var$area(p.prev, p, p.next) === 0)) {
            $678fa78e22f406a1$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $678fa78e22f406a1$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $678fa78e22f406a1$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $678fa78e22f406a1$var$isEarHashed(ear, minX, minY, invSize) : $678fa78e22f406a1$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $678fa78e22f406a1$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $678fa78e22f406a1$var$earcutLinked($678fa78e22f406a1$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $678fa78e22f406a1$var$cureLocalIntersections($678fa78e22f406a1$var$filterPoints(ear), triangles, dim);
                $678fa78e22f406a1$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $678fa78e22f406a1$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $678fa78e22f406a1$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($678fa78e22f406a1$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($678fa78e22f406a1$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $678fa78e22f406a1$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $678fa78e22f406a1$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($678fa78e22f406a1$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $678fa78e22f406a1$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $678fa78e22f406a1$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $678fa78e22f406a1$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $678fa78e22f406a1$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $678fa78e22f406a1$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $678fa78e22f406a1$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $678fa78e22f406a1$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $678fa78e22f406a1$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $678fa78e22f406a1$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $678fa78e22f406a1$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $678fa78e22f406a1$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$678fa78e22f406a1$var$equals(a, b) && $678fa78e22f406a1$var$intersects(a, p, p.next, b) && $678fa78e22f406a1$var$locallyInside(a, b) && $678fa78e22f406a1$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $678fa78e22f406a1$var$removeNode(p);
            $678fa78e22f406a1$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $678fa78e22f406a1$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $678fa78e22f406a1$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $678fa78e22f406a1$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $678fa78e22f406a1$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $678fa78e22f406a1$var$filterPoints(a, a.next);
                c = $678fa78e22f406a1$var$filterPoints(c, c.next);
                // run earcut on each half
                $678fa78e22f406a1$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $678fa78e22f406a1$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $678fa78e22f406a1$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $678fa78e22f406a1$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($678fa78e22f406a1$var$getLeftmost(list));
    }
    queue.sort($678fa78e22f406a1$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $678fa78e22f406a1$var$eliminateHole(queue[i], outerNode);
        outerNode = $678fa78e22f406a1$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $678fa78e22f406a1$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $678fa78e22f406a1$var$eliminateHole(hole, outerNode) {
    outerNode = $678fa78e22f406a1$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $678fa78e22f406a1$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $678fa78e22f406a1$var$filterPoints(outerNode, outerNode.next);
        $678fa78e22f406a1$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $678fa78e22f406a1$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $678fa78e22f406a1$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($678fa78e22f406a1$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $678fa78e22f406a1$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $678fa78e22f406a1$var$sectorContainsSector(m, p) {
    return $678fa78e22f406a1$var$area(m.prev, m, p.prev) < 0 && $678fa78e22f406a1$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $678fa78e22f406a1$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $678fa78e22f406a1$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $678fa78e22f406a1$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $678fa78e22f406a1$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $678fa78e22f406a1$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $678fa78e22f406a1$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $678fa78e22f406a1$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $678fa78e22f406a1$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$678fa78e22f406a1$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($678fa78e22f406a1$var$locallyInside(a, b) && $678fa78e22f406a1$var$locallyInside(b, a) && $678fa78e22f406a1$var$middleInside(a, b) && // locally visible
    ($678fa78e22f406a1$var$area(a.prev, a, b.prev) || $678fa78e22f406a1$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $678fa78e22f406a1$var$equals(a, b) && $678fa78e22f406a1$var$area(a.prev, a, a.next) > 0 && $678fa78e22f406a1$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $678fa78e22f406a1$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $678fa78e22f406a1$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $678fa78e22f406a1$var$intersects(p1, q1, p2, q2) {
    const o1 = $678fa78e22f406a1$var$sign($678fa78e22f406a1$var$area(p1, q1, p2));
    const o2 = $678fa78e22f406a1$var$sign($678fa78e22f406a1$var$area(p1, q1, q2));
    const o3 = $678fa78e22f406a1$var$sign($678fa78e22f406a1$var$area(p2, q2, p1));
    const o4 = $678fa78e22f406a1$var$sign($678fa78e22f406a1$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $678fa78e22f406a1$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $678fa78e22f406a1$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $678fa78e22f406a1$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $678fa78e22f406a1$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $678fa78e22f406a1$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $678fa78e22f406a1$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $678fa78e22f406a1$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $678fa78e22f406a1$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $678fa78e22f406a1$var$locallyInside(a, b) {
    return $678fa78e22f406a1$var$area(a.prev, a, a.next) < 0 ? $678fa78e22f406a1$var$area(a, b, a.next) >= 0 && $678fa78e22f406a1$var$area(a, a.prev, b) >= 0 : $678fa78e22f406a1$var$area(a, b, a.prev) < 0 || $678fa78e22f406a1$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $678fa78e22f406a1$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $678fa78e22f406a1$var$splitPolygon(a, b) {
    const a2 = new $678fa78e22f406a1$var$Node(a.i, a.x, a.y), b2 = new $678fa78e22f406a1$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $678fa78e22f406a1$var$insertNode(i, x, y, last) {
    const p = new $678fa78e22f406a1$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $678fa78e22f406a1$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $678fa78e22f406a1$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $678fa78e22f406a1$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $678fa78e22f406a1$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $678fa78e22f406a1$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $678fa78e22f406a1$var$removeDupEndPts(contour);
        $678fa78e22f406a1$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($678fa78e22f406a1$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $678fa78e22f406a1$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $678fa78e22f406a1$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $678fa78e22f406a1$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $678fa78e22f406a1$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $678fa78e22f406a1$export$91836d01b9f75a58 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $678fa78e22f406a1$var$toJSON$1(shapes, options, data);
    }
    constructor(shapes, options){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 100;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $678fa78e22f406a1$var$WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn('THREE.ExtrudeBufferGeometry: amount has been renamed to depth.');
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $678fa78e22f406a1$export$64b5c384219d3699();
                normal = new $678fa78e22f406a1$export$64b5c384219d3699();
                position2 = new $678fa78e22f406a1$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$678fa78e22f406a1$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($678fa78e22f406a1$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $678fa78e22f406a1$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $678fa78e22f406a1$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $678fa78e22f406a1$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
}
const $678fa78e22f406a1$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $678fa78e22f406a1$export$c977b3e384af9ae1(a_x, a_y),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(b_x, b_y),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $678fa78e22f406a1$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $678fa78e22f406a1$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $678fa78e22f406a1$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $678fa78e22f406a1$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $678fa78e22f406a1$export$731fd4feef063ea2 extends $678fa78e22f406a1$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class $678fa78e22f406a1$export$dc3e1273c1dd9240 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(points, segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $678fa78e22f406a1$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const uv = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        // generate vertices and uvs
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
        // generate normals
        this.computeVertexNormals();
        // if the geometry is closed, we need to average the normals along the seam.
        // because the corresponding vertices are identical (but still have different UVs).
        if (phiLength === Math.PI * 2) {
            const normals = this.attributes.normal.array;
            const n1 = new $678fa78e22f406a1$export$64b5c384219d3699();
            const n2 = new $678fa78e22f406a1$export$64b5c384219d3699();
            const n = new $678fa78e22f406a1$export$64b5c384219d3699();
            // this is the buffer offset for the last line of vertices
            const base = segments * points.length * 3;
            for(let i = 0, j = 0; i < points.length; i++, j += 3){
                // select the normal of the vertex in the first line
                n1.x = normals[j + 0];
                n1.y = normals[j + 1];
                n1.z = normals[j + 2];
                // select the normal of the vertex in the last line
                n2.x = normals[base + j + 0];
                n2.y = normals[base + j + 1];
                n2.z = normals[base + j + 2];
                // average normals
                n.addVectors(n1, n2).normalize();
                // assign the new values to both normals
                normals[j + 0] = normals[base + j + 0] = n.x;
                normals[j + 1] = normals[base + j + 1] = n.y;
                normals[j + 2] = normals[base + j + 2] = n.z;
            }
        }
    }
}
class $678fa78e22f406a1$export$8e05fc91596f4752 extends $678fa78e22f406a1$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout https://prideout.net/blog/old/blog/index.html@p=44.html
 */ class $678fa78e22f406a1$export$c56b5b5c6f0a7fff extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(func, slices, stacks){
        super();
        this.type = 'ParametricGeometry';
        this.parameters = {
            func: func,
            slices: slices,
            stacks: stacks
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        const EPS = 0.00001;
        const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
        const p0 = new $678fa78e22f406a1$export$64b5c384219d3699(), p1 = new $678fa78e22f406a1$export$64b5c384219d3699();
        const pu = new $678fa78e22f406a1$export$64b5c384219d3699(), pv = new $678fa78e22f406a1$export$64b5c384219d3699();
        if (func.length < 3) console.error('THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.');
        // generate vertices, normals and uvs
        const sliceCount = slices + 1;
        for(let i = 0; i <= stacks; i++){
            const v = i / stacks;
            for(let j = 0; j <= slices; j++){
                const u = j / slices;
                // vertex
                func(u, v, p0);
                vertices.push(p0.x, p0.y, p0.z);
                // normal
                // approximate tangent vectors via finite differences
                if (u - EPS >= 0) {
                    func(u - EPS, v, p1);
                    pu.subVectors(p0, p1);
                } else {
                    func(u + EPS, v, p1);
                    pu.subVectors(p1, p0);
                }
                if (v - EPS >= 0) {
                    func(u, v - EPS, p1);
                    pv.subVectors(p0, p1);
                } else {
                    func(u, v + EPS, p1);
                    pv.subVectors(p1, p0);
                }
                // cross product of tangent vectors returns surface normal
                normal.crossVectors(pu, pv).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u, v);
            }
        }
        // generate indices
        for(let i = 0; i < stacks; i++)for(let j = 0; j < slices; j++){
            const a = i * sliceCount + j;
            const b = i * sliceCount + j + 1;
            const c = (i + 1) * sliceCount + j + 1;
            const d = (i + 1) * sliceCount + j;
            // faces one and two
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $678fa78e22f406a1$export$ee8b85b34b7d9cad extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const uv = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $678fa78e22f406a1$export$233afc324766bed8 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $678fa78e22f406a1$var$toJSON(shapes, data);
    }
    constructor(shapes, curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($678fa78e22f406a1$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($678fa78e22f406a1$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $678fa78e22f406a1$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
}
function $678fa78e22f406a1$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $678fa78e22f406a1$export$d5d06a966fec4192 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 8, heightSegments = 6, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $678fa78e22f406a1$export$369e08f62a796c65 extends $678fa78e22f406a1$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ class $678fa78e22f406a1$export$89b83bbad46fe613 extends $678fa78e22f406a1$export$91836d01b9f75a58 {
    constructor(text, parameters = {}){
        const font = parameters.font;
        if (!(font && font.isFont)) {
            console.error('THREE.TextGeometry: font parameter is not an instance of THREE.Font.');
            return new $678fa78e22f406a1$export$b7be63a67df8959();
        }
        const shapes = font.generateShapes(text, parameters.size);
        // translate parameters to ExtrudeGeometry API
        parameters.depth = parameters.height !== undefined ? parameters.height : 50;
        // defaults
        if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
        if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
        if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
        super(shapes, parameters);
        this.type = 'TextGeometry';
    }
}
class $678fa78e22f406a1$export$19d55f905fa4f2cb extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $678fa78e22f406a1$export$64b5c384219d3699();
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $678fa78e22f406a1$export$2b32466f4274fe5c extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
        const P1 = new $678fa78e22f406a1$export$64b5c384219d3699();
        const P2 = new $678fa78e22f406a1$export$64b5c384219d3699();
        const B = new $678fa78e22f406a1$export$64b5c384219d3699();
        const T = new $678fa78e22f406a1$export$64b5c384219d3699();
        const N = new $678fa78e22f406a1$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
}
class $678fa78e22f406a1$export$d97a193ce44e691b extends $678fa78e22f406a1$export$b7be63a67df8959 {
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    constructor(path, tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
        const uv = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        let P = new $678fa78e22f406a1$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $678fa78e22f406a1$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $678fa78e22f406a1$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
}
class $678fa78e22f406a1$export$4b739da06d24892b extends $678fa78e22f406a1$export$b7be63a67df8959 {
    constructor(geometry){
        super();
        this.type = 'WireframeGeometry';
        if (geometry.isGeometry === true) {
            console.error('THREE.WireframeGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            return;
        }
        // buffer
        const vertices = [];
        // helper variables
        const edge = [
            0,
            0
        ], edges = {};
        const vertex = new $678fa78e22f406a1$export$64b5c384219d3699();
        if (geometry.index !== null) {
            // indexed BufferGeometry
            const position = geometry.attributes.position;
            const indices = geometry.index;
            let groups = geometry.groups;
            if (groups.length === 0) groups = [
                {
                    start: 0,
                    count: indices.count,
                    materialIndex: 0
                }
            ];
            // create a data structure that contains all eges without duplicates
            for(let o = 0, ol = groups.length; o < ol; ++o){
                const group = groups[o];
                const start = group.start;
                const count = group.count;
                for(let i = start, l = start + count; i < l; i += 3)for(let j = 0; j < 3; j++){
                    const edge1 = indices.getX(i + j);
                    const edge2 = indices.getX(i + (j + 1) % 3);
                    edge[0] = Math.min(edge1, edge2); // sorting prevents duplicates
                    edge[1] = Math.max(edge1, edge2);
                    const key = edge[0] + ',' + edge[1];
                    if (edges[key] === undefined) edges[key] = {
                        index1: edge[0],
                        index2: edge[1]
                    };
                }
            }
            // generate vertices
            for(const key in edges){
                const e = edges[key];
                vertex.fromBufferAttribute(position, e.index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                vertex.fromBufferAttribute(position, e.index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        } else {
            // non-indexed BufferGeometry
            const position = geometry.attributes.position;
            for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                // three edges per triangle, an edge is represented as (index1, index2)
                // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                const index1 = 3 * i + j;
                vertex.fromBufferAttribute(position, index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                const index2 = 3 * i + (j + 1) % 3;
                vertex.fromBufferAttribute(position, index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        // build geometry
        this.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
    }
}
var $678fa78e22f406a1$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $678fa78e22f406a1$export$ab3456a079aa7d80,
    BoxBufferGeometry: $678fa78e22f406a1$export$ab3456a079aa7d80,
    CircleGeometry: $678fa78e22f406a1$export$3f74fe60decf7462,
    CircleBufferGeometry: $678fa78e22f406a1$export$3f74fe60decf7462,
    ConeGeometry: $678fa78e22f406a1$export$59d971120dc8b6e7,
    ConeBufferGeometry: $678fa78e22f406a1$export$59d971120dc8b6e7,
    CylinderGeometry: $678fa78e22f406a1$export$d4345c83207d7c68,
    CylinderBufferGeometry: $678fa78e22f406a1$export$d4345c83207d7c68,
    DodecahedronGeometry: $678fa78e22f406a1$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $678fa78e22f406a1$export$37cd4e52cce48c4c,
    EdgesGeometry: $678fa78e22f406a1$export$4730b1542707547f,
    ExtrudeGeometry: $678fa78e22f406a1$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $678fa78e22f406a1$export$91836d01b9f75a58,
    IcosahedronGeometry: $678fa78e22f406a1$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $678fa78e22f406a1$export$731fd4feef063ea2,
    LatheGeometry: $678fa78e22f406a1$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $678fa78e22f406a1$export$dc3e1273c1dd9240,
    OctahedronGeometry: $678fa78e22f406a1$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $678fa78e22f406a1$export$8e05fc91596f4752,
    ParametricGeometry: $678fa78e22f406a1$export$c56b5b5c6f0a7fff,
    ParametricBufferGeometry: $678fa78e22f406a1$export$c56b5b5c6f0a7fff,
    PlaneGeometry: $678fa78e22f406a1$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $678fa78e22f406a1$export$e789a11a194ca4e0,
    PolyhedronGeometry: $678fa78e22f406a1$export$38789b531813345c,
    PolyhedronBufferGeometry: $678fa78e22f406a1$export$38789b531813345c,
    RingGeometry: $678fa78e22f406a1$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $678fa78e22f406a1$export$ee8b85b34b7d9cad,
    ShapeGeometry: $678fa78e22f406a1$export$233afc324766bed8,
    ShapeBufferGeometry: $678fa78e22f406a1$export$233afc324766bed8,
    SphereGeometry: $678fa78e22f406a1$export$d5d06a966fec4192,
    SphereBufferGeometry: $678fa78e22f406a1$export$d5d06a966fec4192,
    TetrahedronGeometry: $678fa78e22f406a1$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $678fa78e22f406a1$export$369e08f62a796c65,
    TextGeometry: $678fa78e22f406a1$export$89b83bbad46fe613,
    TextBufferGeometry: $678fa78e22f406a1$export$89b83bbad46fe613,
    TorusGeometry: $678fa78e22f406a1$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $678fa78e22f406a1$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $678fa78e22f406a1$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $678fa78e22f406a1$export$2b32466f4274fe5c,
    TubeGeometry: $678fa78e22f406a1$export$d97a193ce44e691b,
    TubeBufferGeometry: $678fa78e22f406a1$export$d97a193ce44e691b,
    WireframeGeometry: $678fa78e22f406a1$export$4b739da06d24892b
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ class $678fa78e22f406a1$export$e8564da406055a3 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'ShadowMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$e8564da406055a3.prototype.isShadowMaterial = true;
class $678fa78e22f406a1$export$21c421a2e1df9d22 extends $678fa78e22f406a1$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.type = 'RawShaderMaterial';
    }
}
$678fa78e22f406a1$export$21c421a2e1df9d22.prototype.isRawShaderMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ class $678fa78e22f406a1$export$f2980790215acccd extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        this.vertexTangents = source.vertexTangents;
        return this;
    }
    constructor(parameters){
        super();
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $678fa78e22f406a1$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $678fa78e22f406a1$export$2852a58ebdac27b8;
        this.normalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.vertexTangents = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$f2980790215acccd.prototype.isMeshStandardMaterial = true;
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  reflectivity: <float>,
 *  ior: <float>,
 *
 *  sheen: <Color>,
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> ),
 *
 *  thickness: <float>,
 *  thicknessMap: new THREE.Texture( <Image> ),
 *  attenuationDistance: <float>,
 *  attenuationColor: <Color>
 * }
 */ class $678fa78e22f406a1$export$28d04986c4269c9f extends $678fa78e22f406a1$export$f2980790215acccd {
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.reflectivity = source.reflectivity;
        if (source.sheen) this.sheen = (this.sheen || new $678fa78e22f406a1$export$892596cec99bc70e()).copy(source.sheen);
        else this.sheen = null;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        return this;
    }
    constructor(parameters){
        super();
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.clearcoat = 0.0;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.reflectivity = 0.5; // maps to F0 = 0.04
        Object.defineProperty(this, 'ior', {
            get: function() {
                return (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity);
            },
            set: function(ior) {
                this.reflectivity = $678fa78e22f406a1$var$clamp(2.5 * (ior - 1) / (ior + 1), 0, 1);
            }
        });
        this.sheen = null; // null will disable sheen bsdf
        this.transmission = 0.0;
        this.transmissionMap = null;
        this.thickness = 0.01;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $678fa78e22f406a1$export$892596cec99bc70e(1, 1, 1);
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$28d04986c4269c9f.prototype.isMeshPhysicalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ class $678fa78e22f406a1$export$24c72f71cbaf0678 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'MeshPhongMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $678fa78e22f406a1$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $678fa78e22f406a1$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $678fa78e22f406a1$export$2852a58ebdac27b8;
        this.normalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $678fa78e22f406a1$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$24c72f71cbaf0678.prototype.isMeshPhongMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ class $678fa78e22f406a1$export$df893cf97e765622 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        return this;
    }
    constructor(parameters){
        super();
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $678fa78e22f406a1$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $678fa78e22f406a1$export$2852a58ebdac27b8;
        this.normalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.morphTargets = false;
        this.morphNormals = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$df893cf97e765622.prototype.isMeshToonMaterial = true;
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>,
 *
 *  flatShading: <bool>
 * }
 */ class $678fa78e22f406a1$export$bfe8c0a091f41ae7 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $678fa78e22f406a1$export$2852a58ebdac27b8;
        this.normalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false;
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$bfe8c0a091f41ae7.prototype.isMeshNormalMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ class $678fa78e22f406a1$export$5023a9a8114806b8 extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'MeshLambertMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $678fa78e22f406a1$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $678fa78e22f406a1$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.morphTargets = false;
        this.morphNormals = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$5023a9a8114806b8.prototype.isMeshLambertMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 *
 *  flatShading: <bool>
 * }
 */ class $678fa78e22f406a1$export$6f5fef6235ec12ee extends $678fa78e22f406a1$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.morphTargets = source.morphTargets;
        this.morphNormals = source.morphNormals;
        this.flatShading = source.flatShading;
        return this;
    }
    constructor(parameters){
        super();
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $678fa78e22f406a1$export$2852a58ebdac27b8;
        this.normalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.morphTargets = false;
        this.morphNormals = false;
        this.flatShading = false;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$6f5fef6235ec12ee.prototype.isMeshMatcapMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ class $678fa78e22f406a1$export$327886a3efaeaebe extends $678fa78e22f406a1$export$fbaaa33907730a0c {
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
    constructor(parameters){
        super();
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
}
$678fa78e22f406a1$export$327886a3efaeaebe.prototype.isLineDashedMaterial = true;
var $678fa78e22f406a1$var$Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: $678fa78e22f406a1$export$e8564da406055a3,
    SpriteMaterial: $678fa78e22f406a1$export$5ec7dd1c6994bf8e,
    RawShaderMaterial: $678fa78e22f406a1$export$21c421a2e1df9d22,
    ShaderMaterial: $678fa78e22f406a1$export$83c7d75d550a8b0d,
    PointsMaterial: $678fa78e22f406a1$export$a178c45366ce5d6b,
    MeshPhysicalMaterial: $678fa78e22f406a1$export$28d04986c4269c9f,
    MeshStandardMaterial: $678fa78e22f406a1$export$f2980790215acccd,
    MeshPhongMaterial: $678fa78e22f406a1$export$24c72f71cbaf0678,
    MeshToonMaterial: $678fa78e22f406a1$export$df893cf97e765622,
    MeshNormalMaterial: $678fa78e22f406a1$export$bfe8c0a091f41ae7,
    MeshLambertMaterial: $678fa78e22f406a1$export$5023a9a8114806b8,
    MeshDepthMaterial: $678fa78e22f406a1$export$2698c22ec13825db,
    MeshDistanceMaterial: $678fa78e22f406a1$export$33e187ed002f2a19,
    MeshBasicMaterial: $678fa78e22f406a1$export$55cbcc9b622fe1f5,
    MeshMatcapMaterial: $678fa78e22f406a1$export$6f5fef6235ec12ee,
    LineDashedMaterial: $678fa78e22f406a1$export$327886a3efaeaebe,
    LineBasicMaterial: $678fa78e22f406a1$export$fbaaa33907730a0c,
    Material: $678fa78e22f406a1$export$a2d8b23205c25948
});
const $678fa78e22f406a1$export$7ee8caa573e71ad1 = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if ($678fa78e22f406a1$export$7ee8caa573e71ad1.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = $678fa78e22f406a1$export$7ee8caa573e71ad1.convertArray(times, track.times.constructor);
            track.values = $678fa78e22f406a1$export$7ee8caa573e71ad1.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === 'quaternion') {
                const referenceQuat = new $678fa78e22f406a1$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
                $678fa78e22f406a1$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = $678fa78e22f406a1$export$d875e029ef558d3;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $678fa78e22f406a1$export$b558baee9c0f72d3 {
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.afterEnd_(i1 - 1, t, t0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.beforeStart_(0, t, t1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.beforeStart_(0, t, t1);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.afterEnd_(i1 - 1, t0, t);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
}
// ALIAS DEFINITIONS
$678fa78e22f406a1$export$b558baee9c0f72d3.prototype.beforeStart_ = $678fa78e22f406a1$export$b558baee9c0f72d3.prototype.copySampleValue_;
$678fa78e22f406a1$export$b558baee9c0f72d3.prototype.afterEnd_ = $678fa78e22f406a1$export$b558baee9c0f72d3.prototype.copySampleValue_;
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $678fa78e22f406a1$export$3646682e7a3959 extends $678fa78e22f406a1$export$b558baee9c0f72d3 {
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $678fa78e22f406a1$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $678fa78e22f406a1$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $678fa78e22f406a1$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $678fa78e22f406a1$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $678fa78e22f406a1$export$7f795934b84ab523,
            endingEnd: $678fa78e22f406a1$export$7f795934b84ab523
        };
    }
}
class $678fa78e22f406a1$export$a8e6009059f51e1a extends $678fa78e22f406a1$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ class $678fa78e22f406a1$export$fb9758ef7ef8d5cc extends $678fa78e22f406a1$export$b558baee9c0f72d3 {
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
class $678fa78e22f406a1$export$b0e479f45b7006d6 {
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $678fa78e22f406a1$export$7ee8caa573e71ad1.convertArray(track.times, Array),
                'values': $678fa78e22f406a1$export$7ee8caa573e71ad1.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $678fa78e22f406a1$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $678fa78e22f406a1$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $678fa78e22f406a1$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $678fa78e22f406a1$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $678fa78e22f406a1$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $678fa78e22f406a1$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $678fa78e22f406a1$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $678fa78e22f406a1$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $678fa78e22f406a1$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(times, from, to);
            this.values = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($678fa78e22f406a1$export$7ee8caa573e71ad1.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(this.times), values = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $678fa78e22f406a1$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(times, 0, writeIndex);
            this.values = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(this.times, 0);
        const values = $678fa78e22f406a1$export$7ee8caa573e71ad1.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $678fa78e22f406a1$export$7ee8caa573e71ad1.convertArray(times, this.TimeBufferType);
        this.values = $678fa78e22f406a1$export$7ee8caa573e71ad1.convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
}
$678fa78e22f406a1$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$678fa78e22f406a1$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$678fa78e22f406a1$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $678fa78e22f406a1$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $678fa78e22f406a1$export$d3a344b98cf0b775 extends $678fa78e22f406a1$export$b0e479f45b7006d6 {
}
$678fa78e22f406a1$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$678fa78e22f406a1$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$678fa78e22f406a1$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $678fa78e22f406a1$export$995b32462a65e855;
$678fa78e22f406a1$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$678fa78e22f406a1$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $678fa78e22f406a1$export$83444c5d885347d8 extends $678fa78e22f406a1$export$b0e479f45b7006d6 {
}
$678fa78e22f406a1$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $678fa78e22f406a1$export$d45f0d1a4d9a9314 extends $678fa78e22f406a1$export$b0e479f45b7006d6 {
}
$678fa78e22f406a1$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $678fa78e22f406a1$export$2db1cfb7923d931e extends $678fa78e22f406a1$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$678fa78e22f406a1$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $678fa78e22f406a1$export$b8043f12b5aafbd7 extends $678fa78e22f406a1$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $678fa78e22f406a1$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$678fa78e22f406a1$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$678fa78e22f406a1$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $678fa78e22f406a1$export$30fac1aace31cf4d;
$678fa78e22f406a1$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $678fa78e22f406a1$export$6ce41d4f3a8df9cd extends $678fa78e22f406a1$export$b0e479f45b7006d6 {
}
$678fa78e22f406a1$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$678fa78e22f406a1$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$678fa78e22f406a1$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $678fa78e22f406a1$export$995b32462a65e855;
$678fa78e22f406a1$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$678fa78e22f406a1$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $678fa78e22f406a1$export$5ce2dcb4cc9f2bff extends $678fa78e22f406a1$export$b0e479f45b7006d6 {
}
$678fa78e22f406a1$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $678fa78e22f406a1$export$d942c706bf23829c {
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($678fa78e22f406a1$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($678fa78e22f406a1$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $678fa78e22f406a1$export$7ee8caa573e71ad1.getKeyframeOrder(times);
            times = $678fa78e22f406a1$export$7ee8caa573e71ad1.sortedArray(times, 1, order);
            values = $678fa78e22f406a1$export$7ee8caa573e71ad1.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $678fa78e22f406a1$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $678fa78e22f406a1$export$7ee8caa573e71ad1.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $678fa78e22f406a1$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * (fps || 1.0);
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($678fa78e22f406a1$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($678fa78e22f406a1$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($678fa78e22f406a1$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
    constructor(name, duration = -1, tracks, blendMode = $678fa78e22f406a1$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
}
function $678fa78e22f406a1$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $678fa78e22f406a1$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $678fa78e22f406a1$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $678fa78e22f406a1$export$83444c5d885347d8;
        case 'quaternion':
            return $678fa78e22f406a1$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $678fa78e22f406a1$export$d3a344b98cf0b775;
        case 'string':
            return $678fa78e22f406a1$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $678fa78e22f406a1$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $678fa78e22f406a1$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $678fa78e22f406a1$export$7ee8caa573e71ad1.flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $678fa78e22f406a1$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $678fa78e22f406a1$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $678fa78e22f406a1$export$b033c3f9a95c6a16 = new $678fa78e22f406a1$export$99cc795e99919eed();
class $678fa78e22f406a1$export$3b0d6d7590275603 {
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    constructor(manager){
        this.manager = manager !== undefined ? manager : $678fa78e22f406a1$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
}
const $678fa78e22f406a1$var$loading = {};
class $678fa78e22f406a1$export$98435a25b5cf7b2b extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $678fa78e22f406a1$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($678fa78e22f406a1$var$loading[url] !== undefined) {
            $678fa78e22f406a1$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Check for data: URI
        const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
        const dataUriRegexResult = url.match(dataUriRegex);
        let request;
        // Safari can not handle Data URIs through XMLHttpRequest so process manually
        if (dataUriRegexResult) {
            const mimeType = dataUriRegexResult[1];
            const isBase64 = !!dataUriRegexResult[2];
            let data = dataUriRegexResult[3];
            data = decodeURIComponent(data);
            if (isBase64) data = atob(data);
            try {
                let response;
                const responseType = (this.responseType || '').toLowerCase();
                switch(responseType){
                    case 'arraybuffer':
                    case 'blob':
                        const view = new Uint8Array(data.length);
                        for(let i = 0; i < data.length; i++)view[i] = data.charCodeAt(i);
                        if (responseType === 'blob') response = new Blob([
                            view.buffer
                        ], {
                            type: mimeType
                        });
                        else response = view.buffer;
                        break;
                    case 'document':
                        const parser = new DOMParser();
                        response = parser.parseFromString(data, mimeType);
                        break;
                    case 'json':
                        response = JSON.parse(data);
                        break;
                    default:
                        response = data;
                        break;
                }
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onLoad) onLoad(response);
                    scope.manager.itemEnd(url);
                }, 0);
            } catch (error) {
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onError) onError(error);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }, 0);
            }
        } else {
            // Initialise array for duplicate requests
            $678fa78e22f406a1$var$loading[url] = [];
            $678fa78e22f406a1$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.addEventListener('load', function(event) {
                const response = this.response;
                const callbacks = $678fa78e22f406a1$var$loading[url];
                delete $678fa78e22f406a1$var$loading[url];
                if (this.status === 200 || this.status === 0) {
                    // Some browsers return HTTP Status 0 when using non-http protocol
                    // e.g. 'file://' or 'data://'. Handle as success.
                    if (this.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                    // Add to cache only on HTTP success, so that we do not cache
                    // error response bodies as proper responses to requests.
                    $678fa78e22f406a1$export$94affb487e701bf2.add(url, response);
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(response);
                    }
                    scope.manager.itemEnd(url);
                } else {
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onError) callback.onError(event);
                    }
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
            }, false);
            request.addEventListener('progress', function(event) {
                const callbacks = $678fa78e22f406a1$var$loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onProgress) callback.onProgress(event);
                }
            }, false);
            request.addEventListener('error', function(event) {
                const callbacks = $678fa78e22f406a1$var$loading[url];
                delete $678fa78e22f406a1$var$loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            request.addEventListener('abort', function(event) {
                const callbacks = $678fa78e22f406a1$var$loading[url];
                delete $678fa78e22f406a1$var$loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            if (this.responseType !== undefined) request.responseType = this.responseType;
            if (this.withCredentials !== undefined) request.withCredentials = this.withCredentials;
            if (request.overrideMimeType) request.overrideMimeType(this.mimeType !== undefined ? this.mimeType : 'text/plain');
            for(const header in this.requestHeader)request.setRequestHeader(header, this.requestHeader[header]);
            request.send(null);
        }
        scope.manager.itemStart(url);
        return request;
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    constructor(manager){
        super(manager);
    }
}
class $678fa78e22f406a1$export$29711c7e14f61db extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $678fa78e22f406a1$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
    constructor(manager){
        super(manager);
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $678fa78e22f406a1$export$bd73ce947a280350 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $678fa78e22f406a1$export$3466bac9141a5cc4();
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $678fa78e22f406a1$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $678fa78e22f406a1$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
class $678fa78e22f406a1$export$8905ce1c7a2464a1 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $678fa78e22f406a1$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');
        function onImageLoad() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
            $678fa78e22f406a1$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.substr(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
    constructor(manager){
        super(manager);
    }
}
class $678fa78e22f406a1$export$2ec114afc2cf6308 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(urls, onLoad, onProgress, onError) {
        const texture = new $678fa78e22f406a1$export$ee2e5a18258a4049();
        const loader = new $678fa78e22f406a1$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $678fa78e22f406a1$export$792d8a18f2c55855 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $678fa78e22f406a1$export$b691f601014eabe1();
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $678fa78e22f406a1$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $678fa78e22f406a1$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $678fa78e22f406a1$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $678fa78e22f406a1$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $678fa78e22f406a1$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $678fa78e22f406a1$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
class $678fa78e22f406a1$export$fd1bfc71f64c538c extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const texture = new $678fa78e22f406a1$export$5431306cf43de24a();
        const loader = new $678fa78e22f406a1$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
            const isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
            texture.format = isJPEG ? $678fa78e22f406a1$export$7c67423a5ee6f5eb : $678fa78e22f406a1$export$3f8bb04b555a363c;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $678fa78e22f406a1$export$c977b3e384af9ae1() : new $678fa78e22f406a1$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $678fa78e22f406a1$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $678fa78e22f406a1$export$64b5c384219d3699();
        const mat = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $678fa78e22f406a1$export$64b5c384219d3699());
            tangents[i].normalize();
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $678fa78e22f406a1$export$64b5c384219d3699();
        binormals[0] = new $678fa78e22f406a1$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($678fa78e22f406a1$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($678fa78e22f406a1$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
}
class $678fa78e22f406a1$export$3f87a931616cde04 extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $678fa78e22f406a1$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
}
$678fa78e22f406a1$export$3f87a931616cde04.prototype.isEllipseCurve = true;
class $678fa78e22f406a1$export$b1eedc9aab6300e8 extends $678fa78e22f406a1$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.type = 'ArcCurve';
    }
}
$678fa78e22f406a1$export$b1eedc9aab6300e8.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $678fa78e22f406a1$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $678fa78e22f406a1$var$tmp = new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$px = new $678fa78e22f406a1$var$CubicPoly(), $678fa78e22f406a1$var$py = new $678fa78e22f406a1$var$CubicPoly(), $678fa78e22f406a1$var$pz = new $678fa78e22f406a1$var$CubicPoly();
class $678fa78e22f406a1$export$b9146b27c24b744c extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $678fa78e22f406a1$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $678fa78e22f406a1$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $678fa78e22f406a1$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $678fa78e22f406a1$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $678fa78e22f406a1$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $678fa78e22f406a1$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $678fa78e22f406a1$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $678fa78e22f406a1$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $678fa78e22f406a1$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $678fa78e22f406a1$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($678fa78e22f406a1$var$px.calc(weight), $678fa78e22f406a1$var$py.calc(weight), $678fa78e22f406a1$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $678fa78e22f406a1$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
}
$678fa78e22f406a1$export$b9146b27c24b744c.prototype.isCatmullRomCurve3 = true;
/**
 * Bezier Curves formulas obtained from
 * http://en.wikipedia.org/wiki/Bézier_curve
 */ function $678fa78e22f406a1$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $678fa78e22f406a1$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $678fa78e22f406a1$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $678fa78e22f406a1$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $678fa78e22f406a1$var$QuadraticBezier(t, p0, p1, p2) {
    return $678fa78e22f406a1$var$QuadraticBezierP0(t, p0) + $678fa78e22f406a1$var$QuadraticBezierP1(t, p1) + $678fa78e22f406a1$var$QuadraticBezierP2(t, p2);
}
//
function $678fa78e22f406a1$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $678fa78e22f406a1$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $678fa78e22f406a1$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $678fa78e22f406a1$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $678fa78e22f406a1$var$CubicBezier(t, p0, p1, p2, p3) {
    return $678fa78e22f406a1$var$CubicBezierP0(t, p0) + $678fa78e22f406a1$var$CubicBezierP1(t, p1) + $678fa78e22f406a1$var$CubicBezierP2(t, p2) + $678fa78e22f406a1$var$CubicBezierP3(t, p3);
}
class $678fa78e22f406a1$export$e36650d36468bb39 extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($678fa78e22f406a1$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $678fa78e22f406a1$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
    constructor(v0 = new $678fa78e22f406a1$export$c977b3e384af9ae1(), v1 = new $678fa78e22f406a1$export$c977b3e384af9ae1(), v2 = new $678fa78e22f406a1$export$c977b3e384af9ae1(), v3 = new $678fa78e22f406a1$export$c977b3e384af9ae1()){
        super();
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
}
$678fa78e22f406a1$export$e36650d36468bb39.prototype.isCubicBezierCurve = true;
class $678fa78e22f406a1$export$13d5f1c9525f246c extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($678fa78e22f406a1$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $678fa78e22f406a1$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $678fa78e22f406a1$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
    constructor(v0 = new $678fa78e22f406a1$export$64b5c384219d3699(), v1 = new $678fa78e22f406a1$export$64b5c384219d3699(), v2 = new $678fa78e22f406a1$export$64b5c384219d3699(), v3 = new $678fa78e22f406a1$export$64b5c384219d3699()){
        super();
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
}
$678fa78e22f406a1$export$13d5f1c9525f246c.prototype.isCubicBezierCurve3 = true;
class $678fa78e22f406a1$export$ab2e07e76531a47e extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $678fa78e22f406a1$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v1 = new $678fa78e22f406a1$export$c977b3e384af9ae1(), v2 = new $678fa78e22f406a1$export$c977b3e384af9ae1()){
        super();
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
}
$678fa78e22f406a1$export$ab2e07e76531a47e.prototype.isLineCurve = true;
class $678fa78e22f406a1$export$1fdfd9d9cf487600 extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v1 = new $678fa78e22f406a1$export$64b5c384219d3699(), v2 = new $678fa78e22f406a1$export$64b5c384219d3699()){
        super();
        this.type = 'LineCurve3';
        this.isLineCurve3 = true;
        this.v1 = v1;
        this.v2 = v2;
    }
}
class $678fa78e22f406a1$export$5938c4ee491a43ad extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($678fa78e22f406a1$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $678fa78e22f406a1$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v0 = new $678fa78e22f406a1$export$c977b3e384af9ae1(), v1 = new $678fa78e22f406a1$export$c977b3e384af9ae1(), v2 = new $678fa78e22f406a1$export$c977b3e384af9ae1()){
        super();
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
}
$678fa78e22f406a1$export$5938c4ee491a43ad.prototype.isQuadraticBezierCurve = true;
class $678fa78e22f406a1$export$bf3f4c7e459f90fc extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($678fa78e22f406a1$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $678fa78e22f406a1$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $678fa78e22f406a1$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v0 = new $678fa78e22f406a1$export$64b5c384219d3699(), v1 = new $678fa78e22f406a1$export$64b5c384219d3699(), v2 = new $678fa78e22f406a1$export$64b5c384219d3699()){
        super();
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
}
$678fa78e22f406a1$export$bf3f4c7e459f90fc.prototype.isQuadraticBezierCurve3 = true;
class $678fa78e22f406a1$export$d3bdd77da77afc1b extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $678fa78e22f406a1$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($678fa78e22f406a1$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $678fa78e22f406a1$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $678fa78e22f406a1$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
    constructor(points = []){
        super();
        this.type = 'SplineCurve';
        this.points = points;
    }
}
$678fa78e22f406a1$export$d3bdd77da77afc1b.prototype.isSplineCurve = true;
var $678fa78e22f406a1$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $678fa78e22f406a1$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $678fa78e22f406a1$export$b9146b27c24b744c,
    CubicBezierCurve: $678fa78e22f406a1$export$e36650d36468bb39,
    CubicBezierCurve3: $678fa78e22f406a1$export$13d5f1c9525f246c,
    EllipseCurve: $678fa78e22f406a1$export$3f87a931616cde04,
    LineCurve: $678fa78e22f406a1$export$ab2e07e76531a47e,
    LineCurve3: $678fa78e22f406a1$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $678fa78e22f406a1$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $678fa78e22f406a1$export$bf3f4c7e459f90fc,
    SplineCurve: $678fa78e22f406a1$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $678fa78e22f406a1$export$4aaf9b66af1bbf2c extends $678fa78e22f406a1$export$b0e83c3ef8d2db1 {
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $678fa78e22f406a1$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $678fa78e22f406a1$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
}
class $678fa78e22f406a1$export$4b2950bdac9b6ee9 extends $678fa78e22f406a1$export$4aaf9b66af1bbf2c {
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $678fa78e22f406a1$export$ab2e07e76531a47e(this.currentPoint.clone(), new $678fa78e22f406a1$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $678fa78e22f406a1$export$5938c4ee491a43ad(this.currentPoint.clone(), new $678fa78e22f406a1$export$c977b3e384af9ae1(aCPx, aCPy), new $678fa78e22f406a1$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $678fa78e22f406a1$export$e36650d36468bb39(this.currentPoint.clone(), new $678fa78e22f406a1$export$c977b3e384af9ae1(aCP1x, aCP1y), new $678fa78e22f406a1$export$c977b3e384af9ae1(aCP2x, aCP2y), new $678fa78e22f406a1$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $678fa78e22f406a1$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $678fa78e22f406a1$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
}
class $678fa78e22f406a1$export$6428a7f2611ef1fa extends $678fa78e22f406a1$export$4b2950bdac9b6ee9 {
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $678fa78e22f406a1$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
    constructor(points){
        super(points);
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
}
class $678fa78e22f406a1$export$6ecadb6ed240d696 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
    constructor(color, intensity = 1){
        super();
        this.type = 'Light';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
}
$678fa78e22f406a1$export$6ecadb6ed240d696.prototype.isLight = true;
class $678fa78e22f406a1$export$8d474f55edbb9624 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    copy(source) {
        $678fa78e22f406a1$export$6ecadb6ed240d696.prototype.copy.call(this, source);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.type = 'HemisphereLight';
        this.position.copy($678fa78e22f406a1$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $678fa78e22f406a1$export$892596cec99bc70e(groundColor);
    }
}
$678fa78e22f406a1$export$8d474f55edbb9624.prototype.isHemisphereLight = true;
const $678fa78e22f406a1$var$_projScreenMatrix$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_lightPositionWorld$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_lookTarget$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$var$LightShadow {
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $678fa78e22f406a1$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($678fa78e22f406a1$var$_lightPositionWorld$1);
        $678fa78e22f406a1$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($678fa78e22f406a1$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $678fa78e22f406a1$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($678fa78e22f406a1$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.mapSize = new $678fa78e22f406a1$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $678fa78e22f406a1$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $678fa78e22f406a1$export$35efe6f4c85463d2();
        this._frameExtents = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
}
class $678fa78e22f406a1$var$SpotLightShadow extends $678fa78e22f406a1$var$LightShadow {
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $678fa78e22f406a1$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
    constructor(){
        super(new $678fa78e22f406a1$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.focus = 1;
    }
}
$678fa78e22f406a1$var$SpotLightShadow.prototype.isSpotLightShadow = true;
class $678fa78e22f406a1$export$81495cbb73897362 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    get power() {
        // intensity = power per solid angle.
        // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        return this.intensity * Math.PI;
    }
    set power(power) {
        // intensity = power per solid angle.
        // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.type = 'SpotLight';
        this.position.copy($678fa78e22f406a1$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $678fa78e22f406a1$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $678fa78e22f406a1$var$SpotLightShadow();
    }
}
$678fa78e22f406a1$export$81495cbb73897362.prototype.isSpotLight = true;
const $678fa78e22f406a1$var$_projScreenMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_lightPositionWorld = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_lookTarget = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$var$PointLightShadow extends $678fa78e22f406a1$var$LightShadow {
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $678fa78e22f406a1$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($678fa78e22f406a1$var$_lightPositionWorld);
        $678fa78e22f406a1$var$_lookTarget.copy(camera.position);
        $678fa78e22f406a1$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($678fa78e22f406a1$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$678fa78e22f406a1$var$_lightPositionWorld.x, -$678fa78e22f406a1$var$_lightPositionWorld.y, -$678fa78e22f406a1$var$_lightPositionWorld.z);
        $678fa78e22f406a1$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($678fa78e22f406a1$var$_projScreenMatrix);
    }
    constructor(){
        super(new $678fa78e22f406a1$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this._frameExtents = new $678fa78e22f406a1$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $678fa78e22f406a1$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $678fa78e22f406a1$export$64b5c384219d3699(1, 0, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(-1, 0, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 1),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, -1),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 1),
            new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, -1)
        ];
    }
}
$678fa78e22f406a1$var$PointLightShadow.prototype.isPointLightShadow = true;
class $678fa78e22f406a1$export$4c9c1cb3f0b6f455 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    get power() {
        // intensity = power per solid angle.
        // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // intensity = power per solid angle.
        // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $678fa78e22f406a1$var$PointLightShadow();
    }
}
$678fa78e22f406a1$export$4c9c1cb3f0b6f455.prototype.isPointLight = true;
class $678fa78e22f406a1$export$9ebf355ee4ed261b extends $678fa78e22f406a1$export$79f141de891a5fed {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
}
$678fa78e22f406a1$export$9ebf355ee4ed261b.prototype.isOrthographicCamera = true;
class $678fa78e22f406a1$var$DirectionalLightShadow extends $678fa78e22f406a1$var$LightShadow {
    constructor(){
        super(new $678fa78e22f406a1$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
    }
}
$678fa78e22f406a1$var$DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
class $678fa78e22f406a1$export$3fea33cc9972c868 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    constructor(color, intensity){
        super(color, intensity);
        this.type = 'DirectionalLight';
        this.position.copy($678fa78e22f406a1$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $678fa78e22f406a1$export$e4dd07dff30cc924();
        this.shadow = new $678fa78e22f406a1$var$DirectionalLightShadow();
    }
}
$678fa78e22f406a1$export$3fea33cc9972c868.prototype.isDirectionalLight = true;
class $678fa78e22f406a1$export$af279bfef9ec2c96 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.type = 'AmbientLight';
    }
}
$678fa78e22f406a1$export$af279bfef9ec2c96.prototype.isAmbientLight = true;
class $678fa78e22f406a1$export$61db2d908bbd2429 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
}
$678fa78e22f406a1$export$61db2d908bbd2429.prototype.isRectAreaLight = true;
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $678fa78e22f406a1$export$ba61ce607e1f405a {
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
    constructor(){
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $678fa78e22f406a1$export$64b5c384219d3699());
    }
}
$678fa78e22f406a1$export$ba61ce607e1f405a.prototype.isSphericalHarmonics3 = true;
class $678fa78e22f406a1$export$e7ef036e309b38d2 extends $678fa78e22f406a1$export$6ecadb6ed240d696 {
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
    constructor(sh = new $678fa78e22f406a1$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.sh = sh;
    }
}
$678fa78e22f406a1$export$e7ef036e309b38d2.prototype.isLightProbe = true;
class $678fa78e22f406a1$export$3bd6d323353dcf96 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = new $678fa78e22f406a1$var$Materials[json.type]();
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = new $678fa78e22f406a1$export$892596cec99bc70e().setHex(json.sheen);
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.morphTargets !== undefined) material.morphTargets = json.morphTargets;
        if (json.morphNormals !== undefined) material.morphNormals = json.morphNormals;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.vertexTangents !== undefined) material.vertexTangents = json.vertexTangents;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $678fa78e22f406a1$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $678fa78e22f406a1$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $678fa78e22f406a1$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $678fa78e22f406a1$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $678fa78e22f406a1$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $678fa78e22f406a1$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $678fa78e22f406a1$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    constructor(manager){
        super(manager);
        this.textures = {};
    }
}
class $678fa78e22f406a1$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.substr(0, index + 1);
    }
}
class $678fa78e22f406a1$export$231f009cbe414146 extends $678fa78e22f406a1$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
    constructor(){
        super();
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
}
$678fa78e22f406a1$export$231f009cbe414146.prototype.isInstancedBufferGeometry = true;
class $678fa78e22f406a1$export$32ea87a8b54d744a extends $678fa78e22f406a1$export$8dea267bd6bde117 {
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
    constructor(array, itemSize, normalized, meshPerAttribute){
        if (typeof normalized === 'number') {
            meshPerAttribute = normalized;
            normalized = false;
            console.error('THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.');
        }
        super(array, itemSize, normalized);
        this.meshPerAttribute = meshPerAttribute || 1;
    }
}
$678fa78e22f406a1$export$32ea87a8b54d744a.prototype.isInstancedBufferAttribute = true;
class $678fa78e22f406a1$export$dc275bb96327833a extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $678fa78e22f406a1$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $678fa78e22f406a1$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $678fa78e22f406a1$export$231f009cbe414146() : new $678fa78e22f406a1$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $678fa78e22f406a1$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $678fa78e22f406a1$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $678fa78e22f406a1$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $678fa78e22f406a1$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $678fa78e22f406a1$export$32ea87a8b54d744a : $678fa78e22f406a1$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $678fa78e22f406a1$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $678fa78e22f406a1$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $678fa78e22f406a1$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $678fa78e22f406a1$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $678fa78e22f406a1$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
    constructor(manager){
        super(manager);
    }
}
class $678fa78e22f406a1$export$40110c8505c5ad19 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $678fa78e22f406a1$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $678fa78e22f406a1$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $678fa78e22f406a1$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        let geometryShapes;
        if (json !== undefined) {
            const bufferGeometryLoader = new $678fa78e22f406a1$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'PlaneGeometry':
                    case 'PlaneBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.width, data.height, data.widthSegments, data.heightSegments);
                        break;
                    case 'BoxGeometry':
                    case 'BoxBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
                        break;
                    case 'CircleGeometry':
                    case 'CircleBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radius, data.segments, data.thetaStart, data.thetaLength);
                        break;
                    case 'CylinderGeometry':
                    case 'CylinderBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
                        break;
                    case 'ConeGeometry':
                    case 'ConeBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
                        break;
                    case 'SphereGeometry':
                    case 'SphereBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
                        break;
                    case 'DodecahedronGeometry':
                    case 'DodecahedronBufferGeometry':
                    case 'IcosahedronGeometry':
                    case 'IcosahedronBufferGeometry':
                    case 'OctahedronGeometry':
                    case 'OctahedronBufferGeometry':
                    case 'TetrahedronGeometry':
                    case 'TetrahedronBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radius, data.detail);
                        break;
                    case 'RingGeometry':
                    case 'RingBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
                        break;
                    case 'TorusGeometry':
                    case 'TorusBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
                        break;
                    case 'TorusKnotGeometry':
                    case 'TorusKnotBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
                        break;
                    case 'TubeGeometry':
                    case 'TubeBufferGeometry':
                        // This only works for built-in curves (e.g. CatmullRomCurve3).
                        // User defined curves or instances of CurvePath will not be deserialized.
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](new $678fa78e22f406a1$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
                        break;
                    case 'LatheGeometry':
                    case 'LatheBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.points, data.segments, data.phiStart, data.phiLength);
                        break;
                    case 'PolyhedronGeometry':
                    case 'PolyhedronBufferGeometry':
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](data.vertices, data.indices, data.radius, data.details);
                        break;
                    case 'ShapeGeometry':
                    case 'ShapeBufferGeometry':
                        geometryShapes = [];
                        for(let j = 0, jl = data.shapes.length; j < jl; j++){
                            const shape = shapes[data.shapes[j]];
                            geometryShapes.push(shape);
                        }
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](geometryShapes, data.curveSegments);
                        break;
                    case 'ExtrudeGeometry':
                    case 'ExtrudeBufferGeometry':
                        geometryShapes = [];
                        for(let j = 0, jl = data.shapes.length; j < jl; j++){
                            const shape = shapes[data.shapes[j]];
                            geometryShapes.push(shape);
                        }
                        const extrudePath = data.options.extrudePath;
                        if (extrudePath !== undefined) data.options.extrudePath = new $678fa78e22f406a1$var$Curves[extrudePath.type]().fromJSON(extrudePath);
                        geometry = new $678fa78e22f406a1$var$Geometries[data.type](geometryShapes, data.options);
                        break;
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case 'Geometry':
                        console.error('THREE.ObjectLoader: Loading "Geometry" is not supported anymore.');
                        break;
                    default:
                        console.warn('THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"');
                        continue;
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $678fa78e22f406a1$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === 'MultiMaterial') {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $678fa78e22f406a1$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $678fa78e22f406a1$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $678fa78e22f406a1$export$99cc795e99919eed(onLoad);
            loader = new $678fa78e22f406a1$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new $678fa78e22f406a1$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            let texture;
            const image = images[data.image];
            if (Array.isArray(image)) {
                texture = new $678fa78e22f406a1$export$ee2e5a18258a4049(image);
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $678fa78e22f406a1$export$b691f601014eabe1(image.data, image.width, image.height);
                else texture = new $678fa78e22f406a1$export$5431306cf43de24a(image);
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $678fa78e22f406a1$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $678fa78e22f406a1$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $678fa78e22f406a1$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $678fa78e22f406a1$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $678fa78e22f406a1$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $678fa78e22f406a1$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $678fa78e22f406a1$export$892596cec99bc70e(data.background);
                }
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $678fa78e22f406a1$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $678fa78e22f406a1$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case 'PerspectiveCamera':
                object = new $678fa78e22f406a1$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $678fa78e22f406a1$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $678fa78e22f406a1$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $678fa78e22f406a1$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new $678fa78e22f406a1$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $678fa78e22f406a1$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $678fa78e22f406a1$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new $678fa78e22f406a1$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $678fa78e22f406a1$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $678fa78e22f406a1$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $678fa78e22f406a1$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $678fa78e22f406a1$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $678fa78e22f406a1$export$8dea267bd6bde117(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'LOD':
                object = new $678fa78e22f406a1$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $678fa78e22f406a1$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $678fa78e22f406a1$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $678fa78e22f406a1$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $678fa78e22f406a1$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $678fa78e22f406a1$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $678fa78e22f406a1$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $678fa78e22f406a1$export$b127726e56765aa4();
                break;
            default:
                object = new $678fa78e22f406a1$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn('THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().');
        return this.setResourcePath(value);
    }
    constructor(manager){
        super(manager);
    }
}
const $678fa78e22f406a1$var$TEXTURE_MAPPING = {
    UVMapping: $678fa78e22f406a1$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $678fa78e22f406a1$export$8759762a6477f2c4,
    CubeRefractionMapping: $678fa78e22f406a1$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $678fa78e22f406a1$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $678fa78e22f406a1$export$ee99d97d46898098,
    CubeUVReflectionMapping: $678fa78e22f406a1$export$dbf3e70ff37af79,
    CubeUVRefractionMapping: $678fa78e22f406a1$export$76a9f4355364345c
};
const $678fa78e22f406a1$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $678fa78e22f406a1$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $678fa78e22f406a1$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $678fa78e22f406a1$export$c7e7c00b14f51a4f
};
const $678fa78e22f406a1$var$TEXTURE_FILTER = {
    NearestFilter: $678fa78e22f406a1$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $678fa78e22f406a1$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $678fa78e22f406a1$export$d2327c1afe5bfdf2,
    LinearFilter: $678fa78e22f406a1$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $678fa78e22f406a1$export$19a719f377145a13,
    LinearMipmapLinearFilter: $678fa78e22f406a1$export$5d8599b6a933fb1b
};
class $678fa78e22f406a1$export$52286b55c4a9b51f extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $678fa78e22f406a1$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $678fa78e22f406a1$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
    constructor(manager){
        super(manager);
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
}
$678fa78e22f406a1$export$52286b55c4a9b51f.prototype.isImageBitmapLoader = true;
class $678fa78e22f406a1$export$148534a3c727230b {
    moveTo(x, y) {
        this.currentPath = new $678fa78e22f406a1$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $678fa78e22f406a1$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $678fa78e22f406a1$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $678fa78e22f406a1$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $678fa78e22f406a1$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            const toChange = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange.push({
                            froms: sIdx,
                            tos: s2Idx,
                            hole: hIdx
                        });
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            // console.log("ambiguous: ", ambiguous);
            if (toChange.length > 0) // console.log("to change: ", toChange);
            {
                if (!ambiguous) newShapeHoles = betterShapeHoles;
            }
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
    constructor(){
        this.type = 'ShapePath';
        this.color = new $678fa78e22f406a1$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
}
class $678fa78e22f406a1$export$89abf52a030e56ee {
    generateShapes(text, size = 100) {
        const shapes = [];
        const paths = $678fa78e22f406a1$var$createPaths(text, size, this.data);
        for(let p = 0, pl = paths.length; p < pl; p++)Array.prototype.push.apply(shapes, paths[p].toShapes());
        return shapes;
    }
    constructor(data){
        this.type = 'Font';
        this.data = data;
    }
}
function $678fa78e22f406a1$var$createPaths(text, size, data) {
    const chars = Array.from(text);
    const scale = size / data.resolution;
    const line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    const paths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === '\n') {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = $678fa78e22f406a1$var$createPath(char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function $678fa78e22f406a1$var$createPath(char, scale, offsetX, offsetY, data) {
    const glyph = data.glyphs[char] || data.glyphs['?'];
    if (!glyph) {
        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');
        return;
    }
    const path = new $678fa78e22f406a1$export$148534a3c727230b();
    let x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case 'm':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case 'l':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case 'q':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case 'b':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}
$678fa78e22f406a1$export$89abf52a030e56ee.prototype.isFont = true;
class $678fa78e22f406a1$export$812303d6cad736b3 extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            let json;
            try {
                json = JSON.parse(text);
            } catch (e) {
                console.warn('THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.');
                json = JSON.parse(text.substring(65, text.length - 2));
            }
            const font = scope.parse(json);
            if (onLoad) onLoad(font);
        }, onProgress, onError);
    }
    parse(json) {
        return new $678fa78e22f406a1$export$89abf52a030e56ee(json);
    }
    constructor(manager){
        super(manager);
    }
}
let $678fa78e22f406a1$var$_context;
const $678fa78e22f406a1$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($678fa78e22f406a1$var$_context === undefined) $678fa78e22f406a1$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $678fa78e22f406a1$var$_context;
    },
    setContext: function(value) {
        $678fa78e22f406a1$var$_context = value;
    }
};
class $678fa78e22f406a1$export$d8d5fccfbf47714e extends $678fa78e22f406a1$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $678fa78e22f406a1$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $678fa78e22f406a1$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    constructor(manager){
        super(manager);
    }
}
class $678fa78e22f406a1$export$2f22dadc8bc42820 extends $678fa78e22f406a1$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        const color1 = new $678fa78e22f406a1$export$892596cec99bc70e().set(skyColor);
        const color2 = new $678fa78e22f406a1$export$892596cec99bc70e().set(groundColor);
        const sky = new $678fa78e22f406a1$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $678fa78e22f406a1$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
$678fa78e22f406a1$export$2f22dadc8bc42820.prototype.isHemisphereLightProbe = true;
class $678fa78e22f406a1$export$afe310a21c86023d extends $678fa78e22f406a1$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        const color1 = new $678fa78e22f406a1$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
$678fa78e22f406a1$export$afe310a21c86023d.prototype.isAmbientLightProbe = true;
const $678fa78e22f406a1$var$_eyeRight = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_eyeLeft = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
class $678fa78e22f406a1$export$bc7f73a1065bee0c {
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            const projectionMatrix = camera.projectionMatrix.clone();
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($678fa78e22f406a1$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $678fa78e22f406a1$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $678fa78e22f406a1$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy(projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy(projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($678fa78e22f406a1$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($678fa78e22f406a1$var$_eyeRight);
    }
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $678fa78e22f406a1$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $678fa78e22f406a1$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
}
class $678fa78e22f406a1$export$9735c82c4bae3302 {
    start() {
        this.startTime = $678fa78e22f406a1$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $678fa78e22f406a1$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
}
function $678fa78e22f406a1$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $678fa78e22f406a1$var$_position$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_quaternion$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
const $678fa78e22f406a1$var$_scale$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_orientation$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$8a1b810c6fde8951 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($678fa78e22f406a1$var$_position$1, $678fa78e22f406a1$var$_quaternion$1, $678fa78e22f406a1$var$_scale$1);
        $678fa78e22f406a1$var$_orientation$1.set(0, 0, -1).applyQuaternion($678fa78e22f406a1$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($678fa78e22f406a1$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($678fa78e22f406a1$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($678fa78e22f406a1$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($678fa78e22f406a1$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($678fa78e22f406a1$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($678fa78e22f406a1$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($678fa78e22f406a1$var$_position$1.x, $678fa78e22f406a1$var$_position$1.y, $678fa78e22f406a1$var$_position$1.z);
            listener.setOrientation($678fa78e22f406a1$var$_orientation$1.x, $678fa78e22f406a1$var$_orientation$1.y, $678fa78e22f406a1$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $678fa78e22f406a1$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $678fa78e22f406a1$export$9735c82c4bae3302();
    }
}
class $678fa78e22f406a1$export$153755f98d9861de extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
}
const $678fa78e22f406a1$var$_position = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_quaternion = /*@__PURE__*/ new $678fa78e22f406a1$export$23d6a54f0bbc85a3();
const $678fa78e22f406a1$var$_scale = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_orientation = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$4b3e397ef1832507 extends $678fa78e22f406a1$export$153755f98d9861de {
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($678fa78e22f406a1$var$_position, $678fa78e22f406a1$var$_quaternion, $678fa78e22f406a1$var$_scale);
        $678fa78e22f406a1$var$_orientation.set(0, 0, 1).applyQuaternion($678fa78e22f406a1$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($678fa78e22f406a1$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($678fa78e22f406a1$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($678fa78e22f406a1$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($678fa78e22f406a1$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($678fa78e22f406a1$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($678fa78e22f406a1$var$_orientation.z, endTime);
        } else {
            panner.setPosition($678fa78e22f406a1$var$_position.x, $678fa78e22f406a1$var$_position.y, $678fa78e22f406a1$var$_position.z);
            panner.setOrientation($678fa78e22f406a1$var$_orientation.x, $678fa78e22f406a1$var$_orientation.y, $678fa78e22f406a1$var$_orientation.z);
        }
    }
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
}
class $678fa78e22f406a1$export$d47da1ef3d382827 {
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
}
class $678fa78e22f406a1$export$dfe0af1ca1acb78a {
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $678fa78e22f406a1$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $678fa78e22f406a1$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $678fa78e22f406a1$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $678fa78e22f406a1$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $678fa78e22f406a1$var$_reservedRe = new RegExp('[' + $678fa78e22f406a1$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $678fa78e22f406a1$var$_wordChar = '[^' + $678fa78e22f406a1$var$_RESERVED_CHARS_RE + ']';
const $678fa78e22f406a1$var$_wordCharOrDot = '[^' + $678fa78e22f406a1$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $678fa78e22f406a1$var$_directoryRe = /((?:WC+[\/:])*)/.source.replace('WC', $678fa78e22f406a1$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $678fa78e22f406a1$var$_nodeRe = /(WCOD+)?/.source.replace('WCOD', $678fa78e22f406a1$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $678fa78e22f406a1$var$_objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $678fa78e22f406a1$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $678fa78e22f406a1$var$_propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $678fa78e22f406a1$var$_wordChar);
const $678fa78e22f406a1$var$_trackRe = new RegExp("^" + $678fa78e22f406a1$var$_directoryRe + $678fa78e22f406a1$var$_nodeRe + $678fa78e22f406a1$var$_objectRe + $678fa78e22f406a1$var$_propertyRe + '$');
const $678fa78e22f406a1$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones'
];
class $678fa78e22f406a1$var$Composite {
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $678fa78e22f406a1$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $678fa78e22f406a1$export$7bf70fcf9f891893 {
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $678fa78e22f406a1$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $678fa78e22f406a1$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($678fa78e22f406a1$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $678fa78e22f406a1$var$_trackRe.exec(trackName);
        if (!matches) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($678fa78e22f406a1$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (!nodeName || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.node[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $678fa78e22f406a1$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (targetObject.geometry.isBufferGeometry) {
                    if (!targetObject.geometry.morphAttributes) {
                        console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                        return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                } else {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.', this);
                    return;
                }
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $678fa78e22f406a1$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $678fa78e22f406a1$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$678fa78e22f406a1$export$7bf70fcf9f891893.Composite = $678fa78e22f406a1$var$Composite;
$678fa78e22f406a1$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$678fa78e22f406a1$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$678fa78e22f406a1$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._getValue_direct,
    $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._getValue_array,
    $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$678fa78e22f406a1$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_direct,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_array,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $678fa78e22f406a1$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $678fa78e22f406a1$export$30619c2afd3f34db {
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $678fa78e22f406a1$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $678fa78e22f406a1$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $678fa78e22f406a1$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
    constructor(){
        this.uuid = $678fa78e22f406a1$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
}
$678fa78e22f406a1$export$30619c2afd3f34db.prototype.isAnimationObjectGroup = true;
class $678fa78e22f406a1$var$AnimationAction {
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $678fa78e22f406a1$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $678fa78e22f406a1$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $678fa78e22f406a1$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $678fa78e22f406a1$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $678fa78e22f406a1$export$24a4ccb5099273b5;
            settings.endingEnd = $678fa78e22f406a1$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $678fa78e22f406a1$export$24a4ccb5099273b5 : $678fa78e22f406a1$export$7f795934b84ab523;
            else settings.endingStart = $678fa78e22f406a1$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $678fa78e22f406a1$export$24a4ccb5099273b5 : $678fa78e22f406a1$export$7f795934b84ab523;
            else settings.endingEnd = $678fa78e22f406a1$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $678fa78e22f406a1$export$7f795934b84ab523,
            endingEnd: $678fa78e22f406a1$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $678fa78e22f406a1$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
}
class $678fa78e22f406a1$export$fbd77e5aefaa0102 extends $678fa78e22f406a1$export$ec8b666c5fe2c75a {
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) bindings[i] = binding;
            else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $678fa78e22f406a1$export$dfe0af1ca1acb78a($678fa78e22f406a1$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $678fa78e22f406a1$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $678fa78e22f406a1$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $678fa78e22f406a1$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $678fa78e22f406a1$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $678fa78e22f406a1$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
}
$678fa78e22f406a1$export$fbd77e5aefaa0102.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class $678fa78e22f406a1$export$2947cebfe91c02f8 {
    clone() {
        return new $678fa78e22f406a1$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
    constructor(value){
        if (typeof value === 'string') {
            console.warn('THREE.Uniform: Type parameter is no longer needed.');
            value = arguments[1];
        }
        this.value = value;
    }
}
class $678fa78e22f406a1$export$25ec0e1af1389358 extends $678fa78e22f406a1$export$3d5cd879f108f53f {
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.meshPerAttribute = meshPerAttribute || 1;
    }
}
$678fa78e22f406a1$export$25ec0e1af1389358.prototype.isInstancedInterleavedBuffer = true;
class $678fa78e22f406a1$export$6b7339ae8dbddf73 {
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
    constructor(buffer, type, itemSize, elementSize, count){
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
}
$678fa78e22f406a1$export$6b7339ae8dbddf73.prototype.isGLBufferAttribute = true;
class $678fa78e22f406a1$export$8b7aaceff00bd2f {
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera && camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera && camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    intersectObject(object, recursive = false, intersects = []) {
        $678fa78e22f406a1$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($678fa78e22f406a1$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = false, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$678fa78e22f406a1$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($678fa78e22f406a1$var$ascSort);
        return intersects;
    }
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $678fa78e22f406a1$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $678fa78e22f406a1$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
}
function $678fa78e22f406a1$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $678fa78e22f406a1$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$678fa78e22f406a1$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $678fa78e22f406a1$export$d712cd887b4a00f7 {
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be betwee EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($678fa78e22f406a1$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $678fa78e22f406a1$export$287165bb2177f4fd {
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
}
const $678fa78e22f406a1$var$_vector$4 = /*@__PURE__*/ new $678fa78e22f406a1$export$c977b3e384af9ae1();
class $678fa78e22f406a1$export$60f553fa130f08b0 {
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $678fa78e22f406a1$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .getCenter() target is now required');
            target = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        }
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .getSize() target is now required');
            target = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        }
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        if (target === undefined) {
            console.warn('THREE.Box2: .getParameter() target is now required');
            target = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        }
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .clampPoint() target is now required');
            target = new $678fa78e22f406a1$export$c977b3e384af9ae1();
        }
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $678fa78e22f406a1$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    constructor(min = new $678fa78e22f406a1$export$c977b3e384af9ae1(Infinity, Infinity), max = new $678fa78e22f406a1$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.min = min;
        this.max = max;
    }
}
$678fa78e22f406a1$export$60f553fa130f08b0.prototype.isBox2 = true;
const $678fa78e22f406a1$var$_startP = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_startEnd = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$e0ba6359f1954fd3 {
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .getCenter() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .delta() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .at() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $678fa78e22f406a1$var$_startP.subVectors(point, this.start);
        $678fa78e22f406a1$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $678fa78e22f406a1$var$_startEnd.dot($678fa78e22f406a1$var$_startEnd);
        const startEnd_startP = $678fa78e22f406a1$var$_startEnd.dot($678fa78e22f406a1$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $678fa78e22f406a1$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        if (target === undefined) {
            console.warn('THREE.Line3: .closestPointToPoint() target is now required');
            target = new $678fa78e22f406a1$export$64b5c384219d3699();
        }
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(start = new $678fa78e22f406a1$export$64b5c384219d3699(), end = new $678fa78e22f406a1$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
}
class $678fa78e22f406a1$export$960665a8431ecff6 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.material = material;
        this.render = function() {};
        this.hasPositions = false;
        this.hasNormals = false;
        this.hasColors = false;
        this.hasUvs = false;
        this.positionArray = null;
        this.normalArray = null;
        this.colorArray = null;
        this.uvArray = null;
        this.count = 0;
    }
}
$678fa78e22f406a1$export$960665a8431ecff6.prototype.isImmediateRenderObject = true;
const $678fa78e22f406a1$var$_vector$3 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$4b14638ffdd81e68 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $678fa78e22f406a1$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($678fa78e22f406a1$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(positions, 3));
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $678fa78e22f406a1$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
}
const $678fa78e22f406a1$var$_vector$2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_boneMatrix = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
const $678fa78e22f406a1$var$_matrixWorldInv = /*@__PURE__*/ new $678fa78e22f406a1$export$2ae72fc923e5eb5();
class $678fa78e22f406a1$export$5277df3c9e732259 extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $678fa78e22f406a1$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $678fa78e22f406a1$var$_boneMatrix.multiplyMatrices($678fa78e22f406a1$var$_matrixWorldInv, bone.matrixWorld);
                $678fa78e22f406a1$var$_vector$2.setFromMatrixPosition($678fa78e22f406a1$var$_boneMatrix);
                position.setXYZ(j, $678fa78e22f406a1$var$_vector$2.x, $678fa78e22f406a1$var$_vector$2.y, $678fa78e22f406a1$var$_vector$2.z);
                $678fa78e22f406a1$var$_boneMatrix.multiplyMatrices($678fa78e22f406a1$var$_matrixWorldInv, bone.parent.matrixWorld);
                $678fa78e22f406a1$var$_vector$2.setFromMatrixPosition($678fa78e22f406a1$var$_boneMatrix);
                position.setXYZ(j + 1, $678fa78e22f406a1$var$_vector$2.x, $678fa78e22f406a1$var$_vector$2.y, $678fa78e22f406a1$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    constructor(object){
        const bones = $678fa78e22f406a1$var$getBoneList(object);
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $678fa78e22f406a1$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $678fa78e22f406a1$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $678fa78e22f406a1$export$cbe7a62641830ebd(colors, 3));
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.type = 'SkeletonHelper';
        this.isSkeletonHelper = true;
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
}
function $678fa78e22f406a1$var$getBoneList(object) {
    const boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $678fa78e22f406a1$var$getBoneList(object.children[i]));
    return boneList;
}
class $678fa78e22f406a1$export$9a9291685b9e4023 extends $678fa78e22f406a1$export$e176487c05830cc5 {
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
    constructor(light, sphereSize, color){
        const geometry = new $678fa78e22f406a1$export$d5d06a966fec4192(sphereSize, 4, 2);
        const material = new $678fa78e22f406a1$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronBufferGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
}
const $678fa78e22f406a1$var$_vector$1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_color1 = /*@__PURE__*/ new $678fa78e22f406a1$export$892596cec99bc70e();
const $678fa78e22f406a1$var$_color2 = /*@__PURE__*/ new $678fa78e22f406a1$export$892596cec99bc70e();
class $678fa78e22f406a1$export$8dca15f13f4f8172 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $678fa78e22f406a1$var$_color1.copy(this.light.color);
            $678fa78e22f406a1$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $678fa78e22f406a1$var$_color1 : $678fa78e22f406a1$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($678fa78e22f406a1$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $678fa78e22f406a1$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $678fa78e22f406a1$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $678fa78e22f406a1$export$8dea267bd6bde117(colors, 3));
        this.add(new $678fa78e22f406a1$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
}
class $678fa78e22f406a1$export$3875d39926561055 extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $678fa78e22f406a1$export$892596cec99bc70e(color1);
        color2 = new $678fa78e22f406a1$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $678fa78e22f406a1$export$cbe7a62641830ebd(colors, 3));
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
}
class $678fa78e22f406a1$export$361430a10f533cd3 extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $678fa78e22f406a1$export$892596cec99bc70e(color1);
        color2 = new $678fa78e22f406a1$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $678fa78e22f406a1$export$cbe7a62641830ebd(colors, 3));
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
}
const $678fa78e22f406a1$var$_v1 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v2 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_v3 = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
class $678fa78e22f406a1$export$f8e434dc14203e7d extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $678fa78e22f406a1$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $678fa78e22f406a1$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $678fa78e22f406a1$var$_v3.subVectors($678fa78e22f406a1$var$_v2, $678fa78e22f406a1$var$_v1);
        this.lightPlane.lookAt($678fa78e22f406a1$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($678fa78e22f406a1$var$_v2);
        this.targetLine.scale.z = $678fa78e22f406a1$var$_v3.length();
    }
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $678fa78e22f406a1$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $678fa78e22f406a1$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
}
const $678fa78e22f406a1$var$_vector = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
const $678fa78e22f406a1$var$_camera = /*@__PURE__*/ new $678fa78e22f406a1$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */ class $678fa78e22f406a1$export$ed8e93f853cd795 extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $678fa78e22f406a1$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $678fa78e22f406a1$var$setPoint('c', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, 0, -1);
        $678fa78e22f406a1$var$setPoint('t', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, 0, 1);
        // near
        $678fa78e22f406a1$var$setPoint('n1', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w, -h, -1);
        $678fa78e22f406a1$var$setPoint('n2', pointMap, geometry, $678fa78e22f406a1$var$_camera, w, -h, -1);
        $678fa78e22f406a1$var$setPoint('n3', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w, h, -1);
        $678fa78e22f406a1$var$setPoint('n4', pointMap, geometry, $678fa78e22f406a1$var$_camera, w, h, -1);
        // far
        $678fa78e22f406a1$var$setPoint('f1', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w, -h, 1);
        $678fa78e22f406a1$var$setPoint('f2', pointMap, geometry, $678fa78e22f406a1$var$_camera, w, -h, 1);
        $678fa78e22f406a1$var$setPoint('f3', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w, h, 1);
        $678fa78e22f406a1$var$setPoint('f4', pointMap, geometry, $678fa78e22f406a1$var$_camera, w, h, 1);
        // up
        $678fa78e22f406a1$var$setPoint('u1', pointMap, geometry, $678fa78e22f406a1$var$_camera, w * 0.7, h * 1.1, -1);
        $678fa78e22f406a1$var$setPoint('u2', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w * 0.7, h * 1.1, -1);
        $678fa78e22f406a1$var$setPoint('u3', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, h * 2, -1);
        // cross
        $678fa78e22f406a1$var$setPoint('cf1', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w, 0, 1);
        $678fa78e22f406a1$var$setPoint('cf2', pointMap, geometry, $678fa78e22f406a1$var$_camera, w, 0, 1);
        $678fa78e22f406a1$var$setPoint('cf3', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, -h, 1);
        $678fa78e22f406a1$var$setPoint('cf4', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, h, 1);
        $678fa78e22f406a1$var$setPoint('cn1', pointMap, geometry, $678fa78e22f406a1$var$_camera, -w, 0, -1);
        $678fa78e22f406a1$var$setPoint('cn2', pointMap, geometry, $678fa78e22f406a1$var$_camera, w, 0, -1);
        $678fa78e22f406a1$var$setPoint('cn3', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, -h, -1);
        $678fa78e22f406a1$var$setPoint('cn4', pointMap, geometry, $678fa78e22f406a1$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(camera){
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // colors
        const colorFrustum = new $678fa78e22f406a1$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $678fa78e22f406a1$export$892596cec99bc70e(0xff0000);
        const colorUp = new $678fa78e22f406a1$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $678fa78e22f406a1$export$892596cec99bc70e(0xffffff);
        const colorCross = new $678fa78e22f406a1$export$892596cec99bc70e(0x333333);
        // near
        addLine('n1', 'n2', colorFrustum);
        addLine('n2', 'n4', colorFrustum);
        addLine('n4', 'n3', colorFrustum);
        addLine('n3', 'n1', colorFrustum);
        // far
        addLine('f1', 'f2', colorFrustum);
        addLine('f2', 'f4', colorFrustum);
        addLine('f4', 'f3', colorFrustum);
        addLine('f3', 'f1', colorFrustum);
        // sides
        addLine('n1', 'f1', colorFrustum);
        addLine('n2', 'f2', colorFrustum);
        addLine('n3', 'f3', colorFrustum);
        addLine('n4', 'f4', colorFrustum);
        // cone
        addLine('p', 'n1', colorCone);
        addLine('p', 'n2', colorCone);
        addLine('p', 'n3', colorCone);
        addLine('p', 'n4', colorCone);
        // up
        addLine('u1', 'u2', colorUp);
        addLine('u2', 'u3', colorUp);
        addLine('u3', 'u1', colorUp);
        // target
        addLine('c', 't', colorTarget);
        addLine('p', 'c', colorCross);
        // cross
        addLine('cn1', 'cn2', colorCross);
        addLine('cn3', 'cn4', colorCross);
        addLine('cf1', 'cf2', colorCross);
        addLine('cf3', 'cf4', colorCross);
        function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        }
        function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $678fa78e22f406a1$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
    }
}
function $678fa78e22f406a1$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $678fa78e22f406a1$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $678fa78e22f406a1$var$_vector.x, $678fa78e22f406a1$var$_vector.y, $678fa78e22f406a1$var$_vector.z);
    }
}
const $678fa78e22f406a1$var$_box = /*@__PURE__*/ new $678fa78e22f406a1$export$6f7d5a9418ab2aa3();
class $678fa78e22f406a1$export$38a664cc862a6a9d extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $678fa78e22f406a1$var$_box.setFromObject(this.object);
        if ($678fa78e22f406a1$var$_box.isEmpty()) return;
        const min = $678fa78e22f406a1$var$_box.min;
        const max = $678fa78e22f406a1$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source) {
        $678fa78e22f406a1$export$ff1ed10fedfdd604.prototype.copy.call(this, source);
        this.object = source.object;
        return this;
    }
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setIndex(new $678fa78e22f406a1$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $678fa78e22f406a1$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $678fa78e22f406a1$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
}
class $678fa78e22f406a1$export$ce39f4bb96c9a290 extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setIndex(new $678fa78e22f406a1$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $678fa78e22f406a1$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
}
class $678fa78e22f406a1$export$a34fe8156c66e5d7 extends $678fa78e22f406a1$export$17d680238e50603e {
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? $678fa78e22f406a1$export$d9f0486e75b5ace : $678fa78e22f406a1$export$2ede184fc2998901; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $678fa78e22f406a1$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $678fa78e22f406a1$export$e176487c05830cc5(geometry2, new $678fa78e22f406a1$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
}
const $678fa78e22f406a1$var$_axis = /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699();
let $678fa78e22f406a1$var$_lineGeometry, $678fa78e22f406a1$var$_coneGeometry;
class $678fa78e22f406a1$export$a3008e7bd8d2cbe7 extends $678fa78e22f406a1$export$e4dd07dff30cc924 {
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $678fa78e22f406a1$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($678fa78e22f406a1$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    // dir is assumed to be normalized
    constructor(dir = new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 1), origin = new $678fa78e22f406a1$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($678fa78e22f406a1$var$_lineGeometry === undefined) {
            $678fa78e22f406a1$var$_lineGeometry = new $678fa78e22f406a1$export$b7be63a67df8959();
            $678fa78e22f406a1$var$_lineGeometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $678fa78e22f406a1$var$_coneGeometry = new $678fa78e22f406a1$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $678fa78e22f406a1$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $678fa78e22f406a1$export$17d680238e50603e($678fa78e22f406a1$var$_lineGeometry, new $678fa78e22f406a1$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $678fa78e22f406a1$export$e176487c05830cc5($678fa78e22f406a1$var$_coneGeometry, new $678fa78e22f406a1$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
}
class $678fa78e22f406a1$export$6c8303f35b8578fd extends $678fa78e22f406a1$export$ff1ed10fedfdd604 {
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $678fa78e22f406a1$export$b7be63a67df8959();
        geometry.setAttribute('position', new $678fa78e22f406a1$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $678fa78e22f406a1$export$cbe7a62641830ebd(colors, 3));
        const material = new $678fa78e22f406a1$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
}
const $678fa78e22f406a1$var$_floatView = new Float32Array(1);
const $678fa78e22f406a1$var$_int32View = new Int32Array($678fa78e22f406a1$var$_floatView.buffer);
class $678fa78e22f406a1$export$11ce8b759162cc80 {
    // Converts float32 to float16 (stored as uint16 value).
    static toHalfFloat(val) {
        // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
        /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ $678fa78e22f406a1$var$_floatView[0] = val;
        const x = $678fa78e22f406a1$var$_int32View[0];
        let bits = x >> 16 & 0x8000; /* Get the sign */ 
        let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
        const e = x >> 23 & 0xff; /* Using int is faster here */ 
        /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
            return bits;
        }
        bits |= e - 112 << 10 | m >> 1;
        /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
        return bits;
    }
}
const $678fa78e22f406a1$var$LOD_MIN = 4;
const $678fa78e22f406a1$var$LOD_MAX = 8;
const $678fa78e22f406a1$var$SIZE_MAX = Math.pow(2, $678fa78e22f406a1$var$LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $678fa78e22f406a1$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
const $678fa78e22f406a1$var$TOTAL_LODS = $678fa78e22f406a1$var$LOD_MAX - $678fa78e22f406a1$var$LOD_MIN + 1 + $678fa78e22f406a1$var$EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $678fa78e22f406a1$var$MAX_SAMPLES = 20;
const $678fa78e22f406a1$var$ENCODINGS = {
    [$678fa78e22f406a1$export$7207336e4151a112]: 0,
    [$678fa78e22f406a1$export$f32388edbb32674]: 1,
    [$678fa78e22f406a1$export$3be4c466a12b5dcf]: 2,
    [$678fa78e22f406a1$export$2c4bdfd76b188654]: 3,
    [$678fa78e22f406a1$export$48a0051d6a5a9b9]: 4,
    [$678fa78e22f406a1$export$ca2f89b13b49d951]: 5,
    [$678fa78e22f406a1$export$eaab32c1bcea1817]: 6
};
const $678fa78e22f406a1$var$backgroundMaterial = new $678fa78e22f406a1$export$55cbcc9b622fe1f5({
    side: $678fa78e22f406a1$export$d9f0486e75b5ace,
    depthWrite: false,
    depthTest: false
});
const $678fa78e22f406a1$var$backgroundBox = new $678fa78e22f406a1$export$e176487c05830cc5(new $678fa78e22f406a1$export$ab3456a079aa7d80(), $678fa78e22f406a1$var$backgroundMaterial);
const $678fa78e22f406a1$var$_flatCamera = /*@__PURE__*/ new $678fa78e22f406a1$export$9ebf355ee4ed261b();
const { _lodPlanes: $678fa78e22f406a1$var$_lodPlanes, _sizeLods: $678fa78e22f406a1$var$_sizeLods, _sigmas: $678fa78e22f406a1$var$_sigmas } = /*@__PURE__*/ $678fa78e22f406a1$var$_createPlanes();
const $678fa78e22f406a1$var$_clearColor = /*@__PURE__*/ new $678fa78e22f406a1$export$892596cec99bc70e();
let $678fa78e22f406a1$var$_oldTarget = null;
// Golden Ratio
const $678fa78e22f406a1$var$PHI = (1 + Math.sqrt(5)) / 2;
const $678fa78e22f406a1$var$INV_PHI = 1 / $678fa78e22f406a1$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $678fa78e22f406a1$var$_axisDirections = [
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(0, $678fa78e22f406a1$var$PHI, $678fa78e22f406a1$var$INV_PHI),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(0, $678fa78e22f406a1$var$PHI, -$678fa78e22f406a1$var$INV_PHI),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699($678fa78e22f406a1$var$INV_PHI, 0, $678fa78e22f406a1$var$PHI),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(-$678fa78e22f406a1$var$INV_PHI, 0, $678fa78e22f406a1$var$PHI),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699($678fa78e22f406a1$var$PHI, $678fa78e22f406a1$var$INV_PHI, 0),
    /*@__PURE__*/ new $678fa78e22f406a1$export$64b5c384219d3699(-$678fa78e22f406a1$var$PHI, $678fa78e22f406a1$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ function $678fa78e22f406a1$var$convertLinearToRGBE(color) {
    const maxComponent = Math.max(color.r, color.g, color.b);
    const fExp = Math.min(Math.max(Math.ceil(Math.log2(maxComponent)), -128), 127.0);
    color.multiplyScalar(Math.pow(2.0, -fExp));
    const alpha = (fExp + 128.0) / 255.0;
    return alpha;
}
class $678fa78e22f406a1$export$6add42717753e221 {
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $678fa78e22f406a1$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets();
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular) {
        return this._fromTexture(equirectangular);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap) {
        return this._fromTexture(cubemap);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapShader === null) {
            this._cubemapShader = $678fa78e22f406a1$var$_getCubemapShader();
            this._compileMaterial(this._cubemapShader);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectShader === null) {
            this._equirectShader = $678fa78e22f406a1$var$_getEquirectShader();
            this._compileMaterial(this._equirectShader);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._blurMaterial.dispose();
        if (this._cubemapShader !== null) this._cubemapShader.dispose();
        if (this._equirectShader !== null) this._equirectShader.dispose();
        for(let i = 0; i < $678fa78e22f406a1$var$_lodPlanes.length; i++)$678fa78e22f406a1$var$_lodPlanes[i].dispose();
    }
    // private interface
    _cleanup(outputTarget) {
        this._pingPongRenderTarget.dispose();
        this._renderer.setRenderTarget($678fa78e22f406a1$var$_oldTarget);
        outputTarget.scissorTest = false;
        $678fa78e22f406a1$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture) {
        $678fa78e22f406a1$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets(texture);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets(texture) {
        const params = {
            magFilter: $678fa78e22f406a1$export$727aa5ec3fe39bf0,
            minFilter: $678fa78e22f406a1$export$727aa5ec3fe39bf0,
            generateMipmaps: false,
            type: $678fa78e22f406a1$export$2e8ce08d3f6f5e10,
            format: $678fa78e22f406a1$export$7f419e36e2229a1d,
            encoding: $678fa78e22f406a1$var$_isLDR(texture) ? texture.encoding : $678fa78e22f406a1$export$3be4c466a12b5dcf,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $678fa78e22f406a1$var$_createRenderTarget(params);
        cubeUVRenderTarget.depthBuffer = texture ? false : true;
        this._pingPongRenderTarget = $678fa78e22f406a1$var$_createRenderTarget(params);
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $678fa78e22f406a1$export$e176487c05830cc5($678fa78e22f406a1$var$_lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $678fa78e22f406a1$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $678fa78e22f406a1$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const outputEncoding = renderer.outputEncoding;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($678fa78e22f406a1$var$_clearColor);
        renderer.toneMapping = $678fa78e22f406a1$export$9fcb6b4294603b2;
        renderer.outputEncoding = $678fa78e22f406a1$export$7207336e4151a112;
        renderer.autoClear = false;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                $678fa78e22f406a1$var$backgroundMaterial.color.copy(background).convertSRGBToLinear();
                scene.background = null;
                const alpha = $678fa78e22f406a1$var$convertLinearToRGBE($678fa78e22f406a1$var$backgroundMaterial.color);
                $678fa78e22f406a1$var$backgroundMaterial.opacity = alpha;
                useSolidColor = true;
            }
        } else {
            $678fa78e22f406a1$var$backgroundMaterial.color.copy($678fa78e22f406a1$var$_clearColor).convertSRGBToLinear();
            const alpha = $678fa78e22f406a1$var$convertLinearToRGBE($678fa78e22f406a1$var$backgroundMaterial.color);
            $678fa78e22f406a1$var$backgroundMaterial.opacity = alpha;
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col == 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col == 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            $678fa78e22f406a1$var$_setViewport(cubeUVRenderTarget, col * $678fa78e22f406a1$var$SIZE_MAX, i > 2 ? $678fa78e22f406a1$var$SIZE_MAX : 0, $678fa78e22f406a1$var$SIZE_MAX, $678fa78e22f406a1$var$SIZE_MAX);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render($678fa78e22f406a1$var$backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.outputEncoding = outputEncoding;
        renderer.autoClear = originalAutoClear;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        if (texture.isCubeTexture) {
            if (this._cubemapShader == null) this._cubemapShader = $678fa78e22f406a1$var$_getCubemapShader();
        } else if (this._equirectShader == null) this._equirectShader = $678fa78e22f406a1$var$_getEquirectShader();
        const material = texture.isCubeTexture ? this._cubemapShader : this._equirectShader;
        const mesh = new $678fa78e22f406a1$export$e176487c05830cc5($678fa78e22f406a1$var$_lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        if (!texture.isCubeTexture) uniforms['texelSize'].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
        uniforms['inputEncoding'].value = $678fa78e22f406a1$var$ENCODINGS[texture.encoding];
        uniforms['outputEncoding'].value = $678fa78e22f406a1$var$ENCODINGS[cubeUVRenderTarget.texture.encoding];
        $678fa78e22f406a1$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * $678fa78e22f406a1$var$SIZE_MAX, 2 * $678fa78e22f406a1$var$SIZE_MAX);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $678fa78e22f406a1$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < $678fa78e22f406a1$var$TOTAL_LODS; i++){
            const sigma = Math.sqrt($678fa78e22f406a1$var$_sigmas[i] * $678fa78e22f406a1$var$_sigmas[i] - $678fa78e22f406a1$var$_sigmas[i - 1] * $678fa78e22f406a1$var$_sigmas[i - 1]);
            const poleAxis = $678fa78e22f406a1$var$_axisDirections[(i - 1) % $678fa78e22f406a1$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $678fa78e22f406a1$export$e176487c05830cc5($678fa78e22f406a1$var$_lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = $678fa78e22f406a1$var$_sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $678fa78e22f406a1$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $678fa78e22f406a1$var$MAX_SAMPLES;
        if (samples > $678fa78e22f406a1$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$678fa78e22f406a1$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $678fa78e22f406a1$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i == 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = $678fa78e22f406a1$var$LOD_MAX - lodIn;
        blurUniforms['inputEncoding'].value = $678fa78e22f406a1$var$ENCODINGS[targetIn.texture.encoding];
        blurUniforms['outputEncoding'].value = $678fa78e22f406a1$var$ENCODINGS[targetIn.texture.encoding];
        const outputSize = $678fa78e22f406a1$var$_sizeLods[lodOut];
        const x = 3 * Math.max(0, $678fa78e22f406a1$var$SIZE_MAX - 2 * outputSize);
        const y = (lodOut === 0 ? 0 : 2 * $678fa78e22f406a1$var$SIZE_MAX) + 2 * outputSize * (lodOut > $678fa78e22f406a1$var$LOD_MAX - $678fa78e22f406a1$var$LOD_MIN ? lodOut - $678fa78e22f406a1$var$LOD_MAX + $678fa78e22f406a1$var$LOD_MIN : 0);
        $678fa78e22f406a1$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $678fa78e22f406a1$var$_flatCamera);
    }
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = $678fa78e22f406a1$var$_getBlurShader($678fa78e22f406a1$var$MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
}
function $678fa78e22f406a1$var$_isLDR(texture) {
    if (texture === undefined || texture.type !== $678fa78e22f406a1$export$2e8ce08d3f6f5e10) return false;
    return texture.encoding === $678fa78e22f406a1$export$7207336e4151a112 || texture.encoding === $678fa78e22f406a1$export$f32388edbb32674 || texture.encoding === $678fa78e22f406a1$export$eaab32c1bcea1817;
}
function $678fa78e22f406a1$var$_createPlanes() {
    const _lodPlanes = [];
    const _sizeLods = [];
    const _sigmas = [];
    let lod = $678fa78e22f406a1$var$LOD_MAX;
    for(let i = 0; i < $678fa78e22f406a1$var$TOTAL_LODS; i++){
        const sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > $678fa78e22f406a1$var$LOD_MAX - $678fa78e22f406a1$var$LOD_MIN) sigma = $678fa78e22f406a1$var$EXTRA_LOD_SIGMA[i - $678fa78e22f406a1$var$LOD_MAX + $678fa78e22f406a1$var$LOD_MIN - 1];
        else if (i == 0) sigma = 0;
        _sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 1);
        const min = -texelSize / 2;
        const max = 1 + texelSize / 2;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $678fa78e22f406a1$export$b7be63a67df8959();
        planes.setAttribute('position', new $678fa78e22f406a1$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $678fa78e22f406a1$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $678fa78e22f406a1$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > $678fa78e22f406a1$var$LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function $678fa78e22f406a1$var$_createRenderTarget(params) {
    const cubeUVRenderTarget = new $678fa78e22f406a1$export$3c052beb2e51e23f(3 * $678fa78e22f406a1$var$SIZE_MAX, 3 * $678fa78e22f406a1$var$SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = $678fa78e22f406a1$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $678fa78e22f406a1$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $678fa78e22f406a1$var$_getBlurShader(maxSamples) {
    const weights = new Float32Array(maxSamples);
    const poleAxis = new $678fa78e22f406a1$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $678fa78e22f406a1$export$21c421a2e1df9d22({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': maxSamples
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            },
            'inputEncoding': {
                value: $678fa78e22f406a1$var$ENCODINGS[$678fa78e22f406a1$export$7207336e4151a112]
            },
            'outputEncoding': {
                value: $678fa78e22f406a1$var$ENCODINGS[$678fa78e22f406a1$export$7207336e4151a112]
            }
        },
        vertexShader: $678fa78e22f406a1$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			${$678fa78e22f406a1$var$_getEncodings()}

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: $678fa78e22f406a1$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $678fa78e22f406a1$var$_getEquirectShader() {
    const texelSize = new $678fa78e22f406a1$export$c977b3e384af9ae1(1, 1);
    const shaderMaterial = new $678fa78e22f406a1$export$21c421a2e1df9d22({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'texelSize': {
                value: texelSize
            },
            'inputEncoding': {
                value: $678fa78e22f406a1$var$ENCODINGS[$678fa78e22f406a1$export$7207336e4151a112]
            },
            'outputEncoding': {
                value: $678fa78e22f406a1$var$ENCODINGS[$678fa78e22f406a1$export$7207336e4151a112]
            }
        },
        vertexShader: $678fa78e22f406a1$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			${$678fa78e22f406a1$var$_getEncodings()}

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x += texelSize.x;
				vec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.y += texelSize.y;
				vec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: $678fa78e22f406a1$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $678fa78e22f406a1$var$_getCubemapShader() {
    const shaderMaterial = new $678fa78e22f406a1$export$21c421a2e1df9d22({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'inputEncoding': {
                value: $678fa78e22f406a1$var$ENCODINGS[$678fa78e22f406a1$export$7207336e4151a112]
            },
            'outputEncoding': {
                value: $678fa78e22f406a1$var$ENCODINGS[$678fa78e22f406a1$export$7207336e4151a112]
            }
        },
        vertexShader: $678fa78e22f406a1$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			${$678fa78e22f406a1$var$_getEncodings()}

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;
				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: $678fa78e22f406a1$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $678fa78e22f406a1$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $678fa78e22f406a1$var$_getEncodings() {
    return /* glsl */ `

		uniform int inputEncoding;
		uniform int outputEncoding;

		#include <encodings_pars_fragment>

		vec4 inputTexelToLinear( vec4 value ) {

			if ( inputEncoding == 0 ) {

				return value;

			} else if ( inputEncoding == 1 ) {

				return sRGBToLinear( value );

			} else if ( inputEncoding == 2 ) {

				return RGBEToLinear( value );

			} else if ( inputEncoding == 3 ) {

				return RGBMToLinear( value, 7.0 );

			} else if ( inputEncoding == 4 ) {

				return RGBMToLinear( value, 16.0 );

			} else if ( inputEncoding == 5 ) {

				return RGBDToLinear( value, 256.0 );

			} else {

				return GammaToLinear( value, 2.2 );

			}

		}

		vec4 linearToOutputTexel( vec4 value ) {

			if ( outputEncoding == 0 ) {

				return value;

			} else if ( outputEncoding == 1 ) {

				return LinearTosRGB( value );

			} else if ( outputEncoding == 2 ) {

				return LinearToRGBE( value );

			} else if ( outputEncoding == 3 ) {

				return LinearToRGBM( value, 7.0 );

			} else if ( outputEncoding == 4 ) {

				return LinearToRGBM( value, 16.0 );

			} else if ( outputEncoding == 5 ) {

				return LinearToRGBD( value, 256.0 );

			} else {

				return LinearToGamma( value, 2.2 );

			}

		}

		vec4 envMapTexelToLinear( vec4 color ) {

			return inputTexelToLinear( color );

		}
	`;
}
const $678fa78e22f406a1$export$195910b613d3dbcb = 0;
const $678fa78e22f406a1$export$c8a71586e494fb81 = 1;
const $678fa78e22f406a1$export$1a5c46edbdc9a5b7 = 0;
const $678fa78e22f406a1$export$617e978cc3201d85 = 1;
const $678fa78e22f406a1$export$969ede3d37172881 = 2;
function $678fa78e22f406a1$export$8f0d8c869214e38a(materials) {
    console.warn('THREE.MeshFaceMaterial has been removed. Use an Array instead.');
    return materials;
}
function $678fa78e22f406a1$export$4f1842f7cdf61f78(materials = []) {
    console.warn('THREE.MultiMaterial has been removed. Use an Array instead.');
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function $678fa78e22f406a1$export$5c812f854e08d33d(geometry, material) {
    console.warn('THREE.PointCloud has been renamed to THREE.Points.');
    return new $678fa78e22f406a1$export$1c787534cb11aa3e(geometry, material);
}
function $678fa78e22f406a1$export$c36c68baa13912a5(material) {
    console.warn('THREE.Particle has been renamed to THREE.Sprite.');
    return new $678fa78e22f406a1$export$3075603db8e6204c(material);
}
function $678fa78e22f406a1$export$f219b6a0e4bb0b6d(geometry, material) {
    console.warn('THREE.ParticleSystem has been renamed to THREE.Points.');
    return new $678fa78e22f406a1$export$1c787534cb11aa3e(geometry, material);
}
function $678fa78e22f406a1$export$29121d9ccd2f757a(parameters) {
    console.warn('THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.');
    return new $678fa78e22f406a1$export$a178c45366ce5d6b(parameters);
}
function $678fa78e22f406a1$export$ffa02580217a1c8(parameters) {
    console.warn('THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.');
    return new $678fa78e22f406a1$export$a178c45366ce5d6b(parameters);
}
function $678fa78e22f406a1$export$cb1306c614c86e6b(parameters) {
    console.warn('THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.');
    return new $678fa78e22f406a1$export$a178c45366ce5d6b(parameters);
}
function $678fa78e22f406a1$export$3e8a3cc8713efbec(x, y, z) {
    console.warn('THREE.Vertex has been removed. Use THREE.Vector3 instead.');
    return new $678fa78e22f406a1$export$64b5c384219d3699(x, y, z);
}
//
function $678fa78e22f406a1$export$189ab5ea9d161e81(array, itemSize) {
    console.warn('THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.');
    return new $678fa78e22f406a1$export$8dea267bd6bde117(array, itemSize).setUsage($678fa78e22f406a1$export$8505d14ac8546ca);
}
function $678fa78e22f406a1$export$e0ae4f0a1804ea11(array, itemSize) {
    console.warn('THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$f9ff2d6a20248cbf(array, itemSize);
}
function $678fa78e22f406a1$export$a0d192e03a5b32f5(array, itemSize) {
    console.warn('THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$cacc90cf35d11cdd(array, itemSize);
}
function $678fa78e22f406a1$export$8ca743ab36552bfa(array, itemSize) {
    console.warn('THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.');
    return new $678fa78e22f406a1$export$baaa85a1a812c157(array, itemSize);
}
function $678fa78e22f406a1$export$5d9757676aad9dab(array, itemSize) {
    console.warn('THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$2b755a102ccdcefe(array, itemSize);
}
function $678fa78e22f406a1$export$ed102ffd14092320(array, itemSize) {
    console.warn('THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$640a853f68025f2e(array, itemSize);
}
function $678fa78e22f406a1$export$6acc479034658f15(array, itemSize) {
    console.warn('THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$46b369aed2968a0a(array, itemSize);
}
function $678fa78e22f406a1$export$53474877d6e539b9(array, itemSize) {
    console.warn('THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$7eb8c9fa25cd5bd6(array, itemSize);
}
function $678fa78e22f406a1$export$377af6eadc8006c3(array, itemSize) {
    console.warn('THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$cbe7a62641830ebd(array, itemSize);
}
function $678fa78e22f406a1$export$b9212d1a67b6f081(array, itemSize) {
    console.warn('THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.');
    return new $678fa78e22f406a1$export$9e0ade74842adbb8(array, itemSize);
}
//
$678fa78e22f406a1$export$b0e83c3ef8d2db1.create = function(construct, getPoint) {
    console.log('THREE.Curve.create() has been deprecated');
    construct.prototype = Object.create($678fa78e22f406a1$export$b0e83c3ef8d2db1.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
$678fa78e22f406a1$export$4b2950bdac9b6ee9.prototype.fromPoints = function(points) {
    console.warn('THREE.Path: .fromPoints() has been renamed to .setFromPoints().');
    return this.setFromPoints(points);
};
//
function $678fa78e22f406a1$export$46c1eaab6b8d1e23(size) {
    console.warn('THREE.AxisHelper has been renamed to THREE.AxesHelper.');
    return new $678fa78e22f406a1$export$6c8303f35b8578fd(size);
}
function $678fa78e22f406a1$export$3c24c67720a2146c(object, color) {
    console.warn('THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.');
    return new $678fa78e22f406a1$export$38a664cc862a6a9d(object, color);
}
function $678fa78e22f406a1$export$e341a90264c62d4c(object, hex) {
    console.warn('THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.');
    return new $678fa78e22f406a1$export$ff1ed10fedfdd604(new $678fa78e22f406a1$export$4730b1542707547f(object.geometry), new $678fa78e22f406a1$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
$678fa78e22f406a1$export$3875d39926561055.prototype.setColors = function() {
    console.error('THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.');
};
$678fa78e22f406a1$export$5277df3c9e732259.prototype.update = function() {
    console.error('THREE.SkeletonHelper: update() no longer needs to be called.');
};
function $678fa78e22f406a1$export$72d033539c529f13(object, hex) {
    console.warn('THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.');
    return new $678fa78e22f406a1$export$ff1ed10fedfdd604(new $678fa78e22f406a1$export$4b739da06d24892b(object.geometry), new $678fa78e22f406a1$export$fbaaa33907730a0c({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
$678fa78e22f406a1$export$3b0d6d7590275603.prototype.extractUrlBase = function(url) {
    console.warn('THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.');
    return $678fa78e22f406a1$export$b5d2dc08d867e41a.extractUrlBase(url);
};
$678fa78e22f406a1$export$3b0d6d7590275603.Handlers = {
    add: function() {
        console.error('THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.');
    },
    get: function() {
        console.error('THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.');
    }
};
function $678fa78e22f406a1$export$c8b77178c5db4e0d(manager) {
    console.warn('THREE.XHRLoader has been renamed to THREE.FileLoader.');
    return new $678fa78e22f406a1$export$98435a25b5cf7b2b(manager);
}
function $678fa78e22f406a1$export$58c7c1107fc658f9(manager) {
    console.warn('THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.');
    return new $678fa78e22f406a1$export$792d8a18f2c55855(manager);
}
//
$678fa78e22f406a1$export$60f553fa130f08b0.prototype.center = function(optionalTarget) {
    console.warn('THREE.Box2: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
$678fa78e22f406a1$export$60f553fa130f08b0.prototype.empty = function() {
    console.warn('THREE.Box2: .empty() has been renamed to .isEmpty().');
    return this.isEmpty();
};
$678fa78e22f406a1$export$60f553fa130f08b0.prototype.isIntersectionBox = function(box) {
    console.warn('THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().');
    return this.intersectsBox(box);
};
$678fa78e22f406a1$export$60f553fa130f08b0.prototype.size = function(optionalTarget) {
    console.warn('THREE.Box2: .size() has been renamed to .getSize().');
    return this.getSize(optionalTarget);
};
//
$678fa78e22f406a1$export$6f7d5a9418ab2aa3.prototype.center = function(optionalTarget) {
    console.warn('THREE.Box3: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
$678fa78e22f406a1$export$6f7d5a9418ab2aa3.prototype.empty = function() {
    console.warn('THREE.Box3: .empty() has been renamed to .isEmpty().');
    return this.isEmpty();
};
$678fa78e22f406a1$export$6f7d5a9418ab2aa3.prototype.isIntersectionBox = function(box) {
    console.warn('THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().');
    return this.intersectsBox(box);
};
$678fa78e22f406a1$export$6f7d5a9418ab2aa3.prototype.isIntersectionSphere = function(sphere) {
    console.warn('THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().');
    return this.intersectsSphere(sphere);
};
$678fa78e22f406a1$export$6f7d5a9418ab2aa3.prototype.size = function(optionalTarget) {
    console.warn('THREE.Box3: .size() has been renamed to .getSize().');
    return this.getSize(optionalTarget);
};
//
$678fa78e22f406a1$export$805e8b72413ccaba.prototype.empty = function() {
    console.warn('THREE.Sphere: .empty() has been renamed to .isEmpty().');
    return this.isEmpty();
};
//
$678fa78e22f406a1$export$35efe6f4c85463d2.prototype.setFromMatrix = function(m) {
    console.warn('THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().');
    return this.setFromProjectionMatrix(m);
};
//
$678fa78e22f406a1$export$e0ba6359f1954fd3.prototype.center = function(optionalTarget) {
    console.warn('THREE.Line3: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
//
$678fa78e22f406a1$export$8ff26dafa08918.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn('THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
    return this.toArray(array, offset);
};
$678fa78e22f406a1$export$8ff26dafa08918.prototype.multiplyVector3 = function(vector) {
    console.warn('THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.');
    return vector.applyMatrix3(this);
};
$678fa78e22f406a1$export$8ff26dafa08918.prototype.multiplyVector3Array = function() {
    console.error('THREE.Matrix3: .multiplyVector3Array() has been removed.');
};
$678fa78e22f406a1$export$8ff26dafa08918.prototype.applyToBufferAttribute = function(attribute) {
    console.warn('THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.');
    return attribute.applyMatrix3(this);
};
$678fa78e22f406a1$export$8ff26dafa08918.prototype.applyToVector3Array = function() {
    console.error('THREE.Matrix3: .applyToVector3Array() has been removed.');
};
$678fa78e22f406a1$export$8ff26dafa08918.prototype.getInverse = function(matrix) {
    console.warn('THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
    return this.copy(matrix).invert();
};
//
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.extractPosition = function(m) {
    console.warn('THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().');
    return this.copyPosition(m);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.flattenToArrayOffset = function(array, offset) {
    console.warn('THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
    return this.toArray(array, offset);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.getPosition = function() {
    console.warn('THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.');
    return new $678fa78e22f406a1$export$64b5c384219d3699().setFromMatrixColumn(this, 3);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.setRotationFromQuaternion = function(q) {
    console.warn('THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().');
    return this.makeRotationFromQuaternion(q);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.multiplyToArray = function() {
    console.warn('THREE.Matrix4: .multiplyToArray() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.multiplyVector3 = function(vector) {
    console.warn('THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.multiplyVector4 = function(vector) {
    console.warn('THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.multiplyVector3Array = function() {
    console.error('THREE.Matrix4: .multiplyVector3Array() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.rotateAxis = function(v) {
    console.warn('THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.');
    v.transformDirection(this);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.crossVector = function(vector) {
    console.warn('THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.');
    return vector.applyMatrix4(this);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.translate = function() {
    console.error('THREE.Matrix4: .translate() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.rotateX = function() {
    console.error('THREE.Matrix4: .rotateX() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.rotateY = function() {
    console.error('THREE.Matrix4: .rotateY() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.rotateZ = function() {
    console.error('THREE.Matrix4: .rotateZ() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.rotateByAxis = function() {
    console.error('THREE.Matrix4: .rotateByAxis() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.applyToBufferAttribute = function(attribute) {
    console.warn('THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.');
    return attribute.applyMatrix4(this);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.applyToVector3Array = function() {
    console.error('THREE.Matrix4: .applyToVector3Array() has been removed.');
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
    console.warn('THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.');
    return this.makePerspective(left, right, top, bottom, near, far);
};
$678fa78e22f406a1$export$2ae72fc923e5eb5.prototype.getInverse = function(matrix) {
    console.warn('THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
    return this.copy(matrix).invert();
};
//
$678fa78e22f406a1$export$7ff5ac152ef991b0.prototype.isIntersectionLine = function(line) {
    console.warn('THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().');
    return this.intersectsLine(line);
};
//
$678fa78e22f406a1$export$23d6a54f0bbc85a3.prototype.multiplyVector3 = function(vector) {
    console.warn('THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.');
    return vector.applyQuaternion(this);
};
$678fa78e22f406a1$export$23d6a54f0bbc85a3.prototype.inverse = function() {
    console.warn('THREE.Quaternion: .inverse() has been renamed to invert().');
    return this.invert();
};
//
$678fa78e22f406a1$export$a186db52eed6d40e.prototype.isIntersectionBox = function(box) {
    console.warn('THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().');
    return this.intersectsBox(box);
};
$678fa78e22f406a1$export$a186db52eed6d40e.prototype.isIntersectionPlane = function(plane) {
    console.warn('THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().');
    return this.intersectsPlane(plane);
};
$678fa78e22f406a1$export$a186db52eed6d40e.prototype.isIntersectionSphere = function(sphere) {
    console.warn('THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().');
    return this.intersectsSphere(sphere);
};
//
$678fa78e22f406a1$export$5a465592bfe74b48.prototype.area = function() {
    console.warn('THREE.Triangle: .area() has been renamed to .getArea().');
    return this.getArea();
};
$678fa78e22f406a1$export$5a465592bfe74b48.prototype.barycoordFromPoint = function(point, target) {
    console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
    return this.getBarycoord(point, target);
};
$678fa78e22f406a1$export$5a465592bfe74b48.prototype.midpoint = function(target) {
    console.warn('THREE.Triangle: .midpoint() has been renamed to .getMidpoint().');
    return this.getMidpoint(target);
};
$678fa78e22f406a1$export$5a465592bfe74b48.prototypenormal = function(target) {
    console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
    return this.getNormal(target);
};
$678fa78e22f406a1$export$5a465592bfe74b48.prototype.plane = function(target) {
    console.warn('THREE.Triangle: .plane() has been renamed to .getPlane().');
    return this.getPlane(target);
};
$678fa78e22f406a1$export$5a465592bfe74b48.barycoordFromPoint = function(point, a, b, c, target) {
    console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
    return $678fa78e22f406a1$export$5a465592bfe74b48.getBarycoord(point, a, b, c, target);
};
$678fa78e22f406a1$export$5a465592bfe74b48.normal = function(a, b, c, target) {
    console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
    return $678fa78e22f406a1$export$5a465592bfe74b48.getNormal(a, b, c, target);
};
//
$678fa78e22f406a1$export$6428a7f2611ef1fa.prototype.extractAllPoints = function(divisions) {
    console.warn('THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.');
    return this.extractPoints(divisions);
};
$678fa78e22f406a1$export$6428a7f2611ef1fa.prototype.extrude = function(options) {
    console.warn('THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.');
    return new $678fa78e22f406a1$export$91836d01b9f75a58(this, options);
};
$678fa78e22f406a1$export$6428a7f2611ef1fa.prototype.makeGeometry = function(options) {
    console.warn('THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.');
    return new $678fa78e22f406a1$export$233afc324766bed8(this, options);
};
//
$678fa78e22f406a1$export$c977b3e384af9ae1.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn('THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().');
    return this.fromBufferAttribute(attribute, index, offset);
};
$678fa78e22f406a1$export$c977b3e384af9ae1.prototype.distanceToManhattan = function(v) {
    console.warn('THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
    return this.manhattanDistanceTo(v);
};
$678fa78e22f406a1$export$c977b3e384af9ae1.prototype.lengthManhattan = function() {
    console.warn('THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().');
    return this.manhattanLength();
};
//
$678fa78e22f406a1$export$64b5c384219d3699.prototype.setEulerFromRotationMatrix = function() {
    console.error('THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.');
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.setEulerFromQuaternion = function() {
    console.error('THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.');
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.getPositionFromMatrix = function(m) {
    console.warn('THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().');
    return this.setFromMatrixPosition(m);
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.getScaleFromMatrix = function(m) {
    console.warn('THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().');
    return this.setFromMatrixScale(m);
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.getColumnFromMatrix = function(index, matrix) {
    console.warn('THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().');
    return this.setFromMatrixColumn(matrix, index);
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.applyProjection = function(m) {
    console.warn('THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.');
    return this.applyMatrix4(m);
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn('THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().');
    return this.fromBufferAttribute(attribute, index, offset);
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.distanceToManhattan = function(v) {
    console.warn('THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
    return this.manhattanDistanceTo(v);
};
$678fa78e22f406a1$export$64b5c384219d3699.prototype.lengthManhattan = function() {
    console.warn('THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().');
    return this.manhattanLength();
};
//
$678fa78e22f406a1$export$fa7daccca11cdbe3.prototype.fromAttribute = function(attribute, index, offset) {
    console.warn('THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().');
    return this.fromBufferAttribute(attribute, index, offset);
};
$678fa78e22f406a1$export$fa7daccca11cdbe3.prototype.lengthManhattan = function() {
    console.warn('THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().');
    return this.manhattanLength();
};
//
$678fa78e22f406a1$export$e4dd07dff30cc924.prototype.getChildByName = function(name) {
    console.warn('THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().');
    return this.getObjectByName(name);
};
$678fa78e22f406a1$export$e4dd07dff30cc924.prototype.renderDepth = function() {
    console.warn('THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.');
};
$678fa78e22f406a1$export$e4dd07dff30cc924.prototype.translate = function(distance, axis) {
    console.warn('THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.');
    return this.translateOnAxis(axis, distance);
};
$678fa78e22f406a1$export$e4dd07dff30cc924.prototype.getWorldRotation = function() {
    console.error('THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.');
};
$678fa78e22f406a1$export$e4dd07dff30cc924.prototype.applyMatrix = function(matrix) {
    console.warn('THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().');
    return this.applyMatrix4(matrix);
};
Object.defineProperties($678fa78e22f406a1$export$e4dd07dff30cc924.prototype, {
    eulerOrder: {
        get: function() {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            return this.rotation.order;
        },
        set: function(value) {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        },
        set: function() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        }
    }
});
$678fa78e22f406a1$export$e176487c05830cc5.prototype.setDrawMode = function() {
    console.error('THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
};
Object.defineProperties($678fa78e22f406a1$export$e176487c05830cc5.prototype, {
    drawMode: {
        get: function() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.');
            return $678fa78e22f406a1$export$4c28c87c2dc84758;
        },
        set: function() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
        }
    }
});
$678fa78e22f406a1$export$b303577035157ecf.prototype.initBones = function() {
    console.error('THREE.SkinnedMesh: initBones() has been removed.');
};
//
$678fa78e22f406a1$export$74e4ae24825f68d7.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties($678fa78e22f406a1$export$6ecadb6ed240d696.prototype, {
    onlyShadow: {
        set: function() {
            console.warn('THREE.Light: .onlyShadow has been removed.');
        }
    },
    shadowCameraFov: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraFov is now .shadow.camera.fov.');
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraLeft is now .shadow.camera.left.');
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraRight is now .shadow.camera.right.');
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraTop is now .shadow.camera.top.');
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.');
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraNear is now .shadow.camera.near.');
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraFar is now .shadow.camera.far.');
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn('THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.');
        }
    },
    shadowBias: {
        set: function(value) {
            console.warn('THREE.Light: .shadowBias is now .shadow.bias.');
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn('THREE.Light: .shadowDarkness has been removed.');
        }
    },
    shadowMapWidth: {
        set: function(value) {
            console.warn('THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.');
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function(value) {
            console.warn('THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.');
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties($678fa78e22f406a1$export$8dea267bd6bde117.prototype, {
    length: {
        get: function() {
            console.warn('THREE.BufferAttribute: .length has been deprecated. Use .count instead.');
            return this.array.length;
        }
    },
    dynamic: {
        get: function() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            return this.usage === $678fa78e22f406a1$export$8505d14ac8546ca;
        },
        set: function() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            this.setUsage($678fa78e22f406a1$export$8505d14ac8546ca);
        }
    }
});
$678fa78e22f406a1$export$8dea267bd6bde117.prototype.setDynamic = function(value) {
    console.warn('THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.');
    this.setUsage(value === true ? $678fa78e22f406a1$export$8505d14ac8546ca : $678fa78e22f406a1$export$763e8360f4d7f77d);
    return this;
};
$678fa78e22f406a1$export$8dea267bd6bde117.prototype.copyIndicesArray = function() {
    console.error('THREE.BufferAttribute: .copyIndicesArray() has been removed.');
}, $678fa78e22f406a1$export$8dea267bd6bde117.prototype.setArray = function() {
    console.error('THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
};
//
$678fa78e22f406a1$export$b7be63a67df8959.prototype.addIndex = function(index) {
    console.warn('THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().');
    this.setIndex(index);
};
$678fa78e22f406a1$export$b7be63a67df8959.prototype.addAttribute = function(name, attribute) {
    console.warn('THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().');
    if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
        console.warn('THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).');
        return this.setAttribute(name, new $678fa78e22f406a1$export$8dea267bd6bde117(arguments[1], arguments[2]));
    }
    if (name === 'index') {
        console.warn('THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.');
        this.setIndex(attribute);
        return this;
    }
    return this.setAttribute(name, attribute);
};
$678fa78e22f406a1$export$b7be63a67df8959.prototype.addDrawCall = function(start, count, indexOffset) {
    if (indexOffset !== undefined) console.warn('THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.');
    console.warn('THREE.BufferGeometry: .addDrawCall() is now .addGroup().');
    this.addGroup(start, count);
};
$678fa78e22f406a1$export$b7be63a67df8959.prototype.clearDrawCalls = function() {
    console.warn('THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().');
    this.clearGroups();
};
$678fa78e22f406a1$export$b7be63a67df8959.prototype.computeOffsets = function() {
    console.warn('THREE.BufferGeometry: .computeOffsets() has been removed.');
};
$678fa78e22f406a1$export$b7be63a67df8959.prototype.removeAttribute = function(name) {
    console.warn('THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().');
    return this.deleteAttribute(name);
};
$678fa78e22f406a1$export$b7be63a67df8959.prototype.applyMatrix = function(matrix) {
    console.warn('THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().');
    return this.applyMatrix4(matrix);
};
Object.defineProperties($678fa78e22f406a1$export$b7be63a67df8959.prototype, {
    drawcalls: {
        get: function() {
            console.error('THREE.BufferGeometry: .drawcalls has been renamed to .groups.');
            return this.groups;
        }
    },
    offsets: {
        get: function() {
            console.warn('THREE.BufferGeometry: .offsets has been renamed to .groups.');
            return this.groups;
        }
    }
});
$678fa78e22f406a1$export$3d5cd879f108f53f.prototype.setDynamic = function(value) {
    console.warn('THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.');
    this.setUsage(value === true ? $678fa78e22f406a1$export$8505d14ac8546ca : $678fa78e22f406a1$export$763e8360f4d7f77d);
    return this;
};
$678fa78e22f406a1$export$3d5cd879f108f53f.prototype.setArray = function() {
    console.error('THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
};
//
$678fa78e22f406a1$export$91836d01b9f75a58.prototype.getArrays = function() {
    console.error('THREE.ExtrudeGeometry: .getArrays() has been removed.');
};
$678fa78e22f406a1$export$91836d01b9f75a58.prototype.addShapeList = function() {
    console.error('THREE.ExtrudeGeometry: .addShapeList() has been removed.');
};
$678fa78e22f406a1$export$91836d01b9f75a58.prototype.addShape = function() {
    console.error('THREE.ExtrudeGeometry: .addShape() has been removed.');
};
//
$678fa78e22f406a1$export$38af1803e3442a7f.prototype.dispose = function() {
    console.error('THREE.Scene: .dispose() has been removed.');
};
//
$678fa78e22f406a1$export$2947cebfe91c02f8.prototype.onUpdate = function() {
    console.warn('THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.');
    return this;
};
//
Object.defineProperties($678fa78e22f406a1$export$a2d8b23205c25948.prototype, {
    wrapAround: {
        get: function() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        },
        set: function() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        }
    },
    overdraw: {
        get: function() {
            console.warn('THREE.Material: .overdraw has been removed.');
        },
        set: function() {
            console.warn('THREE.Material: .overdraw has been removed.');
        }
    },
    wrapRGB: {
        get: function() {
            console.warn('THREE.Material: .wrapRGB has been removed.');
            return new $678fa78e22f406a1$export$892596cec99bc70e();
        }
    },
    shading: {
        get: function() {
            console.error('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
        },
        set: function(value) {
            console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
            this.flatShading = value === $678fa78e22f406a1$export$a62047d29c96d8ff;
        }
    },
    stencilMask: {
        get: function() {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            return this.stencilFuncMask;
        },
        set: function(value) {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            this.stencilFuncMask = value;
        }
    }
});
Object.defineProperties($678fa78e22f406a1$export$83c7d75d550a8b0d.prototype, {
    derivatives: {
        get: function() {
            console.warn('THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            return this.extensions.derivatives;
        },
        set: function(value) {
            console.warn('THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            this.extensions.derivatives = value;
        }
    }
});
//
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.clearTarget = function(renderTarget, color, depth, stencil) {
    console.warn('THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.');
    this.setRenderTarget(renderTarget);
    this.clear(color, depth, stencil);
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.animate = function(callback) {
    console.warn('THREE.WebGLRenderer: .animate() is now .setAnimationLoop().');
    this.setAnimationLoop(callback);
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.getCurrentRenderTarget = function() {
    console.warn('THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().');
    return this.getRenderTarget();
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.getMaxAnisotropy = function() {
    console.warn('THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().');
    return this.capabilities.getMaxAnisotropy();
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.getPrecision = function() {
    console.warn('THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.');
    return this.capabilities.precision;
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.resetGLState = function() {
    console.warn('THREE.WebGLRenderer: .resetGLState() is now .state.reset().');
    return this.state.reset();
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsFloatTextures = function() {
    console.warn('THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).');
    return this.extensions.get('OES_texture_float');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsHalfFloatTextures = function() {
    console.warn('THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).');
    return this.extensions.get('OES_texture_half_float');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsStandardDerivatives = function() {
    console.warn('THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).');
    return this.extensions.get('OES_standard_derivatives');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsCompressedTextureS3TC = function() {
    console.warn('THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).');
    return this.extensions.get('WEBGL_compressed_texture_s3tc');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsCompressedTexturePVRTC = function() {
    console.warn('THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).');
    return this.extensions.get('WEBGL_compressed_texture_pvrtc');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsBlendMinMax = function() {
    console.warn('THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).');
    return this.extensions.get('EXT_blend_minmax');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsVertexTextures = function() {
    console.warn('THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.');
    return this.capabilities.vertexTextures;
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.supportsInstancedArrays = function() {
    console.warn('THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).');
    return this.extensions.get('ANGLE_instanced_arrays');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.enableScissorTest = function(boolean) {
    console.warn('THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().');
    this.setScissorTest(boolean);
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.initMaterial = function() {
    console.warn('THREE.WebGLRenderer: .initMaterial() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.addPrePlugin = function() {
    console.warn('THREE.WebGLRenderer: .addPrePlugin() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.addPostPlugin = function() {
    console.warn('THREE.WebGLRenderer: .addPostPlugin() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.updateShadowMap = function() {
    console.warn('THREE.WebGLRenderer: .updateShadowMap() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.setFaceCulling = function() {
    console.warn('THREE.WebGLRenderer: .setFaceCulling() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.allocTextureUnit = function() {
    console.warn('THREE.WebGLRenderer: .allocTextureUnit() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.setTexture = function() {
    console.warn('THREE.WebGLRenderer: .setTexture() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.setTexture2D = function() {
    console.warn('THREE.WebGLRenderer: .setTexture2D() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.setTextureCube = function() {
    console.warn('THREE.WebGLRenderer: .setTextureCube() has been removed.');
};
$678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype.getActiveMipMapLevel = function() {
    console.warn('THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().');
    return this.getActiveMipmapLevel();
};
Object.defineProperties($678fa78e22f406a1$export$f6cc00ef28d7cf97.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.');
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.');
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    context: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.');
            return this.getContext();
        }
    },
    vr: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .vr has been renamed to .xr');
            return this.xr;
        }
    },
    gammaInput: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
            return false;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
        }
    },
    gammaOutput: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            return false;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            this.outputEncoding = value === true ? $678fa78e22f406a1$export$f32388edbb32674 : $678fa78e22f406a1$export$7207336e4151a112;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
            return 1.0;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
        }
    }
});
Object.defineProperties($678fa78e22f406a1$var$WebGLShadowMap.prototype, {
    cullFace: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
        }
    }
});
function $678fa78e22f406a1$export$689069929abfa262(width, height, options) {
    console.warn('THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).');
    return new $678fa78e22f406a1$export$ac386671d651941e(width, options);
}
//
Object.defineProperties($678fa78e22f406a1$export$3c052beb2e51e23f.prototype, {
    wrapS: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            return this.texture.wrapS;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            return this.texture.wrapT;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            return this.texture.magFilter;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            return this.texture.minFilter;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            return this.texture.anisotropy;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            return this.texture.offset;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            return this.texture.repeat;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            this.texture.repeat = value;
        }
    },
    format: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            return this.texture.format;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            this.texture.format = value;
        }
    },
    type: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            return this.texture.type;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            return this.texture.generateMipmaps;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            this.texture.generateMipmaps = value;
        }
    }
});
//
$678fa78e22f406a1$export$153755f98d9861de.prototype.load = function(file) {
    console.warn('THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.');
    const scope = this;
    const audioLoader = new $678fa78e22f406a1$export$d8d5fccfbf47714e();
    audioLoader.load(file, function(buffer) {
        scope.setBuffer(buffer);
    });
    return this;
};
$678fa78e22f406a1$export$d47da1ef3d382827.prototype.getData = function() {
    console.warn('THREE.AudioAnalyser: .getData() is now .getFrequencyData().');
    return this.getFrequencyData();
};
//
$678fa78e22f406a1$export$d0cdd0bd804995de.prototype.updateCubeMap = function(renderer, scene) {
    console.warn('THREE.CubeCamera: .updateCubeMap() is now .update().');
    return this.update(renderer, scene);
};
$678fa78e22f406a1$export$d0cdd0bd804995de.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn('THREE.CubeCamera: .clear() is now .renderTarget.clear().');
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
$678fa78e22f406a1$export$698882cf06df44aa.crossOrigin = undefined;
$678fa78e22f406a1$export$698882cf06df44aa.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.');
    const loader = new $678fa78e22f406a1$export$fd1bfc71f64c538c();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$678fa78e22f406a1$export$698882cf06df44aa.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.');
    const loader = new $678fa78e22f406a1$export$2ec114afc2cf6308();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
$678fa78e22f406a1$export$698882cf06df44aa.loadCompressedTexture = function() {
    console.error('THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.');
};
$678fa78e22f406a1$export$698882cf06df44aa.loadCompressedTextureCube = function() {
    console.error('THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.');
};
//
function $678fa78e22f406a1$export$7adc20298958481a() {
    console.error('THREE.CanvasRenderer has been removed');
}
//
function $678fa78e22f406a1$export$8e85bca5826c4696() {
    console.error('THREE.JSONLoader has been removed.');
}
//
const $678fa78e22f406a1$export$a8351e0de8b3fd78 = {
    createMultiMaterialObject: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    detach: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    attach: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    }
};
//
function $678fa78e22f406a1$export$3f909fba4d49fe3d() {
    console.error('THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js');
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') /* eslint-disable no-undef */ __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $678fa78e22f406a1$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $678fa78e22f406a1$export$3545e07a80636437;
}

});
parcelRegister("4Z4w2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3a105cb01a993c28$export$71511d61b312f219; });

var $ejS2W = parcelRequire("ejS2W");
function $3a105cb01a993c28$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $ejS2W._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("ejS2W", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a6ccc38a7b5e0681$export$71511d61b312f219; });
function $a6ccc38a7b5e0681$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});



parcelRegister("evpiW", function(module, exports) {

$parcel$export(module.exports, "traverse", function () { return $a8f796e052001f69$export$df3f009e3d155b20; });

var $8TfIJ = parcelRequire("8TfIJ");
// A version of traverse that will stop a branch when the callback returns "true"
function $a8f796e052001f69$export$df3f009e3d155b20(obj, cb, descendants = "children") {
    let ret = cb(obj);
    if (ret || !obj[descendants]) return;
    const children = obj[descendants];
    for(let i = 0; i < children.length; i++)$a8f796e052001f69$export$df3f009e3d155b20(children[i], cb, descendants);
}
function $a8f796e052001f69$export$b1a44ceb51a89baa(scene, positions, color = null) {
    let material = new (0, $8TfIJ.PointsMaterial)({
        size: 10,
        color: color !== null ? color : 0x00ff00,
        sizeAttenuation: false,
        depthTest: false,
        depthWrite: true
    });
    // three.js dropped Geometry in r125; BufferGeometry takes the points directly.
    let geom = new (0, $8TfIJ.BufferGeometry)().setFromPoints(positions);
    var dots = new (0, $8TfIJ.Points)(geom, material);
    dots.layers.toggle(31);
    scene.add(dots);
}
function $a8f796e052001f69$export$b824647bc5763476(objects) {
    for (const o of objects){
        let color = 0xff0000;
        for (const c of [
            'x',
            'y',
            'z'
        ]){
            let dir = new (0, $8TfIJ.Vector3)();
            dir[c] = 1.0;
            let arrow = new (0, $8TfIJ.ArrowHelper)(dir, new (0, $8TfIJ.Vector3)(), 0.2, color);
            o.add(arrow);
            color = color >>> 8;
        }
    }
}
/*
 * Returns the signed difference between two angles in [-PI, PI);
 */ function $a8f796e052001f69$export$55ecdfa5f190714f(a1, a2) {
    return (a1 - a2 + 3 * Math.PI) % (2 * Math.PI) - Math.PI;
}

});

parcelRegister("4zEWR", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $idc1D = parcelRequire("idc1D");
'use strict';
function $354a31c8cce81733$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $354a31c8cce81733$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $354a31c8cce81733$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $354a31c8cce81733$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $idc1D.cwd();
                path = cwd;
            }
            $354a31c8cce81733$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $354a31c8cce81733$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $354a31c8cce81733$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $354a31c8cce81733$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $354a31c8cce81733$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $354a31c8cce81733$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $354a31c8cce81733$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $354a31c8cce81733$var$assertPath(from);
        $354a31c8cce81733$var$assertPath(to);
        if (from === to) return '';
        from = $354a31c8cce81733$var$posix.resolve(from);
        to = $354a31c8cce81733$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $354a31c8cce81733$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $354a31c8cce81733$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $354a31c8cce81733$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $354a31c8cce81733$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $354a31c8cce81733$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$354a31c8cce81733$var$posix.posix = $354a31c8cce81733$var$posix;
module.exports = $354a31c8cce81733$var$posix;

});
parcelRegister("idc1D", function(module, exports) {
// shim for using process in browser
var $d422c4dc036a3fd5$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d422c4dc036a3fd5$var$cachedSetTimeout;
var $d422c4dc036a3fd5$var$cachedClearTimeout;
function $d422c4dc036a3fd5$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d422c4dc036a3fd5$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d422c4dc036a3fd5$var$cachedSetTimeout = setTimeout;
        else $d422c4dc036a3fd5$var$cachedSetTimeout = $d422c4dc036a3fd5$var$defaultSetTimout;
    } catch (e) {
        $d422c4dc036a3fd5$var$cachedSetTimeout = $d422c4dc036a3fd5$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d422c4dc036a3fd5$var$cachedClearTimeout = clearTimeout;
        else $d422c4dc036a3fd5$var$cachedClearTimeout = $d422c4dc036a3fd5$var$defaultClearTimeout;
    } catch (e) {
        $d422c4dc036a3fd5$var$cachedClearTimeout = $d422c4dc036a3fd5$var$defaultClearTimeout;
    }
})();
function $d422c4dc036a3fd5$var$runTimeout(fun) {
    if ($d422c4dc036a3fd5$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d422c4dc036a3fd5$var$cachedSetTimeout === $d422c4dc036a3fd5$var$defaultSetTimout || !$d422c4dc036a3fd5$var$cachedSetTimeout) && setTimeout) {
        $d422c4dc036a3fd5$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d422c4dc036a3fd5$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d422c4dc036a3fd5$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d422c4dc036a3fd5$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d422c4dc036a3fd5$var$runClearTimeout(marker) {
    if ($d422c4dc036a3fd5$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d422c4dc036a3fd5$var$cachedClearTimeout === $d422c4dc036a3fd5$var$defaultClearTimeout || !$d422c4dc036a3fd5$var$cachedClearTimeout) && clearTimeout) {
        $d422c4dc036a3fd5$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d422c4dc036a3fd5$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d422c4dc036a3fd5$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d422c4dc036a3fd5$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d422c4dc036a3fd5$var$queue = [];
var $d422c4dc036a3fd5$var$draining = false;
var $d422c4dc036a3fd5$var$currentQueue;
var $d422c4dc036a3fd5$var$queueIndex = -1;
function $d422c4dc036a3fd5$var$cleanUpNextTick() {
    if (!$d422c4dc036a3fd5$var$draining || !$d422c4dc036a3fd5$var$currentQueue) return;
    $d422c4dc036a3fd5$var$draining = false;
    if ($d422c4dc036a3fd5$var$currentQueue.length) $d422c4dc036a3fd5$var$queue = $d422c4dc036a3fd5$var$currentQueue.concat($d422c4dc036a3fd5$var$queue);
    else $d422c4dc036a3fd5$var$queueIndex = -1;
    if ($d422c4dc036a3fd5$var$queue.length) $d422c4dc036a3fd5$var$drainQueue();
}
function $d422c4dc036a3fd5$var$drainQueue() {
    if ($d422c4dc036a3fd5$var$draining) return;
    var timeout = $d422c4dc036a3fd5$var$runTimeout($d422c4dc036a3fd5$var$cleanUpNextTick);
    $d422c4dc036a3fd5$var$draining = true;
    var len = $d422c4dc036a3fd5$var$queue.length;
    while(len){
        $d422c4dc036a3fd5$var$currentQueue = $d422c4dc036a3fd5$var$queue;
        $d422c4dc036a3fd5$var$queue = [];
        while(++$d422c4dc036a3fd5$var$queueIndex < len)if ($d422c4dc036a3fd5$var$currentQueue) $d422c4dc036a3fd5$var$currentQueue[$d422c4dc036a3fd5$var$queueIndex].run();
        $d422c4dc036a3fd5$var$queueIndex = -1;
        len = $d422c4dc036a3fd5$var$queue.length;
    }
    $d422c4dc036a3fd5$var$currentQueue = null;
    $d422c4dc036a3fd5$var$draining = false;
    $d422c4dc036a3fd5$var$runClearTimeout(timeout);
}
$d422c4dc036a3fd5$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d422c4dc036a3fd5$var$queue.push(new $d422c4dc036a3fd5$var$Item(fun, args));
    if ($d422c4dc036a3fd5$var$queue.length === 1 && !$d422c4dc036a3fd5$var$draining) $d422c4dc036a3fd5$var$runTimeout($d422c4dc036a3fd5$var$drainQueue);
};
// v8 likes predictible objects
function $d422c4dc036a3fd5$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d422c4dc036a3fd5$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d422c4dc036a3fd5$var$process.title = 'browser';
$d422c4dc036a3fd5$var$process.browser = true;
$d422c4dc036a3fd5$var$process.env = {};
$d422c4dc036a3fd5$var$process.argv = [];
$d422c4dc036a3fd5$var$process.version = ''; // empty string to avoid regexp issues
$d422c4dc036a3fd5$var$process.versions = {};
function $d422c4dc036a3fd5$var$noop() {}
$d422c4dc036a3fd5$var$process.on = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.addListener = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.once = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.off = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.removeListener = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.removeAllListeners = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.emit = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.prependListener = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.prependOnceListener = $d422c4dc036a3fd5$var$noop;
$d422c4dc036a3fd5$var$process.listeners = function(name) {
    return [];
};
$d422c4dc036a3fd5$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d422c4dc036a3fd5$var$process.cwd = function() {
    return '/';
};
$d422c4dc036a3fd5$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d422c4dc036a3fd5$var$process.umask = function() {
    return 0;
};

});




parcelRegister("jIL9O", function(module, exports) {

var $4cLJb = parcelRequire("4cLJb");

var $irThb = parcelRequire("irThb");
class $e5b6b4d83af12703$var$Niryo extends (0, $4cLJb.default) {
    constructor(){
        super("Niryo", "niryo_robot_description", "urdf/ned/niryo_ned_gripper.urdf.xacro");
        this.robotRoot = "base_link";
        this.handRoot = "tool_link";
        this.modelScale = 20;
        this.defaultPose = {
            joint_1: 0,
            joint_2: 0.32,
            joint_3: -0.68,
            joint_4: 0,
            joint_5: -0.73,
            joint_6: -0.01
        };
        this.tcp.parent = 'hand_link';
        this.tcp.position = [
            0,
            0,
            0.08
        ];
        this.ikEnabled = [
            "joint_1",
            "joint_2",
            "joint_3",
            // "joint_4",
            "joint_5"
        ];
        this.generator = (0, $irThb.default);
    }
}
module.exports = new $e5b6b4d83af12703$var$Niryo();

});
parcelRegister("irThb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6e5a052fa2993c4$export$2e2bcd8739ae039; });
parcelRequire("4jupP");

var $kFmW2 = parcelRequire("kFmW2");

var $3z8rE = parcelRequire("3z8rE");

var $gxi2A = parcelRequire("gxi2A");
// Version 2 uses slightly different imports and init. Also some commands 
// are named differently.
/*
	from niryo_one_python_api.niryo_one_api import *
	import rospy
	rospy.init_node('niryo_one_run_python_api_code')

	n = NiryoOne()
*/ const $d6e5a052fa2993c4$var$NiryoGenerator_v3 = $kFmW2.Python;
var $d6e5a052fa2993c4$export$2e2bcd8739ae039 = $d6e5a052fa2993c4$var$NiryoGenerator_v3;
$d6e5a052fa2993c4$var$NiryoGenerator_v3.finish_orig = $d6e5a052fa2993c4$var$NiryoGenerator_v3.finish;
$d6e5a052fa2993c4$var$NiryoGenerator_v3.finish = function(code) {
    const n = $d6e5a052fa2993c4$var$NiryoGenerator_v3;
    n.definitions_["import_niryo_roswrapper"] = "from niryo_robot_python_ros_wrapper.ros_wrapper import *";
    n.definitions_["import_sys"] = "import sys";
    n.definitions_["import_rospy"] = "import rospy";
    n.definitions_["niryo_init"] = "rospy.init_node('rocksi_niryo_code')\nn = NiryoRosWrapper()\nn.calibrate_auto()\n";
    code = "try:\n" + n.prefixLines(code, n.INDENT) + '\n' + "except NiryoRosWrapperException as e:\n" + n.prefixLines("sys.stderr.write(str(e))", n.INDENT);
    return n.finish_orig(code);
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3.FILE_EXTENSION = '.py';
$d6e5a052fa2993c4$var$NiryoGenerator_v3.MAX_MOVE_SPEED = 100;
$d6e5a052fa2993c4$var$NiryoGenerator_v3.MAX_GRIPPER_SPEED = 1000;
$d6e5a052fa2993c4$var$NiryoGenerator_v3.GRIPPER_SPEED = 100;
var $d6e5a052fa2993c4$var$simulation = null;
(0, $3z8rE.default).getInstance().then((sim)=>$d6e5a052fa2993c4$var$simulation = sim);
function $d6e5a052fa2993c4$var$export_impossible(block_name) {
    let msg = block_name + ' cannot be translated for Niryo. So sorry ._.\n';
    $gxi2A.popWarning(msg);
    return "# " + msg;
}
/* ==============
 * BLOCKS TO CODE
 * ============== */ // Movement
$d6e5a052fa2993c4$var$NiryoGenerator_v3["move"] = function(block) {
    let pose = $kFmW2.JavaScript.valueToCode(block, 'POSE', $kFmW2.JavaScript.ORDER_COMMA) || 0;
    let poseType = block.getInputTargetBlock('POSE').outputConnection.getCheck()[0];
    switch(poseType){
        case 'JointspacePose':
            return 'n.move_joints(*' + pose + ')\n';
        case 'TaskspacePose':
            return 'n.move_pose(*' + pose + ')\n';
        default:
            throw new Error('Invalid move argument \'' + poseType + '\'');
    }
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["default_pose"] = function(block) {
    let ret1 = '[' + block.defaultPose.toString() + ']';
    return [
        ret1,
        $kFmW2.NiryoGenerator_v3.ORDER_COLLECTION
    ];
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["joint_space_pose"] = function(block) {
    let pose = [];
    for(let i = 1; i < 8; i++)pose.push(block.getFieldValue('JOINT_' + i));
    let code = '[' + ret.toString() + ']';
    return [
        code,
        $kFmW2.NiryoGenerator_v3.ORDER_COLLECTION
    ];
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["task_space_pose"] = function(block) {
    let pose = [];
    for (const key of [
        'X',
        'Y',
        'Z',
        'ROLL',
        'PITCH',
        'YAW'
    ])pose.push(block.getFieldValue(key));
    let code = '[' + pose.toString() + ']';
    return [
        code,
        $kFmW2.NiryoGenerator_v3.ORDER_COLLECTION
    ];
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["joint_absolute"] = function(block) {
    let joint = block.getFieldValue('JOINT');
    let deg = block.getFieldValue('DEGREES');
    let rad = deg / 180 * Math.PI;
    let code = "pose = n.get_joints()\npose[" + (joint - 1) + "] = " + rad + '\n' + "n.move_joints(*pose)\n";
    return code;
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["joint_relative"] = function(block) {
    let joint = block.getFieldValue('JOINT');
    let deg = block.getFieldValue('DEGREES');
    let rad = deg / 180 * Math.PI;
    let code = "pose = n.get_joints()\npose[" + (joint - 1) + "] += " + rad + '\n' + "n.move_joints(*pose)\n";
    return code;
};
// Objects
$d6e5a052fa2993c4$var$NiryoGenerator_v3["gripper_open"] = function(block) {
    let code = 'n.open_gripper(' + $d6e5a052fa2993c4$var$NiryoGenerator_v3.GRIPPER_SPEED + ')\n';
    return code;
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["gripper_close"] = function(block) {
    let code = 'n.close_gripper(' + $d6e5a052fa2993c4$var$NiryoGenerator_v3.GRIPPER_SPEED + ')\n';
    return code;
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["add_sim_object"] = function(block) {
    return $d6e5a052fa2993c4$var$export_impossible("add_sim_object");
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["physics_done"] = function(block) {
    return $d6e5a052fa2993c4$var$export_impossible("physics_done");
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["is_attached"] = function(block) {
    return $d6e5a052fa2993c4$var$export_impossible("is_attached");
};
// Logic
// Standard blocks, handled by Blockly.Python
// Extras
$d6e5a052fa2993c4$var$NiryoGenerator_v3["comment"] = function(block) {
    return "# " + block.getFieldValue('COMMENT') + '\n';
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["wait"] = function(block) {
    let seconds = block.getFieldValue('SECONDS');
    return "n.wait(" + seconds + ")\n";
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["set_speed"] = function(block) {
    let motion = block.getFieldValue('MOTION_TYPE');
    let speed = block.getFieldValue('SPEED') / 100;
    switch(motion){
        case 'move':
            // Set directly on the robot
            let v = (speed * $d6e5a052fa2993c4$var$NiryoGenerator_v3.MAX_MOVE_SPEED).toFixed(0);
            return 'n.set_arm_max_velocity(' + v + ')\n';
        case 'gripper':
            // Used by gripper_open/_close
            $d6e5a052fa2993c4$var$NiryoGenerator_v3.GRIPPER_SPEED = (speed * $d6e5a052fa2993c4$var$NiryoGenerator_v3.MAX_GRIPPER_SPEED).toFixed(0);
            return '# set_speed(gripper) will take effect on the next gripper movement';
        default:
            return $d6e5a052fa2993c4$var$export_impossible("set_speed(" + motion + ")");
    }
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["joint_lock"] = function(block) {
    return $d6e5a052fa2993c4$var$export_impossible("joint_lock");
};
$d6e5a052fa2993c4$var$NiryoGenerator_v3["joint_unlock"] = function(block) {
    return $d6e5a052fa2993c4$var$export_impossible("joint_unlock");
};

});
parcelRegister("4jupP", function(module, exports) {
/* eslint-disable */ 

(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './core',
        './python_compressed.js'
    ], factory);
    else module.exports = factory((parcelRequire("460Qg")), (parcelRequire("fVNWo")));
})(module.exports, function(Blockly, BlocklyPython) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Python Generator module.
 */ /* eslint-disable */ 'use strict';
    Blockly.Python = BlocklyPython;
    return BlocklyPython;
});

});
parcelRegister("fVNWo", function(module, exports) {
// Do not edit this file; automatically generated by gulp.
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './blockly_compressed.js'
    ], factory);
    else module.exports = factory((parcelRequire("6CdWE")));
})(module.exports, function(Blockly) {
    'use strict';
    Blockly.Python = new Blockly.Generator("Python");
    Blockly.Python.addReservedWords("False,None,True,and,as,assert,break,class,continue,def,del,elif,else,except,exec,finally,for,from,global,if,import,in,is,lambda,nonlocal,not,or,pass,print,raise,return,try,while,with,yield,NotImplemented,Ellipsis,__debug__,quit,exit,copyright,license,credits,ArithmeticError,AssertionError,AttributeError,BaseException,BlockingIOError,BrokenPipeError,BufferError,BytesWarning,ChildProcessError,ConnectionAbortedError,ConnectionError,ConnectionRefusedError,ConnectionResetError,DeprecationWarning,EOFError,Ellipsis,EnvironmentError,Exception,FileExistsError,FileNotFoundError,FloatingPointError,FutureWarning,GeneratorExit,IOError,ImportError,ImportWarning,IndentationError,IndexError,InterruptedError,IsADirectoryError,KeyError,KeyboardInterrupt,LookupError,MemoryError,ModuleNotFoundError,NameError,NotADirectoryError,NotImplemented,NotImplementedError,OSError,OverflowError,PendingDeprecationWarning,PermissionError,ProcessLookupError,RecursionError,ReferenceError,ResourceWarning,RuntimeError,RuntimeWarning,StandardError,StopAsyncIteration,StopIteration,SyntaxError,SyntaxWarning,SystemError,SystemExit,TabError,TimeoutError,TypeError,UnboundLocalError,UnicodeDecodeError,UnicodeEncodeError,UnicodeError,UnicodeTranslateError,UnicodeWarning,UserWarning,ValueError,Warning,ZeroDivisionError,_,__build_class__,__debug__,__doc__,__import__,__loader__,__name__,__package__,__spec__,abs,all,any,apply,ascii,basestring,bin,bool,buffer,bytearray,bytes,callable,chr,classmethod,cmp,coerce,compile,complex,copyright,credits,delattr,dict,dir,divmod,enumerate,eval,exec,execfile,exit,file,filter,float,format,frozenset,getattr,globals,hasattr,hash,help,hex,id,input,int,intern,isinstance,issubclass,iter,len,license,list,locals,long,map,max,memoryview,min,next,object,oct,open,ord,pow,print,property,quit,range,raw_input,reduce,reload,repr,reversed,round,set,setattr,slice,sorted,staticmethod,str,sum,super,tuple,type,unichr,unicode,vars,xrange,zip");
    Blockly.Python.ORDER_ATOMIC = 0;
    Blockly.Python.ORDER_COLLECTION = 1;
    Blockly.Python.ORDER_STRING_CONVERSION = 1;
    Blockly.Python.ORDER_MEMBER = 2.1;
    Blockly.Python.ORDER_FUNCTION_CALL = 2.2;
    Blockly.Python.ORDER_EXPONENTIATION = 3;
    Blockly.Python.ORDER_UNARY_SIGN = 4;
    Blockly.Python.ORDER_BITWISE_NOT = 4;
    Blockly.Python.ORDER_MULTIPLICATIVE = 5;
    Blockly.Python.ORDER_ADDITIVE = 6;
    Blockly.Python.ORDER_BITWISE_SHIFT = 7;
    Blockly.Python.ORDER_BITWISE_AND = 8;
    Blockly.Python.ORDER_BITWISE_XOR = 9;
    Blockly.Python.ORDER_BITWISE_OR = 10;
    Blockly.Python.ORDER_RELATIONAL = 11;
    Blockly.Python.ORDER_LOGICAL_NOT = 12;
    Blockly.Python.ORDER_LOGICAL_AND = 13;
    Blockly.Python.ORDER_LOGICAL_OR = 14;
    Blockly.Python.ORDER_CONDITIONAL = 15;
    Blockly.Python.ORDER_LAMBDA = 16;
    Blockly.Python.ORDER_NONE = 99;
    Blockly.Python.ORDER_OVERRIDES = [
        [
            Blockly.Python.ORDER_FUNCTION_CALL,
            Blockly.Python.ORDER_MEMBER
        ],
        [
            Blockly.Python.ORDER_FUNCTION_CALL,
            Blockly.Python.ORDER_FUNCTION_CALL
        ],
        [
            Blockly.Python.ORDER_MEMBER,
            Blockly.Python.ORDER_MEMBER
        ],
        [
            Blockly.Python.ORDER_MEMBER,
            Blockly.Python.ORDER_FUNCTION_CALL
        ],
        [
            Blockly.Python.ORDER_LOGICAL_NOT,
            Blockly.Python.ORDER_LOGICAL_NOT
        ],
        [
            Blockly.Python.ORDER_LOGICAL_AND,
            Blockly.Python.ORDER_LOGICAL_AND
        ],
        [
            Blockly.Python.ORDER_LOGICAL_OR,
            Blockly.Python.ORDER_LOGICAL_OR
        ]
    ];
    Blockly.Python.isInitialized = !1;
    Blockly.Python.init = function(a) {
        Blockly.Python.PASS = this.INDENT + "pass\n";
        Blockly.Python.definitions_ = Object.create(null);
        Blockly.Python.functionNames_ = Object.create(null);
        Blockly.Python.variableDB_ ? Blockly.Python.variableDB_.reset() : Blockly.Python.variableDB_ = new Blockly.Names(Blockly.Python.RESERVED_WORDS_);
        Blockly.Python.variableDB_.setVariableMap(a.getVariableMap());
        for(var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++)b.push(Blockly.Python.variableDB_.getName(c[d], Blockly.Names.DEVELOPER_VARIABLE_TYPE) + " = None");
        a = Blockly.Variables.allUsedVarModels(a);
        for(d = 0; d < a.length; d++)b.push(Blockly.Python.variableDB_.getName(a[d].getId(), Blockly.VARIABLE_CATEGORY_NAME) + " = None");
        Blockly.Python.definitions_.variables = b.join("\n");
        this.isInitialized = !0;
    };
    Blockly.Python.finish = function(a) {
        var b = [], c = [], d;
        for(d in Blockly.Python.definitions_){
            var e = Blockly.Python.definitions_[d];
            e.match(/^(from\s+\S+\s+)?import\s+\S+/) ? b.push(e) : c.push(e);
        }
        delete Blockly.Python.definitions_;
        delete Blockly.Python.functionNames_;
        Blockly.Python.variableDB_.reset();
        return (b.join("\n") + "\n\n" + c.join("\n\n")).replace(/\n\n+/g, "\n\n").replace(/\n*$/, "\n\n\n") + a;
    };
    Blockly.Python.scrubNakedValue = function(a) {
        return a + "\n";
    };
    Blockly.Python.quote_ = function(a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n");
        var b = "'";
        -1 !== a.indexOf("'") && (-1 === a.indexOf('"') ? b = '"' : a = a.replace(/'/g, "\\'"));
        return b + a + b;
    };
    Blockly.Python.multiline_quote_ = function(a) {
        return a.split(/\n/g).map(Blockly.Python.quote_).join(" + '\\n' + \n");
    };
    Blockly.Python.scrub_ = function(a, b, c) {
        var d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            e && (e = Blockly.utils.string.wrap(e, Blockly.Python.COMMENT_WRAP - 3), d += Blockly.Python.prefixLines(e + "\n", "# "));
            for(var f = 0; f < a.inputList.length; f++)a.inputList[f].type == Blockly.inputTypes.VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.Python.allNestedComments(e)) && (d += Blockly.Python.prefixLines(e, "# "));
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c = c ? "" : Blockly.Python.blockToCode(a);
        return d + b + c;
    };
    Blockly.Python.getAdjustedInt = function(a, b, c, d) {
        c = c || 0;
        a.workspace.options.oneBasedIndex && c--;
        var e = a.workspace.options.oneBasedIndex ? "1" : "0";
        a = Blockly.Python.valueToCode(a, b, c ? Blockly.Python.ORDER_ADDITIVE : Blockly.Python.ORDER_NONE) || e;
        Blockly.isNumber(a) ? (a = parseInt(a, 10) + c, d && (a = -a)) : (a = 0 < c ? "int(" + a + " + " + c + ")" : 0 > c ? "int(" + a + " - " + -c + ")" : "int(" + a + ")", d && (a = "-" + a));
        return a;
    };
    Blockly.Python.colour = {};
    Blockly.Python.colour_picker = function(a) {
        return [
            Blockly.Python.quote_(a.getFieldValue("COLOUR")),
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.colour_random = function(a) {
        Blockly.Python.definitions_.import_random = "import random";
        return [
            "'#%06x' % random.randint(0, 2**24 - 1)",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.colour_rgb = function(a) {
        var b = Blockly.Python.provideFunction_("colour_rgb", [
            "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(r, g, b):",
            "  r = round(min(100, max(0, r)) * 2.55)",
            "  g = round(min(100, max(0, g)) * 2.55)",
            "  b = round(min(100, max(0, b)) * 2.55)",
            "  return '#%02x%02x%02x' % (r, g, b)"
        ]), c = Blockly.Python.valueToCode(a, "RED", Blockly.Python.ORDER_NONE) || 0, d = Blockly.Python.valueToCode(a, "GREEN", Blockly.Python.ORDER_NONE) || 0;
        a = Blockly.Python.valueToCode(a, "BLUE", Blockly.Python.ORDER_NONE) || 0;
        return [
            b + "(" + c + ", " + d + ", " + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.colour_blend = function(a) {
        var b = Blockly.Python.provideFunction_("colour_blend", [
            "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(colour1, colour2, ratio):",
            "  r1, r2 = int(colour1[1:3], 16), int(colour2[1:3], 16)",
            "  g1, g2 = int(colour1[3:5], 16), int(colour2[3:5], 16)",
            "  b1, b2 = int(colour1[5:7], 16), int(colour2[5:7], 16)",
            "  ratio = min(1, max(0, ratio))",
            "  r = round(r1 * (1 - ratio) + r2 * ratio)",
            "  g = round(g1 * (1 - ratio) + g2 * ratio)",
            "  b = round(b1 * (1 - ratio) + b2 * ratio)",
            "  return '#%02x%02x%02x' % (r, g, b)"
        ]), c = Blockly.Python.valueToCode(a, "COLOUR1", Blockly.Python.ORDER_NONE) || "'#000000'", d = Blockly.Python.valueToCode(a, "COLOUR2", Blockly.Python.ORDER_NONE) || "'#000000'";
        a = Blockly.Python.valueToCode(a, "RATIO", Blockly.Python.ORDER_NONE) || 0;
        return [
            b + "(" + c + ", " + d + ", " + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.lists = {};
    Blockly.Python.lists_create_empty = function(a) {
        return [
            "[]",
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.lists_create_with = function(a) {
        for(var b = Array(a.itemCount_), c = 0; c < a.itemCount_; c++)b[c] = Blockly.Python.valueToCode(a, "ADD" + c, Blockly.Python.ORDER_NONE) || "None";
        return [
            "[" + b.join(", ") + "]",
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.lists_repeat = function(a) {
        var b = Blockly.Python.valueToCode(a, "ITEM", Blockly.Python.ORDER_NONE) || "None";
        a = Blockly.Python.valueToCode(a, "NUM", Blockly.Python.ORDER_MULTIPLICATIVE) || "0";
        return [
            "[" + b + "] * " + a,
            Blockly.Python.ORDER_MULTIPLICATIVE
        ];
    };
    Blockly.Python.lists_length = function(a) {
        return [
            "len(" + (Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "[]") + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.lists_isEmpty = function(a) {
        return [
            "not len(" + (Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "[]") + ")",
            Blockly.Python.ORDER_LOGICAL_NOT
        ];
    };
    Blockly.Python.lists_indexOf = function(a) {
        var b = Blockly.Python.valueToCode(a, "FIND", Blockly.Python.ORDER_NONE) || "[]", c = Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "''";
        if (a.workspace.options.oneBasedIndex) var d = " 0", e = " + 1", f = "";
        else d = " -1", e = "", f = " - 1";
        if ("FIRST" == a.getFieldValue("END")) return a = Blockly.Python.provideFunction_("first_index", [
            "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(my_list, elem):",
            "  try: index = my_list.index(elem)" + e,
            "  except: index =" + d,
            "  return index"
        ]), [
            a + "(" + c + ", " + b + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
        a = Blockly.Python.provideFunction_("last_index", [
            "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(my_list, elem):",
            "  try: index = len(my_list) - my_list[::-1].index(elem)" + f,
            "  except: index =" + d,
            "  return index"
        ]);
        return [
            a + "(" + c + ", " + b + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.lists_getIndex = function(a) {
        var b = a.getFieldValue("MODE") || "GET", c = a.getFieldValue("WHERE") || "FROM_START", d = Blockly.Python.valueToCode(a, "VALUE", "RANDOM" == c ? Blockly.Python.ORDER_NONE : Blockly.Python.ORDER_MEMBER) || "[]";
        switch(c){
            case "FIRST":
                if ("GET" == b) return [
                    d + "[0]",
                    Blockly.Python.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".pop(0)",
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ".pop(0)\n";
                break;
            case "LAST":
                if ("GET" == b) return [
                    d + "[-1]",
                    Blockly.Python.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".pop()",
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ".pop()\n";
                break;
            case "FROM_START":
                a = Blockly.Python.getAdjustedInt(a, "AT");
                if ("GET" == b) return [
                    d + "[" + a + "]",
                    Blockly.Python.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".pop(" + a + ")",
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ".pop(" + a + ")\n";
                break;
            case "FROM_END":
                a = Blockly.Python.getAdjustedInt(a, "AT", 1, !0);
                if ("GET" == b) return [
                    d + "[" + a + "]",
                    Blockly.Python.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".pop(" + a + ")",
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ".pop(" + a + ")\n";
                break;
            case "RANDOM":
                Blockly.Python.definitions_.import_random = "import random";
                if ("GET" == b) return [
                    "random.choice(" + d + ")",
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
                d = Blockly.Python.provideFunction_("lists_remove_random_item", [
                    "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(myList):",
                    "  x = int(random.random() * len(myList))",
                    "  return myList.pop(x)"
                ]) + "(" + d + ")";
                if ("GET_REMOVE" == b) return [
                    d,
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + "\n";
        }
        throw Error("Unhandled combination (lists_getIndex).");
    };
    Blockly.Python.lists_setIndex = function(a) {
        var b = Blockly.Python.valueToCode(a, "LIST", Blockly.Python.ORDER_MEMBER) || "[]", c = a.getFieldValue("MODE") || "GET", d = a.getFieldValue("WHERE") || "FROM_START", e = Blockly.Python.valueToCode(a, "TO", Blockly.Python.ORDER_NONE) || "None";
        switch(d){
            case "FIRST":
                if ("SET" == c) return b + "[0] = " + e + "\n";
                if ("INSERT" == c) return b + ".insert(0, " + e + ")\n";
                break;
            case "LAST":
                if ("SET" == c) return b + "[-1] = " + e + "\n";
                if ("INSERT" == c) return b + ".append(" + e + ")\n";
                break;
            case "FROM_START":
                a = Blockly.Python.getAdjustedInt(a, "AT");
                if ("SET" == c) return b + "[" + a + "] = " + e + "\n";
                if ("INSERT" == c) return b + ".insert(" + a + ", " + e + ")\n";
                break;
            case "FROM_END":
                a = Blockly.Python.getAdjustedInt(a, "AT", 1, !0);
                if ("SET" == c) return b + "[" + a + "] = " + e + "\n";
                if ("INSERT" == c) return b + ".insert(" + a + ", " + e + ")\n";
                break;
            case "RANDOM":
                Blockly.Python.definitions_.import_random = "import random";
                b.match(/^\w+$/) ? a = "" : (a = Blockly.Python.variableDB_.getDistinctName("tmp_list", Blockly.VARIABLE_CATEGORY_NAME), d = a + " = " + b + "\n", b = a, a = d);
                d = Blockly.Python.variableDB_.getDistinctName("tmp_x", Blockly.VARIABLE_CATEGORY_NAME);
                a += d + " = int(random.random() * len(" + b + "))\n";
                if ("SET" == c) return a + (b + "[" + d + "] = " + e + "\n");
                if ("INSERT" == c) return a + (b + ".insert(" + d + ", " + e + ")\n");
        }
        throw Error("Unhandled combination (lists_setIndex).");
    };
    Blockly.Python.lists_getSublist = function(a) {
        var b = Blockly.Python.valueToCode(a, "LIST", Blockly.Python.ORDER_MEMBER) || "[]", c = a.getFieldValue("WHERE1"), d = a.getFieldValue("WHERE2");
        switch(c){
            case "FROM_START":
                c = Blockly.Python.getAdjustedInt(a, "AT1");
                "0" == c && (c = "");
                break;
            case "FROM_END":
                c = Blockly.Python.getAdjustedInt(a, "AT1", 1, !0);
                break;
            case "FIRST":
                c = "";
                break;
            default:
                throw Error("Unhandled option (lists_getSublist)");
        }
        switch(d){
            case "FROM_START":
                a = Blockly.Python.getAdjustedInt(a, "AT2", 1);
                break;
            case "FROM_END":
                a = Blockly.Python.getAdjustedInt(a, "AT2", 0, !0);
                Blockly.isNumber(String(a)) ? "0" == a && (a = "") : (Blockly.Python.definitions_.import_sys = "import sys", a += " or sys.maxsize");
                break;
            case "LAST":
                a = "";
                break;
            default:
                throw Error("Unhandled option (lists_getSublist)");
        }
        return [
            b + "[" + c + " : " + a + "]",
            Blockly.Python.ORDER_MEMBER
        ];
    };
    Blockly.Python.lists_sort = function(a) {
        var b = Blockly.Python.valueToCode(a, "LIST", Blockly.Python.ORDER_NONE) || "[]", c = a.getFieldValue("TYPE");
        a = "1" === a.getFieldValue("DIRECTION") ? "False" : "True";
        return [
            Blockly.Python.provideFunction_("lists_sort", [
                "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(my_list, type, reverse):",
                "  def try_float(s):",
                "    try:",
                "      return float(s)",
                "    except:",
                "      return 0",
                "  key_funcs = {",
                '    "NUMERIC": try_float,',
                '    "TEXT": str,',
                '    "IGNORE_CASE": lambda s: str(s).lower()',
                "  }",
                "  key_func = key_funcs[type]",
                "  list_cpy = list(my_list)",
                "  return sorted(list_cpy, key=key_func, reverse=reverse)"
            ]) + "(" + b + ', "' + c + '", ' + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.lists_split = function(a) {
        var b = a.getFieldValue("MODE");
        if ("SPLIT" == b) b = Blockly.Python.valueToCode(a, "INPUT", Blockly.Python.ORDER_MEMBER) || "''", a = Blockly.Python.valueToCode(a, "DELIM", Blockly.Python.ORDER_NONE), a = b + ".split(" + a + ")";
        else if ("JOIN" == b) b = Blockly.Python.valueToCode(a, "INPUT", Blockly.Python.ORDER_NONE) || "[]", a = Blockly.Python.valueToCode(a, "DELIM", Blockly.Python.ORDER_MEMBER) || "''", a = a + ".join(" + b + ")";
        else throw Error("Unknown mode: " + b);
        return [
            a,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.lists_reverse = function(a) {
        return [
            "list(reversed(" + (Blockly.Python.valueToCode(a, "LIST", Blockly.Python.ORDER_NONE) || "[]") + "))",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.logic = {};
    Blockly.Python.controls_if = function(a) {
        var b = 0, c = "";
        Blockly.Python.STATEMENT_PREFIX && (c += Blockly.Python.injectId(Blockly.Python.STATEMENT_PREFIX, a));
        do {
            var d = Blockly.Python.valueToCode(a, "IF" + b, Blockly.Python.ORDER_NONE) || "False";
            var e = Blockly.Python.statementToCode(a, "DO" + b) || Blockly.Python.PASS;
            Blockly.Python.STATEMENT_SUFFIX && (e = Blockly.Python.prefixLines(Blockly.Python.injectId(Blockly.Python.STATEMENT_SUFFIX, a), Blockly.Python.INDENT) + e);
            c += (0 == b ? "if " : "elif ") + d + ":\n" + e;
            ++b;
        }while (a.getInput("IF" + b));
        if (a.getInput("ELSE") || Blockly.Python.STATEMENT_SUFFIX) e = Blockly.Python.statementToCode(a, "ELSE") || Blockly.Python.PASS, Blockly.Python.STATEMENT_SUFFIX && (e = Blockly.Python.prefixLines(Blockly.Python.injectId(Blockly.Python.STATEMENT_SUFFIX, a), Blockly.Python.INDENT) + e), c += "else:\n" + e;
        return c;
    };
    Blockly.Python.controls_ifelse = Blockly.Python.controls_if;
    Blockly.Python.logic_compare = function(a) {
        var b = {
            EQ: "==",
            NEQ: "!=",
            LT: "<",
            LTE: "<=",
            GT: ">",
            GTE: ">="
        }[a.getFieldValue("OP")], c = Blockly.Python.ORDER_RELATIONAL, d = Blockly.Python.valueToCode(a, "A", c) || "0";
        a = Blockly.Python.valueToCode(a, "B", c) || "0";
        return [
            d + " " + b + " " + a,
            c
        ];
    };
    Blockly.Python.logic_operation = function(a) {
        var b = "AND" == a.getFieldValue("OP") ? "and" : "or", c = "and" == b ? Blockly.Python.ORDER_LOGICAL_AND : Blockly.Python.ORDER_LOGICAL_OR, d = Blockly.Python.valueToCode(a, "A", c);
        a = Blockly.Python.valueToCode(a, "B", c);
        if (d || a) {
            var e = "and" == b ? "True" : "False";
            d || (d = e);
            a || (a = e);
        } else a = d = "False";
        return [
            d + " " + b + " " + a,
            c
        ];
    };
    Blockly.Python.logic_negate = function(a) {
        return [
            "not " + (Blockly.Python.valueToCode(a, "BOOL", Blockly.Python.ORDER_LOGICAL_NOT) || "True"),
            Blockly.Python.ORDER_LOGICAL_NOT
        ];
    };
    Blockly.Python.logic_boolean = function(a) {
        return [
            "TRUE" == a.getFieldValue("BOOL") ? "True" : "False",
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.logic_null = function(a) {
        return [
            "None",
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.logic_ternary = function(a) {
        var b = Blockly.Python.valueToCode(a, "IF", Blockly.Python.ORDER_CONDITIONAL) || "False", c = Blockly.Python.valueToCode(a, "THEN", Blockly.Python.ORDER_CONDITIONAL) || "None";
        a = Blockly.Python.valueToCode(a, "ELSE", Blockly.Python.ORDER_CONDITIONAL) || "None";
        return [
            c + " if " + b + " else " + a,
            Blockly.Python.ORDER_CONDITIONAL
        ];
    };
    Blockly.Python.loops = {};
    Blockly.Python.controls_repeat_ext = function(a) {
        var b = a.getField("TIMES") ? String(parseInt(a.getFieldValue("TIMES"), 10)) : Blockly.Python.valueToCode(a, "TIMES", Blockly.Python.ORDER_NONE) || "0";
        b = Blockly.isNumber(b) ? parseInt(b, 10) : "int(" + b + ")";
        var c = Blockly.Python.statementToCode(a, "DO");
        c = Blockly.Python.addLoopTrap(c, a) || Blockly.Python.PASS;
        return "for " + Blockly.Python.variableDB_.getDistinctName("count", Blockly.VARIABLE_CATEGORY_NAME) + " in range(" + b + "):\n" + c;
    };
    Blockly.Python.controls_repeat = Blockly.Python.controls_repeat_ext;
    Blockly.Python.controls_whileUntil = function(a) {
        var b = "UNTIL" == a.getFieldValue("MODE"), c = Blockly.Python.valueToCode(a, "BOOL", b ? Blockly.Python.ORDER_LOGICAL_NOT : Blockly.Python.ORDER_NONE) || "False", d = Blockly.Python.statementToCode(a, "DO");
        d = Blockly.Python.addLoopTrap(d, a) || Blockly.Python.PASS;
        b && (c = "not " + c);
        return "while " + c + ":\n" + d;
    };
    Blockly.Python.controls_for = function(a) {
        var b = Blockly.Python.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME), c = Blockly.Python.valueToCode(a, "FROM", Blockly.Python.ORDER_NONE) || "0", d = Blockly.Python.valueToCode(a, "TO", Blockly.Python.ORDER_NONE) || "0", e = Blockly.Python.valueToCode(a, "BY", Blockly.Python.ORDER_NONE) || "1", f = Blockly.Python.statementToCode(a, "DO");
        f = Blockly.Python.addLoopTrap(f, a) || Blockly.Python.PASS;
        var n = "", k = function() {
            return Blockly.Python.provideFunction_("upRange", [
                "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(start, stop, step):",
                "  while start <= stop:",
                "    yield start",
                "    start += abs(step)"
            ]);
        }, h = function() {
            return Blockly.Python.provideFunction_("downRange", [
                "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(start, stop, step):",
                "  while start >= stop:",
                "    yield start",
                "    start -= abs(step)"
            ]);
        };
        a = function(g, l, p) {
            return "(" + g + " <= " + l + ") and " + k() + "(" + g + ", " + l + ", " + p + ") or " + h() + "(" + g + ", " + l + ", " + p + ")";
        };
        if (Blockly.isNumber(c) && Blockly.isNumber(d) && Blockly.isNumber(e)) c = Number(c), d = Number(d), e = Math.abs(Number(e)), 0 === c % 1 && 0 === d % 1 && 0 === e % 1 ? (c <= d ? (d++, a = 0 == c && 1 == e ? d : c + ", " + d, 1 != e && (a += ", " + e)) : (d--, a = c + ", " + d + ", -" + e), a = "range(" + a + ")") : (a = c < d ? k() : h(), a += "(" + c + ", " + d + ", " + e + ")");
        else {
            var m = function(g, l) {
                Blockly.isNumber(g) ? g = Number(g) : g.match(/^\w+$/) ? g = "float(" + g + ")" : (l = Blockly.Python.variableDB_.getDistinctName(b + l, Blockly.VARIABLE_CATEGORY_NAME), n += l + " = float(" + g + ")\n", g = l);
                return g;
            };
            c = m(c, "_start");
            d = m(d, "_end");
            e = m(e, "_inc");
            "number" == typeof c && "number" == typeof d ? (a = c < d ? k() : h(), a += "(" + c + ", " + d + ", " + e + ")") : a = a(c, d, e);
        }
        return n += "for " + b + " in " + a + ":\n" + f;
    };
    Blockly.Python.controls_forEach = function(a) {
        var b = Blockly.Python.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME), c = Blockly.Python.valueToCode(a, "LIST", Blockly.Python.ORDER_RELATIONAL) || "[]", d = Blockly.Python.statementToCode(a, "DO");
        d = Blockly.Python.addLoopTrap(d, a) || Blockly.Python.PASS;
        return "for " + b + " in " + c + ":\n" + d;
    };
    Blockly.Python.controls_flow_statements = function(a) {
        var b = "";
        Blockly.Python.STATEMENT_PREFIX && (b += Blockly.Python.injectId(Blockly.Python.STATEMENT_PREFIX, a));
        Blockly.Python.STATEMENT_SUFFIX && (b += Blockly.Python.injectId(Blockly.Python.STATEMENT_SUFFIX, a));
        if (Blockly.Python.STATEMENT_PREFIX) {
            var c = Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.getSurroundLoop(a);
            c && !c.suppressPrefixSuffix && (b += Blockly.Python.injectId(Blockly.Python.STATEMENT_PREFIX, c));
        }
        switch(a.getFieldValue("FLOW")){
            case "BREAK":
                return b + "break\n";
            case "CONTINUE":
                return b + "continue\n";
        }
        throw Error("Unknown flow statement.");
    };
    Blockly.Python.math = {};
    Blockly.Python.addReservedWords("math,random,Number");
    Blockly.Python.math_number = function(a) {
        a = Number(a.getFieldValue("NUM"));
        if (Infinity == a) {
            a = 'float("inf")';
            var b = Blockly.Python.ORDER_FUNCTION_CALL;
        } else -Infinity == a ? (a = '-float("inf")', b = Blockly.Python.ORDER_UNARY_SIGN) : b = 0 > a ? Blockly.Python.ORDER_UNARY_SIGN : Blockly.Python.ORDER_ATOMIC;
        return [
            a,
            b
        ];
    };
    Blockly.Python.math_arithmetic = function(a) {
        var b = {
            ADD: [
                " + ",
                Blockly.Python.ORDER_ADDITIVE
            ],
            MINUS: [
                " - ",
                Blockly.Python.ORDER_ADDITIVE
            ],
            MULTIPLY: [
                " * ",
                Blockly.Python.ORDER_MULTIPLICATIVE
            ],
            DIVIDE: [
                " / ",
                Blockly.Python.ORDER_MULTIPLICATIVE
            ],
            POWER: [
                " ** ",
                Blockly.Python.ORDER_EXPONENTIATION
            ]
        }[a.getFieldValue("OP")], c = b[0];
        b = b[1];
        var d = Blockly.Python.valueToCode(a, "A", b) || "0";
        a = Blockly.Python.valueToCode(a, "B", b) || "0";
        return [
            d + c + a,
            b
        ];
    };
    Blockly.Python.math_single = function(a) {
        var b = a.getFieldValue("OP");
        if ("NEG" == b) {
            var c = Blockly.Python.valueToCode(a, "NUM", Blockly.Python.ORDER_UNARY_SIGN) || "0";
            return [
                "-" + c,
                Blockly.Python.ORDER_UNARY_SIGN
            ];
        }
        Blockly.Python.definitions_.import_math = "import math";
        a = "SIN" == b || "COS" == b || "TAN" == b ? Blockly.Python.valueToCode(a, "NUM", Blockly.Python.ORDER_MULTIPLICATIVE) || "0" : Blockly.Python.valueToCode(a, "NUM", Blockly.Python.ORDER_NONE) || "0";
        switch(b){
            case "ABS":
                c = "math.fabs(" + a + ")";
                break;
            case "ROOT":
                c = "math.sqrt(" + a + ")";
                break;
            case "LN":
                c = "math.log(" + a + ")";
                break;
            case "LOG10":
                c = "math.log10(" + a + ")";
                break;
            case "EXP":
                c = "math.exp(" + a + ")";
                break;
            case "POW10":
                c = "math.pow(10," + a + ")";
                break;
            case "ROUND":
                c = "round(" + a + ")";
                break;
            case "ROUNDUP":
                c = "math.ceil(" + a + ")";
                break;
            case "ROUNDDOWN":
                c = "math.floor(" + a + ")";
                break;
            case "SIN":
                c = "math.sin(" + a + " / 180.0 * math.pi)";
                break;
            case "COS":
                c = "math.cos(" + a + " / 180.0 * math.pi)";
                break;
            case "TAN":
                c = "math.tan(" + a + " / 180.0 * math.pi)";
        }
        if (c) return [
            c,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
        switch(b){
            case "ASIN":
                c = "math.asin(" + a + ") / math.pi * 180";
                break;
            case "ACOS":
                c = "math.acos(" + a + ") / math.pi * 180";
                break;
            case "ATAN":
                c = "math.atan(" + a + ") / math.pi * 180";
                break;
            default:
                throw Error("Unknown math operator: " + b);
        }
        return [
            c,
            Blockly.Python.ORDER_MULTIPLICATIVE
        ];
    };
    Blockly.Python.math_constant = function(a) {
        var b = {
            PI: [
                "math.pi",
                Blockly.Python.ORDER_MEMBER
            ],
            E: [
                "math.e",
                Blockly.Python.ORDER_MEMBER
            ],
            GOLDEN_RATIO: [
                "(1 + math.sqrt(5)) / 2",
                Blockly.Python.ORDER_MULTIPLICATIVE
            ],
            SQRT2: [
                "math.sqrt(2)",
                Blockly.Python.ORDER_MEMBER
            ],
            SQRT1_2: [
                "math.sqrt(1.0 / 2)",
                Blockly.Python.ORDER_MEMBER
            ],
            INFINITY: [
                "float('inf')",
                Blockly.Python.ORDER_ATOMIC
            ]
        };
        a = a.getFieldValue("CONSTANT");
        "INFINITY" != a && (Blockly.Python.definitions_.import_math = "import math");
        return b[a];
    };
    Blockly.Python.math_number_property = function(a) {
        var b = Blockly.Python.valueToCode(a, "NUMBER_TO_CHECK", Blockly.Python.ORDER_MULTIPLICATIVE) || "0", c = a.getFieldValue("PROPERTY");
        if ("PRIME" == c) return Blockly.Python.definitions_.import_math = "import math", Blockly.Python.definitions_.from_numbers_import_Number = "from numbers import Number", [
            Blockly.Python.provideFunction_("math_isPrime", [
                "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(n):",
                "  # https://en.wikipedia.org/wiki/Primality_test#Naive_methods",
                "  # If n is not a number but a string, try parsing it.",
                "  if not isinstance(n, Number):",
                "    try:",
                "      n = float(n)",
                "    except:",
                "      return False",
                "  if n == 2 or n == 3:",
                "    return True",
                "  # False if n is negative, is 1, or not whole, or if n is divisible by 2 or 3.",
                "  if n <= 1 or n % 1 != 0 or n % 2 == 0 or n % 3 == 0:",
                "    return False",
                "  # Check all the numbers of form 6k +/- 1, up to sqrt(n).",
                "  for x in range(6, int(math.sqrt(n)) + 2, 6):",
                "    if n % (x - 1) == 0 or n % (x + 1) == 0:",
                "      return False",
                "  return True"
            ]) + "(" + b + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
        switch(c){
            case "EVEN":
                var d = b + " % 2 == 0";
                break;
            case "ODD":
                d = b + " % 2 == 1";
                break;
            case "WHOLE":
                d = b + " % 1 == 0";
                break;
            case "POSITIVE":
                d = b + " > 0";
                break;
            case "NEGATIVE":
                d = b + " < 0";
                break;
            case "DIVISIBLE_BY":
                a = Blockly.Python.valueToCode(a, "DIVISOR", Blockly.Python.ORDER_MULTIPLICATIVE);
                if (!a || "0" == a) return [
                    "False",
                    Blockly.Python.ORDER_ATOMIC
                ];
                d = b + " % " + a + " == 0";
        }
        return [
            d,
            Blockly.Python.ORDER_RELATIONAL
        ];
    };
    Blockly.Python.math_change = function(a) {
        Blockly.Python.definitions_.from_numbers_import_Number = "from numbers import Number";
        var b = Blockly.Python.valueToCode(a, "DELTA", Blockly.Python.ORDER_ADDITIVE) || "0";
        a = Blockly.Python.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME);
        return a + " = (" + a + " if isinstance(" + a + ", Number) else 0) + " + b + "\n";
    };
    Blockly.Python.math_round = Blockly.Python.math_single;
    Blockly.Python.math_trig = Blockly.Python.math_single;
    Blockly.Python.math_on_list = function(a) {
        var b = a.getFieldValue("OP");
        a = Blockly.Python.valueToCode(a, "LIST", Blockly.Python.ORDER_NONE) || "[]";
        switch(b){
            case "SUM":
                b = "sum(" + a + ")";
                break;
            case "MIN":
                b = "min(" + a + ")";
                break;
            case "MAX":
                b = "max(" + a + ")";
                break;
            case "AVERAGE":
                Blockly.Python.definitions_.from_numbers_import_Number = "from numbers import Number";
                b = Blockly.Python.provideFunction_("math_mean", [
                    "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(myList):",
                    "  localList = [e for e in myList if isinstance(e, Number)]",
                    "  if not localList: return",
                    "  return float(sum(localList)) / len(localList)"
                ]);
                b = b + "(" + a + ")";
                break;
            case "MEDIAN":
                Blockly.Python.definitions_.from_numbers_import_Number = "from numbers import Number";
                b = Blockly.Python.provideFunction_("math_median", [
                    "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(myList):",
                    "  localList = sorted([e for e in myList if isinstance(e, Number)])",
                    "  if not localList: return",
                    "  if len(localList) % 2 == 0:",
                    "    return (localList[len(localList) // 2 - 1] + localList[len(localList) // 2]) / 2.0",
                    "  else:",
                    "    return localList[(len(localList) - 1) // 2]"
                ]);
                b = b + "(" + a + ")";
                break;
            case "MODE":
                b = Blockly.Python.provideFunction_("math_modes", [
                    "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(some_list):",
                    "  modes = []",
                    "  # Using a lists of [item, count] to keep count rather than dict",
                    '  # to avoid "unhashable" errors when the counted item is itself a list or dict.',
                    "  counts = []",
                    "  maxCount = 1",
                    "  for item in some_list:",
                    "    found = False",
                    "    for count in counts:",
                    "      if count[0] == item:",
                    "        count[1] += 1",
                    "        maxCount = max(maxCount, count[1])",
                    "        found = True",
                    "    if not found:",
                    "      counts.append([item, 1])",
                    "  for counted_item, item_count in counts:",
                    "    if item_count == maxCount:",
                    "      modes.append(counted_item)",
                    "  return modes"
                ]);
                b = b + "(" + a + ")";
                break;
            case "STD_DEV":
                Blockly.Python.definitions_.import_math = "import math";
                b = Blockly.Python.provideFunction_("math_standard_deviation", [
                    "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(numbers):",
                    "  n = len(numbers)",
                    "  if n == 0: return",
                    "  mean = float(sum(numbers)) / n",
                    "  variance = sum((x - mean) ** 2 for x in numbers) / n",
                    "  return math.sqrt(variance)"
                ]);
                b = b + "(" + a + ")";
                break;
            case "RANDOM":
                Blockly.Python.definitions_.import_random = "import random";
                b = "random.choice(" + a + ")";
                break;
            default:
                throw Error("Unknown operator: " + b);
        }
        return [
            b,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.math_modulo = function(a) {
        var b = Blockly.Python.valueToCode(a, "DIVIDEND", Blockly.Python.ORDER_MULTIPLICATIVE) || "0";
        a = Blockly.Python.valueToCode(a, "DIVISOR", Blockly.Python.ORDER_MULTIPLICATIVE) || "0";
        return [
            b + " % " + a,
            Blockly.Python.ORDER_MULTIPLICATIVE
        ];
    };
    Blockly.Python.math_constrain = function(a) {
        var b = Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "0", c = Blockly.Python.valueToCode(a, "LOW", Blockly.Python.ORDER_NONE) || "0";
        a = Blockly.Python.valueToCode(a, "HIGH", Blockly.Python.ORDER_NONE) || "float('inf')";
        return [
            "min(max(" + b + ", " + c + "), " + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.math_random_int = function(a) {
        Blockly.Python.definitions_.import_random = "import random";
        var b = Blockly.Python.valueToCode(a, "FROM", Blockly.Python.ORDER_NONE) || "0";
        a = Blockly.Python.valueToCode(a, "TO", Blockly.Python.ORDER_NONE) || "0";
        return [
            "random.randint(" + b + ", " + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.math_random_float = function(a) {
        Blockly.Python.definitions_.import_random = "import random";
        return [
            "random.random()",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.math_atan2 = function(a) {
        Blockly.Python.definitions_.import_math = "import math";
        var b = Blockly.Python.valueToCode(a, "X", Blockly.Python.ORDER_NONE) || "0";
        return [
            "math.atan2(" + (Blockly.Python.valueToCode(a, "Y", Blockly.Python.ORDER_NONE) || "0") + ", " + b + ") / math.pi * 180",
            Blockly.Python.ORDER_MULTIPLICATIVE
        ];
    };
    Blockly.Python.procedures = {};
    Blockly.Python.procedures_defreturn = function(a) {
        for(var b = [], c, d = a.workspace, e = Blockly.Variables.allUsedVarModels(d) || [], f = 0; c = e[f]; f++)c = c.name, -1 == a.getVars().indexOf(c) && b.push(Blockly.Python.variableDB_.getName(c, Blockly.VARIABLE_CATEGORY_NAME));
        e = Blockly.Variables.allDeveloperVariables(d);
        for(f = 0; f < e.length; f++)b.push(Blockly.Python.variableDB_.getName(e[f], Blockly.Names.DEVELOPER_VARIABLE_TYPE));
        b = b.length ? Blockly.Python.INDENT + "global " + b.join(", ") + "\n" : "";
        d = Blockly.Python.variableDB_.getName(a.getFieldValue("NAME"), Blockly.PROCEDURE_CATEGORY_NAME);
        c = "";
        Blockly.Python.STATEMENT_PREFIX && (c += Blockly.Python.injectId(Blockly.Python.STATEMENT_PREFIX, a));
        Blockly.Python.STATEMENT_SUFFIX && (c += Blockly.Python.injectId(Blockly.Python.STATEMENT_SUFFIX, a));
        c && (c = Blockly.Python.prefixLines(c, Blockly.Python.INDENT));
        var n = "";
        Blockly.Python.INFINITE_LOOP_TRAP && (n = Blockly.Python.prefixLines(Blockly.Python.injectId(Blockly.Python.INFINITE_LOOP_TRAP, a), Blockly.Python.INDENT));
        var k = Blockly.Python.statementToCode(a, "STACK"), h = Blockly.Python.valueToCode(a, "RETURN", Blockly.Python.ORDER_NONE) || "", m = "";
        k && h && (m = c);
        h ? h = Blockly.Python.INDENT + "return " + h + "\n" : k || (k = Blockly.Python.PASS);
        var g = [];
        e = a.getVars();
        for(f = 0; f < e.length; f++)g[f] = Blockly.Python.variableDB_.getName(e[f], Blockly.VARIABLE_CATEGORY_NAME);
        b = "def " + d + "(" + g.join(", ") + "):\n" + b + c + n + k + m + h;
        b = Blockly.Python.scrub_(a, b);
        Blockly.Python.definitions_["%" + d] = b;
        return null;
    };
    Blockly.Python.procedures_defnoreturn = Blockly.Python.procedures_defreturn;
    Blockly.Python.procedures_callreturn = function(a) {
        for(var b = Blockly.Python.variableDB_.getName(a.getFieldValue("NAME"), Blockly.PROCEDURE_CATEGORY_NAME), c = [], d = a.getVars(), e = 0; e < d.length; e++)c[e] = Blockly.Python.valueToCode(a, "ARG" + e, Blockly.Python.ORDER_NONE) || "None";
        return [
            b + "(" + c.join(", ") + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.procedures_callnoreturn = function(a) {
        return Blockly.Python.procedures_callreturn(a)[0] + "\n";
    };
    Blockly.Python.procedures_ifreturn = function(a) {
        var b = "if " + (Blockly.Python.valueToCode(a, "CONDITION", Blockly.Python.ORDER_NONE) || "False") + ":\n";
        Blockly.Python.STATEMENT_SUFFIX && (b += Blockly.Python.prefixLines(Blockly.Python.injectId(Blockly.Python.STATEMENT_SUFFIX, a), Blockly.Python.INDENT));
        a.hasReturnValue_ ? (a = Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "None", b += Blockly.Python.INDENT + "return " + a + "\n") : b += Blockly.Python.INDENT + "return\n";
        return b;
    };
    Blockly.Python.texts = {};
    Blockly.Python.text = function(a) {
        return [
            Blockly.Python.quote_(a.getFieldValue("TEXT")),
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.text_multiline = function(a) {
        a = Blockly.Python.multiline_quote_(a.getFieldValue("TEXT"));
        var b = -1 != a.indexOf("+") ? Blockly.Python.ORDER_ADDITIVE : Blockly.Python.ORDER_ATOMIC;
        return [
            a,
            b
        ];
    };
    Blockly.Python.text.forceString_ = function(a) {
        return Blockly.Python.text.forceString_.strRegExp.test(a) ? [
            a,
            Blockly.Python.ORDER_ATOMIC
        ] : [
            "str(" + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text.forceString_.strRegExp = /^\s*'([^']|\\')*'\s*$/;
    Blockly.Python.text_join = function(a) {
        switch(a.itemCount_){
            case 0:
                return [
                    "''",
                    Blockly.Python.ORDER_ATOMIC
                ];
            case 1:
                return a = Blockly.Python.valueToCode(a, "ADD0", Blockly.Python.ORDER_NONE) || "''", Blockly.Python.text.forceString_(a);
            case 2:
                var b = Blockly.Python.valueToCode(a, "ADD0", Blockly.Python.ORDER_NONE) || "''";
                a = Blockly.Python.valueToCode(a, "ADD1", Blockly.Python.ORDER_NONE) || "''";
                a = Blockly.Python.text.forceString_(b)[0] + " + " + Blockly.Python.text.forceString_(a)[0];
                return [
                    a,
                    Blockly.Python.ORDER_ADDITIVE
                ];
            default:
                b = [];
                for(var c = 0; c < a.itemCount_; c++)b[c] = Blockly.Python.valueToCode(a, "ADD" + c, Blockly.Python.ORDER_NONE) || "''";
                a = Blockly.Python.variableDB_.getDistinctName("x", Blockly.VARIABLE_CATEGORY_NAME);
                a = "''.join([str(" + a + ") for " + a + " in [" + b.join(", ") + "]])";
                return [
                    a,
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
        }
    };
    Blockly.Python.text_append = function(a) {
        var b = Blockly.Python.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME);
        a = Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_NONE) || "''";
        return b + " = str(" + b + ") + " + Blockly.Python.text.forceString_(a)[0] + "\n";
    };
    Blockly.Python.text_length = function(a) {
        return [
            "len(" + (Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "''") + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text_isEmpty = function(a) {
        return [
            "not len(" + (Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "''") + ")",
            Blockly.Python.ORDER_LOGICAL_NOT
        ];
    };
    Blockly.Python.text_indexOf = function(a) {
        var b = "FIRST" == a.getFieldValue("END") ? "find" : "rfind", c = Blockly.Python.valueToCode(a, "FIND", Blockly.Python.ORDER_NONE) || "''";
        b = (Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_MEMBER) || "''") + "." + b + "(" + c + ")";
        return a.workspace.options.oneBasedIndex ? [
            b + " + 1",
            Blockly.Python.ORDER_ADDITIVE
        ] : [
            b,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text_charAt = function(a) {
        var b = a.getFieldValue("WHERE") || "FROM_START", c = Blockly.Python.valueToCode(a, "VALUE", "RANDOM" == b ? Blockly.Python.ORDER_NONE : Blockly.Python.ORDER_MEMBER) || "''";
        switch(b){
            case "FIRST":
                return [
                    c + "[0]",
                    Blockly.Python.ORDER_MEMBER
                ];
            case "LAST":
                return [
                    c + "[-1]",
                    Blockly.Python.ORDER_MEMBER
                ];
            case "FROM_START":
                return a = Blockly.Python.getAdjustedInt(a, "AT"), [
                    c + "[" + a + "]",
                    Blockly.Python.ORDER_MEMBER
                ];
            case "FROM_END":
                return a = Blockly.Python.getAdjustedInt(a, "AT", 1, !0), [
                    c + "[" + a + "]",
                    Blockly.Python.ORDER_MEMBER
                ];
            case "RANDOM":
                return Blockly.Python.definitions_.import_random = "import random", [
                    Blockly.Python.provideFunction_("text_random_letter", [
                        "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(text):",
                        "  x = int(random.random() * len(text))",
                        "  return text[x];"
                    ]) + "(" + c + ")",
                    Blockly.Python.ORDER_FUNCTION_CALL
                ];
        }
        throw Error("Unhandled option (text_charAt).");
    };
    Blockly.Python.text_getSubstring = function(a) {
        var b = a.getFieldValue("WHERE1"), c = a.getFieldValue("WHERE2"), d = Blockly.Python.valueToCode(a, "STRING", Blockly.Python.ORDER_MEMBER) || "''";
        switch(b){
            case "FROM_START":
                b = Blockly.Python.getAdjustedInt(a, "AT1");
                "0" == b && (b = "");
                break;
            case "FROM_END":
                b = Blockly.Python.getAdjustedInt(a, "AT1", 1, !0);
                break;
            case "FIRST":
                b = "";
                break;
            default:
                throw Error("Unhandled option (text_getSubstring)");
        }
        switch(c){
            case "FROM_START":
                a = Blockly.Python.getAdjustedInt(a, "AT2", 1);
                break;
            case "FROM_END":
                a = Blockly.Python.getAdjustedInt(a, "AT2", 0, !0);
                Blockly.isNumber(String(a)) ? "0" == a && (a = "") : (Blockly.Python.definitions_.import_sys = "import sys", a += " or sys.maxsize");
                break;
            case "LAST":
                a = "";
                break;
            default:
                throw Error("Unhandled option (text_getSubstring)");
        }
        return [
            d + "[" + b + " : " + a + "]",
            Blockly.Python.ORDER_MEMBER
        ];
    };
    Blockly.Python.text_changeCase = function(a) {
        var b = {
            UPPERCASE: ".upper()",
            LOWERCASE: ".lower()",
            TITLECASE: ".title()"
        }[a.getFieldValue("CASE")];
        return [
            (Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_MEMBER) || "''") + b,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text_trim = function(a) {
        var b = {
            LEFT: ".lstrip()",
            RIGHT: ".rstrip()",
            BOTH: ".strip()"
        }[a.getFieldValue("MODE")];
        return [
            (Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_MEMBER) || "''") + b,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text_print = function(a) {
        return "print(" + (Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_NONE) || "''") + ")\n";
    };
    Blockly.Python.text_prompt_ext = function(a) {
        var b = Blockly.Python.provideFunction_("text_prompt", [
            "def " + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + "(msg):",
            "  try:",
            "    return raw_input(msg)",
            "  except NameError:",
            "    return input(msg)"
        ]), c = a.getField("TEXT") ? Blockly.Python.quote_(a.getFieldValue("TEXT")) : Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_NONE) || "''";
        b = b + "(" + c + ")";
        "NUMBER" == a.getFieldValue("TYPE") && (b = "float(" + b + ")");
        return [
            b,
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text_prompt = Blockly.Python.text_prompt_ext;
    Blockly.Python.text_count = function(a) {
        var b = Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_MEMBER) || "''";
        a = Blockly.Python.valueToCode(a, "SUB", Blockly.Python.ORDER_NONE) || "''";
        return [
            b + ".count(" + a + ")",
            Blockly.Python.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.Python.text_replace = function(a) {
        var b = Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_MEMBER) || "''", c = Blockly.Python.valueToCode(a, "FROM", Blockly.Python.ORDER_NONE) || "''";
        a = Blockly.Python.valueToCode(a, "TO", Blockly.Python.ORDER_NONE) || "''";
        return [
            b + ".replace(" + c + ", " + a + ")",
            Blockly.Python.ORDER_MEMBER
        ];
    };
    Blockly.Python.text_reverse = function(a) {
        return [
            (Blockly.Python.valueToCode(a, "TEXT", Blockly.Python.ORDER_MEMBER) || "''") + "[::-1]",
            Blockly.Python.ORDER_MEMBER
        ];
    };
    Blockly.Python.variables = {};
    Blockly.Python.variables_get = function(a) {
        return [
            Blockly.Python.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME),
            Blockly.Python.ORDER_ATOMIC
        ];
    };
    Blockly.Python.variables_set = function(a) {
        var b = Blockly.Python.valueToCode(a, "VALUE", Blockly.Python.ORDER_NONE) || "0";
        return Blockly.Python.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME) + " = " + b + "\n";
    };
    Blockly.Python.variablesDynamic = {};
    Blockly.Python.variables_get_dynamic = Blockly.Python.variables_get;
    Blockly.Python.variables_set_dynamic = Blockly.Python.variables_set;
    return Blockly.Python;
});

});


parcelRegister("kFmW2", function(module, exports) {
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './browser'
    ], factory);
    else module.exports = factory((parcelRequire("fNAzW")));
})(module.exports, function(Blockly) {
    /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly module.
 */ /* eslint-disable */ 'use strict';
    return Blockly;
});

});
parcelRegister("fNAzW", function(module, exports) {
/* eslint-disable */ 



(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './core-browser',
        './msg/en',
        './blocks',
        './javascript'
    ], factory);
    else module.exports = factory((parcelRequire("460Qg")), (parcelRequire("8c7aX")), (parcelRequire("67PMQ")), (parcelRequire("cK1vO")));
})(module.exports, function(Blockly, En, BlocklyBlocks, BlocklyJS) {
    /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly module for the browser. This includes Blockly core
 * and built in blocks, the JavaScript code generator and the English block
 * localization files.
 */ /* eslint-disable */ 'use strict';
    // Include the EN Locale by default.
    Blockly.setLocale(En);
    Blockly.Blocks = Blockly.Blocks || {};
    Object.keys(BlocklyBlocks).forEach(function(k) {
        Blockly.Blocks[k] = BlocklyBlocks[k];
    });
    Blockly.JavaScript = BlocklyJS;
    return Blockly;
});

});
parcelRegister("8c7aX", function(module, exports) {
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        '../core'
    ], factory);
    else module.exports = factory((parcelRequire("460Qg")));
})(module.exports, function(Blockly) {
    var Blockly = {};
    Blockly.Msg = {}; // This file was automatically generated.  Do not modify.
    'use strict';
    Blockly.Msg["ADD_COMMENT"] = "Add Comment";
    Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "Can't delete the variable '%1' because it's part of the definition of the function '%2'";
    Blockly.Msg["CHANGE_VALUE_TITLE"] = "Change value:";
    Blockly.Msg["CLEAN_UP"] = "Clean up Blocks";
    Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "Collapsed blocks contain warnings.";
    Blockly.Msg["COLLAPSE_ALL"] = "Collapse Blocks";
    Blockly.Msg["COLLAPSE_BLOCK"] = "Collapse Block";
    Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "colour 1";
    Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "colour 2";
    Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp";
    Blockly.Msg["COLOUR_BLEND_RATIO"] = "ratio";
    Blockly.Msg["COLOUR_BLEND_TITLE"] = "blend";
    Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "Blends two colours together with a given ratio (0.0 - 1.0).";
    Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://en.wikipedia.org/wiki/Color";
    Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "Choose a colour from the palette.";
    Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com";
    Blockly.Msg["COLOUR_RANDOM_TITLE"] = "random colour";
    Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "Choose a colour at random.";
    Blockly.Msg["COLOUR_RGB_BLUE"] = "blue";
    Blockly.Msg["COLOUR_RGB_GREEN"] = "green";
    Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html";
    Blockly.Msg["COLOUR_RGB_RED"] = "red";
    Blockly.Msg["COLOUR_RGB_TITLE"] = "colour with";
    Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "Create a colour with the specified amount of red, green, and blue. All values must be between 0 and 100.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "break out of loop";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "continue with next iteration of loop";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "Break out of the containing loop.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "Skip the rest of this loop, and continue with the next iteration.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "Warning: This block may only be used within a loop.";
    Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#for-each";
    Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "for each item %1 in list %2";
    Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = "For each item in a list, set the variable '%1' to the item, and then do some statements.";
    Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#count-with";
    Blockly.Msg["CONTROLS_FOR_TITLE"] = "count with %1 from %2 to %3 by %4";
    Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "Have the variable '%1' take on the values from the start number to the end number, counting by the specified interval, and do the specified blocks.";
    Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "Add a condition to the if block.";
    Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "Add a final, catch-all condition to the if block.";
    Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse";
    Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this if block.";
    Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "else";
    Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "else if";
    Blockly.Msg["CONTROLS_IF_MSG_IF"] = "if";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "If a value is true, then do some statements.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "If a value is true, then do the first block of statements. Otherwise, do the second block of statements.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements. If none of the values are true, do the last block of statements.";
    Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://en.wikipedia.org/wiki/For_loop";
    Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "do";
    Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "repeat %1 times";
    Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Do some statements several times.";
    Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#repeat";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "repeat until";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "repeat while";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "While a value is false, then do some statements.";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "While a value is true, then do some statements.";
    Blockly.Msg["DELETE_ALL_BLOCKS"] = "Delete all %1 blocks?";
    Blockly.Msg["DELETE_BLOCK"] = "Delete Block";
    Blockly.Msg["DELETE_VARIABLE"] = "Delete the '%1' variable";
    Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Delete %1 uses of the '%2' variable?";
    Blockly.Msg["DELETE_X_BLOCKS"] = "Delete %1 Blocks";
    Blockly.Msg["DISABLE_BLOCK"] = "Disable Block";
    Blockly.Msg["DUPLICATE_BLOCK"] = "Duplicate";
    Blockly.Msg["DUPLICATE_COMMENT"] = "Duplicate Comment";
    Blockly.Msg["ENABLE_BLOCK"] = "Enable Block";
    Blockly.Msg["EXPAND_ALL"] = "Expand Blocks";
    Blockly.Msg["EXPAND_BLOCK"] = "Expand Block";
    Blockly.Msg["EXTERNAL_INPUTS"] = "External Inputs";
    Blockly.Msg["HELP"] = "Help";
    Blockly.Msg["INLINE_INPUTS"] = "Inline Inputs";
    Blockly.Msg["IOS_CANCEL"] = "Cancel";
    Blockly.Msg["IOS_ERROR"] = "Error";
    Blockly.Msg["IOS_OK"] = "OK";
    Blockly.Msg["IOS_PROCEDURES_ADD_INPUT"] = "+ Add Input";
    Blockly.Msg["IOS_PROCEDURES_ALLOW_STATEMENTS"] = "Allow statements";
    Blockly.Msg["IOS_PROCEDURES_DUPLICATE_INPUTS_ERROR"] = "This function has duplicate inputs.";
    Blockly.Msg["IOS_PROCEDURES_INPUTS"] = "INPUTS";
    Blockly.Msg["IOS_VARIABLES_ADD_BUTTON"] = "Add";
    Blockly.Msg["IOS_VARIABLES_ADD_VARIABLE"] = "+ Add Variable";
    Blockly.Msg["IOS_VARIABLES_DELETE_BUTTON"] = "Delete";
    Blockly.Msg["IOS_VARIABLES_EMPTY_NAME_ERROR"] = "You can't use an empty variable name.";
    Blockly.Msg["IOS_VARIABLES_RENAME_BUTTON"] = "Rename";
    Blockly.Msg["IOS_VARIABLES_VARIABLE_NAME"] = "Variable name";
    Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list";
    Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "create empty list";
    Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "Returns a list, of length 0, containing no data records";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "list";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this list block.";
    Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
    Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "create list with";
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "Add an item to the list.";
    Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Create a list with any number of items.";
    Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "first";
    Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "# from end";
    Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "#";
    Blockly.Msg["LISTS_GET_INDEX_GET"] = "get";
    Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "get and remove";
    Blockly.Msg["LISTS_GET_INDEX_LAST"] = "last";
    Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "random";
    Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "remove";
    Blockly.Msg["LISTS_GET_INDEX_TAIL"] = "";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "Returns the first item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "Returns the item at the specified position in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "Returns the last item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "Returns a random item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "Removes and returns the first item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "Removes and returns the item at the specified position in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "Removes and returns the last item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "Removes and returns a random item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "Removes the first item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "Removes the item at the specified position in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "Removes the last item in a list.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "Removes a random item in a list.";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "to # from end";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "to #";
    Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "to last";
    Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "get sub-list from first";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "get sub-list from # from end";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "get sub-list from #";
    Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = "";
    Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "Creates a copy of the specified portion of a list.";
    Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 is the last item.";
    Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 is the first item.";
    Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "find first occurrence of item";
    Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list";
    Blockly.Msg["LISTS_INDEX_OF_LAST"] = "find last occurrence of item";
    Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "Returns the index of the first/last occurrence of the item in the list. Returns %1 if item is not found.";
    Blockly.Msg["LISTS_INLIST"] = "in list";
    Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty";
    Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1 is empty";
    Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "Returns true if the list is empty.";
    Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of";
    Blockly.Msg["LISTS_LENGTH_TITLE"] = "length of %1";
    Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Returns the length of a list.";
    Blockly.Msg["LISTS_REPEAT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
    Blockly.Msg["LISTS_REPEAT_TITLE"] = "create list with item %1 repeated %2 times";
    Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "Creates a list consisting of the given value repeated the specified number of times.";
    Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list";
    Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "reverse %1";
    Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "Reverse a copy of a list.";
    Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#in-list--set";
    Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "as";
    Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "insert at";
    Blockly.Msg["LISTS_SET_INDEX_SET"] = "set";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "Inserts the item at the start of a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "Inserts the item at the specified position in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "Append the item to the end of a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "Inserts the item randomly in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "Sets the first item in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "Sets the item at the specified position in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "Sets the last item in a list.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "Sets a random item in a list.";
    Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list";
    Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "ascending";
    Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "descending";
    Blockly.Msg["LISTS_SORT_TITLE"] = "sort %1 %2 %3";
    Blockly.Msg["LISTS_SORT_TOOLTIP"] = "Sort a copy of a list.";
    Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "alphabetic, ignore case";
    Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "numeric";
    Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "alphabetic";
    Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists";
    Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "make list from text";
    Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "make text from list";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "Join a list of texts into one text, separated by a delimiter.";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "Split text into a list of texts, breaking at each delimiter.";
    Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "with delimiter";
    Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "false";
    Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values";
    Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Returns either true or false.";
    Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "true";
    Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://en.wikipedia.org/wiki/Inequality_(mathematics)";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Return true if both inputs equal each other.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Return true if the first input is greater than the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Return true if the first input is greater than or equal to the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Return true if the first input is smaller than the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Return true if the first input is smaller than or equal to the second input.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Return true if both inputs are not equal to each other.";
    Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not";
    Blockly.Msg["LOGIC_NEGATE_TITLE"] = "not %1";
    Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Returns true if the input is false. Returns false if the input is true.";
    Blockly.Msg["LOGIC_NULL"] = "null";
    Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://en.wikipedia.org/wiki/Nullable_type";
    Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "Returns null.";
    Blockly.Msg["LOGIC_OPERATION_AND"] = "and";
    Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations";
    Blockly.Msg["LOGIC_OPERATION_OR"] = "or";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Return true if both inputs are true.";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Return true if at least one of the inputs is true.";
    Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "test";
    Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://en.wikipedia.org/wiki/%3F:";
    Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "if false";
    Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "if true";
    Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = "Check the condition in 'test'. If the condition is true, returns the 'if true' value; otherwise returns the 'if false' value.";
    Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
    Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://en.wikipedia.org/wiki/Arithmetic";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Return the sum of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Return the quotient of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Return the difference of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Return the product of the two numbers.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Return the first number raised to the power of the second number.";
    Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://en.wikipedia.org/wiki/Atan2";
    Blockly.Msg["MATH_ATAN2_TITLE"] = "atan2 of X:%1 Y:%2";
    Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "Return the arctangent of point (X, Y) in degrees from -180 to 180.";
    Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter";
    Blockly.Msg["MATH_CHANGE_TITLE"] = "change %1 by %2";
    Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Add a number to variable '%1'.";
    Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://en.wikipedia.org/wiki/Mathematical_constant";
    Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "Return one of the common constants: \u03C0 (3.141\u2026), e (2.718\u2026), \u03C6 (1.618\u2026), sqrt(2) (1.414\u2026), sqrt(\xbd) (0.707\u2026), or \u221E (infinity).";
    Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)";
    Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "constrain %1 low %2 high %3";
    Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Constrain a number to be between the specified limits (inclusive).";
    Blockly.Msg["MATH_DIVISION_SYMBOL"] = "\xf7";
    Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "is divisible by";
    Blockly.Msg["MATH_IS_EVEN"] = "is even";
    Blockly.Msg["MATH_IS_NEGATIVE"] = "is negative";
    Blockly.Msg["MATH_IS_ODD"] = "is odd";
    Blockly.Msg["MATH_IS_POSITIVE"] = "is positive";
    Blockly.Msg["MATH_IS_PRIME"] = "is prime";
    Blockly.Msg["MATH_IS_TOOLTIP"] = "Check if a number is an even, odd, prime, whole, positive, negative, or if it is divisible by certain number. Returns true or false.";
    Blockly.Msg["MATH_IS_WHOLE"] = "is whole";
    Blockly.Msg["MATH_MODULO_HELPURL"] = "https://en.wikipedia.org/wiki/Modulo_operation";
    Blockly.Msg["MATH_MODULO_TITLE"] = "remainder of %1 \xf7 %2";
    Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Return the remainder from dividing the two numbers.";
    Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "\xd7";
    Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://en.wikipedia.org/wiki/Number";
    Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "A number.";
    Blockly.Msg["MATH_ONLIST_HELPURL"] = "";
    Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "average of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "max of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "median of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "min of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "modes of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "random item of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "standard deviation of list";
    Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "sum of list";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "Return the average (arithmetic mean) of the numeric values in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "Return the largest number in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "Return the median number in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "Return the smallest number in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "Return a list of the most common item(s) in the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "Return a random element from the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "Return the standard deviation of the list.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "Return the sum of all the numbers in the list.";
    Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
    Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";
    Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "random fraction";
    Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "Return a random fraction between 0.0 (inclusive) and 1.0 (exclusive).";
    Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";
    Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "random integer from %1 to %2";
    Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Return a random integer between the two specified limits, inclusive.";
    Blockly.Msg["MATH_ROUND_HELPURL"] = "https://en.wikipedia.org/wiki/Rounding";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "round";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "round down";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "round up";
    Blockly.Msg["MATH_ROUND_TOOLTIP"] = "Round a number up or down.";
    Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://en.wikipedia.org/wiki/Square_root";
    Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absolute";
    Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "square root";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Return the absolute value of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Return e to the power of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Return the natural logarithm of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Return the base 10 logarithm of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Return the negation of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Return 10 to the power of a number.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Return the square root of a number.";
    Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
    Blockly.Msg["MATH_TRIG_ACOS"] = "acos";
    Blockly.Msg["MATH_TRIG_ASIN"] = "asin";
    Blockly.Msg["MATH_TRIG_ATAN"] = "atan";
    Blockly.Msg["MATH_TRIG_COS"] = "cos";
    Blockly.Msg["MATH_TRIG_HELPURL"] = "https://en.wikipedia.org/wiki/Trigonometric_functions";
    Blockly.Msg["MATH_TRIG_SIN"] = "sin";
    Blockly.Msg["MATH_TRIG_TAN"] = "tan";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "Return the arccosine of a number.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "Return the arcsine of a number.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "Return the arctangent of a number.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "Return the cosine of a degree (not radian).";
    Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "Return the sine of a degree (not radian).";
    Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "Return the tangent of a degree (not radian).";
    Blockly.Msg["NEW_COLOUR_VARIABLE"] = "Create colour variable...";
    Blockly.Msg["NEW_NUMBER_VARIABLE"] = "Create number variable...";
    Blockly.Msg["NEW_STRING_VARIABLE"] = "Create string variable...";
    Blockly.Msg["NEW_VARIABLE"] = "Create variable...";
    Blockly.Msg["NEW_VARIABLE_TITLE"] = "New variable name:";
    Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "New variable type:";
    Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = "";
    Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "allow statements";
    Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "with:";
    Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Run the user-defined function '%1'.";
    Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Run the user-defined function '%1' and use its output.";
    Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "with:";
    Blockly.Msg["PROCEDURES_CREATE_DO"] = "Create '%1'";
    Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Describe this function...";
    Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
    Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "do something";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "to";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Creates a function with no output.";
    Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
    Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "return";
    Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Creates a function with an output.";
    Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Warning: This function has duplicate parameters.";
    Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Highlight function definition";
    Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "http://c2.com/cgi/wiki?GuardClause";
    Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "If a value is true, then return a second value.";
    Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Warning: This block may be used only within a function definition.";
    Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "input name:";
    Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Add an input to the function.";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "inputs";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Add, remove, or reorder inputs to this function.";
    Blockly.Msg["REDO"] = "Redo";
    Blockly.Msg["REMOVE_COMMENT"] = "Remove Comment";
    Blockly.Msg["RENAME_VARIABLE"] = "Rename variable...";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Rename all '%1' variables to:";
    Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";
    Blockly.Msg["TEXT_APPEND_TITLE"] = "to %1 append text %2";
    Blockly.Msg["TEXT_APPEND_TOOLTIP"] = "Append some text to variable '%1'.";
    Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "to lower case";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "to Title Case";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "to UPPER CASE";
    Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "Return a copy of the text in a different case.";
    Blockly.Msg["TEXT_CHARAT_FIRST"] = "get first letter";
    Blockly.Msg["TEXT_CHARAT_FROM_END"] = "get letter # from end";
    Blockly.Msg["TEXT_CHARAT_FROM_START"] = "get letter #";
    Blockly.Msg["TEXT_CHARAT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-text";
    Blockly.Msg["TEXT_CHARAT_LAST"] = "get last letter";
    Blockly.Msg["TEXT_CHARAT_RANDOM"] = "get random letter";
    Blockly.Msg["TEXT_CHARAT_TAIL"] = "";
    Blockly.Msg["TEXT_CHARAT_TITLE"] = "in text %1 %2";
    Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "Returns the letter at the specified position.";
    Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings";
    Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "count %1 in %2";
    Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "Count how many times some text occurs within some other text.";
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Add an item to the text.";
    Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "join";
    Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this text block.";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "to letter # from end";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "to letter #";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "to last letter";
    Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text";
    Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "in text";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "get substring from first letter";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "get substring from letter # from end";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "get substring from letter #";
    Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = "";
    Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "Returns a specified portion of the text.";
    Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "https://github.com/google/blockly/wiki/Text#finding-text";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "find first occurrence of text";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "find last occurrence of text";
    Blockly.Msg["TEXT_INDEXOF_TITLE"] = "in text %1 %2 %3";
    Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "Returns the index of the first/last occurrence of the first text in the second text. Returns %1 if text is not found.";
    Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text";
    Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1 is empty";
    Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "Returns true if the provided text is empty.";
    Blockly.Msg["TEXT_JOIN_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-creation";
    Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "create text with";
    Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Create a piece of text by joining together any number of items.";
    Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";
    Blockly.Msg["TEXT_LENGTH_TITLE"] = "length of %1";
    Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Returns the number of letters (including spaces) in the provided text.";
    Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text";
    Blockly.Msg["TEXT_PRINT_TITLE"] = "print %1";
    Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "Print the specified text, number or other value.";
    Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user";
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "Prompt for user for a number.";
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "Prompt for user for some text.";
    Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "prompt for number with message";
    Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "prompt for text with message";
    Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings";
    Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "replace %1 with %2 in %3";
    Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "Replace all occurances of some text within some other text.";
    Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text";
    Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "reverse %1";
    Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "Reverses the order of the characters in the text.";
    Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://en.wikipedia.org/wiki/String_(computer_science)";
    Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "A letter, word, or line of text.";
    Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces";
    Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "trim spaces from both sides of";
    Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "trim spaces from left side of";
    Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "trim spaces from right side of";
    Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "Return a copy of the text with spaces removed from one or both ends.";
    Blockly.Msg["TODAY"] = "Today";
    Blockly.Msg["UNDO"] = "Undo";
    Blockly.Msg["UNNAMED_KEY"] = "unnamed";
    Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "item";
    Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Create 'set %1'";
    Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#get";
    Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Returns the value of this variable.";
    Blockly.Msg["VARIABLES_SET"] = "set %1 to %2";
    Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Create 'get %1'";
    Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#set";
    Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Sets this variable to be equal to the input.";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "A variable named '%1' already exists.";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "A variable named '%1' already exists for another type: '%2'.";
    Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Blockly Workspace";
    Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Say something...";
    Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
    Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
    Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
    Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
    Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
    Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
    Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
    Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
    Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["MATH_HUE"] = "230";
    Blockly.Msg["LOOPS_HUE"] = "120";
    Blockly.Msg["LISTS_HUE"] = "260";
    Blockly.Msg["LOGIC_HUE"] = "210";
    Blockly.Msg["VARIABLES_HUE"] = "330";
    Blockly.Msg["TEXTS_HUE"] = "160";
    Blockly.Msg["PROCEDURES_HUE"] = "290";
    Blockly.Msg["COLOUR_HUE"] = "20";
    Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
    return Blockly.Msg;
});

});

parcelRegister("67PMQ", function(module, exports) {
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './blocks_compressed'
    ], factory);
    else module.exports = factory((parcelRequire("jUYxT")));
})(module.exports, function(Blockly) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Blockly Blocks module.
 */ /* eslint-disable */ 'use strict';
    Blockly.Blocks = {};
    return Blockly.Blocks;
});

});
parcelRegister("jUYxT", function(module, exports) {
// Do not edit this file; automatically generated by gulp.
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './blockly_compressed.js'
    ], factory);
    else module.exports = factory((parcelRequire("6CdWE")));
})(module.exports, function(Blockly) {
    'use strict';
    Blockly.Blocks.colour = {};
    Blockly.Constants = {};
    Blockly.Constants.Colour = {};
    Blockly.Constants.Colour.HUE = 20;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "colour_picker",
            message0: "%1",
            args0: [
                {
                    type: "field_colour",
                    name: "COLOUR",
                    colour: "#ff0000"
                }
            ],
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_PICKER_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_PICKER_TOOLTIP}",
            extensions: [
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "colour_random",
            message0: "%{BKY_COLOUR_RANDOM_TITLE}",
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_RANDOM_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_RANDOM_TOOLTIP}"
        },
        {
            type: "colour_rgb",
            message0: "%{BKY_COLOUR_RGB_TITLE} %{BKY_COLOUR_RGB_RED} %1 %{BKY_COLOUR_RGB_GREEN} %2 %{BKY_COLOUR_RGB_BLUE} %3",
            args0: [
                {
                    type: "input_value",
                    name: "RED",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "GREEN",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "BLUE",
                    check: "Number",
                    align: "RIGHT"
                }
            ],
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_RGB_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_RGB_TOOLTIP}"
        },
        {
            type: "colour_blend",
            message0: "%{BKY_COLOUR_BLEND_TITLE} %{BKY_COLOUR_BLEND_COLOUR1} %1 %{BKY_COLOUR_BLEND_COLOUR2} %2 %{BKY_COLOUR_BLEND_RATIO} %3",
            args0: [
                {
                    type: "input_value",
                    name: "COLOUR1",
                    check: "Colour",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "COLOUR2",
                    check: "Colour",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "RATIO",
                    check: "Number",
                    align: "RIGHT"
                }
            ],
            output: "Colour",
            helpUrl: "%{BKY_COLOUR_BLEND_HELPURL}",
            style: "colour_blocks",
            tooltip: "%{BKY_COLOUR_BLEND_TOOLTIP}"
        }
    ]);
    Blockly.Blocks.lists = {};
    Blockly.Constants.Lists = {};
    Blockly.Constants.Lists.HUE = 260;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "lists_create_empty",
            message0: "%{BKY_LISTS_CREATE_EMPTY_TITLE}",
            output: "Array",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_CREATE_EMPTY_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_CREATE_EMPTY_HELPURL}"
        },
        {
            type: "lists_repeat",
            message0: "%{BKY_LISTS_REPEAT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "ITEM"
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Array",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_REPEAT_HELPURL}"
        },
        {
            type: "lists_reverse",
            message0: "%{BKY_LISTS_REVERSE_MESSAGE0}",
            args0: [
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            output: "Array",
            inputsInline: !0,
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_REVERSE_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_REVERSE_HELPURL}"
        },
        {
            type: "lists_isEmpty",
            message0: "%{BKY_LISTS_ISEMPTY_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Boolean",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_ISEMPTY_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_ISEMPTY_HELPURL}"
        },
        {
            type: "lists_length",
            message0: "%{BKY_LISTS_LENGTH_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Number",
            style: "list_blocks",
            tooltip: "%{BKY_LISTS_LENGTH_TOOLTIP}",
            helpUrl: "%{BKY_LISTS_LENGTH_HELPURL}"
        }
    ]);
    Blockly.Blocks.lists_create_with = {
        init: function() {
            this.setHelpUrl(Blockly.Msg.LISTS_CREATE_WITH_HELPURL);
            this.setStyle("list_blocks");
            this.itemCount_ = 3;
            this.updateShape_();
            this.setOutput(!0, "Array");
            this.setMutator(new Blockly.Mutator([
                "lists_create_with_item"
            ]));
            this.setTooltip(Blockly.Msg.LISTS_CREATE_WITH_TOOLTIP);
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("items", this.itemCount_);
            return a;
        },
        domToMutation: function(a) {
            this.itemCount_ = parseInt(a.getAttribute("items"), 10);
            this.updateShape_();
        },
        decompose: function(a) {
            var b = a.newBlock("lists_create_with_container");
            b.initSvg();
            for(var c = b.getInput("STACK").connection, d = 0; d < this.itemCount_; d++){
                var e = a.newBlock("lists_create_with_item");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection;
            }
            return b;
        },
        compose: function(a) {
            var b = a.getInputTargetBlock("STACK");
            for(a = []; b && !b.isInsertionMarker();)a.push(b.valueConnection_), b = b.nextConnection && b.nextConnection.targetBlock();
            for(b = 0; b < this.itemCount_; b++){
                var c = this.getInput("ADD" + b).connection.targetConnection;
                c && -1 == a.indexOf(c) && c.disconnect();
            }
            this.itemCount_ = a.length;
            this.updateShape_();
            for(b = 0; b < this.itemCount_; b++)Blockly.Mutator.reconnect(a[b], this, "ADD" + b);
        },
        saveConnections: function(a) {
            a = a.getInputTargetBlock("STACK");
            for(var b = 0; a;){
                var c = this.getInput("ADD" + b);
                a.valueConnection_ = c && c.connection.targetConnection;
                b++;
                a = a.nextConnection && a.nextConnection.targetBlock();
            }
        },
        updateShape_: function() {
            this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(Blockly.Msg.LISTS_CREATE_EMPTY_TITLE);
            for(var a = 0; a < this.itemCount_; a++)if (!this.getInput("ADD" + a)) {
                var b = this.appendValueInput("ADD" + a).setAlign(Blockly.ALIGN_RIGHT);
                0 == a && b.appendField(Blockly.Msg.LISTS_CREATE_WITH_INPUT_WITH);
            }
            for(; this.getInput("ADD" + a);)this.removeInput("ADD" + a), a++;
        }
    };
    Blockly.Blocks.lists_create_with_container = {
        init: function() {
            this.setStyle("list_blocks");
            this.appendDummyInput().appendField(Blockly.Msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD);
            this.appendStatementInput("STACK");
            this.setTooltip(Blockly.Msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP);
            this.contextMenu = !1;
        }
    };
    Blockly.Blocks.lists_create_with_item = {
        init: function() {
            this.setStyle("list_blocks");
            this.appendDummyInput().appendField(Blockly.Msg.LISTS_CREATE_WITH_ITEM_TITLE);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setTooltip(Blockly.Msg.LISTS_CREATE_WITH_ITEM_TOOLTIP);
            this.contextMenu = !1;
        }
    };
    Blockly.Blocks.lists_indexOf = {
        init: function() {
            var a = [
                [
                    Blockly.Msg.LISTS_INDEX_OF_FIRST,
                    "FIRST"
                ],
                [
                    Blockly.Msg.LISTS_INDEX_OF_LAST,
                    "LAST"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.LISTS_INDEX_OF_HELPURL);
            this.setStyle("list_blocks");
            this.setOutput(!0, "Number");
            this.appendValueInput("VALUE").setCheck("Array").appendField(Blockly.Msg.LISTS_INDEX_OF_INPUT_IN_LIST);
            this.appendValueInput("FIND").appendField(new Blockly.FieldDropdown(a), "END");
            this.setInputsInline(!0);
            var b = this;
            this.setTooltip(function() {
                return Blockly.Msg.LISTS_INDEX_OF_TOOLTIP.replace("%1", b.workspace.options.oneBasedIndex ? "0" : "-1");
            });
        }
    };
    Blockly.Blocks.lists_getIndex = {
        init: function() {
            var a = [
                [
                    Blockly.Msg.LISTS_GET_INDEX_GET,
                    "GET"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_GET_REMOVE,
                    "GET_REMOVE"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_REMOVE,
                    "REMOVE"
                ]
            ];
            this.WHERE_OPTIONS = [
                [
                    Blockly.Msg.LISTS_GET_INDEX_FROM_START,
                    "FROM_START"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_FROM_END,
                    "FROM_END"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_FIRST,
                    "FIRST"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_LAST,
                    "LAST"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_RANDOM,
                    "RANDOM"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.LISTS_GET_INDEX_HELPURL);
            this.setStyle("list_blocks");
            a = new Blockly.FieldDropdown(a, function(c) {
                c = "REMOVE" == c;
                this.getSourceBlock().updateStatement_(c);
            });
            this.appendValueInput("VALUE").setCheck("Array").appendField(Blockly.Msg.LISTS_GET_INDEX_INPUT_IN_LIST);
            this.appendDummyInput().appendField(a, "MODE").appendField("", "SPACE");
            this.appendDummyInput("AT");
            Blockly.Msg.LISTS_GET_INDEX_TAIL && this.appendDummyInput("TAIL").appendField(Blockly.Msg.LISTS_GET_INDEX_TAIL);
            this.setInputsInline(!0);
            this.setOutput(!0);
            this.updateAt_(!0);
            var b = this;
            this.setTooltip(function() {
                var c = b.getFieldValue("MODE"), d = b.getFieldValue("WHERE"), e = "";
                switch(c + " " + d){
                    case "GET FROM_START":
                    case "GET FROM_END":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM;
                        break;
                    case "GET FIRST":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST;
                        break;
                    case "GET LAST":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST;
                        break;
                    case "GET RANDOM":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM;
                        break;
                    case "GET_REMOVE FROM_START":
                    case "GET_REMOVE FROM_END":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM;
                        break;
                    case "GET_REMOVE FIRST":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST;
                        break;
                    case "GET_REMOVE LAST":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST;
                        break;
                    case "GET_REMOVE RANDOM":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM;
                        break;
                    case "REMOVE FROM_START":
                    case "REMOVE FROM_END":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM;
                        break;
                    case "REMOVE FIRST":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST;
                        break;
                    case "REMOVE LAST":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST;
                        break;
                    case "REMOVE RANDOM":
                        e = Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM;
                }
                if ("FROM_START" == d || "FROM_END" == d) e += "  " + ("FROM_START" == d ? Blockly.Msg.LISTS_INDEX_FROM_START_TOOLTIP : Blockly.Msg.LISTS_INDEX_FROM_END_TOOLTIP).replace("%1", b.workspace.options.oneBasedIndex ? "#1" : "#0");
                return e;
            });
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("statement", !this.outputConnection);
            var b = this.getInput("AT").type == Blockly.INPUT_VALUE;
            a.setAttribute("at", b);
            return a;
        },
        domToMutation: function(a) {
            var b = "true" == a.getAttribute("statement");
            this.updateStatement_(b);
            a = "false" != a.getAttribute("at");
            this.updateAt_(a);
        },
        updateStatement_: function(a) {
            a != !this.outputConnection && (this.unplug(!0, !0), a ? (this.setOutput(!1), this.setPreviousStatement(!0), this.setNextStatement(!0)) : (this.setPreviousStatement(!1), this.setNextStatement(!1), this.setOutput(!0)));
        },
        updateAt_: function(a) {
            this.removeInput("AT");
            this.removeInput("ORDINAL", !0);
            a ? (this.appendValueInput("AT").setCheck("Number"), Blockly.Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
            var b = new Blockly.FieldDropdown(this.WHERE_OPTIONS, function(c) {
                var d = "FROM_START" == c || "FROM_END" == c;
                if (d != a) {
                    var e = this.getSourceBlock();
                    e.updateAt_(d);
                    e.setFieldValue(c, "WHERE");
                    return null;
                }
            });
            this.getInput("AT").appendField(b, "WHERE");
            Blockly.Msg.LISTS_GET_INDEX_TAIL && this.moveInputBefore("TAIL", null);
        }
    };
    Blockly.Blocks.lists_setIndex = {
        init: function() {
            var a = [
                [
                    Blockly.Msg.LISTS_SET_INDEX_SET,
                    "SET"
                ],
                [
                    Blockly.Msg.LISTS_SET_INDEX_INSERT,
                    "INSERT"
                ]
            ];
            this.WHERE_OPTIONS = [
                [
                    Blockly.Msg.LISTS_GET_INDEX_FROM_START,
                    "FROM_START"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_FROM_END,
                    "FROM_END"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_FIRST,
                    "FIRST"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_LAST,
                    "LAST"
                ],
                [
                    Blockly.Msg.LISTS_GET_INDEX_RANDOM,
                    "RANDOM"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.LISTS_SET_INDEX_HELPURL);
            this.setStyle("list_blocks");
            this.appendValueInput("LIST").setCheck("Array").appendField(Blockly.Msg.LISTS_SET_INDEX_INPUT_IN_LIST);
            this.appendDummyInput().appendField(new Blockly.FieldDropdown(a), "MODE").appendField("", "SPACE");
            this.appendDummyInput("AT");
            this.appendValueInput("TO").appendField(Blockly.Msg.LISTS_SET_INDEX_INPUT_TO);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setTooltip(Blockly.Msg.LISTS_SET_INDEX_TOOLTIP);
            this.updateAt_(!0);
            var b = this;
            this.setTooltip(function() {
                var c = b.getFieldValue("MODE"), d = b.getFieldValue("WHERE"), e = "";
                switch(c + " " + d){
                    case "SET FROM_START":
                    case "SET FROM_END":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM;
                        break;
                    case "SET FIRST":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST;
                        break;
                    case "SET LAST":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST;
                        break;
                    case "SET RANDOM":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM;
                        break;
                    case "INSERT FROM_START":
                    case "INSERT FROM_END":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM;
                        break;
                    case "INSERT FIRST":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST;
                        break;
                    case "INSERT LAST":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST;
                        break;
                    case "INSERT RANDOM":
                        e = Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM;
                }
                if ("FROM_START" == d || "FROM_END" == d) e += "  " + Blockly.Msg.LISTS_INDEX_FROM_START_TOOLTIP.replace("%1", b.workspace.options.oneBasedIndex ? "#1" : "#0");
                return e;
            });
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation"), b = this.getInput("AT").type == Blockly.INPUT_VALUE;
            a.setAttribute("at", b);
            return a;
        },
        domToMutation: function(a) {
            a = "false" != a.getAttribute("at");
            this.updateAt_(a);
        },
        updateAt_: function(a) {
            this.removeInput("AT");
            this.removeInput("ORDINAL", !0);
            a ? (this.appendValueInput("AT").setCheck("Number"), Blockly.Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
            var b = new Blockly.FieldDropdown(this.WHERE_OPTIONS, function(c) {
                var d = "FROM_START" == c || "FROM_END" == c;
                if (d != a) {
                    var e = this.getSourceBlock();
                    e.updateAt_(d);
                    e.setFieldValue(c, "WHERE");
                    return null;
                }
            });
            this.moveInputBefore("AT", "TO");
            this.getInput("ORDINAL") && this.moveInputBefore("ORDINAL", "TO");
            this.getInput("AT").appendField(b, "WHERE");
        }
    };
    Blockly.Blocks.lists_getSublist = {
        init: function() {
            this.WHERE_OPTIONS_1 = [
                [
                    Blockly.Msg.LISTS_GET_SUBLIST_START_FROM_START,
                    "FROM_START"
                ],
                [
                    Blockly.Msg.LISTS_GET_SUBLIST_START_FROM_END,
                    "FROM_END"
                ],
                [
                    Blockly.Msg.LISTS_GET_SUBLIST_START_FIRST,
                    "FIRST"
                ]
            ];
            this.WHERE_OPTIONS_2 = [
                [
                    Blockly.Msg.LISTS_GET_SUBLIST_END_FROM_START,
                    "FROM_START"
                ],
                [
                    Blockly.Msg.LISTS_GET_SUBLIST_END_FROM_END,
                    "FROM_END"
                ],
                [
                    Blockly.Msg.LISTS_GET_SUBLIST_END_LAST,
                    "LAST"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.LISTS_GET_SUBLIST_HELPURL);
            this.setStyle("list_blocks");
            this.appendValueInput("LIST").setCheck("Array").appendField(Blockly.Msg.LISTS_GET_SUBLIST_INPUT_IN_LIST);
            this.appendDummyInput("AT1");
            this.appendDummyInput("AT2");
            Blockly.Msg.LISTS_GET_SUBLIST_TAIL && this.appendDummyInput("TAIL").appendField(Blockly.Msg.LISTS_GET_SUBLIST_TAIL);
            this.setInputsInline(!0);
            this.setOutput(!0, "Array");
            this.updateAt_(1, !0);
            this.updateAt_(2, !0);
            this.setTooltip(Blockly.Msg.LISTS_GET_SUBLIST_TOOLTIP);
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation"), b = this.getInput("AT1").type == Blockly.INPUT_VALUE;
            a.setAttribute("at1", b);
            b = this.getInput("AT2").type == Blockly.INPUT_VALUE;
            a.setAttribute("at2", b);
            return a;
        },
        domToMutation: function(a) {
            var b = "true" == a.getAttribute("at1");
            a = "true" == a.getAttribute("at2");
            this.updateAt_(1, b);
            this.updateAt_(2, a);
        },
        updateAt_: function(a, b) {
            this.removeInput("AT" + a);
            this.removeInput("ORDINAL" + a, !0);
            b ? (this.appendValueInput("AT" + a).setCheck("Number"), Blockly.Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + a).appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + a);
            var c = new Blockly.FieldDropdown(this["WHERE_OPTIONS_" + a], function(d) {
                var e = "FROM_START" == d || "FROM_END" == d;
                if (e != b) {
                    var f = this.getSourceBlock();
                    f.updateAt_(a, e);
                    f.setFieldValue(d, "WHERE" + a);
                    return null;
                }
            });
            this.getInput("AT" + a).appendField(c, "WHERE" + a);
            1 == a && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2"));
            Blockly.Msg.LISTS_GET_SUBLIST_TAIL && this.moveInputBefore("TAIL", null);
        }
    };
    Blockly.Blocks.lists_sort = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.LISTS_SORT_TITLE,
                args0: [
                    {
                        type: "field_dropdown",
                        name: "TYPE",
                        options: [
                            [
                                Blockly.Msg.LISTS_SORT_TYPE_NUMERIC,
                                "NUMERIC"
                            ],
                            [
                                Blockly.Msg.LISTS_SORT_TYPE_TEXT,
                                "TEXT"
                            ],
                            [
                                Blockly.Msg.LISTS_SORT_TYPE_IGNORECASE,
                                "IGNORE_CASE"
                            ]
                        ]
                    },
                    {
                        type: "field_dropdown",
                        name: "DIRECTION",
                        options: [
                            [
                                Blockly.Msg.LISTS_SORT_ORDER_ASCENDING,
                                "1"
                            ],
                            [
                                Blockly.Msg.LISTS_SORT_ORDER_DESCENDING,
                                "-1"
                            ]
                        ]
                    },
                    {
                        type: "input_value",
                        name: "LIST",
                        check: "Array"
                    }
                ],
                output: "Array",
                style: "list_blocks",
                tooltip: Blockly.Msg.LISTS_SORT_TOOLTIP,
                helpUrl: Blockly.Msg.LISTS_SORT_HELPURL
            });
        }
    };
    Blockly.Blocks.lists_split = {
        init: function() {
            var a = this, b = new Blockly.FieldDropdown([
                [
                    Blockly.Msg.LISTS_SPLIT_LIST_FROM_TEXT,
                    "SPLIT"
                ],
                [
                    Blockly.Msg.LISTS_SPLIT_TEXT_FROM_LIST,
                    "JOIN"
                ]
            ], function(c) {
                a.updateType_(c);
            });
            this.setHelpUrl(Blockly.Msg.LISTS_SPLIT_HELPURL);
            this.setStyle("list_blocks");
            this.appendValueInput("INPUT").setCheck("String").appendField(b, "MODE");
            this.appendValueInput("DELIM").setCheck("String").appendField(Blockly.Msg.LISTS_SPLIT_WITH_DELIMITER);
            this.setInputsInline(!0);
            this.setOutput(!0, "Array");
            this.setTooltip(function() {
                var c = a.getFieldValue("MODE");
                if ("SPLIT" == c) return Blockly.Msg.LISTS_SPLIT_TOOLTIP_SPLIT;
                if ("JOIN" == c) return Blockly.Msg.LISTS_SPLIT_TOOLTIP_JOIN;
                throw Error("Unknown mode: " + c);
            });
        },
        updateType_: function(a) {
            if (this.getFieldValue("MODE") != a) {
                var b = this.getInput("INPUT").connection;
                b.setShadowDom(null);
                var c = b.targetBlock();
                c && (b.disconnect(), c.isShadow() ? c.dispose() : this.bumpNeighbours());
            }
            "SPLIT" == a ? (this.outputConnection.setCheck("Array"), this.getInput("INPUT").setCheck("String")) : (this.outputConnection.setCheck("String"), this.getInput("INPUT").setCheck("Array"));
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("mode", this.getFieldValue("MODE"));
            return a;
        },
        domToMutation: function(a) {
            this.updateType_(a.getAttribute("mode"));
        }
    };
    Blockly.Blocks.logic = {};
    Blockly.Constants.Logic = {};
    Blockly.Constants.Logic.HUE = 210;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "logic_boolean",
            message0: "%1",
            args0: [
                {
                    type: "field_dropdown",
                    name: "BOOL",
                    options: [
                        [
                            "%{BKY_LOGIC_BOOLEAN_TRUE}",
                            "TRUE"
                        ],
                        [
                            "%{BKY_LOGIC_BOOLEAN_FALSE}",
                            "FALSE"
                        ]
                    ]
                }
            ],
            output: "Boolean",
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_BOOLEAN_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_BOOLEAN_HELPURL}"
        },
        {
            type: "controls_if",
            message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
            args0: [
                {
                    type: "input_value",
                    name: "IF0",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO0"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "logic_blocks",
            helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
            mutator: "controls_if_mutator",
            extensions: [
                "controls_if_tooltip"
            ]
        },
        {
            type: "controls_ifelse",
            message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
            args0: [
                {
                    type: "input_value",
                    name: "IF0",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO0"
                }
            ],
            message2: "%{BKY_CONTROLS_IF_MSG_ELSE} %1",
            args2: [
                {
                    type: "input_statement",
                    name: "ELSE"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "logic_blocks",
            tooltip: "%{BKYCONTROLS_IF_TOOLTIP_2}",
            helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
            extensions: [
                "controls_if_tooltip"
            ]
        },
        {
            type: "logic_compare",
            message0: "%1 %2 %3",
            args0: [
                {
                    type: "input_value",
                    name: "A"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "=",
                            "EQ"
                        ],
                        [
                            "\u2260",
                            "NEQ"
                        ],
                        [
                            "\u200f<",
                            "LT"
                        ],
                        [
                            "\u200f\u2264",
                            "LTE"
                        ],
                        [
                            "\u200f>",
                            "GT"
                        ],
                        [
                            "\u200f\u2265",
                            "GTE"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "B"
                }
            ],
            inputsInline: !0,
            output: "Boolean",
            style: "logic_blocks",
            helpUrl: "%{BKY_LOGIC_COMPARE_HELPURL}",
            extensions: [
                "logic_compare",
                "logic_op_tooltip"
            ]
        },
        {
            type: "logic_operation",
            message0: "%1 %2 %3",
            args0: [
                {
                    type: "input_value",
                    name: "A",
                    check: "Boolean"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_LOGIC_OPERATION_AND}",
                            "AND"
                        ],
                        [
                            "%{BKY_LOGIC_OPERATION_OR}",
                            "OR"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "B",
                    check: "Boolean"
                }
            ],
            inputsInline: !0,
            output: "Boolean",
            style: "logic_blocks",
            helpUrl: "%{BKY_LOGIC_OPERATION_HELPURL}",
            extensions: [
                "logic_op_tooltip"
            ]
        },
        {
            type: "logic_negate",
            message0: "%{BKY_LOGIC_NEGATE_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "BOOL",
                    check: "Boolean"
                }
            ],
            output: "Boolean",
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_NEGATE_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_NEGATE_HELPURL}"
        },
        {
            type: "logic_null",
            message0: "%{BKY_LOGIC_NULL}",
            output: null,
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_NULL_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_NULL_HELPURL}"
        },
        {
            type: "logic_ternary",
            message0: "%{BKY_LOGIC_TERNARY_CONDITION} %1",
            args0: [
                {
                    type: "input_value",
                    name: "IF",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_LOGIC_TERNARY_IF_TRUE} %1",
            args1: [
                {
                    type: "input_value",
                    name: "THEN"
                }
            ],
            message2: "%{BKY_LOGIC_TERNARY_IF_FALSE} %1",
            args2: [
                {
                    type: "input_value",
                    name: "ELSE"
                }
            ],
            output: null,
            style: "logic_blocks",
            tooltip: "%{BKY_LOGIC_TERNARY_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_TERNARY_HELPURL}",
            extensions: [
                "logic_ternary"
            ]
        }
    ]);
    Blockly.defineBlocksWithJsonArray([
        {
            type: "controls_if_if",
            message0: "%{BKY_CONTROLS_IF_IF_TITLE_IF}",
            nextStatement: null,
            enableContextMenu: !1,
            style: "logic_blocks",
            tooltip: "%{BKY_CONTROLS_IF_IF_TOOLTIP}"
        },
        {
            type: "controls_if_elseif",
            message0: "%{BKY_CONTROLS_IF_ELSEIF_TITLE_ELSEIF}",
            previousStatement: null,
            nextStatement: null,
            enableContextMenu: !1,
            style: "logic_blocks",
            tooltip: "%{BKY_CONTROLS_IF_ELSEIF_TOOLTIP}"
        },
        {
            type: "controls_if_else",
            message0: "%{BKY_CONTROLS_IF_ELSE_TITLE_ELSE}",
            previousStatement: null,
            enableContextMenu: !1,
            style: "logic_blocks",
            tooltip: "%{BKY_CONTROLS_IF_ELSE_TOOLTIP}"
        }
    ]);
    Blockly.Constants.Logic.TOOLTIPS_BY_OP = {
        EQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_EQ}",
        NEQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_NEQ}",
        LT: "%{BKY_LOGIC_COMPARE_TOOLTIP_LT}",
        LTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_LTE}",
        GT: "%{BKY_LOGIC_COMPARE_TOOLTIP_GT}",
        GTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_GTE}",
        AND: "%{BKY_LOGIC_OPERATION_TOOLTIP_AND}",
        OR: "%{BKY_LOGIC_OPERATION_TOOLTIP_OR}"
    };
    Blockly.Extensions.register("logic_op_tooltip", Blockly.Extensions.buildTooltipForDropdown("OP", Blockly.Constants.Logic.TOOLTIPS_BY_OP));
    Blockly.Constants.Logic.CONTROLS_IF_MUTATOR_MIXIN = {
        elseifCount_: 0,
        elseCount_: 0,
        suppressPrefixSuffix: !0,
        mutationToDom: function() {
            if (!this.elseifCount_ && !this.elseCount_) return null;
            var a = Blockly.utils.xml.createElement("mutation");
            this.elseifCount_ && a.setAttribute("elseif", this.elseifCount_);
            this.elseCount_ && a.setAttribute("else", 1);
            return a;
        },
        domToMutation: function(a) {
            this.elseifCount_ = parseInt(a.getAttribute("elseif"), 10) || 0;
            this.elseCount_ = parseInt(a.getAttribute("else"), 10) || 0;
            this.rebuildShape_();
        },
        decompose: function(a) {
            var b = a.newBlock("controls_if_if");
            b.initSvg();
            for(var c = b.nextConnection, d = 1; d <= this.elseifCount_; d++){
                var e = a.newBlock("controls_if_elseif");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection;
            }
            this.elseCount_ && (a = a.newBlock("controls_if_else"), a.initSvg(), c.connect(a.previousConnection));
            return b;
        },
        compose: function(a) {
            a = a.nextConnection.targetBlock();
            this.elseCount_ = this.elseifCount_ = 0;
            for(var b = [
                null
            ], c = [
                null
            ], d = null; a && !a.isInsertionMarker();){
                switch(a.type){
                    case "controls_if_elseif":
                        this.elseifCount_++;
                        b.push(a.valueConnection_);
                        c.push(a.statementConnection_);
                        break;
                    case "controls_if_else":
                        this.elseCount_++;
                        d = a.statementConnection_;
                        break;
                    default:
                        throw TypeError("Unknown block type: " + a.type);
                }
                a = a.nextConnection && a.nextConnection.targetBlock();
            }
            this.updateShape_();
            this.reconnectChildBlocks_(b, c, d);
        },
        saveConnections: function(a) {
            a = a.nextConnection.targetBlock();
            for(var b = 1; a;){
                switch(a.type){
                    case "controls_if_elseif":
                        var c = this.getInput("IF" + b), d = this.getInput("DO" + b);
                        a.valueConnection_ = c && c.connection.targetConnection;
                        a.statementConnection_ = d && d.connection.targetConnection;
                        b++;
                        break;
                    case "controls_if_else":
                        d = this.getInput("ELSE");
                        a.statementConnection_ = d && d.connection.targetConnection;
                        break;
                    default:
                        throw TypeError("Unknown block type: " + a.type);
                }
                a = a.nextConnection && a.nextConnection.targetBlock();
            }
        },
        rebuildShape_: function() {
            var a = [
                null
            ], b = [
                null
            ], c = null;
            this.getInput("ELSE") && (c = this.getInput("ELSE").connection.targetConnection);
            for(var d = 1; this.getInput("IF" + d);){
                var e = this.getInput("IF" + d), f = this.getInput("DO" + d);
                a.push(e.connection.targetConnection);
                b.push(f.connection.targetConnection);
                d++;
            }
            this.updateShape_();
            this.reconnectChildBlocks_(a, b, c);
        },
        updateShape_: function() {
            this.getInput("ELSE") && this.removeInput("ELSE");
            for(var a = 1; this.getInput("IF" + a);)this.removeInput("IF" + a), this.removeInput("DO" + a), a++;
            for(a = 1; a <= this.elseifCount_; a++)this.appendValueInput("IF" + a).setCheck("Boolean").appendField(Blockly.Msg.CONTROLS_IF_MSG_ELSEIF), this.appendStatementInput("DO" + a).appendField(Blockly.Msg.CONTROLS_IF_MSG_THEN);
            this.elseCount_ && this.appendStatementInput("ELSE").appendField(Blockly.Msg.CONTROLS_IF_MSG_ELSE);
        },
        reconnectChildBlocks_: function(a, b, c) {
            for(var d = 1; d <= this.elseifCount_; d++)Blockly.Mutator.reconnect(a[d], this, "IF" + d), Blockly.Mutator.reconnect(b[d], this, "DO" + d);
            Blockly.Mutator.reconnect(c, this, "ELSE");
        }
    };
    Blockly.Extensions.registerMutator("controls_if_mutator", Blockly.Constants.Logic.CONTROLS_IF_MUTATOR_MIXIN, null, [
        "controls_if_elseif",
        "controls_if_else"
    ]);
    Blockly.Constants.Logic.CONTROLS_IF_TOOLTIP_EXTENSION = function() {
        this.setTooltip((function() {
            if (this.elseifCount_ || this.elseCount_) {
                if (!this.elseifCount_ && this.elseCount_) return Blockly.Msg.CONTROLS_IF_TOOLTIP_2;
                if (this.elseifCount_ && !this.elseCount_) return Blockly.Msg.CONTROLS_IF_TOOLTIP_3;
                if (this.elseifCount_ && this.elseCount_) return Blockly.Msg.CONTROLS_IF_TOOLTIP_4;
            } else return Blockly.Msg.CONTROLS_IF_TOOLTIP_1;
            return "";
        }).bind(this));
    };
    Blockly.Extensions.register("controls_if_tooltip", Blockly.Constants.Logic.CONTROLS_IF_TOOLTIP_EXTENSION);
    Blockly.Constants.Logic.LOGIC_COMPARE_ONCHANGE_MIXIN = {
        onchange: function(a) {
            this.prevBlocks_ || (this.prevBlocks_ = [
                null,
                null
            ]);
            var b = this.getInputTargetBlock("A"), c = this.getInputTargetBlock("B");
            b && c && !this.workspace.connectionChecker.doTypeChecks(b.outputConnection, c.outputConnection) && (Blockly.Events.setGroup(a.group), a = this.prevBlocks_[0], a !== b && (b.unplug(), !a || a.isDisposed() || a.isShadow() || this.getInput("A").connection.connect(a.outputConnection)), b = this.prevBlocks_[1], b !== c && (c.unplug(), !b || b.isDisposed() || b.isShadow() || this.getInput("B").connection.connect(b.outputConnection)), this.bumpNeighbours(), Blockly.Events.setGroup(!1));
            this.prevBlocks_[0] = this.getInputTargetBlock("A");
            this.prevBlocks_[1] = this.getInputTargetBlock("B");
        }
    };
    Blockly.Constants.Logic.LOGIC_COMPARE_EXTENSION = function() {
        this.mixin(Blockly.Constants.Logic.LOGIC_COMPARE_ONCHANGE_MIXIN);
    };
    Blockly.Extensions.register("logic_compare", Blockly.Constants.Logic.LOGIC_COMPARE_EXTENSION);
    Blockly.Constants.Logic.LOGIC_TERNARY_ONCHANGE_MIXIN = {
        prevParentConnection_: null,
        onchange: function(a) {
            var b = this.getInputTargetBlock("THEN"), c = this.getInputTargetBlock("ELSE"), d = this.outputConnection.targetConnection;
            if ((b || c) && d) for(var e = 0; 2 > e; e++){
                var f = 1 == e ? b : c;
                f && !f.workspace.connectionChecker.doTypeChecks(f.outputConnection, d) && (Blockly.Events.setGroup(a.group), d === this.prevParentConnection_ ? (this.unplug(), d.getSourceBlock().bumpNeighbours()) : (f.unplug(), f.bumpNeighbours()), Blockly.Events.setGroup(!1));
            }
            this.prevParentConnection_ = d;
        }
    };
    Blockly.Extensions.registerMixin("logic_ternary", Blockly.Constants.Logic.LOGIC_TERNARY_ONCHANGE_MIXIN);
    Blockly.Blocks.loops = {};
    Blockly.Constants.Loops = {};
    Blockly.Constants.Loops.HUE = 120;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "controls_repeat_ext",
            message0: "%{BKY_CONTROLS_REPEAT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "TIMES",
                    check: "Number"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
        },
        {
            type: "controls_repeat",
            message0: "%{BKY_CONTROLS_REPEAT_TITLE}",
            args0: [
                {
                    type: "field_number",
                    name: "TIMES",
                    value: 10,
                    min: 0,
                    precision: 1
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
            helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
        },
        {
            type: "controls_whileUntil",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [
                            "%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}",
                            "WHILE"
                        ],
                        [
                            "%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}",
                            "UNTIL"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "BOOL",
                    check: "Boolean"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_WHILEUNTIL_HELPURL}",
            extensions: [
                "controls_whileUntil_tooltip"
            ]
        },
        {
            type: "controls_for",
            message0: "%{BKY_CONTROLS_FOR_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: null
                },
                {
                    type: "input_value",
                    name: "FROM",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "TO",
                    check: "Number",
                    align: "RIGHT"
                },
                {
                    type: "input_value",
                    name: "BY",
                    check: "Number",
                    align: "RIGHT"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            inputsInline: !0,
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FOR_HELPURL}",
            extensions: [
                "contextMenu_newGetVariableBlock",
                "controls_for_tooltip"
            ]
        },
        {
            type: "controls_forEach",
            message0: "%{BKY_CONTROLS_FOREACH_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: null
                },
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
            args1: [
                {
                    type: "input_statement",
                    name: "DO"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FOREACH_HELPURL}",
            extensions: [
                "contextMenu_newGetVariableBlock",
                "controls_forEach_tooltip"
            ]
        },
        {
            type: "controls_flow_statements",
            message0: "%1",
            args0: [
                {
                    type: "field_dropdown",
                    name: "FLOW",
                    options: [
                        [
                            "%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK}",
                            "BREAK"
                        ],
                        [
                            "%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE}",
                            "CONTINUE"
                        ]
                    ]
                }
            ],
            previousStatement: null,
            style: "loop_blocks",
            helpUrl: "%{BKY_CONTROLS_FLOW_STATEMENTS_HELPURL}",
            extensions: [
                "controls_flow_tooltip",
                "controls_flow_in_loop_check"
            ]
        }
    ]);
    Blockly.Constants.Loops.WHILE_UNTIL_TOOLTIPS = {
        WHILE: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE}",
        UNTIL: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL}"
    };
    Blockly.Extensions.register("controls_whileUntil_tooltip", Blockly.Extensions.buildTooltipForDropdown("MODE", Blockly.Constants.Loops.WHILE_UNTIL_TOOLTIPS));
    Blockly.Constants.Loops.BREAK_CONTINUE_TOOLTIPS = {
        BREAK: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK}",
        CONTINUE: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE}"
    };
    Blockly.Extensions.register("controls_flow_tooltip", Blockly.Extensions.buildTooltipForDropdown("FLOW", Blockly.Constants.Loops.BREAK_CONTINUE_TOOLTIPS));
    Blockly.Constants.Loops.CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN = {
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                var b = this.getField("VAR").getVariable(), c = b.name;
                if (!this.isCollapsed() && null != c) {
                    var d = {
                        enabled: !0
                    };
                    d.text = Blockly.Msg.VARIABLES_SET_CREATE_GET.replace("%1", c);
                    b = Blockly.Variables.generateVariableFieldDom(b);
                    c = Blockly.utils.xml.createElement("block");
                    c.setAttribute("type", "variables_get");
                    c.appendChild(b);
                    d.callback = Blockly.ContextMenu.callbackFactory(this, c);
                    a.push(d);
                }
            }
        }
    };
    Blockly.Extensions.registerMixin("contextMenu_newGetVariableBlock", Blockly.Constants.Loops.CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN);
    Blockly.Extensions.register("controls_for_tooltip", Blockly.Extensions.buildTooltipWithFieldText("%{BKY_CONTROLS_FOR_TOOLTIP}", "VAR"));
    Blockly.Extensions.register("controls_forEach_tooltip", Blockly.Extensions.buildTooltipWithFieldText("%{BKY_CONTROLS_FOREACH_TOOLTIP}", "VAR"));
    Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN = {
        LOOP_TYPES: [
            "controls_repeat",
            "controls_repeat_ext",
            "controls_forEach",
            "controls_for",
            "controls_whileUntil"
        ],
        suppressPrefixSuffix: !0,
        getSurroundLoop: function(a) {
            do {
                if (-1 != Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.LOOP_TYPES.indexOf(a.type)) return a;
                a = a.getSurroundParent();
            }while (a);
            return null;
        },
        onchange: function(a) {
            if (this.workspace.isDragging && !this.workspace.isDragging() && a.type == Blockly.Events.BLOCK_MOVE) {
                var b = Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.getSurroundLoop(this);
                this.setWarningText(b ? null : Blockly.Msg.CONTROLS_FLOW_STATEMENTS_WARNING);
                if (!this.isInFlyout) {
                    var c = Blockly.Events.getGroup();
                    Blockly.Events.setGroup(a.group);
                    this.setEnabled(b);
                    Blockly.Events.setGroup(c);
                }
            }
        }
    };
    Blockly.Extensions.registerMixin("controls_flow_in_loop_check", Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN);
    Blockly.Blocks.math = {};
    Blockly.Constants.Math = {};
    Blockly.Constants.Math.HUE = 230;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "math_number",
            message0: "%1",
            args0: [
                {
                    type: "field_number",
                    name: "NUM",
                    value: 0
                }
            ],
            output: "Number",
            helpUrl: "%{BKY_MATH_NUMBER_HELPURL}",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_NUMBER_TOOLTIP}",
            extensions: [
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "math_arithmetic",
            message0: "%1 %2 %3",
            args0: [
                {
                    type: "input_value",
                    name: "A",
                    check: "Number"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_ADDITION_SYMBOL}",
                            "ADD"
                        ],
                        [
                            "%{BKY_MATH_SUBTRACTION_SYMBOL}",
                            "MINUS"
                        ],
                        [
                            "%{BKY_MATH_MULTIPLICATION_SYMBOL}",
                            "MULTIPLY"
                        ],
                        [
                            "%{BKY_MATH_DIVISION_SYMBOL}",
                            "DIVIDE"
                        ],
                        [
                            "%{BKY_MATH_POWER_SYMBOL}",
                            "POWER"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "B",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ARITHMETIC_HELPURL}",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_single",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_SINGLE_OP_ROOT}",
                            "ROOT"
                        ],
                        [
                            "%{BKY_MATH_SINGLE_OP_ABSOLUTE}",
                            "ABS"
                        ],
                        [
                            "-",
                            "NEG"
                        ],
                        [
                            "ln",
                            "LN"
                        ],
                        [
                            "log10",
                            "LOG10"
                        ],
                        [
                            "e^",
                            "EXP"
                        ],
                        [
                            "10^",
                            "POW10"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_SINGLE_HELPURL}",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_trig",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_TRIG_SIN}",
                            "SIN"
                        ],
                        [
                            "%{BKY_MATH_TRIG_COS}",
                            "COS"
                        ],
                        [
                            "%{BKY_MATH_TRIG_TAN}",
                            "TAN"
                        ],
                        [
                            "%{BKY_MATH_TRIG_ASIN}",
                            "ASIN"
                        ],
                        [
                            "%{BKY_MATH_TRIG_ACOS}",
                            "ACOS"
                        ],
                        [
                            "%{BKY_MATH_TRIG_ATAN}",
                            "ATAN"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_TRIG_HELPURL}",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_constant",
            message0: "%1",
            args0: [
                {
                    type: "field_dropdown",
                    name: "CONSTANT",
                    options: [
                        [
                            "\u03c0",
                            "PI"
                        ],
                        [
                            "e",
                            "E"
                        ],
                        [
                            "\u03c6",
                            "GOLDEN_RATIO"
                        ],
                        [
                            "sqrt(2)",
                            "SQRT2"
                        ],
                        [
                            "sqrt(\u00bd)",
                            "SQRT1_2"
                        ],
                        [
                            "\u221e",
                            "INFINITY"
                        ]
                    ]
                }
            ],
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_CONSTANT_TOOLTIP}",
            helpUrl: "%{BKY_MATH_CONSTANT_HELPURL}"
        },
        {
            type: "math_number_property",
            message0: "%1 %2",
            args0: [
                {
                    type: "input_value",
                    name: "NUMBER_TO_CHECK",
                    check: "Number"
                },
                {
                    type: "field_dropdown",
                    name: "PROPERTY",
                    options: [
                        [
                            "%{BKY_MATH_IS_EVEN}",
                            "EVEN"
                        ],
                        [
                            "%{BKY_MATH_IS_ODD}",
                            "ODD"
                        ],
                        [
                            "%{BKY_MATH_IS_PRIME}",
                            "PRIME"
                        ],
                        [
                            "%{BKY_MATH_IS_WHOLE}",
                            "WHOLE"
                        ],
                        [
                            "%{BKY_MATH_IS_POSITIVE}",
                            "POSITIVE"
                        ],
                        [
                            "%{BKY_MATH_IS_NEGATIVE}",
                            "NEGATIVE"
                        ],
                        [
                            "%{BKY_MATH_IS_DIVISIBLE_BY}",
                            "DIVISIBLE_BY"
                        ]
                    ]
                }
            ],
            inputsInline: !0,
            output: "Boolean",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_IS_TOOLTIP}",
            mutator: "math_is_divisibleby_mutator"
        },
        {
            type: "math_change",
            message0: "%{BKY_MATH_CHANGE_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_MATH_CHANGE_TITLE_ITEM}"
                },
                {
                    type: "input_value",
                    name: "DELTA",
                    check: "Number"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "variable_blocks",
            helpUrl: "%{BKY_MATH_CHANGE_HELPURL}",
            extensions: [
                "math_change_tooltip"
            ]
        },
        {
            type: "math_round",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_ROUND_OPERATOR_ROUND}",
                            "ROUND"
                        ],
                        [
                            "%{BKY_MATH_ROUND_OPERATOR_ROUNDUP}",
                            "ROUNDUP"
                        ],
                        [
                            "%{BKY_MATH_ROUND_OPERATOR_ROUNDDOWN}",
                            "ROUNDDOWN"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ROUND_HELPURL}",
            tooltip: "%{BKY_MATH_ROUND_TOOLTIP}"
        },
        {
            type: "math_on_list",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_SUM}",
                            "SUM"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MIN}",
                            "MIN"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MAX}",
                            "MAX"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}",
                            "AVERAGE"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}",
                            "MEDIAN"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_MODE}",
                            "MODE"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}",
                            "STD_DEV"
                        ],
                        [
                            "%{BKY_MATH_ONLIST_OPERATOR_RANDOM}",
                            "RANDOM"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ONLIST_HELPURL}",
            mutator: "math_modes_of_list_mutator",
            extensions: [
                "math_op_tooltip"
            ]
        },
        {
            type: "math_modulo",
            message0: "%{BKY_MATH_MODULO_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "DIVIDEND",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "DIVISOR",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_MODULO_TOOLTIP}",
            helpUrl: "%{BKY_MATH_MODULO_HELPURL}"
        },
        {
            type: "math_constrain",
            message0: "%{BKY_MATH_CONSTRAIN_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "LOW",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "HIGH",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_CONSTRAIN_TOOLTIP}",
            helpUrl: "%{BKY_MATH_CONSTRAIN_HELPURL}"
        },
        {
            type: "math_random_int",
            message0: "%{BKY_MATH_RANDOM_INT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "FROM",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "TO",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_RANDOM_INT_TOOLTIP}",
            helpUrl: "%{BKY_MATH_RANDOM_INT_HELPURL}"
        },
        {
            type: "math_random_float",
            message0: "%{BKY_MATH_RANDOM_FLOAT_TITLE_RANDOM}",
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_RANDOM_FLOAT_TOOLTIP}",
            helpUrl: "%{BKY_MATH_RANDOM_FLOAT_HELPURL}"
        },
        {
            type: "math_atan2",
            message0: "%{BKY_MATH_ATAN2_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "X",
                    check: "Number"
                },
                {
                    type: "input_value",
                    name: "Y",
                    check: "Number"
                }
            ],
            inputsInline: !0,
            output: "Number",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_ATAN2_TOOLTIP}",
            helpUrl: "%{BKY_MATH_ATAN2_HELPURL}"
        }
    ]);
    Blockly.Constants.Math.TOOLTIPS_BY_OP = {
        ADD: "%{BKY_MATH_ARITHMETIC_TOOLTIP_ADD}",
        MINUS: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MINUS}",
        MULTIPLY: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MULTIPLY}",
        DIVIDE: "%{BKY_MATH_ARITHMETIC_TOOLTIP_DIVIDE}",
        POWER: "%{BKY_MATH_ARITHMETIC_TOOLTIP_POWER}",
        ROOT: "%{BKY_MATH_SINGLE_TOOLTIP_ROOT}",
        ABS: "%{BKY_MATH_SINGLE_TOOLTIP_ABS}",
        NEG: "%{BKY_MATH_SINGLE_TOOLTIP_NEG}",
        LN: "%{BKY_MATH_SINGLE_TOOLTIP_LN}",
        LOG10: "%{BKY_MATH_SINGLE_TOOLTIP_LOG10}",
        EXP: "%{BKY_MATH_SINGLE_TOOLTIP_EXP}",
        POW10: "%{BKY_MATH_SINGLE_TOOLTIP_POW10}",
        SIN: "%{BKY_MATH_TRIG_TOOLTIP_SIN}",
        COS: "%{BKY_MATH_TRIG_TOOLTIP_COS}",
        TAN: "%{BKY_MATH_TRIG_TOOLTIP_TAN}",
        ASIN: "%{BKY_MATH_TRIG_TOOLTIP_ASIN}",
        ACOS: "%{BKY_MATH_TRIG_TOOLTIP_ACOS}",
        ATAN: "%{BKY_MATH_TRIG_TOOLTIP_ATAN}",
        SUM: "%{BKY_MATH_ONLIST_TOOLTIP_SUM}",
        MIN: "%{BKY_MATH_ONLIST_TOOLTIP_MIN}",
        MAX: "%{BKY_MATH_ONLIST_TOOLTIP_MAX}",
        AVERAGE: "%{BKY_MATH_ONLIST_TOOLTIP_AVERAGE}",
        MEDIAN: "%{BKY_MATH_ONLIST_TOOLTIP_MEDIAN}",
        MODE: "%{BKY_MATH_ONLIST_TOOLTIP_MODE}",
        STD_DEV: "%{BKY_MATH_ONLIST_TOOLTIP_STD_DEV}",
        RANDOM: "%{BKY_MATH_ONLIST_TOOLTIP_RANDOM}"
    };
    Blockly.Extensions.register("math_op_tooltip", Blockly.Extensions.buildTooltipForDropdown("OP", Blockly.Constants.Math.TOOLTIPS_BY_OP));
    Blockly.Constants.Math.IS_DIVISIBLEBY_MUTATOR_MIXIN = {
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation"), b = "DIVISIBLE_BY" == this.getFieldValue("PROPERTY");
            a.setAttribute("divisor_input", b);
            return a;
        },
        domToMutation: function(a) {
            a = "true" == a.getAttribute("divisor_input");
            this.updateShape_(a);
        },
        updateShape_: function(a) {
            var b = this.getInput("DIVISOR");
            a ? b || this.appendValueInput("DIVISOR").setCheck("Number") : b && this.removeInput("DIVISOR");
        }
    };
    Blockly.Constants.Math.IS_DIVISIBLE_MUTATOR_EXTENSION = function() {
        this.getField("PROPERTY").setValidator(function(a) {
            a = "DIVISIBLE_BY" == a;
            this.getSourceBlock().updateShape_(a);
        });
    };
    Blockly.Extensions.registerMutator("math_is_divisibleby_mutator", Blockly.Constants.Math.IS_DIVISIBLEBY_MUTATOR_MIXIN, Blockly.Constants.Math.IS_DIVISIBLE_MUTATOR_EXTENSION);
    Blockly.Extensions.register("math_change_tooltip", Blockly.Extensions.buildTooltipWithFieldText("%{BKY_MATH_CHANGE_TOOLTIP}", "VAR"));
    Blockly.Constants.Math.LIST_MODES_MUTATOR_MIXIN = {
        updateType_: function(a) {
            "MODE" == a ? this.outputConnection.setCheck("Array") : this.outputConnection.setCheck("Number");
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("op", this.getFieldValue("OP"));
            return a;
        },
        domToMutation: function(a) {
            this.updateType_(a.getAttribute("op"));
        }
    };
    Blockly.Constants.Math.LIST_MODES_MUTATOR_EXTENSION = function() {
        this.getField("OP").setValidator((function(a) {
            this.updateType_(a);
        }).bind(this));
    };
    Blockly.Extensions.registerMutator("math_modes_of_list_mutator", Blockly.Constants.Math.LIST_MODES_MUTATOR_MIXIN, Blockly.Constants.Math.LIST_MODES_MUTATOR_EXTENSION);
    Blockly.Blocks.procedures = {};
    Blockly.Blocks.procedures_defnoreturn = {
        init: function() {
            var a = Blockly.Procedures.findLegalName("", this);
            a = new Blockly.FieldTextInput(a, Blockly.Procedures.rename);
            a.setSpellcheck(!1);
            this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_DEFNORETURN_TITLE).appendField(a, "NAME").appendField("", "PARAMS");
            this.setMutator(new Blockly.Mutator([
                "procedures_mutatorarg"
            ]));
            (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && Blockly.Msg.PROCEDURES_DEFNORETURN_COMMENT && this.setCommentText(Blockly.Msg.PROCEDURES_DEFNORETURN_COMMENT);
            this.setStyle("procedure_blocks");
            this.setTooltip(Blockly.Msg.PROCEDURES_DEFNORETURN_TOOLTIP);
            this.setHelpUrl(Blockly.Msg.PROCEDURES_DEFNORETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.setStatements_(!0);
            this.statementConnection_ = null;
        },
        setStatements_: function(a) {
            this.hasStatements_ !== a && (a ? (this.appendStatementInput("STACK").appendField(Blockly.Msg.PROCEDURES_DEFNORETURN_DO), this.getInput("RETURN") && this.moveInputBefore("STACK", "RETURN")) : this.removeInput("STACK", !0), this.hasStatements_ = a);
        },
        updateParams_: function() {
            var a = "";
            this.arguments_.length && (a = Blockly.Msg.PROCEDURES_BEFORE_PARAMS + " " + this.arguments_.join(", "));
            Blockly.Events.disable();
            try {
                this.setFieldValue(a, "PARAMS");
            } finally{
                Blockly.Events.enable();
            }
        },
        mutationToDom: function(a) {
            var b = Blockly.utils.xml.createElement("mutation");
            a && b.setAttribute("name", this.getFieldValue("NAME"));
            for(var c = 0; c < this.argumentVarModels_.length; c++){
                var d = Blockly.utils.xml.createElement("arg"), e = this.argumentVarModels_[c];
                d.setAttribute("name", e.name);
                d.setAttribute("varid", e.getId());
                a && this.paramIds_ && d.setAttribute("paramId", this.paramIds_[c]);
                b.appendChild(d);
            }
            this.hasStatements_ || b.setAttribute("statements", "false");
            return b;
        },
        domToMutation: function(a) {
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            for(var b = 0, c; c = a.childNodes[b]; b++)if ("arg" == c.nodeName.toLowerCase()) {
                var d = c.getAttribute("name");
                c = c.getAttribute("varid") || c.getAttribute("varId");
                this.arguments_.push(d);
                c = Blockly.Variables.getOrCreateVariablePackage(this.workspace, c, d, "");
                null != c ? this.argumentVarModels_.push(c) : console.log("Failed to create a variable with name " + d + ", ignoring.");
            }
            this.updateParams_();
            Blockly.Procedures.mutateCallers(this);
            this.setStatements_("false" !== a.getAttribute("statements"));
        },
        decompose: function(a) {
            var b = Blockly.utils.xml.createElement("block");
            b.setAttribute("type", "procedures_mutatorcontainer");
            var c = Blockly.utils.xml.createElement("statement");
            c.setAttribute("name", "STACK");
            b.appendChild(c);
            for(var d = 0; d < this.arguments_.length; d++){
                var e = Blockly.utils.xml.createElement("block");
                e.setAttribute("type", "procedures_mutatorarg");
                var f = Blockly.utils.xml.createElement("field");
                f.setAttribute("name", "NAME");
                var g = Blockly.utils.xml.createTextNode(this.arguments_[d]);
                f.appendChild(g);
                e.appendChild(f);
                f = Blockly.utils.xml.createElement("next");
                e.appendChild(f);
                c.appendChild(e);
                c = f;
            }
            a = Blockly.Xml.domToBlock(b, a);
            "procedures_defreturn" == this.type ? a.setFieldValue(this.hasStatements_, "STATEMENTS") : a.removeInput("STATEMENT_INPUT");
            Blockly.Procedures.mutateCallers(this);
            return a;
        },
        compose: function(a) {
            this.arguments_ = [];
            this.paramIds_ = [];
            this.argumentVarModels_ = [];
            for(var b = a.getInputTargetBlock("STACK"); b && !b.isInsertionMarker();){
                var c = b.getFieldValue("NAME");
                this.arguments_.push(c);
                c = this.workspace.getVariable(c, "");
                this.argumentVarModels_.push(c);
                this.paramIds_.push(b.id);
                b = b.nextConnection && b.nextConnection.targetBlock();
            }
            this.updateParams_();
            Blockly.Procedures.mutateCallers(this);
            a = a.getFieldValue("STATEMENTS");
            if (null !== a && (a = "TRUE" == a, this.hasStatements_ != a)) {
                if (a) this.setStatements_(!0), Blockly.Mutator.reconnect(this.statementConnection_, this, "STACK"), this.statementConnection_ = null;
                else {
                    a = this.getInput("STACK").connection;
                    if (this.statementConnection_ = a.targetConnection) a = a.targetBlock(), a.unplug(), a.bumpNeighbours();
                    this.setStatements_(!1);
                }
            }
        },
        getProcedureDef: function() {
            return [
                this.getFieldValue("NAME"),
                this.arguments_,
                !1
            ];
        },
        getVars: function() {
            return this.arguments_;
        },
        getVarModels: function() {
            return this.argumentVarModels_;
        },
        renameVarById: function(a, b) {
            var c = this.workspace.getVariableById(a);
            if ("" == c.type) {
                c = c.name;
                b = this.workspace.getVariableById(b);
                for(var d = !1, e = 0; e < this.argumentVarModels_.length; e++)this.argumentVarModels_[e].getId() == a && (this.arguments_[e] = b.name, this.argumentVarModels_[e] = b, d = !0);
                d && (this.displayRenamedVar_(c, b.name), Blockly.Procedures.mutateCallers(this));
            }
        },
        updateVarName: function(a) {
            for(var b = a.name, c = !1, d = 0; d < this.argumentVarModels_.length; d++)if (this.argumentVarModels_[d].getId() == a.getId()) {
                var e = this.arguments_[d];
                this.arguments_[d] = b;
                c = !0;
            }
            c && (this.displayRenamedVar_(e, b), Blockly.Procedures.mutateCallers(this));
        },
        displayRenamedVar_: function(a, b) {
            this.updateParams_();
            if (this.mutator && this.mutator.isVisible()) for(var c = this.mutator.workspace_.getAllBlocks(!1), d = 0, e; e = c[d]; d++)"procedures_mutatorarg" == e.type && Blockly.Names.equals(a, e.getFieldValue("NAME")) && e.setFieldValue(b, "NAME");
        },
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                var b = {
                    enabled: !0
                }, c = this.getFieldValue("NAME");
                b.text = Blockly.Msg.PROCEDURES_CREATE_DO.replace("%1", c);
                var d = Blockly.utils.xml.createElement("mutation");
                d.setAttribute("name", c);
                for(c = 0; c < this.arguments_.length; c++){
                    var e = Blockly.utils.xml.createElement("arg");
                    e.setAttribute("name", this.arguments_[c]);
                    d.appendChild(e);
                }
                c = Blockly.utils.xml.createElement("block");
                c.setAttribute("type", this.callType_);
                c.appendChild(d);
                b.callback = Blockly.ContextMenu.callbackFactory(this, c);
                a.push(b);
                if (!this.isCollapsed()) for(c = 0; c < this.argumentVarModels_.length; c++)b = {
                    enabled: !0
                }, d = this.argumentVarModels_[c], b.text = Blockly.Msg.VARIABLES_SET_CREATE_GET.replace("%1", d.name), d = Blockly.Variables.generateVariableFieldDom(d), e = Blockly.utils.xml.createElement("block"), e.setAttribute("type", "variables_get"), e.appendChild(d), b.callback = Blockly.ContextMenu.callbackFactory(this, e), a.push(b);
            }
        },
        callType_: "procedures_callnoreturn"
    };
    Blockly.Blocks.procedures_defreturn = {
        init: function() {
            var a = Blockly.Procedures.findLegalName("", this);
            a = new Blockly.FieldTextInput(a, Blockly.Procedures.rename);
            a.setSpellcheck(!1);
            this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_DEFRETURN_TITLE).appendField(a, "NAME").appendField("", "PARAMS");
            this.appendValueInput("RETURN").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN);
            this.setMutator(new Blockly.Mutator([
                "procedures_mutatorarg"
            ]));
            (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && Blockly.Msg.PROCEDURES_DEFRETURN_COMMENT && this.setCommentText(Blockly.Msg.PROCEDURES_DEFRETURN_COMMENT);
            this.setStyle("procedure_blocks");
            this.setTooltip(Blockly.Msg.PROCEDURES_DEFRETURN_TOOLTIP);
            this.setHelpUrl(Blockly.Msg.PROCEDURES_DEFRETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.setStatements_(!0);
            this.statementConnection_ = null;
        },
        setStatements_: Blockly.Blocks.procedures_defnoreturn.setStatements_,
        updateParams_: Blockly.Blocks.procedures_defnoreturn.updateParams_,
        mutationToDom: Blockly.Blocks.procedures_defnoreturn.mutationToDom,
        domToMutation: Blockly.Blocks.procedures_defnoreturn.domToMutation,
        decompose: Blockly.Blocks.procedures_defnoreturn.decompose,
        compose: Blockly.Blocks.procedures_defnoreturn.compose,
        getProcedureDef: function() {
            return [
                this.getFieldValue("NAME"),
                this.arguments_,
                !0
            ];
        },
        getVars: Blockly.Blocks.procedures_defnoreturn.getVars,
        getVarModels: Blockly.Blocks.procedures_defnoreturn.getVarModels,
        renameVarById: Blockly.Blocks.procedures_defnoreturn.renameVarById,
        updateVarName: Blockly.Blocks.procedures_defnoreturn.updateVarName,
        displayRenamedVar_: Blockly.Blocks.procedures_defnoreturn.displayRenamedVar_,
        customContextMenu: Blockly.Blocks.procedures_defnoreturn.customContextMenu,
        callType_: "procedures_callreturn"
    };
    Blockly.Blocks.procedures_mutatorcontainer = {
        init: function() {
            this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_MUTATORCONTAINER_TITLE);
            this.appendStatementInput("STACK");
            this.appendDummyInput("STATEMENT_INPUT").appendField(Blockly.Msg.PROCEDURES_ALLOW_STATEMENTS).appendField(new Blockly.FieldCheckbox("TRUE"), "STATEMENTS");
            this.setStyle("procedure_blocks");
            this.setTooltip(Blockly.Msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP);
            this.contextMenu = !1;
        }
    };
    Blockly.Blocks.procedures_mutatorarg = {
        init: function() {
            var a = new Blockly.FieldTextInput(Blockly.Procedures.DEFAULT_ARG, this.validator_);
            a.oldShowEditorFn_ = a.showEditor_;
            a.showEditor_ = function() {
                this.createdVariables_ = [];
                this.oldShowEditorFn_();
            };
            this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_MUTATORARG_TITLE).appendField(a, "NAME");
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setStyle("procedure_blocks");
            this.setTooltip(Blockly.Msg.PROCEDURES_MUTATORARG_TOOLTIP);
            this.contextMenu = !1;
            a.onFinishEditing_ = this.deleteIntermediateVars_;
            a.createdVariables_ = [];
            a.onFinishEditing_("x");
        },
        validator_: function(a) {
            var b = this.getSourceBlock(), c = Blockly.Mutator.findParentWs(b.workspace);
            a = a.replace(/[\s\xa0]+/g, " ").replace(/^ | $/g, "");
            if (!a) return null;
            for(var d = (b.workspace.targetWorkspace || b.workspace).getAllBlocks(!1), e = a.toLowerCase(), f = 0; f < d.length; f++)if (d[f].id != this.getSourceBlock().id) {
                var g = d[f].getFieldValue("NAME");
                if (g && g.toLowerCase() == e) return null;
            }
            if (b.isInFlyout) return a;
            (b = c.getVariable(a, "")) && b.name != a && c.renameVariableById(b.getId(), a);
            b || (b = c.createVariable(a, "")) && this.createdVariables_ && this.createdVariables_.push(b);
            return a;
        },
        deleteIntermediateVars_: function(a) {
            var b = Blockly.Mutator.findParentWs(this.getSourceBlock().workspace);
            if (b) for(var c = 0; c < this.createdVariables_.length; c++){
                var d = this.createdVariables_[c];
                d.name != a && b.deleteVariableById(d.getId());
            }
        }
    };
    Blockly.Blocks.procedures_callnoreturn = {
        init: function() {
            this.appendDummyInput("TOPROW").appendField("", "NAME");
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setStyle("procedure_blocks");
            this.setHelpUrl(Blockly.Msg.PROCEDURES_CALLNORETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.quarkConnections_ = {};
            this.quarkIds_ = null;
            this.previousEnabledState_ = !0;
        },
        getProcedureCall: function() {
            return this.getFieldValue("NAME");
        },
        renameProcedure: function(a, b) {
            Blockly.Names.equals(a, this.getProcedureCall()) && (this.setFieldValue(b, "NAME"), this.setTooltip((this.outputConnection ? Blockly.Msg.PROCEDURES_CALLRETURN_TOOLTIP : Blockly.Msg.PROCEDURES_CALLNORETURN_TOOLTIP).replace("%1", b)));
        },
        setProcedureParameters_: function(a, b) {
            var c = Blockly.Procedures.getDefinition(this.getProcedureCall(), this.workspace), d = c && c.mutator && c.mutator.isVisible();
            d || (this.quarkConnections_ = {}, this.quarkIds_ = null);
            if (b) {
                if (a.join("\n") == this.arguments_.join("\n")) this.quarkIds_ = b;
                else {
                    if (b.length != a.length) throw RangeError("paramNames and paramIds must be the same length.");
                    this.setCollapsed(!1);
                    this.quarkIds_ || (this.quarkConnections_ = {}, this.quarkIds_ = []);
                    c = this.rendered;
                    this.rendered = !1;
                    for(var e = 0; e < this.arguments_.length; e++){
                        var f = this.getInput("ARG" + e);
                        f && (f = f.connection.targetConnection, this.quarkConnections_[this.quarkIds_[e]] = f, d && f && -1 == b.indexOf(this.quarkIds_[e]) && (f.disconnect(), f.getSourceBlock().bumpNeighbours()));
                    }
                    this.arguments_ = [].concat(a);
                    this.argumentVarModels_ = [];
                    for(e = 0; e < this.arguments_.length; e++)a = Blockly.Variables.getOrCreateVariablePackage(this.workspace, null, this.arguments_[e], ""), this.argumentVarModels_.push(a);
                    this.updateShape_();
                    if (this.quarkIds_ = b) for(e = 0; e < this.arguments_.length; e++)b = this.quarkIds_[e], b in this.quarkConnections_ && (f = this.quarkConnections_[b], Blockly.Mutator.reconnect(f, this, "ARG" + e) || delete this.quarkConnections_[b]);
                    (this.rendered = c) && this.render();
                }
            }
        },
        updateShape_: function() {
            for(var a = 0; a < this.arguments_.length; a++){
                var b = this.getField("ARGNAME" + a);
                if (b) {
                    Blockly.Events.disable();
                    try {
                        b.setValue(this.arguments_[a]);
                    } finally{
                        Blockly.Events.enable();
                    }
                } else b = new Blockly.FieldLabel(this.arguments_[a]), this.appendValueInput("ARG" + a).setAlign(Blockly.ALIGN_RIGHT).appendField(b, "ARGNAME" + a).init();
            }
            for(; this.getInput("ARG" + a);)this.removeInput("ARG" + a), a++;
            if (a = this.getInput("TOPROW")) this.arguments_.length ? this.getField("WITH") || (a.appendField(Blockly.Msg.PROCEDURES_CALL_BEFORE_PARAMS, "WITH"), a.init()) : this.getField("WITH") && a.removeField("WITH");
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("name", this.getProcedureCall());
            for(var b = 0; b < this.arguments_.length; b++){
                var c = Blockly.utils.xml.createElement("arg");
                c.setAttribute("name", this.arguments_[b]);
                a.appendChild(c);
            }
            return a;
        },
        domToMutation: function(a) {
            var b = a.getAttribute("name");
            this.renameProcedure(this.getProcedureCall(), b);
            b = [];
            for(var c = [], d = 0, e; e = a.childNodes[d]; d++)"arg" == e.nodeName.toLowerCase() && (b.push(e.getAttribute("name")), c.push(e.getAttribute("paramId")));
            this.setProcedureParameters_(b, c);
        },
        getVars: function() {
            return this.arguments_;
        },
        getVarModels: function() {
            return this.argumentVarModels_;
        },
        onchange: function(a) {
            if (this.workspace && !this.workspace.isFlyout && a.recordUndo) {
                if (a.type == Blockly.Events.BLOCK_CREATE && -1 != a.ids.indexOf(this.id)) {
                    var b = this.getProcedureCall();
                    b = Blockly.Procedures.getDefinition(b, this.workspace);
                    !b || b.type == this.defType_ && JSON.stringify(b.getVars()) == JSON.stringify(this.arguments_) || (b = null);
                    if (!b) {
                        Blockly.Events.setGroup(a.group);
                        a = Blockly.utils.xml.createElement("xml");
                        b = Blockly.utils.xml.createElement("block");
                        b.setAttribute("type", this.defType_);
                        var c = this.getRelativeToSurfaceXY(), d = c.y + 2 * Blockly.SNAP_RADIUS;
                        b.setAttribute("x", c.x + Blockly.SNAP_RADIUS * (this.RTL ? -1 : 1));
                        b.setAttribute("y", d);
                        c = this.mutationToDom();
                        b.appendChild(c);
                        c = Blockly.utils.xml.createElement("field");
                        c.setAttribute("name", "NAME");
                        d = this.getProcedureCall();
                        d || (d = Blockly.Procedures.findLegalName("", this), this.renameProcedure("", d));
                        c.appendChild(Blockly.utils.xml.createTextNode(d));
                        b.appendChild(c);
                        a.appendChild(b);
                        Blockly.Xml.domToWorkspace(a, this.workspace);
                        Blockly.Events.setGroup(!1);
                    }
                } else a.type == Blockly.Events.BLOCK_DELETE ? (b = this.getProcedureCall(), b = Blockly.Procedures.getDefinition(b, this.workspace), b || (Blockly.Events.setGroup(a.group), this.dispose(!0), Blockly.Events.setGroup(!1))) : a.type == Blockly.Events.CHANGE && "disabled" == a.element && (b = this.getProcedureCall(), (b = Blockly.Procedures.getDefinition(b, this.workspace)) && b.id == a.blockId && ((b = Blockly.Events.getGroup()) && console.log("Saw an existing group while responding to a definition change"), Blockly.Events.setGroup(a.group), a.newValue ? (this.previousEnabledState_ = this.isEnabled(), this.setEnabled(!1)) : this.setEnabled(this.previousEnabledState_), Blockly.Events.setGroup(b)));
            }
        },
        customContextMenu: function(a) {
            if (this.workspace.isMovable()) {
                var b = {
                    enabled: !0
                };
                b.text = Blockly.Msg.PROCEDURES_HIGHLIGHT_DEF;
                var c = this.getProcedureCall(), d = this.workspace;
                b.callback = function() {
                    var e = Blockly.Procedures.getDefinition(c, d);
                    e && (d.centerOnBlock(e.id), e.select());
                };
                a.push(b);
            }
        },
        defType_: "procedures_defnoreturn"
    };
    Blockly.Blocks.procedures_callreturn = {
        init: function() {
            this.appendDummyInput("TOPROW").appendField("", "NAME");
            this.setOutput(!0);
            this.setStyle("procedure_blocks");
            this.setHelpUrl(Blockly.Msg.PROCEDURES_CALLRETURN_HELPURL);
            this.arguments_ = [];
            this.argumentVarModels_ = [];
            this.quarkConnections_ = {};
            this.quarkIds_ = null;
            this.previousEnabledState_ = !0;
        },
        getProcedureCall: Blockly.Blocks.procedures_callnoreturn.getProcedureCall,
        renameProcedure: Blockly.Blocks.procedures_callnoreturn.renameProcedure,
        setProcedureParameters_: Blockly.Blocks.procedures_callnoreturn.setProcedureParameters_,
        updateShape_: Blockly.Blocks.procedures_callnoreturn.updateShape_,
        mutationToDom: Blockly.Blocks.procedures_callnoreturn.mutationToDom,
        domToMutation: Blockly.Blocks.procedures_callnoreturn.domToMutation,
        getVars: Blockly.Blocks.procedures_callnoreturn.getVars,
        getVarModels: Blockly.Blocks.procedures_callnoreturn.getVarModels,
        onchange: Blockly.Blocks.procedures_callnoreturn.onchange,
        customContextMenu: Blockly.Blocks.procedures_callnoreturn.customContextMenu,
        defType_: "procedures_defreturn"
    };
    Blockly.Blocks.procedures_ifreturn = {
        init: function() {
            this.appendValueInput("CONDITION").setCheck("Boolean").appendField(Blockly.Msg.CONTROLS_IF_MSG_IF);
            this.appendValueInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.setStyle("procedure_blocks");
            this.setTooltip(Blockly.Msg.PROCEDURES_IFRETURN_TOOLTIP);
            this.setHelpUrl(Blockly.Msg.PROCEDURES_IFRETURN_HELPURL);
            this.hasReturnValue_ = !0;
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("value", Number(this.hasReturnValue_));
            return a;
        },
        domToMutation: function(a) {
            this.hasReturnValue_ = 1 == a.getAttribute("value");
            this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN));
        },
        onchange: function(a) {
            if (this.workspace.isDragging && !this.workspace.isDragging()) {
                a = !1;
                var b = this;
                do {
                    if (-1 != this.FUNCTION_TYPES.indexOf(b.type)) {
                        a = !0;
                        break;
                    }
                    b = b.getSurroundParent();
                }while (b);
                a ? ("procedures_defnoreturn" == b.type && this.hasReturnValue_ ? (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !1) : "procedures_defreturn" != b.type || this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendValueInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !0), this.setWarningText(null), this.isInFlyout || this.setEnabled(!0)) : (this.setWarningText(Blockly.Msg.PROCEDURES_IFRETURN_WARNING), this.isInFlyout || this.getInheritedDisabled() || this.setEnabled(!1));
            }
        },
        FUNCTION_TYPES: [
            "procedures_defnoreturn",
            "procedures_defreturn"
        ]
    };
    Blockly.Blocks.texts = {};
    Blockly.Constants.Text = {};
    Blockly.Constants.Text.HUE = 160;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "text",
            message0: "%1",
            args0: [
                {
                    type: "field_input",
                    name: "TEXT",
                    text: ""
                }
            ],
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_TEXT_HELPURL}",
            tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}",
            extensions: [
                "text_quotes",
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "text_multiline",
            message0: "%1 %2",
            args0: [
                {
                    type: "field_image",
                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAdhgAAHYYBXaITgQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAP1JREFUOE+Vks0KQUEYhjmRIja4ABtZ2dm5A3t3Ia6AUm7CylYuQRaUhZSlLZJiQbFAyRnPN33y01HOW08z8873zpwzM4F3GWOCruvGIE4/rLaV+Nq1hVGMBqzhqlxgCys4wJA65xnogMHsQ5lujnYHTejBBCK2mE4abjCgMGhNxHgDFWjDSG07kdfVa2pZMf4ZyMAdWmpZMfYOsLiDMYMjlMB+K613QISRhTnITnsYg5yUd0DETmEoMlkFOeIT/A58iyK5E18BuTBfgYXfwNJv4P9/oEBerLylOnRhygmGdPpTTBZAPkde61lbQe4moWUvYUZYLfUNftIY4zwA5X2Z9AYnQrEAAAAASUVORK5CYII=",
                    width: 12,
                    height: 17,
                    alt: "\u00b6"
                },
                {
                    type: "field_multilinetext",
                    name: "TEXT",
                    text: ""
                }
            ],
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_TEXT_HELPURL}",
            tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}",
            extensions: [
                "parent_tooltip_when_inline"
            ]
        },
        {
            type: "text_join",
            message0: "",
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_JOIN_HELPURL}",
            tooltip: "%{BKY_TEXT_JOIN_TOOLTIP}",
            mutator: "text_join_mutator"
        },
        {
            type: "text_create_join_container",
            message0: "%{BKY_TEXT_CREATE_JOIN_TITLE_JOIN} %1 %2",
            args0: [
                {
                    type: "input_dummy"
                },
                {
                    type: "input_statement",
                    name: "STACK"
                }
            ],
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_CREATE_JOIN_TOOLTIP}",
            enableContextMenu: !1
        },
        {
            type: "text_create_join_item",
            message0: "%{BKY_TEXT_CREATE_JOIN_ITEM_TITLE_ITEM}",
            previousStatement: null,
            nextStatement: null,
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_CREATE_JOIN_ITEM_TOOLTIP}",
            enableContextMenu: !1
        },
        {
            type: "text_append",
            message0: "%{BKY_TEXT_APPEND_TITLE}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_TEXT_APPEND_VARIABLE}"
                },
                {
                    type: "input_value",
                    name: "TEXT"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "text_blocks",
            extensions: [
                "text_append_tooltip"
            ]
        },
        {
            type: "text_length",
            message0: "%{BKY_TEXT_LENGTH_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Number",
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_LENGTH_TOOLTIP}",
            helpUrl: "%{BKY_TEXT_LENGTH_HELPURL}"
        },
        {
            type: "text_isEmpty",
            message0: "%{BKY_TEXT_ISEMPTY_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: [
                        "String",
                        "Array"
                    ]
                }
            ],
            output: "Boolean",
            style: "text_blocks",
            tooltip: "%{BKY_TEXT_ISEMPTY_TOOLTIP}",
            helpUrl: "%{BKY_TEXT_ISEMPTY_HELPURL}"
        },
        {
            type: "text_indexOf",
            message0: "%{BKY_TEXT_INDEXOF_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: "String"
                },
                {
                    type: "field_dropdown",
                    name: "END",
                    options: [
                        [
                            "%{BKY_TEXT_INDEXOF_OPERATOR_FIRST}",
                            "FIRST"
                        ],
                        [
                            "%{BKY_TEXT_INDEXOF_OPERATOR_LAST}",
                            "LAST"
                        ]
                    ]
                },
                {
                    type: "input_value",
                    name: "FIND",
                    check: "String"
                }
            ],
            output: "Number",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_INDEXOF_HELPURL}",
            inputsInline: !0,
            extensions: [
                "text_indexOf_tooltip"
            ]
        },
        {
            type: "text_charAt",
            message0: "%{BKY_TEXT_CHARAT_TITLE}",
            args0: [
                {
                    type: "input_value",
                    name: "VALUE",
                    check: "String"
                },
                {
                    type: "field_dropdown",
                    name: "WHERE",
                    options: [
                        [
                            "%{BKY_TEXT_CHARAT_FROM_START}",
                            "FROM_START"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_FROM_END}",
                            "FROM_END"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_FIRST}",
                            "FIRST"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_LAST}",
                            "LAST"
                        ],
                        [
                            "%{BKY_TEXT_CHARAT_RANDOM}",
                            "RANDOM"
                        ]
                    ]
                }
            ],
            output: "String",
            style: "text_blocks",
            helpUrl: "%{BKY_TEXT_CHARAT_HELPURL}",
            inputsInline: !0,
            mutator: "text_charAt_mutator"
        }
    ]);
    Blockly.Blocks.text_getSubstring = {
        init: function() {
            this.WHERE_OPTIONS_1 = [
                [
                    Blockly.Msg.TEXT_GET_SUBSTRING_START_FROM_START,
                    "FROM_START"
                ],
                [
                    Blockly.Msg.TEXT_GET_SUBSTRING_START_FROM_END,
                    "FROM_END"
                ],
                [
                    Blockly.Msg.TEXT_GET_SUBSTRING_START_FIRST,
                    "FIRST"
                ]
            ];
            this.WHERE_OPTIONS_2 = [
                [
                    Blockly.Msg.TEXT_GET_SUBSTRING_END_FROM_START,
                    "FROM_START"
                ],
                [
                    Blockly.Msg.TEXT_GET_SUBSTRING_END_FROM_END,
                    "FROM_END"
                ],
                [
                    Blockly.Msg.TEXT_GET_SUBSTRING_END_LAST,
                    "LAST"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.TEXT_GET_SUBSTRING_HELPURL);
            this.setStyle("text_blocks");
            this.appendValueInput("STRING").setCheck("String").appendField(Blockly.Msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT);
            this.appendDummyInput("AT1");
            this.appendDummyInput("AT2");
            Blockly.Msg.TEXT_GET_SUBSTRING_TAIL && this.appendDummyInput("TAIL").appendField(Blockly.Msg.TEXT_GET_SUBSTRING_TAIL);
            this.setInputsInline(!0);
            this.setOutput(!0, "String");
            this.updateAt_(1, !0);
            this.updateAt_(2, !0);
            this.setTooltip(Blockly.Msg.TEXT_GET_SUBSTRING_TOOLTIP);
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation"), b = this.getInput("AT1").type == Blockly.INPUT_VALUE;
            a.setAttribute("at1", b);
            b = this.getInput("AT2").type == Blockly.INPUT_VALUE;
            a.setAttribute("at2", b);
            return a;
        },
        domToMutation: function(a) {
            var b = "true" == a.getAttribute("at1");
            a = "true" == a.getAttribute("at2");
            this.updateAt_(1, b);
            this.updateAt_(2, a);
        },
        updateAt_: function(a, b) {
            this.removeInput("AT" + a);
            this.removeInput("ORDINAL" + a, !0);
            b ? (this.appendValueInput("AT" + a).setCheck("Number"), Blockly.Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + a).appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + a);
            2 == a && Blockly.Msg.TEXT_GET_SUBSTRING_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(Blockly.Msg.TEXT_GET_SUBSTRING_TAIL));
            var c = new Blockly.FieldDropdown(this["WHERE_OPTIONS_" + a], function(d) {
                var e = "FROM_START" == d || "FROM_END" == d;
                if (e != b) {
                    var f = this.getSourceBlock();
                    f.updateAt_(a, e);
                    f.setFieldValue(d, "WHERE" + a);
                    return null;
                }
            });
            this.getInput("AT" + a).appendField(c, "WHERE" + a);
            1 == a && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2"));
        }
    };
    Blockly.Blocks.text_changeCase = {
        init: function() {
            var a = [
                [
                    Blockly.Msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE,
                    "UPPERCASE"
                ],
                [
                    Blockly.Msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE,
                    "LOWERCASE"
                ],
                [
                    Blockly.Msg.TEXT_CHANGECASE_OPERATOR_TITLECASE,
                    "TITLECASE"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.TEXT_CHANGECASE_HELPURL);
            this.setStyle("text_blocks");
            this.appendValueInput("TEXT").setCheck("String").appendField(new Blockly.FieldDropdown(a), "CASE");
            this.setOutput(!0, "String");
            this.setTooltip(Blockly.Msg.TEXT_CHANGECASE_TOOLTIP);
        }
    };
    Blockly.Blocks.text_trim = {
        init: function() {
            var a = [
                [
                    Blockly.Msg.TEXT_TRIM_OPERATOR_BOTH,
                    "BOTH"
                ],
                [
                    Blockly.Msg.TEXT_TRIM_OPERATOR_LEFT,
                    "LEFT"
                ],
                [
                    Blockly.Msg.TEXT_TRIM_OPERATOR_RIGHT,
                    "RIGHT"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.TEXT_TRIM_HELPURL);
            this.setStyle("text_blocks");
            this.appendValueInput("TEXT").setCheck("String").appendField(new Blockly.FieldDropdown(a), "MODE");
            this.setOutput(!0, "String");
            this.setTooltip(Blockly.Msg.TEXT_TRIM_TOOLTIP);
        }
    };
    Blockly.Blocks.text_print = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.TEXT_PRINT_TITLE,
                args0: [
                    {
                        type: "input_value",
                        name: "TEXT"
                    }
                ],
                previousStatement: null,
                nextStatement: null,
                style: "text_blocks",
                tooltip: Blockly.Msg.TEXT_PRINT_TOOLTIP,
                helpUrl: Blockly.Msg.TEXT_PRINT_HELPURL
            });
        }
    };
    Blockly.Blocks.text_prompt_ext = {
        init: function() {
            var a = [
                [
                    Blockly.Msg.TEXT_PROMPT_TYPE_TEXT,
                    "TEXT"
                ],
                [
                    Blockly.Msg.TEXT_PROMPT_TYPE_NUMBER,
                    "NUMBER"
                ]
            ];
            this.setHelpUrl(Blockly.Msg.TEXT_PROMPT_HELPURL);
            this.setStyle("text_blocks");
            var b = this;
            a = new Blockly.FieldDropdown(a, function(c) {
                b.updateType_(c);
            });
            this.appendValueInput("TEXT").appendField(a, "TYPE");
            this.setOutput(!0, "String");
            this.setTooltip(function() {
                return "TEXT" == b.getFieldValue("TYPE") ? Blockly.Msg.TEXT_PROMPT_TOOLTIP_TEXT : Blockly.Msg.TEXT_PROMPT_TOOLTIP_NUMBER;
            });
        },
        updateType_: function(a) {
            this.outputConnection.setCheck("NUMBER" == a ? "Number" : "String");
        },
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("type", this.getFieldValue("TYPE"));
            return a;
        },
        domToMutation: function(a) {
            this.updateType_(a.getAttribute("type"));
        }
    };
    Blockly.Blocks.text_prompt = {
        init: function() {
            this.mixin(Blockly.Constants.Text.QUOTE_IMAGE_MIXIN);
            var a = [
                [
                    Blockly.Msg.TEXT_PROMPT_TYPE_TEXT,
                    "TEXT"
                ],
                [
                    Blockly.Msg.TEXT_PROMPT_TYPE_NUMBER,
                    "NUMBER"
                ]
            ], b = this;
            this.setHelpUrl(Blockly.Msg.TEXT_PROMPT_HELPURL);
            this.setStyle("text_blocks");
            a = new Blockly.FieldDropdown(a, function(c) {
                b.updateType_(c);
            });
            this.appendDummyInput().appendField(a, "TYPE").appendField(this.newQuote_(!0)).appendField(new Blockly.FieldTextInput(""), "TEXT").appendField(this.newQuote_(!1));
            this.setOutput(!0, "String");
            this.setTooltip(function() {
                return "TEXT" == b.getFieldValue("TYPE") ? Blockly.Msg.TEXT_PROMPT_TOOLTIP_TEXT : Blockly.Msg.TEXT_PROMPT_TOOLTIP_NUMBER;
            });
        },
        updateType_: Blockly.Blocks.text_prompt_ext.updateType_,
        mutationToDom: Blockly.Blocks.text_prompt_ext.mutationToDom,
        domToMutation: Blockly.Blocks.text_prompt_ext.domToMutation
    };
    Blockly.Blocks.text_count = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.TEXT_COUNT_MESSAGE0,
                args0: [
                    {
                        type: "input_value",
                        name: "SUB",
                        check: "String"
                    },
                    {
                        type: "input_value",
                        name: "TEXT",
                        check: "String"
                    }
                ],
                output: "Number",
                inputsInline: !0,
                style: "text_blocks",
                tooltip: Blockly.Msg.TEXT_COUNT_TOOLTIP,
                helpUrl: Blockly.Msg.TEXT_COUNT_HELPURL
            });
        }
    };
    Blockly.Blocks.text_replace = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.TEXT_REPLACE_MESSAGE0,
                args0: [
                    {
                        type: "input_value",
                        name: "FROM",
                        check: "String"
                    },
                    {
                        type: "input_value",
                        name: "TO",
                        check: "String"
                    },
                    {
                        type: "input_value",
                        name: "TEXT",
                        check: "String"
                    }
                ],
                output: "String",
                inputsInline: !0,
                style: "text_blocks",
                tooltip: Blockly.Msg.TEXT_REPLACE_TOOLTIP,
                helpUrl: Blockly.Msg.TEXT_REPLACE_HELPURL
            });
        }
    };
    Blockly.Blocks.text_reverse = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.TEXT_REVERSE_MESSAGE0,
                args0: [
                    {
                        type: "input_value",
                        name: "TEXT",
                        check: "String"
                    }
                ],
                output: "String",
                inputsInline: !0,
                style: "text_blocks",
                tooltip: Blockly.Msg.TEXT_REVERSE_TOOLTIP,
                helpUrl: Blockly.Msg.TEXT_REVERSE_HELPURL
            });
        }
    };
    Blockly.Constants.Text.QUOTE_IMAGE_MIXIN = {
        QUOTE_IMAGE_LEFT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAn0lEQVQI1z3OMa5BURSF4f/cQhAKjUQhuQmFNwGJEUi0RKN5rU7FHKhpjEH3TEMtkdBSCY1EIv8r7nFX9e29V7EBAOvu7RPjwmWGH/VuF8CyN9/OAdvqIXYLvtRaNjx9mMTDyo+NjAN1HNcl9ZQ5oQMM3dgDUqDo1l8DzvwmtZN7mnD+PkmLa+4mhrxVA9fRowBWmVBhFy5gYEjKMfz9AylsaRRgGzvZAAAAAElFTkSuQmCC",
        QUOTE_IMAGE_RIGHT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAqUlEQVQI1z3KvUpCcRiA8ef9E4JNHhI0aFEacm1o0BsI0Slx8wa8gLauoDnoBhq7DcfWhggONDmJJgqCPA7neJ7p934EOOKOnM8Q7PDElo/4x4lFb2DmuUjcUzS3URnGib9qaPNbuXvBO3sGPHJDRG6fGVdMSeWDP2q99FQdFrz26Gu5Tq7dFMzUvbXy8KXeAj57cOklgA+u1B5AoslLtGIHQMaCVnwDnADZIFIrXsoXrgAAAABJRU5ErkJggg==",
        QUOTE_IMAGE_WIDTH: 12,
        QUOTE_IMAGE_HEIGHT: 12,
        quoteField_: function(a) {
            for(var b = 0, c; c = this.inputList[b]; b++)for(var d = 0, e; e = c.fieldRow[d]; d++)if (a == e.name) {
                c.insertFieldAt(d, this.newQuote_(!0));
                c.insertFieldAt(d + 2, this.newQuote_(!1));
                return;
            }
            console.warn('field named "' + a + '" not found in ' + this.toDevString());
        },
        newQuote_: function(a) {
            a = this.RTL ? !a : a;
            return new Blockly.FieldImage(a ? this.QUOTE_IMAGE_LEFT_DATAURI : this.QUOTE_IMAGE_RIGHT_DATAURI, this.QUOTE_IMAGE_WIDTH, this.QUOTE_IMAGE_HEIGHT, a ? "\u201c" : "\u201d");
        }
    };
    Blockly.Constants.Text.TEXT_QUOTES_EXTENSION = function() {
        this.mixin(Blockly.Constants.Text.QUOTE_IMAGE_MIXIN);
        this.quoteField_("TEXT");
    };
    Blockly.Constants.Text.TEXT_JOIN_MUTATOR_MIXIN = {
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("items", this.itemCount_);
            return a;
        },
        domToMutation: function(a) {
            this.itemCount_ = parseInt(a.getAttribute("items"), 10);
            this.updateShape_();
        },
        decompose: function(a) {
            var b = a.newBlock("text_create_join_container");
            b.initSvg();
            for(var c = b.getInput("STACK").connection, d = 0; d < this.itemCount_; d++){
                var e = a.newBlock("text_create_join_item");
                e.initSvg();
                c.connect(e.previousConnection);
                c = e.nextConnection;
            }
            return b;
        },
        compose: function(a) {
            var b = a.getInputTargetBlock("STACK");
            for(a = []; b && !b.isInsertionMarker();)a.push(b.valueConnection_), b = b.nextConnection && b.nextConnection.targetBlock();
            for(b = 0; b < this.itemCount_; b++){
                var c = this.getInput("ADD" + b).connection.targetConnection;
                c && -1 == a.indexOf(c) && c.disconnect();
            }
            this.itemCount_ = a.length;
            this.updateShape_();
            for(b = 0; b < this.itemCount_; b++)Blockly.Mutator.reconnect(a[b], this, "ADD" + b);
        },
        saveConnections: function(a) {
            a = a.getInputTargetBlock("STACK");
            for(var b = 0; a;){
                var c = this.getInput("ADD" + b);
                a.valueConnection_ = c && c.connection.targetConnection;
                b++;
                a = a.nextConnection && a.nextConnection.targetBlock();
            }
        },
        updateShape_: function() {
            this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(this.newQuote_(!0)).appendField(this.newQuote_(!1));
            for(var a = 0; a < this.itemCount_; a++)if (!this.getInput("ADD" + a)) {
                var b = this.appendValueInput("ADD" + a).setAlign(Blockly.ALIGN_RIGHT);
                0 == a && b.appendField(Blockly.Msg.TEXT_JOIN_TITLE_CREATEWITH);
            }
            for(; this.getInput("ADD" + a);)this.removeInput("ADD" + a), a++;
        }
    };
    Blockly.Constants.Text.TEXT_JOIN_EXTENSION = function() {
        this.mixin(Blockly.Constants.Text.QUOTE_IMAGE_MIXIN);
        this.itemCount_ = 2;
        this.updateShape_();
        this.setMutator(new Blockly.Mutator([
            "text_create_join_item"
        ]));
    };
    Blockly.Extensions.register("text_append_tooltip", Blockly.Extensions.buildTooltipWithFieldText("%{BKY_TEXT_APPEND_TOOLTIP}", "VAR"));
    Blockly.Constants.Text.TEXT_INDEXOF_TOOLTIP_EXTENSION = function() {
        var a = this;
        this.setTooltip(function() {
            return Blockly.Msg.TEXT_INDEXOF_TOOLTIP.replace("%1", a.workspace.options.oneBasedIndex ? "0" : "-1");
        });
    };
    Blockly.Constants.Text.TEXT_CHARAT_MUTATOR_MIXIN = {
        mutationToDom: function() {
            var a = Blockly.utils.xml.createElement("mutation");
            a.setAttribute("at", !!this.isAt_);
            return a;
        },
        domToMutation: function(a) {
            a = "false" != a.getAttribute("at");
            this.updateAt_(a);
        },
        updateAt_: function(a) {
            this.removeInput("AT", !0);
            this.removeInput("ORDINAL", !0);
            a && (this.appendValueInput("AT").setCheck("Number"), Blockly.Msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX));
            Blockly.Msg.TEXT_CHARAT_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(Blockly.Msg.TEXT_CHARAT_TAIL));
            this.isAt_ = a;
        }
    };
    Blockly.Constants.Text.TEXT_CHARAT_EXTENSION = function() {
        this.getField("WHERE").setValidator(function(b) {
            b = "FROM_START" == b || "FROM_END" == b;
            b != this.isAt_ && this.getSourceBlock().updateAt_(b);
        });
        this.updateAt_(!0);
        var a = this;
        this.setTooltip(function() {
            var b = a.getFieldValue("WHERE"), c = Blockly.Msg.TEXT_CHARAT_TOOLTIP;
            ("FROM_START" == b || "FROM_END" == b) && (b = "FROM_START" == b ? Blockly.Msg.LISTS_INDEX_FROM_START_TOOLTIP : Blockly.Msg.LISTS_INDEX_FROM_END_TOOLTIP) && (c += "  " + b.replace("%1", a.workspace.options.oneBasedIndex ? "#1" : "#0"));
            return c;
        });
    };
    Blockly.Extensions.register("text_indexOf_tooltip", Blockly.Constants.Text.TEXT_INDEXOF_TOOLTIP_EXTENSION);
    Blockly.Extensions.register("text_quotes", Blockly.Constants.Text.TEXT_QUOTES_EXTENSION);
    Blockly.Extensions.registerMutator("text_join_mutator", Blockly.Constants.Text.TEXT_JOIN_MUTATOR_MIXIN, Blockly.Constants.Text.TEXT_JOIN_EXTENSION);
    Blockly.Extensions.registerMutator("text_charAt_mutator", Blockly.Constants.Text.TEXT_CHARAT_MUTATOR_MIXIN, Blockly.Constants.Text.TEXT_CHARAT_EXTENSION);
    Blockly.Blocks.variables = {};
    Blockly.Constants.Variables = {};
    Blockly.Constants.Variables.HUE = 330;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "variables_get",
            message0: "%1",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                }
            ],
            output: null,
            style: "variable_blocks",
            helpUrl: "%{BKY_VARIABLES_GET_HELPURL}",
            tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}",
            extensions: [
                "contextMenu_variableSetterGetter"
            ]
        },
        {
            type: "variables_set",
            message0: "%{BKY_VARIABLES_SET}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                },
                {
                    type: "input_value",
                    name: "VALUE"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "variable_blocks",
            tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}",
            helpUrl: "%{BKY_VARIABLES_SET_HELPURL}",
            extensions: [
                "contextMenu_variableSetterGetter"
            ]
        }
    ]);
    Blockly.Constants.Variables.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN = {
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                if ("variables_get" == this.type) var b = "variables_set", c = Blockly.Msg.VARIABLES_GET_CREATE_SET;
                else b = "variables_get", c = Blockly.Msg.VARIABLES_SET_CREATE_GET;
                var d = {
                    enabled: 0 < this.workspace.remainingCapacity()
                }, e = this.getField("VAR").getText();
                d.text = c.replace("%1", e);
                c = Blockly.utils.xml.createElement("field");
                c.setAttribute("name", "VAR");
                c.appendChild(Blockly.utils.xml.createTextNode(e));
                e = Blockly.utils.xml.createElement("block");
                e.setAttribute("type", b);
                e.appendChild(c);
                d.callback = Blockly.ContextMenu.callbackFactory(this, e);
                a.push(d);
            } else if ("variables_get" == this.type || "variables_get_reporter" == this.type) b = {
                text: Blockly.Msg.RENAME_VARIABLE,
                enabled: !0,
                callback: Blockly.Constants.Variables.RENAME_OPTION_CALLBACK_FACTORY(this)
            }, e = this.getField("VAR").getText(), d = {
                text: Blockly.Msg.DELETE_VARIABLE.replace("%1", e),
                enabled: !0,
                callback: Blockly.Constants.Variables.DELETE_OPTION_CALLBACK_FACTORY(this)
            }, a.unshift(b), a.unshift(d);
        }
    };
    Blockly.Constants.Variables.RENAME_OPTION_CALLBACK_FACTORY = function(a) {
        return function() {
            var b = a.workspace, c = a.getField("VAR").getVariable();
            Blockly.Variables.renameVariable(b, c);
        };
    };
    Blockly.Constants.Variables.DELETE_OPTION_CALLBACK_FACTORY = function(a) {
        return function() {
            var b = a.workspace, c = a.getField("VAR").getVariable();
            b.deleteVariableById(c.getId());
            b.refreshToolboxSelection();
        };
    };
    Blockly.Extensions.registerMixin("contextMenu_variableSetterGetter", Blockly.Constants.Variables.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN);
    Blockly.Constants.VariablesDynamic = {};
    Blockly.Constants.VariablesDynamic.HUE = 310;
    Blockly.defineBlocksWithJsonArray([
        {
            type: "variables_get_dynamic",
            message0: "%1",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                }
            ],
            output: null,
            style: "variable_dynamic_blocks",
            helpUrl: "%{BKY_VARIABLES_GET_HELPURL}",
            tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}",
            extensions: [
                "contextMenu_variableDynamicSetterGetter"
            ]
        },
        {
            type: "variables_set_dynamic",
            message0: "%{BKY_VARIABLES_SET}",
            args0: [
                {
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
                },
                {
                    type: "input_value",
                    name: "VALUE"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: "variable_dynamic_blocks",
            tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}",
            helpUrl: "%{BKY_VARIABLES_SET_HELPURL}",
            extensions: [
                "contextMenu_variableDynamicSetterGetter"
            ]
        }
    ]);
    Blockly.Constants.VariablesDynamic.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN = {
        customContextMenu: function(a) {
            if (!this.isInFlyout) {
                var b = this.getFieldValue("VAR");
                var c = this.workspace.getVariableById(b).type;
                if ("variables_get_dynamic" == this.type) {
                    b = "variables_set_dynamic";
                    var d = Blockly.Msg.VARIABLES_GET_CREATE_SET;
                } else b = "variables_get_dynamic", d = Blockly.Msg.VARIABLES_SET_CREATE_GET;
                var e = {
                    enabled: 0 < this.workspace.remainingCapacity()
                }, f = this.getField("VAR").getText();
                e.text = d.replace("%1", f);
                d = Blockly.utils.xml.createElement("field");
                d.setAttribute("name", "VAR");
                d.setAttribute("variabletype", c);
                d.appendChild(Blockly.utils.xml.createTextNode(f));
                f = Blockly.utils.xml.createElement("block");
                f.setAttribute("type", b);
                f.appendChild(d);
                e.callback = Blockly.ContextMenu.callbackFactory(this, f);
                a.push(e);
            } else if ("variables_get_dynamic" == this.type || "variables_get_reporter_dynamic" == this.type) b = {
                text: Blockly.Msg.RENAME_VARIABLE,
                enabled: !0,
                callback: Blockly.Constants.Variables.RENAME_OPTION_CALLBACK_FACTORY(this)
            }, f = this.getField("VAR").getText(), e = {
                text: Blockly.Msg.DELETE_VARIABLE.replace("%1", f),
                enabled: !0,
                callback: Blockly.Constants.Variables.DELETE_OPTION_CALLBACK_FACTORY(this)
            }, a.unshift(b), a.unshift(e);
        },
        onchange: function(a) {
            a = this.getFieldValue("VAR");
            a = Blockly.Variables.getVariable(this.workspace, a);
            "variables_get_dynamic" == this.type ? this.outputConnection.setCheck(a.type) : this.getInput("VALUE").connection.setCheck(a.type);
        }
    };
    Blockly.Constants.VariablesDynamic.RENAME_OPTION_CALLBACK_FACTORY = function(a) {
        return function() {
            var b = a.workspace, c = a.getField("VAR").getVariable();
            Blockly.Variables.renameVariable(b, c);
        };
    };
    Blockly.Constants.VariablesDynamic.DELETE_OPTION_CALLBACK_FACTORY = function(a) {
        return function() {
            var b = a.workspace, c = a.getField("VAR").getVariable();
            b.deleteVariableById(c.getId());
            b.refreshToolboxSelection();
        };
    };
    Blockly.Extensions.registerMixin("contextMenu_variableDynamicSetterGetter", Blockly.Constants.VariablesDynamic.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN);
    return Blockly.Blocks;
});

});


parcelRegister("cK1vO", function(module, exports) {
/* eslint-disable */ 

(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './core',
        './javascript_compressed.js'
    ], factory);
    else module.exports = factory((parcelRequire("460Qg")), (parcelRequire("eo3Si")));
})(module.exports, function(Blockly, BlocklyJavaScript) {
    /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview JavaScript Generator module.
 */ /* eslint-disable */ 'use strict';
    Blockly.JavaScript = BlocklyJavaScript;
    return BlocklyJavaScript;
});

});
parcelRegister("eo3Si", function(module, exports) {
// Do not edit this file; automatically generated by gulp.
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        './blockly_compressed.js'
    ], factory);
    else module.exports = factory((parcelRequire("6CdWE")));
})(module.exports, function(Blockly) {
    'use strict';
    Blockly.JavaScript = new Blockly.Generator("JavaScript");
    Blockly.JavaScript.addReservedWords("break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,new,return,super,switch,this,throw,try,typeof,var,void,while,with,yield,enum,implements,interface,let,package,private,protected,public,static,await,null,true,false,arguments," + Object.getOwnPropertyNames(Blockly.utils.global).join(","));
    Blockly.JavaScript.ORDER_ATOMIC = 0;
    Blockly.JavaScript.ORDER_NEW = 1.1;
    Blockly.JavaScript.ORDER_MEMBER = 1.2;
    Blockly.JavaScript.ORDER_FUNCTION_CALL = 2;
    Blockly.JavaScript.ORDER_INCREMENT = 3;
    Blockly.JavaScript.ORDER_DECREMENT = 3;
    Blockly.JavaScript.ORDER_BITWISE_NOT = 4.1;
    Blockly.JavaScript.ORDER_UNARY_PLUS = 4.2;
    Blockly.JavaScript.ORDER_UNARY_NEGATION = 4.3;
    Blockly.JavaScript.ORDER_LOGICAL_NOT = 4.4;
    Blockly.JavaScript.ORDER_TYPEOF = 4.5;
    Blockly.JavaScript.ORDER_VOID = 4.6;
    Blockly.JavaScript.ORDER_DELETE = 4.7;
    Blockly.JavaScript.ORDER_AWAIT = 4.8;
    Blockly.JavaScript.ORDER_EXPONENTIATION = 5;
    Blockly.JavaScript.ORDER_MULTIPLICATION = 5.1;
    Blockly.JavaScript.ORDER_DIVISION = 5.2;
    Blockly.JavaScript.ORDER_MODULUS = 5.3;
    Blockly.JavaScript.ORDER_SUBTRACTION = 6.1;
    Blockly.JavaScript.ORDER_ADDITION = 6.2;
    Blockly.JavaScript.ORDER_BITWISE_SHIFT = 7;
    Blockly.JavaScript.ORDER_RELATIONAL = 8;
    Blockly.JavaScript.ORDER_IN = 8;
    Blockly.JavaScript.ORDER_INSTANCEOF = 8;
    Blockly.JavaScript.ORDER_EQUALITY = 9;
    Blockly.JavaScript.ORDER_BITWISE_AND = 10;
    Blockly.JavaScript.ORDER_BITWISE_XOR = 11;
    Blockly.JavaScript.ORDER_BITWISE_OR = 12;
    Blockly.JavaScript.ORDER_LOGICAL_AND = 13;
    Blockly.JavaScript.ORDER_LOGICAL_OR = 14;
    Blockly.JavaScript.ORDER_CONDITIONAL = 15;
    Blockly.JavaScript.ORDER_ASSIGNMENT = 16;
    Blockly.JavaScript.ORDER_YIELD = 17;
    Blockly.JavaScript.ORDER_COMMA = 18;
    Blockly.JavaScript.ORDER_NONE = 99;
    Blockly.JavaScript.ORDER_OVERRIDES = [
        [
            Blockly.JavaScript.ORDER_FUNCTION_CALL,
            Blockly.JavaScript.ORDER_MEMBER
        ],
        [
            Blockly.JavaScript.ORDER_FUNCTION_CALL,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ],
        [
            Blockly.JavaScript.ORDER_MEMBER,
            Blockly.JavaScript.ORDER_MEMBER
        ],
        [
            Blockly.JavaScript.ORDER_MEMBER,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ],
        [
            Blockly.JavaScript.ORDER_LOGICAL_NOT,
            Blockly.JavaScript.ORDER_LOGICAL_NOT
        ],
        [
            Blockly.JavaScript.ORDER_MULTIPLICATION,
            Blockly.JavaScript.ORDER_MULTIPLICATION
        ],
        [
            Blockly.JavaScript.ORDER_ADDITION,
            Blockly.JavaScript.ORDER_ADDITION
        ],
        [
            Blockly.JavaScript.ORDER_LOGICAL_AND,
            Blockly.JavaScript.ORDER_LOGICAL_AND
        ],
        [
            Blockly.JavaScript.ORDER_LOGICAL_OR,
            Blockly.JavaScript.ORDER_LOGICAL_OR
        ]
    ];
    Blockly.JavaScript.isInitialized = !1;
    Blockly.JavaScript.init = function(a) {
        Blockly.JavaScript.definitions_ = Object.create(null);
        Blockly.JavaScript.functionNames_ = Object.create(null);
        Blockly.JavaScript.variableDB_ ? Blockly.JavaScript.variableDB_.reset() : Blockly.JavaScript.variableDB_ = new Blockly.Names(Blockly.JavaScript.RESERVED_WORDS_);
        Blockly.JavaScript.variableDB_.setVariableMap(a.getVariableMap());
        for(var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++)b.push(Blockly.JavaScript.variableDB_.getName(c[d], Blockly.Names.DEVELOPER_VARIABLE_TYPE));
        a = Blockly.Variables.allUsedVarModels(a);
        for(d = 0; d < a.length; d++)b.push(Blockly.JavaScript.variableDB_.getName(a[d].getId(), Blockly.VARIABLE_CATEGORY_NAME));
        b.length && (Blockly.JavaScript.definitions_.variables = "var " + b.join(", ") + ";");
        this.isInitialized = !0;
    };
    Blockly.JavaScript.finish = function(a) {
        var b = [], c;
        for(c in Blockly.JavaScript.definitions_)b.push(Blockly.JavaScript.definitions_[c]);
        delete Blockly.JavaScript.definitions_;
        delete Blockly.JavaScript.functionNames_;
        Blockly.JavaScript.variableDB_.reset();
        return b.join("\n\n") + "\n\n\n" + a;
    };
    Blockly.JavaScript.scrubNakedValue = function(a) {
        return a + ";\n";
    };
    Blockly.JavaScript.quote_ = function(a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n").replace(/'/g, "\\'");
        return "'" + a + "'";
    };
    Blockly.JavaScript.multiline_quote_ = function(a) {
        return a.split(/\n/g).map(Blockly.JavaScript.quote_).join(" + '\\n' +\n");
    };
    Blockly.JavaScript.scrub_ = function(a, b, c) {
        var d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            e && (e = Blockly.utils.string.wrap(e, Blockly.JavaScript.COMMENT_WRAP - 3), d += Blockly.JavaScript.prefixLines(e + "\n", "// "));
            for(var f = 0; f < a.inputList.length; f++)a.inputList[f].type == Blockly.inputTypes.VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.JavaScript.allNestedComments(e)) && (d += Blockly.JavaScript.prefixLines(e, "// "));
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c = c ? "" : Blockly.JavaScript.blockToCode(a);
        return d + b + c;
    };
    Blockly.JavaScript.getAdjusted = function(a, b, c, d, e) {
        c = c || 0;
        e = e || Blockly.JavaScript.ORDER_NONE;
        a.workspace.options.oneBasedIndex && c--;
        var f = a.workspace.options.oneBasedIndex ? "1" : "0";
        a = 0 < c ? Blockly.JavaScript.valueToCode(a, b, Blockly.JavaScript.ORDER_ADDITION) || f : 0 > c ? Blockly.JavaScript.valueToCode(a, b, Blockly.JavaScript.ORDER_SUBTRACTION) || f : d ? Blockly.JavaScript.valueToCode(a, b, Blockly.JavaScript.ORDER_UNARY_NEGATION) || f : Blockly.JavaScript.valueToCode(a, b, e) || f;
        if (Blockly.isNumber(a)) a = Number(a) + c, d && (a = -a);
        else {
            if (0 < c) {
                a = a + " + " + c;
                var g = Blockly.JavaScript.ORDER_ADDITION;
            } else 0 > c && (a = a + " - " + -c, g = Blockly.JavaScript.ORDER_SUBTRACTION);
            d && (a = c ? "-(" + a + ")" : "-" + a, g = Blockly.JavaScript.ORDER_UNARY_NEGATION);
            g = Math.floor(g);
            e = Math.floor(e);
            g && e >= g && (a = "(" + a + ")");
        }
        return a;
    };
    Blockly.JavaScript.colour = {};
    Blockly.JavaScript.colour_picker = function(a) {
        return [
            Blockly.JavaScript.quote_(a.getFieldValue("COLOUR")),
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.colour_random = function(a) {
        return [
            Blockly.JavaScript.provideFunction_("colourRandom", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "() {",
                "  var num = Math.floor(Math.random() * Math.pow(2, 24));",
                "  return '#' + ('00000' + num.toString(16)).substr(-6);",
                "}"
            ]) + "()",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.colour_rgb = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "RED", Blockly.JavaScript.ORDER_NONE) || 0, c = Blockly.JavaScript.valueToCode(a, "GREEN", Blockly.JavaScript.ORDER_NONE) || 0;
        a = Blockly.JavaScript.valueToCode(a, "BLUE", Blockly.JavaScript.ORDER_NONE) || 0;
        return [
            Blockly.JavaScript.provideFunction_("colourRgb", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(r, g, b) {",
                "  r = Math.max(Math.min(Number(r), 100), 0) * 2.55;",
                "  g = Math.max(Math.min(Number(g), 100), 0) * 2.55;",
                "  b = Math.max(Math.min(Number(b), 100), 0) * 2.55;",
                "  r = ('0' + (Math.round(r) || 0).toString(16)).slice(-2);",
                "  g = ('0' + (Math.round(g) || 0).toString(16)).slice(-2);",
                "  b = ('0' + (Math.round(b) || 0).toString(16)).slice(-2);",
                "  return '#' + r + g + b;",
                "}"
            ]) + "(" + b + ", " + c + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.colour_blend = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "COLOUR1", Blockly.JavaScript.ORDER_NONE) || "'#000000'", c = Blockly.JavaScript.valueToCode(a, "COLOUR2", Blockly.JavaScript.ORDER_NONE) || "'#000000'";
        a = Blockly.JavaScript.valueToCode(a, "RATIO", Blockly.JavaScript.ORDER_NONE) || .5;
        return [
            Blockly.JavaScript.provideFunction_("colourBlend", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(c1, c2, ratio) {",
                "  ratio = Math.max(Math.min(Number(ratio), 1), 0);",
                "  var r1 = parseInt(c1.substring(1, 3), 16);",
                "  var g1 = parseInt(c1.substring(3, 5), 16);",
                "  var b1 = parseInt(c1.substring(5, 7), 16);",
                "  var r2 = parseInt(c2.substring(1, 3), 16);",
                "  var g2 = parseInt(c2.substring(3, 5), 16);",
                "  var b2 = parseInt(c2.substring(5, 7), 16);",
                "  var r = Math.round(r1 * (1 - ratio) + r2 * ratio);",
                "  var g = Math.round(g1 * (1 - ratio) + g2 * ratio);",
                "  var b = Math.round(b1 * (1 - ratio) + b2 * ratio);",
                "  r = ('0' + (r || 0).toString(16)).slice(-2);",
                "  g = ('0' + (g || 0).toString(16)).slice(-2);",
                "  b = ('0' + (b || 0).toString(16)).slice(-2);",
                "  return '#' + r + g + b;",
                "}"
            ]) + "(" + b + ", " + c + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.lists = {};
    Blockly.JavaScript.lists_create_empty = function(a) {
        return [
            "[]",
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.lists_create_with = function(a) {
        for(var b = Array(a.itemCount_), c = 0; c < a.itemCount_; c++)b[c] = Blockly.JavaScript.valueToCode(a, "ADD" + c, Blockly.JavaScript.ORDER_NONE) || "null";
        return [
            "[" + b.join(", ") + "]",
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.lists_repeat = function(a) {
        var b = Blockly.JavaScript.provideFunction_("listsRepeat", [
            "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(value, n) {",
            "  var array = [];",
            "  for (var i = 0; i < n; i++) {",
            "    array[i] = value;",
            "  }",
            "  return array;",
            "}"
        ]), c = Blockly.JavaScript.valueToCode(a, "ITEM", Blockly.JavaScript.ORDER_NONE) || "null";
        a = Blockly.JavaScript.valueToCode(a, "NUM", Blockly.JavaScript.ORDER_NONE) || "0";
        return [
            b + "(" + c + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.lists_length = function(a) {
        return [
            (Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_MEMBER) || "[]") + ".length",
            Blockly.JavaScript.ORDER_MEMBER
        ];
    };
    Blockly.JavaScript.lists_isEmpty = function(a) {
        return [
            "!" + (Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_MEMBER) || "[]") + ".length",
            Blockly.JavaScript.ORDER_LOGICAL_NOT
        ];
    };
    Blockly.JavaScript.lists_indexOf = function(a) {
        var b = "FIRST" == a.getFieldValue("END") ? "indexOf" : "lastIndexOf", c = Blockly.JavaScript.valueToCode(a, "FIND", Blockly.JavaScript.ORDER_NONE) || "''";
        b = (Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_MEMBER) || "[]") + "." + b + "(" + c + ")";
        return a.workspace.options.oneBasedIndex ? [
            b + " + 1",
            Blockly.JavaScript.ORDER_ADDITION
        ] : [
            b,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.lists_getIndex = function(a) {
        var b = a.getFieldValue("MODE") || "GET", c = a.getFieldValue("WHERE") || "FROM_START", d = Blockly.JavaScript.valueToCode(a, "VALUE", "RANDOM" == c ? Blockly.JavaScript.ORDER_NONE : Blockly.JavaScript.ORDER_MEMBER) || "[]";
        switch(c){
            case "FIRST":
                if ("GET" == b) return [
                    d + "[0]",
                    Blockly.JavaScript.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".shift()",
                    Blockly.JavaScript.ORDER_MEMBER
                ];
                if ("REMOVE" == b) return d + ".shift();\n";
                break;
            case "LAST":
                if ("GET" == b) return [
                    d + ".slice(-1)[0]",
                    Blockly.JavaScript.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".pop()",
                    Blockly.JavaScript.ORDER_MEMBER
                ];
                if ("REMOVE" == b) return d + ".pop();\n";
                break;
            case "FROM_START":
                a = Blockly.JavaScript.getAdjusted(a, "AT");
                if ("GET" == b) return [
                    d + "[" + a + "]",
                    Blockly.JavaScript.ORDER_MEMBER
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".splice(" + a + ", 1)[0]",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ".splice(" + a + ", 1);\n";
                break;
            case "FROM_END":
                a = Blockly.JavaScript.getAdjusted(a, "AT", 1, !0);
                if ("GET" == b) return [
                    d + ".slice(" + a + ")[0]",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
                if ("GET_REMOVE" == b) return [
                    d + ".splice(" + a + ", 1)[0]",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ".splice(" + a + ", 1);";
                break;
            case "RANDOM":
                d = Blockly.JavaScript.provideFunction_("listsGetRandomItem", [
                    "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(list, remove) {",
                    "  var x = Math.floor(Math.random() * list.length);",
                    "  if (remove) {",
                    "    return list.splice(x, 1)[0];",
                    "  } else {",
                    "    return list[x];",
                    "  }",
                    "}"
                ]) + "(" + d + ", " + ("GET" != b) + ")";
                if ("GET" == b || "GET_REMOVE" == b) return [
                    d,
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
                if ("REMOVE" == b) return d + ";\n";
        }
        throw Error("Unhandled combination (lists_getIndex).");
    };
    Blockly.JavaScript.lists_setIndex = function(a) {
        function b() {
            if (c.match(/^\w+$/)) return "";
            var g = Blockly.JavaScript.variableDB_.getDistinctName("tmpList", Blockly.VARIABLE_CATEGORY_NAME), h = "var " + g + " = " + c + ";\n";
            c = g;
            return h;
        }
        var c = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_MEMBER) || "[]", d = a.getFieldValue("MODE") || "GET", e = a.getFieldValue("WHERE") || "FROM_START", f = Blockly.JavaScript.valueToCode(a, "TO", Blockly.JavaScript.ORDER_ASSIGNMENT) || "null";
        switch(e){
            case "FIRST":
                if ("SET" == d) return c + "[0] = " + f + ";\n";
                if ("INSERT" == d) return c + ".unshift(" + f + ");\n";
                break;
            case "LAST":
                if ("SET" == d) return a = b(), a + (c + "[" + c + ".length - 1] = " + f + ";\n");
                if ("INSERT" == d) return c + ".push(" + f + ");\n";
                break;
            case "FROM_START":
                e = Blockly.JavaScript.getAdjusted(a, "AT");
                if ("SET" == d) return c + "[" + e + "] = " + f + ";\n";
                if ("INSERT" == d) return c + ".splice(" + e + ", 0, " + f + ");\n";
                break;
            case "FROM_END":
                e = Blockly.JavaScript.getAdjusted(a, "AT", 1, !1, Blockly.JavaScript.ORDER_SUBTRACTION);
                a = b();
                if ("SET" == d) return a + (c + "[" + c + ".length - " + e + "] = " + f + ";\n");
                if ("INSERT" == d) return a + (c + ".splice(" + c + ".length - " + e + ", 0, " + f + ");\n");
                break;
            case "RANDOM":
                a = b();
                e = Blockly.JavaScript.variableDB_.getDistinctName("tmpX", Blockly.VARIABLE_CATEGORY_NAME);
                a += "var " + e + " = Math.floor(Math.random() * " + c + ".length);\n";
                if ("SET" == d) return a + (c + "[" + e + "] = " + f + ";\n");
                if ("INSERT" == d) return a + (c + ".splice(" + e + ", 0, " + f + ");\n");
        }
        throw Error("Unhandled combination (lists_setIndex).");
    };
    Blockly.JavaScript.lists.getIndex_ = function(a, b, c) {
        return "FIRST" == b ? "0" : "FROM_END" == b ? a + ".length - 1 - " + c : "LAST" == b ? a + ".length - 1" : c;
    };
    Blockly.JavaScript.lists_getSublist = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_MEMBER) || "[]", c = a.getFieldValue("WHERE1"), d = a.getFieldValue("WHERE2");
        if ("FIRST" == c && "LAST" == d) b += ".slice(0)";
        else if (b.match(/^\w+$/) || "FROM_END" != c && "FROM_START" == d) {
            switch(c){
                case "FROM_START":
                    var e = Blockly.JavaScript.getAdjusted(a, "AT1");
                    break;
                case "FROM_END":
                    e = Blockly.JavaScript.getAdjusted(a, "AT1", 1, !1, Blockly.JavaScript.ORDER_SUBTRACTION);
                    e = b + ".length - " + e;
                    break;
                case "FIRST":
                    e = "0";
                    break;
                default:
                    throw Error("Unhandled option (lists_getSublist).");
            }
            switch(d){
                case "FROM_START":
                    a = Blockly.JavaScript.getAdjusted(a, "AT2", 1);
                    break;
                case "FROM_END":
                    a = Blockly.JavaScript.getAdjusted(a, "AT2", 0, !1, Blockly.JavaScript.ORDER_SUBTRACTION);
                    a = b + ".length - " + a;
                    break;
                case "LAST":
                    a = b + ".length";
                    break;
                default:
                    throw Error("Unhandled option (lists_getSublist).");
            }
            b = b + ".slice(" + e + ", " + a + ")";
        } else {
            e = Blockly.JavaScript.getAdjusted(a, "AT1");
            a = Blockly.JavaScript.getAdjusted(a, "AT2");
            var f = Blockly.JavaScript.lists.getIndex_, g = {
                FIRST: "First",
                LAST: "Last",
                FROM_START: "FromStart",
                FROM_END: "FromEnd"
            };
            b = Blockly.JavaScript.provideFunction_("subsequence" + g[c] + g[d], [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(sequence" + ("FROM_END" == c || "FROM_START" == c ? ", at1" : "") + ("FROM_END" == d || "FROM_START" == d ? ", at2" : "") + ") {",
                "  var start = " + f("sequence", c, "at1") + ";",
                "  var end = " + f("sequence", d, "at2") + " + 1;",
                "  return sequence.slice(start, end);",
                "}"
            ]) + "(" + b + ("FROM_END" == c || "FROM_START" == c ? ", " + e : "") + ("FROM_END" == d || "FROM_START" == d ? ", " + a : "") + ")";
        }
        return [
            b,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.lists_sort = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_FUNCTION_CALL) || "[]", c = "1" === a.getFieldValue("DIRECTION") ? 1 : -1;
        a = a.getFieldValue("TYPE");
        var d = Blockly.JavaScript.provideFunction_("listsGetSortCompare", [
            "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(type, direction) {",
            "  var compareFuncs = {",
            '    "NUMERIC": function(a, b) {',
            "        return Number(a) - Number(b); },",
            '    "TEXT": function(a, b) {',
            "        return a.toString() > b.toString() ? 1 : -1; },",
            '    "IGNORE_CASE": function(a, b) {',
            "        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },",
            "  };",
            "  var compare = compareFuncs[type];",
            "  return function(a, b) { return compare(a, b) * direction; }",
            "}"
        ]);
        return [
            b + ".slice().sort(" + d + '("' + a + '", ' + c + "))",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.lists_split = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "INPUT", Blockly.JavaScript.ORDER_MEMBER), c = Blockly.JavaScript.valueToCode(a, "DELIM", Blockly.JavaScript.ORDER_NONE) || "''";
        a = a.getFieldValue("MODE");
        if ("SPLIT" == a) b || (b = "''"), a = "split";
        else if ("JOIN" == a) b || (b = "[]"), a = "join";
        else throw Error("Unknown mode: " + a);
        return [
            b + "." + a + "(" + c + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.lists_reverse = function(a) {
        return [
            (Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_FUNCTION_CALL) || "[]") + ".slice().reverse()",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.logic = {};
    Blockly.JavaScript.controls_if = function(a) {
        var b = 0, c = "";
        Blockly.JavaScript.STATEMENT_PREFIX && (c += Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX, a));
        do {
            var d = Blockly.JavaScript.valueToCode(a, "IF" + b, Blockly.JavaScript.ORDER_NONE) || "false";
            var e = Blockly.JavaScript.statementToCode(a, "DO" + b);
            Blockly.JavaScript.STATEMENT_SUFFIX && (e = Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX, a), Blockly.JavaScript.INDENT) + e);
            c += (0 < b ? " else " : "") + "if (" + d + ") {\n" + e + "}";
            ++b;
        }while (a.getInput("IF" + b));
        if (a.getInput("ELSE") || Blockly.JavaScript.STATEMENT_SUFFIX) e = Blockly.JavaScript.statementToCode(a, "ELSE"), Blockly.JavaScript.STATEMENT_SUFFIX && (e = Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX, a), Blockly.JavaScript.INDENT) + e), c += " else {\n" + e + "}";
        return c + "\n";
    };
    Blockly.JavaScript.controls_ifelse = Blockly.JavaScript.controls_if;
    Blockly.JavaScript.logic_compare = function(a) {
        var b = {
            EQ: "==",
            NEQ: "!=",
            LT: "<",
            LTE: "<=",
            GT: ">",
            GTE: ">="
        }[a.getFieldValue("OP")], c = "==" == b || "!=" == b ? Blockly.JavaScript.ORDER_EQUALITY : Blockly.JavaScript.ORDER_RELATIONAL, d = Blockly.JavaScript.valueToCode(a, "A", c) || "0";
        a = Blockly.JavaScript.valueToCode(a, "B", c) || "0";
        return [
            d + " " + b + " " + a,
            c
        ];
    };
    Blockly.JavaScript.logic_operation = function(a) {
        var b = "AND" == a.getFieldValue("OP") ? "&&" : "||", c = "&&" == b ? Blockly.JavaScript.ORDER_LOGICAL_AND : Blockly.JavaScript.ORDER_LOGICAL_OR, d = Blockly.JavaScript.valueToCode(a, "A", c);
        a = Blockly.JavaScript.valueToCode(a, "B", c);
        if (d || a) {
            var e = "&&" == b ? "true" : "false";
            d || (d = e);
            a || (a = e);
        } else a = d = "false";
        return [
            d + " " + b + " " + a,
            c
        ];
    };
    Blockly.JavaScript.logic_negate = function(a) {
        var b = Blockly.JavaScript.ORDER_LOGICAL_NOT;
        return [
            "!" + (Blockly.JavaScript.valueToCode(a, "BOOL", b) || "true"),
            b
        ];
    };
    Blockly.JavaScript.logic_boolean = function(a) {
        return [
            "TRUE" == a.getFieldValue("BOOL") ? "true" : "false",
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.logic_null = function(a) {
        return [
            "null",
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.logic_ternary = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "IF", Blockly.JavaScript.ORDER_CONDITIONAL) || "false", c = Blockly.JavaScript.valueToCode(a, "THEN", Blockly.JavaScript.ORDER_CONDITIONAL) || "null";
        a = Blockly.JavaScript.valueToCode(a, "ELSE", Blockly.JavaScript.ORDER_CONDITIONAL) || "null";
        return [
            b + " ? " + c + " : " + a,
            Blockly.JavaScript.ORDER_CONDITIONAL
        ];
    };
    Blockly.JavaScript.loops = {};
    Blockly.JavaScript.controls_repeat_ext = function(a) {
        var b = a.getField("TIMES") ? String(Number(a.getFieldValue("TIMES"))) : Blockly.JavaScript.valueToCode(a, "TIMES", Blockly.JavaScript.ORDER_ASSIGNMENT) || "0", c = Blockly.JavaScript.statementToCode(a, "DO");
        c = Blockly.JavaScript.addLoopTrap(c, a);
        a = "";
        var d = Blockly.JavaScript.variableDB_.getDistinctName("count", Blockly.VARIABLE_CATEGORY_NAME), e = b;
        b.match(/^\w+$/) || Blockly.isNumber(b) || (e = Blockly.JavaScript.variableDB_.getDistinctName("repeat_end", Blockly.VARIABLE_CATEGORY_NAME), a += "var " + e + " = " + b + ";\n");
        return a + ("for (var " + d + " = 0; " + d + " < " + e + "; " + d + "++) {\n" + c + "}\n");
    };
    Blockly.JavaScript.controls_repeat = Blockly.JavaScript.controls_repeat_ext;
    Blockly.JavaScript.controls_whileUntil = function(a) {
        var b = "UNTIL" == a.getFieldValue("MODE"), c = Blockly.JavaScript.valueToCode(a, "BOOL", b ? Blockly.JavaScript.ORDER_LOGICAL_NOT : Blockly.JavaScript.ORDER_NONE) || "false", d = Blockly.JavaScript.statementToCode(a, "DO");
        d = Blockly.JavaScript.addLoopTrap(d, a);
        b && (c = "!" + c);
        return "while (" + c + ") {\n" + d + "}\n";
    };
    Blockly.JavaScript.controls_for = function(a) {
        var b = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME), c = Blockly.JavaScript.valueToCode(a, "FROM", Blockly.JavaScript.ORDER_ASSIGNMENT) || "0", d = Blockly.JavaScript.valueToCode(a, "TO", Blockly.JavaScript.ORDER_ASSIGNMENT) || "0", e = Blockly.JavaScript.valueToCode(a, "BY", Blockly.JavaScript.ORDER_ASSIGNMENT) || "1", f = Blockly.JavaScript.statementToCode(a, "DO");
        f = Blockly.JavaScript.addLoopTrap(f, a);
        if (Blockly.isNumber(c) && Blockly.isNumber(d) && Blockly.isNumber(e)) {
            var g = Number(c) <= Number(d);
            a = "for (" + b + " = " + c + "; " + b + (g ? " <= " : " >= ") + d + "; " + b;
            b = Math.abs(Number(e));
            a = (1 == b ? a + (g ? "++" : "--") : a + ((g ? " += " : " -= ") + b)) + (") {\n" + f + "}\n");
        } else a = "", g = c, c.match(/^\w+$/) || Blockly.isNumber(c) || (g = Blockly.JavaScript.variableDB_.getDistinctName(b + "_start", Blockly.VARIABLE_CATEGORY_NAME), a += "var " + g + " = " + c + ";\n"), c = d, d.match(/^\w+$/) || Blockly.isNumber(d) || (c = Blockly.JavaScript.variableDB_.getDistinctName(b + "_end", Blockly.VARIABLE_CATEGORY_NAME), a += "var " + c + " = " + d + ";\n"), d = Blockly.JavaScript.variableDB_.getDistinctName(b + "_inc", Blockly.VARIABLE_CATEGORY_NAME), a += "var " + d + " = ", a = Blockly.isNumber(e) ? a + (Math.abs(e) + ";\n") : a + ("Math.abs(" + e + ");\n"), a = a + ("if (" + g + " > " + c + ") {\n") + (Blockly.JavaScript.INDENT + d + " = -" + d + ";\n"), a += "}\n", a += "for (" + b + " = " + g + "; " + d + " >= 0 ? " + b + " <= " + c + " : " + b + " >= " + c + "; " + b + " += " + d + ") {\n" + f + "}\n";
        return a;
    };
    Blockly.JavaScript.controls_forEach = function(a) {
        var b = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME), c = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_ASSIGNMENT) || "[]", d = Blockly.JavaScript.statementToCode(a, "DO");
        d = Blockly.JavaScript.addLoopTrap(d, a);
        a = "";
        var e = c;
        c.match(/^\w+$/) || (e = Blockly.JavaScript.variableDB_.getDistinctName(b + "_list", Blockly.VARIABLE_CATEGORY_NAME), a += "var " + e + " = " + c + ";\n");
        c = Blockly.JavaScript.variableDB_.getDistinctName(b + "_index", Blockly.VARIABLE_CATEGORY_NAME);
        d = Blockly.JavaScript.INDENT + b + " = " + e + "[" + c + "];\n" + d;
        return a + ("for (var " + c + " in " + e + ") {\n" + d + "}\n");
    };
    Blockly.JavaScript.controls_flow_statements = function(a) {
        var b = "";
        Blockly.JavaScript.STATEMENT_PREFIX && (b += Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX, a));
        Blockly.JavaScript.STATEMENT_SUFFIX && (b += Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX, a));
        if (Blockly.JavaScript.STATEMENT_PREFIX) {
            var c = Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.getSurroundLoop(a);
            c && !c.suppressPrefixSuffix && (b += Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX, c));
        }
        switch(a.getFieldValue("FLOW")){
            case "BREAK":
                return b + "break;\n";
            case "CONTINUE":
                return b + "continue;\n";
        }
        throw Error("Unknown flow statement.");
    };
    Blockly.JavaScript.math = {};
    Blockly.JavaScript.math_number = function(a) {
        a = Number(a.getFieldValue("NUM"));
        return [
            a,
            0 <= a ? Blockly.JavaScript.ORDER_ATOMIC : Blockly.JavaScript.ORDER_UNARY_NEGATION
        ];
    };
    Blockly.JavaScript.math_arithmetic = function(a) {
        var b = {
            ADD: [
                " + ",
                Blockly.JavaScript.ORDER_ADDITION
            ],
            MINUS: [
                " - ",
                Blockly.JavaScript.ORDER_SUBTRACTION
            ],
            MULTIPLY: [
                " * ",
                Blockly.JavaScript.ORDER_MULTIPLICATION
            ],
            DIVIDE: [
                " / ",
                Blockly.JavaScript.ORDER_DIVISION
            ],
            POWER: [
                null,
                Blockly.JavaScript.ORDER_NONE
            ]
        }[a.getFieldValue("OP")], c = b[0];
        b = b[1];
        var d = Blockly.JavaScript.valueToCode(a, "A", b) || "0";
        a = Blockly.JavaScript.valueToCode(a, "B", b) || "0";
        return c ? [
            d + c + a,
            b
        ] : [
            "Math.pow(" + d + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.math_single = function(a) {
        var b = a.getFieldValue("OP");
        if ("NEG" == b) return a = Blockly.JavaScript.valueToCode(a, "NUM", Blockly.JavaScript.ORDER_UNARY_NEGATION) || "0", "-" == a[0] && (a = " " + a), [
            "-" + a,
            Blockly.JavaScript.ORDER_UNARY_NEGATION
        ];
        a = "SIN" == b || "COS" == b || "TAN" == b ? Blockly.JavaScript.valueToCode(a, "NUM", Blockly.JavaScript.ORDER_DIVISION) || "0" : Blockly.JavaScript.valueToCode(a, "NUM", Blockly.JavaScript.ORDER_NONE) || "0";
        switch(b){
            case "ABS":
                var c = "Math.abs(" + a + ")";
                break;
            case "ROOT":
                c = "Math.sqrt(" + a + ")";
                break;
            case "LN":
                c = "Math.log(" + a + ")";
                break;
            case "EXP":
                c = "Math.exp(" + a + ")";
                break;
            case "POW10":
                c = "Math.pow(10," + a + ")";
                break;
            case "ROUND":
                c = "Math.round(" + a + ")";
                break;
            case "ROUNDUP":
                c = "Math.ceil(" + a + ")";
                break;
            case "ROUNDDOWN":
                c = "Math.floor(" + a + ")";
                break;
            case "SIN":
                c = "Math.sin(" + a + " / 180 * Math.PI)";
                break;
            case "COS":
                c = "Math.cos(" + a + " / 180 * Math.PI)";
                break;
            case "TAN":
                c = "Math.tan(" + a + " / 180 * Math.PI)";
        }
        if (c) return [
            c,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
        switch(b){
            case "LOG10":
                c = "Math.log(" + a + ") / Math.log(10)";
                break;
            case "ASIN":
                c = "Math.asin(" + a + ") / Math.PI * 180";
                break;
            case "ACOS":
                c = "Math.acos(" + a + ") / Math.PI * 180";
                break;
            case "ATAN":
                c = "Math.atan(" + a + ") / Math.PI * 180";
                break;
            default:
                throw Error("Unknown math operator: " + b);
        }
        return [
            c,
            Blockly.JavaScript.ORDER_DIVISION
        ];
    };
    Blockly.JavaScript.math_constant = function(a) {
        return ({
            PI: [
                "Math.PI",
                Blockly.JavaScript.ORDER_MEMBER
            ],
            E: [
                "Math.E",
                Blockly.JavaScript.ORDER_MEMBER
            ],
            GOLDEN_RATIO: [
                "(1 + Math.sqrt(5)) / 2",
                Blockly.JavaScript.ORDER_DIVISION
            ],
            SQRT2: [
                "Math.SQRT2",
                Blockly.JavaScript.ORDER_MEMBER
            ],
            SQRT1_2: [
                "Math.SQRT1_2",
                Blockly.JavaScript.ORDER_MEMBER
            ],
            INFINITY: [
                "Infinity",
                Blockly.JavaScript.ORDER_ATOMIC
            ]
        })[a.getFieldValue("CONSTANT")];
    };
    Blockly.JavaScript.math_number_property = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "NUMBER_TO_CHECK", Blockly.JavaScript.ORDER_MODULUS) || "0", c = a.getFieldValue("PROPERTY");
        if ("PRIME" == c) return [
            Blockly.JavaScript.provideFunction_("mathIsPrime", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(n) {",
                "  // https://en.wikipedia.org/wiki/Primality_test#Naive_methods",
                "  if (n == 2 || n == 3) {",
                "    return true;",
                "  }",
                "  // False if n is NaN, negative, is 1, or not whole.",
                "  // And false if n is divisible by 2 or 3.",
                "  if (isNaN(n) || n <= 1 || n % 1 != 0 || n % 2 == 0 || n % 3 == 0) {",
                "    return false;",
                "  }",
                "  // Check all the numbers of form 6k +/- 1, up to sqrt(n).",
                "  for (var x = 6; x <= Math.sqrt(n) + 1; x += 6) {",
                "    if (n % (x - 1) == 0 || n % (x + 1) == 0) {",
                "      return false;",
                "    }",
                "  }",
                "  return true;",
                "}"
            ]) + "(" + b + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
        switch(c){
            case "EVEN":
                var d = b + " % 2 == 0";
                break;
            case "ODD":
                d = b + " % 2 == 1";
                break;
            case "WHOLE":
                d = b + " % 1 == 0";
                break;
            case "POSITIVE":
                d = b + " > 0";
                break;
            case "NEGATIVE":
                d = b + " < 0";
                break;
            case "DIVISIBLE_BY":
                a = Blockly.JavaScript.valueToCode(a, "DIVISOR", Blockly.JavaScript.ORDER_MODULUS) || "0", d = b + " % " + a + " == 0";
        }
        return [
            d,
            Blockly.JavaScript.ORDER_EQUALITY
        ];
    };
    Blockly.JavaScript.math_change = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "DELTA", Blockly.JavaScript.ORDER_ADDITION) || "0";
        a = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME);
        return a + " = (typeof " + a + " == 'number' ? " + a + " : 0) + " + b + ";\n";
    };
    Blockly.JavaScript.math_round = Blockly.JavaScript.math_single;
    Blockly.JavaScript.math_trig = Blockly.JavaScript.math_single;
    Blockly.JavaScript.math_on_list = function(a) {
        var b = a.getFieldValue("OP");
        switch(b){
            case "SUM":
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_MEMBER) || "[]";
                a += ".reduce(function(x, y) {return x + y;})";
                break;
            case "MIN":
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = "Math.min.apply(null, " + a + ")";
                break;
            case "MAX":
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = "Math.max.apply(null, " + a + ")";
                break;
            case "AVERAGE":
                b = Blockly.JavaScript.provideFunction_("mathMean", [
                    "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(myList) {",
                    "  return myList.reduce(function(x, y) {return x + y;}) / myList.length;",
                    "}"
                ]);
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "MEDIAN":
                b = Blockly.JavaScript.provideFunction_("mathMedian", [
                    "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(myList) {",
                    "  var localList = myList.filter(function (x) {return typeof x == 'number';});",
                    "  if (!localList.length) return null;",
                    "  localList.sort(function(a, b) {return b - a;});",
                    "  if (localList.length % 2 == 0) {",
                    "    return (localList[localList.length / 2 - 1] + localList[localList.length / 2]) / 2;",
                    "  } else {",
                    "    return localList[(localList.length - 1) / 2];",
                    "  }",
                    "}"
                ]);
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "MODE":
                b = Blockly.JavaScript.provideFunction_("mathModes", [
                    "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(values) {",
                    "  var modes = [];",
                    "  var counts = [];",
                    "  var maxCount = 0;",
                    "  for (var i = 0; i < values.length; i++) {",
                    "    var value = values[i];",
                    "    var found = false;",
                    "    var thisCount;",
                    "    for (var j = 0; j < counts.length; j++) {",
                    "      if (counts[j][0] === value) {",
                    "        thisCount = ++counts[j][1];",
                    "        found = true;",
                    "        break;",
                    "      }",
                    "    }",
                    "    if (!found) {",
                    "      counts.push([value, 1]);",
                    "      thisCount = 1;",
                    "    }",
                    "    maxCount = Math.max(thisCount, maxCount);",
                    "  }",
                    "  for (var j = 0; j < counts.length; j++) {",
                    "    if (counts[j][1] == maxCount) {",
                    "        modes.push(counts[j][0]);",
                    "    }",
                    "  }",
                    "  return modes;",
                    "}"
                ]);
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "STD_DEV":
                b = Blockly.JavaScript.provideFunction_("mathStandardDeviation", [
                    "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(numbers) {",
                    "  var n = numbers.length;",
                    "  if (!n) return null;",
                    "  var mean = numbers.reduce(function(x, y) {return x + y;}) / n;",
                    "  var variance = 0;",
                    "  for (var j = 0; j < n; j++) {",
                    "    variance += Math.pow(numbers[j] - mean, 2);",
                    "  }",
                    "  variance = variance / n;",
                    "  return Math.sqrt(variance);",
                    "}"
                ]);
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            case "RANDOM":
                b = Blockly.JavaScript.provideFunction_("mathRandomList", [
                    "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(list) {",
                    "  var x = Math.floor(Math.random() * list.length);",
                    "  return list[x];",
                    "}"
                ]);
                a = Blockly.JavaScript.valueToCode(a, "LIST", Blockly.JavaScript.ORDER_NONE) || "[]";
                a = b + "(" + a + ")";
                break;
            default:
                throw Error("Unknown operator: " + b);
        }
        return [
            a,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.math_modulo = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "DIVIDEND", Blockly.JavaScript.ORDER_MODULUS) || "0";
        a = Blockly.JavaScript.valueToCode(a, "DIVISOR", Blockly.JavaScript.ORDER_MODULUS) || "0";
        return [
            b + " % " + a,
            Blockly.JavaScript.ORDER_MODULUS
        ];
    };
    Blockly.JavaScript.math_constrain = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_NONE) || "0", c = Blockly.JavaScript.valueToCode(a, "LOW", Blockly.JavaScript.ORDER_NONE) || "0";
        a = Blockly.JavaScript.valueToCode(a, "HIGH", Blockly.JavaScript.ORDER_NONE) || "Infinity";
        return [
            "Math.min(Math.max(" + b + ", " + c + "), " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.math_random_int = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "FROM", Blockly.JavaScript.ORDER_NONE) || "0";
        a = Blockly.JavaScript.valueToCode(a, "TO", Blockly.JavaScript.ORDER_NONE) || "0";
        return [
            Blockly.JavaScript.provideFunction_("mathRandomInt", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(a, b) {",
                "  if (a > b) {",
                "    // Swap a and b to ensure a is smaller.",
                "    var c = a;",
                "    a = b;",
                "    b = c;",
                "  }",
                "  return Math.floor(Math.random() * (b - a + 1) + a);",
                "}"
            ]) + "(" + b + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.math_random_float = function(a) {
        return [
            "Math.random()",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.math_atan2 = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "X", Blockly.JavaScript.ORDER_NONE) || "0";
        return [
            "Math.atan2(" + (Blockly.JavaScript.valueToCode(a, "Y", Blockly.JavaScript.ORDER_NONE) || "0") + ", " + b + ") / Math.PI * 180",
            Blockly.JavaScript.ORDER_DIVISION
        ];
    };
    Blockly.JavaScript.procedures = {};
    Blockly.JavaScript.procedures_defreturn = function(a) {
        var b = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("NAME"), Blockly.PROCEDURE_CATEGORY_NAME), c = "";
        Blockly.JavaScript.STATEMENT_PREFIX && (c += Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX, a));
        Blockly.JavaScript.STATEMENT_SUFFIX && (c += Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX, a));
        c && (c = Blockly.JavaScript.prefixLines(c, Blockly.JavaScript.INDENT));
        var d = "";
        Blockly.JavaScript.INFINITE_LOOP_TRAP && (d = Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.INFINITE_LOOP_TRAP, a), Blockly.JavaScript.INDENT));
        var e = Blockly.JavaScript.statementToCode(a, "STACK"), f = Blockly.JavaScript.valueToCode(a, "RETURN", Blockly.JavaScript.ORDER_NONE) || "", g = "";
        e && f && (g = c);
        f && (f = Blockly.JavaScript.INDENT + "return " + f + ";\n");
        for(var h = [], l = a.getVars(), k = 0; k < l.length; k++)h[k] = Blockly.JavaScript.variableDB_.getName(l[k], Blockly.VARIABLE_CATEGORY_NAME);
        c = "function " + b + "(" + h.join(", ") + ") {\n" + c + d + e + g + f + "}";
        c = Blockly.JavaScript.scrub_(a, c);
        Blockly.JavaScript.definitions_["%" + b] = c;
        return null;
    };
    Blockly.JavaScript.procedures_defnoreturn = Blockly.JavaScript.procedures_defreturn;
    Blockly.JavaScript.procedures_callreturn = function(a) {
        for(var b = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("NAME"), Blockly.PROCEDURE_CATEGORY_NAME), c = [], d = a.getVars(), e = 0; e < d.length; e++)c[e] = Blockly.JavaScript.valueToCode(a, "ARG" + e, Blockly.JavaScript.ORDER_NONE) || "null";
        return [
            b + "(" + c.join(", ") + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.procedures_callnoreturn = function(a) {
        return Blockly.JavaScript.procedures_callreturn(a)[0] + ";\n";
    };
    Blockly.JavaScript.procedures_ifreturn = function(a) {
        var b = "if (" + (Blockly.JavaScript.valueToCode(a, "CONDITION", Blockly.JavaScript.ORDER_NONE) || "false") + ") {\n";
        Blockly.JavaScript.STATEMENT_SUFFIX && (b += Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX, a), Blockly.JavaScript.INDENT));
        a.hasReturnValue_ ? (a = Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_NONE) || "null", b += Blockly.JavaScript.INDENT + "return " + a + ";\n") : b += Blockly.JavaScript.INDENT + "return;\n";
        return b + "}\n";
    };
    Blockly.JavaScript.texts = {};
    Blockly.JavaScript.text = function(a) {
        return [
            Blockly.JavaScript.quote_(a.getFieldValue("TEXT")),
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.text_multiline = function(a) {
        a = Blockly.JavaScript.multiline_quote_(a.getFieldValue("TEXT"));
        var b = -1 != a.indexOf("+") ? Blockly.JavaScript.ORDER_ADDITION : Blockly.JavaScript.ORDER_ATOMIC;
        return [
            a,
            b
        ];
    };
    Blockly.JavaScript.text.forceString_ = function(a) {
        return Blockly.JavaScript.text.forceString_.strRegExp.test(a) ? [
            a,
            Blockly.JavaScript.ORDER_ATOMIC
        ] : [
            "String(" + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text.forceString_.strRegExp = /^\s*'([^']|\\')*'\s*$/;
    Blockly.JavaScript.text_join = function(a) {
        switch(a.itemCount_){
            case 0:
                return [
                    "''",
                    Blockly.JavaScript.ORDER_ATOMIC
                ];
            case 1:
                return a = Blockly.JavaScript.valueToCode(a, "ADD0", Blockly.JavaScript.ORDER_NONE) || "''", Blockly.JavaScript.text.forceString_(a);
            case 2:
                var b = Blockly.JavaScript.valueToCode(a, "ADD0", Blockly.JavaScript.ORDER_NONE) || "''";
                a = Blockly.JavaScript.valueToCode(a, "ADD1", Blockly.JavaScript.ORDER_NONE) || "''";
                a = Blockly.JavaScript.text.forceString_(b)[0] + " + " + Blockly.JavaScript.text.forceString_(a)[0];
                return [
                    a,
                    Blockly.JavaScript.ORDER_ADDITION
                ];
            default:
                b = Array(a.itemCount_);
                for(var c = 0; c < a.itemCount_; c++)b[c] = Blockly.JavaScript.valueToCode(a, "ADD" + c, Blockly.JavaScript.ORDER_NONE) || "''";
                a = "[" + b.join(",") + "].join('')";
                return [
                    a,
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
        }
    };
    Blockly.JavaScript.text_append = function(a) {
        var b = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME);
        a = Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_NONE) || "''";
        return b + " += " + Blockly.JavaScript.text.forceString_(a)[0] + ";\n";
    };
    Blockly.JavaScript.text_length = function(a) {
        return [
            (Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_MEMBER) || "''") + ".length",
            Blockly.JavaScript.ORDER_MEMBER
        ];
    };
    Blockly.JavaScript.text_isEmpty = function(a) {
        return [
            "!" + (Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_MEMBER) || "''") + ".length",
            Blockly.JavaScript.ORDER_LOGICAL_NOT
        ];
    };
    Blockly.JavaScript.text_indexOf = function(a) {
        var b = "FIRST" == a.getFieldValue("END") ? "indexOf" : "lastIndexOf", c = Blockly.JavaScript.valueToCode(a, "FIND", Blockly.JavaScript.ORDER_NONE) || "''";
        b = (Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_MEMBER) || "''") + "." + b + "(" + c + ")";
        return a.workspace.options.oneBasedIndex ? [
            b + " + 1",
            Blockly.JavaScript.ORDER_ADDITION
        ] : [
            b,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_charAt = function(a) {
        var b = a.getFieldValue("WHERE") || "FROM_START", c = Blockly.JavaScript.valueToCode(a, "VALUE", "RANDOM" == b ? Blockly.JavaScript.ORDER_NONE : Blockly.JavaScript.ORDER_MEMBER) || "''";
        switch(b){
            case "FIRST":
                return [
                    c + ".charAt(0)",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
            case "LAST":
                return [
                    c + ".slice(-1)",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
            case "FROM_START":
                return a = Blockly.JavaScript.getAdjusted(a, "AT"), [
                    c + ".charAt(" + a + ")",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
            case "FROM_END":
                return a = Blockly.JavaScript.getAdjusted(a, "AT", 1, !0), [
                    c + ".slice(" + a + ").charAt(0)",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
            case "RANDOM":
                return [
                    Blockly.JavaScript.provideFunction_("textRandomLetter", [
                        "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(text) {",
                        "  var x = Math.floor(Math.random() * text.length);",
                        "  return text[x];",
                        "}"
                    ]) + "(" + c + ")",
                    Blockly.JavaScript.ORDER_FUNCTION_CALL
                ];
        }
        throw Error("Unhandled option (text_charAt).");
    };
    Blockly.JavaScript.text.getIndex_ = function(a, b, c) {
        return "FIRST" == b ? "0" : "FROM_END" == b ? a + ".length - 1 - " + c : "LAST" == b ? a + ".length - 1" : c;
    };
    Blockly.JavaScript.text_getSubstring = function(a) {
        var b = a.getFieldValue("WHERE1"), c = a.getFieldValue("WHERE2"), d = "FROM_END" != b && "LAST" != b && "FROM_END" != c && "LAST" != c, e = Blockly.JavaScript.valueToCode(a, "STRING", d ? Blockly.JavaScript.ORDER_MEMBER : Blockly.JavaScript.ORDER_NONE) || "''";
        if ("FIRST" == b && "LAST" == c) return [
            e,
            Blockly.JavaScript.ORDER_NONE
        ];
        if (e.match(/^'?\w+'?$/) || d) {
            switch(b){
                case "FROM_START":
                    d = Blockly.JavaScript.getAdjusted(a, "AT1");
                    break;
                case "FROM_END":
                    d = Blockly.JavaScript.getAdjusted(a, "AT1", 1, !1, Blockly.JavaScript.ORDER_SUBTRACTION);
                    d = e + ".length - " + d;
                    break;
                case "FIRST":
                    d = "0";
                    break;
                default:
                    throw Error("Unhandled option (text_getSubstring).");
            }
            switch(c){
                case "FROM_START":
                    a = Blockly.JavaScript.getAdjusted(a, "AT2", 1);
                    break;
                case "FROM_END":
                    a = Blockly.JavaScript.getAdjusted(a, "AT2", 0, !1, Blockly.JavaScript.ORDER_SUBTRACTION);
                    a = e + ".length - " + a;
                    break;
                case "LAST":
                    a = e + ".length";
                    break;
                default:
                    throw Error("Unhandled option (text_getSubstring).");
            }
            b = e + ".slice(" + d + ", " + a + ")";
        } else {
            d = Blockly.JavaScript.getAdjusted(a, "AT1");
            a = Blockly.JavaScript.getAdjusted(a, "AT2");
            var f = Blockly.JavaScript.text.getIndex_, g = {
                FIRST: "First",
                LAST: "Last",
                FROM_START: "FromStart",
                FROM_END: "FromEnd"
            };
            b = Blockly.JavaScript.provideFunction_("subsequence" + g[b] + g[c], [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(sequence" + ("FROM_END" == b || "FROM_START" == b ? ", at1" : "") + ("FROM_END" == c || "FROM_START" == c ? ", at2" : "") + ") {",
                "  var start = " + f("sequence", b, "at1") + ";",
                "  var end = " + f("sequence", c, "at2") + " + 1;",
                "  return sequence.slice(start, end);",
                "}"
            ]) + "(" + e + ("FROM_END" == b || "FROM_START" == b ? ", " + d : "") + ("FROM_END" == c || "FROM_START" == c ? ", " + a : "") + ")";
        }
        return [
            b,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_changeCase = function(a) {
        var b = {
            UPPERCASE: ".toUpperCase()",
            LOWERCASE: ".toLowerCase()",
            TITLECASE: null
        }[a.getFieldValue("CASE")];
        a = Blockly.JavaScript.valueToCode(a, "TEXT", b ? Blockly.JavaScript.ORDER_MEMBER : Blockly.JavaScript.ORDER_NONE) || "''";
        return [
            b ? a + b : Blockly.JavaScript.provideFunction_("textToTitleCase", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(str) {",
                "  return str.replace(/\\S+/g,",
                "      function(txt) {return txt[0].toUpperCase() + txt.substring(1).toLowerCase();});",
                "}"
            ]) + "(" + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_trim = function(a) {
        var b = {
            LEFT: ".replace(/^[\\s\\xa0]+/, '')",
            RIGHT: ".replace(/[\\s\\xa0]+$/, '')",
            BOTH: ".trim()"
        }[a.getFieldValue("MODE")];
        return [
            (Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_MEMBER) || "''") + b,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_print = function(a) {
        return "window.alert(" + (Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_NONE) || "''") + ");\n";
    };
    Blockly.JavaScript.text_prompt_ext = function(a) {
        var b = "window.prompt(" + (a.getField("TEXT") ? Blockly.JavaScript.quote_(a.getFieldValue("TEXT")) : Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_NONE) || "''") + ")";
        "NUMBER" == a.getFieldValue("TYPE") && (b = "Number(" + b + ")");
        return [
            b,
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_prompt = Blockly.JavaScript.text_prompt_ext;
    Blockly.JavaScript.text_count = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_NONE) || "''";
        a = Blockly.JavaScript.valueToCode(a, "SUB", Blockly.JavaScript.ORDER_NONE) || "''";
        return [
            Blockly.JavaScript.provideFunction_("textCount", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(haystack, needle) {",
                "  if (needle.length === 0) {",
                "    return haystack.length + 1;",
                "  } else {",
                "    return haystack.split(needle).length - 1;",
                "  }",
                "}"
            ]) + "(" + b + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_replace = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_NONE) || "''", c = Blockly.JavaScript.valueToCode(a, "FROM", Blockly.JavaScript.ORDER_NONE) || "''";
        a = Blockly.JavaScript.valueToCode(a, "TO", Blockly.JavaScript.ORDER_NONE) || "''";
        return [
            Blockly.JavaScript.provideFunction_("textReplace", [
                "function " + Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_ + "(haystack, needle, replacement) {",
                '  needle = needle.replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g,"\\\\$1")',
                '                 .replace(/\\x08/g,"\\\\x08");',
                "  return haystack.replace(new RegExp(needle, 'g'), replacement);",
                "}"
            ]) + "(" + b + ", " + c + ", " + a + ")",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.text_reverse = function(a) {
        return [
            (Blockly.JavaScript.valueToCode(a, "TEXT", Blockly.JavaScript.ORDER_MEMBER) || "''") + ".split('').reverse().join('')",
            Blockly.JavaScript.ORDER_FUNCTION_CALL
        ];
    };
    Blockly.JavaScript.variables = {};
    Blockly.JavaScript.variables_get = function(a) {
        return [
            Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME),
            Blockly.JavaScript.ORDER_ATOMIC
        ];
    };
    Blockly.JavaScript.variables_set = function(a) {
        var b = Blockly.JavaScript.valueToCode(a, "VALUE", Blockly.JavaScript.ORDER_ASSIGNMENT) || "0";
        return Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME) + " = " + b + ";\n";
    };
    Blockly.JavaScript.variablesDynamic = {};
    Blockly.JavaScript.variables_get_dynamic = Blockly.JavaScript.variables_get;
    Blockly.JavaScript.variables_set_dynamic = Blockly.JavaScript.variables_set;
    return Blockly.JavaScript;
});

});




parcelRegister("3z8rE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298b30fd45d3bb3c$export$2e2bcd8739ae039; });

var $8TfIJ = parcelRequire("8TfIJ");

var $kHIP8 = parcelRequire("kHIP8");

var $29ZVX = parcelRequire("29ZVX");

var $gOITV = parcelRequire("gOITV");
const $298b30fd45d3bb3c$var$_slowdown_factor = 1.5;
function $298b30fd45d3bb3c$var$deg2rad(deg) {
    return deg * Math.PI / 180.0;
}
function $298b30fd45d3bb3c$var$clampJointAngle(joint, angle) {
    // ROS is limiting the joint values by itself, but this prevents long tweens
    // where nothing happens because a joint is already past its limit
    let min = joint.limit.lower;
    let max = joint.limit.upper;
    return Math.min(max, Math.max(min, angle));
}
function $298b30fd45d3bb3c$var$getDuration(robot, target, vmax) {
    let smax = 0.0;
    // Find the joint that has to move the farthest
    for(const j in target)smax = Math.max(smax, Math.abs(robot.joints[j].angle - target[j]));
    return smax / vmax * 1000 * $298b30fd45d3bb3c$var$_slowdown_factor; // ms
}
class $298b30fd45d3bb3c$var$TheSimulation {
    reset() {
        this.unlockJoints();
        this.setDefaultVelocities();
        this.physicsDone = true;
        this.lastSimObjectProcessed = false;
        this.runningPhysics = false;
    }
    //Resets the simObjects to the position and orientation in the pose block.
    resetSimObjects(visible = true) {
        const simObjects = (0, $29ZVX.getSimObjects)();
        for (const simObject of simObjects){
            if (simObject.attached) simObject.detachFromGripper(this.robot);
            simObject.reset();
            if (visible) simObject.makeVisible();
            else simObject.hide();
        }
    }
    async run(command, ...args) {
        const sim = this;
        const validCommands = {
            'cancel': sim.cancel,
            'setParam': sim.setParam,
            'lockJoint': sim.lockJoint,
            'unlockJoint': sim.unlockJoint,
            'wait': sim.wait,
            'move': sim.move,
            'gripper_close': sim.gripper_close,
            'gripper_open': sim.gripper_open,
            'joint_absolute': sim.joint_absolute,
            'joint_relative': sim.joint_relative,
            'startPhysicalBody': sim.startPhysicalBody,
            'getPhysicsDone': sim.getPhysicsDone
        };
        try {
            await validCommands[command].call(this, ...args);
        } catch (e) {
            console.error('Failed to run command \'' + command + '(' + args + ')\':' + e);
            throw e;
        }
    }
    cancel() {
        console.log('cancel');
        // Will prevent further callbacks to _animate
        this.running = false;
        for (const t of $gOITV.getAll())t.stop();
        // As this is called by _onTweenFinished, this prevents having multiple tweens
        // with different end times, but that's not a use case at the moment
        $gOITV.removeAll();
        this.runningPhysics = false;
        this.physicsDone = true;
        this.lastSimObjectProcessed = true;
    }
    setParam(param, value) {
        console.log('> Setting ' + param + ' to ' + value);
        try {
            if (param.startsWith('velocity')) {
                let motion = param.split('/')[1];
                value = parseFloat(value);
                switch(motion){
                    case 'move':
                        this.velocities.move = value;
                        break;
                    case 'gripper':
                        this.velocities.gripper = value;
                        break;
                    default:
                        throw 'invalid parameter \'' + param + '=' + value + '\'';
                }
            } else throw 'unknown parameter';
        } catch (e) {
            console.warn('! Failed to set ' + param + ': ' + e);
        }
    }
    setDefaultVelocities() {
        console.log('> Resetting velocities to defaults');
        this.velocities = {
            move: 0.5,
            gripper: 0.5
        };
    }
    lockJoint(jointIdx) {
        console.log('> Locking joint ' + jointIdx);
        if (this.lockedJointIndices.includes(jointIdx)) {
            console.warn('! ... but joint ' + jointIdx + ' is already locked');
            return;
        }
        this.lockedJointIndices.push(jointIdx);
    }
    unlockJoint(jointIdx) {
        console.log('> Unlocking joint ' + jointIdx);
        let idx = this.lockedJointIndices.indexOf(jointIdx);
        if (idx < 0) {
            console.warn('! ... but joint ' + jointIdx + ' is not locked');
            return;
        }
        this.lockedJointIndices.splice(idx, 1);
    }
    unlockJoints() {
        console.log('> Unlocking all joints');
        this.lockedJointIndices = [];
    }
    getJointSpacePose() {
        const robot = this.robot;
        const pose = [];
        for(let idx = 0; idx < robot.arm.movable.length; idx++){
            const joint = robot.arm.movable[idx];
            pose.push(joint.angle);
        }
        return pose;
    }
    getTaskSpacePose() {
        const pose = [];
        const m = this.robot.tcp.object.matrixWorld;
        const pos = new (0, $8TfIJ.Vector3)();
        pos.setFromMatrixPosition(m);
        const rot = new (0, $8TfIJ.Euler)();
        rot.setFromRotationMatrix(m);
        // x, y, z, roll, pitch, yaw
        pose.push(pos.x, pos.y, pos.z, rot.x, rot.y, rot.z);
        return pose;
    }
    wait(ms) {
        console.log('> Waiting ' + ms + ' ms');
        return new Promise((resolve)=>{
            setTimeout(()=>resolve('success'), ms);
        });
    }
    move(poseType, pose) {
        if (!pose) throw new Error('move failed: missing pose');
        // Seems to be a weird bug in js-interpreter concerning varargs and arrays
        if (pose.class === 'Array' && pose.length === undefined) {
            let newPose = [];
            for(const p in pose.properties)if (p.match(/\d+/g)) newPose[p] = pose.properties[p];
            pose = newPose;
        }
        const robot = this.robot;
        const start = {};
        const target = {};
        switch(poseType){
            case 'TaskspacePose':
                // Task space pose
                console.log('> Moving robot to task space pose ' + pose);
                const ikTarget = new (0, $8TfIJ.Object3D)();
                ikTarget.position.set(pose[0], pose[1], pose[2]);
                if (pose.length > 3) ikTarget.setRotationFromEuler(new (0, $8TfIJ.Euler)(pose[3], pose[4], pose[5]));
                else ikTarget.setRotationFromQuaternion(robot.tcp.object.quaternion);
                const solution = this.ik.solve(ikTarget, robot, robot.ikEnabled, {
                    // This should be precise to avoid surprises for the user
                    maxIterations: 30,
                    stopDistance: 0.05,
                    jointLimits: robot.interactionJointLimits,
                    apply: false
                });
                for(let i = 0; i < pose.length; i++){
                    const joint = robot.arm.movable[i];
                    if (joint.name in solution) {
                        start[joint.name] = joint.angle;
                        target[joint.name] = solution[joint.name];
                    }
                }
                break;
            case 'JointspacePose':
                // Joint space pose
                console.log('> Moving robot to joint space pose ' + pose);
                for(let i = 0; i < pose.length; i++){
                    const joint = robot.arm.movable[i];
                    start[joint.name] = joint.angle;
                    target[joint.name] = $298b30fd45d3bb3c$var$clampJointAngle(joint, $298b30fd45d3bb3c$var$deg2rad(pose[i]));
                }
                break;
            default:
                console.error('# unknown configuration space \'' + poseType + '\'');
                return;
        }
        const duration = $298b30fd45d3bb3c$var$getDuration(robot, target, this.velocities.move * robot.maxSpeed.move);
        let tween = this._makeTween(start, target, duration);
        return tween;
    }
    gripper_close() {
        console.log('> Closing hand');
        const robot = this.robot;
        const start = {};
        const target = {};
        const tcp = robot.tcp.object;
        let position = new (0, $8TfIJ.Vector3)();
        tcp.getWorldPosition(position);
        if ((0, $29ZVX.isAttached)()) {
            // An object is already attached to the gripper, we can't grip another one
            console.log('... but an object is already held');
            throw new Error('already gripping');
        }
        const simObject = (0, $29ZVX.getSimObjectByPos)(position); //Retruns a simObject, if tcp is inside a box around it
        //Gripping a simObject if it is available
        if (simObject != undefined && simObject.isGrippable()) {
            if (!robot.useAdvancedGripping || simObject.isGrippableAxisIndependent() || simObject.checkGripperOrientation(robot)) {
                simObject.attachToGripper(robot);
                for (const finger of robot.hand.movable){
                    start[finger.name] = finger.angle;
                    target[finger.name] = finger.states.closed; // fully closed
                }
            } else {
                console.log('... but object does not fit inside gripper (realistic gripping is on)');
                throw new Error('ungrippable');
            }
        } else for (const finger of robot.hand.movable){
            start[finger.name] = finger.angle;
            target[finger.name] = finger.states.closed; // fully closed
        }
        const duration = $298b30fd45d3bb3c$var$getDuration(robot, target, this.velocities.gripper);
        let tween = this._makeTween(start, target, duration);
        return tween;
    }
    gripper_open() {
        console.log('> Opening hand');
        const robot = this.robot;
        const start = {};
        const target = {};
        // If an object is currently gripped, detach it from the gripper
        // and activate the physics
        if ((0, $29ZVX.isAttached)() == true) {
            const simObject = (0, $29ZVX.getAttachedObject)();
            simObject.detachFromGripper(robot);
            const idx = (0, $29ZVX.getSimObjectIdx)(simObject.name);
            if (!this.runningPhysics) this.startPhysicalBody(idx);
        }
        for (const finger of robot.hand.movable){
            start[finger.name] = finger.angle;
            target[finger.name] = finger.states.opened; // fully opened
        }
        const duration = $298b30fd45d3bb3c$var$getDuration(robot, target, this.velocities.gripper);
        let tween = this._makeTween(start, target, duration);
        return tween;
    }
    joint_absolute(jointIdx, angle) {
        console.log('> Setting joint ' + jointIdx + ' to ' + angle + ' degrees');
        if (this.lockedJointIndices.includes(jointIdx)) {
            console.log('> ... but joint ' + jointIdx + ' is locked');
            throw new Error('locked');
        }
        const robot = this.robot;
        const start = {};
        const target = {};
        const joint = robot.arm.movable[jointIdx - 1];
        start[joint.name] = joint.angle;
        target[joint.name] = $298b30fd45d3bb3c$var$clampJointAngle(joint, $298b30fd45d3bb3c$var$deg2rad(angle));
        const duration = $298b30fd45d3bb3c$var$getDuration(robot, target, this.velocities.move * robot.maxSpeed.move);
        let tween = this._makeTween(start, target, duration);
        return tween;
    }
    joint_relative(jointIdx, angle) {
        console.log('> Rotating joint ' + jointIdx + ' by ' + angle + ' degrees');
        const joint = this.robot.arm.movable[jointIdx - 1];
        let angleAbs = joint.angle * 180.0 / Math.PI + angle; // degrees
        return this.joint_absolute(jointIdx, angleAbs);
    }
    //Activate simObject and start physics if not already running
    startPhysicalBody(simObjectsIdx) {
        const simObjects = (0, $29ZVX.getSimObjects)();
        this.physicsDone = false;
        if (simObjects[simObjectsIdx].wasGripped) simObjects[simObjectsIdx].wasGripped = false;
        else simObjects[simObjectsIdx].reset();
        simObjects[simObjectsIdx].visible = true;
        simObjects[simObjectsIdx].addBodyToWorld();
        simObjects[simObjectsIdx].updateBody();
        simObjects[simObjectsIdx].body.wakeUp();
        if (simObjectsIdx + 1 >= simObjects.length) this.lastSimObjectProcessed = true;
        if (!this.runningPhysics) {
            this._animatePhysics();
            this.runningPhysics = true;
        }
    }
    //Returns state of physics simulation
    getPhysicsDone() {
        const simObjects = (0, $29ZVX.getSimObjects)();
        if (simObjects.length > 0) {
            if (!this.runningPhysics && this.lastSimObjectProcessed && !(0, $kHIP8.isWorldActive)()) this.physicsDone = true;
            else this.physicsDone = false;
        }
        return this.physicsDone;
    }
    //Physics animation loop
    _animatePhysics() {
        (0, $kHIP8.updatePhysics)(); //Updates the 3D object positions and orientations 
        this.renderCallback();
        if (!(0, $kHIP8.isWorldActive)()) {
            console.log('Physics rendering halted.');
            this.runningPhysics = false;
            return;
        }
        window.requestAnimationFrame(()=>this._animatePhysics());
    }
    _makeTween(start, target, duration) {
        return new Promise((resolve, reject)=>{
            const robot = this.robot;
            // Locked joints should not be animated
            for (const jidx of this.lockedJointIndices){
                const name = robot.arm.movable[jidx].name;
                delete target[name];
            }
            let tween = new $gOITV.Tween(start).to(target, duration).easing($gOITV.Easing.Quadratic.Out);
            tween.onUpdate((object)=>{
                for(const j in object)robot.model.joints[j].setJointValue(object[j]);
            });
            tween.onComplete((object)=>{
                this.running = false;
                resolve('success');
            });
            tween.onStop((object)=>{
                this.running = false;
                reject('tween obsolete');
            });
            tween.start();
            if (!this.running) {
                this.running = true;
                // => captures the 'this' reference
                window.requestAnimationFrame(()=>this._animate());
            }
        });
    }
    _animate(time) {
        $gOITV.update(time);
        this.renderCallback();
        if (this.running) // => captures the 'this' reference
        window.requestAnimationFrame(()=>this._animate());
    }
    constructor(robot, ik, renderCallback){
        this.robot = robot;
        this.ik = ik;
        this.renderCallback = renderCallback;
        this.lockedJointIndices = [];
        this.running = false;
        this.velocities = {};
        this.setDefaultVelocities();
        //Physics and triggers
        this.runningPhysics = false;
        this.physicsDone = true;
        this.lastSimObjectProcessed = false;
    }
}
/*
 * Singleton with async getter, will be initialized by the robot simulator.
 */ const $298b30fd45d3bb3c$var$Simulation = {
    instance: null,
    _awaiting: [],
    getInstance: function() {
        if (this.instance) return Promise.resolve(this.instance);
        else {
            let p = new Promise((resolve)=>this._awaiting.push(resolve));
            return p;
        }
    },
    init: function(robot, ik, renderCallback) {
        this.instance = new $298b30fd45d3bb3c$var$TheSimulation(robot, ik, renderCallback);
        this._awaiting.forEach((p)=>p(this.instance));
        this._awaiting = [];
    }
};
var $298b30fd45d3bb3c$export$2e2bcd8739ae039 = $298b30fd45d3bb3c$var$Simulation;

});
parcelRegister("kHIP8", function(module, exports) {

$parcel$export(module.exports, "initCannon", function () { return $f12a97df2d2add9b$export$bc5f65408bf10d67; });
$parcel$export(module.exports, "getWorld", function () { return $f12a97df2d2add9b$export$f7f646a65dc201e2; });
$parcel$export(module.exports, "updatePhysics", function () { return $f12a97df2d2add9b$export$45d541249ce09669; });
$parcel$export(module.exports, "isWorldActive", function () { return $f12a97df2d2add9b$export$dc77ef1c46164beb; });
/**
This script handels the setup for the physics engine
**/ //cannon-es import

var $OCLXF = parcelRequire("OCLXF");


var $29ZVX = parcelRequire("29ZVX");

var $cxq7w = parcelRequire("cxq7w");

var $6vqIF = parcelRequire("6vqIF");
//Physics setup
//variables for the physics simulation
const $f12a97df2d2add9b$var$dt = 0.02;
let $f12a97df2d2add9b$var$world;
let $f12a97df2d2add9b$var$initDone = false;
const $f12a97df2d2add9b$var$debugOn = false;
function $f12a97df2d2add9b$var$debug() {
    if ($f12a97df2d2add9b$var$debugOn) {
        const scene = (0, $cxq7w.getScene)();
        (0, $6vqIF.default)(scene, $f12a97df2d2add9b$var$world.bodies);
    }
}
function $f12a97df2d2add9b$export$bc5f65408bf10d67() {
    //World
    $f12a97df2d2add9b$var$world = new $OCLXF.World();
    $f12a97df2d2add9b$var$world.gravity.set(0, 0, -9.81);
    $f12a97df2d2add9b$var$world.broadphase = new $OCLXF.NaiveBroadphase();
    $f12a97df2d2add9b$var$world.solver.tolerance = 0.001;
    $f12a97df2d2add9b$var$world.quatNormalizeFast = true;
    $f12a97df2d2add9b$var$world.solver.iterations = 10;
    $f12a97df2d2add9b$var$world.allowSleep = true;
    //Floor
    const floorShape = new $OCLXF.Plane();
    const floorBody = new $OCLXF.Body({
        mass: 0
    });
    floorBody.addShape(floorShape);
    floorBody.material = new $OCLXF.Material({
        friction: 4,
        restitution: -2
    });
    floorBody.quaternion.setFromEuler(0, 0, -Math.PI / 2);
    floorBody.allowSleep = true;
    floorBody.sleepSpeedLimit = 1.2;
    floorBody.sleepTimeLimit = 0.1;
    floorBody.name = 'the_floor';
    $f12a97df2d2add9b$var$world.addBody(floorBody);
    $f12a97df2d2add9b$var$initDone = true;
    $f12a97df2d2add9b$var$debug();
}
function $f12a97df2d2add9b$export$f7f646a65dc201e2() {
    if ($f12a97df2d2add9b$var$initDone) return $f12a97df2d2add9b$var$world;
    else console.error('Physics not ready!');
}
function $f12a97df2d2add9b$export$45d541249ce09669() {
    const simObjects = (0, $29ZVX.getSimObjects)();
    $f12a97df2d2add9b$var$world.step($f12a97df2d2add9b$var$dt);
    $f12a97df2d2add9b$export$22fc139d1b42e83f(simObjects);
}
function $f12a97df2d2add9b$export$4dd6bd15fdfbc3cf(simObject) {
    $f12a97df2d2add9b$var$world.addBody(simObject.body);
}
function $f12a97df2d2add9b$export$a831fd11038d6133(simObject) {
    $f12a97df2d2add9b$var$world.removeBody(simObject.body);
}
function $f12a97df2d2add9b$export$303921259417e03c(simObjects) {
    for(var i = 0; i < simObjects.length; i++)$f12a97df2d2add9b$export$a831fd11038d6133(simObjects[i]);
}
function $f12a97df2d2add9b$export$22fc139d1b42e83f(simObjects) {
    let limit = simObjects.length;
    for(let i = 0; i < limit; i++)simObjects[i].updateMesh();
}
function $f12a97df2d2add9b$export$a4f7c15cc9b556bd() {
    const simObjects = (0, $29ZVX.getSimObjects)();
    for(let i = 0; i < simObjects.length; i++)simObjects[i].updateBody();
}
function $f12a97df2d2add9b$export$dc77ef1c46164beb() {
    return $f12a97df2d2add9b$var$world.hasActiveBodies;
}

});
parcelRegister("OCLXF", function(module, exports) {

$parcel$export(module.exports, "Vec3", function () { return $0982bf0d3ab2ea42$export$838423f3adec30fa; });
$parcel$export(module.exports, "Quaternion", function () { return $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3; });
$parcel$export(module.exports, "Shape", function () { return $0982bf0d3ab2ea42$export$6428a7f2611ef1fa; });
$parcel$export(module.exports, "Box", function () { return $0982bf0d3ab2ea42$export$e71c4d32a2263218; });
$parcel$export(module.exports, "Body", function () { return $0982bf0d3ab2ea42$export$4b2c32e08f77ff18; });
$parcel$export(module.exports, "NaiveBroadphase", function () { return $0982bf0d3ab2ea42$export$c86abd7a4a88e05e; });
$parcel$export(module.exports, "Material", function () { return $0982bf0d3ab2ea42$export$a2d8b23205c25948; });
$parcel$export(module.exports, "Sphere", function () { return $0982bf0d3ab2ea42$export$805e8b72413ccaba; });
$parcel$export(module.exports, "Cylinder", function () { return $0982bf0d3ab2ea42$export$665c37f020fe48f9; });
$parcel$export(module.exports, "Plane", function () { return $0982bf0d3ab2ea42$export$7ff5ac152ef991b0; });
$parcel$export(module.exports, "World", function () { return $0982bf0d3ab2ea42$export$812cd9544993280d; });
/**
 * Records what objects are colliding with each other
 */ class $0982bf0d3ab2ea42$export$f88c31aa5a14caa8 {
    /**
   * get
   */ get(bi, bj) {
        let { id: i } = bi;
        let { id: j } = bj;
        if (j > i) {
            const temp = j;
            j = i;
            i = temp;
        }
        return i + "-" + j in this.matrix;
    }
    /**
   * set
   */ set(bi, bj, value) {
        let { id: i } = bi;
        let { id: j } = bj;
        if (j > i) {
            const temp = j;
            j = i;
            i = temp;
        }
        if (value) this.matrix[i + "-" + j] = true;
        else delete this.matrix[i + "-" + j];
    }
    /**
   * Empty the matrix
   */ reset() {
        this.matrix = {};
    }
    /**
   * Set max number of objects
   */ setNumObjects(n) {}
    /**
   * The matrix storage.
   */ /**
   * @todo Remove useless constructor
   */ constructor(){
        this.matrix = void 0;
        this.matrix = {};
    }
}
/**
 * A 3x3 matrix.
 * Authored by {@link http://github.com/schteppe/ schteppe}
 */ class $0982bf0d3ab2ea42$export$83f4edd572c84121 {
    /**
   * Sets the matrix to identity
   * @todo Should perhaps be renamed to `setIdentity()` to be more clear.
   * @todo Create another function that immediately creates an identity matrix eg. `eye()`
   */ identity() {
        const e = this.elements;
        e[0] = 1;
        e[1] = 0;
        e[2] = 0;
        e[3] = 0;
        e[4] = 1;
        e[5] = 0;
        e[6] = 0;
        e[7] = 0;
        e[8] = 1;
    }
    /**
   * Set all elements to zero
   */ setZero() {
        const e = this.elements;
        e[0] = 0;
        e[1] = 0;
        e[2] = 0;
        e[3] = 0;
        e[4] = 0;
        e[5] = 0;
        e[6] = 0;
        e[7] = 0;
        e[8] = 0;
    }
    /**
   * Sets the matrix diagonal elements from a Vec3
   */ setTrace(vector) {
        const e = this.elements;
        e[0] = vector.x;
        e[4] = vector.y;
        e[8] = vector.z;
    }
    /**
   * Gets the matrix diagonal elements
   */ getTrace(target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const e = this.elements;
        target.x = e[0];
        target.y = e[4];
        target.z = e[8];
        return target;
    }
    /**
   * Matrix-Vector multiplication
   * @param v The vector to multiply with
   * @param target Optional, target to save the result in.
   */ vmult(v, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const e = this.elements;
        const x = v.x;
        const y = v.y;
        const z = v.z;
        target.x = e[0] * x + e[1] * y + e[2] * z;
        target.y = e[3] * x + e[4] * y + e[5] * z;
        target.z = e[6] * x + e[7] * y + e[8] * z;
        return target;
    }
    /**
   * Matrix-scalar multiplication
   */ smult(s) {
        for(let i = 0; i < this.elements.length; i++)this.elements[i] *= s;
    }
    /**
   * Matrix multiplication
   * @param matrix Matrix to multiply with from left side.
   */ mmult(matrix, target = new $0982bf0d3ab2ea42$export$83f4edd572c84121()) {
        const A = this.elements;
        const B = matrix.elements;
        const T = target.elements;
        const a11 = A[0], a12 = A[1], a13 = A[2], a21 = A[3], a22 = A[4], a23 = A[5], a31 = A[6], a32 = A[7], a33 = A[8];
        const b11 = B[0], b12 = B[1], b13 = B[2], b21 = B[3], b22 = B[4], b23 = B[5], b31 = B[6], b32 = B[7], b33 = B[8];
        T[0] = a11 * b11 + a12 * b21 + a13 * b31;
        T[1] = a11 * b12 + a12 * b22 + a13 * b32;
        T[2] = a11 * b13 + a12 * b23 + a13 * b33;
        T[3] = a21 * b11 + a22 * b21 + a23 * b31;
        T[4] = a21 * b12 + a22 * b22 + a23 * b32;
        T[5] = a21 * b13 + a22 * b23 + a23 * b33;
        T[6] = a31 * b11 + a32 * b21 + a33 * b31;
        T[7] = a31 * b12 + a32 * b22 + a33 * b32;
        T[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return target;
    }
    /**
   * Scale each column of the matrix
   */ scale(vector, target = new $0982bf0d3ab2ea42$export$83f4edd572c84121()) {
        const e = this.elements;
        const t = target.elements;
        for(let i = 0; i !== 3; i++){
            t[3 * i + 0] = vector.x * e[3 * i + 0];
            t[3 * i + 1] = vector.y * e[3 * i + 1];
            t[3 * i + 2] = vector.z * e[3 * i + 2];
        }
        return target;
    }
    /**
   * Solve Ax=b
   * @param b The right hand side
   * @param target Optional. Target vector to save in.
   * @return The solution x
   * @todo should reuse arrays
   */ solve(b, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        // Construct equations
        const nr = 3; // num rows
        const nc = 4; // num cols
        const eqns = [];
        let i;
        let j;
        for(i = 0; i < nr * nc; i++)eqns.push(0);
        for(i = 0; i < 3; i++)for(j = 0; j < 3; j++)eqns[i + nc * j] = this.elements[i + 3 * j];
        eqns[3] = b.x;
        eqns[7] = b.y;
        eqns[11] = b.z; // Compute right upper triangular version of the matrix - Gauss elimination
        let n = 3;
        const k = n;
        let np;
        const kp = 4; // num rows
        let p;
        do {
            i = k - n;
            if (eqns[i + nc * i] === 0) {
                // the pivot is null, swap lines
                for(j = i + 1; j < k; j++)if (eqns[i + nc * j] !== 0) {
                    np = kp;
                    do {
                        // do ligne( i ) = ligne( i ) + ligne( k )
                        p = kp - np;
                        eqns[p + nc * i] += eqns[p + nc * j];
                    }while (--np);
                    break;
                }
            }
            if (eqns[i + nc * i] !== 0) for(j = i + 1; j < k; j++){
                const multiplier = eqns[i + nc * j] / eqns[i + nc * i];
                np = kp;
                do {
                    // do ligne( k ) = ligne( k ) - multiplier * ligne( i )
                    p = kp - np;
                    eqns[p + nc * j] = p <= i ? 0 : eqns[p + nc * j] - eqns[p + nc * i] * multiplier;
                }while (--np);
            }
        }while (--n); // Get the solution
        target.z = eqns[2 * nc + 3] / eqns[2 * nc + 2];
        target.y = (eqns[1 * nc + 3] - eqns[1 * nc + 2] * target.z) / eqns[1 * nc + 1];
        target.x = (eqns[0 * nc + 3] - eqns[0 * nc + 2] * target.z - eqns[0 * nc + 1] * target.y) / eqns[0 * nc + 0];
        if (isNaN(target.x) || isNaN(target.y) || isNaN(target.z) || target.x === Infinity || target.y === Infinity || target.z === Infinity) throw "Could not solve equation! Got x=[" + target.toString() + "], b=[" + b.toString() + "], A=[" + this.toString() + "]";
        return target;
    }
    /**
   * Get an element in the matrix by index. Index starts at 0, not 1!!!
   * @param value If provided, the matrix element will be set to this value.
   */ e(row, column, value) {
        if (value === undefined) return this.elements[column + 3 * row];
        else // Set value
        this.elements[column + 3 * row] = value;
    }
    /**
   * Copy another matrix into this matrix object.
   */ copy(matrix) {
        for(let i = 0; i < matrix.elements.length; i++)this.elements[i] = matrix.elements[i];
        return this;
    }
    /**
   * Returns a string representation of the matrix.
   */ toString() {
        let r = '';
        const sep = ',';
        for(let i = 0; i < 9; i++)r += this.elements[i] + sep;
        return r;
    }
    /**
   * reverse the matrix
   * @param target Target matrix to save in.
   * @return The solution x
   */ reverse(target = new $0982bf0d3ab2ea42$export$83f4edd572c84121()) {
        // Construct equations
        const nr = 3; // num rows
        const nc = 6; // num cols
        const eqns = $0982bf0d3ab2ea42$var$reverse_eqns;
        let i;
        let j;
        for(i = 0; i < 3; i++)for(j = 0; j < 3; j++)eqns[i + nc * j] = this.elements[i + 3 * j];
        eqns[3] = 1;
        eqns[9] = 0;
        eqns[15] = 0;
        eqns[4] = 0;
        eqns[10] = 1;
        eqns[16] = 0;
        eqns[5] = 0;
        eqns[11] = 0;
        eqns[17] = 1; // Compute right upper triangular version of the matrix - Gauss elimination
        let n = 3;
        const k = n;
        let np;
        const kp = nc; // num rows
        let p;
        do {
            i = k - n;
            if (eqns[i + nc * i] === 0) {
                // the pivot is null, swap lines
                for(j = i + 1; j < k; j++)if (eqns[i + nc * j] !== 0) {
                    np = kp;
                    do {
                        // do line( i ) = line( i ) + line( k )
                        p = kp - np;
                        eqns[p + nc * i] += eqns[p + nc * j];
                    }while (--np);
                    break;
                }
            }
            if (eqns[i + nc * i] !== 0) for(j = i + 1; j < k; j++){
                const multiplier = eqns[i + nc * j] / eqns[i + nc * i];
                np = kp;
                do {
                    // do line( k ) = line( k ) - multiplier * line( i )
                    p = kp - np;
                    eqns[p + nc * j] = p <= i ? 0 : eqns[p + nc * j] - eqns[p + nc * i] * multiplier;
                }while (--np);
            }
        }while (--n); // eliminate the upper left triangle of the matrix
        i = 2;
        do {
            j = i - 1;
            do {
                const multiplier = eqns[i + nc * j] / eqns[i + nc * i];
                np = nc;
                do {
                    p = nc - np;
                    eqns[p + nc * j] = eqns[p + nc * j] - eqns[p + nc * i] * multiplier;
                }while (--np);
            }while (j--);
        }while (--i); // operations on the diagonal
        i = 2;
        do {
            const multiplier = 1 / eqns[i + nc * i];
            np = nc;
            do {
                p = nc - np;
                eqns[p + nc * i] = eqns[p + nc * i] * multiplier;
            }while (--np);
        }while (i--);
        i = 2;
        do {
            j = 2;
            do {
                p = eqns[nr + j + nc * i];
                if (isNaN(p) || p === Infinity) throw "Could not reverse! A=[" + this.toString() + "]";
                target.e(i, j, p);
            }while (j--);
        }while (i--);
        return target;
    }
    /**
   * Set the matrix from a quaterion
   */ setRotationFromQuaternion(q) {
        const x = q.x;
        const y = q.y;
        const z = q.z;
        const w = q.w;
        const x2 = x + x;
        const y2 = y + y;
        const z2 = z + z;
        const xx = x * x2;
        const xy = x * y2;
        const xz = x * z2;
        const yy = y * y2;
        const yz = y * z2;
        const zz = z * z2;
        const wx = w * x2;
        const wy = w * y2;
        const wz = w * z2;
        const e = this.elements;
        e[0] = 1 - (yy + zz);
        e[1] = xy - wz;
        e[2] = xz + wy;
        e[3] = xy + wz;
        e[4] = 1 - (xx + zz);
        e[5] = yz - wx;
        e[6] = xz - wy;
        e[7] = yz + wx;
        e[8] = 1 - (xx + yy);
        return this;
    }
    /**
   * Transpose the matrix
   * @param target Optional. Where to store the result.
   * @return The target Mat3, or a new Mat3 if target was omitted.
   */ transpose(target = new $0982bf0d3ab2ea42$export$83f4edd572c84121()) {
        const M = this.elements;
        const T = target.elements;
        let tmp; //Set diagonals
        T[0] = M[0];
        T[4] = M[4];
        T[8] = M[8];
        tmp = M[1];
        T[1] = M[3];
        T[3] = tmp;
        tmp = M[2];
        T[2] = M[6];
        T[6] = tmp;
        tmp = M[5];
        T[5] = M[7];
        T[7] = tmp;
        return target;
    }
    /**
   * A vector of length 9, containing all matrix elements.
   */ /**
   * @param elements A vector of length 9, containing all matrix elements.
   */ constructor(elements = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]){
        this.elements = void 0;
        this.elements = elements;
    }
}
const $0982bf0d3ab2ea42$var$reverse_eqns = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
/**
 * 3-dimensional vector
 * @example
 *     const v = new Vec3(1, 2, 3)
 *     console.log('x=' + v.x) // x=1
 */ class $0982bf0d3ab2ea42$export$838423f3adec30fa {
    /**
   * Vector cross product
   * @param target Optional target to save in.
   */ cross(vector, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const vx = vector.x;
        const vy = vector.y;
        const vz = vector.z;
        const x = this.x;
        const y = this.y;
        const z = this.z;
        target.x = y * vz - z * vy;
        target.y = z * vx - x * vz;
        target.z = x * vy - y * vx;
        return target;
    }
    /**
   * Set the vectors' 3 elements
   */ set(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
   * Set all components of the vector to zero.
   */ setZero() {
        this.x = this.y = this.z = 0;
    }
    /**
   * Vector addition
   */ vadd(vector, target) {
        if (target) {
            target.x = vector.x + this.x;
            target.y = vector.y + this.y;
            target.z = vector.z + this.z;
        } else return new $0982bf0d3ab2ea42$export$838423f3adec30fa(this.x + vector.x, this.y + vector.y, this.z + vector.z);
    }
    /**
   * Vector subtraction
   * @param target Optional target to save in.
   */ vsub(vector, target) {
        if (target) {
            target.x = this.x - vector.x;
            target.y = this.y - vector.y;
            target.z = this.z - vector.z;
        } else return new $0982bf0d3ab2ea42$export$838423f3adec30fa(this.x - vector.x, this.y - vector.y, this.z - vector.z);
    }
    /**
   * Get the cross product matrix a_cross from a vector, such that a x b = a_cross * b = c
   *
   * See {@link https://www8.cs.umu.se/kurser/TDBD24/VT06/lectures/Lecture6.pdf Umeå University Lecture}
   */ crossmat() {
        return new $0982bf0d3ab2ea42$export$83f4edd572c84121([
            0,
            -this.z,
            this.y,
            this.z,
            0,
            -this.x,
            -this.y,
            this.x,
            0
        ]);
    }
    /**
   * Normalize the vector. Note that this changes the values in the vector.
    * @return Returns the norm of the vector
   */ normalize() {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        const n = Math.sqrt(x * x + y * y + z * z);
        if (n > 0.0) {
            const invN = 1 / n;
            this.x *= invN;
            this.y *= invN;
            this.z *= invN;
        } else {
            // Make something up
            this.x = 0;
            this.y = 0;
            this.z = 0;
        }
        return n;
    }
    /**
   * Get the version of this vector that is of length 1.
   * @param target Optional target to save in
   * @return Returns the unit vector
   */ unit(target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        let ninv = Math.sqrt(x * x + y * y + z * z);
        if (ninv > 0.0) {
            ninv = 1.0 / ninv;
            target.x = x * ninv;
            target.y = y * ninv;
            target.z = z * ninv;
        } else {
            target.x = 1;
            target.y = 0;
            target.z = 0;
        }
        return target;
    }
    /**
   * Get the length of the vector
   */ length() {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        return Math.sqrt(x * x + y * y + z * z);
    }
    /**
   * Get the squared length of the vector.
   */ lengthSquared() {
        return this.dot(this);
    }
    /**
   * Get distance from this point to another point
   */ distanceTo(p) {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        const px = p.x;
        const py = p.y;
        const pz = p.z;
        return Math.sqrt((px - x) * (px - x) + (py - y) * (py - y) + (pz - z) * (pz - z));
    }
    /**
   * Get squared distance from this point to another point
   */ distanceSquared(p) {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        const px = p.x;
        const py = p.y;
        const pz = p.z;
        return (px - x) * (px - x) + (py - y) * (py - y) + (pz - z) * (pz - z);
    }
    /**
   * Multiply all the components of the vector with a scalar.
   * @param target The vector to save the result in.
   */ scale(scalar, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        target.x = scalar * x;
        target.y = scalar * y;
        target.z = scalar * z;
        return target;
    }
    /**
   * Multiply the vector with an other vector, component-wise.
   * @param target The vector to save the result in.
   */ vmul(vector, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        target.x = vector.x * this.x;
        target.y = vector.y * this.y;
        target.z = vector.z * this.z;
        return target;
    }
    /**
   * Scale a vector and add it to this vector. Save the result in "target". (target = this + vector * scalar)
   * @param target The vector to save the result in.
   */ addScaledVector(scalar, vector, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        target.x = this.x + scalar * vector.x;
        target.y = this.y + scalar * vector.y;
        target.z = this.z + scalar * vector.z;
        return target;
    }
    /**
   * Calculate dot product
   * @param vector
   */ dot(vector) {
        return this.x * vector.x + this.y * vector.y + this.z * vector.z;
    }
    isZero() {
        return this.x === 0 && this.y === 0 && this.z === 0;
    }
    /**
   * Make the vector point in the opposite direction.
   * @param target Optional target to save in
   */ negate(target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        target.x = -this.x;
        target.y = -this.y;
        target.z = -this.z;
        return target;
    }
    /**
   * Compute two artificial tangents to the vector
   * @param t1 Vector object to save the first tangent in
   * @param t2 Vector object to save the second tangent in
   */ tangents(t1, t2) {
        const norm = this.length();
        if (norm > 0.0) {
            const n = $0982bf0d3ab2ea42$var$Vec3_tangents_n;
            const inorm = 1 / norm;
            n.set(this.x * inorm, this.y * inorm, this.z * inorm);
            const randVec = $0982bf0d3ab2ea42$var$Vec3_tangents_randVec;
            if (Math.abs(n.x) < 0.9) {
                randVec.set(1, 0, 0);
                n.cross(randVec, t1);
            } else {
                randVec.set(0, 1, 0);
                n.cross(randVec, t1);
            }
            n.cross(t1, t2);
        } else {
            // The normal length is zero, make something up
            t1.set(1, 0, 0);
            t2.set(0, 1, 0);
        }
    }
    /**
   * Converts to a more readable format
   */ toString() {
        return this.x + "," + this.y + "," + this.z;
    }
    /**
   * Converts to an array
   */ toArray() {
        return [
            this.x,
            this.y,
            this.z
        ];
    }
    /**
   * Copies value of source to this vector.
   */ copy(vector) {
        this.x = vector.x;
        this.y = vector.y;
        this.z = vector.z;
        return this;
    }
    /**
   * Do a linear interpolation between two vectors
   * @param t A number between 0 and 1. 0 will make this function return u, and 1 will make it return v. Numbers in between will generate a vector in between them.
   */ lerp(vector, t, target) {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        target.x = x + (vector.x - x) * t;
        target.y = y + (vector.y - y) * t;
        target.z = z + (vector.z - z) * t;
    }
    /**
   * Check if a vector equals is almost equal to another one.
   */ almostEquals(vector, precision = 1e-6) {
        if (Math.abs(this.x - vector.x) > precision || Math.abs(this.y - vector.y) > precision || Math.abs(this.z - vector.z) > precision) return false;
        return true;
    }
    /**
   * Check if a vector is almost zero
   */ almostZero(precision = 1e-6) {
        if (Math.abs(this.x) > precision || Math.abs(this.y) > precision || Math.abs(this.z) > precision) return false;
        return true;
    }
    /**
   * Check if the vector is anti-parallel to another vector.
   * @param precision Set to zero for exact comparisons
   */ isAntiparallelTo(vector, precision) {
        this.negate($0982bf0d3ab2ea42$var$antip_neg);
        return $0982bf0d3ab2ea42$var$antip_neg.almostEquals(vector, precision);
    }
    /**
   * Clone the vector
   */ clone() {
        return new $0982bf0d3ab2ea42$export$838423f3adec30fa(this.x, this.y, this.z);
    }
    constructor(x = 0.0, y = 0.0, z = 0.0){
        this.x = void 0;
        this.y = void 0;
        this.z = void 0;
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
$0982bf0d3ab2ea42$export$838423f3adec30fa.ZERO = void 0;
$0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_X = void 0;
$0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Y = void 0;
$0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Z = void 0;
$0982bf0d3ab2ea42$export$838423f3adec30fa.ZERO = new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 0);
$0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_X = new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0);
$0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Y = new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 0);
$0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Z = new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 1);
const $0982bf0d3ab2ea42$var$Vec3_tangents_n = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Vec3_tangents_randVec = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$antip_neg = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Axis aligned bounding box class.
 */ class $0982bf0d3ab2ea42$export$8ec70f2db73b49aa {
    /**
   * Set the AABB bounds from a set of points.
   * @param points An array of Vec3's.
   * @return The self object
   */ setFromPoints(points, position, quaternion, skinSize) {
        const l = this.lowerBound;
        const u = this.upperBound;
        const q = quaternion; // Set to the first point
        l.copy(points[0]);
        if (q) q.vmult(l, l);
        u.copy(l);
        for(let i = 1; i < points.length; i++){
            let p = points[i];
            if (q) {
                q.vmult(p, $0982bf0d3ab2ea42$var$tmp$1);
                p = $0982bf0d3ab2ea42$var$tmp$1;
            }
            if (p.x > u.x) u.x = p.x;
            if (p.x < l.x) l.x = p.x;
            if (p.y > u.y) u.y = p.y;
            if (p.y < l.y) l.y = p.y;
            if (p.z > u.z) u.z = p.z;
            if (p.z < l.z) l.z = p.z;
        } // Add offset
        if (position) {
            position.vadd(l, l);
            position.vadd(u, u);
        }
        if (skinSize) {
            l.x -= skinSize;
            l.y -= skinSize;
            l.z -= skinSize;
            u.x += skinSize;
            u.y += skinSize;
            u.z += skinSize;
        }
        return this;
    }
    /**
   * Copy bounds from an AABB to this AABB
   * @param aabb Source to copy from
   * @return The this object, for chainability
   */ copy(aabb) {
        this.lowerBound.copy(aabb.lowerBound);
        this.upperBound.copy(aabb.upperBound);
        return this;
    }
    /**
   * Clone an AABB
   */ clone() {
        return new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa().copy(this);
    }
    /**
   * Extend this AABB so that it covers the given AABB too.
   */ extend(aabb) {
        this.lowerBound.x = Math.min(this.lowerBound.x, aabb.lowerBound.x);
        this.upperBound.x = Math.max(this.upperBound.x, aabb.upperBound.x);
        this.lowerBound.y = Math.min(this.lowerBound.y, aabb.lowerBound.y);
        this.upperBound.y = Math.max(this.upperBound.y, aabb.upperBound.y);
        this.lowerBound.z = Math.min(this.lowerBound.z, aabb.lowerBound.z);
        this.upperBound.z = Math.max(this.upperBound.z, aabb.upperBound.z);
    }
    /**
   * Returns true if the given AABB overlaps this AABB.
   */ overlaps(aabb) {
        const l1 = this.lowerBound;
        const u1 = this.upperBound;
        const l2 = aabb.lowerBound;
        const u2 = aabb.upperBound; //      l2        u2
        //      |---------|
        // |--------|
        // l1       u1
        const overlapsX = l2.x <= u1.x && u1.x <= u2.x || l1.x <= u2.x && u2.x <= u1.x;
        const overlapsY = l2.y <= u1.y && u1.y <= u2.y || l1.y <= u2.y && u2.y <= u1.y;
        const overlapsZ = l2.z <= u1.z && u1.z <= u2.z || l1.z <= u2.z && u2.z <= u1.z;
        return overlapsX && overlapsY && overlapsZ;
    }
    volume() {
        const l = this.lowerBound;
        const u = this.upperBound;
        return (u.x - l.x) * (u.y - l.y) * (u.z - l.z);
    }
    /**
   * Returns true if the given AABB is fully contained in this AABB.
   */ contains(aabb) {
        const l1 = this.lowerBound;
        const u1 = this.upperBound;
        const l2 = aabb.lowerBound;
        const u2 = aabb.upperBound; //      l2        u2
        //      |---------|
        // |---------------|
        // l1              u1
        return l1.x <= l2.x && u1.x >= u2.x && l1.y <= l2.y && u1.y >= u2.y && l1.z <= l2.z && u1.z >= u2.z;
    }
    getCorners(a, b, c, d, e, f, g, h) {
        const l = this.lowerBound;
        const u = this.upperBound;
        a.copy(l);
        b.set(u.x, l.y, l.z);
        c.set(u.x, u.y, l.z);
        d.set(l.x, u.y, u.z);
        e.set(u.x, l.y, u.z);
        f.set(l.x, u.y, l.z);
        g.set(l.x, l.y, u.z);
        h.copy(u);
    }
    /**
   * Get the representation of an AABB in another frame.
   * @return The "target" AABB object.
   */ toLocalFrame(frame, target) {
        const corners = $0982bf0d3ab2ea42$var$transformIntoFrame_corners;
        const a = corners[0];
        const b = corners[1];
        const c = corners[2];
        const d = corners[3];
        const e = corners[4];
        const f = corners[5];
        const g = corners[6];
        const h = corners[7]; // Get corners in current frame
        this.getCorners(a, b, c, d, e, f, g, h); // Transform them to new local frame
        for(let i = 0; i !== 8; i++){
            const corner = corners[i];
            frame.pointToLocal(corner, corner);
        }
        return target.setFromPoints(corners);
    }
    /**
   * Get the representation of an AABB in the global frame.
   * @return The "target" AABB object.
   */ toWorldFrame(frame, target) {
        const corners = $0982bf0d3ab2ea42$var$transformIntoFrame_corners;
        const a = corners[0];
        const b = corners[1];
        const c = corners[2];
        const d = corners[3];
        const e = corners[4];
        const f = corners[5];
        const g = corners[6];
        const h = corners[7]; // Get corners in current frame
        this.getCorners(a, b, c, d, e, f, g, h); // Transform them to new local frame
        for(let i = 0; i !== 8; i++){
            const corner = corners[i];
            frame.pointToWorld(corner, corner);
        }
        return target.setFromPoints(corners);
    }
    /**
   * Check if the AABB is hit by a ray.
   */ overlapsRay(ray) {
        const { direction: direction, from: from } = ray; // const t = 0
        // ray.direction is unit direction vector of ray
        const dirFracX = 1 / direction.x;
        const dirFracY = 1 / direction.y;
        const dirFracZ = 1 / direction.z; // this.lowerBound is the corner of AABB with minimal coordinates - left bottom, rt is maximal corner
        const t1 = (this.lowerBound.x - from.x) * dirFracX;
        const t2 = (this.upperBound.x - from.x) * dirFracX;
        const t3 = (this.lowerBound.y - from.y) * dirFracY;
        const t4 = (this.upperBound.y - from.y) * dirFracY;
        const t5 = (this.lowerBound.z - from.z) * dirFracZ;
        const t6 = (this.upperBound.z - from.z) * dirFracZ; // const tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)));
        // const tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)));
        const tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)), Math.min(t5, t6));
        const tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)), Math.max(t5, t6)); // if tmax < 0, ray (line) is intersecting AABB, but whole AABB is behing us
        if (tmax < 0) //t = tmax;
        return false;
         // if tmin > tmax, ray doesn't intersect AABB
        if (tmin > tmax) //t = tmax;
        return false;
        return true;
    }
    /**
   * The lower bound of the bounding box
   */ /**
   * The upper bound of the bounding box
   */ constructor(options = {}){
        this.lowerBound = void 0;
        this.upperBound = void 0;
        this.lowerBound = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.upperBound = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        if (options.lowerBound) this.lowerBound.copy(options.lowerBound);
        if (options.upperBound) this.upperBound.copy(options.upperBound);
    }
}
const $0982bf0d3ab2ea42$var$tmp$1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$transformIntoFrame_corners = [
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa()
];
/**
 * Collision "matrix".
 * It's actually a triangular-shaped array of whether two bodies are touching this step, for reference next step
 */ class $0982bf0d3ab2ea42$export$21b91c75495c488a {
    /**
   * Get an element
   */ get(bi, bj) {
        let { index: i } = bi;
        let { index: j } = bj;
        if (j > i) {
            const temp = j;
            j = i;
            i = temp;
        }
        return this.matrix[(i * (i + 1) >> 1) + j - 1];
    }
    /**
   * Set an element
   */ set(bi, bj, value) {
        let { index: i } = bi;
        let { index: j } = bj;
        if (j > i) {
            const temp = j;
            j = i;
            i = temp;
        }
        this.matrix[(i * (i + 1) >> 1) + j - 1] = value ? 1 : 0;
    }
    /**
   * Sets all elements to zero
   */ reset() {
        for(let i = 0, l = this.matrix.length; i !== l; i++)this.matrix[i] = 0;
    }
    /**
   * Sets the max number of objects
   */ setNumObjects(n) {
        this.matrix.length = n * (n - 1) >> 1;
    }
    /**
   * The matrix storage.
   */ constructor(){
        this.matrix = void 0;
        this.matrix = [];
    }
}
/**
 * Base class for objects that dispatches events.
 */ class $0982bf0d3ab2ea42$export$648eec84020a2b10 {
    /**
   * Add an event listener
   * @return The self object, for chainability.
   */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (!listeners[type].includes(listener)) listeners[type].push(listener);
        return this;
    }
    /**
   * Check if an event listener is added
   */ hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        if (listeners[type] !== undefined && listeners[type].includes(listener)) return true;
        return false;
    }
    /**
   * Check if any event listener of the given type is added
   */ hasAnyEventListener(type) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined;
    }
    /**
   * Remove an event listener
   * @return The self object, for chainability.
   */ removeEventListener(type, listener) {
        if (this._listeners === undefined) return this;
        const listeners = this._listeners;
        if (listeners[type] === undefined) return this;
        const index = listeners[type].indexOf(listener);
        if (index !== -1) listeners[type].splice(index, 1);
        return this;
    }
    /**
   * Emit an event.
   * @return The self object, for chainability.
   */ dispatchEvent(event) {
        if (this._listeners === undefined) return this;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            for(let i = 0, l = listenerArray.length; i < l; i++)listenerArray[i].call(this, event);
        }
        return this;
    }
    constructor(){
        this._listeners = void 0;
    }
}
/**
 * A Quaternion describes a rotation in 3D space. The Quaternion is mathematically defined as Q = x*i + y*j + z*k + w, where (i,j,k) are imaginary basis vectors. (x,y,z) can be seen as a vector related to the axis of rotation, while the real multiplier, w, is related to the amount of rotation.
 * @param x Multiplier of the imaginary basis vector i.
 * @param y Multiplier of the imaginary basis vector j.
 * @param z Multiplier of the imaginary basis vector k.
 * @param w Multiplier of the real part.
 * @see http://en.wikipedia.org/wiki/Quaternion
 */ class $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3 {
    /**
   * Set the value of the quaternion.
   */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
   * Convert to a readable format
   * @return "x,y,z,w"
   */ toString() {
        return this.x + "," + this.y + "," + this.z + "," + this.w;
    }
    /**
   * Convert to an Array
   * @return [x, y, z, w]
   */ toArray() {
        return [
            this.x,
            this.y,
            this.z,
            this.w
        ];
    }
    /**
   * Set the quaternion components given an axis and an angle in radians.
   */ setFromAxisAngle(vector, angle) {
        const s = Math.sin(angle * 0.5);
        this.x = vector.x * s;
        this.y = vector.y * s;
        this.z = vector.z * s;
        this.w = Math.cos(angle * 0.5);
        return this;
    }
    /**
   * Converts the quaternion to [ axis, angle ] representation.
   * @param targetAxis A vector object to reuse for storing the axis.
   * @return An array, first element is the axis and the second is the angle in radians.
   */ toAxisAngle(targetAxis = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        this.normalize(); // if w>1 acos and sqrt will produce errors, this cant happen if quaternion is normalised
        const angle = 2 * Math.acos(this.w);
        const s = Math.sqrt(1 - this.w * this.w); // assuming quaternion normalised then w is less than 1, so term always positive.
        if (s < 0.001) {
            // test to avoid divide by zero, s is always positive due to sqrt
            // if s close to zero then direction of axis not important
            targetAxis.x = this.x; // if it is important that axis is normalised then replace with x=1; y=z=0;
            targetAxis.y = this.y;
            targetAxis.z = this.z;
        } else {
            targetAxis.x = this.x / s; // normalise axis
            targetAxis.y = this.y / s;
            targetAxis.z = this.z / s;
        }
        return [
            targetAxis,
            angle
        ];
    }
    /**
   * Set the quaternion value given two vectors. The resulting rotation will be the needed rotation to rotate u to v.
   */ setFromVectors(u, v) {
        if (u.isAntiparallelTo(v)) {
            const t1 = $0982bf0d3ab2ea42$var$sfv_t1;
            const t2 = $0982bf0d3ab2ea42$var$sfv_t2;
            u.tangents(t1, t2);
            this.setFromAxisAngle(t1, Math.PI);
        } else {
            const a = u.cross(v);
            this.x = a.x;
            this.y = a.y;
            this.z = a.z;
            this.w = Math.sqrt(u.length() ** 2 * v.length() ** 2) + u.dot(v);
            this.normalize();
        }
        return this;
    }
    /**
   * Multiply the quaternion with an other quaternion.
   */ mult(quat, target = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3()) {
        const ax = this.x;
        const ay = this.y;
        const az = this.z;
        const aw = this.w;
        const bx = quat.x;
        const by = quat.y;
        const bz = quat.z;
        const bw = quat.w;
        target.x = ax * bw + aw * bx + ay * bz - az * by;
        target.y = ay * bw + aw * by + az * bx - ax * bz;
        target.z = az * bw + aw * bz + ax * by - ay * bx;
        target.w = aw * bw - ax * bx - ay * by - az * bz;
        return target;
    }
    /**
   * Get the inverse quaternion rotation.
   */ inverse(target = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3()) {
        const x = this.x;
        const y = this.y;
        const z = this.z;
        const w = this.w;
        this.conjugate(target);
        const inorm2 = 1 / (x * x + y * y + z * z + w * w);
        target.x *= inorm2;
        target.y *= inorm2;
        target.z *= inorm2;
        target.w *= inorm2;
        return target;
    }
    /**
   * Get the quaternion conjugate
   */ conjugate(target = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3()) {
        target.x = -this.x;
        target.y = -this.y;
        target.z = -this.z;
        target.w = this.w;
        return target;
    }
    /**
   * Normalize the quaternion. Note that this changes the values of the quaternion.
   */ normalize() {
        let l = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
        if (l === 0) {
            this.x = 0;
            this.y = 0;
            this.z = 0;
            this.w = 0;
        } else {
            l = 1 / l;
            this.x *= l;
            this.y *= l;
            this.z *= l;
            this.w *= l;
        }
        return this;
    }
    /**
   * Approximation of quaternion normalization. Works best when quat is already almost-normalized.
   * @author unphased, https://github.com/unphased
   */ normalizeFast() {
        const f = (3.0 - (this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w)) / 2.0;
        if (f === 0) {
            this.x = 0;
            this.y = 0;
            this.z = 0;
            this.w = 0;
        } else {
            this.x *= f;
            this.y *= f;
            this.z *= f;
            this.w *= f;
        }
        return this;
    }
    /**
   * Multiply the quaternion by a vector
   */ vmult(v, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const x = v.x;
        const y = v.y;
        const z = v.z;
        const qx = this.x;
        const qy = this.y;
        const qz = this.z;
        const qw = this.w; // q*v
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        target.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        target.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        target.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return target;
    }
    /**
   * Copies value of source to this quaternion.
   * @return this
   */ copy(quat) {
        this.x = quat.x;
        this.y = quat.y;
        this.z = quat.z;
        this.w = quat.w;
        return this;
    }
    /**
   * Convert the quaternion to euler angle representation. Order: YZX, as this page describes: https://www.euclideanspace.com/maths/standards/index.htm
   * @param order Three-character string, defaults to "YZX"
   */ toEuler(target, order = 'YZX') {
        let heading;
        let attitude;
        let bank;
        const x = this.x;
        const y = this.y;
        const z = this.z;
        const w = this.w;
        switch(order){
            case 'YZX':
                const test = x * y + z * w;
                if (test > 0.499) {
                    // singularity at north pole
                    heading = 2 * Math.atan2(x, w);
                    attitude = Math.PI / 2;
                    bank = 0;
                }
                if (test < -0.499) {
                    // singularity at south pole
                    heading = -2 * Math.atan2(x, w);
                    attitude = -Math.PI / 2;
                    bank = 0;
                }
                if (heading === undefined) {
                    const sqx = x * x;
                    const sqy = y * y;
                    const sqz = z * z;
                    heading = Math.atan2(2 * y * w - 2 * x * z, 1 - 2 * sqy - 2 * sqz); // Heading
                    attitude = Math.asin(2 * test); // attitude
                    bank = Math.atan2(2 * x * w - 2 * y * z, 1 - 2 * sqx - 2 * sqz); // bank
                }
                break;
            default:
                throw new Error("Euler order " + order + " not supported yet.");
        }
        target.y = heading;
        target.z = attitude;
        target.x = bank;
    }
    /**
   * @param order The order to apply angles: 'XYZ' or 'YXZ' or any other combination.
   *
   * See {@link https://www.mathworks.com/matlabcentral/fileexchange/20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors MathWorks} reference
   */ setFromEuler(x, y, z, order = 'XYZ') {
        const c1 = Math.cos(x / 2);
        const c2 = Math.cos(y / 2);
        const c3 = Math.cos(z / 2);
        const s1 = Math.sin(x / 2);
        const s2 = Math.sin(y / 2);
        const s3 = Math.sin(z / 2);
        if (order === 'XYZ') {
            this.x = s1 * c2 * c3 + c1 * s2 * s3;
            this.y = c1 * s2 * c3 - s1 * c2 * s3;
            this.z = c1 * c2 * s3 + s1 * s2 * c3;
            this.w = c1 * c2 * c3 - s1 * s2 * s3;
        } else if (order === 'YXZ') {
            this.x = s1 * c2 * c3 + c1 * s2 * s3;
            this.y = c1 * s2 * c3 - s1 * c2 * s3;
            this.z = c1 * c2 * s3 - s1 * s2 * c3;
            this.w = c1 * c2 * c3 + s1 * s2 * s3;
        } else if (order === 'ZXY') {
            this.x = s1 * c2 * c3 - c1 * s2 * s3;
            this.y = c1 * s2 * c3 + s1 * c2 * s3;
            this.z = c1 * c2 * s3 + s1 * s2 * c3;
            this.w = c1 * c2 * c3 - s1 * s2 * s3;
        } else if (order === 'ZYX') {
            this.x = s1 * c2 * c3 - c1 * s2 * s3;
            this.y = c1 * s2 * c3 + s1 * c2 * s3;
            this.z = c1 * c2 * s3 - s1 * s2 * c3;
            this.w = c1 * c2 * c3 + s1 * s2 * s3;
        } else if (order === 'YZX') {
            this.x = s1 * c2 * c3 + c1 * s2 * s3;
            this.y = c1 * s2 * c3 + s1 * c2 * s3;
            this.z = c1 * c2 * s3 - s1 * s2 * c3;
            this.w = c1 * c2 * c3 - s1 * s2 * s3;
        } else if (order === 'XZY') {
            this.x = s1 * c2 * c3 - c1 * s2 * s3;
            this.y = c1 * s2 * c3 - s1 * c2 * s3;
            this.z = c1 * c2 * s3 + s1 * s2 * c3;
            this.w = c1 * c2 * c3 + s1 * s2 * s3;
        }
        return this;
    }
    clone() {
        return new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3(this.x, this.y, this.z, this.w);
    }
    /**
   * Performs a spherical linear interpolation between two quat
   *
   * @param toQuat second operand
   * @param t interpolation amount between the self quaternion and toQuat
   * @param target A quaternion to store the result in. If not provided, a new one will be created.
   * @returns {Quaternion} The "target" object
   */ slerp(toQuat, t, target = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3()) {
        const ax = this.x;
        const ay = this.y;
        const az = this.z;
        const aw = this.w;
        let bx = toQuat.x;
        let by = toQuat.y;
        let bz = toQuat.z;
        let bw = toQuat.w;
        let omega;
        let cosom;
        let sinom;
        let scale0;
        let scale1; // calc cosine
        cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        } // calculate coefficients
        if (1.0 - cosom > 0.000001) {
            // standard case (slerp)
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            // "from" and "to" quaternions are very close
            //  ... so we can do a linear interpolation
            scale0 = 1.0 - t;
            scale1 = t;
        } // calculate final values
        target.x = scale0 * ax + scale1 * bx;
        target.y = scale0 * ay + scale1 * by;
        target.z = scale0 * az + scale1 * bz;
        target.w = scale0 * aw + scale1 * bw;
        return target;
    }
    /**
   * Rotate an absolute orientation quaternion given an angular velocity and a time step.
   */ integrate(angularVelocity, dt, angularFactor, target = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3()) {
        const ax = angularVelocity.x * angularFactor.x, ay = angularVelocity.y * angularFactor.y, az = angularVelocity.z * angularFactor.z, bx = this.x, by = this.y, bz = this.z, bw = this.w;
        const half_dt = dt * 0.5;
        target.x += half_dt * (ax * bw + ay * bz - az * by);
        target.y += half_dt * (ay * bw + az * bx - ax * bz);
        target.z += half_dt * (az * bw + ax * by - ay * bx);
        target.w += half_dt * (-ax * bx - ay * by - az * bz);
        return target;
    }
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.x = void 0;
        this.y = void 0;
        this.z = void 0;
        this.w = void 0;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
}
const $0982bf0d3ab2ea42$var$sfv_t1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sfv_t2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * The available shape types.
 */ const $0982bf0d3ab2ea42$export$7fb58f79f687967 = {
    /** SPHERE */ SPHERE: 1,
    /** PLANE */ PLANE: 2,
    /** BOX */ BOX: 4,
    /** COMPOUND */ COMPOUND: 8,
    /** CONVEXPOLYHEDRON */ CONVEXPOLYHEDRON: 16,
    /** HEIGHTFIELD */ HEIGHTFIELD: 32,
    /** PARTICLE */ PARTICLE: 64,
    /** CYLINDER */ CYLINDER: 128,
    /** TRIMESH */ TRIMESH: 256
};
/**
 * ShapeType
 */ /**
 * Base class for shapes
 */ class $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /**
   * Computes the bounding sphere radius.
   * The result is stored in the property `.boundingSphereRadius`
   */ updateBoundingSphereRadius() {
        throw "computeBoundingSphereRadius() not implemented for shape type " + this.type;
    }
    /**
   * Get the volume of this shape
   */ volume() {
        throw "volume() not implemented for shape type " + this.type;
    }
    /**
   * Calculates the inertia in the local frame for this shape.
   * @see http://en.wikipedia.org/wiki/List_of_moments_of_inertia
   */ calculateLocalInertia(mass, target) {
        throw "calculateLocalInertia() not implemented for shape type " + this.type;
    }
    /**
   * @todo use abstract for these kind of methods
   */ calculateWorldAABB(pos, quat, min, max) {
        throw "calculateWorldAABB() not implemented for shape type " + this.type;
    }
    /**
   * Identifier of the Shape.
   */ /**
   * The type of this shape. Must be set to an int > 0 by subclasses.
   */ /**
   * The local bounding sphere radius of this shape.
   */ /**
   * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled.
   * @default true
   */ /**
   * @default 1
   */ /**
   * @default -1
   */ /**
   * Optional material of the shape that regulates contact properties.
   */ /**
   * The body to which the shape is added to.
   */ /**
   * All the Shape types.
   */ constructor(options = {}){
        this.id = void 0;
        this.type = void 0;
        this.boundingSphereRadius = void 0;
        this.collisionResponse = void 0;
        this.collisionFilterGroup = void 0;
        this.collisionFilterMask = void 0;
        this.material = void 0;
        this.body = void 0;
        this.id = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.idCounter++;
        this.type = options.type || 0;
        this.boundingSphereRadius = 0;
        this.collisionResponse = options.collisionResponse ? options.collisionResponse : true;
        this.collisionFilterGroup = options.collisionFilterGroup !== undefined ? options.collisionFilterGroup : 1;
        this.collisionFilterMask = options.collisionFilterMask !== undefined ? options.collisionFilterMask : -1;
        this.material = options.material ? options.material : null;
        this.body = null;
    }
}
$0982bf0d3ab2ea42$export$6428a7f2611ef1fa.idCounter = 0;
$0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types = $0982bf0d3ab2ea42$export$7fb58f79f687967;
/**
 * Transformation utilities.
 */ class $0982bf0d3ab2ea42$export$563a914cafbdc389 {
    /**
   * Get a global point in local transform coordinates.
   */ pointToLocal(worldPoint, result) {
        return $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(this.position, this.quaternion, worldPoint, result);
    }
    /**
   * Get a local point in global transform coordinates.
   */ pointToWorld(localPoint, result) {
        return $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(this.position, this.quaternion, localPoint, result);
    }
    /**
   * vectorToWorldFrame
   */ vectorToWorldFrame(localVector, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        this.quaternion.vmult(localVector, result);
        return result;
    }
    /**
   * pointToLocalFrame
   */ static pointToLocalFrame(position, quaternion, worldPoint, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        worldPoint.vsub(position, result);
        quaternion.conjugate($0982bf0d3ab2ea42$var$tmpQuat$1);
        $0982bf0d3ab2ea42$var$tmpQuat$1.vmult(result, result);
        return result;
    }
    /**
   * pointToWorldFrame
   */ static pointToWorldFrame(position, quaternion, localPoint, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        quaternion.vmult(localPoint, result);
        result.vadd(position, result);
        return result;
    }
    /**
   * vectorToWorldFrame
   */ static vectorToWorldFrame(quaternion, localVector, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        quaternion.vmult(localVector, result);
        return result;
    }
    /**
   * vectorToLocalFrame
   */ static vectorToLocalFrame(position, quaternion, worldVector, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        quaternion.w *= -1;
        quaternion.vmult(worldVector, result);
        quaternion.w *= -1;
        return result;
    }
    /**
   * position
   */ /**
   * quaternion
   */ constructor(options = {}){
        this.position = void 0;
        this.quaternion = void 0;
        this.position = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.quaternion = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        if (options.position) this.position.copy(options.position);
        if (options.quaternion) this.quaternion.copy(options.quaternion);
    }
}
const $0982bf0d3ab2ea42$var$tmpQuat$1 = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
/**
 * A set of polygons describing a convex shape.
 *
 * The shape MUST be convex for the code to work properly. No polygons may be coplanar (contained
 * in the same 3D plane), instead these should be merged into one polygon.
 *
 * @author qiao / https://github.com/qiao (original author, see https://github.com/qiao/three.js/commit/85026f0c769e4000148a67d45a9e9b9c5108836f)
 * @author schteppe / https://github.com/schteppe
 * @see https://www.altdevblogaday.com/2011/05/13/contact-generation-between-3d-convex-meshes/
 *
 * @todo Move the clipping functions to ContactGenerator?
 * @todo Automatically merge coplanar polygons in constructor.
 * @example
 *     const convexShape = new CANNON.ConvexPolyhedron({ vertices, faces })
 *     const convexBody = new CANNON.Body({ mass: 1, shape: convexShape })
 *     world.addBody(convexBody)
 */ class $0982bf0d3ab2ea42$export$7c637a75bc263948 extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /**
   * Computes uniqueEdges
   */ computeEdges() {
        const faces = this.faces;
        const vertices = this.vertices;
        const edges = this.uniqueEdges;
        edges.length = 0;
        const edge = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        for(let i = 0; i !== faces.length; i++){
            const face = faces[i];
            const numVertices = face.length;
            for(let j = 0; j !== numVertices; j++){
                const k = (j + 1) % numVertices;
                vertices[face[j]].vsub(vertices[face[k]], edge);
                edge.normalize();
                let found = false;
                for(let p = 0; p !== edges.length; p++)if (edges[p].almostEquals(edge) || edges[p].almostEquals(edge)) {
                    found = true;
                    break;
                }
                if (!found) edges.push(edge.clone());
            }
        }
    }
    /**
   * Compute the normals of the faces.
   * Will reuse existing Vec3 objects in the `faceNormals` array if they exist.
   */ computeNormals() {
        this.faceNormals.length = this.faces.length; // Generate normals
        for(let i = 0; i < this.faces.length; i++){
            // Check so all vertices exists for this face
            for(let j = 0; j < this.faces[i].length; j++){
                if (!this.vertices[this.faces[i][j]]) throw new Error("Vertex " + this.faces[i][j] + " not found!");
            }
            const n = this.faceNormals[i] || new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            this.getFaceNormal(i, n);
            n.negate(n);
            this.faceNormals[i] = n;
            const vertex = this.vertices[this.faces[i][0]];
            if (n.dot(vertex) < 0) {
                console.error(".faceNormals[" + i + "] = Vec3(" + n.toString() + ") looks like it points into the shape? The vertices follow. Make sure they are ordered CCW around the normal, using the right hand rule.");
                for(let j = 0; j < this.faces[i].length; j++)console.warn(".vertices[" + this.faces[i][j] + "] = Vec3(" + this.vertices[this.faces[i][j]].toString() + ")");
            }
        }
    }
    /**
   * Compute the normal of a face from its vertices
   */ getFaceNormal(i, target) {
        const f = this.faces[i];
        const va = this.vertices[f[0]];
        const vb = this.vertices[f[1]];
        const vc = this.vertices[f[2]];
        $0982bf0d3ab2ea42$export$7c637a75bc263948.computeNormal(va, vb, vc, target);
    }
    /**
   * Get face normal given 3 vertices
   */ static computeNormal(va, vb, vc, target) {
        const cb = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const ab = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        vb.vsub(va, ab);
        vc.vsub(vb, cb);
        cb.cross(ab, target);
        if (!target.isZero()) target.normalize();
    }
    /**
   * @param minDist Clamp distance
   * @param result The an array of contact point objects, see clipFaceAgainstHull
   */ clipAgainstHull(posA, quatA, hullB, posB, quatB, separatingNormal, minDist, maxDist, result) {
        const WorldNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        let closestFaceB = -1;
        let dmax = -Number.MAX_VALUE;
        for(let face = 0; face < hullB.faces.length; face++){
            WorldNormal.copy(hullB.faceNormals[face]);
            quatB.vmult(WorldNormal, WorldNormal);
            const d = WorldNormal.dot(separatingNormal);
            if (d > dmax) {
                dmax = d;
                closestFaceB = face;
            }
        }
        const worldVertsB1 = [];
        for(let i = 0; i < hullB.faces[closestFaceB].length; i++){
            const b = hullB.vertices[hullB.faces[closestFaceB][i]];
            const worldb = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            worldb.copy(b);
            quatB.vmult(worldb, worldb);
            posB.vadd(worldb, worldb);
            worldVertsB1.push(worldb);
        }
        if (closestFaceB >= 0) this.clipFaceAgainstHull(separatingNormal, posA, quatA, worldVertsB1, minDist, maxDist, result);
    }
    /**
   * Find the separating axis between this hull and another
   * @param target The target vector to save the axis in
   * @return Returns false if a separation is found, else true
   */ findSeparatingAxis(hullB, posA, quatA, posB, quatB, target, faceListA, faceListB) {
        const faceANormalWS3 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const Worldnormal1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const deltaC = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const worldEdge0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const worldEdge1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const Cross = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        let dmin = Number.MAX_VALUE;
        const hullA = this;
        if (!hullA.uniqueAxes) {
            const numFacesA = faceListA ? faceListA.length : hullA.faces.length; // Test face normals from hullA
            for(let i = 0; i < numFacesA; i++){
                const fi = faceListA ? faceListA[i] : i; // Get world face normal
                faceANormalWS3.copy(hullA.faceNormals[fi]);
                quatA.vmult(faceANormalWS3, faceANormalWS3);
                const d = hullA.testSepAxis(faceANormalWS3, hullB, posA, quatA, posB, quatB);
                if (d === false) return false;
                if (d < dmin) {
                    dmin = d;
                    target.copy(faceANormalWS3);
                }
            }
        } else // Test unique axes
        for(let i = 0; i !== hullA.uniqueAxes.length; i++){
            // Get world axis
            quatA.vmult(hullA.uniqueAxes[i], faceANormalWS3);
            const d = hullA.testSepAxis(faceANormalWS3, hullB, posA, quatA, posB, quatB);
            if (d === false) return false;
            if (d < dmin) {
                dmin = d;
                target.copy(faceANormalWS3);
            }
        }
        if (!hullB.uniqueAxes) {
            // Test face normals from hullB
            const numFacesB = faceListB ? faceListB.length : hullB.faces.length;
            for(let i = 0; i < numFacesB; i++){
                const fi = faceListB ? faceListB[i] : i;
                Worldnormal1.copy(hullB.faceNormals[fi]);
                quatB.vmult(Worldnormal1, Worldnormal1);
                const d = hullA.testSepAxis(Worldnormal1, hullB, posA, quatA, posB, quatB);
                if (d === false) return false;
                if (d < dmin) {
                    dmin = d;
                    target.copy(Worldnormal1);
                }
            }
        } else // Test unique axes in B
        for(let i = 0; i !== hullB.uniqueAxes.length; i++){
            quatB.vmult(hullB.uniqueAxes[i], Worldnormal1);
            const d = hullA.testSepAxis(Worldnormal1, hullB, posA, quatA, posB, quatB);
            if (d === false) return false;
            if (d < dmin) {
                dmin = d;
                target.copy(Worldnormal1);
            }
        }
         // Test edges
        for(let e0 = 0; e0 !== hullA.uniqueEdges.length; e0++){
            // Get world edge
            quatA.vmult(hullA.uniqueEdges[e0], worldEdge0);
            for(let e1 = 0; e1 !== hullB.uniqueEdges.length; e1++){
                // Get world edge 2
                quatB.vmult(hullB.uniqueEdges[e1], worldEdge1);
                worldEdge0.cross(worldEdge1, Cross);
                if (!Cross.almostZero()) {
                    Cross.normalize();
                    const dist = hullA.testSepAxis(Cross, hullB, posA, quatA, posB, quatB);
                    if (dist === false) return false;
                    if (dist < dmin) {
                        dmin = dist;
                        target.copy(Cross);
                    }
                }
            }
        }
        posB.vsub(posA, deltaC);
        if (deltaC.dot(target) > 0.0) target.negate(target);
        return true;
    }
    /**
   * Test separating axis against two hulls. Both hulls are projected onto the axis and the overlap size is returned if there is one.
   * @return The overlap depth, or FALSE if no penetration.
   */ testSepAxis(axis, hullB, posA, quatA, posB, quatB) {
        const hullA = this;
        $0982bf0d3ab2ea42$export$7c637a75bc263948.project(hullA, axis, posA, quatA, $0982bf0d3ab2ea42$var$maxminA);
        $0982bf0d3ab2ea42$export$7c637a75bc263948.project(hullB, axis, posB, quatB, $0982bf0d3ab2ea42$var$maxminB);
        const maxA = $0982bf0d3ab2ea42$var$maxminA[0];
        const minA = $0982bf0d3ab2ea42$var$maxminA[1];
        const maxB = $0982bf0d3ab2ea42$var$maxminB[0];
        const minB = $0982bf0d3ab2ea42$var$maxminB[1];
        if (maxA < minB || maxB < minA) return false; // Separated
        const d0 = maxA - minB;
        const d1 = maxB - minA;
        const depth = d0 < d1 ? d0 : d1;
        return depth;
    }
    /**
   * calculateLocalInertia
   */ calculateLocalInertia(mass, target) {
        // Approximate with box inertia
        // Exact inertia calculation is overkill, but see http://geometrictools.com/Documentation/PolyhedralMassProperties.pdf for the correct way to do it
        const aabbmax = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const aabbmin = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.computeLocalAABB(aabbmin, aabbmax);
        const x = aabbmax.x - aabbmin.x;
        const y = aabbmax.y - aabbmin.y;
        const z = aabbmax.z - aabbmin.z;
        target.x = 1.0 / 12.0 * mass * (2 * y * 2 * y + 2 * z * 2 * z);
        target.y = 1.0 / 12.0 * mass * (2 * x * 2 * x + 2 * z * 2 * z);
        target.z = 1.0 / 12.0 * mass * (2 * y * 2 * y + 2 * x * 2 * x);
    }
    /**
   * @param face_i Index of the face
   */ getPlaneConstantOfFace(face_i) {
        const f = this.faces[face_i];
        const n = this.faceNormals[face_i];
        const v = this.vertices[f[0]];
        const c = -n.dot(v);
        return c;
    }
    /**
   * Clip a face against a hull.
   * @param worldVertsB1 An array of Vec3 with vertices in the world frame.
   * @param minDist Distance clamping
   * @param Array result Array to store resulting contact points in. Will be objects with properties: point, depth, normal. These are represented in world coordinates.
   */ clipFaceAgainstHull(separatingNormal, posA, quatA, worldVertsB1, minDist, maxDist, result) {
        const faceANormalWS = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const edge0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const WorldEdge0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const worldPlaneAnormal1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const planeNormalWS1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const worldA1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const localPlaneNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const planeNormalWS = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const hullA = this;
        const worldVertsB2 = [];
        const pVtxIn = worldVertsB1;
        const pVtxOut = worldVertsB2;
        let closestFaceA = -1;
        let dmin = Number.MAX_VALUE; // Find the face with normal closest to the separating axis
        for(let face = 0; face < hullA.faces.length; face++){
            faceANormalWS.copy(hullA.faceNormals[face]);
            quatA.vmult(faceANormalWS, faceANormalWS);
            const d = faceANormalWS.dot(separatingNormal);
            if (d < dmin) {
                dmin = d;
                closestFaceA = face;
            }
        }
        if (closestFaceA < 0) return;
         // Get the face and construct connected faces
        const polyA = hullA.faces[closestFaceA];
        polyA.connectedFaces = [];
        for(let i = 0; i < hullA.faces.length; i++){
            for(let j = 0; j < hullA.faces[i].length; j++)if (/* Sharing a vertex*/ polyA.indexOf(hullA.faces[i][j]) !== -1 && /* Not the one we are looking for connections from */ i !== closestFaceA && /* Not already added */ polyA.connectedFaces.indexOf(i) === -1) polyA.connectedFaces.push(i);
        } // Clip the polygon to the back of the planes of all faces of hull A,
        // that are adjacent to the witness face
        const numVerticesA = polyA.length;
        for(let i = 0; i < numVerticesA; i++){
            const a = hullA.vertices[polyA[i]];
            const b = hullA.vertices[polyA[(i + 1) % numVerticesA]];
            a.vsub(b, edge0);
            WorldEdge0.copy(edge0);
            quatA.vmult(WorldEdge0, WorldEdge0);
            posA.vadd(WorldEdge0, WorldEdge0);
            worldPlaneAnormal1.copy(this.faceNormals[closestFaceA]);
            quatA.vmult(worldPlaneAnormal1, worldPlaneAnormal1);
            posA.vadd(worldPlaneAnormal1, worldPlaneAnormal1);
            WorldEdge0.cross(worldPlaneAnormal1, planeNormalWS1);
            planeNormalWS1.negate(planeNormalWS1);
            worldA1.copy(a);
            quatA.vmult(worldA1, worldA1);
            posA.vadd(worldA1, worldA1);
            const otherFace = polyA.connectedFaces[i];
            localPlaneNormal.copy(this.faceNormals[otherFace]);
            const localPlaneEq = this.getPlaneConstantOfFace(otherFace);
            planeNormalWS.copy(localPlaneNormal);
            quatA.vmult(planeNormalWS, planeNormalWS);
            const planeEqWS = localPlaneEq - planeNormalWS.dot(posA); // Clip face against our constructed plane
            this.clipFaceAgainstPlane(pVtxIn, pVtxOut, planeNormalWS, planeEqWS); // Throw away all clipped points, but save the remaining until next clip
            while(pVtxIn.length)pVtxIn.shift();
            while(pVtxOut.length)pVtxIn.push(pVtxOut.shift());
        } // only keep contact points that are behind the witness face
        localPlaneNormal.copy(this.faceNormals[closestFaceA]);
        const localPlaneEq = this.getPlaneConstantOfFace(closestFaceA);
        planeNormalWS.copy(localPlaneNormal);
        quatA.vmult(planeNormalWS, planeNormalWS);
        const planeEqWS = localPlaneEq - planeNormalWS.dot(posA);
        for(let i = 0; i < pVtxIn.length; i++){
            let depth = planeNormalWS.dot(pVtxIn[i]) + planeEqWS; // ???
            if (depth <= minDist) {
                console.log("clamped: depth=" + depth + " to minDist=" + minDist);
                depth = minDist;
            }
            if (depth <= maxDist) {
                const point = pVtxIn[i];
                if (depth <= 1e-6) {
                    const p = {
                        point: point,
                        normal: planeNormalWS,
                        depth: depth
                    };
                    result.push(p);
                }
            }
        }
    }
    /**
   * Clip a face in a hull against the back of a plane.
   * @param planeConstant The constant in the mathematical plane equation
   */ clipFaceAgainstPlane(inVertices, outVertices, planeNormal, planeConstant) {
        let n_dot_first;
        let n_dot_last;
        const numVerts = inVertices.length;
        if (numVerts < 2) return outVertices;
        let firstVertex = inVertices[inVertices.length - 1];
        let lastVertex = inVertices[0];
        n_dot_first = planeNormal.dot(firstVertex) + planeConstant;
        for(let vi = 0; vi < numVerts; vi++){
            lastVertex = inVertices[vi];
            n_dot_last = planeNormal.dot(lastVertex) + planeConstant;
            if (n_dot_first < 0) {
                if (n_dot_last < 0) {
                    // Start < 0, end < 0, so output lastVertex
                    const newv = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
                    newv.copy(lastVertex);
                    outVertices.push(newv);
                } else {
                    // Start < 0, end >= 0, so output intersection
                    const newv = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
                    firstVertex.lerp(lastVertex, n_dot_first / (n_dot_first - n_dot_last), newv);
                    outVertices.push(newv);
                }
            } else if (n_dot_last < 0) {
                // Start >= 0, end < 0 so output intersection and end
                const newv = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
                firstVertex.lerp(lastVertex, n_dot_first / (n_dot_first - n_dot_last), newv);
                outVertices.push(newv);
                outVertices.push(lastVertex);
            }
            firstVertex = lastVertex;
            n_dot_first = n_dot_last;
        }
        return outVertices;
    }
    /**
   * Updates `.worldVertices` and sets `.worldVerticesNeedsUpdate` to false.
   */ computeWorldVertices(position, quat) {
        while(this.worldVertices.length < this.vertices.length)this.worldVertices.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa());
        const verts = this.vertices;
        const worldVerts = this.worldVertices;
        for(let i = 0; i !== this.vertices.length; i++){
            quat.vmult(verts[i], worldVerts[i]);
            position.vadd(worldVerts[i], worldVerts[i]);
        }
        this.worldVerticesNeedsUpdate = false;
    }
    computeLocalAABB(aabbmin, aabbmax) {
        const vertices = this.vertices;
        aabbmin.set(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        aabbmax.set(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        for(let i = 0; i < this.vertices.length; i++){
            const v = vertices[i];
            if (v.x < aabbmin.x) aabbmin.x = v.x;
            else if (v.x > aabbmax.x) aabbmax.x = v.x;
            if (v.y < aabbmin.y) aabbmin.y = v.y;
            else if (v.y > aabbmax.y) aabbmax.y = v.y;
            if (v.z < aabbmin.z) aabbmin.z = v.z;
            else if (v.z > aabbmax.z) aabbmax.z = v.z;
        }
    }
    /**
   * Updates `worldVertices` and sets `worldVerticesNeedsUpdate` to false.
   */ computeWorldFaceNormals(quat) {
        const N = this.faceNormals.length;
        while(this.worldFaceNormals.length < N)this.worldFaceNormals.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa());
        const normals = this.faceNormals;
        const worldNormals = this.worldFaceNormals;
        for(let i = 0; i !== N; i++)quat.vmult(normals[i], worldNormals[i]);
        this.worldFaceNormalsNeedsUpdate = false;
    }
    /**
   * updateBoundingSphereRadius
   */ updateBoundingSphereRadius() {
        // Assume points are distributed with local (0,0,0) as center
        let max2 = 0;
        const verts = this.vertices;
        for(let i = 0; i !== verts.length; i++){
            const norm2 = verts[i].lengthSquared();
            if (norm2 > max2) max2 = norm2;
        }
        this.boundingSphereRadius = Math.sqrt(max2);
    }
    /**
   * calculateWorldAABB
   */ calculateWorldAABB(pos, quat, min, max) {
        const verts = this.vertices;
        let minx;
        let miny;
        let minz;
        let maxx;
        let maxy;
        let maxz;
        let tempWorldVertex = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        for(let i = 0; i < verts.length; i++){
            tempWorldVertex.copy(verts[i]);
            quat.vmult(tempWorldVertex, tempWorldVertex);
            pos.vadd(tempWorldVertex, tempWorldVertex);
            const v = tempWorldVertex;
            if (minx === undefined || v.x < minx) minx = v.x;
            if (maxx === undefined || v.x > maxx) maxx = v.x;
            if (miny === undefined || v.y < miny) miny = v.y;
            if (maxy === undefined || v.y > maxy) maxy = v.y;
            if (minz === undefined || v.z < minz) minz = v.z;
            if (maxz === undefined || v.z > maxz) maxz = v.z;
        }
        min.set(minx, miny, minz);
        max.set(maxx, maxy, maxz);
    }
    /**
   * Get approximate convex volume
   */ volume() {
        return 4.0 * Math.PI * this.boundingSphereRadius / 3.0;
    }
    /**
   * Get an average of all the vertices positions
   */ getAveragePointLocal(target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const verts = this.vertices;
        for(let i = 0; i < verts.length; i++)target.vadd(verts[i], target);
        target.scale(1 / verts.length, target);
        return target;
    }
    /**
   * Transform all local points. Will change the .vertices
   */ transformAllPoints(offset, quat) {
        const n = this.vertices.length;
        const verts = this.vertices; // Apply rotation
        if (quat) {
            // Rotate vertices
            for(let i = 0; i < n; i++){
                const v = verts[i];
                quat.vmult(v, v);
            } // Rotate face normals
            for(let i = 0; i < this.faceNormals.length; i++){
                const v = this.faceNormals[i];
                quat.vmult(v, v);
            }
        /*
            // Rotate edges
            for(let i=0; i<this.uniqueEdges.length; i++){
                const v = this.uniqueEdges[i];
                quat.vmult(v,v);
            }*/ } // Apply offset
        if (offset) for(let i = 0; i < n; i++){
            const v = verts[i];
            v.vadd(offset, v);
        }
    }
    /**
   * Checks whether p is inside the polyhedra. Must be in local coords.
   * The point lies outside of the convex hull of the other points if and only if the direction
   * of all the vectors from it to those other points are on less than one half of a sphere around it.
   * @param p A point given in local coordinates
   */ pointIsInside(p) {
        const verts = this.vertices;
        const faces = this.faces;
        const normals = this.faceNormals;
        const pointInside = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.getAveragePointLocal(pointInside);
        for(let i = 0; i < this.faces.length; i++){
            let n = normals[i];
            const v = verts[faces[i][0]]; // We only need one point in the face
            // This dot product determines which side of the edge the point is
            const vToP = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            p.vsub(v, vToP);
            const r1 = n.dot(vToP);
            const vToPointInside = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            pointInside.vsub(v, vToPointInside);
            const r2 = n.dot(vToPointInside);
            if (r1 < 0 && r2 > 0 || r1 > 0 && r2 < 0) return false; // Encountered some other sign. Exit.
        } // If we got here, all dot products were of the same sign.
        return -1;
    }
    /**
   * Get max and min dot product of a convex hull at position (pos,quat) projected onto an axis.
   * Results are saved in the array maxmin.
   * @param result result[0] and result[1] will be set to maximum and minimum, respectively.
   */ static project(shape, axis, pos, quat, result) {
        const n = shape.vertices.length;
        const localAxis = $0982bf0d3ab2ea42$var$project_localAxis;
        let max = 0;
        let min = 0;
        const localOrigin = $0982bf0d3ab2ea42$var$project_localOrigin;
        const vs = shape.vertices;
        localOrigin.setZero(); // Transform the axis to local
        $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToLocalFrame(pos, quat, axis, localAxis);
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(pos, quat, localOrigin, localOrigin);
        const add = localOrigin.dot(localAxis);
        min = max = vs[0].dot(localAxis);
        for(let i = 1; i < n; i++){
            const val = vs[i].dot(localAxis);
            if (val > max) max = val;
            if (val < min) min = val;
        }
        min -= add;
        max -= add;
        if (min > max) {
            // Inconsistent - swap
            const temp = min;
            min = max;
            max = temp;
        } // Output
        result[0] = max;
        result[1] = min;
    }
    /** vertices */ /**
   * Array of integer arrays, indicating which vertices each face consists of
   */ /** faceNormals */ /** worldVertices */ /** worldVerticesNeedsUpdate */ /** worldFaceNormals */ /** worldFaceNormalsNeedsUpdate */ /**
   * If given, these locally defined, normalized axes are the only ones being checked when doing separating axis check.
   */ /** uniqueEdges */ /**
   * @param vertices An array of Vec3's
   * @param faces Array of integer arrays, describing which vertices that is included in each face.
   */ constructor(props = {}){
        const { vertices: vertices = [], faces: faces = [], normals: normals = [], axes: axes, boundingSphereRadius: boundingSphereRadius } = props;
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON
        });
        this.vertices = void 0;
        this.faces = void 0;
        this.faceNormals = void 0;
        this.worldVertices = void 0;
        this.worldVerticesNeedsUpdate = void 0;
        this.worldFaceNormals = void 0;
        this.worldFaceNormalsNeedsUpdate = void 0;
        this.uniqueAxes = void 0;
        this.uniqueEdges = void 0;
        this.vertices = vertices;
        this.faces = faces;
        this.faceNormals = normals;
        if (this.faceNormals.length === 0) this.computeNormals();
        if (!boundingSphereRadius) this.updateBoundingSphereRadius();
        else this.boundingSphereRadius = boundingSphereRadius;
        this.worldVertices = []; // World transformed version of .vertices
        this.worldVerticesNeedsUpdate = true;
        this.worldFaceNormals = []; // World transformed version of .faceNormals
        this.worldFaceNormalsNeedsUpdate = true;
        this.uniqueAxes = axes ? axes.slice() : null;
        this.uniqueEdges = [];
        this.computeEdges();
    }
}
const $0982bf0d3ab2ea42$var$maxminA = [];
const $0982bf0d3ab2ea42$var$maxminB = [];
const $0982bf0d3ab2ea42$var$project_localAxis = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$project_localOrigin = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * A 3d box shape.
 * @example
 *     const size = 1
 *     const halfExtents = new CANNON.Vec3(size, size, size)
 *     const boxShape = new CANNON.Box(halfExtents)
 *     const boxBody = new CANNON.Body({ mass: 1, shape: boxShape })
 *     world.addBody(boxBody)
 */ class $0982bf0d3ab2ea42$export$e71c4d32a2263218 extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /**
   * Updates the local convex polyhedron representation used for some collisions.
   */ updateConvexPolyhedronRepresentation() {
        const sx = this.halfExtents.x;
        const sy = this.halfExtents.y;
        const sz = this.halfExtents.z;
        const V = $0982bf0d3ab2ea42$export$838423f3adec30fa;
        const vertices = [
            new V(-sx, -sy, -sz),
            new V(sx, -sy, -sz),
            new V(sx, sy, -sz),
            new V(-sx, sy, -sz),
            new V(-sx, -sy, sz),
            new V(sx, -sy, sz),
            new V(sx, sy, sz),
            new V(-sx, sy, sz)
        ];
        const faces = [
            [
                3,
                2,
                1,
                0
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                5,
                4,
                0,
                1
            ],
            [
                2,
                3,
                7,
                6
            ],
            [
                0,
                4,
                7,
                3
            ],
            [
                1,
                2,
                6,
                5
            ] // +x
        ];
        const axes = [
            new V(0, 0, 1),
            new V(0, 1, 0),
            new V(1, 0, 0)
        ];
        const h = new $0982bf0d3ab2ea42$export$7c637a75bc263948({
            vertices: vertices,
            faces: faces,
            axes: axes
        });
        this.convexPolyhedronRepresentation = h;
        h.material = this.material;
    }
    /**
   * Calculate the inertia of the box.
   */ calculateLocalInertia(mass, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        $0982bf0d3ab2ea42$export$e71c4d32a2263218.calculateInertia(this.halfExtents, mass, target);
        return target;
    }
    static calculateInertia(halfExtents, mass, target) {
        const e = halfExtents;
        target.x = 1.0 / 12.0 * mass * (2 * e.y * 2 * e.y + 2 * e.z * 2 * e.z);
        target.y = 1.0 / 12.0 * mass * (2 * e.x * 2 * e.x + 2 * e.z * 2 * e.z);
        target.z = 1.0 / 12.0 * mass * (2 * e.y * 2 * e.y + 2 * e.x * 2 * e.x);
    }
    /**
   * Get the box 6 side normals
   * @param sixTargetVectors An array of 6 vectors, to store the resulting side normals in.
   * @param quat Orientation to apply to the normal vectors. If not provided, the vectors will be in respect to the local frame.
   */ getSideNormals(sixTargetVectors, quat) {
        const sides = sixTargetVectors;
        const ex = this.halfExtents;
        sides[0].set(ex.x, 0, 0);
        sides[1].set(0, ex.y, 0);
        sides[2].set(0, 0, ex.z);
        sides[3].set(-ex.x, 0, 0);
        sides[4].set(0, -ex.y, 0);
        sides[5].set(0, 0, -ex.z);
        if (quat !== undefined) for(let i = 0; i !== sides.length; i++)quat.vmult(sides[i], sides[i]);
        return sides;
    }
    /**
   * Returns the volume of the box.
   */ volume() {
        return 8.0 * this.halfExtents.x * this.halfExtents.y * this.halfExtents.z;
    }
    /**
   * updateBoundingSphereRadius
   */ updateBoundingSphereRadius() {
        this.boundingSphereRadius = this.halfExtents.length();
    }
    /**
   * forEachWorldCorner
   */ forEachWorldCorner(pos, quat, callback) {
        const e = this.halfExtents;
        const corners = [
            [
                e.x,
                e.y,
                e.z
            ],
            [
                -e.x,
                e.y,
                e.z
            ],
            [
                -e.x,
                -e.y,
                e.z
            ],
            [
                -e.x,
                -e.y,
                -e.z
            ],
            [
                e.x,
                -e.y,
                -e.z
            ],
            [
                e.x,
                e.y,
                -e.z
            ],
            [
                -e.x,
                e.y,
                -e.z
            ],
            [
                e.x,
                -e.y,
                e.z
            ]
        ];
        for(let i = 0; i < corners.length; i++){
            $0982bf0d3ab2ea42$var$worldCornerTempPos.set(corners[i][0], corners[i][1], corners[i][2]);
            quat.vmult($0982bf0d3ab2ea42$var$worldCornerTempPos, $0982bf0d3ab2ea42$var$worldCornerTempPos);
            pos.vadd($0982bf0d3ab2ea42$var$worldCornerTempPos, $0982bf0d3ab2ea42$var$worldCornerTempPos);
            callback($0982bf0d3ab2ea42$var$worldCornerTempPos.x, $0982bf0d3ab2ea42$var$worldCornerTempPos.y, $0982bf0d3ab2ea42$var$worldCornerTempPos.z);
        }
    }
    /**
   * calculateWorldAABB
   */ calculateWorldAABB(pos, quat, min, max) {
        const e = this.halfExtents;
        $0982bf0d3ab2ea42$var$worldCornersTemp[0].set(e.x, e.y, e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[1].set(-e.x, e.y, e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[2].set(-e.x, -e.y, e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[3].set(-e.x, -e.y, -e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[4].set(e.x, -e.y, -e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[5].set(e.x, e.y, -e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[6].set(-e.x, e.y, -e.z);
        $0982bf0d3ab2ea42$var$worldCornersTemp[7].set(e.x, -e.y, e.z);
        const wc = $0982bf0d3ab2ea42$var$worldCornersTemp[0];
        quat.vmult(wc, wc);
        pos.vadd(wc, wc);
        max.copy(wc);
        min.copy(wc);
        for(let i = 1; i < 8; i++){
            const wc = $0982bf0d3ab2ea42$var$worldCornersTemp[i];
            quat.vmult(wc, wc);
            pos.vadd(wc, wc);
            const x = wc.x;
            const y = wc.y;
            const z = wc.z;
            if (x > max.x) max.x = x;
            if (y > max.y) max.y = y;
            if (z > max.z) max.z = z;
            if (x < min.x) min.x = x;
            if (y < min.y) min.y = y;
            if (z < min.z) min.z = z;
        } // Get each axis max
    // min.set(Infinity,Infinity,Infinity);
    // max.set(-Infinity,-Infinity,-Infinity);
    // this.forEachWorldCorner(pos,quat,function(x,y,z){
    //     if(x > max.x){
    //         max.x = x;
    //     }
    //     if(y > max.y){
    //         max.y = y;
    //     }
    //     if(z > max.z){
    //         max.z = z;
    //     }
    //     if(x < min.x){
    //         min.x = x;
    //     }
    //     if(y < min.y){
    //         min.y = y;
    //     }
    //     if(z < min.z){
    //         min.z = z;
    //     }
    // });
    }
    /**
   * The half extents of the box.
   */ /**
   * Used by the contact generator to make contacts with other convex polyhedra for example.
   */ constructor(halfExtents){
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX
        });
        this.halfExtents = void 0;
        this.convexPolyhedronRepresentation = void 0;
        this.halfExtents = halfExtents;
        this.convexPolyhedronRepresentation = null;
        this.updateConvexPolyhedronRepresentation();
        this.updateBoundingSphereRadius();
    }
}
const $0982bf0d3ab2ea42$var$worldCornerTempPos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$worldCornersTemp = [
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa()
];
/**
 * BODY_TYPES
 */ const $0982bf0d3ab2ea42$export$639c83c23c4267cd = {
    /** DYNAMIC */ DYNAMIC: 1,
    /** STATIC */ STATIC: 2,
    /** KINEMATIC */ KINEMATIC: 4
};
/**
 * BodyType
 */ /**
 * BODY_SLEEP_STATES
 */ const $0982bf0d3ab2ea42$export$39fcd8c83b7ae118 = {
    /** AWAKE */ AWAKE: 0,
    /** SLEEPY */ SLEEPY: 1,
    /** SLEEPING */ SLEEPING: 2
};
/**
 * BodySleepState
 */ /**
 * Base class for all body types.
 * @example
 *     const shape = new CANNON.Sphere(1)
 *     const body = new CANNON.Body({
 *       mass: 1,
 *       shape,
 *     })
 *     world.addBody(body)
 */ class $0982bf0d3ab2ea42$export$4b2c32e08f77ff18 extends $0982bf0d3ab2ea42$export$648eec84020a2b10 {
    /**
   * Wake the body up.
   */ wakeUp() {
        const prevState = this.sleepState;
        this.sleepState = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.AWAKE;
        this.wakeUpAfterNarrowphase = false;
        if (prevState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) this.dispatchEvent($0982bf0d3ab2ea42$export$4b2c32e08f77ff18.wakeupEvent);
    }
    /**
   * Force body sleep
   */ sleep() {
        this.sleepState = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING;
        this.velocity.set(0, 0, 0);
        this.angularVelocity.set(0, 0, 0);
        this.wakeUpAfterNarrowphase = false;
    }
    /**
   * Called every timestep to update internal sleep timer and change sleep state if needed.
   * @param time The world time in seconds
   */ sleepTick(time) {
        if (this.allowSleep) {
            const sleepState = this.sleepState;
            const speedSquared = this.velocity.lengthSquared() + this.angularVelocity.lengthSquared();
            const speedLimitSquared = this.sleepSpeedLimit ** 2;
            if (sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.AWAKE && speedSquared < speedLimitSquared) {
                this.sleepState = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPY; // Sleepy
                this.timeLastSleepy = time;
                this.dispatchEvent($0982bf0d3ab2ea42$export$4b2c32e08f77ff18.sleepyEvent);
            } else if (sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPY && speedSquared > speedLimitSquared) this.wakeUp(); // Wake up
            else if (sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPY && time - this.timeLastSleepy > this.sleepTimeLimit) {
                this.sleep(); // Sleeping
                this.dispatchEvent($0982bf0d3ab2ea42$export$4b2c32e08f77ff18.sleepEvent);
            }
        }
    }
    /**
   * If the body is sleeping, it should be immovable / have infinite mass during solve. We solve it by having a separate "solve mass".
   */ updateSolveMassProperties() {
        if (this.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING || this.type === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC) {
            this.invMassSolve = 0;
            this.invInertiaSolve.setZero();
            this.invInertiaWorldSolve.setZero();
        } else {
            this.invMassSolve = this.invMass;
            this.invInertiaSolve.copy(this.invInertia);
            this.invInertiaWorldSolve.copy(this.invInertiaWorld);
        }
    }
    /**
   * Convert a world point to local body frame.
   */ pointToLocalFrame(worldPoint, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        worldPoint.vsub(this.position, result);
        this.quaternion.conjugate().vmult(result, result);
        return result;
    }
    /**
   * Convert a world vector to local body frame.
   */ vectorToLocalFrame(worldVector, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        this.quaternion.conjugate().vmult(worldVector, result);
        return result;
    }
    /**
   * Convert a local body point to world frame.
   */ pointToWorldFrame(localPoint, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        this.quaternion.vmult(localPoint, result);
        result.vadd(this.position, result);
        return result;
    }
    /**
   * Convert a local body point to world frame.
   */ vectorToWorldFrame(localVector, result = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        this.quaternion.vmult(localVector, result);
        return result;
    }
    /**
   * Add a shape to the body with a local offset and orientation.
   * @return The body object, for chainability.
   */ addShape(shape, _offset, _orientation) {
        const offset = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const orientation = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        if (_offset) offset.copy(_offset);
        if (_orientation) orientation.copy(_orientation);
        this.shapes.push(shape);
        this.shapeOffsets.push(offset);
        this.shapeOrientations.push(orientation);
        this.updateMassProperties();
        this.updateBoundingRadius();
        this.aabbNeedsUpdate = true;
        shape.body = this;
        return this;
    }
    /**
   * Remove a shape from the body.
   * @return The body object, for chainability.
   */ removeShape(shape) {
        const index = this.shapes.indexOf(shape);
        if (index === -1) {
            console.warn('Shape does not belong to the body');
            return this;
        }
        this.shapes.splice(index, 1);
        this.shapeOffsets.splice(index, 1);
        this.shapeOrientations.splice(index, 1);
        this.updateMassProperties();
        this.updateBoundingRadius();
        this.aabbNeedsUpdate = true;
        shape.body = null;
        return this;
    }
    /**
   * Update the bounding radius of the body. Should be done if any of the shapes are changed.
   */ updateBoundingRadius() {
        const shapes = this.shapes;
        const shapeOffsets = this.shapeOffsets;
        const N = shapes.length;
        let radius = 0;
        for(let i = 0; i !== N; i++){
            const shape = shapes[i];
            shape.updateBoundingSphereRadius();
            const offset = shapeOffsets[i].length();
            const r = shape.boundingSphereRadius;
            if (offset + r > radius) radius = offset + r;
        }
        this.boundingRadius = radius;
    }
    /**
   * Updates the .aabb
   */ updateAABB() {
        const shapes = this.shapes;
        const shapeOffsets = this.shapeOffsets;
        const shapeOrientations = this.shapeOrientations;
        const N = shapes.length;
        const offset = $0982bf0d3ab2ea42$var$tmpVec;
        const orientation = $0982bf0d3ab2ea42$var$tmpQuat;
        const bodyQuat = this.quaternion;
        const aabb = this.aabb;
        const shapeAABB = $0982bf0d3ab2ea42$var$updateAABB_shapeAABB;
        for(let i = 0; i !== N; i++){
            const shape = shapes[i]; // Get shape world position
            bodyQuat.vmult(shapeOffsets[i], offset);
            offset.vadd(this.position, offset); // Get shape world quaternion
            bodyQuat.mult(shapeOrientations[i], orientation); // Get shape AABB
            shape.calculateWorldAABB(offset, orientation, shapeAABB.lowerBound, shapeAABB.upperBound);
            if (i === 0) aabb.copy(shapeAABB);
            else aabb.extend(shapeAABB);
        }
        this.aabbNeedsUpdate = false;
    }
    /**
   * Update `.inertiaWorld` and `.invInertiaWorld`
   */ updateInertiaWorld(force) {
        const I = this.invInertia;
        if (I.x === I.y && I.y === I.z && !force) ;
        else {
            const m1 = $0982bf0d3ab2ea42$var$uiw_m1;
            const m2 = $0982bf0d3ab2ea42$var$uiw_m2;
            m1.setRotationFromQuaternion(this.quaternion);
            m1.transpose(m2);
            m1.scale(I, m1);
            m1.mmult(m2, this.invInertiaWorld);
        }
    }
    /**
   * Apply force to a point of the body. This could for example be a point on the Body surface.
   * Applying force this way will add to Body.force and Body.torque.
   * @param force The amount of force to add.
   * @param relativePoint A point relative to the center of mass to apply the force on.
   */ applyForce(force, relativePoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        // Needed?
        if (this.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC) return;
        if (this.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) this.wakeUp();
         // Compute produced rotational force
        const rotForce = $0982bf0d3ab2ea42$var$Body_applyForce_rotForce;
        relativePoint.cross(force, rotForce); // Add linear force
        this.force.vadd(force, this.force); // Add rotational force
        this.torque.vadd(rotForce, this.torque);
    }
    /**
   * Apply force to a local point in the body.
   * @param force The force vector to apply, defined locally in the body frame.
   * @param localPoint A local point in the body to apply the force on.
   */ applyLocalForce(localForce, localPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        if (this.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC) return;
        const worldForce = $0982bf0d3ab2ea42$var$Body_applyLocalForce_worldForce;
        const relativePointWorld = $0982bf0d3ab2ea42$var$Body_applyLocalForce_relativePointWorld; // Transform the force vector to world space
        this.vectorToWorldFrame(localForce, worldForce);
        this.vectorToWorldFrame(localPoint, relativePointWorld);
        this.applyForce(worldForce, relativePointWorld);
    }
    /**
   * Apply torque to the body.
   * @param torque The amount of torque to add.
   */ applyTorque(torque) {
        if (this.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC) return;
        if (this.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) this.wakeUp();
         // Add rotational force
        this.torque.vadd(torque, this.torque);
    }
    /**
   * Apply impulse to a point of the body. This could for example be a point on the Body surface.
   * An impulse is a force added to a body during a short period of time (impulse = force * time).
   * Impulses will be added to Body.velocity and Body.angularVelocity.
   * @param impulse The amount of impulse to add.
   * @param relativePoint A point relative to the center of mass to apply the force on.
   */ applyImpulse(impulse, relativePoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        if (this.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC) return;
        if (this.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) this.wakeUp();
         // Compute point position relative to the body center
        const r = relativePoint; // Compute produced central impulse velocity
        const velo = $0982bf0d3ab2ea42$var$Body_applyImpulse_velo;
        velo.copy(impulse);
        velo.scale(this.invMass, velo); // Add linear impulse
        this.velocity.vadd(velo, this.velocity); // Compute produced rotational impulse velocity
        const rotVelo = $0982bf0d3ab2ea42$var$Body_applyImpulse_rotVelo;
        r.cross(impulse, rotVelo);
        /*
     rotVelo.x *= this.invInertia.x;
     rotVelo.y *= this.invInertia.y;
     rotVelo.z *= this.invInertia.z;
     */ this.invInertiaWorld.vmult(rotVelo, rotVelo); // Add rotational Impulse
        this.angularVelocity.vadd(rotVelo, this.angularVelocity);
    }
    /**
   * Apply locally-defined impulse to a local point in the body.
   * @param force The force vector to apply, defined locally in the body frame.
   * @param localPoint A local point in the body to apply the force on.
   */ applyLocalImpulse(localImpulse, localPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        if (this.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC) return;
        const worldImpulse = $0982bf0d3ab2ea42$var$Body_applyLocalImpulse_worldImpulse;
        const relativePointWorld = $0982bf0d3ab2ea42$var$Body_applyLocalImpulse_relativePoint; // Transform the force vector to world space
        this.vectorToWorldFrame(localImpulse, worldImpulse);
        this.vectorToWorldFrame(localPoint, relativePointWorld);
        this.applyImpulse(worldImpulse, relativePointWorld);
    }
    /**
   * Should be called whenever you change the body shape or mass.
   */ updateMassProperties() {
        const halfExtents = $0982bf0d3ab2ea42$var$Body_updateMassProperties_halfExtents;
        this.invMass = this.mass > 0 ? 1.0 / this.mass : 0;
        const I = this.inertia;
        const fixed = this.fixedRotation; // Approximate with AABB box
        this.updateAABB();
        halfExtents.set((this.aabb.upperBound.x - this.aabb.lowerBound.x) / 2, (this.aabb.upperBound.y - this.aabb.lowerBound.y) / 2, (this.aabb.upperBound.z - this.aabb.lowerBound.z) / 2);
        $0982bf0d3ab2ea42$export$e71c4d32a2263218.calculateInertia(halfExtents, this.mass, I);
        this.invInertia.set(I.x > 0 && !fixed ? 1.0 / I.x : 0, I.y > 0 && !fixed ? 1.0 / I.y : 0, I.z > 0 && !fixed ? 1.0 / I.z : 0);
        this.updateInertiaWorld(true);
    }
    /**
   * Get world velocity of a point in the body.
   * @param worldPoint
   * @param result
   * @return The result vector.
   */ getVelocityAtWorldPoint(worldPoint, result) {
        const r = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        worldPoint.vsub(this.position, r);
        this.angularVelocity.cross(r, result);
        this.velocity.vadd(result, result);
        return result;
    }
    /**
   * Move the body forward in time.
   * @param dt Time step
   * @param quatNormalize Set to true to normalize the body quaternion
   * @param quatNormalizeFast If the quaternion should be normalized using "fast" quaternion normalization
   */ integrate(dt, quatNormalize, quatNormalizeFast) {
        // Save previous position
        this.previousPosition.copy(this.position);
        this.previousQuaternion.copy(this.quaternion);
        if (!(this.type === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC || this.type === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC) || this.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) // Only for dynamic
        return;
        const velo = this.velocity;
        const angularVelo = this.angularVelocity;
        const pos = this.position;
        const force = this.force;
        const torque = this.torque;
        const quat = this.quaternion;
        const invMass = this.invMass;
        const invInertia = this.invInertiaWorld;
        const linearFactor = this.linearFactor;
        const iMdt = invMass * dt;
        velo.x += force.x * iMdt * linearFactor.x;
        velo.y += force.y * iMdt * linearFactor.y;
        velo.z += force.z * iMdt * linearFactor.z;
        const e = invInertia.elements;
        const angularFactor = this.angularFactor;
        const tx = torque.x * angularFactor.x;
        const ty = torque.y * angularFactor.y;
        const tz = torque.z * angularFactor.z;
        angularVelo.x += dt * (e[0] * tx + e[1] * ty + e[2] * tz);
        angularVelo.y += dt * (e[3] * tx + e[4] * ty + e[5] * tz);
        angularVelo.z += dt * (e[6] * tx + e[7] * ty + e[8] * tz); // Use new velocity  - leap frog
        pos.x += velo.x * dt;
        pos.y += velo.y * dt;
        pos.z += velo.z * dt;
        quat.integrate(this.angularVelocity, dt, this.angularFactor, quat);
        if (quatNormalize) {
            if (quatNormalizeFast) quat.normalizeFast();
            else quat.normalize();
        }
        this.aabbNeedsUpdate = true; // Update world inertia
        this.updateInertiaWorld();
    }
    /**
   * Dispatched after two bodies collide. This event is dispatched on each
   * of the two bodies involved in the collision.
   * @event collide
   * @param body The body that was involved in the collision.
   * @param contact The details of the collision.
   */ /**
   * A dynamic body is fully simulated. Can be moved manually by the user, but normally they move according to forces. A dynamic body can collide with all body types. A dynamic body always has finite, non-zero mass.
   */ /**
   * A static body does not move during simulation and behaves as if it has infinite mass. Static bodies can be moved manually by setting the position of the body. The velocity of a static body is always zero. Static bodies do not collide with other static or kinematic bodies.
   */ /**
   * A kinematic body moves under simulation according to its velocity. They do not respond to forces. They can be moved manually, but normally a kinematic body is moved by setting its velocity. A kinematic body behaves as if it has infinite mass. Kinematic bodies do not collide with other static or kinematic bodies.
   */ /**
   * AWAKE
   */ /**
   * SLEEPY
   */ /**
   * SLEEPING
   */ /**
   * Dispatched after a sleeping body has woken up.
   * @event wakeup
   */ /**
   * Dispatched after a body has gone in to the sleepy state.
   * @event sleepy
   */ /**
   * Dispatched after a body has fallen asleep.
   * @event sleep
   */ /**
   * Identifier of the body.
   */ /**
   * Position of body in World.bodies. Updated by World and used in ArrayCollisionMatrix.
   */ /**
   * Reference to the world the body is living in.
   */ /**
   * Callback function that is used BEFORE stepping the system. Use it to apply forces, for example. Inside the function, "this" will refer to this Body object. Deprecated - use World events instead.
   * @deprecated Use World events instead
   */ /**
   * Callback function that is used AFTER stepping the system. Inside the function, "this" will refer to this Body object. Deprecated - use World events instead.
   * @deprecated Use World events instead
   */ /**
   * The collision group the body belongs to.
   * @default 1
   */ /**
   * The collision group the body can collide with.
   * @default -1
   */ /**
   * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled - i.e. "collide" events will be raised, but forces will not be altered.
   */ /**
   * World space position of the body.
   */ /**
   * Interpolated position of the body.
   */ /**
   * Initial position of the body.
   */ /**
   * World space velocity of the body.
   */ /**
   * Initial velocity of the body.
   */ /**
   * Linear force on the body in world space.
   */ /**
   * The mass of the body.
   * @default 0
   */ /**
   * The physics material of the body. It defines the body interaction with other bodies.
   */ /**
   * How much to damp the body velocity each step. It can go from 0 to 1.
   * @default 0.01
   */ /**
   * One of: `Body.DYNAMIC`, `Body.STATIC` and `Body.KINEMATIC`.
   */ /**
   * If true, the body will automatically fall to sleep.
   * @default true
   */ /**
   * Current sleep state.
   */ /**
   * If the speed (the norm of the velocity) is smaller than this value, the body is considered sleepy.
   * @default 0.1
   */ /**
   * If the body has been sleepy for this sleepTimeLimit seconds, it is considered sleeping.
   * @default 1
   */ /**
   * World space rotational force on the body, around center of mass.
   */ /**
   * World space orientation of the body.
   */ /**
   * Initial quaternion of the body.
   */ /**
   * Interpolated orientation of the body.
   */ /**
   * Angular velocity of the body, in world space. Think of the angular velocity as a vector, which the body rotates around. The length of this vector determines how fast (in radians per second) the body rotates.
   */ /**
   * Initial angular velocity of the body.
   */ /**
   * List of Shapes that have been added to the body.
   */ /**
   * Position of each Shape in the body, given in local Body space.
   */ /**
   * Orientation of each Shape, given in local Body space.
   */ /**
   * The inertia of the body.
   */ /**
   * Set to true if you don't want the body to rotate. Make sure to run .updateMassProperties() if you change this after the body creation.
   * @default false
   */ /**
   * How much to damp the body angular velocity each step. It can go from 0 to 1.
   * @default 0.01
   */ /**
   * Use this property to limit the motion along any world axis. (1,1,1) will allow motion along all axes while (0,0,0) allows none.
   */ /**
   * Use this property to limit the rotational motion along any world axis. (1,1,1) will allow rotation along all axes while (0,0,0) allows none.
   */ /**
   * World space bounding box of the body and its shapes.
   */ /**
   * Indicates if the AABB needs to be updated before use.
   */ /**
   * Total bounding radius of the Body including its shapes, relative to body.position.
   */ /**
   * When true the body behaves like a trigger. It does not collide
   * with other bodies but collision events are still triggered.
   * @default false
   */ constructor(options = {}){
        super();
        this.id = void 0;
        this.index = void 0;
        this.world = void 0;
        this.preStep = void 0;
        this.postStep = void 0;
        this.vlambda = void 0;
        this.collisionFilterGroup = void 0;
        this.collisionFilterMask = void 0;
        this.collisionResponse = void 0;
        this.position = void 0;
        this.previousPosition = void 0;
        this.interpolatedPosition = void 0;
        this.initPosition = void 0;
        this.velocity = void 0;
        this.initVelocity = void 0;
        this.force = void 0;
        this.mass = void 0;
        this.invMass = void 0;
        this.material = void 0;
        this.linearDamping = void 0;
        this.type = void 0;
        this.allowSleep = void 0;
        this.sleepState = void 0;
        this.sleepSpeedLimit = void 0;
        this.sleepTimeLimit = void 0;
        this.timeLastSleepy = void 0;
        this.wakeUpAfterNarrowphase = void 0;
        this.torque = void 0;
        this.quaternion = void 0;
        this.initQuaternion = void 0;
        this.previousQuaternion = void 0;
        this.interpolatedQuaternion = void 0;
        this.angularVelocity = void 0;
        this.initAngularVelocity = void 0;
        this.shapes = void 0;
        this.shapeOffsets = void 0;
        this.shapeOrientations = void 0;
        this.inertia = void 0;
        this.invInertia = void 0;
        this.invInertiaWorld = void 0;
        this.invMassSolve = void 0;
        this.invInertiaSolve = void 0;
        this.invInertiaWorldSolve = void 0;
        this.fixedRotation = void 0;
        this.angularDamping = void 0;
        this.linearFactor = void 0;
        this.angularFactor = void 0;
        this.aabb = void 0;
        this.aabbNeedsUpdate = void 0;
        this.boundingRadius = void 0;
        this.wlambda = void 0;
        this.isTrigger = void 0;
        this.id = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.idCounter++;
        this.index = -1;
        this.world = null;
        this.preStep = null;
        this.postStep = null;
        this.vlambda = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.collisionFilterGroup = typeof options.collisionFilterGroup === 'number' ? options.collisionFilterGroup : 1;
        this.collisionFilterMask = typeof options.collisionFilterMask === 'number' ? options.collisionFilterMask : -1;
        this.collisionResponse = typeof options.collisionResponse === 'boolean' ? options.collisionResponse : true;
        this.position = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.previousPosition = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.interpolatedPosition = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.initPosition = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        if (options.position) {
            this.position.copy(options.position);
            this.previousPosition.copy(options.position);
            this.interpolatedPosition.copy(options.position);
            this.initPosition.copy(options.position);
        }
        this.velocity = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        if (options.velocity) this.velocity.copy(options.velocity);
        this.initVelocity = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.force = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const mass = typeof options.mass === 'number' ? options.mass : 0;
        this.mass = mass;
        this.invMass = mass > 0 ? 1.0 / mass : 0;
        this.material = options.material || null;
        this.linearDamping = typeof options.linearDamping === 'number' ? options.linearDamping : 0.01;
        this.type = mass <= 0.0 ? $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC : $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC;
        if (typeof options.type === typeof $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC) this.type = options.type;
        this.allowSleep = typeof options.allowSleep !== 'undefined' ? options.allowSleep : true;
        this.sleepState = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.AWAKE;
        this.sleepSpeedLimit = typeof options.sleepSpeedLimit !== 'undefined' ? options.sleepSpeedLimit : 0.1;
        this.sleepTimeLimit = typeof options.sleepTimeLimit !== 'undefined' ? options.sleepTimeLimit : 1;
        this.timeLastSleepy = 0;
        this.wakeUpAfterNarrowphase = false;
        this.torque = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.quaternion = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        this.initQuaternion = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        this.previousQuaternion = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        this.interpolatedQuaternion = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        if (options.quaternion) {
            this.quaternion.copy(options.quaternion);
            this.initQuaternion.copy(options.quaternion);
            this.previousQuaternion.copy(options.quaternion);
            this.interpolatedQuaternion.copy(options.quaternion);
        }
        this.angularVelocity = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        if (options.angularVelocity) this.angularVelocity.copy(options.angularVelocity);
        this.initAngularVelocity = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.shapes = [];
        this.shapeOffsets = [];
        this.shapeOrientations = [];
        this.inertia = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.invInertia = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.invInertiaWorld = new $0982bf0d3ab2ea42$export$83f4edd572c84121();
        this.invMassSolve = 0;
        this.invInertiaSolve = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.invInertiaWorldSolve = new $0982bf0d3ab2ea42$export$83f4edd572c84121();
        this.fixedRotation = typeof options.fixedRotation !== 'undefined' ? options.fixedRotation : false;
        this.angularDamping = typeof options.angularDamping !== 'undefined' ? options.angularDamping : 0.01;
        this.linearFactor = new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 1, 1);
        if (options.linearFactor) this.linearFactor.copy(options.linearFactor);
        this.angularFactor = new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 1, 1);
        if (options.angularFactor) this.angularFactor.copy(options.angularFactor);
        this.aabb = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
        this.aabbNeedsUpdate = true;
        this.boundingRadius = 0;
        this.wlambda = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.isTrigger = Boolean(options.isTrigger);
        if (options.shape) this.addShape(options.shape);
        this.updateMassProperties();
    }
}
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.idCounter = 0;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.COLLIDE_EVENT_NAME = 'collide';
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC = $0982bf0d3ab2ea42$export$639c83c23c4267cd.DYNAMIC;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC = $0982bf0d3ab2ea42$export$639c83c23c4267cd.STATIC;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC = $0982bf0d3ab2ea42$export$639c83c23c4267cd.KINEMATIC;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.AWAKE = $0982bf0d3ab2ea42$export$39fcd8c83b7ae118.AWAKE;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPY = $0982bf0d3ab2ea42$export$39fcd8c83b7ae118.SLEEPY;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING = $0982bf0d3ab2ea42$export$39fcd8c83b7ae118.SLEEPING;
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.wakeupEvent = {
    type: 'wakeup'
};
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.sleepyEvent = {
    type: 'sleepy'
};
$0982bf0d3ab2ea42$export$4b2c32e08f77ff18.sleepEvent = {
    type: 'sleep'
};
const $0982bf0d3ab2ea42$var$tmpVec = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpQuat = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
const $0982bf0d3ab2ea42$var$updateAABB_shapeAABB = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$uiw_m1 = new $0982bf0d3ab2ea42$export$83f4edd572c84121();
const $0982bf0d3ab2ea42$var$uiw_m2 = new $0982bf0d3ab2ea42$export$83f4edd572c84121();
const $0982bf0d3ab2ea42$var$Body_applyForce_rotForce = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_applyLocalForce_worldForce = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_applyLocalForce_relativePointWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_applyImpulse_velo = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_applyImpulse_rotVelo = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_applyLocalImpulse_worldImpulse = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_applyLocalImpulse_relativePoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Body_updateMassProperties_halfExtents = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Base class for broadphase implementations
 * @author schteppe
 */ class $0982bf0d3ab2ea42$export$b1da34c0243c37ef {
    /**
   * Get the collision pairs from the world
   * @param world The world to search in
   * @param p1 Empty array to be filled with body objects
   * @param p2 Empty array to be filled with body objects
   */ collisionPairs(world, p1, p2) {
        throw new Error('collisionPairs not implemented for this BroadPhase class!');
    }
    /**
   * Check if a body pair needs to be intersection tested at all.
   */ needBroadphaseCollision(bodyA, bodyB) {
        // Check collision filter masks
        if ((bodyA.collisionFilterGroup & bodyB.collisionFilterMask) === 0 || (bodyB.collisionFilterGroup & bodyA.collisionFilterMask) === 0) return false;
         // Check types
        if (((bodyA.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC) !== 0 || bodyA.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) && ((bodyB.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC) !== 0 || bodyB.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING)) // Both bodies are static or sleeping. Skip.
        return false;
        return true;
    }
    /**
   * Check if the bounding volumes of two bodies intersect.
   */ intersectionTest(bodyA, bodyB, pairs1, pairs2) {
        if (this.useBoundingBoxes) this.doBoundingBoxBroadphase(bodyA, bodyB, pairs1, pairs2);
        else this.doBoundingSphereBroadphase(bodyA, bodyB, pairs1, pairs2);
    }
    /**
   * Check if the bounding spheres of two bodies are intersecting.
   * @param pairs1 bodyA is appended to this array if intersection
   * @param pairs2 bodyB is appended to this array if intersection
   */ doBoundingSphereBroadphase(bodyA, bodyB, pairs1, pairs2) {
        const r = $0982bf0d3ab2ea42$var$Broadphase_collisionPairs_r;
        bodyB.position.vsub(bodyA.position, r);
        const boundingRadiusSum2 = (bodyA.boundingRadius + bodyB.boundingRadius) ** 2;
        const norm2 = r.lengthSquared();
        if (norm2 < boundingRadiusSum2) {
            pairs1.push(bodyA);
            pairs2.push(bodyB);
        }
    }
    /**
   * Check if the bounding boxes of two bodies are intersecting.
   */ doBoundingBoxBroadphase(bodyA, bodyB, pairs1, pairs2) {
        if (bodyA.aabbNeedsUpdate) bodyA.updateAABB();
        if (bodyB.aabbNeedsUpdate) bodyB.updateAABB();
         // Check AABB / AABB
        if (bodyA.aabb.overlaps(bodyB.aabb)) {
            pairs1.push(bodyA);
            pairs2.push(bodyB);
        }
    }
    /**
   * Removes duplicate pairs from the pair arrays.
   */ makePairsUnique(pairs1, pairs2) {
        const t = $0982bf0d3ab2ea42$var$Broadphase_makePairsUnique_temp;
        const p1 = $0982bf0d3ab2ea42$var$Broadphase_makePairsUnique_p1;
        const p2 = $0982bf0d3ab2ea42$var$Broadphase_makePairsUnique_p2;
        const N = pairs1.length;
        for(let i = 0; i !== N; i++){
            p1[i] = pairs1[i];
            p2[i] = pairs2[i];
        }
        pairs1.length = 0;
        pairs2.length = 0;
        for(let i = 0; i !== N; i++){
            const id1 = p1[i].id;
            const id2 = p2[i].id;
            const key = id1 < id2 ? id1 + "," + id2 : id2 + "," + id1;
            t[key] = i;
            t.keys.push(key);
        }
        for(let i = 0; i !== t.keys.length; i++){
            const key = t.keys.pop();
            const pairIndex = t[key];
            pairs1.push(p1[pairIndex]);
            pairs2.push(p2[pairIndex]);
            delete t[key];
        }
    }
    /**
   * To be implemented by subcasses
   */ setWorld(world) {}
    /**
   * Check if the bounding spheres of two bodies overlap.
   */ static boundingSphereCheck(bodyA, bodyB) {
        const dist = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // bsc_dist;
        bodyA.position.vsub(bodyB.position, dist);
        const sa = bodyA.shapes[0];
        const sb = bodyB.shapes[0];
        return Math.pow(sa.boundingSphereRadius + sb.boundingSphereRadius, 2) > dist.lengthSquared();
    }
    /**
   * Returns all the bodies within the AABB.
   */ aabbQuery(world, aabb, result) {
        console.warn('.aabbQuery is not implemented in this Broadphase subclass.');
        return [];
    }
    /**
   * The world to search for collisions in.
   */ /**
   * If set to true, the broadphase uses bounding boxes for intersection tests, else it uses bounding spheres.
   */ /**
   * Set to true if the objects in the world moved.
   */ constructor(){
        this.world = void 0;
        this.useBoundingBoxes = void 0;
        this.dirty = void 0;
        this.world = null;
        this.useBoundingBoxes = false;
        this.dirty = true;
    }
} // Temp objects
const $0982bf0d3ab2ea42$var$Broadphase_collisionPairs_r = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Broadphase_makePairsUnique_temp = {
    keys: []
};
const $0982bf0d3ab2ea42$var$Broadphase_makePairsUnique_p1 = [];
const $0982bf0d3ab2ea42$var$Broadphase_makePairsUnique_p2 = [];
/**
 * Axis aligned uniform grid broadphase.
 * @todo Needs support for more than just planes and spheres.
 */ class $0982bf0d3ab2ea42$export$f744f7e6035d0152 extends $0982bf0d3ab2ea42$export$b1da34c0243c37ef {
    /**
   * Get all the collision pairs in the physics world
   */ collisionPairs(world, pairs1, pairs2) {
        const N = world.numObjects();
        const bodies = world.bodies;
        const max = this.aabbMax;
        const min = this.aabbMin;
        const nx = this.nx;
        const ny = this.ny;
        const nz = this.nz;
        const xstep = ny * nz;
        const ystep = nz;
        const zstep = 1;
        const xmax = max.x;
        const ymax = max.y;
        const zmax = max.z;
        const xmin = min.x;
        const ymin = min.y;
        const zmin = min.z;
        const xmult = nx / (xmax - xmin);
        const ymult = ny / (ymax - ymin);
        const zmult = nz / (zmax - zmin);
        const binsizeX = (xmax - xmin) / nx;
        const binsizeY = (ymax - ymin) / ny;
        const binsizeZ = (zmax - zmin) / nz;
        const binRadius = Math.sqrt(binsizeX * binsizeX + binsizeY * binsizeY + binsizeZ * binsizeZ) * 0.5;
        const types = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types;
        const SPHERE = types.SPHERE;
        const PLANE = types.PLANE;
        types.BOX;
        types.COMPOUND;
        types.CONVEXPOLYHEDRON;
        const bins = this.bins;
        const binLengths = this.binLengths;
        const Nbins = this.bins.length; // Reset bins
        for(let i = 0; i !== Nbins; i++)binLengths[i] = 0;
        const ceil = Math.ceil;
        function addBoxToBins(x0, y0, z0, x1, y1, z1, bi) {
            let xoff0 = (x0 - xmin) * xmult | 0;
            let yoff0 = (y0 - ymin) * ymult | 0;
            let zoff0 = (z0 - zmin) * zmult | 0;
            let xoff1 = ceil((x1 - xmin) * xmult);
            let yoff1 = ceil((y1 - ymin) * ymult);
            let zoff1 = ceil((z1 - zmin) * zmult);
            if (xoff0 < 0) xoff0 = 0;
            else if (xoff0 >= nx) xoff0 = nx - 1;
            if (yoff0 < 0) yoff0 = 0;
            else if (yoff0 >= ny) yoff0 = ny - 1;
            if (zoff0 < 0) zoff0 = 0;
            else if (zoff0 >= nz) zoff0 = nz - 1;
            if (xoff1 < 0) xoff1 = 0;
            else if (xoff1 >= nx) xoff1 = nx - 1;
            if (yoff1 < 0) yoff1 = 0;
            else if (yoff1 >= ny) yoff1 = ny - 1;
            if (zoff1 < 0) zoff1 = 0;
            else if (zoff1 >= nz) zoff1 = nz - 1;
            xoff0 *= xstep;
            yoff0 *= ystep;
            zoff0 *= zstep;
            xoff1 *= xstep;
            yoff1 *= ystep;
            zoff1 *= zstep;
            for(let xoff = xoff0; xoff <= xoff1; xoff += xstep){
                for(let yoff = yoff0; yoff <= yoff1; yoff += ystep)for(let zoff = zoff0; zoff <= zoff1; zoff += zstep){
                    const idx = xoff + yoff + zoff;
                    bins[idx][binLengths[idx]++] = bi;
                }
            }
        } // Put all bodies into the bins
        for(let i = 0; i !== N; i++){
            const bi = bodies[i];
            const si = bi.shapes[0];
            switch(si.type){
                case SPHERE:
                    {
                        const shape = si; // Put in bin
                        // check if overlap with other bins
                        const x = bi.position.x;
                        const y = bi.position.y;
                        const z = bi.position.z;
                        const r = shape.radius;
                        addBoxToBins(x - r, y - r, z - r, x + r, y + r, z + r, bi);
                        break;
                    }
                case PLANE:
                    {
                        const shape = si;
                        if (shape.worldNormalNeedsUpdate) shape.computeWorldNormal(bi.quaternion);
                        const planeNormal = shape.worldNormal; //Relative position from origin of plane object to the first bin
                        //Incremented as we iterate through the bins
                        const xreset = xmin + binsizeX * 0.5 - bi.position.x;
                        const yreset = ymin + binsizeY * 0.5 - bi.position.y;
                        const zreset = zmin + binsizeZ * 0.5 - bi.position.z;
                        const d = $0982bf0d3ab2ea42$var$GridBroadphase_collisionPairs_d;
                        d.set(xreset, yreset, zreset);
                        for(let xi = 0, xoff = 0; xi !== nx; xi++, xoff += xstep, d.y = yreset, d.x += binsizeX)for(let yi = 0, yoff = 0; yi !== ny; yi++, yoff += ystep, d.z = zreset, d.y += binsizeY){
                            for(let zi = 0, zoff = 0; zi !== nz; zi++, zoff += zstep, d.z += binsizeZ)if (d.dot(planeNormal) < binRadius) {
                                const idx = xoff + yoff + zoff;
                                bins[idx][binLengths[idx]++] = bi;
                            }
                        }
                        break;
                    }
                default:
                    if (bi.aabbNeedsUpdate) bi.updateAABB();
                    addBoxToBins(bi.aabb.lowerBound.x, bi.aabb.lowerBound.y, bi.aabb.lowerBound.z, bi.aabb.upperBound.x, bi.aabb.upperBound.y, bi.aabb.upperBound.z, bi);
                    break;
            }
        } // Check each bin
        for(let i = 0; i !== Nbins; i++){
            const binLength = binLengths[i]; //Skip bins with no potential collisions
            if (binLength > 1) {
                const bin = bins[i]; // Do N^2 broadphase inside
                for(let xi = 0; xi !== binLength; xi++){
                    const bi = bin[xi];
                    for(let yi = 0; yi !== xi; yi++){
                        const bj = bin[yi];
                        if (this.needBroadphaseCollision(bi, bj)) this.intersectionTest(bi, bj, pairs1, pairs2);
                    }
                }
            }
        } //	for (let zi = 0, zoff=0; zi < nz; zi++, zoff+= zstep) {
        //		console.log("layer "+zi);
        //		for (let yi = 0, yoff=0; yi < ny; yi++, yoff += ystep) {
        //			const row = '';
        //			for (let xi = 0, xoff=0; xi < nx; xi++, xoff += xstep) {
        //				const idx = xoff + yoff + zoff;
        //				row += ' ' + binLengths[idx];
        //			}
        //			console.log(row);
        //		}
        //	}
        this.makePairsUnique(pairs1, pairs2);
    }
    /**
   * Number of boxes along x
   */ /**
   * Number of boxes along y
   */ /**
   * Number of boxes along z
   */ /**
   * aabbMin
   */ /**
   * aabbMax
   */ /**
   * bins
   */ /**
   * binLengths
   */ /**
   * @param nx Number of boxes along x.
   * @param ny Number of boxes along y.
   * @param nz Number of boxes along z.
   */ constructor(aabbMin = new $0982bf0d3ab2ea42$export$838423f3adec30fa(100, 100, 100), aabbMax = new $0982bf0d3ab2ea42$export$838423f3adec30fa(-100, -100, -100), nx = 10, ny = 10, nz = 10){
        super();
        this.nx = void 0;
        this.ny = void 0;
        this.nz = void 0;
        this.aabbMin = void 0;
        this.aabbMax = void 0;
        this.bins = void 0;
        this.binLengths = void 0;
        this.nx = nx;
        this.ny = ny;
        this.nz = nz;
        this.aabbMin = aabbMin;
        this.aabbMax = aabbMax;
        const nbins = this.nx * this.ny * this.nz;
        if (nbins <= 0) throw "GridBroadphase: Each dimension's n must be >0";
        this.bins = [];
        this.binLengths = []; // Rather than continually resizing arrays (thrashing the memory), just record length and allow them to grow
        this.bins.length = nbins;
        this.binLengths.length = nbins;
        for(let i = 0; i < nbins; i++){
            this.bins[i] = [];
            this.binLengths[i] = 0;
        }
    }
}
const $0982bf0d3ab2ea42$var$GridBroadphase_collisionPairs_d = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Naive broadphase implementation, used in lack of better ones.
 *
 * The naive broadphase looks at all possible pairs without restriction, therefore it has complexity N^2 _(which is bad)_
 */ class $0982bf0d3ab2ea42$export$c86abd7a4a88e05e extends $0982bf0d3ab2ea42$export$b1da34c0243c37ef {
    /**
   * Get all the collision pairs in the physics world
   */ collisionPairs(world, pairs1, pairs2) {
        const bodies = world.bodies;
        const n = bodies.length;
        let bi;
        let bj; // Naive N^2 ftw!
        for(let i = 0; i !== n; i++)for(let j = 0; j !== i; j++){
            bi = bodies[i];
            bj = bodies[j];
            if (!this.needBroadphaseCollision(bi, bj)) continue;
            this.intersectionTest(bi, bj, pairs1, pairs2);
        }
    }
    /**
   * Returns all the bodies within an AABB.
   * @param result An array to store resulting bodies in.
   */ aabbQuery(world, aabb, result = []) {
        for(let i = 0; i < world.bodies.length; i++){
            const b = world.bodies[i];
            if (b.aabbNeedsUpdate) b.updateAABB();
             // Ugly hack until Body gets aabb
            if (b.aabb.overlaps(aabb)) result.push(b);
        }
        return result;
    }
    /**
   * @todo Remove useless constructor
   */ constructor(){
        super();
    }
}
/**
 * Storage for Ray casting data
 */ class $0982bf0d3ab2ea42$export$2e8bb24f335362cc {
    /**
   * Reset all result data.
   */ reset() {
        this.rayFromWorld.setZero();
        this.rayToWorld.setZero();
        this.hitNormalWorld.setZero();
        this.hitPointWorld.setZero();
        this.hasHit = false;
        this.shape = null;
        this.body = null;
        this.hitFaceIndex = -1;
        this.distance = -1;
        this.shouldStop = false;
    }
    /**
   * abort
   */ abort() {
        this.shouldStop = true;
    }
    /**
   * Set result data.
   */ set(rayFromWorld, rayToWorld, hitNormalWorld, hitPointWorld, shape, body, distance) {
        this.rayFromWorld.copy(rayFromWorld);
        this.rayToWorld.copy(rayToWorld);
        this.hitNormalWorld.copy(hitNormalWorld);
        this.hitPointWorld.copy(hitPointWorld);
        this.shape = shape;
        this.body = body;
        this.distance = distance;
    }
    /**
   * rayFromWorld
   */ /**
   * rayToWorld
   */ /**
   * hitNormalWorld
   */ /**
   * hitPointWorld
   */ /**
   * hasHit
   */ /**
   * shape
   */ /**
   * body
   */ /**
   * The index of the hit triangle, if the hit shape was a trimesh
   */ /**
   * Distance to the hit. Will be set to -1 if there was no hit
   */ /**
   * If the ray should stop traversing the bodies
   */ constructor(){
        this.rayFromWorld = void 0;
        this.rayToWorld = void 0;
        this.hitNormalWorld = void 0;
        this.hitPointWorld = void 0;
        this.hasHit = void 0;
        this.shape = void 0;
        this.body = void 0;
        this.hitFaceIndex = void 0;
        this.distance = void 0;
        this.shouldStop = void 0;
        this.rayFromWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.rayToWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.hitNormalWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.hitPointWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.hasHit = false;
        this.shape = null;
        this.body = null;
        this.hitFaceIndex = -1;
        this.distance = -1;
        this.shouldStop = false;
    }
}
let $0982bf0d3ab2ea42$var$_Shape$types$SPHERE, $0982bf0d3ab2ea42$var$_Shape$types$PLANE, $0982bf0d3ab2ea42$var$_Shape$types$BOX, $0982bf0d3ab2ea42$var$_Shape$types$CYLINDER, $0982bf0d3ab2ea42$var$_Shape$types$CONVEXPO, $0982bf0d3ab2ea42$var$_Shape$types$HEIGHTFI, $0982bf0d3ab2ea42$var$_Shape$types$TRIMESH;
/**
 * RAY_MODES
 */ const $0982bf0d3ab2ea42$export$aa9a2841d846c8ef = {
    /** CLOSEST */ CLOSEST: 1,
    /** ANY */ ANY: 2,
    /** ALL */ ALL: 4
};
/**
 * RayMode
 */ $0982bf0d3ab2ea42$var$_Shape$types$SPHERE = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE;
$0982bf0d3ab2ea42$var$_Shape$types$PLANE = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE;
$0982bf0d3ab2ea42$var$_Shape$types$BOX = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX;
$0982bf0d3ab2ea42$var$_Shape$types$CYLINDER = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER;
$0982bf0d3ab2ea42$var$_Shape$types$CONVEXPO = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON;
$0982bf0d3ab2ea42$var$_Shape$types$HEIGHTFI = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.HEIGHTFIELD;
$0982bf0d3ab2ea42$var$_Shape$types$TRIMESH = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.TRIMESH;
/**
 * A line in 3D space that intersects bodies and return points.
 */ class $0982bf0d3ab2ea42$export$a186db52eed6d40e {
    /**
   * from
   */ /**
   * to
   */ /**
   * direction
   */ /**
   * The precision of the ray. Used when checking parallelity etc.
   * @default 0.0001
   */ /**
   * Set to `false` if you don't want the Ray to take `collisionResponse` flags into account on bodies and shapes.
   * @default true
   */ /**
   * If set to `true`, the ray skips any hits with normal.dot(rayDirection) < 0.
   * @default false
   */ /**
   * collisionFilterMask
   * @default -1
   */ /**
   * collisionFilterGroup
   * @default -1
   */ /**
   * The intersection mode. Should be Ray.ANY, Ray.ALL or Ray.CLOSEST.
   * @default RAY.ANY
   */ /**
   * Current result object.
   */ /**
   * Will be set to `true` during intersectWorld() if the ray hit anything.
   */ /**
   * User-provided result callback. Will be used if mode is Ray.ALL.
   */ /**
   * CLOSEST
   */ /**
   * ANY
   */ /**
   * ALL
   */ get [$0982bf0d3ab2ea42$var$_Shape$types$SPHERE]() {
        return this._intersectSphere;
    }
    get [$0982bf0d3ab2ea42$var$_Shape$types$PLANE]() {
        return this._intersectPlane;
    }
    get [$0982bf0d3ab2ea42$var$_Shape$types$BOX]() {
        return this._intersectBox;
    }
    get [$0982bf0d3ab2ea42$var$_Shape$types$CYLINDER]() {
        return this._intersectConvex;
    }
    get [$0982bf0d3ab2ea42$var$_Shape$types$CONVEXPO]() {
        return this._intersectConvex;
    }
    get [$0982bf0d3ab2ea42$var$_Shape$types$HEIGHTFI]() {
        return this._intersectHeightfield;
    }
    get [$0982bf0d3ab2ea42$var$_Shape$types$TRIMESH]() {
        return this._intersectTrimesh;
    }
    /**
   * Do itersection against all bodies in the given World.
   * @return True if the ray hit anything, otherwise false.
   */ intersectWorld(world, options) {
        this.mode = options.mode || $0982bf0d3ab2ea42$export$a186db52eed6d40e.ANY;
        this.result = options.result || new $0982bf0d3ab2ea42$export$2e8bb24f335362cc();
        this.skipBackfaces = !!options.skipBackfaces;
        this.collisionFilterMask = typeof options.collisionFilterMask !== 'undefined' ? options.collisionFilterMask : -1;
        this.collisionFilterGroup = typeof options.collisionFilterGroup !== 'undefined' ? options.collisionFilterGroup : -1;
        this.checkCollisionResponse = typeof options.checkCollisionResponse !== 'undefined' ? options.checkCollisionResponse : true;
        if (options.from) this.from.copy(options.from);
        if (options.to) this.to.copy(options.to);
        this.callback = options.callback || (()=>{});
        this.hasHit = false;
        this.result.reset();
        this.updateDirection();
        this.getAABB($0982bf0d3ab2ea42$var$tmpAABB$1);
        $0982bf0d3ab2ea42$var$tmpArray.length = 0;
        world.broadphase.aabbQuery(world, $0982bf0d3ab2ea42$var$tmpAABB$1, $0982bf0d3ab2ea42$var$tmpArray);
        this.intersectBodies($0982bf0d3ab2ea42$var$tmpArray);
        return this.hasHit;
    }
    /**
   * Shoot a ray at a body, get back information about the hit.
   * @deprecated @param result set the result property of the Ray instead.
   */ intersectBody(body, result) {
        if (result) {
            this.result = result;
            this.updateDirection();
        }
        const checkCollisionResponse = this.checkCollisionResponse;
        if (checkCollisionResponse && !body.collisionResponse) return;
        if ((this.collisionFilterGroup & body.collisionFilterMask) === 0 || (body.collisionFilterGroup & this.collisionFilterMask) === 0) return;
        const xi = $0982bf0d3ab2ea42$var$intersectBody_xi;
        const qi = $0982bf0d3ab2ea42$var$intersectBody_qi;
        for(let i = 0, N = body.shapes.length; i < N; i++){
            const shape = body.shapes[i];
            if (checkCollisionResponse && !shape.collisionResponse) continue; // Skip
            body.quaternion.mult(body.shapeOrientations[i], qi);
            body.quaternion.vmult(body.shapeOffsets[i], xi);
            xi.vadd(body.position, xi);
            this.intersectShape(shape, qi, xi, body);
            if (this.result.shouldStop) break;
        }
    }
    /**
   * Shoot a ray at an array bodies, get back information about the hit.
   * @param bodies An array of Body objects.
   * @deprecated @param result set the result property of the Ray instead.
   *
   */ intersectBodies(bodies, result) {
        if (result) {
            this.result = result;
            this.updateDirection();
        }
        for(let i = 0, l = bodies.length; !this.result.shouldStop && i < l; i++)this.intersectBody(bodies[i]);
    }
    /**
   * Updates the direction vector.
   */ updateDirection() {
        this.to.vsub(this.from, this.direction);
        this.direction.normalize();
    }
    intersectShape(shape, quat, position, body) {
        const from = this.from; // Checking boundingSphere
        const distance = $0982bf0d3ab2ea42$var$distanceFromIntersection(from, this.direction, position);
        if (distance > shape.boundingSphereRadius) return;
        const intersectMethod = this[shape.type];
        if (intersectMethod) intersectMethod.call(this, shape, quat, position, body, shape);
    }
    _intersectBox(box, quat, position, body, reportedShape) {
        return this._intersectConvex(box.convexPolyhedronRepresentation, quat, position, body, reportedShape);
    }
    _intersectPlane(shape, quat, position, body, reportedShape) {
        const from = this.from;
        const to = this.to;
        const direction = this.direction; // Get plane normal
        const worldNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 1);
        quat.vmult(worldNormal, worldNormal);
        const len = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        from.vsub(position, len);
        const planeToFrom = len.dot(worldNormal);
        to.vsub(position, len);
        const planeToTo = len.dot(worldNormal);
        if (planeToFrom * planeToTo > 0) // "from" and "to" are on the same side of the plane... bail out
        return;
        if (from.distanceTo(to) < planeToFrom) return;
        const n_dot_dir = worldNormal.dot(direction);
        if (Math.abs(n_dot_dir) < this.precision) // No intersection
        return;
        const planePointToFrom = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const dir_scaled_with_t = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const hitPointWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        from.vsub(position, planePointToFrom);
        const t = -worldNormal.dot(planePointToFrom) / n_dot_dir;
        direction.scale(t, dir_scaled_with_t);
        from.vadd(dir_scaled_with_t, hitPointWorld);
        this.reportIntersection(worldNormal, hitPointWorld, reportedShape, body, -1);
    }
    /**
   * Get the world AABB of the ray.
   */ getAABB(aabb) {
        const { lowerBound: lowerBound, upperBound: upperBound } = aabb;
        const to = this.to;
        const from = this.from;
        lowerBound.x = Math.min(to.x, from.x);
        lowerBound.y = Math.min(to.y, from.y);
        lowerBound.z = Math.min(to.z, from.z);
        upperBound.x = Math.max(to.x, from.x);
        upperBound.y = Math.max(to.y, from.y);
        upperBound.z = Math.max(to.z, from.z);
    }
    _intersectHeightfield(shape, quat, position, body, reportedShape) {
        shape.data;
        shape.elementSize; // Convert the ray to local heightfield coordinates
        const localRay = $0982bf0d3ab2ea42$var$intersectHeightfield_localRay; //new Ray(this.from, this.to);
        localRay.from.copy(this.from);
        localRay.to.copy(this.to);
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(position, quat, localRay.from, localRay.from);
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(position, quat, localRay.to, localRay.to);
        localRay.updateDirection(); // Get the index of the data points to test against
        const index = $0982bf0d3ab2ea42$var$intersectHeightfield_index;
        let iMinX;
        let iMinY;
        let iMaxX;
        let iMaxY; // Set to max
        iMinX = iMinY = 0;
        iMaxX = iMaxY = shape.data.length - 1;
        const aabb = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
        localRay.getAABB(aabb);
        shape.getIndexOfPosition(aabb.lowerBound.x, aabb.lowerBound.y, index, true);
        iMinX = Math.max(iMinX, index[0]);
        iMinY = Math.max(iMinY, index[1]);
        shape.getIndexOfPosition(aabb.upperBound.x, aabb.upperBound.y, index, true);
        iMaxX = Math.min(iMaxX, index[0] + 1);
        iMaxY = Math.min(iMaxY, index[1] + 1);
        for(let i = iMinX; i < iMaxX; i++)for(let j = iMinY; j < iMaxY; j++){
            if (this.result.shouldStop) return;
            shape.getAabbAtIndex(i, j, aabb);
            if (!aabb.overlapsRay(localRay)) continue;
             // Lower triangle
            shape.getConvexTrianglePillar(i, j, false);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(position, quat, shape.pillarOffset, $0982bf0d3ab2ea42$var$worldPillarOffset);
            this._intersectConvex(shape.pillarConvex, quat, $0982bf0d3ab2ea42$var$worldPillarOffset, body, reportedShape, $0982bf0d3ab2ea42$var$intersectConvexOptions);
            if (this.result.shouldStop) return;
             // Upper triangle
            shape.getConvexTrianglePillar(i, j, true);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(position, quat, shape.pillarOffset, $0982bf0d3ab2ea42$var$worldPillarOffset);
            this._intersectConvex(shape.pillarConvex, quat, $0982bf0d3ab2ea42$var$worldPillarOffset, body, reportedShape, $0982bf0d3ab2ea42$var$intersectConvexOptions);
        }
    }
    _intersectSphere(sphere, quat, position, body, reportedShape) {
        const from = this.from;
        const to = this.to;
        const r = sphere.radius;
        const a = (to.x - from.x) ** 2 + (to.y - from.y) ** 2 + (to.z - from.z) ** 2;
        const b = 2 * ((to.x - from.x) * (from.x - position.x) + (to.y - from.y) * (from.y - position.y) + (to.z - from.z) * (from.z - position.z));
        const c = (from.x - position.x) ** 2 + (from.y - position.y) ** 2 + (from.z - position.z) ** 2 - r ** 2;
        const delta = b ** 2 - 4 * a * c;
        const intersectionPoint = $0982bf0d3ab2ea42$var$Ray_intersectSphere_intersectionPoint;
        const normal = $0982bf0d3ab2ea42$var$Ray_intersectSphere_normal;
        if (delta < 0) // No intersection
        return;
        else if (delta === 0) {
            // single intersection point
            from.lerp(to, delta, intersectionPoint);
            intersectionPoint.vsub(position, normal);
            normal.normalize();
            this.reportIntersection(normal, intersectionPoint, reportedShape, body, -1);
        } else {
            const d1 = (-b - Math.sqrt(delta)) / (2 * a);
            const d2 = (-b + Math.sqrt(delta)) / (2 * a);
            if (d1 >= 0 && d1 <= 1) {
                from.lerp(to, d1, intersectionPoint);
                intersectionPoint.vsub(position, normal);
                normal.normalize();
                this.reportIntersection(normal, intersectionPoint, reportedShape, body, -1);
            }
            if (this.result.shouldStop) return;
            if (d2 >= 0 && d2 <= 1) {
                from.lerp(to, d2, intersectionPoint);
                intersectionPoint.vsub(position, normal);
                normal.normalize();
                this.reportIntersection(normal, intersectionPoint, reportedShape, body, -1);
            }
        }
    }
    _intersectConvex(shape, quat, position, body, reportedShape, options) {
        const normal = $0982bf0d3ab2ea42$var$intersectConvex_normal;
        const vector = $0982bf0d3ab2ea42$var$intersectConvex_vector;
        const faceList = options && options.faceList || null; // Checking faces
        const faces = shape.faces;
        const vertices = shape.vertices;
        const normals = shape.faceNormals;
        const direction = this.direction;
        const from = this.from;
        const to = this.to;
        const fromToDistance = from.distanceTo(to);
        const Nfaces = faceList ? faceList.length : faces.length;
        const result = this.result;
        for(let j = 0; !result.shouldStop && j < Nfaces; j++){
            const fi = faceList ? faceList[j] : j;
            const face = faces[fi];
            const faceNormal = normals[fi];
            const q = quat;
            const x = position; // determine if ray intersects the plane of the face
            // note: this works regardless of the direction of the face normal
            // Get plane point in world coordinates...
            vector.copy(vertices[face[0]]);
            q.vmult(vector, vector);
            vector.vadd(x, vector); // ...but make it relative to the ray from. We'll fix this later.
            vector.vsub(from, vector); // Get plane normal
            q.vmult(faceNormal, normal); // If this dot product is negative, we have something interesting
            const dot = direction.dot(normal); // Bail out if ray and plane are parallel
            if (Math.abs(dot) < this.precision) continue;
             // calc distance to plane
            const scalar = normal.dot(vector) / dot; // if negative distance, then plane is behind ray
            if (scalar < 0) continue;
             // if (dot < 0) {
            // Intersection point is from + direction * scalar
            direction.scale(scalar, $0982bf0d3ab2ea42$var$intersectPoint);
            $0982bf0d3ab2ea42$var$intersectPoint.vadd(from, $0982bf0d3ab2ea42$var$intersectPoint); // a is the point we compare points b and c with.
            $0982bf0d3ab2ea42$var$a.copy(vertices[face[0]]);
            q.vmult($0982bf0d3ab2ea42$var$a, $0982bf0d3ab2ea42$var$a);
            x.vadd($0982bf0d3ab2ea42$var$a, $0982bf0d3ab2ea42$var$a);
            for(let i = 1; !result.shouldStop && i < face.length - 1; i++){
                // Transform 3 vertices to world coords
                $0982bf0d3ab2ea42$var$b.copy(vertices[face[i]]);
                $0982bf0d3ab2ea42$var$c.copy(vertices[face[i + 1]]);
                q.vmult($0982bf0d3ab2ea42$var$b, $0982bf0d3ab2ea42$var$b);
                q.vmult($0982bf0d3ab2ea42$var$c, $0982bf0d3ab2ea42$var$c);
                x.vadd($0982bf0d3ab2ea42$var$b, $0982bf0d3ab2ea42$var$b);
                x.vadd($0982bf0d3ab2ea42$var$c, $0982bf0d3ab2ea42$var$c);
                const distance = $0982bf0d3ab2ea42$var$intersectPoint.distanceTo(from);
                if (!($0982bf0d3ab2ea42$export$a186db52eed6d40e.pointInTriangle($0982bf0d3ab2ea42$var$intersectPoint, $0982bf0d3ab2ea42$var$a, $0982bf0d3ab2ea42$var$b, $0982bf0d3ab2ea42$var$c) || $0982bf0d3ab2ea42$export$a186db52eed6d40e.pointInTriangle($0982bf0d3ab2ea42$var$intersectPoint, $0982bf0d3ab2ea42$var$b, $0982bf0d3ab2ea42$var$a, $0982bf0d3ab2ea42$var$c)) || distance > fromToDistance) continue;
                this.reportIntersection(normal, $0982bf0d3ab2ea42$var$intersectPoint, reportedShape, body, fi);
            } // }
        }
    }
    /**
   * @todo Optimize by transforming the world to local space first.
   * @todo Use Octree lookup
   */ _intersectTrimesh(mesh, quat, position, body, reportedShape, options) {
        const normal = $0982bf0d3ab2ea42$var$intersectTrimesh_normal;
        const triangles = $0982bf0d3ab2ea42$var$intersectTrimesh_triangles;
        const treeTransform = $0982bf0d3ab2ea42$var$intersectTrimesh_treeTransform;
        const vector = $0982bf0d3ab2ea42$var$intersectConvex_vector;
        const localDirection = $0982bf0d3ab2ea42$var$intersectTrimesh_localDirection;
        const localFrom = $0982bf0d3ab2ea42$var$intersectTrimesh_localFrom;
        const localTo = $0982bf0d3ab2ea42$var$intersectTrimesh_localTo;
        const worldIntersectPoint = $0982bf0d3ab2ea42$var$intersectTrimesh_worldIntersectPoint;
        const worldNormal = $0982bf0d3ab2ea42$var$intersectTrimesh_worldNormal; // Checking faces
        const indices = mesh.indices;
        mesh.vertices; // const normals = mesh.faceNormals
        const from = this.from;
        const to = this.to;
        const direction = this.direction;
        treeTransform.position.copy(position);
        treeTransform.quaternion.copy(quat); // Transform ray to local space!
        $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToLocalFrame(position, quat, direction, localDirection);
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(position, quat, from, localFrom);
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(position, quat, to, localTo);
        localTo.x *= mesh.scale.x;
        localTo.y *= mesh.scale.y;
        localTo.z *= mesh.scale.z;
        localFrom.x *= mesh.scale.x;
        localFrom.y *= mesh.scale.y;
        localFrom.z *= mesh.scale.z;
        localTo.vsub(localFrom, localDirection);
        localDirection.normalize();
        const fromToDistanceSquared = localFrom.distanceSquared(localTo);
        mesh.tree.rayQuery(this, treeTransform, triangles);
        for(let i = 0, N = triangles.length; !this.result.shouldStop && i !== N; i++){
            const trianglesIndex = triangles[i];
            mesh.getNormal(trianglesIndex, normal); // determine if ray intersects the plane of the face
            // note: this works regardless of the direction of the face normal
            // Get plane point in world coordinates...
            mesh.getVertex(indices[trianglesIndex * 3], $0982bf0d3ab2ea42$var$a); // ...but make it relative to the ray from. We'll fix this later.
            $0982bf0d3ab2ea42$var$a.vsub(localFrom, vector); // If this dot product is negative, we have something interesting
            const dot = localDirection.dot(normal); // Bail out if ray and plane are parallel
            // if (Math.abs( dot ) < this.precision){
            //     continue;
            // }
            // calc distance to plane
            const scalar = normal.dot(vector) / dot; // if negative distance, then plane is behind ray
            if (scalar < 0) continue;
             // Intersection point is from + direction * scalar
            localDirection.scale(scalar, $0982bf0d3ab2ea42$var$intersectPoint);
            $0982bf0d3ab2ea42$var$intersectPoint.vadd(localFrom, $0982bf0d3ab2ea42$var$intersectPoint); // Get triangle vertices
            mesh.getVertex(indices[trianglesIndex * 3 + 1], $0982bf0d3ab2ea42$var$b);
            mesh.getVertex(indices[trianglesIndex * 3 + 2], $0982bf0d3ab2ea42$var$c);
            const squaredDistance = $0982bf0d3ab2ea42$var$intersectPoint.distanceSquared(localFrom);
            if (!($0982bf0d3ab2ea42$export$a186db52eed6d40e.pointInTriangle($0982bf0d3ab2ea42$var$intersectPoint, $0982bf0d3ab2ea42$var$b, $0982bf0d3ab2ea42$var$a, $0982bf0d3ab2ea42$var$c) || $0982bf0d3ab2ea42$export$a186db52eed6d40e.pointInTriangle($0982bf0d3ab2ea42$var$intersectPoint, $0982bf0d3ab2ea42$var$a, $0982bf0d3ab2ea42$var$b, $0982bf0d3ab2ea42$var$c)) || squaredDistance > fromToDistanceSquared) continue;
             // transform intersectpoint and normal to world
            $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToWorldFrame(quat, normal, worldNormal);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(position, quat, $0982bf0d3ab2ea42$var$intersectPoint, worldIntersectPoint);
            this.reportIntersection(worldNormal, worldIntersectPoint, reportedShape, body, trianglesIndex);
        }
        triangles.length = 0;
    }
    /**
   * @return True if the intersections should continue
   */ reportIntersection(normal, hitPointWorld, shape, body, hitFaceIndex) {
        const from = this.from;
        const to = this.to;
        const distance = from.distanceTo(hitPointWorld);
        const result = this.result; // Skip back faces?
        if (this.skipBackfaces && normal.dot(this.direction) > 0) return;
        result.hitFaceIndex = typeof hitFaceIndex !== 'undefined' ? hitFaceIndex : -1;
        switch(this.mode){
            case $0982bf0d3ab2ea42$export$a186db52eed6d40e.ALL:
                this.hasHit = true;
                result.set(from, to, normal, hitPointWorld, shape, body, distance);
                result.hasHit = true;
                this.callback(result);
                break;
            case $0982bf0d3ab2ea42$export$a186db52eed6d40e.CLOSEST:
                // Store if closer than current closest
                if (distance < result.distance || !result.hasHit) {
                    this.hasHit = true;
                    result.hasHit = true;
                    result.set(from, to, normal, hitPointWorld, shape, body, distance);
                }
                break;
            case $0982bf0d3ab2ea42$export$a186db52eed6d40e.ANY:
                // Report and stop.
                this.hasHit = true;
                result.hasHit = true;
                result.set(from, to, normal, hitPointWorld, shape, body, distance);
                result.shouldStop = true;
                break;
        }
    }
    /**
   * As per "Barycentric Technique" as named
   * {@link https://www.blackpawn.com/texts/pointinpoly/default.html here} but without the division
   */ static pointInTriangle(p, a, b, c) {
        c.vsub(a, $0982bf0d3ab2ea42$var$v0);
        b.vsub(a, $0982bf0d3ab2ea42$var$v1);
        p.vsub(a, $0982bf0d3ab2ea42$var$v2);
        const dot00 = $0982bf0d3ab2ea42$var$v0.dot($0982bf0d3ab2ea42$var$v0);
        const dot01 = $0982bf0d3ab2ea42$var$v0.dot($0982bf0d3ab2ea42$var$v1);
        const dot02 = $0982bf0d3ab2ea42$var$v0.dot($0982bf0d3ab2ea42$var$v2);
        const dot11 = $0982bf0d3ab2ea42$var$v1.dot($0982bf0d3ab2ea42$var$v1);
        const dot12 = $0982bf0d3ab2ea42$var$v1.dot($0982bf0d3ab2ea42$var$v2);
        let u;
        let v;
        return (u = dot11 * dot02 - dot01 * dot12) >= 0 && (v = dot00 * dot12 - dot01 * dot02) >= 0 && u + v < dot00 * dot11 - dot01 * dot01;
    }
    constructor(from = new $0982bf0d3ab2ea42$export$838423f3adec30fa(), to = new $0982bf0d3ab2ea42$export$838423f3adec30fa()){
        this.from = void 0;
        this.to = void 0;
        this.direction = void 0;
        this.precision = void 0;
        this.checkCollisionResponse = void 0;
        this.skipBackfaces = void 0;
        this.collisionFilterMask = void 0;
        this.collisionFilterGroup = void 0;
        this.mode = void 0;
        this.result = void 0;
        this.hasHit = void 0;
        this.callback = void 0;
        this.from = from.clone();
        this.to = to.clone();
        this.direction = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.precision = 0.0001;
        this.checkCollisionResponse = true;
        this.skipBackfaces = false;
        this.collisionFilterMask = -1;
        this.collisionFilterGroup = -1;
        this.mode = $0982bf0d3ab2ea42$export$a186db52eed6d40e.ANY;
        this.result = new $0982bf0d3ab2ea42$export$2e8bb24f335362cc();
        this.hasHit = false;
        this.callback = (result)=>{};
    }
}
$0982bf0d3ab2ea42$export$a186db52eed6d40e.CLOSEST = $0982bf0d3ab2ea42$export$aa9a2841d846c8ef.CLOSEST;
$0982bf0d3ab2ea42$export$a186db52eed6d40e.ANY = $0982bf0d3ab2ea42$export$aa9a2841d846c8ef.ANY;
$0982bf0d3ab2ea42$export$a186db52eed6d40e.ALL = $0982bf0d3ab2ea42$export$aa9a2841d846c8ef.ALL;
const $0982bf0d3ab2ea42$var$tmpAABB$1 = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$tmpArray = [];
const $0982bf0d3ab2ea42$var$v1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$v2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectBody_xi = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectBody_qi = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
const $0982bf0d3ab2ea42$var$intersectPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$a = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$b = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$c = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectConvexOptions = {
    faceList: [
        0
    ]
};
const $0982bf0d3ab2ea42$var$worldPillarOffset = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectHeightfield_localRay = new $0982bf0d3ab2ea42$export$a186db52eed6d40e();
const $0982bf0d3ab2ea42$var$intersectHeightfield_index = [];
const $0982bf0d3ab2ea42$var$Ray_intersectSphere_intersectionPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$Ray_intersectSphere_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectConvex_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectConvex_vector = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_localDirection = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_localFrom = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_localTo = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_worldNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_worldIntersectPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$intersectTrimesh_triangles = [];
const $0982bf0d3ab2ea42$var$intersectTrimesh_treeTransform = new $0982bf0d3ab2ea42$export$563a914cafbdc389();
const $0982bf0d3ab2ea42$var$v0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$intersect = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
function $0982bf0d3ab2ea42$var$distanceFromIntersection(from, direction, position) {
    // v0 is vector from from to position
    position.vsub(from, $0982bf0d3ab2ea42$var$v0);
    const dot = $0982bf0d3ab2ea42$var$v0.dot(direction); // intersect = direction*dot + from
    direction.scale(dot, $0982bf0d3ab2ea42$var$intersect);
    $0982bf0d3ab2ea42$var$intersect.vadd(from, $0982bf0d3ab2ea42$var$intersect);
    const distance = position.distanceTo($0982bf0d3ab2ea42$var$intersect);
    return distance;
}
/**
 * Sweep and prune broadphase along one axis.
 */ class $0982bf0d3ab2ea42$export$3486ef600d4ebe6d extends $0982bf0d3ab2ea42$export$b1da34c0243c37ef {
    /**
   * List of bodies currently in the broadphase.
   */ /**
   * The world to search in.
   */ /**
   * Axis to sort the bodies along.
   * Set to 0 for x axis, and 1 for y axis.
   * For best performance, pick the axis where bodies are most distributed.
   */ /**
   * Check if the bounds of two bodies overlap, along the given SAP axis.
   */ static checkBounds(bi, bj, axisIndex) {
        let biPos;
        let bjPos;
        if (axisIndex === 0) {
            biPos = bi.position.x;
            bjPos = bj.position.x;
        } else if (axisIndex === 1) {
            biPos = bi.position.y;
            bjPos = bj.position.y;
        } else if (axisIndex === 2) {
            biPos = bi.position.z;
            bjPos = bj.position.z;
        }
        const ri = bi.boundingRadius, rj = bj.boundingRadius, boundA2 = biPos + ri, boundB1 = bjPos - rj;
        return boundB1 < boundA2;
    }
    /**
   * insertionSortX
   */ static insertionSortX(a) {
        for(let i = 1, l = a.length; i < l; i++){
            const v = a[i];
            let j;
            for(j = i - 1; j >= 0; j--){
                if (a[j].aabb.lowerBound.x <= v.aabb.lowerBound.x) break;
                a[j + 1] = a[j];
            }
            a[j + 1] = v;
        }
        return a;
    }
    /**
   * insertionSortY
   */ static insertionSortY(a) {
        for(let i = 1, l = a.length; i < l; i++){
            const v = a[i];
            let j;
            for(j = i - 1; j >= 0; j--){
                if (a[j].aabb.lowerBound.y <= v.aabb.lowerBound.y) break;
                a[j + 1] = a[j];
            }
            a[j + 1] = v;
        }
        return a;
    }
    /**
   * insertionSortZ
   */ static insertionSortZ(a) {
        for(let i = 1, l = a.length; i < l; i++){
            const v = a[i];
            let j;
            for(j = i - 1; j >= 0; j--){
                if (a[j].aabb.lowerBound.z <= v.aabb.lowerBound.z) break;
                a[j + 1] = a[j];
            }
            a[j + 1] = v;
        }
        return a;
    }
    /**
   * Change the world
   */ setWorld(world) {
        // Clear the old axis array
        this.axisList.length = 0; // Add all bodies from the new world
        for(let i = 0; i < world.bodies.length; i++)this.axisList.push(world.bodies[i]);
         // Remove old handlers, if any
        world.removeEventListener('addBody', this._addBodyHandler);
        world.removeEventListener('removeBody', this._removeBodyHandler); // Add handlers to update the list of bodies.
        world.addEventListener('addBody', this._addBodyHandler);
        world.addEventListener('removeBody', this._removeBodyHandler);
        this.world = world;
        this.dirty = true;
    }
    /**
   * Collect all collision pairs
   */ collisionPairs(world, p1, p2) {
        const bodies = this.axisList;
        const N = bodies.length;
        const axisIndex = this.axisIndex;
        let i;
        let j;
        if (this.dirty) {
            this.sortList();
            this.dirty = false;
        } // Look through the list
        for(i = 0; i !== N; i++){
            const bi = bodies[i];
            for(j = i + 1; j < N; j++){
                const bj = bodies[j];
                if (!this.needBroadphaseCollision(bi, bj)) continue;
                if (!$0982bf0d3ab2ea42$export$3486ef600d4ebe6d.checkBounds(bi, bj, axisIndex)) break;
                this.intersectionTest(bi, bj, p1, p2);
            }
        }
    }
    sortList() {
        const axisList = this.axisList;
        const axisIndex = this.axisIndex;
        const N = axisList.length; // Update AABBs
        for(let i = 0; i !== N; i++){
            const bi = axisList[i];
            if (bi.aabbNeedsUpdate) bi.updateAABB();
        } // Sort the list
        if (axisIndex === 0) $0982bf0d3ab2ea42$export$3486ef600d4ebe6d.insertionSortX(axisList);
        else if (axisIndex === 1) $0982bf0d3ab2ea42$export$3486ef600d4ebe6d.insertionSortY(axisList);
        else if (axisIndex === 2) $0982bf0d3ab2ea42$export$3486ef600d4ebe6d.insertionSortZ(axisList);
    }
    /**
   * Computes the variance of the body positions and estimates the best axis to use.
   * Will automatically set property `axisIndex`.
   */ autoDetectAxis() {
        let sumX = 0;
        let sumX2 = 0;
        let sumY = 0;
        let sumY2 = 0;
        let sumZ = 0;
        let sumZ2 = 0;
        const bodies = this.axisList;
        const N = bodies.length;
        const invN = 1 / N;
        for(let i = 0; i !== N; i++){
            const b = bodies[i];
            const centerX = b.position.x;
            sumX += centerX;
            sumX2 += centerX * centerX;
            const centerY = b.position.y;
            sumY += centerY;
            sumY2 += centerY * centerY;
            const centerZ = b.position.z;
            sumZ += centerZ;
            sumZ2 += centerZ * centerZ;
        }
        const varianceX = sumX2 - sumX * sumX * invN;
        const varianceY = sumY2 - sumY * sumY * invN;
        const varianceZ = sumZ2 - sumZ * sumZ * invN;
        if (varianceX > varianceY) {
            if (varianceX > varianceZ) this.axisIndex = 0;
            else this.axisIndex = 2;
        } else if (varianceY > varianceZ) this.axisIndex = 1;
        else this.axisIndex = 2;
    }
    /**
   * Returns all the bodies within an AABB.
   * @param result An array to store resulting bodies in.
   */ aabbQuery(world, aabb, result = []) {
        if (this.dirty) {
            this.sortList();
            this.dirty = false;
        }
        const axisIndex = this.axisIndex;
        let axis = 'x';
        if (axisIndex === 1) axis = 'y';
        if (axisIndex === 2) axis = 'z';
        const axisList = this.axisList;
        aabb.lowerBound[axis];
        aabb.upperBound[axis];
        for(let i = 0; i < axisList.length; i++){
            const b = axisList[i];
            if (b.aabbNeedsUpdate) b.updateAABB();
            if (b.aabb.overlaps(aabb)) result.push(b);
        }
        return result;
    }
    constructor(world){
        super();
        this.axisList = void 0;
        this.world = void 0;
        this.axisIndex = void 0;
        this._addBodyHandler = void 0;
        this._removeBodyHandler = void 0;
        this.axisList = [];
        this.world = null;
        this.axisIndex = 0;
        const axisList = this.axisList;
        this._addBodyHandler = (event)=>{
            axisList.push(event.body);
        };
        this._removeBodyHandler = (event)=>{
            const idx = axisList.indexOf(event.body);
            if (idx !== -1) axisList.splice(idx, 1);
        };
        if (world) this.setWorld(world);
    }
}
class $0982bf0d3ab2ea42$var$Utils {
    /**
   * Extend an options object with default values.
   * @param options The options object. May be falsy: in this case, a new object is created and returned.
   * @param defaults An object containing default values.
   * @return The modified options object.
   */ static defaults(options = {}, defaults) {
        for(let key in defaults)if (!(key in options)) options[key] = defaults[key];
        return options;
    }
}
/**
 * Constraint base class
 */ class $0982bf0d3ab2ea42$export$aec1359a0a40a615 {
    /**
   * Update all the equations with data.
   */ update() {
        throw new Error('method update() not implmemented in this Constraint subclass!');
    }
    /**
   * Enables all equations in the constraint.
   */ enable() {
        const eqs = this.equations;
        for(let i = 0; i < eqs.length; i++)eqs[i].enabled = true;
    }
    /**
   * Disables all equations in the constraint.
   */ disable() {
        const eqs = this.equations;
        for(let i = 0; i < eqs.length; i++)eqs[i].enabled = false;
    }
    /**
   * Equations to be solved in this constraint.
   */ /**
   * Body A.
   */ /**
   * Body B.
   */ /**
   * Set to false if you don't want the bodies to collide when they are connected.
   */ constructor(bodyA, bodyB, options = {}){
        this.equations = void 0;
        this.bodyA = void 0;
        this.bodyB = void 0;
        this.id = void 0;
        this.collideConnected = void 0;
        options = $0982bf0d3ab2ea42$var$Utils.defaults(options, {
            collideConnected: true,
            wakeUpBodies: true
        });
        this.equations = [];
        this.bodyA = bodyA;
        this.bodyB = bodyB;
        this.id = $0982bf0d3ab2ea42$export$aec1359a0a40a615.idCounter++;
        this.collideConnected = options.collideConnected;
        if (options.wakeUpBodies) {
            if (bodyA) bodyA.wakeUp();
            if (bodyB) bodyB.wakeUp();
        }
    }
}
$0982bf0d3ab2ea42$export$aec1359a0a40a615.idCounter = 0;
/**
 * An element containing 6 entries, 3 spatial and 3 rotational degrees of freedom.
 */ class $0982bf0d3ab2ea42$export$429232140b5adba6 {
    /**
   * Multiply with other JacobianElement
   */ multiplyElement(element) {
        return element.spatial.dot(this.spatial) + element.rotational.dot(this.rotational);
    }
    /**
   * Multiply with two vectors
   */ multiplyVectors(spatial, rotational) {
        return spatial.dot(this.spatial) + rotational.dot(this.rotational);
    }
    /**
   * spatial
   */ /**
   * rotational
   */ constructor(){
        this.spatial = void 0;
        this.rotational = void 0;
        this.spatial = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.rotational = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
    }
}
/**
 * Equation base class.
 *
 * `a`, `b` and `eps` are {@link https://www8.cs.umu.se/kurser/5DV058/VT15/lectures/SPOOKlabnotes.pdf SPOOK} parameters that default to `0.0`. See {@link https://github.com/schteppe/cannon.js/issues/238#issuecomment-147172327 this exchange} for more details on Cannon's physics implementation.
 */ class $0982bf0d3ab2ea42$export$9e6be560da9da590 {
    /**
   * Recalculates a, b, and eps.
   *
   * The Equation constructor sets typical SPOOK parameters as such:
   * * `stiffness` = 1e7
   * * `relaxation` = 4
   * * `timeStep`= 1 / 60, _note the hardcoded refresh rate._
   */ setSpookParams(stiffness, relaxation, timeStep) {
        const d = relaxation;
        const k = stiffness;
        const h = timeStep;
        this.a = 4.0 / (h * (1 + 4 * d));
        this.b = 4.0 * d / (1 + 4 * d);
        this.eps = 4.0 / (h * h * k * (1 + 4 * d));
    }
    /**
   * Computes the right hand side of the SPOOK equation
   */ computeB(a, b, h) {
        const GW = this.computeGW();
        const Gq = this.computeGq();
        const GiMf = this.computeGiMf();
        return -Gq * a - GW * b - GiMf * h;
    }
    /**
   * Computes G*q, where q are the generalized body coordinates
   */ computeGq() {
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const bi = this.bi;
        const bj = this.bj;
        const xi = bi.position;
        const xj = bj.position;
        return GA.spatial.dot(xi) + GB.spatial.dot(xj);
    }
    /**
   * Computes G*W, where W are the body velocities
   */ computeGW() {
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const bi = this.bi;
        const bj = this.bj;
        const vi = bi.velocity;
        const vj = bj.velocity;
        const wi = bi.angularVelocity;
        const wj = bj.angularVelocity;
        return GA.multiplyVectors(vi, wi) + GB.multiplyVectors(vj, wj);
    }
    /**
   * Computes G*Wlambda, where W are the body velocities
   */ computeGWlambda() {
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const bi = this.bi;
        const bj = this.bj;
        const vi = bi.vlambda;
        const vj = bj.vlambda;
        const wi = bi.wlambda;
        const wj = bj.wlambda;
        return GA.multiplyVectors(vi, wi) + GB.multiplyVectors(vj, wj);
    }
    /**
   * Computes G*inv(M)*f, where M is the mass matrix with diagonal blocks for each body, and f are the forces on the bodies.
   */ computeGiMf() {
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const bi = this.bi;
        const bj = this.bj;
        const fi = bi.force;
        const ti = bi.torque;
        const fj = bj.force;
        const tj = bj.torque;
        const invMassi = bi.invMassSolve;
        const invMassj = bj.invMassSolve;
        fi.scale(invMassi, $0982bf0d3ab2ea42$var$iMfi);
        fj.scale(invMassj, $0982bf0d3ab2ea42$var$iMfj);
        bi.invInertiaWorldSolve.vmult(ti, $0982bf0d3ab2ea42$var$invIi_vmult_taui);
        bj.invInertiaWorldSolve.vmult(tj, $0982bf0d3ab2ea42$var$invIj_vmult_tauj);
        return GA.multiplyVectors($0982bf0d3ab2ea42$var$iMfi, $0982bf0d3ab2ea42$var$invIi_vmult_taui) + GB.multiplyVectors($0982bf0d3ab2ea42$var$iMfj, $0982bf0d3ab2ea42$var$invIj_vmult_tauj);
    }
    /**
   * Computes G*inv(M)*G'
   */ computeGiMGt() {
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const bi = this.bi;
        const bj = this.bj;
        const invMassi = bi.invMassSolve;
        const invMassj = bj.invMassSolve;
        const invIi = bi.invInertiaWorldSolve;
        const invIj = bj.invInertiaWorldSolve;
        let result = invMassi + invMassj;
        invIi.vmult(GA.rotational, $0982bf0d3ab2ea42$var$tmp);
        result += $0982bf0d3ab2ea42$var$tmp.dot(GA.rotational);
        invIj.vmult(GB.rotational, $0982bf0d3ab2ea42$var$tmp);
        result += $0982bf0d3ab2ea42$var$tmp.dot(GB.rotational);
        return result;
    }
    /**
   * Add constraint velocity to the bodies.
   */ addToWlambda(deltalambda) {
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const bi = this.bi;
        const bj = this.bj;
        const temp = $0982bf0d3ab2ea42$var$addToWlambda_temp; // Add to linear velocity
        // v_lambda += inv(M) * delta_lamba * G
        bi.vlambda.addScaledVector(bi.invMassSolve * deltalambda, GA.spatial, bi.vlambda);
        bj.vlambda.addScaledVector(bj.invMassSolve * deltalambda, GB.spatial, bj.vlambda); // Add to angular velocity
        bi.invInertiaWorldSolve.vmult(GA.rotational, temp);
        bi.wlambda.addScaledVector(deltalambda, temp, bi.wlambda);
        bj.invInertiaWorldSolve.vmult(GB.rotational, temp);
        bj.wlambda.addScaledVector(deltalambda, temp, bj.wlambda);
    }
    /**
   * Compute the denominator part of the SPOOK equation: C = G*inv(M)*G' + eps
   */ computeC() {
        return this.computeGiMGt() + this.eps;
    }
    /**
   * Minimum (read: negative max) force to be applied by the constraint.
   */ /**
   * Maximum (read: positive max) force to be applied by the constraint.
   */ /**
   * SPOOK parameter
   */ /**
   * SPOOK parameter
   */ /**
   * SPOOK parameter
   */ /**
   * A number, proportional to the force added to the bodies.
   */ constructor(bi, bj, minForce = -1000000, maxForce = 1e6){
        this.id = void 0;
        this.minForce = void 0;
        this.maxForce = void 0;
        this.bi = void 0;
        this.bj = void 0;
        this.si = void 0;
        this.sj = void 0;
        this.a = void 0;
        this.b = void 0;
        this.eps = void 0;
        this.jacobianElementA = void 0;
        this.jacobianElementB = void 0;
        this.enabled = void 0;
        this.multiplier = void 0;
        this.id = $0982bf0d3ab2ea42$export$9e6be560da9da590.idCounter++;
        this.minForce = minForce;
        this.maxForce = maxForce;
        this.bi = bi;
        this.bj = bj;
        this.a = 0.0; // SPOOK parameter
        this.b = 0.0; // SPOOK parameter
        this.eps = 0.0; // SPOOK parameter
        this.jacobianElementA = new $0982bf0d3ab2ea42$export$429232140b5adba6();
        this.jacobianElementB = new $0982bf0d3ab2ea42$export$429232140b5adba6();
        this.enabled = true;
        this.multiplier = 0;
        this.setSpookParams(1e7, 4, 1 / 60); // Set typical spook params
    }
}
$0982bf0d3ab2ea42$export$9e6be560da9da590.idCounter = 0;
const $0982bf0d3ab2ea42$var$iMfi = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$iMfj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$invIi_vmult_taui = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$invIj_vmult_tauj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmp = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$addToWlambda_temp = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Contact/non-penetration constraint equation
 */ class $0982bf0d3ab2ea42$export$9197d1b6f1213c3 extends $0982bf0d3ab2ea42$export$9e6be560da9da590 {
    computeB(h) {
        const a = this.a;
        const b = this.b;
        const bi = this.bi;
        const bj = this.bj;
        const ri = this.ri;
        const rj = this.rj;
        const rixn = $0982bf0d3ab2ea42$var$ContactEquation_computeB_temp1;
        const rjxn = $0982bf0d3ab2ea42$var$ContactEquation_computeB_temp2;
        const vi = bi.velocity;
        const wi = bi.angularVelocity;
        bi.force;
        bi.torque;
        const vj = bj.velocity;
        const wj = bj.angularVelocity;
        bj.force;
        bj.torque;
        const penetrationVec = $0982bf0d3ab2ea42$var$ContactEquation_computeB_temp3;
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        const n = this.ni; // Caluclate cross products
        ri.cross(n, rixn);
        rj.cross(n, rjxn); // g = xj+rj -(xi+ri)
        // G = [ -ni  -rixn  ni  rjxn ]
        n.negate(GA.spatial);
        rixn.negate(GA.rotational);
        GB.spatial.copy(n);
        GB.rotational.copy(rjxn); // Calculate the penetration vector
        penetrationVec.copy(bj.position);
        penetrationVec.vadd(rj, penetrationVec);
        penetrationVec.vsub(bi.position, penetrationVec);
        penetrationVec.vsub(ri, penetrationVec);
        const g = n.dot(penetrationVec); // Compute iteration
        const ePlusOne = this.restitution + 1;
        const GW = ePlusOne * vj.dot(n) - ePlusOne * vi.dot(n) + wj.dot(rjxn) - wi.dot(rixn);
        const GiMf = this.computeGiMf();
        const B = -g * a - GW * b - h * GiMf;
        return B;
    }
    /**
   * Get the current relative velocity in the contact point.
   */ getImpactVelocityAlongNormal() {
        const vi = $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_vi;
        const vj = $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_vj;
        const xi = $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_xi;
        const xj = $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_xj;
        const relVel = $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_relVel;
        this.bi.position.vadd(this.ri, xi);
        this.bj.position.vadd(this.rj, xj);
        this.bi.getVelocityAtWorldPoint(xi, vi);
        this.bj.getVelocityAtWorldPoint(xj, vj);
        vi.vsub(vj, relVel);
        return this.ni.dot(relVel);
    }
    /**
   * "bounciness": u1 = -e*u0
   */ /**
   * World-oriented vector that goes from the center of bi to the contact point.
   */ /**
   * World-oriented vector that starts in body j position and goes to the contact point.
   */ /**
   * Contact normal, pointing out of body i.
   */ constructor(bodyA, bodyB, maxForce = 1e6){
        super(bodyA, bodyB, 0, maxForce);
        this.restitution = void 0;
        this.ri = void 0;
        this.rj = void 0;
        this.ni = void 0;
        this.restitution = 0.0;
        this.ri = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.rj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.ni = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
    }
}
const $0982bf0d3ab2ea42$var$ContactEquation_computeB_temp1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // Temp vectors
const $0982bf0d3ab2ea42$var$ContactEquation_computeB_temp2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ContactEquation_computeB_temp3 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_vi = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_vj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_xi = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_xj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ContactEquation_getImpactVelocityAlongNormal_relVel = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Connects two bodies at given offset points.
 * @example
 *     const bodyA = new Body({ mass: 1 })
 *     const bodyB = new Body({ mass: 1 })
 *     bodyA.position.set(-1, 0, 0)
 *     bodyB.position.set(1, 0, 0)
 *     bodyA.addShape(shapeA)
 *     bodyB.addShape(shapeB)
 *     world.addBody(bodyA)
 *     world.addBody(bodyB)
 *     const localPivotA = new Vec3(1, 0, 0)
 *     const localPivotB = new Vec3(-1, 0, 0)
 *     const constraint = new PointToPointConstraint(bodyA, localPivotA, bodyB, localPivotB)
 *     world.addConstraint(constraint)
 */ class $0982bf0d3ab2ea42$export$1966541426b45787 extends $0982bf0d3ab2ea42$export$aec1359a0a40a615 {
    update() {
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        const x = this.equationX;
        const y = this.equationY;
        const z = this.equationZ; // Rotate the pivots to world space
        bodyA.quaternion.vmult(this.pivotA, x.ri);
        bodyB.quaternion.vmult(this.pivotB, x.rj);
        y.ri.copy(x.ri);
        y.rj.copy(x.rj);
        z.ri.copy(x.ri);
        z.rj.copy(x.rj);
    }
    /**
   * Pivot, defined locally in bodyA.
   */ /**
   * Pivot, defined locally in bodyB.
   */ /**
   * @param pivotA The point relative to the center of mass of bodyA which bodyA is constrained to.
   * @param bodyB Body that will be constrained in a similar way to the same point as bodyA. We will therefore get a link between bodyA and bodyB. If not specified, bodyA will be constrained to a static point.
   * @param pivotB The point relative to the center of mass of bodyB which bodyB is constrained to.
   * @param maxForce The maximum force that should be applied to constrain the bodies.
   */ constructor(bodyA, pivotA = new $0982bf0d3ab2ea42$export$838423f3adec30fa(), bodyB, pivotB = new $0982bf0d3ab2ea42$export$838423f3adec30fa(), maxForce = 1e6){
        super(bodyA, bodyB);
        this.pivotA = void 0;
        this.pivotB = void 0;
        this.equationX = void 0;
        this.equationY = void 0;
        this.equationZ = void 0;
        this.pivotA = pivotA.clone();
        this.pivotB = pivotB.clone();
        const x = this.equationX = new $0982bf0d3ab2ea42$export$9197d1b6f1213c3(bodyA, bodyB);
        const y = this.equationY = new $0982bf0d3ab2ea42$export$9197d1b6f1213c3(bodyA, bodyB);
        const z = this.equationZ = new $0982bf0d3ab2ea42$export$9197d1b6f1213c3(bodyA, bodyB); // Equations to be fed to the solver
        this.equations.push(x, y, z); // Make the equations bidirectional
        x.minForce = y.minForce = z.minForce = -maxForce;
        x.maxForce = y.maxForce = z.maxForce = maxForce;
        x.ni.set(1, 0, 0);
        y.ni.set(0, 1, 0);
        z.ni.set(0, 0, 1);
    }
}
/**
 * Cone equation. Works to keep the given body world vectors aligned, or tilted within a given angle from each other.
 */ class $0982bf0d3ab2ea42$var$ConeEquation extends $0982bf0d3ab2ea42$export$9e6be560da9da590 {
    computeB(h) {
        const a = this.a;
        const b = this.b;
        const ni = this.axisA;
        const nj = this.axisB;
        const nixnj = $0982bf0d3ab2ea42$var$tmpVec1$2;
        const njxni = $0982bf0d3ab2ea42$var$tmpVec2$2;
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB; // Caluclate cross products
        ni.cross(nj, nixnj);
        nj.cross(ni, njxni); // The angle between two vector is:
        // cos(theta) = a * b / (length(a) * length(b) = { len(a) = len(b) = 1 } = a * b
        // g = a * b
        // gdot = (b x a) * wi + (a x b) * wj
        // G = [0 bxa 0 axb]
        // W = [vi wi vj wj]
        GA.rotational.copy(njxni);
        GB.rotational.copy(nixnj);
        const g = Math.cos(this.angle) - ni.dot(nj);
        const GW = this.computeGW();
        const GiMf = this.computeGiMf();
        const B = -g * a - GW * b - h * GiMf;
        return B;
    }
    /**
   * Local axis in A
   */ /**
   * Local axis in B
   */ /**
   * The "cone angle" to keep
   */ constructor(bodyA, bodyB, options = {}){
        const maxForce = typeof options.maxForce !== 'undefined' ? options.maxForce : 1e6;
        super(bodyA, bodyB, -maxForce, maxForce);
        this.axisA = void 0;
        this.axisB = void 0;
        this.angle = void 0;
        this.axisA = options.axisA ? options.axisA.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0);
        this.axisB = options.axisB ? options.axisB.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 0);
        this.angle = typeof options.angle !== 'undefined' ? options.angle : 0;
    }
}
const $0982bf0d3ab2ea42$var$tmpVec1$2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpVec2$2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Rotational constraint. Works to keep the local vectors orthogonal to each other in world space.
 */ class $0982bf0d3ab2ea42$export$911a976a4d3543a5 extends $0982bf0d3ab2ea42$export$9e6be560da9da590 {
    computeB(h) {
        const a = this.a;
        const b = this.b;
        const ni = this.axisA;
        const nj = this.axisB;
        const nixnj = $0982bf0d3ab2ea42$var$tmpVec1$1;
        const njxni = $0982bf0d3ab2ea42$var$tmpVec2$1;
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB; // Caluclate cross products
        ni.cross(nj, nixnj);
        nj.cross(ni, njxni); // g = ni * nj
        // gdot = (nj x ni) * wi + (ni x nj) * wj
        // G = [0 njxni 0 nixnj]
        // W = [vi wi vj wj]
        GA.rotational.copy(njxni);
        GB.rotational.copy(nixnj);
        const g = Math.cos(this.maxAngle) - ni.dot(nj);
        const GW = this.computeGW();
        const GiMf = this.computeGiMf();
        const B = -g * a - GW * b - h * GiMf;
        return B;
    }
    /**
   * World oriented rotational axis.
   */ /**
   * World oriented rotational axis.
   */ /**
   * maxAngle
   */ constructor(bodyA, bodyB, options = {}){
        const maxForce = typeof options.maxForce !== 'undefined' ? options.maxForce : 1e6;
        super(bodyA, bodyB, -maxForce, maxForce);
        this.axisA = void 0;
        this.axisB = void 0;
        this.maxAngle = void 0;
        this.axisA = options.axisA ? options.axisA.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0);
        this.axisB = options.axisB ? options.axisB.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 0);
        this.maxAngle = Math.PI / 2;
    }
}
const $0982bf0d3ab2ea42$var$tmpVec1$1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpVec2$1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * A Cone Twist constraint, useful for ragdolls.
 */ class $0982bf0d3ab2ea42$export$3f8243de12d839d8 extends $0982bf0d3ab2ea42$export$1966541426b45787 {
    update() {
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        const cone = this.coneEquation;
        const twist = this.twistEquation;
        super.update(); // Update the axes to the cone constraint
        bodyA.vectorToWorldFrame(this.axisA, cone.axisA);
        bodyB.vectorToWorldFrame(this.axisB, cone.axisB); // Update the world axes in the twist constraint
        this.axisA.tangents(twist.axisA, twist.axisA);
        bodyA.vectorToWorldFrame(twist.axisA, twist.axisA);
        this.axisB.tangents(twist.axisB, twist.axisB);
        bodyB.vectorToWorldFrame(twist.axisB, twist.axisB);
        cone.angle = this.angle;
        twist.maxAngle = this.twistAngle;
    }
    /**
   * The axis direction for the constraint of the body A.
   */ /**
   * The axis direction for the constraint of the body B.
   */ /**
   * The aperture angle of the cone.
   */ /**
   * The twist angle of the joint.
   */ constructor(bodyA, bodyB, options = {}){
        const maxForce = typeof options.maxForce !== 'undefined' ? options.maxForce : 1e6; // Set pivot point in between
        const pivotA = options.pivotA ? options.pivotA.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const pivotB = options.pivotB ? options.pivotB.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        super(bodyA, pivotA, bodyB, pivotB, maxForce);
        this.axisA = void 0;
        this.axisB = void 0;
        this.angle = void 0;
        this.twistAngle = void 0;
        this.coneEquation = void 0;
        this.twistEquation = void 0;
        this.axisA = options.axisA ? options.axisA.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.axisB = options.axisB ? options.axisB.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.collideConnected = !!options.collideConnected;
        this.angle = typeof options.angle !== 'undefined' ? options.angle : 0;
        const c = this.coneEquation = new $0982bf0d3ab2ea42$var$ConeEquation(bodyA, bodyB, options);
        const t = this.twistEquation = new $0982bf0d3ab2ea42$export$911a976a4d3543a5(bodyA, bodyB, options);
        this.twistAngle = typeof options.twistAngle !== 'undefined' ? options.twistAngle : 0; // Make the cone equation push the bodies toward the cone axis, not outward
        c.maxForce = 0;
        c.minForce = -maxForce; // Make the twist equation add torque toward the initial position
        t.maxForce = 0;
        t.minForce = -maxForce;
        this.equations.push(c, t);
    }
}
/**
 * Constrains two bodies to be at a constant distance from each others center of mass.
 */ class $0982bf0d3ab2ea42$export$7f13e3afb2fe70fe extends $0982bf0d3ab2ea42$export$aec1359a0a40a615 {
    /**
   * update
   */ update() {
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        const eq = this.distanceEquation;
        const halfDist = this.distance * 0.5;
        const normal = eq.ni;
        bodyB.position.vsub(bodyA.position, normal);
        normal.normalize();
        normal.scale(halfDist, eq.ri);
        normal.scale(-halfDist, eq.rj);
    }
    /**
   * The distance to keep. If undefined, it will be set to the current distance between bodyA and bodyB
   */ /**
   * @param distance The distance to keep. If undefined, it will be set to the current distance between bodyA and bodyB.
   * @param maxForce The maximum force that should be applied to constrain the bodies.
   */ constructor(bodyA, bodyB, distance, maxForce = 1e6){
        super(bodyA, bodyB);
        this.distance = void 0;
        this.distanceEquation = void 0;
        if (typeof distance === 'undefined') distance = bodyA.position.distanceTo(bodyB.position);
        this.distance = distance;
        const eq = this.distanceEquation = new $0982bf0d3ab2ea42$export$9197d1b6f1213c3(bodyA, bodyB);
        this.equations.push(eq); // Make it bidirectional
        eq.minForce = -maxForce;
        eq.maxForce = maxForce;
    }
}
/**
 * Lock constraint. Will remove all degrees of freedom between the bodies.
 */ class $0982bf0d3ab2ea42$export$dd4dd491c6f7644d extends $0982bf0d3ab2ea42$export$1966541426b45787 {
    /**
   * update
   */ update() {
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        this.motorEquation;
        const r1 = this.rotationalEquation1;
        const r2 = this.rotationalEquation2;
        const r3 = this.rotationalEquation3;
        super.update(); // These vector pairs must be orthogonal
        bodyA.vectorToWorldFrame(this.xA, r1.axisA);
        bodyB.vectorToWorldFrame(this.yB, r1.axisB);
        bodyA.vectorToWorldFrame(this.yA, r2.axisA);
        bodyB.vectorToWorldFrame(this.zB, r2.axisB);
        bodyA.vectorToWorldFrame(this.zA, r3.axisA);
        bodyB.vectorToWorldFrame(this.xB, r3.axisB);
    }
    constructor(bodyA, bodyB, options = {}){
        const maxForce = typeof options.maxForce !== 'undefined' ? options.maxForce : 1e6; // Set pivot point in between
        const pivotA = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const pivotB = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const halfWay = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        bodyA.position.vadd(bodyB.position, halfWay);
        halfWay.scale(0.5, halfWay);
        bodyB.pointToLocalFrame(halfWay, pivotB);
        bodyA.pointToLocalFrame(halfWay, pivotA); // The point-to-point constraint will keep a point shared between the bodies
        super(bodyA, pivotA, bodyB, pivotB, maxForce); // Store initial rotation of the bodies as unit vectors in the local body spaces
        this.xA = void 0;
        this.xB = void 0;
        this.yA = void 0;
        this.yB = void 0;
        this.zA = void 0;
        this.zB = void 0;
        this.rotationalEquation1 = void 0;
        this.rotationalEquation2 = void 0;
        this.rotationalEquation3 = void 0;
        this.motorEquation = void 0;
        this.xA = bodyA.vectorToLocalFrame($0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_X);
        this.xB = bodyB.vectorToLocalFrame($0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_X);
        this.yA = bodyA.vectorToLocalFrame($0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Y);
        this.yB = bodyB.vectorToLocalFrame($0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Y);
        this.zA = bodyA.vectorToLocalFrame($0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Z);
        this.zB = bodyB.vectorToLocalFrame($0982bf0d3ab2ea42$export$838423f3adec30fa.UNIT_Z); // ...and the following rotational equations will keep all rotational DOF's in place
        const r1 = this.rotationalEquation1 = new $0982bf0d3ab2ea42$export$911a976a4d3543a5(bodyA, bodyB, options);
        const r2 = this.rotationalEquation2 = new $0982bf0d3ab2ea42$export$911a976a4d3543a5(bodyA, bodyB, options);
        const r3 = this.rotationalEquation3 = new $0982bf0d3ab2ea42$export$911a976a4d3543a5(bodyA, bodyB, options);
        this.equations.push(r1, r2, r3);
    }
}
/**
 * Rotational motor constraint. Tries to keep the relative angular velocity of the bodies to a given value.
 */ class $0982bf0d3ab2ea42$export$3ae4b6f6e775a4c9 extends $0982bf0d3ab2ea42$export$9e6be560da9da590 {
    computeB(h) {
        this.a;
        const b = this.b;
        this.bi;
        this.bj;
        const axisA = this.axisA;
        const axisB = this.axisB;
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB; // g = 0
        // gdot = axisA * wi - axisB * wj
        // gdot = G * W = G * [vi wi vj wj]
        // =>
        // G = [0 axisA 0 -axisB]
        GA.rotational.copy(axisA);
        axisB.negate(GB.rotational);
        const GW = this.computeGW() - this.targetVelocity;
        const GiMf = this.computeGiMf();
        const B = -GW * b - h * GiMf;
        return B;
    }
    /**
   * World oriented rotational axis.
   */ /**
   * World oriented rotational axis.
   */ /**
   * Motor velocity.
   */ constructor(bodyA, bodyB, maxForce = 1e6){
        super(bodyA, bodyB, -maxForce, maxForce);
        this.axisA = void 0;
        this.axisB = void 0;
        this.targetVelocity = void 0;
        this.axisA = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.axisB = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.targetVelocity = 0;
    }
}
/**
 * Hinge constraint. Think of it as a door hinge. It tries to keep the door in the correct place and with the correct orientation.
 */ class $0982bf0d3ab2ea42$export$18c5826321ba66b3 extends $0982bf0d3ab2ea42$export$1966541426b45787 {
    /**
   * enableMotor
   */ enableMotor() {
        this.motorEquation.enabled = true;
    }
    /**
   * disableMotor
   */ disableMotor() {
        this.motorEquation.enabled = false;
    }
    /**
   * setMotorSpeed
   */ setMotorSpeed(speed) {
        this.motorEquation.targetVelocity = speed;
    }
    /**
   * setMotorMaxForce
   */ setMotorMaxForce(maxForce) {
        this.motorEquation.maxForce = maxForce;
        this.motorEquation.minForce = -maxForce;
    }
    /**
   * update
   */ update() {
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        const motor = this.motorEquation;
        const r1 = this.rotationalEquation1;
        const r2 = this.rotationalEquation2;
        const worldAxisA = $0982bf0d3ab2ea42$var$HingeConstraint_update_tmpVec1;
        const worldAxisB = $0982bf0d3ab2ea42$var$HingeConstraint_update_tmpVec2;
        const axisA = this.axisA;
        const axisB = this.axisB;
        super.update(); // Get world axes
        bodyA.quaternion.vmult(axisA, worldAxisA);
        bodyB.quaternion.vmult(axisB, worldAxisB);
        worldAxisA.tangents(r1.axisA, r2.axisA);
        r1.axisB.copy(worldAxisB);
        r2.axisB.copy(worldAxisB);
        if (this.motorEquation.enabled) {
            bodyA.quaternion.vmult(this.axisA, motor.axisA);
            bodyB.quaternion.vmult(this.axisB, motor.axisB);
        }
    }
    /**
   * Rotation axis, defined locally in bodyA.
   */ /**
   * Rotation axis, defined locally in bodyB.
   */ constructor(bodyA, bodyB, options = {}){
        const maxForce = typeof options.maxForce !== 'undefined' ? options.maxForce : 1e6;
        const pivotA = options.pivotA ? options.pivotA.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const pivotB = options.pivotB ? options.pivotB.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        super(bodyA, pivotA, bodyB, pivotB, maxForce);
        this.axisA = void 0;
        this.axisB = void 0;
        this.rotationalEquation1 = void 0;
        this.rotationalEquation2 = void 0;
        this.motorEquation = void 0;
        const axisA = this.axisA = options.axisA ? options.axisA.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0);
        axisA.normalize();
        const axisB = this.axisB = options.axisB ? options.axisB.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0);
        axisB.normalize();
        this.collideConnected = !!options.collideConnected;
        const rotational1 = this.rotationalEquation1 = new $0982bf0d3ab2ea42$export$911a976a4d3543a5(bodyA, bodyB, options);
        const rotational2 = this.rotationalEquation2 = new $0982bf0d3ab2ea42$export$911a976a4d3543a5(bodyA, bodyB, options);
        const motor = this.motorEquation = new $0982bf0d3ab2ea42$export$3ae4b6f6e775a4c9(bodyA, bodyB, maxForce);
        motor.enabled = false; // Not enabled by default
        // Equations to be fed to the solver
        this.equations.push(rotational1, rotational2, motor);
    }
}
const $0982bf0d3ab2ea42$var$HingeConstraint_update_tmpVec1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$HingeConstraint_update_tmpVec2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Constrains the slipping in a contact along a tangent
 */ class $0982bf0d3ab2ea42$export$aaf1bc25025a5803 extends $0982bf0d3ab2ea42$export$9e6be560da9da590 {
    computeB(h) {
        this.a;
        const b = this.b;
        this.bi;
        this.bj;
        const ri = this.ri;
        const rj = this.rj;
        const rixt = $0982bf0d3ab2ea42$var$FrictionEquation_computeB_temp1;
        const rjxt = $0982bf0d3ab2ea42$var$FrictionEquation_computeB_temp2;
        const t = this.t; // Caluclate cross products
        ri.cross(t, rixt);
        rj.cross(t, rjxt); // G = [-t -rixt t rjxt]
        // And remember, this is a pure velocity constraint, g is always zero!
        const GA = this.jacobianElementA;
        const GB = this.jacobianElementB;
        t.negate(GA.spatial);
        rixt.negate(GA.rotational);
        GB.spatial.copy(t);
        GB.rotational.copy(rjxt);
        const GW = this.computeGW();
        const GiMf = this.computeGiMf();
        const B = -GW * b - h * GiMf;
        return B;
    }
    // Tangent
    /**
   * @param slipForce should be +-F_friction = +-mu * F_normal = +-mu * m * g
   */ constructor(bodyA, bodyB, slipForce){
        super(bodyA, bodyB, -slipForce, slipForce);
        this.ri = void 0;
        this.rj = void 0;
        this.t = void 0;
        this.ri = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.rj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.t = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
    }
}
const $0982bf0d3ab2ea42$var$FrictionEquation_computeB_temp1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$FrictionEquation_computeB_temp2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Defines what happens when two materials meet.
 * @todo Refactor materials to materialA and materialB
 */ class $0982bf0d3ab2ea42$export$a172e4020a254255 {
    /**
   * Identifier of this material.
   */ /**
   * Participating materials.
   */ /**
   * Friction coefficient.
   * @default 0.3
   */ /**
   * Restitution coefficient.
   * @default 0.3
   */ /**
   * Stiffness of the produced contact equations.
   * @default 1e7
   */ /**
   * Relaxation time of the produced contact equations.
   * @default 3
   */ /**
   * Stiffness of the produced friction equations.
   * @default 1e7
   */ /**
   * Relaxation time of the produced friction equations
   * @default 3
   */ constructor(m1, m2, options){
        this.id = void 0;
        this.materials = void 0;
        this.friction = void 0;
        this.restitution = void 0;
        this.contactEquationStiffness = void 0;
        this.contactEquationRelaxation = void 0;
        this.frictionEquationStiffness = void 0;
        this.frictionEquationRelaxation = void 0;
        options = $0982bf0d3ab2ea42$var$Utils.defaults(options, {
            friction: 0.3,
            restitution: 0.3,
            contactEquationStiffness: 1e7,
            contactEquationRelaxation: 3,
            frictionEquationStiffness: 1e7,
            frictionEquationRelaxation: 3
        });
        this.id = $0982bf0d3ab2ea42$export$a172e4020a254255.idCounter++;
        this.materials = [
            m1,
            m2
        ];
        this.friction = options.friction;
        this.restitution = options.restitution;
        this.contactEquationStiffness = options.contactEquationStiffness;
        this.contactEquationRelaxation = options.contactEquationRelaxation;
        this.frictionEquationStiffness = options.frictionEquationStiffness;
        this.frictionEquationRelaxation = options.frictionEquationRelaxation;
    }
}
$0982bf0d3ab2ea42$export$a172e4020a254255.idCounter = 0;
/**
 * Defines a physics material.
 */ class $0982bf0d3ab2ea42$export$a2d8b23205c25948 {
    /**
   * Material name.
   * If options is a string, name will be set to that string.
   * @todo Deprecate this
   */ /** Material id. */ /**
   * Friction for this material.
   * If non-negative, it will be used instead of the friction given by ContactMaterials. If there's no matching ContactMaterial, the value from `defaultContactMaterial` in the World will be used.
   */ /**
   * Restitution for this material.
   * If non-negative, it will be used instead of the restitution given by ContactMaterials. If there's no matching ContactMaterial, the value from `defaultContactMaterial` in the World will be used.
   */ constructor(options = {}){
        this.name = void 0;
        this.id = void 0;
        this.friction = void 0;
        this.restitution = void 0;
        let name = ''; // Backwards compatibility fix
        if (typeof options === 'string') {
            //console.warn(`Passing a string to MaterialOptions is deprecated, and has no effect`)
            name = options;
            options = {};
        }
        this.name = name;
        this.id = $0982bf0d3ab2ea42$export$a2d8b23205c25948.idCounter++;
        this.friction = typeof options.friction !== 'undefined' ? options.friction : -1;
        this.restitution = typeof options.restitution !== 'undefined' ? options.restitution : -1;
    }
}
$0982bf0d3ab2ea42$export$a2d8b23205c25948.idCounter = 0;
/**
 * A spring, connecting two bodies.
 * @example
 *     const spring = new Spring(boxBody, sphereBody, {
 *       restLength: 0,
 *       stiffness: 50,
 *       damping: 1,
 *     })
 *
 *     // Compute the force after each step
 *     world.addEventListener('postStep', (event) => {
 *       spring.applyForce()
 *     })
 */ class $0982bf0d3ab2ea42$export$a500e5b516cedfc {
    /**
   * Set the anchor point on body A, using world coordinates.
   */ setWorldAnchorA(worldAnchorA) {
        this.bodyA.pointToLocalFrame(worldAnchorA, this.localAnchorA);
    }
    /**
   * Set the anchor point on body B, using world coordinates.
   */ setWorldAnchorB(worldAnchorB) {
        this.bodyB.pointToLocalFrame(worldAnchorB, this.localAnchorB);
    }
    /**
   * Get the anchor point on body A, in world coordinates.
   * @param result The vector to store the result in.
   */ getWorldAnchorA(result) {
        this.bodyA.pointToWorldFrame(this.localAnchorA, result);
    }
    /**
   * Get the anchor point on body B, in world coordinates.
   * @param result The vector to store the result in.
   */ getWorldAnchorB(result) {
        this.bodyB.pointToWorldFrame(this.localAnchorB, result);
    }
    /**
   * Apply the spring force to the connected bodies.
   */ applyForce() {
        const k = this.stiffness;
        const d = this.damping;
        const l = this.restLength;
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        const r = $0982bf0d3ab2ea42$var$applyForce_r;
        const r_unit = $0982bf0d3ab2ea42$var$applyForce_r_unit;
        const u = $0982bf0d3ab2ea42$var$applyForce_u;
        const f = $0982bf0d3ab2ea42$var$applyForce_f;
        const tmp = $0982bf0d3ab2ea42$var$applyForce_tmp;
        const worldAnchorA = $0982bf0d3ab2ea42$var$applyForce_worldAnchorA;
        const worldAnchorB = $0982bf0d3ab2ea42$var$applyForce_worldAnchorB;
        const ri = $0982bf0d3ab2ea42$var$applyForce_ri;
        const rj = $0982bf0d3ab2ea42$var$applyForce_rj;
        const ri_x_f = $0982bf0d3ab2ea42$var$applyForce_ri_x_f;
        const rj_x_f = $0982bf0d3ab2ea42$var$applyForce_rj_x_f; // Get world anchors
        this.getWorldAnchorA(worldAnchorA);
        this.getWorldAnchorB(worldAnchorB); // Get offset points
        worldAnchorA.vsub(bodyA.position, ri);
        worldAnchorB.vsub(bodyB.position, rj); // Compute distance vector between world anchor points
        worldAnchorB.vsub(worldAnchorA, r);
        const rlen = r.length();
        r_unit.copy(r);
        r_unit.normalize(); // Compute relative velocity of the anchor points, u
        bodyB.velocity.vsub(bodyA.velocity, u); // Add rotational velocity
        bodyB.angularVelocity.cross(rj, tmp);
        u.vadd(tmp, u);
        bodyA.angularVelocity.cross(ri, tmp);
        u.vsub(tmp, u); // F = - k * ( x - L ) - D * ( u )
        r_unit.scale(-k * (rlen - l) - d * u.dot(r_unit), f); // Add forces to bodies
        bodyA.force.vsub(f, bodyA.force);
        bodyB.force.vadd(f, bodyB.force); // Angular force
        ri.cross(f, ri_x_f);
        rj.cross(f, rj_x_f);
        bodyA.torque.vsub(ri_x_f, bodyA.torque);
        bodyB.torque.vadd(rj_x_f, bodyB.torque);
    }
    /**
   * Rest length of the spring. A number > 0.
   * @default 1
   */ /**
   * Stiffness of the spring. A number >= 0.
   * @default 100
   */ /**
   * Damping of the spring. A number >= 0.
   * @default 1
   */ /**
   * First connected body.
   */ /**
   * Second connected body.
   */ /**
   * Anchor for bodyA in local bodyA coordinates.
   * Where to hook the spring to body A, in local body coordinates.
   * @default new Vec3()
   */ /**
   * Anchor for bodyB in local bodyB coordinates.
   * Where to hook the spring to body B, in local body coordinates.
   * @default new Vec3()
   */ constructor(bodyA, bodyB, options = {}){
        this.restLength = void 0;
        this.stiffness = void 0;
        this.damping = void 0;
        this.bodyA = void 0;
        this.bodyB = void 0;
        this.localAnchorA = void 0;
        this.localAnchorB = void 0;
        this.restLength = typeof options.restLength === 'number' ? options.restLength : 1;
        this.stiffness = options.stiffness || 100;
        this.damping = options.damping || 1;
        this.bodyA = bodyA;
        this.bodyB = bodyB;
        this.localAnchorA = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.localAnchorB = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        if (options.localAnchorA) this.localAnchorA.copy(options.localAnchorA);
        if (options.localAnchorB) this.localAnchorB.copy(options.localAnchorB);
        if (options.worldAnchorA) this.setWorldAnchorA(options.worldAnchorA);
        if (options.worldAnchorB) this.setWorldAnchorB(options.worldAnchorB);
    }
}
const $0982bf0d3ab2ea42$var$applyForce_r = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_r_unit = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_u = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_f = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_worldAnchorA = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_worldAnchorB = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_ri = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_rj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_ri_x_f = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_rj_x_f = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$applyForce_tmp = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * WheelInfo
 */ class $0982bf0d3ab2ea42$export$213d906b524272f5 {
    updateWheel(chassis) {
        const raycastResult = this.raycastResult;
        if (this.isInContact) {
            const project = raycastResult.hitNormalWorld.dot(raycastResult.directionWorld);
            raycastResult.hitPointWorld.vsub(chassis.position, $0982bf0d3ab2ea42$var$relpos);
            chassis.getVelocityAtWorldPoint($0982bf0d3ab2ea42$var$relpos, $0982bf0d3ab2ea42$var$chassis_velocity_at_contactPoint);
            const projVel = raycastResult.hitNormalWorld.dot($0982bf0d3ab2ea42$var$chassis_velocity_at_contactPoint);
            if (project >= -0.1) {
                this.suspensionRelativeVelocity = 0.0;
                this.clippedInvContactDotSuspension = 10;
            } else {
                const inv = -1 / project;
                this.suspensionRelativeVelocity = projVel * inv;
                this.clippedInvContactDotSuspension = inv;
            }
        } else {
            // Not in contact : position wheel in a nice (rest length) position
            raycastResult.suspensionLength = this.suspensionRestLength;
            this.suspensionRelativeVelocity = 0.0;
            raycastResult.directionWorld.scale(-1, raycastResult.hitNormalWorld);
            this.clippedInvContactDotSuspension = 1.0;
        }
    }
    /**
   * Max travel distance of the suspension, in meters.
   * @default 1
   */ /**
   * Speed to apply to the wheel rotation when the wheel is sliding.
   * @default -0.1
   */ /**
   * If the customSlidingRotationalSpeed should be used.
   * @default false
   */ /**
   * sliding
   */ /**
   * Connection point, defined locally in the chassis body frame.
   */ /**
   * chassisConnectionPointWorld
   */ /**
   * directionLocal
   */ /**
   * directionWorld
   */ /**
   * axleLocal
   */ /**
   * axleWorld
   */ /**
   * suspensionRestLength
   * @default 1
   */ /**
   * suspensionMaxLength
   * @default 2
   */ /**
   * radius
   * @default 1
   */ /**
   * suspensionStiffness
   * @default 100
   */ /**
   * dampingCompression
   * @default 10
   */ /**
   * dampingRelaxation
   * @default 10
   */ /**
   * frictionSlip
   * @default 10.5
   */ /** forwardAcceleration */ /** sideAcceleration */ /**
   * steering
   * @default 0
   */ /**
   * Rotation value, in radians.
   * @default 0
   */ /**
   * deltaRotation
   * @default 0
   */ /**
   * rollInfluence
   * @default 0.01
   */ /**
   * maxSuspensionForce
   */ /**
   * engineForce
   */ /**
   * brake
   */ /**
   * isFrontWheel
   * @default true
   */ /**
   * clippedInvContactDotSuspension
   * @default 1
   */ /**
   * suspensionRelativeVelocity
   * @default 0
   */ /**
   * suspensionForce
   * @default 0
   */ /**
   * slipInfo
   */ /**
   * skidInfo
   * @default 0
   */ /**
   * suspensionLength
   * @default 0
   */ /**
   * sideImpulse
   */ /**
   * forwardImpulse
   */ /**
   * The result from raycasting.
   */ /**
   * Wheel world transform.
   */ /**
   * isInContact
   */ constructor(options = {}){
        this.maxSuspensionTravel = void 0;
        this.customSlidingRotationalSpeed = void 0;
        this.useCustomSlidingRotationalSpeed = void 0;
        this.sliding = void 0;
        this.chassisConnectionPointLocal = void 0;
        this.chassisConnectionPointWorld = void 0;
        this.directionLocal = void 0;
        this.directionWorld = void 0;
        this.axleLocal = void 0;
        this.axleWorld = void 0;
        this.suspensionRestLength = void 0;
        this.suspensionMaxLength = void 0;
        this.radius = void 0;
        this.suspensionStiffness = void 0;
        this.dampingCompression = void 0;
        this.dampingRelaxation = void 0;
        this.frictionSlip = void 0;
        this.forwardAcceleration = void 0;
        this.sideAcceleration = void 0;
        this.steering = void 0;
        this.rotation = void 0;
        this.deltaRotation = void 0;
        this.rollInfluence = void 0;
        this.maxSuspensionForce = void 0;
        this.engineForce = void 0;
        this.brake = void 0;
        this.isFrontWheel = void 0;
        this.clippedInvContactDotSuspension = void 0;
        this.suspensionRelativeVelocity = void 0;
        this.suspensionForce = void 0;
        this.slipInfo = void 0;
        this.skidInfo = void 0;
        this.suspensionLength = void 0;
        this.sideImpulse = void 0;
        this.forwardImpulse = void 0;
        this.raycastResult = void 0;
        this.worldTransform = void 0;
        this.isInContact = void 0;
        options = $0982bf0d3ab2ea42$var$Utils.defaults(options, {
            chassisConnectionPointLocal: new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
            chassisConnectionPointWorld: new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
            directionLocal: new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
            directionWorld: new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
            axleLocal: new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
            axleWorld: new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
            suspensionRestLength: 1,
            suspensionMaxLength: 2,
            radius: 1,
            suspensionStiffness: 100,
            dampingCompression: 10,
            dampingRelaxation: 10,
            frictionSlip: 10.5,
            forwardAcceleration: 1,
            sideAcceleration: 1,
            steering: 0,
            rotation: 0,
            deltaRotation: 0,
            rollInfluence: 0.01,
            maxSuspensionForce: Number.MAX_VALUE,
            isFrontWheel: true,
            clippedInvContactDotSuspension: 1,
            suspensionRelativeVelocity: 0,
            suspensionForce: 0,
            slipInfo: 0,
            skidInfo: 0,
            suspensionLength: 0,
            maxSuspensionTravel: 1,
            useCustomSlidingRotationalSpeed: false,
            customSlidingRotationalSpeed: -0.1
        });
        this.maxSuspensionTravel = options.maxSuspensionTravel;
        this.customSlidingRotationalSpeed = options.customSlidingRotationalSpeed;
        this.useCustomSlidingRotationalSpeed = options.useCustomSlidingRotationalSpeed;
        this.sliding = false;
        this.chassisConnectionPointLocal = options.chassisConnectionPointLocal.clone();
        this.chassisConnectionPointWorld = options.chassisConnectionPointWorld.clone();
        this.directionLocal = options.directionLocal.clone();
        this.directionWorld = options.directionWorld.clone();
        this.axleLocal = options.axleLocal.clone();
        this.axleWorld = options.axleWorld.clone();
        this.suspensionRestLength = options.suspensionRestLength;
        this.suspensionMaxLength = options.suspensionMaxLength;
        this.radius = options.radius;
        this.suspensionStiffness = options.suspensionStiffness;
        this.dampingCompression = options.dampingCompression;
        this.dampingRelaxation = options.dampingRelaxation;
        this.frictionSlip = options.frictionSlip;
        this.forwardAcceleration = options.forwardAcceleration;
        this.sideAcceleration = options.sideAcceleration;
        this.steering = 0;
        this.rotation = 0;
        this.deltaRotation = 0;
        this.rollInfluence = options.rollInfluence;
        this.maxSuspensionForce = options.maxSuspensionForce;
        this.engineForce = 0;
        this.brake = 0;
        this.isFrontWheel = options.isFrontWheel;
        this.clippedInvContactDotSuspension = 1;
        this.suspensionRelativeVelocity = 0;
        this.suspensionForce = 0;
        this.slipInfo = 0;
        this.skidInfo = 0;
        this.suspensionLength = 0;
        this.sideImpulse = 0;
        this.forwardImpulse = 0;
        this.raycastResult = new $0982bf0d3ab2ea42$export$2e8bb24f335362cc();
        this.worldTransform = new $0982bf0d3ab2ea42$export$563a914cafbdc389();
        this.isInContact = false;
    }
}
const $0982bf0d3ab2ea42$var$chassis_velocity_at_contactPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$relpos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Vehicle helper class that casts rays from the wheel positions towards the ground and applies forces.
 */ class $0982bf0d3ab2ea42$export$791f0c86c6ec4eab {
    /**
   * Add a wheel. For information about the options, see `WheelInfo`.
   */ addWheel(options = {}) {
        const info = new $0982bf0d3ab2ea42$export$213d906b524272f5(options);
        const index = this.wheelInfos.length;
        this.wheelInfos.push(info);
        return index;
    }
    /**
   * Set the steering value of a wheel.
   */ setSteeringValue(value, wheelIndex) {
        const wheel = this.wheelInfos[wheelIndex];
        wheel.steering = value;
    }
    /**
   * Set the wheel force to apply on one of the wheels each time step
   */ applyEngineForce(value, wheelIndex) {
        this.wheelInfos[wheelIndex].engineForce = value;
    }
    /**
   * Set the braking force of a wheel
   */ setBrake(brake, wheelIndex) {
        this.wheelInfos[wheelIndex].brake = brake;
    }
    /**
   * Add the vehicle including its constraints to the world.
   */ addToWorld(world) {
        world.addBody(this.chassisBody);
        const that = this;
        this.preStepCallback = ()=>{
            that.updateVehicle(world.dt);
        };
        world.addEventListener('preStep', this.preStepCallback);
        this.world = world;
    }
    /**
   * Get one of the wheel axles, world-oriented.
   */ getVehicleAxisWorld(axisIndex, result) {
        result.set(axisIndex === 0 ? 1 : 0, axisIndex === 1 ? 1 : 0, axisIndex === 2 ? 1 : 0);
        this.chassisBody.vectorToWorldFrame(result, result);
    }
    updateVehicle(timeStep) {
        const wheelInfos = this.wheelInfos;
        const numWheels = wheelInfos.length;
        const chassisBody = this.chassisBody;
        for(let i = 0; i < numWheels; i++)this.updateWheelTransform(i);
        this.currentVehicleSpeedKmHour = 3.6 * chassisBody.velocity.length();
        const forwardWorld = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.getVehicleAxisWorld(this.indexForwardAxis, forwardWorld);
        if (forwardWorld.dot(chassisBody.velocity) < 0) this.currentVehicleSpeedKmHour *= -1;
         // simulate suspension
        for(let i = 0; i < numWheels; i++)this.castRay(wheelInfos[i]);
        this.updateSuspension(timeStep);
        const impulse = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const relpos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        for(let i = 0; i < numWheels; i++){
            //apply suspension force
            const wheel = wheelInfos[i];
            let suspensionForce = wheel.suspensionForce;
            if (suspensionForce > wheel.maxSuspensionForce) suspensionForce = wheel.maxSuspensionForce;
            wheel.raycastResult.hitNormalWorld.scale(suspensionForce * timeStep, impulse);
            wheel.raycastResult.hitPointWorld.vsub(chassisBody.position, relpos);
            chassisBody.applyImpulse(impulse, relpos);
        }
        this.updateFriction(timeStep);
        const hitNormalWorldScaledWithProj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const fwd = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const vel = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        for(let i = 0; i < numWheels; i++){
            const wheel = wheelInfos[i]; //const relpos = new Vec3();
            //wheel.chassisConnectionPointWorld.vsub(chassisBody.position, relpos);
            chassisBody.getVelocityAtWorldPoint(wheel.chassisConnectionPointWorld, vel); // Hack to get the rotation in the correct direction
            let m = 1;
            switch(this.indexUpAxis){
                case 1:
                    m = -1;
                    break;
            }
            if (wheel.isInContact) {
                this.getVehicleAxisWorld(this.indexForwardAxis, fwd);
                const proj = fwd.dot(wheel.raycastResult.hitNormalWorld);
                wheel.raycastResult.hitNormalWorld.scale(proj, hitNormalWorldScaledWithProj);
                fwd.vsub(hitNormalWorldScaledWithProj, fwd);
                const proj2 = fwd.dot(vel);
                wheel.deltaRotation = m * proj2 * timeStep / wheel.radius;
            }
            if ((wheel.sliding || !wheel.isInContact) && wheel.engineForce !== 0 && wheel.useCustomSlidingRotationalSpeed) // Apply custom rotation when accelerating and sliding
            wheel.deltaRotation = (wheel.engineForce > 0 ? 1 : -1) * wheel.customSlidingRotationalSpeed * timeStep;
             // Lock wheels
            if (Math.abs(wheel.brake) > Math.abs(wheel.engineForce)) wheel.deltaRotation = 0;
            wheel.rotation += wheel.deltaRotation; // Use the old value
            wheel.deltaRotation *= 0.99; // damping of rotation when not in contact
        }
    }
    updateSuspension(deltaTime) {
        const chassisBody = this.chassisBody;
        const chassisMass = chassisBody.mass;
        const wheelInfos = this.wheelInfos;
        const numWheels = wheelInfos.length;
        for(let w_it = 0; w_it < numWheels; w_it++){
            const wheel = wheelInfos[w_it];
            if (wheel.isInContact) {
                let force; // Spring
                const susp_length = wheel.suspensionRestLength;
                const current_length = wheel.suspensionLength;
                const length_diff = susp_length - current_length;
                force = wheel.suspensionStiffness * length_diff * wheel.clippedInvContactDotSuspension; // Damper
                const projected_rel_vel = wheel.suspensionRelativeVelocity;
                let susp_damping;
                if (projected_rel_vel < 0) susp_damping = wheel.dampingCompression;
                else susp_damping = wheel.dampingRelaxation;
                force -= susp_damping * projected_rel_vel;
                wheel.suspensionForce = force * chassisMass;
                if (wheel.suspensionForce < 0) wheel.suspensionForce = 0;
            } else wheel.suspensionForce = 0;
        }
    }
    /**
   * Remove the vehicle including its constraints from the world.
   */ removeFromWorld(world) {
        this.constraints;
        world.removeBody(this.chassisBody);
        world.removeEventListener('preStep', this.preStepCallback);
        this.world = null;
    }
    castRay(wheel) {
        const rayvector = $0982bf0d3ab2ea42$var$castRay_rayvector;
        const target = $0982bf0d3ab2ea42$var$castRay_target;
        this.updateWheelTransformWorld(wheel);
        const chassisBody = this.chassisBody;
        let depth = -1;
        const raylen = wheel.suspensionRestLength + wheel.radius;
        wheel.directionWorld.scale(raylen, rayvector);
        const source = wheel.chassisConnectionPointWorld;
        source.vadd(rayvector, target);
        const raycastResult = wheel.raycastResult;
        raycastResult.reset(); // Turn off ray collision with the chassis temporarily
        const oldState = chassisBody.collisionResponse;
        chassisBody.collisionResponse = false; // Cast ray against world
        this.world.rayTest(source, target, raycastResult);
        chassisBody.collisionResponse = oldState;
        const object = raycastResult.body;
        wheel.raycastResult.groundObject = 0;
        if (object) {
            depth = raycastResult.distance;
            wheel.raycastResult.hitNormalWorld = raycastResult.hitNormalWorld;
            wheel.isInContact = true;
            const hitDistance = raycastResult.distance;
            wheel.suspensionLength = hitDistance - wheel.radius; // clamp on max suspension travel
            const minSuspensionLength = wheel.suspensionRestLength - wheel.maxSuspensionTravel;
            const maxSuspensionLength = wheel.suspensionRestLength + wheel.maxSuspensionTravel;
            if (wheel.suspensionLength < minSuspensionLength) wheel.suspensionLength = minSuspensionLength;
            if (wheel.suspensionLength > maxSuspensionLength) {
                wheel.suspensionLength = maxSuspensionLength;
                wheel.raycastResult.reset();
            }
            const denominator = wheel.raycastResult.hitNormalWorld.dot(wheel.directionWorld);
            const chassis_velocity_at_contactPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            chassisBody.getVelocityAtWorldPoint(wheel.raycastResult.hitPointWorld, chassis_velocity_at_contactPoint);
            const projVel = wheel.raycastResult.hitNormalWorld.dot(chassis_velocity_at_contactPoint);
            if (denominator >= -0.1) {
                wheel.suspensionRelativeVelocity = 0;
                wheel.clippedInvContactDotSuspension = 10;
            } else {
                const inv = -1 / denominator;
                wheel.suspensionRelativeVelocity = projVel * inv;
                wheel.clippedInvContactDotSuspension = inv;
            }
        } else {
            //put wheel info as in rest position
            wheel.suspensionLength = wheel.suspensionRestLength + 0 * wheel.maxSuspensionTravel;
            wheel.suspensionRelativeVelocity = 0.0;
            wheel.directionWorld.scale(-1, wheel.raycastResult.hitNormalWorld);
            wheel.clippedInvContactDotSuspension = 1.0;
        }
        return depth;
    }
    updateWheelTransformWorld(wheel) {
        wheel.isInContact = false;
        const chassisBody = this.chassisBody;
        chassisBody.pointToWorldFrame(wheel.chassisConnectionPointLocal, wheel.chassisConnectionPointWorld);
        chassisBody.vectorToWorldFrame(wheel.directionLocal, wheel.directionWorld);
        chassisBody.vectorToWorldFrame(wheel.axleLocal, wheel.axleWorld);
    }
    /**
   * Update one of the wheel transform.
   * Note when rendering wheels: during each step, wheel transforms are updated BEFORE the chassis; ie. their position becomes invalid after the step. Thus when you render wheels, you must update wheel transforms before rendering them. See raycastVehicle demo for an example.
   * @param wheelIndex The wheel index to update.
   */ updateWheelTransform(wheelIndex) {
        const up = $0982bf0d3ab2ea42$var$tmpVec4;
        const right = $0982bf0d3ab2ea42$var$tmpVec5;
        const fwd = $0982bf0d3ab2ea42$var$tmpVec6;
        const wheel = this.wheelInfos[wheelIndex];
        this.updateWheelTransformWorld(wheel);
        wheel.directionLocal.scale(-1, up);
        right.copy(wheel.axleLocal);
        up.cross(right, fwd);
        fwd.normalize();
        right.normalize(); // Rotate around steering over the wheelAxle
        const steering = wheel.steering;
        const steeringOrn = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        steeringOrn.setFromAxisAngle(up, steering);
        const rotatingOrn = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
        rotatingOrn.setFromAxisAngle(right, wheel.rotation); // World rotation of the wheel
        const q = wheel.worldTransform.quaternion;
        this.chassisBody.quaternion.mult(steeringOrn, q);
        q.mult(rotatingOrn, q);
        q.normalize(); // world position of the wheel
        const p = wheel.worldTransform.position;
        p.copy(wheel.directionWorld);
        p.scale(wheel.suspensionLength, p);
        p.vadd(wheel.chassisConnectionPointWorld, p);
    }
    /**
   * Get the world transform of one of the wheels
   */ getWheelTransformWorld(wheelIndex) {
        return this.wheelInfos[wheelIndex].worldTransform;
    }
    updateFriction(timeStep) {
        const surfNormalWS_scaled_proj = $0982bf0d3ab2ea42$var$updateFriction_surfNormalWS_scaled_proj; //calculate the impulse, so that the wheels don't move sidewards
        const wheelInfos = this.wheelInfos;
        const numWheels = wheelInfos.length;
        const chassisBody = this.chassisBody;
        const forwardWS = $0982bf0d3ab2ea42$var$updateFriction_forwardWS;
        const axle = $0982bf0d3ab2ea42$var$updateFriction_axle;
        for(let i = 0; i < numWheels; i++){
            const wheel = wheelInfos[i];
            wheel.raycastResult.body;
            wheel.sideImpulse = 0;
            wheel.forwardImpulse = 0;
            if (!forwardWS[i]) forwardWS[i] = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            if (!axle[i]) axle[i] = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        }
        for(let i = 0; i < numWheels; i++){
            const wheel = wheelInfos[i];
            const groundObject = wheel.raycastResult.body;
            if (groundObject) {
                const axlei = axle[i];
                const wheelTrans = this.getWheelTransformWorld(i); // Get world axle
                wheelTrans.vectorToWorldFrame($0982bf0d3ab2ea42$var$directions[this.indexRightAxis], axlei);
                const surfNormalWS = wheel.raycastResult.hitNormalWorld;
                const proj = axlei.dot(surfNormalWS);
                surfNormalWS.scale(proj, surfNormalWS_scaled_proj);
                axlei.vsub(surfNormalWS_scaled_proj, axlei);
                axlei.normalize();
                surfNormalWS.cross(axlei, forwardWS[i]);
                forwardWS[i].normalize();
                wheel.sideImpulse = $0982bf0d3ab2ea42$var$resolveSingleBilateral(chassisBody, wheel.raycastResult.hitPointWorld, groundObject, wheel.raycastResult.hitPointWorld, axlei);
                wheel.sideImpulse *= $0982bf0d3ab2ea42$var$sideFrictionStiffness2;
            }
        }
        const sideFactor = 1;
        const fwdFactor = 0.5;
        this.sliding = false;
        for(let i = 0; i < numWheels; i++){
            const wheel = wheelInfos[i];
            const groundObject = wheel.raycastResult.body;
            let rollingFriction = 0;
            wheel.slipInfo = 1;
            if (groundObject) {
                const defaultRollingFrictionImpulse = 0;
                const maxImpulse = wheel.brake ? wheel.brake : defaultRollingFrictionImpulse; // btWheelContactPoint contactPt(chassisBody,groundObject,wheelInfraycastInfo.hitPointWorld,forwardWS[wheel],maxImpulse);
                // rollingFriction = calcRollingFriction(contactPt);
                rollingFriction = $0982bf0d3ab2ea42$var$calcRollingFriction(chassisBody, groundObject, wheel.raycastResult.hitPointWorld, forwardWS[i], maxImpulse);
                rollingFriction += wheel.engineForce * timeStep; // rollingFriction = 0;
                const factor = maxImpulse / rollingFriction;
                wheel.slipInfo *= factor;
            } //switch between active rolling (throttle), braking and non-active rolling friction (nthrottle/break)
            wheel.forwardImpulse = 0;
            wheel.skidInfo = 1;
            if (groundObject) {
                wheel.skidInfo = 1;
                const maximp = wheel.suspensionForce * timeStep * wheel.frictionSlip;
                const maximpSide = maximp;
                const maximpSquared = maximp * maximpSide;
                wheel.forwardImpulse = rollingFriction; //wheelInfo.engineForce* timeStep;
                const x = wheel.forwardImpulse * fwdFactor / wheel.forwardAcceleration;
                const y = wheel.sideImpulse * sideFactor / wheel.sideAcceleration;
                const impulseSquared = x * x + y * y;
                wheel.sliding = false;
                if (impulseSquared > maximpSquared) {
                    this.sliding = true;
                    wheel.sliding = true;
                    const factor = maximp / Math.sqrt(impulseSquared);
                    wheel.skidInfo *= factor;
                }
            }
        }
        if (this.sliding) for(let i = 0; i < numWheels; i++){
            const wheel = wheelInfos[i];
            if (wheel.sideImpulse !== 0) {
                if (wheel.skidInfo < 1) {
                    wheel.forwardImpulse *= wheel.skidInfo;
                    wheel.sideImpulse *= wheel.skidInfo;
                }
            }
        }
         // apply the impulses
        for(let i = 0; i < numWheels; i++){
            const wheel = wheelInfos[i];
            const rel_pos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            wheel.raycastResult.hitPointWorld.vsub(chassisBody.position, rel_pos); // cannons applyimpulse is using world coord for the position
            //rel_pos.copy(wheel.raycastResult.hitPointWorld);
            if (wheel.forwardImpulse !== 0) {
                const impulse = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
                forwardWS[i].scale(wheel.forwardImpulse, impulse);
                chassisBody.applyImpulse(impulse, rel_pos);
            }
            if (wheel.sideImpulse !== 0) {
                const groundObject = wheel.raycastResult.body;
                const rel_pos2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
                wheel.raycastResult.hitPointWorld.vsub(groundObject.position, rel_pos2); //rel_pos2.copy(wheel.raycastResult.hitPointWorld);
                const sideImp = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
                axle[i].scale(wheel.sideImpulse, sideImp); // Scale the relative position in the up direction with rollInfluence.
                // If rollInfluence is 1, the impulse will be applied on the hitPoint (easy to roll over), if it is zero it will be applied in the same plane as the center of mass (not easy to roll over).
                chassisBody.vectorToLocalFrame(rel_pos, rel_pos);
                rel_pos['xyz'[this.indexUpAxis]] *= wheel.rollInfluence;
                chassisBody.vectorToWorldFrame(rel_pos, rel_pos);
                chassisBody.applyImpulse(sideImp, rel_pos); //apply friction impulse on the ground
                sideImp.scale(-1, sideImp);
                groundObject.applyImpulse(sideImp, rel_pos2);
            }
        }
    }
    /** The car chassis body. */ /** The wheels. */ /** Will be set to true if the car is sliding. */ /** Index of the right axis. x=0, y=1, z=2 */ /** Index of the forward axis. x=0, y=1, z=2 */ /** Index of the up axis. x=0, y=1, z=2 */ /** The constraints. */ /** Optional pre-step callback. */ constructor(options){
        this.chassisBody = void 0;
        this.wheelInfos = void 0;
        this.sliding = void 0;
        this.world = void 0;
        this.indexRightAxis = void 0;
        this.indexForwardAxis = void 0;
        this.indexUpAxis = void 0;
        this.constraints = void 0;
        this.preStepCallback = void 0;
        this.currentVehicleSpeedKmHour = void 0;
        this.chassisBody = options.chassisBody;
        this.wheelInfos = [];
        this.sliding = false;
        this.world = null;
        this.indexRightAxis = typeof options.indexRightAxis !== 'undefined' ? options.indexRightAxis : 2;
        this.indexForwardAxis = typeof options.indexForwardAxis !== 'undefined' ? options.indexForwardAxis : 0;
        this.indexUpAxis = typeof options.indexUpAxis !== 'undefined' ? options.indexUpAxis : 1;
        this.constraints = [];
        this.preStepCallback = ()=>{};
        this.currentVehicleSpeedKmHour = 0;
    }
}
const $0982bf0d3ab2ea42$var$tmpVec4 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpVec5 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpVec6 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
new $0982bf0d3ab2ea42$export$a186db52eed6d40e();
const $0982bf0d3ab2ea42$var$castRay_rayvector = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$castRay_target = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$directions = [
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 0),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 1)
];
const $0982bf0d3ab2ea42$var$updateFriction_surfNormalWS_scaled_proj = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$updateFriction_axle = [];
const $0982bf0d3ab2ea42$var$updateFriction_forwardWS = [];
const $0982bf0d3ab2ea42$var$sideFrictionStiffness2 = 1;
const $0982bf0d3ab2ea42$var$calcRollingFriction_vel1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$calcRollingFriction_vel2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$calcRollingFriction_vel = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
function $0982bf0d3ab2ea42$var$calcRollingFriction(body0, body1, frictionPosWorld, frictionDirectionWorld, maxImpulse) {
    let j1 = 0;
    const contactPosWorld = frictionPosWorld; // const rel_pos1 = new Vec3();
    // const rel_pos2 = new Vec3();
    const vel1 = $0982bf0d3ab2ea42$var$calcRollingFriction_vel1;
    const vel2 = $0982bf0d3ab2ea42$var$calcRollingFriction_vel2;
    const vel = $0982bf0d3ab2ea42$var$calcRollingFriction_vel; // contactPosWorld.vsub(body0.position, rel_pos1);
    // contactPosWorld.vsub(body1.position, rel_pos2);
    body0.getVelocityAtWorldPoint(contactPosWorld, vel1);
    body1.getVelocityAtWorldPoint(contactPosWorld, vel2);
    vel1.vsub(vel2, vel);
    const vrel = frictionDirectionWorld.dot(vel);
    const denom0 = $0982bf0d3ab2ea42$var$computeImpulseDenominator(body0, frictionPosWorld, frictionDirectionWorld);
    const denom1 = $0982bf0d3ab2ea42$var$computeImpulseDenominator(body1, frictionPosWorld, frictionDirectionWorld);
    const relaxation = 1;
    const jacDiagABInv = relaxation / (denom0 + denom1); // calculate j that moves us to zero relative velocity
    j1 = -vrel * jacDiagABInv;
    if (maxImpulse < j1) j1 = maxImpulse;
    if (j1 < -maxImpulse) j1 = -maxImpulse;
    return j1;
}
const $0982bf0d3ab2ea42$var$computeImpulseDenominator_r0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$computeImpulseDenominator_c0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$computeImpulseDenominator_vec = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$computeImpulseDenominator_m = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
function $0982bf0d3ab2ea42$var$computeImpulseDenominator(body, pos, normal) {
    const r0 = $0982bf0d3ab2ea42$var$computeImpulseDenominator_r0;
    const c0 = $0982bf0d3ab2ea42$var$computeImpulseDenominator_c0;
    const vec = $0982bf0d3ab2ea42$var$computeImpulseDenominator_vec;
    const m = $0982bf0d3ab2ea42$var$computeImpulseDenominator_m;
    pos.vsub(body.position, r0);
    r0.cross(normal, c0);
    body.invInertiaWorld.vmult(c0, m);
    m.cross(r0, vec);
    return body.invMass + normal.dot(vec);
}
const $0982bf0d3ab2ea42$var$resolveSingleBilateral_vel1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$resolveSingleBilateral_vel2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$resolveSingleBilateral_vel = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // bilateral constraint between two dynamic objects
function $0982bf0d3ab2ea42$var$resolveSingleBilateral(body1, pos1, body2, pos2, normal) {
    const normalLenSqr = normal.lengthSquared();
    if (normalLenSqr > 1.1) return 0; // no impulse
     // const rel_pos1 = new Vec3();
    // const rel_pos2 = new Vec3();
    // pos1.vsub(body1.position, rel_pos1);
    // pos2.vsub(body2.position, rel_pos2);
    const vel1 = $0982bf0d3ab2ea42$var$resolveSingleBilateral_vel1;
    const vel2 = $0982bf0d3ab2ea42$var$resolveSingleBilateral_vel2;
    const vel = $0982bf0d3ab2ea42$var$resolveSingleBilateral_vel;
    body1.getVelocityAtWorldPoint(pos1, vel1);
    body2.getVelocityAtWorldPoint(pos2, vel2);
    vel1.vsub(vel2, vel);
    const rel_vel = normal.dot(vel);
    const contactDamping = 0.2;
    const massTerm = 1 / (body1.invMass + body2.invMass);
    const impulse = -contactDamping * rel_vel * massTerm;
    return impulse;
}
/**
 * Spherical shape
 * @example
 *     const radius = 1
 *     const sphereShape = new CANNON.Sphere(radius)
 *     const sphereBody = new CANNON.Body({ mass: 1, shape: sphereShape })
 *     world.addBody(sphereBody)
 */ class $0982bf0d3ab2ea42$export$805e8b72413ccaba extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /** calculateLocalInertia */ calculateLocalInertia(mass, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        const I = 2.0 * mass * this.radius * this.radius / 5.0;
        target.x = I;
        target.y = I;
        target.z = I;
        return target;
    }
    /** volume */ volume() {
        return 4.0 * Math.PI * Math.pow(this.radius, 3) / 3.0;
    }
    updateBoundingSphereRadius() {
        this.boundingSphereRadius = this.radius;
    }
    calculateWorldAABB(pos, quat, min, max) {
        const r = this.radius;
        const axes = [
            'x',
            'y',
            'z'
        ];
        for(let i = 0; i < axes.length; i++){
            const ax = axes[i];
            min[ax] = pos[ax] - r;
            max[ax] = pos[ax] + r;
        }
    }
    /**
   * The radius of the sphere.
   */ /**
   *
   * @param radius The radius of the sphere, a non-negative number.
   */ constructor(radius){
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE
        });
        this.radius = void 0;
        this.radius = radius !== undefined ? radius : 1.0;
        if (this.radius < 0) throw new Error('The sphere radius cannot be negative.');
        this.updateBoundingSphereRadius();
    }
}
/**
 * Simple vehicle helper class with spherical rigid body wheels.
 */ class $0982bf0d3ab2ea42$export$762f6e6d5ecffb40 {
    /**
   * Add a wheel
   */ addWheel(options = {}) {
        let wheelBody;
        if (options.body) wheelBody = options.body;
        else // No wheel body given. Create it!
        wheelBody = new $0982bf0d3ab2ea42$export$4b2c32e08f77ff18({
            mass: 1,
            shape: new $0982bf0d3ab2ea42$export$805e8b72413ccaba(1.2)
        });
        this.wheelBodies.push(wheelBody);
        this.wheelForces.push(0); // Position constrain wheels
        const position = typeof options.position !== 'undefined' ? options.position.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // Set position locally to the chassis
        const worldPosition = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.chassisBody.pointToWorldFrame(position, worldPosition);
        wheelBody.position.set(worldPosition.x, worldPosition.y, worldPosition.z); // Constrain wheel
        const axis = typeof options.axis !== 'undefined' ? options.axis.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 1);
        this.wheelAxes.push(axis);
        const hingeConstraint = new $0982bf0d3ab2ea42$export$18c5826321ba66b3(this.chassisBody, wheelBody, {
            pivotA: position,
            axisA: axis,
            pivotB: $0982bf0d3ab2ea42$export$838423f3adec30fa.ZERO,
            axisB: axis,
            collideConnected: false
        });
        this.constraints.push(hingeConstraint);
        return this.wheelBodies.length - 1;
    }
    /**
   * Set the steering value of a wheel.
   * @todo check coordinateSystem
   */ setSteeringValue(value, wheelIndex) {
        // Set angle of the hinge axis
        const axis = this.wheelAxes[wheelIndex];
        const c = Math.cos(value);
        const s = Math.sin(value);
        const x = axis.x;
        const z = axis.z;
        this.constraints[wheelIndex].axisA.set(-c * x + s * z, 0, s * x + c * z);
    }
    /**
   * Set the target rotational speed of the hinge constraint.
   */ setMotorSpeed(value, wheelIndex) {
        const hingeConstraint = this.constraints[wheelIndex];
        hingeConstraint.enableMotor();
        hingeConstraint.motorTargetVelocity = value;
    }
    /**
   * Set the target rotational speed of the hinge constraint.
   */ disableMotor(wheelIndex) {
        const hingeConstraint = this.constraints[wheelIndex];
        hingeConstraint.disableMotor();
    }
    /**
   * Set the wheel force to apply on one of the wheels each time step
   */ setWheelForce(value, wheelIndex) {
        this.wheelForces[wheelIndex] = value;
    }
    /**
   * Apply a torque on one of the wheels.
   */ applyWheelForce(value, wheelIndex) {
        const axis = this.wheelAxes[wheelIndex];
        const wheelBody = this.wheelBodies[wheelIndex];
        const bodyTorque = wheelBody.torque;
        axis.scale(value, $0982bf0d3ab2ea42$var$torque);
        wheelBody.vectorToWorldFrame($0982bf0d3ab2ea42$var$torque, $0982bf0d3ab2ea42$var$torque);
        bodyTorque.vadd($0982bf0d3ab2ea42$var$torque, bodyTorque);
    }
    /**
   * Add the vehicle including its constraints to the world.
   */ addToWorld(world) {
        const constraints = this.constraints;
        const bodies = this.wheelBodies.concat([
            this.chassisBody
        ]);
        for(let i = 0; i < bodies.length; i++)world.addBody(bodies[i]);
        for(let i = 0; i < constraints.length; i++)world.addConstraint(constraints[i]);
        world.addEventListener('preStep', this._update.bind(this));
    }
    _update() {
        const wheelForces = this.wheelForces;
        for(let i = 0; i < wheelForces.length; i++)this.applyWheelForce(wheelForces[i], i);
    }
    /**
   * Remove the vehicle including its constraints from the world.
   */ removeFromWorld(world) {
        const constraints = this.constraints;
        const bodies = this.wheelBodies.concat([
            this.chassisBody
        ]);
        for(let i = 0; i < bodies.length; i++)world.removeBody(bodies[i]);
        for(let i = 0; i < constraints.length; i++)world.removeConstraint(constraints[i]);
    }
    /**
   * Get current rotational velocity of a wheel
   */ getWheelSpeed(wheelIndex) {
        const axis = this.wheelAxes[wheelIndex];
        const wheelBody = this.wheelBodies[wheelIndex];
        const w = wheelBody.angularVelocity;
        this.chassisBody.vectorToWorldFrame(axis, $0982bf0d3ab2ea42$var$worldAxis);
        return w.dot($0982bf0d3ab2ea42$var$worldAxis);
    }
    /**
   * The bodies of the wheels.
   */ /**
   * The chassis body.
   */ /**
   * The constraints.
   */ /**
   * The wheel axes.
   */ /**
   * The wheel forces.
   */ constructor(options = {}){
        this.wheelBodies = void 0;
        this.coordinateSystem = void 0;
        this.chassisBody = void 0;
        this.constraints = void 0;
        this.wheelAxes = void 0;
        this.wheelForces = void 0;
        this.wheelBodies = [];
        this.coordinateSystem = typeof options.coordinateSystem !== 'undefined' ? options.coordinateSystem.clone() : new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 2, 3);
        if (options.chassisBody) this.chassisBody = options.chassisBody;
        else // No chassis body given. Create it!
        this.chassisBody = new $0982bf0d3ab2ea42$export$4b2c32e08f77ff18({
            mass: 1,
            shape: new $0982bf0d3ab2ea42$export$e71c4d32a2263218(new $0982bf0d3ab2ea42$export$838423f3adec30fa(5, 0.5, 2))
        });
        this.constraints = [];
        this.wheelAxes = [];
        this.wheelForces = [];
    }
}
const $0982bf0d3ab2ea42$var$torque = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$worldAxis = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Smoothed-particle hydrodynamics system
 * @todo Make parameters customizable in the constructor
 */ class $0982bf0d3ab2ea42$export$d42dc6617ebe1c44 {
    /**
   * Add a particle to the system.
   */ add(particle) {
        this.particles.push(particle);
        if (this.neighbors.length < this.particles.length) this.neighbors.push([]);
    }
    /**
   * Remove a particle from the system.
   */ remove(particle) {
        const idx = this.particles.indexOf(particle);
        if (idx !== -1) {
            this.particles.splice(idx, 1);
            if (this.neighbors.length > this.particles.length) this.neighbors.pop();
        }
    }
    /**
   * Get neighbors within smoothing volume, save in the array neighbors
   */ getNeighbors(particle, neighbors) {
        const N = this.particles.length;
        const id = particle.id;
        const R2 = this.smoothingRadius * this.smoothingRadius;
        const dist = $0982bf0d3ab2ea42$var$SPHSystem_getNeighbors_dist;
        for(let i = 0; i !== N; i++){
            const p = this.particles[i];
            p.position.vsub(particle.position, dist);
            if (id !== p.id && dist.lengthSquared() < R2) neighbors.push(p);
        }
    }
    update() {
        const N = this.particles.length;
        const dist = $0982bf0d3ab2ea42$var$SPHSystem_update_dist;
        const cs = this.speedOfSound;
        const eps = this.eps;
        for(let i = 0; i !== N; i++){
            const p = this.particles[i]; // Current particle
            const neighbors = this.neighbors[i]; // Get neighbors
            neighbors.length = 0;
            this.getNeighbors(p, neighbors);
            neighbors.push(this.particles[i]); // Add current too
            const numNeighbors = neighbors.length; // Accumulate density for the particle
            let sum = 0.0;
            for(let j = 0; j !== numNeighbors; j++){
                //printf("Current particle has position %f %f %f\n",objects[id].pos.x(),objects[id].pos.y(),objects[id].pos.z());
                p.position.vsub(neighbors[j].position, dist);
                const len = dist.length();
                const weight = this.w(len);
                sum += neighbors[j].mass * weight;
            } // Save
            this.densities[i] = sum;
            this.pressures[i] = cs * cs * (this.densities[i] - this.density);
        } // Add forces
        // Sum to these accelerations
        const a_pressure = $0982bf0d3ab2ea42$var$SPHSystem_update_a_pressure;
        const a_visc = $0982bf0d3ab2ea42$var$SPHSystem_update_a_visc;
        const gradW = $0982bf0d3ab2ea42$var$SPHSystem_update_gradW;
        const r_vec = $0982bf0d3ab2ea42$var$SPHSystem_update_r_vec;
        const u = $0982bf0d3ab2ea42$var$SPHSystem_update_u;
        for(let i = 0; i !== N; i++){
            const particle = this.particles[i];
            a_pressure.set(0, 0, 0);
            a_visc.set(0, 0, 0); // Init vars
            let Pij;
            let nabla;
            const neighbors = this.neighbors[i];
            const numNeighbors = neighbors.length; //printf("Neighbors: ");
            for(let j = 0; j !== numNeighbors; j++){
                const neighbor = neighbors[j]; //printf("%d ",nj);
                // Get r once for all..
                particle.position.vsub(neighbor.position, r_vec);
                const r = r_vec.length(); // Pressure contribution
                Pij = -neighbor.mass * (this.pressures[i] / (this.densities[i] * this.densities[i] + eps) + this.pressures[j] / (this.densities[j] * this.densities[j] + eps));
                this.gradw(r_vec, gradW); // Add to pressure acceleration
                gradW.scale(Pij, gradW);
                a_pressure.vadd(gradW, a_pressure); // Viscosity contribution
                neighbor.velocity.vsub(particle.velocity, u);
                u.scale(1.0 / (0.0001 + this.densities[i] * this.densities[j]) * this.viscosity * neighbor.mass, u);
                nabla = this.nablaw(r);
                u.scale(nabla, u); // Add to viscosity acceleration
                a_visc.vadd(u, a_visc);
            } // Calculate force
            a_visc.scale(particle.mass, a_visc);
            a_pressure.scale(particle.mass, a_pressure); // Add force to particles
            particle.force.vadd(a_visc, particle.force);
            particle.force.vadd(a_pressure, particle.force);
        }
    }
    w(r) {
        // 315
        const h = this.smoothingRadius;
        return 315.0 / (64.0 * Math.PI * h ** 9) * (h * h - r * r) ** 3;
    }
    gradw(rVec, resultVec) {
        const r = rVec.length();
        const h = this.smoothingRadius;
        rVec.scale(945.0 / (32.0 * Math.PI * h ** 9) * (h * h - r * r) ** 2, resultVec);
    }
    nablaw(r) {
        const h = this.smoothingRadius;
        const nabla = 945.0 / (32.0 * Math.PI * h ** 9) * (h * h - r * r) * (7 * r * r - 3 * h * h);
        return nabla;
    }
    /**
   * The particles array.
   */ /**
   * Density of the system (kg/m3).
   * @default 1
   */ /**
   * Distance below which two particles are considered to be neighbors.
   * It should be adjusted so there are about 15-20 neighbor particles within this radius.
   * @default 1
   */ /**
   * @default 1
   */ /**
   * Viscosity of the system.
   * @default 0.01
   */ /**
   * @default 0.000001
   */ constructor(){
        this.particles = void 0;
        this.density = void 0;
        this.smoothingRadius = void 0;
        this.speedOfSound = void 0;
        this.viscosity = void 0;
        this.eps = void 0;
        this.pressures = void 0;
        this.densities = void 0;
        this.neighbors = void 0;
        this.particles = [];
        this.density = 1;
        this.smoothingRadius = 1;
        this.speedOfSound = 1;
        this.viscosity = 0.01;
        this.eps = 0.000001; // Stuff Computed per particle
        this.pressures = [];
        this.densities = [];
        this.neighbors = [];
    }
}
const $0982bf0d3ab2ea42$var$SPHSystem_getNeighbors_dist = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // Temp vectors for calculation
const $0982bf0d3ab2ea42$var$SPHSystem_update_dist = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // Relative velocity
const $0982bf0d3ab2ea42$var$SPHSystem_update_a_pressure = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$SPHSystem_update_a_visc = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$SPHSystem_update_gradW = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$SPHSystem_update_r_vec = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$SPHSystem_update_u = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Cylinder class.
 * @example
 *     const radiusTop = 0.5
 *     const radiusBottom = 0.5
 *     const height = 2
 *     const numSegments = 12
 *     const cylinderShape = new CANNON.Cylinder(radiusTop, radiusBottom, height, numSegments)
 *     const cylinderBody = new CANNON.Body({ mass: 1, shape: cylinderShape })
 *     world.addBody(cylinderBody)
 */ class $0982bf0d3ab2ea42$export$665c37f020fe48f9 extends $0982bf0d3ab2ea42$export$7c637a75bc263948 {
    /** The radius of the top of the Cylinder. */ /** The radius of the bottom of the Cylinder. */ /** The height of the Cylinder. */ /** The number of segments to build the cylinder out of. */ /**
   * @param radiusTop The radius of the top of the Cylinder.
   * @param radiusBottom The radius of the bottom of the Cylinder.
   * @param height The height of the Cylinder.
   * @param numSegments The number of segments to build the cylinder out of.
   */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, numSegments = 8){
        if (radiusTop < 0) throw new Error('The cylinder radiusTop cannot be negative.');
        if (radiusBottom < 0) throw new Error('The cylinder radiusBottom cannot be negative.');
        const N = numSegments;
        const vertices = [];
        const axes = [];
        const faces = [];
        const bottomface = [];
        const topface = [];
        const cos = Math.cos;
        const sin = Math.sin; // First bottom point
        vertices.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa(-radiusBottom * sin(0), -height * 0.5, radiusBottom * cos(0)));
        bottomface.push(0); // First top point
        vertices.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa(-radiusTop * sin(0), height * 0.5, radiusTop * cos(0)));
        topface.push(1);
        for(let i = 0; i < N; i++){
            const theta = 2 * Math.PI / N * (i + 1);
            const thetaN = 2 * Math.PI / N * (i + 0.5);
            if (i < N - 1) {
                // Bottom
                vertices.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa(-radiusBottom * sin(theta), -height * 0.5, radiusBottom * cos(theta)));
                bottomface.push(2 * i + 2); // Top
                vertices.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa(-radiusTop * sin(theta), height * 0.5, radiusTop * cos(theta)));
                topface.push(2 * i + 3); // Face
                faces.push([
                    2 * i,
                    2 * i + 1,
                    2 * i + 3,
                    2 * i + 2
                ]);
            } else faces.push([
                2 * i,
                2 * i + 1,
                1,
                0
            ]); // Connect
             // Axis: we can cut off half of them if we have even number of segments
            if (N % 2 === 1 || i < N / 2) axes.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa(-sin(thetaN), 0, cos(thetaN)));
        }
        faces.push(bottomface);
        axes.push(new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 0)); // Reorder top face
        const temp = [];
        for(let i = 0; i < topface.length; i++)temp.push(topface[topface.length - i - 1]);
        faces.push(temp);
        super({
            vertices: vertices,
            faces: faces,
            axes: axes
        });
        this.radiusTop = void 0;
        this.radiusBottom = void 0;
        this.height = void 0;
        this.numSegments = void 0;
        this.type = $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER;
        this.radiusTop = radiusTop;
        this.radiusBottom = radiusBottom;
        this.height = height;
        this.numSegments = numSegments;
    }
}
/**
 * Particle shape.
 * @example
 *     const particleShape = new CANNON.Particle()
 *     const particleBody = new CANNON.Body({ mass: 1, shape: particleShape })
 *     world.addBody(particleBody)
 */ class $0982bf0d3ab2ea42$export$c36c68baa13912a5 extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /**
   * calculateLocalInertia
   */ calculateLocalInertia(mass, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        target.set(0, 0, 0);
        return target;
    }
    volume() {
        return 0;
    }
    updateBoundingSphereRadius() {
        this.boundingSphereRadius = 0;
    }
    calculateWorldAABB(pos, quat, min, max) {
        // Get each axis max
        min.copy(pos);
        max.copy(pos);
    }
    constructor(){
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PARTICLE
        });
    }
}
/**
 * A plane, facing in the Z direction. The plane has its surface at z=0 and everything below z=0 is assumed to be solid plane. To make the plane face in some other direction than z, you must put it inside a Body and rotate that body. See the demos.
 * @example
 *     const planeShape = new CANNON.Plane()
 *     const planeBody = new CANNON.Body({ mass: 0, shape:  planeShape })
 *     planeBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0) // make it face up
 *     world.addBody(planeBody)
 */ class $0982bf0d3ab2ea42$export$7ff5ac152ef991b0 extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /** computeWorldNormal */ computeWorldNormal(quat) {
        const n = this.worldNormal;
        n.set(0, 0, 1);
        quat.vmult(n, n);
        this.worldNormalNeedsUpdate = false;
    }
    calculateLocalInertia(mass, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        return target;
    }
    volume() {
        return Number.MAX_VALUE;
    }
    calculateWorldAABB(pos, quat, min, max) {
        // The plane AABB is infinite, except if the normal is pointing along any axis
        $0982bf0d3ab2ea42$var$tempNormal.set(0, 0, 1); // Default plane normal is z
        quat.vmult($0982bf0d3ab2ea42$var$tempNormal, $0982bf0d3ab2ea42$var$tempNormal);
        const maxVal = Number.MAX_VALUE;
        min.set(-maxVal, -maxVal, -maxVal);
        max.set(maxVal, maxVal, maxVal);
        if ($0982bf0d3ab2ea42$var$tempNormal.x === 1) max.x = pos.x;
        else if ($0982bf0d3ab2ea42$var$tempNormal.x === -1) min.x = pos.x;
        if ($0982bf0d3ab2ea42$var$tempNormal.y === 1) max.y = pos.y;
        else if ($0982bf0d3ab2ea42$var$tempNormal.y === -1) min.y = pos.y;
        if ($0982bf0d3ab2ea42$var$tempNormal.z === 1) max.z = pos.z;
        else if ($0982bf0d3ab2ea42$var$tempNormal.z === -1) min.z = pos.z;
    }
    updateBoundingSphereRadius() {
        this.boundingSphereRadius = Number.MAX_VALUE;
    }
    /** worldNormal */ /** worldNormalNeedsUpdate */ constructor(){
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE
        }); // World oriented normal
        this.worldNormal = void 0;
        this.worldNormalNeedsUpdate = void 0;
        this.boundingSphereRadius = void 0;
        this.worldNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.worldNormalNeedsUpdate = true;
        this.boundingSphereRadius = Number.MAX_VALUE;
    }
}
const $0982bf0d3ab2ea42$var$tempNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
/**
 * Heightfield shape class. Height data is given as an array. These data points are spread out evenly with a given distance.
 * @todo Should be possible to use along all axes, not just y
 * @todo should be possible to scale along all axes
 * @todo Refactor elementSize to elementSizeX and elementSizeY
 *
 * @example
 *     // Generate some height data (y-values).
 *     const data = []
 *     for (let i = 0; i < 1000; i++) {
 *         const y = 0.5 * Math.cos(0.2 * i)
 *         data.push(y)
 *     }
 *
 *     // Create the heightfield shape
 *     const heightfieldShape = new CANNON.Heightfield(data, {
 *         elementSize: 1 // Distance between the data points in X and Y directions
 *     })
 *     const heightfieldBody = new CANNON.Body({ shape: heightfieldShape })
 *     world.addBody(heightfieldBody)
 */ class $0982bf0d3ab2ea42$export$fa360b5b58f475b7 extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /**
   * Call whenever you change the data array.
   */ update() {
        this._cachedPillars = {};
    }
    /**
   * Update the `minValue` property
   */ updateMinValue() {
        const data = this.data;
        let minValue = data[0][0];
        for(let i = 0; i !== data.length; i++)for(let j = 0; j !== data[i].length; j++){
            const v = data[i][j];
            if (v < minValue) minValue = v;
        }
        this.minValue = minValue;
    }
    /**
   * Update the `maxValue` property
   */ updateMaxValue() {
        const data = this.data;
        let maxValue = data[0][0];
        for(let i = 0; i !== data.length; i++)for(let j = 0; j !== data[i].length; j++){
            const v = data[i][j];
            if (v > maxValue) maxValue = v;
        }
        this.maxValue = maxValue;
    }
    /**
   * Set the height value at an index. Don't forget to update maxValue and minValue after you're done.
   */ setHeightValueAtIndex(xi, yi, value) {
        const data = this.data;
        data[xi][yi] = value; // Invalidate cache
        this.clearCachedConvexTrianglePillar(xi, yi, false);
        if (xi > 0) {
            this.clearCachedConvexTrianglePillar(xi - 1, yi, true);
            this.clearCachedConvexTrianglePillar(xi - 1, yi, false);
        }
        if (yi > 0) {
            this.clearCachedConvexTrianglePillar(xi, yi - 1, true);
            this.clearCachedConvexTrianglePillar(xi, yi - 1, false);
        }
        if (yi > 0 && xi > 0) this.clearCachedConvexTrianglePillar(xi - 1, yi - 1, true);
    }
    /**
   * Get max/min in a rectangle in the matrix data
   * @param result An array to store the results in.
   * @return The result array, if it was passed in. Minimum will be at position 0 and max at 1.
   */ getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, result = []) {
        // Get max and min of the data
        const data = this.data; // Set first value
        let max = this.minValue;
        for(let i = iMinX; i <= iMaxX; i++)for(let j = iMinY; j <= iMaxY; j++){
            const height = data[i][j];
            if (height > max) max = height;
        }
        result[0] = this.minValue;
        result[1] = max;
    }
    /**
   * Get the index of a local position on the heightfield. The indexes indicate the rectangles, so if your terrain is made of N x N height data points, you will have rectangle indexes ranging from 0 to N-1.
   * @param result Two-element array
   * @param clamp If the position should be clamped to the heightfield edge.
   */ getIndexOfPosition(x, y, result, clamp) {
        // Get the index of the data points to test against
        const w = this.elementSize;
        const data = this.data;
        let xi = Math.floor(x / w);
        let yi = Math.floor(y / w);
        result[0] = xi;
        result[1] = yi;
        if (clamp) {
            // Clamp index to edges
            if (xi < 0) xi = 0;
            if (yi < 0) yi = 0;
            if (xi >= data.length - 1) xi = data.length - 1;
            if (yi >= data[0].length - 1) yi = data[0].length - 1;
        } // Bail out if we are out of the terrain
        if (xi < 0 || yi < 0 || xi >= data.length - 1 || yi >= data[0].length - 1) return false;
        return true;
    }
    getTriangleAt(x, y, edgeClamp, a, b, c) {
        const idx = $0982bf0d3ab2ea42$var$getHeightAt_idx;
        this.getIndexOfPosition(x, y, idx, edgeClamp);
        let xi = idx[0];
        let yi = idx[1];
        const data = this.data;
        if (edgeClamp) {
            xi = Math.min(data.length - 2, Math.max(0, xi));
            yi = Math.min(data[0].length - 2, Math.max(0, yi));
        }
        const elementSize = this.elementSize;
        const lowerDist2 = (x / elementSize - xi) ** 2 + (y / elementSize - yi) ** 2;
        const upperDist2 = (x / elementSize - (xi + 1)) ** 2 + (y / elementSize - (yi + 1)) ** 2;
        const upper = lowerDist2 > upperDist2;
        this.getTriangle(xi, yi, upper, a, b, c);
        return upper;
    }
    getNormalAt(x, y, edgeClamp, result) {
        const a = $0982bf0d3ab2ea42$var$getNormalAt_a;
        const b = $0982bf0d3ab2ea42$var$getNormalAt_b;
        const c = $0982bf0d3ab2ea42$var$getNormalAt_c;
        const e0 = $0982bf0d3ab2ea42$var$getNormalAt_e0;
        const e1 = $0982bf0d3ab2ea42$var$getNormalAt_e1;
        this.getTriangleAt(x, y, edgeClamp, a, b, c);
        b.vsub(a, e0);
        c.vsub(a, e1);
        e0.cross(e1, result);
        result.normalize();
    }
    /**
   * Get an AABB of a square in the heightfield
   * @param xi
   * @param yi
   * @param result
   */ getAabbAtIndex(xi, yi, { lowerBound: lowerBound, upperBound: upperBound }) {
        const data = this.data;
        const elementSize = this.elementSize;
        lowerBound.set(xi * elementSize, yi * elementSize, data[xi][yi]);
        upperBound.set((xi + 1) * elementSize, (yi + 1) * elementSize, data[xi + 1][yi + 1]);
    }
    /**
   * Get the height in the heightfield at a given position
   */ getHeightAt(x, y, edgeClamp) {
        const data = this.data;
        const a = $0982bf0d3ab2ea42$var$getHeightAt_a;
        const b = $0982bf0d3ab2ea42$var$getHeightAt_b;
        const c = $0982bf0d3ab2ea42$var$getHeightAt_c;
        const idx = $0982bf0d3ab2ea42$var$getHeightAt_idx;
        this.getIndexOfPosition(x, y, idx, edgeClamp);
        let xi = idx[0];
        let yi = idx[1];
        if (edgeClamp) {
            xi = Math.min(data.length - 2, Math.max(0, xi));
            yi = Math.min(data[0].length - 2, Math.max(0, yi));
        }
        const upper = this.getTriangleAt(x, y, edgeClamp, a, b, c);
        $0982bf0d3ab2ea42$var$barycentricWeights(x, y, a.x, a.y, b.x, b.y, c.x, c.y, $0982bf0d3ab2ea42$var$getHeightAt_weights);
        const w = $0982bf0d3ab2ea42$var$getHeightAt_weights;
        if (upper) // Top triangle verts
        return data[xi + 1][yi + 1] * w.x + data[xi][yi + 1] * w.y + data[xi + 1][yi] * w.z;
        else // Top triangle verts
        return data[xi][yi] * w.x + data[xi + 1][yi] * w.y + data[xi][yi + 1] * w.z;
    }
    getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle) {
        return xi + "_" + yi + "_" + (getUpperTriangle ? 1 : 0);
    }
    getCachedConvexTrianglePillar(xi, yi, getUpperTriangle) {
        return this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)];
    }
    setCachedConvexTrianglePillar(xi, yi, getUpperTriangle, convex, offset) {
        this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)] = {
            convex: convex,
            offset: offset
        };
    }
    clearCachedConvexTrianglePillar(xi, yi, getUpperTriangle) {
        delete this._cachedPillars[this.getCacheConvexTrianglePillarKey(xi, yi, getUpperTriangle)];
    }
    /**
   * Get a triangle from the heightfield
   */ getTriangle(xi, yi, upper, a, b, c) {
        const data = this.data;
        const elementSize = this.elementSize;
        if (upper) {
            // Top triangle verts
            a.set((xi + 1) * elementSize, (yi + 1) * elementSize, data[xi + 1][yi + 1]);
            b.set(xi * elementSize, (yi + 1) * elementSize, data[xi][yi + 1]);
            c.set((xi + 1) * elementSize, yi * elementSize, data[xi + 1][yi]);
        } else {
            // Top triangle verts
            a.set(xi * elementSize, yi * elementSize, data[xi][yi]);
            b.set((xi + 1) * elementSize, yi * elementSize, data[xi + 1][yi]);
            c.set(xi * elementSize, (yi + 1) * elementSize, data[xi][yi + 1]);
        }
    }
    /**
   * Get a triangle in the terrain in the form of a triangular convex shape.
   */ getConvexTrianglePillar(xi, yi, getUpperTriangle) {
        let result = this.pillarConvex;
        let offsetResult = this.pillarOffset;
        if (this.cacheEnabled) {
            const data = this.getCachedConvexTrianglePillar(xi, yi, getUpperTriangle);
            if (data) {
                this.pillarConvex = data.convex;
                this.pillarOffset = data.offset;
                return;
            }
            result = new $0982bf0d3ab2ea42$export$7c637a75bc263948();
            offsetResult = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            this.pillarConvex = result;
            this.pillarOffset = offsetResult;
        }
        const data = this.data;
        const elementSize = this.elementSize;
        const faces = result.faces; // Reuse verts if possible
        result.vertices.length = 6;
        for(let i = 0; i < 6; i++)if (!result.vertices[i]) result.vertices[i] = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
         // Reuse faces if possible
        faces.length = 5;
        for(let i = 0; i < 5; i++)if (!faces[i]) faces[i] = [];
        const verts = result.vertices;
        const h = (Math.min(data[xi][yi], data[xi + 1][yi], data[xi][yi + 1], data[xi + 1][yi + 1]) - this.minValue) / 2 + this.minValue;
        if (!getUpperTriangle) {
            // Center of the triangle pillar - all polygons are given relative to this one
            offsetResult.set((xi + 0.25) * elementSize, (yi + 0.25) * elementSize, h // vertical center
            ); // Top triangle verts
            verts[0].set(-0.25 * elementSize, -0.25 * elementSize, data[xi][yi] - h);
            verts[1].set(0.75 * elementSize, -0.25 * elementSize, data[xi + 1][yi] - h);
            verts[2].set(-0.25 * elementSize, 0.75 * elementSize, data[xi][yi + 1] - h); // bottom triangle verts
            verts[3].set(-0.25 * elementSize, -0.25 * elementSize, -Math.abs(h) - 1);
            verts[4].set(0.75 * elementSize, -0.25 * elementSize, -Math.abs(h) - 1);
            verts[5].set(-0.25 * elementSize, 0.75 * elementSize, -Math.abs(h) - 1); // top triangle
            faces[0][0] = 0;
            faces[0][1] = 1;
            faces[0][2] = 2; // bottom triangle
            faces[1][0] = 5;
            faces[1][1] = 4;
            faces[1][2] = 3; // -x facing quad
            faces[2][0] = 0;
            faces[2][1] = 2;
            faces[2][2] = 5;
            faces[2][3] = 3; // -y facing quad
            faces[3][0] = 1;
            faces[3][1] = 0;
            faces[3][2] = 3;
            faces[3][3] = 4; // +xy facing quad
            faces[4][0] = 4;
            faces[4][1] = 5;
            faces[4][2] = 2;
            faces[4][3] = 1;
        } else {
            // Center of the triangle pillar - all polygons are given relative to this one
            offsetResult.set((xi + 0.75) * elementSize, (yi + 0.75) * elementSize, h // vertical center
            ); // Top triangle verts
            verts[0].set(0.25 * elementSize, 0.25 * elementSize, data[xi + 1][yi + 1] - h);
            verts[1].set(-0.75 * elementSize, 0.25 * elementSize, data[xi][yi + 1] - h);
            verts[2].set(0.25 * elementSize, -0.75 * elementSize, data[xi + 1][yi] - h); // bottom triangle verts
            verts[3].set(0.25 * elementSize, 0.25 * elementSize, -Math.abs(h) - 1);
            verts[4].set(-0.75 * elementSize, 0.25 * elementSize, -Math.abs(h) - 1);
            verts[5].set(0.25 * elementSize, -0.75 * elementSize, -Math.abs(h) - 1); // Top triangle
            faces[0][0] = 0;
            faces[0][1] = 1;
            faces[0][2] = 2; // bottom triangle
            faces[1][0] = 5;
            faces[1][1] = 4;
            faces[1][2] = 3; // +x facing quad
            faces[2][0] = 2;
            faces[2][1] = 5;
            faces[2][2] = 3;
            faces[2][3] = 0; // +y facing quad
            faces[3][0] = 3;
            faces[3][1] = 4;
            faces[3][2] = 1;
            faces[3][3] = 0; // -xy facing quad
            faces[4][0] = 1;
            faces[4][1] = 4;
            faces[4][2] = 5;
            faces[4][3] = 2;
        }
        result.computeNormals();
        result.computeEdges();
        result.updateBoundingSphereRadius();
        this.setCachedConvexTrianglePillar(xi, yi, getUpperTriangle, result, offsetResult);
    }
    calculateLocalInertia(mass, target = new $0982bf0d3ab2ea42$export$838423f3adec30fa()) {
        target.set(0, 0, 0);
        return target;
    }
    volume() {
        return Number.MAX_VALUE;
    }
    calculateWorldAABB(pos, quat, min, max) {
        /** @TODO do it properly */ min.set(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        max.set(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    }
    updateBoundingSphereRadius() {
        // Use the bounding box of the min/max values
        const data = this.data;
        const s = this.elementSize;
        this.boundingSphereRadius = new $0982bf0d3ab2ea42$export$838423f3adec30fa(data.length * s, data[0].length * s, Math.max(Math.abs(this.maxValue), Math.abs(this.minValue))).length();
    }
    /**
   * Sets the height values from an image. Currently only supported in browser.
   */ setHeightsFromImage(image, scale) {
        const { x: x, z: z, y: y } = scale;
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0);
        const imageData = context.getImageData(0, 0, image.width, image.height);
        const matrix = this.data;
        matrix.length = 0;
        this.elementSize = Math.abs(x) / imageData.width;
        for(let i = 0; i < imageData.height; i++){
            const row = [];
            for(let j = 0; j < imageData.width; j++){
                const a = imageData.data[(i * imageData.height + j) * 4];
                const b = imageData.data[(i * imageData.height + j) * 4 + 1];
                const c = imageData.data[(i * imageData.height + j) * 4 + 2];
                const height = (a + b + c) / 4 / 255 * z;
                if (x < 0) row.push(height);
                else row.unshift(height);
            }
            if (y < 0) matrix.unshift(row);
            else matrix.push(row);
        }
        this.updateMaxValue();
        this.updateMinValue();
        this.update();
    }
    /**
   * An array of numbers, or height values, that are spread out along the x axis.
   */ /**
   * Max value of the data points in the data array.
   */ /**
   * Minimum value of the data points in the data array.
   */ /**
   * World spacing between the data points in X and Y direction.
   * @todo elementSizeX and Y
   * @default 1
   */ /**
   * @default true
   */ /**
   * @param data An array of numbers, or height values, that are spread out along the x axis.
   */ constructor(data, options = {}){
        options = $0982bf0d3ab2ea42$var$Utils.defaults(options, {
            maxValue: null,
            minValue: null,
            elementSize: 1
        });
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.HEIGHTFIELD
        });
        this.data = void 0;
        this.maxValue = void 0;
        this.minValue = void 0;
        this.elementSize = void 0;
        this.cacheEnabled = void 0;
        this.pillarConvex = void 0;
        this.pillarOffset = void 0;
        this._cachedPillars = void 0;
        this.data = data;
        this.maxValue = options.maxValue;
        this.minValue = options.minValue;
        this.elementSize = options.elementSize;
        if (options.minValue === null) this.updateMinValue();
        if (options.maxValue === null) this.updateMaxValue();
        this.cacheEnabled = true;
        this.pillarConvex = new $0982bf0d3ab2ea42$export$7c637a75bc263948();
        this.pillarOffset = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        this.updateBoundingSphereRadius(); // "i_j_isUpper" => { convex: ..., offset: ... }
        // for example:
        // _cachedPillars["0_2_1"]
        this._cachedPillars = {};
    }
}
const $0982bf0d3ab2ea42$var$getHeightAt_idx = [];
const $0982bf0d3ab2ea42$var$getHeightAt_weights = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getHeightAt_a = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getHeightAt_b = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getHeightAt_c = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getNormalAt_a = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getNormalAt_b = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getNormalAt_c = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getNormalAt_e0 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getNormalAt_e1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // from https://en.wikipedia.org/wiki/Barycentric_coordinate_system
function $0982bf0d3ab2ea42$var$barycentricWeights(x, y, ax, ay, bx, by, cx, cy, result) {
    result.x = ((by - cy) * (x - cx) + (cx - bx) * (y - cy)) / ((by - cy) * (ax - cx) + (cx - bx) * (ay - cy));
    result.y = ((cy - ay) * (x - cx) + (ax - cx) * (y - cy)) / ((by - cy) * (ax - cx) + (cx - bx) * (ay - cy));
    result.z = 1 - result.x - result.y;
}
/**
 * OctreeNode
 */ class $0982bf0d3ab2ea42$var$OctreeNode {
    /**
   * reset
   */ reset() {
        this.children.length = this.data.length = 0;
    }
    /**
   * Insert data into this node
   * @return True if successful, otherwise false
   */ insert(aabb, elementData, level = 0) {
        const nodeData = this.data; // Ignore objects that do not belong in this node
        if (!this.aabb.contains(aabb)) return false; // object cannot be added
        const children = this.children;
        const maxDepth = this.maxDepth || this.root.maxDepth;
        if (level < maxDepth) {
            // Subdivide if there are no children yet
            let subdivided = false;
            if (!children.length) {
                this.subdivide();
                subdivided = true;
            } // add to whichever node will accept it
            for(let i = 0; i !== 8; i++){
                if (children[i].insert(aabb, elementData, level + 1)) return true;
            }
            if (subdivided) // No children accepted! Might as well just remove em since they contain none
            children.length = 0;
        } // Too deep, or children didnt want it. add it in current node
        nodeData.push(elementData);
        return true;
    }
    /**
   * Create 8 equally sized children nodes and put them in the `children` array.
   */ subdivide() {
        const aabb = this.aabb;
        const l = aabb.lowerBound;
        const u = aabb.upperBound;
        const children = this.children;
        children.push(new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 0)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 0)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 1, 0)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 1, 1)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 1)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 0, 1)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 0, 1)
            })
        }), new $0982bf0d3ab2ea42$var$OctreeNode({
            aabb: new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa({
                lowerBound: new $0982bf0d3ab2ea42$export$838423f3adec30fa(0, 1, 0)
            })
        }));
        u.vsub(l, $0982bf0d3ab2ea42$var$halfDiagonal);
        $0982bf0d3ab2ea42$var$halfDiagonal.scale(0.5, $0982bf0d3ab2ea42$var$halfDiagonal);
        const root = this.root || this;
        for(let i = 0; i !== 8; i++){
            const child = children[i]; // Set current node as root
            child.root = root; // Compute bounds
            const lowerBound = child.aabb.lowerBound;
            lowerBound.x *= $0982bf0d3ab2ea42$var$halfDiagonal.x;
            lowerBound.y *= $0982bf0d3ab2ea42$var$halfDiagonal.y;
            lowerBound.z *= $0982bf0d3ab2ea42$var$halfDiagonal.z;
            lowerBound.vadd(l, lowerBound); // Upper bound is always lower bound + halfDiagonal
            lowerBound.vadd($0982bf0d3ab2ea42$var$halfDiagonal, child.aabb.upperBound);
        }
    }
    /**
   * Get all data, potentially within an AABB
   * @return The "result" object
   */ aabbQuery(aabb, result) {
        this.data; // abort if the range does not intersect this node
        // if (!this.aabb.overlaps(aabb)){
        //     return result;
        // }
        // Add objects at this level
        // Array.prototype.push.apply(result, nodeData);
        // Add child data
        // @todo unwrap recursion into a queue / loop, that's faster in JS
        this.children; // for (let i = 0, N = this.children.length; i !== N; i++) {
        //     children[i].aabbQuery(aabb, result);
        // }
        const queue = [
            this
        ];
        while(queue.length){
            const node = queue.pop();
            if (node.aabb.overlaps(aabb)) Array.prototype.push.apply(result, node.data);
            Array.prototype.push.apply(queue, node.children);
        }
        return result;
    }
    /**
   * Get all data, potentially intersected by a ray.
   * @return The "result" object
   */ rayQuery(ray, treeTransform, result) {
        // Use aabb query for now.
        /** @todo implement real ray query which needs less lookups */ ray.getAABB($0982bf0d3ab2ea42$var$tmpAABB);
        $0982bf0d3ab2ea42$var$tmpAABB.toLocalFrame(treeTransform, $0982bf0d3ab2ea42$var$tmpAABB);
        this.aabbQuery($0982bf0d3ab2ea42$var$tmpAABB, result);
        return result;
    }
    /**
   * removeEmptyNodes
   */ removeEmptyNodes() {
        for(let i = this.children.length - 1; i >= 0; i--){
            this.children[i].removeEmptyNodes();
            if (!this.children[i].children.length && !this.children[i].data.length) this.children.splice(i, 1);
        }
    }
    /** The root node */ /** Boundary of this node */ /** Contained data at the current node level */ /** Children to this node */ constructor(options = {}){
        this.root = void 0;
        this.aabb = void 0;
        this.data = void 0;
        this.children = void 0;
        this.root = options.root || null;
        this.aabb = options.aabb ? options.aabb.clone() : new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
        this.data = [];
        this.children = [];
    }
}
/**
 * Octree
 */ class $0982bf0d3ab2ea42$var$Octree extends $0982bf0d3ab2ea42$var$OctreeNode {
    /**
   * Maximum subdivision depth
   * @default 8
   */ /**
   * @param aabb The total AABB of the tree
   */ constructor(aabb, options = {}){
        super({
            root: null,
            aabb: aabb
        });
        this.maxDepth = void 0;
        this.maxDepth = typeof options.maxDepth !== 'undefined' ? options.maxDepth : 8;
    }
}
const $0982bf0d3ab2ea42$var$halfDiagonal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpAABB = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
/**
 * Trimesh.
 * @example
 *     // How to make a mesh with a single triangle
 *     const vertices = [
 *         0, 0, 0, // vertex 0
 *         1, 0, 0, // vertex 1
 *         0, 1, 0  // vertex 2
 *     ]
 *     const indices = [
 *         0, 1, 2  // triangle 0
 *     ]
 *     const trimeshShape = new CANNON.Trimesh(vertices, indices)
 */ class $0982bf0d3ab2ea42$export$2f616c27eb280dcb extends $0982bf0d3ab2ea42$export$6428a7f2611ef1fa {
    /**
   * updateTree
   */ updateTree() {
        const tree = this.tree;
        tree.reset();
        tree.aabb.copy(this.aabb);
        const scale = this.scale; // The local mesh AABB is scaled, but the octree AABB should be unscaled
        tree.aabb.lowerBound.x *= 1 / scale.x;
        tree.aabb.lowerBound.y *= 1 / scale.y;
        tree.aabb.lowerBound.z *= 1 / scale.z;
        tree.aabb.upperBound.x *= 1 / scale.x;
        tree.aabb.upperBound.y *= 1 / scale.y;
        tree.aabb.upperBound.z *= 1 / scale.z; // Insert all triangles
        const triangleAABB = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
        const a = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const b = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const c = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const points = [
            a,
            b,
            c
        ];
        for(let i = 0; i < this.indices.length / 3; i++){
            //this.getTriangleVertices(i, a, b, c);
            // Get unscaled triangle verts
            const i3 = i * 3;
            this._getUnscaledVertex(this.indices[i3], a);
            this._getUnscaledVertex(this.indices[i3 + 1], b);
            this._getUnscaledVertex(this.indices[i3 + 2], c);
            triangleAABB.setFromPoints(points);
            tree.insert(triangleAABB, i);
        }
        tree.removeEmptyNodes();
    }
    /**
   * Get triangles in a local AABB from the trimesh.
   * @param result An array of integers, referencing the queried triangles.
   */ getTrianglesInAABB(aabb, result) {
        $0982bf0d3ab2ea42$var$unscaledAABB.copy(aabb); // Scale it to local
        const scale = this.scale;
        const isx = scale.x;
        const isy = scale.y;
        const isz = scale.z;
        const l = $0982bf0d3ab2ea42$var$unscaledAABB.lowerBound;
        const u = $0982bf0d3ab2ea42$var$unscaledAABB.upperBound;
        l.x /= isx;
        l.y /= isy;
        l.z /= isz;
        u.x /= isx;
        u.y /= isy;
        u.z /= isz;
        return this.tree.aabbQuery($0982bf0d3ab2ea42$var$unscaledAABB, result);
    }
    /**
   * setScale
   */ setScale(scale) {
        const wasUniform = this.scale.x === this.scale.y && this.scale.y === this.scale.z;
        const isUniform = scale.x === scale.y && scale.y === scale.z;
        if (!(wasUniform && isUniform)) // Non-uniform scaling. Need to update normals.
        this.updateNormals();
        this.scale.copy(scale);
        this.updateAABB();
        this.updateBoundingSphereRadius();
    }
    /**
   * Compute the normals of the faces. Will save in the `.normals` array.
   */ updateNormals() {
        const n = $0982bf0d3ab2ea42$var$computeNormals_n; // Generate normals
        const normals = this.normals;
        for(let i = 0; i < this.indices.length / 3; i++){
            const i3 = i * 3;
            const a = this.indices[i3];
            const b = this.indices[i3 + 1];
            const c = this.indices[i3 + 2];
            this.getVertex(a, $0982bf0d3ab2ea42$var$va);
            this.getVertex(b, $0982bf0d3ab2ea42$var$vb);
            this.getVertex(c, $0982bf0d3ab2ea42$var$vc);
            $0982bf0d3ab2ea42$export$2f616c27eb280dcb.computeNormal($0982bf0d3ab2ea42$var$vb, $0982bf0d3ab2ea42$var$va, $0982bf0d3ab2ea42$var$vc, n);
            normals[i3] = n.x;
            normals[i3 + 1] = n.y;
            normals[i3 + 2] = n.z;
        }
    }
    /**
   * Update the `.edges` property
   */ updateEdges() {
        const edges = {};
        const add = (a, b)=>{
            const key = a < b ? a + "_" + b : b + "_" + a;
            edges[key] = true;
        };
        for(let i = 0; i < this.indices.length / 3; i++){
            const i3 = i * 3;
            const a = this.indices[i3];
            const b = this.indices[i3 + 1];
            const c = this.indices[i3 + 2];
            add(a, b);
            add(b, c);
            add(c, a);
        }
        const keys = Object.keys(edges);
        this.edges = new Int16Array(keys.length * 2);
        for(let i = 0; i < keys.length; i++){
            const indices = keys[i].split('_');
            this.edges[2 * i] = parseInt(indices[0], 10);
            this.edges[2 * i + 1] = parseInt(indices[1], 10);
        }
    }
    /**
   * Get an edge vertex
   * @param firstOrSecond 0 or 1, depending on which one of the vertices you need.
   * @param vertexStore Where to store the result
   */ getEdgeVertex(edgeIndex, firstOrSecond, vertexStore) {
        const vertexIndex = this.edges[edgeIndex * 2 + (firstOrSecond ? 1 : 0)];
        this.getVertex(vertexIndex, vertexStore);
    }
    /**
   * Get a vector along an edge.
   */ getEdgeVector(edgeIndex, vectorStore) {
        const va = $0982bf0d3ab2ea42$var$getEdgeVector_va;
        const vb = $0982bf0d3ab2ea42$var$getEdgeVector_vb;
        this.getEdgeVertex(edgeIndex, 0, va);
        this.getEdgeVertex(edgeIndex, 1, vb);
        vb.vsub(va, vectorStore);
    }
    /**
   * Get face normal given 3 vertices
   */ static computeNormal(va, vb, vc, target) {
        vb.vsub(va, $0982bf0d3ab2ea42$var$ab);
        vc.vsub(vb, $0982bf0d3ab2ea42$var$cb);
        $0982bf0d3ab2ea42$var$cb.cross($0982bf0d3ab2ea42$var$ab, target);
        if (!target.isZero()) target.normalize();
    }
    /**
   * Get vertex i.
   * @return The "out" vector object
   */ getVertex(i, out) {
        const scale = this.scale;
        this._getUnscaledVertex(i, out);
        out.x *= scale.x;
        out.y *= scale.y;
        out.z *= scale.z;
        return out;
    }
    /**
   * Get raw vertex i
   * @return The "out" vector object
   */ _getUnscaledVertex(i, out) {
        const i3 = i * 3;
        const vertices = this.vertices;
        return out.set(vertices[i3], vertices[i3 + 1], vertices[i3 + 2]);
    }
    /**
   * Get a vertex from the trimesh,transformed by the given position and quaternion.
   * @return The "out" vector object
   */ getWorldVertex(i, pos, quat, out) {
        this.getVertex(i, out);
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(pos, quat, out, out);
        return out;
    }
    /**
   * Get the three vertices for triangle i.
   */ getTriangleVertices(i, a, b, c) {
        const i3 = i * 3;
        this.getVertex(this.indices[i3], a);
        this.getVertex(this.indices[i3 + 1], b);
        this.getVertex(this.indices[i3 + 2], c);
    }
    /**
   * Compute the normal of triangle i.
   * @return The "target" vector object
   */ getNormal(i, target) {
        const i3 = i * 3;
        return target.set(this.normals[i3], this.normals[i3 + 1], this.normals[i3 + 2]);
    }
    /**
   * @return The "target" vector object
   */ calculateLocalInertia(mass, target) {
        // Approximate with box inertia
        // Exact inertia calculation is overkill, but see http://geometrictools.com/Documentation/PolyhedralMassProperties.pdf for the correct way to do it
        this.computeLocalAABB($0982bf0d3ab2ea42$var$cli_aabb);
        const x = $0982bf0d3ab2ea42$var$cli_aabb.upperBound.x - $0982bf0d3ab2ea42$var$cli_aabb.lowerBound.x;
        const y = $0982bf0d3ab2ea42$var$cli_aabb.upperBound.y - $0982bf0d3ab2ea42$var$cli_aabb.lowerBound.y;
        const z = $0982bf0d3ab2ea42$var$cli_aabb.upperBound.z - $0982bf0d3ab2ea42$var$cli_aabb.lowerBound.z;
        return target.set(1.0 / 12.0 * mass * (2 * y * 2 * y + 2 * z * 2 * z), 1.0 / 12.0 * mass * (2 * x * 2 * x + 2 * z * 2 * z), 1.0 / 12.0 * mass * (2 * y * 2 * y + 2 * x * 2 * x));
    }
    /**
   * Compute the local AABB for the trimesh
   */ computeLocalAABB(aabb) {
        const l = aabb.lowerBound;
        const u = aabb.upperBound;
        const n = this.vertices.length;
        this.vertices;
        const v = $0982bf0d3ab2ea42$var$computeLocalAABB_worldVert;
        this.getVertex(0, v);
        l.copy(v);
        u.copy(v);
        for(let i = 0; i !== n; i++){
            this.getVertex(i, v);
            if (v.x < l.x) l.x = v.x;
            else if (v.x > u.x) u.x = v.x;
            if (v.y < l.y) l.y = v.y;
            else if (v.y > u.y) u.y = v.y;
            if (v.z < l.z) l.z = v.z;
            else if (v.z > u.z) u.z = v.z;
        }
    }
    /**
   * Update the `.aabb` property
   */ updateAABB() {
        this.computeLocalAABB(this.aabb);
    }
    /**
   * Will update the `.boundingSphereRadius` property
   */ updateBoundingSphereRadius() {
        // Assume points are distributed with local (0,0,0) as center
        let max2 = 0;
        const vertices = this.vertices;
        const v = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        for(let i = 0, N = vertices.length / 3; i !== N; i++){
            this.getVertex(i, v);
            const norm2 = v.lengthSquared();
            if (norm2 > max2) max2 = norm2;
        }
        this.boundingSphereRadius = Math.sqrt(max2);
    }
    /**
   * calculateWorldAABB
   */ calculateWorldAABB(pos, quat, min, max) {
        /*
        const n = this.vertices.length / 3,
            verts = this.vertices;
        const minx,miny,minz,maxx,maxy,maxz;
         const v = tempWorldVertex;
        for(let i=0; i<n; i++){
            this.getVertex(i, v);
            quat.vmult(v, v);
            pos.vadd(v, v);
            if (v.x < minx || minx===undefined){
                minx = v.x;
            } else if(v.x > maxx || maxx===undefined){
                maxx = v.x;
            }
             if (v.y < miny || miny===undefined){
                miny = v.y;
            } else if(v.y > maxy || maxy===undefined){
                maxy = v.y;
            }
             if (v.z < minz || minz===undefined){
                minz = v.z;
            } else if(v.z > maxz || maxz===undefined){
                maxz = v.z;
            }
        }
        min.set(minx,miny,minz);
        max.set(maxx,maxy,maxz);
        */ // Faster approximation using local AABB
        const frame = $0982bf0d3ab2ea42$var$calculateWorldAABB_frame;
        const result = $0982bf0d3ab2ea42$var$calculateWorldAABB_aabb;
        frame.position = pos;
        frame.quaternion = quat;
        this.aabb.toWorldFrame(frame, result);
        min.copy(result.lowerBound);
        max.copy(result.upperBound);
    }
    /**
   * Get approximate volume
   */ volume() {
        return 4.0 * Math.PI * this.boundingSphereRadius / 3.0;
    }
    /**
   * Create a Trimesh instance, shaped as a torus.
   */ static createTorus(radius = 1, tube = 0.5, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2) {
        const vertices = [];
        const indices = [];
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            const x = (radius + tube * Math.cos(v)) * Math.cos(u);
            const y = (radius + tube * Math.cos(v)) * Math.sin(u);
            const z = tube * Math.sin(v);
            vertices.push(x, y, z);
        }
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        return new $0982bf0d3ab2ea42$export$2f616c27eb280dcb(vertices, indices);
    }
    /**
   * vertices
   */ /**
   * Array of integers, indicating which vertices each triangle consists of. The length of this array is thus 3 times the number of triangles.
   */ /**
   * The normals data.
   */ /**
   * The local AABB of the mesh.
   */ /**
   * References to vertex pairs, making up all unique edges in the trimesh.
   */ /**
   * Local scaling of the mesh. Use .setScale() to set it.
   */ /**
   * The indexed triangles. Use .updateTree() to update it.
   */ constructor(vertices, indices){
        super({
            type: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.TRIMESH
        });
        this.vertices = void 0;
        this.indices = void 0;
        this.normals = void 0;
        this.aabb = void 0;
        this.edges = void 0;
        this.scale = void 0;
        this.tree = void 0;
        this.vertices = new Float32Array(vertices);
        this.indices = new Int16Array(indices);
        this.normals = new Float32Array(indices.length);
        this.aabb = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
        this.edges = null;
        this.scale = new $0982bf0d3ab2ea42$export$838423f3adec30fa(1, 1, 1);
        this.tree = new $0982bf0d3ab2ea42$var$Octree();
        this.updateEdges();
        this.updateNormals();
        this.updateAABB();
        this.updateBoundingSphereRadius();
        this.updateTree();
    }
}
const $0982bf0d3ab2ea42$var$computeNormals_n = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$unscaledAABB = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$getEdgeVector_va = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$getEdgeVector_vb = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$cb = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$ab = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$va = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$vb = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$vc = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$cli_aabb = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$computeLocalAABB_worldVert = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$calculateWorldAABB_frame = new $0982bf0d3ab2ea42$export$563a914cafbdc389();
const $0982bf0d3ab2ea42$var$calculateWorldAABB_aabb = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
/**
 * Constraint equation solver base class.
 */ class $0982bf0d3ab2ea42$export$cca492cadf45c096 {
    /**
   * Should be implemented in subclasses!
   * @todo use abstract
   * @return number of iterations performed
   */ solve(dt, world) {
        return 0;
    }
    /**
   * Add an equation
   */ addEquation(eq) {
        if (eq.enabled && !eq.bi.isTrigger && !eq.bj.isTrigger) this.equations.push(eq);
    }
    /**
   * Remove an equation
   */ removeEquation(eq) {
        const eqs = this.equations;
        const i = eqs.indexOf(eq);
        if (i !== -1) eqs.splice(i, 1);
    }
    /**
   * Add all equations
   */ removeAllEquations() {
        this.equations.length = 0;
    }
    /**
   * All equations to be solved
   */ /**
   * @todo remove useless constructor
   */ constructor(){
        this.equations = void 0;
        this.equations = [];
    }
}
/**
 * Constraint equation Gauss-Seidel solver.
 * @todo The spook parameters should be specified for each constraint, not globally.
 * @see https://www8.cs.umu.se/kurser/5DV058/VT09/lectures/spooknotes.pdf
 */ class $0982bf0d3ab2ea42$export$2ee2332ebe4d942 extends $0982bf0d3ab2ea42$export$cca492cadf45c096 {
    /**
   * Solve
   * @return number of iterations performed
   */ solve(dt, world) {
        let iter = 0;
        const maxIter = this.iterations;
        const tolSquared = this.tolerance * this.tolerance;
        const equations = this.equations;
        const Neq = equations.length;
        const bodies = world.bodies;
        const Nbodies = bodies.length;
        const h = dt;
        let B;
        let invC;
        let deltalambda;
        let deltalambdaTot;
        let GWlambda;
        let lambdaj; // Update solve mass
        if (Neq !== 0) for(let i = 0; i !== Nbodies; i++)bodies[i].updateSolveMassProperties();
         // Things that do not change during iteration can be computed once
        const invCs = $0982bf0d3ab2ea42$var$GSSolver_solve_invCs;
        const Bs = $0982bf0d3ab2ea42$var$GSSolver_solve_Bs;
        const lambda = $0982bf0d3ab2ea42$var$GSSolver_solve_lambda;
        invCs.length = Neq;
        Bs.length = Neq;
        lambda.length = Neq;
        for(let i = 0; i !== Neq; i++){
            const c = equations[i];
            lambda[i] = 0.0;
            Bs[i] = c.computeB(h);
            invCs[i] = 1.0 / c.computeC();
        }
        if (Neq !== 0) {
            // Reset vlambda
            for(let i = 0; i !== Nbodies; i++){
                const b = bodies[i];
                const vlambda = b.vlambda;
                const wlambda = b.wlambda;
                vlambda.set(0, 0, 0);
                wlambda.set(0, 0, 0);
            } // Iterate over equations
            for(iter = 0; iter !== maxIter; iter++){
                // Accumulate the total error for each iteration.
                deltalambdaTot = 0.0;
                for(let j = 0; j !== Neq; j++){
                    const c = equations[j]; // Compute iteration
                    B = Bs[j];
                    invC = invCs[j];
                    lambdaj = lambda[j];
                    GWlambda = c.computeGWlambda();
                    deltalambda = invC * (B - GWlambda - c.eps * lambdaj); // Clamp if we are not within the min/max interval
                    if (lambdaj + deltalambda < c.minForce) deltalambda = c.minForce - lambdaj;
                    else if (lambdaj + deltalambda > c.maxForce) deltalambda = c.maxForce - lambdaj;
                    lambda[j] += deltalambda;
                    deltalambdaTot += deltalambda > 0.0 ? deltalambda : -deltalambda; // abs(deltalambda)
                    c.addToWlambda(deltalambda);
                } // If the total error is small enough - stop iterate
                if (deltalambdaTot * deltalambdaTot < tolSquared) break;
            } // Add result to velocity
            for(let i = 0; i !== Nbodies; i++){
                const b = bodies[i];
                const v = b.velocity;
                const w = b.angularVelocity;
                b.vlambda.vmul(b.linearFactor, b.vlambda);
                v.vadd(b.vlambda, v);
                b.wlambda.vmul(b.angularFactor, b.wlambda);
                w.vadd(b.wlambda, w);
            } // Set the `.multiplier` property of each equation
            let l = equations.length;
            const invDt = 1 / h;
            while(l--)equations[l].multiplier = lambda[l] * invDt;
        }
        return iter;
    }
    /**
   * The number of solver iterations determines quality of the constraints in the world.
   * The more iterations, the more correct simulation. More iterations need more computations though. If you have a large gravity force in your world, you will need more iterations.
   */ /**
   * When tolerance is reached, the system is assumed to be converged.
   */ /**
   * @todo remove useless constructor
   */ constructor(){
        super();
        this.iterations = void 0;
        this.tolerance = void 0;
        this.iterations = 10;
        this.tolerance = 1e-7;
    }
} // Just temporary number holders that we want to reuse each iteration.
const $0982bf0d3ab2ea42$var$GSSolver_solve_lambda = [];
const $0982bf0d3ab2ea42$var$GSSolver_solve_invCs = [];
const $0982bf0d3ab2ea42$var$GSSolver_solve_Bs = [];
/**
 * Splits the equations into islands and solves them independently. Can improve performance.
 */ class $0982bf0d3ab2ea42$export$e4ea195f3afc2e8b extends $0982bf0d3ab2ea42$export$cca492cadf45c096 {
    /**
   * createNode
   */ createNode() {
        return {
            body: null,
            children: [],
            eqs: [],
            visited: false
        };
    }
    /**
   * Solve the subsystems
   * @return number of iterations performed
   */ solve(dt, world) {
        const nodes = $0982bf0d3ab2ea42$var$SplitSolver_solve_nodes;
        const nodePool = this.nodePool;
        const bodies = world.bodies;
        const equations = this.equations;
        const Neq = equations.length;
        const Nbodies = bodies.length;
        const subsolver = this.subsolver; // Create needed nodes, reuse if possible
        while(nodePool.length < Nbodies)nodePool.push(this.createNode());
        nodes.length = Nbodies;
        for(let i = 0; i < Nbodies; i++)nodes[i] = nodePool[i];
         // Reset node values
        for(let i = 0; i !== Nbodies; i++){
            const node = nodes[i];
            node.body = bodies[i];
            node.children.length = 0;
            node.eqs.length = 0;
            node.visited = false;
        }
        for(let k = 0; k !== Neq; k++){
            const eq = equations[k];
            const i = bodies.indexOf(eq.bi);
            const j = bodies.indexOf(eq.bj);
            const ni = nodes[i];
            const nj = nodes[j];
            ni.children.push(nj);
            ni.eqs.push(eq);
            nj.children.push(ni);
            nj.eqs.push(eq);
        }
        let child;
        let n = 0;
        let eqs = $0982bf0d3ab2ea42$var$SplitSolver_solve_eqs;
        subsolver.tolerance = this.tolerance;
        subsolver.iterations = this.iterations;
        const dummyWorld = $0982bf0d3ab2ea42$var$SplitSolver_solve_dummyWorld;
        while(child = $0982bf0d3ab2ea42$var$getUnvisitedNode(nodes)){
            eqs.length = 0;
            dummyWorld.bodies.length = 0;
            $0982bf0d3ab2ea42$var$bfs(child, $0982bf0d3ab2ea42$var$visitFunc, dummyWorld.bodies, eqs);
            const Neqs = eqs.length;
            eqs = eqs.sort($0982bf0d3ab2ea42$var$sortById);
            for(let i = 0; i !== Neqs; i++)subsolver.addEquation(eqs[i]);
            subsolver.solve(dt, dummyWorld);
            subsolver.removeAllEquations();
            n++;
        }
        return n;
    }
    /**
   * The number of solver iterations determines quality of the constraints in the world. The more iterations, the more correct simulation. More iterations need more computations though. If you have a large gravity force in your world, you will need more iterations.
   */ /**
   * When tolerance is reached, the system is assumed to be converged.
   */ /** subsolver */ constructor(subsolver){
        super();
        this.iterations = void 0;
        this.tolerance = void 0;
        this.subsolver = void 0;
        this.nodes = void 0;
        this.nodePool = void 0;
        this.iterations = 10;
        this.tolerance = 1e-7;
        this.subsolver = subsolver;
        this.nodes = [];
        this.nodePool = []; // Create needed nodes, reuse if possible
        while(this.nodePool.length < 128)this.nodePool.push(this.createNode());
    }
} // Returns the number of subsystems
const $0982bf0d3ab2ea42$var$SplitSolver_solve_nodes = []; // All allocated node objects
const $0982bf0d3ab2ea42$var$SplitSolver_solve_eqs = []; // Temp array
const $0982bf0d3ab2ea42$var$SplitSolver_solve_dummyWorld = {
    bodies: []
}; // Temp object
const $0982bf0d3ab2ea42$var$STATIC = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC;
function $0982bf0d3ab2ea42$var$getUnvisitedNode(nodes) {
    const Nnodes = nodes.length;
    for(let i = 0; i !== Nnodes; i++){
        const node = nodes[i];
        if (!node.visited && !(node.body.type & $0982bf0d3ab2ea42$var$STATIC)) return node;
    }
    return false;
}
const $0982bf0d3ab2ea42$var$queue = [];
function $0982bf0d3ab2ea42$var$bfs(root, visitFunc, bds, eqs) {
    $0982bf0d3ab2ea42$var$queue.push(root);
    root.visited = true;
    visitFunc(root, bds, eqs);
    while($0982bf0d3ab2ea42$var$queue.length){
        const node = $0982bf0d3ab2ea42$var$queue.pop(); // Loop over unvisited child nodes
        let child;
        while(child = $0982bf0d3ab2ea42$var$getUnvisitedNode(node.children)){
            child.visited = true;
            visitFunc(child, bds, eqs);
            $0982bf0d3ab2ea42$var$queue.push(child);
        }
    }
}
function $0982bf0d3ab2ea42$var$visitFunc(node, bds, eqs) {
    bds.push(node.body);
    const Neqs = node.eqs.length;
    for(let i = 0; i !== Neqs; i++){
        const eq = node.eqs[i];
        if (!eqs.includes(eq)) eqs.push(eq);
    }
}
function $0982bf0d3ab2ea42$var$sortById(a, b) {
    return b.id - a.id;
}
/**
 * For pooling objects that can be reused.
 */ class $0982bf0d3ab2ea42$export$14963ee5c8637e11 {
    /**
   * Release an object after use
   */ release(...args) {
        const Nargs = args.length;
        for(let i = 0; i !== Nargs; i++)this.objects.push(args[i]);
        return this;
    }
    /**
   * Get an object
   */ get() {
        if (this.objects.length === 0) return this.constructObject();
        else return this.objects.pop();
    }
    /**
   * Construct an object. Should be implemented in each subclass.
   */ constructObject() {
        throw new Error('constructObject() not implemented in this Pool subclass yet!');
    }
    /**
   * @return Self, for chaining
   */ resize(size) {
        const objects = this.objects;
        while(objects.length > size)objects.pop();
        while(objects.length < size)objects.push(this.constructObject());
        return this;
    }
    constructor(){
        this.objects = [];
        this.type = Object;
    }
}
/**
 * Vec3Pool
 */ class $0982bf0d3ab2ea42$export$8cab54e48d922244 extends $0982bf0d3ab2ea42$export$14963ee5c8637e11 {
    /**
   * Construct a vector
   */ constructObject() {
        return new $0982bf0d3ab2ea42$export$838423f3adec30fa();
    }
    constructor(...args){
        super(...args);
        this.type = $0982bf0d3ab2ea42$export$838423f3adec30fa;
    }
}
let $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe2, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxB, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe3, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe4, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan2, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxC, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe5, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxH, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv2, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe6, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan3, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxP, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv3, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$cyli, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe7, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan4, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxC2, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv4, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$heig, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$part, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe8, $0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan5;
// Naming rule: based of the order in SHAPE_TYPES,
// the first part of the method is formed by the
// shape type that comes before, in the second part
// there is the shape type that comes after in the SHAPE_TYPES list
const $0982bf0d3ab2ea42$export$fbd062e3e69f69f1 = {
    sphereSphere: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE,
    spherePlane: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE,
    boxBox: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX,
    sphereBox: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX,
    planeBox: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX,
    convexConvex: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON,
    sphereConvex: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON,
    planeConvex: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON,
    boxConvex: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON,
    sphereHeightfield: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.HEIGHTFIELD,
    boxHeightfield: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.HEIGHTFIELD,
    convexHeightfield: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.HEIGHTFIELD,
    sphereParticle: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PARTICLE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE,
    planeParticle: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PARTICLE,
    boxParticle: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PARTICLE,
    convexParticle: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PARTICLE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON,
    cylinderCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    sphereCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    planeCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    boxCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.BOX | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    convexCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CONVEXPOLYHEDRON | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    heightfieldCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.HEIGHTFIELD | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    particleCylinder: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PARTICLE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.CYLINDER,
    sphereTrimesh: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.SPHERE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.TRIMESH,
    planeTrimesh: $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.PLANE | $0982bf0d3ab2ea42$export$6428a7f2611ef1fa.types.TRIMESH
};
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereSphere;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe2 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.spherePlane;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxB = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.boxBox;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe3 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereBox;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.planeBox;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.convexConvex;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe4 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereConvex;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan2 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.planeConvex;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxC = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.boxConvex;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe5 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereHeightfield;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxH = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.boxHeightfield;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv2 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.convexHeightfield;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe6 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereParticle;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan3 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.planeParticle;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxP = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.boxParticle;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv3 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.convexParticle;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$cyli = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.cylinderCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe7 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan4 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.planeCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxC2 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.boxCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv4 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.convexCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$heig = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.heightfieldCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$part = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.particleCylinder;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe8 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.sphereTrimesh;
$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan5 = $0982bf0d3ab2ea42$export$fbd062e3e69f69f1.planeTrimesh;
/**
 * Helper class for the World. Generates ContactEquations.
 * @todo Sphere-ConvexPolyhedron contacts
 * @todo Contact reduction
 * @todo should move methods to prototype
 */ class $0982bf0d3ab2ea42$export$9e9d3b163351dd02 {
    /**
   * Internal storage of pooled contact points.
   */ /**
   * Pooled vectors.
   */ get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe]() {
        return this.sphereSphere;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe2]() {
        return this.spherePlane;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxB]() {
        return this.boxBox;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe3]() {
        return this.sphereBox;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan]() {
        return this.planeBox;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv]() {
        return this.convexConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe4]() {
        return this.sphereConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan2]() {
        return this.planeConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxC]() {
        return this.boxConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe5]() {
        return this.sphereHeightfield;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxH]() {
        return this.boxHeightfield;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv2]() {
        return this.convexHeightfield;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe6]() {
        return this.sphereParticle;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan3]() {
        return this.planeParticle;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxP]() {
        return this.boxParticle;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv3]() {
        return this.convexParticle;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$cyli]() {
        return this.convexConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe7]() {
        return this.sphereConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan4]() {
        return this.planeConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$boxC2]() {
        return this.boxConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$conv4]() {
        return this.convexConvex;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$heig]() {
        return this.heightfieldCylinder;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$part]() {
        return this.particleCylinder;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$sphe8]() {
        return this.sphereTrimesh;
    }
    get [$0982bf0d3ab2ea42$var$_COLLISION_TYPES$plan5]() {
        return this.planeTrimesh;
    }
    /**
   * Make a contact object, by using the internal pool or creating a new one.
   */ createContactEquation(bi, bj, si, sj, overrideShapeA, overrideShapeB) {
        let c;
        if (this.contactPointPool.length) {
            c = this.contactPointPool.pop();
            c.bi = bi;
            c.bj = bj;
        } else c = new $0982bf0d3ab2ea42$export$9197d1b6f1213c3(bi, bj);
        c.enabled = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;
        const cm = this.currentContactMaterial;
        c.restitution = cm.restitution;
        c.setSpookParams(cm.contactEquationStiffness, cm.contactEquationRelaxation, this.world.dt);
        const matA = si.material || bi.material;
        const matB = sj.material || bj.material;
        if (matA && matB && matA.restitution >= 0 && matB.restitution >= 0) c.restitution = matA.restitution * matB.restitution;
        c.si = overrideShapeA || si;
        c.sj = overrideShapeB || sj;
        return c;
    }
    createFrictionEquationsFromContact(contactEquation, outArray) {
        const bodyA = contactEquation.bi;
        const bodyB = contactEquation.bj;
        const shapeA = contactEquation.si;
        const shapeB = contactEquation.sj;
        const world = this.world;
        const cm = this.currentContactMaterial; // If friction or restitution were specified in the material, use them
        let friction = cm.friction;
        const matA = shapeA.material || bodyA.material;
        const matB = shapeB.material || bodyB.material;
        if (matA && matB && matA.friction >= 0 && matB.friction >= 0) friction = matA.friction * matB.friction;
        if (friction > 0) {
            // Create 2 tangent equations
            const mug = friction * world.gravity.length();
            let reducedMass = bodyA.invMass + bodyB.invMass;
            if (reducedMass > 0) reducedMass = 1 / reducedMass;
            const pool = this.frictionEquationPool;
            const c1 = pool.length ? pool.pop() : new $0982bf0d3ab2ea42$export$aaf1bc25025a5803(bodyA, bodyB, mug * reducedMass);
            const c2 = pool.length ? pool.pop() : new $0982bf0d3ab2ea42$export$aaf1bc25025a5803(bodyA, bodyB, mug * reducedMass);
            c1.bi = c2.bi = bodyA;
            c1.bj = c2.bj = bodyB;
            c1.minForce = c2.minForce = -mug * reducedMass;
            c1.maxForce = c2.maxForce = mug * reducedMass; // Copy over the relative vectors
            c1.ri.copy(contactEquation.ri);
            c1.rj.copy(contactEquation.rj);
            c2.ri.copy(contactEquation.ri);
            c2.rj.copy(contactEquation.rj); // Construct tangents
            contactEquation.ni.tangents(c1.t, c2.t); // Set spook params
            c1.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, world.dt);
            c2.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, world.dt);
            c1.enabled = c2.enabled = contactEquation.enabled;
            outArray.push(c1, c2);
            return true;
        }
        return false;
    }
    /**
   * Take the average N latest contact point on the plane.
   */ createFrictionFromAverage(numContacts) {
        // The last contactEquation
        let c = this.result[this.result.length - 1]; // Create the result: two "average" friction equations
        if (!this.createFrictionEquationsFromContact(c, this.frictionResult) || numContacts === 1) return;
        const f1 = this.frictionResult[this.frictionResult.length - 2];
        const f2 = this.frictionResult[this.frictionResult.length - 1];
        $0982bf0d3ab2ea42$var$averageNormal.setZero();
        $0982bf0d3ab2ea42$var$averageContactPointA.setZero();
        $0982bf0d3ab2ea42$var$averageContactPointB.setZero();
        const bodyA = c.bi;
        c.bj;
        for(let i = 0; i !== numContacts; i++){
            c = this.result[this.result.length - 1 - i];
            if (c.bi !== bodyA) {
                $0982bf0d3ab2ea42$var$averageNormal.vadd(c.ni, $0982bf0d3ab2ea42$var$averageNormal);
                $0982bf0d3ab2ea42$var$averageContactPointA.vadd(c.ri, $0982bf0d3ab2ea42$var$averageContactPointA);
                $0982bf0d3ab2ea42$var$averageContactPointB.vadd(c.rj, $0982bf0d3ab2ea42$var$averageContactPointB);
            } else {
                $0982bf0d3ab2ea42$var$averageNormal.vsub(c.ni, $0982bf0d3ab2ea42$var$averageNormal);
                $0982bf0d3ab2ea42$var$averageContactPointA.vadd(c.rj, $0982bf0d3ab2ea42$var$averageContactPointA);
                $0982bf0d3ab2ea42$var$averageContactPointB.vadd(c.ri, $0982bf0d3ab2ea42$var$averageContactPointB);
            }
        }
        const invNumContacts = 1 / numContacts;
        $0982bf0d3ab2ea42$var$averageContactPointA.scale(invNumContacts, f1.ri);
        $0982bf0d3ab2ea42$var$averageContactPointB.scale(invNumContacts, f1.rj);
        f2.ri.copy(f1.ri); // Should be the same
        f2.rj.copy(f1.rj);
        $0982bf0d3ab2ea42$var$averageNormal.normalize();
        $0982bf0d3ab2ea42$var$averageNormal.tangents(f1.t, f2.t); // return eq;
    }
    /**
   * Generate all contacts between a list of body pairs
   * @param p1 Array of body indices
   * @param p2 Array of body indices
   * @param result Array to store generated contacts
   * @param oldcontacts Optional. Array of reusable contact objects
   */ getContacts(p1, p2, world, result, oldcontacts, frictionResult, frictionPool) {
        // Save old contact objects
        this.contactPointPool = oldcontacts;
        this.frictionEquationPool = frictionPool;
        this.result = result;
        this.frictionResult = frictionResult;
        const qi = $0982bf0d3ab2ea42$var$tmpQuat1;
        const qj = $0982bf0d3ab2ea42$var$tmpQuat2;
        const xi = $0982bf0d3ab2ea42$var$tmpVec1;
        const xj = $0982bf0d3ab2ea42$var$tmpVec2;
        for(let k = 0, N = p1.length; k !== N; k++){
            // Get current collision bodies
            const bi = p1[k];
            const bj = p2[k]; // Get contact material
            let bodyContactMaterial = null;
            if (bi.material && bj.material) bodyContactMaterial = world.getContactMaterial(bi.material, bj.material) || null;
            const justTest = bi.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC && bj.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC || bi.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC && bj.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC || bi.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC && bj.type & $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.KINEMATIC;
            for(let i = 0; i < bi.shapes.length; i++){
                bi.quaternion.mult(bi.shapeOrientations[i], qi);
                bi.quaternion.vmult(bi.shapeOffsets[i], xi);
                xi.vadd(bi.position, xi);
                const si = bi.shapes[i];
                for(let j = 0; j < bj.shapes.length; j++){
                    // Compute world transform of shapes
                    bj.quaternion.mult(bj.shapeOrientations[j], qj);
                    bj.quaternion.vmult(bj.shapeOffsets[j], xj);
                    xj.vadd(bj.position, xj);
                    const sj = bj.shapes[j];
                    if (!(si.collisionFilterMask & sj.collisionFilterGroup && sj.collisionFilterMask & si.collisionFilterGroup)) continue;
                    if (xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius) continue;
                     // Get collision material
                    let shapeContactMaterial = null;
                    if (si.material && sj.material) shapeContactMaterial = world.getContactMaterial(si.material, sj.material) || null;
                    this.currentContactMaterial = shapeContactMaterial || bodyContactMaterial || world.defaultContactMaterial; // Get contacts
                    const resolverIndex = si.type | sj.type;
                    const resolver = this[resolverIndex];
                    if (resolver) {
                        let retval = false; // TO DO: investigate why sphereParticle and convexParticle
                        // resolvers expect si and sj shapes to be in reverse order
                        // (i.e. larger integer value type first instead of smaller first)
                        if (si.type < sj.type) retval = resolver.call(this, si, sj, xi, xj, qi, qj, bi, bj, si, sj, justTest);
                        else retval = resolver.call(this, sj, si, xj, xi, qj, qi, bj, bi, si, sj, justTest);
                        if (retval && justTest) {
                            // Register overlap
                            world.shapeOverlapKeeper.set(si.id, sj.id);
                            world.bodyOverlapKeeper.set(bi.id, bj.id);
                        }
                    }
                }
            }
        }
    }
    sphereSphere(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        if (justTest) return xi.distanceSquared(xj) < (si.radius + sj.radius) ** 2;
         // We will have only one contact in this case
        const contactEq = this.createContactEquation(bi, bj, si, sj, rsi, rsj); // Contact normal
        xj.vsub(xi, contactEq.ni);
        contactEq.ni.normalize(); // Contact point locations
        contactEq.ri.copy(contactEq.ni);
        contactEq.rj.copy(contactEq.ni);
        contactEq.ri.scale(si.radius, contactEq.ri);
        contactEq.rj.scale(-sj.radius, contactEq.rj);
        contactEq.ri.vadd(xi, contactEq.ri);
        contactEq.ri.vsub(bi.position, contactEq.ri);
        contactEq.rj.vadd(xj, contactEq.rj);
        contactEq.rj.vsub(bj.position, contactEq.rj);
        this.result.push(contactEq);
        this.createFrictionEquationsFromContact(contactEq, this.frictionResult);
    }
    spherePlane(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        // We will have one contact in this case
        const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj); // Contact normal
        r.ni.set(0, 0, 1);
        qj.vmult(r.ni, r.ni);
        r.ni.negate(r.ni); // body i is the sphere, flip normal
        r.ni.normalize(); // Needed?
        // Vector from sphere center to contact point
        r.ni.scale(si.radius, r.ri); // Project down sphere on plane
        xi.vsub(xj, $0982bf0d3ab2ea42$var$point_on_plane_to_sphere);
        r.ni.scale(r.ni.dot($0982bf0d3ab2ea42$var$point_on_plane_to_sphere), $0982bf0d3ab2ea42$var$plane_to_sphere_ortho);
        $0982bf0d3ab2ea42$var$point_on_plane_to_sphere.vsub($0982bf0d3ab2ea42$var$plane_to_sphere_ortho, r.rj); // The sphere position projected to plane
        if (-$0982bf0d3ab2ea42$var$point_on_plane_to_sphere.dot(r.ni) <= si.radius) {
            if (justTest) return true;
             // Make it relative to the body
            const ri = r.ri;
            const rj = r.rj;
            ri.vadd(xi, ri);
            ri.vsub(bi.position, ri);
            rj.vadd(xj, rj);
            rj.vsub(bj.position, rj);
            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }
    boxBox(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        si.convexPolyhedronRepresentation.material = si.material;
        sj.convexPolyhedronRepresentation.material = sj.material;
        si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
        sj.convexPolyhedronRepresentation.collisionResponse = sj.collisionResponse;
        return this.convexConvex(si.convexPolyhedronRepresentation, sj.convexPolyhedronRepresentation, xi, xj, qi, qj, bi, bj, si, sj, justTest);
    }
    sphereBox(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        const v3pool = this.v3pool; // we refer to the box as body j
        const sides = $0982bf0d3ab2ea42$var$sphereBox_sides;
        xi.vsub(xj, $0982bf0d3ab2ea42$var$box_to_sphere);
        sj.getSideNormals(sides, qj);
        const R = si.radius;
        let found = false; // Store the resulting side penetration info
        const side_ns = $0982bf0d3ab2ea42$var$sphereBox_side_ns;
        const side_ns1 = $0982bf0d3ab2ea42$var$sphereBox_side_ns1;
        const side_ns2 = $0982bf0d3ab2ea42$var$sphereBox_side_ns2;
        let side_h = null;
        let side_penetrations = 0;
        let side_dot1 = 0;
        let side_dot2 = 0;
        let side_distance = null;
        for(let idx = 0, nsides = sides.length; idx !== nsides && found === false; idx++){
            // Get the plane side normal (ns)
            const ns = $0982bf0d3ab2ea42$var$sphereBox_ns;
            ns.copy(sides[idx]);
            const h = ns.length();
            ns.normalize(); // The normal/distance dot product tells which side of the plane we are
            const dot = $0982bf0d3ab2ea42$var$box_to_sphere.dot(ns);
            if (dot < h + R && dot > 0) {
                // Intersects plane. Now check the other two dimensions
                const ns1 = $0982bf0d3ab2ea42$var$sphereBox_ns1;
                const ns2 = $0982bf0d3ab2ea42$var$sphereBox_ns2;
                ns1.copy(sides[(idx + 1) % 3]);
                ns2.copy(sides[(idx + 2) % 3]);
                const h1 = ns1.length();
                const h2 = ns2.length();
                ns1.normalize();
                ns2.normalize();
                const dot1 = $0982bf0d3ab2ea42$var$box_to_sphere.dot(ns1);
                const dot2 = $0982bf0d3ab2ea42$var$box_to_sphere.dot(ns2);
                if (dot1 < h1 && dot1 > -h1 && dot2 < h2 && dot2 > -h2) {
                    const dist = Math.abs(dot - h - R);
                    if (side_distance === null || dist < side_distance) {
                        side_distance = dist;
                        side_dot1 = dot1;
                        side_dot2 = dot2;
                        side_h = h;
                        side_ns.copy(ns);
                        side_ns1.copy(ns1);
                        side_ns2.copy(ns2);
                        side_penetrations++;
                        if (justTest) return true;
                    }
                }
            }
        }
        if (side_penetrations) {
            found = true;
            const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
            side_ns.scale(-R, r.ri); // Sphere r
            r.ni.copy(side_ns);
            r.ni.negate(r.ni); // Normal should be out of sphere
            side_ns.scale(side_h, side_ns);
            side_ns1.scale(side_dot1, side_ns1);
            side_ns.vadd(side_ns1, side_ns);
            side_ns2.scale(side_dot2, side_ns2);
            side_ns.vadd(side_ns2, r.rj); // Make relative to bodies
            r.ri.vadd(xi, r.ri);
            r.ri.vsub(bi.position, r.ri);
            r.rj.vadd(xj, r.rj);
            r.rj.vsub(bj.position, r.rj);
            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        } // Check corners
        let rj = v3pool.get();
        const sphere_to_corner = $0982bf0d3ab2ea42$var$sphereBox_sphere_to_corner;
        for(let j = 0; j !== 2 && !found; j++){
            for(let k = 0; k !== 2 && !found; k++)for(let l = 0; l !== 2 && !found; l++){
                rj.set(0, 0, 0);
                if (j) rj.vadd(sides[0], rj);
                else rj.vsub(sides[0], rj);
                if (k) rj.vadd(sides[1], rj);
                else rj.vsub(sides[1], rj);
                if (l) rj.vadd(sides[2], rj);
                else rj.vsub(sides[2], rj);
                 // World position of corner
                xj.vadd(rj, sphere_to_corner);
                sphere_to_corner.vsub(xi, sphere_to_corner);
                if (sphere_to_corner.lengthSquared() < R * R) {
                    if (justTest) return true;
                    found = true;
                    const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                    r.ri.copy(sphere_to_corner);
                    r.ri.normalize();
                    r.ni.copy(r.ri);
                    r.ri.scale(R, r.ri);
                    r.rj.copy(rj); // Make relative to bodies
                    r.ri.vadd(xi, r.ri);
                    r.ri.vsub(bi.position, r.ri);
                    r.rj.vadd(xj, r.rj);
                    r.rj.vsub(bj.position, r.rj);
                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult);
                }
            }
        }
        v3pool.release(rj);
        rj = null; // Check edges
        const edgeTangent = v3pool.get();
        const edgeCenter = v3pool.get();
        const r = v3pool.get(); // r = edge center to sphere center
        const orthogonal = v3pool.get();
        const dist = v3pool.get();
        const Nsides = sides.length;
        for(let j = 0; j !== Nsides && !found; j++){
            for(let k = 0; k !== Nsides && !found; k++)if (j % 3 !== k % 3) {
                // Get edge tangent
                sides[k].cross(sides[j], edgeTangent);
                edgeTangent.normalize();
                sides[j].vadd(sides[k], edgeCenter);
                r.copy(xi);
                r.vsub(edgeCenter, r);
                r.vsub(xj, r);
                const orthonorm = r.dot(edgeTangent); // distance from edge center to sphere center in the tangent direction
                edgeTangent.scale(orthonorm, orthogonal); // Vector from edge center to sphere center in the tangent direction
                // Find the third side orthogonal to this one
                let l = 0;
                while(l === j % 3 || l === k % 3)l++;
                 // vec from edge center to sphere projected to the plane orthogonal to the edge tangent
                dist.copy(xi);
                dist.vsub(orthogonal, dist);
                dist.vsub(edgeCenter, dist);
                dist.vsub(xj, dist); // Distances in tangent direction and distance in the plane orthogonal to it
                const tdist = Math.abs(orthonorm);
                const ndist = dist.length();
                if (tdist < sides[l].length() && ndist < R) {
                    if (justTest) return true;
                    found = true;
                    const res = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                    edgeCenter.vadd(orthogonal, res.rj); // box rj
                    res.rj.copy(res.rj);
                    dist.negate(res.ni);
                    res.ni.normalize();
                    res.ri.copy(res.rj);
                    res.ri.vadd(xj, res.ri);
                    res.ri.vsub(xi, res.ri);
                    res.ri.normalize();
                    res.ri.scale(R, res.ri); // Make relative to bodies
                    res.ri.vadd(xi, res.ri);
                    res.ri.vsub(bi.position, res.ri);
                    res.rj.vadd(xj, res.rj);
                    res.rj.vsub(bj.position, res.rj);
                    this.result.push(res);
                    this.createFrictionEquationsFromContact(res, this.frictionResult);
                }
            }
        }
        v3pool.release(edgeTangent, edgeCenter, r, orthogonal, dist);
    }
    planeBox(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        sj.convexPolyhedronRepresentation.material = sj.material;
        sj.convexPolyhedronRepresentation.collisionResponse = sj.collisionResponse;
        sj.convexPolyhedronRepresentation.id = sj.id;
        return this.planeConvex(si, sj.convexPolyhedronRepresentation, xi, xj, qi, qj, bi, bj, si, sj, justTest);
    }
    convexConvex(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest, faceListA, faceListB) {
        const sepAxis = $0982bf0d3ab2ea42$var$convexConvex_sepAxis;
        if (xi.distanceTo(xj) > si.boundingSphereRadius + sj.boundingSphereRadius) return;
        if (si.findSeparatingAxis(sj, xi, qi, xj, qj, sepAxis, faceListA, faceListB)) {
            const res = [];
            const q = $0982bf0d3ab2ea42$var$convexConvex_q;
            si.clipAgainstHull(xi, qi, sj, xj, qj, sepAxis, -100, 100, res);
            let numContacts = 0;
            for(let j = 0; j !== res.length; j++){
                if (justTest) return true;
                const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                const ri = r.ri;
                const rj = r.rj;
                sepAxis.negate(r.ni);
                res[j].normal.negate(q);
                q.scale(res[j].depth, q);
                res[j].point.vadd(q, ri);
                rj.copy(res[j].point); // Contact points are in world coordinates. Transform back to relative
                ri.vsub(xi, ri);
                rj.vsub(xj, rj); // Make relative to bodies
                ri.vadd(xi, ri);
                ri.vsub(bi.position, ri);
                rj.vadd(xj, rj);
                rj.vsub(bj.position, rj);
                this.result.push(r);
                numContacts++;
                if (!this.enableFrictionReduction) this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
            if (this.enableFrictionReduction && numContacts) this.createFrictionFromAverage(numContacts);
        }
    }
    sphereConvex(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        const v3pool = this.v3pool;
        xi.vsub(xj, $0982bf0d3ab2ea42$var$convex_to_sphere);
        const normals = sj.faceNormals;
        const faces = sj.faces;
        const verts = sj.vertices;
        const R = si.radius;
        //     return;
        // }
        let found = false; // Check corners
        for(let i = 0; i !== verts.length; i++){
            const v = verts[i]; // World position of corner
            const worldCorner = $0982bf0d3ab2ea42$var$sphereConvex_worldCorner;
            qj.vmult(v, worldCorner);
            xj.vadd(worldCorner, worldCorner);
            const sphere_to_corner = $0982bf0d3ab2ea42$var$sphereConvex_sphereToCorner;
            worldCorner.vsub(xi, sphere_to_corner);
            if (sphere_to_corner.lengthSquared() < R * R) {
                if (justTest) return true;
                found = true;
                const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                r.ri.copy(sphere_to_corner);
                r.ri.normalize();
                r.ni.copy(r.ri);
                r.ri.scale(R, r.ri);
                worldCorner.vsub(xj, r.rj); // Should be relative to the body.
                r.ri.vadd(xi, r.ri);
                r.ri.vsub(bi.position, r.ri); // Should be relative to the body.
                r.rj.vadd(xj, r.rj);
                r.rj.vsub(bj.position, r.rj);
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
                return;
            }
        } // Check side (plane) intersections
        for(let i = 0, nfaces = faces.length; i !== nfaces && found === false; i++){
            const normal = normals[i];
            const face = faces[i]; // Get world-transformed normal of the face
            const worldNormal = $0982bf0d3ab2ea42$var$sphereConvex_worldNormal;
            qj.vmult(normal, worldNormal); // Get a world vertex from the face
            const worldPoint = $0982bf0d3ab2ea42$var$sphereConvex_worldPoint;
            qj.vmult(verts[face[0]], worldPoint);
            worldPoint.vadd(xj, worldPoint); // Get a point on the sphere, closest to the face normal
            const worldSpherePointClosestToPlane = $0982bf0d3ab2ea42$var$sphereConvex_worldSpherePointClosestToPlane;
            worldNormal.scale(-R, worldSpherePointClosestToPlane);
            xi.vadd(worldSpherePointClosestToPlane, worldSpherePointClosestToPlane); // Vector from a face point to the closest point on the sphere
            const penetrationVec = $0982bf0d3ab2ea42$var$sphereConvex_penetrationVec;
            worldSpherePointClosestToPlane.vsub(worldPoint, penetrationVec); // The penetration. Negative value means overlap.
            const penetration = penetrationVec.dot(worldNormal);
            const worldPointToSphere = $0982bf0d3ab2ea42$var$sphereConvex_sphereToWorldPoint;
            xi.vsub(worldPoint, worldPointToSphere);
            if (penetration < 0 && worldPointToSphere.dot(worldNormal) > 0) {
                // Intersects plane. Now check if the sphere is inside the face polygon
                const faceVerts = []; // Face vertices, in world coords
                for(let j = 0, Nverts = face.length; j !== Nverts; j++){
                    const worldVertex = v3pool.get();
                    qj.vmult(verts[face[j]], worldVertex);
                    xj.vadd(worldVertex, worldVertex);
                    faceVerts.push(worldVertex);
                }
                if ($0982bf0d3ab2ea42$var$pointInPolygon(faceVerts, worldNormal, xi)) {
                    // Is the sphere center in the face polygon?
                    if (justTest) return true;
                    found = true;
                    const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                    worldNormal.scale(-R, r.ri); // Contact offset, from sphere center to contact
                    worldNormal.negate(r.ni); // Normal pointing out of sphere
                    const penetrationVec2 = v3pool.get();
                    worldNormal.scale(-penetration, penetrationVec2);
                    const penetrationSpherePoint = v3pool.get();
                    worldNormal.scale(-R, penetrationSpherePoint); //xi.vsub(xj).vadd(penetrationSpherePoint).vadd(penetrationVec2 , r.rj);
                    xi.vsub(xj, r.rj);
                    r.rj.vadd(penetrationSpherePoint, r.rj);
                    r.rj.vadd(penetrationVec2, r.rj); // Should be relative to the body.
                    r.rj.vadd(xj, r.rj);
                    r.rj.vsub(bj.position, r.rj); // Should be relative to the body.
                    r.ri.vadd(xi, r.ri);
                    r.ri.vsub(bi.position, r.ri);
                    v3pool.release(penetrationVec2);
                    v3pool.release(penetrationSpherePoint);
                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult); // Release world vertices
                    for(let j = 0, Nfaceverts = faceVerts.length; j !== Nfaceverts; j++)v3pool.release(faceVerts[j]);
                    return; // We only expect *one* face contact
                } else // Edge?
                for(let j = 0; j !== face.length; j++){
                    // Get two world transformed vertices
                    const v1 = v3pool.get();
                    const v2 = v3pool.get();
                    qj.vmult(verts[face[(j + 1) % face.length]], v1);
                    qj.vmult(verts[face[(j + 2) % face.length]], v2);
                    xj.vadd(v1, v1);
                    xj.vadd(v2, v2); // Construct edge vector
                    const edge = $0982bf0d3ab2ea42$var$sphereConvex_edge;
                    v2.vsub(v1, edge); // Construct the same vector, but normalized
                    const edgeUnit = $0982bf0d3ab2ea42$var$sphereConvex_edgeUnit;
                    edge.unit(edgeUnit); // p is xi projected onto the edge
                    const p = v3pool.get();
                    const v1_to_xi = v3pool.get();
                    xi.vsub(v1, v1_to_xi);
                    const dot = v1_to_xi.dot(edgeUnit);
                    edgeUnit.scale(dot, p);
                    p.vadd(v1, p); // Compute a vector from p to the center of the sphere
                    const xi_to_p = v3pool.get();
                    p.vsub(xi, xi_to_p); // Collision if the edge-sphere distance is less than the radius
                    // AND if p is in between v1 and v2
                    if (dot > 0 && dot * dot < edge.lengthSquared() && xi_to_p.lengthSquared() < R * R) {
                        // Collision if the edge-sphere distance is less than the radius
                        // Edge contact!
                        if (justTest) return true;
                        const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                        p.vsub(xj, r.rj);
                        p.vsub(xi, r.ni);
                        r.ni.normalize();
                        r.ni.scale(R, r.ri); // Should be relative to the body.
                        r.rj.vadd(xj, r.rj);
                        r.rj.vsub(bj.position, r.rj); // Should be relative to the body.
                        r.ri.vadd(xi, r.ri);
                        r.ri.vsub(bi.position, r.ri);
                        this.result.push(r);
                        this.createFrictionEquationsFromContact(r, this.frictionResult); // Release world vertices
                        for(let j = 0, Nfaceverts = faceVerts.length; j !== Nfaceverts; j++)v3pool.release(faceVerts[j]);
                        v3pool.release(v1);
                        v3pool.release(v2);
                        v3pool.release(p);
                        v3pool.release(xi_to_p);
                        v3pool.release(v1_to_xi);
                        return;
                    }
                    v3pool.release(v1);
                    v3pool.release(v2);
                    v3pool.release(p);
                    v3pool.release(xi_to_p);
                    v3pool.release(v1_to_xi);
                }
                 // Release world vertices
                for(let j = 0, Nfaceverts = faceVerts.length; j !== Nfaceverts; j++)v3pool.release(faceVerts[j]);
            }
        }
    }
    planeConvex(planeShape, convexShape, planePosition, convexPosition, planeQuat, convexQuat, planeBody, convexBody, si, sj, justTest) {
        // Simply return the points behind the plane.
        const worldVertex = $0982bf0d3ab2ea42$var$planeConvex_v;
        const worldNormal = $0982bf0d3ab2ea42$var$planeConvex_normal;
        worldNormal.set(0, 0, 1);
        planeQuat.vmult(worldNormal, worldNormal); // Turn normal according to plane orientation
        let numContacts = 0;
        const relpos = $0982bf0d3ab2ea42$var$planeConvex_relpos;
        for(let i = 0; i !== convexShape.vertices.length; i++){
            // Get world convex vertex
            worldVertex.copy(convexShape.vertices[i]);
            convexQuat.vmult(worldVertex, worldVertex);
            convexPosition.vadd(worldVertex, worldVertex);
            worldVertex.vsub(planePosition, relpos);
            const dot = worldNormal.dot(relpos);
            if (dot <= 0.0) {
                if (justTest) return true;
                const r = this.createContactEquation(planeBody, convexBody, planeShape, convexShape, si, sj); // Get vertex position projected on plane
                const projected = $0982bf0d3ab2ea42$var$planeConvex_projected;
                worldNormal.scale(worldNormal.dot(relpos), projected);
                worldVertex.vsub(projected, projected);
                projected.vsub(planePosition, r.ri); // From plane to vertex projected on plane
                r.ni.copy(worldNormal); // Contact normal is the plane normal out from plane
                // rj is now just the vector from the convex center to the vertex
                worldVertex.vsub(convexPosition, r.rj); // Make it relative to the body
                r.ri.vadd(planePosition, r.ri);
                r.ri.vsub(planeBody.position, r.ri);
                r.rj.vadd(convexPosition, r.rj);
                r.rj.vsub(convexBody.position, r.rj);
                this.result.push(r);
                numContacts++;
                if (!this.enableFrictionReduction) this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
        if (this.enableFrictionReduction && numContacts) this.createFrictionFromAverage(numContacts);
    }
    boxConvex(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        si.convexPolyhedronRepresentation.material = si.material;
        si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
        return this.convexConvex(si.convexPolyhedronRepresentation, sj, xi, xj, qi, qj, bi, bj, si, sj, justTest);
    }
    sphereHeightfield(sphereShape, hfShape, spherePos, hfPos, sphereQuat, hfQuat, sphereBody, hfBody, rsi, rsj, justTest) {
        const data = hfShape.data;
        const radius = sphereShape.radius;
        const w = hfShape.elementSize;
        const worldPillarOffset = $0982bf0d3ab2ea42$var$sphereHeightfield_tmp2; // Get sphere position to heightfield local!
        const localSpherePos = $0982bf0d3ab2ea42$var$sphereHeightfield_tmp1;
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(hfPos, hfQuat, spherePos, localSpherePos); // Get the index of the data points to test against
        let iMinX = Math.floor((localSpherePos.x - radius) / w) - 1;
        let iMaxX = Math.ceil((localSpherePos.x + radius) / w) + 1;
        let iMinY = Math.floor((localSpherePos.y - radius) / w) - 1;
        let iMaxY = Math.ceil((localSpherePos.y + radius) / w) + 1; // Bail out if we are out of the terrain
        if (iMaxX < 0 || iMaxY < 0 || iMinX > data.length || iMinY > data[0].length) return;
         // Clamp index to edges
        if (iMinX < 0) iMinX = 0;
        if (iMaxX < 0) iMaxX = 0;
        if (iMinY < 0) iMinY = 0;
        if (iMaxY < 0) iMaxY = 0;
        if (iMinX >= data.length) iMinX = data.length - 1;
        if (iMaxX >= data.length) iMaxX = data.length - 1;
        if (iMaxY >= data[0].length) iMaxY = data[0].length - 1;
        if (iMinY >= data[0].length) iMinY = data[0].length - 1;
        const minMax = [];
        hfShape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
        const min = minMax[0];
        const max = minMax[1]; // Bail out if we can't touch the bounding height box
        if (localSpherePos.z - radius > max || localSpherePos.z + radius < min) return;
        const result = this.result;
        for(let i = iMinX; i < iMaxX; i++)for(let j = iMinY; j < iMaxY; j++){
            const numContactsBefore = result.length;
            let intersecting = false; // Lower triangle
            hfShape.getConvexTrianglePillar(i, j, false);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (spherePos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + sphereShape.boundingSphereRadius) intersecting = this.sphereConvex(sphereShape, hfShape.pillarConvex, spherePos, worldPillarOffset, sphereQuat, hfQuat, sphereBody, hfBody, sphereShape, hfShape, justTest);
            if (justTest && intersecting) return true;
             // Upper triangle
            hfShape.getConvexTrianglePillar(i, j, true);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (spherePos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + sphereShape.boundingSphereRadius) intersecting = this.sphereConvex(sphereShape, hfShape.pillarConvex, spherePos, worldPillarOffset, sphereQuat, hfQuat, sphereBody, hfBody, sphereShape, hfShape, justTest);
            if (justTest && intersecting) return true;
            const numContacts = result.length - numContactsBefore;
            if (numContacts > 2) return;
        /*
          // Skip all but 1
          for (let k = 0; k < numContacts - 1; k++) {
              result.pop();
          }
        */ }
    }
    boxHeightfield(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        si.convexPolyhedronRepresentation.material = si.material;
        si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
        return this.convexHeightfield(si.convexPolyhedronRepresentation, sj, xi, xj, qi, qj, bi, bj, si, sj, justTest);
    }
    convexHeightfield(convexShape, hfShape, convexPos, hfPos, convexQuat, hfQuat, convexBody, hfBody, rsi, rsj, justTest) {
        const data = hfShape.data;
        const w = hfShape.elementSize;
        const radius = convexShape.boundingSphereRadius;
        const worldPillarOffset = $0982bf0d3ab2ea42$var$convexHeightfield_tmp2;
        const faceList = $0982bf0d3ab2ea42$var$convexHeightfield_faceList; // Get sphere position to heightfield local!
        const localConvexPos = $0982bf0d3ab2ea42$var$convexHeightfield_tmp1;
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(hfPos, hfQuat, convexPos, localConvexPos); // Get the index of the data points to test against
        let iMinX = Math.floor((localConvexPos.x - radius) / w) - 1;
        let iMaxX = Math.ceil((localConvexPos.x + radius) / w) + 1;
        let iMinY = Math.floor((localConvexPos.y - radius) / w) - 1;
        let iMaxY = Math.ceil((localConvexPos.y + radius) / w) + 1; // Bail out if we are out of the terrain
        if (iMaxX < 0 || iMaxY < 0 || iMinX > data.length || iMinY > data[0].length) return;
         // Clamp index to edges
        if (iMinX < 0) iMinX = 0;
        if (iMaxX < 0) iMaxX = 0;
        if (iMinY < 0) iMinY = 0;
        if (iMaxY < 0) iMaxY = 0;
        if (iMinX >= data.length) iMinX = data.length - 1;
        if (iMaxX >= data.length) iMaxX = data.length - 1;
        if (iMaxY >= data[0].length) iMaxY = data[0].length - 1;
        if (iMinY >= data[0].length) iMinY = data[0].length - 1;
        const minMax = [];
        hfShape.getRectMinMax(iMinX, iMinY, iMaxX, iMaxY, minMax);
        const min = minMax[0];
        const max = minMax[1]; // Bail out if we're cant touch the bounding height box
        if (localConvexPos.z - radius > max || localConvexPos.z + radius < min) return;
        for(let i = iMinX; i < iMaxX; i++)for(let j = iMinY; j < iMaxY; j++){
            let intersecting = false; // Lower triangle
            hfShape.getConvexTrianglePillar(i, j, false);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (convexPos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + convexShape.boundingSphereRadius) intersecting = this.convexConvex(convexShape, hfShape.pillarConvex, convexPos, worldPillarOffset, convexQuat, hfQuat, convexBody, hfBody, null, null, justTest, faceList, null);
            if (justTest && intersecting) return true;
             // Upper triangle
            hfShape.getConvexTrianglePillar(i, j, true);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(hfPos, hfQuat, hfShape.pillarOffset, worldPillarOffset);
            if (convexPos.distanceTo(worldPillarOffset) < hfShape.pillarConvex.boundingSphereRadius + convexShape.boundingSphereRadius) intersecting = this.convexConvex(convexShape, hfShape.pillarConvex, convexPos, worldPillarOffset, convexQuat, hfQuat, convexBody, hfBody, null, null, justTest, faceList, null);
            if (justTest && intersecting) return true;
        }
    }
    sphereParticle(sj, si, xj, xi, qj, qi, bj, bi, rsi, rsj, justTest) {
        // The normal is the unit vector from sphere center to particle center
        const normal = $0982bf0d3ab2ea42$var$particleSphere_normal;
        normal.set(0, 0, 1);
        xi.vsub(xj, normal);
        const lengthSquared = normal.lengthSquared();
        if (lengthSquared <= sj.radius * sj.radius) {
            if (justTest) return true;
            const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
            normal.normalize();
            r.rj.copy(normal);
            r.rj.scale(sj.radius, r.rj);
            r.ni.copy(normal); // Contact normal
            r.ni.negate(r.ni);
            r.ri.set(0, 0, 0); // Center of particle
            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }
    planeParticle(sj, si, xj, xi, qj, qi, bj, bi, rsi, rsj, justTest) {
        const normal = $0982bf0d3ab2ea42$var$particlePlane_normal;
        normal.set(0, 0, 1);
        bj.quaternion.vmult(normal, normal); // Turn normal according to plane orientation
        const relpos = $0982bf0d3ab2ea42$var$particlePlane_relpos;
        xi.vsub(bj.position, relpos);
        const dot = normal.dot(relpos);
        if (dot <= 0.0) {
            if (justTest) return true;
            const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
            r.ni.copy(normal); // Contact normal is the plane normal
            r.ni.negate(r.ni);
            r.ri.set(0, 0, 0); // Center of particle
            // Get particle position projected on plane
            const projected = $0982bf0d3ab2ea42$var$particlePlane_projected;
            normal.scale(normal.dot(xi), projected);
            xi.vsub(projected, projected); //projected.vadd(bj.position,projected);
            // rj is now the projected world position minus plane position
            r.rj.copy(projected);
            this.result.push(r);
            this.createFrictionEquationsFromContact(r, this.frictionResult);
        }
    }
    boxParticle(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        si.convexPolyhedronRepresentation.material = si.material;
        si.convexPolyhedronRepresentation.collisionResponse = si.collisionResponse;
        return this.convexParticle(si.convexPolyhedronRepresentation, sj, xi, xj, qi, qj, bi, bj, si, sj, justTest);
    }
    convexParticle(sj, si, xj, xi, qj, qi, bj, bi, rsi, rsj, justTest) {
        let penetratedFaceIndex = -1;
        const penetratedFaceNormal = $0982bf0d3ab2ea42$var$convexParticle_penetratedFaceNormal;
        const worldPenetrationVec = $0982bf0d3ab2ea42$var$convexParticle_worldPenetrationVec;
        let minPenetration = null;
        const local = $0982bf0d3ab2ea42$var$convexParticle_local;
        local.copy(xi);
        local.vsub(xj, local); // Convert position to relative the convex origin
        qj.conjugate($0982bf0d3ab2ea42$var$cqj);
        $0982bf0d3ab2ea42$var$cqj.vmult(local, local);
        if (sj.pointIsInside(local)) {
            if (sj.worldVerticesNeedsUpdate) sj.computeWorldVertices(xj, qj);
            if (sj.worldFaceNormalsNeedsUpdate) sj.computeWorldFaceNormals(qj);
             // For each world polygon in the polyhedra
            for(let i = 0, nfaces = sj.faces.length; i !== nfaces; i++){
                // Construct world face vertices
                const verts = [
                    sj.worldVertices[sj.faces[i][0]]
                ];
                const normal = sj.worldFaceNormals[i]; // Check how much the particle penetrates the polygon plane.
                xi.vsub(verts[0], $0982bf0d3ab2ea42$var$convexParticle_vertexToParticle);
                const penetration = -normal.dot($0982bf0d3ab2ea42$var$convexParticle_vertexToParticle);
                if (minPenetration === null || Math.abs(penetration) < Math.abs(minPenetration)) {
                    if (justTest) return true;
                    minPenetration = penetration;
                    penetratedFaceIndex = i;
                    penetratedFaceNormal.copy(normal);
                }
            }
            if (penetratedFaceIndex !== -1) {
                // Setup contact
                const r = this.createContactEquation(bi, bj, si, sj, rsi, rsj);
                penetratedFaceNormal.scale(minPenetration, worldPenetrationVec); // rj is the particle position projected to the face
                worldPenetrationVec.vadd(xi, worldPenetrationVec);
                worldPenetrationVec.vsub(xj, worldPenetrationVec);
                r.rj.copy(worldPenetrationVec); //const projectedToFace = xi.vsub(xj).vadd(worldPenetrationVec);
                //projectedToFace.copy(r.rj);
                //qj.vmult(r.rj,r.rj);
                penetratedFaceNormal.negate(r.ni); // Contact normal
                r.ri.set(0, 0, 0); // Center of particle
                const ri = r.ri;
                const rj = r.rj; // Make relative to bodies
                ri.vadd(xi, ri);
                ri.vsub(bi.position, ri);
                rj.vadd(xj, rj);
                rj.vsub(bj.position, rj);
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            } else console.warn('Point found inside convex, but did not find penetrating face!');
        }
    }
    heightfieldCylinder(hfShape, convexShape, hfPos, convexPos, hfQuat, convexQuat, hfBody, convexBody, rsi, rsj, justTest) {
        return this.convexHeightfield(convexShape, hfShape, convexPos, hfPos, convexQuat, hfQuat, convexBody, hfBody, rsi, rsj, justTest);
    }
    particleCylinder(si, sj, xi, xj, qi, qj, bi, bj, rsi, rsj, justTest) {
        return this.convexParticle(sj, si, xj, xi, qj, qi, bj, bi, rsi, rsj, justTest);
    }
    sphereTrimesh(sphereShape, trimeshShape, spherePos, trimeshPos, sphereQuat, trimeshQuat, sphereBody, trimeshBody, rsi, rsj, justTest) {
        const edgeVertexA = $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVertexA;
        const edgeVertexB = $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVertexB;
        const edgeVector = $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVector;
        const edgeVectorUnit = $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVectorUnit;
        const localSpherePos = $0982bf0d3ab2ea42$var$sphereTrimesh_localSpherePos;
        const tmp = $0982bf0d3ab2ea42$var$sphereTrimesh_tmp;
        const localSphereAABB = $0982bf0d3ab2ea42$var$sphereTrimesh_localSphereAABB;
        const v2 = $0982bf0d3ab2ea42$var$sphereTrimesh_v2;
        const relpos = $0982bf0d3ab2ea42$var$sphereTrimesh_relpos;
        const triangles = $0982bf0d3ab2ea42$var$sphereTrimesh_triangles; // Convert sphere position to local in the trimesh
        $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToLocalFrame(trimeshPos, trimeshQuat, spherePos, localSpherePos); // Get the aabb of the sphere locally in the trimesh
        const sphereRadius = sphereShape.radius;
        localSphereAABB.lowerBound.set(localSpherePos.x - sphereRadius, localSpherePos.y - sphereRadius, localSpherePos.z - sphereRadius);
        localSphereAABB.upperBound.set(localSpherePos.x + sphereRadius, localSpherePos.y + sphereRadius, localSpherePos.z + sphereRadius);
        trimeshShape.getTrianglesInAABB(localSphereAABB, triangles); //for (let i = 0; i < trimeshShape.indices.length / 3; i++) triangles.push(i); // All
        // Vertices
        const v = $0982bf0d3ab2ea42$var$sphereTrimesh_v;
        const radiusSquared = sphereShape.radius * sphereShape.radius;
        for(let i = 0; i < triangles.length; i++)for(let j = 0; j < 3; j++){
            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + j], v); // Check vertex overlap in sphere
            v.vsub(localSpherePos, relpos);
            if (relpos.lengthSquared() <= radiusSquared) {
                // Safe up
                v2.copy(v);
                $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(trimeshPos, trimeshQuat, v2, v);
                v.vsub(spherePos, relpos);
                if (justTest) return true;
                let r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape, rsi, rsj);
                r.ni.copy(relpos);
                r.ni.normalize(); // ri is the vector from sphere center to the sphere surface
                r.ri.copy(r.ni);
                r.ri.scale(sphereShape.radius, r.ri);
                r.ri.vadd(spherePos, r.ri);
                r.ri.vsub(sphereBody.position, r.ri);
                r.rj.copy(v);
                r.rj.vsub(trimeshBody.position, r.rj); // Store result
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
         // Check all edges
        for(let i = 0; i < triangles.length; i++)for(let j = 0; j < 3; j++){
            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + j], edgeVertexA);
            trimeshShape.getVertex(trimeshShape.indices[triangles[i] * 3 + (j + 1) % 3], edgeVertexB);
            edgeVertexB.vsub(edgeVertexA, edgeVector); // Project sphere position to the edge
            localSpherePos.vsub(edgeVertexB, tmp);
            const positionAlongEdgeB = tmp.dot(edgeVector);
            localSpherePos.vsub(edgeVertexA, tmp);
            let positionAlongEdgeA = tmp.dot(edgeVector);
            if (positionAlongEdgeA > 0 && positionAlongEdgeB < 0) {
                // Now check the orthogonal distance from edge to sphere center
                localSpherePos.vsub(edgeVertexA, tmp);
                edgeVectorUnit.copy(edgeVector);
                edgeVectorUnit.normalize();
                positionAlongEdgeA = tmp.dot(edgeVectorUnit);
                edgeVectorUnit.scale(positionAlongEdgeA, tmp);
                tmp.vadd(edgeVertexA, tmp); // tmp is now the sphere center position projected to the edge, defined locally in the trimesh frame
                const dist = tmp.distanceTo(localSpherePos);
                if (dist < sphereShape.radius) {
                    if (justTest) return true;
                    const r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape, rsi, rsj);
                    tmp.vsub(localSpherePos, r.ni);
                    r.ni.normalize();
                    r.ni.scale(sphereShape.radius, r.ri);
                    r.ri.vadd(spherePos, r.ri);
                    r.ri.vsub(sphereBody.position, r.ri);
                    $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(trimeshPos, trimeshQuat, tmp, tmp);
                    tmp.vsub(trimeshBody.position, r.rj);
                    $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToWorldFrame(trimeshQuat, r.ni, r.ni);
                    $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToWorldFrame(trimeshQuat, r.ri, r.ri);
                    this.result.push(r);
                    this.createFrictionEquationsFromContact(r, this.frictionResult);
                }
            }
        }
         // Triangle faces
        const va = $0982bf0d3ab2ea42$var$sphereTrimesh_va;
        const vb = $0982bf0d3ab2ea42$var$sphereTrimesh_vb;
        const vc = $0982bf0d3ab2ea42$var$sphereTrimesh_vc;
        const normal = $0982bf0d3ab2ea42$var$sphereTrimesh_normal;
        for(let i = 0, N = triangles.length; i !== N; i++){
            trimeshShape.getTriangleVertices(triangles[i], va, vb, vc);
            trimeshShape.getNormal(triangles[i], normal);
            localSpherePos.vsub(va, tmp);
            let dist = tmp.dot(normal);
            normal.scale(dist, tmp);
            localSpherePos.vsub(tmp, tmp); // tmp is now the sphere position projected to the triangle plane
            dist = tmp.distanceTo(localSpherePos);
            if ($0982bf0d3ab2ea42$export$a186db52eed6d40e.pointInTriangle(tmp, va, vb, vc) && dist < sphereShape.radius) {
                if (justTest) return true;
                let r = this.createContactEquation(sphereBody, trimeshBody, sphereShape, trimeshShape, rsi, rsj);
                tmp.vsub(localSpherePos, r.ni);
                r.ni.normalize();
                r.ni.scale(sphereShape.radius, r.ri);
                r.ri.vadd(spherePos, r.ri);
                r.ri.vsub(sphereBody.position, r.ri);
                $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(trimeshPos, trimeshQuat, tmp, tmp);
                tmp.vsub(trimeshBody.position, r.rj);
                $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToWorldFrame(trimeshQuat, r.ni, r.ni);
                $0982bf0d3ab2ea42$export$563a914cafbdc389.vectorToWorldFrame(trimeshQuat, r.ri, r.ri);
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
        triangles.length = 0;
    }
    planeTrimesh(planeShape, trimeshShape, planePos, trimeshPos, planeQuat, trimeshQuat, planeBody, trimeshBody, rsi, rsj, justTest) {
        // Make contacts!
        const v = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        const normal = $0982bf0d3ab2ea42$var$planeTrimesh_normal;
        normal.set(0, 0, 1);
        planeQuat.vmult(normal, normal); // Turn normal according to plane
        for(let i = 0; i < trimeshShape.vertices.length / 3; i++){
            // Get world vertex from trimesh
            trimeshShape.getVertex(i, v); // Safe up
            const v2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
            v2.copy(v);
            $0982bf0d3ab2ea42$export$563a914cafbdc389.pointToWorldFrame(trimeshPos, trimeshQuat, v2, v); // Check plane side
            const relpos = $0982bf0d3ab2ea42$var$planeTrimesh_relpos;
            v.vsub(planePos, relpos);
            const dot = normal.dot(relpos);
            if (dot <= 0.0) {
                if (justTest) return true;
                const r = this.createContactEquation(planeBody, trimeshBody, planeShape, trimeshShape, rsi, rsj);
                r.ni.copy(normal); // Contact normal is the plane normal
                // Get vertex position projected on plane
                const projected = $0982bf0d3ab2ea42$var$planeTrimesh_projected;
                normal.scale(relpos.dot(normal), projected);
                v.vsub(projected, projected); // ri is the projected world position minus plane position
                r.ri.copy(projected);
                r.ri.vsub(planeBody.position, r.ri);
                r.rj.copy(v);
                r.rj.vsub(trimeshBody.position, r.rj); // Store result
                this.result.push(r);
                this.createFrictionEquationsFromContact(r, this.frictionResult);
            }
        }
    }
    //   return this.convexTrimesh
    // }
    constructor(world){
        this.contactPointPool = void 0;
        this.frictionEquationPool = void 0;
        this.result = void 0;
        this.frictionResult = void 0;
        this.v3pool = void 0;
        this.world = void 0;
        this.currentContactMaterial = void 0;
        this.enableFrictionReduction = void 0;
        this.contactPointPool = [];
        this.frictionEquationPool = [];
        this.result = [];
        this.frictionResult = [];
        this.v3pool = new $0982bf0d3ab2ea42$export$8cab54e48d922244();
        this.world = world;
        this.currentContactMaterial = world.defaultContactMaterial;
        this.enableFrictionReduction = false;
    }
}
const $0982bf0d3ab2ea42$var$averageNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$averageContactPointA = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$averageContactPointB = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpVec1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpVec2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$tmpQuat1 = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
const $0982bf0d3ab2ea42$var$tmpQuat2 = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
const $0982bf0d3ab2ea42$var$planeTrimesh_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$planeTrimesh_relpos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$planeTrimesh_projected = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_relpos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_v = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_v2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVertexA = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVertexB = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVector = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_edgeVectorUnit = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_localSpherePos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_tmp = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_va = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_vb = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_vc = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_localSphereAABB = new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$sphereTrimesh_triangles = [];
const $0982bf0d3ab2ea42$var$point_on_plane_to_sphere = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$plane_to_sphere_ortho = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // See http://bulletphysics.com/Bullet/BulletFull/SphereTriangleDetector_8cpp_source.html
const $0982bf0d3ab2ea42$var$pointInPolygon_edge = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$pointInPolygon_edge_x_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$pointInPolygon_vtp = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
function $0982bf0d3ab2ea42$var$pointInPolygon(verts, normal, p) {
    let positiveResult = null;
    const N = verts.length;
    for(let i = 0; i !== N; i++){
        const v = verts[i]; // Get edge to the next vertex
        const edge = $0982bf0d3ab2ea42$var$pointInPolygon_edge;
        verts[(i + 1) % N].vsub(v, edge); // Get cross product between polygon normal and the edge
        const edge_x_normal = $0982bf0d3ab2ea42$var$pointInPolygon_edge_x_normal; //const edge_x_normal = new Vec3();
        edge.cross(normal, edge_x_normal); // Get vector between point and current vertex
        const vertex_to_p = $0982bf0d3ab2ea42$var$pointInPolygon_vtp;
        p.vsub(v, vertex_to_p); // This dot product determines which side of the edge the point is
        const r = edge_x_normal.dot(vertex_to_p); // If all such dot products have same sign, we are inside the polygon.
        if (positiveResult === null || r > 0 && positiveResult === true || r <= 0 && positiveResult === false) {
            if (positiveResult === null) positiveResult = r > 0;
            continue;
        } else return false; // Encountered some other sign. Exit.
    } // If we got here, all dot products were of the same sign.
    return true;
}
const $0982bf0d3ab2ea42$var$box_to_sphere = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_ns = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_ns1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_ns2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_sides = [
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa(),
    new $0982bf0d3ab2ea42$export$838423f3adec30fa()
];
const $0982bf0d3ab2ea42$var$sphereBox_sphere_to_corner = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_side_ns = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_side_ns1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereBox_side_ns2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convex_to_sphere = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_edge = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_edgeUnit = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_sphereToCorner = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_worldCorner = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_worldNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_worldPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_worldSpherePointClosestToPlane = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_penetrationVec = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereConvex_sphereToWorldPoint = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$planeConvex_v = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$planeConvex_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$planeConvex_relpos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$planeConvex_projected = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexConvex_sepAxis = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexConvex_q = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$particlePlane_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$particlePlane_relpos = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$particlePlane_projected = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$particleSphere_normal = new $0982bf0d3ab2ea42$export$838423f3adec30fa(); // WIP
const $0982bf0d3ab2ea42$var$cqj = new $0982bf0d3ab2ea42$export$23d6a54f0bbc85a3();
const $0982bf0d3ab2ea42$var$convexParticle_local = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexParticle_penetratedFaceNormal = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexParticle_vertexToParticle = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexParticle_worldPenetrationVec = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexHeightfield_tmp1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexHeightfield_tmp2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$convexHeightfield_faceList = [
    0
];
const $0982bf0d3ab2ea42$var$sphereHeightfield_tmp1 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
const $0982bf0d3ab2ea42$var$sphereHeightfield_tmp2 = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
class $0982bf0d3ab2ea42$var$OverlapKeeper {
    /**
   * getKey
   */ getKey(i, j) {
        if (j < i) {
            const temp = j;
            j = i;
            i = temp;
        }
        return i << 16 | j;
    }
    /**
   * set
   */ set(i, j) {
        // Insertion sort. This way the diff will have linear complexity.
        const key = this.getKey(i, j);
        const current = this.current;
        let index = 0;
        while(key > current[index])index++;
        if (key === current[index]) return; // Pair was already added
        for(let j = current.length - 1; j >= index; j--)current[j + 1] = current[j];
        current[index] = key;
    }
    /**
   * tick
   */ tick() {
        const tmp = this.current;
        this.current = this.previous;
        this.previous = tmp;
        this.current.length = 0;
    }
    /**
   * getDiff
   */ getDiff(additions, removals) {
        const a = this.current;
        const b = this.previous;
        const al = a.length;
        const bl = b.length;
        let j = 0;
        for(let i = 0; i < al; i++){
            let found = false;
            const keyA = a[i];
            while(keyA > b[j])j++;
            found = keyA === b[j];
            if (!found) $0982bf0d3ab2ea42$var$unpackAndPush(additions, keyA);
        }
        j = 0;
        for(let i = 0; i < bl; i++){
            let found = false;
            const keyB = b[i];
            while(keyB > a[j])j++;
            found = a[j] === keyB;
            if (!found) $0982bf0d3ab2ea42$var$unpackAndPush(removals, keyB);
        }
    }
    /**
   * @todo Remove useless constructor
   */ constructor(){
        this.current = void 0;
        this.previous = void 0;
        this.current = [];
        this.previous = [];
    }
}
function $0982bf0d3ab2ea42$var$unpackAndPush(array, key) {
    array.push((key & 0xffff0000) >> 16, key & 0x0000ffff);
}
/**
 * TupleDictionary
 */ class $0982bf0d3ab2ea42$var$TupleDictionary {
    /** get */ get(i, j) {
        if (i > j) {
            // swap
            const temp = j;
            j = i;
            i = temp;
        }
        return this.data[i + "-" + j];
    }
    /** set */ set(i, j, value) {
        if (i > j) {
            const temp = j;
            j = i;
            i = temp;
        }
        const key = i + "-" + j; // Check if key already exists
        if (!this.get(i, j)) this.data.keys.push(key);
        this.data[key] = value;
    }
    /** reset */ reset() {
        const data = this.data;
        const keys = data.keys;
        while(keys.length > 0){
            const key = keys.pop();
            delete data[key];
        }
    }
    constructor(){
        this.data = {
            keys: []
        };
    }
}
/**
 * The physics world
 */ class $0982bf0d3ab2ea42$export$812cd9544993280d extends $0982bf0d3ab2ea42$export$648eec84020a2b10 {
    /**
   * Get the contact material between materials m1 and m2
   * @return The contact material if it was found.
   */ getContactMaterial(m1, m2) {
        return this.contactMaterialTable.get(m1.id, m2.id);
    }
    /**
   * Get number of objects in the world.
   * @deprecated
   */ numObjects() {
        return this.bodies.length;
    }
    /**
   * Store old collision state info
   */ collisionMatrixTick() {
        const temp = this.collisionMatrixPrevious;
        this.collisionMatrixPrevious = this.collisionMatrix;
        this.collisionMatrix = temp;
        this.collisionMatrix.reset();
        this.bodyOverlapKeeper.tick();
        this.shapeOverlapKeeper.tick();
    }
    /**
   * Add a constraint to the simulation.
   */ addConstraint(c) {
        this.constraints.push(c);
    }
    /**
   * Removes a constraint
   */ removeConstraint(c) {
        const idx = this.constraints.indexOf(c);
        if (idx !== -1) this.constraints.splice(idx, 1);
    }
    /**
   * Raycast test
   * @deprecated Use .raycastAll, .raycastClosest or .raycastAny instead.
   */ rayTest(from, to, result) {
        if (result instanceof $0982bf0d3ab2ea42$export$2e8bb24f335362cc) // Do raycastClosest
        this.raycastClosest(from, to, {
            skipBackfaces: true
        }, result);
        else // Do raycastAll
        this.raycastAll(from, to, {
            skipBackfaces: true
        }, result);
    }
    /**
   * Ray cast against all bodies. The provided callback will be executed for each hit with a RaycastResult as single argument.
   * @return True if any body was hit.
   */ raycastAll(from, to, options = {}, callback) {
        options.mode = $0982bf0d3ab2ea42$export$a186db52eed6d40e.ALL;
        options.from = from;
        options.to = to;
        options.callback = callback;
        return $0982bf0d3ab2ea42$var$tmpRay.intersectWorld(this, options);
    }
    /**
   * Ray cast, and stop at the first result. Note that the order is random - but the method is fast.
   * @return True if any body was hit.
   */ raycastAny(from, to, options = {}, result) {
        options.mode = $0982bf0d3ab2ea42$export$a186db52eed6d40e.ANY;
        options.from = from;
        options.to = to;
        options.result = result;
        return $0982bf0d3ab2ea42$var$tmpRay.intersectWorld(this, options);
    }
    /**
   * Ray cast, and return information of the closest hit.
   * @return True if any body was hit.
   */ raycastClosest(from, to, options = {}, result) {
        options.mode = $0982bf0d3ab2ea42$export$a186db52eed6d40e.CLOSEST;
        options.from = from;
        options.to = to;
        options.result = result;
        return $0982bf0d3ab2ea42$var$tmpRay.intersectWorld(this, options);
    }
    /**
   * Add a rigid body to the simulation.
   * @todo If the simulation has not yet started, why recrete and copy arrays for each body? Accumulate in dynamic arrays in this case.
   * @todo Adding an array of bodies should be possible. This would save some loops too
   */ addBody(body) {
        if (this.bodies.includes(body)) return;
        body.index = this.bodies.length;
        this.bodies.push(body);
        body.world = this;
        body.initPosition.copy(body.position);
        body.initVelocity.copy(body.velocity);
        body.timeLastSleepy = this.time;
        if (body instanceof $0982bf0d3ab2ea42$export$4b2c32e08f77ff18) {
            body.initAngularVelocity.copy(body.angularVelocity);
            body.initQuaternion.copy(body.quaternion);
        }
        this.collisionMatrix.setNumObjects(this.bodies.length);
        this.addBodyEvent.body = body;
        this.idToBodyMap[body.id] = body;
        this.dispatchEvent(this.addBodyEvent);
    }
    /**
   * Remove a rigid body from the simulation.
   */ removeBody(body) {
        body.world = null;
        const n = this.bodies.length - 1;
        const bodies = this.bodies;
        const idx = bodies.indexOf(body);
        if (idx !== -1) {
            bodies.splice(idx, 1); // Todo: should use a garbage free method
            // Recompute index
            for(let i = 0; i !== bodies.length; i++)bodies[i].index = i;
            this.collisionMatrix.setNumObjects(n);
            this.removeBodyEvent.body = body;
            delete this.idToBodyMap[body.id];
            this.dispatchEvent(this.removeBodyEvent);
        }
    }
    getBodyById(id) {
        return this.idToBodyMap[id];
    }
    /**
   * @todo Make a faster map
   */ getShapeById(id) {
        const bodies = this.bodies;
        for(let i = 0; i < bodies.length; i++){
            const shapes = bodies[i].shapes;
            for(let j = 0; j < shapes.length; j++){
                const shape = shapes[j];
                if (shape.id === id) return shape;
            }
        }
        return null;
    }
    /**
   * Adds a material to the World.
   * @deprecated
   * @todo Remove
   */ addMaterial(m) {
        this.materials.push(m);
    }
    /**
   * Adds a contact material to the World
   */ addContactMaterial(cmat) {
        // Add contact material
        this.contactmaterials.push(cmat); // Add current contact material to the material table
        this.contactMaterialTable.set(cmat.materials[0].id, cmat.materials[1].id, cmat);
    }
    /**
   * Step the physics world forward in time.
   *
   * There are two modes. The simple mode is fixed timestepping without interpolation. In this case you only use the first argument. The second case uses interpolation. In that you also provide the time since the function was last used, as well as the maximum fixed timesteps to take.
   *
   * @param dt The fixed time step size to use.
   * @param timeSinceLastCalled The time elapsed since the function was last called.
   * @param maxSubSteps Maximum number of fixed steps to take per function call.
   * @see https://web.archive.org/web/20180426154531/http://bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World#What_do_the_parameters_to_btDynamicsWorld::stepSimulation_mean.3F
   * @example
   *     // fixed timestepping without interpolation
   *     world.step(1 / 60)
   */ step(dt, timeSinceLastCalled, maxSubSteps = 10) {
        if (timeSinceLastCalled === undefined) {
            // Fixed, simple stepping
            this.internalStep(dt); // Increment time
            this.time += dt;
        } else {
            this.accumulator += timeSinceLastCalled;
            const t0 = $0982bf0d3ab2ea42$var$performance.now();
            let substeps = 0;
            while(this.accumulator >= dt && substeps < maxSubSteps){
                // Do fixed steps to catch up
                this.internalStep(dt);
                this.accumulator -= dt;
                substeps++;
                if ($0982bf0d3ab2ea42$var$performance.now() - t0 > dt * 1000) break;
            } // Remove the excess accumulator, since we may not
            // have had enough substeps available to catch up
            this.accumulator = this.accumulator % dt;
            const t = this.accumulator / dt;
            for(let j = 0; j !== this.bodies.length; j++){
                const b = this.bodies[j];
                b.previousPosition.lerp(b.position, t, b.interpolatedPosition);
                b.previousQuaternion.slerp(b.quaternion, t, b.interpolatedQuaternion);
                b.previousQuaternion.normalize();
            }
            this.time += timeSinceLastCalled;
        }
    }
    internalStep(dt) {
        this.dt = dt;
        const contacts = this.contacts;
        const p1 = $0982bf0d3ab2ea42$var$World_step_p1;
        const p2 = $0982bf0d3ab2ea42$var$World_step_p2;
        const N = this.numObjects();
        const bodies = this.bodies;
        const solver = this.solver;
        const gravity = this.gravity;
        const doProfiling = this.doProfiling;
        const profile = this.profile;
        const DYNAMIC = $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC;
        let profilingStart = -Infinity;
        const constraints = this.constraints;
        const frictionEquationPool = $0982bf0d3ab2ea42$var$World_step_frictionEquationPool;
        gravity.length();
        const gx = gravity.x;
        const gy = gravity.y;
        const gz = gravity.z;
        let i = 0;
        if (doProfiling) profilingStart = $0982bf0d3ab2ea42$var$performance.now();
         // Add gravity to all objects
        for(i = 0; i !== N; i++){
            const bi = bodies[i];
            if (bi.type === DYNAMIC) {
                // Only for dynamic bodies
                const f = bi.force;
                const m = bi.mass;
                f.x += m * gx;
                f.y += m * gy;
                f.z += m * gz;
            }
        } // Update subsystems
        for(let i = 0, Nsubsystems = this.subsystems.length; i !== Nsubsystems; i++)this.subsystems[i].update();
         // Collision detection
        if (doProfiling) profilingStart = $0982bf0d3ab2ea42$var$performance.now();
        p1.length = 0; // Clean up pair arrays from last step
        p2.length = 0;
        this.broadphase.collisionPairs(this, p1, p2);
        if (doProfiling) profile.broadphase = $0982bf0d3ab2ea42$var$performance.now() - profilingStart;
         // Remove constrained pairs with collideConnected == false
        let Nconstraints = constraints.length;
        for(i = 0; i !== Nconstraints; i++){
            const c = constraints[i];
            if (!c.collideConnected) {
                for(let j = p1.length - 1; j >= 0; j -= 1)if (c.bodyA === p1[j] && c.bodyB === p2[j] || c.bodyB === p1[j] && c.bodyA === p2[j]) {
                    p1.splice(j, 1);
                    p2.splice(j, 1);
                }
            }
        }
        this.collisionMatrixTick(); // Generate contacts
        if (doProfiling) profilingStart = $0982bf0d3ab2ea42$var$performance.now();
        const oldcontacts = $0982bf0d3ab2ea42$var$World_step_oldContacts;
        const NoldContacts = contacts.length;
        for(i = 0; i !== NoldContacts; i++)oldcontacts.push(contacts[i]);
        contacts.length = 0; // Transfer FrictionEquation from current list to the pool for reuse
        const NoldFrictionEquations = this.frictionEquations.length;
        for(i = 0; i !== NoldFrictionEquations; i++)frictionEquationPool.push(this.frictionEquations[i]);
        this.frictionEquations.length = 0;
        this.narrowphase.getContacts(p1, p2, this, contacts, oldcontacts, this.frictionEquations, frictionEquationPool);
        if (doProfiling) profile.narrowphase = $0982bf0d3ab2ea42$var$performance.now() - profilingStart;
         // Loop over all collisions
        if (doProfiling) profilingStart = $0982bf0d3ab2ea42$var$performance.now();
         // Add all friction eqs
        for(i = 0; i < this.frictionEquations.length; i++)solver.addEquation(this.frictionEquations[i]);
        const ncontacts = contacts.length;
        for(let k = 0; k !== ncontacts; k++){
            // Current contact
            const c = contacts[k]; // Get current collision indeces
            const bi = c.bi;
            const bj = c.bj;
            const si = c.si;
            const sj = c.sj; // Get collision properties
            let cm;
            if (bi.material && bj.material) cm = this.getContactMaterial(bi.material, bj.material) || this.defaultContactMaterial;
            else cm = this.defaultContactMaterial;
             // c.enabled = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;
            cm.friction; // c.restitution = cm.restitution;
            // If friction or restitution were specified in the material, use them
            if (bi.material && bj.material) {
                if (bi.material.friction >= 0 && bj.material.friction >= 0) bi.material.friction, bj.material.friction;
                if (bi.material.restitution >= 0 && bj.material.restitution >= 0) c.restitution = bi.material.restitution * bj.material.restitution;
            } // c.setSpookParams(
            //           cm.contactEquationStiffness,
            //           cm.contactEquationRelaxation,
            //           dt
            //       );
            solver.addEquation(c); // // Add friction constraint equation
            // if(mu > 0){
            // 	// Create 2 tangent equations
            // 	const mug = mu * gnorm;
            // 	const reducedMass = (bi.invMass + bj.invMass);
            // 	if(reducedMass > 0){
            // 		reducedMass = 1/reducedMass;
            // 	}
            // 	const pool = frictionEquationPool;
            // 	const c1 = pool.length ? pool.pop() : new FrictionEquation(bi,bj,mug*reducedMass);
            // 	const c2 = pool.length ? pool.pop() : new FrictionEquation(bi,bj,mug*reducedMass);
            // 	this.frictionEquations.push(c1, c2);
            // 	c1.bi = c2.bi = bi;
            // 	c1.bj = c2.bj = bj;
            // 	c1.minForce = c2.minForce = -mug*reducedMass;
            // 	c1.maxForce = c2.maxForce = mug*reducedMass;
            // 	// Copy over the relative vectors
            // 	c1.ri.copy(c.ri);
            // 	c1.rj.copy(c.rj);
            // 	c2.ri.copy(c.ri);
            // 	c2.rj.copy(c.rj);
            // 	// Construct tangents
            // 	c.ni.tangents(c1.t, c2.t);
            //           // Set spook params
            //           c1.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, dt);
            //           c2.setSpookParams(cm.frictionEquationStiffness, cm.frictionEquationRelaxation, dt);
            //           c1.enabled = c2.enabled = c.enabled;
            // 	// Add equations to solver
            // 	solver.addEquation(c1);
            // 	solver.addEquation(c2);
            // }
            if (bi.allowSleep && bi.type === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC && bi.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING && bj.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.AWAKE && bj.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC) {
                const speedSquaredB = bj.velocity.lengthSquared() + bj.angularVelocity.lengthSquared();
                const speedLimitSquaredB = bj.sleepSpeedLimit ** 2;
                if (speedSquaredB >= speedLimitSquaredB * 2) bi.wakeUpAfterNarrowphase = true;
            }
            if (bj.allowSleep && bj.type === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.DYNAMIC && bj.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING && bi.sleepState === $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.AWAKE && bi.type !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.STATIC) {
                const speedSquaredA = bi.velocity.lengthSquared() + bi.angularVelocity.lengthSquared();
                const speedLimitSquaredA = bi.sleepSpeedLimit ** 2;
                if (speedSquaredA >= speedLimitSquaredA * 2) bj.wakeUpAfterNarrowphase = true;
            } // Now we know that i and j are in contact. Set collision matrix state
            this.collisionMatrix.set(bi, bj, true);
            if (!this.collisionMatrixPrevious.get(bi, bj)) {
                // First contact!
                // We reuse the collideEvent object, otherwise we will end up creating new objects for each new contact, even if there's no event listener attached.
                $0982bf0d3ab2ea42$var$World_step_collideEvent.body = bj;
                $0982bf0d3ab2ea42$var$World_step_collideEvent.contact = c;
                bi.dispatchEvent($0982bf0d3ab2ea42$var$World_step_collideEvent);
                $0982bf0d3ab2ea42$var$World_step_collideEvent.body = bi;
                bj.dispatchEvent($0982bf0d3ab2ea42$var$World_step_collideEvent);
            }
            this.bodyOverlapKeeper.set(bi.id, bj.id);
            this.shapeOverlapKeeper.set(si.id, sj.id);
        }
        this.emitContactEvents();
        if (doProfiling) {
            profile.makeContactConstraints = $0982bf0d3ab2ea42$var$performance.now() - profilingStart;
            profilingStart = $0982bf0d3ab2ea42$var$performance.now();
        } // Wake up bodies
        for(i = 0; i !== N; i++){
            const bi = bodies[i];
            if (bi.wakeUpAfterNarrowphase) {
                bi.wakeUp();
                bi.wakeUpAfterNarrowphase = false;
            }
        } // Add user-added constraints
        Nconstraints = constraints.length;
        for(i = 0; i !== Nconstraints; i++){
            const c = constraints[i];
            c.update();
            for(let j = 0, Neq = c.equations.length; j !== Neq; j++){
                const eq = c.equations[j];
                solver.addEquation(eq);
            }
        } // Solve the constrained system
        solver.solve(dt, this);
        if (doProfiling) profile.solve = $0982bf0d3ab2ea42$var$performance.now() - profilingStart;
         // Remove all contacts from solver
        solver.removeAllEquations(); // Apply damping, see http://code.google.com/p/bullet/issues/detail?id=74 for details
        const pow = Math.pow;
        for(i = 0; i !== N; i++){
            const bi = bodies[i];
            if (bi.type & DYNAMIC) {
                // Only for dynamic bodies
                const ld = pow(1.0 - bi.linearDamping, dt);
                const v = bi.velocity;
                v.scale(ld, v);
                const av = bi.angularVelocity;
                if (av) {
                    const ad = pow(1.0 - bi.angularDamping, dt);
                    av.scale(ad, av);
                }
            }
        }
        this.dispatchEvent($0982bf0d3ab2ea42$var$World_step_preStepEvent); // Invoke pre-step callbacks
        for(i = 0; i !== N; i++){
            const bi = bodies[i];
            if (bi.preStep) bi.preStep.call(bi);
        } // Leap frog
        // vnew = v + h*f/m
        // xnew = x + h*vnew
        if (doProfiling) profilingStart = $0982bf0d3ab2ea42$var$performance.now();
        const stepnumber = this.stepnumber;
        const quatNormalize = stepnumber % (this.quatNormalizeSkip + 1) === 0;
        const quatNormalizeFast = this.quatNormalizeFast;
        for(i = 0; i !== N; i++)bodies[i].integrate(dt, quatNormalize, quatNormalizeFast);
        this.clearForces();
        this.broadphase.dirty = true;
        if (doProfiling) profile.integrate = $0982bf0d3ab2ea42$var$performance.now() - profilingStart;
         // Update step number
        this.stepnumber += 1;
        this.dispatchEvent($0982bf0d3ab2ea42$var$World_step_postStepEvent); // Invoke post-step callbacks
        for(i = 0; i !== N; i++){
            const bi = bodies[i];
            const postStep = bi.postStep;
            if (postStep) postStep.call(bi);
        } // Sleeping update
        let hasActiveBodies = true;
        if (this.allowSleep) {
            hasActiveBodies = false;
            for(i = 0; i !== N; i++){
                const bi = bodies[i];
                bi.sleepTick(this.time);
                if (bi.sleepState !== $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.SLEEPING) hasActiveBodies = true;
            }
        }
        this.hasActiveBodies = hasActiveBodies;
    }
    emitContactEvents() {
        const hasBeginContact = this.hasAnyEventListener('beginContact');
        const hasEndContact = this.hasAnyEventListener('endContact');
        if (hasBeginContact || hasEndContact) this.bodyOverlapKeeper.getDiff($0982bf0d3ab2ea42$var$additions, $0982bf0d3ab2ea42$var$removals);
        if (hasBeginContact) {
            for(let i = 0, l = $0982bf0d3ab2ea42$var$additions.length; i < l; i += 2){
                $0982bf0d3ab2ea42$var$beginContactEvent.bodyA = this.getBodyById($0982bf0d3ab2ea42$var$additions[i]);
                $0982bf0d3ab2ea42$var$beginContactEvent.bodyB = this.getBodyById($0982bf0d3ab2ea42$var$additions[i + 1]);
                this.dispatchEvent($0982bf0d3ab2ea42$var$beginContactEvent);
            }
            $0982bf0d3ab2ea42$var$beginContactEvent.bodyA = $0982bf0d3ab2ea42$var$beginContactEvent.bodyB = null;
        }
        if (hasEndContact) {
            for(let i = 0, l = $0982bf0d3ab2ea42$var$removals.length; i < l; i += 2){
                $0982bf0d3ab2ea42$var$endContactEvent.bodyA = this.getBodyById($0982bf0d3ab2ea42$var$removals[i]);
                $0982bf0d3ab2ea42$var$endContactEvent.bodyB = this.getBodyById($0982bf0d3ab2ea42$var$removals[i + 1]);
                this.dispatchEvent($0982bf0d3ab2ea42$var$endContactEvent);
            }
            $0982bf0d3ab2ea42$var$endContactEvent.bodyA = $0982bf0d3ab2ea42$var$endContactEvent.bodyB = null;
        }
        $0982bf0d3ab2ea42$var$additions.length = $0982bf0d3ab2ea42$var$removals.length = 0;
        const hasBeginShapeContact = this.hasAnyEventListener('beginShapeContact');
        const hasEndShapeContact = this.hasAnyEventListener('endShapeContact');
        if (hasBeginShapeContact || hasEndShapeContact) this.shapeOverlapKeeper.getDiff($0982bf0d3ab2ea42$var$additions, $0982bf0d3ab2ea42$var$removals);
        if (hasBeginShapeContact) {
            for(let i = 0, l = $0982bf0d3ab2ea42$var$additions.length; i < l; i += 2){
                const shapeA = this.getShapeById($0982bf0d3ab2ea42$var$additions[i]);
                const shapeB = this.getShapeById($0982bf0d3ab2ea42$var$additions[i + 1]);
                $0982bf0d3ab2ea42$var$beginShapeContactEvent.shapeA = shapeA;
                $0982bf0d3ab2ea42$var$beginShapeContactEvent.shapeB = shapeB;
                if (shapeA) $0982bf0d3ab2ea42$var$beginShapeContactEvent.bodyA = shapeA.body;
                if (shapeB) $0982bf0d3ab2ea42$var$beginShapeContactEvent.bodyB = shapeB.body;
                this.dispatchEvent($0982bf0d3ab2ea42$var$beginShapeContactEvent);
            }
            $0982bf0d3ab2ea42$var$beginShapeContactEvent.bodyA = $0982bf0d3ab2ea42$var$beginShapeContactEvent.bodyB = $0982bf0d3ab2ea42$var$beginShapeContactEvent.shapeA = $0982bf0d3ab2ea42$var$beginShapeContactEvent.shapeB = null;
        }
        if (hasEndShapeContact) {
            for(let i = 0, l = $0982bf0d3ab2ea42$var$removals.length; i < l; i += 2){
                const shapeA = this.getShapeById($0982bf0d3ab2ea42$var$removals[i]);
                const shapeB = this.getShapeById($0982bf0d3ab2ea42$var$removals[i + 1]);
                $0982bf0d3ab2ea42$var$endShapeContactEvent.shapeA = shapeA;
                $0982bf0d3ab2ea42$var$endShapeContactEvent.shapeB = shapeB;
                if (shapeA) $0982bf0d3ab2ea42$var$endShapeContactEvent.bodyA = shapeA.body;
                if (shapeB) $0982bf0d3ab2ea42$var$endShapeContactEvent.bodyB = shapeB.body;
                this.dispatchEvent($0982bf0d3ab2ea42$var$endShapeContactEvent);
            }
            $0982bf0d3ab2ea42$var$endShapeContactEvent.bodyA = $0982bf0d3ab2ea42$var$endShapeContactEvent.bodyB = $0982bf0d3ab2ea42$var$endShapeContactEvent.shapeA = $0982bf0d3ab2ea42$var$endShapeContactEvent.shapeB = null;
        }
    }
    /**
   * Sets all body forces in the world to zero.
   */ clearForces() {
        const bodies = this.bodies;
        const N = bodies.length;
        for(let i = 0; i !== N; i++){
            const b = bodies[i];
            b.force;
            b.torque;
            b.force.set(0, 0, 0);
            b.torque.set(0, 0, 0);
        }
    }
    /**
   * Currently / last used timestep. Is set to -1 if not available. This value is updated before each internal step, which means that it is "fresh" inside event callbacks.
   */ /**
   * Makes bodies go to sleep when they've been inactive.
   * @default false
   */ /**
   * All the current contacts (instances of ContactEquation) in the world.
   */ /**
   * How often to normalize quaternions. Set to 0 for every step, 1 for every second etc.. A larger value increases performance. If bodies tend to explode, set to a smaller value (zero to be sure nothing can go wrong).
   * @default 0
   */ /**
   * Set to true to use fast quaternion normalization. It is often enough accurate to use.
   * If bodies tend to explode, set to false.
   * @default false
   */ /**
   * The wall-clock time since simulation start.
   */ /**
   * Number of timesteps taken since start.
   */ /**
   * Default and last timestep sizes.
   */ /**
   * The gravity of the world.
   */ /**
   * The broadphase algorithm to use.
   * @default NaiveBroadphase
   */ /**
   * All bodies in this world
   */ /**
   * True if any bodies are not sleeping, false if every body is sleeping.
   */ /**
   * The solver algorithm to use.
   * @default GSSolver
   */ /**
   * collisionMatrix
   */ /**
   * CollisionMatrix from the previous step.
   */ /**
   * All added materials.
   * @deprecated
   * @todo Remove
   */ /**
   * All added contactmaterials.
   */ /**
   * Used to look up a ContactMaterial given two instances of Material.
   */ /**
   * The default material of the bodies.
   */ /**
   * This contact material is used if no suitable contactmaterial is found for a contact.
   */ /**
   * Time accumulator for interpolation.
   * @see https://gafferongames.com/game-physics/fix-your-timestep/
   */ /**
   * Dispatched after a body has been added to the world.
   */ /**
   * Dispatched after a body has been removed from the world.
   */ constructor(options = {}){
        super();
        this.dt = void 0;
        this.allowSleep = void 0;
        this.contacts = void 0;
        this.frictionEquations = void 0;
        this.quatNormalizeSkip = void 0;
        this.quatNormalizeFast = void 0;
        this.time = void 0;
        this.stepnumber = void 0;
        this.default_dt = void 0;
        this.nextId = void 0;
        this.gravity = void 0;
        this.broadphase = void 0;
        this.bodies = void 0;
        this.hasActiveBodies = void 0;
        this.solver = void 0;
        this.constraints = void 0;
        this.narrowphase = void 0;
        this.collisionMatrix = void 0;
        this.collisionMatrixPrevious = void 0;
        this.bodyOverlapKeeper = void 0;
        this.shapeOverlapKeeper = void 0;
        this.materials = void 0;
        this.contactmaterials = void 0;
        this.contactMaterialTable = void 0;
        this.defaultMaterial = void 0;
        this.defaultContactMaterial = void 0;
        this.doProfiling = void 0;
        this.profile = void 0;
        this.accumulator = void 0;
        this.subsystems = void 0;
        this.addBodyEvent = void 0;
        this.removeBodyEvent = void 0;
        this.idToBodyMap = void 0;
        this.dt = -1;
        this.allowSleep = !!options.allowSleep;
        this.contacts = [];
        this.frictionEquations = [];
        this.quatNormalizeSkip = options.quatNormalizeSkip !== undefined ? options.quatNormalizeSkip : 0;
        this.quatNormalizeFast = options.quatNormalizeFast !== undefined ? options.quatNormalizeFast : false;
        this.time = 0.0;
        this.stepnumber = 0;
        this.default_dt = 1 / 60;
        this.nextId = 0;
        this.gravity = new $0982bf0d3ab2ea42$export$838423f3adec30fa();
        if (options.gravity) this.gravity.copy(options.gravity);
        this.broadphase = options.broadphase !== undefined ? options.broadphase : new $0982bf0d3ab2ea42$export$c86abd7a4a88e05e();
        this.bodies = [];
        this.hasActiveBodies = false;
        this.solver = options.solver !== undefined ? options.solver : new $0982bf0d3ab2ea42$export$2ee2332ebe4d942();
        this.constraints = [];
        this.narrowphase = new $0982bf0d3ab2ea42$export$9e9d3b163351dd02(this);
        this.collisionMatrix = new $0982bf0d3ab2ea42$export$21b91c75495c488a();
        this.collisionMatrixPrevious = new $0982bf0d3ab2ea42$export$21b91c75495c488a();
        this.bodyOverlapKeeper = new $0982bf0d3ab2ea42$var$OverlapKeeper();
        this.shapeOverlapKeeper = new $0982bf0d3ab2ea42$var$OverlapKeeper();
        this.materials = [];
        this.contactmaterials = [];
        this.contactMaterialTable = new $0982bf0d3ab2ea42$var$TupleDictionary();
        this.defaultMaterial = new $0982bf0d3ab2ea42$export$a2d8b23205c25948('default');
        this.defaultContactMaterial = new $0982bf0d3ab2ea42$export$a172e4020a254255(this.defaultMaterial, this.defaultMaterial, {
            friction: 0.3,
            restitution: 0.0
        });
        this.doProfiling = false;
        this.profile = {
            solve: 0,
            makeContactConstraints: 0,
            broadphase: 0,
            integrate: 0,
            narrowphase: 0
        };
        this.accumulator = 0;
        this.subsystems = [];
        this.addBodyEvent = {
            type: 'addBody',
            body: null
        };
        this.removeBodyEvent = {
            type: 'removeBody',
            body: null
        };
        this.idToBodyMap = {};
        this.broadphase.setWorld(this);
    }
} // Temp stuff
new $0982bf0d3ab2ea42$export$8ec70f2db73b49aa();
const $0982bf0d3ab2ea42$var$tmpRay = new $0982bf0d3ab2ea42$export$a186db52eed6d40e(); // performance.now() fallback on Date.now()
const $0982bf0d3ab2ea42$var$performance = globalThis.performance || {};
if (!$0982bf0d3ab2ea42$var$performance.now) {
    let nowOffset = Date.now();
    if ($0982bf0d3ab2ea42$var$performance.timing && $0982bf0d3ab2ea42$var$performance.timing.navigationStart) nowOffset = $0982bf0d3ab2ea42$var$performance.timing.navigationStart;
    $0982bf0d3ab2ea42$var$performance.now = ()=>Date.now() - nowOffset;
}
// Reusable event objects to save memory.
const $0982bf0d3ab2ea42$var$World_step_postStepEvent = {
    type: 'postStep'
}; // Dispatched before the world steps forward in time.
const $0982bf0d3ab2ea42$var$World_step_preStepEvent = {
    type: 'preStep'
};
const $0982bf0d3ab2ea42$var$World_step_collideEvent = {
    type: $0982bf0d3ab2ea42$export$4b2c32e08f77ff18.COLLIDE_EVENT_NAME,
    body: null,
    contact: null
}; // Pools for unused objects
const $0982bf0d3ab2ea42$var$World_step_oldContacts = [];
const $0982bf0d3ab2ea42$var$World_step_frictionEquationPool = []; // Reusable arrays for collision pairs
const $0982bf0d3ab2ea42$var$World_step_p1 = [];
const $0982bf0d3ab2ea42$var$World_step_p2 = []; // Stuff for emitContactEvents
const $0982bf0d3ab2ea42$var$additions = [];
const $0982bf0d3ab2ea42$var$removals = [];
const $0982bf0d3ab2ea42$var$beginContactEvent = {
    type: 'beginContact',
    bodyA: null,
    bodyB: null
};
const $0982bf0d3ab2ea42$var$endContactEvent = {
    type: 'endContact',
    bodyA: null,
    bodyB: null
};
const $0982bf0d3ab2ea42$var$beginShapeContactEvent = {
    type: 'beginShapeContact',
    bodyA: null,
    bodyB: null,
    shapeA: null,
    shapeB: null
};
const $0982bf0d3ab2ea42$var$endShapeContactEvent = {
    type: 'endShapeContact',
    bodyA: null,
    bodyB: null,
    shapeA: null,
    shapeB: null
};

});

parcelRegister("29ZVX", function(module, exports) {

$parcel$export(module.exports, "addGeometry", function () { return $192c76cfa3142e30$export$9be89d5146f6d1ba; });
$parcel$export(module.exports, "addSimObject", function () { return $192c76cfa3142e30$export$7dd7e5a61a10f71d; });
$parcel$export(module.exports, "remSimObjects", function () { return $192c76cfa3142e30$export$e575120a216d8527; });
$parcel$export(module.exports, "getSimObject", function () { return $192c76cfa3142e30$export$c2d878a467464ca9; });
$parcel$export(module.exports, "getSimObjectIdx", function () { return $192c76cfa3142e30$export$c7ec567f7b168c30; });
$parcel$export(module.exports, "setSimObjectHighlight", function () { return $192c76cfa3142e30$export$56e405533b26a1fb; });
$parcel$export(module.exports, "setTCSimObjectsOnClick", function () { return $192c76cfa3142e30$export$3a5f6abb88398a00; });
$parcel$export(module.exports, "remControledSimObject", function () { return $192c76cfa3142e30$export$fb72e3604843fdc2; });
$parcel$export(module.exports, "getSimObjects", function () { return $192c76cfa3142e30$export$43bd6e44974bdbcc; });
$parcel$export(module.exports, "getSimObjectByPos", function () { return $192c76cfa3142e30$export$4aef52f7a6a329ce; });
$parcel$export(module.exports, "isAttached", function () { return $192c76cfa3142e30$export$25f47d8d05737ff2; });
$parcel$export(module.exports, "getAttachedObject", function () { return $192c76cfa3142e30$export$b98fbe97bca7a136; });
$parcel$export(module.exports, "randomColour", function () { return $192c76cfa3142e30$export$cca776d31eacb7a1; });
/**
This script handeles the 3D object addition
**/ 
var $8TfIJ = parcelRequire("8TfIJ");

parcelRequire("bIMf4");

var $hhs4I = parcelRequire("hhs4I");

var $htT9M = parcelRequire("htT9M");

var $jpav3 = parcelRequire("jpav3");

var $460Qg = parcelRequire("460Qg");

var $lT4gU = parcelRequire("lT4gU");

var $aFxf6 = parcelRequire("aFxf6");

var $cxq7w = parcelRequire("cxq7w");
parcelRequire("kHIP8");
//simObjects array
let $192c76cfa3142e30$var$simObjects = [];
//This stores the currently via the tranform controls controlled simObject
let $192c76cfa3142e30$var$controlledSimObject = undefined;
//Functions for creating meshes
//Simple box shape
function $192c76cfa3142e30$var$createBoxMesh(simObject1) {
    const geometry = new (0, $8TfIJ.BoxBufferGeometry)(simObject1.size.x, simObject1.size.y, simObject1.size.z, 10, 10);
    const material = new (0, $8TfIJ.MeshPhongMaterial)({
        color: simObject1.color
    });
    const mesh = new (0, $8TfIJ.Mesh)(geometry, material);
    return mesh;
}
//Simple cylinder
function $192c76cfa3142e30$var$createCylinderMesh(simObject1) {
    const cylinderMesh = new (0, $8TfIJ.Mesh)();
    cylinderMesh.geometry = new (0, $8TfIJ.CylinderGeometry)(.3, 0, .5, 10);
    cylinderMesh.material = new (0, $8TfIJ.MeshPhongMaterial)({
        color: simObject1.colour
    });
    return cylinderMesh;
}
//Simple sphere
function $192c76cfa3142e30$var$createSphereMesh(simObject1) {
    const mesh = new (0, $8TfIJ.Mesh)();
    mesh.geometry = new (0, $8TfIJ.SphereGeometry)(simObject1.size.z * 0.5, 12, 12);
    mesh.material = new (0, $8TfIJ.MeshPhongMaterial)({
        color: simObject1.colour
    });
    return mesh;
}
function $192c76cfa3142e30$export$9be89d5146f6d1ba(simObject1) {
    const size = new (0, $8TfIJ.Vector3)();
    const checkBox = new (0, $8TfIJ.Box3)();
    switch(simObject1.shape){
        case 'cube':
            simObject1.size.copy(new (0, $8TfIJ.Vector3)(.4, .4, .4));
            const cubeMesh = $192c76cfa3142e30$var$createBoxMesh(simObject1);
            simObject1.bodyShape = 'box';
            simObject1.add(cubeMesh);
            simObject1.createBody(0.5, 2, 0.1); //mass, friction, restitution
            simObject1.setGrippable();
            simObject1.setGripAxes();
            break;
        case 'rock':
            const rockMesh = (0, $aFxf6.makeRock)(50, simObject1.size.z, simObject1.colour);
            rockMesh.geometry.computeBoundingBox();
            rockMesh.geometry.center();
            checkBox.setFromObject(rockMesh);
            checkBox.getSize(size);
            simObject1.bodyShape = 'box';
            simObject1.size.copy(size);
            simObject1.add(rockMesh);
            simObject1.createBody(3, 2, 0.01); //mass, friction, restitution
            simObject1.setGrippable();
            simObject1.setGripAxes();
            break;
        case 'sphere':
            const sphereMesh = $192c76cfa3142e30$var$createSphereMesh(simObject1);
            sphereMesh.geometry.computeBoundingSphere();
            sphereMesh.geometry.computeBoundingBox();
            checkBox.setFromObject(sphereMesh);
            checkBox.getSize(size);
            simObject1.size.copy(size);
            simObject1.radius = sphereMesh.geometry.boundingSphere.radius;
            simObject1.bodyShape = 'sphere';
            simObject1.add(sphereMesh);
            simObject1.createBody(2.1, 1, 0.1); //mass, friction, restitution
            simObject1.setGrippable();
            simObject1.setGripAxes();
            break;
        case 'shaft':
            const assetPath = '/models/simObject_shapes/shaft/shaft.stl';
            const shape = 'cylinder';
            $192c76cfa3142e30$var$loadAssetSTL(simObject1, assetPath, shape); //I have use the promise stuff here...
            break;
        case 'custom':
            $192c76cfa3142e30$var$loadUserFile(simObject1);
            break;
        default:
            console.error('Unknown SimObject shape: ', simObject1.shape);
            break;
    }
}
//Loads a 3D object from file.
function $192c76cfa3142e30$var$loadAssetSTL(simObject1, assetPath, shape) {
    //const filePath = '/models/simObject_shapes/shaft/shaft.stl';
    const loader = new (0, $hhs4I.STLLoader)();
    const size = new (0, $8TfIJ.Vector3)();
    loader.load(assetPath, (geometry)=>{
        const material = new (0, $8TfIJ.MeshPhongMaterial)({
            color: simObject1.color
        });
        const mesh = new (0, $8TfIJ.Mesh)(geometry, material);
        simObject1.scaleFactor = 0.3;
        mesh.scale.copy(new (0, $8TfIJ.Vector3)(.03, .03, .03));
        mesh.geometry.computeBoundingBox();
        mesh.geometry.center();
        mesh.rotation.x = Math.PI / 2;
        const tmpBox = new (0, $8TfIJ.Box3)().setFromObject(mesh);
        tmpBox.getSize(size);
        simObject1.size.copy(size);
        simObject1.add(mesh);
        simObject1.bodyShape = shape;
        simObject1.createBody(5, 2, 0.1); //mass, friction, restitution
        simObject1.setGrippable();
        simObject1.setGripAxes();
        simObject1.render();
    });
}
function $192c76cfa3142e30$var$loadUserFile(simObject1) {
    const upload = document.createElement('input');
    upload.setAttribute('type', 'file');
    upload.setAttribute('accept', '.stl,.obj,.mtl,.png,.jpg,.jpeg,.bmp');
    upload.setAttribute('multiple', 'true'); // allow .obj + .mtl + textures
    upload.onchange = (fileSelectedEvent)=>{
        try {
            const files = Array.from(fileSelectedEvent.target.files);
            if (files.length === 0) return;
            const stlFile = files.find((f)=>f.name.toLowerCase().endsWith('.stl'));
            const objFile = files.find((f)=>f.name.toLowerCase().endsWith('.obj'));
            if (stlFile) {
                const reader = new FileReader();
                reader.addEventListener('load', (event)=>{
                    loadSTL(simObject1, event.target.result);
                });
                reader.readAsArrayBuffer(stlFile);
            } else if (objFile) $192c76cfa3142e30$var$loadUserOBJ(simObject1, files, objFile);
            else alert('Please select an .stl or .obj file (you can also include .mtl and texture files).');
        } catch (e) {
            console.log(e);
        }
    };
    document.body.appendChild(upload);
    upload.click();
    document.body.removeChild(upload);
}
function $192c76cfa3142e30$var$loadUserOBJ(simObject1, allFiles, objFile) {
    const mtlFile = allFiles.find((f)=>f.name.toLowerCase().endsWith('.mtl'));
    const textureFiles = allFiles.filter((f)=>/\.(png|jpe?g|bmp)$/i.test(f.name));
    const fileMap = {};
    allFiles.forEach((f)=>{
        fileMap[f.name] = URL.createObjectURL(f);
    });
    const manager = new (0, $8TfIJ.LoadingManager)();
    manager.setURLModifier((url)=>{
        const filename = url.split('/').pop().split('\\').pop();
        if (fileMap[filename]) return fileMap[filename];
        return url;
    });
    const objReader = new FileReader();
    objReader.addEventListener('load', (event)=>{
        const objText = event.target.result;
        if (mtlFile) {
            const mtlReader = new FileReader();
            mtlReader.addEventListener('load', (mtlEvent)=>{
                const mtlText = mtlEvent.target.result;
                const mtlLoader = new (0, $jpav3.MTLLoader)(manager);
                const materials = mtlLoader.parse(mtlText);
                materials.preload();
                const objLoader = new (0, $htT9M.OBJLoader)(manager);
                objLoader.setMaterials(materials);
                const obj = objLoader.parse(objText);
                $192c76cfa3142e30$var$attachOBJToSimObject(simObject1, obj);
            });
            mtlReader.readAsText(mtlFile);
        } else {
            const objLoader = new (0, $htT9M.OBJLoader)(manager);
            const obj = objLoader.parse(objText);
            const defaultMaterial = new (0, $8TfIJ.MeshPhongMaterial)({
                color: simObject1.color
            });
            obj.traverse((child)=>{
                if (child.isMesh) child.material = defaultMaterial;
            });
            $192c76cfa3142e30$var$attachOBJToSimObject(simObject1, obj);
        }
    });
    objReader.readAsText(objFile);
}
function $192c76cfa3142e30$var$attachOBJToSimObject(simObject1, obj) {
    const size = new (0, $8TfIJ.Vector3)();
    const rawBox = new (0, $8TfIJ.Box3)().setFromObject(obj);
    rawBox.getSize(size);
    const TARGET_SIZE = 1.0;
    const maxDim = Math.max(size.x, size.y, size.z);
    if (maxDim > 0 && isFinite(maxDim)) {
        const sf = TARGET_SIZE / maxDim;
        obj.scale.set(sf, sf, sf);
        simObject1.scaleFactor = sf;
    } else simObject1.scaleFactor = 1;
    obj.updateMatrixWorld(true);
    const scaledBox = new (0, $8TfIJ.Box3)().setFromObject(obj);
    const scaledCenter = new (0, $8TfIJ.Vector3)();
    scaledBox.getCenter(scaledCenter);
    scaledBox.getSize(size);
    obj.position.x -= scaledCenter.x;
    obj.position.y -= scaledCenter.y;
    obj.position.z -= scaledBox.min.z;
    simObject1.size.copy(size);
    simObject1.add(obj);
    simObject1.bodyShape = 'box';
    simObject1.createBody(5, 2, 0.1);
    simObject1.setGrippable();
    simObject1.setGripAxes();
    simObject1.render();
}
function $192c76cfa3142e30$export$7dd7e5a61a10f71d(blockUUID, fieldValues, color, shape, scale) {
    let simObject1 = new (0, $lT4gU.SimObject);
    simObject1.name = blockUUID;
    $192c76cfa3142e30$var$simObjects.push(simObject1);
    simObject1.shape = shape;
    simObject1.color = color;
    $192c76cfa3142e30$export$9be89d5146f6d1ba(simObject1);
    if (fieldValues != undefined) {
        simObject1.setFieldValues(fieldValues);
        simObject1.updateFromFieldValues();
    } else {
        simObject1.setFieldValues(simObject1._fieldValues);
        simObject1.updateFromFieldValues();
    }
    simObject1.addToScene();
    if (scale != 1) simObject1.setScale(scale);
    if ($192c76cfa3142e30$var$simObjects.length > 1) {
        $192c76cfa3142e30$export$9848deae207f96bc(simObject1);
        simObject1.updateFieldValues();
        simObject1.updatePoseBlock();
    }
}
function $192c76cfa3142e30$export$9848deae207f96bc(simObject1) {
    const limit = $192c76cfa3142e30$var$simObjects.length;
    for(let k = 0; k < limit; k++)if ($192c76cfa3142e30$var$simObjects[k].name != simObject1.name) {
        let box = new (0, $8TfIJ.Box3)().setFromObject(simObject1);
        let checkBox = new (0, $8TfIJ.Box3)().setFromObject($192c76cfa3142e30$var$simObjects[k]);
        let intersecting = true;
        while(intersecting){
            simObject1.position.z = simObject1.position.z + 0.001;
            box.setFromObject(simObject1);
            intersecting = box.intersectsBox(checkBox);
        }
    }
}
function $192c76cfa3142e30$export$e575120a216d8527(ids) {
    const limit = ids.length;
    for(let i = 0; i < limit; i++){
        const deletedSimObject = $192c76cfa3142e30$export$c2d878a467464ca9(ids[i]);
        const idx = $192c76cfa3142e30$export$c7ec567f7b168c30(ids[i]);
        if (deletedSimObject != undefined) {
            deletedSimObject.removeFromScene();
            $192c76cfa3142e30$var$simObjects.splice(idx, 1);
        }
    }
}
function $192c76cfa3142e30$export$56e405533b26a1fb(raycaster) {
    if ($192c76cfa3142e30$var$controlledSimObject != undefined) return;
    const intersections = raycaster.intersectObjects($192c76cfa3142e30$var$simObjects, true);
    const intersected = intersections.length > 0;
    const workspace = $460Qg.getMainWorkspace();
    if (intersected) {
        const intersectedSimObj = intersections[0].object.parent;
        if (intersectedSimObj.highlighted != intersected) {
            const limit = $192c76cfa3142e30$var$simObjects.length;
            for(let i = 0; i < limit; i++)$192c76cfa3142e30$var$simObjects[i].highlight(false);
            intersectedSimObj.highlight(intersected);
            workspace.highlightBlock(intersectedSimObj.name);
        }
    } else {
        const limit = $192c76cfa3142e30$var$simObjects.length;
        for(let i = 0; i < limit; i++){
            $192c76cfa3142e30$var$simObjects[i].highlight(false);
            workspace.highlightBlock(null);
        }
    }
}
function $192c76cfa3142e30$export$3a5f6abb88398a00(raycaster) {
    const intersections = raycaster.intersectObjects($192c76cfa3142e30$var$simObjects, true);
    const intersected = intersections.length > 0;
    if (intersected) {
        const intersectedSimObj = intersections[0].object.parent;
        if (intersectedSimObj === $192c76cfa3142e30$var$controlledSimObject) {
            const mode = intersectedSimObj.control.getMode();
            switch(mode){
                case 'translate':
                    intersectedSimObj.control.setMode('rotate');
                    break;
                case 'rotate':
                default:
                    intersectedSimObj.control.setMode('translate');
            }
            return intersected;
        }
        if ($192c76cfa3142e30$var$controlledSimObject != undefined) $192c76cfa3142e30$var$removeTransformControl($192c76cfa3142e30$var$controlledSimObject);
        $192c76cfa3142e30$var$activateTransformControl(intersectedSimObj);
        $192c76cfa3142e30$var$controlledSimObject = intersectedSimObj;
    } else if ($192c76cfa3142e30$var$controlledSimObject != undefined) {
        $460Qg.getMainWorkspace().highlightBlock(null);
        $192c76cfa3142e30$var$controlledSimObject.highlight(false);
        $192c76cfa3142e30$var$removeTransformControl($192c76cfa3142e30$var$controlledSimObject);
        $192c76cfa3142e30$var$controlledSimObject = undefined;
    }
    return intersected;
}
//Activates the TransformControls
function $192c76cfa3142e30$var$activateTransformControl(simObject1) {
    simObject1.control.setMode('translate');
    simObject1.setTransformControlEnabled(true);
    (0, $cxq7w.getScene)().add(simObject1.control);
}
//Removes the TransformControls
function $192c76cfa3142e30$var$removeTransformControl(simObject1) {
    (0, $cxq7w.getScene)().remove(simObject1.control);
    simObject1.control.setMode('rotate');
    simObject1.setTransformControlEnabled(false);
}
function $192c76cfa3142e30$export$fb72e3604843fdc2() {
    if ($192c76cfa3142e30$var$controlledSimObject) $192c76cfa3142e30$var$removeTransformControl($192c76cfa3142e30$var$controlledSimObject);
    $192c76cfa3142e30$var$controlledSimObject = undefined;
}
function $192c76cfa3142e30$export$c1954e064721f3ee() {
    let simObjectsNames = [];
    const simObjectsLen = $192c76cfa3142e30$var$simObjects.length;
    for(let i = 0; i < simObjectsLen; i++)simObjectsNames.push(simObject.name);
    return simObjectsNames;
}
function $192c76cfa3142e30$export$43bd6e44974bdbcc() {
    return $192c76cfa3142e30$var$simObjects;
}
function $192c76cfa3142e30$export$c2d878a467464ca9(simObjectName) {
    const simObject1 = $192c76cfa3142e30$var$simObjects.find((simObject1)=>simObject1.name === simObjectName);
    return simObject1;
}
function $192c76cfa3142e30$export$c7ec567f7b168c30(simObjectName) {
    const idx = $192c76cfa3142e30$var$simObjects.findIndex((simObject1)=>simObject1.name === simObjectName);
    return idx;
}
function $192c76cfa3142e30$export$4aef52f7a6a329ce(position) {
    let minDist = 9999.0;
    let minIdx = -1;
    let dist;
    const simObjectsLen = $192c76cfa3142e30$var$simObjects.length;
    for(let i = 0; i < simObjectsLen; i++){
        dist = $192c76cfa3142e30$var$simObjects[i].position.distanceTo(position);
        if (dist <= minDist) {
            minDist = dist;
            minIdx = i;
        }
    }
    if (minIdx < 0) return undefined;
    const checkBox = new (0, $8TfIJ.Box3)().setFromObject($192c76cfa3142e30$var$simObjects[minIdx]);
    if (checkBox.containsPoint(position)) return $192c76cfa3142e30$var$simObjects[minIdx];
    return undefined;
}
function $192c76cfa3142e30$export$25f47d8d05737ff2() {
    return !!$192c76cfa3142e30$export$b98fbe97bca7a136();
}
function $192c76cfa3142e30$export$b98fbe97bca7a136() {
    const limit = $192c76cfa3142e30$var$simObjects.length;
    for(let i = 0; i < limit; i++){
        if ($192c76cfa3142e30$var$simObjects[i].attached) return $192c76cfa3142e30$var$simObjects[i];
    }
    return undefined;
}
//Utils
//Random integers. They are essential. Not uesed right now.
function $192c76cfa3142e30$var$getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}
function $192c76cfa3142e30$export$cca776d31eacb7a1() {
    const hexDigits = '0123456789ABCDEF';
    let colour = '#';
    for(let i = 0; i < 6; i++)colour += hexDigits[Math.floor(Math.random() * 16)];
    return colour;
}

});
parcelRegister("bIMf4", function(module, exports) {

$parcel$export(module.exports, "TransformControls", function () { return $888939a466314c44$export$198e80c116632110; });

var $8TfIJ = parcelRequire("8TfIJ");
const $888939a466314c44$var$_raycaster = new (0, $8TfIJ.Raycaster)();
const $888939a466314c44$var$_tempVector = new (0, $8TfIJ.Vector3)();
const $888939a466314c44$var$_tempVector2 = new (0, $8TfIJ.Vector3)();
const $888939a466314c44$var$_tempQuaternion = new (0, $8TfIJ.Quaternion)();
const $888939a466314c44$var$_unit = {
    X: new (0, $8TfIJ.Vector3)(1, 0, 0),
    Y: new (0, $8TfIJ.Vector3)(0, 1, 0),
    Z: new (0, $8TfIJ.Vector3)(0, 0, 1)
};
const $888939a466314c44$var$_changeEvent = {
    type: 'change'
};
const $888939a466314c44$var$_mouseDownEvent = {
    type: 'mouseDown'
};
const $888939a466314c44$var$_mouseUpEvent = {
    type: 'mouseUp',
    mode: null
};
const $888939a466314c44$var$_objectChangeEvent = {
    type: 'objectChange'
};
class $888939a466314c44$export$198e80c116632110 extends (0, $8TfIJ.Object3D) {
    // updateMatrixWorld  updates key transformation variables
    updateMatrixWorld() {
        if (this.object !== undefined) {
            this.object.updateMatrixWorld();
            if (this.object.parent === null) console.error('TransformControls: The attached 3D object must be a part of the scene graph.');
            else this.object.parent.matrixWorld.decompose(this._parentPosition, this._parentQuaternion, this._parentScale);
            this.object.matrixWorld.decompose(this.worldPosition, this.worldQuaternion, this._worldScale);
            this._parentQuaternionInv.copy(this._parentQuaternion).invert();
            this._worldQuaternionInv.copy(this.worldQuaternion).invert();
        }
        this.camera.updateMatrixWorld();
        this.camera.matrixWorld.decompose(this.cameraPosition, this.cameraQuaternion, this._cameraScale);
        this.eye.copy(this.cameraPosition).sub(this.worldPosition).normalize();
        super.updateMatrixWorld(this);
    }
    pointerHover(pointer) {
        if (this.object === undefined || this.dragging === true) return;
        $888939a466314c44$var$_raycaster.setFromCamera(pointer, this.camera);
        const intersect = $888939a466314c44$var$intersectObjectWithRay(this._gizmo.picker[this.mode], $888939a466314c44$var$_raycaster);
        if (intersect) this.axis = intersect.object.name;
        else this.axis = null;
    }
    pointerDown(pointer) {
        if (this.object === undefined || this.dragging === true || pointer.button !== 0) return;
        if (this.axis !== null) {
            $888939a466314c44$var$_raycaster.setFromCamera(pointer, this.camera);
            const planeIntersect = $888939a466314c44$var$intersectObjectWithRay(this._plane, $888939a466314c44$var$_raycaster, true);
            if (planeIntersect) {
                let space = this.space;
                if (this.mode === 'scale') space = 'local';
                else if (this.axis === 'E' || this.axis === 'XYZE' || this.axis === 'XYZ') space = 'world';
                if (space === 'local' && this.mode === 'rotate') {
                    const snap = this.rotationSnap;
                    if (this.axis === 'X' && snap) this.object.rotation.x = Math.round(this.object.rotation.x / snap) * snap;
                    if (this.axis === 'Y' && snap) this.object.rotation.y = Math.round(this.object.rotation.y / snap) * snap;
                    if (this.axis === 'Z' && snap) this.object.rotation.z = Math.round(this.object.rotation.z / snap) * snap;
                }
                this.object.updateMatrixWorld();
                this.object.parent.updateMatrixWorld();
                this._positionStart.copy(this.object.position);
                this._quaternionStart.copy(this.object.quaternion);
                this._scaleStart.copy(this.object.scale);
                this.object.matrixWorld.decompose(this.worldPositionStart, this.worldQuaternionStart, this._worldScaleStart);
                this.pointStart.copy(planeIntersect.point).sub(this.worldPositionStart);
            }
            this.dragging = true;
            $888939a466314c44$var$_mouseDownEvent.mode = this.mode;
            this.dispatchEvent($888939a466314c44$var$_mouseDownEvent);
        }
    }
    pointerMove(pointer) {
        const axis = this.axis;
        const mode = this.mode;
        const object = this.object;
        let space = this.space;
        if (mode === 'scale') space = 'local';
        else if (axis === 'E' || axis === 'XYZE' || axis === 'XYZ') space = 'world';
        if (object === undefined || axis === null || this.dragging === false || pointer.button !== -1) return;
        $888939a466314c44$var$_raycaster.setFromCamera(pointer, this.camera);
        const planeIntersect = $888939a466314c44$var$intersectObjectWithRay(this._plane, $888939a466314c44$var$_raycaster, true);
        if (!planeIntersect) return;
        this.pointEnd.copy(planeIntersect.point).sub(this.worldPositionStart);
        if (mode === 'translate') {
            // Apply translate
            this._offset.copy(this.pointEnd).sub(this.pointStart);
            if (space === 'local' && axis !== 'XYZ') this._offset.applyQuaternion(this._worldQuaternionInv);
            if (axis.indexOf('X') === -1) this._offset.x = 0;
            if (axis.indexOf('Y') === -1) this._offset.y = 0;
            if (axis.indexOf('Z') === -1) this._offset.z = 0;
            if (space === 'local' && axis !== 'XYZ') this._offset.applyQuaternion(this._quaternionStart).divide(this._parentScale);
            else this._offset.applyQuaternion(this._parentQuaternionInv).divide(this._parentScale);
            object.position.copy(this._offset).add(this._positionStart);
            // Apply translation snap
            if (this.translationSnap) {
                if (space === 'local') {
                    object.position.applyQuaternion($888939a466314c44$var$_tempQuaternion.copy(this._quaternionStart).invert());
                    if (axis.search('X') !== -1) object.position.x = Math.round(object.position.x / this.translationSnap) * this.translationSnap;
                    if (axis.search('Y') !== -1) object.position.y = Math.round(object.position.y / this.translationSnap) * this.translationSnap;
                    if (axis.search('Z') !== -1) object.position.z = Math.round(object.position.z / this.translationSnap) * this.translationSnap;
                    object.position.applyQuaternion(this._quaternionStart);
                }
                if (space === 'world') {
                    if (object.parent) object.position.add($888939a466314c44$var$_tempVector.setFromMatrixPosition(object.parent.matrixWorld));
                    if (axis.search('X') !== -1) object.position.x = Math.round(object.position.x / this.translationSnap) * this.translationSnap;
                    if (axis.search('Y') !== -1) object.position.y = Math.round(object.position.y / this.translationSnap) * this.translationSnap;
                    if (axis.search('Z') !== -1) object.position.z = Math.round(object.position.z / this.translationSnap) * this.translationSnap;
                    if (object.parent) object.position.sub($888939a466314c44$var$_tempVector.setFromMatrixPosition(object.parent.matrixWorld));
                }
            }
        } else if (mode === 'scale') {
            if (axis.search('XYZ') !== -1) {
                let d = this.pointEnd.length() / this.pointStart.length();
                if (this.pointEnd.dot(this.pointStart) < 0) d *= -1;
                $888939a466314c44$var$_tempVector2.set(d, d, d);
            } else {
                $888939a466314c44$var$_tempVector.copy(this.pointStart);
                $888939a466314c44$var$_tempVector2.copy(this.pointEnd);
                $888939a466314c44$var$_tempVector.applyQuaternion(this._worldQuaternionInv);
                $888939a466314c44$var$_tempVector2.applyQuaternion(this._worldQuaternionInv);
                $888939a466314c44$var$_tempVector2.divide($888939a466314c44$var$_tempVector);
                if (axis.search('X') === -1) $888939a466314c44$var$_tempVector2.x = 1;
                if (axis.search('Y') === -1) $888939a466314c44$var$_tempVector2.y = 1;
                if (axis.search('Z') === -1) $888939a466314c44$var$_tempVector2.z = 1;
            }
            // Apply scale
            object.scale.copy(this._scaleStart).multiply($888939a466314c44$var$_tempVector2);
            if (this.scaleSnap) {
                if (axis.search('X') !== -1) object.scale.x = Math.round(object.scale.x / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
                if (axis.search('Y') !== -1) object.scale.y = Math.round(object.scale.y / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
                if (axis.search('Z') !== -1) object.scale.z = Math.round(object.scale.z / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
            }
        } else if (mode === 'rotate') {
            this._offset.copy(this.pointEnd).sub(this.pointStart);
            const ROTATION_SPEED = 20 / this.worldPosition.distanceTo($888939a466314c44$var$_tempVector.setFromMatrixPosition(this.camera.matrixWorld));
            if (axis === 'E') {
                this.rotationAxis.copy(this.eye);
                this.rotationAngle = this.pointEnd.angleTo(this.pointStart);
                this._startNorm.copy(this.pointStart).normalize();
                this._endNorm.copy(this.pointEnd).normalize();
                this.rotationAngle *= this._endNorm.cross(this._startNorm).dot(this.eye) < 0 ? 1 : -1;
            } else if (axis === 'XYZE') {
                this.rotationAxis.copy(this._offset).cross(this.eye).normalize();
                this.rotationAngle = this._offset.dot($888939a466314c44$var$_tempVector.copy(this.rotationAxis).cross(this.eye)) * ROTATION_SPEED;
            } else if (axis === 'X' || axis === 'Y' || axis === 'Z') {
                this.rotationAxis.copy($888939a466314c44$var$_unit[axis]);
                $888939a466314c44$var$_tempVector.copy($888939a466314c44$var$_unit[axis]);
                if (space === 'local') $888939a466314c44$var$_tempVector.applyQuaternion(this.worldQuaternion);
                this.rotationAngle = this._offset.dot($888939a466314c44$var$_tempVector.cross(this.eye).normalize()) * ROTATION_SPEED;
            }
            // Apply rotation snap
            if (this.rotationSnap) this.rotationAngle = Math.round(this.rotationAngle / this.rotationSnap) * this.rotationSnap;
            // Apply rotate
            if (space === 'local' && axis !== 'E' && axis !== 'XYZE') {
                object.quaternion.copy(this._quaternionStart);
                object.quaternion.multiply($888939a466314c44$var$_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle)).normalize();
            } else {
                this.rotationAxis.applyQuaternion(this._parentQuaternionInv);
                object.quaternion.copy($888939a466314c44$var$_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle));
                object.quaternion.multiply(this._quaternionStart).normalize();
            }
        }
        this.dispatchEvent($888939a466314c44$var$_changeEvent);
        this.dispatchEvent($888939a466314c44$var$_objectChangeEvent);
    }
    pointerUp(pointer) {
        if (pointer.button !== 0) return;
        if (this.dragging && this.axis !== null) {
            $888939a466314c44$var$_mouseUpEvent.mode = this.mode;
            this.dispatchEvent($888939a466314c44$var$_mouseUpEvent);
        }
        this.dragging = false;
        this.axis = null;
    }
    dispose() {
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointermove', this._onPointerHover);
        this.domElement.ownerDocument.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.ownerDocument.removeEventListener('pointerup', this._onPointerUp);
        this.traverse(function(child) {
            if (child.geometry) child.geometry.dispose();
            if (child.material) child.material.dispose();
        });
    }
    // Set current object
    attach(object) {
        this.object = object;
        this.visible = true;
        return this;
    }
    // Detatch from object
    detach() {
        this.object = undefined;
        this.visible = false;
        this.axis = null;
        return this;
    }
    // TODO: deprecate
    getMode() {
        return this.mode;
    }
    setMode(mode) {
        this.mode = mode;
    }
    setTranslationSnap(translationSnap) {
        this.translationSnap = translationSnap;
    }
    setRotationSnap(rotationSnap) {
        this.rotationSnap = rotationSnap;
    }
    setScaleSnap(scaleSnap) {
        this.scaleSnap = scaleSnap;
    }
    setSize(size) {
        this.size = size;
    }
    setSpace(space) {
        this.space = space;
    }
    update() {
        console.warn('THREE.TransformControls: update function has no more functionality and therefore has been deprecated.');
    }
    constructor(camera, domElement){
        super();
        if (domElement === undefined) {
            console.warn('THREE.TransformControls: The second parameter "domElement" is now mandatory.');
            domElement = document;
        }
        this.visible = false;
        this.domElement = domElement;
        const _gizmo = new $888939a466314c44$export$c2ae06a69fb9d31f();
        this._gizmo = _gizmo;
        this.add(_gizmo);
        const _plane = new $888939a466314c44$export$c0ab73045548e2ca();
        this._plane = _plane;
        this.add(_plane);
        const scope = this;
        // Defined getter, setter and store for a property
        function defineProperty(propName, defaultValue) {
            let propValue = defaultValue;
            Object.defineProperty(scope, propName, {
                get: function() {
                    return propValue !== undefined ? propValue : defaultValue;
                },
                set: function(value) {
                    if (propValue !== value) {
                        propValue = value;
                        _plane[propName] = value;
                        _gizmo[propName] = value;
                        scope.dispatchEvent({
                            type: propName + '-changed',
                            value: value
                        });
                        scope.dispatchEvent($888939a466314c44$var$_changeEvent);
                    }
                }
            });
            scope[propName] = defaultValue;
            _plane[propName] = defaultValue;
            _gizmo[propName] = defaultValue;
        }
        // Define properties with getters/setter
        // Setting the defined property will automatically trigger change event
        // Defined properties are passed down to gizmo and plane
        defineProperty('camera', camera);
        defineProperty('object', undefined);
        defineProperty('enabled', true);
        defineProperty('axis', null);
        defineProperty('mode', 'translate');
        defineProperty('translationSnap', null);
        defineProperty('rotationSnap', null);
        defineProperty('scaleSnap', null);
        defineProperty('space', 'world');
        defineProperty('size', 1);
        defineProperty('dragging', false);
        defineProperty('showX', true);
        defineProperty('showY', true);
        defineProperty('showZ', true);
        // Reusable utility variables
        const worldPosition = new (0, $8TfIJ.Vector3)();
        const worldPositionStart = new (0, $8TfIJ.Vector3)();
        const worldQuaternion = new (0, $8TfIJ.Quaternion)();
        const worldQuaternionStart = new (0, $8TfIJ.Quaternion)();
        const cameraPosition = new (0, $8TfIJ.Vector3)();
        const cameraQuaternion = new (0, $8TfIJ.Quaternion)();
        const pointStart = new (0, $8TfIJ.Vector3)();
        const pointEnd = new (0, $8TfIJ.Vector3)();
        const rotationAxis = new (0, $8TfIJ.Vector3)();
        const rotationAngle = 0;
        const eye = new (0, $8TfIJ.Vector3)();
        // TODO: remove properties unused in plane and gizmo
        defineProperty('worldPosition', worldPosition);
        defineProperty('worldPositionStart', worldPositionStart);
        defineProperty('worldQuaternion', worldQuaternion);
        defineProperty('worldQuaternionStart', worldQuaternionStart);
        defineProperty('cameraPosition', cameraPosition);
        defineProperty('cameraQuaternion', cameraQuaternion);
        defineProperty('pointStart', pointStart);
        defineProperty('pointEnd', pointEnd);
        defineProperty('rotationAxis', rotationAxis);
        defineProperty('rotationAngle', rotationAngle);
        defineProperty('eye', eye);
        this._offset = new (0, $8TfIJ.Vector3)();
        this._startNorm = new (0, $8TfIJ.Vector3)();
        this._endNorm = new (0, $8TfIJ.Vector3)();
        this._cameraScale = new (0, $8TfIJ.Vector3)();
        this._parentPosition = new (0, $8TfIJ.Vector3)();
        this._parentQuaternion = new (0, $8TfIJ.Quaternion)();
        this._parentQuaternionInv = new (0, $8TfIJ.Quaternion)();
        this._parentScale = new (0, $8TfIJ.Vector3)();
        this._worldScaleStart = new (0, $8TfIJ.Vector3)();
        this._worldQuaternionInv = new (0, $8TfIJ.Quaternion)();
        this._worldScale = new (0, $8TfIJ.Vector3)();
        this._positionStart = new (0, $8TfIJ.Vector3)();
        this._quaternionStart = new (0, $8TfIJ.Quaternion)();
        this._scaleStart = new (0, $8TfIJ.Vector3)();
        this._getPointer = $888939a466314c44$var$getPointer.bind(this);
        this._onPointerDown = $888939a466314c44$var$onPointerDown.bind(this);
        this._onPointerHover = $888939a466314c44$var$onPointerHover.bind(this);
        this._onPointerMove = $888939a466314c44$var$onPointerMove.bind(this);
        this._onPointerUp = $888939a466314c44$var$onPointerUp.bind(this);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointermove', this._onPointerHover);
        this.domElement.ownerDocument.addEventListener('pointerup', this._onPointerUp);
    }
}
$888939a466314c44$export$198e80c116632110.prototype.isTransformControls = true;
// mouse / touch event handlers
function $888939a466314c44$var$getPointer(event) {
    if (this.domElement.ownerDocument.pointerLockElement) return {
        x: 0,
        y: 0,
        button: event.button
    };
    else {
        const pointer = event.changedTouches ? event.changedTouches[0] : event;
        const rect = this.domElement.getBoundingClientRect();
        return {
            x: (pointer.clientX - rect.left) / rect.width * 2 - 1,
            y: -(pointer.clientY - rect.top) / rect.height * 2 + 1,
            button: event.button
        };
    }
}
function $888939a466314c44$var$onPointerHover(event) {
    if (!this.enabled) return;
    switch(event.pointerType){
        case 'mouse':
        case 'pen':
            this.pointerHover(this._getPointer(event));
            break;
    }
}
function $888939a466314c44$var$onPointerDown(event) {
    if (!this.enabled) return;
    this.domElement.style.touchAction = 'none'; // disable touch scroll
    this.domElement.ownerDocument.addEventListener('pointermove', this._onPointerMove);
    this.pointerHover(this._getPointer(event));
    this.pointerDown(this._getPointer(event));
}
function $888939a466314c44$var$onPointerMove(event) {
    if (!this.enabled) return;
    this.pointerMove(this._getPointer(event));
}
function $888939a466314c44$var$onPointerUp(event) {
    if (!this.enabled) return;
    this.domElement.style.touchAction = '';
    this.domElement.ownerDocument.removeEventListener('pointermove', this._onPointerMove);
    this.pointerUp(this._getPointer(event));
}
function $888939a466314c44$var$intersectObjectWithRay(object, raycaster, includeInvisible) {
    const allIntersections = raycaster.intersectObject(object, true);
    for(let i = 0; i < allIntersections.length; i++){
        if (allIntersections[i].object.visible || includeInvisible) return allIntersections[i];
    }
    return false;
}
//
// Reusable utility variables
const $888939a466314c44$var$_tempEuler = new (0, $8TfIJ.Euler)();
const $888939a466314c44$var$_alignVector = new (0, $8TfIJ.Vector3)(0, 1, 0);
const $888939a466314c44$var$_zeroVector = new (0, $8TfIJ.Vector3)(0, 0, 0);
const $888939a466314c44$var$_lookAtMatrix = new (0, $8TfIJ.Matrix4)();
const $888939a466314c44$var$_tempQuaternion2 = new (0, $8TfIJ.Quaternion)();
const $888939a466314c44$var$_identityQuaternion = new (0, $8TfIJ.Quaternion)();
const $888939a466314c44$var$_dirVector = new (0, $8TfIJ.Vector3)();
const $888939a466314c44$var$_tempMatrix = new (0, $8TfIJ.Matrix4)();
const $888939a466314c44$var$_unitX = new (0, $8TfIJ.Vector3)(1, 0, 0);
const $888939a466314c44$var$_unitY = new (0, $8TfIJ.Vector3)(0, 1, 0);
const $888939a466314c44$var$_unitZ = new (0, $8TfIJ.Vector3)(0, 0, 1);
const $888939a466314c44$var$_v1 = new (0, $8TfIJ.Vector3)();
const $888939a466314c44$var$_v2 = new (0, $8TfIJ.Vector3)();
const $888939a466314c44$var$_v3 = new (0, $8TfIJ.Vector3)();
class $888939a466314c44$export$c2ae06a69fb9d31f extends (0, $8TfIJ.Object3D) {
    // updateMatrixWorld will update transformations and appearance of individual handles
    updateMatrixWorld(force) {
        const space = this.mode === 'scale' ? 'local' : this.space; // scale always oriented to local rotation
        const quaternion = space === 'local' ? this.worldQuaternion : $888939a466314c44$var$_identityQuaternion;
        // Show only gizmos for current transform mode
        this.gizmo['translate'].visible = this.mode === 'translate';
        this.gizmo['rotate'].visible = this.mode === 'rotate';
        this.gizmo['scale'].visible = this.mode === 'scale';
        this.helper['translate'].visible = this.mode === 'translate';
        this.helper['rotate'].visible = this.mode === 'rotate';
        this.helper['scale'].visible = this.mode === 'scale';
        let handles = [];
        handles = handles.concat(this.picker[this.mode].children);
        handles = handles.concat(this.gizmo[this.mode].children);
        handles = handles.concat(this.helper[this.mode].children);
        for(let i = 0; i < handles.length; i++){
            const handle = handles[i];
            // hide aligned to camera
            handle.visible = true;
            handle.rotation.set(0, 0, 0);
            handle.position.copy(this.worldPosition);
            let factor;
            if (this.camera.isOrthographicCamera) factor = (this.camera.top - this.camera.bottom) / this.camera.zoom;
            else factor = this.worldPosition.distanceTo(this.cameraPosition) * Math.min(1.9 * Math.tan(Math.PI * this.camera.fov / 360) / this.camera.zoom, 7);
            handle.scale.set(1, 1, 1).multiplyScalar(factor * this.size / 7);
            // TODO: simplify helpers and consider decoupling from gizmo
            if (handle.tag === 'helper') {
                handle.visible = false;
                if (handle.name === 'AXIS') {
                    handle.position.copy(this.worldPositionStart);
                    handle.visible = !!this.axis;
                    if (this.axis === 'X') {
                        $888939a466314c44$var$_tempQuaternion.setFromEuler($888939a466314c44$var$_tempEuler.set(0, 0, 0));
                        handle.quaternion.copy(quaternion).multiply($888939a466314c44$var$_tempQuaternion);
                        if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitX).applyQuaternion(quaternion).dot(this.eye)) > 0.9) handle.visible = false;
                    }
                    if (this.axis === 'Y') {
                        $888939a466314c44$var$_tempQuaternion.setFromEuler($888939a466314c44$var$_tempEuler.set(0, 0, Math.PI / 2));
                        handle.quaternion.copy(quaternion).multiply($888939a466314c44$var$_tempQuaternion);
                        if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitY).applyQuaternion(quaternion).dot(this.eye)) > 0.9) handle.visible = false;
                    }
                    if (this.axis === 'Z') {
                        $888939a466314c44$var$_tempQuaternion.setFromEuler($888939a466314c44$var$_tempEuler.set(0, Math.PI / 2, 0));
                        handle.quaternion.copy(quaternion).multiply($888939a466314c44$var$_tempQuaternion);
                        if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitZ).applyQuaternion(quaternion).dot(this.eye)) > 0.9) handle.visible = false;
                    }
                    if (this.axis === 'XYZE') {
                        $888939a466314c44$var$_tempQuaternion.setFromEuler($888939a466314c44$var$_tempEuler.set(0, Math.PI / 2, 0));
                        $888939a466314c44$var$_alignVector.copy(this.rotationAxis);
                        handle.quaternion.setFromRotationMatrix($888939a466314c44$var$_lookAtMatrix.lookAt($888939a466314c44$var$_zeroVector, $888939a466314c44$var$_alignVector, $888939a466314c44$var$_unitY));
                        handle.quaternion.multiply($888939a466314c44$var$_tempQuaternion);
                        handle.visible = this.dragging;
                    }
                    if (this.axis === 'E') handle.visible = false;
                } else if (handle.name === 'START') {
                    handle.position.copy(this.worldPositionStart);
                    handle.visible = this.dragging;
                } else if (handle.name === 'END') {
                    handle.position.copy(this.worldPosition);
                    handle.visible = this.dragging;
                } else if (handle.name === 'DELTA') {
                    handle.position.copy(this.worldPositionStart);
                    handle.quaternion.copy(this.worldQuaternionStart);
                    $888939a466314c44$var$_tempVector.set(1e-10, 1e-10, 1e-10).add(this.worldPositionStart).sub(this.worldPosition).multiplyScalar(-1);
                    $888939a466314c44$var$_tempVector.applyQuaternion(this.worldQuaternionStart.clone().invert());
                    handle.scale.copy($888939a466314c44$var$_tempVector);
                    handle.visible = this.dragging;
                } else {
                    handle.quaternion.copy(quaternion);
                    if (this.dragging) handle.position.copy(this.worldPositionStart);
                    else handle.position.copy(this.worldPosition);
                    if (this.axis) handle.visible = this.axis.search(handle.name) !== -1;
                }
                continue;
            }
            // Align handles to current local or world rotation
            handle.quaternion.copy(quaternion);
            if (this.mode === 'translate' || this.mode === 'scale') {
                // Hide translate and scale axis facing the camera
                const AXIS_HIDE_TRESHOLD = 0.99;
                const PLANE_HIDE_TRESHOLD = 0.2;
                const AXIS_FLIP_TRESHOLD = 0.0;
                if (handle.name === 'X' || handle.name === 'XYZX') {
                    if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitX).applyQuaternion(quaternion).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
                        handle.scale.set(1e-10, 1e-10, 1e-10);
                        handle.visible = false;
                    }
                }
                if (handle.name === 'Y' || handle.name === 'XYZY') {
                    if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitY).applyQuaternion(quaternion).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
                        handle.scale.set(1e-10, 1e-10, 1e-10);
                        handle.visible = false;
                    }
                }
                if (handle.name === 'Z' || handle.name === 'XYZZ') {
                    if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitZ).applyQuaternion(quaternion).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
                        handle.scale.set(1e-10, 1e-10, 1e-10);
                        handle.visible = false;
                    }
                }
                if (handle.name === 'XY') {
                    if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitZ).applyQuaternion(quaternion).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
                        handle.scale.set(1e-10, 1e-10, 1e-10);
                        handle.visible = false;
                    }
                }
                if (handle.name === 'YZ') {
                    if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitX).applyQuaternion(quaternion).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
                        handle.scale.set(1e-10, 1e-10, 1e-10);
                        handle.visible = false;
                    }
                }
                if (handle.name === 'XZ') {
                    if (Math.abs($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitY).applyQuaternion(quaternion).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
                        handle.scale.set(1e-10, 1e-10, 1e-10);
                        handle.visible = false;
                    }
                }
                // Flip translate and scale axis ocluded behind another axis
                if (handle.name.search('X') !== -1) {
                    if ($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitX).applyQuaternion(quaternion).dot(this.eye) < AXIS_FLIP_TRESHOLD) {
                        if (handle.tag === 'fwd') handle.visible = false;
                        else handle.scale.x *= -1;
                    } else if (handle.tag === 'bwd') handle.visible = false;
                }
                if (handle.name.search('Y') !== -1) {
                    if ($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitY).applyQuaternion(quaternion).dot(this.eye) < AXIS_FLIP_TRESHOLD) {
                        if (handle.tag === 'fwd') handle.visible = false;
                        else handle.scale.y *= -1;
                    } else if (handle.tag === 'bwd') handle.visible = false;
                }
                if (handle.name.search('Z') !== -1) {
                    if ($888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_unitZ).applyQuaternion(quaternion).dot(this.eye) < AXIS_FLIP_TRESHOLD) {
                        if (handle.tag === 'fwd') handle.visible = false;
                        else handle.scale.z *= -1;
                    } else if (handle.tag === 'bwd') handle.visible = false;
                }
            } else if (this.mode === 'rotate') {
                // Align handles to current local or world rotation
                $888939a466314c44$var$_tempQuaternion2.copy(quaternion);
                $888939a466314c44$var$_alignVector.copy(this.eye).applyQuaternion($888939a466314c44$var$_tempQuaternion.copy(quaternion).invert());
                if (handle.name.search('E') !== -1) handle.quaternion.setFromRotationMatrix($888939a466314c44$var$_lookAtMatrix.lookAt(this.eye, $888939a466314c44$var$_zeroVector, $888939a466314c44$var$_unitY));
                if (handle.name === 'X') {
                    $888939a466314c44$var$_tempQuaternion.setFromAxisAngle($888939a466314c44$var$_unitX, Math.atan2(-$888939a466314c44$var$_alignVector.y, $888939a466314c44$var$_alignVector.z));
                    $888939a466314c44$var$_tempQuaternion.multiplyQuaternions($888939a466314c44$var$_tempQuaternion2, $888939a466314c44$var$_tempQuaternion);
                    handle.quaternion.copy($888939a466314c44$var$_tempQuaternion);
                }
                if (handle.name === 'Y') {
                    $888939a466314c44$var$_tempQuaternion.setFromAxisAngle($888939a466314c44$var$_unitY, Math.atan2($888939a466314c44$var$_alignVector.x, $888939a466314c44$var$_alignVector.z));
                    $888939a466314c44$var$_tempQuaternion.multiplyQuaternions($888939a466314c44$var$_tempQuaternion2, $888939a466314c44$var$_tempQuaternion);
                    handle.quaternion.copy($888939a466314c44$var$_tempQuaternion);
                }
                if (handle.name === 'Z') {
                    $888939a466314c44$var$_tempQuaternion.setFromAxisAngle($888939a466314c44$var$_unitZ, Math.atan2($888939a466314c44$var$_alignVector.y, $888939a466314c44$var$_alignVector.x));
                    $888939a466314c44$var$_tempQuaternion.multiplyQuaternions($888939a466314c44$var$_tempQuaternion2, $888939a466314c44$var$_tempQuaternion);
                    handle.quaternion.copy($888939a466314c44$var$_tempQuaternion);
                }
            }
            // Hide disabled axes
            handle.visible = handle.visible && (handle.name.indexOf('X') === -1 || this.showX);
            handle.visible = handle.visible && (handle.name.indexOf('Y') === -1 || this.showY);
            handle.visible = handle.visible && (handle.name.indexOf('Z') === -1 || this.showZ);
            handle.visible = handle.visible && (handle.name.indexOf('E') === -1 || this.showX && this.showY && this.showZ);
            // highlight selected axis
            handle.material._opacity = handle.material._opacity || handle.material.opacity;
            handle.material._color = handle.material._color || handle.material.color.clone();
            handle.material.color.copy(handle.material._color);
            handle.material.opacity = handle.material._opacity;
            if (!this.enabled) {
                handle.material.opacity *= 0.5;
                handle.material.color.lerp(new (0, $8TfIJ.Color)(1, 1, 1), 0.5);
            } else if (this.axis) {
                if (handle.name === this.axis) {
                    handle.material.opacity = 1.0;
                    handle.material.color.lerp(new (0, $8TfIJ.Color)(1, 1, 1), 0.5);
                } else if (this.axis.split('').some(function(a) {
                    return handle.name === a;
                })) {
                    handle.material.opacity = 1.0;
                    handle.material.color.lerp(new (0, $8TfIJ.Color)(1, 1, 1), 0.5);
                } else {
                    handle.material.opacity *= 0.25;
                    handle.material.color.lerp(new (0, $8TfIJ.Color)(1, 1, 1), 0.5);
                }
            }
        }
        super.updateMatrixWorld(force);
    }
    constructor(){
        super();
        this.type = 'TransformControlsGizmo';
        // shared materials
        const gizmoMaterial = new (0, $8TfIJ.MeshBasicMaterial)({
            depthTest: false,
            depthWrite: false,
            transparent: true,
            side: (0, $8TfIJ.DoubleSide),
            fog: false,
            toneMapped: false
        });
        const gizmoLineMaterial = new (0, $8TfIJ.LineBasicMaterial)({
            depthTest: false,
            depthWrite: false,
            transparent: true,
            linewidth: 1,
            fog: false,
            toneMapped: false
        });
        // Make unique material for each axis/color
        const matInvisible = gizmoMaterial.clone();
        matInvisible.opacity = 0.15;
        const matHelper = gizmoMaterial.clone();
        matHelper.opacity = 0.33;
        const matRed = gizmoMaterial.clone();
        matRed.color.set(0xff0000);
        const matGreen = gizmoMaterial.clone();
        matGreen.color.set(0x00ff00);
        const matBlue = gizmoMaterial.clone();
        matBlue.color.set(0x0000ff);
        const matWhiteTransparent = gizmoMaterial.clone();
        matWhiteTransparent.opacity = 0.25;
        const matYellowTransparent = matWhiteTransparent.clone();
        matYellowTransparent.color.set(0xffff00);
        const matCyanTransparent = matWhiteTransparent.clone();
        matCyanTransparent.color.set(0x00ffff);
        const matMagentaTransparent = matWhiteTransparent.clone();
        matMagentaTransparent.color.set(0xff00ff);
        const matYellow = gizmoMaterial.clone();
        matYellow.color.set(0xffff00);
        const matLineRed = gizmoLineMaterial.clone();
        matLineRed.color.set(0xff0000);
        const matLineGreen = gizmoLineMaterial.clone();
        matLineGreen.color.set(0x00ff00);
        const matLineBlue = gizmoLineMaterial.clone();
        matLineBlue.color.set(0x0000ff);
        const matLineCyan = gizmoLineMaterial.clone();
        matLineCyan.color.set(0x00ffff);
        const matLineMagenta = gizmoLineMaterial.clone();
        matLineMagenta.color.set(0xff00ff);
        const matLineYellow = gizmoLineMaterial.clone();
        matLineYellow.color.set(0xffff00);
        const matLineGray = gizmoLineMaterial.clone();
        matLineGray.color.set(0x787878);
        const matLineYellowTransparent = matLineYellow.clone();
        matLineYellowTransparent.opacity = 0.25;
        // reusable geometry
        const arrowGeometry = new (0, $8TfIJ.CylinderGeometry)(0, 0.05, 0.2, 12, 1, false);
        const scaleHandleGeometry = new (0, $8TfIJ.BoxGeometry)(0.125, 0.125, 0.125);
        const lineGeometry = new (0, $8TfIJ.BufferGeometry)();
        lineGeometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)([
            0,
            0,
            0,
            1,
            0,
            0
        ], 3));
        function CircleGeometry(radius, arc) {
            const geometry = new (0, $8TfIJ.BufferGeometry)();
            const vertices = [];
            for(let i = 0; i <= 64 * arc; ++i)vertices.push(0, Math.cos(i / 32 * Math.PI) * radius, Math.sin(i / 32 * Math.PI) * radius);
            geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(vertices, 3));
            return geometry;
        }
        // Special geometry for transform helper. If scaled with position vector it spans from [0,0,0] to position
        function TranslateHelperGeometry() {
            const geometry = new (0, $8TfIJ.BufferGeometry)();
            geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)([
                0,
                0,
                0,
                1,
                1,
                1
            ], 3));
            return geometry;
        }
        // Gizmo definitions - custom hierarchy definitions for setupGizmo() function
        const gizmoTranslate = {
            X: [
                [
                    new (0, $8TfIJ.Mesh)(arrowGeometry, matRed),
                    [
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ],
                    null,
                    'fwd'
                ],
                [
                    new (0, $8TfIJ.Mesh)(arrowGeometry, matRed),
                    [
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    null,
                    'bwd'
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineRed)
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Mesh)(arrowGeometry, matGreen),
                    [
                        0,
                        1,
                        0
                    ],
                    null,
                    null,
                    'fwd'
                ],
                [
                    new (0, $8TfIJ.Mesh)(arrowGeometry, matGreen),
                    [
                        0,
                        1,
                        0
                    ],
                    [
                        Math.PI,
                        0,
                        0
                    ],
                    null,
                    'bwd'
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineGreen),
                    null,
                    [
                        0,
                        0,
                        Math.PI / 2
                    ]
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Mesh)(arrowGeometry, matBlue),
                    [
                        0,
                        0,
                        1
                    ],
                    [
                        Math.PI / 2,
                        0,
                        0
                    ],
                    null,
                    'fwd'
                ],
                [
                    new (0, $8TfIJ.Mesh)(arrowGeometry, matBlue),
                    [
                        0,
                        0,
                        1
                    ],
                    [
                        -Math.PI / 2,
                        0,
                        0
                    ],
                    null,
                    'bwd'
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineBlue),
                    null,
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ]
                ]
            ],
            XYZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.1, 0), matWhiteTransparent.clone()),
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0
                    ]
                ]
            ],
            XY: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.PlaneGeometry)(0.295, 0.295), matYellowTransparent.clone()),
                    [
                        0.15,
                        0.15,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineYellow),
                    [
                        0.18,
                        0.3,
                        0
                    ],
                    null,
                    [
                        0.125,
                        1,
                        1
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineYellow),
                    [
                        0.3,
                        0.18,
                        0
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ]
            ],
            YZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.PlaneGeometry)(0.295, 0.295), matCyanTransparent.clone()),
                    [
                        0,
                        0.15,
                        0.15
                    ],
                    [
                        0,
                        Math.PI / 2,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineCyan),
                    [
                        0,
                        0.18,
                        0.3
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineCyan),
                    [
                        0,
                        0.3,
                        0.18
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ]
            ],
            XZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.PlaneGeometry)(0.295, 0.295), matMagentaTransparent.clone()),
                    [
                        0.15,
                        0,
                        0.15
                    ],
                    [
                        -Math.PI / 2,
                        0,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineMagenta),
                    [
                        0.18,
                        0,
                        0.3
                    ],
                    null,
                    [
                        0.125,
                        1,
                        1
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineMagenta),
                    [
                        0.3,
                        0,
                        0.18
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ]
            ]
        };
        const pickerTranslate = {
            X: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.2, 0, 1, 4, 1, false), matInvisible),
                    [
                        0.6,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ]
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.2, 0, 1, 4, 1, false), matInvisible),
                    [
                        0,
                        0.6,
                        0
                    ]
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.2, 0, 1, 4, 1, false), matInvisible),
                    [
                        0,
                        0,
                        0.6
                    ],
                    [
                        Math.PI / 2,
                        0,
                        0
                    ]
                ]
            ],
            XYZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.2, 0), matInvisible)
                ]
            ],
            XY: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.PlaneGeometry)(0.4, 0.4), matInvisible),
                    [
                        0.2,
                        0.2,
                        0
                    ]
                ]
            ],
            YZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.PlaneGeometry)(0.4, 0.4), matInvisible),
                    [
                        0,
                        0.2,
                        0.2
                    ],
                    [
                        0,
                        Math.PI / 2,
                        0
                    ]
                ]
            ],
            XZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.PlaneGeometry)(0.4, 0.4), matInvisible),
                    [
                        0.2,
                        0,
                        0.2
                    ],
                    [
                        -Math.PI / 2,
                        0,
                        0
                    ]
                ]
            ]
        };
        const helperTranslate = {
            START: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.01, 2), matHelper),
                    null,
                    null,
                    null,
                    'helper'
                ]
            ],
            END: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.01, 2), matHelper),
                    null,
                    null,
                    null,
                    'helper'
                ]
            ],
            DELTA: [
                [
                    new (0, $8TfIJ.Line)(TranslateHelperGeometry(), matHelper),
                    null,
                    null,
                    null,
                    'helper'
                ]
            ],
            X: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        -1000,
                        0,
                        0
                    ],
                    null,
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        0,
                        -1000,
                        0
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        0,
                        0,
                        -1000
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ]
        };
        const gizmoRotate = {
            X: [
                [
                    new (0, $8TfIJ.Line)(CircleGeometry(1, 0.5), matLineRed)
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.04, 0), matRed),
                    [
                        0,
                        0,
                        0.99
                    ],
                    null,
                    [
                        1,
                        3,
                        1
                    ]
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Line)(CircleGeometry(1, 0.5), matLineGreen),
                    null,
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ]
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.04, 0), matGreen),
                    [
                        0,
                        0,
                        0.99
                    ],
                    null,
                    [
                        3,
                        1,
                        1
                    ]
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Line)(CircleGeometry(1, 0.5), matLineBlue),
                    null,
                    [
                        0,
                        Math.PI / 2,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.OctahedronGeometry)(0.04, 0), matBlue),
                    [
                        0.99,
                        0,
                        0
                    ],
                    null,
                    [
                        1,
                        3,
                        1
                    ]
                ]
            ],
            E: [
                [
                    new (0, $8TfIJ.Line)(CircleGeometry(1.25, 1), matLineYellowTransparent),
                    null,
                    [
                        0,
                        Math.PI / 2,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent),
                    [
                        1.17,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ],
                    [
                        1,
                        1,
                        0.001
                    ]
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent),
                    [
                        -1.17,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        1,
                        1,
                        0.001
                    ]
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent),
                    [
                        0,
                        -1.17,
                        0
                    ],
                    [
                        Math.PI,
                        0,
                        0
                    ],
                    [
                        1,
                        1,
                        0.001
                    ]
                ],
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.03, 0, 0.15, 4, 1, false), matLineYellowTransparent),
                    [
                        0,
                        1.17,
                        0
                    ],
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        1,
                        1,
                        0.001
                    ]
                ]
            ],
            XYZE: [
                [
                    new (0, $8TfIJ.Line)(CircleGeometry(1, 1), matLineGray),
                    null,
                    [
                        0,
                        Math.PI / 2,
                        0
                    ]
                ]
            ]
        };
        const helperRotate = {
            AXIS: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        -1000,
                        0,
                        0
                    ],
                    null,
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ]
        };
        const pickerRotate = {
            X: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.TorusGeometry)(1, 0.1, 4, 24), matInvisible),
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        -Math.PI / 2
                    ]
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.TorusGeometry)(1, 0.1, 4, 24), matInvisible),
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        Math.PI / 2,
                        0,
                        0
                    ]
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.TorusGeometry)(1, 0.1, 4, 24), matInvisible),
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ]
                ]
            ],
            E: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.TorusGeometry)(1.25, 0.1, 2, 24), matInvisible)
                ]
            ],
            XYZE: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.SphereGeometry)(0.7, 10, 8), matInvisible)
                ]
            ]
        };
        const gizmoScale = {
            X: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matRed),
                    [
                        0.8,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineRed),
                    null,
                    null,
                    [
                        0.8,
                        1,
                        1
                    ]
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matGreen),
                    [
                        0,
                        0.8,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineGreen),
                    null,
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        0.8,
                        1,
                        1
                    ]
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matBlue),
                    [
                        0,
                        0,
                        0.8
                    ],
                    [
                        Math.PI / 2,
                        0,
                        0
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineBlue),
                    null,
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        0.8,
                        1,
                        1
                    ]
                ]
            ],
            XY: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matYellowTransparent),
                    [
                        0.85,
                        0.85,
                        0
                    ],
                    null,
                    [
                        2,
                        2,
                        0.2
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineYellow),
                    [
                        0.855,
                        0.98,
                        0
                    ],
                    null,
                    [
                        0.125,
                        1,
                        1
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineYellow),
                    [
                        0.98,
                        0.855,
                        0
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ]
            ],
            YZ: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matCyanTransparent),
                    [
                        0,
                        0.85,
                        0.85
                    ],
                    null,
                    [
                        0.2,
                        2,
                        2
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineCyan),
                    [
                        0,
                        0.855,
                        0.98
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineCyan),
                    [
                        0,
                        0.98,
                        0.855
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ]
            ],
            XZ: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matMagentaTransparent),
                    [
                        0.85,
                        0,
                        0.85
                    ],
                    null,
                    [
                        2,
                        0.2,
                        2
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineMagenta),
                    [
                        0.855,
                        0,
                        0.98
                    ],
                    null,
                    [
                        0.125,
                        1,
                        1
                    ]
                ],
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matLineMagenta),
                    [
                        0.98,
                        0,
                        0.855
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        0.125,
                        1,
                        1
                    ]
                ]
            ],
            XYZX: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.BoxGeometry)(0.125, 0.125, 0.125), matWhiteTransparent.clone()),
                    [
                        1.1,
                        0,
                        0
                    ]
                ]
            ],
            XYZY: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.BoxGeometry)(0.125, 0.125, 0.125), matWhiteTransparent.clone()),
                    [
                        0,
                        1.1,
                        0
                    ]
                ]
            ],
            XYZZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.BoxGeometry)(0.125, 0.125, 0.125), matWhiteTransparent.clone()),
                    [
                        0,
                        0,
                        1.1
                    ]
                ]
            ]
        };
        const pickerScale = {
            X: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.2, 0, 0.8, 4, 1, false), matInvisible),
                    [
                        0.5,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        -Math.PI / 2
                    ]
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.2, 0, 0.8, 4, 1, false), matInvisible),
                    [
                        0,
                        0.5,
                        0
                    ]
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.CylinderGeometry)(0.2, 0, 0.8, 4, 1, false), matInvisible),
                    [
                        0,
                        0,
                        0.5
                    ],
                    [
                        Math.PI / 2,
                        0,
                        0
                    ]
                ]
            ],
            XY: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matInvisible),
                    [
                        0.85,
                        0.85,
                        0
                    ],
                    null,
                    [
                        3,
                        3,
                        0.2
                    ]
                ]
            ],
            YZ: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matInvisible),
                    [
                        0,
                        0.85,
                        0.85
                    ],
                    null,
                    [
                        0.2,
                        3,
                        3
                    ]
                ]
            ],
            XZ: [
                [
                    new (0, $8TfIJ.Mesh)(scaleHandleGeometry, matInvisible),
                    [
                        0.85,
                        0,
                        0.85
                    ],
                    null,
                    [
                        3,
                        0.2,
                        3
                    ]
                ]
            ],
            XYZX: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.BoxGeometry)(0.2, 0.2, 0.2), matInvisible),
                    [
                        1.1,
                        0,
                        0
                    ]
                ]
            ],
            XYZY: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.BoxGeometry)(0.2, 0.2, 0.2), matInvisible),
                    [
                        0,
                        1.1,
                        0
                    ]
                ]
            ],
            XYZZ: [
                [
                    new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.BoxGeometry)(0.2, 0.2, 0.2), matInvisible),
                    [
                        0,
                        0,
                        1.1
                    ]
                ]
            ]
        };
        const helperScale = {
            X: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        -1000,
                        0,
                        0
                    ],
                    null,
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ],
            Y: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        0,
                        -1000,
                        0
                    ],
                    [
                        0,
                        0,
                        Math.PI / 2
                    ],
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ],
            Z: [
                [
                    new (0, $8TfIJ.Line)(lineGeometry, matHelper.clone()),
                    [
                        0,
                        0,
                        -1000
                    ],
                    [
                        0,
                        -Math.PI / 2,
                        0
                    ],
                    [
                        1e6,
                        1,
                        1
                    ],
                    'helper'
                ]
            ]
        };
        // Creates an Object3D with gizmos described in custom hierarchy definition.
        function setupGizmo(gizmoMap) {
            const gizmo = new (0, $8TfIJ.Object3D)();
            for(const name in gizmoMap)for(let i = gizmoMap[name].length; i--;){
                const object = gizmoMap[name][i][0].clone();
                const position = gizmoMap[name][i][1];
                const rotation = gizmoMap[name][i][2];
                const scale = gizmoMap[name][i][3];
                const tag = gizmoMap[name][i][4];
                // name and tag properties are essential for picking and updating logic.
                object.name = name;
                object.tag = tag;
                if (position) object.position.set(position[0], position[1], position[2]);
                if (rotation) object.rotation.set(rotation[0], rotation[1], rotation[2]);
                if (scale) object.scale.set(scale[0], scale[1], scale[2]);
                object.updateMatrix();
                const tempGeometry = object.geometry.clone();
                tempGeometry.applyMatrix4(object.matrix);
                object.geometry = tempGeometry;
                object.renderOrder = Infinity;
                object.position.set(0, 0, 0);
                object.rotation.set(0, 0, 0);
                object.scale.set(1, 1, 1);
                gizmo.add(object);
            }
            return gizmo;
        }
        // Gizmo creation
        this.gizmo = {};
        this.picker = {};
        this.helper = {};
        this.add(this.gizmo['translate'] = setupGizmo(gizmoTranslate));
        this.add(this.gizmo['rotate'] = setupGizmo(gizmoRotate));
        this.add(this.gizmo['scale'] = setupGizmo(gizmoScale));
        this.add(this.picker['translate'] = setupGizmo(pickerTranslate));
        this.add(this.picker['rotate'] = setupGizmo(pickerRotate));
        this.add(this.picker['scale'] = setupGizmo(pickerScale));
        this.add(this.helper['translate'] = setupGizmo(helperTranslate));
        this.add(this.helper['rotate'] = setupGizmo(helperRotate));
        this.add(this.helper['scale'] = setupGizmo(helperScale));
        // Pickers should be hidden always
        this.picker['translate'].visible = false;
        this.picker['rotate'].visible = false;
        this.picker['scale'].visible = false;
    }
}
$888939a466314c44$export$c2ae06a69fb9d31f.prototype.isTransformControlsGizmo = true;
//
class $888939a466314c44$export$c0ab73045548e2ca extends (0, $8TfIJ.Mesh) {
    updateMatrixWorld(force) {
        let space = this.space;
        this.position.copy(this.worldPosition);
        if (this.mode === 'scale') space = 'local'; // scale always oriented to local rotation
        $888939a466314c44$var$_v1.copy($888939a466314c44$var$_unitX).applyQuaternion(space === 'local' ? this.worldQuaternion : $888939a466314c44$var$_identityQuaternion);
        $888939a466314c44$var$_v2.copy($888939a466314c44$var$_unitY).applyQuaternion(space === 'local' ? this.worldQuaternion : $888939a466314c44$var$_identityQuaternion);
        $888939a466314c44$var$_v3.copy($888939a466314c44$var$_unitZ).applyQuaternion(space === 'local' ? this.worldQuaternion : $888939a466314c44$var$_identityQuaternion);
        // Align the plane for current transform mode, axis and space.
        $888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_v2);
        switch(this.mode){
            case 'translate':
            case 'scale':
                switch(this.axis){
                    case 'X':
                        $888939a466314c44$var$_alignVector.copy(this.eye).cross($888939a466314c44$var$_v1);
                        $888939a466314c44$var$_dirVector.copy($888939a466314c44$var$_v1).cross($888939a466314c44$var$_alignVector);
                        break;
                    case 'Y':
                        $888939a466314c44$var$_alignVector.copy(this.eye).cross($888939a466314c44$var$_v2);
                        $888939a466314c44$var$_dirVector.copy($888939a466314c44$var$_v2).cross($888939a466314c44$var$_alignVector);
                        break;
                    case 'Z':
                        $888939a466314c44$var$_alignVector.copy(this.eye).cross($888939a466314c44$var$_v3);
                        $888939a466314c44$var$_dirVector.copy($888939a466314c44$var$_v3).cross($888939a466314c44$var$_alignVector);
                        break;
                    case 'XY':
                        $888939a466314c44$var$_dirVector.copy($888939a466314c44$var$_v3);
                        break;
                    case 'YZ':
                        $888939a466314c44$var$_dirVector.copy($888939a466314c44$var$_v1);
                        break;
                    case 'XZ':
                        $888939a466314c44$var$_alignVector.copy($888939a466314c44$var$_v3);
                        $888939a466314c44$var$_dirVector.copy($888939a466314c44$var$_v2);
                        break;
                    case 'XYZ':
                    case 'E':
                        $888939a466314c44$var$_dirVector.set(0, 0, 0);
                        break;
                }
                break;
            case 'rotate':
            default:
                // special case for rotate
                $888939a466314c44$var$_dirVector.set(0, 0, 0);
        }
        if ($888939a466314c44$var$_dirVector.length() === 0) // If in rotate mode, make the plane parallel to camera
        this.quaternion.copy(this.cameraQuaternion);
        else {
            $888939a466314c44$var$_tempMatrix.lookAt($888939a466314c44$var$_tempVector.set(0, 0, 0), $888939a466314c44$var$_dirVector, $888939a466314c44$var$_alignVector);
            this.quaternion.setFromRotationMatrix($888939a466314c44$var$_tempMatrix);
        }
        super.updateMatrixWorld(force);
    }
    constructor(){
        super(new (0, $8TfIJ.PlaneGeometry)(100000, 100000, 2, 2), new (0, $8TfIJ.MeshBasicMaterial)({
            visible: false,
            wireframe: true,
            side: (0, $8TfIJ.DoubleSide),
            transparent: true,
            opacity: 0.1,
            toneMapped: false
        }));
        this.type = 'TransformControlsPlane';
    }
}
$888939a466314c44$export$c0ab73045548e2ca.prototype.isTransformControlsPlane = true;

});

parcelRegister("hhs4I", function(module, exports) {

$parcel$export(module.exports, "STLLoader", function () { return $c949cd4da2a72025$export$78deb5981b3aff86; });

var $8TfIJ = parcelRequire("8TfIJ");
/**
 * Description: A THREE loader for STL ASCII files, as created by Solidworks and other CAD programs.
 *
 * Supports both binary and ASCII encoded files, with automatic detection of type.
 *
 * The loader returns a non-indexed buffer geometry.
 *
 * Limitations:
 *  Binary decoding supports "Magics" color format (http://en.wikipedia.org/wiki/STL_(file_format)#Color_in_binary_STL).
 *  There is perhaps some question as to how valid it is to always assume little-endian-ness.
 *  ASCII decoding assumes file is UTF-8.
 *
 * Usage:
 *  const loader = new STLLoader();
 *  loader.load( './models/stl/slotted_disk.stl', function ( geometry ) {
 *    scene.add( new THREE.Mesh( geometry ) );
 *  });
 *
 * For binary STLs geometry might contain colors for vertices. To use it:
 *  // use the same code to load STL as above
 *  if (geometry.hasColors) {
 *    material = new THREE.MeshPhongMaterial({ opacity: geometry.alpha, vertexColors: true });
 *  } else { .... }
 *  const mesh = new THREE.Mesh( geometry, material );
 *
 * For ASCII STLs containing multiple solids, each solid is assigned to a different group.
 * Groups can be used to assign a different color by defining an array of materials with the same length of
 * geometry.groups and passing it to the Mesh constructor:
 *
 * const mesh = new THREE.Mesh( geometry, material );
 *
 * For example:
 *
 *  const materials = [];
 *  const nGeometryGroups = geometry.groups.length;
 *
 *  const colorMap = ...; // Some logic to index colors.
 *
 *  for (let i = 0; i < nGeometryGroups; i++) {
 *
 *		const material = new THREE.MeshPhongMaterial({
 *			color: colorMap[i],
 *			wireframe: false
 *		});
 *
 *  }
 *
 *  materials.push(material);
 *  const mesh = new THREE.Mesh(geometry, materials);
 */ class $c949cd4da2a72025$export$78deb5981b3aff86 extends (0, $8TfIJ.Loader) {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new (0, $8TfIJ.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(text));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(data) {
        function isBinary(data) {
            const reader = new DataView(data);
            const face_size = 50;
            const n_faces = reader.getUint32(80, true);
            const expect = 84 + n_faces * face_size;
            if (expect === reader.byteLength) return true;
            // An ASCII STL data must begin with 'solid ' as the first six bytes.
            // However, ASCII STLs lacking the SPACE after the 'd' are known to be
            // plentiful.  So, check the first 5 bytes for 'solid'.
            // Several encodings, such as UTF-8, precede the text with up to 5 bytes:
            // https://en.wikipedia.org/wiki/Byte_order_mark#Byte_order_marks_by_encoding
            // Search for "solid" to start anywhere after those prefixes.
            // US-ASCII ordinal values for 's', 'o', 'l', 'i', 'd'
            const solid = [
                115,
                111,
                108,
                105,
                100
            ];
            for(let off = 0; off < 5; off++){
                // If "solid" text is matched to the current offset, declare it to be an ASCII STL.
                if (matchDataViewAt(solid, reader, off)) return false;
            }
            // Couldn't find "solid" text at the beginning; it is binary STL.
            return true;
        }
        function matchDataViewAt(query, reader, offset) {
            // Check if each byte in query matches the corresponding byte from the current offset
            for(let i = 0, il = query.length; i < il; i++){
                if (query[i] !== reader.getUint8(offset + i, false)) return false;
            }
            return true;
        }
        function parseBinary(data) {
            const reader = new DataView(data);
            const faces = reader.getUint32(80, true);
            let r, g, b, hasColors = false, colors;
            let defaultR, defaultG, defaultB, alpha;
            // process STL header
            // check for default color in header ("COLOR=rgba" sequence).
            for(let index = 0; index < 70; index++)if (reader.getUint32(index, false) == 0x434F4C4F /*COLO*/  && reader.getUint8(index + 4) == 0x52 /*'R'*/  && reader.getUint8(index + 5) == 0x3D /*'='*/ ) {
                hasColors = true;
                colors = new Float32Array(faces * 9);
                defaultR = reader.getUint8(index + 6) / 255;
                defaultG = reader.getUint8(index + 7) / 255;
                defaultB = reader.getUint8(index + 8) / 255;
                alpha = reader.getUint8(index + 9) / 255;
            }
            const dataOffset = 84;
            const faceLength = 50;
            const geometry = new (0, $8TfIJ.BufferGeometry)();
            const vertices = new Float32Array(faces * 9);
            const normals = new Float32Array(faces * 9);
            for(let face = 0; face < faces; face++){
                const start = dataOffset + face * faceLength;
                const normalX = reader.getFloat32(start, true);
                const normalY = reader.getFloat32(start + 4, true);
                const normalZ = reader.getFloat32(start + 8, true);
                if (hasColors) {
                    const packedColor = reader.getUint16(start + 48, true);
                    if ((packedColor & 0x8000) === 0) {
                        // facet has its own unique color
                        r = (packedColor & 0x1F) / 31;
                        g = (packedColor >> 5 & 0x1F) / 31;
                        b = (packedColor >> 10 & 0x1F) / 31;
                    } else {
                        r = defaultR;
                        g = defaultG;
                        b = defaultB;
                    }
                }
                for(let i = 1; i <= 3; i++){
                    const vertexstart = start + i * 12;
                    const componentIdx = face * 9 + (i - 1) * 3;
                    vertices[componentIdx] = reader.getFloat32(vertexstart, true);
                    vertices[componentIdx + 1] = reader.getFloat32(vertexstart + 4, true);
                    vertices[componentIdx + 2] = reader.getFloat32(vertexstart + 8, true);
                    normals[componentIdx] = normalX;
                    normals[componentIdx + 1] = normalY;
                    normals[componentIdx + 2] = normalZ;
                    if (hasColors) {
                        colors[componentIdx] = r;
                        colors[componentIdx + 1] = g;
                        colors[componentIdx + 2] = b;
                    }
                }
            }
            geometry.setAttribute('position', new (0, $8TfIJ.BufferAttribute)(vertices, 3));
            geometry.setAttribute('normal', new (0, $8TfIJ.BufferAttribute)(normals, 3));
            if (hasColors) {
                geometry.setAttribute('color', new (0, $8TfIJ.BufferAttribute)(colors, 3));
                geometry.hasColors = true;
                geometry.alpha = alpha;
            }
            return geometry;
        }
        function parseASCII(data) {
            const geometry = new (0, $8TfIJ.BufferGeometry)();
            const patternSolid = /solid([\s\S]*?)endsolid/g;
            const patternFace = /facet([\s\S]*?)endfacet/g;
            let faceCounter = 0;
            const patternFloat = /[\s]+([+-]?(?:\d*)(?:\.\d*)?(?:[eE][+-]?\d+)?)/.source;
            const patternVertex = new RegExp('vertex' + patternFloat + patternFloat + patternFloat, 'g');
            const patternNormal = new RegExp('normal' + patternFloat + patternFloat + patternFloat, 'g');
            const vertices = [];
            const normals = [];
            const normal = new (0, $8TfIJ.Vector3)();
            let result;
            let groupCount = 0;
            let startVertex = 0;
            let endVertex = 0;
            while((result = patternSolid.exec(data)) !== null){
                startVertex = endVertex;
                const solid = result[0];
                while((result = patternFace.exec(solid)) !== null){
                    let vertexCountPerFace = 0;
                    let normalCountPerFace = 0;
                    const text = result[0];
                    while((result = patternNormal.exec(text)) !== null){
                        normal.x = parseFloat(result[1]);
                        normal.y = parseFloat(result[2]);
                        normal.z = parseFloat(result[3]);
                        normalCountPerFace++;
                    }
                    while((result = patternVertex.exec(text)) !== null){
                        vertices.push(parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3]));
                        normals.push(normal.x, normal.y, normal.z);
                        vertexCountPerFace++;
                        endVertex++;
                    }
                    // every face have to own ONE valid normal
                    if (normalCountPerFace !== 1) console.error('THREE.STLLoader: Something isn\'t right with the normal of face number ' + faceCounter);
                    // each face have to own THREE valid vertices
                    if (vertexCountPerFace !== 3) console.error('THREE.STLLoader: Something isn\'t right with the vertices of face number ' + faceCounter);
                    faceCounter++;
                }
                const start = startVertex;
                const count = endVertex - startVertex;
                geometry.addGroup(start, count, groupCount);
                groupCount++;
            }
            geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(vertices, 3));
            geometry.setAttribute('normal', new (0, $8TfIJ.Float32BufferAttribute)(normals, 3));
            return geometry;
        }
        function ensureString(buffer) {
            if (typeof buffer !== 'string') return (0, $8TfIJ.LoaderUtils).decodeText(new Uint8Array(buffer));
            return buffer;
        }
        function ensureBinary(buffer) {
            if (typeof buffer === 'string') {
                const array_buffer = new Uint8Array(buffer.length);
                for(let i = 0; i < buffer.length; i++)array_buffer[i] = buffer.charCodeAt(i) & 0xff; // implicitly assumes little-endian
                return array_buffer.buffer || array_buffer;
            } else return buffer;
        }
        // start
        const binData = ensureBinary(data);
        return isBinary(binData) ? parseBinary(binData) : parseASCII(ensureString(data));
    }
    constructor(manager){
        super(manager);
    }
}

});

parcelRegister("htT9M", function(module, exports) {

$parcel$export(module.exports, "OBJLoader", function () { return $cb9fee166e1d427e$export$7ae31604ad04b4a7; });

var $8TfIJ = parcelRequire("8TfIJ");
// o object_name | g group_name
const $cb9fee166e1d427e$var$_object_pattern = /^[og]\s*(.+)?/;
// mtllib file_reference
const $cb9fee166e1d427e$var$_material_library_pattern = /^mtllib /;
// usemtl material_name
const $cb9fee166e1d427e$var$_material_use_pattern = /^usemtl /;
// usemap map_name
const $cb9fee166e1d427e$var$_map_use_pattern = /^usemap /;
const $cb9fee166e1d427e$var$_vA = new (0, $8TfIJ.Vector3)();
const $cb9fee166e1d427e$var$_vB = new (0, $8TfIJ.Vector3)();
const $cb9fee166e1d427e$var$_vC = new (0, $8TfIJ.Vector3)();
const $cb9fee166e1d427e$var$_ab = new (0, $8TfIJ.Vector3)();
const $cb9fee166e1d427e$var$_cb = new (0, $8TfIJ.Vector3)();
function $cb9fee166e1d427e$var$ParserState() {
    const state = {
        objects: [],
        object: {},
        vertices: [],
        normals: [],
        colors: [],
        uvs: [],
        materials: {},
        materialLibraries: [],
        startObject: function(name, fromDeclaration) {
            // If the current object (initial from reset) is not from a g/o declaration in the parsed
            // file. We need to use it for the first parsed g/o to keep things in sync.
            if (this.object && this.object.fromDeclaration === false) {
                this.object.name = name;
                this.object.fromDeclaration = fromDeclaration !== false;
                return;
            }
            const previousMaterial = this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined;
            if (this.object && typeof this.object._finalize === 'function') this.object._finalize(true);
            this.object = {
                name: name || '',
                fromDeclaration: fromDeclaration !== false,
                geometry: {
                    vertices: [],
                    normals: [],
                    colors: [],
                    uvs: [],
                    hasUVIndices: false
                },
                materials: [],
                smooth: true,
                startMaterial: function(name, libraries) {
                    const previous = this._finalize(false);
                    // New usemtl declaration overwrites an inherited material, except if faces were declared
                    // after the material, then it must be preserved for proper MultiMaterial continuation.
                    if (previous && (previous.inherited || previous.groupCount <= 0)) this.materials.splice(previous.index, 1);
                    const material = {
                        index: this.materials.length,
                        name: name || '',
                        mtllib: Array.isArray(libraries) && libraries.length > 0 ? libraries[libraries.length - 1] : '',
                        smooth: previous !== undefined ? previous.smooth : this.smooth,
                        groupStart: previous !== undefined ? previous.groupEnd : 0,
                        groupEnd: -1,
                        groupCount: -1,
                        inherited: false,
                        clone: function(index) {
                            const cloned = {
                                index: typeof index === 'number' ? index : this.index,
                                name: this.name,
                                mtllib: this.mtllib,
                                smooth: this.smooth,
                                groupStart: 0,
                                groupEnd: -1,
                                groupCount: -1,
                                inherited: false
                            };
                            cloned.clone = this.clone.bind(cloned);
                            return cloned;
                        }
                    };
                    this.materials.push(material);
                    return material;
                },
                currentMaterial: function() {
                    if (this.materials.length > 0) return this.materials[this.materials.length - 1];
                    return undefined;
                },
                _finalize: function(end) {
                    const lastMultiMaterial = this.currentMaterial();
                    if (lastMultiMaterial && lastMultiMaterial.groupEnd === -1) {
                        lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
                        lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
                        lastMultiMaterial.inherited = false;
                    }
                    // Ignore objects tail materials if no face declarations followed them before a new o/g started.
                    if (end && this.materials.length > 1) {
                        for(let mi = this.materials.length - 1; mi >= 0; mi--)if (this.materials[mi].groupCount <= 0) this.materials.splice(mi, 1);
                    }
                    // Guarantee at least one empty material, this makes the creation later more straight forward.
                    if (end && this.materials.length === 0) this.materials.push({
                        name: '',
                        smooth: this.smooth
                    });
                    return lastMultiMaterial;
                }
            };
            // Inherit previous objects material.
            // Spec tells us that a declared material must be set to all objects until a new material is declared.
            // If a usemtl declaration is encountered while this new object is being parsed, it will
            // overwrite the inherited material. Exception being that there was already face declarations
            // to the inherited material, then it will be preserved for proper MultiMaterial continuation.
            if (previousMaterial && previousMaterial.name && typeof previousMaterial.clone === 'function') {
                const declared = previousMaterial.clone(0);
                declared.inherited = true;
                this.object.materials.push(declared);
            }
            this.objects.push(this.object);
        },
        finalize: function() {
            if (this.object && typeof this.object._finalize === 'function') this.object._finalize(true);
        },
        parseVertexIndex: function(value, len) {
            const index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 3) * 3;
        },
        parseNormalIndex: function(value, len) {
            const index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 3) * 3;
        },
        parseUVIndex: function(value, len) {
            const index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 2) * 2;
        },
        addVertex: function(a, b, c) {
            const src = this.vertices;
            const dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
            dst.push(src[b + 0], src[b + 1], src[b + 2]);
            dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addVertexPoint: function(a) {
            const src = this.vertices;
            const dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
        },
        addVertexLine: function(a) {
            const src = this.vertices;
            const dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
        },
        addNormal: function(a, b, c) {
            const src = this.normals;
            const dst = this.object.geometry.normals;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
            dst.push(src[b + 0], src[b + 1], src[b + 2]);
            dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addFaceNormal: function(a, b, c) {
            const src = this.vertices;
            const dst = this.object.geometry.normals;
            $cb9fee166e1d427e$var$_vA.fromArray(src, a);
            $cb9fee166e1d427e$var$_vB.fromArray(src, b);
            $cb9fee166e1d427e$var$_vC.fromArray(src, c);
            $cb9fee166e1d427e$var$_cb.subVectors($cb9fee166e1d427e$var$_vC, $cb9fee166e1d427e$var$_vB);
            $cb9fee166e1d427e$var$_ab.subVectors($cb9fee166e1d427e$var$_vA, $cb9fee166e1d427e$var$_vB);
            $cb9fee166e1d427e$var$_cb.cross($cb9fee166e1d427e$var$_ab);
            $cb9fee166e1d427e$var$_cb.normalize();
            dst.push($cb9fee166e1d427e$var$_cb.x, $cb9fee166e1d427e$var$_cb.y, $cb9fee166e1d427e$var$_cb.z);
            dst.push($cb9fee166e1d427e$var$_cb.x, $cb9fee166e1d427e$var$_cb.y, $cb9fee166e1d427e$var$_cb.z);
            dst.push($cb9fee166e1d427e$var$_cb.x, $cb9fee166e1d427e$var$_cb.y, $cb9fee166e1d427e$var$_cb.z);
        },
        addColor: function(a, b, c) {
            const src = this.colors;
            const dst = this.object.geometry.colors;
            if (src[a] !== undefined) dst.push(src[a + 0], src[a + 1], src[a + 2]);
            if (src[b] !== undefined) dst.push(src[b + 0], src[b + 1], src[b + 2]);
            if (src[c] !== undefined) dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addUV: function(a, b, c) {
            const src = this.uvs;
            const dst = this.object.geometry.uvs;
            dst.push(src[a + 0], src[a + 1]);
            dst.push(src[b + 0], src[b + 1]);
            dst.push(src[c + 0], src[c + 1]);
        },
        addDefaultUV: function() {
            const dst = this.object.geometry.uvs;
            dst.push(0, 0);
            dst.push(0, 0);
            dst.push(0, 0);
        },
        addUVLine: function(a) {
            const src = this.uvs;
            const dst = this.object.geometry.uvs;
            dst.push(src[a + 0], src[a + 1]);
        },
        addFace: function(a, b, c, ua, ub, uc, na, nb, nc) {
            const vLen = this.vertices.length;
            let ia = this.parseVertexIndex(a, vLen);
            let ib = this.parseVertexIndex(b, vLen);
            let ic = this.parseVertexIndex(c, vLen);
            this.addVertex(ia, ib, ic);
            this.addColor(ia, ib, ic);
            // normals
            if (na !== undefined && na !== '') {
                const nLen = this.normals.length;
                ia = this.parseNormalIndex(na, nLen);
                ib = this.parseNormalIndex(nb, nLen);
                ic = this.parseNormalIndex(nc, nLen);
                this.addNormal(ia, ib, ic);
            } else this.addFaceNormal(ia, ib, ic);
            // uvs
            if (ua !== undefined && ua !== '') {
                const uvLen = this.uvs.length;
                ia = this.parseUVIndex(ua, uvLen);
                ib = this.parseUVIndex(ub, uvLen);
                ic = this.parseUVIndex(uc, uvLen);
                this.addUV(ia, ib, ic);
                this.object.geometry.hasUVIndices = true;
            } else // add placeholder values (for inconsistent face definitions)
            this.addDefaultUV();
        },
        addPointGeometry: function(vertices) {
            this.object.geometry.type = 'Points';
            const vLen = this.vertices.length;
            for(let vi = 0, l = vertices.length; vi < l; vi++){
                const index = this.parseVertexIndex(vertices[vi], vLen);
                this.addVertexPoint(index);
                this.addColor(index);
            }
        },
        addLineGeometry: function(vertices, uvs) {
            this.object.geometry.type = 'Line';
            const vLen = this.vertices.length;
            const uvLen = this.uvs.length;
            for(let vi = 0, l = vertices.length; vi < l; vi++)this.addVertexLine(this.parseVertexIndex(vertices[vi], vLen));
            for(let uvi = 0, l = uvs.length; uvi < l; uvi++)this.addUVLine(this.parseUVIndex(uvs[uvi], uvLen));
        }
    };
    state.startObject('', false);
    return state;
}
//
class $cb9fee166e1d427e$export$7ae31604ad04b4a7 extends (0, $8TfIJ.Loader) {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new (0, $8TfIJ.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(text));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    setMaterials(materials) {
        this.materials = materials;
        return this;
    }
    parse(text) {
        const state = new $cb9fee166e1d427e$var$ParserState();
        if (text.indexOf('\r\n') !== -1) // This is faster than String.split with regex that splits on both
        text = text.replace(/\r\n/g, '\n');
        if (text.indexOf('\\\n') !== -1) // join lines separated by a line continuation character (\)
        text = text.replace(/\\\n/g, '');
        const lines = text.split('\n');
        let line = '', lineFirstChar = '';
        let lineLength = 0;
        let result = [];
        // Faster to just trim left side of the line. Use if available.
        const trimLeft = typeof ''.trimLeft === 'function';
        for(let i = 0, l = lines.length; i < l; i++){
            line = lines[i];
            line = trimLeft ? line.trimLeft() : line.trim();
            lineLength = line.length;
            if (lineLength === 0) continue;
            lineFirstChar = line.charAt(0);
            // @todo invoke passed in handler if any
            if (lineFirstChar === '#') continue;
            if (lineFirstChar === 'v') {
                const data = line.split(/\s+/);
                switch(data[0]){
                    case 'v':
                        state.vertices.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                        if (data.length >= 7) state.colors.push(parseFloat(data[4]), parseFloat(data[5]), parseFloat(data[6]));
                        else // if no colors are defined, add placeholders so color and vertex indices match
                        state.colors.push(undefined, undefined, undefined);
                        break;
                    case 'vn':
                        state.normals.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                        break;
                    case 'vt':
                        state.uvs.push(parseFloat(data[1]), parseFloat(data[2]));
                        break;
                }
            } else if (lineFirstChar === 'f') {
                const lineData = line.substr(1).trim();
                const vertexData = lineData.split(/\s+/);
                const faceVertices = [];
                // Parse the face vertex data into an easy to work with format
                for(let j = 0, jl = vertexData.length; j < jl; j++){
                    const vertex = vertexData[j];
                    if (vertex.length > 0) {
                        const vertexParts = vertex.split('/');
                        faceVertices.push(vertexParts);
                    }
                }
                // Draw an edge between the first vertex and all subsequent vertices to form an n-gon
                const v1 = faceVertices[0];
                for(let j = 1, jl = faceVertices.length - 1; j < jl; j++){
                    const v2 = faceVertices[j];
                    const v3 = faceVertices[j + 1];
                    state.addFace(v1[0], v2[0], v3[0], v1[1], v2[1], v3[1], v1[2], v2[2], v3[2]);
                }
            } else if (lineFirstChar === 'l') {
                const lineParts = line.substring(1).trim().split(' ');
                let lineVertices = [];
                const lineUVs = [];
                if (line.indexOf('/') === -1) lineVertices = lineParts;
                else for(let li = 0, llen = lineParts.length; li < llen; li++){
                    const parts = lineParts[li].split('/');
                    if (parts[0] !== '') lineVertices.push(parts[0]);
                    if (parts[1] !== '') lineUVs.push(parts[1]);
                }
                state.addLineGeometry(lineVertices, lineUVs);
            } else if (lineFirstChar === 'p') {
                const lineData = line.substr(1).trim();
                const pointData = lineData.split(' ');
                state.addPointGeometry(pointData);
            } else if ((result = $cb9fee166e1d427e$var$_object_pattern.exec(line)) !== null) {
                // o object_name
                // or
                // g group_name
                // WORKAROUND: https://bugs.chromium.org/p/v8/issues/detail?id=2869
                // let name = result[ 0 ].substr( 1 ).trim();
                const name = (' ' + result[0].substr(1).trim()).substr(1);
                state.startObject(name);
            } else if ($cb9fee166e1d427e$var$_material_use_pattern.test(line)) // material
            state.object.startMaterial(line.substring(7).trim(), state.materialLibraries);
            else if ($cb9fee166e1d427e$var$_material_library_pattern.test(line)) // mtl file
            state.materialLibraries.push(line.substring(7).trim());
            else if ($cb9fee166e1d427e$var$_map_use_pattern.test(line)) // the line is parsed but ignored since the loader assumes textures are defined MTL files
            // (according to https://www.okino.com/conv/imp_wave.htm, 'usemap' is the old-style Wavefront texture reference method)
            console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
            else if (lineFirstChar === 's') {
                result = line.split(' ');
                // smooth shading
                // @todo Handle files that have varying smooth values for a set of faces inside one geometry,
                // but does not define a usemtl for each face set.
                // This should be detected and a dummy material created (later MultiMaterial and geometry groups).
                // This requires some care to not create extra material on each smooth value for "normal" obj files.
                // where explicit usemtl defines geometry groups.
                // Example asset: examples/models/obj/cerberus/Cerberus.obj
                /*
					 * http://paulbourke.net/dataformats/obj/
					 * or
					 * http://www.cs.utah.edu/~boulos/cs3505/obj_spec.pdf
					 *
					 * From chapter "Grouping" Syntax explanation "s group_number":
					 * "group_number is the smoothing group number. To turn off smoothing groups, use a value of 0 or off.
					 * Polygonal elements use group numbers to put elements in different smoothing groups. For free-form
					 * surfaces, smoothing groups are either turned on or off; there is no difference between values greater
					 * than 0."
					 */ if (result.length > 1) {
                    const value = result[1].trim().toLowerCase();
                    state.object.smooth = value !== '0' && value !== 'off';
                } else // ZBrush can produce "s" lines #11707
                state.object.smooth = true;
                const material = state.object.currentMaterial();
                if (material) material.smooth = state.object.smooth;
            } else {
                // Handle null terminated files without exception
                if (line === '\0') continue;
                console.warn('THREE.OBJLoader: Unexpected line: "' + line + '"');
            }
        }
        state.finalize();
        const container = new (0, $8TfIJ.Group)();
        container.materialLibraries = [].concat(state.materialLibraries);
        const hasPrimitives = !(state.objects.length === 1 && state.objects[0].geometry.vertices.length === 0);
        if (hasPrimitives === true) for(let i = 0, l = state.objects.length; i < l; i++){
            const object = state.objects[i];
            const geometry = object.geometry;
            const materials = object.materials;
            const isLine = geometry.type === 'Line';
            const isPoints = geometry.type === 'Points';
            let hasVertexColors = false;
            // Skip o/g line declarations that did not follow with any faces
            if (geometry.vertices.length === 0) continue;
            const buffergeometry = new (0, $8TfIJ.BufferGeometry)();
            buffergeometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(geometry.vertices, 3));
            if (geometry.normals.length > 0) buffergeometry.setAttribute('normal', new (0, $8TfIJ.Float32BufferAttribute)(geometry.normals, 3));
            if (geometry.colors.length > 0) {
                hasVertexColors = true;
                buffergeometry.setAttribute('color', new (0, $8TfIJ.Float32BufferAttribute)(geometry.colors, 3));
            }
            if (geometry.hasUVIndices === true) buffergeometry.setAttribute('uv', new (0, $8TfIJ.Float32BufferAttribute)(geometry.uvs, 2));
            // Create materials
            const createdMaterials = [];
            for(let mi = 0, miLen = materials.length; mi < miLen; mi++){
                const sourceMaterial = materials[mi];
                const materialHash = sourceMaterial.name + '_' + sourceMaterial.smooth + '_' + hasVertexColors;
                let material = state.materials[materialHash];
                if (this.materials !== null) {
                    material = this.materials.create(sourceMaterial.name);
                    // mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
                    if (isLine && material && !(material instanceof (0, $8TfIJ.LineBasicMaterial))) {
                        const materialLine = new (0, $8TfIJ.LineBasicMaterial)();
                        (0, $8TfIJ.Material).prototype.copy.call(materialLine, material);
                        materialLine.color.copy(material.color);
                        material = materialLine;
                    } else if (isPoints && material && !(material instanceof (0, $8TfIJ.PointsMaterial))) {
                        const materialPoints = new (0, $8TfIJ.PointsMaterial)({
                            size: 10,
                            sizeAttenuation: false
                        });
                        (0, $8TfIJ.Material).prototype.copy.call(materialPoints, material);
                        materialPoints.color.copy(material.color);
                        materialPoints.map = material.map;
                        material = materialPoints;
                    }
                }
                if (material === undefined) {
                    if (isLine) material = new (0, $8TfIJ.LineBasicMaterial)();
                    else if (isPoints) material = new (0, $8TfIJ.PointsMaterial)({
                        size: 1,
                        sizeAttenuation: false
                    });
                    else material = new (0, $8TfIJ.MeshPhongMaterial)();
                    material.name = sourceMaterial.name;
                    material.flatShading = sourceMaterial.smooth ? false : true;
                    material.vertexColors = hasVertexColors;
                    state.materials[materialHash] = material;
                }
                createdMaterials.push(material);
            }
            // Create mesh
            let mesh;
            if (createdMaterials.length > 1) {
                for(let mi = 0, miLen = materials.length; mi < miLen; mi++){
                    const sourceMaterial = materials[mi];
                    buffergeometry.addGroup(sourceMaterial.groupStart, sourceMaterial.groupCount, mi);
                }
                if (isLine) mesh = new (0, $8TfIJ.LineSegments)(buffergeometry, createdMaterials);
                else if (isPoints) mesh = new (0, $8TfIJ.Points)(buffergeometry, createdMaterials);
                else mesh = new (0, $8TfIJ.Mesh)(buffergeometry, createdMaterials);
            } else {
                if (isLine) mesh = new (0, $8TfIJ.LineSegments)(buffergeometry, createdMaterials[0]);
                else if (isPoints) mesh = new (0, $8TfIJ.Points)(buffergeometry, createdMaterials[0]);
                else mesh = new (0, $8TfIJ.Mesh)(buffergeometry, createdMaterials[0]);
            }
            mesh.name = object.name;
            container.add(mesh);
        }
        else // if there is only the default parser state object with no geometry data, interpret data as point cloud
        if (state.vertices.length > 0) {
            const material = new (0, $8TfIJ.PointsMaterial)({
                size: 1,
                sizeAttenuation: false
            });
            const buffergeometry = new (0, $8TfIJ.BufferGeometry)();
            buffergeometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(state.vertices, 3));
            if (state.colors.length > 0 && state.colors[0] !== undefined) {
                buffergeometry.setAttribute('color', new (0, $8TfIJ.Float32BufferAttribute)(state.colors, 3));
                material.vertexColors = true;
            }
            const points = new (0, $8TfIJ.Points)(buffergeometry, material);
            container.add(points);
        }
        return container;
    }
    constructor(manager){
        super(manager);
        this.materials = null;
    }
}

});

parcelRegister("jpav3", function(module, exports) {

$parcel$export(module.exports, "MTLLoader", function () { return $e2087f2fb214164f$export$2a0ca4746a43f1f8; });

var $8TfIJ = parcelRequire("8TfIJ");
/**
 * Loads a Wavefront .mtl file specifying materials
 */ class $e2087f2fb214164f$export$2a0ca4746a43f1f8 extends (0, $8TfIJ.Loader) {
    /**
	 * Loads and parses a MTL asset from a URL.
	 *
	 * @param {String} url - URL to the MTL file.
	 * @param {Function} [onLoad] - Callback invoked with the loaded object.
	 * @param {Function} [onProgress] - Callback for download progress.
	 * @param {Function} [onError] - Callback for download errors.
	 *
	 * @see setPath setResourcePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setResourcePath() explicitly prior to load.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? (0, $8TfIJ.LoaderUtils).extractUrlBase(url) : this.path;
        const loader = new (0, $8TfIJ.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(text, path));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    setMaterialOptions(value) {
        this.materialOptions = value;
        return this;
    }
    /**
	 * Parses a MTL file.
	 *
	 * @param {String} text - Content of MTL file
	 * @return {MaterialCreator}
	 *
	 * @see setPath setResourcePath
	 *
	 * @note In order for relative texture references to resolve correctly
	 * you must call setResourcePath() explicitly prior to parse.
	 */ parse(text, path) {
        const lines = text.split('\n');
        let info = {};
        const delimiter_pattern = /\s+/;
        const materialsInfo = {};
        for(let i = 0; i < lines.length; i++){
            let line = lines[i];
            line = line.trim();
            if (line.length === 0 || line.charAt(0) === '#') continue;
            const pos = line.indexOf(' ');
            let key = pos >= 0 ? line.substring(0, pos) : line;
            key = key.toLowerCase();
            let value = pos >= 0 ? line.substring(pos + 1) : '';
            value = value.trim();
            if (key === 'newmtl') {
                // New material
                info = {
                    name: value
                };
                materialsInfo[value] = info;
            } else if (key === 'ka' || key === 'kd' || key === 'ks' || key === 'ke') {
                const ss = value.split(delimiter_pattern, 3);
                info[key] = [
                    parseFloat(ss[0]),
                    parseFloat(ss[1]),
                    parseFloat(ss[2])
                ];
            } else info[key] = value;
        }
        const materialCreator = new $e2087f2fb214164f$var$MaterialCreator(this.resourcePath || path, this.materialOptions);
        materialCreator.setCrossOrigin(this.crossOrigin);
        materialCreator.setManager(this.manager);
        materialCreator.setMaterials(materialsInfo);
        return materialCreator;
    }
    constructor(manager){
        super(manager);
    }
}
/**
 * Create a new MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */ class $e2087f2fb214164f$var$MaterialCreator {
    setCrossOrigin(value) {
        this.crossOrigin = value;
        return this;
    }
    setManager(value) {
        this.manager = value;
    }
    setMaterials(materialsInfo) {
        this.materialsInfo = this.convert(materialsInfo);
        this.materials = {};
        this.materialsArray = [];
        this.nameLookup = {};
    }
    convert(materialsInfo) {
        if (!this.options) return materialsInfo;
        const converted = {};
        for(const mn in materialsInfo){
            // Convert materials info into normalized form based on options
            const mat = materialsInfo[mn];
            const covmat = {};
            converted[mn] = covmat;
            for(const prop in mat){
                let save = true;
                let value = mat[prop];
                const lprop = prop.toLowerCase();
                switch(lprop){
                    case 'kd':
                    case 'ka':
                    case 'ks':
                        // Diffuse color (color under white light) using RGB values
                        if (this.options && this.options.normalizeRGB) value = [
                            value[0] / 255,
                            value[1] / 255,
                            value[2] / 255
                        ];
                        if (this.options && this.options.ignoreZeroRGBs) {
                            if (value[0] === 0 && value[1] === 0 && value[2] === 0) // ignore
                            save = false;
                        }
                        break;
                    default:
                        break;
                }
                if (save) covmat[lprop] = value;
            }
        }
        return converted;
    }
    preload() {
        for(const mn in this.materialsInfo)this.create(mn);
    }
    getIndex(materialName) {
        return this.nameLookup[materialName];
    }
    getAsArray() {
        let index = 0;
        for(const mn in this.materialsInfo){
            this.materialsArray[index] = this.create(mn);
            this.nameLookup[mn] = index;
            index++;
        }
        return this.materialsArray;
    }
    create(materialName) {
        if (this.materials[materialName] === undefined) this.createMaterial_(materialName);
        return this.materials[materialName];
    }
    createMaterial_(materialName) {
        // Create material
        const scope = this;
        const mat = this.materialsInfo[materialName];
        const params = {
            name: materialName,
            side: this.side
        };
        function resolveURL(baseUrl, url) {
            if (typeof url !== 'string' || url === '') return '';
            // Absolute URL
            if (/^https?:\/\//i.test(url)) return url;
            return baseUrl + url;
        }
        function setMapForType(mapType, value) {
            if (params[mapType]) return; // Keep the first encountered texture
            const texParams = scope.getTextureParams(value, params);
            const map = scope.loadTexture(resolveURL(scope.baseUrl, texParams.url));
            map.repeat.copy(texParams.scale);
            map.offset.copy(texParams.offset);
            map.wrapS = scope.wrap;
            map.wrapT = scope.wrap;
            params[mapType] = map;
        }
        for(const prop in mat){
            const value = mat[prop];
            let n;
            if (value === '') continue;
            switch(prop.toLowerCase()){
                // Ns is material specular exponent
                case 'kd':
                    // Diffuse color (color under white light) using RGB values
                    params.color = new (0, $8TfIJ.Color)().fromArray(value);
                    break;
                case 'ks':
                    // Specular color (color when light is reflected from shiny surface) using RGB values
                    params.specular = new (0, $8TfIJ.Color)().fromArray(value);
                    break;
                case 'ke':
                    // Emissive using RGB values
                    params.emissive = new (0, $8TfIJ.Color)().fromArray(value);
                    break;
                case 'map_kd':
                    // Diffuse texture map
                    setMapForType('map', value);
                    break;
                case 'map_ks':
                    // Specular map
                    setMapForType('specularMap', value);
                    break;
                case 'map_ke':
                    // Emissive map
                    setMapForType('emissiveMap', value);
                    break;
                case 'norm':
                    setMapForType('normalMap', value);
                    break;
                case 'map_bump':
                case 'bump':
                    // Bump texture map
                    setMapForType('bumpMap', value);
                    break;
                case 'map_d':
                    // Alpha map
                    setMapForType('alphaMap', value);
                    params.transparent = true;
                    break;
                case 'ns':
                    // The specular exponent (defines the focus of the specular highlight)
                    // A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.
                    params.shininess = parseFloat(value);
                    break;
                case 'd':
                    n = parseFloat(value);
                    if (n < 1) {
                        params.opacity = n;
                        params.transparent = true;
                    }
                    break;
                case 'tr':
                    n = parseFloat(value);
                    if (this.options && this.options.invertTrProperty) n = 1 - n;
                    if (n > 0) {
                        params.opacity = 1 - n;
                        params.transparent = true;
                    }
                    break;
                default:
                    break;
            }
        }
        this.materials[materialName] = new (0, $8TfIJ.MeshPhongMaterial)(params);
        return this.materials[materialName];
    }
    getTextureParams(value, matParams) {
        const texParams = {
            scale: new (0, $8TfIJ.Vector2)(1, 1),
            offset: new (0, $8TfIJ.Vector2)(0, 0)
        };
        const items = value.split(/\s+/);
        let pos;
        pos = items.indexOf('-bm');
        if (pos >= 0) {
            matParams.bumpScale = parseFloat(items[pos + 1]);
            items.splice(pos, 2);
        }
        pos = items.indexOf('-s');
        if (pos >= 0) {
            texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
            items.splice(pos, 4); // we expect 3 parameters here!
        }
        pos = items.indexOf('-o');
        if (pos >= 0) {
            texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
            items.splice(pos, 4); // we expect 3 parameters here!
        }
        texParams.url = items.join(' ').trim();
        return texParams;
    }
    loadTexture(url, mapping, onLoad, onProgress, onError) {
        const manager = this.manager !== undefined ? this.manager : (0, $8TfIJ.DefaultLoadingManager);
        let loader = manager.getHandler(url);
        if (loader === null) loader = new (0, $8TfIJ.TextureLoader)(manager);
        if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
        const texture = loader.load(url, onLoad, onProgress, onError);
        if (mapping !== undefined) texture.mapping = mapping;
        return texture;
    }
    constructor(baseUrl = '', options = {}){
        this.baseUrl = baseUrl;
        this.options = options;
        this.materialsInfo = {};
        this.materials = {};
        this.materialsArray = [];
        this.nameLookup = {};
        this.crossOrigin = 'anonymous';
        this.side = this.options.side !== undefined ? this.options.side : (0, $8TfIJ.FrontSide);
        this.wrap = this.options.wrap !== undefined ? this.options.wrap : (0, $8TfIJ.RepeatWrapping);
    }
}

});

parcelRegister("lT4gU", function(module, exports) {

$parcel$export(module.exports, "SimObject", function () { return $fef20c540401172b$export$daadc9f9996dde0d; });
/**
Class for the object interaction
**/ 
var $8TfIJ = parcelRequire("8TfIJ");

var $bIMf4 = parcelRequire("bIMf4");

var $cxq7w = parcelRequire("cxq7w");

var $kHIP8 = parcelRequire("kHIP8");

var $29ZVX = parcelRequire("29ZVX");

var $OCLXF = parcelRequire("OCLXF");

var $460Qg = parcelRequire("460Qg");

var $gnVfA = parcelRequire("gnVfA");
class $fef20c540401172b$export$daadc9f9996dde0d extends (0, $8TfIJ.Object3D) {
    //Positioning
    _calcFieldValues() {
        let fieldValues = [];
        let radValues = [];
        this.position.toArray(fieldValues);
        if (this.bodyShape === 'sphere') fieldValues[2] = fieldValues[2] - this.radius;
        else if (this.bodyShape === 'cylinder') fieldValues[2] = fieldValues[2] - this.size.z * .5;
        else fieldValues[2] = fieldValues[2] - this.size.z * .5;
        this.rotation.toArray(radValues);
        for(let i = 0; i < 3; i++){
            let val = this._radToDeg(radValues[i]);
            fieldValues.push(parseInt(val.toFixed()));
        }
        return fieldValues;
    }
    updateFieldValues() {
        this._fieldValues = this._calcFieldValues();
    }
    _radToDeg(rad) {
        return rad * 180 / Math.PI;
    }
    _degToRad(deg) {
        return deg * Math.PI / 180.0;
    }
    getFieldValues() {
        return this._fieldValues;
    }
    setFieldValues(fieldValues) {
        this._fieldValues = fieldValues;
    }
    updateFromFieldValues() {
        let posArray = [];
        let eulArray = [];
        for(let i = 0; i < 3; i++){
            posArray.push(this._fieldValues[i]);
            eulArray.push(parseFloat(this._degToRad(this._fieldValues[i + 3]).toFixed(3)));
        }
        for(let i = 0; i < 2; i++)this.position.setComponent(i, posArray[i]);
        this.position.setComponent(2, posArray[2] + this.size.z * .5);
        this.rotation.fromArray(eulArray);
    }
    //callback for objectChange
    _objectChange() {
        if (this.control.visible && !this.attached) {
            const checkBox = new (0, $8TfIJ.Box3)().setFromObject(this);
            const floor = new (0, $8TfIJ.Plane)(new (0, $8TfIJ.Vector3)(0, 0, 1));
            const distance = floor.distanceToPoint(this.position);
            if (floor.intersectsBox(checkBox)) {
                this.control.enabled = false;
                this.position.z = this.position.z + 0.001;
                return this._objectChange();
            } else if (distance < 0) {
                this.position.z = 0;
                this.control.enabled = false;
                return this._objectChange();
            } else {
                this.control.enabled = true;
                return;
            }
        }
    }
    //Use with caution, sets z-position until not intersecting with the floor.
    _floorCollision() {
        const checkBox = new (0, $8TfIJ.Box3)().setFromObject(this);
        const floor = new (0, $8TfIJ.Plane)(new (0, $8TfIJ.Vector3)(0, 0, 1));
        const distance = floor.distanceToPoint(this.position);
        if (floor.intersectsBox(checkBox)) {
            this.position.z = this.position.z + 0.001;
            return this._floorCollision();
        } else if (distance < 0) {
            this.position.z = 0;
            return this._floorCollision();
        } else return;
    }
    //Updates the attachted pose block.
    updatePoseBlock() {
        const fieldKeys = [
            'X',
            'Y',
            'Z',
            'ROLL',
            'PITCH',
            'YAW'
        ];
        const workspace = $460Qg.getMainWorkspace();
        if (workspace) {
            const block = workspace.getBlockById(this.name);
            if (block) {
                const pose = block.getInputTargetBlock('POSE');
                if (pose) for(var i = 0; i < this._fieldValues.length; i++){
                    let val = this._fieldValues[i];
                    pose.setFieldValue(val, fieldKeys[i]);
                }
            }
        }
    }
    //Visiblity and scene
    render() {
        (0, $cxq7w.requestAF)();
    }
    addToScene() {
        const scene = (0, $cxq7w.getScene)();
        const world = (0, $kHIP8.getWorld)();
        scene.add(this);
        this.initTransformControl();
        this.render();
    }
    removeFromScene() {
        const scene = (0, $cxq7w.getScene)();
        const world = (0, $kHIP8.getWorld)();
        if (this.hasBody) world.removeBody(this.body);
        if (this.isAttached) scene.attach(this);
        this.control.visible = true; //otherwise the renderer throws an error.
        //I suspect that threejs removes the
        //controls if visible is false.
        scene.remove(this.control);
        scene.remove(this);
        world.removeBody(this.body);
        this.render();
    }
    makeVisible() {
        const scene = (0, $cxq7w.getScene)();
        scene.add(this.control);
        this.visible = true;
        this.render();
    }
    hide() {
        const scene = (0, $cxq7w.getScene)();
        scene.remove(this.control);
        this.setTransformControlEnabled(false);
        this.visible = false;
        this.render();
    }
    highlight(status) {
        const limit = this.children.length;
        if (status) {
            for(let i = 0; i < limit; i++)if (this.children[i].material.emissive != undefined) {
                const colour = this.children[i].material.color.getHex();
                this.children[i].material.emissive.setHex(colour);
            }
            this.highlighted = status;
        } else if (!status) {
            for(let i = 0; i < limit; i++)if (this.children[i].material.emissive != undefined) this.children[i].material.emissive.setHex(0x000000);
            this.highlighted = status;
        }
        this.render();
    }
    setColor(color) {
        const limit = this.children.length;
        const children = this.children;
        this.color = color;
        for(let i = 0; i < limit; i++)children[i].material = new (0, $8TfIJ.MeshPhongMaterial)({
            color: color
        });
    }
    setScale(scale) {
        this.scaleFactor = scale;
        this.scale.set(scale, scale, scale);
        this.children[0].geometry.computeBoundingBox();
        this.children[0].geometry.boundingBox.getCenter();
        this.children[0].geometry.center();
        const size = new (0, $8TfIJ.Vector3)();
        const tmpBox = new (0, $8TfIJ.Box3)().setFromObject(this);
        tmpBox.getSize(size);
        this.size.copy(size);
        this.createBody(0.5 * scale, 2, 0.1);
        this.setGrippable();
        this.setGripAxes();
        this._floorCollision();
        this.updateFieldValues();
        this.updatePoseBlock();
        this.render();
    }
    changeShape(shape) {
        this.shape = shape;
        const world = (0, $kHIP8.getWorld)();
        this.removeFromScene();
        const limit = this.children.length;
        const children = this.children;
        for(let i = 0; i < limit; i++)this.remove(children[i]);
        world.removeBody(this.body);
        (0, $29ZVX.addGeometry)(this);
        (0, $29ZVX.remControledSimObject)();
        this.addToScene();
        console.log('Changed to shape: ', shape);
    }
    reset() {
        this.updateFromFieldValues();
        this.attached = false;
        this.removeBodyFromWorld();
        this.render();
    }
    //Collision bodys
    createBody(mass, friction, restitution) {
        const body = new (0, $OCLXF.Body)({
            mass: mass
        });
        const world = (0, $kHIP8.getWorld)();
        body.material = new (0, $OCLXF.Material)({
            friction: friction,
            restitution: restitution
        });
        body.allowSleep = true;
        switch(this.bodyShape){
            case 'sphere':
                {
                    const sphere = new (0, $OCLXF.Sphere)(this.radius * this.scaleFactor);
                    body.sleepSpeedLimit = 1.2;
                    body.sleepTimeLimit = 0.2;
                    body.addShape(sphere);
                }
                break;
            case 'cylinder':
                {
                    const radiusTop = this.size.x * 0.5;
                    const radiusBottom = this.size.z * 0.5;
                    const height = this.size.y;
                    const numSegments = 12;
                    const cylinder = new (0, $OCLXF.Cylinder)(radiusTop, radiusBottom, height, numSegments);
                    body.sleepSpeedLimit = 0.5;
                    body.sleepTimeLimit = 0.2;
                    body.addShape(cylinder);
                }
                break;
            case 'box':
            default:
                {
                    //cannon size is defined from the center
                    const shape = new (0, $OCLXF.Box)(new (0, $OCLXF.Vec3)(this.size.x * 0.5, this.size.y * 0.5, this.size.z * 0.5));
                    body.sleepSpeedLimit = 0.5;
                    body.sleepTimeLimit = 0.2;
                    body.addShape(shape);
                }
        }
        this.hasBody = true;
        this.mass = mass;
        this.body = body;
        this.body.name = this.name;
        this.body.sleep();
        this.updateBody();
    }
    updateBody() {
        this.body.position.copy(this.position);
        this.body.quaternion.copy(this.quaternion);
    }
    updateMesh() {
        this.position.copy(this.body.position);
        this.quaternion.copy(this.body.quaternion);
    }
    addBodyToWorld() {
        const world = (0, $kHIP8.getWorld)();
        world.addBody(this.body);
    }
    removeBodyFromWorld() {
        const world = (0, $kHIP8.getWorld)();
        world.removeBody(this.body);
    }
    //Listeners for controls
    initTransformControl() {
        const controlObj = (0, $cxq7w.getControl)();
        const scene = (0, $cxq7w.getScene)();
        this.control = new (0, $bIMf4.TransformControls)(controlObj.camera, controlObj.renderer.domElement);
        this.control.setSize((0, $gnVfA.canHover)() ? 1.25 : 2.5);
        this.control.addEventListener('dragging-changed', (evt)=>this._draggingCanged(evt));
        this.control.addEventListener('objectChange', ()=>this._objectChange());
        this.control.attach(this);
        scene.add(this.control);
        this.control.visible = false;
        this.control.enabled = this.control.visible;
    }
    setTransformControlEnabled(enabled) {
        this.control.enabled = enabled;
        this.control.visible = enabled;
    }
    //callback for dragging-changed
    _draggingCanged(event) {
        const controlObj = (0, $cxq7w.getControl)();
        controlObj.orbitControls.enabled = !event.value;
    }
    //Interactions
    detachFromGripper(robot) {
        const scene = (0, $cxq7w.getScene)();
        scene.attach(this);
        this.attached = false;
        this.control.enabled = true;
        this.addBodyToWorld();
        this.updateBody();
        this.body.wakeUp();
        this.body.updateInertiaWorld();
        console.log('> Object dropped!');
    }
    attachToGripper(robot) {
        this.removeBodyFromWorld();
        const scene = (0, $cxq7w.getScene)();
        const tcp = robot.tcp.object;
        this.attached = true;
        this.wasGripped = true;
        this.control.enabled = false;
        scene.remove(this.control);
        tcp.attach(this);
        this.updateBody(); /* this is important, i dont know why
                            updateBody has to be the last thing to be executed...*/ 
        console.log('> Object gripped!');
    }
    isGrippable() {
        return this.grippable;
    }
    isGrippableAxisIndependent() {
        return this.grippableAxisIndependent;
    }
    setGrippable() {
        const robot = (0, $cxq7w.getRobot)();
        const sizeArray = [];
        const play = 0.2;
        const upperLimit = 0.8 //(robot.hand.movable[0].limit.upper * robot.modelScale * 2) + play; //Two finger grippers only
        ;
        this.size.toArray(sizeArray);
        if (Math.max(...sizeArray) * this.scaleFactor <= upperLimit) {
            this.grippable = true;
            this.grippableAxisIndependent = true;
        } else if (Math.min(...sizeArray) * this.scaleFactor <= upperLimit) {
            this.grippable = true;
            this.grippableAxisIndependent = false;
        } else {
            this.grippable = false;
            this.grippableAxisIndependent = false;
        }
    //console.log('simObject ', this.name, 'is grippable: ', this.grippable);
    //console.log('simObject ', this.name, 'is grippable on any axis: ', this.grippableAxisIndependent);
    }
    setGripAxes() {
        const sizeArray = [];
        const axisArray = [
            0,
            0,
            0
        ];
        this.gripAxes = [];
        this.size.toArray(sizeArray);
        const min = Math.min(...sizeArray);
        const max = Math.max(...sizeArray);
        let maxIdx;
        let minIdx;
        for(let i = 0; i < sizeArray.length; i++){
            if (sizeArray[i] === max) maxIdx = i;
            if (sizeArray[i] === min) minIdx = i;
        }
        axisArray[maxIdx] = 1;
        const axis = new (0, $8TfIJ.Vector3)().fromArray(axisArray);
        this.gripAxes.push(axis);
    }
    checkGripperOrientation(robot) {
        let returnVal = false;
        //const scene = getScene();
        //hand position for distCheck
        const hand = robot.hand.links[0];
        const handPos = new (0, $8TfIJ.Vector3)();
        hand.getWorldPosition(handPos);
        //tcp position and orientation for the axes
        const tcp = robot.tcp.object;
        const tcpPos = new (0, $8TfIJ.Vector3)();
        const tcpQuat = new (0, $8TfIJ.Quaternion)();
        tcp.getWorldPosition(tcpPos);
        tcp.getWorldQuaternion(tcpQuat);
        const zAxisTCP = new (0, $8TfIJ.Vector3)(0, 0, 1);
        zAxisTCP.applyQuaternion(tcpQuat);
        zAxisTCP.normalize();
        const fingerNormal = new (0, $8TfIJ.Vector3)(0, 1, 0); /*A vector that is normal
                                                    to the plane of the fingertip*/ 
        const leftFinger = robot.hand.movable[0];
        let fingerQuat = new (0, $8TfIJ.Quaternion)();
        leftFinger.getWorldQuaternion(fingerQuat);
        fingerNormal.applyQuaternion(fingerQuat);
        fingerNormal.normalize();
        //Same for the simObject
        let simQuat = new (0, $8TfIJ.Quaternion)();
        let gripAxis = new (0, $8TfIJ.Vector3)().copy(this.gripAxes[0]);
        this.getWorldQuaternion(simQuat);
        gripAxis.applyQuaternion(simQuat);
        gripAxis.normalize();
        //Human readable angles...
        let xi = this._radToDeg(gripAxis.angleTo(zAxisTCP));
        let tau = this._radToDeg(gripAxis.angleTo(fingerNormal));
        console.log('Angle gripAxis to zAxisTCP, xi, (green to yellow)', xi);
        console.log('Angle gripAxis to fingerNormal, tau, (green to pink)', tau);
        //distance check
        let distance = this.position.distanceTo(tcpPos);
        let distCheck = true; //distance >= tcpPos.distanceTo(handPos);
        if (75 < tau && tau < 115) {
            if (0 < xi && xi < 15) {
                if (distCheck) {
                    returnVal = true;
                    console.log('can grip');
                } else {
                    returnVal = false;
                    console.log('can not grip');
                }
            } else if (170 < xi && xi < 185) {
                if (distCheck) {
                    returnVal = true;
                    console.log('can grip');
                } else {
                    returnVal = false;
                    console.log('can not grip');
                }
            } else {
                returnVal = true;
                console.log('can grip');
            }
        } else {
            returnVal = false;
            console.log('can not grip');
        }
        return returnVal;
    }
    constructor(){
        super();
        this.name = undefined;
        this.type = 'simObject'; //not used, set for development purposes
        this.shape = 'cube'; //default
        this.attached = false; //for the gripper interaction
        this.hasBody = false;
        this.body = undefined;
        this.checkBox = undefined;
        this.checkSphere = undefined;
        this.control = undefined;
        this._fieldValues = [
            5,
            0,
            0,
            0,
            0,
            0
        ];
        this.color = '#eb4034' //light orange, default fallback color
        ;
        this.highlighted = false;
        this.bodyShape = 'box';
        this.radius = 0;
        this.mass = 0;
        this.size = new (0, $8TfIJ.Vector3)(0.5, 0.5, 0.5);
        this.scaleFactor = 1;
        this.grippable = true;
        this.grippableAxisIndependent = true;
        this.gripAxes = [];
    }
}

});
parcelRegister("cxq7w", function(module, exports) {

$parcel$export(module.exports, "enablePointerEvents", function () { return $920cd41131946cb9$export$db1674abb9b022c7; });
$parcel$export(module.exports, "disablePointerEvents", function () { return $920cd41131946cb9$export$58ab49e8c4c2cc10; });
$parcel$export(module.exports, "addRenderCallback", function () { return $920cd41131946cb9$export$15d017e5033ed471; });
$parcel$export(module.exports, "requestAF", function () { return $920cd41131946cb9$export$725bc17d6eea0718; });
$parcel$export(module.exports, "getScene", function () { return $920cd41131946cb9$export$c8e3ae83cd1c2af; });
$parcel$export(module.exports, "getRobot", function () { return $920cd41131946cb9$export$db745c57b3eca871; });
$parcel$export(module.exports, "getControl", function () { return $920cd41131946cb9$export$caf8f8b20e380f6e; });

var $8TfIJ = parcelRequire("8TfIJ");

var $kHIP8 = parcelRequire("kHIP8");

var $29ZVX = parcelRequire("29ZVX");

var $gitxc = parcelRequire("gitxc");

var $bIMf4 = parcelRequire("bIMf4");

var $3f0bX = parcelRequire("3f0bX");

var $iBDKO = parcelRequire("iBDKO");

var $3bR3B = parcelRequire("3bR3B");

var $3z8rE = parcelRequire("3z8rE");

var $dw2Ek = parcelRequire("dw2Ek");

var $gxi2A = parcelRequire("gxi2A");

var $gnVfA = parcelRequire("gnVfA");
// In ROS models Z points upwards
(0, $8TfIJ.Object3D).DefaultUp = new (0, $8TfIJ.Vector3)(0, 0, 1);

var $5X33T = parcelRequire("5X33T");

var $4zEWR = parcelRequire("4zEWR");
const $920cd41131946cb9$var$selectedRobot = (0, $gnVfA.getDesiredRobot)();
let $920cd41131946cb9$var$robot;



switch($920cd41131946cb9$var$selectedRobot.toLowerCase()){
    case 'franka':
        $920cd41131946cb9$var$robot = (parcelRequire("iGskC"));
        break;
    case 'niryo':
        $920cd41131946cb9$var$robot = (parcelRequire("jIL9O"));
        break;
    case 'sawyer':
        $920cd41131946cb9$var$robot = (parcelRequire("1Gb2G"));
        break;
    default:
        throw 'Unknown robot \'' + $920cd41131946cb9$var$selectedRobot + '\'';
}
let $920cd41131946cb9$var$container;
let $920cd41131946cb9$var$camera, $920cd41131946cb9$var$scene, $920cd41131946cb9$var$renderer;
let $920cd41131946cb9$var$raycaster;
let $920cd41131946cb9$var$pointerDownPixels = new (0, $8TfIJ.Vector2)();
let $920cd41131946cb9$var$pointerXY = new (0, $8TfIJ.Vector2)();
let $920cd41131946cb9$var$pointerDrag = false;
let $920cd41131946cb9$var$tcptarget, $920cd41131946cb9$var$groundLine;
let $920cd41131946cb9$var$cameraControl, $920cd41131946cb9$var$robotControl;
let $920cd41131946cb9$var$simObjectActive = false;
let $920cd41131946cb9$var$ik;
const $920cd41131946cb9$var$renderCallbacks = [];
$920cd41131946cb9$var$loadRobotModel($920cd41131946cb9$var$robot.xacro).then((model)=>{
    $920cd41131946cb9$var$robot.init(model);
    $('.robot-info').on('click', (evt)=>(0, $gxi2A.popInfo)($920cd41131946cb9$var$robot.info.DE));
    $920cd41131946cb9$var$robot.setPose($920cd41131946cb9$var$robot.defaultPose);
    $920cd41131946cb9$var$initScene();
    (0, $kHIP8.initCannon)();
    $920cd41131946cb9$var$ik = new (0, $3bR3B.default)($920cd41131946cb9$var$scene, $920cd41131946cb9$var$robot);
    (0, $3z8rE.default).init($920cd41131946cb9$var$robot, $920cd41131946cb9$var$ik, $920cd41131946cb9$var$ikRender);
}, (reason)=>{
    console.error(reason);
});
function $920cd41131946cb9$var$loadRobotModel(url) {
    return new Promise((resolve, reject)=>{
        const xacroLoader = new (0, $3f0bX.XacroLoader)();
        xacroLoader.inOrder = true;
        xacroLoader.requirePrefix = true;
        xacroLoader.localProperties = true;
        xacroLoader.rospackCommands.find = (...args)=>{
            return $4zEWR.join($920cd41131946cb9$var$robot.root, ...args);
        };
        for(let cmd in $920cd41131946cb9$var$robot.rosMacros)xacroLoader.rospackCommands[cmd] = $920cd41131946cb9$var$robot.rosMacros[cmd];
        xacroLoader.load(url, (xml)=>{
            let manager = new (0, $8TfIJ.LoadingManager)($920cd41131946cb9$var$onLoadComplete, $920cd41131946cb9$var$render);
            const urdfLoader = new (0, $iBDKO.default)(manager);
            urdfLoader.packages = $920cd41131946cb9$var$robot.packages;
            urdfLoader.workingPath = (0, $8TfIJ.LoaderUtils).extractUrlBase(url);
            let model = urdfLoader.parse(xml);
            resolve(model);
        }, (error)=>{
            console.error(error);
            reject(error);
        });
    });
}
function $920cd41131946cb9$var$onLoadComplete() {
    $('.loading-lightbox').hide();
    $920cd41131946cb9$var$robot.onLoadComplete();
}
function $920cd41131946cb9$var$initScene() {
    $920cd41131946cb9$var$container = document.getElementById("sim-canvas");
    $920cd41131946cb9$var$scene = new (0, $8TfIJ.Scene)();
    $920cd41131946cb9$var$scene.background = new (0, $8TfIJ.Color)(0x363b4b);
    // Camera
    $920cd41131946cb9$var$camera = new (0, $8TfIJ.PerspectiveCamera)(45, $920cd41131946cb9$var$container.clientWidth / $920cd41131946cb9$var$container.clientHeight, 1, 2000);
    $920cd41131946cb9$var$camera.position.set(8, 20, 17);
    $920cd41131946cb9$var$camera.lookAt(0, 0, 10);
    // Grid
    //const grid = new PolarGridHelper(12, 16, 8, 64, 0x888888, 0xaaaaaa);
    const grid = new (0, $8TfIJ.GridHelper)(20, 20, 0xf0f0f0, 0x888888);
    grid.rotateX(Math.PI / 2);
    $920cd41131946cb9$var$scene.add(grid);
    // for (let i = 0; i < 5; i++) {
    // 	let rock = makeRock(20, 1);
    // 	rock.position.set(i * 3, 5, 0);
    // 	scene.add(rock);
    // }
    // Robot
    $920cd41131946cb9$var$scene.add($920cd41131946cb9$var$robot.model);
    // for (let joint of robot.arm.movable) {
    // 	joint.add(new ArrowHelper(new Vector3(0, 0, 1), new Vector3(), 0.3, 0x0000ff));
    // }
    // Lights
    const light = new (0, $8TfIJ.HemisphereLight)(0xffeeee, 0x111122);
    $920cd41131946cb9$var$scene.add(light);
    const pointLight = new (0, $8TfIJ.PointLight)(0xffffff, 0.3);
    //pointLight.castShadow = true;
    //particleLight.add(pointLight);
    //particleLight.position.set(30, 40, 30);
    pointLight.position.set(30, 30, 40);
    $920cd41131946cb9$var$scene.add(pointLight);
    $920cd41131946cb9$var$renderer = new (0, $8TfIJ.WebGLRenderer)();
    $920cd41131946cb9$var$renderer.sortObjects = false;
    $920cd41131946cb9$var$renderer.setPixelRatio(window.devicePixelRatio);
    $920cd41131946cb9$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $920cd41131946cb9$var$container.appendChild($920cd41131946cb9$var$renderer.domElement);
    // Scene controls
    $920cd41131946cb9$var$cameraControl = new (0, $gitxc.OrbitControls)($920cd41131946cb9$var$camera, $920cd41131946cb9$var$renderer.domElement);
    $920cd41131946cb9$var$cameraControl.damping = 0.2;
    $920cd41131946cb9$var$cameraControl.addEventListener("change", $920cd41131946cb9$var$render);
    // TCP target & controls
    $920cd41131946cb9$var$tcptarget = new (0, $8TfIJ.Mesh)(new (0, $8TfIJ.SphereGeometry)(2), new (0, $8TfIJ.MeshBasicMaterial)({
        visible: false
    }));
    $920cd41131946cb9$var$robot.tcp.object.getWorldPosition($920cd41131946cb9$var$tcptarget.position);
    $920cd41131946cb9$var$scene.add($920cd41131946cb9$var$tcptarget);
    let lineVertices = [];
    lineVertices.push($920cd41131946cb9$var$tcptarget.position.clone());
    lineVertices.push($920cd41131946cb9$var$tcptarget.position.clone().setZ(0));
    let lineGeometry = new (0, $8TfIJ.BufferGeometry)().setFromPoints(lineVertices);
    $920cd41131946cb9$var$groundLine = new (0, $8TfIJ.Line)(lineGeometry, new (0, $8TfIJ.LineBasicMaterial)({
        color: 0xaaaacc
    }));
    $920cd41131946cb9$var$groundLine.name = 'groundLine';
    $920cd41131946cb9$var$scene.add($920cd41131946cb9$var$groundLine);
    $920cd41131946cb9$var$robotControl = new (0, $bIMf4.TransformControls)($920cd41131946cb9$var$camera, $920cd41131946cb9$var$renderer.domElement);
    $920cd41131946cb9$var$robotControl.setSize((0, $gnVfA.canHover)() ? 1.7 : 3);
    $920cd41131946cb9$var$robotControl.addEventListener("change", (evt)=>requestAnimationFrame($920cd41131946cb9$var$render));
    $920cd41131946cb9$var$robotControl.addEventListener("objectChange", $920cd41131946cb9$var$onTargetChange);
    $920cd41131946cb9$var$robotControl.addEventListener("dragging-changed", (evt)=>$920cd41131946cb9$var$cameraControl.enabled = !evt.value);
    // TODO setMode('rotate') on click event
    $920cd41131946cb9$var$robotControl.attach($920cd41131946cb9$var$tcptarget);
    $920cd41131946cb9$var$scene.add($920cd41131946cb9$var$robotControl);
    $920cd41131946cb9$var$robotControl.visible = false;
    $920cd41131946cb9$var$robotControl.enabled = false;
    $920cd41131946cb9$var$raycaster = new (0, $8TfIJ.Raycaster)();
    $920cd41131946cb9$export$db1674abb9b022c7();
    let domParent = document.querySelector('.sim-container');
    new $5X33T(domParent, $920cd41131946cb9$var$onCanvasResize);
    $920cd41131946cb9$var$onCanvasResize();
    $dw2Ek.initGui($920cd41131946cb9$var$robot, $920cd41131946cb9$var$cameraControl, $920cd41131946cb9$var$ikRender);
}
function $920cd41131946cb9$var$onCanvasResize() {
    $920cd41131946cb9$var$camera.aspect = $920cd41131946cb9$var$container.clientWidth / $920cd41131946cb9$var$container.clientHeight;
    $920cd41131946cb9$var$camera.updateProjectionMatrix();
    $920cd41131946cb9$var$renderer.setSize($920cd41131946cb9$var$container.clientWidth, $920cd41131946cb9$var$container.clientHeight);
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$var$onTargetChange() {
    // Prevent target from going beneath the floor
    $920cd41131946cb9$var$tcptarget.position.z = Math.max(0, $920cd41131946cb9$var$tcptarget.position.z);
    $920cd41131946cb9$var$updateGroundLine();
    // Do the IK if the target has been moved
    $920cd41131946cb9$var$ik.solve($920cd41131946cb9$var$tcptarget, $920cd41131946cb9$var$robot, $920cd41131946cb9$var$robot.ikEnabled, {
        // we don't have to be all that precise here
        maxIterations: 3,
        stopDistance: 0.1,
        jointLimits: $920cd41131946cb9$var$robot.interactionJointLimits,
        apply: true
    });
// requestAnimationFrame is called in the transformControl's change-listener,
// so we can skip it here
}
function $920cd41131946cb9$var$ikRender() {
    $920cd41131946cb9$var$robot.tcp.object.getWorldPosition($920cd41131946cb9$var$tcptarget.position);
    $920cd41131946cb9$var$robot.tcp.object.getWorldQuaternion($920cd41131946cb9$var$tcptarget.quaternion);
    $920cd41131946cb9$var$updateGroundLine();
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$var$updateGroundLine() {
    const geom = $920cd41131946cb9$var$groundLine.geometry;
    const position = geom.attributes.position;
    position.setXYZ(0, $920cd41131946cb9$var$tcptarget.position.x, $920cd41131946cb9$var$tcptarget.position.y, $920cd41131946cb9$var$tcptarget.position.z);
    position.setXYZ(1, $920cd41131946cb9$var$tcptarget.position.x, $920cd41131946cb9$var$tcptarget.position.y, 0);
    position.needsUpdate = true;
}
function $920cd41131946cb9$var$render() {
    $920cd41131946cb9$var$renderer.render($920cd41131946cb9$var$scene, $920cd41131946cb9$var$camera);
    for (let cb of $920cd41131946cb9$var$renderCallbacks)cb($920cd41131946cb9$var$robot);
}
function $920cd41131946cb9$export$db1674abb9b022c7() {
    if ((0, $gnVfA.canHover)()) {
        $920cd41131946cb9$var$container.addEventListener('pointermove', $920cd41131946cb9$var$onHoverPointerMove);
        $920cd41131946cb9$var$container.addEventListener('pointerdown', $920cd41131946cb9$var$onHoverPointerDown);
        $920cd41131946cb9$var$container.addEventListener('pointerup', $920cd41131946cb9$var$onHoverPointerUp);
    } else {
        $920cd41131946cb9$var$container.addEventListener('pointermove', $920cd41131946cb9$var$onClickPointerMove);
        $920cd41131946cb9$var$container.addEventListener('pointerdown', $920cd41131946cb9$var$onClickPointerDown);
        $920cd41131946cb9$var$container.addEventListener('pointerup', $920cd41131946cb9$var$onClickPointerUp);
    }
}
function $920cd41131946cb9$export$58ab49e8c4c2cc10() {
    if ((0, $gnVfA.canHover)()) {
        $920cd41131946cb9$var$container.removeEventListener('pointermove', $920cd41131946cb9$var$onHoverPointerMove);
        $920cd41131946cb9$var$container.removeEventListener('pointerdown', $920cd41131946cb9$var$onHoverPointerDown);
        $920cd41131946cb9$var$container.removeEventListener('pointerup', $920cd41131946cb9$var$onHoverPointerUp);
    } else {
        $920cd41131946cb9$var$container.removeEventListener('pointermove', $920cd41131946cb9$var$onClickPointerMove);
        $920cd41131946cb9$var$container.removeEventListener('pointerdown', $920cd41131946cb9$var$onClickPointerDown);
        $920cd41131946cb9$var$container.removeEventListener('pointerup', $920cd41131946cb9$var$onClickPointerUp);
    }
    (0, $29ZVX.remControledSimObject)();
    $920cd41131946cb9$var$robotControl.visible = false;
    $920cd41131946cb9$var$robotControl.enabled = false;
}
function $920cd41131946cb9$var$onHoverPointerMove(evt) {
    evt.preventDefault();
    $920cd41131946cb9$var$pointerDrag = true;
    $920cd41131946cb9$var$pointerXY.x = evt.offsetX / $920cd41131946cb9$var$container.clientWidth * 2 - 1;
    $920cd41131946cb9$var$pointerXY.y = -(evt.offsetY / $920cd41131946cb9$var$container.clientHeight) * 2 + 1;
    $920cd41131946cb9$var$raycaster.setFromCamera($920cd41131946cb9$var$pointerXY, $920cd41131946cb9$var$camera);
    (0, $29ZVX.setSimObjectHighlight)($920cd41131946cb9$var$raycaster); //does this for all TransformControls of simObjects
    let showRTC = false;
    // Only show the robot controls if no object is visible
    if (!$920cd41131946cb9$var$simObjectActive) {
        const intersections = $920cd41131946cb9$var$raycaster.intersectObjects([
            $920cd41131946cb9$var$tcptarget
        ]);
        showRTC = intersections.length > 0;
    }
    if (showRTC !== $920cd41131946cb9$var$robotControl.visible) {
        $920cd41131946cb9$var$robotControl.visible = showRTC;
        $920cd41131946cb9$var$robotControl.enabled = showRTC;
    }
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$var$onHoverPointerDown(evt) {
    $920cd41131946cb9$var$pointerDrag = false;
    $920cd41131946cb9$var$pointerDownPixels.x = evt.offsetX;
    $920cd41131946cb9$var$pointerDownPixels.y = evt.offsetY;
}
function $920cd41131946cb9$var$onHoverPointerUp(evt) {
    // Don't change transform controls if the pointer was dragged at least (5) pixels
    if ($920cd41131946cb9$var$pointerDrag || new (0, $8TfIJ.Vector2)(evt.offsetX, evt.offsetY).sub($920cd41131946cb9$var$pointerDownPixels).length() > 5) return;
    $920cd41131946cb9$var$simObjectActive = (0, $29ZVX.setTCSimObjectsOnClick)($920cd41131946cb9$var$raycaster);
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$var$onClickPointerMove(evt) {
    evt.preventDefault();
    $920cd41131946cb9$var$pointerDrag = true;
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$var$onClickPointerDown(evt) {
    $920cd41131946cb9$var$pointerDrag = false;
    $920cd41131946cb9$var$pointerDownPixels.x = evt.offsetX;
    $920cd41131946cb9$var$pointerDownPixels.y = evt.offsetY;
}
function $920cd41131946cb9$var$onClickPointerUp(evt) {
    // Don't do anything if the pointer was dragged at least (5) pixels
    if ($920cd41131946cb9$var$pointerDrag || new (0, $8TfIJ.Vector2)(evt.offsetX, evt.offsetY).sub($920cd41131946cb9$var$pointerDownPixels).length() > 5) return;
    $920cd41131946cb9$var$pointerXY.x = evt.offsetX / $920cd41131946cb9$var$container.clientWidth * 2 - 1;
    $920cd41131946cb9$var$pointerXY.y = -(evt.offsetY / $920cd41131946cb9$var$container.clientHeight) * 2 + 1;
    $920cd41131946cb9$var$raycaster.setFromCamera($920cd41131946cb9$var$pointerXY, $920cd41131946cb9$var$camera);
    let showRTC = false;
    // SimObjects first since they are harder to hit
    let simObjectHit = (0, $29ZVX.setTCSimObjectsOnClick)($920cd41131946cb9$var$raycaster);
    if (!simObjectHit) {
        let intersected = $920cd41131946cb9$var$raycaster.intersectObjects([
            $920cd41131946cb9$var$tcptarget
        ]);
        showRTC = intersected.length > 0;
    }
    if (showRTC !== $920cd41131946cb9$var$robotControl.visible) {
        $920cd41131946cb9$var$robotControl.visible = showRTC;
        $920cd41131946cb9$var$robotControl.enabled = showRTC;
    }
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$export$15d017e5033ed471(callback) {
    if ($920cd41131946cb9$var$renderCallbacks.includes(callback)) return;
    $920cd41131946cb9$var$renderCallbacks.push(callback);
}
function $920cd41131946cb9$export$725bc17d6eea0718() {
    requestAnimationFrame($920cd41131946cb9$var$render);
}
function $920cd41131946cb9$export$c8e3ae83cd1c2af() {
    return $920cd41131946cb9$var$scene;
}
function $920cd41131946cb9$export$db745c57b3eca871() {
    return $920cd41131946cb9$var$robot;
}
function $920cd41131946cb9$export$caf8f8b20e380f6e() {
    const contObj = {
        camera: $920cd41131946cb9$var$camera,
        orbitControls: $920cd41131946cb9$var$cameraControl,
        renderer: $920cd41131946cb9$var$renderer
    };
    return contObj;
}

});
parcelRegister("gitxc", function(module, exports) {

$parcel$export(module.exports, "OrbitControls", function () { return $bdd53cbbc361ae77$export$8ff7788029dfdf52; });

var $8TfIJ = parcelRequire("8TfIJ");
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $bdd53cbbc361ae77$var$_changeEvent = {
    type: 'change'
};
const $bdd53cbbc361ae77$var$_startEvent = {
    type: 'start'
};
const $bdd53cbbc361ae77$var$_endEvent = {
    type: 'end'
};
class $bdd53cbbc361ae77$export$8ff7788029dfdf52 extends (0, $8TfIJ.EventDispatcher) {
    constructor(object, domElement){
        super();
        if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
        if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
        this.object = object;
        this.domElement = domElement;
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $8TfIJ.Vector3)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown'
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $8TfIJ.MOUSE).ROTATE,
            MIDDLE: (0, $8TfIJ.MOUSE).DOLLY,
            RIGHT: (0, $8TfIJ.MOUSE).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $8TfIJ.TOUCH).ROTATE,
            TWO: (0, $8TfIJ.TOUCH).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        //
        // public methods
        //
        this.getPolarAngle = function() {
            return spherical.phi;
        };
        this.getAzimuthalAngle = function() {
            return spherical.theta;
        };
        this.listenToKeyEvents = function(domElement) {
            domElement.addEventListener('keydown', onKeyDown);
            this._domElementKeyEvents = domElement;
        };
        this.saveState = function() {
            scope.target0.copy(scope.target);
            scope.position0.copy(scope.object.position);
            scope.zoom0 = scope.object.zoom;
        };
        this.reset = function() {
            scope.target.copy(scope.target0);
            scope.object.position.copy(scope.position0);
            scope.object.zoom = scope.zoom0;
            scope.object.updateProjectionMatrix();
            scope.dispatchEvent($bdd53cbbc361ae77$var$_changeEvent);
            scope.update();
            state = STATE.NONE;
        };
        // this method is exposed, but perhaps it would be better if we can make it private...
        this.update = function() {
            const offset = new (0, $8TfIJ.Vector3)();
            // so camera.up is the orbit axis
            const quat = new (0, $8TfIJ.Quaternion)().setFromUnitVectors(object.up, new (0, $8TfIJ.Vector3)(0, 1, 0));
            const quatInverse = quat.clone().invert();
            const lastPosition = new (0, $8TfIJ.Vector3)();
            const lastQuaternion = new (0, $8TfIJ.Quaternion)();
            const twoPI = 2 * Math.PI;
            return function update() {
                const position = scope.object.position;
                offset.copy(position).sub(scope.target);
                // rotate offset to "y-axis-is-up" space
                offset.applyQuaternion(quat);
                // angle from z-axis around y-axis
                spherical.setFromVector3(offset);
                if (scope.autoRotate && state === STATE.NONE) rotateLeft(getAutoRotationAngle());
                if (scope.enableDamping) {
                    spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                    spherical.phi += sphericalDelta.phi * scope.dampingFactor;
                } else {
                    spherical.theta += sphericalDelta.theta;
                    spherical.phi += sphericalDelta.phi;
                }
                // restrict theta to be between desired limits
                let min = scope.minAzimuthAngle;
                let max = scope.maxAzimuthAngle;
                if (isFinite(min) && isFinite(max)) {
                    if (min < -Math.PI) min += twoPI;
                    else if (min > Math.PI) min -= twoPI;
                    if (max < -Math.PI) max += twoPI;
                    else if (max > Math.PI) max -= twoPI;
                    if (min <= max) spherical.theta = Math.max(min, Math.min(max, spherical.theta));
                    else spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
                }
                // restrict phi to be between desired limits
                spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
                spherical.makeSafe();
                spherical.radius *= scale;
                // restrict radius to be between desired limits
                spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));
                // move target to panned location
                if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
                else scope.target.add(panOffset);
                offset.setFromSpherical(spherical);
                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);
                position.copy(scope.target).add(offset);
                scope.object.lookAt(scope.target);
                if (scope.enableDamping === true) {
                    sphericalDelta.theta *= 1 - scope.dampingFactor;
                    sphericalDelta.phi *= 1 - scope.dampingFactor;
                    panOffset.multiplyScalar(1 - scope.dampingFactor);
                } else {
                    sphericalDelta.set(0, 0, 0);
                    panOffset.set(0, 0, 0);
                }
                scale = 1;
                // update condition is:
                // min(camera displacement, camera rotation in radians)^2 > EPS
                // using small-angle approximation cos(x/2) = 1 - x^2 / 8
                if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                    scope.dispatchEvent($bdd53cbbc361ae77$var$_changeEvent);
                    lastPosition.copy(scope.object.position);
                    lastQuaternion.copy(scope.object.quaternion);
                    zoomChanged = false;
                    return true;
                }
                return false;
            };
        }();
        this.dispose = function() {
            scope.domElement.removeEventListener('contextmenu', onContextMenu);
            scope.domElement.removeEventListener('pointerdown', onPointerDown);
            scope.domElement.removeEventListener('wheel', onMouseWheel);
            scope.domElement.removeEventListener('touchstart', onTouchStart);
            scope.domElement.removeEventListener('touchend', onTouchEnd);
            scope.domElement.removeEventListener('touchmove', onTouchMove);
            scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove);
            scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            if (scope._domElementKeyEvents !== null) scope._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
        //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
        };
        //
        // internals
        //
        const scope = this;
        const STATE = {
            NONE: -1,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2,
            TOUCH_ROTATE: 3,
            TOUCH_PAN: 4,
            TOUCH_DOLLY_PAN: 5,
            TOUCH_DOLLY_ROTATE: 6
        };
        let state = STATE.NONE;
        const EPS = 0.000001;
        // current position in spherical coordinates
        const spherical = new (0, $8TfIJ.Spherical)();
        const sphericalDelta = new (0, $8TfIJ.Spherical)();
        let scale = 1;
        const panOffset = new (0, $8TfIJ.Vector3)();
        let zoomChanged = false;
        const rotateStart = new (0, $8TfIJ.Vector2)();
        const rotateEnd = new (0, $8TfIJ.Vector2)();
        const rotateDelta = new (0, $8TfIJ.Vector2)();
        const panStart = new (0, $8TfIJ.Vector2)();
        const panEnd = new (0, $8TfIJ.Vector2)();
        const panDelta = new (0, $8TfIJ.Vector2)();
        const dollyStart = new (0, $8TfIJ.Vector2)();
        const dollyEnd = new (0, $8TfIJ.Vector2)();
        const dollyDelta = new (0, $8TfIJ.Vector2)();
        function getAutoRotationAngle() {
            return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
        }
        function getZoomScale() {
            return Math.pow(0.95, scope.zoomSpeed);
        }
        function rotateLeft(angle) {
            sphericalDelta.theta -= angle;
        }
        function rotateUp(angle) {
            sphericalDelta.phi -= angle;
        }
        const panLeft = function() {
            const v = new (0, $8TfIJ.Vector3)();
            return function panLeft(distance, objectMatrix) {
                v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
                v.multiplyScalar(-distance);
                panOffset.add(v);
            };
        }();
        const panUp = function() {
            const v = new (0, $8TfIJ.Vector3)();
            return function panUp(distance, objectMatrix) {
                if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
                else {
                    v.setFromMatrixColumn(objectMatrix, 0);
                    v.crossVectors(scope.object.up, v);
                }
                v.multiplyScalar(distance);
                panOffset.add(v);
            };
        }();
        // deltaX and deltaY are in pixels; right and down are positive
        const pan = function() {
            const offset = new (0, $8TfIJ.Vector3)();
            return function pan(deltaX, deltaY) {
                const element = scope.domElement;
                if (scope.object.isPerspectiveCamera) {
                    // perspective
                    const position = scope.object.position;
                    offset.copy(position).sub(scope.target);
                    let targetDistance = offset.length();
                    // half of the fov is center to top of screen
                    targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
                    // we use only clientHeight here so aspect ratio does not distort speed
                    panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                    panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
                } else if (scope.object.isOrthographicCamera) {
                    // orthographic
                    panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                    panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
                } else {
                    // camera neither orthographic nor perspective
                    console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
                    scope.enablePan = false;
                }
            };
        }();
        function dollyOut(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale /= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
                scope.enableZoom = false;
            }
        }
        function dollyIn(dollyScale) {
            if (scope.object.isPerspectiveCamera) scale *= dollyScale;
            else if (scope.object.isOrthographicCamera) {
                scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
                scope.object.updateProjectionMatrix();
                zoomChanged = true;
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
                scope.enableZoom = false;
            }
        }
        //
        // event callbacks - update the object state
        //
        function handleMouseDownRotate(event) {
            rotateStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownDolly(event) {
            dollyStart.set(event.clientX, event.clientY);
        }
        function handleMouseDownPan(event) {
            panStart.set(event.clientX, event.clientY);
        }
        function handleMouseMoveRotate(event) {
            rotateEnd.set(event.clientX, event.clientY);
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
            scope.update();
        }
        function handleMouseMoveDolly(event) {
            dollyEnd.set(event.clientX, event.clientY);
            dollyDelta.subVectors(dollyEnd, dollyStart);
            if (dollyDelta.y > 0) dollyOut(getZoomScale());
            else if (dollyDelta.y < 0) dollyIn(getZoomScale());
            dollyStart.copy(dollyEnd);
            scope.update();
        }
        function handleMouseMovePan(event) {
            panEnd.set(event.clientX, event.clientY);
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
            scope.update();
        }
        function handleMouseUp() {
        // no-op
        }
        function handleMouseWheel(event) {
            if (event.deltaY < 0) dollyIn(getZoomScale());
            else if (event.deltaY > 0) dollyOut(getZoomScale());
            scope.update();
        }
        function handleKeyDown(event) {
            let needsUpdate = false;
            switch(event.code){
                case scope.keys.UP:
                    pan(0, scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.BOTTOM:
                    pan(0, -scope.keyPanSpeed);
                    needsUpdate = true;
                    break;
                case scope.keys.LEFT:
                    pan(scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
                case scope.keys.RIGHT:
                    pan(-scope.keyPanSpeed, 0);
                    needsUpdate = true;
                    break;
            }
            if (needsUpdate) {
                // prevent the browser from scrolling on cursor keys
                event.preventDefault();
                scope.update();
            }
        }
        function handleTouchStartRotate(event) {
            if (event.touches.length == 1) rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
            else {
                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
                rotateStart.set(x, y);
            }
        }
        function handleTouchStartPan(event) {
            if (event.touches.length == 1) panStart.set(event.touches[0].pageX, event.touches[0].pageY);
            else {
                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
                panStart.set(x, y);
            }
        }
        function handleTouchStartDolly(event) {
            const dx = event.touches[0].pageX - event.touches[1].pageX;
            const dy = event.touches[0].pageY - event.touches[1].pageY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyStart.set(0, distance);
        }
        function handleTouchStartDollyPan(event) {
            if (scope.enableZoom) handleTouchStartDolly(event);
            if (scope.enablePan) handleTouchStartPan(event);
        }
        function handleTouchStartDollyRotate(event) {
            if (scope.enableZoom) handleTouchStartDolly(event);
            if (scope.enableRotate) handleTouchStartRotate(event);
        }
        function handleTouchMoveRotate(event) {
            if (event.touches.length == 1) rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
            else {
                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
                rotateEnd.set(x, y);
            }
            rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
            const element = scope.domElement;
            rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
            rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
            rotateStart.copy(rotateEnd);
        }
        function handleTouchMovePan(event) {
            if (event.touches.length == 1) panEnd.set(event.touches[0].pageX, event.touches[0].pageY);
            else {
                const x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
                const y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
                panEnd.set(x, y);
            }
            panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
            pan(panDelta.x, panDelta.y);
            panStart.copy(panEnd);
        }
        function handleTouchMoveDolly(event) {
            const dx = event.touches[0].pageX - event.touches[1].pageX;
            const dy = event.touches[0].pageY - event.touches[1].pageY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            dollyEnd.set(0, distance);
            dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
            dollyOut(dollyDelta.y);
            dollyStart.copy(dollyEnd);
        }
        function handleTouchMoveDollyPan(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enablePan) handleTouchMovePan(event);
        }
        function handleTouchMoveDollyRotate(event) {
            if (scope.enableZoom) handleTouchMoveDolly(event);
            if (scope.enableRotate) handleTouchMoveRotate(event);
        }
        function handleTouchEnd() {
        // no-op
        }
        //
        // event handlers - FSM: listen for events and reset state
        //
        function onPointerDown(event) {
            if (scope.enabled === false) return;
            switch(event.pointerType){
                case 'mouse':
                case 'pen':
                    onMouseDown(event);
                    break;
            }
        }
        function onPointerMove(event) {
            if (scope.enabled === false) return;
            switch(event.pointerType){
                case 'mouse':
                case 'pen':
                    onMouseMove(event);
                    break;
            }
        }
        function onPointerUp(event) {
            switch(event.pointerType){
                case 'mouse':
                case 'pen':
                    onMouseUp(event);
                    break;
            }
        }
        function onMouseDown(event) {
            // Prevent the browser from scrolling.
            event.preventDefault();
            // Manually set the focus since calling preventDefault above
            // prevents the browser from setting it automatically.
            scope.domElement.focus ? scope.domElement.focus() : window.focus();
            let mouseAction;
            switch(event.button){
                case 0:
                    mouseAction = scope.mouseButtons.LEFT;
                    break;
                case 1:
                    mouseAction = scope.mouseButtons.MIDDLE;
                    break;
                case 2:
                    mouseAction = scope.mouseButtons.RIGHT;
                    break;
                default:
                    mouseAction = -1;
            }
            switch(mouseAction){
                case (0, $8TfIJ.MOUSE).DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseDownDolly(event);
                    state = STATE.DOLLY;
                    break;
                case (0, $8TfIJ.MOUSE).ROTATE:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    } else {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    }
                    break;
                case (0, $8TfIJ.MOUSE).PAN:
                    if (event.ctrlKey || event.metaKey || event.shiftKey) {
                        if (scope.enableRotate === false) return;
                        handleMouseDownRotate(event);
                        state = STATE.ROTATE;
                    } else {
                        if (scope.enablePan === false) return;
                        handleMouseDownPan(event);
                        state = STATE.PAN;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) {
                scope.domElement.ownerDocument.addEventListener('pointermove', onPointerMove);
                scope.domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
                scope.dispatchEvent($bdd53cbbc361ae77$var$_startEvent);
            }
        }
        function onMouseMove(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
            switch(state){
                case STATE.ROTATE:
                    if (scope.enableRotate === false) return;
                    handleMouseMoveRotate(event);
                    break;
                case STATE.DOLLY:
                    if (scope.enableZoom === false) return;
                    handleMouseMoveDolly(event);
                    break;
                case STATE.PAN:
                    if (scope.enablePan === false) return;
                    handleMouseMovePan(event);
                    break;
            }
        }
        function onMouseUp(event) {
            scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove);
            scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
            if (scope.enabled === false) return;
            handleMouseUp(event);
            scope.dispatchEvent($bdd53cbbc361ae77$var$_endEvent);
            state = STATE.NONE;
        }
        function onMouseWheel(event) {
            if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE && state !== STATE.ROTATE) return;
            event.preventDefault();
            scope.dispatchEvent($bdd53cbbc361ae77$var$_startEvent);
            handleMouseWheel(event);
            scope.dispatchEvent($bdd53cbbc361ae77$var$_endEvent);
        }
        function onKeyDown(event) {
            if (scope.enabled === false || scope.enablePan === false) return;
            handleKeyDown(event);
        }
        function onTouchStart(event) {
            if (scope.enabled === false) return;
            event.preventDefault(); // prevent scrolling
            switch(event.touches.length){
                case 1:
                    switch(scope.touches.ONE){
                        case (0, $8TfIJ.TOUCH).ROTATE:
                            if (scope.enableRotate === false) return;
                            handleTouchStartRotate(event);
                            state = STATE.TOUCH_ROTATE;
                            break;
                        case (0, $8TfIJ.TOUCH).PAN:
                            if (scope.enablePan === false) return;
                            handleTouchStartPan(event);
                            state = STATE.TOUCH_PAN;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                case 2:
                    switch(scope.touches.TWO){
                        case (0, $8TfIJ.TOUCH).DOLLY_PAN:
                            if (scope.enableZoom === false && scope.enablePan === false) return;
                            handleTouchStartDollyPan(event);
                            state = STATE.TOUCH_DOLLY_PAN;
                            break;
                        case (0, $8TfIJ.TOUCH).DOLLY_ROTATE:
                            if (scope.enableZoom === false && scope.enableRotate === false) return;
                            handleTouchStartDollyRotate(event);
                            state = STATE.TOUCH_DOLLY_ROTATE;
                            break;
                        default:
                            state = STATE.NONE;
                    }
                    break;
                default:
                    state = STATE.NONE;
            }
            if (state !== STATE.NONE) scope.dispatchEvent($bdd53cbbc361ae77$var$_startEvent);
        }
        function onTouchMove(event) {
            if (scope.enabled === false) return;
            event.preventDefault(); // prevent scrolling
            switch(state){
                case STATE.TOUCH_ROTATE:
                    if (scope.enableRotate === false) return;
                    handleTouchMoveRotate(event);
                    scope.update();
                    break;
                case STATE.TOUCH_PAN:
                    if (scope.enablePan === false) return;
                    handleTouchMovePan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_PAN:
                    if (scope.enableZoom === false && scope.enablePan === false) return;
                    handleTouchMoveDollyPan(event);
                    scope.update();
                    break;
                case STATE.TOUCH_DOLLY_ROTATE:
                    if (scope.enableZoom === false && scope.enableRotate === false) return;
                    handleTouchMoveDollyRotate(event);
                    scope.update();
                    break;
                default:
                    state = STATE.NONE;
            }
        }
        function onTouchEnd(event) {
            if (scope.enabled === false) return;
            handleTouchEnd(event);
            scope.dispatchEvent($bdd53cbbc361ae77$var$_endEvent);
            state = STATE.NONE;
        }
        function onContextMenu(event) {
            if (scope.enabled === false) return;
            event.preventDefault();
        }
        //
        scope.domElement.addEventListener('contextmenu', onContextMenu);
        scope.domElement.addEventListener('pointerdown', onPointerDown);
        scope.domElement.addEventListener('wheel', onMouseWheel, {
            passive: false
        });
        scope.domElement.addEventListener('touchstart', onTouchStart, {
            passive: false
        });
        scope.domElement.addEventListener('touchend', onTouchEnd);
        scope.domElement.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
        // force an update at start
        this.update();
    }
}
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move
class $bdd53cbbc361ae77$export$7628ccdac312035f extends $bdd53cbbc361ae77$export$8ff7788029dfdf52 {
    constructor(object, domElement){
        super(object, domElement);
        this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up
        this.mouseButtons.LEFT = (0, $8TfIJ.MOUSE).PAN;
        this.mouseButtons.RIGHT = (0, $8TfIJ.MOUSE).ROTATE;
        this.touches.ONE = (0, $8TfIJ.TOUCH).PAN;
        this.touches.TWO = (0, $8TfIJ.TOUCH).DOLLY_ROTATE;
    }
}

});

parcelRegister("3f0bX", function(module, exports) {

$parcel$export(module.exports, "XacroLoader", function () { return $25c2ebea0714e0aa$export$20d4cdea3605edba; });

var $hn502 = parcelRequire("hn502");

var $365KJ = parcelRequire("365KJ");
class $25c2ebea0714e0aa$export$20d4cdea3605edba extends (0, $365KJ.XacroParser) {
    load(url, onComplete, onError) {
        const workingPath = (0, $hn502.getUrlBase)(url);
        if (this.workingPath === '') this.workingPath = workingPath;
        this.getFileContents(url).then((text)=>{
            this.parse(text, onComplete, onError);
        }).catch((e)=>{
            if (onError) onError(e);
        });
    }
    parse(data, onComplete, onError) {
        super.parse(data).then(onComplete).catch((e)=>{
            if (onError) onError(e);
        });
    }
    getFileContents(path) {
        return fetch(path, this.fetchOptions).then((res)=>{
            if (res.ok) return res.text();
            else throw new Error(`XacroLoader: Failed to load url '${path}' with error code ${res.status} : ${res.statusText}.`);
        });
    }
    constructor(){
        super();
        this.fetchOptions = {};
    }
}

});
parcelRegister("hn502", function(module, exports) {

$parcel$export(module.exports, "getUrlBase", function () { return $ca5876776360ee32$export$808f821920713542; });
$parcel$export(module.exports, "getElementsWithName", function () { return $ca5876776360ee32$export$d4e3728d787f4318; });
$parcel$export(module.exports, "deepClone", function () { return $ca5876776360ee32$export$b7d58db314e0ac27; });
$parcel$export(module.exports, "removeEndCommentsFromArray", function () { return $ca5876776360ee32$export$9ac9d97bb14e572; });
$parcel$export(module.exports, "isOperator", function () { return $ca5876776360ee32$export$4e40859592ee7ac2; });
$parcel$export(module.exports, "isString", function () { return $ca5876776360ee32$export$844ec244b1367d54; });
$parcel$export(module.exports, "isNumber", function () { return $ca5876776360ee32$export$7e4aa119212bc614; });
$parcel$export(module.exports, "tokenize", function () { return $ca5876776360ee32$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "normalizeExpression", function () { return $ca5876776360ee32$export$ea098e0ad93a8b80; });
$parcel$export(module.exports, "PARENT_SCOPE", function () { return $ca5876776360ee32$export$f3c94b0efd66345b; });
$parcel$export(module.exports, "mergePropertySets", function () { return $ca5876776360ee32$export$2c0d50a82a0126d6; });
$parcel$export(module.exports, "createNewPropertyScope", function () { return $ca5876776360ee32$export$4183f2c8c900e548; });
function $ca5876776360ee32$export$808f821920713542(url) {
    const tokens = url.split(/[\\/]/g);
    tokens.pop();
    if (tokens.length === 0) return './';
    else return tokens.join('/') + '/';
}
function $ca5876776360ee32$export$d4e3728d787f4318(node, name, res = []) {
    if (node.tagName === name) res.push(node);
    for(let i = 0, l = node.children.length; i < l; i++){
        const child = node.children[i];
        $ca5876776360ee32$export$d4e3728d787f4318(child, name, res);
    }
    return res;
}
function $ca5876776360ee32$export$b7d58db314e0ac27(node, stripPropsMacros) {
    const cloned = node.cloneNode();
    const childNodes = node.childNodes;
    for(let i = 0, l = childNodes.length; i < l; i++){
        const child = childNodes[i];
        const tagName = child.tagName;
        if (!stripPropsMacros || tagName !== 'xacro:property' && tagName !== 'xacro:macro') cloned.appendChild($ca5876776360ee32$export$b7d58db314e0ac27(child, stripPropsMacros));
    }
    return cloned;
}
function $ca5876776360ee32$export$9ac9d97bb14e572(arr) {
    while(arr.length > 0){
        const el = arr[arr.length - 1];
        if (el.nodeType !== el.ELEMENT_NODE) arr.pop();
        else break;
    }
}
function $ca5876776360ee32$export$4e40859592ee7ac2(str) {
    const regexp = /^[()/*+\-%|&=[\]]+$/;
    return regexp.test(str);
}
function $ca5876776360ee32$export$844ec244b1367d54(str) {
    const regexp = /^(('[^']*?')|("[^"]*?")|(`[^`]*?`))$/;
    return regexp.test(str);
}
function $ca5876776360ee32$export$7e4aa119212bc614(str) {
    return !isNaN(Number(str)) && !isNaN(parseFloat(str));
}
function $ca5876776360ee32$export$660b2ee2d4fb4eff(str) {
    // split text within quotes (', ", `) or operators
    const regexp = /(('[^']*?')|("[^"]*?")|(`[^`]*?`)|([()/*+\-%|!&=]+?))/g;
    return str.replace(regexp, (m)=>` ${m} `).trim().split(/\s+/g);
}
function $ca5876776360ee32$export$ea098e0ad93a8b80(str) {
    // Remove any instances of "--" or "++" that might occur from negating a negative number
    // by adding a space that are not in a string.
    return str.replace(/[-+]{2,}/, (val)=>{
        let positive = true;
        for(let i = 0, l = val.length; i < l; i++){
            const operator = val[i];
            if (operator === '-') positive = !positive;
        }
        return positive ? '+' : '-';
    });
}
const $ca5876776360ee32$export$f3c94b0efd66345b = Symbol('parent');
function $ca5876776360ee32$export$2c0d50a82a0126d6(...args) {
    const res = {};
    for(let i = 0, l = args.length; i < l; i++){
        const obj = args[i];
        for(const key in obj)res[key] = obj[key];
        if ($ca5876776360ee32$export$f3c94b0efd66345b in obj) res[$ca5876776360ee32$export$f3c94b0efd66345b] = obj[$ca5876776360ee32$export$f3c94b0efd66345b];
    }
    return res;
}
function $ca5876776360ee32$export$4183f2c8c900e548(properties) {
    const res = $ca5876776360ee32$export$2c0d50a82a0126d6(properties);
    res[$ca5876776360ee32$export$f3c94b0efd66345b] = properties;
    return res;
}

});

parcelRegister("365KJ", function(module, exports) {

$parcel$export(module.exports, "XacroParser", function () { return $2416650863e5b50a$export$95de28ea7d6fc1fe; });

var $hn502 = parcelRequire("hn502");

var $k3xN0 = parcelRequire("k3xN0");
class $2416650863e5b50a$export$95de28ea7d6fc1fe {
    async getFileContents(path) {
        throw new Error('XacroParser: getFileContents() not implemented.');
    }
    async parse(data) {
        /* Evaluation */ // Evaluate expressions and rospack commands in attribute text
        // TODO: expressions can basically be any python expression
        function evaluateAttribute(str, properties, finalValue = false) {
            // recursively unpack parameters
            function unpackParams(str, properties) {
                // if we're unpacking something that's already a number or object then just return
                if (typeof str !== 'string') return str;
                // process all of the ${} and $() expressions
                const tokens = str.split(/(\$?\$\([^)]+\))|(\$?\${[^}]+})/g).filter((t)=>!!t);
                const res = tokens.map((match)=>{
                    // skip tokens that shouldn't be evaluated
                    if (!/^\$[{(].+/.test(match)) return match;
                    // if we encounter an escaped $$ then return early
                    if (/^\$\$/.test(match)) return match;
                    const isRospackCommand = /^\$\(/.test(match);
                    let contents = match.substring(2, match.length - 1);
                    contents = unpackParams(contents, properties);
                    // replace the dictionary accessor with a function call in place
                    const isDictionaryAccessor = /\[.+\]$/.test(contents);
                    if (isDictionaryAccessor) contents = contents.replace(/([^[\s]+)(\[[^[]+\])+/g, (match, ...args)=>{
                        const splits = match.split(/[[\]]+/g);
                        splits.pop();
                        return `__read_property__( ${splits.join(',')} )`;
                    });
                    if (isRospackCommand) {
                        const command = unpackParams(contents, properties);
                        const tokens = command.split(/\s+/g);
                        const stem = tokens.shift();
                        try {
                            return handleRospackCommand(stem, ...tokens);
                        } catch (e) {
                            throw new Error(`XacroParser: Cannot run rospack command "${contents}".\n` + e.message);
                        }
                    } else {
                        if (stack.includes(contents)) throw new Error(`XacroParser: Cannot evaluate infinitely recursive expression: ${stack.join(' > ')} > ${contents}`);
                        stack.push(contents);
                        const operators = /([()/*+!\-%|&=])+/g;
                        const expr = (0, $hn502.tokenize)(contents).map((t)=>{
                            operators.lastIndex = 0;
                            if ((0, $hn502.isOperator)(t)) return t;
                            if ((0, $hn502.isNumber)(t)) return t;
                            if ((0, $hn502.isString)(t)) return t;
                            if (t in properties) {
                                const arg = unpackParams(properties[t], properties);
                                if (!(0, $hn502.isNumber)(arg) && typeof arg !== 'object') return `"${arg.toString().replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
                                else return arg;
                            } else return t;
                        }).map((t)=>{
                            // add some spaces around non numbers and operators to avoid
                            // inadvertently creating a variable token.
                            operators.lastIndex = 0;
                            if (/^[^0-9.]/.test(t) && !operators.test(t)) return ` ${t} `;
                            else return t;
                        }).join('');
                        stack.pop();
                        if ((0, $hn502.isString)(expr)) return expr.substring(1, expr.length - 1);
                        else if ((0, $hn502.isNumber)(expr)) return expr;
                        else {
                            const cleanExpr = (0, $hn502.normalizeExpression)(expr);
                            return expressionParser.evaluate(cleanExpr, properties);
                        }
                    }
                });
                const trimmedRes = res.filter((t)=>{
                    if (typeof t === 'string') t = t.trim();
                    return t !== '' && t !== null && t !== undefined;
                });
                if (trimmedRes.length === 1) return trimmedRes[0];
                else return res.join('');
            }
            const stack = [];
            const allProps = (0, $hn502.mergePropertySets)(globalProperties, properties);
            try {
                // fix the escaped dollar signs only at the end to prevent double evaluation and only
                // if the value is not an intermediate value like a computed property.
                let result = unpackParams(str, allProps);
                if (finalValue && typeof result === 'string') result = result.replace(/\${2}([({])/g, (val, brace)=>`$${brace}`);
                return result;
            } catch (e) {
                throw new Error(`XacroParser: Failed to process expression "${str}". \n` + e.message);
            }
        }
        // Evaluate the given node as a macro
        async function evaluateMacro(node, properties, macros, resultsList) {
            // Find the macro
            const macroName = node.tagName.replace(/^xacro:/, '');
            const macro = macros[macroName];
            if (!macro) throw new Error(`XacroParser: Cannot find macro "${macroName}"`);
            // Copy the properties and macros so we can modify them with
            // macro input fields and local macro definitions.
            const ogProperties = properties;
            const ogMacros = macros;
            properties = (0, $hn502.createNewPropertyScope)(properties);
            macros = (0, $hn502.mergePropertySets)(macros);
            // Modify the properties with macro param inputs
            let children = [];
            for (const c of node.children)await processNode(c, ogProperties, ogMacros, children);
            children = children.filter((c)=>c.nodeType === c.ELEMENT_NODE);
            let blockCount = 0;
            for(const p in macro.params){
                const param = macro.params[p];
                if (node.hasAttribute(p)) properties[p] = evaluateAttribute(node.getAttribute(p), ogProperties);
                else if (param.type === 'BLOCK') {
                    properties[p] = [
                        children[blockCount]
                    ];
                    blockCount++;
                } else if (param.type === 'MULTI_BLOCK') properties[p] = [
                    ...children.filter((c)=>c.tagName === p)[0].childNodes
                ];
                else properties[p] = evaluateAttribute(macro.params[p].def, ogProperties);
            }
            // Expand the macro
            const macroChildren = [
                ...macro.node.childNodes
            ];
            for (const c of macroChildren){
                const nodes = [];
                await processNode(c, properties, macros, nodes);
                resultsList.push(...nodes);
            }
        }
        /* Parsing */ // Conver the params into an object representation
        function parseMacroParam(param) {
            const obj = {};
            // Save the type of parameter
            // - two asterisks means an element expands input multiple
            // - one asterisk means copy the first elemnt
            // - no asterisks means value param
            if (/^\*\*/.test(param)) obj.type = 'MULTI_BLOCK';
            else if (/^\*/.test(param)) obj.type = 'BLOCK';
            else obj.type = 'PARAM';
            // strip the asterisks
            param = param.replace(/^\*{1,2}/g, '');
            // Check if a default value is provided (= or := syntax)
            if (/:?=/.test(param)) {
                const [name, def] = param.split(/:?=/);
                // TODO: Support caret and default syntax
                if (/^\^/.test(def) || /\|/.test(def)) throw new Error(`XacroParser: ROS Jade pass-through notation not supported in macro defaults: ${def}`);
                obj.name = name;
                if (def.startsWith('\'') && def.endsWith('\'')) // strip quotes from the default value if it happens to be a string like so:
                // a:='0.0 1.0 2.0'
                obj.def = def.substring(1, def.length - 1);
                else obj.def = def;
            } else {
                obj.name = param;
                obj.def = null;
            }
            return obj;
        }
        // Parse a xacro:macro tag
        function parseMacro(node) {
            // get attributes
            const name = node.getAttribute('name').replace(/^xacro:/, '');
            const params = node.getAttribute('params');
            // parse params
            const inputMap = {};
            if (params) {
                // find param definitions including string values like a:='0.0 1.0 2.0'
                const inputs = params.trim().match(/[^\s']+('[^']*')?/g).map((s)=>parseMacroParam(s));
                inputs.forEach((inp)=>{
                    inputMap[inp.name] = inp;
                });
            }
            return {
                name: name,
                node: (0, $hn502.deepClone)(node, false),
                params: inputMap
            };
        }
        // Recursively process and expand a node
        async function processNode(node, properties, macros, resultsList = []) {
            if (node.nodeType === node.TEXT_NODE) {
                const res = node.cloneNode();
                res.textContent = evaluateAttribute(res.textContent, properties, true);
                resultsList.push(res);
                return;
            } else if (node.nodeType !== node.ELEMENT_NODE) {
                resultsList.push(node.cloneNode());
                return;
            }
            let tagName = node.tagName.toLowerCase();
            if (!requirePrefix) switch(tagName){
                case 'arg':
                case 'property':
                case 'macro':
                case 'insert_block':
                case 'if':
                case 'unless':
                case 'include':
                case 'element':
                case 'attribute':
                    tagName = `xacro:${tagName}`;
                    break;
                default:
                    if (tagName in macros) tagName = `xacro:${tagName}`;
                    break;
            }
            switch(tagName){
                case 'xacro:property':
                    {
                        (0, $hn502.removeEndCommentsFromArray)(resultsList);
                        const name = node.getAttribute('name');
                        let value;
                        if (node.hasAttribute('value')) value = node.getAttribute('value');
                        else if (node.hasAttribute('default')) value = node.getAttribute('default');
                        else {
                            const childNodes = [
                                ...node.childNodes
                            ];
                            value = [];
                            for (const c of childNodes)value.push((0, $hn502.deepClone)(c, false));
                        }
                        let scope = 'global';
                        if (localProperties) scope = node.getAttribute('scope') || 'local';
                        // Emulated behavior here
                        // https://github.com/ros/xacro/blob/melodic-devel/src/xacro/__init__.py#L565
                        if (scope !== 'local') value = evaluateAttribute(value, properties);
                        if (scope === 'global') globalProperties[name] = value;
                        else if (scope === 'parent') properties[0, $hn502.PARENT_SCOPE][name] = value;
                        else properties[name] = value;
                        break;
                    }
                case 'xacro:macro':
                    {
                        (0, $hn502.removeEndCommentsFromArray)(resultsList);
                        const macro = parseMacro(node);
                        macros[macro.name] = macro;
                        break;
                    }
                case 'xacro:insert_block':
                    {
                        (0, $hn502.removeEndCommentsFromArray)(resultsList);
                        const name = node.getAttribute('name');
                        const nodes = properties[name];
                        for (const c of nodes)await processNode(c, properties, macros, resultsList);
                        return;
                    }
                case 'xacro:if':
                case 'xacro:unless':
                    {
                        (0, $hn502.removeEndCommentsFromArray)(resultsList);
                        const value = evaluateAttribute(node.getAttribute('value'), properties, true);
                        let bool = null;
                        if (!isNaN(parseFloat(value))) bool = !!parseFloat(value);
                        else if (value === 'true' || value === 'false') bool = value === 'true';
                        else bool = value;
                        if (tagName === 'xacro:unless') bool = !bool;
                        if (bool) {
                            const childNodes = [
                                ...node.childNodes
                            ];
                            for (const c of childNodes)await processNode(c, properties, macros, resultsList);
                        }
                        return;
                    }
                case 'xacro:include':
                    {
                        (0, $hn502.removeEndCommentsFromArray)(resultsList);
                        if (node.hasAttribute('ns')) throw new Error('XacroParser: xacro:include name spaces not supported.');
                        const filename = evaluateAttribute(node.getAttribute('filename'), properties, true);
                        const isAbsolute = /^[/\\]/.test(filename) || /^[a-zA-Z]+:[/\\]/.test(filename);
                        const filePath = isAbsolute ? filename : currWorkingPath + filename;
                        const prevWorkingPath = currWorkingPath;
                        currWorkingPath = (0, $hn502.getUrlBase)(filePath);
                        const includeContent = await loadInclude(filePath);
                        const childNodes = [
                            ...includeContent.children[0].childNodes
                        ];
                        for (const c of childNodes)await processNode(c, properties, macros, resultsList);
                        currWorkingPath = prevWorkingPath;
                        return;
                    }
                case 'xacro:arg':
                    {
                        const name = node.getAttribute('name');
                        argumentDefaults[name] = evaluateAttribute(node.getAttribute('default'), properties, true);
                        return;
                    }
                case 'xacro:attribute':
                case 'xacro:element':
                    throw new Error(`XacroParser: ${tagName} tags not supported.`);
                default:
                    // TODO: check if there's a 'call' attribute here which indicates that
                    // a macro should be invoked?
                    if (/^xacro:/.test(tagName) || tagName in macros) {
                        (0, $hn502.removeEndCommentsFromArray)(resultsList);
                        return evaluateMacro(node, properties, macros, resultsList);
                    } else {
                        const res = node.cloneNode();
                        for(let i = 0, l = res.attributes.length; i < l; i++){
                            const attr = res.attributes[i];
                            const value = evaluateAttribute(attr.value, properties, true);
                            res.setAttribute(attr.name, value);
                        }
                        const childNodes = [
                            ...node.childNodes
                        ];
                        const resultChildren = [];
                        for(let i = 0, l = childNodes.length; i < l; i++)await processNode(childNodes[i], properties, macros, resultChildren);
                        resultChildren.forEach((c)=>res.appendChild(c));
                        resultsList.push(res);
                    }
            }
        }
        // Process all property and macro tags into the objects
        async function gatherPropertiesAndMacros(el, properties, macros) {
            const propertyEl = (0, $hn502.getElementsWithName)(el, 'xacro:property');
            if (!requirePrefix) propertyEl.push(...(0, $hn502.getElementsWithName)(el, 'property'));
            for (const el of propertyEl)await processNode(el, properties, macros);
            const macroEl = (0, $hn502.getElementsWithName)(el, 'xacro:macro');
            if (!requirePrefix) macroEl.push(...(0, $hn502.getElementsWithName)(el, 'macro'));
            for (const el of macroEl)await processNode(el, properties, macros);
        }
        // Process a document node with a new property and macro scope
        async function processXacro(xacro, properties, macros) {
            const res = xacro.cloneNode();
            for(let i = 0, l = xacro.children.length; i < l; i++){
                const child = [];
                await processNode(xacro.children[i], properties, macros, child);
                const root = child[0];
                root.removeAttribute('xmlns:xacro');
                res.appendChild(root);
            }
            return res;
        }
        async function loadInclude(path) {
            try {
                const text = await scope.getFileContents(path);
                return new DOMParser().parseFromString(text, 'text/xml');
            } catch (e) {
                throw new Error(`XacroParser: Could not load included file: ${path}`);
            }
        }
        async function loadIncludes(xacro, workingPath, results = []) {
            const includeEl = (0, $hn502.getElementsWithName)(xacro, 'xacro:include');
            if (!requirePrefix) includeEl.push(...(0, $hn502.getElementsWithName)(xacro, 'include'));
            const promises = includeEl.map((el)=>{
                // TODO: Handle namespaces on the include.
                if (el.hasAttribute('ns')) throw new Error('XacroParser: xacro:include name spaces not supported.');
                const filename = el.getAttribute('filename');
                const namespace = el.getAttribute('ns') || null;
                const isAbsolute = /^[/\\]/.test(filename) || /^[a-zA-Z]+:[/\\]/.test(filename);
                const filePath = isAbsolute ? filename : workingPath + filename;
                const pr = loadInclude(filePath).then((content)=>{
                    results.push({
                        filename: filename,
                        namespace: namespace,
                        content: content
                    });
                    const relPath = (0, $hn502.getUrlBase)(filePath);
                    return loadIncludes(content, relPath, results);
                });
                return pr;
            });
            await Promise.all(promises);
            return results;
        }
        const scope = this;
        const inOrder = this.inOrder;
        // add a file separator to the end of the working path if it's specified
        // and doesn't have one.
        const workingPath = this.workingPath + (this.workingPath && !/[\\/]$/.test(this.workingPath) ? '/' : '');
        const requirePrefix = this.requirePrefix;
        const rospackCommands = this.rospackCommands;
        const globalMacros = {};
        const includeMap = {};
        const argumentDefaults = {};
        const globalProperties = {
            True: 1,
            False: 0
        };
        globalProperties[0, $hn502.PARENT_SCOPE] = globalProperties;
        const handleRospackCommand = (stem, ...args)=>{
            let result;
            if (rospackCommands instanceof Function) result = rospackCommands(stem, ...args);
            if (result == null && rospackCommands != null && typeof rospackCommands[stem] === 'function') result = rospackCommands[stem](...args);
            if (result == null && stem === 'arg') {
                const arg = args[0];
                if (arg === undefined) throw new Error(`XacroParser: $(arg) must specify a variable name`);
                result = this.arguments[arg];
                if (result == null) result = argumentDefaults[arg];
                if (result == null) throw new Error(`XacroParser: Undefined substitution argument ${arg}`);
            }
            return result;
        };
        const expressionParser = this.expressionParser;
        let localProperties = this.localProperties;
        let currWorkingPath = workingPath;
        let content = new DOMParser().parseFromString(data, 'text/xml');
        if (localProperties && !inOrder) {
            console.warn('XacroParser: Implicitly setting "localProperties" option to false because "inOrder" is false.');
            localProperties = false;
        }
        let inOrderPromise = null;
        if (!inOrder) inOrderPromise = async function() {
            await gatherPropertiesAndMacros(content, globalProperties, globalMacros);
            content = (0, $hn502.deepClone)(content, true);
            return loadIncludes(content, workingPath).then((arr)=>{
                arr.forEach((inc)=>{
                    // TODO: handle namespaces here when rolling up properties and macros
                    gatherPropertiesAndMacros(inc.content, globalProperties, globalMacros);
                    inc.content = (0, $hn502.deepClone)(inc.content, true);
                    includeMap[inc.filename] = inc.content;
                });
            });
        }();
        else inOrderPromise = Promise.resolve();
        await inOrderPromise;
        return processXacro(content, globalProperties, globalMacros);
    }
    constructor(){
        this.inOrder = true;
        this.requirePrefix = true;
        this.localProperties = true;
        this.rospackCommands = {};
        this.arguments = {};
        this.expressionParser = new (0, $k3xN0.ExpressionParser)();
        this.workingPath = '';
    }
}

});
parcelRegister("k3xN0", function(module, exports) {

$parcel$export(module.exports, "ExpressionParser", function () { return $e99e4c5277fe4da5$export$e698c7418fab884c; });

var $4Z4w2 = parcelRequire("4Z4w2");

var $kfWQJ = parcelRequire("kfWQJ");

var $hn502 = parcelRequire("hn502");

var $7WATq = parcelRequire("7WATq");
class $e99e4c5277fe4da5$export$e698c7418fab884c extends (0, $7WATq.Parser) {
    constructor(...args){
        super(...args);
        const parser = this;
        parser.unaryOps = {
            '-': parser.unaryOps['-'],
            '+': parser.unaryOps['+'],
            '!': parser.unaryOps['not'],
            'not': parser.unaryOps['not']
        };
        parser.functions = {
            sin: Math.sin,
            cos: Math.cos,
            tan: Math.tan,
            asin: Math.asin,
            acos: Math.acos,
            atan: Math.atan,
            log: Math.log,
            atan2: Math.atan2,
            pow: Math.pow,
            radians: (degrees)=>{
                return degrees * (Math.PI / 180);
            },
            degrees: (radians)=>{
                return radians * (180 / Math.PI);
            },
            __read_property__: (obj, ...args)=>{
                let curr = obj;
                for(let i = 0, l = args.length; i < l; i++)curr = curr[args[i]];
                return curr;
            }
        };
        parser.binaryOps = (0, $kfWQJ._)((0, $4Z4w2._)({}, parser.binaryOps), {
            '+': (a, b)=>{
                if ((0, $hn502.isNumber)(a)) a = Number(a);
                if ((0, $hn502.isNumber)(b)) b = Number(b);
                return a + b;
            },
            'in': (a, b)=>{
                if (Array.isArray(b)) return b.includes(a);
                else if (typeof b === 'string') return b.includes(a);
                else return a in b;
            },
            '||': (a, b)=>Boolean(a || b)
        });
        parser.consts = (0, $kfWQJ._)((0, $4Z4w2._)({}, parser.consts), {
            pi: Math.PI,
            tau: 2 * Math.PI,
            e: Math.E
        });
    }
}

});
parcelRegister("kfWQJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ebf2dba0517eed29$export$71511d61b312f219; });
function $ebf2dba0517eed29$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ebf2dba0517eed29$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ebf2dba0517eed29$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("7WATq", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $a75d88c86447809c$export$7acfa6ed01010e37; });
var $a75d88c86447809c$var$INUMBER = 'INUMBER';
var $a75d88c86447809c$var$IOP1 = 'IOP1';
var $a75d88c86447809c$var$IOP2 = 'IOP2';
var $a75d88c86447809c$var$IOP3 = 'IOP3';
var $a75d88c86447809c$var$IVAR = 'IVAR';
var $a75d88c86447809c$var$IVARNAME = 'IVARNAME';
var $a75d88c86447809c$var$IFUNCALL = 'IFUNCALL';
var $a75d88c86447809c$var$IFUNDEF = 'IFUNDEF';
var $a75d88c86447809c$var$IEXPR = 'IEXPR';
var $a75d88c86447809c$var$IEXPREVAL = 'IEXPREVAL';
var $a75d88c86447809c$var$IMEMBER = 'IMEMBER';
var $a75d88c86447809c$var$IENDSTATEMENT = 'IENDSTATEMENT';
var $a75d88c86447809c$var$IARRAY = 'IARRAY';
function $a75d88c86447809c$var$Instruction(type, value) {
    this.type = type;
    this.value = value !== undefined && value !== null ? value : 0;
}
$a75d88c86447809c$var$Instruction.prototype.toString = function() {
    switch(this.type){
        case $a75d88c86447809c$var$INUMBER:
        case $a75d88c86447809c$var$IOP1:
        case $a75d88c86447809c$var$IOP2:
        case $a75d88c86447809c$var$IOP3:
        case $a75d88c86447809c$var$IVAR:
        case $a75d88c86447809c$var$IVARNAME:
        case $a75d88c86447809c$var$IENDSTATEMENT:
            return this.value;
        case $a75d88c86447809c$var$IFUNCALL:
            return 'CALL ' + this.value;
        case $a75d88c86447809c$var$IFUNDEF:
            return 'DEF ' + this.value;
        case $a75d88c86447809c$var$IARRAY:
            return 'ARRAY ' + this.value;
        case $a75d88c86447809c$var$IMEMBER:
            return '.' + this.value;
        default:
            return 'Invalid Instruction';
    }
};
function $a75d88c86447809c$var$unaryInstruction(value) {
    return new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IOP1, value);
}
function $a75d88c86447809c$var$binaryInstruction(value) {
    return new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IOP2, value);
}
function $a75d88c86447809c$var$ternaryInstruction(value) {
    return new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IOP3, value);
}
function $a75d88c86447809c$var$simplify(tokens, unaryOps, binaryOps, ternaryOps, values) {
    var nstack = [];
    var newexpression = [];
    var n1, n2, n3;
    var f;
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === $a75d88c86447809c$var$INUMBER || type === $a75d88c86447809c$var$IVARNAME) {
            if (Array.isArray(item.value)) nstack.push.apply(nstack, $a75d88c86447809c$var$simplify(item.value.map(function(x) {
                return new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, x);
            }).concat(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IARRAY, item.value.length)), unaryOps, binaryOps, ternaryOps, values));
            else nstack.push(item);
        } else if (type === $a75d88c86447809c$var$IVAR && Object.hasOwn(values, item.value)) {
            item = new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, values[item.value]);
            nstack.push(item);
        } else if (type === $a75d88c86447809c$var$IOP2 && nstack.length > 1) {
            n2 = nstack.pop();
            n1 = nstack.pop();
            f = binaryOps[item.value];
            item = new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, f(n1.value, n2.value));
            nstack.push(item);
        } else if (type === $a75d88c86447809c$var$IOP3 && nstack.length > 2) {
            n3 = nstack.pop();
            n2 = nstack.pop();
            n1 = nstack.pop();
            if (item.value === '?') nstack.push(n1.value ? n2.value : n3.value);
            else {
                f = ternaryOps[item.value];
                item = new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, f(n1.value, n2.value, n3.value));
                nstack.push(item);
            }
        } else if (type === $a75d88c86447809c$var$IOP1 && nstack.length > 0) {
            n1 = nstack.pop();
            f = unaryOps[item.value];
            item = new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, f(n1.value));
            nstack.push(item);
        } else if (type === $a75d88c86447809c$var$IEXPR) {
            while(nstack.length > 0)newexpression.push(nstack.shift());
            newexpression.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, $a75d88c86447809c$var$simplify(item.value, unaryOps, binaryOps, ternaryOps, values)));
        } else if (type === $a75d88c86447809c$var$IMEMBER && nstack.length > 0) {
            n1 = nstack.pop();
            nstack.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, n1.value[item.value]));
        /* } else if (type === IARRAY && nstack.length >= item.value) {
      var length = item.value;
      while (length-- > 0) {
        newexpression.push(nstack.pop());
      }
      newexpression.push(new Instruction(IARRAY, item.value));
    } */ } else {
            while(nstack.length > 0)newexpression.push(nstack.shift());
            newexpression.push(item);
        }
    }
    while(nstack.length > 0)newexpression.push(nstack.shift());
    return newexpression;
}
function $a75d88c86447809c$var$substitute(tokens, variable, expr) {
    var newexpression = [];
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === $a75d88c86447809c$var$IVAR && item.value === variable) for(var j = 0; j < expr.tokens.length; j++){
            var expritem = expr.tokens[j];
            var replitem;
            if (expritem.type === $a75d88c86447809c$var$IOP1) replitem = $a75d88c86447809c$var$unaryInstruction(expritem.value);
            else if (expritem.type === $a75d88c86447809c$var$IOP2) replitem = $a75d88c86447809c$var$binaryInstruction(expritem.value);
            else if (expritem.type === $a75d88c86447809c$var$IOP3) replitem = $a75d88c86447809c$var$ternaryInstruction(expritem.value);
            else replitem = new $a75d88c86447809c$var$Instruction(expritem.type, expritem.value);
            newexpression.push(replitem);
        }
        else if (type === $a75d88c86447809c$var$IEXPR) newexpression.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, $a75d88c86447809c$var$substitute(item.value, variable, expr)));
        else newexpression.push(item);
    }
    return newexpression;
}
/**
 * Checks if a function reference 'f' is explicitly allowed to be executed.
 * This logic is the core security allowance gate.
 */ function $a75d88c86447809c$var$isAllowedFunc(f, expr, values) {
    // function definition is included in registered functions
    if (Object.values(expr.functions).includes(f)) return true;
    for (const v of Object.values(values))if (typeof v === 'object' && v !== null) {
        for (const subV of Object.values(v))if (subV === f) {
            const SAFE_MATH = Object.freeze({
                abs: Math.abs,
                acos: Math.acos,
                asin: Math.asin,
                atan: Math.atan,
                atan2: Math.atan2,
                ceil: Math.ceil,
                clz32: Math.clz32,
                cos: Math.cos,
                exp: Math.exp,
                floor: Math.floor,
                imul: Math.imul,
                fround: Math.fround,
                f16round: Math.f16round,
                log: Math.log,
                max: Math.max,
                min: Math.min,
                pow: Math.pow,
                random: Math.random,
                round: Math.round,
                sin: Math.sin,
                sqrt: Math.sqrt,
                tan: Math.tan,
                log10: Math.log10,
                log2: Math.log2,
                log1p: Math.log1p,
                expm1: Math.expm1,
                cosh: Math.cosh,
                sinh: Math.sinh,
                tanh: Math.tanh,
                acosh: Math.acosh,
                asinh: Math.asinh,
                atanh: Math.atanh,
                hypot: Math.hypot,
                trunc: Math.trunc,
                sign: Math.sign,
                cbrt: Math.cbrt
            });
            // allow Math functions
            for (var key of Object.getOwnPropertyNames(SAFE_MATH)){
                if (SAFE_MATH[key] === subV) return true;
            }
            // function definition is included in registered functions
            return Object.values(expr.functions).includes(subV);
        }
    }
    return false;
}
function $a75d88c86447809c$var$evaluate(tokens, expr, values) {
    var nstack = [];
    var n1, n2, n3;
    var f, args, argCount;
    if ($a75d88c86447809c$var$isExpressionEvaluator(tokens)) return $a75d88c86447809c$var$resolveExpression(tokens, values);
    var numTokens = tokens.length;
    for(var i = 0; i < numTokens; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === $a75d88c86447809c$var$INUMBER || type === $a75d88c86447809c$var$IVARNAME) nstack.push(item.value);
        else if (type === $a75d88c86447809c$var$IOP2) {
            n2 = nstack.pop();
            n1 = nstack.pop();
            if (item.value === 'and') nstack.push(n1 ? !!$a75d88c86447809c$var$evaluate(n2, expr, values) : false);
            else if (item.value === 'or') nstack.push(n1 ? true : !!$a75d88c86447809c$var$evaluate(n2, expr, values));
            else if (item.value === '=') {
                f = expr.binaryOps[item.value];
                nstack.push(f(n1, $a75d88c86447809c$var$evaluate(n2, expr, values), values));
            } else {
                f = expr.binaryOps[item.value];
                nstack.push(f($a75d88c86447809c$var$resolveExpression(n1, values), $a75d88c86447809c$var$resolveExpression(n2, values)));
            }
        } else if (type === $a75d88c86447809c$var$IOP3) {
            n3 = nstack.pop();
            n2 = nstack.pop();
            n1 = nstack.pop();
            if (item.value === '?') nstack.push($a75d88c86447809c$var$evaluate(n1 ? n2 : n3, expr, values));
            else {
                f = expr.ternaryOps[item.value];
                nstack.push(f($a75d88c86447809c$var$resolveExpression(n1, values), $a75d88c86447809c$var$resolveExpression(n2, values), $a75d88c86447809c$var$resolveExpression(n3, values)));
            }
        } else if (type === $a75d88c86447809c$var$IVAR) {
            if (/^__proto__|prototype|constructor$/.test(item.value)) throw new Error('prototype access detected');
            if (item.value in expr.functions) nstack.push(expr.functions[item.value]);
            else if (item.value in expr.unaryOps && expr.parser.isOperatorEnabled(item.value)) nstack.push(expr.unaryOps[item.value]);
            else {
                var v = values[item.value];
                if (v !== undefined) {
                    if (typeof v === 'function' && !$a75d88c86447809c$var$isAllowedFunc(v, expr, values)) /* function is not registered, not marked safe, and not a member function. BLOCKED. */ throw new Error('Variable references an unallowed function: ' + item.value);
                    nstack.push(v);
                } else throw new Error('undefined variable: ' + item.value);
            }
        } else if (type === $a75d88c86447809c$var$IOP1) {
            n1 = nstack.pop();
            f = expr.unaryOps[item.value];
            nstack.push(f($a75d88c86447809c$var$resolveExpression(n1, values)));
        } else if (type === $a75d88c86447809c$var$IFUNCALL) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift($a75d88c86447809c$var$resolveExpression(nstack.pop(), values));
            f = nstack.pop();
            if (!$a75d88c86447809c$var$isAllowedFunc(f, expr, values)) throw new Error('Is not an allowed function.');
            if (f.apply && f.call) nstack.push(f.apply(undefined, args));
            else throw new Error(f + ' is not a function');
        } else if (type === $a75d88c86447809c$var$IFUNDEF) // Create closure to keep references to arguments and expression
        nstack.push(function() {
            var n2 = nstack.pop();
            var args = [];
            var argCount = item.value;
            while(argCount-- > 0)args.unshift(nstack.pop());
            var n1 = nstack.pop();
            var f = function() {
                var scope = Object.assign({}, values);
                for(var i = 0, len = args.length; i < len; i++)scope[args[i]] = arguments[i];
                return $a75d88c86447809c$var$evaluate(n2, expr, scope);
            };
            expr.functions['lambda_' + expr.functions.__counter++] = f;
            values[n1] = f;
            return f;
        }());
        else if (type === $a75d88c86447809c$var$IEXPR) nstack.push($a75d88c86447809c$var$createExpressionEvaluator(item, expr));
        else if (type === $a75d88c86447809c$var$IEXPREVAL) nstack.push(item);
        else if (type === $a75d88c86447809c$var$IMEMBER) {
            n1 = nstack.pop();
            if (/^__proto__|prototype|constructor$/.test(item.value)) throw new Error('prototype access detected in MEMBER');
            if (typeof n1 === 'object' && typeof n1[item.value] === 'function' && !$a75d88c86447809c$var$isAllowedFunc(n1[item.value], expr, values)) throw new Error('Is not an allowed function in MEMBER.');
            nstack.push(n1[item.value]);
        } else if (type === $a75d88c86447809c$var$IENDSTATEMENT) nstack.pop();
        else if (type === $a75d88c86447809c$var$IARRAY) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            nstack.push(args);
        } else throw new Error('invalid Expression');
    }
    if (nstack.length > 1) throw new Error('invalid Expression (parity)');
    // Explicitly return zero to avoid test issues caused by -0
    return nstack[0] === 0 ? 0 : $a75d88c86447809c$var$resolveExpression(nstack[0], values);
}
function $a75d88c86447809c$var$createExpressionEvaluator(token, expr, values) {
    if ($a75d88c86447809c$var$isExpressionEvaluator(token)) return token;
    return {
        type: $a75d88c86447809c$var$IEXPREVAL,
        value: function(scope) {
            return $a75d88c86447809c$var$evaluate(token.value, expr, scope);
        }
    };
}
function $a75d88c86447809c$var$isExpressionEvaluator(n) {
    return n && n.type === $a75d88c86447809c$var$IEXPREVAL;
}
function $a75d88c86447809c$var$resolveExpression(n, values) {
    return $a75d88c86447809c$var$isExpressionEvaluator(n) ? n.value(values) : n;
}
function $a75d88c86447809c$var$expressionToString(tokens, toJS) {
    var nstack = [];
    var n1, n2, n3;
    var f, args, argCount;
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        var type = item.type;
        if (type === $a75d88c86447809c$var$INUMBER) {
            if (typeof item.value === 'number' && item.value < 0) nstack.push('(' + item.value + ')');
            else if (Array.isArray(item.value)) nstack.push('[' + item.value.map($a75d88c86447809c$var$escapeValue).join(', ') + ']');
            else nstack.push($a75d88c86447809c$var$escapeValue(item.value));
        } else if (type === $a75d88c86447809c$var$IOP2) {
            n2 = nstack.pop();
            n1 = nstack.pop();
            f = item.value;
            if (toJS) {
                if (f === '^') nstack.push('Math.pow(' + n1 + ', ' + n2 + ')');
                else if (f === 'and') nstack.push('(!!' + n1 + ' && !!' + n2 + ')');
                else if (f === 'or') nstack.push('(!!' + n1 + ' || !!' + n2 + ')');
                else if (f === '||') nstack.push('(function(a,b){ return Array.isArray(a) && Array.isArray(b) ? a.concat(b) : String(a) + String(b); }((' + n1 + '),(' + n2 + ')))');
                else if (f === '==') nstack.push('(' + n1 + ' === ' + n2 + ')');
                else if (f === '!=') nstack.push('(' + n1 + ' !== ' + n2 + ')');
                else if (f === '[') nstack.push(n1 + '[(' + n2 + ') | 0]');
                else nstack.push('(' + n1 + ' ' + f + ' ' + n2 + ')');
            } else if (f === '[') nstack.push(n1 + '[' + n2 + ']');
            else nstack.push('(' + n1 + ' ' + f + ' ' + n2 + ')');
        } else if (type === $a75d88c86447809c$var$IOP3) {
            n3 = nstack.pop();
            n2 = nstack.pop();
            n1 = nstack.pop();
            f = item.value;
            if (f === '?') nstack.push('(' + n1 + ' ? ' + n2 + ' : ' + n3 + ')');
            else throw new Error('invalid Expression');
        } else if (type === $a75d88c86447809c$var$IVAR || type === $a75d88c86447809c$var$IVARNAME) nstack.push(item.value);
        else if (type === $a75d88c86447809c$var$IOP1) {
            n1 = nstack.pop();
            f = item.value;
            if (f === '-' || f === '+') nstack.push('(' + f + n1 + ')');
            else if (toJS) {
                if (f === 'not') nstack.push("(!" + n1 + ')');
                else if (f === '!') nstack.push('fac(' + n1 + ')');
                else nstack.push(f + '(' + n1 + ')');
            } else if (f === '!') nstack.push('(' + n1 + '!)');
            else nstack.push('(' + f + ' ' + n1 + ')');
        } else if (type === $a75d88c86447809c$var$IFUNCALL) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            f = nstack.pop();
            nstack.push(f + '(' + args.join(', ') + ')');
        } else if (type === $a75d88c86447809c$var$IFUNDEF) {
            n2 = nstack.pop();
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            n1 = nstack.pop();
            if (toJS) nstack.push('(' + n1 + ' = function(' + args.join(', ') + ') { return ' + n2 + ' })');
            else nstack.push('(' + n1 + '(' + args.join(', ') + ') = ' + n2 + ')');
        } else if (type === $a75d88c86447809c$var$IMEMBER) {
            n1 = nstack.pop();
            nstack.push(n1 + '.' + item.value);
        } else if (type === $a75d88c86447809c$var$IARRAY) {
            argCount = item.value;
            args = [];
            while(argCount-- > 0)args.unshift(nstack.pop());
            nstack.push('[' + args.join(', ') + ']');
        } else if (type === $a75d88c86447809c$var$IEXPR) nstack.push('(' + $a75d88c86447809c$var$expressionToString(item.value, toJS) + ')');
        else if (type === $a75d88c86447809c$var$IENDSTATEMENT) ;
        else throw new Error('invalid Expression');
    }
    if (nstack.length > 1) {
        if (toJS) nstack = [
            nstack.join(',')
        ];
        else nstack = [
            nstack.join(';')
        ];
    }
    return String(nstack[0]);
}
function $a75d88c86447809c$var$escapeValue(v) {
    if (typeof v === 'string') return JSON.stringify(v).replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
    return v;
}
function $a75d88c86447809c$var$contains(array, obj) {
    for(var i = 0; i < array.length; i++){
        if (array[i] === obj) return true;
    }
    return false;
}
function $a75d88c86447809c$var$getSymbols(tokens, symbols, options) {
    options = options || {};
    var withMembers = !!options.withMembers;
    var prevVar = null;
    for(var i = 0; i < tokens.length; i++){
        var item = tokens[i];
        if (item.type === $a75d88c86447809c$var$IVAR || item.type === $a75d88c86447809c$var$IVARNAME) {
            if (!withMembers && !$a75d88c86447809c$var$contains(symbols, item.value)) symbols.push(item.value);
            else if (prevVar !== null) {
                if (!$a75d88c86447809c$var$contains(symbols, prevVar)) symbols.push(prevVar);
                prevVar = item.value;
            } else prevVar = item.value;
        } else if (item.type === $a75d88c86447809c$var$IMEMBER && withMembers && prevVar !== null) prevVar += '.' + item.value;
        else if (item.type === $a75d88c86447809c$var$IEXPR) $a75d88c86447809c$var$getSymbols(item.value, symbols, options);
        else if (prevVar !== null) {
            if (!$a75d88c86447809c$var$contains(symbols, prevVar)) symbols.push(prevVar);
            prevVar = null;
        }
    }
    if (prevVar !== null && !$a75d88c86447809c$var$contains(symbols, prevVar)) symbols.push(prevVar);
}
function $a75d88c86447809c$export$bfe37c1342e5eb83(tokens, parser) {
    this.tokens = tokens;
    this.parser = parser;
    this.unaryOps = parser.unaryOps;
    this.binaryOps = parser.binaryOps;
    this.ternaryOps = parser.ternaryOps;
    this.functions = parser.functions;
}
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.simplify = function(values) {
    values = values || {};
    return new $a75d88c86447809c$export$bfe37c1342e5eb83($a75d88c86447809c$var$simplify(this.tokens, this.unaryOps, this.binaryOps, this.ternaryOps, values), this.parser);
};
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.substitute = function(variable, expr) {
    if (!(expr instanceof $a75d88c86447809c$export$bfe37c1342e5eb83)) expr = this.parser.parse(String(expr));
    return new $a75d88c86447809c$export$bfe37c1342e5eb83($a75d88c86447809c$var$substitute(this.tokens, variable, expr), this.parser);
};
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.evaluate = function(values) {
    values = values || {};
    return $a75d88c86447809c$var$evaluate(this.tokens, this, values);
};
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.toString = function() {
    return $a75d88c86447809c$var$expressionToString(this.tokens, false);
};
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.symbols = function(options) {
    options = options || {};
    var vars = [];
    $a75d88c86447809c$var$getSymbols(this.tokens, vars, options);
    return vars;
};
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.variables = function(options) {
    options = options || {};
    var vars = [];
    $a75d88c86447809c$var$getSymbols(this.tokens, vars, options);
    var functions = this.functions;
    return vars.filter(function(name) {
        return !(name in functions);
    });
};
$a75d88c86447809c$export$bfe37c1342e5eb83.prototype.toJSFunction = function(param, variables) {
    var expr = this;
    var f = new Function(param, 'with(this.functions) with (this.ternaryOps) with (this.binaryOps) with (this.unaryOps) { return ' + $a75d88c86447809c$var$expressionToString(this.simplify(variables).tokens, true) + '; }'); // eslint-disable-line no-new-func
    return function() {
        return f.apply(expr, arguments);
    };
};
var $a75d88c86447809c$var$TEOF = 'TEOF';
var $a75d88c86447809c$var$TOP = 'TOP';
var $a75d88c86447809c$var$TNUMBER = 'TNUMBER';
var $a75d88c86447809c$var$TSTRING = 'TSTRING';
var $a75d88c86447809c$var$TPAREN = 'TPAREN';
var $a75d88c86447809c$var$TBRACKET = 'TBRACKET';
var $a75d88c86447809c$var$TCOMMA = 'TCOMMA';
var $a75d88c86447809c$var$TNAME = 'TNAME';
var $a75d88c86447809c$var$TSEMICOLON = 'TSEMICOLON';
function $a75d88c86447809c$var$Token(type, value, index) {
    this.type = type;
    this.value = value;
    this.index = index;
}
$a75d88c86447809c$var$Token.prototype.toString = function() {
    return this.type + ': ' + this.value;
};
function $a75d88c86447809c$var$TokenStream(parser, expression) {
    this.pos = 0;
    this.current = null;
    this.unaryOps = parser.unaryOps;
    this.binaryOps = parser.binaryOps;
    this.ternaryOps = parser.ternaryOps;
    this.consts = parser.consts;
    this.expression = expression;
    this.savedPosition = 0;
    this.savedCurrent = null;
    this.options = parser.options;
    this.parser = parser;
}
$a75d88c86447809c$var$TokenStream.prototype.newToken = function(type, value, pos) {
    return new $a75d88c86447809c$var$Token(type, value, pos != null ? pos : this.pos);
};
$a75d88c86447809c$var$TokenStream.prototype.save = function() {
    this.savedPosition = this.pos;
    this.savedCurrent = this.current;
};
$a75d88c86447809c$var$TokenStream.prototype.restore = function() {
    this.pos = this.savedPosition;
    this.current = this.savedCurrent;
};
$a75d88c86447809c$var$TokenStream.prototype.next = function() {
    if (this.pos >= this.expression.length) return this.newToken($a75d88c86447809c$var$TEOF, 'EOF');
    if (this.isWhitespace() || this.isComment()) return this.next();
    else if (this.isRadixInteger() || this.isNumber() || this.isOperator() || this.isString() || this.isParen() || this.isBracket() || this.isComma() || this.isSemicolon() || this.isNamedOp() || this.isConst() || this.isName()) return this.current;
    else this.parseError('Unknown character "' + this.expression.charAt(this.pos) + '"');
};
$a75d88c86447809c$var$TokenStream.prototype.isString = function() {
    var r = false;
    var startPos = this.pos;
    var quote = this.expression.charAt(startPos);
    if (quote === '\'' || quote === '"') {
        var index = this.expression.indexOf(quote, startPos + 1);
        while(index >= 0 && this.pos < this.expression.length){
            this.pos = index + 1;
            if (this.expression.charAt(index - 1) !== '\\') {
                var rawString = this.expression.substring(startPos + 1, index);
                this.current = this.newToken($a75d88c86447809c$var$TSTRING, this.unescape(rawString), startPos);
                r = true;
                break;
            }
            index = this.expression.indexOf(quote, index + 1);
        }
    }
    return r;
};
$a75d88c86447809c$var$TokenStream.prototype.isParen = function() {
    var c = this.expression.charAt(this.pos);
    if (c === '(' || c === ')') {
        this.current = this.newToken($a75d88c86447809c$var$TPAREN, c);
        this.pos++;
        return true;
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isBracket = function() {
    var c = this.expression.charAt(this.pos);
    if ((c === '[' || c === ']') && this.isOperatorEnabled('[')) {
        this.current = this.newToken($a75d88c86447809c$var$TBRACKET, c);
        this.pos++;
        return true;
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isComma = function() {
    var c = this.expression.charAt(this.pos);
    if (c === ',') {
        this.current = this.newToken($a75d88c86447809c$var$TCOMMA, ',');
        this.pos++;
        return true;
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isSemicolon = function() {
    var c = this.expression.charAt(this.pos);
    if (c === ';') {
        this.current = this.newToken($a75d88c86447809c$var$TSEMICOLON, ';');
        this.pos++;
        return true;
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isConst = function() {
    var startPos = this.pos;
    var i = startPos;
    for(; i < this.expression.length; i++){
        var c = this.expression.charAt(i);
        if (c.toUpperCase() === c.toLowerCase()) {
            if (i === this.pos || c !== '_' && c !== '.' && (c < '0' || c > '9')) break;
        }
    }
    if (i > startPos) {
        var str = this.expression.substring(startPos, i);
        if (str in this.consts) {
            this.current = this.newToken($a75d88c86447809c$var$TNUMBER, this.consts[str]);
            this.pos += str.length;
            return true;
        }
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isNamedOp = function() {
    var startPos = this.pos;
    var i = startPos;
    for(; i < this.expression.length; i++){
        var c = this.expression.charAt(i);
        if (c.toUpperCase() === c.toLowerCase()) {
            if (i === this.pos || c !== '_' && (c < '0' || c > '9')) break;
        }
    }
    if (i > startPos) {
        var str = this.expression.substring(startPos, i);
        if (this.isOperatorEnabled(str) && (str in this.binaryOps || str in this.unaryOps || str in this.ternaryOps)) {
            this.current = this.newToken($a75d88c86447809c$var$TOP, str);
            this.pos += str.length;
            return true;
        }
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isName = function() {
    var startPos = this.pos;
    var i = startPos;
    var hasLetter = false;
    for(; i < this.expression.length; i++){
        var c = this.expression.charAt(i);
        if (c.toUpperCase() === c.toLowerCase()) {
            if (i === this.pos && (c === '$' || c === '_')) {
                if (c === '_') hasLetter = true;
                continue;
            } else if (i === this.pos || !hasLetter || c !== '_' && (c < '0' || c > '9')) break;
        } else hasLetter = true;
    }
    if (hasLetter) {
        var str = this.expression.substring(startPos, i);
        this.current = this.newToken($a75d88c86447809c$var$TNAME, str);
        this.pos += str.length;
        return true;
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isWhitespace = function() {
    var r = false;
    var c = this.expression.charAt(this.pos);
    while(c === ' ' || c === '\t' || c === '\n' || c === '\r'){
        r = true;
        this.pos++;
        if (this.pos >= this.expression.length) break;
        c = this.expression.charAt(this.pos);
    }
    return r;
};
var $a75d88c86447809c$var$codePointPattern = /^[0-9a-f]{4}$/i;
$a75d88c86447809c$var$TokenStream.prototype.unescape = function(v) {
    var index = v.indexOf('\\');
    if (index < 0) return v;
    var buffer = v.substring(0, index);
    while(index >= 0){
        var c = v.charAt(++index);
        switch(c){
            case '\'':
                buffer += '\'';
                break;
            case '"':
                buffer += '"';
                break;
            case '\\':
                buffer += '\\';
                break;
            case '/':
                buffer += '/';
                break;
            case 'b':
                buffer += '\b';
                break;
            case 'f':
                buffer += '\f';
                break;
            case 'n':
                buffer += '\n';
                break;
            case 'r':
                buffer += '\r';
                break;
            case 't':
                buffer += '\t';
                break;
            case 'u':
                // interpret the following 4 characters as the hex of the unicode code point
                var codePoint = v.substring(index + 1, index + 5);
                if (!$a75d88c86447809c$var$codePointPattern.test(codePoint)) this.parseError('Illegal escape sequence: \\u' + codePoint);
                buffer += String.fromCharCode(parseInt(codePoint, 16));
                index += 4;
                break;
            default:
                throw this.parseError('Illegal escape sequence: "\\' + c + '"');
        }
        ++index;
        var backslash = v.indexOf('\\', index);
        buffer += v.substring(index, backslash < 0 ? v.length : backslash);
        index = backslash;
    }
    return buffer;
};
$a75d88c86447809c$var$TokenStream.prototype.isComment = function() {
    var c = this.expression.charAt(this.pos);
    if (c === '/' && this.expression.charAt(this.pos + 1) === '*') {
        this.pos = this.expression.indexOf('*/', this.pos) + 2;
        if (this.pos === 1) this.pos = this.expression.length;
        return true;
    }
    return false;
};
$a75d88c86447809c$var$TokenStream.prototype.isRadixInteger = function() {
    var pos = this.pos;
    if (pos >= this.expression.length - 2 || this.expression.charAt(pos) !== '0') return false;
    ++pos;
    var radix;
    var validDigit;
    if (this.expression.charAt(pos) === 'x') {
        radix = 16;
        validDigit = /^[0-9a-f]$/i;
        ++pos;
    } else if (this.expression.charAt(pos) === 'b') {
        radix = 2;
        validDigit = /^[01]$/i;
        ++pos;
    } else return false;
    var valid = false;
    var startPos = pos;
    while(pos < this.expression.length){
        var c = this.expression.charAt(pos);
        if (validDigit.test(c)) {
            pos++;
            valid = true;
        } else break;
    }
    if (valid) {
        this.current = this.newToken($a75d88c86447809c$var$TNUMBER, parseInt(this.expression.substring(startPos, pos), radix));
        this.pos = pos;
    }
    return valid;
};
$a75d88c86447809c$var$TokenStream.prototype.isNumber = function() {
    var valid = false;
    var pos = this.pos;
    var startPos = pos;
    var resetPos = pos;
    var foundDot = false;
    var foundDigits = false;
    var c;
    while(pos < this.expression.length){
        c = this.expression.charAt(pos);
        if (c >= '0' && c <= '9' || !foundDot && c === '.') {
            if (c === '.') foundDot = true;
            else foundDigits = true;
            pos++;
            valid = foundDigits;
        } else break;
    }
    if (valid) resetPos = pos;
    if (c === 'e' || c === 'E') {
        pos++;
        var acceptSign = true;
        var validExponent = false;
        while(pos < this.expression.length){
            c = this.expression.charAt(pos);
            if (acceptSign && (c === '+' || c === '-')) acceptSign = false;
            else if (c >= '0' && c <= '9') {
                validExponent = true;
                acceptSign = false;
            } else break;
            pos++;
        }
        if (!validExponent) pos = resetPos;
    }
    if (valid) {
        this.current = this.newToken($a75d88c86447809c$var$TNUMBER, parseFloat(this.expression.substring(startPos, pos)));
        this.pos = pos;
    } else this.pos = resetPos;
    return valid;
};
$a75d88c86447809c$var$TokenStream.prototype.isOperator = function() {
    var startPos = this.pos;
    var c = this.expression.charAt(this.pos);
    if (c === '+' || c === '-' || c === '*' || c === '/' || c === '%' || c === '^' || c === '?' || c === ':' || c === '.') this.current = this.newToken($a75d88c86447809c$var$TOP, c);
    else if (c === "\u2219" || c === "\u2022") this.current = this.newToken($a75d88c86447809c$var$TOP, '*');
    else if (c === '>') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken($a75d88c86447809c$var$TOP, '>=');
            this.pos++;
        } else this.current = this.newToken($a75d88c86447809c$var$TOP, '>');
    } else if (c === '<') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken($a75d88c86447809c$var$TOP, '<=');
            this.pos++;
        } else this.current = this.newToken($a75d88c86447809c$var$TOP, '<');
    } else if (c === '|') {
        if (this.expression.charAt(this.pos + 1) === '|') {
            this.current = this.newToken($a75d88c86447809c$var$TOP, '||');
            this.pos++;
        } else return false;
    } else if (c === '=') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken($a75d88c86447809c$var$TOP, '==');
            this.pos++;
        } else this.current = this.newToken($a75d88c86447809c$var$TOP, c);
    } else if (c === '!') {
        if (this.expression.charAt(this.pos + 1) === '=') {
            this.current = this.newToken($a75d88c86447809c$var$TOP, '!=');
            this.pos++;
        } else this.current = this.newToken($a75d88c86447809c$var$TOP, c);
    } else return false;
    this.pos++;
    if (this.isOperatorEnabled(this.current.value)) return true;
    else {
        this.pos = startPos;
        return false;
    }
};
$a75d88c86447809c$var$TokenStream.prototype.isOperatorEnabled = function(op) {
    return this.parser.isOperatorEnabled(op);
};
$a75d88c86447809c$var$TokenStream.prototype.getCoordinates = function() {
    var line = 0;
    var column;
    var newline = -1;
    do {
        line++;
        column = this.pos - newline;
        newline = this.expression.indexOf('\n', newline + 1);
    }while (newline >= 0 && newline < this.pos);
    return {
        line: line,
        column: column
    };
};
$a75d88c86447809c$var$TokenStream.prototype.parseError = function(msg) {
    var coords = this.getCoordinates();
    throw new Error('parse error [' + coords.line + ':' + coords.column + ']: ' + msg);
};
function $a75d88c86447809c$var$ParserState(parser, tokenStream, options) {
    this.parser = parser;
    this.tokens = tokenStream;
    this.current = null;
    this.nextToken = null;
    this.next();
    this.savedCurrent = null;
    this.savedNextToken = null;
    this.allowMemberAccess = options.allowMemberAccess !== false;
}
$a75d88c86447809c$var$ParserState.prototype.next = function() {
    this.current = this.nextToken;
    return this.nextToken = this.tokens.next();
};
$a75d88c86447809c$var$ParserState.prototype.tokenMatches = function(token, value) {
    if (typeof value === 'undefined') return true;
    else if (Array.isArray(value)) return $a75d88c86447809c$var$contains(value, token.value);
    else if (typeof value === 'function') return value(token);
    else return token.value === value;
};
$a75d88c86447809c$var$ParserState.prototype.save = function() {
    this.savedCurrent = this.current;
    this.savedNextToken = this.nextToken;
    this.tokens.save();
};
$a75d88c86447809c$var$ParserState.prototype.restore = function() {
    this.tokens.restore();
    this.current = this.savedCurrent;
    this.nextToken = this.savedNextToken;
};
$a75d88c86447809c$var$ParserState.prototype.accept = function(type, value) {
    if (this.nextToken.type === type && this.tokenMatches(this.nextToken, value)) {
        this.next();
        return true;
    }
    return false;
};
$a75d88c86447809c$var$ParserState.prototype.expect = function(type, value) {
    if (!this.accept(type, value)) {
        var coords = this.tokens.getCoordinates();
        throw new Error('parse error [' + coords.line + ':' + coords.column + ']: Expected ' + (value || type));
    }
};
$a75d88c86447809c$var$ParserState.prototype.parseAtom = function(instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
        return token.value in unaryOps;
    }
    if (this.accept($a75d88c86447809c$var$TNAME) || this.accept($a75d88c86447809c$var$TOP, isPrefixOperator)) instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IVAR, this.current.value));
    else if (this.accept($a75d88c86447809c$var$TNUMBER)) instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, this.current.value));
    else if (this.accept($a75d88c86447809c$var$TSTRING)) instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$INUMBER, this.current.value));
    else if (this.accept($a75d88c86447809c$var$TPAREN, '(')) {
        this.parseExpression(instr);
        this.expect($a75d88c86447809c$var$TPAREN, ')');
    } else if (this.accept($a75d88c86447809c$var$TBRACKET, '[')) {
        if (this.accept($a75d88c86447809c$var$TBRACKET, ']')) instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IARRAY, 0));
        else {
            var argCount = this.parseArrayList(instr);
            instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IARRAY, argCount));
        }
    } else throw new Error('unexpected ' + this.nextToken);
};
$a75d88c86447809c$var$ParserState.prototype.parseExpression = function(instr) {
    var exprInstr = [];
    if (this.parseUntilEndStatement(instr, exprInstr)) return;
    this.parseVariableAssignmentExpression(exprInstr);
    if (this.parseUntilEndStatement(instr, exprInstr)) return;
    this.pushExpression(instr, exprInstr);
};
$a75d88c86447809c$var$ParserState.prototype.pushExpression = function(instr, exprInstr) {
    for(var i = 0, len = exprInstr.length; i < len; i++)instr.push(exprInstr[i]);
};
$a75d88c86447809c$var$ParserState.prototype.parseUntilEndStatement = function(instr, exprInstr) {
    if (!this.accept($a75d88c86447809c$var$TSEMICOLON)) return false;
    if (this.nextToken && this.nextToken.type !== $a75d88c86447809c$var$TEOF && !(this.nextToken.type === $a75d88c86447809c$var$TPAREN && this.nextToken.value === ')')) exprInstr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IENDSTATEMENT));
    if (this.nextToken.type !== $a75d88c86447809c$var$TEOF) this.parseExpression(exprInstr);
    instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, exprInstr));
    return true;
};
$a75d88c86447809c$var$ParserState.prototype.parseArrayList = function(instr) {
    var argCount = 0;
    while(!this.accept($a75d88c86447809c$var$TBRACKET, ']')){
        this.parseExpression(instr);
        ++argCount;
        while(this.accept($a75d88c86447809c$var$TCOMMA)){
            this.parseExpression(instr);
            ++argCount;
        }
    }
    return argCount;
};
$a75d88c86447809c$var$ParserState.prototype.parseVariableAssignmentExpression = function(instr) {
    this.parseConditionalExpression(instr);
    while(this.accept($a75d88c86447809c$var$TOP, '=')){
        var varName = instr.pop();
        var varValue = [];
        var lastInstrIndex = instr.length - 1;
        if (varName.type === $a75d88c86447809c$var$IFUNCALL) {
            if (!this.tokens.isOperatorEnabled('()=')) throw new Error('function definition is not permitted');
            for(var i = 0, len = varName.value + 1; i < len; i++){
                var index = lastInstrIndex - i;
                if (instr[index].type === $a75d88c86447809c$var$IVAR) instr[index] = new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IVARNAME, instr[index].value);
            }
            this.parseVariableAssignmentExpression(varValue);
            instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, varValue));
            instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IFUNDEF, varName.value));
            continue;
        }
        if (varName.type !== $a75d88c86447809c$var$IVAR && varName.type !== $a75d88c86447809c$var$IMEMBER) throw new Error('expected variable for assignment');
        this.parseVariableAssignmentExpression(varValue);
        instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IVARNAME, varName.value));
        instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, varValue));
        instr.push($a75d88c86447809c$var$binaryInstruction('='));
    }
};
$a75d88c86447809c$var$ParserState.prototype.parseConditionalExpression = function(instr) {
    this.parseOrExpression(instr);
    while(this.accept($a75d88c86447809c$var$TOP, '?')){
        var trueBranch = [];
        var falseBranch = [];
        this.parseConditionalExpression(trueBranch);
        this.expect($a75d88c86447809c$var$TOP, ':');
        this.parseConditionalExpression(falseBranch);
        instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, trueBranch));
        instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, falseBranch));
        instr.push($a75d88c86447809c$var$ternaryInstruction('?'));
    }
};
$a75d88c86447809c$var$ParserState.prototype.parseOrExpression = function(instr) {
    this.parseAndExpression(instr);
    while(this.accept($a75d88c86447809c$var$TOP, 'or')){
        var falseBranch = [];
        this.parseAndExpression(falseBranch);
        instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, falseBranch));
        instr.push($a75d88c86447809c$var$binaryInstruction('or'));
    }
};
$a75d88c86447809c$var$ParserState.prototype.parseAndExpression = function(instr) {
    this.parseComparison(instr);
    while(this.accept($a75d88c86447809c$var$TOP, 'and')){
        var trueBranch = [];
        this.parseComparison(trueBranch);
        instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IEXPR, trueBranch));
        instr.push($a75d88c86447809c$var$binaryInstruction('and'));
    }
};
var $a75d88c86447809c$var$COMPARISON_OPERATORS = [
    '==',
    '!=',
    '<',
    '<=',
    '>=',
    '>',
    'in'
];
$a75d88c86447809c$var$ParserState.prototype.parseComparison = function(instr) {
    this.parseAddSub(instr);
    while(this.accept($a75d88c86447809c$var$TOP, $a75d88c86447809c$var$COMPARISON_OPERATORS)){
        var op = this.current;
        this.parseAddSub(instr);
        instr.push($a75d88c86447809c$var$binaryInstruction(op.value));
    }
};
var $a75d88c86447809c$var$ADD_SUB_OPERATORS = [
    '+',
    '-',
    '||'
];
$a75d88c86447809c$var$ParserState.prototype.parseAddSub = function(instr) {
    this.parseTerm(instr);
    while(this.accept($a75d88c86447809c$var$TOP, $a75d88c86447809c$var$ADD_SUB_OPERATORS)){
        var op = this.current;
        this.parseTerm(instr);
        instr.push($a75d88c86447809c$var$binaryInstruction(op.value));
    }
};
var $a75d88c86447809c$var$TERM_OPERATORS = [
    '*',
    '/',
    '%'
];
$a75d88c86447809c$var$ParserState.prototype.parseTerm = function(instr) {
    this.parseFactor(instr);
    while(this.accept($a75d88c86447809c$var$TOP, $a75d88c86447809c$var$TERM_OPERATORS)){
        var op = this.current;
        this.parseFactor(instr);
        instr.push($a75d88c86447809c$var$binaryInstruction(op.value));
    }
};
$a75d88c86447809c$var$ParserState.prototype.parseFactor = function(instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
        return token.value in unaryOps;
    }
    this.save();
    if (this.accept($a75d88c86447809c$var$TOP, isPrefixOperator)) {
        if (this.current.value !== '-' && this.current.value !== '+') {
            if (this.nextToken.type === $a75d88c86447809c$var$TPAREN && this.nextToken.value === '(') {
                this.restore();
                this.parseExponential(instr);
                return;
            } else if (this.nextToken.type === $a75d88c86447809c$var$TSEMICOLON || this.nextToken.type === $a75d88c86447809c$var$TCOMMA || this.nextToken.type === $a75d88c86447809c$var$TEOF || this.nextToken.type === $a75d88c86447809c$var$TPAREN && this.nextToken.value === ')') {
                this.restore();
                this.parseAtom(instr);
                return;
            }
        }
        var op = this.current;
        this.parseFactor(instr);
        instr.push($a75d88c86447809c$var$unaryInstruction(op.value));
    } else this.parseExponential(instr);
};
$a75d88c86447809c$var$ParserState.prototype.parseExponential = function(instr) {
    this.parsePostfixExpression(instr);
    while(this.accept($a75d88c86447809c$var$TOP, '^')){
        this.parseFactor(instr);
        instr.push($a75d88c86447809c$var$binaryInstruction('^'));
    }
};
$a75d88c86447809c$var$ParserState.prototype.parsePostfixExpression = function(instr) {
    this.parseFunctionCall(instr);
    while(this.accept($a75d88c86447809c$var$TOP, '!'))instr.push($a75d88c86447809c$var$unaryInstruction('!'));
};
$a75d88c86447809c$var$ParserState.prototype.parseFunctionCall = function(instr) {
    var unaryOps = this.tokens.unaryOps;
    function isPrefixOperator(token) {
        return token.value in unaryOps;
    }
    if (this.accept($a75d88c86447809c$var$TOP, isPrefixOperator)) {
        var op = this.current;
        this.parseAtom(instr);
        instr.push($a75d88c86447809c$var$unaryInstruction(op.value));
    } else {
        this.parseMemberExpression(instr);
        while(this.accept($a75d88c86447809c$var$TPAREN, '('))if (this.accept($a75d88c86447809c$var$TPAREN, ')')) instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IFUNCALL, 0));
        else {
            var argCount = this.parseArgumentList(instr);
            instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IFUNCALL, argCount));
        }
    }
};
$a75d88c86447809c$var$ParserState.prototype.parseArgumentList = function(instr) {
    var argCount = 0;
    while(!this.accept($a75d88c86447809c$var$TPAREN, ')')){
        this.parseExpression(instr);
        ++argCount;
        while(this.accept($a75d88c86447809c$var$TCOMMA)){
            this.parseExpression(instr);
            ++argCount;
        }
    }
    return argCount;
};
$a75d88c86447809c$var$ParserState.prototype.parseMemberExpression = function(instr) {
    this.parseAtom(instr);
    while(this.accept($a75d88c86447809c$var$TOP, '.') || this.accept($a75d88c86447809c$var$TBRACKET, '[')){
        var op = this.current;
        if (op.value === '.') {
            if (!this.allowMemberAccess) throw new Error('unexpected ".", member access is not permitted');
            this.expect($a75d88c86447809c$var$TNAME);
            instr.push(new $a75d88c86447809c$var$Instruction($a75d88c86447809c$var$IMEMBER, this.current.value));
        } else if (op.value === '[') {
            if (!this.tokens.isOperatorEnabled('[')) throw new Error('unexpected "[]", arrays are disabled');
            this.parseExpression(instr);
            this.expect($a75d88c86447809c$var$TBRACKET, ']');
            instr.push($a75d88c86447809c$var$binaryInstruction('['));
        } else throw new Error('unexpected symbol: ' + op.value);
    }
};
function $a75d88c86447809c$var$add(a, b) {
    return Number(a) + Number(b);
}
function $a75d88c86447809c$var$sub(a, b) {
    return a - b;
}
function $a75d88c86447809c$var$mul(a, b) {
    return a * b;
}
function $a75d88c86447809c$var$div(a, b) {
    return a / b;
}
function $a75d88c86447809c$var$mod(a, b) {
    return a % b;
}
function $a75d88c86447809c$var$concat(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.concat(b);
    return '' + a + b;
}
function $a75d88c86447809c$var$equal(a, b) {
    return a === b;
}
function $a75d88c86447809c$var$notEqual(a, b) {
    return a !== b;
}
function $a75d88c86447809c$var$greaterThan(a, b) {
    return a > b;
}
function $a75d88c86447809c$var$lessThan(a, b) {
    return a < b;
}
function $a75d88c86447809c$var$greaterThanEqual(a, b) {
    return a >= b;
}
function $a75d88c86447809c$var$lessThanEqual(a, b) {
    return a <= b;
}
function $a75d88c86447809c$var$andOperator(a, b) {
    return Boolean(a && b);
}
function $a75d88c86447809c$var$orOperator(a, b) {
    return Boolean(a || b);
}
function $a75d88c86447809c$var$inOperator(a, b) {
    return $a75d88c86447809c$var$contains(b, a);
}
function $a75d88c86447809c$var$sinh(a) {
    return (Math.exp(a) - Math.exp(-a)) / 2;
}
function $a75d88c86447809c$var$cosh(a) {
    return (Math.exp(a) + Math.exp(-a)) / 2;
}
function $a75d88c86447809c$var$tanh(a) {
    if (a === Infinity) return 1;
    if (a === -Infinity) return -1;
    return (Math.exp(a) - Math.exp(-a)) / (Math.exp(a) + Math.exp(-a));
}
function $a75d88c86447809c$var$asinh(a) {
    if (a === -Infinity) return a;
    return Math.log(a + Math.sqrt(a * a + 1));
}
function $a75d88c86447809c$var$acosh(a) {
    return Math.log(a + Math.sqrt(a * a - 1));
}
function $a75d88c86447809c$var$atanh(a) {
    return Math.log((1 + a) / (1 - a)) / 2;
}
function $a75d88c86447809c$var$log10(a) {
    return Math.log(a) * Math.LOG10E;
}
function $a75d88c86447809c$var$neg(a) {
    return -a;
}
function $a75d88c86447809c$var$not(a) {
    return !a;
}
function $a75d88c86447809c$var$trunc(a) {
    return a < 0 ? Math.ceil(a) : Math.floor(a);
}
function $a75d88c86447809c$var$random(a) {
    return Math.random() * (a || 1);
}
function $a75d88c86447809c$var$factorial(a) {
    return $a75d88c86447809c$var$gamma(a + 1);
}
function $a75d88c86447809c$var$isInteger(value) {
    return isFinite(value) && value === Math.round(value);
}
var $a75d88c86447809c$var$GAMMA_G = 4.7421875;
var $a75d88c86447809c$var$GAMMA_P = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];
// Gamma function from math.js
function $a75d88c86447809c$var$gamma(n) {
    var t, x;
    if ($a75d88c86447809c$var$isInteger(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        var value = n - 2;
        var res = n - 1;
        while(value > 1){
            res *= value;
            value--;
        }
        if (res === 0) res = 1; // 0! is per definition 1
        return res;
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $a75d88c86447809c$var$gamma(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $a75d88c86447809c$var$GAMMA_P[0];
    for(var i = 1; i < $a75d88c86447809c$var$GAMMA_P.length; ++i)x += $a75d88c86447809c$var$GAMMA_P[i] / (n + i);
    t = n + $a75d88c86447809c$var$GAMMA_G + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
function $a75d88c86447809c$var$stringOrArrayLength(s) {
    if (Array.isArray(s)) return s.length;
    return String(s).length;
}
function $a75d88c86447809c$var$hypot() {
    var sum = 0;
    var larg = 0;
    for(var i = 0; i < arguments.length; i++){
        var arg = Math.abs(arguments[i]);
        var div;
        if (larg < arg) {
            div = larg / arg;
            sum = sum * div * div + 1;
            larg = arg;
        } else if (arg > 0) {
            div = arg / larg;
            sum += div * div;
        } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
}
function $a75d88c86447809c$var$condition(cond, yep, nope) {
    return cond ? yep : nope;
}
/**
* Decimal adjustment of a number.
* From @escopecz.
*
* @param {Number} value The number.
* @param {Integer} exp  The exponent (the 10 logarithm of the adjustment base).
* @return {Number} The adjusted value.
*/ function $a75d88c86447809c$var$roundTo(value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) return Math.round(value);
    value = +value;
    exp = -+exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) return NaN;
    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
}
function $a75d88c86447809c$var$setVar(name, value, variables) {
    if (variables) variables[name] = value;
    return value;
}
function $a75d88c86447809c$var$arrayIndex(array, index) {
    return array[index | 0];
}
function $a75d88c86447809c$var$max(array) {
    if (arguments.length === 1 && Array.isArray(array)) return Math.max.apply(Math, array);
    else return Math.max.apply(Math, arguments);
}
function $a75d88c86447809c$var$min(array) {
    if (arguments.length === 1 && Array.isArray(array)) return Math.min.apply(Math, array);
    else return Math.min.apply(Math, arguments);
}
function $a75d88c86447809c$var$arrayMap(f, a) {
    if (typeof f !== 'function') throw new Error('First argument to map is not a function');
    if (!Array.isArray(a)) throw new Error('Second argument to map is not an array');
    return a.map(function(x, i) {
        return f(x, i);
    });
}
function $a75d88c86447809c$var$arrayFold(f, init, a) {
    if (typeof f !== 'function') throw new Error('First argument to fold is not a function');
    if (!Array.isArray(a)) throw new Error('Second argument to fold is not an array');
    return a.reduce(function(acc, x, i) {
        return f(acc, x, i);
    }, init);
}
function $a75d88c86447809c$var$arrayFilter(f, a) {
    if (typeof f !== 'function') throw new Error('First argument to filter is not a function');
    if (!Array.isArray(a)) throw new Error('Second argument to filter is not an array');
    return a.filter(function(x, i) {
        return f(x, i);
    });
}
function $a75d88c86447809c$var$stringOrArrayIndexOf(target, s) {
    if (!(Array.isArray(s) || typeof s === 'string')) throw new Error('Second argument to indexOf is not a string or array');
    return s.indexOf(target);
}
function $a75d88c86447809c$var$arrayJoin(sep, a) {
    if (!Array.isArray(a)) throw new Error('Second argument to join is not an array');
    return a.join(sep);
}
function $a75d88c86447809c$var$sign(x) {
    return (x > 0) - (x < 0) || +x;
}
var $a75d88c86447809c$var$ONE_THIRD = 1 / 3;
function $a75d88c86447809c$var$cbrt(x) {
    return x < 0 ? -Math.pow(-x, $a75d88c86447809c$var$ONE_THIRD) : Math.pow(x, $a75d88c86447809c$var$ONE_THIRD);
}
function $a75d88c86447809c$var$expm1(x) {
    return Math.exp(x) - 1;
}
function $a75d88c86447809c$var$log1p(x) {
    return Math.log(1 + x);
}
function $a75d88c86447809c$var$log2(x) {
    return Math.log(x) / Math.LN2;
}
function $a75d88c86447809c$var$sum(array) {
    if (!Array.isArray(array)) throw new Error('Sum argument is not an array');
    return array.reduce(function(total, value) {
        return total + Number(value);
    }, 0);
}
function $a75d88c86447809c$export$7acfa6ed01010e37(options) {
    this.options = options || {};
    this.unaryOps = {
        sin: Math.sin,
        cos: Math.cos,
        tan: Math.tan,
        asin: Math.asin,
        acos: Math.acos,
        atan: Math.atan,
        sinh: Math.sinh || $a75d88c86447809c$var$sinh,
        cosh: Math.cosh || $a75d88c86447809c$var$cosh,
        tanh: Math.tanh || $a75d88c86447809c$var$tanh,
        asinh: Math.asinh || $a75d88c86447809c$var$asinh,
        acosh: Math.acosh || $a75d88c86447809c$var$acosh,
        atanh: Math.atanh || $a75d88c86447809c$var$atanh,
        sqrt: Math.sqrt,
        cbrt: Math.cbrt || $a75d88c86447809c$var$cbrt,
        log: Math.log,
        log2: Math.log2 || $a75d88c86447809c$var$log2,
        ln: Math.log,
        lg: Math.log10 || $a75d88c86447809c$var$log10,
        log10: Math.log10 || $a75d88c86447809c$var$log10,
        expm1: Math.expm1 || $a75d88c86447809c$var$expm1,
        log1p: Math.log1p || $a75d88c86447809c$var$log1p,
        abs: Math.abs,
        ceil: Math.ceil,
        floor: Math.floor,
        round: Math.round,
        trunc: Math.trunc || $a75d88c86447809c$var$trunc,
        '-': $a75d88c86447809c$var$neg,
        '+': Number,
        exp: Math.exp,
        not: $a75d88c86447809c$var$not,
        length: $a75d88c86447809c$var$stringOrArrayLength,
        '!': $a75d88c86447809c$var$factorial,
        sign: Math.sign || $a75d88c86447809c$var$sign
    };
    this.binaryOps = {
        '+': $a75d88c86447809c$var$add,
        '-': $a75d88c86447809c$var$sub,
        '*': $a75d88c86447809c$var$mul,
        '/': $a75d88c86447809c$var$div,
        '%': $a75d88c86447809c$var$mod,
        '^': Math.pow,
        '||': $a75d88c86447809c$var$concat,
        '==': $a75d88c86447809c$var$equal,
        '!=': $a75d88c86447809c$var$notEqual,
        '>': $a75d88c86447809c$var$greaterThan,
        '<': $a75d88c86447809c$var$lessThan,
        '>=': $a75d88c86447809c$var$greaterThanEqual,
        '<=': $a75d88c86447809c$var$lessThanEqual,
        and: $a75d88c86447809c$var$andOperator,
        or: $a75d88c86447809c$var$orOperator,
        in: $a75d88c86447809c$var$inOperator,
        '=': $a75d88c86447809c$var$setVar,
        '[': $a75d88c86447809c$var$arrayIndex
    };
    this.ternaryOps = {
        '?': $a75d88c86447809c$var$condition
    };
    this.functions = {
        random: $a75d88c86447809c$var$random,
        fac: $a75d88c86447809c$var$factorial,
        min: $a75d88c86447809c$var$min,
        max: $a75d88c86447809c$var$max,
        hypot: Math.hypot || $a75d88c86447809c$var$hypot,
        pyt: Math.hypot || $a75d88c86447809c$var$hypot,
        pow: Math.pow,
        atan2: Math.atan2,
        if: $a75d88c86447809c$var$condition,
        gamma: $a75d88c86447809c$var$gamma,
        roundTo: $a75d88c86447809c$var$roundTo,
        map: $a75d88c86447809c$var$arrayMap,
        fold: $a75d88c86447809c$var$arrayFold,
        filter: $a75d88c86447809c$var$arrayFilter,
        indexOf: $a75d88c86447809c$var$stringOrArrayIndexOf,
        join: $a75d88c86447809c$var$arrayJoin,
        sum: $a75d88c86447809c$var$sum
    };
    this.consts = {
        E: Math.E,
        PI: Math.PI,
        true: true,
        false: false
    };
}
$a75d88c86447809c$export$7acfa6ed01010e37.prototype.parse = function(expr) {
    var instr = [];
    var parserState = new $a75d88c86447809c$var$ParserState(this, new $a75d88c86447809c$var$TokenStream(this, expr), {
        allowMemberAccess: this.options.allowMemberAccess
    });
    parserState.parseExpression(instr);
    parserState.expect($a75d88c86447809c$var$TEOF, 'EOF');
    return new $a75d88c86447809c$export$bfe37c1342e5eb83(instr, this);
};
$a75d88c86447809c$export$7acfa6ed01010e37.prototype.evaluate = function(expr, variables) {
    return this.parse(expr).evaluate(variables);
};
var $a75d88c86447809c$var$sharedParser = new $a75d88c86447809c$export$7acfa6ed01010e37();
$a75d88c86447809c$export$7acfa6ed01010e37.parse = function(expr) {
    return $a75d88c86447809c$var$sharedParser.parse(expr);
};
$a75d88c86447809c$export$7acfa6ed01010e37.evaluate = function(expr, variables) {
    return $a75d88c86447809c$var$sharedParser.parse(expr).evaluate(variables);
};
var $a75d88c86447809c$var$optionNameMap = {
    '+': 'add',
    '-': 'subtract',
    '*': 'multiply',
    '/': 'divide',
    '%': 'remainder',
    '^': 'power',
    '!': 'factorial',
    '<': 'comparison',
    '>': 'comparison',
    '<=': 'comparison',
    '>=': 'comparison',
    '==': 'comparison',
    '!=': 'comparison',
    '||': 'concatenate',
    and: 'logical',
    or: 'logical',
    not: 'logical',
    '?': 'conditional',
    ':': 'conditional',
    '=': 'assignment',
    '[': 'array',
    '()=': 'fndef'
};
function $a75d88c86447809c$var$getOptionName(op) {
    return Object.hasOwn($a75d88c86447809c$var$optionNameMap, op) ? $a75d88c86447809c$var$optionNameMap[op] : op;
}
$a75d88c86447809c$export$7acfa6ed01010e37.prototype.isOperatorEnabled = function(op) {
    var optionName = $a75d88c86447809c$var$getOptionName(op);
    var operators = this.options.operators || {};
    return !(optionName in operators) || !!operators[optionName];
};
/*!
 Based on ndef.parser, by Raphael Graf(r@undefined.ch)
 http://www.undefined.ch/mparser/index.html

 Ported to JavaScript and modified by Matthew Crumley (email@matthewcrumley.com, http://silentmatt.com/)

 You are free to use and modify this code in anyway you find useful. Please leave this comment in the code
 to acknowledge its original source. If you feel like it, I enjoy hearing about projects that use my code,
 but don't feel like you have to let me know or ask permission.
*/ // Backwards compatibility
var $a75d88c86447809c$var$index = {
    Parser: $a75d88c86447809c$export$7acfa6ed01010e37,
    Expression: $a75d88c86447809c$export$bfe37c1342e5eb83
};
var $a75d88c86447809c$export$2e2bcd8739ae039 = $a75d88c86447809c$var$index;

});




parcelRegister("iBDKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8ba8508068c9dcb$export$2e2bcd8739ae039; });

var $4Z4w2 = parcelRequire("4Z4w2");

var $8TfIJ = parcelRequire("8TfIJ");

var $hhs4I = parcelRequire("hhs4I");

var $2Qlmh = parcelRequire("2Qlmh");

var $hP4Mu = parcelRequire("hP4Mu");
/*
Reference coordinate frames for THREE.js and ROS.
Both coordinate systems are right handed so the URDF is instantiated without
frame transforms. The resulting model can be rotated to rectify the proper up,
right, and forward directions

THREE.js
   Y
   |
   |
   .-----X
 ／
Z

ROS URDf
       Z
       |   X
       | ／
 Y-----.

*/ const $d8ba8508068c9dcb$var$tempQuaternion = new $8TfIJ.Quaternion();
const $d8ba8508068c9dcb$var$tempEuler = new $8TfIJ.Euler();
// take a vector "x y z" and process it into
// an array [x, y, z]
function $d8ba8508068c9dcb$var$processTuple(val) {
    if (!val) return [
        0,
        0,
        0
    ];
    return val.trim().split(/\s+/g).map((num)=>parseFloat(num));
}
// applies a rotation a threejs object in URDF order
function $d8ba8508068c9dcb$var$applyRotation(obj, rpy, additive = false) {
    // if additive is true the rotation is applied in
    // addition to the existing rotation
    if (!additive) obj.rotation.set(0, 0, 0);
    $d8ba8508068c9dcb$var$tempEuler.set(rpy[0], rpy[1], rpy[2], 'ZYX');
    $d8ba8508068c9dcb$var$tempQuaternion.setFromEuler($d8ba8508068c9dcb$var$tempEuler);
    $d8ba8508068c9dcb$var$tempQuaternion.multiply(obj.quaternion);
    obj.quaternion.copy($d8ba8508068c9dcb$var$tempQuaternion);
}
class $d8ba8508068c9dcb$export$2e2bcd8739ae039 {
    /* Public API */ loadAsync(urdf) {
        return new Promise((resolve, reject)=>{
            this.load(urdf, resolve, null, reject);
        });
    }
    // urdf:    The path to the URDF within the package OR absolute
    // onComplete:      Callback that is passed the model once loaded
    load(urdf, onComplete, onProgress, onError) {
        // Check if a full URI is specified before
        // prepending the package info
        const manager = this.manager;
        const workingPath = $8TfIJ.LoaderUtils.extractUrlBase(urdf);
        const urdfPath = this.manager.resolveURL(urdf);
        manager.itemStart(urdfPath);
        fetch(urdfPath, this.fetchOptions).then((res)=>{
            if (res.ok) {
                if (onProgress) onProgress(null);
                return res.text();
            } else throw new Error(`URDFLoader: Failed to load url '${urdfPath}' with error code ${res.status} : ${res.statusText}.`);
        }).then((data)=>{
            if (this.workingPath === '') this.workingPath = workingPath;
            const model = this.parse(data);
            onComplete(model);
            manager.itemEnd(urdfPath);
        }).catch((e)=>{
            if (onError) onError(e);
            else console.error('URDFLoader: Error loading file.', e);
            manager.itemError(urdfPath);
            manager.itemEnd(urdfPath);
        });
    }
    parse(content) {
        const packages = this.packages;
        const loadMeshCb = this.loadMeshCb;
        const parseVisual = this.parseVisual;
        const parseCollision = this.parseCollision;
        const workingPath = this.workingPath;
        const manager = this.manager;
        const linkMap = {};
        const jointMap = {};
        const materialMap = {};
        // Resolves the path of mesh files
        function resolvePath(path) {
            if (!/^package:\/\//.test(path)) return workingPath ? workingPath + path : path;
            // Remove "package://" keyword and split meshPath at the first slash
            const [targetPkg, relPath] = path.replace(/^package:\/\//, '').split(/\/(.+)/);
            if (typeof packages === 'string') {
                // "pkg" is one single package
                if (packages.endsWith(targetPkg)) // "pkg" is the target package
                return packages + '/' + relPath;
                else // Assume "pkg" is the target package's parent directory
                return packages + '/' + targetPkg + '/' + relPath;
            } else if (packages instanceof Function) return packages(targetPkg) + '/' + relPath;
            else if (typeof packages === 'object') {
                // "pkg" is a map of packages
                if (targetPkg in packages) return packages[targetPkg] + '/' + relPath;
                else {
                    console.error(`URDFLoader : ${targetPkg} not found in provided package list.`);
                    return null;
                }
            }
        }
        // Process the URDF text format
        function processUrdf(data) {
            let children;
            if (data instanceof Document) children = [
                ...data.children
            ];
            else if (data instanceof Element) children = [
                data
            ];
            else {
                const parser = new DOMParser();
                const urdf = parser.parseFromString(data, 'text/xml');
                children = [
                    ...urdf.children
                ];
            }
            const robotNode = children.filter((c)=>c.nodeName === 'robot').pop();
            return processRobot(robotNode);
        }
        // Process the <robot> node
        function processRobot(robot) {
            const robotNodes = [
                ...robot.children
            ];
            const links = robotNodes.filter((c)=>c.nodeName.toLowerCase() === 'link');
            const joints = robotNodes.filter((c)=>c.nodeName.toLowerCase() === 'joint');
            const materials = robotNodes.filter((c)=>c.nodeName.toLowerCase() === 'material');
            const obj = new (0, $hP4Mu.URDFRobot)();
            obj.robotName = robot.getAttribute('name');
            obj.urdfRobotNode = robot;
            // Create the <material> map
            materials.forEach((m)=>{
                const name = m.getAttribute('name');
                materialMap[name] = processMaterial(m);
            });
            // Create the <link> map
            const visualMap = {};
            const colliderMap = {};
            links.forEach((l)=>{
                const name = l.getAttribute('name');
                const isRoot = robot.querySelector(`child[link="${name}"]`) === null;
                linkMap[name] = processLink(l, visualMap, colliderMap, isRoot ? obj : null);
            });
            // Create the <joint> map
            joints.forEach((j)=>{
                const name = j.getAttribute('name');
                jointMap[name] = processJoint(j);
            });
            obj.joints = jointMap;
            obj.links = linkMap;
            obj.colliders = colliderMap;
            obj.visual = visualMap;
            // Link up mimic joints
            const jointList = Object.values(jointMap);
            jointList.forEach((j)=>{
                if (j instanceof (0, $hP4Mu.URDFMimicJoint)) jointMap[j.mimicJoint].mimicJoints.push(j);
            });
            // Detect infinite loops of mimic joints
            jointList.forEach((j)=>{
                const uniqueJoints = new Set();
                const iterFunction = (joint)=>{
                    if (uniqueJoints.has(joint)) throw new Error('URDFLoader: Detected an infinite loop of mimic joints.');
                    uniqueJoints.add(joint);
                    joint.mimicJoints.forEach((j)=>{
                        iterFunction(j);
                    });
                };
                iterFunction(j);
            });
            obj.frames = (0, $4Z4w2._)({}, colliderMap, visualMap, linkMap, jointMap);
            return obj;
        }
        // Process joint nodes and parent them
        function processJoint(joint) {
            const children = [
                ...joint.children
            ];
            const jointType = joint.getAttribute('type');
            let obj;
            const mimicTag = children.find((n)=>n.nodeName.toLowerCase() === 'mimic');
            if (mimicTag) {
                obj = new (0, $hP4Mu.URDFMimicJoint)();
                obj.mimicJoint = mimicTag.getAttribute('joint');
                obj.multiplier = parseFloat(mimicTag.getAttribute('multiplier') || 1.0);
                obj.offset = parseFloat(mimicTag.getAttribute('offset') || 0.0);
            } else obj = new (0, $hP4Mu.URDFJoint)();
            obj.urdfNode = joint;
            obj.name = joint.getAttribute('name');
            obj.urdfName = obj.name;
            obj.jointType = jointType;
            let parent = null;
            let child = null;
            let xyz = [
                0,
                0,
                0
            ];
            let rpy = [
                0,
                0,
                0
            ];
            // Extract the attributes
            children.forEach((n)=>{
                const type = n.nodeName.toLowerCase();
                if (type === 'origin') {
                    xyz = $d8ba8508068c9dcb$var$processTuple(n.getAttribute('xyz'));
                    rpy = $d8ba8508068c9dcb$var$processTuple(n.getAttribute('rpy'));
                } else if (type === 'child') child = linkMap[n.getAttribute('link')];
                else if (type === 'parent') parent = linkMap[n.getAttribute('link')];
                else if (type === 'limit') {
                    obj.limit.lower = parseFloat(n.getAttribute('lower') || obj.limit.lower);
                    obj.limit.upper = parseFloat(n.getAttribute('upper') || obj.limit.upper);
                }
            });
            // Join the links
            parent.add(obj);
            obj.add(child);
            $d8ba8508068c9dcb$var$applyRotation(obj, rpy);
            obj.position.set(xyz[0], xyz[1], xyz[2]);
            // Set up the rotate function
            const axisNode = children.filter((n)=>n.nodeName.toLowerCase() === 'axis')[0];
            if (axisNode) {
                const axisXYZ = axisNode.getAttribute('xyz').split(/\s+/g).map((num)=>parseFloat(num));
                obj.axis = new $8TfIJ.Vector3(axisXYZ[0], axisXYZ[1], axisXYZ[2]);
                obj.axis.normalize();
            }
            return obj;
        }
        // Process the <link> nodes
        function processLink(link, visualMap, colliderMap, target = null) {
            if (target === null) target = new (0, $hP4Mu.URDFLink)();
            const children = [
                ...link.children
            ];
            target.name = link.getAttribute('name');
            target.urdfName = target.name;
            target.urdfNode = link;
            if (parseVisual) {
                const visualNodes = children.filter((n)=>n.nodeName.toLowerCase() === 'visual');
                visualNodes.forEach((vn)=>{
                    const v = processLinkElement(vn, materialMap);
                    target.add(v);
                    if (vn.hasAttribute('name')) {
                        const name = vn.getAttribute('name');
                        v.name = name;
                        v.urdfName = name;
                        visualMap[name] = v;
                    }
                });
            }
            if (parseCollision) {
                const collisionNodes = children.filter((n)=>n.nodeName.toLowerCase() === 'collision');
                collisionNodes.forEach((cn)=>{
                    const c = processLinkElement(cn);
                    target.add(c);
                    if (cn.hasAttribute('name')) {
                        const name = cn.getAttribute('name');
                        c.name = name;
                        c.urdfName = name;
                        colliderMap[name] = c;
                    }
                });
            }
            return target;
        }
        function processMaterial(node) {
            const matNodes = [
                ...node.children
            ];
            const material = new $8TfIJ.MeshPhongMaterial();
            material.name = node.getAttribute('name') || '';
            matNodes.forEach((n)=>{
                const type = n.nodeName.toLowerCase();
                if (type === 'color') {
                    const rgba = n.getAttribute('rgba').split(/\s/g).map((v)=>parseFloat(v));
                    material.color.setRGB(rgba[0], rgba[1], rgba[2]);
                    material.opacity = rgba[3];
                    material.transparent = rgba[3] < 1;
                    material.depthWrite = !material.transparent;
                } else if (type === 'texture') {
                    // The URDF spec does not require that the <texture/> tag include
                    // a filename attribute so skip loading the texture if not provided.
                    const filename = n.getAttribute('filename');
                    if (filename) {
                        const loader = new $8TfIJ.TextureLoader(manager);
                        const filePath = resolvePath(filename);
                        material.map = loader.load(filePath);
                    }
                }
            });
            return material;
        }
        // Process the visual and collision nodes into meshes
        function processLinkElement(vn, materialMap = {}) {
            const isCollisionNode = vn.nodeName.toLowerCase() === 'collision';
            const children = [
                ...vn.children
            ];
            let material = null;
            // get the material first
            const materialNode = children.filter((n)=>n.nodeName.toLowerCase() === 'material')[0];
            if (materialNode) {
                const name = materialNode.getAttribute('name');
                if (name && name in materialMap) material = materialMap[name];
                else material = processMaterial(materialNode);
            } else material = new $8TfIJ.MeshPhongMaterial();
            const group = isCollisionNode ? new (0, $hP4Mu.URDFCollider)() : new (0, $hP4Mu.URDFVisual)();
            group.urdfNode = vn;
            children.forEach((n)=>{
                const type = n.nodeName.toLowerCase();
                if (type === 'geometry') {
                    const geoType = n.children[0].nodeName.toLowerCase();
                    if (geoType === 'mesh') {
                        const filename = n.children[0].getAttribute('filename');
                        const filePath = resolvePath(filename);
                        // file path is null if a package directory is not provided.
                        if (filePath !== null) {
                            const scaleAttr = n.children[0].getAttribute('scale');
                            if (scaleAttr) {
                                const scale = $d8ba8508068c9dcb$var$processTuple(scaleAttr);
                                group.scale.set(scale[0], scale[1], scale[2]);
                            }
                            loadMeshCb(filePath, manager, (obj, err)=>{
                                if (err) console.error('URDFLoader: Error loading mesh.', err);
                                else if (obj) {
                                    if (obj instanceof $8TfIJ.Mesh) obj.material = material;
                                    // We don't expect non identity rotations or positions. In the case of
                                    // COLLADA files the model might come in with a custom scale for unit
                                    // conversion.
                                    obj.position.set(0, 0, 0);
                                    obj.quaternion.identity();
                                    group.add(obj);
                                }
                            });
                        }
                    } else if (geoType === 'box') {
                        const primitiveModel = new $8TfIJ.Mesh();
                        primitiveModel.geometry = new $8TfIJ.BoxBufferGeometry(1, 1, 1);
                        primitiveModel.material = material;
                        const size = $d8ba8508068c9dcb$var$processTuple(n.children[0].getAttribute('size'));
                        primitiveModel.scale.set(size[0], size[1], size[2]);
                        group.add(primitiveModel);
                    } else if (geoType === 'sphere') {
                        const primitiveModel = new $8TfIJ.Mesh();
                        primitiveModel.geometry = new $8TfIJ.SphereBufferGeometry(1, 30, 30);
                        primitiveModel.material = material;
                        const radius = parseFloat(n.children[0].getAttribute('radius')) || 0;
                        primitiveModel.scale.set(radius, radius, radius);
                        group.add(primitiveModel);
                    } else if (geoType === 'cylinder') {
                        const primitiveModel = new $8TfIJ.Mesh();
                        primitiveModel.geometry = new $8TfIJ.CylinderBufferGeometry(1, 1, 1, 30);
                        primitiveModel.material = material;
                        const radius = parseFloat(n.children[0].getAttribute('radius')) || 0;
                        const length = parseFloat(n.children[0].getAttribute('length')) || 0;
                        primitiveModel.scale.set(radius, length, radius);
                        primitiveModel.rotation.set(Math.PI / 2, 0, 0);
                        group.add(primitiveModel);
                    }
                } else if (type === 'origin') {
                    const xyz = $d8ba8508068c9dcb$var$processTuple(n.getAttribute('xyz'));
                    const rpy = $d8ba8508068c9dcb$var$processTuple(n.getAttribute('rpy'));
                    group.position.set(xyz[0], xyz[1], xyz[2]);
                    group.rotation.set(0, 0, 0);
                    $d8ba8508068c9dcb$var$applyRotation(group, rpy);
                }
            });
            return group;
        }
        return processUrdf(content);
    }
    // Default mesh loading function
    defaultMeshLoader(path, manager, done) {
        if (/\.stl$/i.test(path)) {
            const loader = new (0, $hhs4I.STLLoader)(manager);
            loader.load(path, (geom)=>{
                const mesh = new $8TfIJ.Mesh(geom, new $8TfIJ.MeshPhongMaterial());
                done(mesh);
            });
        } else if (/\.dae$/i.test(path)) {
            const loader = new (0, $2Qlmh.ColladaLoader)(manager);
            loader.load(path, (dae)=>done(dae.scene));
        } else console.warn(`URDFLoader: Could not load model at ${path}.\nNo loader available`);
    }
    constructor(manager){
        this.manager = manager || $8TfIJ.DefaultLoadingManager;
        this.loadMeshCb = this.defaultMeshLoader.bind(this);
        this.parseVisual = true;
        this.parseCollision = false;
        this.packages = '';
        this.workingPath = '';
        this.fetchOptions = {};
    }
}

});
parcelRegister("2Qlmh", function(module, exports) {

$parcel$export(module.exports, "ColladaLoader", function () { return $2121016a97576e2e$export$ce4e0fe932362815; });

var $8TfIJ = parcelRequire("8TfIJ");

var $jUfts = parcelRequire("jUfts");
class $2121016a97576e2e$export$ce4e0fe932362815 extends (0, $8TfIJ.Loader) {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = scope.path === '' ? (0, $8TfIJ.LoaderUtils).extractUrlBase(url) : scope.path;
        const loader = new (0, $8TfIJ.FileLoader)(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(text, path));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(text, path) {
        function getElementsByTagName(xml, name) {
            // Non recursive xml.getElementsByTagName() ...
            const array = [];
            const childNodes = xml.childNodes;
            for(let i = 0, l = childNodes.length; i < l; i++){
                const child = childNodes[i];
                if (child.nodeName === name) array.push(child);
            }
            return array;
        }
        function parseStrings(text) {
            if (text.length === 0) return [];
            const parts = text.trim().split(/\s+/);
            const array = new Array(parts.length);
            for(let i = 0, l = parts.length; i < l; i++)array[i] = parts[i];
            return array;
        }
        function parseFloats(text) {
            if (text.length === 0) return [];
            const parts = text.trim().split(/\s+/);
            const array = new Array(parts.length);
            for(let i = 0, l = parts.length; i < l; i++)array[i] = parseFloat(parts[i]);
            return array;
        }
        function parseInts(text) {
            if (text.length === 0) return [];
            const parts = text.trim().split(/\s+/);
            const array = new Array(parts.length);
            for(let i = 0, l = parts.length; i < l; i++)array[i] = parseInt(parts[i]);
            return array;
        }
        function parseId(text) {
            return text.substring(1);
        }
        function generateId() {
            return 'three_default_' + count++;
        }
        function isEmpty(object) {
            return Object.keys(object).length === 0;
        }
        // asset
        function parseAsset(xml) {
            return {
                unit: parseAssetUnit(getElementsByTagName(xml, 'unit')[0]),
                upAxis: parseAssetUpAxis(getElementsByTagName(xml, 'up_axis')[0])
            };
        }
        function parseAssetUnit(xml) {
            if (xml !== undefined && xml.hasAttribute('meter') === true) return parseFloat(xml.getAttribute('meter'));
            else return 1; // default 1 meter
        }
        function parseAssetUpAxis(xml) {
            return xml !== undefined ? xml.textContent : 'Y_UP';
        }
        // library
        function parseLibrary(xml, libraryName, nodeName, parser) {
            const library = getElementsByTagName(xml, libraryName)[0];
            if (library !== undefined) {
                const elements = getElementsByTagName(library, nodeName);
                for(let i = 0; i < elements.length; i++)parser(elements[i]);
            }
        }
        function buildLibrary(data, builder) {
            for(const name in data){
                const object = data[name];
                object.build = builder(data[name]);
            }
        }
        // get
        function getBuild(data, builder) {
            if (data.build !== undefined) return data.build;
            data.build = builder(data);
            return data.build;
        }
        // animation
        function parseAnimation(xml) {
            const data = {
                sources: {},
                samplers: {},
                channels: {}
            };
            let hasChildren = false;
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                let id;
                switch(child.nodeName){
                    case 'source':
                        id = child.getAttribute('id');
                        data.sources[id] = parseSource(child);
                        break;
                    case 'sampler':
                        id = child.getAttribute('id');
                        data.samplers[id] = parseAnimationSampler(child);
                        break;
                    case 'channel':
                        id = child.getAttribute('target');
                        data.channels[id] = parseAnimationChannel(child);
                        break;
                    case 'animation':
                        // hierarchy of related animations
                        parseAnimation(child);
                        hasChildren = true;
                        break;
                    default:
                        console.log(child);
                }
            }
            if (hasChildren === false) // since 'id' attributes can be optional, it's necessary to generate a UUID for unqiue assignment
            library.animations[xml.getAttribute('id') || (0, $8TfIJ.MathUtils).generateUUID()] = data;
        }
        function parseAnimationSampler(xml) {
            const data = {
                inputs: {}
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'input':
                        const id = parseId(child.getAttribute('source'));
                        const semantic = child.getAttribute('semantic');
                        data.inputs[semantic] = id;
                        break;
                }
            }
            return data;
        }
        function parseAnimationChannel(xml) {
            const data = {};
            const target = xml.getAttribute('target');
            // parsing SID Addressing Syntax
            let parts = target.split('/');
            const id = parts.shift();
            let sid = parts.shift();
            // check selection syntax
            const arraySyntax = sid.indexOf('(') !== -1;
            const memberSyntax = sid.indexOf('.') !== -1;
            if (memberSyntax) {
                //  member selection access
                parts = sid.split('.');
                sid = parts.shift();
                data.member = parts.shift();
            } else if (arraySyntax) {
                // array-access syntax. can be used to express fields in one-dimensional vectors or two-dimensional matrices.
                const indices = sid.split('(');
                sid = indices.shift();
                for(let i = 0; i < indices.length; i++)indices[i] = parseInt(indices[i].replace(/\)/, ''));
                data.indices = indices;
            }
            data.id = id;
            data.sid = sid;
            data.arraySyntax = arraySyntax;
            data.memberSyntax = memberSyntax;
            data.sampler = parseId(xml.getAttribute('source'));
            return data;
        }
        function buildAnimation(data) {
            const tracks = [];
            const channels = data.channels;
            const samplers = data.samplers;
            const sources = data.sources;
            for(const target in channels)if (channels.hasOwnProperty(target)) {
                const channel = channels[target];
                const sampler = samplers[channel.sampler];
                const inputId = sampler.inputs.INPUT;
                const outputId = sampler.inputs.OUTPUT;
                const inputSource = sources[inputId];
                const outputSource = sources[outputId];
                const animation = buildAnimationChannel(channel, inputSource, outputSource);
                createKeyframeTracks(animation, tracks);
            }
            return tracks;
        }
        function getAnimation(id) {
            return getBuild(library.animations[id], buildAnimation);
        }
        function buildAnimationChannel(channel, inputSource, outputSource) {
            const node = library.nodes[channel.id];
            const object3D = getNode(node.id);
            const transform = node.transforms[channel.sid];
            const defaultMatrix = node.matrix.clone().transpose();
            let time, stride;
            let i, il, j, jl;
            const data = {};
            // the collada spec allows the animation of data in various ways.
            // depending on the transform type (matrix, translate, rotate, scale), we execute different logic
            switch(transform){
                case 'matrix':
                    for(i = 0, il = inputSource.array.length; i < il; i++){
                        time = inputSource.array[i];
                        stride = i * outputSource.stride;
                        if (data[time] === undefined) data[time] = {};
                        if (channel.arraySyntax === true) {
                            const value = outputSource.array[stride];
                            const index = channel.indices[0] + 4 * channel.indices[1];
                            data[time][index] = value;
                        } else for(j = 0, jl = outputSource.stride; j < jl; j++)data[time][j] = outputSource.array[stride + j];
                    }
                    break;
                case 'translate':
                    console.warn('THREE.ColladaLoader: Animation transform type "%s" not yet implemented.', transform);
                    break;
                case 'rotate':
                    console.warn('THREE.ColladaLoader: Animation transform type "%s" not yet implemented.', transform);
                    break;
                case 'scale':
                    console.warn('THREE.ColladaLoader: Animation transform type "%s" not yet implemented.', transform);
                    break;
            }
            const keyframes = prepareAnimationData(data, defaultMatrix);
            const animation = {
                name: object3D.uuid,
                keyframes: keyframes
            };
            return animation;
        }
        function prepareAnimationData(data, defaultMatrix) {
            const keyframes = [];
            // transfer data into a sortable array
            for(const time in data)keyframes.push({
                time: parseFloat(time),
                value: data[time]
            });
            // ensure keyframes are sorted by time
            keyframes.sort(ascending);
            // now we clean up all animation data, so we can use them for keyframe tracks
            for(let i = 0; i < 16; i++)transformAnimationData(keyframes, i, defaultMatrix.elements[i]);
            return keyframes;
            // array sort function
            function ascending(a, b) {
                return a.time - b.time;
            }
        }
        const position = new (0, $8TfIJ.Vector3)();
        const scale = new (0, $8TfIJ.Vector3)();
        const quaternion = new (0, $8TfIJ.Quaternion)();
        function createKeyframeTracks(animation, tracks) {
            const keyframes = animation.keyframes;
            const name = animation.name;
            const times = [];
            const positionData = [];
            const quaternionData = [];
            const scaleData = [];
            for(let i = 0, l = keyframes.length; i < l; i++){
                const keyframe = keyframes[i];
                const time = keyframe.time;
                const value = keyframe.value;
                matrix.fromArray(value).transpose();
                matrix.decompose(position, quaternion, scale);
                times.push(time);
                positionData.push(position.x, position.y, position.z);
                quaternionData.push(quaternion.x, quaternion.y, quaternion.z, quaternion.w);
                scaleData.push(scale.x, scale.y, scale.z);
            }
            if (positionData.length > 0) tracks.push(new (0, $8TfIJ.VectorKeyframeTrack)(name + '.position', times, positionData));
            if (quaternionData.length > 0) tracks.push(new (0, $8TfIJ.QuaternionKeyframeTrack)(name + '.quaternion', times, quaternionData));
            if (scaleData.length > 0) tracks.push(new (0, $8TfIJ.VectorKeyframeTrack)(name + '.scale', times, scaleData));
            return tracks;
        }
        function transformAnimationData(keyframes, property, defaultValue) {
            let keyframe;
            let empty = true;
            let i, l;
            // check, if values of a property are missing in our keyframes
            for(i = 0, l = keyframes.length; i < l; i++){
                keyframe = keyframes[i];
                if (keyframe.value[property] === undefined) keyframe.value[property] = null; // mark as missing
                else empty = false;
            }
            if (empty === true) // no values at all, so we set a default value
            for(i = 0, l = keyframes.length; i < l; i++){
                keyframe = keyframes[i];
                keyframe.value[property] = defaultValue;
            }
            else // filling gaps
            createMissingKeyframes(keyframes, property);
        }
        function createMissingKeyframes(keyframes, property) {
            let prev, next;
            for(let i = 0, l = keyframes.length; i < l; i++){
                const keyframe = keyframes[i];
                if (keyframe.value[property] === null) {
                    prev = getPrev(keyframes, i, property);
                    next = getNext(keyframes, i, property);
                    if (prev === null) {
                        keyframe.value[property] = next.value[property];
                        continue;
                    }
                    if (next === null) {
                        keyframe.value[property] = prev.value[property];
                        continue;
                    }
                    interpolate(keyframe, prev, next, property);
                }
            }
        }
        function getPrev(keyframes, i, property) {
            while(i >= 0){
                const keyframe = keyframes[i];
                if (keyframe.value[property] !== null) return keyframe;
                i--;
            }
            return null;
        }
        function getNext(keyframes, i, property) {
            while(i < keyframes.length){
                const keyframe = keyframes[i];
                if (keyframe.value[property] !== null) return keyframe;
                i++;
            }
            return null;
        }
        function interpolate(key, prev, next, property) {
            if (next.time - prev.time === 0) {
                key.value[property] = prev.value[property];
                return;
            }
            key.value[property] = (key.time - prev.time) * (next.value[property] - prev.value[property]) / (next.time - prev.time) + prev.value[property];
        }
        // animation clips
        function parseAnimationClip(xml) {
            const data = {
                name: xml.getAttribute('id') || 'default',
                start: parseFloat(xml.getAttribute('start') || 0),
                end: parseFloat(xml.getAttribute('end') || 0),
                animations: []
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'instance_animation':
                        data.animations.push(parseId(child.getAttribute('url')));
                        break;
                }
            }
            library.clips[xml.getAttribute('id')] = data;
        }
        function buildAnimationClip(data) {
            const tracks = [];
            const name = data.name;
            const duration = data.end - data.start || -1;
            const animations = data.animations;
            for(let i = 0, il = animations.length; i < il; i++){
                const animationTracks = getAnimation(animations[i]);
                for(let j = 0, jl = animationTracks.length; j < jl; j++)tracks.push(animationTracks[j]);
            }
            return new (0, $8TfIJ.AnimationClip)(name, duration, tracks);
        }
        function getAnimationClip(id) {
            return getBuild(library.clips[id], buildAnimationClip);
        }
        // controller
        function parseController(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'skin':
                        // there is exactly one skin per controller
                        data.id = parseId(child.getAttribute('source'));
                        data.skin = parseSkin(child);
                        break;
                    case 'morph':
                        data.id = parseId(child.getAttribute('source'));
                        console.warn('THREE.ColladaLoader: Morph target animation not supported yet.');
                        break;
                }
            }
            library.controllers[xml.getAttribute('id')] = data;
        }
        function parseSkin(xml) {
            const data = {
                sources: {}
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'bind_shape_matrix':
                        data.bindShapeMatrix = parseFloats(child.textContent);
                        break;
                    case 'source':
                        const id = child.getAttribute('id');
                        data.sources[id] = parseSource(child);
                        break;
                    case 'joints':
                        data.joints = parseJoints(child);
                        break;
                    case 'vertex_weights':
                        data.vertexWeights = parseVertexWeights(child);
                        break;
                }
            }
            return data;
        }
        function parseJoints(xml) {
            const data = {
                inputs: {}
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'input':
                        const semantic = child.getAttribute('semantic');
                        const id = parseId(child.getAttribute('source'));
                        data.inputs[semantic] = id;
                        break;
                }
            }
            return data;
        }
        function parseVertexWeights(xml) {
            const data = {
                inputs: {}
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'input':
                        const semantic = child.getAttribute('semantic');
                        const id = parseId(child.getAttribute('source'));
                        const offset = parseInt(child.getAttribute('offset'));
                        data.inputs[semantic] = {
                            id: id,
                            offset: offset
                        };
                        break;
                    case 'vcount':
                        data.vcount = parseInts(child.textContent);
                        break;
                    case 'v':
                        data.v = parseInts(child.textContent);
                        break;
                }
            }
            return data;
        }
        function buildController(data) {
            const build = {
                id: data.id
            };
            const geometry = library.geometries[build.id];
            if (data.skin !== undefined) {
                build.skin = buildSkin(data.skin);
                // we enhance the 'sources' property of the corresponding geometry with our skin data
                geometry.sources.skinIndices = build.skin.indices;
                geometry.sources.skinWeights = build.skin.weights;
            }
            return build;
        }
        function buildSkin(data) {
            const BONE_LIMIT = 4;
            const build = {
                joints: [],
                indices: {
                    array: [],
                    stride: BONE_LIMIT
                },
                weights: {
                    array: [],
                    stride: BONE_LIMIT
                }
            };
            const sources = data.sources;
            const vertexWeights = data.vertexWeights;
            const vcount = vertexWeights.vcount;
            const v = vertexWeights.v;
            const jointOffset = vertexWeights.inputs.JOINT.offset;
            const weightOffset = vertexWeights.inputs.WEIGHT.offset;
            const jointSource = data.sources[data.joints.inputs.JOINT];
            const inverseSource = data.sources[data.joints.inputs.INV_BIND_MATRIX];
            const weights = sources[vertexWeights.inputs.WEIGHT.id].array;
            let stride = 0;
            let i, j, l;
            // procces skin data for each vertex
            for(i = 0, l = vcount.length; i < l; i++){
                const jointCount = vcount[i]; // this is the amount of joints that affect a single vertex
                const vertexSkinData = [];
                for(j = 0; j < jointCount; j++){
                    const skinIndex = v[stride + jointOffset];
                    const weightId = v[stride + weightOffset];
                    const skinWeight = weights[weightId];
                    vertexSkinData.push({
                        index: skinIndex,
                        weight: skinWeight
                    });
                    stride += 2;
                }
                // we sort the joints in descending order based on the weights.
                // this ensures, we only procced the most important joints of the vertex
                vertexSkinData.sort(descending);
                // now we provide for each vertex a set of four index and weight values.
                // the order of the skin data matches the order of vertices
                for(j = 0; j < BONE_LIMIT; j++){
                    const d = vertexSkinData[j];
                    if (d !== undefined) {
                        build.indices.array.push(d.index);
                        build.weights.array.push(d.weight);
                    } else {
                        build.indices.array.push(0);
                        build.weights.array.push(0);
                    }
                }
            }
            // setup bind matrix
            if (data.bindShapeMatrix) build.bindMatrix = new (0, $8TfIJ.Matrix4)().fromArray(data.bindShapeMatrix).transpose();
            else build.bindMatrix = new (0, $8TfIJ.Matrix4)().identity();
            // process bones and inverse bind matrix data
            for(i = 0, l = jointSource.array.length; i < l; i++){
                const name = jointSource.array[i];
                const boneInverse = new (0, $8TfIJ.Matrix4)().fromArray(inverseSource.array, i * inverseSource.stride).transpose();
                build.joints.push({
                    name: name,
                    boneInverse: boneInverse
                });
            }
            return build;
            // array sort function
            function descending(a, b) {
                return b.weight - a.weight;
            }
        }
        function getController(id) {
            return getBuild(library.controllers[id], buildController);
        }
        // image
        function parseImage(xml) {
            const data = {
                init_from: getElementsByTagName(xml, 'init_from')[0].textContent
            };
            library.images[xml.getAttribute('id')] = data;
        }
        function buildImage(data) {
            if (data.build !== undefined) return data.build;
            return data.init_from;
        }
        function getImage(id) {
            const data = library.images[id];
            if (data !== undefined) return getBuild(data, buildImage);
            console.warn('THREE.ColladaLoader: Couldn\'t find image with ID:', id);
            return null;
        }
        // effect
        function parseEffect(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'profile_COMMON':
                        data.profile = parseEffectProfileCOMMON(child);
                        break;
                }
            }
            library.effects[xml.getAttribute('id')] = data;
        }
        function parseEffectProfileCOMMON(xml) {
            const data = {
                surfaces: {},
                samplers: {}
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'newparam':
                        parseEffectNewparam(child, data);
                        break;
                    case 'technique':
                        data.technique = parseEffectTechnique(child);
                        break;
                    case 'extra':
                        data.extra = parseEffectExtra(child);
                        break;
                }
            }
            return data;
        }
        function parseEffectNewparam(xml, data) {
            const sid = xml.getAttribute('sid');
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'surface':
                        data.surfaces[sid] = parseEffectSurface(child);
                        break;
                    case 'sampler2D':
                        data.samplers[sid] = parseEffectSampler(child);
                        break;
                }
            }
        }
        function parseEffectSurface(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'init_from':
                        data.init_from = child.textContent;
                        break;
                }
            }
            return data;
        }
        function parseEffectSampler(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'source':
                        data.source = child.textContent;
                        break;
                }
            }
            return data;
        }
        function parseEffectTechnique(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'constant':
                    case 'lambert':
                    case 'blinn':
                    case 'phong':
                        data.type = child.nodeName;
                        data.parameters = parseEffectParameters(child);
                        break;
                }
            }
            return data;
        }
        function parseEffectParameters(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'emission':
                    case 'diffuse':
                    case 'specular':
                    case 'bump':
                    case 'ambient':
                    case 'shininess':
                    case 'transparency':
                        data[child.nodeName] = parseEffectParameter(child);
                        break;
                    case 'transparent':
                        data[child.nodeName] = {
                            opaque: child.getAttribute('opaque'),
                            data: parseEffectParameter(child)
                        };
                        break;
                }
            }
            return data;
        }
        function parseEffectParameter(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'color':
                        data[child.nodeName] = parseFloats(child.textContent);
                        break;
                    case 'float':
                        data[child.nodeName] = parseFloat(child.textContent);
                        break;
                    case 'texture':
                        data[child.nodeName] = {
                            id: child.getAttribute('texture'),
                            extra: parseEffectParameterTexture(child)
                        };
                        break;
                }
            }
            return data;
        }
        function parseEffectParameterTexture(xml) {
            const data = {
                technique: {}
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'extra':
                        parseEffectParameterTextureExtra(child, data);
                        break;
                }
            }
            return data;
        }
        function parseEffectParameterTextureExtra(xml, data) {
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'technique':
                        parseEffectParameterTextureExtraTechnique(child, data);
                        break;
                }
            }
        }
        function parseEffectParameterTextureExtraTechnique(xml, data) {
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'repeatU':
                    case 'repeatV':
                    case 'offsetU':
                    case 'offsetV':
                        data.technique[child.nodeName] = parseFloat(child.textContent);
                        break;
                    case 'wrapU':
                    case 'wrapV':
                        // some files have values for wrapU/wrapV which become NaN via parseInt
                        if (child.textContent.toUpperCase() === 'TRUE') data.technique[child.nodeName] = 1;
                        else if (child.textContent.toUpperCase() === 'FALSE') data.technique[child.nodeName] = 0;
                        else data.technique[child.nodeName] = parseInt(child.textContent);
                        break;
                }
            }
        }
        function parseEffectExtra(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'technique':
                        data.technique = parseEffectExtraTechnique(child);
                        break;
                }
            }
            return data;
        }
        function parseEffectExtraTechnique(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'double_sided':
                        data[child.nodeName] = parseInt(child.textContent);
                        break;
                }
            }
            return data;
        }
        function buildEffect(data) {
            return data;
        }
        function getEffect(id) {
            return getBuild(library.effects[id], buildEffect);
        }
        // material
        function parseMaterial(xml) {
            const data = {
                name: xml.getAttribute('name')
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'instance_effect':
                        data.url = parseId(child.getAttribute('url'));
                        break;
                }
            }
            library.materials[xml.getAttribute('id')] = data;
        }
        function getTextureLoader(image) {
            let loader;
            let extension = image.slice((image.lastIndexOf('.') - 1 >>> 0) + 2); // http://www.jstips.co/en/javascript/get-file-extension/
            extension = extension.toLowerCase();
            switch(extension){
                case 'tga':
                    loader = tgaLoader;
                    break;
                default:
                    loader = textureLoader;
            }
            return loader;
        }
        function buildMaterial(data) {
            const effect = getEffect(data.url);
            const technique = effect.profile.technique;
            const extra = effect.profile.extra;
            let material;
            switch(technique.type){
                case 'phong':
                case 'blinn':
                    material = new (0, $8TfIJ.MeshPhongMaterial)();
                    break;
                case 'lambert':
                    material = new (0, $8TfIJ.MeshLambertMaterial)();
                    break;
                default:
                    material = new (0, $8TfIJ.MeshBasicMaterial)();
                    break;
            }
            material.name = data.name || '';
            function getTexture(textureObject) {
                const sampler = effect.profile.samplers[textureObject.id];
                let image = null;
                // get image
                if (sampler !== undefined) {
                    const surface = effect.profile.surfaces[sampler.source];
                    image = getImage(surface.init_from);
                } else {
                    console.warn('THREE.ColladaLoader: Undefined sampler. Access image directly (see #12530).');
                    image = getImage(textureObject.id);
                }
                // create texture if image is avaiable
                if (image !== null) {
                    const loader = getTextureLoader(image);
                    if (loader !== undefined) {
                        const texture = loader.load(image);
                        const extra = textureObject.extra;
                        if (extra !== undefined && extra.technique !== undefined && isEmpty(extra.technique) === false) {
                            const technique = extra.technique;
                            texture.wrapS = technique.wrapU ? (0, $8TfIJ.RepeatWrapping) : (0, $8TfIJ.ClampToEdgeWrapping);
                            texture.wrapT = technique.wrapV ? (0, $8TfIJ.RepeatWrapping) : (0, $8TfIJ.ClampToEdgeWrapping);
                            texture.offset.set(technique.offsetU || 0, technique.offsetV || 0);
                            texture.repeat.set(technique.repeatU || 1, technique.repeatV || 1);
                        } else {
                            texture.wrapS = (0, $8TfIJ.RepeatWrapping);
                            texture.wrapT = (0, $8TfIJ.RepeatWrapping);
                        }
                        return texture;
                    } else {
                        console.warn('THREE.ColladaLoader: Loader for texture %s not found.', image);
                        return null;
                    }
                } else {
                    console.warn('THREE.ColladaLoader: Couldn\'t create texture with ID:', textureObject.id);
                    return null;
                }
            }
            const parameters = technique.parameters;
            for(const key in parameters){
                const parameter = parameters[key];
                switch(key){
                    case 'diffuse':
                        if (parameter.color) material.color.fromArray(parameter.color);
                        if (parameter.texture) material.map = getTexture(parameter.texture);
                        break;
                    case 'specular':
                        if (parameter.color && material.specular) material.specular.fromArray(parameter.color);
                        if (parameter.texture) material.specularMap = getTexture(parameter.texture);
                        break;
                    case 'bump':
                        if (parameter.texture) material.normalMap = getTexture(parameter.texture);
                        break;
                    case 'ambient':
                        if (parameter.texture) material.lightMap = getTexture(parameter.texture);
                        break;
                    case 'shininess':
                        if (parameter.float && material.shininess) material.shininess = parameter.float;
                        break;
                    case 'emission':
                        if (parameter.color && material.emissive) material.emissive.fromArray(parameter.color);
                        if (parameter.texture) material.emissiveMap = getTexture(parameter.texture);
                        break;
                }
            }
            //
            let transparent = parameters['transparent'];
            let transparency = parameters['transparency'];
            // <transparency> does not exist but <transparent>
            if (transparency === undefined && transparent) transparency = {
                float: 1
            };
            // <transparent> does not exist but <transparency>
            if (transparent === undefined && transparency) transparent = {
                opaque: 'A_ONE',
                data: {
                    color: [
                        1,
                        1,
                        1,
                        1
                    ]
                }
            };
            if (transparent && transparency) {
                // handle case if a texture exists but no color
                if (transparent.data.texture) // we do not set an alpha map (see #13792)
                material.transparent = true;
                else {
                    const color = transparent.data.color;
                    switch(transparent.opaque){
                        case 'A_ONE':
                            material.opacity = color[3] * transparency.float;
                            break;
                        case 'RGB_ZERO':
                            material.opacity = 1 - color[0] * transparency.float;
                            break;
                        case 'A_ZERO':
                            material.opacity = 1 - color[3] * transparency.float;
                            break;
                        case 'RGB_ONE':
                            material.opacity = color[0] * transparency.float;
                            break;
                        default:
                            console.warn('THREE.ColladaLoader: Invalid opaque type "%s" of transparent tag.', transparent.opaque);
                    }
                    if (material.opacity < 1) material.transparent = true;
                }
            }
            //
            if (extra !== undefined && extra.technique !== undefined && extra.technique.double_sided === 1) material.side = (0, $8TfIJ.DoubleSide);
            return material;
        }
        function getMaterial(id) {
            return getBuild(library.materials[id], buildMaterial);
        }
        // camera
        function parseCamera(xml) {
            const data = {
                name: xml.getAttribute('name')
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'optics':
                        data.optics = parseCameraOptics(child);
                        break;
                }
            }
            library.cameras[xml.getAttribute('id')] = data;
        }
        function parseCameraOptics(xml) {
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                switch(child.nodeName){
                    case 'technique_common':
                        return parseCameraTechnique(child);
                }
            }
            return {};
        }
        function parseCameraTechnique(xml) {
            const data = {};
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                switch(child.nodeName){
                    case 'perspective':
                    case 'orthographic':
                        data.technique = child.nodeName;
                        data.parameters = parseCameraParameters(child);
                        break;
                }
            }
            return data;
        }
        function parseCameraParameters(xml) {
            const data = {};
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                switch(child.nodeName){
                    case 'xfov':
                    case 'yfov':
                    case 'xmag':
                    case 'ymag':
                    case 'znear':
                    case 'zfar':
                    case 'aspect_ratio':
                        data[child.nodeName] = parseFloat(child.textContent);
                        break;
                }
            }
            return data;
        }
        function buildCamera(data) {
            let camera;
            switch(data.optics.technique){
                case 'perspective':
                    camera = new (0, $8TfIJ.PerspectiveCamera)(data.optics.parameters.yfov, data.optics.parameters.aspect_ratio, data.optics.parameters.znear, data.optics.parameters.zfar);
                    break;
                case 'orthographic':
                    let ymag = data.optics.parameters.ymag;
                    let xmag = data.optics.parameters.xmag;
                    const aspectRatio = data.optics.parameters.aspect_ratio;
                    xmag = xmag === undefined ? ymag * aspectRatio : xmag;
                    ymag = ymag === undefined ? xmag / aspectRatio : ymag;
                    xmag *= 0.5;
                    ymag *= 0.5;
                    camera = new (0, $8TfIJ.OrthographicCamera)(-xmag, xmag, ymag, -ymag, data.optics.parameters.znear, data.optics.parameters.zfar);
                    break;
                default:
                    camera = new (0, $8TfIJ.PerspectiveCamera)();
                    break;
            }
            camera.name = data.name || '';
            return camera;
        }
        function getCamera(id) {
            const data = library.cameras[id];
            if (data !== undefined) return getBuild(data, buildCamera);
            console.warn('THREE.ColladaLoader: Couldn\'t find camera with ID:', id);
            return null;
        }
        // light
        function parseLight(xml) {
            let data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'technique_common':
                        data = parseLightTechnique(child);
                        break;
                }
            }
            library.lights[xml.getAttribute('id')] = data;
        }
        function parseLightTechnique(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'directional':
                    case 'point':
                    case 'spot':
                    case 'ambient':
                        data.technique = child.nodeName;
                        data.parameters = parseLightParameters(child);
                }
            }
            return data;
        }
        function parseLightParameters(xml) {
            const data = {};
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'color':
                        const array = parseFloats(child.textContent);
                        data.color = new (0, $8TfIJ.Color)().fromArray(array);
                        break;
                    case 'falloff_angle':
                        data.falloffAngle = parseFloat(child.textContent);
                        break;
                    case 'quadratic_attenuation':
                        const f = parseFloat(child.textContent);
                        data.distance = f ? Math.sqrt(1 / f) : 0;
                        break;
                }
            }
            return data;
        }
        function buildLight(data) {
            let light;
            switch(data.technique){
                case 'directional':
                    light = new (0, $8TfIJ.DirectionalLight)();
                    break;
                case 'point':
                    light = new (0, $8TfIJ.PointLight)();
                    break;
                case 'spot':
                    light = new (0, $8TfIJ.SpotLight)();
                    break;
                case 'ambient':
                    light = new (0, $8TfIJ.AmbientLight)();
                    break;
            }
            if (data.parameters.color) light.color.copy(data.parameters.color);
            if (data.parameters.distance) light.distance = data.parameters.distance;
            return light;
        }
        function getLight(id) {
            const data = library.lights[id];
            if (data !== undefined) return getBuild(data, buildLight);
            console.warn('THREE.ColladaLoader: Couldn\'t find light with ID:', id);
            return null;
        }
        // geometry
        function parseGeometry(xml) {
            const data = {
                name: xml.getAttribute('name'),
                sources: {},
                vertices: {},
                primitives: []
            };
            const mesh = getElementsByTagName(xml, 'mesh')[0];
            // the following tags inside geometry are not supported yet (see https://github.com/mrdoob/three.js/pull/12606): convex_mesh, spline, brep
            if (mesh === undefined) return;
            for(let i = 0; i < mesh.childNodes.length; i++){
                const child = mesh.childNodes[i];
                if (child.nodeType !== 1) continue;
                const id = child.getAttribute('id');
                switch(child.nodeName){
                    case 'source':
                        data.sources[id] = parseSource(child);
                        break;
                    case 'vertices':
                        // data.sources[ id ] = data.sources[ parseId( getElementsByTagName( child, 'input' )[ 0 ].getAttribute( 'source' ) ) ];
                        data.vertices = parseGeometryVertices(child);
                        break;
                    case 'polygons':
                        console.warn('THREE.ColladaLoader: Unsupported primitive type: ', child.nodeName);
                        break;
                    case 'lines':
                    case 'linestrips':
                    case 'polylist':
                    case 'triangles':
                        data.primitives.push(parseGeometryPrimitive(child));
                        break;
                    default:
                        console.log(child);
                }
            }
            library.geometries[xml.getAttribute('id')] = data;
        }
        function parseSource(xml) {
            const data = {
                array: [],
                stride: 3
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'float_array':
                        data.array = parseFloats(child.textContent);
                        break;
                    case 'Name_array':
                        data.array = parseStrings(child.textContent);
                        break;
                    case 'technique_common':
                        const accessor = getElementsByTagName(child, 'accessor')[0];
                        if (accessor !== undefined) data.stride = parseInt(accessor.getAttribute('stride'));
                        break;
                }
            }
            return data;
        }
        function parseGeometryVertices(xml) {
            const data = {};
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                data[child.getAttribute('semantic')] = parseId(child.getAttribute('source'));
            }
            return data;
        }
        function parseGeometryPrimitive(xml) {
            const primitive = {
                type: xml.nodeName,
                material: xml.getAttribute('material'),
                count: parseInt(xml.getAttribute('count')),
                inputs: {},
                stride: 0,
                hasUV: false
            };
            for(let i = 0, l = xml.childNodes.length; i < l; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'input':
                        const id = parseId(child.getAttribute('source'));
                        const semantic = child.getAttribute('semantic');
                        const offset = parseInt(child.getAttribute('offset'));
                        const set = parseInt(child.getAttribute('set'));
                        const inputname = set > 0 ? semantic + set : semantic;
                        primitive.inputs[inputname] = {
                            id: id,
                            offset: offset
                        };
                        primitive.stride = Math.max(primitive.stride, offset + 1);
                        if (semantic === 'TEXCOORD') primitive.hasUV = true;
                        break;
                    case 'vcount':
                        primitive.vcount = parseInts(child.textContent);
                        break;
                    case 'p':
                        primitive.p = parseInts(child.textContent);
                        break;
                }
            }
            return primitive;
        }
        function groupPrimitives(primitives) {
            const build = {};
            for(let i = 0; i < primitives.length; i++){
                const primitive = primitives[i];
                if (build[primitive.type] === undefined) build[primitive.type] = [];
                build[primitive.type].push(primitive);
            }
            return build;
        }
        function checkUVCoordinates(primitives) {
            let count = 0;
            for(let i = 0, l = primitives.length; i < l; i++){
                const primitive = primitives[i];
                if (primitive.hasUV === true) count++;
            }
            if (count > 0 && count < primitives.length) primitives.uvsNeedsFix = true;
        }
        function buildGeometry(data) {
            const build = {};
            const sources = data.sources;
            const vertices = data.vertices;
            const primitives = data.primitives;
            if (primitives.length === 0) return {};
            // our goal is to create one buffer geometry for a single type of primitives
            // first, we group all primitives by their type
            const groupedPrimitives = groupPrimitives(primitives);
            for(const type in groupedPrimitives){
                const primitiveType = groupedPrimitives[type];
                // second, ensure consistent uv coordinates for each type of primitives (polylist,triangles or lines)
                checkUVCoordinates(primitiveType);
                // third, create a buffer geometry for each type of primitives
                build[type] = buildGeometryType(primitiveType, sources, vertices);
            }
            return build;
        }
        function buildGeometryType(primitives, sources, vertices) {
            const build = {};
            const position = {
                array: [],
                stride: 0
            };
            const normal = {
                array: [],
                stride: 0
            };
            const uv = {
                array: [],
                stride: 0
            };
            const uv2 = {
                array: [],
                stride: 0
            };
            const color = {
                array: [],
                stride: 0
            };
            const skinIndex = {
                array: [],
                stride: 4
            };
            const skinWeight = {
                array: [],
                stride: 4
            };
            const geometry = new (0, $8TfIJ.BufferGeometry)();
            const materialKeys = [];
            let start = 0;
            for(let p = 0; p < primitives.length; p++){
                const primitive = primitives[p];
                const inputs = primitive.inputs;
                // groups
                let count = 0;
                switch(primitive.type){
                    case 'lines':
                    case 'linestrips':
                        count = primitive.count * 2;
                        break;
                    case 'triangles':
                        count = primitive.count * 3;
                        break;
                    case 'polylist':
                        for(let g = 0; g < primitive.count; g++){
                            const vc = primitive.vcount[g];
                            switch(vc){
                                case 3:
                                    count += 3; // single triangle
                                    break;
                                case 4:
                                    count += 6; // quad, subdivided into two triangles
                                    break;
                                default:
                                    count += (vc - 2) * 3; // polylist with more than four vertices
                                    break;
                            }
                        }
                        break;
                    default:
                        console.warn('THREE.ColladaLoader: Unknow primitive type:', primitive.type);
                }
                geometry.addGroup(start, count, p);
                start += count;
                // material
                if (primitive.material) materialKeys.push(primitive.material);
                // geometry data
                for(const name in inputs){
                    const input = inputs[name];
                    switch(name){
                        case 'VERTEX':
                            for(const key in vertices){
                                const id = vertices[key];
                                switch(key){
                                    case 'POSITION':
                                        const prevLength = position.array.length;
                                        buildGeometryData(primitive, sources[id], input.offset, position.array);
                                        position.stride = sources[id].stride;
                                        if (sources.skinWeights && sources.skinIndices) {
                                            buildGeometryData(primitive, sources.skinIndices, input.offset, skinIndex.array);
                                            buildGeometryData(primitive, sources.skinWeights, input.offset, skinWeight.array);
                                        }
                                        // see #3803
                                        if (primitive.hasUV === false && primitives.uvsNeedsFix === true) {
                                            const count = (position.array.length - prevLength) / position.stride;
                                            for(let i = 0; i < count; i++)// fill missing uv coordinates
                                            uv.array.push(0, 0);
                                        }
                                        break;
                                    case 'NORMAL':
                                        buildGeometryData(primitive, sources[id], input.offset, normal.array);
                                        normal.stride = sources[id].stride;
                                        break;
                                    case 'COLOR':
                                        buildGeometryData(primitive, sources[id], input.offset, color.array);
                                        color.stride = sources[id].stride;
                                        break;
                                    case 'TEXCOORD':
                                        buildGeometryData(primitive, sources[id], input.offset, uv.array);
                                        uv.stride = sources[id].stride;
                                        break;
                                    case 'TEXCOORD1':
                                        buildGeometryData(primitive, sources[id], input.offset, uv2.array);
                                        uv.stride = sources[id].stride;
                                        break;
                                    default:
                                        console.warn('THREE.ColladaLoader: Semantic "%s" not handled in geometry build process.', key);
                                }
                            }
                            break;
                        case 'NORMAL':
                            buildGeometryData(primitive, sources[input.id], input.offset, normal.array);
                            normal.stride = sources[input.id].stride;
                            break;
                        case 'COLOR':
                            buildGeometryData(primitive, sources[input.id], input.offset, color.array);
                            color.stride = sources[input.id].stride;
                            break;
                        case 'TEXCOORD':
                            buildGeometryData(primitive, sources[input.id], input.offset, uv.array);
                            uv.stride = sources[input.id].stride;
                            break;
                        case 'TEXCOORD1':
                            buildGeometryData(primitive, sources[input.id], input.offset, uv2.array);
                            uv2.stride = sources[input.id].stride;
                            break;
                    }
                }
            }
            // build geometry
            if (position.array.length > 0) geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(position.array, position.stride));
            if (normal.array.length > 0) geometry.setAttribute('normal', new (0, $8TfIJ.Float32BufferAttribute)(normal.array, normal.stride));
            if (color.array.length > 0) geometry.setAttribute('color', new (0, $8TfIJ.Float32BufferAttribute)(color.array, color.stride));
            if (uv.array.length > 0) geometry.setAttribute('uv', new (0, $8TfIJ.Float32BufferAttribute)(uv.array, uv.stride));
            if (uv2.array.length > 0) geometry.setAttribute('uv2', new (0, $8TfIJ.Float32BufferAttribute)(uv2.array, uv2.stride));
            if (skinIndex.array.length > 0) geometry.setAttribute('skinIndex', new (0, $8TfIJ.Float32BufferAttribute)(skinIndex.array, skinIndex.stride));
            if (skinWeight.array.length > 0) geometry.setAttribute('skinWeight', new (0, $8TfIJ.Float32BufferAttribute)(skinWeight.array, skinWeight.stride));
            build.data = geometry;
            build.type = primitives[0].type;
            build.materialKeys = materialKeys;
            return build;
        }
        function buildGeometryData(primitive, source, offset, array) {
            const indices = primitive.p;
            const stride = primitive.stride;
            const vcount = primitive.vcount;
            function pushVector(i) {
                let index = indices[i + offset] * sourceStride;
                const length = index + sourceStride;
                for(; index < length; index++)array.push(sourceArray[index]);
            }
            const sourceArray = source.array;
            const sourceStride = source.stride;
            if (primitive.vcount !== undefined) {
                let index = 0;
                for(let i = 0, l = vcount.length; i < l; i++){
                    const count = vcount[i];
                    if (count === 4) {
                        const a = index + stride * 0;
                        const b = index + stride * 1;
                        const c = index + stride * 2;
                        const d = index + stride * 3;
                        pushVector(a);
                        pushVector(b);
                        pushVector(d);
                        pushVector(b);
                        pushVector(c);
                        pushVector(d);
                    } else if (count === 3) {
                        const a = index + stride * 0;
                        const b = index + stride * 1;
                        const c = index + stride * 2;
                        pushVector(a);
                        pushVector(b);
                        pushVector(c);
                    } else if (count > 4) for(let k = 1, kl = count - 2; k <= kl; k++){
                        const a = index + stride * 0;
                        const b = index + stride * k;
                        const c = index + stride * (k + 1);
                        pushVector(a);
                        pushVector(b);
                        pushVector(c);
                    }
                    index += stride * count;
                }
            } else for(let i = 0, l = indices.length; i < l; i += stride)pushVector(i);
        }
        function getGeometry(id) {
            return getBuild(library.geometries[id], buildGeometry);
        }
        // kinematics
        function parseKinematicsModel(xml) {
            const data = {
                name: xml.getAttribute('name') || '',
                joints: {},
                links: []
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'technique_common':
                        parseKinematicsTechniqueCommon(child, data);
                        break;
                }
            }
            library.kinematicsModels[xml.getAttribute('id')] = data;
        }
        function buildKinematicsModel(data) {
            if (data.build !== undefined) return data.build;
            return data;
        }
        function getKinematicsModel(id) {
            return getBuild(library.kinematicsModels[id], buildKinematicsModel);
        }
        function parseKinematicsTechniqueCommon(xml, data) {
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'joint':
                        data.joints[child.getAttribute('sid')] = parseKinematicsJoint(child);
                        break;
                    case 'link':
                        data.links.push(parseKinematicsLink(child));
                        break;
                }
            }
        }
        function parseKinematicsJoint(xml) {
            let data;
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'prismatic':
                    case 'revolute':
                        data = parseKinematicsJointParameter(child);
                        break;
                }
            }
            return data;
        }
        function parseKinematicsJointParameter(xml) {
            const data = {
                sid: xml.getAttribute('sid'),
                name: xml.getAttribute('name') || '',
                axis: new (0, $8TfIJ.Vector3)(),
                limits: {
                    min: 0,
                    max: 0
                },
                type: xml.nodeName,
                static: false,
                zeroPosition: 0,
                middlePosition: 0
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'axis':
                        const array = parseFloats(child.textContent);
                        data.axis.fromArray(array);
                        break;
                    case 'limits':
                        const max = child.getElementsByTagName('max')[0];
                        const min = child.getElementsByTagName('min')[0];
                        data.limits.max = parseFloat(max.textContent);
                        data.limits.min = parseFloat(min.textContent);
                        break;
                }
            }
            // if min is equal to or greater than max, consider the joint static
            if (data.limits.min >= data.limits.max) data.static = true;
            // calculate middle position
            data.middlePosition = (data.limits.min + data.limits.max) / 2.0;
            return data;
        }
        function parseKinematicsLink(xml) {
            const data = {
                sid: xml.getAttribute('sid'),
                name: xml.getAttribute('name') || '',
                attachments: [],
                transforms: []
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'attachment_full':
                        data.attachments.push(parseKinematicsAttachment(child));
                        break;
                    case 'matrix':
                    case 'translate':
                    case 'rotate':
                        data.transforms.push(parseKinematicsTransform(child));
                        break;
                }
            }
            return data;
        }
        function parseKinematicsAttachment(xml) {
            const data = {
                joint: xml.getAttribute('joint').split('/').pop(),
                transforms: [],
                links: []
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'link':
                        data.links.push(parseKinematicsLink(child));
                        break;
                    case 'matrix':
                    case 'translate':
                    case 'rotate':
                        data.transforms.push(parseKinematicsTransform(child));
                        break;
                }
            }
            return data;
        }
        function parseKinematicsTransform(xml) {
            const data = {
                type: xml.nodeName
            };
            const array = parseFloats(xml.textContent);
            switch(data.type){
                case 'matrix':
                    data.obj = new (0, $8TfIJ.Matrix4)();
                    data.obj.fromArray(array).transpose();
                    break;
                case 'translate':
                    data.obj = new (0, $8TfIJ.Vector3)();
                    data.obj.fromArray(array);
                    break;
                case 'rotate':
                    data.obj = new (0, $8TfIJ.Vector3)();
                    data.obj.fromArray(array);
                    data.angle = (0, $8TfIJ.MathUtils).degToRad(array[3]);
                    break;
            }
            return data;
        }
        // physics
        function parsePhysicsModel(xml) {
            const data = {
                name: xml.getAttribute('name') || '',
                rigidBodies: {}
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'rigid_body':
                        data.rigidBodies[child.getAttribute('name')] = {};
                        parsePhysicsRigidBody(child, data.rigidBodies[child.getAttribute('name')]);
                        break;
                }
            }
            library.physicsModels[xml.getAttribute('id')] = data;
        }
        function parsePhysicsRigidBody(xml, data) {
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'technique_common':
                        parsePhysicsTechniqueCommon(child, data);
                        break;
                }
            }
        }
        function parsePhysicsTechniqueCommon(xml, data) {
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'inertia':
                        data.inertia = parseFloats(child.textContent);
                        break;
                    case 'mass':
                        data.mass = parseFloats(child.textContent)[0];
                        break;
                }
            }
        }
        // scene
        function parseKinematicsScene(xml) {
            const data = {
                bindJointAxis: []
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'bind_joint_axis':
                        data.bindJointAxis.push(parseKinematicsBindJointAxis(child));
                        break;
                }
            }
            library.kinematicsScenes[parseId(xml.getAttribute('url'))] = data;
        }
        function parseKinematicsBindJointAxis(xml) {
            const data = {
                target: xml.getAttribute('target').split('/').pop()
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                switch(child.nodeName){
                    case 'axis':
                        const param = child.getElementsByTagName('param')[0];
                        data.axis = param.textContent;
                        const tmpJointIndex = data.axis.split('inst_').pop().split('axis')[0];
                        data.jointIndex = tmpJointIndex.substr(0, tmpJointIndex.length - 1);
                        break;
                }
            }
            return data;
        }
        function buildKinematicsScene(data) {
            if (data.build !== undefined) return data.build;
            return data;
        }
        function getKinematicsScene(id) {
            return getBuild(library.kinematicsScenes[id], buildKinematicsScene);
        }
        function setupKinematics() {
            const kinematicsModelId = Object.keys(library.kinematicsModels)[0];
            const kinematicsSceneId = Object.keys(library.kinematicsScenes)[0];
            const visualSceneId = Object.keys(library.visualScenes)[0];
            if (kinematicsModelId === undefined || kinematicsSceneId === undefined) return;
            const kinematicsModel = getKinematicsModel(kinematicsModelId);
            const kinematicsScene = getKinematicsScene(kinematicsSceneId);
            const visualScene = getVisualScene(visualSceneId);
            const bindJointAxis = kinematicsScene.bindJointAxis;
            const jointMap = {};
            for(let i = 0, l = bindJointAxis.length; i < l; i++){
                const axis = bindJointAxis[i];
                // the result of the following query is an element of type 'translate', 'rotate','scale' or 'matrix'
                const targetElement = collada.querySelector('[sid="' + axis.target + '"]');
                if (targetElement) {
                    // get the parent of the transform element
                    const parentVisualElement = targetElement.parentElement;
                    // connect the joint of the kinematics model with the element in the visual scene
                    connect(axis.jointIndex, parentVisualElement);
                }
            }
            function connect(jointIndex, visualElement) {
                const visualElementName = visualElement.getAttribute('name');
                const joint = kinematicsModel.joints[jointIndex];
                visualScene.traverse(function(object) {
                    if (object.name === visualElementName) jointMap[jointIndex] = {
                        object: object,
                        transforms: buildTransformList(visualElement),
                        joint: joint,
                        position: joint.zeroPosition
                    };
                });
            }
            const m0 = new (0, $8TfIJ.Matrix4)();
            kinematics = {
                joints: kinematicsModel && kinematicsModel.joints,
                getJointValue: function(jointIndex) {
                    const jointData = jointMap[jointIndex];
                    if (jointData) return jointData.position;
                    else console.warn('THREE.ColladaLoader: Joint ' + jointIndex + ' doesn\'t exist.');
                },
                setJointValue: function(jointIndex, value) {
                    const jointData = jointMap[jointIndex];
                    if (jointData) {
                        const joint = jointData.joint;
                        if (value > joint.limits.max || value < joint.limits.min) console.warn('THREE.ColladaLoader: Joint ' + jointIndex + ' value ' + value + ' outside of limits (min: ' + joint.limits.min + ', max: ' + joint.limits.max + ').');
                        else if (joint.static) console.warn('THREE.ColladaLoader: Joint ' + jointIndex + ' is static.');
                        else {
                            const object = jointData.object;
                            const axis = joint.axis;
                            const transforms = jointData.transforms;
                            matrix.identity();
                            // each update, we have to apply all transforms in the correct order
                            for(let i = 0; i < transforms.length; i++){
                                const transform = transforms[i];
                                // if there is a connection of the transform node with a joint, apply the joint value
                                if (transform.sid && transform.sid.indexOf(jointIndex) !== -1) switch(joint.type){
                                    case 'revolute':
                                        matrix.multiply(m0.makeRotationAxis(axis, (0, $8TfIJ.MathUtils).degToRad(value)));
                                        break;
                                    case 'prismatic':
                                        matrix.multiply(m0.makeTranslation(axis.x * value, axis.y * value, axis.z * value));
                                        break;
                                    default:
                                        console.warn('THREE.ColladaLoader: Unknown joint type: ' + joint.type);
                                        break;
                                }
                                else switch(transform.type){
                                    case 'matrix':
                                        matrix.multiply(transform.obj);
                                        break;
                                    case 'translate':
                                        matrix.multiply(m0.makeTranslation(transform.obj.x, transform.obj.y, transform.obj.z));
                                        break;
                                    case 'scale':
                                        matrix.scale(transform.obj);
                                        break;
                                    case 'rotate':
                                        matrix.multiply(m0.makeRotationAxis(transform.obj, transform.angle));
                                        break;
                                }
                            }
                            object.matrix.copy(matrix);
                            object.matrix.decompose(object.position, object.quaternion, object.scale);
                            jointMap[jointIndex].position = value;
                        }
                    } else console.log('THREE.ColladaLoader: ' + jointIndex + ' does not exist.');
                }
            };
        }
        function buildTransformList(node) {
            const transforms = [];
            const xml = collada.querySelector('[id="' + node.id + '"]');
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                let array, vector;
                switch(child.nodeName){
                    case 'matrix':
                        array = parseFloats(child.textContent);
                        const matrix = new (0, $8TfIJ.Matrix4)().fromArray(array).transpose();
                        transforms.push({
                            sid: child.getAttribute('sid'),
                            type: child.nodeName,
                            obj: matrix
                        });
                        break;
                    case 'translate':
                    case 'scale':
                        array = parseFloats(child.textContent);
                        vector = new (0, $8TfIJ.Vector3)().fromArray(array);
                        transforms.push({
                            sid: child.getAttribute('sid'),
                            type: child.nodeName,
                            obj: vector
                        });
                        break;
                    case 'rotate':
                        array = parseFloats(child.textContent);
                        vector = new (0, $8TfIJ.Vector3)().fromArray(array);
                        const angle = (0, $8TfIJ.MathUtils).degToRad(array[3]);
                        transforms.push({
                            sid: child.getAttribute('sid'),
                            type: child.nodeName,
                            obj: vector,
                            angle: angle
                        });
                        break;
                }
            }
            return transforms;
        }
        // nodes
        function prepareNodes(xml) {
            const elements = xml.getElementsByTagName('node');
            // ensure all node elements have id attributes
            for(let i = 0; i < elements.length; i++){
                const element = elements[i];
                if (element.hasAttribute('id') === false) element.setAttribute('id', generateId());
            }
        }
        const matrix = new (0, $8TfIJ.Matrix4)();
        const vector = new (0, $8TfIJ.Vector3)();
        function parseNode(xml) {
            const data = {
                name: xml.getAttribute('name') || '',
                type: xml.getAttribute('type'),
                id: xml.getAttribute('id'),
                sid: xml.getAttribute('sid'),
                matrix: new (0, $8TfIJ.Matrix4)(),
                nodes: [],
                instanceCameras: [],
                instanceControllers: [],
                instanceLights: [],
                instanceGeometries: [],
                instanceNodes: [],
                transforms: {}
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                if (child.nodeType !== 1) continue;
                let array;
                switch(child.nodeName){
                    case 'node':
                        data.nodes.push(child.getAttribute('id'));
                        parseNode(child);
                        break;
                    case 'instance_camera':
                        data.instanceCameras.push(parseId(child.getAttribute('url')));
                        break;
                    case 'instance_controller':
                        data.instanceControllers.push(parseNodeInstance(child));
                        break;
                    case 'instance_light':
                        data.instanceLights.push(parseId(child.getAttribute('url')));
                        break;
                    case 'instance_geometry':
                        data.instanceGeometries.push(parseNodeInstance(child));
                        break;
                    case 'instance_node':
                        data.instanceNodes.push(parseId(child.getAttribute('url')));
                        break;
                    case 'matrix':
                        array = parseFloats(child.textContent);
                        data.matrix.multiply(matrix.fromArray(array).transpose());
                        data.transforms[child.getAttribute('sid')] = child.nodeName;
                        break;
                    case 'translate':
                        array = parseFloats(child.textContent);
                        vector.fromArray(array);
                        data.matrix.multiply(matrix.makeTranslation(vector.x, vector.y, vector.z));
                        data.transforms[child.getAttribute('sid')] = child.nodeName;
                        break;
                    case 'rotate':
                        array = parseFloats(child.textContent);
                        const angle = (0, $8TfIJ.MathUtils).degToRad(array[3]);
                        data.matrix.multiply(matrix.makeRotationAxis(vector.fromArray(array), angle));
                        data.transforms[child.getAttribute('sid')] = child.nodeName;
                        break;
                    case 'scale':
                        array = parseFloats(child.textContent);
                        data.matrix.scale(vector.fromArray(array));
                        data.transforms[child.getAttribute('sid')] = child.nodeName;
                        break;
                    case 'extra':
                        break;
                    default:
                        console.log(child);
                }
            }
            if (hasNode(data.id)) console.warn('THREE.ColladaLoader: There is already a node with ID %s. Exclude current node from further processing.', data.id);
            else library.nodes[data.id] = data;
            return data;
        }
        function parseNodeInstance(xml) {
            const data = {
                id: parseId(xml.getAttribute('url')),
                materials: {},
                skeletons: []
            };
            for(let i = 0; i < xml.childNodes.length; i++){
                const child = xml.childNodes[i];
                switch(child.nodeName){
                    case 'bind_material':
                        const instances = child.getElementsByTagName('instance_material');
                        for(let j = 0; j < instances.length; j++){
                            const instance = instances[j];
                            const symbol = instance.getAttribute('symbol');
                            const target = instance.getAttribute('target');
                            data.materials[symbol] = parseId(target);
                        }
                        break;
                    case 'skeleton':
                        data.skeletons.push(parseId(child.textContent));
                        break;
                    default:
                        break;
                }
            }
            return data;
        }
        function buildSkeleton(skeletons, joints) {
            const boneData = [];
            const sortedBoneData = [];
            let i, j, data;
            // a skeleton can have multiple root bones. collada expresses this
            // situtation with multiple "skeleton" tags per controller instance
            for(i = 0; i < skeletons.length; i++){
                const skeleton = skeletons[i];
                let root;
                if (hasNode(skeleton)) {
                    root = getNode(skeleton);
                    buildBoneHierarchy(root, joints, boneData);
                } else if (hasVisualScene(skeleton)) {
                    // handle case where the skeleton refers to the visual scene (#13335)
                    const visualScene = library.visualScenes[skeleton];
                    const children = visualScene.children;
                    for(let j = 0; j < children.length; j++){
                        const child = children[j];
                        if (child.type === 'JOINT') {
                            const root = getNode(child.id);
                            buildBoneHierarchy(root, joints, boneData);
                        }
                    }
                } else console.error('THREE.ColladaLoader: Unable to find root bone of skeleton with ID:', skeleton);
            }
            // sort bone data (the order is defined in the corresponding controller)
            for(i = 0; i < joints.length; i++)for(j = 0; j < boneData.length; j++){
                data = boneData[j];
                if (data.bone.name === joints[i].name) {
                    sortedBoneData[i] = data;
                    data.processed = true;
                    break;
                }
            }
            // add unprocessed bone data at the end of the list
            for(i = 0; i < boneData.length; i++){
                data = boneData[i];
                if (data.processed === false) {
                    sortedBoneData.push(data);
                    data.processed = true;
                }
            }
            // setup arrays for skeleton creation
            const bones = [];
            const boneInverses = [];
            for(i = 0; i < sortedBoneData.length; i++){
                data = sortedBoneData[i];
                bones.push(data.bone);
                boneInverses.push(data.boneInverse);
            }
            return new (0, $8TfIJ.Skeleton)(bones, boneInverses);
        }
        function buildBoneHierarchy(root, joints, boneData) {
            // setup bone data from visual scene
            root.traverse(function(object) {
                if (object.isBone === true) {
                    let boneInverse;
                    // retrieve the boneInverse from the controller data
                    for(let i = 0; i < joints.length; i++){
                        const joint = joints[i];
                        if (joint.name === object.name) {
                            boneInverse = joint.boneInverse;
                            break;
                        }
                    }
                    if (boneInverse === undefined) // Unfortunately, there can be joints in the visual scene that are not part of the
                    // corresponding controller. In this case, we have to create a dummy boneInverse matrix
                    // for the respective bone. This bone won't affect any vertices, because there are no skin indices
                    // and weights defined for it. But we still have to add the bone to the sorted bone list in order to
                    // ensure a correct animation of the model.
                    boneInverse = new (0, $8TfIJ.Matrix4)();
                    boneData.push({
                        bone: object,
                        boneInverse: boneInverse,
                        processed: false
                    });
                }
            });
        }
        function buildNode(data) {
            const objects = [];
            const matrix = data.matrix;
            const nodes = data.nodes;
            const type = data.type;
            const instanceCameras = data.instanceCameras;
            const instanceControllers = data.instanceControllers;
            const instanceLights = data.instanceLights;
            const instanceGeometries = data.instanceGeometries;
            const instanceNodes = data.instanceNodes;
            // nodes
            for(let i = 0, l = nodes.length; i < l; i++)objects.push(getNode(nodes[i]));
            // instance cameras
            for(let i = 0, l = instanceCameras.length; i < l; i++){
                const instanceCamera = getCamera(instanceCameras[i]);
                if (instanceCamera !== null) objects.push(instanceCamera.clone());
            }
            // instance controllers
            for(let i = 0, l = instanceControllers.length; i < l; i++){
                const instance = instanceControllers[i];
                const controller = getController(instance.id);
                const geometries = getGeometry(controller.id);
                const newObjects = buildObjects(geometries, instance.materials);
                const skeletons = instance.skeletons;
                const joints = controller.skin.joints;
                const skeleton = buildSkeleton(skeletons, joints);
                for(let j = 0, jl = newObjects.length; j < jl; j++){
                    const object = newObjects[j];
                    if (object.isSkinnedMesh) {
                        object.bind(skeleton, controller.skin.bindMatrix);
                        object.normalizeSkinWeights();
                    }
                    objects.push(object);
                }
            }
            // instance lights
            for(let i = 0, l = instanceLights.length; i < l; i++){
                const instanceLight = getLight(instanceLights[i]);
                if (instanceLight !== null) objects.push(instanceLight.clone());
            }
            // instance geometries
            for(let i = 0, l = instanceGeometries.length; i < l; i++){
                const instance = instanceGeometries[i];
                // a single geometry instance in collada can lead to multiple object3Ds.
                // this is the case when primitives are combined like triangles and lines
                const geometries = getGeometry(instance.id);
                const newObjects = buildObjects(geometries, instance.materials);
                for(let j = 0, jl = newObjects.length; j < jl; j++)objects.push(newObjects[j]);
            }
            // instance nodes
            for(let i = 0, l = instanceNodes.length; i < l; i++)objects.push(getNode(instanceNodes[i]).clone());
            let object;
            if (nodes.length === 0 && objects.length === 1) object = objects[0];
            else {
                object = type === 'JOINT' ? new (0, $8TfIJ.Bone)() : new (0, $8TfIJ.Group)();
                for(let i = 0; i < objects.length; i++)object.add(objects[i]);
            }
            object.name = type === 'JOINT' ? data.sid : data.name;
            object.matrix.copy(matrix);
            object.matrix.decompose(object.position, object.quaternion, object.scale);
            return object;
        }
        const fallbackMaterial = new (0, $8TfIJ.MeshBasicMaterial)({
            color: 0xff00ff
        });
        function resolveMaterialBinding(keys, instanceMaterials) {
            const materials = [];
            for(let i = 0, l = keys.length; i < l; i++){
                const id = instanceMaterials[keys[i]];
                if (id === undefined) {
                    console.warn('THREE.ColladaLoader: Material with key %s not found. Apply fallback material.', keys[i]);
                    materials.push(fallbackMaterial);
                } else materials.push(getMaterial(id));
            }
            return materials;
        }
        function buildObjects(geometries, instanceMaterials) {
            const objects = [];
            for(const type in geometries){
                const geometry = geometries[type];
                const materials = resolveMaterialBinding(geometry.materialKeys, instanceMaterials);
                // handle case if no materials are defined
                if (materials.length === 0) {
                    if (type === 'lines' || type === 'linestrips') materials.push(new (0, $8TfIJ.LineBasicMaterial)());
                    else materials.push(new (0, $8TfIJ.MeshPhongMaterial)());
                }
                // regard skinning
                const skinning = geometry.data.attributes.skinIndex !== undefined;
                // choose between a single or multi materials (material array)
                const material = materials.length === 1 ? materials[0] : materials;
                // now create a specific 3D object
                let object;
                switch(type){
                    case 'lines':
                        object = new (0, $8TfIJ.LineSegments)(geometry.data, material);
                        break;
                    case 'linestrips':
                        object = new (0, $8TfIJ.Line)(geometry.data, material);
                        break;
                    case 'triangles':
                    case 'polylist':
                        if (skinning) object = new (0, $8TfIJ.SkinnedMesh)(geometry.data, material);
                        else object = new (0, $8TfIJ.Mesh)(geometry.data, material);
                        break;
                }
                objects.push(object);
            }
            return objects;
        }
        function hasNode(id) {
            return library.nodes[id] !== undefined;
        }
        function getNode(id) {
            return getBuild(library.nodes[id], buildNode);
        }
        // visual scenes
        function parseVisualScene(xml) {
            const data = {
                name: xml.getAttribute('name'),
                children: []
            };
            prepareNodes(xml);
            const elements = getElementsByTagName(xml, 'node');
            for(let i = 0; i < elements.length; i++)data.children.push(parseNode(elements[i]));
            library.visualScenes[xml.getAttribute('id')] = data;
        }
        function buildVisualScene(data) {
            const group = new (0, $8TfIJ.Group)();
            group.name = data.name;
            const children = data.children;
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                group.add(getNode(child.id));
            }
            return group;
        }
        function hasVisualScene(id) {
            return library.visualScenes[id] !== undefined;
        }
        function getVisualScene(id) {
            return getBuild(library.visualScenes[id], buildVisualScene);
        }
        // scenes
        function parseScene(xml) {
            const instance = getElementsByTagName(xml, 'instance_visual_scene')[0];
            return getVisualScene(parseId(instance.getAttribute('url')));
        }
        function setupAnimations() {
            const clips = library.clips;
            if (isEmpty(clips) === true) {
                if (isEmpty(library.animations) === false) {
                    // if there are animations but no clips, we create a default clip for playback
                    const tracks = [];
                    for(const id in library.animations){
                        const animationTracks = getAnimation(id);
                        for(let i = 0, l = animationTracks.length; i < l; i++)tracks.push(animationTracks[i]);
                    }
                    animations.push(new (0, $8TfIJ.AnimationClip)('default', -1, tracks));
                }
            } else for(const id in clips)animations.push(getAnimationClip(id));
        }
        // convert the parser error element into text with each child elements text
        // separated by new lines.
        function parserErrorToText(parserError) {
            let result = '';
            const stack = [
                parserError
            ];
            while(stack.length){
                const node = stack.shift();
                if (node.nodeType === Node.TEXT_NODE) result += node.textContent;
                else {
                    result += '\n';
                    stack.push.apply(stack, node.childNodes);
                }
            }
            return result.trim();
        }
        if (text.length === 0) return {
            scene: new (0, $8TfIJ.Scene)()
        };
        const xml = new DOMParser().parseFromString(text, 'application/xml');
        const collada = getElementsByTagName(xml, 'COLLADA')[0];
        const parserError = xml.getElementsByTagName('parsererror')[0];
        if (parserError !== undefined) {
            // Chrome will return parser error with a div in it
            const errorElement = getElementsByTagName(parserError, 'div')[0];
            let errorText;
            if (errorElement) errorText = errorElement.textContent;
            else errorText = parserErrorToText(parserError);
            console.error('THREE.ColladaLoader: Failed to parse collada file.\n', errorText);
            return null;
        }
        // metadata
        const version = collada.getAttribute('version');
        console.log('THREE.ColladaLoader: File version', version);
        const asset = parseAsset(getElementsByTagName(collada, 'asset')[0]);
        const textureLoader = new (0, $8TfIJ.TextureLoader)(this.manager);
        textureLoader.setPath(this.resourcePath || path).setCrossOrigin(this.crossOrigin);
        let tgaLoader;
        if (0, $jUfts.TGALoader) {
            tgaLoader = new (0, $jUfts.TGALoader)(this.manager);
            tgaLoader.setPath(this.resourcePath || path);
        }
        //
        const animations = [];
        let kinematics = {};
        let count = 0;
        //
        const library = {
            animations: {},
            clips: {},
            controllers: {},
            images: {},
            effects: {},
            materials: {},
            cameras: {},
            lights: {},
            geometries: {},
            nodes: {},
            visualScenes: {},
            kinematicsModels: {},
            physicsModels: {},
            kinematicsScenes: {}
        };
        parseLibrary(collada, 'library_animations', 'animation', parseAnimation);
        parseLibrary(collada, 'library_animation_clips', 'animation_clip', parseAnimationClip);
        parseLibrary(collada, 'library_controllers', 'controller', parseController);
        parseLibrary(collada, 'library_images', 'image', parseImage);
        parseLibrary(collada, 'library_effects', 'effect', parseEffect);
        parseLibrary(collada, 'library_materials', 'material', parseMaterial);
        parseLibrary(collada, 'library_cameras', 'camera', parseCamera);
        parseLibrary(collada, 'library_lights', 'light', parseLight);
        parseLibrary(collada, 'library_geometries', 'geometry', parseGeometry);
        parseLibrary(collada, 'library_nodes', 'node', parseNode);
        parseLibrary(collada, 'library_visual_scenes', 'visual_scene', parseVisualScene);
        parseLibrary(collada, 'library_kinematics_models', 'kinematics_model', parseKinematicsModel);
        parseLibrary(collada, 'library_physics_models', 'physics_model', parsePhysicsModel);
        parseLibrary(collada, 'scene', 'instance_kinematics_scene', parseKinematicsScene);
        buildLibrary(library.animations, buildAnimation);
        buildLibrary(library.clips, buildAnimationClip);
        buildLibrary(library.controllers, buildController);
        buildLibrary(library.images, buildImage);
        buildLibrary(library.effects, buildEffect);
        buildLibrary(library.materials, buildMaterial);
        buildLibrary(library.cameras, buildCamera);
        buildLibrary(library.lights, buildLight);
        buildLibrary(library.geometries, buildGeometry);
        buildLibrary(library.visualScenes, buildVisualScene);
        setupAnimations();
        setupKinematics();
        const scene = parseScene(getElementsByTagName(collada, 'scene')[0]);
        scene.animations = animations;
        if (asset.upAxis === 'Z_UP') scene.quaternion.setFromEuler(new (0, $8TfIJ.Euler)(-Math.PI / 2, 0, 0));
        scene.scale.multiplyScalar(asset.unit);
        return {
            get animations () {
                console.warn('THREE.ColladaLoader: Please access animations over scene.animations now.');
                return animations;
            },
            kinematics: kinematics,
            library: library,
            scene: scene
        };
    }
    constructor(manager){
        super(manager);
    }
}

});
parcelRegister("jUfts", function(module, exports) {

$parcel$export(module.exports, "TGALoader", function () { return $e7df4019742876f1$export$f133a99b4c3153a; });

var $8TfIJ = parcelRequire("8TfIJ");
class $e7df4019742876f1$export$f133a99b4c3153a extends (0, $8TfIJ.DataTextureLoader) {
    parse(buffer) {
        // reference from vthibault, https://github.com/vthibault/roBrowser/blob/master/src/Loaders/Targa.js
        function tgaCheckHeader(header) {
            switch(header.image_type){
                // check indexed type
                case TGA_TYPE_INDEXED:
                case TGA_TYPE_RLE_INDEXED:
                    if (header.colormap_length > 256 || header.colormap_size !== 24 || header.colormap_type !== 1) console.error('THREE.TGALoader: Invalid type colormap data for indexed type.');
                    break;
                // check colormap type
                case TGA_TYPE_RGB:
                case TGA_TYPE_GREY:
                case TGA_TYPE_RLE_RGB:
                case TGA_TYPE_RLE_GREY:
                    if (header.colormap_type) console.error('THREE.TGALoader: Invalid type colormap data for colormap type.');
                    break;
                // What the need of a file without data ?
                case TGA_TYPE_NO_DATA:
                    console.error('THREE.TGALoader: No data.');
                // Invalid type ?
                default:
                    console.error('THREE.TGALoader: Invalid type "%s".', header.image_type);
            }
            // check image width and height
            if (header.width <= 0 || header.height <= 0) console.error('THREE.TGALoader: Invalid image size.');
            // check image pixel size
            if (header.pixel_size !== 8 && header.pixel_size !== 16 && header.pixel_size !== 24 && header.pixel_size !== 32) console.error('THREE.TGALoader: Invalid pixel size "%s".', header.pixel_size);
        }
        // parse tga image buffer
        function tgaParse(use_rle, use_pal, header, offset, data) {
            let pixel_data, palettes;
            const pixel_size = header.pixel_size >> 3;
            const pixel_total = header.width * header.height * pixel_size;
            // read palettes
            if (use_pal) palettes = data.subarray(offset, offset += header.colormap_length * (header.colormap_size >> 3));
            // read RLE
            if (use_rle) {
                pixel_data = new Uint8Array(pixel_total);
                let c, count, i;
                let shift = 0;
                const pixels = new Uint8Array(pixel_size);
                while(shift < pixel_total){
                    c = data[offset++];
                    count = (c & 0x7f) + 1;
                    // RLE pixels
                    if (c & 0x80) {
                        // bind pixel tmp array
                        for(i = 0; i < pixel_size; ++i)pixels[i] = data[offset++];
                        // copy pixel array
                        for(i = 0; i < count; ++i)pixel_data.set(pixels, shift + i * pixel_size);
                        shift += pixel_size * count;
                    } else {
                        // raw pixels
                        count *= pixel_size;
                        for(i = 0; i < count; ++i)pixel_data[shift + i] = data[offset++];
                        shift += count;
                    }
                }
            } else // raw pixels
            pixel_data = data.subarray(offset, offset += use_pal ? header.width * header.height : pixel_total);
            return {
                pixel_data: pixel_data,
                palettes: palettes
            };
        }
        function tgaGetImageData8bits(imageData, y_start, y_step, y_end, x_start, x_step, x_end, image, palettes) {
            const colormap = palettes;
            let color, i = 0, x, y;
            const width = header.width;
            for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i++){
                color = image[i];
                imageData[(x + width * y) * 4 + 3] = 255;
                imageData[(x + width * y) * 4 + 2] = colormap[color * 3 + 0];
                imageData[(x + width * y) * 4 + 1] = colormap[color * 3 + 1];
                imageData[(x + width * y) * 4 + 0] = colormap[color * 3 + 2];
            }
            return imageData;
        }
        function tgaGetImageData16bits(imageData, y_start, y_step, y_end, x_start, x_step, x_end, image) {
            let color, i = 0, x, y;
            const width = header.width;
            for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 2){
                color = image[i + 0] + (image[i + 1] << 8); // Inversed ?
                imageData[(x + width * y) * 4 + 0] = (color & 0x7C00) >> 7;
                imageData[(x + width * y) * 4 + 1] = (color & 0x03E0) >> 2;
                imageData[(x + width * y) * 4 + 2] = (color & 0x001F) >> 3;
                imageData[(x + width * y) * 4 + 3] = color & 0x8000 ? 0 : 255;
            }
            return imageData;
        }
        function tgaGetImageData24bits(imageData, y_start, y_step, y_end, x_start, x_step, x_end, image) {
            let i = 0, x, y;
            const width = header.width;
            for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 3){
                imageData[(x + width * y) * 4 + 3] = 255;
                imageData[(x + width * y) * 4 + 2] = image[i + 0];
                imageData[(x + width * y) * 4 + 1] = image[i + 1];
                imageData[(x + width * y) * 4 + 0] = image[i + 2];
            }
            return imageData;
        }
        function tgaGetImageData32bits(imageData, y_start, y_step, y_end, x_start, x_step, x_end, image) {
            let i = 0, x, y;
            const width = header.width;
            for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 4){
                imageData[(x + width * y) * 4 + 2] = image[i + 0];
                imageData[(x + width * y) * 4 + 1] = image[i + 1];
                imageData[(x + width * y) * 4 + 0] = image[i + 2];
                imageData[(x + width * y) * 4 + 3] = image[i + 3];
            }
            return imageData;
        }
        function tgaGetImageDataGrey8bits(imageData, y_start, y_step, y_end, x_start, x_step, x_end, image) {
            let color, i = 0, x, y;
            const width = header.width;
            for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i++){
                color = image[i];
                imageData[(x + width * y) * 4 + 0] = color;
                imageData[(x + width * y) * 4 + 1] = color;
                imageData[(x + width * y) * 4 + 2] = color;
                imageData[(x + width * y) * 4 + 3] = 255;
            }
            return imageData;
        }
        function tgaGetImageDataGrey16bits(imageData, y_start, y_step, y_end, x_start, x_step, x_end, image) {
            let i = 0, x, y;
            const width = header.width;
            for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 2){
                imageData[(x + width * y) * 4 + 0] = image[i + 0];
                imageData[(x + width * y) * 4 + 1] = image[i + 0];
                imageData[(x + width * y) * 4 + 2] = image[i + 0];
                imageData[(x + width * y) * 4 + 3] = image[i + 1];
            }
            return imageData;
        }
        function getTgaRGBA(data, width, height, image, palette) {
            let x_start, y_start, x_step, y_step, x_end, y_end;
            switch((header.flags & TGA_ORIGIN_MASK) >> TGA_ORIGIN_SHIFT){
                default:
                case TGA_ORIGIN_UL:
                    x_start = 0;
                    x_step = 1;
                    x_end = width;
                    y_start = 0;
                    y_step = 1;
                    y_end = height;
                    break;
                case TGA_ORIGIN_BL:
                    x_start = 0;
                    x_step = 1;
                    x_end = width;
                    y_start = height - 1;
                    y_step = -1;
                    y_end = -1;
                    break;
                case TGA_ORIGIN_UR:
                    x_start = width - 1;
                    x_step = -1;
                    x_end = -1;
                    y_start = 0;
                    y_step = 1;
                    y_end = height;
                    break;
                case TGA_ORIGIN_BR:
                    x_start = width - 1;
                    x_step = -1;
                    x_end = -1;
                    y_start = height - 1;
                    y_step = -1;
                    y_end = -1;
                    break;
            }
            if (use_grey) switch(header.pixel_size){
                case 8:
                    tgaGetImageDataGrey8bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image);
                    break;
                case 16:
                    tgaGetImageDataGrey16bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image);
                    break;
                default:
                    console.error('THREE.TGALoader: Format not supported.');
                    break;
            }
            else switch(header.pixel_size){
                case 8:
                    tgaGetImageData8bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image, palette);
                    break;
                case 16:
                    tgaGetImageData16bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image);
                    break;
                case 24:
                    tgaGetImageData24bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image);
                    break;
                case 32:
                    tgaGetImageData32bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image);
                    break;
                default:
                    console.error('THREE.TGALoader: Format not supported.');
                    break;
            }
            // Load image data according to specific method
            // let func = 'tgaGetImageData' + (use_grey ? 'Grey' : '') + (header.pixel_size) + 'bits';
            // func(data, y_start, y_step, y_end, x_start, x_step, x_end, width, image, palette );
            return data;
        }
        // TGA constants
        const TGA_TYPE_NO_DATA = 0, TGA_TYPE_INDEXED = 1, TGA_TYPE_RGB = 2, TGA_TYPE_GREY = 3, TGA_TYPE_RLE_INDEXED = 9, TGA_TYPE_RLE_RGB = 10, TGA_TYPE_RLE_GREY = 11, TGA_ORIGIN_MASK = 0x30, TGA_ORIGIN_SHIFT = 0x04, TGA_ORIGIN_BL = 0x00, TGA_ORIGIN_BR = 0x01, TGA_ORIGIN_UL = 0x02, TGA_ORIGIN_UR = 0x03;
        if (buffer.length < 19) console.error('THREE.TGALoader: Not enough data to contain header.');
        let offset = 0;
        const content = new Uint8Array(buffer), header = {
            id_length: content[offset++],
            colormap_type: content[offset++],
            image_type: content[offset++],
            colormap_index: content[offset++] | content[offset++] << 8,
            colormap_length: content[offset++] | content[offset++] << 8,
            colormap_size: content[offset++],
            origin: [
                content[offset++] | content[offset++] << 8,
                content[offset++] | content[offset++] << 8
            ],
            width: content[offset++] | content[offset++] << 8,
            height: content[offset++] | content[offset++] << 8,
            pixel_size: content[offset++],
            flags: content[offset++]
        };
        // check tga if it is valid format
        tgaCheckHeader(header);
        if (header.id_length + offset > buffer.length) console.error('THREE.TGALoader: No data.');
        // skip the needn't data
        offset += header.id_length;
        // get targa information about RLE compression and palette
        let use_rle = false, use_pal = false, use_grey = false;
        switch(header.image_type){
            case TGA_TYPE_RLE_INDEXED:
                use_rle = true;
                use_pal = true;
                break;
            case TGA_TYPE_INDEXED:
                use_pal = true;
                break;
            case TGA_TYPE_RLE_RGB:
                use_rle = true;
                break;
            case TGA_TYPE_RGB:
                break;
            case TGA_TYPE_RLE_GREY:
                use_rle = true;
                use_grey = true;
                break;
            case TGA_TYPE_GREY:
                use_grey = true;
                break;
        }
        //
        const imageData = new Uint8Array(header.width * header.height * 4);
        const result = tgaParse(use_rle, use_pal, header, offset, content);
        getTgaRGBA(imageData, header.width, header.height, result.pixel_data, result.palettes);
        return {
            data: imageData,
            width: header.width,
            height: header.height,
            flipY: true,
            generateMipmaps: true,
            minFilter: (0, $8TfIJ.LinearMipmapLinearFilter)
        };
    }
    constructor(manager){
        super(manager);
    }
}

});


parcelRegister("hP4Mu", function(module, exports) {

$parcel$export(module.exports, "URDFCollider", function () { return $cf9ae8822cd9270f$export$96148412cb4c79c1; });
$parcel$export(module.exports, "URDFVisual", function () { return $cf9ae8822cd9270f$export$344798c61faaed1d; });
$parcel$export(module.exports, "URDFLink", function () { return $cf9ae8822cd9270f$export$57ce561fd28b62ce; });
$parcel$export(module.exports, "URDFJoint", function () { return $cf9ae8822cd9270f$export$f821a5e904506851; });
$parcel$export(module.exports, "URDFMimicJoint", function () { return $cf9ae8822cd9270f$export$d1c279877ffff143; });
$parcel$export(module.exports, "URDFRobot", function () { return $cf9ae8822cd9270f$export$3b6eeb5211e1c44; });

var $4Z4w2 = parcelRequire("4Z4w2");

var $8TfIJ = parcelRequire("8TfIJ");
class $cf9ae8822cd9270f$var$URDFBase extends (0, $8TfIJ.Object3D) {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.urdfNode = source.urdfNode;
        this.urdfName = source.urdfName;
        return this;
    }
    constructor(...args){
        super(...args);
        this.urdfNode = null;
        this.urdfName = '';
    }
}
class $cf9ae8822cd9270f$export$96148412cb4c79c1 extends $cf9ae8822cd9270f$var$URDFBase {
    constructor(...args){
        super(...args);
        this.isURDFCollider = true;
        this.type = 'URDFCollider';
    }
}
class $cf9ae8822cd9270f$export$344798c61faaed1d extends $cf9ae8822cd9270f$var$URDFBase {
    constructor(...args){
        super(...args);
        this.isURDFVisual = true;
        this.type = 'URDFVisual';
    }
}
class $cf9ae8822cd9270f$export$57ce561fd28b62ce extends $cf9ae8822cd9270f$var$URDFBase {
    constructor(...args){
        super(...args);
        this.isURDFLink = true;
        this.type = 'URDFLink';
    }
}
class $cf9ae8822cd9270f$export$f821a5e904506851 extends $cf9ae8822cd9270f$var$URDFBase {
    get jointType() {
        return this._jointType;
    }
    set jointType(v) {
        if (this.jointType === v) return;
        this._jointType = v;
        this.matrixWorldNeedsUpdate = true;
        switch(v){
            case 'fixed':
                this.jointValue = [];
                break;
            case 'continuous':
            case 'revolute':
            case 'prismatic':
                this.jointValue = new Array(1).fill(0);
                break;
            case 'planar':
                this.jointValue = new Array(2).fill(0);
                break;
            case 'floating':
                this.jointValue = new Array(6).fill(0);
                break;
        }
    }
    get angle() {
        return this.jointValue[0];
    }
    /* Overrides */ copy(source, recursive) {
        super.copy(source, recursive);
        this.jointType = source.jointType;
        this.axis = source.axis ? source.axis.clone() : null;
        this.limit.lower = source.limit.lower;
        this.limit.upper = source.limit.upper;
        this.ignoreLimits = false;
        this.jointValue = [
            ...source.jointValue
        ];
        this.origPosition = source.origPosition ? source.origPosition.clone() : null;
        this.origQuaternion = source.origQuaternion ? source.origQuaternion.clone() : null;
        this.mimicJoints = [
            ...source.mimicJoints
        ];
        return this;
    }
    /* Public Functions */ setJointValue(...values) {
        values = values.map((v)=>parseFloat(v));
        if (!this.origPosition || !this.origQuaternion) {
            this.origPosition = this.position.clone();
            this.origQuaternion = this.quaternion.clone();
        }
        let didUpdate = false;
        this.mimicJoints.forEach((joint)=>{
            didUpdate = joint.updateFromMimickedJoint(...values) || didUpdate;
        });
        switch(this.jointType){
            case 'fixed':
                return didUpdate;
            case 'continuous':
            case 'revolute':
                {
                    let angle = values[0];
                    if (angle == null) return didUpdate;
                    if (angle === this.jointValue[0]) return didUpdate;
                    if (!this.ignoreLimits && this.jointType === 'revolute') {
                        angle = Math.min(this.limit.upper, angle);
                        angle = Math.max(this.limit.lower, angle);
                    }
                    this.quaternion.setFromAxisAngle(this.axis, angle).premultiply(this.origQuaternion);
                    if (this.jointValue[0] !== angle) {
                        this.jointValue[0] = angle;
                        this.matrixWorldNeedsUpdate = true;
                        return true;
                    } else return didUpdate;
                }
            case 'prismatic':
                {
                    let pos = values[0];
                    if (pos == null) return didUpdate;
                    if (pos === this.jointValue[0]) return didUpdate;
                    if (!this.ignoreLimits) {
                        pos = Math.min(this.limit.upper, pos);
                        pos = Math.max(this.limit.lower, pos);
                    }
                    this.position.copy(this.origPosition);
                    this.position.addScaledVector(this.axis, pos);
                    if (this.jointValue[0] !== pos) {
                        this.jointValue[0] = pos;
                        this.matrixWorldNeedsUpdate = true;
                        return true;
                    } else return didUpdate;
                }
            case 'floating':
            case 'planar':
                // TODO: Support these joint types
                console.warn(`'${this.jointType}' joint not yet supported`);
        }
        return didUpdate;
    }
    constructor(...args){
        super(...args);
        this.isURDFJoint = true;
        this.type = 'URDFJoint';
        this.jointValue = null;
        this.jointType = 'fixed';
        this.axis = null;
        this.limit = {
            lower: 0,
            upper: 0
        };
        this.ignoreLimits = false;
        this.origPosition = null;
        this.origQuaternion = null;
        this.mimicJoints = [];
    }
}
class $cf9ae8822cd9270f$export$d1c279877ffff143 extends $cf9ae8822cd9270f$export$f821a5e904506851 {
    updateFromMimickedJoint(...values) {
        const modifiedValues = values.map((x)=>x * this.multiplier + this.offset);
        return super.setJointValue(...modifiedValues);
    }
    /* Overrides */ setJointValue(...values) {
        console.warn(`URDFMimicJoint: Setting the joint value of mimic joint "${this.urdfName}" will cause it to be out of sync.`);
        return super.setJointValue(...values);
    }
    /* Overrides */ copy(source, recursive) {
        super.copy(source, recursive);
        this.mimicJoint = source.mimicJoint;
        this.offset = source.offset;
        this.multiplier = source.multiplier;
        return this;
    }
    constructor(...args){
        super(...args);
        this.type = 'URDFMimicJoint';
        this.mimicJoint = null;
        this.offset = 0;
        this.multiplier = 1;
    }
}
class $cf9ae8822cd9270f$export$3b6eeb5211e1c44 extends $cf9ae8822cd9270f$export$57ce561fd28b62ce {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.urdfRobotNode = source.urdfRobotNode;
        this.robotName = source.robotName;
        this.links = {};
        this.joints = {};
        this.colliders = {};
        this.visual = {};
        this.traverse((c)=>{
            if (c.isURDFJoint && c.urdfName in source.joints) this.joints[c.urdfName] = c;
            if (c.isURDFLink && c.urdfName in source.links) this.links[c.urdfName] = c;
            if (c.isURDFCollider && c.urdfName in source.colliders) this.colliders[c.urdfName] = c;
            if (c.isURDFVisual && c.urdfName in source.visual) this.visual[c.urdfName] = c;
        });
        this.frames = (0, $4Z4w2._)({}, this.colliders, this.visual, this.links, this.joints);
        return this;
    }
    getFrame(name) {
        return this.frames[name];
    }
    setJointValue(jointName, ...angle) {
        const joint = this.joints[jointName];
        if (joint) return joint.setJointValue(...angle);
        return false;
    }
    setJointValues(values) {
        let didChange = false;
        for(const name in values){
            const value = values[name];
            if (Array.isArray(value)) didChange = this.setJointValue(name, ...value) || didChange;
            else didChange = this.setJointValue(name, value) || didChange;
        }
        return didChange;
    }
    constructor(...args){
        super(...args);
        this.isURDFRobot = true;
        this.urdfNode = null;
        this.urdfRobotNode = null;
        this.robotName = null;
        this.links = null;
        this.joints = null;
        this.colliders = null;
        this.visual = null;
        this.frames = null;
    }
}

});


parcelRegister("3bR3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $252b8e3230f2182d$export$2e2bcd8739ae039; });

var $8TfIJ = parcelRequire("8TfIJ");
/*
 * Cyclic Coordinate Descent
 * Inspired by https://zalo.github.io/blog/inverse-kinematics/
 */ class $252b8e3230f2182d$var$CCDIK {
    solve(target, robot, joints, { maxIterations: maxIterations = 1, stopDistance: stopDistance = 0.1, jointLimits: jointLimits = {}, apply: apply = false } = {}) {
        let movable = [];
        if (joints.length) {
            for (let joint of robot.arm.movable)if (joints.includes(joint.name)) movable.push(joint);
        } else movable = robot.arm.movable;
        const orig = {};
        const solution = {};
        let targetPosition = new (0, $8TfIJ.Vector3)();
        let tipPosition = new (0, $8TfIJ.Vector3)();
        let deltaNormal = new (0, $8TfIJ.Vector3)();
        // Using a dummy object or pose always resulted in some slight difference to the actual robot, so
        // we're using the robot as our representation and then reset it to its original configuration later
        for (const joint of movable)orig[joint.name] = joint.angle;
        target.getWorldPosition(targetPosition);
        for(let iter = 0; iter < maxIterations; iter++){
            // Rotate each joint so that the endeffector moves towards the target
            for(let i = movable.length - 1; i >= 0; i--){
                const joint = movable[i];
                // Vector to the TCP and target from the joint's POV. This algorithm is iterative in the sense 
                // that we update the tip position after every joint adjustment. The solution won't be perfect
                // so running the solver again will improve on the previous solution.
                robot.tcp.object.getWorldPosition(tipPosition); // changes with each joint!
                let tcpDirection = joint.worldToLocal(tipPosition.clone()).normalize();
                let targetDirection = joint.worldToLocal(targetPosition.clone()).normalize();
                // Project direction vectors onto the joint's rotation plane
                tcpDirection = tcpDirection.projectOnPlane(joint.axis);
                targetDirection = targetDirection.projectOnPlane(joint.axis);
                deltaNormal.crossVectors(tcpDirection, targetDirection).normalize();
                // Depending on which direction we have to turn, the rotation axes will be parallel or anti-parallel
                let alignment = deltaNormal.dot(joint.axis);
                let delta = Math.sign(alignment) * tcpDirection.angleTo(targetDirection);
                let angle = joint.angle + delta;
                // Alternative: more performant, less intuitive (see https://stackoverflow.com/a/33920320/2061551)
                // let v1 = new Vector3();
                // let v2 = new Vector3();
                // let delta = Math.atan2(v1.crossVectors(tcpDirection, targetDirection).dot(joint.axis),
                //     v2.copy(tcpDirection).dot(targetDirection));
                // let angle = joint.angle + delta;
                const limit = jointLimits[joint.name];
                if (limit) {
                    if ('lower' in limit && angle < limit['lower']) // delta = limit['lower'] - joint.angle;
                    angle = Math.max(limit['lower'], angle);
                    if ('upper' in limit && angle > limit['upper']) // delta = limit['upper'] - joint.angle;
                    angle = Math.min(limit['upper'], angle);
                }
                joint.setJointValue(angle);
                solution[joint.name] = joint.angle;
            }
            robot.tcp.object.getWorldPosition(tipPosition);
            if (targetPosition.distanceTo(tipPosition) < stopDistance) break;
        }
        if (!apply) for (const joint of movable)joint.setJointValue(orig[joint.name]);
        return solution;
    }
    constructor(scene, robot){}
}
var $252b8e3230f2182d$export$2e2bcd8739ae039 = $252b8e3230f2182d$var$CCDIK;

});

parcelRegister("dw2Ek", function(module, exports) {

$parcel$export(module.exports, "initGui", function () { return $9d7051ab1fbb44b8$export$7e45f57f0dee54ca; });

var $htoRr = parcelRequire("htoRr");

var $gnVfA = parcelRequire("gnVfA");

var $cxq7w = parcelRequire("cxq7w");

var $3z8rE = parcelRequire("3z8rE");

var $gxi2A = parcelRequire("gxi2A");
const $9d7051ab1fbb44b8$var$theRobots = [
    'Franka',
    'Niryo',
    'Sawyer'
];
let $9d7051ab1fbb44b8$var$currentRobotIdx = 0;
{
    let currentRobot = (0, $gnVfA.getDesiredRobot)().toLowerCase();
    for(let i = 0; i < $9d7051ab1fbb44b8$var$theRobots.length; i++)if ($9d7051ab1fbb44b8$var$theRobots[i].toLowerCase() == currentRobot) {
        $9d7051ab1fbb44b8$var$currentRobotIdx = i;
        break;
    }
}const $9d7051ab1fbb44b8$var$theLanguages = [
    'EN',
    'DE'
];
let $9d7051ab1fbb44b8$var$currentLanguageIdx = 0;
{
    let currentLanguage = (0, $gnVfA.getDesiredLanguage)();
    for(let i = 0; i < $9d7051ab1fbb44b8$var$theLanguages.length; i++)if ($9d7051ab1fbb44b8$var$theLanguages[i].toLowerCase() == currentLanguage) {
        $9d7051ab1fbb44b8$var$currentLanguageIdx = i;
        break;
    }
}var $9d7051ab1fbb44b8$var$gui = null;
let $9d7051ab1fbb44b8$var$jointList = null;
function $9d7051ab1fbb44b8$export$7e45f57f0dee54ca(robot, cameraControl, renderCall) {
    $9d7051ab1fbb44b8$var$gui = new $htoRr.Gui({
        css: 'h:20; w: 200; z-index: 98'
    });
    $9d7051ab1fbb44b8$var$gui.content.id = 'robot-gui';
    $9d7051ab1fbb44b8$var$gui.add('title', {
        name: 'Rocksi',
        prefix: 'v2.0'
    });
    const languages = $9d7051ab1fbb44b8$var$gui.add('list', {
        name: (0, $gnVfA.localize)('gui-language'),
        list: $9d7051ab1fbb44b8$var$theLanguages,
        value: $9d7051ab1fbb44b8$var$currentLanguageIdx
    }).onChange((val)=>$9d7051ab1fbb44b8$var$switchLanguage(languages, val));
    const robotList = $9d7051ab1fbb44b8$var$gui.add('list', {
        name: (0, $gnVfA.localize)('gui-robot'),
        list: $9d7051ab1fbb44b8$var$theRobots,
        value: $9d7051ab1fbb44b8$var$currentRobotIdx
    }).onChange((val)=>$9d7051ab1fbb44b8$var$loadRobot(robotList, val));
    $9d7051ab1fbb44b8$var$gui.add('button', {
        name: '',
        value: [
            (0, $gnVfA.localize)('gui-robot-info')
        ]
    }).onChange((val)=>$9d7051ab1fbb44b8$var$showRobotInfo(robot));
    let gripperButtons = $9d7051ab1fbb44b8$var$gui.add('button', {
        name: '',
        value: [
            (0, $gnVfA.localize)('gui-gripper-open'),
            (0, $gnVfA.localize)('gui-gripper-close')
        ]
    }).onChange((val)=>$9d7051ab1fbb44b8$var$setGripper(val));
    gripperButtons.label((0, $gnVfA.localize)('gui-gripper'), 1);
    // let advancedGripping = gui.add('bool', 
    //                                 { name: localize('gui-advanced-gripping'), 
    //                                 value: robot.useAdvancedGripping, 
    //                                 mode: 0 })
    //                             .onChange( 
    //                                 val => { robot.useAdvancedGripping = val; } 
    //                             );
    let jointValuesRelative = $9d7051ab1fbb44b8$var$getRobotJointValuesRelative(robot);
    $9d7051ab1fbb44b8$var$jointList = $9d7051ab1fbb44b8$var$gui.add('graph', {
        name: (0, $gnVfA.localize)('gui-joints'),
        value: jointValuesRelative,
        neg: true,
        precision: 2,
        h: 80
    }).onChange((vals)=>$9d7051ab1fbb44b8$var$updateRobotJoints(robot, vals, renderCall));
    let ikgroup = $9d7051ab1fbb44b8$var$gui.add('group', {
        name: (0, $gnVfA.localize)('gui-ik-joints')
    });
    for (let joint of robot.arm.movable){
        let active = robot.ikEnabled.includes(joint.name);
        ikgroup.add('bool', {
            name: joint.name,
            value: active,
            h: 20
        }).onChange((val)=>$9d7051ab1fbb44b8$var$onJointIKChange(robot, joint.name, val));
    }
    $9d7051ab1fbb44b8$var$gui.add('button', {
        name: '',
        value: [
            (0, $gnVfA.localize)('gui-reset-robot')
        ],
        p: 0
    }).onChange((val)=>$9d7051ab1fbb44b8$var$resetRobot(robot, renderCall));
    $9d7051ab1fbb44b8$var$gui.add('button', {
        name: '',
        value: [
            (0, $gnVfA.localize)('gui-reset-view')
        ],
        p: 0
    }).onChange((val)=>cameraControl.reset());
    $9d7051ab1fbb44b8$var$gui.isOpen = false;
    $9d7051ab1fbb44b8$var$gui.setHeight();
    $9d7051ab1fbb44b8$var$gui.bottomText = [
        (0, $gnVfA.localize)('gui-robot'),
        (0, $gnVfA.localize)('gui-close')
    ];
    $9d7051ab1fbb44b8$var$gui.bottom.textContent = (0, $gnVfA.localize)('gui-robot');
    (0, $cxq7w.addRenderCallback)($9d7051ab1fbb44b8$var$onRobotMoved);
}
function $9d7051ab1fbb44b8$export$57bf213be019eeb0() {
    $9d7051ab1fbb44b8$var$gui.hide(false);
}
function $9d7051ab1fbb44b8$export$fe8985bb6374093c() {
    $9d7051ab1fbb44b8$var$gui.hide(true);
}
function $9d7051ab1fbb44b8$var$onRobotMoved(robot) {
    let jointValuesRelative = $9d7051ab1fbb44b8$var$getRobotJointValuesRelative(robot);
    // UIL.Graph doesn't handle setValue properly, so we have to update an internal variable as well
    let normed = $9d7051ab1fbb44b8$var$jointList.v;
    for(let i = 0; i < jointValuesRelative.length; i++)normed[i] = (1 + jointValuesRelative[i]) / 2; // * jointList.multiplicator
    $9d7051ab1fbb44b8$var$jointList.setValue(jointValuesRelative);
}
function $9d7051ab1fbb44b8$var$getRobotJointValuesRelative(robot) {
    let values = [];
    for (let joint of robot.arm.movable){
        let angle = joint.angle;
        let lower = joint.limit.lower;
        let upper = joint.limit.upper;
        let rel = (angle - lower) / (upper - lower) * 2 - 1.0;
        values.push(rel);
    }
    return values;
}
function $9d7051ab1fbb44b8$var$switchLanguage(guiLanguageList, language) {
    if ($9d7051ab1fbb44b8$var$theLanguages[$9d7051ab1fbb44b8$var$currentLanguageIdx] === language) return;
    let ok = window.confirm((0, $gnVfA.localize)('gui-confirm-switch-language', language));
    if (ok) {
        let url = window.location;
        let params = new URLSearchParams(url.search);
        params.set('lang', language);
        window.location.replace(url.origin + url.pathname + '?' + params.toString());
    } else {
        guiLanguageList.setList($9d7051ab1fbb44b8$var$theLanguages, $9d7051ab1fbb44b8$var$currentLanguageIdx);
        guiLanguageList.close();
    }
}
function $9d7051ab1fbb44b8$var$loadRobot(guiRobotList, robotName) {
    if ($9d7051ab1fbb44b8$var$theRobots[$9d7051ab1fbb44b8$var$currentRobotIdx] === robotName) return;
    let ok = window.confirm((0, $gnVfA.localize)('gui-confirm-switch-robot', robotName));
    if (ok) {
        let url = window.location;
        let params = new URLSearchParams(url.search);
        params.set('robot', robotName);
        window.location.replace(url.origin + url.pathname + '?' + params.toString());
    } else {
        guiRobotList.setList($9d7051ab1fbb44b8$var$theRobots, robotIdx);
        guiRobotList.close();
    }
}
function $9d7051ab1fbb44b8$var$showRobotInfo(robot) {
    (0, $gxi2A.msgBoxInfo)({
        closeTime: 20000
    }).show((0, $gnVfA.localize)(robot.name.toLowerCase() + '-info'));
}
function $9d7051ab1fbb44b8$var$setGripper(val) {
    (0, $3z8rE.default).getInstance().then((sim)=>{
        switch(val){
            case (0, $gnVfA.localize)('gui-gripper-open'):
                sim.gripper_open();
                break;
            case (0, $gnVfA.localize)('gui-gripper-close'):
                sim.gripper_close();
                break;
            default:
                console.error('GUI event "' + val + '" not handled');
        }
    });
}
function $9d7051ab1fbb44b8$var$updateRobotJoints(robot, values, renderCallback) {
    for(let i = 0; i < robot.arm.movable.length; i++){
        let joint = robot.arm.movable[i];
        let lower = joint.limit.lower;
        let upper = joint.limit.upper;
        let rel = values[i];
        let abs = lower + (upper - lower) * (rel + 1) / 2;
        // We could also use robot.setPose, but since we already have the joint this is easier
        joint.setJointValue(abs);
    }
    renderCallback();
}
function $9d7051ab1fbb44b8$var$onJointIKChange(robot, jointName, enabled) {
    let idx = robot.ikEnabled.indexOf(jointName);
    if (enabled && idx < 0) robot.ikEnabled.push(jointName);
    else if (!enabled && idx >= 0) robot.ikEnabled.splice(idx, 1);
}
function $9d7051ab1fbb44b8$var$resetRobot(robot, renderCallback) {
    for(let jointName in robot.defaultPose){
        let angle = robot.defaultPose[jointName];
        robot.joints[jointName].setJointValue(angle);
    }
    renderCallback();
}

});
parcelRegister("htoRr", function(module, exports) {

$parcel$export(module.exports, "Gui", function () { return $cb886df1bae8879c$export$d8bdd9c139c695f7; });
/**
 * @author lth / https://github.com/lo-th
 */ 
var $4Z4w2 = parcelRequire("4Z4w2");
const $cb886df1bae8879c$export$3545e07a80636437 = '4.4.0';
// INTENAL FUNCTION
/*const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
        console.log(entry)
        //const bounds = entry.boundingClientRect;
        entry.target.bounds = entry.boundingClientRect;
    }
    observer.disconnect();
})*/ const $cb886df1bae8879c$var$R = {
    ui: [],
    debug: false,
    dom: null,
    ID: null,
    lock: false,
    wlock: false,
    current: -1,
    needReZone: true,
    needResize: false,
    forceZone: false,
    isEventsInit: false,
    isLeave: false,
    downTime: 0,
    prevTime: 0,
    //prevDefault: ['contextmenu', 'wheel'],
    prevDefault: [
        'contextmenu'
    ],
    pointerEvent: [
        'pointerdown',
        'pointermove',
        'pointerup'
    ],
    eventOut: [
        'pointercancel',
        'pointerout',
        'pointerleave'
    ],
    xmlserializer: null,
    tmpTime: null,
    tmpImage: null,
    oldCursor: 'auto',
    input: null,
    parent: null,
    firstImput: true,
    hiddenImput: null,
    hiddenSizer: null,
    hasFocus: false,
    startInput: false,
    inputRange: [
        0,
        0
    ],
    cursorId: 0,
    str: '',
    pos: 0,
    startX: -1,
    moveX: -1,
    debugInput: false,
    isLoop: false,
    listens: [],
    e: {
        type: null,
        clientX: 0,
        clientY: 0,
        keyCode: NaN,
        key: null,
        delta: 0
    },
    isMobile: false,
    now: null,
    injectCss (css, styleName, parent) {
        const CSS_ID = styleName || 'codeflask-style';
        const PARENT = parent || document.head;
        if (!css) return false;
        if (document.getElementById(CSS_ID)) return true;
        const style = document.createElement('style');
        style.innerHTML = css;
        style.id = CSS_ID;
        PARENT.appendChild(style);
        return true;
    },
    getTime: function() {
        return self.performance && self.performance.now ? self.performance.now.bind(performance) : Date.now;
    },
    testMobile: function() {
        let n = navigator.userAgent;
        if (n.match(/Android/i) || n.match(/webOS/i) || n.match(/iPhone/i) || n.match(/iPad/i) || n.match(/iPod/i) || n.match(/BlackBerry/i) || n.match(/Windows Phone/i)) return true;
        else return false;
    },
    // ----------------------
    //   ADD / REMOVE
    // ----------------------
    add: function(o) {
        $cb886df1bae8879c$var$R.ui.push(o);
        $cb886df1bae8879c$var$R.getZone(o);
        if (!$cb886df1bae8879c$var$R.isEventsInit) $cb886df1bae8879c$var$R.initEvents();
    },
    remove: function(o) {
        let i = $cb886df1bae8879c$var$R.ui.indexOf(o);
        if (i !== -1) {
            $cb886df1bae8879c$var$R.removeListen(o);
            $cb886df1bae8879c$var$R.ui.splice(i, 1);
        }
        if ($cb886df1bae8879c$var$R.ui.length === 0) $cb886df1bae8879c$var$R.removeEvents();
    //console.log('remove:', R.ui.length)
    },
    // ----------------------
    //   EVENTS
    // ----------------------
    initEvents: function() {
        if ($cb886df1bae8879c$var$R.isEventsInit) return;
        let dom = document.body;
        $cb886df1bae8879c$var$R.isMobile = $cb886df1bae8879c$var$R.testMobile();
        $cb886df1bae8879c$var$R.now = $cb886df1bae8879c$var$R.getTime();
        if (!$cb886df1bae8879c$var$R.isMobile) dom.addEventListener('wheel', $cb886df1bae8879c$var$R, {
            passive: false
        });
        else dom.style.touchAction = 'none';
        dom.addEventListener('pointercancel', $cb886df1bae8879c$var$R);
        dom.addEventListener('pointerleave', $cb886df1bae8879c$var$R);
        //dom.addEventListener( 'pointerout', R )
        dom.addEventListener('pointermove', $cb886df1bae8879c$var$R);
        dom.addEventListener('pointerdown', $cb886df1bae8879c$var$R);
        dom.addEventListener('pointerup', $cb886df1bae8879c$var$R);
        dom.addEventListener('keydown', $cb886df1bae8879c$var$R, false);
        dom.addEventListener('keyup', $cb886df1bae8879c$var$R, false);
        window.addEventListener('resize', $cb886df1bae8879c$var$R.resize, false);
        //window.onblur = R.out;
        //window.onfocus = R.in;
        $cb886df1bae8879c$var$R.isEventsInit = true;
        $cb886df1bae8879c$var$R.dom = dom;
    //console.log('event is add !')
    },
    removeEvents: function() {
        if (!$cb886df1bae8879c$var$R.isEventsInit) return;
        let dom = document.body;
        if (!$cb886df1bae8879c$var$R.isMobile) dom.removeEventListener('wheel', $cb886df1bae8879c$var$R);
        dom.removeEventListener('pointercancel', $cb886df1bae8879c$var$R);
        dom.removeEventListener('pointerleave', $cb886df1bae8879c$var$R);
        //dom.removeEventListener( 'pointerout', R );
        dom.removeEventListener('pointermove', $cb886df1bae8879c$var$R);
        dom.removeEventListener('pointerdown', $cb886df1bae8879c$var$R);
        dom.removeEventListener('pointerup', $cb886df1bae8879c$var$R);
        dom.removeEventListener('keydown', $cb886df1bae8879c$var$R);
        dom.removeEventListener('keyup', $cb886df1bae8879c$var$R);
        window.removeEventListener('resize', $cb886df1bae8879c$var$R.resize);
        $cb886df1bae8879c$var$R.isEventsInit = false;
    //console.log('event is remove !')
    },
    resize: function() {
        //console.log('resize !!')
        let i = $cb886df1bae8879c$var$R.ui.length, u;
        while(i--){
            u = $cb886df1bae8879c$var$R.ui[i];
            if (u.isGui && !u.isCanvasOnly && u.autoResize) u.calc();
        }
        $cb886df1bae8879c$var$R.needReZone = true;
        $cb886df1bae8879c$var$R.needResize = false;
    },
    out: function() {
        console.log('im am out');
        $cb886df1bae8879c$var$R.clearOldID();
    },
    in: function() {
        console.log('im am in');
    //  R.clearOldID();
    },
    // ----------------------
    //   HANDLE EVENTS
    // ----------------------
    fakeUp: function() {
        this.handleEvent({
            type: 'pointerup'
        });
    },
    handleEvent: function(event) {
        //if(!event.type) return;
        //if( R.prevDefault.indexOf( event.type ) !== -1 ) event.preventDefault(); 
        if ($cb886df1bae8879c$var$R.needResize) $cb886df1bae8879c$var$R.resize();
        $cb886df1bae8879c$var$R.findZone($cb886df1bae8879c$var$R.forceZone);
        let e = $cb886df1bae8879c$var$R.e;
        let leave = false;
        if (event.type === 'keydown') $cb886df1bae8879c$var$R.keydown(event);
        if (event.type === 'keyup') $cb886df1bae8879c$var$R.keyup(event);
        if (event.type === 'wheel') e.delta = event.deltaY > 0 ? 1 : -1;
        else e.delta = 0;
        let ptype = event.pointerType; // mouse, pen, touch
        e.clientX = (ptype === 'touch' ? event.pageX : event.clientX) || 0;
        e.clientY = (ptype === 'touch' ? event.pageY : event.clientY) || 0;
        e.type = event.type;
        if ($cb886df1bae8879c$var$R.eventOut.indexOf(event.type) !== -1) {
            leave = true;
            e.type = 'mouseup';
        }
        if (event.type === 'pointerleave') $cb886df1bae8879c$var$R.isLeave = true;
        if (event.type === 'pointerdown') e.type = 'mousedown';
        if (event.type === 'pointerup') e.type = 'mouseup';
        if (event.type === 'pointermove') {
            if ($cb886df1bae8879c$var$R.isLeave) {
                // if user resize outside this document
                $cb886df1bae8879c$var$R.isLeave = false;
                $cb886df1bae8879c$var$R.resize();
            }
            e.type = 'mousemove';
        }
        // double click test
        if (e.type === 'mousedown') {
            $cb886df1bae8879c$var$R.downTime = $cb886df1bae8879c$var$R.now();
            let time = $cb886df1bae8879c$var$R.downTime - $cb886df1bae8879c$var$R.prevTime;
            // double click on imput
            if (time < 200) {
                $cb886df1bae8879c$var$R.selectAll();
                return false;
            }
            $cb886df1bae8879c$var$R.prevTime = $cb886df1bae8879c$var$R.downTime;
            $cb886df1bae8879c$var$R.forceZone = false;
        }
        // for imput
        if (e.type === 'mousedown') $cb886df1bae8879c$var$R.clearInput();
        // mouse lock
        if (e.type === 'mousedown') $cb886df1bae8879c$var$R.lock = true;
        if (e.type === 'mouseup') $cb886df1bae8879c$var$R.lock = false;
        //if( R.current !== null && R.current.neverlock ) R.lock = false;
        /*if( e.type === 'mousedown' && event.button === 1){
            R.cursor()
            e.preventDefault();
            e.stopPropagation();
        }*/ if ($cb886df1bae8879c$var$R.isMobile && e.type === 'mousedown') $cb886df1bae8879c$var$R.findID(e);
        if (e.type === 'mousemove' && !$cb886df1bae8879c$var$R.lock) $cb886df1bae8879c$var$R.findID(e);
        if ($cb886df1bae8879c$var$R.ID !== null) {
            if ($cb886df1bae8879c$var$R.ID.isCanvasOnly) {
                e.clientX = $cb886df1bae8879c$var$R.ID.mouse.x;
                e.clientY = $cb886df1bae8879c$var$R.ID.mouse.y;
            }
            //if( R.ID.marginDiv ) e.clientY -= R.ID.margin * 0.5
            $cb886df1bae8879c$var$R.ID.handleEvent(e);
        }
        if ($cb886df1bae8879c$var$R.isMobile && e.type === 'mouseup') $cb886df1bae8879c$var$R.clearOldID();
        if (leave) $cb886df1bae8879c$var$R.clearOldID();
    },
    // ----------------------
    //   ID
    // ----------------------
    findID: function(e) {
        let i = $cb886df1bae8879c$var$R.ui.length, next = -1, u, x, y;
        while(i--){
            u = $cb886df1bae8879c$var$R.ui[i];
            if (u.isCanvasOnly) {
                x = u.mouse.x;
                y = u.mouse.y;
            } else {
                x = e.clientX;
                y = e.clientY;
            }
            if ($cb886df1bae8879c$var$R.onZone(u, x, y)) {
                next = i;
                if (next !== $cb886df1bae8879c$var$R.current) {
                    $cb886df1bae8879c$var$R.clearOldID();
                    $cb886df1bae8879c$var$R.current = next;
                    $cb886df1bae8879c$var$R.ID = u;
                }
                break;
            }
        }
        if (next === -1) $cb886df1bae8879c$var$R.clearOldID();
    },
    clearOldID: function() {
        if (!$cb886df1bae8879c$var$R.ID) return;
        $cb886df1bae8879c$var$R.current = -1;
        $cb886df1bae8879c$var$R.ID.reset();
        $cb886df1bae8879c$var$R.ID = null;
        $cb886df1bae8879c$var$R.cursor();
    },
    // ----------------------
    //  GUI / GROUP FUNCTION
    //  need update if zone change !!
    // ----------------------
    calcUis: (uis, zone, py, group = false)=>{
        if ($cb886df1bae8879c$var$R.debug) console.log('calc_uis !!');
        let i = uis.length, u, px = 0, n = 0, tw;
        let height = 0;
        while(i--){
            u = uis[n];
            n++;
            if (!group && u.isGroup) u.calcUis();
            let m = u.margin || 0;
            u.zone.w = u.w;
            u.zone.h = u.h + m;
            if (!u.autoWidth) {
                if (px === 0) height += u.h + m;
                u.zone.x = zone.x + px;
                u.zone.y = py; // + u.mtop
                //if(div) u.zone.y += m * 0.5
                tw = $cb886df1bae8879c$var$R.getWidth(u);
                if (tw) u.zone.w = u.w = tw;
                else if (u.fw) u.zone.w = u.w = u.fw;
                px += u.zone.w;
                if (px >= zone.w) {
                    py += u.h + m;
                    //if(div) py += m * 0.5
                    px = 0;
                }
            } else {
                px = 0;
                u.zone.x = zone.x + u.dx;
                u.zone.y = py;
                py += u.h + m;
                height += u.h + m; //-0.5;// ???
            }
        }
        return height;
    },
    findTarget: function(uis, e) {
        let i = uis.length;
        while(i--){
            if ($cb886df1bae8879c$var$R.onZone(uis[i], e.clientX, e.clientY)) return i;
        }
        return -1;
    },
    // ----------------------
    //   ZONE
    // ----------------------
    findZone: function(force = false) {
        if (force) $cb886df1bae8879c$var$R.needReZone = force;
        if (!$cb886df1bae8879c$var$R.needReZone) return;
        let i = $cb886df1bae8879c$var$R.ui.length, u;
        while(i--){
            u = $cb886df1bae8879c$var$R.ui[i];
            $cb886df1bae8879c$var$R.getZone(u);
            // TODO need for group open at start !!!
            if (u.isGui) u.calcUis();
        }
        $cb886df1bae8879c$var$R.needReZone = false;
    },
    onZone: function(o, x, y) {
        //console.log(o, x, y)
        if (x === undefined || y === undefined) return false;
        let z = o.zone;
        let mx = x - z.x; // - o.dx;
        let my = y - z.y;
        //if( this.marginDiv ) e.clientY -= this.margin * 0.5
        //if( o.group && o.group.marginDiv ) my += o.group.margin * 0.5
        //if( o.group !== null ) mx -= o.dx
        let over = mx >= 0 && my >= 0 && mx <= z.w && my <= z.h;
        //if( o.marginDiv ) my -= o.margin * 0.5
        if (over) o.local.set(mx, my);
        else o.local.neg();
        return over;
    },
    getWidth: function(o) {
        //return o.getDom().offsetWidth
        return o.getDom().clientWidth;
    //let r = o.getDom().getBoundingClientRect();
    //return (r.width)
    //return Math.floor(r.width)
    },
    getZone: function(o) {
        if (o.isCanvasOnly) return;
        if (o.isEmpty) return;
        const element = o.getDom();
        const r = element.getBoundingClientRect();
        o.zone = {
            x: r.left,
            y: r.top,
            w: r.width,
            h: r.height
        };
        if (o.isBottom) o.zone.y = o.realTop;
    },
    // ----------------------
    //   CURSOR
    // ----------------------
    cursor: function(name) {
        name = name ? name : 'auto';
        if (name !== $cb886df1bae8879c$var$R.oldCursor) {
            document.body.style.cursor = name;
            $cb886df1bae8879c$var$R.oldCursor = name;
        }
    },
    // ----------------------
    //   CANVAS
    // ----------------------
    toCanvas: function(o, w, h, force) {
        if (!$cb886df1bae8879c$var$R.xmlserializer) $cb886df1bae8879c$var$R.xmlserializer = new XMLSerializer();
        // prevent exesive redraw
        if (force && $cb886df1bae8879c$var$R.tmpTime !== null) {
            clearTimeout($cb886df1bae8879c$var$R.tmpTime);
            $cb886df1bae8879c$var$R.tmpTime = null;
        }
        if ($cb886df1bae8879c$var$R.tmpTime !== null) return;
        if ($cb886df1bae8879c$var$R.lock) $cb886df1bae8879c$var$R.tmpTime = setTimeout(function() {
            $cb886df1bae8879c$var$R.tmpTime = null;
        }, 10);
        ///
        let isNewSize = false;
        if (w !== o.canvas.width || h !== o.canvas.height) isNewSize = true;
        if ($cb886df1bae8879c$var$R.tmpImage === null) $cb886df1bae8879c$var$R.tmpImage = new Image();
        let img = $cb886df1bae8879c$var$R.tmpImage; //new Image();
        let htmlString = $cb886df1bae8879c$var$R.xmlserializer.serializeToString(o.content);
        let svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '"><foreignObject style="pointer-events: none; left:0;" width="100%" height="100%">' + htmlString + '</foreignObject></svg>';
        img.onload = function() {
            let ctx = o.canvas.getContext("2d");
            if (isNewSize) {
                o.canvas.width = w;
                o.canvas.height = h;
            } else ctx.clearRect(0, 0, w, h);
            ctx.drawImage(this, 0, 0);
            o.onDraw();
        };
        img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
        //img.src = 'data:image/svg+xml;base64,'+ window.btoa( svg );
        img.crossOrigin = '';
    },
    // ----------------------
    //   INPUT
    // ----------------------
    setHidden: function() {
        if ($cb886df1bae8879c$var$R.hiddenImput === null) {
            //let css = R.parent.css.txtselect + 'padding:0; width:auto; height:auto; '
            //let css = R.parent.css.txt + 'padding:0; width:auto; height:auto; text-shadow:none;'
            //css += 'left:10px; top:auto; border:none; color:#FFF; background:#000;' + hide;
            $cb886df1bae8879c$var$R.hiddenImput = document.createElement('input');
            $cb886df1bae8879c$var$R.hiddenImput.type = 'text';
            //R.hiddenImput.style.cssText = css + 'bottom:30px;' + (R.debugInput ? '' : 'transform:scale(0);');
            $cb886df1bae8879c$var$R.hiddenSizer = document.createElement('div');
            //R.hiddenSizer.style.cssText = css + 'bottom:60px;';
            document.body.appendChild($cb886df1bae8879c$var$R.hiddenImput);
            document.body.appendChild($cb886df1bae8879c$var$R.hiddenSizer);
        }
        let hide = $cb886df1bae8879c$var$R.debugInput ? '' : 'opacity:0; zIndex:0;';
        let css = $cb886df1bae8879c$var$R.parent.css.txtselect + 'padding:0; width:auto; height:auto; left:10px; top:auto; color:#FFF; background:#000;' + hide;
        $cb886df1bae8879c$var$R.hiddenImput.style.cssText = css + 'bottom:10px;' + ($cb886df1bae8879c$var$R.debugInput ? '' : 'transform:scale(0);');
        $cb886df1bae8879c$var$R.hiddenSizer.style.cssText = css + 'bottom:40px;';
        $cb886df1bae8879c$var$R.hiddenImput.style.width = $cb886df1bae8879c$var$R.input.clientWidth + 'px';
        $cb886df1bae8879c$var$R.hiddenImput.value = $cb886df1bae8879c$var$R.str;
        $cb886df1bae8879c$var$R.hiddenSizer.innerHTML = $cb886df1bae8879c$var$R.str;
        $cb886df1bae8879c$var$R.hasFocus = true;
    },
    clearHidden: function(p) {
        if ($cb886df1bae8879c$var$R.hiddenImput === null) return;
        $cb886df1bae8879c$var$R.hasFocus = false;
    },
    clickPos: function(x) {
        let i = $cb886df1bae8879c$var$R.str.length, l = 0, n = 0;
        while(i--){
            l += $cb886df1bae8879c$var$R.textWidth($cb886df1bae8879c$var$R.str[n]);
            if (l >= x) break;
            n++;
        }
        return n;
    },
    upInput: function(x, down) {
        if ($cb886df1bae8879c$var$R.parent === null) return false;
        let up = false;
        if (down) {
            let id = $cb886df1bae8879c$var$R.clickPos(x);
            $cb886df1bae8879c$var$R.moveX = id;
            if ($cb886df1bae8879c$var$R.startX === -1) {
                $cb886df1bae8879c$var$R.startX = id;
                $cb886df1bae8879c$var$R.cursorId = id;
                $cb886df1bae8879c$var$R.inputRange = [
                    $cb886df1bae8879c$var$R.startX,
                    $cb886df1bae8879c$var$R.startX
                ];
            } else {
                let isSelection = $cb886df1bae8879c$var$R.moveX !== $cb886df1bae8879c$var$R.startX;
                if (isSelection) {
                    if ($cb886df1bae8879c$var$R.startX > $cb886df1bae8879c$var$R.moveX) $cb886df1bae8879c$var$R.inputRange = [
                        $cb886df1bae8879c$var$R.moveX,
                        $cb886df1bae8879c$var$R.startX
                    ];
                    else $cb886df1bae8879c$var$R.inputRange = [
                        $cb886df1bae8879c$var$R.startX,
                        $cb886df1bae8879c$var$R.moveX
                    ];
                }
            }
            up = true;
        } else if ($cb886df1bae8879c$var$R.startX !== -1) {
            $cb886df1bae8879c$var$R.hasFocus = true;
            $cb886df1bae8879c$var$R.hiddenImput.focus();
            $cb886df1bae8879c$var$R.hiddenImput.selectionStart = $cb886df1bae8879c$var$R.inputRange[0];
            $cb886df1bae8879c$var$R.hiddenImput.selectionEnd = $cb886df1bae8879c$var$R.inputRange[1];
            $cb886df1bae8879c$var$R.startX = -1;
            up = true;
        }
        if (up) $cb886df1bae8879c$var$R.selectParent();
        return up;
    },
    selectAll: function() {
        if (!$cb886df1bae8879c$var$R.parent) return;
        $cb886df1bae8879c$var$R.str = $cb886df1bae8879c$var$R.input.textContent;
        $cb886df1bae8879c$var$R.inputRange = [
            0,
            $cb886df1bae8879c$var$R.str.length
        ];
        $cb886df1bae8879c$var$R.hasFocus = true;
        $cb886df1bae8879c$var$R.hiddenImput.focus();
        $cb886df1bae8879c$var$R.hiddenImput.selectionStart = $cb886df1bae8879c$var$R.inputRange[0];
        $cb886df1bae8879c$var$R.hiddenImput.selectionEnd = $cb886df1bae8879c$var$R.inputRange[1];
        $cb886df1bae8879c$var$R.cursorId = $cb886df1bae8879c$var$R.inputRange[1];
        $cb886df1bae8879c$var$R.selectParent();
    },
    selectParent: function() {
        var c = $cb886df1bae8879c$var$R.textWidth($cb886df1bae8879c$var$R.str.substring(0, $cb886df1bae8879c$var$R.cursorId));
        var e = $cb886df1bae8879c$var$R.textWidth($cb886df1bae8879c$var$R.str.substring(0, $cb886df1bae8879c$var$R.inputRange[0]));
        var s = $cb886df1bae8879c$var$R.textWidth($cb886df1bae8879c$var$R.str.substring($cb886df1bae8879c$var$R.inputRange[0], $cb886df1bae8879c$var$R.inputRange[1]));
        $cb886df1bae8879c$var$R.parent.select(c, e, s, $cb886df1bae8879c$var$R.hiddenSizer.innerHTML);
    },
    textWidth: function(text) {
        if ($cb886df1bae8879c$var$R.hiddenSizer === null) return 0;
        text = text.replace(/ /g, '&nbsp;');
        $cb886df1bae8879c$var$R.hiddenSizer.innerHTML = text;
        return $cb886df1bae8879c$var$R.hiddenSizer.clientWidth;
    },
    clearInput: function() {
        if ($cb886df1bae8879c$var$R.parent === null) return;
        if (!$cb886df1bae8879c$var$R.firstImput) $cb886df1bae8879c$var$R.parent.validate(true);
        $cb886df1bae8879c$var$R.clearHidden();
        $cb886df1bae8879c$var$R.parent.unselect();
        //R.input.style.background = 'none';
        $cb886df1bae8879c$var$R.input.style.background = $cb886df1bae8879c$var$R.parent.colors.back;
        $cb886df1bae8879c$var$R.input.style.borderColor = $cb886df1bae8879c$var$R.parent.colors.border;
        //R.input.style.color = R.parent.colors.text;
        $cb886df1bae8879c$var$R.parent.isEdit = false;
        $cb886df1bae8879c$var$R.input = null;
        $cb886df1bae8879c$var$R.parent = null;
        $cb886df1bae8879c$var$R.str = '', $cb886df1bae8879c$var$R.firstImput = true;
    },
    setInput: function(Input, parent) {
        $cb886df1bae8879c$var$R.clearInput();
        $cb886df1bae8879c$var$R.input = Input;
        $cb886df1bae8879c$var$R.parent = parent;
        $cb886df1bae8879c$var$R.input.style.background = $cb886df1bae8879c$var$R.parent.colors.backoff;
        $cb886df1bae8879c$var$R.input.style.borderColor = $cb886df1bae8879c$var$R.parent.colors.select;
        //R.input.style.color = R.parent.colors.textSelect;
        $cb886df1bae8879c$var$R.str = $cb886df1bae8879c$var$R.input.textContent;
        $cb886df1bae8879c$var$R.setHidden();
    },
    keydown: function(e) {
        if ($cb886df1bae8879c$var$R.parent === null) return;
        let keyCode = e.which;
        e.shiftKey;
        //console.log( keyCode )
        $cb886df1bae8879c$var$R.firstImput = false;
        if ($cb886df1bae8879c$var$R.hasFocus) {
            // hack to fix touch event bug in iOS Safari
            window.focus();
            $cb886df1bae8879c$var$R.hiddenImput.focus();
        }
        $cb886df1bae8879c$var$R.parent.isEdit = true;
        // e.preventDefault();
        // add support for Ctrl/Cmd+A selection
        //if ( keyCode === 65 && (e.ctrlKey || e.metaKey )) {
        //R.selectText();
        //e.preventDefault();
        //return self.render();
        //}
        if (keyCode === 13) $cb886df1bae8879c$var$R.clearInput();
        else if ($cb886df1bae8879c$var$R.input.isNum) {
            if (e.keyCode > 47 && e.keyCode < 58 || e.keyCode > 95 && e.keyCode < 106 || e.keyCode === 190 || e.keyCode === 110 || e.keyCode === 8 || e.keyCode === 109) $cb886df1bae8879c$var$R.hiddenImput.readOnly = false;
            else $cb886df1bae8879c$var$R.hiddenImput.readOnly = true;
        } else $cb886df1bae8879c$var$R.hiddenImput.readOnly = false;
    },
    keyup: function(e) {
        if ($cb886df1bae8879c$var$R.parent === null) return;
        $cb886df1bae8879c$var$R.str = $cb886df1bae8879c$var$R.hiddenImput.value;
        if ($cb886df1bae8879c$var$R.parent.allEqual) $cb886df1bae8879c$var$R.parent.sameStr($cb886df1bae8879c$var$R.str); // numeric samùe value
        else $cb886df1bae8879c$var$R.input.textContent = $cb886df1bae8879c$var$R.str;
        $cb886df1bae8879c$var$R.cursorId = $cb886df1bae8879c$var$R.hiddenImput.selectionStart;
        $cb886df1bae8879c$var$R.inputRange = [
            $cb886df1bae8879c$var$R.hiddenImput.selectionStart,
            $cb886df1bae8879c$var$R.hiddenImput.selectionEnd
        ];
        $cb886df1bae8879c$var$R.selectParent();
        //if( R.parent.allway ) 
        $cb886df1bae8879c$var$R.parent.validate();
    },
    // ----------------------
    //
    //   LISTENING
    //
    // ----------------------
    loop: function() {
        if ($cb886df1bae8879c$var$R.isLoop) requestAnimationFrame($cb886df1bae8879c$var$R.loop);
        $cb886df1bae8879c$var$R.update();
    },
    update: function() {
        let i = $cb886df1bae8879c$var$R.listens.length;
        while(i--)$cb886df1bae8879c$var$R.listens[i].listening();
    },
    removeListen: function(proto) {
        let id = $cb886df1bae8879c$var$R.listens.indexOf(proto);
        if (id !== -1) $cb886df1bae8879c$var$R.listens.splice(id, 1);
        if ($cb886df1bae8879c$var$R.listens.length === 0) $cb886df1bae8879c$var$R.isLoop = false;
    },
    addListen: function(proto) {
        let id = $cb886df1bae8879c$var$R.listens.indexOf(proto);
        if (id !== -1) return false;
        $cb886df1bae8879c$var$R.listens.push(proto);
        if (!$cb886df1bae8879c$var$R.isLoop) {
            $cb886df1bae8879c$var$R.isLoop = true;
            $cb886df1bae8879c$var$R.loop();
        }
        return true;
    }
};
const $cb886df1bae8879c$var$Roots = $cb886df1bae8879c$var$R;
/**
 * @author lth / https://github.com/lo-th
 */ //import { PixelFont } from './PixelFont.js';
const $cb886df1bae8879c$var$T = {
    size: {
        w: 320,
        h: 24,
        p: 30,
        s: 8
    },
    // three reference class
    texture: null,
    transition: 0.1,
    frag: document.createDocumentFragment(),
    colorRing: null,
    joystick_0: null,
    joystick_1: null,
    circular: null,
    knob: null,
    pad2d: null,
    svgns: "http://www.w3.org/2000/svg",
    links: "http://www.w3.org/1999/xlink",
    htmls: "http://www.w3.org/1999/xhtml",
    DOM_SIZE: [
        'height',
        'width',
        'top',
        'left',
        'bottom',
        'right',
        'margin-left',
        'margin-right',
        'margin-top',
        'margin-bottom'
    ],
    SVG_TYPE_D: [
        'pattern',
        'defs',
        'transform',
        'stop',
        'animate',
        'radialGradient',
        'linearGradient',
        'animateMotion',
        'use',
        'filter',
        'feColorMatrix'
    ],
    SVG_TYPE_G: [
        'svg',
        'rect',
        'circle',
        'path',
        'polygon',
        'text',
        'g',
        'line',
        'foreignObject'
    ],
    PI: Math.PI,
    TwoPI: Math.PI * 2,
    pi90: Math.PI * 0.5,
    pi60: Math.PI / 3,
    torad: Math.PI / 180,
    todeg: 180 / Math.PI,
    clamp: (v, min, max)=>{
        v = v < min ? min : v;
        v = v > max ? max : v;
        return v;
    },
    isDivid: (v)=>v * 0.5 === Math.floor(v * 0.5),
    // ----------------------
    //   COLOR
    // ----------------------
    defineColor: (o, cc = $cb886df1bae8879c$var$T.colors)=>{
        //Roots.injectCss(PixelFont, null)
        let color = (0, $4Z4w2._)({}, cc);
        let textChange = [
            'fontFamily',
            'fontWeight',
            'fontShadow',
            'fontSize'
        ];
        let changeText = false;
        if (o.font) o.fontFamily = o.font;
        if (o.shadow) o.fontShadow = o.shadow;
        if (o.weight) o.fontWeight = o.weight;
        if (o.fontColor) o.text = o.fontColor;
        if (o.color) o.text = o.color;
        if (o.text) {
            color.text = o.text;
            if (!o.fontColor && !o.color) {
                color.title = $cb886df1bae8879c$var$T.ColorLuma(o.text, -0.25);
                color.titleoff = $cb886df1bae8879c$var$T.ColorLuma(o.text, -0.5);
            }
            color.textOver = $cb886df1bae8879c$var$T.ColorLuma(o.text, 0.25);
            color.textSelect = $cb886df1bae8879c$var$T.ColorLuma(o.text, 0.5);
        }
        if (o.button) {
            color.button = o.button;
            color.border = $cb886df1bae8879c$var$T.ColorLuma(o.button, 0.1);
            color.overoff = $cb886df1bae8879c$var$T.ColorLuma(o.button, 0.2);
        }
        if (o.select) {
            color.select = o.select;
            color.over = $cb886df1bae8879c$var$T.ColorLuma(o.select, -0.1);
        }
        if (o.itemBg) o.back = o.itemBg;
        if (o.back) {
            color.back = o.back;
            color.backoff = $cb886df1bae8879c$var$T.ColorLuma(o.back, -0.1);
        }
        if (o.fontSelect) color.textSelect = o.fontSelect;
        if (o.groupBorder) color.gborder = o.groupBorder;
        //if( o.transparent ) o.bg = 'none'
        //if( o.bg ) color.background = color.backgroundOver = o.bg
        if (o.bgOver) color.backgroundOver = o.bgOver;
        for(let m in color)if (o[m] !== undefined) color[m] = o[m];
        for(let m in o)if (textChange.indexOf(m) !== -1) changeText = true;
        if (changeText) $cb886df1bae8879c$var$T.defineText(color);
        return color;
    },
    colors: {
        sx: 4,
        sy: 0,
        radius: 6,
        showOver: 1,
        //groupOver : 1,
        content: '#37383d',
        background: '#28292e',
        backgroundOver: 'rgba(40,40,40,0)',
        title: '#CCC',
        titleoff: '#BBB',
        text: '#DDD',
        textOver: '#EEE',
        textSelect: '#FFF',
        back: 'rgba(0,0,0,0.2)',
        backoff: 'rgba(0,0,0,0.3)',
        // input and button border
        border: '#4c4c4c',
        borderSize: 1,
        gborder: 'none',
        groups: 'none',
        button: '#3c3c3c',
        overoff: '#5c5c5c',
        over: '#024699',
        select: '#308AFF',
        action: '#FF3300',
        //fontFamily: 'Tahoma',
        //fontFamily: 'Consolas, monospace',
        //fontFamily:"'SegoeUI', 'Segoe UI', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, Roboto, Oxygen-Sans, Ubuntu, Cantarell, sans-serif",
        fontFamily: "Roboto Mono, Source Code Pro, Menlo, Courier, monospace",
        //fontFamily: "'Roboto Mono', 'Source Code Pro', Menlo, Courier, monospace",
        fontWeight: 'normal',
        fontShadow: 'none',
        fontSize: 11,
        joyOver: 'rgba(48,138,255,0.25)',
        joyOut: 'rgba(100,100,100,0.5)',
        joySelect: '#308AFF',
        hide: 'rgba(0,0,0,0)'
    },
    // style css
    css: {
        basic: "position:absolute; pointer-events:none; box-sizing:border-box; margin:0; padding:0; overflow:hidden; -o-user-select:none; -ms-user-select:none; -khtml-user-select:none; -webkit-user-select:none; -moz-user-select:none;",
        button: 'display:flex; align-items:center; justify-content:center; text-align:center;',
        middle: 'display:flex; align-items:center; justify-content:left; text-align:left; flex-direction: row-reverse;'
    },
    // svg path
    svgs: {
        g1: 'M 6 4 L 0 4 0 6 6 6 6 4 M 6 0 L 0 0 0 2 6 2 6 0 Z',
        g2: 'M 6 0 L 4 0 4 6 6 6 6 0 M 2 0 L 0 0 0 6 2 6 2 0 Z',
        group: 'M 7 7 L 7 8 8 8 8 7 7 7 M 5 7 L 5 8 6 8 6 7 5 7 M 3 7 L 3 8 4 8 4 7 3 7 M 7 5 L 7 6 8 6 8 5 7 5 M 6 6 L 6 5 5 5 5 6 6 6 M 7 3 L 7 4 8 4 8 3 7 3 M 6 4 L 6 3 5 3 5 4 6 4 M 3 5 L 3 6 4 6 4 5 3 5 M 3 3 L 3 4 4 4 4 3 3 3 Z',
        arrow: 'M 3 8 L 8 5 3 2 3 8 Z',
        arrowDown: 'M 5 8 L 8 3 2 3 5 8 Z',
        arrowUp: 'M 5 2 L 2 7 8 7 5 2 Z',
        solid: 'M 13 10 L 13 1 4 1 1 4 1 13 10 13 13 10 M 11 3 L 11 9 9 11 3 11 3 5 5 3 11 3 Z',
        body: 'M 13 10 L 13 1 4 1 1 4 1 13 10 13 13 10 M 11 3 L 11 9 9 11 3 11 3 5 5 3 11 3 M 5 4 L 4 5 4 10 9 10 10 9 10 4 5 4 Z',
        vehicle: 'M 13 6 L 11 1 3 1 1 6 1 13 3 13 3 11 11 11 11 13 13 13 13 6 M 2.4 6 L 4 2 10 2 11.6 6 2.4 6 M 12 8 L 12 10 10 10 10 8 12 8 M 4 8 L 4 10 2 10 2 8 4 8 Z',
        articulation: 'M 13 9 L 12 9 9 2 9 1 5 1 5 2 2 9 1 9 1 13 5 13 5 9 4 9 6 5 8 5 10 9 9 9 9 13 13 13 13 9 Z',
        character: 'M 13 4 L 12 3 9 4 5 4 2 3 1 4 5 6 5 8 4 13 6 13 7 9 8 13 10 13 9 8 9 6 13 4 M 6 1 L 6 3 8 3 8 1 6 1 Z',
        terrain: 'M 13 8 L 12 7 Q 9.06 -3.67 5.95 4.85 4.04 3.27 2 7 L 1 8 7 13 13 8 M 3 8 Q 3.78 5.420 5.4 6.6 5.20 7.25 5 8 L 7 8 Q 8.39 -0.16 11 8 L 7 11 3 8 Z',
        joint: 'M 7.7 7.7 Q 8 7.45 8 7 8 6.6 7.7 6.3 7.45 6 7 6 6.6 6 6.3 6.3 6 6.6 6 7 6 7.45 6.3 7.7 6.6 8 7 8 7.45 8 7.7 7.7 M 3.35 8.65 L 1 11 3 13 5.35 10.65 Q 6.1 11 7 11 8.28 11 9.25 10.25 L 7.8 8.8 Q 7.45 9 7 9 6.15 9 5.55 8.4 5 7.85 5 7 5 6.54 5.15 6.15 L 3.7 4.7 Q 3 5.712 3 7 3 7.9 3.35 8.65 M 10.25 9.25 Q 11 8.28 11 7 11 6.1 10.65 5.35 L 13 3 11 1 8.65 3.35 Q 7.9 3 7 3 5.7 3 4.7 3.7 L 6.15 5.15 Q 6.54 5 7 5 7.85 5 8.4 5.55 9 6.15 9 7 9 7.45 8.8 7.8 L 10.25 9.25 Z',
        ray: 'M 9 11 L 5 11 5 12 9 12 9 11 M 12 5 L 11 5 11 9 12 9 12 5 M 11.5 10 Q 10.9 10 10.45 10.45 10 10.9 10 11.5 10 12.2 10.45 12.55 10.9 13 11.5 13 12.2 13 12.55 12.55 13 12.2 13 11.5 13 10.9 12.55 10.45 12.2 10 11.5 10 M 9 10 L 10 9 2 1 1 2 9 10 Z',
        collision: 'M 11 12 L 13 10 10 7 13 4 11 2 7.5 5.5 9 7 7.5 8.5 11 12 M 3 2 L 1 4 4 7 1 10 3 12 8 7 3 2 Z',
        map: 'M 13 1 L 1 1 1 13 13 13 13 1 M 12 2 L 12 7 7 7 7 12 2 12 2 7 7 7 7 2 12 2 Z',
        material: 'M 13 1 L 1 1 1 13 13 13 13 1 M 12 2 L 12 7 7 7 7 12 2 12 2 7 7 7 7 2 12 2 Z',
        texture: 'M 13 4 L 13 1 1 1 1 4 5 4 5 13 9 13 9 4 13 4 Z',
        object: 'M 10 1 L 7 4 4 1 1 1 1 13 4 13 4 5 7 8 10 5 10 13 13 13 13 1 10 1 Z',
        none: 'M 9 5 L 5 5 5 9 9 9 9 5 Z',
        cursor: 'M 4 7 L 1 10 1 12 2 13 4 13 7 10 9 14 14 0 0 5 4 7 Z',
        load: 'M 13 8 L 11.5 6.5 9 9 9 3 5 3 5 9 2.5 6.5 1 8 7 14 13 8 M 9 2 L 9 0 5 0 5 2 9 2 Z',
        save: 'M 9 12 L 5 12 5 14 9 14 9 12 M 11.5 7.5 L 13 6 7 0 1 6 2.5 7.5 5 5 5 11 9 11 9 5 11.5 7.5 Z',
        extern: 'M 14 14 L 14 0 0 0 0 14 14 14 M 12 6 L 12 12 2 12 2 6 12 6 M 12 2 L 12 4 2 4 2 2 12 2 Z'
    },
    setDebug (v) {
        $cb886df1bae8879c$var$Roots.debug = v;
    },
    rezone () {
        $cb886df1bae8879c$var$Roots.needReZone = true;
    },
    getImput: function() {
        return $cb886df1bae8879c$var$Roots.input ? true : false;
    },
    setStyle: function(data) {
        for(var o in data)if ($cb886df1bae8879c$var$T.colors[o]) $cb886df1bae8879c$var$T.colors[o] = data[o];
        $cb886df1bae8879c$var$T.setText();
    },
    // ----------------------
    // custom text
    // ----------------------
    defineText: function(o) {
        $cb886df1bae8879c$var$T.setText(o.fontSize, o.text, o.fontFamily, o.fontShadow, o.fontWeight);
    },
    setText: function(size, color, font, shadow, weight) {
        let cc = $cb886df1bae8879c$var$T.colors;
        if (font === undefined) font = cc.fontFamily;
        if (size === undefined) size = cc.fontSize;
        if (shadow === undefined) shadow = cc.fontShadow;
        if (weight === undefined) weight = cc.fontWeight;
        if (color === undefined) color = cc.text;
        if (isNaN(size)) {
            if (size.search('em') === -1) size += 'px';
        } else size += 'px';
        //let align = 'display:flex; justify-content:left; align-items:center; text-align:left;'
        $cb886df1bae8879c$var$T.css.txt = $cb886df1bae8879c$var$T.css.basic + $cb886df1bae8879c$var$T.css.middle + ' font-family:' + font + '; font-weight:' + weight + '; font-size:' + size + '; color:' + cc.text + '; padding:0px 8px; left:0; top:2px; height:16px; width:100px; overflow:hidden; white-space: nowrap; letter-spacing:normal;'; //letter-spacing: normal;
        if (shadow !== 'none') $cb886df1bae8879c$var$T.css.txt += ' text-shadow: 1px 1px 1px ' + shadow + ';';
        $cb886df1bae8879c$var$T.css.txtselect = $cb886df1bae8879c$var$T.css.txt + 'padding:0px 4px; border:1px dashed ' + cc.border + ';';
        $cb886df1bae8879c$var$T.css.item = $cb886df1bae8879c$var$T.css.txt + 'padding:0px 4px; position:relative; margin-bottom:1px; ';
    },
    // note
    //https://developer.mozilla.org/fr/docs/Web/CSS/css_flexible_box_layout/aligning_items_in_a_flex_container
    /*cloneColor: function () {

        let cc = Object.assign({}, T.colors );
        return cc;

    },*/ // intern function
    cloneCss: function() {
        //let cc = Object.assign({}, T.css );
        return (0, $4Z4w2._)({}, $cb886df1bae8879c$var$T.css);
    },
    clone: function(o) {
        return o.cloneNode(true);
    },
    setSvg: function(dom, type, value, id, id2) {
        if (id === -1) dom.setAttributeNS(null, type, value);
        else if (id2 !== undefined) dom.childNodes[id || 0].childNodes[id2 || 0].setAttributeNS(null, type, value);
        else dom.childNodes[id || 0].setAttributeNS(null, type, value);
    },
    setCss: function(dom, css) {
        for(let r in css)if ($cb886df1bae8879c$var$T.DOM_SIZE.indexOf(r) !== -1) dom.style[r] = css[r] + 'px';
        else dom.style[r] = css[r];
    },
    set: function(g, o) {
        for(let att in o){
            if (att === 'txt') g.textContent = o[att];
            if (att === 'link') g.setAttributeNS($cb886df1bae8879c$var$T.links, 'xlink:href', o[att]);
            else g.setAttributeNS(null, att, o[att]);
        }
    },
    get: function(dom, id) {
        if (id === undefined) return dom; // root
        else if (!isNaN(id)) return dom.childNodes[id]; // first child
        else if (id instanceof Array) {
            if (id.length === 2) return dom.childNodes[id[0]].childNodes[id[1]];
            if (id.length === 3) return dom.childNodes[id[0]].childNodes[id[1]].childNodes[id[2]];
        }
    },
    dom: function(type, css, obj, dom, id) {
        type = type || 'div';
        if ($cb886df1bae8879c$var$T.SVG_TYPE_D.indexOf(type) !== -1 || $cb886df1bae8879c$var$T.SVG_TYPE_G.indexOf(type) !== -1) {
            if (type === 'svg') {
                dom = document.createElementNS($cb886df1bae8879c$var$T.svgns, 'svg');
                $cb886df1bae8879c$var$T.set(dom, obj);
            /*  } else if ( type === 'use' ) {

                dom = document.createElementNS( T.svgns, 'use' );
                T.set( dom, obj );
*/ } else {
                // create new svg if not def
                if (dom === undefined) dom = document.createElementNS($cb886df1bae8879c$var$T.svgns, 'svg');
                $cb886df1bae8879c$var$T.addAttributes(dom, type, obj, id);
            }
        } else if (dom === undefined) dom = document.createElementNS($cb886df1bae8879c$var$T.htmls, type);
        else dom = dom.appendChild(document.createElementNS($cb886df1bae8879c$var$T.htmls, type));
        if (css) dom.style.cssText = css;
        if (id === undefined) return dom;
        else return dom.childNodes[id || 0];
    },
    addAttributes: function(dom, type, o, id) {
        let g = document.createElementNS($cb886df1bae8879c$var$T.svgns, type);
        $cb886df1bae8879c$var$T.set(g, o);
        $cb886df1bae8879c$var$T.get(dom, id).appendChild(g);
        if ($cb886df1bae8879c$var$T.SVG_TYPE_G.indexOf(type) !== -1) g.style.pointerEvents = 'none';
        return g;
    },
    clear: function(dom) {
        $cb886df1bae8879c$var$T.purge(dom);
        while(dom.firstChild){
            if (dom.firstChild.firstChild) $cb886df1bae8879c$var$T.clear(dom.firstChild);
            dom.removeChild(dom.firstChild);
        }
    },
    purge: function(dom) {
        let a = dom.attributes, i, n;
        if (a) {
            i = a.length;
            while(i--){
                n = a[i].name;
                if (typeof dom[n] === 'function') dom[n] = null;
            }
        }
        a = dom.childNodes;
        if (a) {
            i = a.length;
            while(i--)$cb886df1bae8879c$var$T.purge(dom.childNodes[i]);
        }
    },
    // ----------------------
    //   SVG Effects function
    // ----------------------
    addSVGGlowEffect: function() {
        if (document.getElementById('UILGlow') !== null) return;
        let svgFilter = $cb886df1bae8879c$var$T.initUILEffects();
        let filter = $cb886df1bae8879c$var$T.addAttributes(svgFilter, 'filter', {
            id: 'UILGlow',
            x: '-20%',
            y: '-20%',
            width: '140%',
            height: '140%'
        });
        $cb886df1bae8879c$var$T.addAttributes(filter, 'feGaussianBlur', {
            in: 'SourceGraphic',
            stdDeviation: '3',
            result: 'uilBlur'
        });
        let feMerge = $cb886df1bae8879c$var$T.addAttributes(filter, 'feMerge', {});
        for(let i = 0; i <= 3; i++)$cb886df1bae8879c$var$T.addAttributes(feMerge, 'feMergeNode', {
            in: 'uilBlur'
        });
        $cb886df1bae8879c$var$T.addAttributes(feMerge, 'feMergeNode', {
            in: 'SourceGraphic'
        });
    },
    initUILEffects: function() {
        let svgFilter = document.getElementById('UILSVGEffects');
        if (svgFilter === null) {
            svgFilter = $cb886df1bae8879c$var$T.dom('svg', undefined, {
                id: 'UILSVGEffects',
                width: '0',
                height: '0'
            });
            document.body.appendChild(svgFilter);
        }
        return svgFilter;
    },
    // ----------------------
    //   Color function
    // ----------------------
    ColorLuma: function(hex, l) {
        //if( hex.substring(0, 3) === 'rgba' ) hex = '#000';
        if (hex === 'n') hex = '#000';
        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        l = l || 0;
        // convert to decimal and change luminosity
        let rgb = "#", c, i;
        for(i = 0; i < 3; i++){
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + c * l), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    },
    findDeepInver: function(c) {
        return c[0] * 0.3 + c[1] * .59 + c[2] * .11 <= 0.6;
    },
    lerpColor: function(c1, c2, factor) {
        let newColor = {};
        for(let i = 0; i < 3; i++)newColor[i] = c1[i] + (c2[i] - c1[i]) * factor;
        return newColor;
    },
    hexToHtml: function(v) {
        v = v === undefined ? 0x000000 : v;
        return "#" + ("000000" + v.toString(16)).substr(-6);
    },
    htmlToHex: function(v) {
        return v.toUpperCase().replace("#", "0x");
    },
    u255: function(c, i) {
        return parseInt(c.substring(i, i + 2), 16) / 255;
    },
    u16: function(c, i) {
        return parseInt(c.substring(i, i + 1), 16) / 15;
    },
    unpack: function(c) {
        if (c.length == 7) return [
            $cb886df1bae8879c$var$T.u255(c, 1),
            $cb886df1bae8879c$var$T.u255(c, 3),
            $cb886df1bae8879c$var$T.u255(c, 5)
        ];
        else if (c.length == 4) return [
            $cb886df1bae8879c$var$T.u16(c, 1),
            $cb886df1bae8879c$var$T.u16(c, 2),
            $cb886df1bae8879c$var$T.u16(c, 3)
        ];
    },
    p255: function(c) {
        let h = Math.round(c * 255).toString(16);
        if (h.length < 2) h = '0' + h;
        return h;
    },
    pack: function(c) {
        return '#' + $cb886df1bae8879c$var$T.p255(c[0]) + $cb886df1bae8879c$var$T.p255(c[1]) + $cb886df1bae8879c$var$T.p255(c[2]);
    },
    htmlRgba: function(c, a) {
        c = $cb886df1bae8879c$var$T.unpack(c);
        return 'rgba(' + Math.round(c[0] * 255) + ',' + Math.round(c[1] * 255) + ',' + Math.round(c[2] * 255) + ',' + a + ')';
    },
    htmlRgb: function(c, a) {
        return 'rgb(' + Math.round(c[0] * 255) + ',' + Math.round(c[1] * 255) + ',' + Math.round(c[2] * 255) + ')';
    },
    pad: function(n) {
        if (n.length == 1) n = '0' + n;
        return n;
    },
    rgbToHex: function(c) {
        let r = Math.round(c[0] * 255).toString(16);
        let g = Math.round(c[1] * 255).toString(16);
        let b = Math.round(c[2] * 255).toString(16);
        return '#' + $cb886df1bae8879c$var$T.pad(r) + $cb886df1bae8879c$var$T.pad(g) + $cb886df1bae8879c$var$T.pad(b);
    // return '#' + ( '000000' + ( ( c[0] * 255 ) << 16 ^ ( c[1] * 255 ) << 8 ^ ( c[2] * 255 ) << 0 ).toString( 16 ) ).slice( - 6 );
    },
    hueToRgb: function(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
        return p;
    },
    rgbToHsl: function(c) {
        let r = c[0], g = c[1], b = c[2], min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h = 0, s = 0, l = (min + max) / 2;
        if (l > 0 && l < 1) s = delta / (l < 0.5 ? 2 * l : 2 - 2 * l);
        if (delta > 0) {
            if (max == r && max != g) h += (g - b) / delta;
            if (max == g && max != b) h += 2 + (b - r) / delta;
            if (max == b && max != r) h += 4 + (r - g) / delta;
            h /= 6;
        }
        return [
            h,
            s,
            l
        ];
    },
    hslToRgb: function(c) {
        let p, q, h = c[0], s = c[1], l = c[2];
        if (s === 0) return [
            l,
            l,
            l
        ];
        else {
            q = l <= 0.5 ? l * (s + 1) : l + s - l * s;
            p = l * 2 - q;
            return [
                $cb886df1bae8879c$var$T.hueToRgb(p, q, h + 0.33333),
                $cb886df1bae8879c$var$T.hueToRgb(p, q, h),
                $cb886df1bae8879c$var$T.hueToRgb(p, q, h - 0.33333)
            ];
        }
    },
    // ----------------------
    //   SVG MODEL
    // ----------------------
    makeGradiant: function(type, settings, parent, colors) {
        $cb886df1bae8879c$var$T.dom(type, null, settings, parent, 0);
        let n = parent.childNodes[0].childNodes.length - 1, c;
        for(let i = 0; i < colors.length; i++){
            c = colors[i];
            //T.dom( 'stop', null, { offset:c[0]+'%', style:'stop-color:'+c[1]+'; stop-opacity:'+c[2]+';' }, parent, [0,n] );
            $cb886df1bae8879c$var$T.dom('stop', null, {
                offset: c[0] + '%',
                'stop-color': c[1],
                'stop-opacity': c[2]
            }, parent, [
                0,
                n
            ]);
        }
    },
    /*makeGraph: function () {

        let w = 128;
        let radius = 34;
        let svg = T.dom( 'svg', T.css.basic , { viewBox:'0 0 '+w+' '+w, width:w, height:w, preserveAspectRatio:'none' } );
        T.dom( 'path', '', { d:'', stroke:T.colors.text, 'stroke-width':4, fill:'none', 'stroke-linecap':'butt' }, svg );//0
        //T.dom( 'rect', '', { x:10, y:10, width:108, height:108, stroke:'rgba(0,0,0,0.3)', 'stroke-width':2 , fill:'none'}, svg );//1
        //T.dom( 'circle', '', { cx:64, cy:64, r:radius, fill:T.colors.button, stroke:'rgba(0,0,0,0.3)', 'stroke-width':8 }, svg );//0
        
        //T.dom( 'circle', '', { cx:64, cy:64, r:radius+7, stroke:'rgba(0,0,0,0.3)', 'stroke-width':7 , fill:'none'}, svg );//2
        //T.dom( 'path', '', { d:'', stroke:'rgba(255,255,255,0.3)', 'stroke-width':2, fill:'none', 'stroke-linecap':'round', 'stroke-opacity':0.5 }, svg );//3
        T.graph = svg;

    },*/ makePad: function(model) {
        let ww = 256;
        let svg = $cb886df1bae8879c$var$T.dom('svg', $cb886df1bae8879c$var$T.css.basic + 'position:relative;', {
            viewBox: '0 0 ' + ww + ' ' + ww,
            width: ww,
            height: ww,
            preserveAspectRatio: 'none'
        });
        let w = 200;
        let d = (ww - w) * 0.5, m = 20;
        $cb886df1bae8879c$export$390d11d353c16e49.dom('rect', '', {
            x: d,
            y: d,
            width: w,
            height: w,
            fill: $cb886df1bae8879c$var$T.colors.back
        }, svg); // 0
        $cb886df1bae8879c$export$390d11d353c16e49.dom('rect', '', {
            x: d + m * 0.5,
            y: d + m * 0.5,
            width: w - m,
            height: w - m,
            fill: $cb886df1bae8879c$var$T.colors.button
        }, svg); // 1
        // Pointer
        $cb886df1bae8879c$export$390d11d353c16e49.dom('line', '', {
            x1: d + m * 0.5,
            y1: ww * 0.5,
            x2: d + (w - m * 0.5),
            y2: ww * 0.5,
            stroke: $cb886df1bae8879c$var$T.colors.back,
            'stroke-width': 2
        }, svg); // 2
        $cb886df1bae8879c$export$390d11d353c16e49.dom('line', '', {
            x1: ww * 0.5,
            x2: ww * 0.5,
            y1: d + m * 0.5,
            y2: d + (w - m * 0.5),
            stroke: $cb886df1bae8879c$var$T.colors.back,
            'stroke-width': 2
        }, svg); // 3
        $cb886df1bae8879c$export$390d11d353c16e49.dom('circle', '', {
            cx: ww * 0.5,
            cy: ww * 0.5,
            r: 5,
            stroke: $cb886df1bae8879c$var$T.colors.text,
            'stroke-width': 5,
            fill: 'none'
        }, svg); // 4
        $cb886df1bae8879c$var$T.pad2d = svg;
    },
    makeKnob: function(model) {
        let w = 128;
        let radius = 34;
        let svg = $cb886df1bae8879c$var$T.dom('svg', $cb886df1bae8879c$var$T.css.basic + 'position:relative;', {
            viewBox: '0 0 ' + w + ' ' + w,
            width: w,
            height: w,
            preserveAspectRatio: 'none'
        });
        $cb886df1bae8879c$var$T.dom('circle', '', {
            cx: 64,
            cy: 64,
            r: radius,
            fill: $cb886df1bae8879c$var$T.colors.button,
            stroke: 'rgba(0,0,0,0.3)',
            'stroke-width': 8
        }, svg); //0
        $cb886df1bae8879c$var$T.dom('path', '', {
            d: '',
            stroke: $cb886df1bae8879c$var$T.colors.text,
            'stroke-width': 4,
            fill: 'none',
            'stroke-linecap': 'round'
        }, svg); //1
        $cb886df1bae8879c$var$T.dom('circle', '', {
            cx: 64,
            cy: 64,
            r: radius + 7,
            stroke: 'rgba(0,0,0,0.1)',
            'stroke-width': 7,
            fill: 'none'
        }, svg); //2
        $cb886df1bae8879c$var$T.dom('path', '', {
            d: '',
            stroke: 'rgba(255,255,255,0.3)',
            'stroke-width': 2,
            fill: 'none',
            'stroke-linecap': 'round',
            'stroke-opacity': 0.5
        }, svg); //3
        $cb886df1bae8879c$var$T.knob = svg;
    },
    makeCircular: function(model) {
        let w = 128;
        let radius = 40;
        let svg = $cb886df1bae8879c$var$T.dom('svg', $cb886df1bae8879c$var$T.css.basic + 'position:relative;', {
            viewBox: '0 0 ' + w + ' ' + w,
            width: w,
            height: w,
            preserveAspectRatio: 'none'
        });
        $cb886df1bae8879c$var$T.dom('circle', '', {
            cx: 64,
            cy: 64,
            r: radius,
            stroke: 'rgba(0,0,0,0.1)',
            'stroke-width': 10,
            fill: 'none'
        }, svg); //0
        $cb886df1bae8879c$var$T.dom('path', '', {
            d: '',
            stroke: $cb886df1bae8879c$var$T.colors.text,
            'stroke-width': 7,
            fill: 'none',
            'stroke-linecap': 'butt'
        }, svg); //1
        $cb886df1bae8879c$var$T.circular = svg;
    },
    makeJoystick: function(model) {
        //+' background:#f00;'
        let w = 128, ccc;
        let radius = Math.floor((w - 30) * 0.5);
        let innerRadius = Math.floor(radius * 0.6);
        let svg = $cb886df1bae8879c$var$T.dom('svg', $cb886df1bae8879c$var$T.css.basic + 'position:relative;', {
            viewBox: '0 0 ' + w + ' ' + w,
            width: w,
            height: w,
            preserveAspectRatio: 'none'
        });
        $cb886df1bae8879c$var$T.dom('defs', null, {}, svg);
        $cb886df1bae8879c$var$T.dom('g', null, {}, svg);
        if (model === 0) {
            // gradian background
            ccc = [
                [
                    40,
                    'rgb(0,0,0)',
                    0.3
                ],
                [
                    80,
                    'rgb(0,0,0)',
                    0
                ],
                [
                    90,
                    'rgb(50,50,50)',
                    0.4
                ],
                [
                    100,
                    'rgb(50,50,50)',
                    0
                ]
            ];
            $cb886df1bae8879c$var$T.makeGradiant('radialGradient', {
                id: 'grad',
                cx: '50%',
                cy: '50%',
                r: '50%',
                fx: '50%',
                fy: '50%'
            }, svg, ccc);
            // gradian shadow
            ccc = [
                [
                    60,
                    'rgb(0,0,0)',
                    0.5
                ],
                [
                    100,
                    'rgb(0,0,0)',
                    0
                ]
            ];
            $cb886df1bae8879c$var$T.makeGradiant('radialGradient', {
                id: 'gradS',
                cx: '50%',
                cy: '50%',
                r: '50%',
                fx: '50%',
                fy: '50%'
            }, svg, ccc);
            // gradian stick
            let cc0 = [
                'rgb(40,40,40)',
                'rgb(48,48,48)',
                'rgb(30,30,30)'
            ];
            let cc1 = [
                'rgb(1,90,197)',
                'rgb(3,95,207)',
                'rgb(0,65,167)'
            ];
            ccc = [
                [
                    30,
                    cc0[0],
                    1
                ],
                [
                    60,
                    cc0[1],
                    1
                ],
                [
                    80,
                    cc0[1],
                    1
                ],
                [
                    100,
                    cc0[2],
                    1
                ]
            ];
            $cb886df1bae8879c$var$T.makeGradiant('radialGradient', {
                id: 'gradIn',
                cx: '50%',
                cy: '50%',
                r: '50%',
                fx: '50%',
                fy: '50%'
            }, svg, ccc);
            ccc = [
                [
                    30,
                    cc1[0],
                    1
                ],
                [
                    60,
                    cc1[1],
                    1
                ],
                [
                    80,
                    cc1[1],
                    1
                ],
                [
                    100,
                    cc1[2],
                    1
                ]
            ];
            $cb886df1bae8879c$var$T.makeGradiant('radialGradient', {
                id: 'gradIn2',
                cx: '50%',
                cy: '50%',
                r: '50%',
                fx: '50%',
                fy: '50%'
            }, svg, ccc);
            // graph
            $cb886df1bae8879c$var$T.dom('circle', '', {
                cx: 64,
                cy: 64,
                r: radius,
                fill: 'url(#grad)'
            }, svg); //2
            $cb886df1bae8879c$var$T.dom('circle', '', {
                cx: 69,
                cy: 74,
                r: innerRadius + 10,
                fill: 'url(#gradS)'
            }, svg); //3
            $cb886df1bae8879c$var$T.dom('circle', '', {
                cx: 64,
                cy: 64,
                r: innerRadius,
                fill: 'url(#gradIn)'
            }, svg); //4
            $cb886df1bae8879c$var$T.joystick_0 = svg;
        } else {
            // gradian shadow
            ccc = [
                [
                    69,
                    'rgb(0,0,0)',
                    0
                ],
                [
                    70,
                    'rgb(0,0,0)',
                    0.3
                ],
                [
                    100,
                    'rgb(0,0,0)',
                    0
                ]
            ];
            $cb886df1bae8879c$var$T.makeGradiant('radialGradient', {
                id: 'gradX',
                cx: '50%',
                cy: '50%',
                r: '50%',
                fx: '50%',
                fy: '50%'
            }, svg, ccc);
            $cb886df1bae8879c$var$T.dom('circle', '', {
                cx: 64,
                cy: 64,
                r: radius,
                fill: 'none',
                stroke: 'rgba(100,100,100,0.25)',
                'stroke-width': '4'
            }, svg); //2
            $cb886df1bae8879c$var$T.dom('circle', '', {
                cx: 64,
                cy: 64,
                r: innerRadius + 14,
                fill: 'url(#gradX)'
            }, svg); //3
            $cb886df1bae8879c$var$T.dom('circle', '', {
                cx: 64,
                cy: 64,
                r: innerRadius,
                fill: 'none',
                stroke: 'rgb(100,100,100)',
                'stroke-width': '4'
            }, svg); //4
            $cb886df1bae8879c$var$T.joystick_1 = svg;
        }
    },
    makeColorRing: function() {
        let w = 256;
        let svg = $cb886df1bae8879c$var$T.dom('svg', $cb886df1bae8879c$var$T.css.basic + 'position:relative;', {
            viewBox: '0 0 ' + w + ' ' + w,
            width: w,
            height: w,
            preserveAspectRatio: 'none'
        });
        $cb886df1bae8879c$var$T.dom('defs', null, {}, svg);
        $cb886df1bae8879c$var$T.dom('g', null, {}, svg);
        let s = 30; //stroke
        let r = (w - s) * 0.5;
        let mid = w * 0.5;
        let n = 24, nudge = 8 / r / n * Math.PI, a1 = 0;
        let am, tan, d2, a2, ar, i, j, path, ccc;
        let color = [];
        for(i = 0; i <= n; ++i){
            d2 = i / n;
            a2 = d2 * $cb886df1bae8879c$var$T.TwoPI;
            am = (a1 + a2) * 0.5;
            tan = 1 / Math.cos((a2 - a1) * 0.5);
            ar = [
                Math.sin(a1),
                -Math.cos(a1),
                Math.sin(am) * tan,
                -Math.cos(am) * tan,
                Math.sin(a2),
                -Math.cos(a2)
            ];
            color[1] = $cb886df1bae8879c$var$T.rgbToHex($cb886df1bae8879c$var$T.hslToRgb([
                d2,
                1,
                0.5
            ]));
            if (i > 0) {
                j = 6;
                while(j--)ar[j] = (ar[j] * r + mid).toFixed(2);
                path = ' M' + ar[0] + ' ' + ar[1] + ' Q' + ar[2] + ' ' + ar[3] + ' ' + ar[4] + ' ' + ar[5];
                ccc = [
                    [
                        0,
                        color[0],
                        1
                    ],
                    [
                        100,
                        color[1],
                        1
                    ]
                ];
                $cb886df1bae8879c$var$T.makeGradiant('linearGradient', {
                    id: 'G' + i,
                    x1: ar[0],
                    y1: ar[1],
                    x2: ar[4],
                    y2: ar[5],
                    gradientUnits: "userSpaceOnUse"
                }, svg, ccc);
                $cb886df1bae8879c$var$T.dom('path', '', {
                    d: path,
                    'stroke-width': s,
                    stroke: 'url(#G' + i + ')',
                    'stroke-linecap': "butt"
                }, svg, 1);
            }
            a1 = a2 - nudge;
            color[0] = color[1];
        }
        let tw = 84.90;
        // black / white
        ccc = [
            [
                0,
                '#FFFFFF',
                1
            ],
            [
                50,
                '#FFFFFF',
                0
            ],
            [
                50,
                '#000000',
                0
            ],
            [
                100,
                '#000000',
                1
            ]
        ];
        $cb886df1bae8879c$var$T.makeGradiant('linearGradient', {
            id: 'GL0',
            x1: 0,
            y1: mid - tw,
            x2: 0,
            y2: mid + tw,
            gradientUnits: "userSpaceOnUse"
        }, svg, ccc);
        ccc = [
            [
                0,
                '#7f7f7f',
                1
            ],
            [
                50,
                '#7f7f7f',
                0.5
            ],
            [
                100,
                '#7f7f7f',
                0
            ]
        ];
        $cb886df1bae8879c$var$T.makeGradiant('linearGradient', {
            id: 'GL1',
            x1: mid - 49.05,
            y1: 0,
            x2: mid + 98,
            y2: 0,
            gradientUnits: "userSpaceOnUse"
        }, svg, ccc);
        $cb886df1bae8879c$var$T.dom('g', null, {
            'transform-origin': '128px 128px',
            'transform': 'rotate(0)'
        }, svg); //2
        $cb886df1bae8879c$var$T.dom('polygon', '', {
            points: '78.95 43.1 78.95 212.85 226 128',
            fill: 'red'
        }, svg, 2); // 2,0
        $cb886df1bae8879c$var$T.dom('polygon', '', {
            points: '78.95 43.1 78.95 212.85 226 128',
            fill: 'url(#GL1)',
            'stroke-width': 1,
            stroke: 'url(#GL1)'
        }, svg, 2); //2,1
        $cb886df1bae8879c$var$T.dom('polygon', '', {
            points: '78.95 43.1 78.95 212.85 226 128',
            fill: 'url(#GL0)',
            'stroke-width': 1,
            stroke: 'url(#GL0)'
        }, svg, 2); //2,2
        $cb886df1bae8879c$var$T.dom('path', '', {
            d: 'M 255.75 136.5 Q 256 132.3 256 128 256 123.7 255.75 119.5 L 241 128 255.75 136.5 Z',
            fill: 'none',
            'stroke-width': 2,
            stroke: '#000'
        }, svg, 2); //2,3
        //T.dom( 'circle', '', { cx:128+113, cy:128, r:6, 'stroke-width':3, stroke:'#000', fill:'none' }, svg, 2 );//2.3
        $cb886df1bae8879c$var$T.dom('circle', '', {
            cx: 128,
            cy: 128,
            r: 6,
            'stroke-width': 2,
            stroke: '#000',
            fill: 'none'
        }, svg); //3
        $cb886df1bae8879c$var$T.colorRing = svg;
    },
    icon: function(type, color, w) {
        w = w || 40;
        //color = color || '#DEDEDE';
        let viewBox = '0 0 256 256';
        //let viewBox = '0 0 '+ w +' '+ w;
        let t = [
            "<svg xmlns='" + $cb886df1bae8879c$var$T.svgns + "' version='1.1' xmlns:xlink='" + $cb886df1bae8879c$var$T.htmls + "' style='pointer-events:none;' preserveAspectRatio='xMinYMax meet' x='0px' y='0px' width='" + w + "px' height='" + w + "px' viewBox='" + viewBox + "'><g>"
        ];
        switch(type){
            case 'logo':
                t[1] = "<path id='logoin' fill='" + color + "' stroke='none' d='" + $cb886df1bae8879c$var$T.logoFill_d + "'/>";
                break;
            case 'donate':
                t[1] = "<path id='logoin' fill='" + color + "' stroke='none' d='" + $cb886df1bae8879c$var$T.logo_donate + "'/>";
                break;
            case 'neo':
                t[1] = "<path id='logoin' fill='" + color + "' stroke='none' d='" + $cb886df1bae8879c$var$T.logo_neo + "'/>";
                break;
            case 'phy':
                t[1] = "<path id='logoin' stroke='" + color + "' stroke-width='49' stroke-linejoin='round' stroke-linecap='butt' fill='none' d='" + $cb886df1bae8879c$var$T.logo_phy + "'/>";
                break;
            case 'config':
                t[1] = "<path id='logoin' stroke='" + color + "' stroke-width='49' stroke-linejoin='round' stroke-linecap='butt' fill='none' d='" + $cb886df1bae8879c$var$T.logo_config + "'/>";
                break;
            case 'github':
                t[1] = "<path id='logoin' fill='" + color + "' stroke='none' d='" + $cb886df1bae8879c$var$T.logo_github + "'/>";
                break;
            case 'save':
                t[1] = "<path stroke='" + color + "' stroke-width='4' stroke-linejoin='round' stroke-linecap='round' fill='none' d='M 26.125 17 L 20 22.95 14.05 17 M 20 9.95 L 20 22.95'/><path stroke='" + color;
                t[1] += "' stroke-width='2.5' stroke-linejoin='round' stroke-linecap='round' fill='none' d='M 32.6 23 L 32.6 25.5 Q 32.6 28.5 29.6 28.5 L 10.6 28.5 Q 7.6 28.5 7.6 25.5 L 7.6 23'/>";
                break;
        }
        t[2] = "</g></svg>";
        return t.join("\n");
    },
    logoFill_d: `
    M 171 150.75 L 171 33.25 155.5 33.25 155.5 150.75 Q 155.5 162.2 147.45 170.2 139.45 178.25 128 178.25 116.6 178.25 108.55 170.2 100.5 162.2 100.5 150.75 
    L 100.5 33.25 85 33.25 85 150.75 Q 85 168.65 97.55 181.15 110.15 193.75 128 193.75 145.9 193.75 158.4 181.15 171 168.65 171 150.75 
    M 200 33.25 L 184 33.25 184 150.8 Q 184 174.1 167.6 190.4 151.3 206.8 128 206.8 104.75 206.8 88.3 190.4 72 174.1 72 150.8 L 72 33.25 56 33.25 56 150.75 
    Q 56 180.55 77.05 201.6 98.2 222.75 128 222.75 157.8 222.75 178.9 201.6 200 180.55 200 150.75 L 200 33.25 Z
    `,
    logo_github: `
    M 180.5 70 Q 186.3 82.4 181.55 96.55 196.5 111.5 189.7 140.65 183.65 168.35 146 172.7 152.5 178.7 152.55 185.9 L 152.55 218.15 Q 152.84 224.56 159.15 223.3 
    159.21 223.3 159.25 223.3 181.14 216.25 198.7 198.7 228 169.4 228 128 228 86.6 198.7 57.3 169.4 28 128 28 86.6 28 57.3 57.3 28 86.6 28 128 28 169.4 57.3 198.7 74.85 
    216.25 96.75 223.3 96.78 223.3 96.8 223.3 103.16 224.54 103.45 218.15 L 103.45 200 Q 82.97 203.1 75.1 196.35 69.85 191.65 68.4 185.45 64.27 177.055 59.4 174.15 49.20 
    166.87 60.8 167.8 69.85 169.61 75.7 180 81.13 188.09 90 188.55 98.18 188.86 103.45 185.9 103.49 178.67 110 172.7 72.33 168.33 66.3 140.65 59.48 111.49 74.45 96.55 69.7 
    82.41 75.5 70 84.87 68.74 103.15 80 115.125 76.635 128 76.85 140.85 76.65 152.85 80 171.1 68.75 180.5 70 Z
    `,
    logo_neo: `
    M 219 52 L 206 52 206 166 Q 206 183.4 193.75 195.65 181.4 208 164 208 146.6 208 134.35 195.65 122 183.4 122 166 L 122 90 Q 122 77.6 113.15 68.85 104.4 60 92 60 79.55 
    60 70.75 68.85 62 77.6 62 90 L 62 204 75 204 75 90 Q 75 83 79.95 78 84.95 73 92 73 99 73 104 78 109 83 109 90 L 109 166 Q 109 188.8 125.15 204.85 141.2 221 164 221 
    186.75 221 202.95 204.85 219 188.8 219 166 L 219 52 M 194 52 L 181 52 181 166 Q 181 173 176.05 178 171.05 183 164 183 157 183 152 178 147 173 147 166 L 147 90 Q 147 
    67.2 130.85 51.15 114.8 35 92 35 69.25 35 53.05 51.15 37 67.2 37 90 L 37 204 50 204 50 90 Q 50 72.6 62.25 60.35 74.6 48 92 48 109.4 48 121.65 60.35 134 72.6 134 90 L 
    134 166 Q 134 178.4 142.85 187.15 151.6 196 164 196 176.45 196 185.25 187.15 194 178.4 194 166 L 194 52 Z
    `,
    logo_phy: `
    M 103.55 37.95 L 127.95 37.95 Q 162.35 37.95 186.5 55 210.9 72.35 210.9 96.5 210.9 120.65 186.5 137.7 162.35 155 127.95 155 L 127.95 237.95 M 127.95 155 
    Q 93.55 155 69.15 137.7 45 120.65 45 96.5 45 72.35 69.15 55 70.9 53.8 72.85 52.85 M 127.95 155 L 127.95 37.95
    `,
    logo_config: `
    M 204.35 51.65 L 173.25 82.75 Q 192 101.5 192 128 L 236 128 M 192 128 Q 192 154.55 173.25 173.25 L 204.4 204.4 M 51.65 51.65 L 82.75 82.75 Q 101.5 64 128 64 
    L 128 20 M 51.6 204.4 L 82.75 173.25 Q 64 154.55 64 128 L 20 128 M 128 236 L 128 192 Q 101.5 192 82.75 173.25 M 64 128 Q 64 101.5 82.75 82.75 M 173.25 173.25 
    Q 154.55 192 128 192 M 128 64 Q 154.55 64 173.25 82.75
    `,
    logo_donate: `
    M 171.3 80.3 Q 179.5 62.15 171.3 45.8 164.1 32.5 141.35 30.1 L 94.35 30.1 Q 89.35 30.4 88.3 35.15 L 70.5 148.05 Q 70.2 152.5 73.7 152.6 L 100.95 152.6 107 111.6 Q 108.75 
    106.55 112.6 106.45 130.45 108.05 145.3 103.9 163.35 98.75 171.3 80.3 M 179.8 71.5 Q 178.6 79.75 174.9 87.85 168.45 102.9 151.9 109.15 140.65 113.95 117.55 113 113.15 
    112.75 111 117.45 L 102.7 169.95 Q 102.45 173.8 105.5 173.85 L 128.95 173.85 Q 132.2 174.2 133.35 169.65 L 138.3 139.95 Q 139.75 135.6 143.1 135.5 146.6 135.75 150.6 135.65 
    154.55 135.5 157.35 135.1 160.15 134.7 166.75 132.35 181.35 127.4 187.9 111.2 194.25 95.75 189.5 81.95 186.75 74.85 179.8 71.5 M 103.5 209.9 Q 103.5 202.85 99.7 198.85 95.95 
    194.75 89.4 194.75 82.8 194.75 79.05 198.85 75.3 202.9 75.3 209.9 75.3 216.85 79.05 220.95 82.8 225.05 89.4 225.05 95.95 225.05 99.7 221 103.5 216.95 103.5 209.9 M 95.45 205.5 
    Q 95.95 207.3 95.95 209.9 95.95 212.65 95.45 214.35 94.95 216 94 217.3 93.1 218.45 91.9 219 90.7 219.55 89.4 219.55 88.15 219.55 86.95 219.05 85.75 218.55 84.8 217.3 83.9 216.15 
    83.4 214.35 82.85 212.6 82.85 209.9 82.85 207.3 83.4 205.45 83.95 203.55 84.85 202.45 85.9 201.2 86.95 200.75 88.05 200.25 89.4 200.25 90.7 200.25 91.85 200.8 93.05 201.3 94 202.5 
    94.9 203.65 95.45 205.5 M 153.3 195.35 L 145.3 195.35 135.5 224.45 142.8 224.45 144.6 218.5 153.75 218.5 155.6 224.45 163.1 224.45 153.3 195.35 M 152.15 213.25 L 146.25 213.25 
    149.2 203.65 152.15 213.25 M 116.75 195.35 L 107.8 195.35 107.8 224.45 114.5 224.45 114.5 204.2 125.7 224.45 132.75 224.45 132.75 195.35 126.05 195.35 126.05 212.05 116.75 195.35 M 
    66.5 197.65 Q 64.15 196.15 61.45 195.75 58.8 195.35 55.75 195.35 L 46.7 195.35 46.7 224.45 55.8 224.45 Q 58.8 224.45 61.5 224.05 64.15 223.6 66.4 222.15 69.15 220.45 70.9 217.2 
    72.7 214 72.7 209.95 72.7 205.7 71 202.6 69.35 199.5 66.5 197.65 M 64.2 205 Q 65.2 207 65.2 209.9 65.2 212.75 64.25 214.75 63.3 216.75 61.5 217.85 60 218.85 58.3 218.9 56.6 219 
    54.15 219 L 54 219 54 200.8 54.15 200.8 Q 56.4 200.8 58.05 200.9 59.7 200.95 61.15 201.75 63.2 202.95 64.2 205 M 210.2 195.35 L 190.5 195.35 190.5 224.45 210.2 224.45 210.2 218.9 
    197.75 218.9 197.75 211.55 209.2 211.55 209.2 206 197.75 206 197.75 200.9 210.2 200.9 210.2 195.35 M 187.5 195.35 L 163 195.35 163 200.9 171.6 200.9 171.6 224.45 178.9 224.45 178.9 
    200.9 187.5 200.9 187.5 195.35 Z
    `
};
$cb886df1bae8879c$var$T.setText();
const $cb886df1bae8879c$export$390d11d353c16e49 = $cb886df1bae8879c$var$T;
///https://wicg.github.io/file-system-access/#api-filesystemfilehandle-getfile
class $cb886df1bae8879c$export$9330ab61a7e5c11b {
    //-----------------------------
    //  FILE TYPE
    //-----------------------------
    static autoTypes(type) {
        let t = [];
        switch(type){
            case 'svg':
                t = [
                    {
                        accept: {
                            'image/svg+xml': '.svg'
                        }
                    }
                ];
                break;
            case 'wav':
                t = [
                    {
                        accept: {
                            'audio/wav': '.wav'
                        }
                    }
                ];
                break;
            case 'mp3':
                t = [
                    {
                        accept: {
                            'audio/mpeg': '.mp3'
                        }
                    }
                ];
                break;
            case 'mp4':
                t = [
                    {
                        accept: {
                            'video/mp4': '.mp4'
                        }
                    }
                ];
                break;
            case 'bin':
            case 'hex':
                t = [
                    {
                        description: 'Binary Files',
                        accept: {
                            'application/octet-stream': [
                                '.bin',
                                '.hex'
                            ]
                        }
                    }
                ];
                break;
            case 'text':
                t = [
                    {
                        description: 'Text Files',
                        accept: {
                            'text/plain': [
                                '.txt',
                                '.text'
                            ],
                            'text/html': [
                                '.html',
                                '.htm'
                            ]
                        }
                    }
                ];
                break;
            case 'json':
                t = [
                    {
                        description: 'JSON Files',
                        accept: {
                            'application/json': [
                                '.json'
                            ]
                        }
                    }
                ]; //text/plain
                break;
            case 'js':
                t = [
                    {
                        description: 'JavaScript Files',
                        accept: {
                            'text/javascript': [
                                '.js'
                            ]
                        }
                    }
                ];
                break;
            case 'ktx2':
                t = [
                    {
                        description: 'ktx2',
                        accept: {
                            'image/ktx2': [
                                '.ktx2'
                            ]
                        }
                    }
                ];
                break;
            case 'image':
                t = [
                    {
                        description: 'Images',
                        accept: {
                            'image/*': [
                                '.png',
                                '.gif',
                                '.jpeg',
                                '.jpg',
                                '.hdr',
                                '.exr'
                            ]
                        }
                    }
                ];
                break;
            case 'gif':
                t = [
                    {
                        description: 'Images',
                        accept: {
                            'image/*': [
                                '.gif'
                            ]
                        }
                    }
                ];
                break;
            case 'png':
                t = [
                    {
                        description: 'Images',
                        accept: {
                            'image/*': [
                                '.png'
                            ]
                        }
                    }
                ];
                break;
            case 'exr':
                t = [
                    {
                        description: 'Images',
                        accept: {
                            'image/exr': [
                                '.exr'
                            ]
                        }
                    }
                ];
                break;
            case 'hdr':
                t = [
                    {
                        description: 'Images',
                        accept: {
                            'image/hdr': [
                                '.hdr'
                            ]
                        }
                    }
                ];
                break;
            case 'jpg':
                t = [
                    {
                        description: 'Images',
                        accept: {
                            'image/*': [
                                '.jpg',
                                '.jpeg'
                            ]
                        }
                    }
                ];
                break;
            case 'icon':
                t = [
                    {
                        description: 'Icons',
                        accept: {
                            'image/x-ico': [
                                '.ico'
                            ]
                        }
                    }
                ];
                break;
            case 'lut':
                t = [
                    {
                        description: 'Lut',
                        accept: {
                            'text/plain': [
                                '.cube',
                                '.3dl'
                            ]
                        }
                    }
                ];
                break;
        }
        return t;
    }
    //-----------------------------
    //  LOAD
    //-----------------------------
    static async load(o = {}) {
        if (typeof window.showOpenFilePicker !== 'function') window.showOpenFilePicker = $cb886df1bae8879c$export$9330ab61a7e5c11b.showOpenFilePickerPolyfill;
        try {
            let type = o.type || '';
            const options = {
                excludeAcceptAllOption: type ? true : false,
                multiple: false
            };
            options.types = $cb886df1bae8879c$export$9330ab61a7e5c11b.autoTypes(type);
            // create a new handle
            const handle = await window.showOpenFilePicker(options);
            const file = await handle[0].getFile();
            //let content = await file.text()
            if (!file) return null;
            let fname = file.name;
            let ftype = fname.substring(fname.lastIndexOf('.') + 1, fname.length);
            let realType = '';
            const dataUrl = [
                'png',
                'jpg',
                'jpeg',
                'mp4',
                'webm',
                'ogg',
                'mp3'
            ];
            const dataBuf = [
                'sea',
                'z',
                'hex',
                'bvh',
                'BVH',
                'glb',
                'gltf',
                'exr',
                'ktx2',
                'hdr'
            ];
            const reader = new FileReader();
            if (o.forceType === 'ArrayBuffer') {
                reader.readAsArrayBuffer(file);
                type = '';
            } else {
                if (dataUrl.indexOf(ftype) !== -1) reader.readAsDataURL(file);
                else if (dataBuf.indexOf(ftype) !== -1) reader.readAsArrayBuffer(file);
                else reader.readAsText(file);
            }
            reader.onload = function(e) {
                let content = e.target.result;
                //console.log(type, files)
                switch(type){
                    case 'image':
                        let img = new Image();
                        img.onload = function() {
                            img.width = img.width;
                            img.height = img.height;
                            if (o.callback) o.callback(img, fname, ftype, [
                                img.width,
                                img.height
                            ]);
                        };
                        img.src = content;
                        break;
                    case 'json':
                        if (o.callback) o.callback(JSON.parse(content), fname, ftype);
                        break;
                    default:
                        if (o.callback) o.callback(content, fname, ftype);
                        break;
                }
            };
        } catch (e) {
            console.log(e);
            if (o.always && o.callback) o.callback(null);
        }
    }
    static showOpenFilePickerPolyfill(options) {
        return new Promise((resolve)=>{
            const input = document.createElement("input");
            input.type = "file";
            input.multiple = options.multiple;
            input.accept = options.types.map((type)=>type.accept).flatMap((inst)=>Object.keys(inst).flatMap((key)=>inst[key])).join(",");
            input.addEventListener("change", ()=>{
                resolve([
                    ...input.files
                ].map((file)=>{
                    return {
                        getFile: async ()=>new Promise((resolve)=>{
                                resolve(file);
                            })
                    };
                }));
            });
            input.click();
        });
    }
    //-----------------------------
    //  SAVE
    //-----------------------------
    static async save(o = {}) {
        let usePoly = false;
        if (typeof window.showSaveFilePicker !== 'function') {
            window.showSaveFilePicker = $cb886df1bae8879c$export$9330ab61a7e5c11b.showSaveFilePickerPolyfill;
            usePoly = true;
        }
        try {
            let type = o.type || '';
            const options = {
                suggestedName: o.name || 'hello',
                data: o.data || ''
            };
            options.types = $cb886df1bae8879c$export$9330ab61a7e5c11b.autoTypes(type);
            options.finalType = Object.keys(options.types[0].accept)[0];
            options.suggestedName += options.types[0].accept[options.finalType][0];
            // create a new handle
            const handle = await window.showSaveFilePicker(options);
            if (usePoly) return;
            // create a FileSystemWritableFileStream to write to
            const file = await handle.createWritable();
            let blob = new Blob([
                options.data
            ], {
                type: options.finalType
            });
            // write our file
            await file.write(blob);
            // close the file and write the contents to disk.
            await file.close();
        } catch (e) {
            console.log(e);
        }
    }
    static showSaveFilePickerPolyfill(options) {
        return new Promise((resolve)=>{
            const a = document.createElement("a");
            a.download = options.suggestedName || "my-file.txt";
            let blob = new Blob([
                options.data
            ], {
                type: options.finalType
            });
            a.href = URL.createObjectURL(blob);
            a.addEventListener("click", ()=>{
                resolve(setTimeout(()=>URL.revokeObjectURL(a.href), 1000));
            });
            a.click();
        });
    }
    //-----------------------------
    //  FOLDER not possible in poly
    //-----------------------------
    static async getFolder() {
        try {
            const handle = await window.showDirectoryPicker();
            const files = [];
            for await (const entry of handle.values()){
                const file = await entry.getFile();
                files.push(file);
            }
            console.log(files);
            return files;
        } catch (e) {
            console.log(e);
        }
    }
}
class $cb886df1bae8879c$var$V2 {
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        var angle = Math.atan2(this.y, this.x);
        if (angle < 0) angle += 2 * Math.PI;
        return angle;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    negate() {
        this.x *= -1;
        this.y *= -1;
        return this;
    }
    neg() {
        this.x = -1;
        this.y = -1;
        return this;
    }
    isZero() {
        return this.x === 0 && this.y === 0;
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    nearEquals(v, n) {
        return v.x.toFixed(n) === this.x.toFixed(n) && v.y.toFixed(n) === this.y.toFixed(n);
    }
    lerp(v, alpha) {
        if (v === null) {
            this.x -= this.x * alpha;
            this.y -= this.y * alpha;
        } else {
            this.x += (v.x - this.x) * alpha;
            this.y += (v.y - this.y) * alpha;
        }
        return this;
    }
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
}
/**
 * @author lth / https://github.com/lo-th
 */ class $cb886df1bae8879c$var$Proto {
    // ----------------------
    // make the node
    // ----------------------
    init() {
        this.ytop = this.top + this.mtop;
        this.zone.h = this.h + this.margin;
        this.zone.w = this.w;
        let s = this.s; // style cache
        let c = this.c; // div cach
        s[0].height = this.h + 'px';
        if (this.isUI) s[0].background = this.colors.background;
        if (!this.autoWidth && this.useFlex) {
            s[0].flex = '1 0 auto';
            s[0].minWidth = this.minw + 'px';
            s[0].textAlign = 'center';
        } else if (this.isUI) s[0].width = '100%';
        //if( this.autoHeight ) s[0].transition = 'height 0.01s ease-out';
        if (c[1] !== undefined && this.autoWidth) {
            s[1] = c[1].style;
            s[1].top = "1px";
            s[1].height = this.h - 2 + 'px';
        }
        let frag = $cb886df1bae8879c$export$390d11d353c16e49.frag;
        for(let i = 1, lng = c.length; i !== lng; i++)if (c[i] !== undefined) {
            frag.appendChild(c[i]);
            s[i] = c[i].style;
        }
        let pp = this.target !== null ? this.target : this.isUI ? this.main.inner : document.body;
        if (this.ontop) pp.insertAdjacentElement('afterbegin', c[0]);
        else pp.appendChild(c[0]);
        c[0].appendChild(frag);
        this.rSize();
        // ! solo proto
        if (!this.isUI) {
            this.c[0].style.pointerEvents = 'auto';
            $cb886df1bae8879c$var$Roots.add(this);
        }
    }
    addTransition() {
        if (this.baseH && this.transition && this.isUI) this.c[0].style.transition = 'height ' + this.transition + 's ease-out';
    }
    // from Tools
    dom(type, css, obj, dom, id) {
        return $cb886df1bae8879c$export$390d11d353c16e49.dom(type, css, obj, dom, id);
    }
    setSvg(dom, type, value, id, id2) {
        $cb886df1bae8879c$export$390d11d353c16e49.setSvg(dom, type, value, id, id2);
    }
    setCss(dom, css) {
        $cb886df1bae8879c$export$390d11d353c16e49.setCss(dom, css);
    }
    clamp(value, min, max) {
        return $cb886df1bae8879c$export$390d11d353c16e49.clamp(value, min, max);
    }
    getColorRing() {
        if (!$cb886df1bae8879c$export$390d11d353c16e49.colorRing) $cb886df1bae8879c$export$390d11d353c16e49.makeColorRing();
        return $cb886df1bae8879c$export$390d11d353c16e49.clone($cb886df1bae8879c$export$390d11d353c16e49.colorRing);
    }
    getJoystick(model) {
        if (!$cb886df1bae8879c$export$390d11d353c16e49['joystick_' + model]) $cb886df1bae8879c$export$390d11d353c16e49.makeJoystick(model);
        return $cb886df1bae8879c$export$390d11d353c16e49.clone($cb886df1bae8879c$export$390d11d353c16e49['joystick_' + model]);
    }
    getCircular(model) {
        if (!$cb886df1bae8879c$export$390d11d353c16e49.circular) $cb886df1bae8879c$export$390d11d353c16e49.makeCircular(model);
        return $cb886df1bae8879c$export$390d11d353c16e49.clone($cb886df1bae8879c$export$390d11d353c16e49.circular);
    }
    getKnob(model) {
        if (!$cb886df1bae8879c$export$390d11d353c16e49.knob) $cb886df1bae8879c$export$390d11d353c16e49.makeKnob(model);
        return $cb886df1bae8879c$export$390d11d353c16e49.clone($cb886df1bae8879c$export$390d11d353c16e49.knob);
    }
    getPad2d(model) {
        if (!$cb886df1bae8879c$export$390d11d353c16e49.pad2d) $cb886df1bae8879c$export$390d11d353c16e49.makePad(model);
        return $cb886df1bae8879c$export$390d11d353c16e49.clone($cb886df1bae8879c$export$390d11d353c16e49.pad2d);
    }
    // from Roots
    cursor(name) {
        $cb886df1bae8879c$var$Roots.cursor(name);
    }
    /////////
    update() {}
    reset() {}
    /////////
    appendChild(m) {
        this.c[0].appendChild(m);
    }
    content() {
        return this.c[0];
    }
    getDom() {
        return this.c[0];
    }
    uiout() {
        if (this.lock) return;
        if (!this.overEffect) return;
        if (this.isGroup) return;
        if (this.isTitle) return;
        if (this.s) this.s[0].background = this.colors.background;
    }
    uiover() {
        if (this.lock) return;
        if (!this.overEffect) return;
        if (this.isGroup) return;
        if (this.isTitle) return;
        if (this.s) this.s[0].background = this.colors.backgroundOver;
    }
    rename(s) {
        if (this.c[1] !== undefined) this.c[1].textContent = s;
    }
    listen() {
        this.isListen = $cb886df1bae8879c$var$Roots.addListen(this);
        return this;
    }
    listening() {
        if (this.objectLink === null) return;
        if (this.isSend) return;
        if (this.isEdit) return;
        this.setValue(this.objectLink[this.objectKey]);
    }
    setValue(v) {
        if (this.isNumber) this.value = this.numValue(v);
        else this.value = v;
        this.update();
    }
    // ----------------------
    // update every change
    // ----------------------
    onChange(f) {
        if (this.isSpace) return;
        this.callback = f || null;
        return this;
    }
    // ----------------------
    // update only on end
    // ----------------------
    onFinishChange(f) {
        if (this.isSpace) return;
        this.callback = null;
        this.endCallback = f;
        return this;
    }
    // ----------------------
    // event on open close
    // ----------------------
    onOpen(f) {
        this.openCallback = f;
        return this;
    }
    onClose(f) {
        this.closeCallback = f;
        return this;
    }
    // ----------------------
    //  send back value
    // ----------------------
    send(v) {
        v = v || this.value;
        if (v instanceof Array && v.length === 1) v = v[0];
        this.isSend = true;
        if (this.objectLink !== null) {
            if (this.objectLink[this.objectKey] && this.objectLink[this.objectKey].isColor) this.objectLink[this.objectKey].setHex(v);
            else this.objectLink[this.objectKey] = v;
        }
        if (this.callback) this.callback(v, this.objectKey);
        this.isSend = false;
    }
    sendEnd(v) {
        v = v || this.value;
        if (v instanceof Array && v.length === 1) v = v[0];
        if (this.endCallback) this.endCallback(v);
        if (this.objectLink !== null) this.objectLink[this.objectKey] = v;
    }
    // ----------------------
    // clear node
    // ----------------------
    dispose() {
        if (this.isListen) $cb886df1bae8879c$var$Roots.removeListen(this);
        $cb886df1bae8879c$export$390d11d353c16e49.clear(this.c[0]);
        if (this.target !== null) {
            if (this.group !== null) this.group.clearOne(this);
            else this.target.removeChild(this.c[0]);
        } else if (this.isUI) this.main.clearOne(this);
        else document.body.removeChild(this.c[0]);
        if (!this.isUI) $cb886df1bae8879c$var$Roots.remove(this);
        this.c = null;
        this.s = null;
        this.callback = null;
        this.target = null;
        this.isListen = false;
    }
    clear() {}
    // ----------------------
    // change size 
    // ----------------------
    getWidth() {
        let nw = $cb886df1bae8879c$var$Roots.getWidth(this);
        if (nw) this.w = nw;
    }
    setSize(sx) {
        if (!this.autoWidth) return;
        this.w = sx;
        if (this.simple) this.sb = this.w - this.sa;
        else {
            let pp = this.w * (this.p / 100);
            //this.sa = Math.floor( pp + 10 )
            //this.sb = Math.floor( this.w - pp - 20 )
            this.sa = Math.floor(pp + 8);
            this.sb = Math.floor(this.w - pp - 16);
        }
    }
    rSize() {
        if (!this.autoWidth) return;
        if (!this.isUI) this.s[0].width = this.w + 'px';
        if (!this.simple) this.s[1].width = this.sa + 'px';
    }
    // ----------------------
    // for numeric value
    // ----------------------
    setTypeNumber(o) {
        this.isNumber = true;
        this.value = 0;
        if (o.value !== undefined) {
            if (typeof o.value === 'string') this.value = o.value * 1;
            else this.value = o.value;
        }
        this.min = o.min === undefined ? -Infinity : o.min;
        this.max = o.max === undefined ? Infinity : o.max;
        this.precision = o.precision === undefined ? 2 : o.precision;
        let s;
        switch(this.precision){
            case 0:
                s = 1;
                break;
            case 1:
                s = 0.1;
                break;
            case 2:
                s = 0.01;
                break;
            case 3:
                s = 0.001;
                break;
            case 4:
                s = 0.0001;
                break;
            case 5:
                s = 0.00001;
                break;
            case 6:
                s = 0.000001;
                break;
        }
        this.step = o.step === undefined ? s : o.step;
        this.range = this.max - this.min;
        this.value = this.numValue(this.value);
    }
    numValue(n) {
        if (this.noNeg) n = Math.abs(n);
        return Math.min(this.max, Math.max(this.min, n)).toFixed(this.precision) * 1;
    }
    // ----------------------
    //   EVENTS DEFAULT
    // ----------------------
    handleEvent(e) {
        if (this.lock) return;
        if (this.neverlock) $cb886df1bae8879c$var$Roots.lock = false;
        if (!this[e.type]) return console.error(e.type, 'this type of event no existe !');
        // TODO !!!!
        //if( this.marginDiv ) z.d -= this.margin * 0.5
        //if( this.marginDiv ) e.clientY -= this.margin * 0.5
        //if( this.group && this.group.marginDiv ) e.clientY -= this.group.margin * 0.5
        return this[e.type](e);
    }
    wheel(e) {
        return false;
    }
    mousedown(e) {
        return false;
    }
    mousemove(e) {
        return false;
    }
    mouseup(e) {
        return false;
    }
    keydown(e) {
        return false;
    }
    keyup(e) {
        return false;
    }
    // ----------------------
    // object referency
    // ----------------------
    setReferency(obj, key) {
        this.objectLink = obj;
        this.objectKey = key;
    }
    display(v = false) {
        this.s[0].visibility = v ? 'visible' : 'hidden';
    }
    // ----------------------
    // resize height 
    // ----------------------
    open() {
        if (this.isOpen) return;
        this.isOpen = true;
        $cb886df1bae8879c$var$Roots.needResize = true;
        if (this.openCallback) this.openCallback();
    }
    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        $cb886df1bae8879c$var$Roots.needResize = true;
        if (this.closeCallback) this.closeCallback();
    }
    needZone() {
        $cb886df1bae8879c$var$Roots.needReZone = true;
    }
    rezone() {
        $cb886df1bae8879c$var$Roots.needReZone = true;
    }
    // ----------------------
    //  INPUT
    // ----------------------
    select() {}
    unselect() {}
    setInput(Input) {
        $cb886df1bae8879c$var$Roots.setInput(Input, this);
    }
    upInput(x, down) {
        return $cb886df1bae8879c$var$Roots.upInput(x, down);
    }
    // ----------------------
    // special item 
    // ----------------------
    selected(b) {
        this.isSelect = b || false;
    }
    constructor(o = {}){
        // disable mouse controle
        this.lock = o.lock || false;
        // for button
        this.neverlock = false;
        // only simple space 
        this.isSpace = o.isSpace || false;
        // if is on gui or group
        this.main = o.main || null;
        this.isUI = o.isUI || false;
        this.group = o.group || null;
        this.isListen = false;
        this.top = 0;
        this.ytop = 0;
        this.dx = o.dx || 0;
        this.isSelectable = o.selectable !== undefined ? o.selectable : false;
        this.unselectable = o.unselect !== undefined ? o.unselect : this.isSelectable;
        this.ontop = o.ontop ? o.ontop : false; // 'beforebegin' 'afterbegin' 'beforeend' 'afterend'
        this.css = this.main ? this.main.css : $cb886df1bae8879c$export$390d11d353c16e49.css;
        this.colors = $cb886df1bae8879c$export$390d11d353c16e49.defineColor(o, this.main ? this.group ? this.group.colors : this.main.colors : $cb886df1bae8879c$export$390d11d353c16e49.colors);
        this.overEffect = this.colors.showOver;
        this.svgs = $cb886df1bae8879c$export$390d11d353c16e49.svgs;
        this.zone = {
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            d: 0
        };
        this.local = new $cb886df1bae8879c$var$V2().neg();
        this.isCanvasOnly = false;
        this.isSelect = false;
        // percent of title
        this.p = o.p !== undefined ? o.p : $cb886df1bae8879c$export$390d11d353c16e49.size.p;
        this.w = this.isUI ? this.main.size.w : $cb886df1bae8879c$export$390d11d353c16e49.size.w;
        if (o.w !== undefined) this.w = o.w;
        this.h = this.isUI ? this.main.size.h : $cb886df1bae8879c$export$390d11d353c16e49.size.h;
        if (o.h !== undefined) this.h = o.h;
        if (!this.isSpace) this.h = this.h < 11 ? 11 : this.h;
        else this.lock = true;
        // decale for canvas only
        this.fw = o.fw || 0;
        this.autoWidth = o.auto || true; // auto width or flex 
        this.isOpen = false; //false// open statu
        // radius for toolbox
        this.radius = o.radius || this.colors.radius;
        this.transition = o.transition || $cb886df1bae8879c$export$390d11d353c16e49.transition;
        // only for number
        this.isNumber = false;
        this.noNeg = o.noNeg || false;
        this.allEqual = o.allEqual || false;
        // only most simple 
        this.mono = false;
        // stop listening for edit slide text
        this.isEdit = false;
        // no title 
        this.simple = o.simple || false;
        if (this.simple) this.sa = 0;
        // define obj size
        this.setSize(this.w);
        // title size
        if (o.sa !== undefined) this.sa = o.sa;
        if (o.sb !== undefined) this.sb = o.sb;
        if (this.simple) this.sb = this.w - this.sa;
        // last number size for slide
        this.sc = o.sc === undefined ? 47 : o.sc;
        // for listening object
        this.objectLink = null;
        this.isSend = false;
        this.objectKey = null;
        this.txt = o.name || '';
        this.name = o.rename || this.txt;
        this.target = o.target || null;
        // callback
        this.callback = o.callback === undefined ? null : o.callback;
        this.endCallback = null;
        this.openCallback = o.openCallback === undefined ? null : o.openCallback;
        this.closeCallback = o.closeCallback === undefined ? null : o.closeCallback;
        // if no callback take one from group or gui
        if (this.callback === null && this.isUI && this.main.callback !== null) this.callback = this.group ? this.group.callback : this.main.callback;
        // elements
        this.c = [];
        // style 
        this.s = [];
        this.useFlex = this.isUI ? this.main.useFlex : false;
        let flexible = this.useFlex ? 'display:flex; justify-content:center; align-items:center; text-align:center; flex: 1 100%;' : 'float:left;';
        this.c[0] = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.basic + flexible + 'position:relative; height:20px;');
        this.s[0] = this.c[0].style;
        // bottom margin
        this.margin = this.colors.sy;
        this.mtop = 0;
        let marginDiv = $cb886df1bae8879c$export$390d11d353c16e49.isDivid(this.margin);
        if (this.isUI && this.margin) {
            this.s[0].boxSizing = 'content-box';
            if (marginDiv) {
                this.mtop = this.margin * 0.5;
                //this.s[0].borderTop = '${this.mtop}px solid transparent'
                //console.log(`${this.mtop}px solid transparent`)
                this.s[0].borderTop = this.mtop + 'px solid transparent';
                this.s[0].borderBottom = this.mtop + 'px solid transparent';
            } else this.s[0].borderBottom = NaN;
        }
        // with title
        if (!this.simple) {
            this.c[1] = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.txt + this.css.middle);
            this.s[1] = this.c[1].style;
            this.c[1].textContent = this.name;
            this.s[1].color = this.lock ? this.colors.titleoff : this.colors.title;
        }
        if (o.pos) {
            this.s[0].position = 'absolute';
            for(let p in o.pos)this.s[0][p] = o.pos[p];
            this.mono = true;
        }
        if (o.css) this.s[0].cssText = o.css;
    }
}
class $cb886df1bae8879c$var$Bool extends $cb886df1bae8879c$var$Proto {
    // ----------------------
    //   EVENTS
    // ----------------------
    mousedown(e) {
        this.value = !this.value;
        this.update(true);
        return this.mousemove(e);
    }
    mousemove(e) {
        this.cursor('pointer');
        return this.mode(true);
    }
    reset() {
        this.cursor();
        return this.mode();
    }
    // ----------------------
    //   MODE
    // ----------------------
    mode(over) {
        let change = false;
        let cc = this.colors, s = this.s, n, v = this.value;
        if (over) n = v ? 4 : 3;
        else n = v ? 2 : 1;
        if (this.stat !== n) {
            this.stat = n;
            if (this.model !== 0) {
                switch(n){
                    case 1:
                        s[2].color = cc.text;
                        s[2].background = cc.button;
                        break;
                    case 2:
                        s[2].color = cc.textSelect;
                        s[2].background = cc.select;
                        break;
                    case 3:
                        s[2].color = cc.textOver;
                        s[2].background = cc.overoff;
                        break;
                    case 4:
                        s[2].color = cc.textOver;
                        s[2].background = cc.over;
                        break;
                }
                this.c[2].innerHTML = v ? this.onName : this.name;
            } else {
                switch(n){
                    case 1:
                        s[2].background = s[2].borderColor = cc.backoff;
                        s[3].background = cc.button;
                        break; // off out
                    case 2:
                        s[2].background = s[2].borderColor = cc.back;
                        s[3].background = cc.textOver;
                        break; // on over
                    case 3:
                        s[2].background = s[2].borderColor = cc.back;
                        s[3].background = cc.overoff;
                        break; // off over
                    case 4:
                        s[2].background = s[2].borderColor = cc.backoff;
                        s[3].background = cc.textSelect;
                        break; // on out
                }
                s[3].marginLeft = v ? '17px' : '2px';
                this.c[1].textContent = v ? this.onName : this.name;
            }
            change = true;
        }
        return change;
    }
    // ----------------------
    update(up) {
        this.mode();
        if (up) this.send();
    }
    rSize() {
        super.rSize();
        let s = this.s;
        let w = this.w - 10 - this.inw;
        if (this.model === 0) {
            s[2].left = w + 'px';
            s[3].left = w + 'px';
        } else {
            s[2].left = this.sa + 'px';
            s[2].width = this.sb + 'px';
        }
    }
    constructor(o = {}){
        super(o);
        this.value = o.value || false;
        this.model = o.mode !== undefined ? o.mode : 0;
        this.onName = o.rename || this.txt;
        if (o.onName) o.onname = o.onName;
        if (o.onname) this.onName = o.onname;
        this.inh = o.inh || Math.floor(this.h * 0.8);
        this.inw = o.inw || 36;
        let cc = this.colors;
        if (this.model === 0) {
            let t = Math.floor(this.h * 0.5) - (this.inh - 2) * 0.5;
            this.c[2] = this.dom('div', this.css.basic + 'background:' + cc.inputBg + '; height:' + (this.inh - 2) + 'px; width:' + this.inw + 'px; top:' + t + 'px; border-radius:10px; border:2px solid ' + cc.back);
            this.c[3] = this.dom('div', this.css.basic + 'height:' + (this.inh - 6) + 'px; width:16px; top:' + (t + 2) + 'px; border-radius:10px; background:' + cc.button + ';');
        } else {
            this.p = 0;
            if (this.c[1] !== undefined) this.c[1].textContent = '';
            this.c[2] = this.dom('div', this.css.txt + this.css.button + 'top:1px; background:' + cc.button + '; height:' + (this.h - 2) + 'px; border:' + cc.borderSize + 'px solid ' + cc.border + '; border-radius:' + this.radius + 'px;');
        }
        this.stat = -1;
        this.init();
        this.update();
    }
}
class $cb886df1bae8879c$var$Button extends $cb886df1bae8879c$var$Proto {
    onOff() {
        this.on = !this.on;
        this.label(this.on ? this.onName : this.value);
    }
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return -1;
        let i = this.lng;
        let t = this.tmp;
        while(i--){
            if (l.x > t[i][0] && l.x < t[i][2]) return i;
        }
        return -1;
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        if (!this.isDown) return false;
        this.isDown = false;
        if (this.res !== -1) {
            if (this.value === this.values[this.res] && this.unselectable) this.value = '';
            else this.value = this.values[this.res];
            if (this.onName !== null) this.onOff();
            this.send();
        }
        return this.mousemove(e);
    }
    mousedown(e) {
        if (this.isDown) return false;
        this.isDown = true;
        return this.mousemove(e);
    }
    mousemove(e) {
        let up = false;
        this.res = this.testZone(e);
        if (this.res !== -1) {
            this.cursor('pointer');
            up = this.modes(this.isDown ? 3 : 2, this.res);
        } else up = this.reset();
        return up;
    }
    // ----------------------
    modes(N = 1, id = -1) {
        let i = this.lng, w, n, r = false;
        while(i--){
            n = N;
            w = this.isSelectable ? this.values[i] === this.value : false;
            if (i === id) {
                if (w && n === 2) n = 3;
            } else {
                n = 1;
                if (w) n = 4;
            }
            //if( this.mode( n, i ) ) r = true
            r = this.mode(n, i);
        }
        return r;
    }
    mode(n, id) {
        //if(!this.s) return false
        let change = false;
        let cc = this.colors, s = this.s;
        let i = id + 2;
        if (this.stat[id] !== n) {
            this.stat[id] = n;
            switch(n){
                case 1:
                    s[i].color = cc.text;
                    s[i].background = cc.button;
                    break;
                case 2:
                    s[i].color = cc.textOver;
                    s[i].background = cc.overoff;
                    break;
                case 3:
                    s[i].color = cc.textOver;
                    s[i].background = cc.over;
                    break;
                case 4:
                    s[i].color = cc.textSelect;
                    s[i].background = cc.select;
                    break;
            }
            change = true;
        }
        return change;
    }
    // ----------------------
    reset() {
        this.res = -1;
        this.cursor();
        return this.modes();
    }
    label(string, n) {
        n = n || 2;
        this.c[n].textContent = string;
    }
    switchValues(n, string) {
        this.c[n + 2].innerHTML = this.values[n] = string;
    }
    icon(string, y = 0, n = 2) {
        //if(y) this.s[n].margin = ( y ) +'px 0px';
        this.s[n].padding = y + 'px 0px';
        this.c[n].innerHTML = string;
        return this;
    }
    rSize() {
        super.rSize();
        let s = this.s;
        let w = this.sb;
        let d = this.sa;
        let i = this.lng;
        let sx = this.colors.sx; //this.space;
        //let size = Math.floor( ( w-(dc*(i-1)) ) / i );
        let size = (w - sx * (i - 1)) / i;
        if (this.bw) {
            size = this.bw < size ? this.bw : size;
            //d = Math.floor((this.w-( (size * i) + (dc * (i-1)) ))*0.5)
            d = (this.w - (size * i + sx * (i - 1))) * 0.5;
        }
        while(i--){
            //this.tmp[i] = [ Math.floor( d + ( size * i ) + ( dc * i )), size ];
            this.tmp[i] = [
                d + size * i + sx * i,
                size
            ];
            this.tmp[i][2] = this.tmp[i][0] + this.tmp[i][1];
            s[i + 2].left = this.tmp[i][0] + 'px';
            s[i + 2].width = this.tmp[i][1] + 'px';
        }
    }
    constructor(o = {}){
        super(o);
        this.value = '';
        if (o.value !== undefined) this.value = o.value;
        this.values = o.value || this.txt;
        if (o.values) this.values = o.values;
        if (!o.values && !o.value) this.txt = '';
        this.onName = o.onName || null;
        this.on = false;
        // force button width
        this.bw = o.forceWidth || 0;
        if (o.bw) this.bw = o.bw;
        this.space = o.space || 3;
        if (typeof this.values === 'string') this.values = [
            this.values
        ];
        this.isDown = false;
        this.neverlock = true;
        this.res = 0;
        this.lng = this.values.length;
        this.tmp = [];
        this.stat = [];
        let sel, cc = this.colors;
        for(let i = 0; i < this.lng; i++){
            sel = false;
            if (this.values[i] === this.value && this.isSelectable) sel = true;
            this.c[i + 2] = this.dom('div', this.css.txt + this.css.button + 'top:1px; height:' + (this.h - 2) + 'px; border:' + cc.borderSize + 'px solid ' + cc.border + '; border-radius:' + this.radius + 'px;');
            this.c[i + 2].style.background = sel ? cc.select : cc.button;
            this.c[i + 2].style.color = sel ? cc.textSelect : cc.text;
            this.c[i + 2].innerHTML = this.values[i];
            this.stat[i] = sel ? 3 : 1;
        }
        if (this.txt === '') this.p = 0;
        if (!o.value && !o.values || this.p === 0) {
            if (this.c[1] !== undefined) this.c[1].textContent = '';
        }
        this.init();
    }
}
class $cb886df1bae8879c$var$Circular extends $cb886df1bae8879c$var$Proto {
    mode(mode) {
        if (this.cmode === mode) return false;
        let cc = this.colors;
        let color;
        switch(mode){
            case 0:
                this.s[2].color = cc.text;
                this.setSvg(this.c[3], 'stroke', cc.back, 0);
                color = this.model > 0 ? $cb886df1bae8879c$export$390d11d353c16e49.pack($cb886df1bae8879c$export$390d11d353c16e49.lerpColor($cb886df1bae8879c$export$390d11d353c16e49.unpack($cb886df1bae8879c$export$390d11d353c16e49.ColorLuma(cc.text, -0.75)), $cb886df1bae8879c$export$390d11d353c16e49.unpack(cc.text), this.percent)) : cc.text;
                this.setSvg(this.c[3], 'stroke', color, 1);
                break;
            case 1:
                this.s[2].color = cc.textOver;
                this.setSvg(this.c[3], 'stroke', cc.backoff, 0);
                color = this.model > 0 ? $cb886df1bae8879c$export$390d11d353c16e49.pack($cb886df1bae8879c$export$390d11d353c16e49.lerpColor($cb886df1bae8879c$export$390d11d353c16e49.unpack($cb886df1bae8879c$export$390d11d353c16e49.ColorLuma(cc.text, -0.75)), $cb886df1bae8879c$export$390d11d353c16e49.unpack(cc.text), this.percent)) : cc.textOver;
                this.setSvg(this.c[3], 'stroke', color, 1);
                break;
        }
        this.cmode = mode;
        return true;
    }
    reset() {
        this.isDown = false;
    }
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.y <= this.c[1].offsetHeight) return 'title';
        else if (l.y > this.h - this.c[2].offsetHeight) return 'text';
        else return 'circular';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        this.isDown = false;
        this.sendEnd();
        return this.mode(0);
    }
    mousedown(e) {
        this.isDown = true;
        this.old = this.value;
        this.oldr = null;
        this.mousemove(e);
        return this.mode(1);
    }
    mousemove(e) {
        if (!this.isDown) return;
        //console.log('over')
        let off = this.offset;
        off.x = this.w * 0.5 - (e.clientX - this.zone.x);
        off.y = this.diam * 0.5 - (e.clientY - this.zone.y - this.ytop);
        this.r = off.angle() - this.pi90;
        this.r = (this.r % this.twoPi + this.twoPi) % this.twoPi;
        if (this.oldr !== null) {
            let dif = this.r - this.oldr;
            this.r = Math.abs(dif) > Math.PI ? this.oldr : this.r;
            if (dif > 6) this.r = 0;
            if (dif < -6) this.r = this.twoPi;
        }
        let steps = 1 / this.twoPi;
        let value = this.r * steps;
        let n = this.range * value + this.min - this.old;
        if (n >= this.step || n <= this.step) {
            n = ~~(n / this.step);
            this.value = this.numValue(this.old + n * this.step);
            this.update(true);
            this.old = this.value;
            this.oldr = this.r;
        }
    }
    wheel(e) {
        let name = this.testZone(e);
        if (name === 'circular') {
            let v = this.value - this.step * e.delta;
            if (v > this.max) v = this.isCyclic ? this.min : this.max;
            else if (v < this.min) v = this.isCyclic ? this.max : this.min;
            this.setValue(v);
            this.old = v;
            this.update(true);
            return true;
        }
        return false;
    }
    // ----------------------
    makePath() {
        let r = 40;
        let d = 24;
        let a = this.percent * this.twoPi - 0.001;
        let x2 = r + r * Math.sin(a) + d;
        let y2 = r - r * Math.cos(a) + d;
        let big = a > Math.PI ? 1 : 0;
        return "M " + (r + d) + "," + d + " A " + r + "," + r + " 0 " + big + " 1 " + x2 + "," + y2;
    }
    update(up) {
        this.c[2].textContent = this.value;
        this.percent = (this.value - this.min) / this.range;
        this.setSvg(this.c[3], 'd', this.makePath(), 1);
        if (this.model > 0) {
            let cc = this.colors;
            let color = $cb886df1bae8879c$export$390d11d353c16e49.pack($cb886df1bae8879c$export$390d11d353c16e49.lerpColor($cb886df1bae8879c$export$390d11d353c16e49.unpack($cb886df1bae8879c$export$390d11d353c16e49.ColorLuma(cc.text, -0.75)), $cb886df1bae8879c$export$390d11d353c16e49.unpack(cc.text), this.percent));
            this.setSvg(this.c[3], 'stroke', color, 1);
        }
        if (up) this.send();
    }
    constructor(o = {}){
        super(o);
        this.isCyclic = o.cyclic || false;
        this.model = o.stype || 0;
        if (o.mode !== undefined) this.model = o.mode;
        this.autoWidth = false;
        this.minw = this.w;
        this.diam = o.diam || this.w;
        this.setTypeNumber(o);
        this.twoPi = $cb886df1bae8879c$export$390d11d353c16e49.TwoPI;
        this.pi90 = $cb886df1bae8879c$export$390d11d353c16e49.pi90;
        this.offset = new $cb886df1bae8879c$var$V2();
        this.h = o.h || this.w + 10;
        this.c[0].style.width = this.w + 'px';
        this.c[0].style.display = 'block';
        if (this.c[1] !== undefined) {
            this.c[1].style.width = '100%';
            this.c[1].style.justifyContent = 'center';
            this.top = 10;
            this.h += 10;
        }
        this.percent = 0;
        this.cmode = 0;
        let cc = this.colors;
        this.c[2] = this.dom('div', this.css.txt + 'justify-content:center; top:' + (this.h - 20) + 'px; width:100%; color:' + cc.text);
        // svg
        this.c[3] = this.getCircular();
        this.setSvg(this.c[3], 'stroke', cc.back, 0);
        this.setSvg(this.c[3], 'd', this.makePath(), 1);
        this.setSvg(this.c[3], 'stroke', cc.text, 1);
        this.setSvg(this.c[3], 'viewBox', '0 0 ' + this.diam + ' ' + this.diam);
        this.setCss(this.c[3], {
            width: this.diam,
            height: this.diam,
            left: 0,
            top: this.top
        });
        this.init();
        this.update();
    }
}
class $cb886df1bae8879c$var$Color extends $cb886df1bae8879c$var$Proto {
    testZone(mx, my) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (this.up && this.isOpen) {
            if (l.y > this.wfixe) return 'title';
            else return 'color';
        } else {
            if (l.y < this.baseH + 2) return 'title';
            else if (this.isOpen) return 'color';
        }
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        this.isDown = false;
        this.d = 256;
    }
    mousedown(e) {
        let name = this.testZone(e.clientX, e.clientY);
        //if( !name ) return;
        if (name === 'title') {
            if (!this.isOpen) this.open();
            else this.close();
            return true;
        }
        if (name === 'color') {
            this.isDown = true;
            this.fistDown = true;
            this.mousemove(e);
        }
    }
    mousemove(e) {
        let name = this.testZone(e.clientX, e.clientY);
        let off, d, hue, sat, lum, rad, x, y, rr, T = $cb886df1bae8879c$export$390d11d353c16e49;
        if (name === 'title') this.cursor('pointer');
        if (name === 'color') {
            off = this.offset;
            off.x = e.clientX - (this.zone.x + this.decal.x + this.mid);
            off.y = e.clientY - (this.zone.y + this.decal.y + this.mid) - this.ytop;
            d = off.length() * this.ratio;
            rr = off.angle();
            if (rr < 0) rr += 2 * T.PI;
            if (d < 128) this.cursor('crosshair');
            else if (!this.isDown) this.cursor();
            if (this.isDown) {
                if (this.fistDown) {
                    this.d = d;
                    this.fistDown = false;
                }
                if (this.d < 128) {
                    if (this.d > this.tr) {
                        hue = (rr + T.pi90) / T.TwoPI;
                        this.hue = (hue + 1) % 1;
                        this.setHSL([
                            (hue + 1) % 1,
                            this.hsl[1],
                            this.hsl[2]
                        ]);
                    } else {
                        x = off.x * this.ratio;
                        y = off.y * this.ratio;
                        let rr = this.hue * T.TwoPI + T.PI;
                        if (rr < 0) rr += 2 * T.PI;
                        rad = Math.atan2(-y, x);
                        if (rad < 0) rad += 2 * T.PI;
                        let rad0 = (rad + T.pi90 + T.TwoPI + rr) % T.TwoPI, rad1 = rad0 % (2 / 3 * T.PI) - T.pi60, a = 0.5 * this.tr, b = Math.tan(rad1) * a, r = Math.sqrt(x * x + y * y), maxR = Math.sqrt(a * a + b * b);
                        if (r > maxR) {
                            let dx = Math.tan(rad1) * r;
                            let rad2 = Math.atan(dx / maxR);
                            if (rad2 > T.pi60) rad2 = T.pi60;
                            else if (rad2 < -T.pi60) rad2 = -T.pi60;
                            rad += rad2 - rad1;
                            rad0 = (rad + T.pi90 + T.TwoPI + rr) % T.TwoPI, rad1 = rad0 % (2 / 3 * T.PI) - T.pi60;
                            b = Math.tan(rad1) * a;
                            r = maxR = Math.sqrt(a * a + b * b);
                        }
                        lum = Math.sin(rad0) * r / this.tsl + 0.5;
                        let w = 1 - Math.abs(lum - 0.5) * 2;
                        sat = (Math.cos(rad0) * r + this.tr / 2) / (1.5 * this.tr) / w;
                        sat = T.clamp(sat, 0, 1);
                        this.setHSL([
                            this.hsl[0],
                            sat,
                            lum
                        ]);
                    }
                }
            }
        }
    }
    // ----------------------
    setHeight() {
        this.h = this.isOpen ? this.wfixe + this.baseH + 5 : this.baseH;
        this.s[0].height = this.h + 'px';
        this.zone.h = this.h;
    }
    parentHeight(t) {
        if (this.group !== null) this.group.calc(t);
        else if (this.isUI) this.main.calc(t);
    }
    open() {
        super.open();
        this.setHeight();
        if (this.up) this.zone.y -= this.wfixe + 5;
        let t = this.h - this.baseH;
        this.s[3].visibility = 'visible';
        //this.s[3].display = 'block';
        this.parentHeight(t);
    }
    close() {
        super.close();
        if (this.up) this.zone.y += this.wfixe + 5;
        let t = this.h - this.baseH;
        this.setHeight();
        this.s[3].visibility = 'hidden';
        //this.s[3].display = 'none';
        this.parentHeight(-t);
    }
    update(up) {
        let cc = $cb886df1bae8879c$export$390d11d353c16e49.rgbToHex($cb886df1bae8879c$export$390d11d353c16e49.hslToRgb([
            this.hsl[0],
            1,
            0.5
        ]));
        this.moveMarkers();
        this.value = this.bcolor;
        this.setSvg(this.c[3], 'fill', cc, 2, 0);
        this.s[2].background = this.bcolor;
        if (!this.notext) this.c[2].textContent = $cb886df1bae8879c$export$390d11d353c16e49.htmlToHex(this.bcolor);
        this.invert = $cb886df1bae8879c$export$390d11d353c16e49.findDeepInver(this.rgb);
        this.s[2].color = this.invert ? '#fff' : '#000';
        if (!up) return;
        if (this.ctype === 'array') this.send(this.rgb);
        if (this.ctype === 'rgb') this.send($cb886df1bae8879c$export$390d11d353c16e49.htmlRgb(this.rgb));
        if (this.ctype === 'hex') this.send($cb886df1bae8879c$export$390d11d353c16e49.htmlToHex(this.value));
        if (this.ctype === 'html') this.send();
    }
    setValue(v) {
        if (v instanceof Array) this.value = $cb886df1bae8879c$export$390d11d353c16e49.rgbToHex(v);
        else if (!isNaN(v)) this.value = $cb886df1bae8879c$export$390d11d353c16e49.hexToHtml(v);
        else this.value = v;
        this.setColor(this.value);
        this.update();
    }
    setColor(color) {
        let unpack = $cb886df1bae8879c$export$390d11d353c16e49.unpack(color);
        if (this.bcolor !== color && unpack) {
            this.bcolor = color;
            this.rgb = unpack;
            this.hsl = $cb886df1bae8879c$export$390d11d353c16e49.rgbToHsl(this.rgb);
            this.hue = this.hsl[0];
            this.update();
        }
        return this;
    }
    setHSL(hsl) {
        this.hsl = hsl;
        this.rgb = $cb886df1bae8879c$export$390d11d353c16e49.hslToRgb(hsl);
        this.bcolor = $cb886df1bae8879c$export$390d11d353c16e49.rgbToHex(this.rgb);
        this.update(true);
        return this;
    }
    moveMarkers() {
        let p = this.pp;
        let T = $cb886df1bae8879c$export$390d11d353c16e49;
        this.invert;
        let a = this.hsl[0] * T.TwoPI;
        let third = 2 / 3 * T.PI;
        let r = this.tr;
        let h = this.hsl[0];
        let s = this.hsl[1];
        let l = this.hsl[2];
        let angle = (a - T.pi90) * T.todeg;
        h = -a + T.pi90;
        let hx = Math.cos(h) * r;
        let hy = -Math.sin(h) * r;
        let sx = Math.cos(h - third) * r;
        let sy = -Math.sin(h - third) * r;
        let vx = Math.cos(h + third) * r;
        let vy = -Math.sin(h + third) * r;
        let mx = (sx + vx) / 2, my = (sy + vy) / 2;
        a = (1 - 2 * Math.abs(l - .5)) * s;
        let x = sx + (vx - sx) * l + (hx - mx) * a;
        let y = sy + (vy - sy) * l + (hy - my) * a;
        p.set(x, y).addScalar(128);
        //let ff = (1-l)*255;
        // this.setSvg( this.c[3], 'stroke', 'rgb('+ff+','+ff+','+ff+')', 3 );
        this.setSvg(this.c[3], 'transform', 'rotate(' + angle + ' )', 2);
        this.setSvg(this.c[3], 'cx', p.x, 3);
        this.setSvg(this.c[3], 'cy', p.y, 3);
        this.setSvg(this.c[3], 'stroke', this.invert ? '#fff' : '#000', 2, 3);
        this.setSvg(this.c[3], 'stroke', this.invert ? '#fff' : '#000', 3);
        this.setSvg(this.c[3], 'fill', this.bcolor, 3);
    }
    rSize() {
        //Proto.prototype.rSize.call( this );
        super.rSize();
        let s = this.s;
        s[2].width = this.sb + 'px';
        s[2].left = this.sa + 'px';
        //console.log(this.sb)
        this.cw = this.sb > 256 ? 256 : this.sb;
        this.rSizeColor(this.cw);
        this.decal.x = Math.floor((this.w - this.wfixe) * 0.5);
    //s[3].left = this.decal.x + 'px';
    }
    rSizeColor(w) {
        if (w === this.wfixe) return;
        this.wfixe = w;
        let s = this.s;
        //this.decal.x = Math.floor((this.w - this.wfixe) * 0.5);
        this.decal.y = this.side === 'up' ? 2 : this.baseH + 2;
        this.mid = Math.floor(this.wfixe * 0.5);
        this.setSvg(this.c[3], 'viewBox', '0 0 ' + this.wfixe + ' ' + this.wfixe);
        s[3].width = this.wfixe + 'px';
        s[3].height = this.wfixe + 'px';
        //s[3].left = this.decal.x + 'px';
        s[3].top = this.decal.y + 'px';
        this.ratio = 256 / this.wfixe;
        this.square = 1 / (60 * (this.wfixe / 256));
        this.setHeight();
    }
    constructor(o = {}){
        super(o);
        //this.autoHeight = true;
        this.ctype = o.ctype || 'hex';
        this.wfixe = 256;
        this.cw = this.sb > 256 ? 256 : this.sb;
        if (o.cw != undefined) this.cw = o.cw;
        // color up or down
        this.side = o.side || 'down';
        this.up = this.side === 'down' ? 0 : 1;
        this.baseH = this.h;
        this.offset = new $cb886df1bae8879c$var$V2();
        this.decal = new $cb886df1bae8879c$var$V2();
        this.pp = new $cb886df1bae8879c$var$V2();
        let cc = this.colors;
        // this.c[2] = this.dom( 'div', this.css.txt + this.css.middle + 'top:1px; height:'+(this.h-2)+'px;' + 'border-radius:'+this.radius+'px; text-shadow:none; border:'+cc.borderSize+'px solid '+cc.border+';' )
        this.c[2] = this.dom('div', `${this.css.txt} ${this.css.middle} top:1px; height:${this.h - 2}px; border-radius:${this.radius}px; text-shadow:none; border:${cc.borderSize}px solid ${cc.border};`);
        //this.s[2] = this.c[2].style;
        //this.s[2].textShadow = 'none'
        /*if( this.up ){
	        this.s[2].top = 'auto';
	        this.s[2].bottom = '2px';
	    }*/ //this.c[0].style.textAlign = 'center';
        this.c[0].style.display = 'block';
        this.c[3] = this.getColorRing();
        this.c[3].style.visibility = 'hidden';
        this.hsl = null;
        this.value = '#ffffff';
        if (o.value !== undefined) {
            if (o.value.isColor) this.value = '#' + o.value.getHexString();
            else if (o.value instanceof Array) this.value = $cb886df1bae8879c$export$390d11d353c16e49.rgbToHex(o.value);
            else if (!isNaN(o.value)) this.value = $cb886df1bae8879c$export$390d11d353c16e49.hexToHtml(o.value);
            else this.value = o.value;
        }
        this.bcolor = null;
        this.isDown = false;
        this.fistDown = false;
        this.notext = o.notext || false;
        this.tr = 98;
        this.tsl = Math.sqrt(3) * this.tr;
        this.hue = 0;
        this.d = 256;
        this.init();
        this.setColor(this.value);
        if (o.open !== undefined) this.open();
    }
}
class $cb886df1bae8879c$var$Fps extends $cb886df1bae8879c$var$Proto {
    // ----------------------
    //   EVENTS
    // ----------------------
    mousedown(e) {
        if (this.isShow) this.close();
        else this.open();
    }
    // ----------------------
    /*mode: function ( mode ) {

        let s = this.s;

        switch(mode){
            case 0: // base
                s[1].color = this.colors.text;
                //s[1].background = 'none';
            break;
            case 1: // over
                s[1].color = '#FFF';
                //s[1].background = UIL.SELECT;
            break;
            case 2: // edit / down
                s[1].color = this.colors.text;
                //s[1].background = UIL.SELECTDOWN;
            break;

        }
    },*/ tick(v) {
        this.values = v;
        if (!this.isShow) return;
        this.drawGraph();
        this.upText();
    }
    makePath(point) {
        let p = '';
        p += "M -1 50";
        for(let i = 0; i < this.res + 1; i++)p += ' L ' + i + ' ' + point[i];
        p += ' L ' + (this.res + 1) + ' ' + 50;
        return p;
    }
    upText(val) {
        let v = val || this.values, t = '';
        for(let j = 0, lng = this.names.length; j < lng; j++)t += this.textDisplay[j] + v[j].toFixed(this.precision) + '</span>';
        this.c[4].innerHTML = t;
    }
    drawGraph() {
        let svg = this.c[2];
        let i = this.names.length, v, old = 0, n = 0;
        while(i--){
            if (this.adding) v = (this.values[n] + old) * this.range[n];
            else v = this.values[n] * this.range[n];
            this.points[n].shift();
            this.points[n].push(50 - v);
            this.setSvg(svg, 'd', this.makePath(this.points[n]), i + 1);
            old += this.values[n];
            n++;
        }
    }
    open() {
        super.open();
        this.h = this.hplus + this.baseH;
        this.setSvg(this.c[3], 'd', this.svgs.g2);
        if (this.group !== null) this.group.calc(this.hplus);
        else if (this.isUI) this.main.calc(this.hplus);
        this.s[0].height = this.h + 'px';
        this.s[2].display = 'block';
        this.s[4].display = 'block';
        this.isShow = true;
        if (!this.custom) $cb886df1bae8879c$var$Roots.addListen(this);
    }
    close() {
        super.close();
        this.h = this.baseH;
        this.setSvg(this.c[3], 'd', this.svgs.g1);
        if (this.group !== null) this.group.calc(-this.hplus);
        else if (this.isUI) this.main.calc(-this.hplus);
        this.s[0].height = this.h + 'px';
        this.s[2].display = 'none';
        this.s[4].display = 'none';
        this.isShow = false;
        if (!this.custom) $cb886df1bae8879c$var$Roots.removeListen(this);
        this.c[4].innerHTML = '';
    }
    ///// AUTO FPS //////
    begin() {
        this.startTime = this.now();
    }
    end() {
        let time = this.now();
        this.ms = time - this.startTime;
        this.frames++;
        if (time > this.prevTime + 1000) {
            this.fps = this.round(this.frames * 1000 / (time - this.prevTime));
            this.prevTime = time;
            this.frames = 0;
            if (this.isMem) {
                let heapSize = performance.memory.usedJSHeapSize;
                let heapSizeLimit = performance.memory.jsHeapSizeLimit;
                this.mem = this.round(heapSize * 0.000000954);
                this.mm = heapSize / heapSizeLimit;
            }
        }
        this.values = [
            this.fps,
            this.ms,
            this.mm
        ];
        this.drawGraph();
        this.upText([
            this.fps,
            this.ms,
            this.mem
        ]);
        return time;
    }
    listening() {
        if (!this.custom) this.startTime = this.end();
    }
    rSize() {
        let s = this.s;
        let w = this.w;
        s[3].left = this.sa + this.sb - 6 + 'px';
        s[0].width = w + 'px';
        s[1].width = w + 'px';
        s[2].left = "10px";
        s[2].width = w - 20 + 'px';
        s[4].width = w - 20 + 'px';
    }
    constructor(o = {}){
        super(o);
        this.round = Math.round;
        //this.autoHeight = true;
        this.baseH = this.h;
        this.hplus = o.hplus || 50;
        this.res = o.res || 40;
        this.l = 1;
        this.precision = o.precision || 0;
        this.custom = o.custom || false;
        this.names = o.names || [
            'FPS',
            'MS'
        ];
        let cc = o.cc || [
            '220,220,220',
            '255,255,0'
        ];
        // this.divid = [ 100, 100, 100 ];
        // this.multy = [ 30, 30, 30 ];
        this.adding = o.adding || false;
        this.range = o.range || [
            165,
            100,
            100
        ];
        this.alpha = o.alpha || 0.25;
        this.values = [];
        this.points = [];
        this.textDisplay = [];
        if (!this.custom) {
            this.now = $cb886df1bae8879c$var$Roots.getTime();
            this.startTime = 0; //this.now()
            this.prevTime = 0; //this.startTime;
            this.frames = 0;
            this.ms = 0;
            this.fps = 0;
            this.mem = 0;
            this.mm = 0;
            this.isMem = self.performance && self.performance.memory ? true : false;
            // this.divid = [ 100, 200, 1 ];
            // this.multy = [ 30, 30, 30 ];
            if (this.isMem) {
                this.names.push('MEM');
                cc.push('0,255,255');
            }
            this.txt = o.name || 'Fps';
        }
        let fltop = Math.floor(this.h * 0.5) - 3;
        const ccc = this.colors;
        this.c[1].textContent = this.txt;
        //this.c[1].innerHTML = '&#160;' + this.txt
        this.c[0].style.cursor = 'pointer';
        this.c[0].style.pointerEvents = 'auto';
        let panelCss = 'display:none; left:10px; top:' + this.h + 'px; height:' + (this.hplus - 8) + 'px; box-sizing:border-box; background: rgba(0, 0, 0, 0.2); border:1px solid ' + ccc.border + ';';
        if (this.radius !== 0) panelCss += 'border-radius:' + this.radius + 'px;';
        this.c[2] = this.dom('path', this.css.basic + panelCss, {});
        this.c[2].setAttribute('viewBox', '0 0 ' + this.res + ' 50');
        this.c[2].setAttribute('height', '100%');
        this.c[2].setAttribute('width', '100%');
        this.c[2].setAttribute('preserveAspectRatio', 'none');
        //this.dom( 'path', null, { fill:'rgba(255,255,0,0.3)', 'stroke-width':1, stroke:'#FF0', 'vector-effect':'non-scaling-stroke' }, this.c[2] );
        //this.dom( 'path', null, { fill:'rgba(0,255,255,0.3)', 'stroke-width':1, stroke:'#0FF', 'vector-effect':'non-scaling-stroke' }, this.c[2] );
        // arrow
        this.c[3] = this.dom('path', this.css.basic + 'position:absolute; width:6px; height:6px; left:0; top:' + fltop + 'px;', {
            d: this.svgs.g1,
            fill: ccc.text,
            stroke: 'none'
        });
        //this.c[3] = this.dom( 'path', this.css.basic + 'position:absolute; width:10px; height:10px; left:4px; top:'+fltop+'px;', { d:this.svgs.arrow, fill:this.colors.text, stroke:'none'});
        // result test
        this.c[4] = this.dom('div', this.css.txt + 'position:absolute; left:10px; top:' + (this.h + 2) + 'px; display:none; width:100%; text-align:center;');
        // bottom line
        if (o.bottomLine) this.c[4] = this.dom('div', this.css.basic + 'width:100%; bottom:0px; height:1px; background: rgba(255, 255, 255, 0.2);');
        this.isShow = false;
        let s = this.s;
        //s[1].marginLeft = '10px';
        s[1].lineHeight = this.h - 4;
        s[1].color = ccc.text;
        //s[1].paddingLeft = '18px';
        //s[1].fontWeight = 'bold';
        if (this.radius !== 0) s[0].borderRadius = this.radius + 'px';
        if (this.colors.gborder !== 'none') s[0].border = '1px solid ' + ccc.gborder;
        let j = 0;
        for(j = 0; j < this.names.length; j++){
            let base = [];
            let i = this.res + 1;
            while(i--)base.push(50);
            this.range[j] = 1 / this.range[j] * 49;
            this.points.push(base);
            this.values.push(0);
            //  this.dom( 'path', null, { fill:'rgba('+cc[j]+',0.5)', 'stroke-width':1, stroke:'rgba('+cc[j]+',1)', 'vector-effect':'non-scaling-stroke' }, this.c[2] );
            this.textDisplay.push("<span style='color:rgb(" + cc[j] + ")'> " + this.names[j] + " ");
        }
        j = this.names.length;
        while(j--)this.dom('path', null, {
            fill: 'rgba(' + cc[j] + ',' + this.alpha + ')',
            'stroke-width': 1,
            stroke: 'rgba(' + cc[j] + ',1)',
            'vector-effect': 'non-scaling-stroke'
        }, this.c[2]);
        this.init();
    //if( this.isShow ) this.show();
    }
}
class $cb886df1bae8879c$var$Graph extends $cb886df1bae8879c$var$Proto {
    setValue(value) {
        this.value = value;
        this.lng = this.value.length;
        for(var i = 0; i < this.lng; i++)if (this.neg) this.v[i] = (1 + value[i] / this.multiplicator) * 0.5;
        else this.v[i] = value[i] / this.multiplicator;
        this.update();
    }
    valueToHtml() {
        let i = this.lng, n = 0, r = '<table style="width:100%;"><tr>';
        let w = 100 / this.lng;
        let style = 'width:' + w + '%;'; //' text-align:center;'
        while(i--){
            if (n === this.lng - 1) r += '<td style=' + style + '>' + this.value[n] + '</td></tr></table>';
            else r += '<td style=' + style + '>' + this.value[n] + '</td>';
            n++;
        }
        return r;
    }
    updateSVG() {
        if (this.line) this.setSvg(this.c[3], 'd', this.makePath(), 0);
        for(let i = 0; i < this.lng; i++){
            this.setSvg(this.c[3], 'height', this.v[i] * this.gh, i + 2);
            this.setSvg(this.c[3], 'y', 14 + (this.gh - this.v[i] * this.gh), i + 2);
            if (this.neg) this.value[i] = ((this.v[i] * 2 - 1) * this.multiplicator).toFixed(this.precision) * 1;
            else this.value[i] = (this.v[i] * this.multiplicator).toFixed(this.precision) * 1;
        }
        //this.c[2].textContent = this.value;
        this.c[2].innerHTML = this.valueToHtml();
    }
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        let i = this.lng;
        let t = this.tmp;
        if (l.y > this.top && l.y < this.h - 20) while(i--){
            if (l.x > t[i][0] && l.x < t[i][2]) return i;
        }
        return '';
    }
    mode(n, name) {
        if (n === this.cMode[name]) return false;
        let a;
        switch(n){
            case 0:
                a = 0.3;
                break;
            case 1:
                a = 0.6;
                break;
            case 2:
                a = 1;
                break;
        }
        this.reset();
        this.setSvg(this.c[3], 'fill-opacity', a, name + 2);
        this.cMode[name] = n;
        return true;
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    reset() {
        let nup = false;
        //this.isDown = false;
        let i = this.lng;
        while(i--)if (this.cMode[i] !== 0) {
            this.cMode[i] = 0;
            this.setSvg(this.c[3], 'fill-opacity', 0.3, i + 2);
            nup = true;
        }
        return nup;
    }
    mouseup(e) {
        this.isDown = false;
        if (this.current !== -1) return this.reset();
    }
    mousedown(e) {
        this.isDown = true;
        return this.mousemove(e);
    }
    mousemove(e) {
        let nup = false;
        let name = this.testZone(e);
        if (name === '') nup = this.reset();
        else {
            nup = this.mode(this.isDown ? 2 : 1, name);
            //this.cursor( this.current !== -1 ? 'move' : 'pointer' );
            if (this.isDown) {
                this.v[name] = this.clamp(1 - (e.clientY - this.zone.y - this.ytop - 10) / this.gh, 0, 1);
                this.update(true);
            }
        }
        return nup;
    }
    // ----------------------
    update(up) {
        this.updateSVG();
        if (up) this.send();
    }
    makePath() {
        let p = "", h, w, wn, wm, ow, oh;
        //let g = this.iw*0.5
        for(let i = 0; i < this.lng; i++){
            h = 14 + (this.gh - this.v[i] * this.gh);
            w = 14 + i * this.iw + i * 4;
            wm = w + this.iw * 0.5;
            wn = w + this.iw;
            if (i === 0) p += 'M ' + w + ' ' + h + ' T ' + wm + ' ' + h;
            else p += ' C ' + ow + ' ' + oh + ',' + w + ' ' + h + ',' + wm + ' ' + h;
            if (i === this.lng - 1) p += ' T ' + wn + ' ' + h;
            ow = wn;
            oh = h;
        }
        return p;
    }
    rSize() {
        super.rSize();
        let s = this.s;
        if (this.c[1] !== undefined) s[1].width = this.w + 'px';
        s[3].width = this.w + 'px';
        let gw = this.w - 28;
        let iw = (gw - 4 * (this.lng - 1)) / this.lng;
        let t = [];
        s[2].width = gw + 'px';
        for(let i = 0; i < this.lng; i++){
            t[i] = [
                14 + i * iw + i * 4,
                iw
            ];
            t[i][2] = t[i][0] + t[i][1];
        }
        this.tmp = t;
    }
    constructor(o = {}){
        super(o);
        this.value = o.value !== undefined ? o.value : [
            0,
            0,
            0
        ];
        this.lng = this.value.length;
        this.precision = o.precision !== undefined ? o.precision : 2;
        this.multiplicator = o.multiplicator || 1;
        this.neg = o.neg || false;
        this.line = o.line !== undefined ? o.line : true;
        //if(this.neg)this.multiplicator*=2;
        this.autoWidth = o.autoWidth !== undefined ? o.autoWidth : true;
        this.isNumber = false;
        this.isDown = false;
        this.h = o.h || 138;
        this.rh = this.h - 10;
        this.top = 0;
        this.c[0].style.width = this.w + 'px';
        if (this.c[1] !== undefined) {
            this.c[1].style.width = this.w + 'px';
            if (!this.autoWidth) {
                this.c[1].style.width = '100%';
                this.c[1].style.justifyContent = 'center';
            }
            //this.c[1].style.background = '#ff0000';
            //this.c[1].style.textAlign = 'center';
            this.top = 10;
            this.h += 10;
        }
        this.gh = this.rh - 28;
        this.gw = this.w - 28;
        //this.c[2] = this.dom( 'div', this.css.txt + 'justify-content:center; text-align: justify; column-count:'+this.lng+'; top:'+(this.h-20)+'px; width:100%; color:'+ this.colors.text );
        //let colum = 'column-count:'+this.lng+'; column:'+this.lng+'; break-inside: column; top:'
        this.c[2] = this.dom('div', this.css.txt + 'display:block; text-align:center; padding:0px 0px; top:' + (this.h - 20) + 'px; left:14px; width:' + this.gw + 'px;  color:' + this.colors.text);
        //this.c[2].textContent = this.value;
        this.c[2].innerHTML = this.valueToHtml();
        let svg = this.dom('svg', this.css.basic, {
            viewBox: '0 0 ' + this.w + ' ' + this.rh,
            width: this.w,
            height: this.rh,
            preserveAspectRatio: 'none'
        });
        this.setCss(svg, {
            width: this.w,
            height: this.rh,
            left: 0,
            top: this.top
        });
        this.dom('path', '', {
            d: '',
            stroke: this.colors.text,
            'stroke-width': 2,
            fill: 'none',
            'stroke-linecap': 'butt'
        }, svg);
        this.dom('rect', '', {
            x: 10,
            y: 10,
            width: this.gw + 8,
            height: this.gh + 8,
            stroke: 'rgba(0,0,0,0.3)',
            'stroke-width': 1,
            fill: 'none'
        }, svg);
        this.iw = (this.gw - 4 * (this.lng - 1)) / this.lng;
        let t = [];
        this.cMode = [];
        this.v = [];
        for(let i = 0; i < this.lng; i++){
            t[i] = [
                14 + i * this.iw + i * 4,
                this.iw
            ];
            t[i][2] = t[i][0] + t[i][1];
            this.cMode[i] = 0;
            if (this.neg) this.v[i] = (1 + this.value[i] / this.multiplicator) * 0.5;
            else this.v[i] = this.value[i] / this.multiplicator;
            this.dom('rect', '', {
                x: t[i][0],
                y: 14,
                width: t[i][1],
                height: 1,
                fill: this.colors.text,
                'fill-opacity': 0.3
            }, svg);
        }
        this.tmp = t;
        this.c[3] = svg;
        //console.log(this.w)
        this.init();
        if (this.c[1] !== undefined) {
            this.c[1].style.top = "0px";
            this.c[1].style.height = "20px";
            this.s[1].lineHeight = "15px";
        }
        this.update(false);
    }
}
class $cb886df1bae8879c$var$Empty extends $cb886df1bae8879c$var$Proto {
    constructor(o = {}){
        o.isSpace = true;
        o.margin = 0;
        if (!o.h) o.h = 10;
        super(o);
        this.init();
    }
}
class $cb886df1bae8879c$var$Group extends $cb886df1bae8879c$var$Proto {
    setBG(bg) {
        const cc = this.colors;
        const s = this.s;
        if (bg !== undefined) cc.groups = bg;
        if (cc.groups === 'none') cc.groups = cc.background;
        //    cc.background = 'none'
        s[0].background = bg !== undefined ? 'none' : cc.content;
        s[1].background = bg !== undefined ? cc.groups : cc.content;
        //s[2].background = bg !== undefined ? cc.groups : cc.content
        //s[0].background = '#FF0';
        //s[4].background = '#FF0';
        //s[2].background = cc.background
        if (cc.gborder !== 'none') s[1].border = cc.borderSize + 'px solid ' + cc.gborder;
        if (this.radius !== 0) {
            s[1].borderRadius = this.radius + 'px';
            s[2].borderRadius = this.radius + 'px';
        }
    /*let i = this.uis.length;
        while(i--){
            this.uis[i].setBG( 'none' );
            //this.uis[i].setBG( this.colors.background );
        }*/ }
    testZone(e) {
        //console.log( this.local)
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        let name = '';
        if (l.y < this.baseH + this.margin) name = 'title';
        else if (this.isOpen) name = 'content';
        return name;
    }
    clearTarget() {
        if (this.current === -1) return false;
        if (this.proto.s) {
            // if no s target is delete !!
            this.proto.uiout();
            this.proto.reset();
        }
        this.proto = null;
        this.current = -1;
        this.cursor();
        return true;
    }
    reset() {
        this.clearTarget();
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    handleEvent(e) {
        let type = e.type;
        let change = false;
        let protoChange = false;
        let name = this.testZone(e);
        if (!name) return;
        switch(name){
            case 'content':
                //this.cursor()
                //if( this.marginDiv ) e.clientY -= this.margin * 0.5
                if ($cb886df1bae8879c$var$Roots.isMobile && type === 'mousedown') this.getNext(e, change);
                if (this.proto) //e.clientY -= this.margin
                protoChange = this.proto.handleEvent(e);
                if (!$cb886df1bae8879c$var$Roots.lock) this.getNext(e, change);
                break;
            case 'title':
                //this.cursor( this.isOpen ? 'n-resize':'s-resize' );
                this.cursor('pointer');
                if (type === 'mousedown') {
                    if (this.isOpen) this.close();
                    else this.open();
                }
                break;
        }
        if (this.isDown) change = true;
        if (protoChange) change = true;
        return change;
    }
    getNext(e, change) {
        let next = $cb886df1bae8879c$var$Roots.findTarget(this.uis, e);
        if (next !== this.current) {
            this.clearTarget();
            this.current = next;
        }
        if (next !== -1) {
            this.proto = this.uis[this.current];
            this.proto.uiover();
        }
    }
    // ----------------------
    add() {
        let a = arguments;
        if (typeof a[1] === 'object') {
            a[1].isUI = this.isUI;
            a[1].target = this.c[2];
            a[1].main = this.main;
            a[1].group = this;
        } else if (typeof arguments[1] === 'string') {
            if (a[2] === undefined) [].push.call(a, {
                isUI: true,
                target: this.c[2],
                main: this.main
            });
            else {
                a[2].isUI = true;
                a[2].target = this.c[2];
                a[2].main = this.main;
                a[2].group = this;
            }
        }
        let u = this.ADD.apply(this, a);
        if (u.isGroup) //o.add = add;
        u.dx = 8;
        //u.dx += 4
        //console.log(this.decal)
        //u.zone.d -= 8
        $cb886df1bae8879c$var$Roots.forceZone = true;
        //u.margin += this.margin
        //console.log( u.margin )
        //Roots.needReZone = true
        //Roots.resize()
        //console.log(Roots.needResize)
        this.uis.push(u);
        this.isEmpty = false;
        return u;
    }
    // remove one node
    remove(n) {
        if (n.dispose) n.dispose();
    }
    // clear all iner 
    dispose() {
        this.clear();
        if (this.isUI) this.main.calc();
        super.dispose();
    }
    clear() {
        this.empty();
    }
    empty() {
        this.close();
        let i = this.uis.length, item;
        while(i--){
            item = this.uis.pop();
            this.c[2].removeChild(item.c[0]);
            item.clear(true);
        //this.uis[i].clear()
        }
        this.isEmpty = true;
        this.h = this.baseH;
    }
    // clear one element
    clearOne(n) {
        let id = this.uis.indexOf(n);
        if (id !== -1) {
            this.calc(-(this.uis[id].h + this.margin));
            this.c[2].removeChild(this.uis[id].c[0]);
            this.uis.splice(id, 1);
            if (this.uis.length === 0) {
                this.isEmpty = true;
                this.close();
            }
        }
    }
    open() {
        super.open();
        this.setSvg(this.c[3], 'd', this.svgs.g2);
        this.rSizeContent();
        //let t = this.h - this.baseH
        const s = this.s;
        const cc = this.colors;
        //s[2].top = (this.h-1) + 'px'
        s[2].top = this.h + this.mtop + 'px';
        //s[4].background = '#0f0'
        if (this.radius) {
            s[1].borderRadius = '0px';
            s[2].borderRadius = '0px';
            s[1].borderTopLeftRadius = this.radius + 'px';
            s[1].borderTopRightRadius = this.radius + 'px';
            s[2].borderBottomLeftRadius = this.radius + 'px';
            s[2].borderBottomRightRadius = this.radius + 'px';
        }
        if (cc.gborder !== 'none') {
            s[4].borderLeft = cc.borderSize + 'px solid ' + cc.gborder;
            s[4].borderRight = cc.borderSize + 'px solid ' + cc.gborder;
            s[2].border = cc.borderSize + 'px solid ' + cc.gborder;
            s[2].borderTop = 'none';
            s[1].borderBottom = cc.borderSize + 'px solid rgba(0,0,0,0)';
        }
        this.parentHeight();
    //Roots.isLeave = true
    //Roots.needResize = true
    }
    close() {
        super.close();
        //let t = this.h - this.baseH
        this.setSvg(this.c[3], 'd', this.svgs.g1);
        this.h = this.baseH;
        const s = this.s;
        const cc = this.colors;
        s[0].height = this.h + 'px';
        //s[1].height = (this.h-2) + 'px'
        //s[2].top = this.h + 'px'
        s[2].top = this.h + this.mtop + 'px';
        //s[4].background = 'none'
        if (cc.gborder !== 'none') {
            s[4].border = 'none';
            s[2].border = 'none';
            s[1].border = cc.borderSize + 'px solid ' + cc.gborder;
        }
        if (this.radius) s[1].borderRadius = this.radius + 'px';
        this.parentHeight();
    }
    calcUis() {
        if (!this.isOpen || this.isEmpty) this.h = this.baseH;
        else this.h = $cb886df1bae8879c$var$Roots.calcUis([
            ...this.uis
        ], this.zone, this.zone.y + this.baseH + this.margin, true) + this.baseH;
        // else this.h = Roots.calcUis( [...this.uis, this.spaceY ], this.zone, this.zone.y + this.baseH + this.margin, true ) + this.baseH
        this.s[0].height = this.h + 'px';
        this.s[2].height = this.h - this.baseH + 'px';
    }
    parentHeight(t) {
        if (this.group !== null) this.group.calc(t);
        else if (this.isUI) this.main.calc(t);
    }
    calc(y) {
        if (!this.isOpen) return;
        if (this.isUI) this.main.calc();
        else this.calcUis();
        this.s[0].height = this.h + 'px';
        this.s[2].height = this.h + 'px';
    }
    rSizeContent() {
        let i = this.uis.length;
        while(i--){
            this.uis[i].setSize(this.w);
            this.uis[i].rSize();
        }
    }
    rSize() {
        super.rSize();
        let s = this.s;
        this.w = this.w - this.decal;
        s[3].left = this.sa + this.sb - 6 + 'px';
        s[1].width = this.w + 'px';
        s[2].width = this.w + 'px';
        s[1].left = this.decal + 'px';
        s[2].left = this.decal + 'px';
        if (this.isOpen) this.rSizeContent();
    }
    constructor(o = {}){
        super(o);
        this.isGroup = true;
        this.ADD = o.add;
        this.autoHeight = true;
        this.uis = [];
        this.current = -1;
        this.proto = null;
        this.isEmpty = true;
        this.decal = o.group ? 8 : 0;
        //this.dd = o.group ? o.group.decal + 8 : 0
        this.baseH = this.h;
        //this.spaceY = new Empty({h:this.margin});
        this.radius = 0;
        let fltop = Math.floor(this.h * 0.5) - 3;
        const cc = this.colors;
        this.useFlex = true;
        let flexible = this.useFlex ? 'display:flex; flex-flow: row wrap;' : '';
        this.c[2] = this.dom('div', this.css.basic + flexible + 'width:100%; left:0;  overflow:hidden; top:' + this.h + 'px');
        this.c[3] = this.dom('path', this.css.basic + 'position:absolute; width:6px; height:6px; left:0; top:' + fltop + 'px;', {
            d: this.svgs.g1,
            fill: cc.text,
            stroke: 'none'
        });
        this.mtop === 0 ? this.margin : this.mtop;
        //this.c[4] = this.dom( 'div', this.css.basic + 'width:100%; left:0; height:'+(bh+1)+'px; top:'+((this.h-1))+'px; background:#f00;')
        this.s;
        this.c[1].name = 'group';
        this.c[1].style.color = cc.text;
        this.init();
        this.setBG(o.bg);
        //console.log(this.margin)
        if (o.open) //setTimeout( this.open.bind(this), 100 )
        this.open();
    }
}
class $cb886df1bae8879c$var$Joystick extends $cb886df1bae8879c$var$Proto {
    mode(mode) {
        let cc = this.colors;
        switch(mode){
            case 0:
                if (this.model === 0) {
                    this.setSvg(this.c[3], 'fill', 'url(#gradIn)', 4);
                    this.setSvg(this.c[3], 'stroke', '#000', 4);
                } else {
                    this.setSvg(this.c[3], 'stroke', cc.joyOut, 2);
                    //this.setSvg( this.c[3], 'stroke', 'rgb(0,0,0,0.1)', 3 );
                    this.setSvg(this.c[3], 'stroke', cc.joyOut, 4);
                    this.setSvg(this.c[3], 'fill', 'none', 4);
                }
                break;
            case 1:
                if (this.model === 0) {
                    this.setSvg(this.c[3], 'fill', 'url(#gradIn2)', 4);
                    this.setSvg(this.c[3], 'stroke', 'rgba(0,0,0,0)', 4);
                } else {
                    this.setSvg(this.c[3], 'stroke', cc.joyOver, 2);
                    //this.setSvg( this.c[3], 'stroke', 'rgb(0,0,0,0.3)', 3 );
                    this.setSvg(this.c[3], 'stroke', cc.joySelect, 4);
                    this.setSvg(this.c[3], 'fill', cc.joyOver, 4);
                }
                break;
        }
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    addInterval() {
        if (this.interval !== null) this.stopInterval();
        if (this.pos.isZero()) return;
        this.interval = setInterval((function() {
            this.update();
        }).bind(this), 10);
    }
    stopInterval() {
        if (this.interval === null) return;
        clearInterval(this.interval);
        this.interval = null;
    }
    reset() {
        this.addInterval();
        this.mode(0);
    }
    mouseup(e) {
        this.addInterval();
        this.isDown = false;
    }
    mousedown(e) {
        this.isDown = true;
        this.mousemove(e);
        this.mode(2);
    }
    mousemove(e) {
        this.mode(1);
        if (!this.isDown) return;
        //this.tmp.x = this.radius - ( e.clientX - this.zone.x );
        //this.tmp.y = this.radius - ( e.clientY - this.zone.y - this.top );
        this.tmp.x = this.w * 0.5 - (e.clientX - this.zone.x);
        this.tmp.y = this.diam * 0.5 - (e.clientY - this.zone.y - this.ytop);
        let distance = this.tmp.length();
        if (distance > this.distance) {
            let angle = Math.atan2(this.tmp.x, this.tmp.y);
            this.tmp.x = Math.sin(angle) * this.distance;
            this.tmp.y = Math.cos(angle) * this.distance;
        }
        this.pos.copy(this.tmp).divideScalar(this.distance).negate();
        this.update();
    }
    setValue(v) {
        if (v === undefined) v = [
            0,
            0
        ];
        this.pos.set(v[0] || 0, v[1] || 0);
        this.updateSVG();
    }
    update(up) {
        if (up === undefined) up = true;
        if (this.interval !== null) {
            if (!this.isDown) {
                this.pos.lerp(null, 0.3);
                this.pos.x = Math.abs(this.pos.x) < 0.01 ? 0 : this.pos.x;
                this.pos.y = Math.abs(this.pos.y) < 0.01 ? 0 : this.pos.y;
                if (this.isUI && this.main.isCanvas) this.main.draw();
            }
        }
        this.updateSVG();
        if (up) this.send();
        if (this.pos.isZero()) this.stopInterval();
    }
    updateSVG() {
        //let x = this.radius - ( -this.pos.x * this.distance );
        //let y = this.radius - ( -this.pos.y * this.distance );
        let x = this.diam * 0.5 - -this.pos.x * this.distance;
        let y = this.diam * 0.5 - -this.pos.y * this.distance;
        if (this.model === 0) {
            let sx = x + this.pos.x * 5 + 5;
            let sy = y + this.pos.y * 5 + 10;
            this.setSvg(this.c[3], 'cx', sx * this.ratio, 3);
            this.setSvg(this.c[3], 'cy', sy * this.ratio, 3);
        } else {
            this.setSvg(this.c[3], 'cx', x * this.ratio, 3);
            this.setSvg(this.c[3], 'cy', y * this.ratio, 3);
        }
        this.setSvg(this.c[3], 'cx', x * this.ratio, 4);
        this.setSvg(this.c[3], 'cy', y * this.ratio, 4);
        this.value[0] = (this.pos.x * this.multiplicator).toFixed(this.precision) * 1;
        this.value[1] = (this.pos.y * this.multiplicator).toFixed(this.precision) * 1;
        if (this.haveText) this.c[2].textContent = this.value;
    }
    clear() {
        this.stopInterval();
        super.clear();
    }
    constructor(o = {}){
        super(o);
        this.autoWidth = false;
        this.value = [
            0,
            0
        ];
        this.minw = this.w;
        this.diam = o.diam || this.w;
        this.joyType = 'analogique';
        this.model = o.mode !== undefined ? o.mode : 0;
        this.precision = o.precision || 2;
        this.multiplicator = o.multiplicator || 1;
        this.pos = new $cb886df1bae8879c$var$V2();
        this.tmp = new $cb886df1bae8879c$var$V2();
        this.interval = null;
        this.c[0].style.display = 'block';
        this.haveText = o.text !== undefined ? o.text : true;
        //this.radius = this.w * 0.5;
        //this.distance = this.radius*0.25;
        this.distance = this.diam * 0.125;
        this.h = o.h || this.w + (this.haveText ? 10 : 0);
        this.c[0].style.width = this.w + 'px';
        if (this.c[1] !== undefined) {
            this.c[1].style.width = '100%';
            this.c[1].style.justifyContent = 'center';
            this.top = 10;
            this.h += 10;
        }
        let cc = this.colors;
        this.c[2] = this.dom('div', this.css.txt + 'justify-content:center; top:' + (this.h - 20) + 'px; width:100%; color:' + cc.text);
        this.c[2].textContent = this.haveText ? this.value : '';
        this.c[3] = this.getJoystick(this.model);
        this.setSvg(this.c[3], 'viewBox', '0 0 ' + this.diam + ' ' + this.diam);
        this.setCss(this.c[3], {
            width: this.diam,
            height: this.diam,
            left: 0,
            top: this.top
        });
        this.mode(0);
        this.ratio = 128 / this.w;
        this.init();
        this.update(false);
    }
}
class $cb886df1bae8879c$var$Knob extends $cb886df1bae8879c$var$Proto {
    mode(mode) {
        let cc = this.colors;
        if (this.cmode === mode) return false;
        switch(mode){
            case 0:
                this.s[2].color = cc.text;
                this.setSvg(this.c[3], 'fill', cc.button, 0);
                //this.setSvg( this.c[3], 'stroke','rgba(255,0,0,0.2)', 2);
                this.setSvg(this.c[3], 'stroke', cc.text, 1);
                break;
            case 1:
                this.s[2].color = cc.textOver;
                this.setSvg(this.c[3], 'fill', cc.select, 0);
                //this.setSvg( this.c[3], 'stroke','rgba(0,0,0,0.6)', 2);
                this.setSvg(this.c[3], 'stroke', cc.textOver, 1);
                break;
        }
        this.cmode = mode;
        return true;
    }
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.y <= this.c[1].offsetHeight) return 'title';
        else if (l.y > this.h - this.c[2].offsetHeight) return 'text';
        else return 'knob';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        this.isDown = false;
        this.sendEnd();
        return this.mode(0);
    }
    mousedown(e) {
        this.isDown = true;
        this.old = this.value;
        this.oldr = null;
        this.mousemove(e);
        return this.mode(1);
    }
    mousemove(e) {
        if (!this.isDown) return;
        let off = this.offset;
        //off.x = this.radius - ( e.clientX - this.zone.x );
        //off.y = this.radius - ( e.clientY - this.zone.y - this.top );
        off.x = this.w * 0.5 - (e.clientX - this.zone.x);
        off.y = this.diam * 0.5 - (e.clientY - this.zone.y - this.ytop);
        this.r = -Math.atan2(off.x, off.y);
        if (this.oldr !== null) this.r = Math.abs(this.r - this.oldr) > Math.PI ? this.oldr : this.r;
        this.r = this.r > this.mPI ? this.mPI : this.r;
        this.r = this.r < -this.mPI ? -this.mPI : this.r;
        let steps = 1 / this.cirRange;
        let value = (this.r + this.mPI) * steps;
        let n = this.range * value + this.min - this.old;
        if (n >= this.step || n <= this.step) {
            n = Math.floor(n / this.step);
            this.value = this.numValue(this.old + n * this.step);
            this.update(true);
            this.old = this.value;
            this.oldr = this.r;
        }
    }
    wheel(e) {
        let name = this.testZone(e);
        if (name === 'knob') {
            let v = this.value - this.step * e.delta;
            if (v > this.max) v = this.isCyclic ? this.min : this.max;
            else if (v < this.min) v = this.isCyclic ? this.max : this.min;
            this.setValue(v);
            this.old = v;
            this.update(true);
            return true;
        }
        return false;
    }
    makeGrad() {
        let d = '', step, range, a, x, y, x2, y2, r = 64;
        let startangle = Math.PI + this.mPI;
        let endangle = Math.PI - this.mPI;
        //let step = this.step>5 ? this.step : 1;
        if (this.step > 5) {
            range = this.range / this.step;
            step = (startangle - endangle) / range;
        } else {
            step = (startangle - endangle) / r * 2;
            range = r * 0.5;
        }
        for(let i = 0; i <= range; ++i){
            a = startangle - step * i;
            x = r + Math.sin(a) * (r - 20);
            y = r + Math.cos(a) * (r - 20);
            x2 = r + Math.sin(a) * (r - 24);
            y2 = r + Math.cos(a) * (r - 24);
            d += 'M' + x + ' ' + y + ' L' + x2 + ' ' + y2 + ' ';
        }
        return d;
    }
    update(up) {
        this.c[2].textContent = this.value;
        this.percent = (this.value - this.min) / this.range;
        let sa = Math.PI + this.mPI;
        let ea = this.percent * this.cirRange - this.mPI;
        let sin = Math.sin(ea);
        let cos = Math.cos(ea);
        let x1 = 25 * sin + 64;
        let y1 = -(25 * cos) + 64;
        let x2 = 20 * sin + 64;
        let y2 = -(20 * cos) + 64;
        this.setSvg(this.c[3], 'd', 'M ' + x1 + ' ' + y1 + ' L ' + x2 + ' ' + y2, 1);
        if (this.model > 0) {
            let x1 = 36 * Math.sin(sa) + 64;
            let y1 = 36 * Math.cos(sa) + 64;
            let x2 = 36 * sin + 64;
            let y2 = -36 * cos + 64;
            let big = ea <= Math.PI - this.mPI ? 0 : 1;
            this.setSvg(this.c[3], 'd', 'M ' + x1 + ',' + y1 + ' A ' + 36 + ',' + 36 + ' 1 ' + big + ' 1 ' + x2 + ',' + y2, 4);
            let color = $cb886df1bae8879c$export$390d11d353c16e49.pack($cb886df1bae8879c$export$390d11d353c16e49.lerpColor($cb886df1bae8879c$export$390d11d353c16e49.unpack($cb886df1bae8879c$export$390d11d353c16e49.ColorLuma(this.colors.text, -0.75)), $cb886df1bae8879c$export$390d11d353c16e49.unpack(this.colors.text), this.percent));
            this.setSvg(this.c[3], 'stroke', color, 4);
        }
        if (up) this.send();
    }
    constructor(o = {}){
        super(o);
        this.isCyclic = o.cyclic || false;
        this.model = o.stype || 0;
        if (o.mode !== undefined) this.model = o.mode;
        this.autoWidth = false;
        this.setTypeNumber(o);
        this.minw = this.w;
        this.diam = o.diam || this.w;
        this.mPI = Math.PI * 0.8;
        this.toDeg = 180 / Math.PI;
        this.cirRange = this.mPI * 2;
        this.offset = new $cb886df1bae8879c$var$V2();
        this.h = o.h || this.w + 10;
        this.c[0].style.width = this.w + 'px';
        this.c[0].style.display = 'block';
        if (this.c[1] !== undefined) {
            this.c[1].style.width = '100%';
            this.c[1].style.justifyContent = 'center';
            this.top = 10;
            this.h += 10;
        }
        this.percent = 0;
        this.cmode = 0;
        let cc = this.colors;
        this.c[2] = this.dom('div', this.css.txt + 'justify-content:center; top:' + (this.h - 20) + 'px; width:100%; color:' + cc.text);
        this.c[3] = this.getKnob();
        this.setSvg(this.c[3], 'fill', cc.button, 0);
        this.setSvg(this.c[3], 'stroke', cc.text, 1);
        this.setSvg(this.c[3], 'stroke', cc.text, 3);
        this.setSvg(this.c[3], 'd', this.makeGrad(), 3);
        this.setSvg(this.c[3], 'viewBox', '0 0 ' + this.diam + ' ' + this.diam);
        this.setCss(this.c[3], {
            width: this.diam,
            height: this.diam,
            left: 0,
            top: this.top
        });
        if (this.model > 0) {
            $cb886df1bae8879c$export$390d11d353c16e49.dom('path', '', {
                d: '',
                stroke: cc.text,
                'stroke-width': 2,
                fill: 'none',
                'stroke-linecap': 'round'
            }, this.c[3]); //4
            if (this.model == 2) {
                $cb886df1bae8879c$export$390d11d353c16e49.addSVGGlowEffect();
                this.setSvg(this.c[3], 'style', 'filter: url("#UILGlow");', 4);
            }
        }
        this.r = 0;
        this.init();
        this.update();
    }
}
class $cb886df1bae8879c$var$List extends $cb886df1bae8879c$var$Proto {
    // image list
    preloadImage() {
        this.preLoadComplete = false;
        this.tmpImage = {};
        for(let i = 0; i < this.list.length; i++)this.tmpUrl.push(this.list[i]);
        this.loadOne();
    }
    nextImg() {
        if (this.c === null) return;
        this.tmpUrl.shift();
        if (this.tmpUrl.length === 0) {
            this.preLoadComplete = true;
            this.addImages();
        /*this.setList( this.list );
            this.init();
            if( this.isOpenOnStart ) this.open();*/ } else this.loadOne();
    }
    loadOne() {
        let self1 = this;
        let name = this.tmpUrl[0];
        let img = document.createElement('img');
        img.style.cssText = 'position:absolute; width:' + self1.imageSize[0] + 'px; height:' + self1.imageSize[1] + 'px';
        img.setAttribute('src', this.path + name + this.format);
        img.addEventListener('load', function() {
            self1.imageSize[2] = img.width;
            self1.imageSize[3] = img.height;
            self1.tmpImage[name] = img;
            self1.nextImg();
        });
    }
    //
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (this.up && this.isOpen) {
            if (l.y > this.h - this.baseH) return 'title';
            else {
                if (this.scroll && l.x > this.sa + this.sb - this.ss) return 'scroll';
                if (l.x > this.sa) return this.testItems(l.y - this.baseH);
            }
        } else {
            if (l.y < this.baseH + 2) return 'title';
            else if (this.isOpen) {
                if (this.scroll && l.x > this.sa + this.sb - this.ss) return 'scroll';
                if (l.x > this.sa) return this.testItems(l.y - this.baseH);
            }
        }
        return '';
    }
    testItems(y) {
        let name = '';
        let items = this.items;
        /*if(this.hideCurrent){
            //items = [...this.items]
            items = this.items.slice(this.tmpId)

        }*/ let i = items.length, item, a, b;
        while(i--){
            item = items[i];
            a = item.posy + this.topList;
            b = item.posy + this.itemHeight + 1 + this.topList;
            if (y >= a && y <= b) {
                name = 'item' + i;
                this.modeItem(0);
                this.current = item;
                this.modeItem(1);
                return name;
            }
        }
        return name;
    }
    modeItem(mode) {
        if (!this.current) return;
        if (this.current.select && mode === 0) mode = 2;
        let cc = this.colors;
        switch(mode){
            case 0:
                this.current.style.background = cc.back;
                this.current.style.color = cc.text;
                break;
            case 1:
                this.current.style.background = cc.over;
                this.current.style.color = cc.textOver;
                break;
            case 2:
                this.current.style.background = cc.select;
                this.current.style.color = cc.textSelect;
                break;
        }
    }
    unSelected() {
        if (!this.current) return;
        this.modeItem(0);
        this.current = null;
    }
    selected() {
        if (!this.current) return;
        this.resetItems();
        this.modeItem(2);
        this.current.select = true;
    }
    resetItems() {
        let i = this.items.length;
        while(i--){
            this.items[i].select = false;
            this.items[i].style.background = this.colors.back;
            this.items[i].style.color = this.colors.text;
        }
    }
    hideActive() {
        if (!this.hideCurrent) return;
        //if( !this.current ) return
        if (this.current) this.tmpId = this.current.id;
        this.resetHide();
    //this.items[this.tmpId].style.height = 0+'px'
    }
    resetHide() {
        console.log(this.tmpId);
        let i = this.items.length;
        while(i--)if (i === this.tmpId) {
            this.items[i].style.height = "0px";
            this.items[i].posy = -1;
        } else {
            this.items[i].style.height = this.itemHeight + 'px';
            this.items[i].posy = (this.itemHeight + 1) * (i - 1);
        }
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        this.isDown = false;
    }
    mousedown(e) {
        let name = this.testZone(e);
        if (!name) return false;
        if (name === 'scroll') {
            this.isDown = true;
            this.mousemove(e);
        } else if (name === 'title') {
            this.modeTitle(2);
            if (!this.listOnly) {
                this.hideActive();
                if (!this.isOpen) this.open();
                else this.close();
            }
        } else // is item
        if (this.current) {
            this.value = this.list[this.current.id];
            //this.tmpId = this.current.id
            if (this.isSelectable) this.selected();
            //this.send( this.refObject !== null ? this.refObject[ this.list[this.current.id]] : this.value );
            this.send(this.value);
            if (!this.listOnly) {
                this.close();
                this.setTopItem();
            //this.hideActive()
            }
        }
        return true;
    }
    mousemove(e) {
        let nup = false;
        let name = this.testZone(e);
        if (!name) return nup;
        if (name === 'title') {
            this.unSelected();
            this.modeTitle(1);
            this.cursor('pointer');
        } else if (name === 'scroll') {
            this.cursor('s-resize');
            this.modeScroll(1);
            if (this.isDown) {
                this.modeScroll(2);
                //this.update( ( e.clientY - top  ) - ( this.sh*0.5 ) );
                let top = this.zone.y + this.baseH - 2;
                this.update(e.clientY - top - this.sh * 0.5);
            }
        //if(this.isDown) this.listmove(e);
        } else {
            // is item
            this.modeTitle(0);
            this.modeScroll(0);
            this.cursor('pointer');
        }
        if (name !== this.prevName) nup = true;
        this.prevName = name;
        return nup;
    }
    wheel(e) {
        let name = this.testZone(e);
        if (name === 'title') return false;
        this.py += e.delta * 10;
        this.update(this.py);
        return true;
    }
    // ----------------------
    reset() {
        this.prevName = '';
        this.unSelected();
        this.modeTitle(0);
        this.modeScroll(0);
    //console.log('this is reset')
    }
    modeScroll(mode) {
        if (mode === this.sMode) return;
        let s = this.scroller.style;
        let cc = this.colors;
        switch(mode){
            case 0:
                s.background = cc.text;
                break;
            case 1:
                s.background = cc.select;
                break;
            case 2:
                s.background = cc.select;
                break;
        }
        this.sMode = mode;
    }
    modeTitle(mode) {
        if (mode === this.tMode) return;
        let s = this.s;
        let cc = this.colors;
        switch(mode){
            case 0:
                s[3].color = cc.text;
                s[3].background = cc.button;
                break;
            case 1:
                s[3].color = cc.textOver;
                s[3].background = cc.overoff;
                break;
            case 2:
                s[3].color = cc.textSelect;
                s[3].background = cc.overoff;
                break;
        }
        this.tMode = mode;
    }
    clearList() {
        while(this.listIn.children.length)this.listIn.removeChild(this.listIn.lastChild);
        this.items = [];
    }
    setList(list) {
        this.clearList();
        this.list = list;
        this.length = this.list.length;
        let lng = this.hideCurrent ? this.length - 1 : this.length;
        this.maxItem = this.full ? lng : 5;
        this.maxItem = lng < this.maxItem ? lng : this.maxItem;
        this.maxHeight = this.maxItem * (this.itemHeight + 1) + 2;
        this.max = lng * (this.itemHeight + 1) + 2;
        this.ratio = this.maxHeight / this.max;
        this.sh = this.maxHeight * this.ratio;
        this.range = this.maxHeight - this.sh;
        this.c[2].style.height = this.maxHeight + 'px';
        this.scrollerBack.style.height = this.maxHeight + 'px';
        this.scroller.style.height = this.sh + 'px';
        if (this.max > this.maxHeight) {
            this.ww = this.sb - this.ss;
            this.scroll = true;
        }
        if (this.miniCanvas) {
            this.tmpCanvas = document.createElement('canvas');
            this.tmpCanvas.width = this.imageSize[0];
            this.tmpCanvas.height = this.imageSize[1];
            this.tmpCtx = this.tmpCanvas.getContext("2d");
            this.tmpCtx.fillStyle = this.canvasBg;
            this.tmpCtx.fillRect(0, 0, this.imageSize[0], this.imageSize[1]);
        }
        let item, n; //, l = this.sb;
        for(let i = 0; i < this.length; i++){
            n = this.list[i];
            item = this.dom('div', this.css.item + 'padding:0px ' + (this.m + 1) + 'px; width:' + this.ww + 'px; height:' + this.itemHeight + 'px; line-height:' + (this.itemHeight - 2) + 'px; color:' + this.colors.text + '; background:' + this.colors.back + ';');
            item.name = 'item' + i;
            item.id = i;
            item.select = false;
            item.posy = (this.itemHeight + 1) * i;
            this.listIn.appendChild(item);
            this.items.push(item);
            if (n === this.value) this.current = item;
            //if( this.isWithImage ) item.appendChild( this.tmpImage[n] );
            if (!this.isWithImage) item.textContent = n;
            if (this.miniCanvas) {
                let c = new Image();
                c.src = this.tmpCanvas.toDataURL();
                //item.style.marginLeft = (this.imageSize[0]+8)+'px'
                /*let c = document.createElement('canvas')

                c.width = this.imageSize[0]
                c.height = this.imageSize[1]
                let ctx = c.getContext("2d")
                ctx.fillStyle = this.canvasBg
                ctx.fillRect(0, 0, this.imageSize[0], this.imageSize[1])*/ //c.style.cssText = 'position:relative; pointer-events:none; display:inline-block; float:left; margin-left:0px; margin-right:5px; top:2px'
                // c.style.cssText =' flex-shrink: 0;'
                c.style.cssText = 'margin-right:4px;';
                //c.style.cssText = 'display:flex; align-content: flex-start; flex-wrap: wrap;'
                //item.style.float = 'right'
                item.appendChild(c);
                this.tmpImage[n] = c;
            }
            if (this.dragout) {
                item.img = this.tmpImage[n];
                item.style.pointerEvents = 'auto';
                item.draggable = "true";
                item.addEventListener('dragstart', this.dragstart || function() {});
                item.addEventListener('drag', this.drag || function() {});
                //item.addEventListener('dragover', this);
                //item.addEventListener('dragenter', this);
                item.addEventListener('dragleave', function() {
                    $cb886df1bae8879c$var$Roots.fakeUp();
                });
                item.addEventListener('dragend', this.dragend || (function() {}).bind(this));
            //item.addEventListener('drop', function(){console.log('drop')})
            }
        }
        this.setTopItem();
        if (this.isSelectable) this.selected();
    }
    drawImage(name, image, x, y, w, h) {
        this.tmpCtx.clearRect(0, 0, this.imageSize[0], this.imageSize[1]);
        this.tmpCtx.drawImage(image, x, y, w, h, 0, 0, this.imageSize[0], this.imageSize[1]);
        this.tmpImage[name].src = this.tmpCanvas.toDataURL();
    /*let c = this.tmpImage[name]
        let ctx = c.getContext("2d")
        ctx.drawImage(image, x, y, w, h, 0, 0, this.imageSize[0], this.imageSize[1])*/ }
    addImages() {
        let lng = this.list.length;
        for(let i = 0; i < lng; i++)this.items[i].appendChild(this.tmpImage[this.list[i]]);
        this.setTopItem();
    }
    setValue(value) {
        if (!isNaN(value)) this.value = this.list[value];
        else this.value = value;
        //this.tmpId = value
        this.setTopItem();
    }
    setTopItem() {
        if (this.staticTop) return;
        if (this.isWithImage) {
            if (!this.preLoadComplete) return;
            if (!this.c[3].children.length) {
                this.canvas = document.createElement('canvas');
                this.canvas.width = this.imageSize[0];
                this.canvas.height = this.imageSize[1];
                this.canvas.style.cssText = 'margin-right:4px;';
                this.ctx = this.canvas.getContext("2d");
                this.c[3].style.textAlign = 'left';
                this.c[3].style.justifyContent = 'left';
                this.c[3].appendChild(this.canvas);
            }
            this.tmpImage[this.value];
            this.ctx.drawImage(this.tmpImage[this.value], 0, 0, this.imageSize[2], this.imageSize[3], 0, 0, this.imageSize[0], this.imageSize[1]);
        } else this.c[3].textContent = this.value;
        if (this.miniCanvas) {
            if (!this.c[3].children.length) {
                this.canvas = document.createElement('canvas');
                this.canvas.width = this.imageSize[0];
                this.canvas.height = this.imageSize[1];
                this.canvas.style.cssText = 'margin-right:4px;';
                this.ctx = this.canvas.getContext("2d");
                this.c[3].style.textAlign = 'left';
                this.c[3].style.justifyContent = 'left';
                this.c[3].appendChild(this.canvas);
            }
            this.ctx.drawImage(this.tmpImage[this.value], 0, 0);
        }
    }
    // ----- LIST
    update(y) {
        if (!this.scroll) return;
        y = y < 0 ? 0 : y;
        y = y > this.range ? this.range : y;
        this.topList = -Math.floor(y / this.ratio);
        this.listIn.style.top = this.topList + 'px';
        this.scroller.style.top = Math.floor(y) + 'px';
        this.py = y;
    }
    parentHeight(t) {
        if (this.group !== null) this.group.calc(t);
        else if (this.isUI) this.main.calc(t);
    }
    open(first) {
        super.open();
        this.update(0);
        this.h = this.maxHeight + this.baseH + 5;
        if (!this.scroll) {
            this.topList = 0;
            this.h = this.baseH + 5 + this.max;
            this.scroller.style.display = 'none';
            this.scrollerBack.style.display = 'none';
        } else {
            this.scroller.style.display = 'block';
            this.scrollerBack.style.display = 'block';
        }
        this.s[0].height = this.h + 'px';
        this.s[2].display = 'block';
        if (this.up) {
            this.zone.y -= this.h - (this.baseH - 10);
            this.setSvg(this.c[4], 'd', this.svgs.g1);
        } else this.setSvg(this.c[4], 'd', this.svgs.g2);
        this.rSizeContent();
        let t = this.h - this.baseH;
        this.zone.h = this.h;
        if (!first) this.parentHeight(t);
    }
    close() {
        super.close();
        if (this.up) this.zone.y += this.h - (this.baseH - 10);
        let t = this.h - this.baseH;
        this.h = this.baseH;
        this.s[0].height = this.h + 'px';
        this.s[2].display = 'none';
        this.setSvg(this.c[4], 'd', this.svgs.g1);
        this.zone.h = this.h;
        this.parentHeight(-t);
    }
    // -----
    text(txt) {
        this.c[3].textContent = txt;
    }
    rSizeContent() {
        let i = this.length;
        while(i--)this.listIn.children[i].style.width = this.ww + 'px';
    }
    rSize() {
        super.rSize();
        //Proto.prototype.rSize.call( this );
        let s = this.s;
        let w = this.sb;
        let d = this.sa;
        if (s[2] === undefined) return;
        s[2].width = w + 'px';
        s[2].left = d + 'px';
        s[3].width = w + 'px';
        s[3].left = d + 'px';
        s[4].left = d + w - 15 + 'px';
        this.ww = w;
        if (this.max > this.maxHeight) this.ww = w - this.ss;
        if (this.isOpen) this.rSizeContent();
    }
    constructor(o = {}){
        super(o);
        // TODO not work
        this.hideCurrent = false;
        // images
        this.path = o.path || '';
        this.format = o.format || '';
        this.isWithImage = this.path !== '' ? true : false;
        this.preLoadComplete = false;
        this.tmpImage = {};
        this.tmpUrl = [];
        this.m = o.m !== undefined ? o.m : 5;
        let align = o.align || 'left';
        // scroll size
        let ss = o.scrollSize || 10;
        this.ss = ss + 1;
        this.sMode = 0;
        this.tMode = 0;
        this.listOnly = o.listOnly || false;
        this.staticTop = o.staticTop || false;
        this.isSelectable = this.listOnly;
        if (o.select !== undefined) o.selectable = o.select;
        if (o.selectable !== undefined) this.isSelectable = o.selectable;
        if (this.txt === '') this.p = 0;
        let fltop = Math.floor(this.h * 0.5) - 3;
        let cc = this.colors;
        this.c[2] = this.dom('div', this.css.basic + 'top:0; display:none; border-radius:' + this.radius + 'px;');
        this.c[3] = this.dom('div', this.css.item + 'padding:0px ' + this.m + 'px; margin-bottom:0px; position:absolute; justify-content:' + align + '; text-align:' + align + '; line-height:' + (this.h - 4) + 'px; top:1px; background:' + cc.button + '; height:' + (this.h - 2) + 'px; border:1px solid ' + cc.border + '; border-radius:' + this.radius + 'px;');
        this.c[4] = this.dom('path', this.css.basic + 'position:absolute; width:6px; height:6px; top:' + fltop + 'px;', {
            d: this.svgs.g1,
            fill: cc.text,
            stroke: 'none'
        });
        this.scrollerBack = this.dom('div', this.css.basic + 'right:0px; width:' + ss + 'px; background:' + cc.back + '; display:none;');
        this.scroller = this.dom('div', this.css.basic + 'right:' + (ss - ss * 0.25) * 0.5 + 'px; width:' + ss * 0.25 + 'px; background:' + cc.text + '; display:none; ');
        this.c[3].style.color = cc.text;
        this.list = [];
        this.refObject = null;
        if (o.list) {
            if (o.list instanceof Array) this.list = o.list;
            else if (o.list instanceof Object) {
                this.refObject = o.list;
                for(let g in this.refObject)this.list.push(g);
            }
        }
        this.items = [];
        this.prevName = '';
        this.tmpId = 0;
        this.baseH = this.h;
        this.itemHeight = o.itemHeight || this.h; //(this.h-3);
        // force full list 
        this.full = o.full || false;
        this.py = 0;
        this.ww = this.sb;
        this.scroll = false;
        this.isDown = false;
        this.current = null;
        // list up or down
        this.side = o.side || 'down';
        this.up = this.side === 'down' ? 0 : 1;
        if (this.up) {
            this.c[2].style.top = 'auto';
            this.c[3].style.top = 'auto';
            this.c[4].style.top = 'auto';
            this.c[2].style.bottom = this.h - 2 + 'px';
            this.c[3].style.bottom = '1px';
            this.c[4].style.bottom = fltop + 'px';
        } else this.c[2].style.top = this.baseH + 'px';
        this.listIn = this.dom('div', this.css.basic + 'left:0; top:0; width:100%; background:none;');
        this.listIn.name = 'list';
        this.topList = 0;
        this.c[2].appendChild(this.listIn);
        this.c[2].appendChild(this.scrollerBack);
        this.c[2].appendChild(this.scroller);
        if (o.value !== undefined) {
            if (!isNaN(o.value)) this.value = this.list[o.value];
            else this.value = o.value;
        } else this.value = this.list[0];
        this.isOpenOnStart = o.open || false;
        if (this.listOnly) {
            this.baseH = 5;
            this.c[3].style.display = 'none';
            this.c[4].style.display = 'none';
            this.c[2].style.top = this.baseH + 'px';
            this.isOpenOnStart = true;
        }
        this.miniCanvas = o.miniCanvas || false;
        this.canvasBg = o.canvasBg || 'rgba(0,0,0,0)';
        this.imageSize = o.imageSize || [
            20,
            20
        ];
        // dragout function
        this.drag = o.drag || false;
        this.dragout = o.dragout || false;
        this.dragstart = o.dragstart || null;
        this.dragend = o.dragend || null;
        //this.c[0].style.background = '#FF0000'
        ///if( this.isWithImage ) this.preloadImage();
        this.setList(this.list);
        this.init();
        if (this.isWithImage) this.preloadImage();
        if (this.isOpenOnStart) this.open(true);
        this.baseH += this.mtop;
    }
}
class $cb886df1bae8879c$var$Numeric extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        let i = this.lng;
        let t = this.tmp;
        while(i--){
            if (l.x > t[i][0] && l.x < t[i][2]) return i;
        }
        return '';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mousedown(e) {
        let name = this.testZone(e);
        if (!this.isDown) {
            this.isDown = true;
            if (name !== '') {
                this.current = name;
                this.prev = {
                    x: e.clientX,
                    y: e.clientY,
                    d: 0,
                    v: this.isSingle ? parseFloat(this.value) : parseFloat(this.value[this.current])
                };
                this.setInput(this.c[3 + this.current]);
            }
            return this.mousemove(e);
        }
        return false;
    }
    mouseup(e) {
        if (this.isDown) {
            this.isDown = false;
            this.prev = {
                x: 0,
                y: 0,
                d: 0,
                v: 0
            };
            return this.mousemove(e);
        }
        return false;
    }
    mousemove(e) {
        let nup = false;
        let x = 0;
        let name = this.testZone(e);
        if (name === '') this.cursor();
        else if (!this.isDrag) this.cursor('text');
        else this.cursor(this.current !== -1 ? 'move' : 'pointer');
        if (this.isDrag) {
            if (this.current !== -1) {
                this.prev.d += e.clientX - this.prev.x - (e.clientY - this.prev.y);
                let n = this.prev.v + this.prev.d * this.step;
                this.value[this.current] = this.numValue(n);
                this.c[3 + this.current].textContent = this.value[this.current];
                this.validate();
                this.prev.x = e.clientX;
                this.prev.y = e.clientY;
                nup = true;
            }
        } else {
            if (this.isDown) x = e.clientX - this.zone.x - 3;
            if (this.current !== -1) x -= this.tmp[this.current][0];
            return this.upInput(x, this.isDown);
        }
        return nup;
    }
    // ----------------------
    reset() {
        let nup = false;
        return nup;
    }
    setValue(v) {
        if (this.isVector) {
            if (v.x !== undefined) this.value[0] = v.x;
            if (v.y !== undefined) this.value[1] = v.y;
            if (v.z !== undefined) this.value[2] = v.z;
            if (v.w !== undefined) this.value[3] = v.w;
        } else this.value = this.isSingle ? [
            v
        ] : v;
        this.update();
    }
    sameStr(str) {
        let i = this.value.length;
        while(i--)this.c[3 + i].textContent = str;
    }
    update(up) {
        let i = this.value.length;
        while(i--){
            this.value[i] = this.numValue(this.value[i] * this.invmulty);
            this.c[3 + i].textContent = this.value[i];
        }
        if (up) this.send();
    }
    send(v) {
        v = v || this.value;
        this.isSend = true;
        if (this.objectLink !== null) {
            if (this.isVector) this.objectLink[this.objectKey].fromArray(v);
            else this.objectLink[this.objectKey] = v;
        }
        if (this.callback) this.callback(v, this.objectKey);
        this.isSend = false;
    }
    // ----------------------
    //   INPUT
    // ----------------------
    select(c, e, w, t) {
        let s = this.s;
        let d = this.current !== -1 ? this.tmp[this.current][0] + 5 : 0;
        s[this.cursorId].width = '1px';
        s[this.cursorId].left = d + c + 'px';
        s[this.selectId].left = d + e + 'px';
        s[this.selectId].width = w + 'px';
        this.c[this.selectId].innerHTML = t;
    }
    unselect() {
        let s = this.s;
        if (!s) return;
        this.c[this.selectId].innerHTML = '';
        s[this.selectId].width = "0px";
        s[this.cursorId].width = "0px";
    }
    validate(force) {
        let ar = [];
        let i = this.lng;
        if (this.allway) force = true;
        while(i--){
            if (!isNaN(this.c[3 + i].textContent)) {
                let nx = this.numValue(this.c[3 + i].textContent);
                this.c[3 + i].textContent = nx;
                this.value[i] = nx;
            } else this.c[3 + i].textContent = this.value[i];
            ar[i] = this.value[i] * this.multy;
        }
        if (!force) return;
        this.send(this.isSingle ? ar[0] : ar);
    }
    // ----------------------
    //   REZISE
    // ----------------------
    rSize() {
        super.rSize();
        let sx = this.colors.sx;
        let ss = sx * (this.lng - 1);
        let w = (this.sb - ss) / this.lng; //(( this.sb + sx ) / this.lng )-sx
        let s = this.s;
        let i = this.lng;
        while(i--){
            //this.tmp[i] = [ Math.floor( this.sa + ( w * i )+( 5 * i )), w ];
            this.tmp[i] = [
                this.sa + w * i + sx * i,
                w
            ];
            this.tmp[i][2] = this.tmp[i][0] + this.tmp[i][1];
            s[3 + i].left = this.tmp[i][0] + 'px';
            s[3 + i].width = this.tmp[i][1] + 'px';
        }
    }
    constructor(o = {}){
        super(o);
        this.setTypeNumber(o);
        this.allway = o.allway || false;
        this.isDown = false;
        this.value = [
            0
        ];
        this.multy = 1;
        this.invmulty = 1;
        this.isSingle = true;
        this.isAngle = false;
        this.isVector = false;
        if (o.isAngle) {
            this.isAngle = true;
            this.multy = $cb886df1bae8879c$export$390d11d353c16e49.torad;
            this.invmulty = $cb886df1bae8879c$export$390d11d353c16e49.todeg;
        }
        this.isDrag = o.drag || false;
        if (o.value !== undefined) {
            if (!isNaN(o.value)) this.value = [
                o.value
            ];
            else if (o.value instanceof Array) {
                this.value = o.value;
                this.isSingle = false;
            } else if (o.value instanceof Object) {
                this.value = [];
                if (o.value.x !== undefined) this.value[0] = o.value.x;
                if (o.value.y !== undefined) this.value[1] = o.value.y;
                if (o.value.z !== undefined) this.value[2] = o.value.z;
                if (o.value.w !== undefined) this.value[3] = o.value.w;
                this.isSingle = false;
                this.isVector = true;
            }
        }
        this.lng = this.value.length;
        this.tmp = [];
        this.current = -1;
        this.prev = {
            x: 0,
            y: 0,
            d: 0,
            v: 0
        };
        let cc = this.colors;
        // bg
        this.c[2] = this.dom('div', this.css.basic + ' background:' + cc.select + '; top:4px; width:0px; height:' + (this.h - 8) + 'px;');
        this.cMode = [];
        let i = this.lng;
        while(i--){
            if (this.isAngle) this.value[i] = (this.value[i] * 180 / Math.PI).toFixed(this.precision);
            this.c[3 + i] = this.dom('div', this.css.txtselect + 'top:1px; height:' + (this.h - 2) + 'px; color:' + cc.text + '; background:' + cc.back + '; borderColor:' + cc.border + '; border-radius:' + this.radius + 'px;');
            if (o.center) this.c[2 + i].style.textAlign = 'center';
            this.c[3 + i].textContent = this.value[i];
            this.c[3 + i].style.color = this.colors.text;
            this.c[3 + i].isNum = true;
            this.cMode[i] = 0;
        }
        // selection
        this.selectId = 3 + this.lng;
        this.c[this.selectId] = this.dom('div', this.css.txtselect + 'position:absolute; top:2px; height:' + (this.h - 4) + 'px; padding:0px 0px; width:0px; color:' + cc.textSelect + '; background:' + cc.select + '; border:none; border-radius:0px;');
        // cursor
        this.cursorId = 4 + this.lng;
        this.c[this.cursorId] = this.dom('div', this.css.basic + 'top:2px; height:' + (this.h - 4) + 'px; width:0px; background:' + cc.text + ';');
        this.init();
    }
}
class $cb886df1bae8879c$var$Slide extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.x >= this.txl) return 'text';
        else if (l.x >= this.sa) return 'scroll';
        else return '';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        if (this.isDown) this.isDown = false;
    }
    mousedown(e) {
        let name = this.testZone(e);
        if (!name) return false;
        if (name === 'scroll') {
            this.isDown = true;
            this.old = this.value;
            this.mousemove(e);
        }
        /*if( name === 'text' ){
            this.setInput( this.c[2], function(){ this.validate() }.bind(this) );
        }*/ return true;
    }
    mousemove(e) {
        let nup = false;
        let name = this.testZone(e);
        if (name === 'scroll') {
            this.mode(1);
            this.cursor('w-resize');
        //} else if(name === 'text'){ 
        //this.cursor('pointer');
        } else this.cursor();
        if (this.isDown) {
            let n = (e.clientX - (this.zone.x + this.sa) - 3) / this.ww * this.range + this.min - this.old;
            if (n >= this.step || n <= this.step) {
                n = Math.floor(n / this.step);
                this.value = this.numValue(this.old + n * this.step);
                this.update(true);
                this.old = this.value;
            }
            nup = true;
        }
        return nup;
    }
    wheel(e) {
        let name = this.testZone(e);
        if (name === 'scroll') {
            let v = this.value - this.step * e.delta;
            if (v > this.max) v = this.isCyclic ? this.min : this.max;
            else if (v < this.min) v = this.isCyclic ? this.max : this.min;
            this.setValue(v);
            this.old = v;
            this.update(true);
            return true;
        }
        return false;
    }
    //keydown: function ( e ) { return true; },
    // ----------------------
    validate() {
        let n = this.c[2].textContent;
        if (!isNaN(n)) {
            this.value = this.numValue(n);
            this.update(true);
        } else if (this.autoValue) this.c[2].textContent = this.value + (this.isDeg ? "\xb0" : '');
    }
    reset() {
        //this.clearInput();
        this.isDown = false;
        this.mode(0);
    }
    mode(mode) {
        let s = this.s;
        let cc = this.colors;
        switch(mode){
            case 0:
                // s[2].border = '1px solid ' + this.colors.hide;
                s[2].color = cc.text;
                s[4].background = cc.back;
                s[5].background = cc.text;
                if (this.model !== 0) s[6].background = cc.text; //cc.button;
                break;
            case 1:
                //s[2].border = '1px dashed ' + this.colors.hide;
                s[2].color = cc.textOver;
                s[4].background = cc.back;
                s[5].background = cc.textOver;
                if (this.model !== 0) s[6].background = cc.textOver; //cc.overoff;
                break;
        }
    }
    update(up) {
        let ww = Math.floor(this.ww * ((this.value - this.min) / this.range));
        if (this.model !== 3) this.s[5].width = ww + 'px';
        if (this.s[6]) this.s[6].left = this.sa + ww + 3 + 'px';
        if (this.autoValue) this.c[2].textContent = this.value + (this.isDeg ? "\xb0" : '');
        if (up) this.send();
    }
    rSize() {
        super.rSize();
        let w = this.sb - this.sc;
        this.ww = w - 6;
        let tx = this.sc;
        if (this.isUI || !this.simple) tx = this.sc + 10;
        this.txl = this.w - tx + 2;
        //let ty = Math.floor(this.h * 0.5) - 8;
        let s = this.s;
        s[2].width = this.sc - 6 + 'px';
        s[2].left = this.txl + 4 + 'px';
        //s[2].top = ty + 'px';
        s[3].left = this.sa + 'px';
        s[3].width = w + 'px';
        s[4].left = this.sa + 'px';
        s[4].width = w + 'px';
        s[5].left = this.sa + 3 + 'px';
        this.update();
    }
    constructor(o = {}){
        super(o);
        this.setTypeNumber(o);
        this.model = o.stype !== undefined ? o.stype : 2;
        if (o.mode !== undefined) this.model = o.mode;
        //this.defaultBorderColor = this.colors.hide;
        this.isDown = false;
        this.isOver = false;
        this.allway = o.allway || false;
        this.autoValue = true;
        if (o.autoValue !== undefined) this.autoValue = false;
        this.isDeg = o.isDeg || false;
        this.isCyclic = o.cyclic || false;
        this.firstImput = false;
        let cc = this.colors;
        //this.c[2] = this.dom( 'div', this.css.txtselect + 'letter-spacing:-1px; text-align:right; width:47px; border:1px dashed '+this.defaultBorderColor+'; color:'+ this.colors.text );
        //this.c[2] = this.dom( 'div', this.css.txtselect + 'text-align:right; width:47px; border:1px dashed '+this.defaultBorderColor+'; color:'+ this.colors.text );
        this.c[2] = this.dom('div', this.css.txtselect + 'border:none; background:none; width:47px; color:' + cc.text + ';');
        //this.c[2] = this.dom( 'div', this.css.txtselect + 'letter-spacing:-1px; text-align:right; width:47px; color:'+ this.colors.text );
        this.c[3] = this.dom('div', this.css.basic + ' top:0; height:' + this.h + 'px;');
        this.c[4] = this.dom('div', this.css.basic + 'background:' + cc.back + '; top:2px; height:' + (this.h - 4) + 'px;');
        this.c[5] = this.dom('div', this.css.basic + 'left:4px; top:5px; height:' + (this.h - 10) + 'px; background:' + cc.text + ';');
        this.c[2].isNum = true;
        //this.c[2].style.height = (this.h-4) + 'px';
        //this.c[2].style.lineHeight = (this.h-8) + 'px';
        this.c[2].style.height = this.h - 2 + 'px';
        this.c[2].style.lineHeight = this.h - 10 + 'px';
        if (this.model !== 0) {
            let r1 = 4, h1 = 4, h2 = 8, ww = this.h - 6, ra = 16;
            if (this.model === 2) {
                r1 = 0;
                h1 = 2;
                h2 = 4;
                ra = 2;
                ww = (this.h - 6) * 0.5;
            }
            if (this.model === 3) this.c[5].style.visible = 'none';
            this.c[4].style.borderRadius = r1 + 'px';
            this.c[4].style.height = h2 + 'px';
            this.c[4].style.top = this.h * 0.5 - h1 + 'px';
            this.c[5].style.borderRadius = r1 * 0.5 + 'px';
            this.c[5].style.height = h1 + 'px';
            this.c[5].style.top = this.h * 0.5 - h1 * 0.5 + 'px';
            //this.c[6] = this.dom( 'div', this.css.basic + 'border-radius:'+ra+'px; margin-left:'+(-ww*0.5)+'px; border:1px solid '+cc.border+'; background:'+cc.button+'; left:4px; top:2px; height:'+(this.h-4)+'px; width:'+ww+'px;' );
            //this.c[6] = this.dom( 'div', this.css.basic + 'border-radius:'+ra+'px; margin-left:'+(-ww*0.5)+'px; background:'+cc.text+'; left:4px; top:3px; height:'+(this.h-6)+'px; width:'+ww+'px;' )
            this.c[6] = this.dom('div', this.css.basic + 'border-radius:' + ra + 'px; margin-left:' + -ww * 0.5 + 'px; background:' + cc.text + '; left:4px; top:' + (this.h - ww) * 0.5 + 'px; height:' + ww + 'px; width:' + ww + 'px;');
        }
        this.init();
    }
}
class $cb886df1bae8879c$var$TextInput extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.x >= this.sa) return 'text';
        return '';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        if (!this.editable) return;
        if (this.isDown) {
            this.isDown = false;
            return this.mousemove(e);
        }
        return false;
    }
    mousedown(e) {
        if (!this.editable) return;
        let name = this.testZone(e);
        if (!this.isDown) {
            this.isDown = true;
            if (name === 'text') this.setInput(this.c[2]);
            return this.mousemove(e);
        }
        return false;
    }
    mousemove(e) {
        if (!this.editable) return;
        let name = this.testZone(e);
        //let l = this.local;
        //if( l.x === -1 && l.y === -1 ){ return;}
        //if( l.x >= this.sa ) this.cursor('text');
        //else this.cursor();
        let x = 0;
        if (name === 'text') this.cursor('text');
        else this.cursor();
        if (this.isDown) x = e.clientX - this.zone.x;
        return this.upInput(x - this.sa - 3, this.isDown);
    }
    update() {
        this.c[2].textContent = this.value;
    }
    // ----------------------
    reset() {
        this.cursor();
    }
    // ----------------------
    //   INPUT
    // ----------------------
    select(c, e, w, t) {
        let s = this.s;
        let d = this.sa + 5;
        s[4].width = '1px';
        s[4].left = d + e + 'px';
        s[3].left = d + e + 'px';
        s[3].width = w + 'px';
        this.c[3].innerHTML = t;
    }
    unselect() {
        let s = this.s;
        if (!s) return;
        s[3].width = "0px";
        this.c[3].innerHTML = 't';
        s[4].width = "0px";
    }
    validate(force) {
        if (this.allway) force = true;
        this.value = this.c[2].textContent;
        if (this.value !== '') this.c[5].textContent = '';
        else this.c[5].textContent = this.placeHolder;
        if (!force) return;
        this.send();
    }
    // ----------------------
    //   REZISE
    // ----------------------
    rSize() {
        super.rSize();
        let s = this.s;
        s[2].left = this.sa + 'px';
        s[2].width = this.sb + 'px';
        s[5].left = this.sa + 'px';
        s[5].width = this.sb + 'px';
    }
    constructor(o = {}){
        super(o);
        this.cmode = 0;
        this.value = o.value !== undefined ? o.value : '';
        this.placeHolder = o.placeHolder || '';
        this.allway = o.allway || false;
        this.editable = o.edit !== undefined ? o.edit : true;
        this.isDown = false;
        let cc = this.colors;
        // text
        this.c[2] = this.dom('div', this.css.txtselect + 'top:1px; height:' + (this.h - 2) + 'px; color:' + cc.text + '; background:' + cc.back + '; borderColor:' + cc.border + '; border-radius:' + this.radius + 'px;');
        this.c[2].textContent = this.value;
        // selection
        this.c[3] = this.dom('div', this.css.txtselect + 'position:absolute; top:2px; height:' + (this.h - 4) + 'px; padding:0px 0px; width:0px; color:' + cc.textSelect + '; background:' + cc.select + '; border:none; border-radius:0px;');
        // cursor
        this.c[4] = this.dom('div', this.css.basic + 'top:2px; height:' + (this.h - 4) + 'px; width:0px; background:' + cc.text + ';');
        // fake
        this.c[5] = this.dom('div', this.css.txtselect + 'top:1px; height:' + (this.h - 2) + 'px; border:none; justify-content: center; font-style: italic; color:' + cc.border + ';');
        if (this.value === '') this.c[5].textContent = this.placeHolder;
        this.init();
    }
}
class $cb886df1bae8879c$var$Title extends $cb886df1bae8879c$var$Proto {
    text(txt) {
        this.c[1].textContent = txt;
    }
    text2(txt) {
        this.c[2].textContent = txt;
    }
    rSize() {
        super.rSize();
        this.s[1].width = this.w + 'px'; //- 50 + 'px';
        this.s[2].left = this.w + 'px'; //- ( 50 + 26 ) + 'px';
    }
    setColor(c) {
        this.s[1].color = c;
        this.s[2].color = c;
    }
    constructor(o = {}){
        super(o);
        this.isTitle = true;
        let prefix = o.prefix || '';
        let color = o.color || this.colors.text;
        this.c[2] = this.dom('div', this.css.txt + 'justify-content:right; width:60px; line-height:' + (this.h - 8) + 'px; color:' + color);
        if (this.h === 31) {
            this.s[0].height = this.h + 'px';
            this.s[1].top = "8px";
            this.c[2].style.top = "8px";
        }
        let s = this.s;
        s[1].justifyContent = o.align || 'left';
        //s[1].textAlign = o.align || 'left';
        s[1].fontWeight = o.fontWeight || 'bold';
        s[1].color = o.color || this.colors.text;
        this.c[1].textContent = this.txt.substring(0, 1).toUpperCase() + this.txt.substring(1).replace("-", " ");
        this.c[2].textContent = prefix;
        this.init();
    }
}
class $cb886df1bae8879c$var$Select extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.x > this.sa && l.x < this.sa + 30) return 'over';
        return '0';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        if (this.isDown) {
            //this.value = false;
            this.isDown = false;
            //this.send();
            return this.mousemove(e);
        }
        return false;
    }
    mousedown(e) {
        let name = this.testZone(e);
        if (!name) return false;
        this.isDown = true;
        //this.value = this.values[ name-2 ];
        //this.send();
        return this.mousemove(e);
    }
    mousemove(e) {
        let up = false;
        let name = this.testZone(e);
        if (name === 'over') {
            this.cursor('pointer');
            up = this.mode(this.isDown ? 3 : 2);
        } else up = this.reset();
        return up;
    }
    // ----------------------
    apply(v) {
        v = v || '';
        if (v !== this.value) {
            this.value = v;
            this.c[3].textContent = this.value;
            this.send();
        }
        this.mode(1);
    }
    update() {
        this.mode(3);
    }
    mode(n) {
        let change = false;
        let cc = this.colors;
        if (this.stat !== n) {
            if (n === 1) this.isActif = false;
            if (n === 3) {
                if (!this.isActif) {
                    this.isActif = true;
                    n = 4;
                    this.onActif(this);
                } else this.isActif = false;
            }
            if (n === 2 && this.isActif) n = 4;
            this.stat = n;
            switch(n){
                case 1:
                    this.s[2].color = cc.text;
                    this.s[2].background = cc.button;
                    break; // base
                case 2:
                    this.s[2].color = cc.textOver;
                    this.s[2].background = cc.overoff;
                    break; // over
                case 3:
                    this.s[2].color = cc.textOver;
                    this.s[2].background = cc.action;
                    break; // down
                case 4:
                    this.s[2].color = cc.textSelect;
                    this.s[2].background = cc.action;
                    break; // actif
            }
            change = true;
        }
        return change;
    }
    reset() {
        this.cursor();
        return this.mode(this.isActif ? 4 : 1);
    }
    text(txt) {
        this.c[3].textContent = txt;
    }
    rSize() {
        super.rSize();
        let s = this.s;
        s[2].left = this.sa + 'px';
        s[3].left = this.sa + 40 + 'px';
        s[3].width = this.sb - 40 + 'px';
        s[4].left = this.sa + 8 + 'px';
    }
    constructor(o = {}){
        super(o);
        this.value = o.value || '';
        this.isDown = false;
        this.onActif = o.onActif || function() {};
        //let prefix = o.prefix || '';
        const cc = this.colors;
        this.c[2] = this.dom('div', this.css.txt + this.css.button + ' top:1px; background:' + cc.button + '; height:' + (this.h - 2) + 'px; border:' + cc.buttonBorder + '; border-radius:15px; width:30px; left:10px;');
        //this.c[2].style.color = this.fontColor;
        this.c[3] = this.dom('div', this.css.txtselect + 'height:' + (this.h - 4) + 'px; background:' + cc.inputBg + '; borderColor:' + cc.inputBorder + '; border-radius:' + this.radius + 'px;');
        this.c[3].textContent = this.value;
        let fltop = Math.floor(this.h * 0.5) - 7;
        this.c[4] = this.dom('path', this.css.basic + 'position:absolute; width:14px; height:14px; left:5px; top:' + fltop + 'px;', {
            d: this.svgs['cursor'],
            fill: cc.text,
            stroke: 'none'
        });
        this.stat = 1;
        this.isActif = false;
        this.init();
    }
}
class $cb886df1bae8879c$var$Bitmap extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.x > this.sa && l.x < this.sa + 30) return 'over';
        if (l.x > this.sa - 30 && l.x < this.sa) return 'delete';
        return '0';
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        if (this.isDown) {
            //this.value = false;
            this.isDown = false;
            //this.send();
            return this.mousemove(e);
        }
        return false;
    }
    mousedown(e) {
        let name = this.testZone(e);
        if (!name) return false;
        if (name === 'over') {
            this.isDown = true;
            $cb886df1bae8879c$export$9330ab61a7e5c11b.load({
                callback: this.changeBitmap.bind(this),
                always: true,
                type: 'image'
            });
        }
        //this.value = this.values[ name-2 ];
        //this.send();
        return this.mousemove(e);
    }
    mousemove(e) {
        let up = false;
        let name = this.testZone(e);
        if (name === 'over') {
            this.cursor('pointer');
            up = this.mode(this.isDown ? 3 : 2);
        } else up = this.reset();
        return up;
    }
    // ----------------------
    makePreview() {
        if (this.img) {
            //let src = this.img.src ? this.img.src : this.img;
            this.c[3].style.background = 'url(' + this.img.src + ')';
            this.c[3].style.backgroundSize = this.sb - 40 + 'px ' + (this.sb - 40) + 'px';
            //this.c[3].style.backgroundSize = 20 + 'px ' + 20 + 'px'
            this.c[3].style.backgroundPosition = 'center';
            this.c[3].style.backgroundRepeat = 'no-repeat';
        } else {
            this.c[3].style.background = this.colors.back;
            this.c[3].style.backgroundImage = 'none';
        }
    }
    changeBitmap(img, fname, type) {
        if (img) {
            this.img = img;
            this.apply(fname);
        } else {
            this.img = null;
            this.apply('null');
        }
        this.makePreview();
        this.threeTexture();
    }
    // ----------------------
    threeTexture() {
        // need define UIL.Tools.texture = THREE.Texture;
        if (this.objectLink === null) return;
        let texture = this.objectLink[this.objectKey];
        if (this.img) {
            if (texture !== null) {
                texture.image = this.img;
                this.objectLink[this.objectKey] = texture.clone();
                texture.dispose();
                this.objectLink[this.objectKey].needsUpdate = true;
            } else if ($cb886df1bae8879c$export$390d11d353c16e49.texture) {
                texture = new $cb886df1bae8879c$export$390d11d353c16e49.texture(this.img);
                //console.log('colorSpace',  texture.colorSpace )
                if (this.colorSpace) texture.colorSpace = this.colorSpace; //'srgb';
                this.objectLink[this.objectKey] = texture;
                this.objectLink[this.objectKey].needsUpdate = true;
            }
        } else this.objectLink[this.objectKey] = null;
        this.objectLink.needsUpdate = true;
    }
    apply(v) {
        v = v || '';
        let name = this.objectLink !== null ? this.objectKey : this.name;
        if (v !== this.value) {
            this.value = v;
            if (this.img !== null) {
                this.c[3].textContent = '';
                //if( this.objectLink !== null ) this.objectLink[ this.val ] = v
                if (this.callback) this.callback(this.value, this.img, name);
            } else {
                this.c[3].textContent = 'null';
                //if( this.objectLink !== null ) this.objectLink[ this.val ] = v
                if (this.callback) this.callback(null, null, name);
            }
        }
        this.mode(1);
    }
    update() {
        this.mode(3);
    }
    mode(n, id) {
        let change = false;
        let cc = this.colors;
        if (this.stat !== n) {
            this.stat = n;
            switch(n){
                case 1:
                    this.s[2].color = cc.text;
                    this.s[2].background = cc.button;
                    break; // base
                case 2:
                    this.s[2].color = cc.textOver;
                    this.s[2].background = cc.overoff;
                    break; // over
                case 3:
                    this.s[2].color = cc.textOver;
                    this.s[2].background = cc.over;
                    break; // down
                case 4:
                    this.s[2].color = cc.textSelect;
                    this.s[2].background = cc.select;
                    break; // actif
            }
            change = true;
        }
        return change;
    }
    reset() {
        this.cursor();
        return this.mode(this.isActif ? 4 : 1);
    }
    text(txt) {
        this.c[3].textContent = txt;
    }
    rSize() {
        super.rSize();
        let s = this.s;
        s[2].left = this.sa + 'px';
        s[3].left = this.sa + 40 + 'px';
        s[3].width = this.sb - 40 + 'px';
        s[4].left = this.sa + 8 + 'px';
    //s[3].backgroundSize = (this.sb - 40) + 'px' + (this.sb - 40) + 'px'
    //s[5].left = (this.w-30) + 'px';
    }
    constructor(o = {}){
        super(o);
        this.value = o.value || '';
        this.colorSpace = o.colorSpace || '';
        //this.refTexture = o.texture || null;
        this.img = null;
        if (this.value.isTexture) {
            if (this.value.image) this.img = this.value.image;
        }
        this.isDown = false;
        this.neverlock = true;
        const cc = this.colors;
        this.c[2] = this.dom('div', this.css.txt + this.css.button + ' top:1px; background:' + cc.button + '; height:' + (this.h - 2) + 'px; border:' + cc.buttonBorder + '; border-radius:2px; width:30px; ');
        this.c[3] = this.dom('div', this.css.txtselect + 'height:' + (this.h - 4) + 'px; background:' + cc.back + '; borderColor:' + cc.inputBorder + '; border-radius:' + this.radius + 'px;');
        //this.c[3].textContent = this.value;
        if (!this.img) this.c[3].textContent = 'null';
        let fltop = Math.floor(this.h * 0.5) - 7;
        this.c[4] = this.dom('path', this.css.basic + 'position:absolute; width:14px; height:14px; left:5px; top:' + fltop + 'px;', {
            d: this.svgs['load'],
            fill: cc.text,
            stroke: 'none'
        });
        //this.c[5] = this.dom( 'div', this.css.txt + this.css.button + ' top:1px; background:'+cc.button+'; height:'+(this.h-2)+'px; border:'+cc.buttonBorder+'; border-radius:2px; width:30px; ' )
        this.stat = 1;
        this.makePreview();
        this.init();
    }
}
//import { Proto } from '../core/Proto.js';
class $cb886df1bae8879c$var$Selector extends $cb886df1bae8879c$var$Button {
    constructor(o = {}){
        if (o.selectable === undefined) o.selectable = true;
        super(o);
    }
}
class $cb886df1bae8879c$var$Item extends $cb886df1bae8879c$var$Proto {
    // ----------------------
    //   EVENTS
    // ----------------------
    mousemove(e) {
        this.cursor('pointer');
    //up = this.modes( this.isDown ? 3 : 2, name );
    }
    mousedown(e) {
        if (this.isUI) this.main.resetItem();
        this.selected(true);
        this.send();
        return true;
    }
    uiout() {
        if (this.isSelect) this.mode(3);
        else this.mode(1);
    }
    uiover() {
        if (this.isSelect) this.mode(4);
        else this.mode(2);
    }
    update() {}
    /*rSize () {
        
        super.rSize();

    }*/ mode(n) {
        let change = false;
        if (this.status !== n) {
            this.status = n;
            let s = this.s, cc = this.colors;
            switch(n){
                case 1:
                    this.status = 1;
                    s[1].color = cc.text;
                    s[0].background = 'none';
                    break;
                case 2:
                    this.status = 2;
                    s[1].color = cc.textOver;
                    s[0].background = cc.back;
                    break;
                case 3:
                    this.status = 3;
                    s[1].color = cc.textSelect;
                    s[0].background = cc.select;
                    break;
                case 4:
                    this.status = 4;
                    s[1].color = cc.textOver;
                    s[0].background = cc.over;
                    break;
            }
            change = true;
        }
        return change;
    }
    reset() {
        this.cursor();
    // return this.mode( 1 );
    }
    selected(b) {
        if (this.isSelect) this.mode(1);
        this.isSelect = b || false;
        if (this.isSelect) this.mode(3);
    }
    constructor(o = {}){
        super(o);
        this.p = 100;
        this.value = this.txt;
        this.status = 1;
        this.itype = o.itype || 'none';
        this.val = this.itype;
        this.graph = this.svgs[this.itype];
        let fltop = Math.floor(this.h * 0.5) - 7;
        this.c[2] = this.dom('path', this.css.basic + 'position:absolute; width:14px; height:14px; left:5px; top:' + fltop + 'px;', {
            d: this.graph,
            fill: this.colors.text,
            stroke: 'none'
        });
        this.s[1].marginLeft = "20px";
        this.init();
    }
}
class $cb886df1bae8879c$var$Grid extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return -1;
        l.y += this.mtop;
        let tx = this.tmpX;
        let ty = this.tmpY;
        let id = -1;
        let c = -1;
        let line = -1;
        let i = this.grid[0];
        while(i--)if (l.x > tx[i][0] && l.x < tx[i][1]) c = i;
        i = this.grid[1];
        while(i--)if (l.y > ty[i][0] && l.y < ty[i][1]) line = i;
        if (c !== -1 && line !== -1) {
            id = c + line * 2;
            if (id > this.lng - 1) id = -1;
        }
        return id;
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    mouseup(e) {
        if (!this.isDown) return false;
        this.isDown = false;
        if (this.res !== -1) {
            this.value = this.values[this.res];
            this.send();
        }
        return this.mousemove(e);
    }
    mousedown(e) {
        if (this.isDown) return false;
        this.isDown = true;
        return this.mousemove(e);
    }
    mousemove(e) {
        let up = false;
        this.res = this.testZone(e);
        if (this.res !== -1) {
            this.cursor('pointer');
            up = this.modes(this.isDown ? 3 : 2, this.res);
        } else up = this.reset();
        return up;
    }
    update() {
        this.modes(2, this.values.indexOf(this.value));
    }
    // ----------------------
    //   MODE
    // -----------------------
    modes(N = 1, id = -1) {
        let i = this.lng, w, n, r = false;
        while(i--){
            n = N;
            w = this.isSelectable ? this.values[i] === this.value : false;
            if (i === id) {
                if (w && n === 2) n = 3;
            } else {
                n = 1;
                if (w) n = 4;
            }
            if (this.mode(n, i)) r = true;
        }
        return r;
    }
    mode(n, id) {
        let change = false;
        let cc = this.colors, s = this.buttons;
        let i = id;
        if (this.stat[id] !== n) {
            this.stat[id] = n;
            switch(n){
                case 1:
                    s[i].style.color = cc.text;
                    s[i].style.background = cc.button;
                    break;
                case 2:
                    s[i].style.color = cc.textOver;
                    s[i].style.background = cc.overoff;
                    break;
                case 3:
                    s[i].style.color = cc.textOver;
                    s[i].style.background = cc.over;
                    break;
                case 4:
                    s[i].style.color = cc.textSelect;
                    s[i].style.background = cc.select;
                    break;
            }
            change = true;
        }
        return change;
    }
    // ----------------------
    reset() {
        this.res = -1;
        this.cursor();
        return this.modes();
    }
    label(string, n) {
        this.buttons[n].textContent = string;
    }
    icon(string, y, n) {
        this.buttons[n].style.padding = (y || 0) + 'px 0px';
        this.buttons[n].innerHTML = string;
    }
    testW() {
        let vw = this.spaces[0] * 3 + this.bsizeMax * 2, rz = false;
        if (vw > this.w) {
            this.bsize[0] = (this.w - this.spaces[0] * 3) * 0.5;
            rz = true;
        } else if (this.bsize[0] !== this.bsizeMax) {
            this.bsize[0] = this.bsizeMax;
            rz = true;
        }
        if (!rz) return;
        let i = this.buttons.length;
        while(i--)this.buttons[i].style.width = this.bsize[0] + 'px';
    }
    rSize() {
        super.rSize();
        this.testW();
        let mid;
        this.tmpX = [];
        this.tmpY = [];
        for(let j = 0; j < this.grid[0]; j++)if (j === 0) {
            mid = this.w * 0.5 - this.spaces[0] * 0.5;
            this.tmpX.push([
                mid - this.bsize[0],
                mid
            ]);
        } else {
            mid = this.w * 0.5 + this.spaces[0] * 0.5;
            this.tmpX.push([
                mid,
                mid + this.bsize[0]
            ]);
        }
        mid = this.spaces[1];
        for(let i = 0; i < this.grid[1]; i++){
            this.tmpY.push([
                mid,
                mid + this.bsize[1]
            ]);
            mid += this.bsize[1] + this.spaces[1];
        }
    }
    constructor(o = {}){
        super(o);
        /*this.values = o.values || [];

        if( typeof this.values === 'string' ) this.values = [ this.values ];*/ this.values = [];
        if (o.values) {
            if (o.values instanceof Array) this.values = o.values;
            else if (o.values instanceof String) this.values = [
                o.values
            ];
            else if (o.values instanceof Object) {
                this.refObject = o.values;
                for(let g in this.refObject)this.values.push(g);
            }
        }
        this.lng = this.values.length;
        this.value = o.value || null;
        let cc = this.colors;
        this.isSelectable = o.selectable || false;
        this.spaces = o.spaces || [
            cc.sx,
            cc.sy
        ];
        this.bsize = o.bsize || [
            90,
            this.h
        ];
        this.bsizeMax = this.bsize[0];
        this.tmp = [];
        this.stat = [];
        this.grid = [
            2,
            Math.round(this.lng * 0.5)
        ];
        this.h = this.grid[1] * this.bsize[1] + this.grid[1] * this.spaces[1]; //+ 4 - (this.mtop*2) //+ (this.spaces[1] - this.mtop);
        this.c[1].textContent = '';
        //this.c[2] = this.dom( 'table', this.css.basic + 'width:100%; top:'+(this.spaces[1]-2)+'px; height:auto; border-collapse:separate; border:none; border-spacing: '+(this.spaces[0]-2)+'px '+(this.spaces[1]-2)+'px;' );
        this.c[2] = this.dom('table', this.css.basic + 'width:100%; border-spacing: ' + (this.spaces[0] - 2) + 'px ' + this.spaces[1] + 'px; border:none;');
        let n = 0, b, td, tr, sel;
        this.res = -1;
        this.isDown = false;
        this.neverlock = true;
        this.buttons = [];
        this.stat = [];
        this.tmpX = [];
        this.tmpY = [];
        for(let i = 0; i < this.grid[1]; i++){
            tr = this.c[2].insertRow();
            tr.style.cssText = 'pointer-events:none;';
            for(let j = 0; j < this.grid[0]; j++){
                td = tr.insertCell();
                td.style.cssText = 'pointer-events:none;';
                if (this.values[n]) {
                    sel = false;
                    if (this.values[n] === this.value && this.isSelectable) sel = true;
                    b = document.createElement('div');
                    b.style.cssText = this.css.txt + this.css.button + 'position:static; top:1px; width:' + this.bsize[0] + 'px; height:' + (this.bsize[1] - 2) + 'px; border:' + cc.borderSize + 'px solid ' + cc.border + '; left:auto; right:auto; border-radius:' + this.radius + 'px;';
                    b.style.background = sel ? cc.select : cc.button;
                    b.style.color = sel ? cc.textSelect : cc.text;
                    b.innerHTML = this.values[n];
                    td.appendChild(b);
                    this.buttons.push(b);
                    this.stat.push(1);
                } else {
                    b = document.createElement('div');
                    b.style.cssText = this.css.txt + 'position:static; width:' + this.bsize[0] + 'px; height:' + this.bsize[1] + 'px; text-align:center; left:auto; right:auto; background:none;';
                    td.appendChild(b);
                }
                if (j === 0) b.style.cssText += 'float:right;';
                else b.style.cssText += 'float:left;';
                n++;
            }
        }
        this.s[0].border = 'none';
        this.init();
    }
}
class $cb886df1bae8879c$var$Pad2D extends $cb886df1bae8879c$var$Proto {
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        if (l.y <= this.c[1].offsetHeight) return 'title';
        else if (l.y > this.h - this.c[2].offsetHeight) return 'text';
        else return 'pad';
    /*if( ( l.x >= this.margin ) && ( l.x <= this.w - this.margin ) && ( l.y >= this.top + this.margin ) && ( l.y <= this.top + this.w - this.margin ) ) {
            return 'pad';
        }*/ //return '';
    }
    mouseup(e) {
        this.isDown = false;
        return this.mode(0);
    }
    mousedown(e) {
        if (this.testZone(e) === 'pad') {
            this.isDown = true;
            this.mousemove(e);
            return this.mode(1);
        }
    }
    mousemove(e) {
        if (!this.isDown) return;
        let x = this.w * 0.5 - (e.clientX - this.zone.x);
        let y = this.diam * 0.5 - (e.clientY - this.zone.y - this.ytop);
        let r = 256 / this.diam;
        x = -(x * r);
        y = -(y * r);
        x = $cb886df1bae8879c$export$390d11d353c16e49.clamp(x, -this.maxPos, this.maxPos);
        y = $cb886df1bae8879c$export$390d11d353c16e49.clamp(y, -this.maxPos, this.maxPos);
        //let x = e.clientX - this.zone.x;
        //let y = e.clientY - this.zone.y - this.top;
        /*if( x < this.margin ) x = this.margin;
        if( x > this.w - this.margin ) x = this.w - this.margin;
        if( y < this.margin ) y = this.margin;
        if( y > this.w - this.margin ) y = this.w - this.margin;*/ //console.log(x,y)
        this.setPos([
            x,
            y
        ]);
        this.update(true);
    }
    mode(mode) {
        if (this.cmode === mode) return false;
        let cc = this.colors;
        switch(mode){
            case 0:
                this.s[2].color = cc.text;
                this.setSvg(this.c[3], 'fill', cc.back, 0);
                this.setSvg(this.c[3], 'fill', cc.button, 1);
                this.setSvg(this.c[3], 'stroke', cc.back, 2);
                this.setSvg(this.c[3], 'stroke', cc.back, 3);
                this.setSvg(this.c[3], 'stroke', cc.text, 4);
                break;
            case 1:
                this.s[2].color = cc.textSelect;
                this.setSvg(this.c[3], 'fill', cc.backoff, 0);
                this.setSvg(this.c[3], 'fill', cc.overoff, 1);
                this.setSvg(this.c[3], 'stroke', cc.backoff, 2);
                this.setSvg(this.c[3], 'stroke', cc.backoff, 3);
                this.setSvg(this.c[3], 'stroke', cc.textSelect, 4);
                break;
        }
        this.cmode = mode;
        return true;
    }
    update(up) {
        //if( up === undefined ) up = true;
        this.c[2].textContent = this.value;
        this.updateSVG();
        if (up) this.send();
    }
    updateSVG() {
        if (this.model == 1) {
            this.setSvg(this.c[3], 'y1', this.pos.y, 2);
            this.setSvg(this.c[3], 'y2', this.pos.y, 2);
            this.setSvg(this.c[3], 'x1', this.pos.x, 3);
            this.setSvg(this.c[3], 'x2', this.pos.x, 3);
        }
        this.setSvg(this.c[3], 'cx', this.pos.x, 4);
        this.setSvg(this.c[3], 'cy', this.pos.y, 4);
    }
    setPos(p) {
        //if( p === undefined ) p = [ this.w / 2, this.w / 2 ];
        this.pos.set(p[0] + 128, p[1] + 128);
        let r = 1 / this.maxPos;
        this.value[0] = (p[0] * r * this.range).toFixed(this.precision);
        this.value[1] = (p[1] * r * this.range).toFixed(this.precision);
    }
    setValue(v, up = false) {
        if (v === undefined) v = this.value;
        /*if ( v[0] < this.bounds.x1 ) v[0] = this.bounds.x1;
        if ( v[0] > this.bounds.x2 ) v[0] = this.bounds.x2;
        if ( v[1] < this.bounds.y1 ) v[1] = this.bounds.y1;
        if ( v[1] > this.bounds.y2 ) v[1] = this.bounds.y2;*/ this.value[0] = Math.min(this.max, Math.max(this.min, v[0])).toFixed(this.precision) * 1;
        this.value[1] = Math.min(this.max, Math.max(this.min, v[1])).toFixed(this.precision) * 1;
        this.pos.set(this.value[0] / this.range * this.maxPos + 128, this.value[1] / this.range * this.maxPos + 128);
        //console.log(this.pos)
        this.update(up);
    }
    constructor(o = {}){
        super(o);
        this.autoWidth = false;
        this.minw = this.w;
        this.diam = o.diam || this.w;
        //this.margin = 15;
        this.pos = new $cb886df1bae8879c$var$V2(0, 0);
        this.maxPos = 90;
        this.model = o.stype || 0;
        if (o.mode !== undefined) this.model = o.mode;
        this.min = o.min === undefined ? -1 : o.min;
        this.max = o.max === undefined ? 1 : o.max;
        this.range = (this.max - this.min) * 0.5;
        this.cmode = 0;
        //console.log(this.range)
        this.c[0].style.display = 'block';
        this.precision = o.precision === undefined ? 2 : o.precision;
        /*this.bounds = {};
        this.bounds.x1 = o.x1 || -1;
        this.bounds.x2 = o.x2 || 1;
        this.bounds.y1 = o.y1 || -1;
        this.bounds.y2 = o.y2 || 1;

        this.lerpX = this.lerp( this.margin, this.w - this.margin , this.bounds.x1, this.bounds.x2 );
        this.lerpY = this.lerp( this.margin, this.w - this.margin , this.bounds.y1, this.bounds.y2 );

        this.alerpX = this.lerp( this.bounds.x1, this.bounds.x2, this.margin, this.w - this.margin );
        this.alerpY = this.lerp( this.bounds.y1, this.bounds.y2, this.margin, this.w - this.margin );*/ this.value = Array.isArray(o.value) && o.value.length == 2 ? o.value : [
            0,
            0
        ];
        this.h = o.h || this.w + 10;
        this.c[0].style.width = this.w + 'px';
        // Title
        if (this.c[1] !== undefined) {
            this.c[1].style.width = '100%';
            this.c[1].style.justifyContent = 'center';
            this.top = 10;
            this.h += 10;
        }
        //this.top -= this.margin
        let cc = this.colors;
        // Value
        this.c[2] = this.dom('div', this.css.txt + 'justify-content:center; top:' + (this.h - 20) + 'px; width:100%; color:' + cc.text);
        this.c[2].textContent = this.value;
        // Pad
        let pad = this.getPad2d();
        this.setSvg(pad, 'fill', cc.back, 0);
        this.setSvg(pad, 'fill', cc.button, 1);
        this.setSvg(pad, 'stroke', cc.back, 2);
        this.setSvg(pad, 'stroke', cc.back, 3);
        this.setSvg(pad, 'stroke', cc.text, 4);
        this.setSvg(pad, 'viewBox', '0 0 ' + this.diam + ' ' + this.diam);
        this.setCss(pad, {
            width: this.diam,
            height: this.diam,
            left: 0,
            top: this.top
        });
        this.c[3] = pad;
        this.init();
        this.setValue();
    }
}
const $cb886df1bae8879c$export$e16d8520af44a096 = function() {
    let a = arguments;
    let type, o, ref = false, n = null;
    if (typeof a[0] === 'string') {
        type = a[0];
        o = a[1] || {};
    } else if (typeof a[0] === 'object') {
        ref = true;
        if (a[2] === undefined) [].push.call(a, {});
        type = a[2].type ? a[2].type : $cb886df1bae8879c$var$autoType(a[0][a[1]], a[2]);
        o = a[2];
        o.name = a[1];
        if (type === 'list' && !o.list) o.list = a[0][a[1]];
        else o.value = a[0][a[1]];
    }
    let name = type.toLowerCase();
    if (name === 'group') o.add = $cb886df1bae8879c$export$e16d8520af44a096;
    switch(name){
        case 'bool':
        case 'boolean':
            n = new $cb886df1bae8879c$var$Bool(o);
            break;
        case 'button':
            n = new $cb886df1bae8879c$var$Button(o);
            break;
        case 'circular':
            n = new $cb886df1bae8879c$var$Circular(o);
            break;
        case 'color':
            n = new $cb886df1bae8879c$var$Color(o);
            break;
        case 'fps':
            n = new $cb886df1bae8879c$var$Fps(o);
            break;
        case 'graph':
            n = new $cb886df1bae8879c$var$Graph(o);
            break;
        case 'group':
            n = new $cb886df1bae8879c$var$Group(o);
            break;
        case 'joystick':
            n = new $cb886df1bae8879c$var$Joystick(o);
            break;
        case 'knob':
            n = new $cb886df1bae8879c$var$Knob(o);
            break;
        case 'list':
            n = new $cb886df1bae8879c$var$List(o);
            break;
        case 'numeric':
        case 'number':
            n = new $cb886df1bae8879c$var$Numeric(o);
            break;
        case 'slide':
            n = new $cb886df1bae8879c$var$Slide(o);
            break;
        case 'textInput':
        case 'string':
            n = new $cb886df1bae8879c$var$TextInput(o);
            break;
        case 'title':
        case 'text':
            n = new $cb886df1bae8879c$var$Title(o);
            break;
        case 'select':
            n = new $cb886df1bae8879c$var$Select(o);
            break;
        case 'bitmap':
            n = new $cb886df1bae8879c$var$Bitmap(o);
            break;
        case 'selector':
            n = new $cb886df1bae8879c$var$Selector(o);
            break;
        case 'empty':
        case 'space':
            n = new $cb886df1bae8879c$var$Empty(o);
            break;
        case 'item':
            n = new $cb886df1bae8879c$var$Item(o);
            break;
        case 'grid':
            n = new $cb886df1bae8879c$var$Grid(o);
            break;
        case 'pad2d':
        case 'pad':
            n = new $cb886df1bae8879c$var$Pad2D(o);
            break;
    }
    if (n !== null) {
        $cb886df1bae8879c$var$Roots.needResize = true;
        if (ref) n.setReferency(a[0], a[1]);
        return n;
    }
};
const $cb886df1bae8879c$var$autoType = function(v, o) {
    let type = 'slide';
    if (v.isColor) type = 'color';
    else if (v.isTexture) type = 'bitmap';
    else {
        if (typeof v === 'boolean') type = 'bool';
        else if (typeof v === 'string') {
            if (v.substring(0, 1) === '#') type = 'color';
            else type = 'string';
        } else if (typeof v === 'number') {
            if (o.ctype) type = 'color';
            else type = 'slide';
        } else if (typeof v === 'array' && v instanceof Array) {
            if (typeof v[0] === 'number') type = 'number';
            else if (typeof v[0] === 'string') type = 'list';
        } else if (typeof v === 'object' && v instanceof Object) {
            if (v.x !== undefined) type = 'number';
            else type = 'list';
        }
    }
    return type;
};
/**
 * @author lth / https://github.com/lo-th
 */ class $cb886df1bae8879c$export$d8bdd9c139c695f7 {
    setLeft(v) {
        this.content.style.left = v + 'px';
        $cb886df1bae8879c$var$Roots.needReZone = true;
    }
    setTop(t, h) {
        this.content.style.top = t + 'px';
        if (h !== undefined) this.forceHeight = h;
        this.calc();
        $cb886df1bae8879c$var$Roots.needReZone = true;
    }
    addTransition() {
        if (this.transition && !this.isCanvas) {
            this.innerContent.style.transition = 'height ' + this.transition + 's ease-out';
            this.content.style.transition = 'height ' + this.transition + 's ease-out';
            this.bottom.style.transition = 'top ' + this.transition + 's ease-out';
        //this.bottom.addEventListener("transitionend", Roots.resize, true);
        }
        let i = this.uis.length;
        while(i--)this.uis[i].addTransition();
    }
    // ----------------------
    //   CANVAS
    // ----------------------
    onDraw() {}
    makeCanvas() {
        this.canvas = document.createElementNS('http://www.w3.org/1999/xhtml', "canvas");
        this.canvas.width = this.zone.w;
        this.canvas.height = this.forceHeight ? this.forceHeight : this.zone.h;
    //console.log( this.canvas.width, this.canvas.height )
    }
    draw(force) {
        if (this.canvas === null) return;
        let w = this.zone.w;
        let h = this.forceHeight ? this.forceHeight : this.zone.h;
        $cb886df1bae8879c$var$Roots.toCanvas(this, w, h, force);
    }
    //////
    getDom() {
        return this.content;
    }
    noMouse() {
        this.mouse.neg();
    }
    setMouse(uv, flip = true) {
        if (flip) this.mouse.set(Math.round(uv.x * this.canvas.width), this.canvas.height - Math.round(uv.y * this.canvas.height));
        else this.mouse.set(Math.round(uv.x * this.canvas.width), Math.round(uv.y * this.canvas.height));
    //this.mouse.set( m.x, m.y );
    }
    setConfig(o) {
        // reset to default text 
        $cb886df1bae8879c$export$390d11d353c16e49.setText();
        this.colors = $cb886df1bae8879c$export$390d11d353c16e49.defineColor(o);
    }
    setColors(o) {
        for(let c in o)if (this.colors[c]) this.colors[c] = o[c];
    }
    setText(size, color, font, shadow) {
        $cb886df1bae8879c$export$390d11d353c16e49.setText(size, color, font, shadow);
    }
    hide(b) {
        this.content.style.visibility = b ? 'hidden' : 'visible';
    }
    display(v = false) {
        this.content.style.visibility = v ? 'visible' : 'hidden';
    }
    onChange(f) {
        this.callback = f || null;
        return this;
    }
    // ----------------------
    //   STYLES
    // ----------------------
    mode(n) {
        let needChange = false;
        let cc = this.colors;
        if (n !== this.cn) {
            this.cn = n;
            switch(n){
                case 'def':
                    $cb886df1bae8879c$var$Roots.cursor();
                    this.scroll.style.background = cc.button;
                    this.bottom.style.background = cc.background;
                    this.bottom.style.color = cc.text;
                    break;
                //case 'scrollDef': this.scroll.style.background = this.colors.scroll; break;
                case 'scrollOver':
                    $cb886df1bae8879c$var$Roots.cursor('ns-resize');
                    this.scroll.style.background = cc.select;
                    break;
                case 'scrollDown':
                    this.scroll.style.background = cc.select;
                    break;
                //case 'bottomDef': this.bottom.style.background = this.colors.background; break;
                case 'bottomOver':
                    $cb886df1bae8879c$var$Roots.cursor('pointer');
                    this.bottom.style.background = cc.backgroundOver;
                    this.bottom.style.color = cc.textOver;
                    break;
            }
            needChange = true;
        }
        return needChange;
    }
    // ----------------------
    //   TARGET
    // ----------------------
    clearTarget() {
        if (this.current === -1) return false;
        if (this.proto.s) {
            // if no s target is delete !!
            this.proto.uiout();
            this.proto.reset();
        }
        this.proto = null;
        this.current = -1;
        ///console.log(this.isDown)//if(this.isDown)Roots.clearInput();
        $cb886df1bae8879c$var$Roots.cursor();
        return true;
    }
    // ----------------------
    //   ZONE TEST
    // ----------------------
    testZone(e) {
        let l = this.local;
        if (l.x === -1 && l.y === -1) return '';
        //console.log('test', this.zone)
        this.isReset = false;
        let name = '';
        let s = this.isScroll ? this.zone.w - this.size.s : this.zone.w;
        if (l.y > this.zone.h - this.bh && l.y < this.zone.h) name = 'bottom';
        else name = l.x > s ? 'scroll' : 'content';
        return name;
    }
    // ----------------------
    //   EVENTS
    // ----------------------
    handleEvent(e) {
        //if( this.cleanning ) return
        let type = e.type;
        let change = false;
        let protoChange = false;
        let name = this.testZone(e);
        if (type === 'mouseup' && this.isDown) this.isDown = false;
        if (type === 'mousedown' && !this.isDown) this.isDown = true;
        if (this.isDown && this.isNewTarget) {
            $cb886df1bae8879c$var$Roots.clearInput();
            this.isNewTarget = false;
        }
        if (!name) return;
        switch(name){
            case 'content':
                e.clientY = this.isScroll ? e.clientY + this.decal : e.clientY;
                if ($cb886df1bae8879c$var$Roots.isMobile && type === 'mousedown') this.getNext(e, change);
                if (this.proto) protoChange = this.proto.handleEvent(e);
                if (type === 'mousemove') change = this.mode('def');
                if (type === 'wheel' && !protoChange && this.isScroll) change = this.onWheel(e);
                if (!$cb886df1bae8879c$var$Roots.lock) this.getNext(e, change);
                break;
            case 'bottom':
                this.clearTarget();
                if (type === 'mousemove') change = this.mode('bottomOver');
                if (type === 'mousedown') {
                    this.isOpen = this.isOpen ? false : true;
                    this.bottom.textContent = this.isOpen ? this.bottomText[1] : this.bottomText[0];
                    //this.setHeight();
                    this.calc();
                    this.mode('def');
                    change = true;
                }
                break;
            case 'scroll':
                this.clearTarget();
                if (type === 'mousemove') change = this.mode('scrollOver');
                if (type === 'mousedown') change = this.mode('scrollDown');
                if (type === 'wheel') change = this.onWheel(e);
                if (this.isDown) this.update(e.clientY - this.zone.y - this.sh * 0.5);
                break;
        }
        if (this.isDown) change = true;
        if (protoChange) change = true;
        if (type === 'keyup') change = true;
        if (type === 'keydown') change = true;
        if (change) this.draw();
    }
    getNext(e, change) {
        let next = $cb886df1bae8879c$var$Roots.findTarget(this.uis, e);
        if (next !== this.current) {
            this.clearTarget();
            this.current = next;
            this.isNewTarget = true;
        }
        if (next !== -1) {
            this.proto = this.uis[this.current];
            this.proto.uiover();
        }
    }
    onWheel(e) {
        this.oy += 20 * e.delta;
        this.update(this.oy);
        return true;
    }
    // ----------------------
    //   RESET
    // ----------------------
    reset(force) {
        if (this.isReset) return;
        //this.resetItem();
        this.mouse.neg();
        this.isDown = false;
        //Roots.clearInput();
        let r = this.mode('def');
        let r2 = this.clearTarget();
        if (r || r2) this.draw(true);
        this.isReset = true;
    //Roots.lock = false;
    }
    // ----------------------
    //   ADD NODE
    // ----------------------
    add() {
        //if(this.cleanning) this.cleanning = false
        let a = arguments;
        let ontop = false;
        if (typeof a[1] === 'object') {
            a[1].isUI = true;
            a[1].main = this;
            ontop = a[1].ontop ? a[1].ontop : false;
        } else if (typeof a[1] === 'string') {
            if (a[2] === undefined) [].push.call(a, {
                isUI: true,
                main: this
            });
            else {
                a[2].isUI = true;
                a[2].main = this;
                //ontop = a[1].ontop ? a[1].ontop : false;
                ontop = a[2].ontop ? a[2].ontop : false;
            }
        }
        let u = $cb886df1bae8879c$export$e16d8520af44a096.apply(this, a);
        if (u === null) return;
        if (ontop) this.uis.unshift(u);
        else this.uis.push(u);
        this.calc();
        this.isEmpty = false;
        return u;
    }
    // remove one node
    remove(n) {
        if (n.dispose) n.dispose();
    }
    // call after uis clear
    clearOne(n) {
        let id = this.uis.indexOf(n);
        if (id !== -1) {
            //this.calc( - (this.uis[ id ].h + 1 ) );
            this.inner.removeChild(this.uis[id].c[0]);
            this.uis.splice(id, 1);
            this.calc();
        }
    }
    // clear all gui
    empty() {
        //this.cleanning = true
        //this.close();
        let i = this.uis.length, item;
        while(i--){
            item = this.uis.pop();
            this.inner.removeChild(item.c[0]);
            item.dispose();
        }
        this.uis = [];
        this.isEmpty = true;
        this.calc();
    }
    clear() {
        this.empty();
    }
    clear2() {
        setTimeout(this.empty.bind(this), 0);
    }
    dispose() {
        this.clear();
        if (this.parent !== null) this.parent.removeChild(this.content);
        $cb886df1bae8879c$var$Roots.remove(this);
    }
    // ----------------------
    //   ITEMS SPECIAL
    // ----------------------
    resetItem() {
        if (!this.isItemMode) return;
        let i = this.uis.length;
        while(i--)this.uis[i].selected();
    }
    setItem(name) {
        if (!this.isItemMode) return;
        name = name || '';
        this.resetItem();
        if (!name) {
            this.update(0);
            return;
        }
        let i = this.uis.length;
        while(i--)if (this.uis[i].value === name) {
            this.uis[i].selected(true);
            if (this.isScroll) this.update(i * (this.uis[i].h + this.margin) * this.ratio);
        }
    }
    // ----------------------
    //   SCROLL
    // ----------------------
    upScroll(b) {
        this.sw = b ? this.size.s : 0;
        this.oy = b ? this.oy : 0;
        this.scrollBG.style.display = b ? 'block' : 'none';
        if (b) {
            this.total = this.h;
            this.maxView = this.maxHeight;
            this.ratio = this.maxView / this.total;
            this.sh = this.maxView * this.ratio;
            this.range = this.maxView - this.sh;
            this.oy = $cb886df1bae8879c$export$390d11d353c16e49.clamp(this.oy, 0, this.range);
            this.scrollBG.style.height = this.maxView + 'px';
            this.scroll.style.height = this.sh + 'px';
        }
        this.setItemWidth(this.zone.w - this.sw);
        this.update(this.oy);
    }
    update(y) {
        y = $cb886df1bae8879c$export$390d11d353c16e49.clamp(y, 0, this.range);
        this.decal = Math.floor(y / this.ratio);
        this.inner.style.top = -this.decal + 'px';
        this.scroll.style.top = Math.floor(y) + 'px';
        this.oy = y;
    }
    // ----------------------
    //   RESIZE FUNCTION
    // ----------------------
    calcUis() {
        return $cb886df1bae8879c$var$Roots.calcUis(this.uis, this.zone, this.zone.y);
    }
    calc() {
        clearTimeout(this.tmp);
        this.tmp = setTimeout(this.setHeight.bind(this), 10);
    }
    setHeight() {
        if (this.tmp) clearTimeout(this.tmp);
        //console.log('gui setHeight')
        this.zone.h = this.bh;
        //if(this.isBottom) this.zone.y =((window.innerHeight-this.zone.h)-this.bottomPosition)
        this.isScroll = false;
        if (this.isOpen) {
            this.h = this.calcUis();
            //console.log(this.h)
            let hhh = this.forceHeight ? this.forceHeight + this.zone.y : window.innerHeight;
            let py = this.isBottom ? this.bottomPosition : this.zone.y;
            this.maxHeight = hhh - py - this.bh;
            let diff = this.h - this.maxHeight;
            if (diff > 1) {
                this.isScroll = true;
                this.zone.h = this.maxHeight + this.bh;
            } else this.zone.h = this.h + this.bh;
        }
        this.upScroll(this.isScroll);
        this.innerContent.style.height = this.zone.h - this.bh + 'px';
        this.content.style.height = this.zone.h + 'px';
        this.bottom.style.top = this.zone.h - this.bh + 'px';
        if (this.isBottom) {
            this.realTop = window.innerHeight - this.zone.h - this.bottomPosition;
            this.zone.y = this.realTop;
            this.content.style.top = this.realTop + 'px';
            this.calcUis();
        }
        if (this.forceHeight && this.lockHeight) this.content.style.height = this.forceHeight + 'px';
        if (this.isCanvas) this.draw(true);
    }
    resizeRoot() {
        $cb886df1bae8879c$var$Roots.resize();
        $cb886df1bae8879c$var$Roots.initEvents();
    }
    rezone() {
        $cb886df1bae8879c$var$Roots.needReZone = true;
    }
    getRoot() {
        return $cb886df1bae8879c$var$Roots;
    }
    zoneReset() {
    //console.log(Roots)
    //Roots.findZone(true);
    }
    setWidth(w) {
        if (w) this.zone.w = w;
        this.zone.w = Math.floor(this.zone.w);
        this.content.style.width = this.zone.w + 'px';
        if (this.isCenter) this.content.style.marginLeft = -Math.floor(this.zone.w * 0.5) + 'px';
        this.setItemWidth(this.zone.w - this.sw);
    }
    setItemWidth(w) {
        let i = this.uis.length;
        while(i--){
            this.uis[i].setSize(w);
            this.uis[i].rSize();
        }
    }
    constructor(o = {}){
        this.isGui = true;
        this.name = 'gui';
        // for 3d
        this.canvas = null;
        this.screen = null;
        this.plane = o.plane || null;
        // color
        if (o.config) o.colors = o.config;
        if (o.colors) this.setConfig(o.colors);
        else this.colors = $cb886df1bae8879c$export$390d11d353c16e49.defineColor(o);
        //this.cleanning = false
        // style
        this.css = $cb886df1bae8879c$export$390d11d353c16e49.cloneCss();
        this.isReset = true;
        this.tmpAdd = null;
        //this.tmpH = 0
        this.isCanvas = o.isCanvas || false;
        this.isCanvasOnly = false;
        this.callback = o.callback === undefined ? null : o.callback;
        this.forceHeight = o.maxHeight || 0;
        this.lockHeight = o.lockHeight || false;
        this.isItemMode = o.itemMode !== undefined ? o.itemMode : false;
        this.cn = '';
        // size define
        this.size = $cb886df1bae8879c$export$390d11d353c16e49.size;
        if (o.p !== undefined) this.size.p = o.p;
        if (o.w !== undefined) this.size.w = o.w;
        if (o.h !== undefined) this.size.h = o.h;
        if (o.s !== undefined) this.size.s = o.s;
        this.size.h = this.size.h < 11 ? 11 : this.size.h;
        // local mouse and zone
        this.local = new $cb886df1bae8879c$var$V2().neg();
        this.zone = {
            x: 0,
            y: 0,
            w: this.size.w,
            h: 0
        };
        // virtual mouse
        this.mouse = new $cb886df1bae8879c$var$V2().neg();
        this.h = 0;
        //this.prevY = -1;
        this.sw = 0;
        this.margin = this.colors.sy;
        this.marginDiv = $cb886df1bae8879c$export$390d11d353c16e49.isDivid(this.margin);
        // bottom and close height
        this.isWithClose = o.close !== undefined ? o.close : true;
        this.bh = !this.isWithClose ? 0 : this.size.h;
        this.autoResize = o.autoResize === undefined ? true : o.autoResize;
        // default position
        this.isCenter = o.center || false;
        this.isBottom = o.bottom !== undefined ? true : false;
        this.realTop = 0;
        this.bottomPosition = o.bottom || 0;
        this.cssGui = o.css !== undefined ? o.css : this.isCenter ? '' : 'right:10px;';
        this.isOpen = o.open !== undefined ? o.open : true;
        this.isDown = false;
        this.isScroll = false;
        this.uis = [];
        this.current = -1;
        this.proto = null;
        this.isEmpty = true;
        this.decal = 0;
        this.ratio = 1;
        this.oy = 0;
        this.isNewTarget = false;
        let cc = this.colors;
        let border = 'border: 2px solid ' + cc.content + '; ';
        this.content = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.basic + ' width:0px; height:auto; top:0px; background:' + cc.content + '; ' + this.cssGui + border);
        this.innerContent = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.basic + 'width:100%; top:0; left:0; height:auto; overflow:hidden;');
        //this.innerContent = Tools.dom( 'div', this.css.basic + this.css.button + 'width:100%; top:0; left:0; height:auto; overflow:hidden;');
        this.content.appendChild(this.innerContent);
        //this.inner = Tools.dom( 'div', this.css.basic + 'width:100%; left:0; ')
        this.useFlex = true;
        let flexible = this.useFlex ? 'display:flex; flex-flow: row wrap;' : ''; //' display:flex; justify-content:start; align-items:start;flex-direction: column; justify-content: center; align-items: center;';
        this.inner = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.basic + flexible + 'width:100%; left:0; ');
        this.innerContent.appendChild(this.inner);
        // scroll
        this.scrollBG = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.basic + 'right:0; top:0; width:' + (this.size.s - 1) + 'px; height:10px; display:none; background:' + cc.background + ';');
        this.content.appendChild(this.scrollBG);
        this.scroll = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.basic + 'background:' + cc.button + '; right:2px; top:0; width:' + (this.size.s - 4) + 'px; height:10px;');
        this.scrollBG.appendChild(this.scroll);
        // bottom button
        this.bottomText = o.bottomText || [
            'open',
            'close'
        ];
        let r = cc.radius;
        this.bottom = $cb886df1bae8879c$export$390d11d353c16e49.dom('div', this.css.txt + 'width:100%; top:auto; bottom:0; left:0; border-bottom-right-radius:' + r + 'px; border-bottom-left-radius:' + r + 'px; justify-content:center; height:' + this.bh + 'px; line-height:' + (this.bh - 5) + 'px; color:' + cc.text + ';'); // border-top:1px solid '+Tools.colors.stroke+';');
        this.content.appendChild(this.bottom);
        this.bottom.textContent = this.isOpen ? this.bottomText[1] : this.bottomText[0];
        this.bottom.style.background = cc.background;
        //
        this.parent = o.parent !== undefined ? o.parent : null;
        this.parent = o.target !== undefined ? o.target : this.parent;
        if (this.parent === null && !this.isCanvas) this.parent = document.body;
        if (this.parent !== null) this.parent.appendChild(this.content);
        if (this.isCanvas && this.parent === null) this.isCanvasOnly = true;
        if (!this.isCanvasOnly) this.content.style.pointerEvents = 'auto';
        else {
            this.content.style.left = '0px';
            this.content.style.right = 'auto';
            o.transition = 0;
        }
        // height transition
        this.transition = o.transition !== undefined ? o.transition : $cb886df1bae8879c$export$390d11d353c16e49.transition;
        if (this.transition) setTimeout(this.addTransition.bind(this), 1000);
        this.setWidth();
        if (this.isCanvas) this.makeCanvas();
        $cb886df1bae8879c$var$Roots.add(this);
    }
}

});

parcelRegister("gnVfA", function(module, exports) {

$parcel$export(module.exports, "getDesiredRobot", function () { return $bedb341082a00c96$export$d955377f50f2e2c9; });
$parcel$export(module.exports, "getDesiredLanguage", function () { return $bedb341082a00c96$export$c7546526f12a06c7; });
$parcel$export(module.exports, "canHover", function () { return $bedb341082a00c96$export$82867126b61fcb72; });
$parcel$export(module.exports, "isNarrowScreen", function () { return $bedb341082a00c96$export$c4eb12371d0790c2; });
$parcel$export(module.exports, "localize", function () { return $bedb341082a00c96$export$b3bd0bc58e36cd63; });
function $bedb341082a00c96$export$d955377f50f2e2c9() {
    let params = new URLSearchParams(location.search);
    return params.get('robot') || 'franka';
}
function $bedb341082a00c96$export$c7546526f12a06c7() {
    let params = new URLSearchParams(location.search);
    let language = params.get('lang');
    if (!language) {
        language = 'en';
        for (let lang of navigator.languages){
            // May include IETF language tags like en-US
            let langPrimary = lang.split('-')[0].toLowerCase();
            if ([
                'de',
                'en'
            ].includes(langPrimary)) {
                language = langPrimary;
                break;
            }
        }
    }
    return language.toLowerCase();
}
const $bedb341082a00c96$var$_isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
function $bedb341082a00c96$export$971e5333ff27c622() {
    return $bedb341082a00c96$var$_isMobile;
}
const $bedb341082a00c96$var$_canHover = window.matchMedia('(hover: hover)').matches;
function $bedb341082a00c96$export$82867126b61fcb72() {
    return $bedb341082a00c96$var$_canHover;
}
function $bedb341082a00c96$export$c4eb12371d0790c2() {
    return document.body.clientWidth < 768;
}
function $bedb341082a00c96$export$b3bd0bc58e36cd63(key, ...args) {
    return $.i18n(key, ...args);
}

});

parcelRegister("gxi2A", function(module, exports) {

$parcel$export(module.exports, "msgBoxInfo", function () { return $c09db8e690e5008d$export$8e44b1c43a74bf1a; });
$parcel$export(module.exports, "popInfo", function () { return $c09db8e690e5008d$export$fd2aea400c484b44; });
$parcel$export(module.exports, "popSuccess", function () { return $c09db8e690e5008d$export$529d91f83666695d; });
$parcel$export(module.exports, "popWarning", function () { return $c09db8e690e5008d$export$19603f898553ff01; });
$parcel$export(module.exports, "popError", function () { return $c09db8e690e5008d$export$e42b842c27c5ee2e; });
/**
 * Inspired by https://codepen.io/takaneichinose/pen/eZoZxv
 */ class $c09db8e690e5008d$export$52499e2c5ea4b095 {
    show(msg, onCloseCallback = null) {
        if (this.id === null || typeof this.id === "undefined") throw "Please set the 'ID' of the message box container.";
        if (msg === "" || typeof msg === "undefined" || msg === null) throw "The 'msg' parameter is empty.";
        console.log(msg);
        let option = this.option;
        let msgboxArea = document.querySelector(this.id);
        let msgboxBox = document.createElement("div");
        let msgboxContent = document.createElement("div");
        let msgboxText = document.createElement("div");
        let msgboxClose = document.createElement("a");
        if (msgboxArea === null) throw "The Message Box container is not found.";
        // Content area of the message box
        msgboxContent.classList.add("msgbox-content");
        msgboxText.classList.add("msgbox-text");
        msgboxText.innerHTML = msg;
        msgboxContent.appendChild(msgboxText);
        // Close button
        msgboxClose.classList.add("msgbox-close");
        msgboxClose.setAttribute("href", "#");
        msgboxClose.innerText = option.closeLabel || "CLOSE";
        // Container of the Message Box element
        msgboxBox.classList.add("msgbox-box");
        if (option.csscls) for (let cls of option.csscls)msgboxBox.classList.add(cls);
        if (option.closeOnClick) msgboxBox.addEventListener("click", (evt)=>{
            this.hide(msgboxBox);
        });
        // TODO not working? Not important for now, but still strange
        msgboxBox.addEventListener("transitionend", ()=>{
            if (msgboxBox.classList.contains("msgbox-box-hide")) {
                msgboxBox.parentNode.removeChild(msgboxBox);
                clearTimeout(msgboxTimeout);
                if (onCloseCallback) onCloseCallback();
            }
        });
        msgboxBox.appendChild(msgboxContent);
        msgboxArea.appendChild(msgboxBox);
        // Close button
        if (option.hideCloseButton === false || typeof option.hideCloseButton === "undefined") {
            msgboxClose.addEventListener("click", (evt)=>{
                evt.preventDefault();
                if (msgboxBox.classList.contains("msgbox-box-hide")) // This is to avoid exceptions if the close button is clicked multiple times 
                // or clicked while hiding.
                return;
                this.hide(msgboxBox);
            });
            msgboxBox.appendChild(msgboxClose);
        }
        // Auto closing
        let msgboxTimeout;
        if (option.closeTime > 0) {
            msgboxBox.addEventListener("mouseenter", (evt)=>{
                clearTimeout(msgboxTimeout);
                msgboxTimeout = null;
            });
            msgboxBox.addEventListener("mouseleave", (evt)=>{
                if (!msgboxTimeout) msgboxTimeout = setTimeout(()=>{
                    this.hide(msgboxBox);
                }, option.closeTime);
            });
            msgboxBox.dispatchEvent(new Event('mouseleave'));
        }
        return msgboxBox;
    }
    hide(msgboxBox) {
        try {
            msgboxBox.classList.add("msgbox-box-hide");
            document.querySelector(this.id).removeChild(msgboxBox);
        } catch (e) {}
    }
    constructor(id, option, onClickCallback = null){
        this.id = id;
        this.option = option;
    }
}
function $c09db8e690e5008d$export$b9d447a7f19b6d0a(type, closeTime, hideCloseButton, closeOnClick) {
    return new $c09db8e690e5008d$export$52499e2c5ea4b095('#msgbox-area', {
        closeTime: closeTime,
        hideCloseButton: hideCloseButton,
        closeOnClick: closeOnClick,
        csscls: type
    });
}
function $c09db8e690e5008d$export$8e44b1c43a74bf1a({ closeTime: closeTime = 4000, hideCloseButton: hideCloseButton = true, closeOnClick: closeOnClick = true } = {}) {
    return $c09db8e690e5008d$export$b9d447a7f19b6d0a([
        "info"
    ], closeTime, hideCloseButton, closeOnClick);
}
function $c09db8e690e5008d$export$fad10c43a67aa93c({ closeTime: closeTime = 4000, hideCloseButton: hideCloseButton = true, closeOnClick: closeOnClick = true } = {}) {
    return $c09db8e690e5008d$export$b9d447a7f19b6d0a([
        "success"
    ], closeTime, hideCloseButton, closeOnClick);
}
function $c09db8e690e5008d$export$f98b8a2b0d2c4b31({ closeTime: closeTime = 4000, hideCloseButton: hideCloseButton = true, closeOnClick: closeOnClick = true } = {}) {
    return $c09db8e690e5008d$export$b9d447a7f19b6d0a([
        "warning"
    ], closeTime, hideCloseButton, closeOnClick);
}
function $c09db8e690e5008d$export$6df2f1da403c50ee({ closeTime: closeTime = 6000, hideCloseButton: hideCloseButton = true, closeOnClick: closeOnClick = true } = {}) {
    return $c09db8e690e5008d$export$b9d447a7f19b6d0a([
        "error"
    ], closeTime, hideCloseButton, closeOnClick);
}
let $c09db8e690e5008d$export$fd2aea400c484b44 = (msg, closeCallback)=>$c09db8e690e5008d$export$8e44b1c43a74bf1a().show(msg, closeCallback);
let $c09db8e690e5008d$export$529d91f83666695d = (msg, closeCallback)=>$c09db8e690e5008d$export$fad10c43a67aa93c().show(msg, closeCallback);
let $c09db8e690e5008d$export$19603f898553ff01 = (msg, closeCallback)=>$c09db8e690e5008d$export$f98b8a2b0d2c4b31().show(msg, closeCallback);
let $c09db8e690e5008d$export$e42b842c27c5ee2e = (msg, closeCallback)=>$c09db8e690e5008d$export$6df2f1da403c50ee().show(msg, closeCallback);

});


parcelRegister("5X33T", function(module, exports) {
'use strict';
/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else module.exports = factory();
})(typeof window !== 'undefined' ? window : module.exports, function() {
    // Make sure it does not throw in a SSR (Server Side Rendering) situation
    if (typeof window === "undefined") return null;
    // https://github.com/Semantic-Org/Semantic-UI/issues/3855
    // https://github.com/marcj/css-element-queries/issues/257
    var globalWindow = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
    // Only used for the dirty checking, so the event callback count is limited to max 1 call per fps per sensor.
    // In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
    // would generate too many unnecessary events.
    var requestAnimationFrame = globalWindow.requestAnimationFrame || globalWindow.mozRequestAnimationFrame || globalWindow.webkitRequestAnimationFrame || function(fn) {
        return globalWindow.setTimeout(fn, 20);
    };
    var cancelAnimationFrame = globalWindow.cancelAnimationFrame || globalWindow.mozCancelAnimationFrame || globalWindow.webkitCancelAnimationFrame || function(timer) {
        globalWindow.clearTimeout(timer);
    };
    /**
     * Iterate over each of the provided element(s).
     *
     * @param {HTMLElement|HTMLElement[]} elements
     * @param {Function}                  callback
     */ function forEachElement(elements, callback) {
        var elementsType = Object.prototype.toString.call(elements);
        var isCollectionTyped = '[object Array]' === elementsType || '[object NodeList]' === elementsType || '[object HTMLCollection]' === elementsType || '[object Object]' === elementsType || 'undefined' !== typeof jQuery && elements instanceof jQuery //jquery
         || 'undefined' !== typeof Elements && elements instanceof Elements //mootools
        ;
        var i = 0, j = elements.length;
        if (isCollectionTyped) for(; i < j; i++)callback(elements[i]);
        else callback(elements);
    }
    /**
    * Get element size
    * @param {HTMLElement} element
    * @returns {Object} {width, height}
    */ function getElementSize(element) {
        if (!element.getBoundingClientRect) return {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        var rect = element.getBoundingClientRect();
        return {
            width: Math.round(rect.width),
            height: Math.round(rect.height)
        };
    }
    /**
     * Apply CSS styles to element.
     *
     * @param {HTMLElement} element
     * @param {Object} style
     */ function setStyle(element, style) {
        Object.keys(style).forEach(function(key) {
            element.style[key] = style[key];
        });
    }
    /**
     * Class for dimension change detection.
     *
     * @param {Element|Element[]|Elements|jQuery} element
     * @param {Function} callback
     *
     * @constructor
     */ var ResizeSensor = function(element, callback) {
        //Is used when checking in reset() only for invisible elements
        var lastAnimationFrameForInvisibleCheck = 0;
        /**
         *
         * @constructor
         */ function EventQueue() {
            var q = [];
            this.add = function(ev) {
                q.push(ev);
            };
            var i, j;
            this.call = function(sizeInfo) {
                for(i = 0, j = q.length; i < j; i++)q[i].call(this, sizeInfo);
            };
            this.remove = function(ev) {
                var newQueue = [];
                for(i = 0, j = q.length; i < j; i++)if (q[i] !== ev) newQueue.push(q[i]);
                q = newQueue;
            };
            this.length = function() {
                return q.length;
            };
        }
        /**
         *
         * @param {HTMLElement} element
         * @param {Function}    resized
         */ function attachResizeEvent(element, resized) {
            if (!element) return;
            if (element.resizedAttached) {
                element.resizedAttached.add(resized);
                return;
            }
            element.resizedAttached = new EventQueue();
            element.resizedAttached.add(resized);
            element.resizeSensor = document.createElement('div');
            element.resizeSensor.dir = 'ltr';
            element.resizeSensor.className = 'resize-sensor';
            var style = {
                pointerEvents: 'none',
                position: 'absolute',
                left: '0px',
                top: '0px',
                right: '0px',
                bottom: '0px',
                overflow: 'hidden',
                zIndex: '-1',
                visibility: 'hidden',
                maxWidth: '100%'
            };
            var styleChild = {
                position: 'absolute',
                left: '0px',
                top: '0px',
                transition: '0s'
            };
            setStyle(element.resizeSensor, style);
            var expand = document.createElement('div');
            expand.className = 'resize-sensor-expand';
            setStyle(expand, style);
            var expandChild = document.createElement('div');
            setStyle(expandChild, styleChild);
            expand.appendChild(expandChild);
            var shrink = document.createElement('div');
            shrink.className = 'resize-sensor-shrink';
            setStyle(shrink, style);
            var shrinkChild = document.createElement('div');
            setStyle(shrinkChild, styleChild);
            setStyle(shrinkChild, {
                width: '200%',
                height: '200%'
            });
            shrink.appendChild(shrinkChild);
            element.resizeSensor.appendChild(expand);
            element.resizeSensor.appendChild(shrink);
            element.appendChild(element.resizeSensor);
            var computedStyle = window.getComputedStyle(element);
            var position = computedStyle ? computedStyle.getPropertyValue('position') : null;
            if ('absolute' !== position && 'relative' !== position && 'fixed' !== position && 'sticky' !== position) element.style.position = 'relative';
            var dirty = false;
            //last request animation frame id used in onscroll event
            var rafId = 0;
            var size = getElementSize(element);
            var lastWidth = 0;
            var lastHeight = 0;
            var initialHiddenCheck = true;
            lastAnimationFrameForInvisibleCheck = 0;
            var resetExpandShrink = function() {
                var width = element.offsetWidth;
                var height = element.offsetHeight;
                expandChild.style.width = width + 10 + 'px';
                expandChild.style.height = height + 10 + 'px';
                expand.scrollLeft = width + 10;
                expand.scrollTop = height + 10;
                shrink.scrollLeft = width + 10;
                shrink.scrollTop = height + 10;
            };
            var reset = function() {
                // Check if element is hidden
                if (initialHiddenCheck) {
                    var invisible = element.offsetWidth === 0 && element.offsetHeight === 0;
                    if (invisible) {
                        // Check in next frame
                        if (!lastAnimationFrameForInvisibleCheck) lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function() {
                            lastAnimationFrameForInvisibleCheck = 0;
                            reset();
                        });
                        return;
                    } else // Stop checking
                    initialHiddenCheck = false;
                }
                resetExpandShrink();
            };
            element.resizeSensor.resetSensor = reset;
            var onResized = function() {
                rafId = 0;
                if (!dirty) return;
                lastWidth = size.width;
                lastHeight = size.height;
                if (element.resizedAttached) element.resizedAttached.call(size);
            };
            var onScroll = function() {
                size = getElementSize(element);
                dirty = size.width !== lastWidth || size.height !== lastHeight;
                if (dirty && !rafId) rafId = requestAnimationFrame(onResized);
                reset();
            };
            var addEvent = function(el, name, cb) {
                if (el.attachEvent) el.attachEvent('on' + name, cb);
                else el.addEventListener(name, cb);
            };
            addEvent(expand, 'scroll', onScroll);
            addEvent(shrink, 'scroll', onScroll);
            // Fix for custom Elements and invisible elements
            lastAnimationFrameForInvisibleCheck = requestAnimationFrame(function() {
                lastAnimationFrameForInvisibleCheck = 0;
                reset();
            });
        }
        forEachElement(element, function(elem) {
            attachResizeEvent(elem, callback);
        });
        this.detach = function(ev) {
            // clean up the unfinished animation frame to prevent a potential endless requestAnimationFrame of reset
            if (!lastAnimationFrameForInvisibleCheck) {
                cancelAnimationFrame(lastAnimationFrameForInvisibleCheck);
                lastAnimationFrameForInvisibleCheck = 0;
            }
            ResizeSensor.detach(element, ev);
        };
        this.reset = function() {
            element.resizeSensor.resetSensor();
        };
    };
    ResizeSensor.reset = function(element) {
        forEachElement(element, function(elem) {
            elem.resizeSensor.resetSensor();
        });
    };
    ResizeSensor.detach = function(element, ev) {
        forEachElement(element, function(elem) {
            if (!elem) return;
            if (elem.resizedAttached && typeof ev === "function") {
                elem.resizedAttached.remove(ev);
                if (elem.resizedAttached.length()) return;
            }
            if (elem.resizeSensor) {
                if (elem.contains(elem.resizeSensor)) elem.removeChild(elem.resizeSensor);
                delete elem.resizeSensor;
                delete elem.resizedAttached;
            }
        });
    };
    if (typeof MutationObserver !== "undefined") {
        var observer = new MutationObserver(function(mutations) {
            for(var i in mutations)if (mutations.hasOwnProperty(i)) {
                var items = mutations[i].addedNodes;
                for(var j = 0; j < items.length; j++)if (items[j].resizeSensor) ResizeSensor.reset(items[j]);
            }
        });
        document.addEventListener("DOMContentLoaded", function(event) {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
    return ResizeSensor;
});

});

parcelRegister("1Gb2G", function(module, exports) {

var $4cLJb = parcelRequire("4cLJb");
class $1392477ae738d612$var$Sawyer extends (0, $4cLJb.default) {
    init(model) {
        if ("robotiq_arg2f_base_link" in model.frames) {
            // 2 finger gripper
            this.tcp.position = [
                0,
                0,
                0.15
            ];
            this.hand.invertOpenClose = true;
        } else // 3 finger gripper
        this.tcp.position = [
            0.05,
            0,
            0
        ];
        return super.init(model);
    }
    constructor(){
        super("Sawyer", "sawyer_description", "urdf/sawyer_rocksi.urdf.xacro");
        // 2 finger and 3 finger grippers. Edit the URDF to decide which one to load!
        this.packages.robotiq_2f_85_gripper_visualization = (0, $4cLJb.getPackage)('robotiq_2f_85_gripper_visualization');
        this.packages.robotiq_3f_gripper_visualization = (0, $4cLJb.getPackage)('robotiq_3f_gripper_visualization');
        this.robotRoot = "base";
        this.handRoot = "right_hand_l";
        this.modelScale = 10;
        this.defaultPose = {
            right_j0: 1.2408,
            right_j1: -1.024,
            right_j2: -1.3984,
            right_j3: 0.7367,
            right_j4: 0.2976,
            right_j5: 1.5476,
            right_j6: -1.193
        };
        this.tcp.parent = "right_hand_l";
        this.ikEnabled = [
            "right_j0",
            //"head_pan",
            "right_j1",
            "right_j2",
            "right_j3",
            "right_j4"
        ];
        this.interactionJointLimits = {
        };
    }
}
module.exports = new $1392477ae738d612$var$Sawyer();

});



parcelRegister("aFxf6", function(module, exports) {

$parcel$export(module.exports, "makeRock", function () { return $7c47850489048ec9$export$43e2f304eb1802ca; });

var $8TfIJ = parcelRequire("8TfIJ");

var $7POKm = parcelRequire("7POKm");
function $7c47850489048ec9$export$43e2f304eb1802ca(vertices, diameter, color) {
    let points = [];
    for(let i = 0; i < vertices; i++)points.push(new (0, $8TfIJ.Vector3)(Math.random() * diameter, Math.random() * diameter, Math.random() * diameter));
    let hull = new (0, $7POKm.ConvexGeometry)(points);
    let mat = new (0, $8TfIJ.MeshPhongMaterial)({
        color: color,
        roughness: 1,
        flatShading: true
    });
    return new (0, $8TfIJ.Mesh)(hull, mat);
}
var $7c47850489048ec9$export$2e2bcd8739ae039 = $7c47850489048ec9$export$43e2f304eb1802ca;

});
parcelRegister("7POKm", function(module, exports) {

$parcel$export(module.exports, "ConvexGeometry", function () { return $5b44a90d9229dd14$export$7af97143bfc37a8f; });

var $8TfIJ = parcelRequire("8TfIJ");

var $lHVyh = parcelRequire("lHVyh");
class $5b44a90d9229dd14$export$7af97143bfc37a8f extends (0, $8TfIJ.BufferGeometry) {
    constructor(points){
        super();
        // buffers
        const vertices = [];
        const normals = [];
        if ((0, $lHVyh.ConvexHull) === undefined) console.error('THREE.ConvexBufferGeometry: ConvexBufferGeometry relies on ConvexHull');
        const convexHull = new (0, $lHVyh.ConvexHull)().setFromPoints(points);
        // generate vertices and normals
        const faces = convexHull.faces;
        for(let i = 0; i < faces.length; i++){
            const face = faces[i];
            let edge = face.edge;
            // we move along a doubly-connected edge list to access all face points (see HalfEdge docs)
            do {
                const point = edge.head().point;
                vertices.push(point.x, point.y, point.z);
                normals.push(face.normal.x, face.normal.y, face.normal.z);
                edge = edge.next;
            }while (edge !== face.edge);
        }
        // build geometry
        this.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(vertices, 3));
        this.setAttribute('normal', new (0, $8TfIJ.Float32BufferAttribute)(normals, 3));
    }
}

});
parcelRegister("lHVyh", function(module, exports) {

$parcel$export(module.exports, "ConvexHull", function () { return $fcda41c10ae52b29$export$2062365927816f76; });

var $8TfIJ = parcelRequire("8TfIJ");
/**
 * Ported from: https://github.com/maurizzzio/quickhull3d/ by Mauricio Poppe (https://github.com/maurizzzio)
 */ const $fcda41c10ae52b29$var$Visible = 0;
const $fcda41c10ae52b29$var$Deleted = 1;
const $fcda41c10ae52b29$var$_v1 = new (0, $8TfIJ.Vector3)();
const $fcda41c10ae52b29$var$_line3 = new (0, $8TfIJ.Line3)();
const $fcda41c10ae52b29$var$_plane = new (0, $8TfIJ.Plane)();
const $fcda41c10ae52b29$var$_closestPoint = new (0, $8TfIJ.Vector3)();
const $fcda41c10ae52b29$var$_triangle = new (0, $8TfIJ.Triangle)();
class $fcda41c10ae52b29$export$2062365927816f76 {
    setFromPoints(points) {
        if (Array.isArray(points) !== true) console.error('THREE.ConvexHull: Points parameter is not an array.');
        if (points.length < 4) console.error('THREE.ConvexHull: The algorithm needs at least four points.');
        this.makeEmpty();
        for(let i = 0, l = points.length; i < l; i++)this.vertices.push(new $fcda41c10ae52b29$var$VertexNode(points[i]));
        this.compute();
        return this;
    }
    setFromObject(object) {
        const points = [];
        object.updateMatrixWorld(true);
        object.traverse(function(node) {
            const geometry = node.geometry;
            if (geometry !== undefined) {
                if (geometry.isGeometry) {
                    console.error('THREE.ConvexHull no longer supports Geometry. Use THREE.BufferGeometry instead.');
                    return;
                } else if (geometry.isBufferGeometry) {
                    const attribute = geometry.attributes.position;
                    if (attribute !== undefined) for(let i = 0, l = attribute.count; i < l; i++){
                        const point = new (0, $8TfIJ.Vector3)();
                        point.fromBufferAttribute(attribute, i).applyMatrix4(node.matrixWorld);
                        points.push(point);
                    }
                }
            }
        });
        return this.setFromPoints(points);
    }
    containsPoint(point) {
        const faces = this.faces;
        for(let i = 0, l = faces.length; i < l; i++){
            const face = faces[i];
            // compute signed distance and check on what half space the point lies
            if (face.distanceToPoint(point) > this.tolerance) return false;
        }
        return true;
    }
    intersectRay(ray, target) {
        // based on "Fast Ray-Convex Polyhedron Intersection"  by Eric Haines, GRAPHICS GEMS II
        const faces = this.faces;
        let tNear = -Infinity;
        let tFar = Infinity;
        for(let i = 0, l = faces.length; i < l; i++){
            const face = faces[i];
            // interpret faces as planes for the further computation
            const vN = face.distanceToPoint(ray.origin);
            const vD = face.normal.dot(ray.direction);
            // if the origin is on the positive side of a plane (so the plane can "see" the origin) and
            // the ray is turned away or parallel to the plane, there is no intersection
            if (vN > 0 && vD >= 0) return null;
            // compute the distance from the ray’s origin to the intersection with the plane
            const t = vD !== 0 ? -vN / vD : 0;
            // only proceed if the distance is positive. a negative distance means the intersection point
            // lies "behind" the origin
            if (t <= 0) continue;
            // now categorized plane as front-facing or back-facing
            if (vD > 0) //  plane faces away from the ray, so this plane is a back-face
            tFar = Math.min(t, tFar);
            else // front-face
            tNear = Math.max(t, tNear);
            if (tNear > tFar) // if tNear ever is greater than tFar, the ray must miss the convex hull
            return null;
        }
        // evaluate intersection point
        // always try tNear first since its the closer intersection point
        if (tNear !== -Infinity) ray.at(tNear, target);
        else ray.at(tFar, target);
        return target;
    }
    intersectsRay(ray) {
        return this.intersectRay(ray, $fcda41c10ae52b29$var$_v1) !== null;
    }
    makeEmpty() {
        this.faces = [];
        this.vertices = [];
        return this;
    }
    // Adds a vertex to the 'assigned' list of vertices and assigns it to the given face
    addVertexToFace(vertex, face) {
        vertex.face = face;
        if (face.outside === null) this.assigned.append(vertex);
        else this.assigned.insertBefore(face.outside, vertex);
        face.outside = vertex;
        return this;
    }
    // Removes a vertex from the 'assigned' list of vertices and from the given face
    removeVertexFromFace(vertex, face) {
        if (vertex === face.outside) {
            // fix face.outside link
            if (vertex.next !== null && vertex.next.face === face) // face has at least 2 outside vertices, move the 'outside' reference
            face.outside = vertex.next;
            else // vertex was the only outside vertex that face had
            face.outside = null;
        }
        this.assigned.remove(vertex);
        return this;
    }
    // Removes all the visible vertices that a given face is able to see which are stored in the 'assigned' vertext list
    removeAllVerticesFromFace(face) {
        if (face.outside !== null) {
            // reference to the first and last vertex of this face
            const start = face.outside;
            let end = face.outside;
            while(end.next !== null && end.next.face === face)end = end.next;
            this.assigned.removeSubList(start, end);
            // fix references
            start.prev = end.next = null;
            face.outside = null;
            return start;
        }
    }
    // Removes all the visible vertices that 'face' is able to see
    deleteFaceVertices(face, absorbingFace) {
        const faceVertices = this.removeAllVerticesFromFace(face);
        if (faceVertices !== undefined) {
            if (absorbingFace === undefined) // mark the vertices to be reassigned to some other face
            this.unassigned.appendChain(faceVertices);
            else {
                // if there's an absorbing face try to assign as many vertices as possible to it
                let vertex = faceVertices;
                do {
                    // we need to buffer the subsequent vertex at this point because the 'vertex.next' reference
                    // will be changed by upcoming method calls
                    const nextVertex = vertex.next;
                    const distance = absorbingFace.distanceToPoint(vertex.point);
                    // check if 'vertex' is able to see 'absorbingFace'
                    if (distance > this.tolerance) this.addVertexToFace(vertex, absorbingFace);
                    else this.unassigned.append(vertex);
                    // now assign next vertex
                    vertex = nextVertex;
                }while (vertex !== null);
            }
        }
        return this;
    }
    // Reassigns as many vertices as possible from the unassigned list to the new faces
    resolveUnassignedPoints(newFaces) {
        if (this.unassigned.isEmpty() === false) {
            let vertex = this.unassigned.first();
            do {
                // buffer 'next' reference, see .deleteFaceVertices()
                const nextVertex = vertex.next;
                let maxDistance = this.tolerance;
                let maxFace = null;
                for(let i = 0; i < newFaces.length; i++){
                    const face = newFaces[i];
                    if (face.mark === $fcda41c10ae52b29$var$Visible) {
                        const distance = face.distanceToPoint(vertex.point);
                        if (distance > maxDistance) {
                            maxDistance = distance;
                            maxFace = face;
                        }
                        if (maxDistance > 1000 * this.tolerance) break;
                    }
                }
                // 'maxFace' can be null e.g. if there are identical vertices
                if (maxFace !== null) this.addVertexToFace(vertex, maxFace);
                vertex = nextVertex;
            }while (vertex !== null);
        }
        return this;
    }
    // Computes the extremes of a simplex which will be the initial hull
    computeExtremes() {
        const min = new (0, $8TfIJ.Vector3)();
        const max = new (0, $8TfIJ.Vector3)();
        const minVertices = [];
        const maxVertices = [];
        // initially assume that the first vertex is the min/max
        for(let i = 0; i < 3; i++)minVertices[i] = maxVertices[i] = this.vertices[0];
        min.copy(this.vertices[0].point);
        max.copy(this.vertices[0].point);
        // compute the min/max vertex on all six directions
        for(let i = 0, l = this.vertices.length; i < l; i++){
            const vertex = this.vertices[i];
            const point = vertex.point;
            // update the min coordinates
            for(let j = 0; j < 3; j++)if (point.getComponent(j) < min.getComponent(j)) {
                min.setComponent(j, point.getComponent(j));
                minVertices[j] = vertex;
            }
            // update the max coordinates
            for(let j = 0; j < 3; j++)if (point.getComponent(j) > max.getComponent(j)) {
                max.setComponent(j, point.getComponent(j));
                maxVertices[j] = vertex;
            }
        }
        // use min/max vectors to compute an optimal epsilon
        this.tolerance = 3 * Number.EPSILON * (Math.max(Math.abs(min.x), Math.abs(max.x)) + Math.max(Math.abs(min.y), Math.abs(max.y)) + Math.max(Math.abs(min.z), Math.abs(max.z)));
        return {
            min: minVertices,
            max: maxVertices
        };
    }
    // Computes the initial simplex assigning to its faces all the points
    // that are candidates to form part of the hull
    computeInitialHull() {
        const vertices = this.vertices;
        const extremes = this.computeExtremes();
        const min = extremes.min;
        const max = extremes.max;
        // 1. Find the two vertices 'v0' and 'v1' with the greatest 1d separation
        // (max.x - min.x)
        // (max.y - min.y)
        // (max.z - min.z)
        let maxDistance = 0;
        let index = 0;
        for(let i = 0; i < 3; i++){
            const distance = max[i].point.getComponent(i) - min[i].point.getComponent(i);
            if (distance > maxDistance) {
                maxDistance = distance;
                index = i;
            }
        }
        const v0 = min[index];
        const v1 = max[index];
        let v2;
        let v3;
        // 2. The next vertex 'v2' is the one farthest to the line formed by 'v0' and 'v1'
        maxDistance = 0;
        $fcda41c10ae52b29$var$_line3.set(v0.point, v1.point);
        for(let i = 0, l = this.vertices.length; i < l; i++){
            const vertex = vertices[i];
            if (vertex !== v0 && vertex !== v1) {
                $fcda41c10ae52b29$var$_line3.closestPointToPoint(vertex.point, true, $fcda41c10ae52b29$var$_closestPoint);
                const distance = $fcda41c10ae52b29$var$_closestPoint.distanceToSquared(vertex.point);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    v2 = vertex;
                }
            }
        }
        // 3. The next vertex 'v3' is the one farthest to the plane 'v0', 'v1', 'v2'
        maxDistance = -1;
        $fcda41c10ae52b29$var$_plane.setFromCoplanarPoints(v0.point, v1.point, v2.point);
        for(let i = 0, l = this.vertices.length; i < l; i++){
            const vertex = vertices[i];
            if (vertex !== v0 && vertex !== v1 && vertex !== v2) {
                const distance = Math.abs($fcda41c10ae52b29$var$_plane.distanceToPoint(vertex.point));
                if (distance > maxDistance) {
                    maxDistance = distance;
                    v3 = vertex;
                }
            }
        }
        const faces = [];
        if ($fcda41c10ae52b29$var$_plane.distanceToPoint(v3.point) < 0) {
            // the face is not able to see the point so 'plane.normal' is pointing outside the tetrahedron
            faces.push($fcda41c10ae52b29$var$Face.create(v0, v1, v2), $fcda41c10ae52b29$var$Face.create(v3, v1, v0), $fcda41c10ae52b29$var$Face.create(v3, v2, v1), $fcda41c10ae52b29$var$Face.create(v3, v0, v2));
            // set the twin edge
            for(let i = 0; i < 3; i++){
                const j = (i + 1) % 3;
                // join face[ i ] i > 0, with the first face
                faces[i + 1].getEdge(2).setTwin(faces[0].getEdge(j));
                // join face[ i ] with face[ i + 1 ], 1 <= i <= 3
                faces[i + 1].getEdge(1).setTwin(faces[j + 1].getEdge(0));
            }
        } else {
            // the face is able to see the point so 'plane.normal' is pointing inside the tetrahedron
            faces.push($fcda41c10ae52b29$var$Face.create(v0, v2, v1), $fcda41c10ae52b29$var$Face.create(v3, v0, v1), $fcda41c10ae52b29$var$Face.create(v3, v1, v2), $fcda41c10ae52b29$var$Face.create(v3, v2, v0));
            // set the twin edge
            for(let i = 0; i < 3; i++){
                const j = (i + 1) % 3;
                // join face[ i ] i > 0, with the first face
                faces[i + 1].getEdge(2).setTwin(faces[0].getEdge((3 - i) % 3));
                // join face[ i ] with face[ i + 1 ]
                faces[i + 1].getEdge(0).setTwin(faces[j + 1].getEdge(1));
            }
        }
        // the initial hull is the tetrahedron
        for(let i = 0; i < 4; i++)this.faces.push(faces[i]);
        // initial assignment of vertices to the faces of the tetrahedron
        for(let i = 0, l = vertices.length; i < l; i++){
            const vertex = vertices[i];
            if (vertex !== v0 && vertex !== v1 && vertex !== v2 && vertex !== v3) {
                maxDistance = this.tolerance;
                let maxFace = null;
                for(let j = 0; j < 4; j++){
                    const distance = this.faces[j].distanceToPoint(vertex.point);
                    if (distance > maxDistance) {
                        maxDistance = distance;
                        maxFace = this.faces[j];
                    }
                }
                if (maxFace !== null) this.addVertexToFace(vertex, maxFace);
            }
        }
        return this;
    }
    // Removes inactive faces
    reindexFaces() {
        const activeFaces = [];
        for(let i = 0; i < this.faces.length; i++){
            const face = this.faces[i];
            if (face.mark === $fcda41c10ae52b29$var$Visible) activeFaces.push(face);
        }
        this.faces = activeFaces;
        return this;
    }
    // Finds the next vertex to create faces with the current hull
    nextVertexToAdd() {
        // if the 'assigned' list of vertices is empty, no vertices are left. return with 'undefined'
        if (this.assigned.isEmpty() === false) {
            let eyeVertex, maxDistance = 0;
            // grap the first available face and start with the first visible vertex of that face
            const eyeFace = this.assigned.first().face;
            let vertex = eyeFace.outside;
            // now calculate the farthest vertex that face can see
            do {
                const distance = eyeFace.distanceToPoint(vertex.point);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    eyeVertex = vertex;
                }
                vertex = vertex.next;
            }while (vertex !== null && vertex.face === eyeFace);
            return eyeVertex;
        }
    }
    // Computes a chain of half edges in CCW order called the 'horizon'.
    // For an edge to be part of the horizon it must join a face that can see
    // 'eyePoint' and a face that cannot see 'eyePoint'.
    computeHorizon(eyePoint, crossEdge, face, horizon) {
        // moves face's vertices to the 'unassigned' vertex list
        this.deleteFaceVertices(face);
        face.mark = $fcda41c10ae52b29$var$Deleted;
        let edge;
        if (crossEdge === null) edge = crossEdge = face.getEdge(0);
        else // start from the next edge since 'crossEdge' was already analyzed
        // (actually 'crossEdge.twin' was the edge who called this method recursively)
        edge = crossEdge.next;
        do {
            const twinEdge = edge.twin;
            const oppositeFace = twinEdge.face;
            if (oppositeFace.mark === $fcda41c10ae52b29$var$Visible) {
                if (oppositeFace.distanceToPoint(eyePoint) > this.tolerance) // the opposite face can see the vertex, so proceed with next edge
                this.computeHorizon(eyePoint, twinEdge, oppositeFace, horizon);
                else // the opposite face can't see the vertex, so this edge is part of the horizon
                horizon.push(edge);
            }
            edge = edge.next;
        }while (edge !== crossEdge);
        return this;
    }
    // Creates a face with the vertices 'eyeVertex.point', 'horizonEdge.tail' and 'horizonEdge.head' in CCW order
    addAdjoiningFace(eyeVertex, horizonEdge) {
        // all the half edges are created in ccw order thus the face is always pointing outside the hull
        const face = $fcda41c10ae52b29$var$Face.create(eyeVertex, horizonEdge.tail(), horizonEdge.head());
        this.faces.push(face);
        // join face.getEdge( - 1 ) with the horizon's opposite edge face.getEdge( - 1 ) = face.getEdge( 2 )
        face.getEdge(-1).setTwin(horizonEdge.twin);
        return face.getEdge(0); // the half edge whose vertex is the eyeVertex
    }
    //  Adds 'horizon.length' faces to the hull, each face will be linked with the
    //  horizon opposite face and the face on the left/right
    addNewFaces(eyeVertex, horizon) {
        this.newFaces = [];
        let firstSideEdge = null;
        let previousSideEdge = null;
        for(let i = 0; i < horizon.length; i++){
            const horizonEdge = horizon[i];
            // returns the right side edge
            const sideEdge = this.addAdjoiningFace(eyeVertex, horizonEdge);
            if (firstSideEdge === null) firstSideEdge = sideEdge;
            else // joins face.getEdge( 1 ) with previousFace.getEdge( 0 )
            sideEdge.next.setTwin(previousSideEdge);
            this.newFaces.push(sideEdge.face);
            previousSideEdge = sideEdge;
        }
        // perform final join of new faces
        firstSideEdge.next.setTwin(previousSideEdge);
        return this;
    }
    // Adds a vertex to the hull
    addVertexToHull(eyeVertex) {
        const horizon = [];
        this.unassigned.clear();
        // remove 'eyeVertex' from 'eyeVertex.face' so that it can't be added to the 'unassigned' vertex list
        this.removeVertexFromFace(eyeVertex, eyeVertex.face);
        this.computeHorizon(eyeVertex.point, null, eyeVertex.face, horizon);
        this.addNewFaces(eyeVertex, horizon);
        // reassign 'unassigned' vertices to the new faces
        this.resolveUnassignedPoints(this.newFaces);
        return this;
    }
    cleanup() {
        this.assigned.clear();
        this.unassigned.clear();
        this.newFaces = [];
        return this;
    }
    compute() {
        let vertex;
        this.computeInitialHull();
        // add all available vertices gradually to the hull
        while((vertex = this.nextVertexToAdd()) !== undefined)this.addVertexToHull(vertex);
        this.reindexFaces();
        this.cleanup();
        return this;
    }
    constructor(){
        this.tolerance = -1;
        this.faces = []; // the generated faces of the convex hull
        this.newFaces = []; // this array holds the faces that are generated within a single iteration
        // the vertex lists work as follows:
        //
        // let 'a' and 'b' be 'Face' instances
        // let 'v' be points wrapped as instance of 'Vertex'
        //
        //     [v, v, ..., v, v, v, ...]
        //      ^             ^
        //      |             |
        //  a.outside     b.outside
        //
        this.assigned = new $fcda41c10ae52b29$var$VertexList();
        this.unassigned = new $fcda41c10ae52b29$var$VertexList();
        this.vertices = []; // vertices of the hull (internal representation of given geometry data)
    }
}
//
class $fcda41c10ae52b29$var$Face {
    static create(a, b, c) {
        const face = new $fcda41c10ae52b29$var$Face();
        const e0 = new $fcda41c10ae52b29$var$HalfEdge(a, face);
        const e1 = new $fcda41c10ae52b29$var$HalfEdge(b, face);
        const e2 = new $fcda41c10ae52b29$var$HalfEdge(c, face);
        // join edges
        e0.next = e2.prev = e1;
        e1.next = e0.prev = e2;
        e2.next = e1.prev = e0;
        // main half edge reference
        face.edge = e0;
        return face.compute();
    }
    getEdge(i) {
        let edge = this.edge;
        while(i > 0){
            edge = edge.next;
            i--;
        }
        while(i < 0){
            edge = edge.prev;
            i++;
        }
        return edge;
    }
    compute() {
        const a = this.edge.tail();
        const b = this.edge.head();
        const c = this.edge.next.head();
        $fcda41c10ae52b29$var$_triangle.set(a.point, b.point, c.point);
        $fcda41c10ae52b29$var$_triangle.getNormal(this.normal);
        $fcda41c10ae52b29$var$_triangle.getMidpoint(this.midpoint);
        this.area = $fcda41c10ae52b29$var$_triangle.getArea();
        this.constant = this.normal.dot(this.midpoint);
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) - this.constant;
    }
    constructor(){
        this.normal = new (0, $8TfIJ.Vector3)();
        this.midpoint = new (0, $8TfIJ.Vector3)();
        this.area = 0;
        this.constant = 0; // signed distance from face to the origin
        this.outside = null; // reference to a vertex in a vertex list this face can see
        this.mark = $fcda41c10ae52b29$var$Visible;
        this.edge = null;
    }
}
// Entity for a Doubly-Connected Edge List (DCEL).
class $fcda41c10ae52b29$var$HalfEdge {
    head() {
        return this.vertex;
    }
    tail() {
        return this.prev ? this.prev.vertex : null;
    }
    length() {
        const head = this.head();
        const tail = this.tail();
        if (tail !== null) return tail.point.distanceTo(head.point);
        return -1;
    }
    lengthSquared() {
        const head = this.head();
        const tail = this.tail();
        if (tail !== null) return tail.point.distanceToSquared(head.point);
        return -1;
    }
    setTwin(edge) {
        this.twin = edge;
        edge.twin = this;
        return this;
    }
    constructor(vertex, face){
        this.vertex = vertex;
        this.prev = null;
        this.next = null;
        this.twin = null;
        this.face = face;
    }
}
// A vertex as a double linked list node.
class $fcda41c10ae52b29$var$VertexNode {
    constructor(point){
        this.point = point;
        this.prev = null;
        this.next = null;
        this.face = null; // the face that is able to see this vertex
    }
}
// A double linked list that contains vertex nodes.
class $fcda41c10ae52b29$var$VertexList {
    first() {
        return this.head;
    }
    last() {
        return this.tail;
    }
    clear() {
        this.head = this.tail = null;
        return this;
    }
    // Inserts a vertex before the target vertex
    insertBefore(target, vertex) {
        vertex.prev = target.prev;
        vertex.next = target;
        if (vertex.prev === null) this.head = vertex;
        else vertex.prev.next = vertex;
        target.prev = vertex;
        return this;
    }
    // Inserts a vertex after the target vertex
    insertAfter(target, vertex) {
        vertex.prev = target;
        vertex.next = target.next;
        if (vertex.next === null) this.tail = vertex;
        else vertex.next.prev = vertex;
        target.next = vertex;
        return this;
    }
    // Appends a vertex to the end of the linked list
    append(vertex) {
        if (this.head === null) this.head = vertex;
        else this.tail.next = vertex;
        vertex.prev = this.tail;
        vertex.next = null; // the tail has no subsequent vertex
        this.tail = vertex;
        return this;
    }
    // Appends a chain of vertices where 'vertex' is the head.
    appendChain(vertex) {
        if (this.head === null) this.head = vertex;
        else this.tail.next = vertex;
        vertex.prev = this.tail;
        // ensure that the 'tail' reference points to the last vertex of the chain
        while(vertex.next !== null)vertex = vertex.next;
        this.tail = vertex;
        return this;
    }
    // Removes a vertex from the linked list
    remove(vertex) {
        if (vertex.prev === null) this.head = vertex.next;
        else vertex.prev.next = vertex.next;
        if (vertex.next === null) this.tail = vertex.prev;
        else vertex.next.prev = vertex.prev;
        return this;
    }
    // Removes a list of vertices whose 'head' is 'a' and whose 'tail' is b
    removeSubList(a, b) {
        if (a.prev === null) this.head = b.next;
        else a.prev.next = b.next;
        if (b.next === null) this.tail = a.prev;
        else b.next.prev = a.prev;
        return this;
    }
    isEmpty() {
        return this.head === null;
    }
    constructor(){
        this.head = null;
        this.tail = null;
    }
}

});




parcelRegister("6vqIF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bca5d3dbe4f6c35$export$2e2bcd8739ae039; });

var $OCLXF = parcelRequire("OCLXF");

var $8TfIJ = parcelRequire("8TfIJ");
function $4bca5d3dbe4f6c35$var$cannonDebugger(scene, bodies, { color: color = 0x00ff00, scale: scale = 1, onInit: onInit, onUpdate: onUpdate, autoUpdate: autoUpdate } = {}) {
    const _meshes = [];
    const _material = new (0, $8TfIJ.MeshBasicMaterial)({
        color: color != null ? color : 0x00ff00,
        wireframe: true
    });
    const _tempVec0 = new (0, $OCLXF.Vec3)();
    const _tempVec1 = new (0, $OCLXF.Vec3)();
    const _tempVec2 = new (0, $OCLXF.Vec3)();
    const _tempQuat0 = new (0, $OCLXF.Quaternion)();
    const _sphereGeometry = new (0, $8TfIJ.SphereGeometry)(1);
    const _boxGeometry = new (0, $8TfIJ.BoxGeometry)(1, 1, 1);
    const _planeGeometry = new (0, $8TfIJ.PlaneGeometry)(10, 10, 10, 10);
    function createConvexPolyhedronGeometry(shape) {
        const geometry = new (0, $8TfIJ.BufferGeometry)(); // Add vertices
        const positions = [];
        for(let i = 0; i < shape.vertices.length; i++){
            const vertex = shape.vertices[i];
            positions.push(vertex.x, vertex.y, vertex.z);
        }
        geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(positions, 3)); // Add faces
        const indices = [];
        for(let i = 0; i < shape.faces.length; i++){
            const face = shape.faces[i];
            const a = face[0];
            for(let j = 1; j < face.length - 1; j++){
                const b = face[j];
                const c = face[j + 1];
                indices.push(a, b, c);
            }
        }
        geometry.setIndex(indices);
        geometry.computeBoundingSphere();
        geometry.computeVertexNormals();
        return geometry;
    }
    function createTrimeshGeometry(shape) {
        const geometry = new (0, $8TfIJ.BufferGeometry)();
        const positions = [];
        const v0 = _tempVec0;
        const v1 = _tempVec1;
        const v2 = _tempVec2;
        for(let i = 0; i < shape.indices.length / 3; i++){
            shape.getTriangleVertices(i, v0, v1, v2);
            positions.push(v0.x, v0.y, v0.z);
            positions.push(v1.x, v1.y, v1.z);
            positions.push(v2.x, v2.y, v2.z);
        }
        geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(positions, 3));
        geometry.computeBoundingSphere();
        geometry.computeVertexNormals();
        return geometry;
    }
    function createHeightfieldGeometry(shape) {
        const geometry = new (0, $8TfIJ.BufferGeometry)();
        const s = shape.elementSize || 1; // assumes square heightfield, else i*x, j*y
        const positions = shape.data.flatMap((row, i)=>row.flatMap((z, j)=>[
                    i * s,
                    j * s,
                    z
                ]));
        const indices = [];
        for(let xi = 0; xi < shape.data.length - 1; xi++)for(let yi = 0; yi < shape.data[xi].length - 1; yi++){
            const stride = shape.data[xi].length;
            const index = xi * stride + yi;
            indices.push(index + 1, index + stride, index + stride + 1);
            indices.push(index + stride, index + 1, index);
        }
        geometry.setIndex(indices);
        geometry.setAttribute('position', new (0, $8TfIJ.Float32BufferAttribute)(positions, 3));
        geometry.computeBoundingSphere();
        geometry.computeVertexNormals();
        return geometry;
    }
    function createMesh(shape) {
        let mesh = new (0, $8TfIJ.Mesh)();
        const { SPHERE: SPHERE, BOX: BOX, PLANE: PLANE, CYLINDER: CYLINDER, CONVEXPOLYHEDRON: CONVEXPOLYHEDRON, TRIMESH: TRIMESH, HEIGHTFIELD: HEIGHTFIELD } = (0, $OCLXF.Shape).types;
        switch(shape.type){
            case SPHERE:
                mesh = new (0, $8TfIJ.Mesh)(_sphereGeometry, _material);
                break;
            case BOX:
                mesh = new (0, $8TfIJ.Mesh)(_boxGeometry, _material);
                break;
            case PLANE:
                mesh = new (0, $8TfIJ.Mesh)(_planeGeometry, _material);
                break;
            case CYLINDER:
                {
                    const geometry = new (0, $8TfIJ.CylinderGeometry)(shape.radiusTop, shape.radiusBottom, shape.height, shape.numSegments);
                    mesh = new (0, $8TfIJ.Mesh)(geometry, _material);
                    shape.geometryId = geometry.id;
                    break;
                }
            case CONVEXPOLYHEDRON:
                {
                    const geometry = createConvexPolyhedronGeometry(shape);
                    mesh = new (0, $8TfIJ.Mesh)(geometry, _material);
                    shape.geometryId = geometry.id;
                    break;
                }
            case TRIMESH:
                {
                    const geometry = createTrimeshGeometry(shape);
                    mesh = new (0, $8TfIJ.Mesh)(geometry, _material);
                    shape.geometryId = geometry.id;
                    break;
                }
            case HEIGHTFIELD:
                {
                    const geometry = createHeightfieldGeometry(shape);
                    mesh = new (0, $8TfIJ.Mesh)(geometry, _material);
                    shape.geometryId = geometry.id;
                    break;
                }
        }
        scene.add(mesh);
        return mesh;
    }
    function scaleMesh(mesh, shape) {
        const { SPHERE: SPHERE, BOX: BOX, PLANE: PLANE, CYLINDER: CYLINDER, CONVEXPOLYHEDRON: CONVEXPOLYHEDRON, TRIMESH: TRIMESH, HEIGHTFIELD: HEIGHTFIELD } = (0, $OCLXF.Shape).types;
        switch(shape.type){
            case SPHERE:
                {
                    const { radius: radius } = shape;
                    mesh.scale.set(radius * scale, radius * scale, radius * scale);
                    break;
                }
            case BOX:
                mesh.scale.copy(shape.halfExtents);
                mesh.scale.multiplyScalar(2 * scale);
                break;
            case PLANE:
                break;
            case CYLINDER:
                mesh.scale.set(1 * scale, 1 * scale, 1 * scale);
                break;
            case CONVEXPOLYHEDRON:
                mesh.scale.set(1 * scale, 1 * scale, 1 * scale);
                break;
            case TRIMESH:
                mesh.scale.copy(shape.scale).multiplyScalar(scale);
                break;
            case HEIGHTFIELD:
                mesh.scale.set(1 * scale, 1 * scale, 1 * scale);
                break;
        }
    }
    function typeMatch(mesh, shape) {
        if (!mesh) return false;
        const { geometry: geometry } = mesh;
        return geometry instanceof (0, $8TfIJ.SphereGeometry) && shape.type === (0, $OCLXF.Shape).types.SPHERE || geometry instanceof (0, $8TfIJ.BoxGeometry) && shape.type === (0, $OCLXF.Shape).types.BOX || geometry instanceof (0, $8TfIJ.PlaneGeometry) && shape.type === (0, $OCLXF.Shape).types.PLANE || geometry.id === shape.geometryId && shape.type === (0, $OCLXF.Shape).types.CYLINDER || geometry.id === shape.geometryId && shape.type === (0, $OCLXF.Shape).types.CONVEXPOLYHEDRON || geometry.id === shape.geometryId && shape.type === (0, $OCLXF.Shape).types.TRIMESH || geometry.id === shape.geometryId && shape.type === (0, $OCLXF.Shape).types.HEIGHTFIELD;
    }
    function updateMesh(index, shape) {
        let mesh = _meshes[index];
        let didCreateNewMesh = false;
        if (!typeMatch(mesh, shape)) {
            if (mesh) scene.remove(mesh);
            _meshes[index] = mesh = createMesh(shape);
            didCreateNewMesh = true;
        }
        scaleMesh(mesh, shape);
        return didCreateNewMesh;
    }
    function update() {
        const meshes = _meshes;
        const shapeWorldPosition = _tempVec0;
        const shapeWorldQuaternion = _tempQuat0;
        let meshIndex = 0;
        for (const body of bodies)for(let i = 0; i !== body.shapes.length; i++){
            const shape = body.shapes[i];
            const didCreateNewMesh = updateMesh(meshIndex, shape);
            const mesh = meshes[meshIndex];
            if (mesh) {
                // Get world position
                body.quaternion.vmult(body.shapeOffsets[i], shapeWorldPosition);
                body.position.vadd(shapeWorldPosition, shapeWorldPosition); // Get world quaternion
                body.quaternion.mult(body.shapeOrientations[i], shapeWorldQuaternion); // Copy to meshes
                mesh.position.copy(shapeWorldPosition);
                mesh.quaternion.copy(shapeWorldQuaternion);
                if (didCreateNewMesh && onInit instanceof Function) onInit(body, mesh, shape);
                if (!didCreateNewMesh && onUpdate instanceof Function) onUpdate(body, mesh, shape);
            }
            meshIndex++;
        }
        for(let i = meshIndex; i < meshes.length; i++){
            const mesh = meshes[i];
            if (mesh) scene.remove(mesh);
        }
        meshes.length = meshIndex;
        if (autoUpdate !== false) requestAnimationFrame(update);
    }
    if (autoUpdate !== false) requestAnimationFrame(update);
    return {
        update: update
    };
}
var $4bca5d3dbe4f6c35$export$2e2bcd8739ae039 = $4bca5d3dbe4f6c35$var$cannonDebugger;

});





parcelRegister("jxVWf", function(module, exports) {
/* eslint-disable */ 
(function(root, factory) {
    if (typeof define === 'function' && define.amd) define([
        '../core'
    ], factory);
    else module.exports = factory((parcelRequire("460Qg")));
})(module.exports, function(Blockly) {
    var Blockly = {};
    Blockly.Msg = {}; // This file was automatically generated.  Do not modify.
    'use strict';
    Blockly.Msg["ADD_COMMENT"] = "Kommentar hinzuf\xfcgen";
    Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "Die Variable \u201E%1\u201C kann nicht gel\xf6scht werden, da sie Teil der Definition der Funktion \u201E%2\u201C ist.";
    Blockly.Msg["CHANGE_VALUE_TITLE"] = "Wert \xe4ndern:";
    Blockly.Msg["CLEAN_UP"] = "Bausteine aufr\xe4umen";
    Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "Eingeklappte Bl\xf6cke enthalten Warnungen.";
    Blockly.Msg["COLLAPSE_ALL"] = "Alle Bausteine zusammenfalten";
    Blockly.Msg["COLLAPSE_BLOCK"] = "Baustein zusammenfalten";
    Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "Farbe 1";
    Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "und Farbe 2";
    Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp";
    Blockly.Msg["COLOUR_BLEND_RATIO"] = "im Verh\xe4ltnis";
    Blockly.Msg["COLOUR_BLEND_TITLE"] = "mische";
    Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "Vermischt 2 Farben mit konfigurierbarem Farbverh\xe4ltnis (0.0 - 1.0).";
    Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://de.wikipedia.org/wiki/Farbe";
    Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "W\xe4hlt eine Farbe aus der Palette aus.";
    Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com"; // untranslated
    Blockly.Msg["COLOUR_RANDOM_TITLE"] = "zuf\xe4llige Farbe";
    Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "Erzeugt eine Farbe nach dem Zufallsprinzip.";
    Blockly.Msg["COLOUR_RGB_BLUE"] = "blau";
    Blockly.Msg["COLOUR_RGB_GREEN"] = "gr\xfcn";
    Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html";
    Blockly.Msg["COLOUR_RGB_RED"] = "rot";
    Blockly.Msg["COLOUR_RGB_TITLE"] = "Farbe aus";
    Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "Erzeugt eine Farbe mit selbst definierten Rot-, Gr\xfcn- und Blauwerten. Alle Werte m\xfcssen zwischen 0 und 100 liegen.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://de.wikipedia.org/wiki/Kontrollstruktur";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "die Schleife abbrechen";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "sofort mit n\xe4chstem Schleifendurchlauf fortfahren";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "Die umgebende Schleife beenden.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "Diese Anweisung abbrechen und mit dem n\xe4chsten Schleifendurchlauf fortfahren.";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "Warnung: Dieser Baustein kann nur in einer Schleife verwendet werden.";
    Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://de.wikipedia.org/wiki/For-Schleife";
    Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "f\xfcr jeden Wert %1 aus der Liste %2";
    Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = 'F\xfchrt eine Anweisung f\xfcr jeden Wert in der Liste aus und setzt dabei die Variable "%1" auf den aktuellen Listenwert.';
    Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://de.wikipedia.org/wiki/For-Schleife";
    Blockly.Msg["CONTROLS_FOR_TITLE"] = "z\xe4hle %1 von %2 bis %3 in Schritten von %4";
    Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = 'Z\xe4hlt die Variable "%1" von einem Startwert bis zu einem Endwert und f\xfchrt f\xfcr jeden Wert eine Anweisung aus.';
    Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "Eine weitere Bedingung hinzuf\xfcgen.";
    Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "Eine sonst-Bedingung hinzuf\xfcgen. F\xfchrt eine Anweisung aus, falls keine Bedingung zutrifft.";
    Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse"; // untranslated
    Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "Hinzuf\xfcgen, entfernen oder sortieren von Sektionen";
    Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "sonst";
    Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "sonst falls";
    Blockly.Msg["CONTROLS_IF_MSG_IF"] = "falls";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "F\xfchrt eine Anweisung aus, falls eine Bedingung wahr ist.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "F\xfchrt die erste Anweisung aus, falls eine Bedingung wahr ist.  F\xfchrt ansonsten die zweite Anweisung aus.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "F\xfchrt die erste Anweisung aus, falls die erste Bedingung wahr ist.  F\xfchrt ansonsten die zweite Anweisung aus, falls die zweite Bedingung wahr ist.";
    Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "F\xfchre die erste Anweisung aus, falls die erste Bedingung wahr ist.  F\xfchrt ansonsten die zweite Anweisung aus, falls die zweite Bedingung wahr ist.  F\xfchrt die dritte Anweisung aus, falls keine der beiden Bedingungen wahr ist";
    Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://de.wikipedia.org/wiki/For-Schleife";
    Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "mache";
    Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "wiederhole %1 mal:";
    Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Eine Anweisung mehrfach ausf\xfchren.";
    Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://de.wikipedia.org/wiki/Schleife_%28Programmierung%29";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "wiederhole bis";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "wiederhole solange";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "F\xfchrt Anweisungen aus solange die Bedingung unwahr ist.";
    Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "F\xfchrt Anweisungen aus solange die Bedingung wahr ist.";
    Blockly.Msg["DELETE_ALL_BLOCKS"] = "Alle %1 Bausteine l\xf6schen?";
    Blockly.Msg["DELETE_BLOCK"] = "Baustein l\xf6schen";
    Blockly.Msg["DELETE_VARIABLE"] = "Die Variable \u201E%1\u201C l\xf6schen";
    Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "%1 Verwendungen der Variable \u201E%2\u201C l\xf6schen?";
    Blockly.Msg["DELETE_X_BLOCKS"] = "%1 Bausteine l\xf6schen";
    Blockly.Msg["DISABLE_BLOCK"] = "Baustein deaktivieren";
    Blockly.Msg["DUPLICATE_BLOCK"] = "Kopieren";
    Blockly.Msg["DUPLICATE_COMMENT"] = "Kommentar kopieren";
    Blockly.Msg["ENABLE_BLOCK"] = "Baustein aktivieren";
    Blockly.Msg["EXPAND_ALL"] = "Alle Bausteine entfalten";
    Blockly.Msg["EXPAND_BLOCK"] = "Baustein entfalten";
    Blockly.Msg["EXTERNAL_INPUTS"] = "externe Eing\xe4nge";
    Blockly.Msg["HELP"] = "Hilfe";
    Blockly.Msg["INLINE_INPUTS"] = "interne Eing\xe4nge";
    Blockly.Msg["IOS_CANCEL"] = "Abbrechen";
    Blockly.Msg["IOS_ERROR"] = "Fehler";
    Blockly.Msg["IOS_OK"] = "OK";
    Blockly.Msg["IOS_PROCEDURES_ADD_INPUT"] = "+ Parameter hinzuf\xfcgen";
    Blockly.Msg["IOS_PROCEDURES_ALLOW_STATEMENTS"] = "Anweisungen erlauben";
    Blockly.Msg["IOS_PROCEDURES_DUPLICATE_INPUTS_ERROR"] = "Diese Funktion hat doppelte Parameter.";
    Blockly.Msg["IOS_PROCEDURES_INPUTS"] = "PARAMETER";
    Blockly.Msg["IOS_VARIABLES_ADD_BUTTON"] = "Hinzuf\xfcgen";
    Blockly.Msg["IOS_VARIABLES_ADD_VARIABLE"] = "+ Variable hinzuf\xfcgen";
    Blockly.Msg["IOS_VARIABLES_DELETE_BUTTON"] = "L\xf6schen";
    Blockly.Msg["IOS_VARIABLES_EMPTY_NAME_ERROR"] = "Du kannst keinen leeren Variablennamen verwenden.";
    Blockly.Msg["IOS_VARIABLES_RENAME_BUTTON"] = "Umbenennen";
    Blockly.Msg["IOS_VARIABLES_VARIABLE_NAME"] = "Name der Variable";
    Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list";
    Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "erzeuge eine leere Liste";
    Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "Erzeugt eine leere Liste ohne Inhalt.";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "Liste";
    Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "Hinzuf\xfcgen, entfernen und sortieren von Elementen.";
    Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
    Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "erzeuge Liste mit";
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "Ein Element zur Liste hinzuf\xfcgen.";
    Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Erzeugt eine Liste aus den angegebenen Elementen.";
    Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "Erste";
    Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "von hinten das";
    Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "das";
    Blockly.Msg["LISTS_GET_INDEX_GET"] = "nimm";
    Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "nimm und entferne";
    Blockly.Msg["LISTS_GET_INDEX_LAST"] = "Letzte";
    Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "Zuf\xe4llig";
    Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "entferne";
    Blockly.Msg["LISTS_GET_INDEX_TAIL"] = "Element";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "Extrahiert das erste Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "Extrahiert das Element an der angegebenen Position in der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "Extrahiert das letzte Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "Extrahiert ein zuf\xe4lliges Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "Extrahiert und entfernt das erste Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "Extrahiert und entfernt das Element an der angegebenen Position aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "Extrahiert und entfernt das letzte Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "Extrahiert und entfernt ein zuf\xe4lliges Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "Entfernt das erste Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "Entfernt das Element an der angegebenen Position aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "Entfernt das letzte Element aus der Liste.";
    Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "Entfernt ein zuf\xe4lliges Element aus der Liste.";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "bis von hinten";
    Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "bis";
    Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "bis letztes";
    Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "nimm Teilliste ab erstes";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "nimm Teilliste ab von hinten";
    Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "nimm Teilliste ab";
    Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = "Element";
    Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "Erstellt eine Kopie mit dem angegebenen Abschnitt der Liste.";
    Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 ist das letzte Element.";
    Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 ist das erste Element.";
    Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "suche erstes Auftreten von";
    Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["LISTS_INDEX_OF_LAST"] = "suche letztes Auftreten von";
    Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "Sucht die Position (Index) eines Elementes in der Liste. Gibt %1 zur\xfcck, falls kein Element gefunden wurde.";
    Blockly.Msg["LISTS_INLIST"] = "in der Liste";
    Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty"; // untranslated
    Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1 ist leer";
    Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "Ist wahr, falls die Liste leer ist.";
    Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of"; // untranslated
    Blockly.Msg["LISTS_LENGTH_TITLE"] = "L\xe4nge von %1";
    Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Die Anzahl von Elementen in der Liste.";
    Blockly.Msg["LISTS_REPEAT_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["LISTS_REPEAT_TITLE"] = "erzeuge Liste mit %2 mal dem Element %1\u200B";
    Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "Erzeugt eine Liste mit einer variablen Anzahl von Elementen";
    Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list";
    Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "kehre %1 um";
    Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "Kehre eine Kopie einer Liste um.";
    Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "ein";
    Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "f\xfcge als";
    Blockly.Msg["LISTS_SET_INDEX_SET"] = "setze f\xfcr";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "F\xfcgt das Element an den Anfang der Liste an.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "F\xfcgt das Element an der angegebenen Position in die Liste ein.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "F\xfcgt das Element ans Ende der Liste an.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "F\xfcgt das Element zuf\xe4llig in die Liste ein.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "Setzt das erste Element in der Liste.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "Setzt das Element an der angegebenen Position in der Liste.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "Setzt das letzte Element in die Liste.";
    Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "Setzt ein zuf\xe4lliges Element in der Liste.";
    Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list";
    Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "aufsteigend";
    Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "absteigend";
    Blockly.Msg["LISTS_SORT_TITLE"] = "%1 %2 %3 sortieren";
    Blockly.Msg["LISTS_SORT_TOOLTIP"] = "Eine Kopie einer Liste sortieren.";
    Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "alphabetisch, Gro\xdfschreibung ignorieren";
    Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "numerisch";
    Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "alphabetisch";
    Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists";
    Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "Liste aus Text erstellen";
    Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "Text aus Liste erstellen";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "Liste mit Texten in einen Text vereinen, getrennt durch ein Trennzeichen.";
    Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "Text in eine Liste mit Texten aufteilen, unterbrochen bei jedem Trennzeichen.";
    Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "mit Trennzeichen";
    Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "falsch";
    Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values"; // untranslated
    Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Ist entweder wahr oder falsch";
    Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "wahr";
    Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://de.wikipedia.org/wiki/Vergleich_%28Zahlen%29";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Ist wahr, falls beide Werte gleich sind.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Ist wahr, falls der erste Wert gr\xf6\xdfer als der zweite Wert ist.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Ist wahr, falls der erste Wert gr\xf6\xdfer als oder gleich gro\xdf wie der zweite Wert ist.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Ist wahr, falls der erste Wert kleiner als der zweite Wert ist.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Ist wahr, falls der erste Wert kleiner als oder gleich gro\xdf wie der zweite Wert ist.";
    Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Ist wahr, falls beide Werte unterschiedlich sind.";
    Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not"; // untranslated
    Blockly.Msg["LOGIC_NEGATE_TITLE"] = "nicht %1";
    Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Ist wahr, falls der Eingabewert unwahr ist.  Ist unwahr, falls der Eingabewert wahr ist.";
    Blockly.Msg["LOGIC_NULL"] = "null";
    Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://de.wikipedia.org/wiki/Nullwert";
    Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "Ist \"null\".";
    Blockly.Msg["LOGIC_OPERATION_AND"] = "und";
    Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations"; // untranslated
    Blockly.Msg["LOGIC_OPERATION_OR"] = "oder";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Ist wahr, falls beide Werte wahr sind.";
    Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Ist wahr, falls einer der beiden Werte wahr ist.";
    Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "pr\xfcfe";
    Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://de.wikipedia.org/wiki/%3F:#Auswahloperator";
    Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "falls falsch";
    Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "falls wahr";
    Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = '\xdcberpr\xfcft eine Bedingung "pr\xfcfe". Falls die Bedingung wahr ist, wird der "falls wahr" Wert zur\xfcckgegeben, andernfalls der "falls unwahr" Wert';
    Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+"; // untranslated
    Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://de.wikipedia.org/wiki/Grundrechenart";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Ist die Summe zweier Zahlen.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Ist der Quotient zweier Zahlen.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Ist die Differenz zweier Zahlen.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Ist das Produkt zweier Zahlen.";
    Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Ist die erste Zahl potenziert mit der zweiten Zahl.";
    Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://de.wikipedia.org/wiki/Arctan2";
    Blockly.Msg["MATH_ATAN2_TITLE"] = "atan2 von X:%1 Y:%2";
    Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "Gibt den Arkustangens des Punktes (X, Y) in Grad von -180 bis 180 zur\xfcck.";
    Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://de.wikipedia.org/wiki/Inkrement_und_Dekrement";
    Blockly.Msg["MATH_CHANGE_TITLE"] = "erh\xf6he %1 um %2";
    Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Addiert eine Zahl zu \"%1\".";
    Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://de.wikipedia.org/wiki/Mathematische_Konstante";
    Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "Mathematische Konstanten wie: \u03C0 (3.141\u2026), e (2.718\u2026), \u03C6 (1.618\u2026), sqrt(2) (1.414\u2026), sqrt(\xbd) (0.707\u2026) oder \u221E (unendlich).";
    Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)"; // untranslated
    Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "begrenze %1 zwischen %2 und %3";
    Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Begrenzt eine Zahl auf den Wertebereich zwischen zwei anderen Zahlen (inklusiv).";
    Blockly.Msg["MATH_DIVISION_SYMBOL"] = "\xf7"; // untranslated
    Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "ist teilbar durch";
    Blockly.Msg["MATH_IS_EVEN"] = "ist gerade";
    Blockly.Msg["MATH_IS_NEGATIVE"] = "ist negativ";
    Blockly.Msg["MATH_IS_ODD"] = "ist ungerade";
    Blockly.Msg["MATH_IS_POSITIVE"] = "ist positiv";
    Blockly.Msg["MATH_IS_PRIME"] = "ist eine Primzahl";
    Blockly.Msg["MATH_IS_TOOLTIP"] = "\xdcberpr\xfcft ob eine Zahl gerade, ungerade, eine Primzahl, ganzzahlig, positiv, negativ oder durch eine zweite Zahl teilbar ist.  Gibt wahr oder falsch zur\xfcck.";
    Blockly.Msg["MATH_IS_WHOLE"] = "ist eine ganze Zahl";
    Blockly.Msg["MATH_MODULO_HELPURL"] = "https://de.wikipedia.org/wiki/Modulo";
    Blockly.Msg["MATH_MODULO_TITLE"] = "Rest von %1 \xf7 %2";
    Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Der Rest nach einer Division.";
    Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "\xd7"; // untranslated
    Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://de.wikipedia.org/wiki/Zahl";
    Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "Eine Zahl.";
    Blockly.Msg["MATH_ONLIST_HELPURL"] = "http://www.sysplus.ch/einstieg.php?links=menu&seite=4125&grad=Crash&prog=Excel";
    Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "Mittelwert der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "Maximalwert der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "Median der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "Minimalwert der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "am h\xe4ufigsten in der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "Zufallswert aus der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "Standardabweichung der Liste";
    Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "Summe \xfcber die Liste";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "Ist der Durchschnittswert aller Zahlen in einer Liste.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "Ist die gr\xf6\xdfte Zahl in einer Liste.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "Ist der Median aller Zahlen in einer Liste.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "Ist die kleinste Zahl in einer Liste.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "Findet die Werte mit dem h\xe4ufigstem Vorkommen in der Liste.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "Gibt einen zuf\xe4lligen Wert aus der Liste zur\xfcck.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "Ist die Standardabweichung aller Werte in der Liste.";
    Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "Ist die Summe aller Zahlen in einer Liste.";
    Blockly.Msg["MATH_POWER_SYMBOL"] = "^"; // untranslated
    Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://de.wikipedia.org/wiki/Zufallszahlen";
    Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "Zufallszahl (0.0 - 1.0)";
    Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "Erzeugt eine Zufallszahl zwischen 0.0 (inklusiv) und 1.0 (exklusiv).";
    Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://de.wikipedia.org/wiki/Zufallszahlen";
    Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "ganzzahlige Zufallszahl zwischen %1 und %2";
    Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Erzeugt eine ganzzahlige Zufallszahl zwischen zwei Zahlen (inklusiv).";
    Blockly.Msg["MATH_ROUND_HELPURL"] = "https://de.wikipedia.org/wiki/Runden";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "runde";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "runde ab";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "runde auf";
    Blockly.Msg["MATH_ROUND_TOOLTIP"] = "Eine Zahl auf- oder abrunden.";
    Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://de.wikipedia.org/wiki/Quadratwurzel";
    Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "Betrag";
    Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "Quadratwurzel";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Ist der Betrag einer Zahl.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Ist Wert der Exponentialfunktion einer Zahl.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Ist der nat\xfcrliche Logarithmus einer Zahl.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Ist der dekadische Logarithmus einer Zahl.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Negiert eine Zahl.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Rechnet 10 hoch eine Zahl.";
    Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Ist die Quadratwurzel einer Zahl.";
    Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-"; // untranslated
    Blockly.Msg["MATH_TRIG_ACOS"] = "acos"; // untranslated
    Blockly.Msg["MATH_TRIG_ASIN"] = "asin"; // untranslated
    Blockly.Msg["MATH_TRIG_ATAN"] = "atan"; // untranslated
    Blockly.Msg["MATH_TRIG_COS"] = "cos"; // untranslated
    Blockly.Msg["MATH_TRIG_HELPURL"] = "https://de.wikipedia.org/wiki/Trigonometrie";
    Blockly.Msg["MATH_TRIG_SIN"] = "sin"; // untranslated
    Blockly.Msg["MATH_TRIG_TAN"] = "tan"; // untranslated
    Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "Ist der Arkuskosinus des Eingabewertes.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "Ist der Arkussinus des Eingabewertes.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "Ist der Arkustangens des Eingabewertes.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "Ist der Kosinus des Winkels.";
    Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "Ist der Sinus des Winkels (nicht Radiant).";
    Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "Ist der Tangens des Winkels (nicht Radiant).";
    Blockly.Msg["NEW_COLOUR_VARIABLE"] = "Farbvariable erstellen \u2026";
    Blockly.Msg["NEW_NUMBER_VARIABLE"] = "Zahlenvariable erstellen \u2026";
    Blockly.Msg["NEW_STRING_VARIABLE"] = "Zeichenfolgenvariable erstellen \u2026";
    Blockly.Msg["NEW_VARIABLE"] = "Variable erstellen \u2026";
    Blockly.Msg["NEW_VARIABLE_TITLE"] = "Name der neuen Variable:";
    Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "Neuer Variablentyp:";
    Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = ".";
    Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "Anweisungen erlauben";
    Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "mit:";
    Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://de.wikipedia.org/wiki/Unterprogramm";
    Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Rufe einen Funktionsblock ohne R\xfcckgabewert auf.";
    Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://de.wikipedia.org/wiki/Unterprogramm";
    Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Rufe einen Funktionsblock mit R\xfcckgabewert auf.";
    Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "mit:";
    Blockly.Msg["PROCEDURES_CREATE_DO"] = "Erzeuge \"Aufruf %1\"";
    Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Beschreibe diese Funktion \u2026";
    Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
    Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://de.wikipedia.org/wiki/Prozedur_%28Programmierung%29";
    Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "etwas tun";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "um";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Ein Funktionsblock ohne R\xfcckgabewert.";
    Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://de.wikipedia.org/wiki/Prozedur_%28Programmierung%29";
    Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "gib zur\xfcck";
    Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Ein Funktionsblock mit R\xfcckgabewert.";
    Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Warnung: Dieser Funktionsblock hat zwei gleich benannte Parameter.";
    Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Markiere Funktionsblock";
    Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "http://c2.com/cgi/wiki?GuardClause";
    Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "Gibt den zweiten Wert zur\xfcck und verl\xe4sst die Funktion, falls der erste Wert wahr ist.";
    Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Warnung: Dieser Block darf nur innerhalb eines Funktionsblocks genutzt werden.";
    Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "Variable:";
    Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Eine Eingabe zur Funktion hinzuf\xfcgen.";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "Parameter";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Die Eingaben zu dieser Funktion hinzuf\xfcgen, entfernen oder neu anordnen.";
    Blockly.Msg["REDO"] = "Wiederholen";
    Blockly.Msg["REMOVE_COMMENT"] = "Kommentar entfernen";
    Blockly.Msg["RENAME_VARIABLE"] = "Variable umbenennen \u2026";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Alle \"%1\" Variablen umbenennen in:";
    Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification"; // untranslated
    Blockly.Msg["TEXT_APPEND_TITLE"] = "zu %1 Text %2 anh\xe4ngen";
    Blockly.Msg["TEXT_APPEND_TOOLTIP"] = 'Text an die Variable "%1" anh\xe4ngen.';
    Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case"; // untranslated
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "wandel um in kleinbuchstaben";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "wandel um in Substantive";
    Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "wandel um in GROSSBUCHSTABEN";
    Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "Wandelt Schreibweise von Texten um, in Gro\xdfbuchstaben, Kleinbuchstaben oder den ersten Buchstaben jedes Wortes gro\xdf und die anderen klein.";
    Blockly.Msg["TEXT_CHARAT_FIRST"] = "nimm ersten";
    Blockly.Msg["TEXT_CHARAT_FROM_END"] = "nimm von hinten";
    Blockly.Msg["TEXT_CHARAT_FROM_START"] = "nimm";
    Blockly.Msg["TEXT_CHARAT_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["TEXT_CHARAT_LAST"] = "nimm letzten";
    Blockly.Msg["TEXT_CHARAT_RANDOM"] = "nimm zuf\xe4lligen";
    Blockly.Msg["TEXT_CHARAT_TAIL"] = "Buchstaben";
    Blockly.Msg["TEXT_CHARAT_TITLE"] = "im Text %1 %2";
    Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "Extrahiert einen Buchstaben von einer bestimmten Position.";
    Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings";
    Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "z\xe4hle %1 in %2";
    Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "Z\xe4hle, wie oft ein Text innerhalb eines anderen Textes vorkommt.";
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Ein Element zum Text hinzuf\xfcgen.";
    Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "verbinden";
    Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Hinzuf\xfcgen, entfernen und sortieren von Elementen.";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "bis von hinten";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "bis";
    Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "bis letzter";
    Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "im Text";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "nimm Teil ab erster";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "nimm Teil ab von hinten";
    Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "nimm Teil ab";
    Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = "Buchstabe";
    Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "Gibt den angegebenen Textabschnitt zur\xfcck.";
    Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "http://publib.boulder.ibm.com/infocenter/lnxpcomp/v8v101/index.jsp?topic=%2Fcom.ibm.xlcpp8l.doc%2Flanguage%2Fref%2Farsubex.htm";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "suche erstes Auftreten des Begriffs";
    Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "suche letztes Auftreten des Begriffs";
    Blockly.Msg["TEXT_INDEXOF_TITLE"] = "im Text %1 %2 %3";
    Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "Findet das erste / letzte Auftreten eines Suchbegriffs in einem Text.  Gibt die Position des Begriffs zur\xfcck oder %1 falls der Suchbegriff nicht gefunden wurde.";
    Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text"; // untranslated
    Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1 ist leer";
    Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "Ist wahr, falls der Text keine Zeichen enth\xe4lt.";
    Blockly.Msg["TEXT_JOIN_HELPURL"] = "";
    Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "erstelle Text aus";
    Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Erstellt einen Text durch das Verbinden von mehreren Textelementen.";
    Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification"; // untranslated
    Blockly.Msg["TEXT_LENGTH_TITLE"] = "L\xe4nge von %1";
    Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Die Anzahl von Zeichen in einem Text (inkl. Leerzeichen).";
    Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text"; // untranslated
    Blockly.Msg["TEXT_PRINT_TITLE"] = "gib aus %1";
    Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "Gibt den Text aus.";
    Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user"; // untranslated
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "Fragt den Benutzer nach einer Zahl.";
    Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "Fragt den Benutzer nach einem Text.";
    Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "frage nach Zahl mit Hinweis";
    Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "frage nach Text mit Hinweis";
    Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings";
    Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "ersetze %1 durch %2 in %3";
    Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "Ersetze alle Vorkommen eines Textes innerhalb eines anderen Textes.";
    Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text";
    Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "kehre %1 um";
    Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "Kehre die Reihenfolge der Zeichen im Text um.";
    Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://de.wikipedia.org/wiki/Zeichenkette";
    Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "Ein Buchstabe, Text oder Satz.";
    Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces"; // untranslated
    Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "entferne Leerzeichen vom Anfang und vom Ende (links und rechts)";
    Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "entferne Leerzeichen vom Anfang (links)";
    Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "entferne Leerzeichen vom Ende (rechts)";
    Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "Entfernt Leerzeichen vom Anfang und / oder Ende eines Textes.";
    Blockly.Msg["TODAY"] = "Heute";
    Blockly.Msg["UNDO"] = "R\xfcckg\xe4ngig";
    Blockly.Msg["UNNAMED_KEY"] = "unbenannt";
    Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "Element";
    Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Erzeuge \"Schreibe %1\"";
    Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://de.wikipedia.org/wiki/Variable_%28Programmierung%29";
    Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Gibt den Wert der Variable zur\xfcck.";
    Blockly.Msg["VARIABLES_SET"] = "setze %1 auf %2";
    Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Erzeuge \"Lese %1\"";
    Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://de.wikipedia.org/wiki/Variable_%28Programmierung%29";
    Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Setzt den Wert einer Variable.";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "Eine Variable namens \u201E%1\u201C ist bereits vorhanden.";
    Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "Eine Variable namens \u201E%1\u201C ist bereits f\xfcr einen anderen Typ vorhanden: \u201E%2\u201C.";
    Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Blockly Arbeitsbereich";
    Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Teile etwas mit\u2026";
    Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
    Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
    Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
    Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
    Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
    Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
    Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
    Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
    Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
    Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
    Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
    Blockly.Msg["MATH_HUE"] = "230";
    Blockly.Msg["LOOPS_HUE"] = "120";
    Blockly.Msg["LISTS_HUE"] = "260";
    Blockly.Msg["LOGIC_HUE"] = "210";
    Blockly.Msg["VARIABLES_HUE"] = "330";
    Blockly.Msg["TEXTS_HUE"] = "160";
    Blockly.Msg["PROCEDURES_HUE"] = "290";
    Blockly.Msg["COLOUR_HUE"] = "20";
    Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
    return Blockly.Msg;
});

});

parcelRegister("hFAmA", function(module, exports) {

$parcel$export(module.exports, "BlocklyCustomDE", function () { return $cdd278fad9ba7036$export$6771de0d50814132; });
const $cdd278fad9ba7036$export$6771de0d50814132 = {
    UNDO: "\u21B6 R\xfcckg\xe4ngig",
    REDO: "\u21B7 Wiederholen",
    CLEAN_UP: "\u2833 Aufr\xe4umen",
    DELETE_BLOCK: "\u2298 L\xf6schen",
    DELETE_X_BLOCKS: "\u2298 L\xf6sche %1 Bl\xf6cke",
    LOAD: "\uD83E\uDC45 Programm laden",
    SAVE: "\uD83E\uDC47 Programm speichern",
    CODE_EXPORT: "\u2756 Code exportieren",
    INLINE_INPUTS: "\u25EB Horizontal anordnen",
    EXTERNAL_INPUTS: "\u229F Vertikal anordnen",
    DUPLICATE_BLOCK: "\uA698 Klonen",
    ADD_COMMENT: "\u270E Kommentar",
    REMOVE_COMMENT: "\uD83D\uDFA9 Kommentar l\xf6schen",
    COLLAPSE_BLOCK: "\u25F2 Reduzieren",
    EXPAND_BLOCK: "\u29C9 Erweitern",
    DISABLE_BLOCK: "\uD83D\uDDF2 Deaktivieren",
    ENABLE_BLOCK: "\uD83D\uDDF2 Aktivieren",
    EXEC_ERROR: "Programmfehler",
    EXEC_SUCCESS: "Programm abgeschlossen",
    EMPTY_PROGRAM: "Leeres Programm",
    SEE_CONSOLE: "Weitere Details in der Browser-Konsole.",
    ROCKSI_CATEGORY_MOVE: "Bewegung",
    ROCKSI_CATEGORY_OBJECTS: "Objekte",
    ROCKSI_CATEGORY_LOGIC: "Logik",
    ROCKSI_CATEGORY_EXTRAS: "Extras",
    ROCKSI_CATEGORY_EXAMPLES: "Beispiele",
    ROCKSI_BLOCK_MOVE: "Bewegung %1",
    ROCKSI_BLOCK_MOVE_TOOLTIP: "F\xfcge rechts eine Joint oder Task Space Pose hinzu, zu der sich der Roboter bewegen soll",
    ROCKSI_BLOCK_DEFAULTPOSE: "Startpose",
    ROCKSI_BLOCK_DEFAULTPOSE_TOOLTIP: "Die Standard-Pose des Roboters",
    ROCKSI_BLOCK_JOINTSPACEPOSE_TOOLTIP: "Eine Pose im Gelenkwinkelraum (ein Winkel pro Gelenk beginnend an der Basis)",
    ROCKSI_BLOCK_TASKSPACEPOSE_TOOLTIP: "Eine Pose im Arbeitsraum (Position und Orientierung im Raum)",
    ROCKSI_BLOCK_JOINTABSOLUTE: "Gelenkwinkel (absolut) %1 %2",
    ROCKSI_BLOCK_JOINTABSOLUTE_TOOLTIP: "Bewege ein einzelnes Gelenk in eine bestimmte Position",
    ROCKSI_BLOCK_JOINTRELATIVE: "Gelenkwinkel (relativ) %1 %2",
    ROCKSI_BLOCK_JOINTRELATIVE_TOOLTIP: "Drehe ein einzelnes Gelenk um den angegebenen Winkel",
    ROCKSI_BLOCK_GRIPPEROPEN: "Greifer \xf6ffnen",
    ROCKSI_BLOCK_GRIPPEROPEN_TOOLTIP: "\xd6ffnet den Greifer auf volle Weite",
    ROCKSI_BLOCK_GRIPPERCLOSE: "Greifer schlie\xdfen",
    ROCKSI_BLOCK_GRIPPERCLOSE_TOOLTIP: "Schlie\xdft den Greifer vollst\xe4ndig",
    ROCKSI_BLOCK_SIMOBJECT: "Platziere einen %1",
    ROCKSI_BLOCK_SIMOBJECT_CUBE: "W\xfcrfel",
    ROCKSI_BLOCK_SIMOBJECT_SPHERE: "Kugel",
    ROCKSI_BLOCK_SIMOBJECT_ROCK: "Stein",
    ROCKSI_BLOCK_SIMOBJECT_SHAFT: "Welle",
    ROCKSI_BLOCK_SIMOBJECT_CUSTOM: "Eigenes Objekt...",
    ROCKSI_BLOCK_SIMOBJECT_COLOR: "in der Farbe %1",
    ROCKSI_BLOCK_SIMOBJECT_POSITION: "an Position %1",
    ROCKSI_BLOCK_SIMOBJECT_SCALE: "in der Skalierung %1",
    ROCKSI_BLOCK_SIMOBJECT_TOOLTIP: "F\xfcgt ein Objekt hinzu, dass der Roboter greifen kann",
    ROCKSI_BLOCK_PHYSICSDONE: "Physiksimulation abgeschlossen?",
    ROCKSI_BLOCK_PHYSICSDONE_TOOLTIP: "Gibt Wahr zur\xfcck sobald sich kein Objekt mehr bewegt (ausgeschlossen der Roboter)",
    ROCKSI_BLOCK_HOLDING: "Gegriffen?",
    ROCKSI_BLOCK_HOLDING_TOOLTIP: "Gibt Wahr zur\xfcck wenn der Roboter etwas gegriffen hat",
    ROCKSI_BLOCK_COMMENT: "Kommentar %1",
    ROCKSI_BLOCK_COMMENT_TOOLTIP: "Kommentar, hat keine Auswirkungen",
    ROCKSI_BLOCK_WAIT: "Warte %1 Sekunden",
    ROCKSI_BLOCK_WAIT_TOOLTIP: "Warte eine bestimmte Zeit, bevor der n\xe4chste Block ausgef\xfchrt wird",
    ROCKSI_BLOCK_SETSPEED: "Geschwindigkeit %1 %2 %%",
    ROCKSI_BLOCK_SETSPEED_MOVE: "Bewegung",
    ROCKSI_BLOCK_SETSPEED_GRIPPER: "Greifer",
    ROCKSI_BLOCK_SETSPEED_TOOLTIP: "\xc4ndere die Bewegungsgeschwindigkeit des Roboters",
    ROCKSI_BLOCK_JOINTLOCK: "Sperre %1",
    ROCKSI_BLOCK_JOINTLOCK_TOOLTIP: "Verhindert \xc4nderungen des Gelenkwinkels f\xfcr das gew\xe4hlte Gelenk",
    ROCKSI_BLOCK_JOINTUNLOCK: "Entsperre %1",
    ROCKSI_BLOCK_JOINTUNLOCK_TOOLTIP: "Erlaubt \xc4nderungen des Gelenkwinkels f\xfcr das gew\xe4hlte Gelenk",
    ROCKSI_BLOCK_SCALE: "%1",
    ROCKSI_BLOCK_SCALE_TOOLTIP: "Ein Faktor",
    ROCKSI_EXAMPLE_PICK_N_PLACE: "Pick & Place: ein Objekt aufheben und loslassen",
    ROCKSI_EXAMPLE_PICK_N_PLACE_COMMENT_1: "Eine Gelenkwinkelpose ist immer zuverl\xe4ssiger!"
};

});

parcelRegister("ex1TO", function(module, exports) {

$parcel$export(module.exports, "BlocklyCustomEN", function () { return $a9459ee12eacbebd$export$5869a636cf6acbf8; });
const $a9459ee12eacbebd$export$5869a636cf6acbf8 = {
    UNDO: "\u21B6 Undo",
    REDO: "\u21B7 Redo",
    CLEAN_UP: "\u2833 Clean Up",
    DELETE_BLOCK: "\u2298 Delete",
    DELETE_X_BLOCKS: "\u2298 Delete %1 blocks",
    LOAD: "\uD83E\uDC45 Load program...",
    SAVE: "\uD83E\uDC47 Save program...",
    CODE_EXPORT: "\u2756 Export code...",
    INLINE_INPUTS: "\u25EB Arrange horizontal",
    EXTERNAL_INPUTS: "\u229F Arrange vertical",
    DUPLICATE_BLOCK: "\uA698 Clone",
    ADD_COMMENT: "\u270E Comment",
    REMOVE_COMMENT: "\uD83D\uDFA9 Delete comment",
    COLLAPSE_BLOCK: "\u25F2 Reduce",
    EXPAND_BLOCK: "\u29C9 Expand",
    DISABLE_BLOCK: "\uD83D\uDDF2 Deactivate",
    ENABLE_BLOCK: "\uD83D\uDDF2 Activate",
    EXEC_ERROR: "Program exception",
    EXEC_SUCCESS: "Program finished",
    EMPTY_PROGRAM: "Empty program",
    SEE_CONSOLE: "Please find additional details in the browser console.",
    ROCKSI_CATEGORY_MOVE: "Moving",
    ROCKSI_CATEGORY_OBJECTS: "Objects",
    ROCKSI_CATEGORY_LOGIC: "Logic",
    ROCKSI_CATEGORY_EXTRAS: "Extras",
    ROCKSI_CATEGORY_EXAMPLES: "Examples",
    ROCKSI_BLOCK_MOVE: "Move %1",
    ROCKSI_BLOCK_MOVE_TOOLTIP: "Connect to a joint or task space pose to make the robot move there",
    ROCKSI_BLOCK_DEFAULTPOSE: "Initial pose",
    ROCKSI_BLOCK_DEFAULTPOSE_TOOLTIP: "Initial pose of the robot",
    ROCKSI_BLOCK_JOINTSPACEPOSE_TOOLTIP: "A joint space pose, i.e. one angle per joint starting from the base",
    ROCKSI_BLOCK_TASKSPACEPOSE_TOOLTIP: "A task space pose, i.e. a position and orientation in space",
    ROCKSI_BLOCK_JOINTABSOLUTE: "Joint angle (absolute) %1 %2",
    ROCKSI_BLOCK_JOINTABSOLUTE_TOOLTIP: "Move a single joint to a set angle",
    ROCKSI_BLOCK_JOINTRELATIVE: "Joint angle (relative) %1 %2",
    ROCKSI_BLOCK_JOINTRELATIVE_TOOLTIP: "Move a single joint by a given amount",
    ROCKSI_BLOCK_GRIPPEROPEN: "Gripper open",
    ROCKSI_BLOCK_GRIPPEROPEN_TOOLTIP: "Opens the gripper to its full width",
    ROCKSI_BLOCK_GRIPPERCLOSE: "Gripper close",
    ROCKSI_BLOCK_GRIPPERCLOSE_TOOLTIP: "Completely closes the gripper",
    ROCKSI_BLOCK_SIMOBJECT: "Place a %1",
    ROCKSI_BLOCK_SIMOBJECT_CUBE: "Cube",
    ROCKSI_BLOCK_SIMOBJECT_SPHERE: "Sphere",
    ROCKSI_BLOCK_SIMOBJECT_ROCK: "Rock",
    ROCKSI_BLOCK_SIMOBJECT_SHAFT: "Shaft",
    ROCKSI_BLOCK_SIMOBJECT_CUSTOM: "Custom object...",
    ROCKSI_BLOCK_SIMOBJECT_COLOR: "with color %1",
    ROCKSI_BLOCK_SIMOBJECT_POSITION: "at position %1",
    ROCKSI_BLOCK_SIMOBJECT_SCALE: "scaled by %1",
    ROCKSI_BLOCK_SIMOBJECT_TOOLTIP: "Adds an object to the scene that can be grabbed by the robot",
    ROCKSI_BLOCK_PHYSICSDONE: "Physics simulation done?",
    ROCKSI_BLOCK_PHYSICSDONE_TOOLTIP: "Returns true once all objects stopped moving (not considering the robot)",
    ROCKSI_BLOCK_HOLDING: "Holding?",
    ROCKSI_BLOCK_HOLDING_TOOLTIP: "Returns true if the robot is holding an object",
    ROCKSI_BLOCK_COMMENT: "Comment %1",
    ROCKSI_BLOCK_COMMENT_TOOLTIP: "Comment, ignored during execution",
    ROCKSI_BLOCK_WAIT: "Wait %1 seconds",
    ROCKSI_BLOCK_WAIT_TOOLTIP: "Waits some time before executing the next block",
    ROCKSI_BLOCK_SETSPEED: "Set speed of %1 to %2 %%",
    ROCKSI_BLOCK_SETSPEED_MOVE: "Moving",
    ROCKSI_BLOCK_SETSPEED_GRIPPER: "Grasping",
    ROCKSI_BLOCK_SETSPEED_TOOLTIP: "Changes the speed at which the robot moves",
    ROCKSI_BLOCK_JOINTLOCK: "Lock %1",
    ROCKSI_BLOCK_JOINTLOCK_TOOLTIP: "Prevents a joint from moving during program execution",
    ROCKSI_BLOCK_JOINTUNLOCK: "Unlock %1",
    ROCKSI_BLOCK_JOINTUNLOCK_TOOLTIP: "Allows a joint to move again during program execution",
    ROCKSI_BLOCK_SCALE: "%1",
    ROCKSI_BLOCK_SCALE_TOOLTIP: "A factor",
    ROCKSI_EXAMPLE_PICK_N_PLACE: "Pick & Place: picking up and letting go of an object",
    ROCKSI_EXAMPLE_PICK_N_PLACE_COMMENT_1: "Jointspace poses will always be more reliable!"
};

});

parcelRegister("kw6y2", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(this, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/js-interpreter.js");
    /******/ }({
        /***/ "./node_modules/vm-browserify/index.js": /*!*********************************************!*\
  !*** ./node_modules/vm-browserify/index.js ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var indexOf = function(xs, item) {
                if (xs.indexOf) return xs.indexOf(item);
                else for(var i = 0; i < xs.length; i++){
                    if (xs[i] === item) return i;
                }
                return -1;
            };
            var Object_keys = function(obj) {
                if (Object.keys) return Object.keys(obj);
                else {
                    var res = [];
                    for(var key in obj)res.push(key);
                    return res;
                }
            };
            var forEach = function(xs, fn) {
                if (xs.forEach) return xs.forEach(fn);
                else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
            };
            var defineProp = function() {
                try {
                    Object.defineProperty({}, '_', {});
                    return function(obj, name, value) {
                        Object.defineProperty(obj, name, {
                            writable: true,
                            enumerable: false,
                            configurable: true,
                            value: value
                        });
                    };
                } catch (e) {
                    return function(obj, name, value) {
                        obj[name] = value;
                    };
                }
            }();
            var globals = [
                'Array',
                'Boolean',
                'Date',
                'Error',
                'EvalError',
                'Function',
                'Infinity',
                'JSON',
                'Math',
                'NaN',
                'Number',
                'Object',
                'RangeError',
                'ReferenceError',
                'RegExp',
                'String',
                'SyntaxError',
                'TypeError',
                'URIError',
                'decodeURI',
                'decodeURIComponent',
                'encodeURI',
                'encodeURIComponent',
                'escape',
                'eval',
                'isFinite',
                'isNaN',
                'parseFloat',
                'parseInt',
                'undefined',
                'unescape'
            ];
            function Context() {}
            Context.prototype = {};
            var Script = exports.Script = function NodeScript(code) {
                if (!(this instanceof Script)) return new Script(code);
                this.code = code;
            };
            Script.prototype.runInContext = function(context) {
                if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
                var iframe = document.createElement('iframe');
                if (!iframe.style) iframe.style = {};
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                var win = iframe.contentWindow;
                var wEval = win.eval, wExecScript = win.execScript;
                if (!wEval && wExecScript) {
                    // win.eval() magically appears when this is called in IE:
                    wExecScript.call(win, 'null');
                    wEval = win.eval;
                }
                forEach(Object_keys(context), function(key) {
                    win[key] = context[key];
                });
                forEach(globals, function(key) {
                    if (context[key]) win[key] = context[key];
                });
                var winKeys = Object_keys(win);
                var res = wEval.call(win, this.code);
                forEach(Object_keys(win), function(key) {
                    // Avoid copying circular objects like `top` and `window` by only
                    // updating existing context properties or new properties in the `win`
                    // that was only introduced after the eval.
                    if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
                });
                forEach(globals, function(key) {
                    if (!(key in context)) defineProp(context, key, win[key]);
                });
                document.body.removeChild(iframe);
                return res;
            };
            Script.prototype.runInThisContext = function() {
                return eval(this.code); // maybe...
            };
            Script.prototype.runInNewContext = function(context) {
                var ctx = Script.createContext(context);
                var res = this.runInContext(ctx);
                if (context) forEach(Object_keys(ctx), function(key) {
                    context[key] = ctx[key];
                });
                return res;
            };
            forEach(Object_keys(Script.prototype), function(name) {
                exports[name] = Script[name] = function(code) {
                    var s = Script(code);
                    return s[name].apply(s, [].slice.call(arguments, 1));
                };
            });
            exports.isContext = function(context) {
                return context instanceof Context;
            };
            exports.createScript = function(code) {
                return exports.Script(code);
            };
            exports.createContext = Script.createContext = function(context) {
                var copy = new Context();
                if (typeof context === 'object') forEach(Object_keys(context), function(key) {
                    copy[key] = context[key];
                });
                return copy;
            };
        /***/ },
        /***/ "./original-repo/acorn.js": /*!********************************!*\
  !*** ./original-repo/acorn.js ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Acorn is a tiny, fast JavaScript parser written in JavaScript.
            //
            // Acorn was written by Marijn Haverbeke and released under an MIT
            // license. The Unicode regexps (for identifiers and whitespace) were
            // taken from [Esprima](http://esprima.org) by Ariya Hidayat.
            //
            // Git repositories for Acorn are available at
            //
            //     http://marijnhaverbeke.nl/git/acorn
            //     https://github.com/marijnh/acorn.git
            //
            // Please use the [github bug tracker][ghbt] to report issues.
            //
            // [ghbt]: https://github.com/marijnh/acorn/issues
            //
            // This file defines the main parser interface. The library also comes
            // with a [error-tolerant parser][dammit] and an
            // [abstract syntax tree walker][walk], defined in other files.
            //
            // [dammit]: acorn_loose.js
            // [walk]: util/walk.js
            (function(root, mod) {
                return mod(exports); // CommonJS
            })(this, function(exports) {
                "use strict";
                exports.version = "0.4.1";
                // The main exported interface (under `self.acorn` when in the
                // browser) is a `parse` function that takes a code string and
                // returns an abstract syntax tree as specified by [Mozilla parser
                // API][api], with the caveat that the SpiderMonkey-specific syntax
                // (`let`, `yield`, inline XML, etc) is not recognized.
                //
                // [api]: https://developer.mozilla.org/en-US/docs/SpiderMonkey/Parser_API
                var options, input, inputLen, sourceFile;
                exports.parse = function(inpt, opts) {
                    input = String(inpt);
                    inputLen = input.length;
                    setOptions(opts);
                    initTokenState();
                    return parseTopLevel(options.program);
                };
                // A second optional argument can be given to further configure
                // the parser process. These options are recognized:
                var defaultOptions = exports.defaultOptions = {
                    // `ecmaVersion` indicates the ECMAScript version to parse. Must
                    // be either 3 or 5. This
                    // influences support for strict mode, the set of reserved words, and
                    // support for getters and setter.
                    ecmaVersion: 5,
                    // Turn on `strictSemicolons` to prevent the parser from doing
                    // automatic semicolon insertion.
                    strictSemicolons: false,
                    // When `allowTrailingCommas` is false, the parser will not allow
                    // trailing commas in array and object literals.
                    allowTrailingCommas: true,
                    // By default, reserved words are not enforced. Enable
                    // `forbidReserved` to enforce them.
                    forbidReserved: false,
                    // When `locations` is on, `loc` properties holding objects with
                    // `start` and `end` properties in `{line, column}` form (with
                    // line being 1-based and column 0-based) will be attached to the
                    // nodes.
                    locations: false,
                    // A function can be passed as `onComment` option, which will
                    // cause Acorn to call that function with `(block, text, start,
                    // end)` parameters whenever a comment is skipped. `block` is a
                    // boolean indicating whether this is a block (`/* */`) comment,
                    // `text` is the content of the comment, and `start` and `end` are
                    // character offsets that denote the start and end of the comment.
                    // When the `locations` option is on, two more parameters are
                    // passed, the full `{line, column}` locations of the start and
                    // end of the comments.
                    onComment: null,
                    // Nodes have their start and end characters offsets recorded in
                    // `start` and `end` properties (directly on the node, rather than
                    // the `loc` object, which holds line/column data. To also add a
                    // [semi-standardized][range] `range` property holding a `[start,
                    // end]` array with the same numbers, set the `ranges` option to
                    // `true`.
                    //
                    // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
                    ranges: false,
                    // It is possible to parse multiple files into a single AST by
                    // passing the tree produced by parsing the first file as
                    // `program` option in subsequent parses. This will add the
                    // toplevel forms of the parsed file to the `Program` (top) node
                    // of an existing parse tree.
                    program: null,
                    // When `location` is on, you can pass this to record the source
                    // file in every node's `loc` object.
                    sourceFile: null,
                    // This value, if given, is stored in every node, whether
                    // `location` is on or off.
                    directSourceFile: null
                };
                function setOptions(opts) {
                    options = opts || {};
                    for(var opt in defaultOptions)if (!Object.prototype.hasOwnProperty.call(options, opt)) options[opt] = defaultOptions[opt];
                    sourceFile = options.sourceFile || null;
                }
                // The `getLineInfo` function is mostly useful when the
                // `locations` option is off (for performance reasons) and you
                // want to find the line/column position for a given character
                // offset. `input` should be the code string that the offset refers
                // into.
                var getLineInfo = exports.getLineInfo = function(input, offset) {
                    for(var line = 1, cur = 0;;){
                        lineBreak.lastIndex = cur;
                        var match = lineBreak.exec(input);
                        if (match && match.index < offset) {
                            ++line;
                            cur = match.index + match[0].length;
                        } else break;
                    }
                    return {
                        line: line,
                        column: offset - cur
                    };
                };
                // Acorn is organized as a tokenizer and a recursive-descent parser.
                // The `tokenize` export provides an interface to the tokenizer.
                // Because the tokenizer is optimized for being efficiently used by
                // the Acorn parser itself, this interface is somewhat crude and not
                // very modular. Performing another parse or call to `tokenize` will
                // reset the internal state, and invalidate existing tokenizers.
                exports.tokenize = function(inpt, opts) {
                    input = String(inpt);
                    inputLen = input.length;
                    setOptions(opts);
                    initTokenState();
                    var t = {};
                    function getToken(forceRegexp) {
                        readToken(forceRegexp);
                        t.start = tokStart;
                        t.end = tokEnd;
                        t.startLoc = tokStartLoc;
                        t.endLoc = tokEndLoc;
                        t.type = tokType;
                        t.value = tokVal;
                        return t;
                    }
                    getToken.jumpTo = function(pos, reAllowed) {
                        tokPos = pos;
                        if (options.locations) {
                            tokCurLine = 1;
                            tokLineStart = lineBreak.lastIndex = 0;
                            var match;
                            while((match = lineBreak.exec(input)) && match.index < pos){
                                ++tokCurLine;
                                tokLineStart = match.index + match[0].length;
                            }
                        }
                        tokRegexpAllowed = reAllowed;
                        skipSpace();
                    };
                    return getToken;
                };
                // State is kept in (closure-)global variables. We already saw the
                // `options`, `input`, and `inputLen` variables above.
                // The current position of the tokenizer in the input.
                var tokPos;
                // The start and end offsets of the current token.
                var tokStart, tokEnd;
                // When `options.locations` is true, these hold objects
                // containing the tokens start and end line/column pairs.
                var tokStartLoc, tokEndLoc;
                // The type and value of the current token. Token types are objects,
                // named by variables against which they can be compared, and
                // holding properties that describe them (indicating, for example,
                // the precedence of an infix operator, and the original name of a
                // keyword token). The kind of value that's held in `tokVal` depends
                // on the type of the token. For literals, it is the literal value,
                // for operators, the operator name, and so on.
                var tokType, tokVal;
                // Interal state for the tokenizer. To distinguish between division
                // operators and regular expressions, it remembers whether the last
                // token was one that is allowed to be followed by an expression.
                // (If it is, a slash is probably a regexp, if it isn't it's a
                // division operator. See the `parseStatement` function for a
                // caveat.)
                var tokRegexpAllowed;
                // When `options.locations` is true, these are used to keep
                // track of the current line, and know when a new line has been
                // entered.
                var tokCurLine, tokLineStart;
                // These store the position of the previous token, which is useful
                // when finishing a node and assigning its `end` position.
                var lastStart, lastEnd, lastEndLoc;
                // This is the parser's state. `inFunction` is used to reject
                // `return` statements outside of functions, `labels` to verify that
                // `break` and `continue` have somewhere to jump to, and `strict`
                // indicates whether strict mode is on.
                var inFunction, labels, strict;
                // This function is used to raise exceptions on parse errors. It
                // takes an offset integer (into the current `input`) to indicate
                // the location of the error, attaches the position to the end
                // of the error message, and then raises a `SyntaxError` with that
                // message.
                function raise(pos, message) {
                    var loc = getLineInfo(input, pos);
                    message += " (" + loc.line + ":" + loc.column + ")";
                    var err = new SyntaxError(message);
                    err.pos = pos;
                    err.loc = loc;
                    err.raisedAt = tokPos;
                    throw err;
                }
                // Reused empty array added for node fields that are always empty.
                var empty = [];
                // ## Token types
                // The assignment of fine-grained, information-carrying type objects
                // allows the tokenizer to store the information it has about a
                // token in a way that is very cheap for the parser to look up.
                // All token type variables start with an underscore, to make them
                // easy to recognize.
                // These are the general types. The `type` property is only used to
                // make them recognizeable when debugging.
                var _num = {
                    type: "num"
                }, _regexp = {
                    type: "regexp"
                }, _string = {
                    type: "string"
                };
                var _name = {
                    type: "name"
                }, _eof = {
                    type: "eof"
                };
                // Keyword tokens. The `keyword` property (also used in keyword-like
                // operators) indicates that the token originated from an
                // identifier-like word, which is used when parsing property names.
                //
                // The `beforeExpr` property is used to disambiguate between regular
                // expressions and divisions. It is set on all token types that can
                // be followed by an expression (thus, a slash after them would be a
                // regular expression).
                //
                // `isLoop` marks a keyword as starting a loop, which is important
                // to know when parsing a label, in order to allow or disallow
                // continue jumps to that label.
                var _break = {
                    keyword: "break"
                }, _case = {
                    keyword: "case",
                    beforeExpr: true
                }, _catch = {
                    keyword: "catch"
                };
                var _continue = {
                    keyword: "continue"
                }, _debugger = {
                    keyword: "debugger"
                }, _default = {
                    keyword: "default"
                };
                var _do = {
                    keyword: "do",
                    isLoop: true
                }, _else = {
                    keyword: "else",
                    beforeExpr: true
                };
                var _finally = {
                    keyword: "finally"
                }, _for = {
                    keyword: "for",
                    isLoop: true
                }, _function = {
                    keyword: "function"
                };
                var _if = {
                    keyword: "if"
                }, _return = {
                    keyword: "return",
                    beforeExpr: true
                }, _switch = {
                    keyword: "switch"
                };
                var _throw = {
                    keyword: "throw",
                    beforeExpr: true
                }, _try = {
                    keyword: "try"
                }, _var = {
                    keyword: "var"
                };
                var _while = {
                    keyword: "while",
                    isLoop: true
                }, _with = {
                    keyword: "with"
                }, _new = {
                    keyword: "new",
                    beforeExpr: true
                };
                var _this = {
                    keyword: "this"
                };
                // The keywords that denote values.
                var _null = {
                    keyword: "null",
                    atomValue: null
                }, _true = {
                    keyword: "true",
                    atomValue: true
                };
                var _false = {
                    keyword: "false",
                    atomValue: false
                };
                // Some keywords are treated as regular operators. `in` sometimes
                // (when parsing `for`) needs to be tested against specifically, so
                // we assign a variable name to it for quick comparing.
                var _in = {
                    keyword: "in",
                    binop: 7,
                    beforeExpr: true
                };
                // Map keyword names to token types.
                var keywordTypes = {
                    "break": _break,
                    "case": _case,
                    "catch": _catch,
                    "continue": _continue,
                    "debugger": _debugger,
                    "default": _default,
                    "do": _do,
                    "else": _else,
                    "finally": _finally,
                    "for": _for,
                    "function": _function,
                    "if": _if,
                    "return": _return,
                    "switch": _switch,
                    "throw": _throw,
                    "try": _try,
                    "var": _var,
                    "while": _while,
                    "with": _with,
                    "null": _null,
                    "true": _true,
                    "false": _false,
                    "new": _new,
                    "in": _in,
                    "instanceof": {
                        keyword: "instanceof",
                        binop: 7,
                        beforeExpr: true
                    },
                    "this": _this,
                    "typeof": {
                        keyword: "typeof",
                        prefix: true,
                        beforeExpr: true
                    },
                    "void": {
                        keyword: "void",
                        prefix: true,
                        beforeExpr: true
                    },
                    "delete": {
                        keyword: "delete",
                        prefix: true,
                        beforeExpr: true
                    }
                };
                // Punctuation token types. Again, the `type` property is purely for debugging.
                var _bracketL = {
                    type: "[",
                    beforeExpr: true
                }, _bracketR = {
                    type: "]"
                }, _braceL = {
                    type: "{",
                    beforeExpr: true
                };
                var _braceR = {
                    type: "}"
                }, _parenL = {
                    type: "(",
                    beforeExpr: true
                }, _parenR = {
                    type: ")"
                };
                var _comma = {
                    type: ",",
                    beforeExpr: true
                }, _semi = {
                    type: ";",
                    beforeExpr: true
                };
                var _colon = {
                    type: ":",
                    beforeExpr: true
                }, _dot = {
                    type: "."
                }, _question = {
                    type: "?",
                    beforeExpr: true
                };
                // Operators. These carry several kinds of properties to help the
                // parser use them properly (the presence of these properties is
                // what categorizes them as operators).
                //
                // `binop`, when present, specifies that this operator is a binary
                // operator, and will refer to its precedence.
                //
                // `prefix` and `postfix` mark the operator as a prefix or postfix
                // unary operator. `isUpdate` specifies that the node produced by
                // the operator should be of type UpdateExpression rather than
                // simply UnaryExpression (`++` and `--`).
                //
                // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
                // binary operators with a very low precedence, that should result
                // in AssignmentExpression nodes.
                var _slash = {
                    binop: 10,
                    beforeExpr: true
                }, _eq = {
                    isAssign: true,
                    beforeExpr: true
                };
                var _assign = {
                    isAssign: true,
                    beforeExpr: true
                };
                var _incDec = {
                    postfix: true,
                    prefix: true,
                    isUpdate: true
                }, _prefix = {
                    prefix: true,
                    beforeExpr: true
                };
                var _logicalOR = {
                    binop: 1,
                    beforeExpr: true
                };
                var _logicalAND = {
                    binop: 2,
                    beforeExpr: true
                };
                var _bitwiseOR = {
                    binop: 3,
                    beforeExpr: true
                };
                var _bitwiseXOR = {
                    binop: 4,
                    beforeExpr: true
                };
                var _bitwiseAND = {
                    binop: 5,
                    beforeExpr: true
                };
                var _equality = {
                    binop: 6,
                    beforeExpr: true
                };
                var _relational = {
                    binop: 7,
                    beforeExpr: true
                };
                var _bitShift = {
                    binop: 8,
                    beforeExpr: true
                };
                var _plusMin = {
                    binop: 9,
                    prefix: true,
                    beforeExpr: true
                };
                var _multiplyModulo = {
                    binop: 10,
                    beforeExpr: true
                };
                // Provide access to the token types for external users of the
                // tokenizer.
                exports.tokTypes = {
                    bracketL: _bracketL,
                    bracketR: _bracketR,
                    braceL: _braceL,
                    braceR: _braceR,
                    parenL: _parenL,
                    parenR: _parenR,
                    comma: _comma,
                    semi: _semi,
                    colon: _colon,
                    dot: _dot,
                    question: _question,
                    slash: _slash,
                    eq: _eq,
                    name: _name,
                    eof: _eof,
                    num: _num,
                    regexp: _regexp,
                    string: _string
                };
                for(var kw in keywordTypes)exports.tokTypes["_" + kw] = keywordTypes[kw];
                // This is a trick taken from Esprima. It turns out that, on
                // non-Chrome browsers, to check whether a string is in a set, a
                // predicate containing a big ugly `switch` statement is faster than
                // a regular expression, and on Chrome the two are about on par.
                // This function uses `eval` (non-lexical) to produce such a
                // predicate from a space-separated string of words.
                //
                // It starts by sorting the words by length.
                function makePredicate(words) {
                    words = words.split(" ");
                    var f = "", cats = [];
                    out: for(var i = 0; i < words.length; ++i){
                        for(var j = 0; j < cats.length; ++j)if (cats[j][0].length == words[i].length) {
                            cats[j].push(words[i]);
                            continue out;
                        }
                        cats.push([
                            words[i]
                        ]);
                    }
                    function compareTo(arr) {
                        if (arr.length == 1) return f += "return str === " + JSON.stringify(arr[0]) + ";";
                        f += "switch(str){";
                        for(var i = 0; i < arr.length; ++i)f += "case " + JSON.stringify(arr[i]) + ":";
                        f += "return true}return false;";
                    }
                    // When there are more than three length categories, an outer
                    // switch first dispatches on the lengths, to save on comparisons.
                    if (cats.length > 3) {
                        cats.sort(function(a, b) {
                            return b.length - a.length;
                        });
                        f += "switch(str.length){";
                        for(var i = 0; i < cats.length; ++i){
                            var cat = cats[i];
                            f += "case " + cat[0].length + ":";
                            compareTo(cat);
                        }
                        f += "}";
                    // Otherwise, simply generate a flat `switch` statement.
                    } else compareTo(words);
                    return new Function("str", f);
                }
                // The ECMAScript 3 reserved word list.
                var isReservedWord3 = makePredicate("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile");
                // ECMAScript 5 reserved words.
                var isReservedWord5 = makePredicate("class enum extends super const export import");
                // The additional reserved words in strict mode.
                var isStrictReservedWord = makePredicate("implements interface let package private protected public static yield");
                // The forbidden variable names in strict mode.
                var isStrictBadIdWord = makePredicate("eval arguments");
                // And the keywords.
                var isKeyword = makePredicate("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this");
                // ## Character categories
                // Big ugly regular expressions that match characters in the
                // whitespace, identifier, and identifier-start categories. These
                // are only applied when a character is found to actually have a
                // code point above 128.
                var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
                var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
                var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
                var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
                var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
                // Whether a single character denotes a newline.
                var newline = /[\n\r\u2028\u2029]/;
                // Matches a whole line break (where CRLF is considered a single
                // line break). Used to count lines.
                var lineBreak = /\r\n|[\n\r\u2028\u2029]/g;
                // Test whether a given character code starts an identifier.
                var isIdentifierStart = exports.isIdentifierStart = function(code) {
                    if (code < 65) return code === 36;
                    if (code < 91) return true;
                    if (code < 97) return code === 95;
                    if (code < 123) return true;
                    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
                };
                // Test whether a given character is part of an identifier.
                var isIdentifierChar = exports.isIdentifierChar = function(code) {
                    if (code < 48) return code === 36;
                    if (code < 58) return true;
                    if (code < 65) return false;
                    if (code < 91) return true;
                    if (code < 97) return code === 95;
                    if (code < 123) return true;
                    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
                };
                // ## Tokenizer
                // These are used when `options.locations` is on, for the
                // `tokStartLoc` and `tokEndLoc` properties.
                function line_loc_t() {
                    this.line = tokCurLine;
                    this.column = tokPos - tokLineStart;
                }
                // Reset the token state. Used at the start of a parse.
                function initTokenState() {
                    tokCurLine = 1;
                    tokPos = tokLineStart = 0;
                    tokRegexpAllowed = true;
                    skipSpace();
                }
                // Called at the end of every token. Sets `tokEnd`, `tokVal`, and
                // `tokRegexpAllowed`, and skips the space after the token, so that
                // the next one's `tokStart` will point at the right position.
                function finishToken(type, val) {
                    tokEnd = tokPos;
                    if (options.locations) tokEndLoc = new line_loc_t;
                    tokType = type;
                    skipSpace();
                    tokVal = val;
                    tokRegexpAllowed = type.beforeExpr;
                }
                function skipBlockComment() {
                    var startLoc = options.onComment && options.locations && new line_loc_t;
                    var start = tokPos, end = input.indexOf("*/", tokPos += 2);
                    if (end === -1) raise(tokPos - 2, "Unterminated comment");
                    tokPos = end + 2;
                    if (options.locations) {
                        lineBreak.lastIndex = start;
                        var match;
                        while((match = lineBreak.exec(input)) && match.index < tokPos){
                            ++tokCurLine;
                            tokLineStart = match.index + match[0].length;
                        }
                    }
                    if (options.onComment) options.onComment(true, input.slice(start + 2, end), start, tokPos, startLoc, options.locations && new line_loc_t);
                }
                function skipLineComment() {
                    var start = tokPos;
                    var startLoc = options.onComment && options.locations && new line_loc_t;
                    var ch = input.charCodeAt(tokPos += 2);
                    while(tokPos < inputLen && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233){
                        ++tokPos;
                        ch = input.charCodeAt(tokPos);
                    }
                    if (options.onComment) options.onComment(false, input.slice(start + 2, tokPos), start, tokPos, startLoc, options.locations && new line_loc_t);
                }
                // Called at the start of the parse and after every token. Skips
                // whitespace and comments, and.
                function skipSpace() {
                    while(tokPos < inputLen){
                        var ch = input.charCodeAt(tokPos);
                        if (ch === 32) ++tokPos;
                        else if (ch === 13) {
                            ++tokPos;
                            var next = input.charCodeAt(tokPos);
                            if (next === 10) ++tokPos;
                            if (options.locations) {
                                ++tokCurLine;
                                tokLineStart = tokPos;
                            }
                        } else if (ch === 10 || ch === 8232 || ch === 8233) {
                            ++tokPos;
                            if (options.locations) {
                                ++tokCurLine;
                                tokLineStart = tokPos;
                            }
                        } else if (ch > 8 && ch < 14) ++tokPos;
                        else if (ch === 47) {
                            var next = input.charCodeAt(tokPos + 1);
                            if (next === 42) skipBlockComment();
                            else if (next === 47) skipLineComment();
                            else break;
                        } else if (ch === 160) ++tokPos;
                        else if (ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) ++tokPos;
                        else break;
                    }
                }
                // ### Token reading
                // This is the function that is called to fetch the next token. It
                // is somewhat obscure, because it works in character codes rather
                // than characters, and because operator parsing has been inlined
                // into it.
                //
                // All in the name of speed.
                //
                // The `forceRegexp` parameter is used in the one case where the
                // `tokRegexpAllowed` trick does not work. See `parseStatement`.
                function readToken_dot() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next >= 48 && next <= 57) return readNumber(true);
                    ++tokPos;
                    return finishToken(_dot);
                }
                function readToken_slash() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (tokRegexpAllowed) {
                        ++tokPos;
                        return readRegexp();
                    }
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_slash, 1);
                }
                function readToken_mult_modulo() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_multiplyModulo, 1);
                }
                function readToken_pipe_amp(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === code) return finishOp(code === 124 ? _logicalOR : _logicalAND, 2);
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(code === 124 ? _bitwiseOR : _bitwiseAND, 1);
                }
                function readToken_caret() {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_bitwiseXOR, 1);
                }
                function readToken_plus_min(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === code) {
                        if (next == 45 && input.charCodeAt(tokPos + 2) == 62 && newline.test(input.slice(lastEnd, tokPos))) {
                            // A `-->` line comment
                            tokPos += 3;
                            skipLineComment();
                            skipSpace();
                            return readToken();
                        }
                        return finishOp(_incDec, 2);
                    }
                    if (next === 61) return finishOp(_assign, 2);
                    return finishOp(_plusMin, 1);
                }
                function readToken_lt_gt(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    var size = 1;
                    if (next === code) {
                        size = code === 62 && input.charCodeAt(tokPos + 2) === 62 ? 3 : 2;
                        if (input.charCodeAt(tokPos + size) === 61) return finishOp(_assign, size + 1);
                        return finishOp(_bitShift, size);
                    }
                    if (next == 33 && code == 60 && input.charCodeAt(tokPos + 2) == 45 && input.charCodeAt(tokPos + 3) == 45) {
                        // `<!--`, an XML-style comment that should be interpreted as a line comment
                        tokPos += 4;
                        skipLineComment();
                        skipSpace();
                        return readToken();
                    }
                    if (next === 61) size = input.charCodeAt(tokPos + 2) === 61 ? 3 : 2;
                    return finishOp(_relational, size);
                }
                function readToken_eq_excl(code) {
                    var next = input.charCodeAt(tokPos + 1);
                    if (next === 61) return finishOp(_equality, input.charCodeAt(tokPos + 2) === 61 ? 3 : 2);
                    return finishOp(code === 61 ? _eq : _prefix, 1);
                }
                function getTokenFromCode(code) {
                    switch(code){
                        // The interpretation of a dot depends on whether it is followed
                        // by a digit.
                        case 46:
                            return readToken_dot();
                        // Punctuation tokens.
                        case 40:
                            ++tokPos;
                            return finishToken(_parenL);
                        case 41:
                            ++tokPos;
                            return finishToken(_parenR);
                        case 59:
                            ++tokPos;
                            return finishToken(_semi);
                        case 44:
                            ++tokPos;
                            return finishToken(_comma);
                        case 91:
                            ++tokPos;
                            return finishToken(_bracketL);
                        case 93:
                            ++tokPos;
                            return finishToken(_bracketR);
                        case 123:
                            ++tokPos;
                            return finishToken(_braceL);
                        case 125:
                            ++tokPos;
                            return finishToken(_braceR);
                        case 58:
                            ++tokPos;
                            return finishToken(_colon);
                        case 63:
                            ++tokPos;
                            return finishToken(_question);
                        // '0x' is a hexadecimal number.
                        case 48:
                            var next = input.charCodeAt(tokPos + 1);
                            if (next === 120 || next === 88) return readHexNumber();
                        // Anything else beginning with a digit is an integer, octal
                        // number, or float.
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                        case 56:
                        case 57:
                            return readNumber(false);
                        // Quotes produce strings.
                        case 34:
                        case 39:
                            return readString(code);
                        // Operators are parsed inline in tiny state machines. '=' (61) is
                        // often referred to. `finishOp` simply skips the amount of
                        // characters it is given as second argument, and returns a token
                        // of the type given by its first argument.
                        case 47:
                            return readToken_slash(code);
                        case 37:
                        case 42:
                            return readToken_mult_modulo();
                        case 124:
                        case 38:
                            return readToken_pipe_amp(code);
                        case 94:
                            return readToken_caret();
                        case 43:
                        case 45:
                            return readToken_plus_min(code);
                        case 60:
                        case 62:
                            return readToken_lt_gt(code);
                        case 61:
                        case 33:
                            return readToken_eq_excl(code);
                        case 126:
                            return finishOp(_prefix, 1);
                    }
                    return false;
                }
                function readToken(forceRegexp) {
                    if (!forceRegexp) tokStart = tokPos;
                    else tokPos = tokStart + 1;
                    if (options.locations) tokStartLoc = new line_loc_t;
                    if (forceRegexp) return readRegexp();
                    if (tokPos >= inputLen) return finishToken(_eof);
                    var code = input.charCodeAt(tokPos);
                    // Identifier or keyword. '\uXXXX' sequences are allowed in
                    // identifiers, so '\' also dispatches to that.
                    if (isIdentifierStart(code) || code === 92 /* '\' */ ) return readWord();
                    var tok = getTokenFromCode(code);
                    if (tok === false) {
                        // If we are here, we either found a non-ASCII identifier
                        // character, or something that's entirely disallowed.
                        var ch = String.fromCharCode(code);
                        if (ch === "\\" || nonASCIIidentifierStart.test(ch)) return readWord();
                        raise(tokPos, "Unexpected character '" + ch + "'");
                    }
                    return tok;
                }
                function finishOp(type, size) {
                    var str = input.slice(tokPos, tokPos + size);
                    tokPos += size;
                    finishToken(type, str);
                }
                // Parse a regular expression. Some context-awareness is necessary,
                // since a '/' inside a '[]' set does not end the expression.
                function readRegexp() {
                    var content = "", escaped, inClass, start = tokPos;
                    for(;;){
                        if (tokPos >= inputLen) raise(start, "Unterminated regular expression");
                        var ch = input.charAt(tokPos);
                        if (newline.test(ch)) raise(start, "Unterminated regular expression");
                        if (!escaped) {
                            if (ch === "[") inClass = true;
                            else if (ch === "]" && inClass) inClass = false;
                            else if (ch === "/" && !inClass) break;
                            escaped = ch === "\\";
                        } else escaped = false;
                        ++tokPos;
                    }
                    var content = input.slice(start, tokPos);
                    ++tokPos;
                    // Need to use `readWord1` because '\uXXXX' sequences are allowed
                    // here (don't ask).
                    var mods = readWord1();
                    if (mods && !/^[gmsiy]*$/.test(mods)) raise(start, "Invalid regexp flag");
                    return finishToken(_regexp, new RegExp(content, mods));
                }
                // Read an integer in the given radix. Return null if zero digits
                // were read, the integer value otherwise. When `len` is given, this
                // will return `null` unless the integer has exactly `len` digits.
                function readInt(radix, len) {
                    var start = tokPos, total = 0;
                    for(var i = 0, e = len == null ? Infinity : len; i < e; ++i){
                        var code = input.charCodeAt(tokPos), val;
                        if (code >= 97) val = code - 97 + 10; // a
                        else if (code >= 65) val = code - 65 + 10; // A
                        else if (code >= 48 && code <= 57) val = code - 48; // 0-9
                        else val = Infinity;
                        if (val >= radix) break;
                        ++tokPos;
                        total = total * radix + val;
                    }
                    if (tokPos === start || len != null && tokPos - start !== len) return null;
                    return total;
                }
                function readHexNumber() {
                    tokPos += 2; // 0x
                    var val = readInt(16);
                    if (val == null) raise(tokStart + 2, "Expected hexadecimal number");
                    if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
                    return finishToken(_num, val);
                }
                // Read an integer, octal integer, or floating-point number.
                function readNumber(startsWithDot) {
                    var start = tokPos, isFloat = false, octal = input.charCodeAt(tokPos) === 48;
                    if (!startsWithDot && readInt(10) === null) raise(start, "Invalid number");
                    if (input.charCodeAt(tokPos) === 46) {
                        ++tokPos;
                        readInt(10);
                        isFloat = true;
                    }
                    var next = input.charCodeAt(tokPos);
                    if (next === 69 || next === 101) {
                        next = input.charCodeAt(++tokPos);
                        if (next === 43 || next === 45) ++tokPos; // '+-'
                        if (readInt(10) === null) raise(start, "Invalid number");
                        isFloat = true;
                    }
                    if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
                    var str = input.slice(start, tokPos), val;
                    if (isFloat) val = parseFloat(str);
                    else if (!octal || str.length === 1) val = parseInt(str, 10);
                    else if (/[89]/.test(str) || strict) raise(start, "Invalid number");
                    else val = parseInt(str, 8);
                    return finishToken(_num, val);
                }
                // Read a string value, interpreting backslash-escapes.
                function readString(quote) {
                    tokPos++;
                    var out = "";
                    for(;;){
                        if (tokPos >= inputLen) raise(tokStart, "Unterminated string constant");
                        var ch = input.charCodeAt(tokPos);
                        if (ch === quote) {
                            ++tokPos;
                            return finishToken(_string, out);
                        }
                        if (ch === 92) {
                            ch = input.charCodeAt(++tokPos);
                            var octal = /^[0-7]+/.exec(input.slice(tokPos, tokPos + 3));
                            if (octal) octal = octal[0];
                            while(octal && parseInt(octal, 8) > 255)octal = octal.slice(0, -1);
                            if (octal === "0") octal = null;
                            ++tokPos;
                            if (octal) {
                                if (strict) raise(tokPos - 2, "Octal literal in strict mode");
                                out += String.fromCharCode(parseInt(octal, 8));
                                tokPos += octal.length - 1;
                            } else switch(ch){
                                case 110:
                                    out += "\n";
                                    break; // 'n' -> '\n'
                                case 114:
                                    out += "\r";
                                    break; // 'r' -> '\r'
                                case 120:
                                    out += String.fromCharCode(readHexChar(2));
                                    break; // 'x'
                                case 117:
                                    out += String.fromCharCode(readHexChar(4));
                                    break; // 'u'
                                case 85:
                                    out += String.fromCharCode(readHexChar(8));
                                    break; // 'U'
                                case 116:
                                    out += "\t";
                                    break; // 't' -> '\t'
                                case 98:
                                    out += "\b";
                                    break; // 'b' -> '\b'
                                case 118:
                                    out += "\u000b";
                                    break; // 'v' -> '\u000b'
                                case 102:
                                    out += "\f";
                                    break; // 'f' -> '\f'
                                case 48:
                                    out += "\0";
                                    break; // 0 -> '\0'
                                case 13:
                                    if (input.charCodeAt(tokPos) === 10) ++tokPos; // '\r\n'
                                case 10:
                                    if (options.locations) {
                                        tokLineStart = tokPos;
                                        ++tokCurLine;
                                    }
                                    break;
                                default:
                                    out += String.fromCharCode(ch);
                                    break;
                            }
                        } else {
                            if (ch === 13 || ch === 10 || ch === 8232 || ch === 8233) raise(tokStart, "Unterminated string constant");
                            out += String.fromCharCode(ch); // '\'
                            ++tokPos;
                        }
                    }
                }
                // Used to read character escape sequences ('\x', '\u', '\U').
                function readHexChar(len) {
                    var n = readInt(16, len);
                    if (n === null) raise(tokStart, "Bad character escape sequence");
                    return n;
                }
                // Used to signal to callers of `readWord1` whether the word
                // contained any escape sequences. This is needed because words with
                // escape sequences must not be interpreted as keywords.
                var containsEsc;
                // Read an identifier, and return it as a string. Sets `containsEsc`
                // to whether the word contained a '\u' escape.
                //
                // Only builds up the word character-by-character when it actually
                // containeds an escape, as a micro-optimization.
                function readWord1() {
                    containsEsc = false;
                    var word, first = true, start = tokPos;
                    for(;;){
                        var ch = input.charCodeAt(tokPos);
                        if (isIdentifierChar(ch)) {
                            if (containsEsc) word += input.charAt(tokPos);
                            ++tokPos;
                        } else if (ch === 92) {
                            if (!containsEsc) word = input.slice(start, tokPos);
                            containsEsc = true;
                            if (input.charCodeAt(++tokPos) != 117) raise(tokPos, "Expecting Unicode escape sequence \\uXXXX");
                            ++tokPos;
                            var esc = readHexChar(4);
                            var escStr = String.fromCharCode(esc);
                            if (!escStr) raise(tokPos - 1, "Invalid Unicode escape");
                            if (!(first ? isIdentifierStart(esc) : isIdentifierChar(esc))) raise(tokPos - 4, "Invalid Unicode escape");
                            word += escStr;
                        } else break;
                        first = false;
                    }
                    return containsEsc ? word : input.slice(start, tokPos);
                }
                // Read an identifier or keyword token. Will check for reserved
                // words when necessary.
                function readWord() {
                    var word = readWord1();
                    var type = _name;
                    if (!containsEsc) {
                        if (isKeyword(word)) type = keywordTypes[word];
                        else if (options.forbidReserved && (options.ecmaVersion === 3 ? isReservedWord3 : isReservedWord5)(word) || strict && isStrictReservedWord(word)) raise(tokStart, "The keyword '" + word + "' is reserved");
                    }
                    return finishToken(type, word);
                }
                // ## Parser
                // A recursive descent parser operates by defining functions for all
                // syntactic elements, and recursively calling those, each function
                // advancing the input stream and returning an AST node. Precedence
                // of constructs (for example, the fact that `!x[1]` means `!(x[1])`
                // instead of `(!x)[1]` is handled by the fact that the parser
                // function that parses unary prefix operators is called first, and
                // in turn calls the function that parses `[]` subscripts — that
                // way, it'll receive the node for `x[1]` already parsed, and wraps
                // *that* in the unary operator node.
                //
                // Acorn uses an [operator precedence parser][opp] to handle binary
                // operator precedence, because it is much more compact than using
                // the technique outlined above, which uses different, nesting
                // functions to specify precedence, for all of the ten binary
                // precedence levels that JavaScript defines.
                //
                // [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
                // ### Parser utilities
                // Continue to the next token.
                function next() {
                    lastStart = tokStart;
                    lastEnd = tokEnd;
                    lastEndLoc = tokEndLoc;
                    readToken();
                }
                // Enter strict mode. Re-reads the next token to please pedantic
                // tests ("use strict"; 010; -- should fail).
                function setStrict(strct) {
                    strict = strct;
                    tokPos = lastEnd;
                    if (options.locations) while(tokPos < tokLineStart){
                        tokLineStart = input.lastIndexOf("\n", tokLineStart - 2) + 1;
                        --tokCurLine;
                    }
                    skipSpace();
                    readToken();
                }
                // Start an AST node, attaching a start offset.
                function node_t() {
                    this.type = null;
                    this.start = tokStart;
                    this.end = null;
                }
                function node_loc_t() {
                    this.start = tokStartLoc;
                    this.end = null;
                    if (sourceFile !== null) this.source = sourceFile;
                }
                function startNode() {
                    var node = new node_t();
                    if (options.locations) node.loc = new node_loc_t();
                    if (options.directSourceFile) node.sourceFile = options.directSourceFile;
                    if (options.ranges) node.range = [
                        tokStart,
                        0
                    ];
                    return node;
                }
                // Start a node whose start offset information should be based on
                // the start of another node. For example, a binary operator node is
                // only started after its left-hand side has already been parsed.
                function startNodeFrom(other) {
                    var node = new node_t();
                    node.start = other.start;
                    if (options.locations) {
                        node.loc = new node_loc_t();
                        node.loc.start = other.loc.start;
                    }
                    if (options.ranges) node.range = [
                        other.range[0],
                        0
                    ];
                    return node;
                }
                // Finish an AST node, adding `type` and `end` properties.
                function finishNode(node, type) {
                    node.type = type;
                    node.end = lastEnd;
                    if (options.locations) node.loc.end = lastEndLoc;
                    if (options.ranges) node.range[1] = lastEnd;
                    return node;
                }
                // Test whether a statement node is the string literal `"use strict"`.
                function isUseStrict(stmt) {
                    return options.ecmaVersion >= 5 && stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && stmt.expression.value === "use strict";
                }
                // Predicate that tests whether the next token is of the given
                // type, and if yes, consumes it as a side effect.
                function eat(type) {
                    if (tokType === type) {
                        next();
                        return true;
                    }
                }
                // Test whether a semicolon can be inserted at the current position.
                function canInsertSemicolon() {
                    return !options.strictSemicolons && (tokType === _eof || tokType === _braceR || newline.test(input.slice(lastEnd, tokStart)));
                }
                // Consume a semicolon, or, failing that, see if we are allowed to
                // pretend that there is a semicolon at this position.
                function semicolon() {
                    if (!eat(_semi) && !canInsertSemicolon()) unexpected();
                }
                // Expect a token of a given type. If found, consume it, otherwise,
                // raise an unexpected token error.
                function expect(type) {
                    if (tokType === type) next();
                    else unexpected();
                }
                // Raise an unexpected token error.
                function unexpected() {
                    raise(tokStart, "Unexpected token");
                }
                // Verify that a node is an lval — something that can be assigned
                // to.
                function checkLVal(expr) {
                    if (expr.type !== "Identifier" && expr.type !== "MemberExpression") raise(expr.start, "Assigning to rvalue");
                    if (strict && expr.type === "Identifier" && isStrictBadIdWord(expr.name)) raise(expr.start, "Assigning to " + expr.name + " in strict mode");
                }
                // ### Statement parsing
                // Parse a program. Initializes the parser, reads any number of
                // statements, and wraps them in a Program node.  Optionally takes a
                // `program` argument.  If present, the statements will be appended
                // to its body instead of creating a new node.
                function parseTopLevel(program) {
                    lastStart = lastEnd = tokPos;
                    if (options.locations) lastEndLoc = new line_loc_t;
                    inFunction = strict = null;
                    labels = [];
                    readToken();
                    var node = program || startNode(), first = true;
                    if (!program) node.body = [];
                    while(tokType !== _eof){
                        var stmt = parseStatement();
                        node.body.push(stmt);
                        if (first && isUseStrict(stmt)) setStrict(true);
                        first = false;
                    }
                    return finishNode(node, "Program");
                }
                var loopLabel = {
                    kind: "loop"
                }, switchLabel = {
                    kind: "switch"
                };
                // Parse a single statement.
                //
                // If expecting a statement and finding a slash operator, parse a
                // regular expression literal. This is to handle cases like
                // `if (foo) /blah/.exec(foo);`, where looking at the previous token
                // does not help.
                function parseStatement() {
                    if (tokType === _slash || tokType === _assign && tokVal == "/=") readToken(true);
                    var starttype = tokType, node = startNode();
                    // Most types of statements are recognized by the keyword they
                    // start with. Many are trivial to parse, some require a bit of
                    // complexity.
                    switch(starttype){
                        case _break:
                        case _continue:
                            next();
                            var isBreak = starttype === _break;
                            if (eat(_semi) || canInsertSemicolon()) node.label = null;
                            else if (tokType !== _name) unexpected();
                            else {
                                node.label = parseIdent();
                                semicolon();
                            }
                            // Verify that there is an actual destination to break or
                            // continue to.
                            for(var i = 0; i < labels.length; ++i){
                                var lab = labels[i];
                                if (node.label == null || lab.name === node.label.name) {
                                    if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
                                    if (node.label && isBreak) break;
                                }
                            }
                            if (i === labels.length) raise(node.start, "Unsyntactic " + starttype.keyword);
                            return finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
                        case _debugger:
                            next();
                            semicolon();
                            return finishNode(node, "DebuggerStatement");
                        case _do:
                            next();
                            labels.push(loopLabel);
                            node.body = parseStatement();
                            labels.pop();
                            expect(_while);
                            node.test = parseParenExpression();
                            semicolon();
                            return finishNode(node, "DoWhileStatement");
                        // Disambiguating between a `for` and a `for`/`in` loop is
                        // non-trivial. Basically, we have to parse the init `var`
                        // statement or expression, disallowing the `in` operator (see
                        // the second parameter to `parseExpression`), and then check
                        // whether the next token is `in`. When there is no init part
                        // (semicolon immediately after the opening parenthesis), it is
                        // a regular `for` loop.
                        case _for:
                            next();
                            labels.push(loopLabel);
                            expect(_parenL);
                            if (tokType === _semi) return parseFor(node, null);
                            if (tokType === _var) {
                                var init = startNode();
                                next();
                                parseVar(init, true);
                                finishNode(init, "VariableDeclaration");
                                if (init.declarations.length === 1 && eat(_in)) return parseForIn(node, init);
                                return parseFor(node, init);
                            }
                            var init = parseExpression(false, true);
                            if (eat(_in)) {
                                checkLVal(init);
                                return parseForIn(node, init);
                            }
                            return parseFor(node, init);
                        case _function:
                            next();
                            return parseFunction(node, true);
                        case _if:
                            next();
                            node.test = parseParenExpression();
                            node.consequent = parseStatement();
                            node.alternate = eat(_else) ? parseStatement() : null;
                            return finishNode(node, "IfStatement");
                        case _return:
                            if (!inFunction) raise(tokStart, "'return' outside of function");
                            next();
                            // In `return` (and `break`/`continue`), the keywords with
                            // optional arguments, we eagerly look for a semicolon or the
                            // possibility to insert one.
                            if (eat(_semi) || canInsertSemicolon()) node.argument = null;
                            else {
                                node.argument = parseExpression();
                                semicolon();
                            }
                            return finishNode(node, "ReturnStatement");
                        case _switch:
                            next();
                            node.discriminant = parseParenExpression();
                            node.cases = [];
                            expect(_braceL);
                            labels.push(switchLabel);
                            // Statements under must be grouped (by label) in SwitchCase
                            // nodes. `cur` is used to keep the node that we are currently
                            // adding statements to.
                            for(var cur, sawDefault; tokType != _braceR;)if (tokType === _case || tokType === _default) {
                                var isCase = tokType === _case;
                                if (cur) finishNode(cur, "SwitchCase");
                                node.cases.push(cur = startNode());
                                cur.consequent = [];
                                next();
                                if (isCase) cur.test = parseExpression();
                                else {
                                    if (sawDefault) raise(lastStart, "Multiple default clauses");
                                    sawDefault = true;
                                    cur.test = null;
                                }
                                expect(_colon);
                            } else {
                                if (!cur) unexpected();
                                cur.consequent.push(parseStatement());
                            }
                            if (cur) finishNode(cur, "SwitchCase");
                            next(); // Closing brace
                            labels.pop();
                            return finishNode(node, "SwitchStatement");
                        case _throw:
                            next();
                            if (newline.test(input.slice(lastEnd, tokStart))) raise(lastEnd, "Illegal newline after throw");
                            node.argument = parseExpression();
                            semicolon();
                            return finishNode(node, "ThrowStatement");
                        case _try:
                            next();
                            node.block = parseBlock();
                            node.handler = null;
                            if (tokType === _catch) {
                                var clause = startNode();
                                next();
                                expect(_parenL);
                                clause.param = parseIdent();
                                if (strict && isStrictBadIdWord(clause.param.name)) raise(clause.param.start, "Binding " + clause.param.name + " in strict mode");
                                expect(_parenR);
                                clause.guard = null;
                                clause.body = parseBlock();
                                node.handler = finishNode(clause, "CatchClause");
                            }
                            node.guardedHandlers = empty;
                            node.finalizer = eat(_finally) ? parseBlock() : null;
                            if (!node.handler && !node.finalizer) raise(node.start, "Missing catch or finally clause");
                            return finishNode(node, "TryStatement");
                        case _var:
                            next();
                            parseVar(node);
                            semicolon();
                            return finishNode(node, "VariableDeclaration");
                        case _while:
                            next();
                            node.test = parseParenExpression();
                            labels.push(loopLabel);
                            node.body = parseStatement();
                            labels.pop();
                            return finishNode(node, "WhileStatement");
                        case _with:
                            if (strict) raise(tokStart, "'with' in strict mode");
                            next();
                            node.object = parseParenExpression();
                            node.body = parseStatement();
                            return finishNode(node, "WithStatement");
                        case _braceL:
                            return parseBlock();
                        case _semi:
                            next();
                            return finishNode(node, "EmptyStatement");
                        // If the statement does not start with a statement keyword or a
                        // brace, it's an ExpressionStatement or LabeledStatement. We
                        // simply start parsing an expression, and afterwards, if the
                        // next token is a colon and the expression was a simple
                        // Identifier node, we switch to interpreting it as a label.
                        default:
                            var maybeName = tokVal, expr = parseExpression();
                            if (starttype === _name && expr.type === "Identifier" && eat(_colon)) {
                                for(var i = 0; i < labels.length; ++i)if (labels[i].name === maybeName) raise(expr.start, "Label '" + maybeName + "' is already declared");
                                var kind = tokType.isLoop ? "loop" : tokType === _switch ? "switch" : null;
                                labels.push({
                                    name: maybeName,
                                    kind: kind
                                });
                                node.body = parseStatement();
                                labels.pop();
                                node.label = expr;
                                return finishNode(node, "LabeledStatement");
                            } else {
                                node.expression = expr;
                                semicolon();
                                return finishNode(node, "ExpressionStatement");
                            }
                    }
                }
                // Used for constructs like `switch` and `if` that insist on
                // parentheses around their expression.
                function parseParenExpression() {
                    expect(_parenL);
                    var val = parseExpression();
                    expect(_parenR);
                    return val;
                }
                // Parse a semicolon-enclosed block of statements, handling `"use
                // strict"` declarations when `allowStrict` is true (used for
                // function bodies).
                function parseBlock(allowStrict) {
                    var node = startNode(), first = true, strict = false, oldStrict;
                    node.body = [];
                    expect(_braceL);
                    while(!eat(_braceR)){
                        var stmt = parseStatement();
                        node.body.push(stmt);
                        if (first && allowStrict && isUseStrict(stmt)) {
                            oldStrict = strict;
                            setStrict(strict = true);
                        }
                        first = false;
                    }
                    if (strict && !oldStrict) setStrict(false);
                    return finishNode(node, "BlockStatement");
                }
                // Parse a regular `for` loop. The disambiguation code in
                // `parseStatement` will already have parsed the init statement or
                // expression.
                function parseFor(node, init) {
                    node.init = init;
                    expect(_semi);
                    node.test = tokType === _semi ? null : parseExpression();
                    expect(_semi);
                    node.update = tokType === _parenR ? null : parseExpression();
                    expect(_parenR);
                    node.body = parseStatement();
                    labels.pop();
                    return finishNode(node, "ForStatement");
                }
                // Parse a `for`/`in` loop.
                function parseForIn(node, init) {
                    node.left = init;
                    node.right = parseExpression();
                    expect(_parenR);
                    node.body = parseStatement();
                    labels.pop();
                    return finishNode(node, "ForInStatement");
                }
                // Parse a list of variable declarations.
                function parseVar(node, noIn) {
                    node.declarations = [];
                    node.kind = "var";
                    for(;;){
                        var decl = startNode();
                        decl.id = parseIdent();
                        if (strict && isStrictBadIdWord(decl.id.name)) raise(decl.id.start, "Binding " + decl.id.name + " in strict mode");
                        decl.init = eat(_eq) ? parseExpression(true, noIn) : null;
                        node.declarations.push(finishNode(decl, "VariableDeclarator"));
                        if (!eat(_comma)) break;
                    }
                    return node;
                }
                // ### Expression parsing
                // These nest, from the most general expression type at the top to
                // 'atomic', nondivisible expression types at the bottom. Most of
                // the functions will simply let the function(s) below them parse,
                // and, *if* the syntactic construct they handle is present, wrap
                // the AST node that the inner parser gave them in another node.
                // Parse a full expression. The arguments are used to forbid comma
                // sequences (in argument lists, array literals, or object literals)
                // or the `in` operator (in for loops initalization expressions).
                function parseExpression(noComma, noIn) {
                    var expr = parseMaybeAssign(noIn);
                    if (!noComma && tokType === _comma) {
                        var node = startNodeFrom(expr);
                        node.expressions = [
                            expr
                        ];
                        while(eat(_comma))node.expressions.push(parseMaybeAssign(noIn));
                        return finishNode(node, "SequenceExpression");
                    }
                    return expr;
                }
                // Parse an assignment expression. This includes applications of
                // operators like `+=`.
                function parseMaybeAssign(noIn) {
                    var left = parseMaybeConditional(noIn);
                    if (tokType.isAssign) {
                        var node = startNodeFrom(left);
                        node.operator = tokVal;
                        node.left = left;
                        next();
                        node.right = parseMaybeAssign(noIn);
                        checkLVal(left);
                        return finishNode(node, "AssignmentExpression");
                    }
                    return left;
                }
                // Parse a ternary conditional (`?:`) operator.
                function parseMaybeConditional(noIn) {
                    var expr = parseExprOps(noIn);
                    if (eat(_question)) {
                        var node = startNodeFrom(expr);
                        node.test = expr;
                        node.consequent = parseExpression(true);
                        expect(_colon);
                        node.alternate = parseExpression(true, noIn);
                        return finishNode(node, "ConditionalExpression");
                    }
                    return expr;
                }
                // Start the precedence parser.
                function parseExprOps(noIn) {
                    return parseExprOp(parseMaybeUnary(), -1, noIn);
                }
                // Parse binary operators with the operator precedence parsing
                // algorithm. `left` is the left-hand side of the operator.
                // `minPrec` provides context that allows the function to stop and
                // defer further parser to one of its callers when it encounters an
                // operator that has a lower precedence than the set it is parsing.
                function parseExprOp(left, minPrec, noIn) {
                    var prec = tokType.binop;
                    if (prec != null && (!noIn || tokType !== _in)) {
                        if (prec > minPrec) {
                            var node = startNodeFrom(left);
                            node.left = left;
                            node.operator = tokVal;
                            var op = tokType;
                            next();
                            node.right = parseExprOp(parseMaybeUnary(), prec, noIn);
                            var exprNode = finishNode(node, op === _logicalOR || op === _logicalAND ? "LogicalExpression" : "BinaryExpression");
                            return parseExprOp(exprNode, minPrec, noIn);
                        }
                    }
                    return left;
                }
                // Parse unary operators, both prefix and postfix.
                function parseMaybeUnary() {
                    if (tokType.prefix) {
                        var node = startNode(), update = tokType.isUpdate;
                        node.operator = tokVal;
                        node.prefix = true;
                        tokRegexpAllowed = true;
                        next();
                        node.argument = parseMaybeUnary();
                        if (update) checkLVal(node.argument);
                        else if (strict && node.operator === "delete" && node.argument.type === "Identifier") raise(node.start, "Deleting local variable in strict mode");
                        return finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
                    }
                    var expr = parseExprSubscripts();
                    while(tokType.postfix && !canInsertSemicolon()){
                        var node = startNodeFrom(expr);
                        node.operator = tokVal;
                        node.prefix = false;
                        node.argument = expr;
                        checkLVal(expr);
                        next();
                        expr = finishNode(node, "UpdateExpression");
                    }
                    return expr;
                }
                // Parse call, dot, and `[]`-subscript expressions.
                function parseExprSubscripts() {
                    return parseSubscripts(parseExprAtom());
                }
                function parseSubscripts(base, noCalls) {
                    if (eat(_dot)) {
                        var node = startNodeFrom(base);
                        node.object = base;
                        node.property = parseIdent(true);
                        node.computed = false;
                        return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
                    } else if (eat(_bracketL)) {
                        var node = startNodeFrom(base);
                        node.object = base;
                        node.property = parseExpression();
                        node.computed = true;
                        expect(_bracketR);
                        return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
                    } else if (!noCalls && eat(_parenL)) {
                        var node = startNodeFrom(base);
                        node.callee = base;
                        node.arguments = parseExprList(_parenR, false);
                        return parseSubscripts(finishNode(node, "CallExpression"), noCalls);
                    } else return base;
                }
                // Parse an atomic expression — either a single token that is an
                // expression, an expression started by a keyword like `function` or
                // `new`, or an expression wrapped in punctuation like `()`, `[]`,
                // or `{}`.
                function parseExprAtom() {
                    switch(tokType){
                        case _this:
                            var node = startNode();
                            next();
                            return finishNode(node, "ThisExpression");
                        case _name:
                            return parseIdent();
                        case _num:
                        case _string:
                        case _regexp:
                            var node = startNode();
                            node.value = tokVal;
                            node.raw = input.slice(tokStart, tokEnd);
                            next();
                            return finishNode(node, "Literal");
                        case _null:
                        case _true:
                        case _false:
                            var node = startNode();
                            node.value = tokType.atomValue;
                            node.raw = tokType.keyword;
                            next();
                            return finishNode(node, "Literal");
                        case _parenL:
                            var tokStartLoc1 = tokStartLoc, tokStart1 = tokStart;
                            next();
                            var val = parseExpression();
                            val.start = tokStart1;
                            val.end = tokEnd;
                            if (options.locations) {
                                val.loc.start = tokStartLoc1;
                                val.loc.end = tokEndLoc;
                            }
                            if (options.ranges) val.range = [
                                tokStart1,
                                tokEnd
                            ];
                            expect(_parenR);
                            return val;
                        case _bracketL:
                            var node = startNode();
                            next();
                            node.elements = parseExprList(_bracketR, true, true);
                            return finishNode(node, "ArrayExpression");
                        case _braceL:
                            return parseObj();
                        case _function:
                            var node = startNode();
                            next();
                            return parseFunction(node, false);
                        case _new:
                            return parseNew();
                        default:
                            unexpected();
                    }
                }
                // New's precedence is slightly tricky. It must allow its argument
                // to be a `[]` or dot subscript expression, but not a call — at
                // least, not without wrapping it in parentheses. Thus, it uses the
                function parseNew() {
                    var node = startNode();
                    next();
                    node.callee = parseSubscripts(parseExprAtom(), true);
                    if (eat(_parenL)) node.arguments = parseExprList(_parenR, false);
                    else node.arguments = empty;
                    return finishNode(node, "NewExpression");
                }
                // Parse an object literal.
                function parseObj() {
                    var node = startNode(), first = true, sawGetSet = false;
                    node.properties = [];
                    next();
                    while(!eat(_braceR)){
                        if (!first) {
                            expect(_comma);
                            if (options.allowTrailingCommas && eat(_braceR)) break;
                        } else first = false;
                        var prop = {
                            key: parsePropertyName()
                        }, isGetSet = false, kind;
                        if (eat(_colon)) {
                            prop.value = parseExpression(true);
                            kind = prop.kind = "init";
                        } else if (options.ecmaVersion >= 5 && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set")) {
                            isGetSet = sawGetSet = true;
                            kind = prop.kind = prop.key.name;
                            prop.key = parsePropertyName();
                            if (tokType !== _parenL) unexpected();
                            prop.value = parseFunction(startNode(), false);
                        } else unexpected();
                        // getters and setters are not allowed to clash — either with
                        // each other or with an init property — and in strict mode,
                        // init properties are also not allowed to be repeated.
                        if (prop.key.type === "Identifier" && (strict || sawGetSet)) for(var i = 0; i < node.properties.length; ++i){
                            var other = node.properties[i];
                            if (other.key.name === prop.key.name) {
                                var conflict = kind == other.kind || isGetSet && other.kind === "init" || kind === "init" && (other.kind === "get" || other.kind === "set");
                                if (conflict && !strict && kind === "init" && other.kind === "init") conflict = false;
                                if (conflict) raise(prop.key.start, "Redefinition of property");
                            }
                        }
                        node.properties.push(prop);
                    }
                    return finishNode(node, "ObjectExpression");
                }
                function parsePropertyName() {
                    if (tokType === _num || tokType === _string) return parseExprAtom();
                    return parseIdent(true);
                }
                // Parse a function declaration or literal (depending on the
                // `isStatement` parameter).
                function parseFunction(node, isStatement) {
                    if (tokType === _name) node.id = parseIdent();
                    else if (isStatement) unexpected();
                    else node.id = null;
                    node.params = [];
                    var first = true;
                    expect(_parenL);
                    while(!eat(_parenR)){
                        if (!first) expect(_comma);
                        else first = false;
                        node.params.push(parseIdent());
                    }
                    // Start a new scope with regard to labels and the `inFunction`
                    // flag (restore them to their old value afterwards).
                    var oldInFunc = inFunction, oldLabels = labels;
                    inFunction = true;
                    labels = [];
                    node.body = parseBlock(true);
                    inFunction = oldInFunc;
                    labels = oldLabels;
                    // If this is a strict mode function, verify that argument names
                    // are not repeated, and it does not try to bind the words `eval`
                    // or `arguments`.
                    if (strict || node.body.body.length && isUseStrict(node.body.body[0])) for(var i = node.id ? -1 : 0; i < node.params.length; ++i){
                        var id = i < 0 ? node.id : node.params[i];
                        if (isStrictReservedWord(id.name) || isStrictBadIdWord(id.name)) raise(id.start, "Defining '" + id.name + "' in strict mode");
                        if (i >= 0) {
                            for(var j = 0; j < i; ++j)if (id.name === node.params[j].name) raise(id.start, "Argument name clash in strict mode");
                        }
                    }
                    return finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
                }
                // Parses a comma-separated list of expressions, and returns them as
                // an array. `close` is the token type that ends the list, and
                // `allowEmpty` can be turned on to allow subsequent commas with
                // nothing in between them to be parsed as `null` (which is needed
                // for array literals).
                function parseExprList(close, allowTrailingComma, allowEmpty) {
                    var elts = [], first = true;
                    while(!eat(close)){
                        if (!first) {
                            expect(_comma);
                            if (allowTrailingComma && options.allowTrailingCommas && eat(close)) break;
                        } else first = false;
                        if (allowEmpty && tokType === _comma) elts.push(null);
                        else elts.push(parseExpression(true));
                    }
                    return elts;
                }
                // Parse the next token as an identifier. If `liberal` is true (used
                // when parsing properties), it will also convert keywords into
                // identifiers.
                function parseIdent(liberal) {
                    var node = startNode();
                    node.name = tokType === _name ? tokVal : liberal && !options.forbidReserved && tokType.keyword || unexpected();
                    tokRegexpAllowed = false;
                    next();
                    return finishNode(node, "Identifier");
                }
            });
        /***/ },
        /***/ "./original-repo/interpreter.js": /*!**************************************!*\
  !*** ./original-repo/interpreter.js ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /* WEBPACK VAR INJECTION */ (function(acorn) {
                /**
 * @fileoverview Interpreting JavaScript in JavaScript.
 * @author fraser@google.com (Neil Fraser)
 */ /**
 * Create a new interpreter.
 * @param {string|!Object} code Raw JavaScript text or AST.
 * @param {Function=} opt_initFunc Optional initialization function.  Used to
 *     define APIs.  When called it is passed the interpreter object and the
 *     global scope object.
 * @constructor
 */ var Interpreter = function(code, opt_initFunc) {
                    if (typeof code === 'string') code = acorn.parse(code, Interpreter.PARSE_OPTIONS);
                    // Get a handle on Acorn's node_t object.
                    this.nodeConstructor = code.constructor;
                    // Clone the root 'Program' node so that the AST may be modified.
                    var ast = new this.nodeConstructor({
                        options: {}
                    });
                    for(var prop in code)ast[prop] = prop === 'body' ? code[prop].slice() : code[prop];
                    this.ast = ast;
                    this.initFunc_ = opt_initFunc;
                    this.paused_ = false;
                    this.polyfills_ = [];
                    // Unique identifier for native functions.  Used in serialization.
                    this.functionCounter_ = 0;
                    // Map node types to our step function names; a property lookup is faster
                    // than string concatenation with "step" prefix.
                    this.stepFunctions_ = Object.create(null);
                    var stepMatch = /^step([A-Z]\w*)$/;
                    var m;
                    for(var methodName in this)if (typeof this[methodName] === 'function' && (m = methodName.match(stepMatch))) this.stepFunctions_[m[1]] = this[methodName].bind(this);
                    // Create and initialize the global scope.
                    this.globalScope = this.createScope(this.ast, null);
                    this.globalObject = this.globalScope.object;
                    // Run the polyfills.
                    this.ast = acorn.parse(this.polyfills_.join('\n'), Interpreter.PARSE_OPTIONS);
                    this.polyfills_ = undefined; // Allow polyfill strings to garbage collect.
                    Interpreter.stripLocations_(this.ast, undefined, undefined);
                    var state = new Interpreter.State(this.ast, this.globalScope);
                    state.done = false;
                    this.stateStack = [
                        state
                    ];
                    this.run();
                    this.value = undefined;
                    // Point at the main program.
                    this.ast = ast;
                    var state = new Interpreter.State(this.ast, this.globalScope);
                    state.done = false;
                    this.stateStack.length = 0;
                    this.stateStack[0] = state;
                    // Preserve publicly properties from being pruned/renamed by JS compilers.
                    // Add others as needed.
                    this['stateStack'] = this.stateStack;
                };
                /**
  * Completion Value Types.
  * @enum {number}
  */ Interpreter.Completion = {
                    NORMAL: 0,
                    BREAK: 1,
                    CONTINUE: 2,
                    RETURN: 3,
                    THROW: 4
                };
                /**
 * @const {!Object} Configuration used for all Acorn parsing.
 */ Interpreter.PARSE_OPTIONS = {
                    ecmaVersion: 5
                };
                /**
 * Property descriptor of readonly properties.
 */ Interpreter.READONLY_DESCRIPTOR = {
                    configurable: true,
                    enumerable: true,
                    writable: false
                };
                /**
 * Property descriptor of non-enumerable properties.
 */ Interpreter.NONENUMERABLE_DESCRIPTOR = {
                    configurable: true,
                    enumerable: false,
                    writable: true
                };
                /**
 * Property descriptor of readonly, non-enumerable properties.
 */ Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR = {
                    configurable: true,
                    enumerable: false,
                    writable: false
                };
                /**
 * Property descriptor of non-configurable, readonly, non-enumerable properties.
 * E.g. NaN, Infinity.
 */ Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR = {
                    configurable: false,
                    enumerable: false,
                    writable: false
                };
                /**
 * Property descriptor of variables.
 */ Interpreter.VARIABLE_DESCRIPTOR = {
                    configurable: false,
                    enumerable: true,
                    writable: true
                };
                /**
 * Unique symbol for indicating that a step has encountered an error, has
 * added it to the stack, and will be thrown within the user's program.
 * When STEP_ERROR is thrown in the JS-Interpreter, the error can be ignored.
 */ Interpreter.STEP_ERROR = {
                    'STEP_ERROR': true
                };
                /**
 * Unique symbol for indicating that a reference is a variable on the scope,
 * not an object property.
 */ Interpreter.SCOPE_REFERENCE = {
                    'SCOPE_REFERENCE': true
                };
                /**
 * Unique symbol for indicating, when used as the value of the value
 * parameter in calls to setProperty and friends, that the value
 * should be taken from the property descriptor instead.
 */ Interpreter.VALUE_IN_DESCRIPTOR = {
                    'VALUE_IN_DESCRIPTOR': true
                };
                /**
 * Unique symbol for indicating that a RegExp timeout has occurred in a VM.
 */ Interpreter.REGEXP_TIMEOUT = {
                    'REGEXP_TIMEOUT': true
                };
                /**
 * For cycle detection in array to string and error conversion;
 * see spec bug github.com/tc39/ecma262/issues/289
 * Since this is for atomic actions only, it can be a class property.
 */ Interpreter.toStringCycles_ = [];
                /**
 * Node's vm module, if loaded and required.
 * @type {Object}
 */ Interpreter.vm = null;
                /**
 * The global object (`window` in a browser, `global` in node.js) is `this`.
 */ Interpreter.nativeGlobal = this;
                /**
 * Code for executing regular expressions in a thread.
 */ Interpreter.WORKER_CODE = [
                    "onmessage = function(e) {",
                    "var result;",
                    "var data = e.data;",
                    "switch (data[0]) {",
                    "case 'split':",
                    // ['split', string, separator, limit]
                    "result = data[1].split(data[2], data[3]);",
                    "break;",
                    "case 'match':",
                    // ['match', string, regexp]
                    "result = data[1].match(data[2]);",
                    "break;",
                    "case 'search':",
                    // ['search', string, regexp]
                    "result = data[1].search(data[2]);",
                    "break;",
                    "case 'replace':",
                    // ['replace', string, regexp, newSubstr]
                    "result = data[1].replace(data[2], data[3]);",
                    "break;",
                    "case 'exec':",
                    // ['exec', regexp, lastIndex, string]
                    "var regexp = data[1];",
                    "regexp.lastIndex = data[2];",
                    "result = [regexp.exec(data[3]), data[1].lastIndex];",
                    "break;",
                    "default:",
                    "throw Error('Unknown RegExp operation: ' + data[0]);",
                    "}",
                    "postMessage(result);",
                    "};"
                ];
                /**
 * Is a value a legal integer for an array length?
 * @param {Interpreter.Value} x Value to check.
 * @return {number} Zero, or a positive integer if the value can be
 *     converted to such.  NaN otherwise.
 */ Interpreter.legalArrayLength = function(x) {
                    var n = x >>> 0;
                    // Array length must be between 0 and 2^32-1 (inclusive).
                    return n === Number(x) ? n : NaN;
                };
                /**
 * Is a value a legal integer for an array index?
 * @param {Interpreter.Value} x Value to check.
 * @return {number} Zero, or a positive integer if the value can be
 *     converted to such.  NaN otherwise.
 */ Interpreter.legalArrayIndex = function(x) {
                    var n = x >>> 0;
                    // Array index cannot be 2^32-1, otherwise length would be 2^32.
                    // 0xffffffff is 2^32-1.
                    return String(n) === String(x) && n !== 0xffffffff ? n : NaN;
                };
                /**
 * Remove start and end values from AST, or set start and end values to a
 * constant value.  Used to remove highlighting from polyfills and to set
 * highlighting in an eval to cover the entire eval expression.
 * @param {!Object} node AST node.
 * @param {number=} start Starting character of all nodes, or undefined.
 * @param {number=} end Ending character of all nodes, or undefined.
 * @private
 */ Interpreter.stripLocations_ = function(node, start, end) {
                    if (start) node['start'] = start;
                    else delete node['start'];
                    if (end) node['end'] = end;
                    else delete node['end'];
                    for(var name in node)if (node.hasOwnProperty(name)) {
                        var prop = node[name];
                        if (prop && typeof prop === 'object') Interpreter.stripLocations_(prop, start, end);
                    }
                };
                /**
 * Some pathological regular expressions can take geometric time.
 * Regular expressions are handled in one of three ways:
 * 0 - throw as invalid.
 * 1 - execute natively (risk of unresponsive program).
 * 2 - execute in separate thread (not supported by IE 9).
 */ Interpreter.prototype['REGEXP_MODE'] = 2;
                /**
 * If REGEXP_MODE = 2, the length of time (in ms) to allow a RegExp
 * thread to execute before terminating it.
 */ Interpreter.prototype['REGEXP_THREAD_TIMEOUT'] = 1000;
                /**
 * Length of time (in ms) to allow a polyfill to run before ending step.
 * If set to 0, polyfills will execute step by step.
 * If set to 1000, polyfills will run for up to a second per step
 * (execution will resume in the polyfill in the next step).
 * If set to Infinity, polyfills will run to completion in a single step.
 */ Interpreter.prototype['POLYFILL_TIMEOUT'] = 1000;
                /**
 * Flag indicating that a getter function needs to be called immediately.
 * @private
 */ Interpreter.prototype.getterStep_ = false;
                /**
 * Flag indicating that a setter function needs to be called immediately.
 * @private
 */ Interpreter.prototype.setterStep_ = false;
                /**
 * Add more code to the interpreter.
 * @param {string|!Object} code Raw JavaScript text or AST.
 */ Interpreter.prototype.appendCode = function(code) {
                    var state = this.stateStack[0];
                    if (!state || state.node['type'] !== 'Program') throw Error('Expecting original AST to start with a Program node.');
                    if (typeof code === 'string') code = acorn.parse(code, Interpreter.PARSE_OPTIONS);
                    if (!code || code['type'] !== 'Program') throw Error('Expecting new AST to start with a Program node.');
                    this.populateScope_(code, state.scope);
                    // Append the new program to the old one.
                    Array.prototype.push.apply(state.node['body'], code['body']);
                    state.done = false;
                };
                /**
 * Execute one step of the interpreter.
 * @return {boolean} True if a step was executed, false if no more instructions.
 */ Interpreter.prototype.step = function() {
                    var stack = this.stateStack;
                    var startTime = Date.now();
                    do {
                        var state = stack[stack.length - 1];
                        if (!state) return false;
                        var node = state.node, type = node['type'];
                        if (type === 'Program' && state.done) return false;
                        else if (this.paused_) return true;
                        try {
                            var nextState = this.stepFunctions_[type](stack, state, node);
                        } catch (e) {
                            // Eat any step errors.  They have been thrown on the stack.
                            if (e !== Interpreter.STEP_ERROR) // Uh oh.  This is a real error in the JS-Interpreter.  Rethrow.
                            throw e;
                        }
                        if (nextState) stack.push(nextState);
                        if (this.getterStep_) // Getter from this step was not handled.
                        throw Error('Getter not supported in this context');
                        if (this.setterStep_) // Setter from this step was not handled.
                        throw Error('Setter not supported in this context');
                    // This may be polyfill code.  Keep executing until we arrive at user code.
                    }while (!node['end'] && startTime + this['POLYFILL_TIMEOUT'] > Date.now());
                    return true;
                };
                /**
 * Execute the interpreter to program completion.  Vulnerable to infinite loops.
 * @return {boolean} True if a execution is asynchronously blocked,
 *     false if no more instructions.
 */ Interpreter.prototype.run = function() {
                    while(!this.paused_ && this.step());
                    return this.paused_;
                };
                /**
 * Initialize the global object with buitin properties and functions.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initGlobal = function(globalObject) {
                    // Initialize uneditable global properties.
                    this.setProperty(globalObject, 'NaN', NaN, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'Infinity', Infinity, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'undefined', undefined, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'window', globalObject, Interpreter.READONLY_DESCRIPTOR);
                    this.setProperty(globalObject, 'this', globalObject, Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'self', globalObject); // Editable.
                    // Create the objects which will become Object.prototype and
                    // Function.prototype, which are needed to bootstrap everything else.
                    this.OBJECT_PROTO = new Interpreter.Object(null);
                    this.FUNCTION_PROTO = new Interpreter.Object(this.OBJECT_PROTO);
                    // Initialize global objects.
                    this.initFunction(globalObject);
                    this.initObject(globalObject);
                    // Unable to set globalObject's parent prior (OBJECT did not exist).
                    // Note that in a browser this would be `Window`, whereas in Node.js it would
                    // be `Object`.  This interpreter is closer to Node in that it has no DOM.
                    globalObject.proto = this.OBJECT_PROTO;
                    this.setProperty(globalObject, 'constructor', this.OBJECT, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.initArray(globalObject);
                    this.initString(globalObject);
                    this.initBoolean(globalObject);
                    this.initNumber(globalObject);
                    this.initDate(globalObject);
                    this.initRegExp(globalObject);
                    this.initError(globalObject);
                    this.initMath(globalObject);
                    this.initJSON(globalObject);
                    // Initialize global functions.
                    var thisInterpreter = this;
                    var func = this.createNativeFunction(function(x) {
                        throw EvalError("Can't happen");
                    }, false);
                    func.eval = true;
                    this.setProperty(globalObject, 'eval', func, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'parseInt', this.createNativeFunction(parseInt, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'parseFloat', this.createNativeFunction(parseFloat, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'isNaN', this.createNativeFunction(isNaN, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'isFinite', this.createNativeFunction(isFinite, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var strFunctions = [
                        [
                            escape,
                            'escape'
                        ],
                        [
                            unescape,
                            'unescape'
                        ],
                        [
                            decodeURI,
                            'decodeURI'
                        ],
                        [
                            decodeURIComponent,
                            'decodeURIComponent'
                        ],
                        [
                            encodeURI,
                            'encodeURI'
                        ],
                        [
                            encodeURIComponent,
                            'encodeURIComponent'
                        ]
                    ];
                    for(var i = 0; i < strFunctions.length; i++){
                        var wrapper = function(nativeFunc) {
                            return function(str) {
                                try {
                                    return nativeFunc(str);
                                } catch (e) {
                                    // decodeURI('%xy') will throw an error.  Catch and rethrow.
                                    thisInterpreter.throwException(thisInterpreter.URI_ERROR, e.message);
                                }
                            };
                        }(strFunctions[i][0]);
                        this.setProperty(globalObject, strFunctions[i][1], this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    }
                    // Preserve publicly properties from being pruned/renamed by JS compilers.
                    // Add others as needed.
                    this['OBJECT'] = this.OBJECT;
                    this['OBJECT_PROTO'] = this.OBJECT_PROTO;
                    this['FUNCTION'] = this.FUNCTION;
                    this['FUNCTION_PROTO'] = this.FUNCTION_PROTO;
                    this['ARRAY'] = this.ARRAY;
                    this['ARRAY_PROTO'] = this.ARRAY_PROTO;
                    this['REGEXP'] = this.REGEXP;
                    this['REGEXP_PROTO'] = this.REGEXP_PROTO;
                    this['DATE'] = this.DATE;
                    this['DATE_PROTO'] = this.DATE_PROTO;
                    // Run any user-provided initialization.
                    if (this.initFunc_) this.initFunc_(this, globalObject);
                };
                /**
 * Initialize the Function class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initFunction = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    var identifierRegexp = /^[A-Za-z_$][\w$]*$/;
                    // Function constructor.
                    wrapper = function Function1(var_args) {
                        if (arguments.length) var code = String(arguments[arguments.length - 1]);
                        else var code = '';
                        var argsStr = Array.prototype.slice.call(arguments, 0, -1).join(',').trim();
                        if (argsStr) {
                            var args = argsStr.split(/\s*,\s*/);
                            for(var i = 0; i < args.length; i++){
                                var name = args[i];
                                if (!identifierRegexp.test(name)) thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, 'Invalid function argument: ' + name);
                            }
                            argsStr = args.join(', ');
                        }
                        // Acorn needs to parse code in the context of a function or else `return`
                        // statements will be syntax errors.
                        try {
                            var ast = acorn.parse('(function(' + argsStr + ') {' + code + '})', Interpreter.PARSE_OPTIONS);
                        } catch (e) {
                            // Acorn threw a SyntaxError.  Rethrow as a trappable error.
                            thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, 'Invalid code: ' + e.message);
                        }
                        if (ast['body'].length !== 1) // Function('a', 'return a + 6;}; {alert(1);');
                        thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, 'Invalid code in function body.');
                        var node = ast['body'][0]['expression'];
                        // Note that if this constructor is called as `new Function()` the function
                        // object created by stepCallExpression and assigned to `this` is discarded.
                        // Interestingly, the scope for constructed functions is the global scope,
                        // even if they were constructed in some other scope.
                        return thisInterpreter.createFunction(node, thisInterpreter.globalScope, 'anonymous');
                    };
                    this.FUNCTION = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, 'Function', this.FUNCTION, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Throw away the created prototype and use the root prototype.
                    this.setProperty(this.FUNCTION, 'prototype', this.FUNCTION_PROTO, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Configure Function.prototype.
                    this.setProperty(this.FUNCTION_PROTO, 'constructor', this.FUNCTION, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.FUNCTION_PROTO.nativeFunc = function() {};
                    this.FUNCTION_PROTO.nativeFunc.id = this.functionCounter_++;
                    this.FUNCTION_PROTO.illegalConstructor = true;
                    this.setProperty(this.FUNCTION_PROTO, 'length', 0, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.FUNCTION_PROTO.class = 'Function';
                    wrapper = function apply(thisArg, args) {
                        var state = thisInterpreter.stateStack[thisInterpreter.stateStack.length - 1];
                        // Rewrite the current CallExpression state to apply a different function.
                        state.func_ = this;
                        // Assign the `this` object.
                        state.funcThis_ = thisArg;
                        // Bind any provided arguments.
                        state.arguments_ = [];
                        if (args !== null && args !== undefined) {
                            if (args instanceof Interpreter.Object) state.arguments_ = thisInterpreter.arrayPseudoToNative(args);
                            else thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, 'CreateListFromArrayLike called on non-object');
                        }
                        state.doneExec_ = false;
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, 'apply', wrapper);
                    wrapper = function call(thisArg /*, var_args */ ) {
                        var state = thisInterpreter.stateStack[thisInterpreter.stateStack.length - 1];
                        // Rewrite the current CallExpression state to call a different function.
                        state.func_ = this;
                        // Assign the `this` object.
                        state.funcThis_ = thisArg;
                        // Bind any provided arguments.
                        state.arguments_ = [];
                        for(var i = 1; i < arguments.length; i++)state.arguments_.push(arguments[i]);
                        state.doneExec_ = false;
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, 'call', wrapper);
                    this.polyfills_.push(// Polyfill copied from:
                    // developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Function/bind
                    "Object.defineProperty(Function.prototype, 'bind',", "{configurable: true, writable: true, value:", "function bind(oThis) {", "if (typeof this !== 'function') {", "throw TypeError('What is trying to be bound is not callable');", "}", "var aArgs   = Array.prototype.slice.call(arguments, 1),", "fToBind = this,", "fNOP    = function() {},", "fBound  = function() {", "return fToBind.apply(this instanceof fNOP", "? this", ": oThis,", "aArgs.concat(Array.prototype.slice.call(arguments)));", "};", "if (this.prototype) {", "fNOP.prototype = this.prototype;", "}", "fBound.prototype = new fNOP();", "return fBound;", "}", "});", "");
                    // Function has no parent to inherit from, so it needs its own mandatory
                    // toString and valueOf functions.
                    wrapper = function toString() {
                        return String(this);
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, 'toString', wrapper);
                    this.setProperty(this.FUNCTION, 'toString', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function valueOf() {
                        return this.valueOf();
                    };
                    this.setNativeFunctionPrototype(this.FUNCTION, 'valueOf', wrapper);
                    this.setProperty(this.FUNCTION, 'valueOf', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize the Object class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initObject = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Object constructor.
                    wrapper = function Object1(value) {
                        if (value === undefined || value === null) {
                            // Create a new object.
                            if (thisInterpreter.calledWithNew()) // Called as `new Object()`.
                            return this;
                            else // Called as `Object()`.
                            return thisInterpreter.createObjectProto(thisInterpreter.OBJECT_PROTO);
                        }
                        if (!(value instanceof Interpreter.Object)) {
                            // Wrap the value as an object.
                            var box = thisInterpreter.createObjectProto(thisInterpreter.getPrototype(value));
                            box.data = value;
                            return box;
                        }
                        // Return the provided object.
                        return value;
                    };
                    this.OBJECT = this.createNativeFunction(wrapper, true);
                    // Throw away the created prototype and use the root prototype.
                    this.setProperty(this.OBJECT, 'prototype', this.OBJECT_PROTO, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.OBJECT_PROTO, 'constructor', this.OBJECT, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(globalObject, 'Object', this.OBJECT, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    /**
   * Checks if the provided value is null or undefined.
   * If so, then throw an error in the call stack.
   * @param {Interpreter.Value} value Value to check.
   */ var throwIfNullUndefined = function(value) {
                        if (value === undefined || value === null) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Cannot convert '" + value + "' to object");
                    };
                    // Static methods on Object.
                    wrapper = function getOwnPropertyNames(obj) {
                        throwIfNullUndefined(obj);
                        var props = obj instanceof Interpreter.Object ? obj.properties : obj;
                        return thisInterpreter.arrayNativeToPseudo(Object.getOwnPropertyNames(props));
                    };
                    this.setProperty(this.OBJECT, 'getOwnPropertyNames', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function keys(obj) {
                        throwIfNullUndefined(obj);
                        if (obj instanceof Interpreter.Object) obj = obj.properties;
                        return thisInterpreter.arrayNativeToPseudo(Object.keys(obj));
                    };
                    this.setProperty(this.OBJECT, 'keys', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function create_(proto) {
                        // Support for the second argument is the responsibility of a polyfill.
                        if (proto === null) return thisInterpreter.createObjectProto(null);
                        if (!(proto instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, 'Object prototype may only be an Object or null');
                        return thisInterpreter.createObjectProto(proto);
                    };
                    this.setProperty(this.OBJECT, 'create', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Add a polyfill to handle create's second argument.
                    this.polyfills_.push("(function() {", "var create_ = Object.create;", "Object.create = function create(proto, props) {", "var obj = create_(proto);", "props && Object.defineProperties(obj, props);", "return obj;", "};", "})();", "");
                    wrapper = function defineProperty(obj, prop, descriptor) {
                        prop = String(prop);
                        if (!(obj instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, 'Object.defineProperty called on non-object');
                        if (!(descriptor instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, 'Property description must be an object');
                        if (!obj.properties[prop] && obj.preventExtensions) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, "Can't define property '" + prop + "', object is not extensible");
                        // The polyfill guarantees no inheritance and no getter functions.
                        // Therefore the descriptor properties map is the native object needed.
                        thisInterpreter.setProperty(obj, prop, Interpreter.VALUE_IN_DESCRIPTOR, descriptor.properties);
                        return obj;
                    };
                    this.setProperty(this.OBJECT, 'defineProperty', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.polyfills_.push(// Flatten the descriptor to remove any inheritance or getter functions.
                    "(function() {", "var defineProperty_ = Object.defineProperty;", "Object.defineProperty = function defineProperty(obj, prop, d1) {", "var d2 = {};", "if ('configurable' in d1) d2.configurable = d1.configurable;", "if ('enumerable' in d1) d2.enumerable = d1.enumerable;", "if ('writable' in d1) d2.writable = d1.writable;", "if ('value' in d1) d2.value = d1.value;", "if ('get' in d1) d2.get = d1.get;", "if ('set' in d1) d2.set = d1.set;", "return defineProperty_(obj, prop, d2);", "};", "})();", "Object.defineProperty(Object, 'defineProperties',", "{configurable: true, writable: true, value:", "function defineProperties(obj, props) {", "var keys = Object.keys(props);", "for (var i = 0; i < keys.length; i++) {", "Object.defineProperty(obj, keys[i], props[keys[i]]);", "}", "return obj;", "}", "});", "");
                    wrapper = function getOwnPropertyDescriptor(obj, prop) {
                        if (!(obj instanceof Interpreter.Object)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, 'Object.getOwnPropertyDescriptor called on non-object');
                        prop = String(prop);
                        if (!(prop in obj.properties)) return undefined;
                        var descriptor = Object.getOwnPropertyDescriptor(obj.properties, prop);
                        var getter = obj.getter[prop];
                        var setter = obj.setter[prop];
                        var pseudoDescriptor = thisInterpreter.createObjectProto(thisInterpreter.OBJECT_PROTO);
                        if (getter || setter) {
                            thisInterpreter.setProperty(pseudoDescriptor, 'get', getter);
                            thisInterpreter.setProperty(pseudoDescriptor, 'set', setter);
                        } else {
                            thisInterpreter.setProperty(pseudoDescriptor, 'value', descriptor.value);
                            thisInterpreter.setProperty(pseudoDescriptor, 'writable', descriptor.writable);
                        }
                        thisInterpreter.setProperty(pseudoDescriptor, 'configurable', descriptor.configurable);
                        thisInterpreter.setProperty(pseudoDescriptor, 'enumerable', descriptor.enumerable);
                        return pseudoDescriptor;
                    };
                    this.setProperty(this.OBJECT, 'getOwnPropertyDescriptor', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function getPrototypeOf(obj) {
                        throwIfNullUndefined(obj);
                        return thisInterpreter.getPrototype(obj);
                    };
                    this.setProperty(this.OBJECT, 'getPrototypeOf', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function isExtensible(obj) {
                        return Boolean(obj) && !obj.preventExtensions;
                    };
                    this.setProperty(this.OBJECT, 'isExtensible', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    wrapper = function preventExtensions(obj) {
                        if (obj instanceof Interpreter.Object) obj.preventExtensions = true;
                        return obj;
                    };
                    this.setProperty(this.OBJECT, 'preventExtensions', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Object.
                    this.setNativeFunctionPrototype(this.OBJECT, 'toString', Interpreter.Object.prototype.toString);
                    this.setNativeFunctionPrototype(this.OBJECT, 'toLocaleString', Interpreter.Object.prototype.toString);
                    this.setNativeFunctionPrototype(this.OBJECT, 'valueOf', Interpreter.Object.prototype.valueOf);
                    wrapper = function hasOwnProperty(prop) {
                        throwIfNullUndefined(this);
                        if (this instanceof Interpreter.Object) return String(prop) in this.properties;
                        // Primitive.
                        return this.hasOwnProperty(prop);
                    };
                    this.setNativeFunctionPrototype(this.OBJECT, 'hasOwnProperty', wrapper);
                    wrapper = function propertyIsEnumerable(prop) {
                        throwIfNullUndefined(this);
                        if (this instanceof Interpreter.Object) return Object.prototype.propertyIsEnumerable.call(this.properties, prop);
                        // Primitive.
                        return this.propertyIsEnumerable(prop);
                    };
                    this.setNativeFunctionPrototype(this.OBJECT, 'propertyIsEnumerable', wrapper);
                    wrapper = function isPrototypeOf(obj) {
                        while(true){
                            // Note, circular loops shouldn't be possible.
                            obj = thisInterpreter.getPrototype(obj);
                            if (!obj) // No parent; reached the top.
                            return false;
                            if (obj === this) return true;
                        }
                    };
                    this.setNativeFunctionPrototype(this.OBJECT, 'isPrototypeOf', wrapper);
                };
                /**
 * Initialize the Array class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initArray = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Array constructor.
                    wrapper = function Array1(var_args) {
                        if (thisInterpreter.calledWithNew()) // Called as `new Array()`.
                        var newArray = this;
                        else // Called as `Array()`.
                        var newArray = thisInterpreter.createArray();
                        var first = arguments[0];
                        if (arguments.length === 1 && typeof first === 'number') {
                            if (isNaN(Interpreter.legalArrayLength(first))) thisInterpreter.throwException(thisInterpreter.RANGE_ERROR, 'Invalid array length');
                            newArray.properties.length = first;
                        } else {
                            for(var i = 0; i < arguments.length; i++)newArray.properties[i] = arguments[i];
                            newArray.properties.length = i;
                        }
                        return newArray;
                    };
                    this.ARRAY = this.createNativeFunction(wrapper, true);
                    this.ARRAY_PROTO = this.ARRAY.properties['prototype'];
                    this.setProperty(globalObject, 'Array', this.ARRAY, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Static methods on Array.
                    wrapper = function isArray(obj) {
                        return obj && obj.class === 'Array';
                    };
                    this.setProperty(this.ARRAY, 'isArray', this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Array.
                    this.setProperty(this.ARRAY_PROTO, 'length', 0, {
                        configurable: false,
                        enumerable: false,
                        writable: true
                    });
                    this.ARRAY_PROTO.class = 'Array';
                    this.polyfills_.push("Object.defineProperty(Array.prototype, 'pop',", "{configurable: true, writable: true, value:", "function pop() {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 0) {", "o.length = 0;", "return undefined;", "}", "len--;", "var x = o[len];", "delete o[len];", "o.length = len;", "return x;", "}", "});", "Object.defineProperty(Array.prototype, 'push',", "{configurable: true, writable: true, value:", "function push(var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "for (var i = 0; i < arguments.length; i++) {", "o[len] = arguments[i];", "len++;", "}", "o.length = len;", "return len;", "}", "});", "Object.defineProperty(Array.prototype, 'shift',", "{configurable: true, writable: true, value:", "function shift() {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 0) {", "o.length = 0;", "return undefined;", "}", "var value = o[0];", "for (var i = 0; i < len - 1; i++) {", "o[i] = o[i + 1];", "}", "delete o[i];", "o.length = len - 1;", "return value;", "}", "});", "Object.defineProperty(Array.prototype, 'unshift',", "{configurable: true, writable: true, value:", "function unshift(var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 0) {", "len = 0;", "}", "for (var i = len - 1; i >= 0; i--) {", "o[i + arguments.length] = o[i];", "}", "for (var i = 0; i < arguments.length; i++) {", "o[i] = arguments[i];", "}", "return o.length = len + arguments.length;", "}", "});", "Object.defineProperty(Array.prototype, 'reverse',", "{configurable: true, writable: true, value:", "function reverse() {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len || len < 2) {", "return o;", "}", "for (var i = 0; i < len / 2 - 0.5; i++) {", "var x = o[i];", "o[i] = o[len - i - 1];", "o[len - i - 1] = x;", "}", "return o;", "}", "});", "Object.defineProperty(Array.prototype, 'indexOf',", "{configurable: true, writable: true, value:", "function indexOf(searchElement, fromIndex) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "var n = fromIndex | 0;", "if (!len || n >= len) {", "return -1;", "}", "var i = Math.max(n >= 0 ? n : len - Math.abs(n), 0);", "while (i < len) {", "if (i in o && o[i] === searchElement) {", "return i;", "}", "i++;", "}", "return -1;", "}", "});", "Object.defineProperty(Array.prototype, 'lastIndexOf',", "{configurable: true, writable: true, value:", "function lastIndexOf(searchElement, fromIndex) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "if (!len) {", "return -1;", "}", "var n = len - 1;", "if (arguments.length > 1) {", "n = fromIndex | 0;", "if (n) {", "n = (n > 0 || -1) * Math.floor(Math.abs(n));", "}", "}", "var i = n >= 0 ? Math.min(n, len - 1) : len - Math.abs(n);", "while (i >= 0) {", "if (i in o && o[i] === searchElement) {", "return i;", "}", "i--;", "}", "return -1;", "}", "});", "Object.defineProperty(Array.prototype, 'slice',", "{configurable: true, writable: true, value:", "function slice(start, end) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", // Handle negative value for "start"
                    "start |= 0;", "start = (start >= 0) ? start : Math.max(0, len + start);", // Handle negative value for "end"
                    "if (typeof end !== 'undefined') {", "if (end !== Infinity) {", "end |= 0;", "}", "if (end < 0) {", "end = len + end;", "} else {", "end = Math.min(end, len);", "}", "} else {", "end = len;", "}", "var size = end - start;", "var cloned = [];", "for (var i = 0; i < size; i++) {", "cloned[i] = o[start + i];", "}", "return cloned;", "}", "});", "Object.defineProperty(Array.prototype, 'splice',", "{configurable: true, writable: true, value:", "function splice(start, deleteCount, var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "start |= 0;", "if (start < 0) {", "start = Math.max(len + start, 0);", "} else {", "start = Math.min(start, len);", "}", "if (arguments.length < 1) {", "deleteCount = len - start;", "} else {", "deleteCount |= 0;", "deleteCount = Math.max(0, Math.min(deleteCount, len - start));", "}", "var removed = [];", // Remove specified elements.
                    "for (var i = start; i < start + deleteCount; i++) {", "removed[removed.length++] = o[i];", "o[i] = o[i + deleteCount];", "}", // Move other element to fill the gap.
                    "for (var i = start + deleteCount; i < len - deleteCount; i++) {", "o[i] = o[i + deleteCount];", "}", // Delete superfluous properties.
                    "for (var i = len - deleteCount; i < len; i++) {", "delete o[i];", "}", "len -= deleteCount;", // Insert specified items.
                    "for (var i = len - 1; i >= start; i--) {", "o[i + arguments.length - 2] = o[i];", "}", "len += arguments.length - 2;", "for (var i = 2; i < arguments.length; i++) {", "o[start + i - 2] = arguments[i];", "}", "o.length = len;", "return removed;", "}", "});", "Object.defineProperty(Array.prototype, 'concat',", "{configurable: true, writable: true, value:", "function concat(var_args) {", "if (!this) throw TypeError();", "var o = Object(this);", "var cloned = [];", "for (var i = -1; i < arguments.length; i++) {", "var value = (i === -1) ? o : arguments[i];", "if (Array.isArray(value)) {", "cloned.push.apply(cloned, value);", "} else {", "cloned.push(value);", "}", "}", "return cloned;", "}", "});", "Object.defineProperty(Array.prototype, 'join',", "{configurable: true, writable: true, value:", "function join(opt_separator) {", "if (!this) throw TypeError();", "var o = Object(this);", "var sep = typeof opt_separator === 'undefined' ?", "',' : ('' + opt_separator);", "var str = '';", "for (var i = 0; i < o.length; i++) {", "if (i && sep) {", "str += sep;", "}", "str += o[i];", "}", "return str;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/every
                    "Object.defineProperty(Array.prototype, 'every',", "{configurable: true, writable: true, value:", "function every(callbackfn, thisArg) {", "if (!this || typeof callbackfn !== 'function') throw TypeError();", "var t, k;", "var o = Object(this);", "var len = o.length >>> 0;", "if (arguments.length > 1) t = thisArg;", "k = 0;", "while (k < len) {", "if (k in o && !callbackfn.call(t, o[k], k, o)) return false;", "k++;", "}", "return true;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
                    "Object.defineProperty(Array.prototype, 'filter',", "{configurable: true, writable: true, value:", "function filter(fun, var_args) {", "if (this === void 0 || this === null || typeof fun !== 'function') throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "var res = [];", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in o) {", "var val = o[i];", "if (fun.call(thisArg, val, i, o)) res.push(val);", "}", "}", "return res;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
                    "Object.defineProperty(Array.prototype, 'forEach',", "{configurable: true, writable: true, value:", "function forEach(callback, thisArg) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var t, k;", "var o = Object(this);", "var len = o.length >>> 0;", "if (arguments.length > 1) t = thisArg;", "k = 0;", "while (k < len) {", "if (k in o) callback.call(t, o[k], k, o);", "k++;", "}", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/map
                    "Object.defineProperty(Array.prototype, 'map',", "{configurable: true, writable: true, value:", "function map(callback, thisArg) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var t, a, k;", "var o = Object(this);", "var len = o.length >>> 0;", "if (arguments.length > 1) t = thisArg;", "a = new Array(len);", "k = 0;", "while (k < len) {", "if (k in o) a[k] = callback.call(t, o[k], k, o);", "k++;", "}", "return a;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
                    "Object.defineProperty(Array.prototype, 'reduce',", "{configurable: true, writable: true, value:", "function reduce(callback /*, initialValue*/) {", "if (!this || typeof callback !== 'function') throw TypeError();", "var o = Object(this), len = o.length >>> 0, k = 0, value;", "if (arguments.length === 2) {", "value = arguments[1];", "} else {", "while (k < len && !(k in o)) k++;", "if (k >= len) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = o[k++];", "}", "for (; k < len; k++) {", "if (k in o) value = callback(value, o[k], k, o);", "}", "return value;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/ReduceRight
                    "Object.defineProperty(Array.prototype, 'reduceRight',", "{configurable: true, writable: true, value:", "function reduceRight(callback /*, initialValue*/) {", "if (null === this || 'undefined' === typeof this || 'function' !== typeof callback) throw TypeError();", "var o = Object(this), len = o.length >>> 0, k = len - 1, value;", "if (arguments.length >= 2) {", "value = arguments[1];", "} else {", "while (k >= 0 && !(k in o)) k--;", "if (k < 0) {", "throw TypeError('Reduce of empty array with no initial value');", "}", "value = o[k--];", "}", "for (; k >= 0; k--) {", "if (k in o) value = callback(value, o[k], k, o);", "}", "return value;", "}", "});", // Polyfill copied from:
                    // developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/some
                    "Object.defineProperty(Array.prototype, 'some',", "{configurable: true, writable: true, value:", "function some(fun/*, thisArg*/) {", "if (!this || typeof fun !== 'function') throw TypeError();", "var o = Object(this);", "var len = o.length >>> 0;", "var thisArg = arguments.length >= 2 ? arguments[1] : void 0;", "for (var i = 0; i < len; i++) {", "if (i in o && fun.call(thisArg, o[i], i, o)) {", "return true;", "}", "}", "return false;", "}", "});", "Object.defineProperty(Array.prototype, 'sort',", "{configurable: true, writable: true, value:", "function sort(opt_comp) {", "if (!this) throw TypeError();", "if (typeof opt_comp !== 'function') {", "opt_comp = undefined;", "}", "for (var i = 0; i < this.length; i++) {", "var changes = 0;", "for (var j = 0; j < this.length - i - 1; j++) {", "if (opt_comp ? (opt_comp(this[j], this[j + 1]) > 0) :", "(String(this[j]) > String(this[j + 1]))) {", "var swap = this[j];", "this[j] = this[j + 1];", "this[j + 1] = swap;", "changes++;", "}", "}", "if (!changes) break;", "}", "return this;", "}", "});", "Object.defineProperty(Array.prototype, 'toLocaleString',", "{configurable: true, writable: true, value:", "function toLocaleString() {", "if (!this) throw TypeError();", "var o = Object(this);", "var out = [];", "for (var i = 0; i < o.length; i++) {", "out[i] = (o[i] === null || o[i] === undefined) ? '' : o[i].toLocaleString();", "}", "return out.join(',');", "}", "});", "");
                };
                /**
 * Initialize the String class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initString = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // String constructor.
                    wrapper = function String1(value) {
                        value = arguments.length ? Interpreter.nativeGlobal.String(value) : '';
                        if (thisInterpreter.calledWithNew()) {
                            // Called as `new String()`.
                            this.data = value;
                            return this;
                        } else // Called as `String()`.
                        return value;
                    };
                    this.STRING = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, 'String', this.STRING, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Static methods on String.
                    this.setProperty(this.STRING, 'fromCharCode', this.createNativeFunction(String.fromCharCode, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on String.
                    // Methods with exclusively primitive arguments.
                    var functions = [
                        'charAt',
                        'charCodeAt',
                        'concat',
                        'indexOf',
                        'lastIndexOf',
                        'slice',
                        'substr',
                        'substring',
                        'toLocaleLowerCase',
                        'toLocaleUpperCase',
                        'toLowerCase',
                        'toUpperCase',
                        'trim'
                    ];
                    for(var i = 0; i < functions.length; i++)this.setNativeFunctionPrototype(this.STRING, functions[i], String.prototype[functions[i]]);
                    wrapper = function localeCompare(compareString, locales, options) {
                        locales = thisInterpreter.pseudoToNative(locales);
                        options = thisInterpreter.pseudoToNative(options);
                        try {
                            return String(this).localeCompare(compareString, locales, options);
                        } catch (e) {
                            thisInterpreter.throwException(thisInterpreter.ERROR, 'localeCompare: ' + e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.STRING, 'localeCompare', wrapper);
                    wrapper = function split(separator, limit, callback) {
                        var string = String(this);
                        limit = limit ? Number(limit) : undefined;
                        // Example of catastrophic split RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.split(/^(a+)+b/)
                        if (thisInterpreter.isa(separator, thisInterpreter.REGEXP)) {
                            separator = separator.data;
                            thisInterpreter.maybeThrowRegExp(separator, callback);
                            if (thisInterpreter['REGEXP_MODE'] === 2) {
                                if (Interpreter.vm) {
                                    // Run split in vm.
                                    var sandbox = {
                                        'string': string,
                                        'separator': separator,
                                        'limit': limit
                                    };
                                    var code = 'string.split(separator, limit)';
                                    var jsList = thisInterpreter.vmCall(code, sandbox, separator, callback);
                                    if (jsList !== Interpreter.REGEXP_TIMEOUT) callback(thisInterpreter.arrayNativeToPseudo(jsList));
                                } else {
                                    // Run split in separate thread.
                                    var splitWorker = thisInterpreter.createWorker();
                                    var pid = thisInterpreter.regExpTimeout(separator, splitWorker, callback);
                                    splitWorker.onmessage = function(e) {
                                        clearTimeout(pid);
                                        callback(thisInterpreter.arrayNativeToPseudo(e.data));
                                    };
                                    splitWorker.postMessage([
                                        'split',
                                        string,
                                        separator,
                                        limit
                                    ]);
                                }
                                return;
                            }
                        }
                        // Run split natively.
                        var jsList = string.split(separator, limit);
                        callback(thisInterpreter.arrayNativeToPseudo(jsList));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, 'split', wrapper);
                    wrapper = function match(regexp, callback) {
                        var string = String(this);
                        if (thisInterpreter.isa(regexp, thisInterpreter.REGEXP)) regexp = regexp.data;
                        else regexp = new RegExp(regexp);
                        // Example of catastrophic match RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.match(/^(a+)+b/)
                        thisInterpreter.maybeThrowRegExp(regexp, callback);
                        if (thisInterpreter['REGEXP_MODE'] === 2) {
                            if (Interpreter.vm) {
                                // Run match in vm.
                                var sandbox = {
                                    'string': string,
                                    'regexp': regexp
                                };
                                var code = 'string.match(regexp)';
                                var m = thisInterpreter.vmCall(code, sandbox, regexp, callback);
                                if (m !== Interpreter.REGEXP_TIMEOUT) callback(m && thisInterpreter.arrayNativeToPseudo(m));
                            } else {
                                // Run match in separate thread.
                                var matchWorker = thisInterpreter.createWorker();
                                var pid = thisInterpreter.regExpTimeout(regexp, matchWorker, callback);
                                matchWorker.onmessage = function(e) {
                                    clearTimeout(pid);
                                    callback(e.data && thisInterpreter.arrayNativeToPseudo(e.data));
                                };
                                matchWorker.postMessage([
                                    'match',
                                    string,
                                    regexp
                                ]);
                            }
                            return;
                        }
                        // Run match natively.
                        var m = string.match(regexp);
                        callback(m && thisInterpreter.arrayNativeToPseudo(m));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, 'match', wrapper);
                    wrapper = function search(regexp, callback) {
                        var string = String(this);
                        if (thisInterpreter.isa(regexp, thisInterpreter.REGEXP)) regexp = regexp.data;
                        else regexp = new RegExp(regexp);
                        // Example of catastrophic search RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.search(/^(a+)+b/)
                        thisInterpreter.maybeThrowRegExp(regexp, callback);
                        if (thisInterpreter['REGEXP_MODE'] === 2) {
                            if (Interpreter.vm) {
                                // Run search in vm.
                                var sandbox = {
                                    'string': string,
                                    'regexp': regexp
                                };
                                var code = 'string.search(regexp)';
                                var n = thisInterpreter.vmCall(code, sandbox, regexp, callback);
                                if (n !== Interpreter.REGEXP_TIMEOUT) callback(n);
                            } else {
                                // Run search in separate thread.
                                var searchWorker = thisInterpreter.createWorker();
                                var pid = thisInterpreter.regExpTimeout(regexp, searchWorker, callback);
                                searchWorker.onmessage = function(e) {
                                    clearTimeout(pid);
                                    callback(e.data);
                                };
                                searchWorker.postMessage([
                                    'search',
                                    string,
                                    regexp
                                ]);
                            }
                            return;
                        }
                        // Run search natively.
                        callback(string.search(regexp));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, 'search', wrapper);
                    wrapper = function replace_(substr, newSubstr, callback) {
                        // Support for function replacements is the responsibility of a polyfill.
                        var string = String(this);
                        newSubstr = String(newSubstr);
                        // Example of catastrophic replace RegExp:
                        // 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac'.replace(/^(a+)+b/, '')
                        if (thisInterpreter.isa(substr, thisInterpreter.REGEXP)) {
                            substr = substr.data;
                            thisInterpreter.maybeThrowRegExp(substr, callback);
                            if (thisInterpreter['REGEXP_MODE'] === 2) {
                                if (Interpreter.vm) {
                                    // Run replace in vm.
                                    var sandbox = {
                                        'string': string,
                                        'substr': substr,
                                        'newSubstr': newSubstr
                                    };
                                    var code = 'string.replace(substr, newSubstr)';
                                    var str = thisInterpreter.vmCall(code, sandbox, substr, callback);
                                    if (str !== Interpreter.REGEXP_TIMEOUT) callback(str);
                                } else {
                                    // Run replace in separate thread.
                                    var replaceWorker = thisInterpreter.createWorker();
                                    var pid = thisInterpreter.regExpTimeout(substr, replaceWorker, callback);
                                    replaceWorker.onmessage = function(e) {
                                        clearTimeout(pid);
                                        callback(e.data);
                                    };
                                    replaceWorker.postMessage([
                                        'replace',
                                        string,
                                        substr,
                                        newSubstr
                                    ]);
                                }
                                return;
                            }
                        }
                        // Run replace natively.
                        callback(string.replace(substr, newSubstr));
                    };
                    this.setAsyncFunctionPrototype(this.STRING, 'replace', wrapper);
                    // Add a polyfill to handle replace's second argument being a function.
                    this.polyfills_.push("(function() {", "var replace_ = String.prototype.replace;", "String.prototype.replace = function replace(substr, newSubstr) {", "if (typeof newSubstr !== 'function') {", // string.replace(string|regexp, string)
                    "return replace_.call(this, substr, newSubstr);", "}", "var str = this;", "if (substr instanceof RegExp) {", "var subs = [];", "var m = substr.exec(str);", "while (m) {", "m.push(m.index, str);", "var inject = newSubstr.apply(null, m);", "subs.push([m.index, m[0].length, inject]);", "m = substr.global ? substr.exec(str) : null;", "}", "for (var i = subs.length - 1; i >= 0; i--) {", "str = str.substring(0, subs[i][0]) + subs[i][2] + str.substring(subs[i][0] + subs[i][1]);", "}", "} else {", "var i = str.indexOf(substr);", "if (i !== -1) {", "var inject = newSubstr(str.substr(i, substr.length), i, str);", "str = str.substring(0, i) + inject + str.substring(i + substr.length);", "}", "}", "return str;", "};", "})();", "");
                };
                /**
 * Initialize the Boolean class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initBoolean = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Boolean constructor.
                    wrapper = function Boolean1(value) {
                        value = Interpreter.nativeGlobal.Boolean(value);
                        if (thisInterpreter.calledWithNew()) {
                            // Called as `new Boolean()`.
                            this.data = value;
                            return this;
                        } else // Called as `Boolean()`.
                        return value;
                    };
                    this.BOOLEAN = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, 'Boolean', this.BOOLEAN, Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize the Number class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initNumber = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Number constructor.
                    wrapper = function Number1(value) {
                        value = arguments.length ? Interpreter.nativeGlobal.Number(value) : 0;
                        if (thisInterpreter.calledWithNew()) {
                            // Called as `new Number()`.
                            this.data = value;
                            return this;
                        } else // Called as `Number()`.
                        return value;
                    };
                    this.NUMBER = this.createNativeFunction(wrapper, true);
                    this.setProperty(globalObject, 'Number', this.NUMBER, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var numConsts = [
                        'MAX_VALUE',
                        'MIN_VALUE',
                        'NaN',
                        'NEGATIVE_INFINITY',
                        'POSITIVE_INFINITY'
                    ];
                    for(var i = 0; i < numConsts.length; i++)this.setProperty(this.NUMBER, numConsts[i], Number[numConsts[i]], Interpreter.NONCONFIGURABLE_READONLY_NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Number.
                    wrapper = function toExponential(fractionDigits) {
                        try {
                            return Number(this).toExponential(fractionDigits);
                        } catch (e) {
                            // Throws if fractionDigits isn't within 0-20.
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, 'toExponential', wrapper);
                    wrapper = function toFixed(digits) {
                        try {
                            return Number(this).toFixed(digits);
                        } catch (e) {
                            // Throws if digits isn't within 0-20.
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, 'toFixed', wrapper);
                    wrapper = function toPrecision(precision) {
                        try {
                            return Number(this).toPrecision(precision);
                        } catch (e) {
                            // Throws if precision isn't within range (depends on implementation).
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, 'toPrecision', wrapper);
                    wrapper = function toString(radix) {
                        try {
                            return Number(this).toString(radix);
                        } catch (e) {
                            // Throws if radix isn't within 2-36.
                            thisInterpreter.throwException(thisInterpreter.ERROR, e.message);
                        }
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, 'toString', wrapper);
                    wrapper = function toLocaleString(locales, options) {
                        locales = locales ? thisInterpreter.pseudoToNative(locales) : undefined;
                        options = options ? thisInterpreter.pseudoToNative(options) : undefined;
                        return Number(this).toLocaleString(locales, options);
                    };
                    this.setNativeFunctionPrototype(this.NUMBER, 'toLocaleString', wrapper);
                };
                /**
 * Initialize the Date class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initDate = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // Date constructor.
                    wrapper = function Date1(value, var_args) {
                        if (!thisInterpreter.calledWithNew()) // Called as `Date()`.
                        // Calling Date() as a function returns a string, no arguments are heeded.
                        return Interpreter.nativeGlobal.Date();
                        // Called as `new Date()`.
                        var args = [
                            null
                        ].concat(Array.from(arguments));
                        this.data = new (Function.prototype.bind.apply(Interpreter.nativeGlobal.Date, args));
                        return this;
                    };
                    this.DATE = this.createNativeFunction(wrapper, true);
                    this.DATE_PROTO = this.DATE.properties['prototype'];
                    this.setProperty(globalObject, 'Date', this.DATE, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Static methods on Date.
                    this.setProperty(this.DATE, 'now', this.createNativeFunction(Date.now, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.DATE, 'parse', this.createNativeFunction(Date.parse, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.DATE, 'UTC', this.createNativeFunction(Date.UTC, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                    // Instance methods on Date.
                    var functions = [
                        'getDate',
                        'getDay',
                        'getFullYear',
                        'getHours',
                        'getMilliseconds',
                        'getMinutes',
                        'getMonth',
                        'getSeconds',
                        'getTime',
                        'getTimezoneOffset',
                        'getUTCDate',
                        'getUTCDay',
                        'getUTCFullYear',
                        'getUTCHours',
                        'getUTCMilliseconds',
                        'getUTCMinutes',
                        'getUTCMonth',
                        'getUTCSeconds',
                        'getYear',
                        'setDate',
                        'setFullYear',
                        'setHours',
                        'setMilliseconds',
                        'setMinutes',
                        'setMonth',
                        'setSeconds',
                        'setTime',
                        'setUTCDate',
                        'setUTCFullYear',
                        'setUTCHours',
                        'setUTCMilliseconds',
                        'setUTCMinutes',
                        'setUTCMonth',
                        'setUTCSeconds',
                        'setYear',
                        'toDateString',
                        'toISOString',
                        'toJSON',
                        'toGMTString',
                        'toLocaleDateString',
                        'toLocaleString',
                        'toLocaleTimeString',
                        'toTimeString',
                        'toUTCString'
                    ];
                    for(var i = 0; i < functions.length; i++){
                        wrapper = function(nativeFunc) {
                            return function(var_args) {
                                var date = this.data;
                                if (!(date instanceof Date)) thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, nativeFunc + ' not called on a Date');
                                var args = [];
                                for(var i = 0; i < arguments.length; i++)args[i] = thisInterpreter.pseudoToNative(arguments[i]);
                                return date[nativeFunc].apply(date, args);
                            };
                        }(functions[i]);
                        this.setNativeFunctionPrototype(this.DATE, functions[i], wrapper);
                    }
                };
                /**
 * Initialize Regular Expression object.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initRegExp = function(globalObject) {
                    var thisInterpreter = this;
                    var wrapper;
                    // RegExp constructor.
                    wrapper = function RegExp1(pattern, flags) {
                        if (thisInterpreter.calledWithNew()) // Called as `new RegExp()`.
                        var rgx = this;
                        else // Called as `RegExp()`.
                        var rgx = thisInterpreter.createObjectProto(thisInterpreter.REGEXP_PROTO);
                        pattern = pattern ? String(pattern) : '';
                        flags = flags ? String(flags) : '';
                        thisInterpreter.populateRegExp(rgx, new Interpreter.nativeGlobal.RegExp(pattern, flags));
                        return rgx;
                    };
                    this.REGEXP = this.createNativeFunction(wrapper, true);
                    this.REGEXP_PROTO = this.REGEXP.properties['prototype'];
                    this.setProperty(globalObject, 'RegExp', this.REGEXP, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties['prototype'], 'global', undefined, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties['prototype'], 'ignoreCase', undefined, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties['prototype'], 'multiline', undefined, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.REGEXP.properties['prototype'], 'source', '(?:)', Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    // Use polyfill to avoid complexity of regexp threads.
                    this.polyfills_.push("Object.defineProperty(RegExp.prototype, 'test',", "{configurable: true, writable: true, value:", "function test(str) {", "return String(str).search(this) !== -1", "}", "});");
                    wrapper = function exec(string, callback) {
                        var regexp = this.data;
                        string = String(string);
                        // Get lastIndex from wrapped regexp, since this is settable.
                        regexp.lastIndex = Number(thisInterpreter.getProperty(this, 'lastIndex'));
                        // Example of catastrophic exec RegExp:
                        // /^(a+)+b/.exec('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaac')
                        thisInterpreter.maybeThrowRegExp(regexp, callback);
                        if (thisInterpreter['REGEXP_MODE'] === 2) {
                            if (Interpreter.vm) {
                                // Run exec in vm.
                                var sandbox = {
                                    'string': string,
                                    'regexp': regexp
                                };
                                var code = 'regexp.exec(string)';
                                var match = thisInterpreter.vmCall(code, sandbox, regexp, callback);
                                if (match !== Interpreter.REGEXP_TIMEOUT) {
                                    thisInterpreter.setProperty(this, 'lastIndex', regexp.lastIndex);
                                    callback(matchToPseudo(match));
                                }
                            } else {
                                // Run exec in separate thread.
                                // Note that lastIndex is not preserved when a RegExp is passed to a
                                // Web Worker.  Thus it needs to be passed back and forth separately.
                                var execWorker = thisInterpreter.createWorker();
                                var pid = thisInterpreter.regExpTimeout(regexp, execWorker, callback);
                                var thisPseudoRegExp = this;
                                execWorker.onmessage = function(e) {
                                    clearTimeout(pid);
                                    // Return tuple: [result, lastIndex]
                                    thisInterpreter.setProperty(thisPseudoRegExp, 'lastIndex', e.data[1]);
                                    callback(matchToPseudo(e.data[0]));
                                };
                                execWorker.postMessage([
                                    'exec',
                                    regexp,
                                    regexp.lastIndex,
                                    string
                                ]);
                            }
                            return;
                        }
                        // Run exec natively.
                        var match = regexp.exec(string);
                        thisInterpreter.setProperty(this, 'lastIndex', regexp.lastIndex);
                        callback(matchToPseudo(match));
                        function matchToPseudo(match) {
                            if (match) {
                                var result = thisInterpreter.arrayNativeToPseudo(match);
                                // match has additional properties.
                                thisInterpreter.setProperty(result, 'index', match.index);
                                thisInterpreter.setProperty(result, 'input', match.input);
                                return result;
                            }
                            return null;
                        }
                    };
                    this.setAsyncFunctionPrototype(this.REGEXP, 'exec', wrapper);
                };
                /**
 * Initialize the Error class.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initError = function(globalObject) {
                    var thisInterpreter = this;
                    // Error constructor.
                    this.ERROR = this.createNativeFunction(function Error1(opt_message) {
                        if (thisInterpreter.calledWithNew()) // Called as `new Error()`.
                        var newError = this;
                        else // Called as `Error()`.
                        var newError = thisInterpreter.createObject(thisInterpreter.ERROR);
                        if (opt_message) thisInterpreter.setProperty(newError, 'message', String(opt_message), Interpreter.NONENUMERABLE_DESCRIPTOR);
                        return newError;
                    }, true);
                    this.setProperty(globalObject, 'Error', this.ERROR, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.ERROR.properties['prototype'], 'message', '', Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(this.ERROR.properties['prototype'], 'name', 'Error', Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var createErrorSubclass = function(name) {
                        var constructor = thisInterpreter.createNativeFunction(function(opt_message) {
                            if (thisInterpreter.calledWithNew()) // Called as `new XyzError()`.
                            var newError = this;
                            else // Called as `XyzError()`.
                            var newError = thisInterpreter.createObject(constructor);
                            if (opt_message) thisInterpreter.setProperty(newError, 'message', String(opt_message), Interpreter.NONENUMERABLE_DESCRIPTOR);
                            return newError;
                        }, true);
                        thisInterpreter.setProperty(constructor, 'prototype', thisInterpreter.createObject(thisInterpreter.ERROR), Interpreter.NONENUMERABLE_DESCRIPTOR);
                        thisInterpreter.setProperty(constructor.properties['prototype'], 'name', name, Interpreter.NONENUMERABLE_DESCRIPTOR);
                        thisInterpreter.setProperty(globalObject, name, constructor, Interpreter.NONENUMERABLE_DESCRIPTOR);
                        return constructor;
                    };
                    this.EVAL_ERROR = createErrorSubclass('EvalError');
                    this.RANGE_ERROR = createErrorSubclass('RangeError');
                    this.REFERENCE_ERROR = createErrorSubclass('ReferenceError');
                    this.SYNTAX_ERROR = createErrorSubclass('SyntaxError');
                    this.TYPE_ERROR = createErrorSubclass('TypeError');
                    this.URI_ERROR = createErrorSubclass('URIError');
                };
                /**
 * Initialize Math object.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initMath = function(globalObject) {
                    var myMath = this.createObjectProto(this.OBJECT_PROTO);
                    this.setProperty(globalObject, 'Math', myMath, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var mathConsts = [
                        'E',
                        'LN2',
                        'LN10',
                        'LOG2E',
                        'LOG10E',
                        'PI',
                        'SQRT1_2',
                        'SQRT2'
                    ];
                    for(var i = 0; i < mathConsts.length; i++)this.setProperty(myMath, mathConsts[i], Math[mathConsts[i]], Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    var numFunctions = [
                        'abs',
                        'acos',
                        'asin',
                        'atan',
                        'atan2',
                        'ceil',
                        'cos',
                        'exp',
                        'floor',
                        'log',
                        'max',
                        'min',
                        'pow',
                        'random',
                        'round',
                        'sin',
                        'sqrt',
                        'tan'
                    ];
                    for(var i = 0; i < numFunctions.length; i++)this.setProperty(myMath, numFunctions[i], this.createNativeFunction(Math[numFunctions[i]], false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Initialize JSON object.
 * @param {!Interpreter.Object} globalObject Global object.
 */ Interpreter.prototype.initJSON = function(globalObject) {
                    var thisInterpreter = this;
                    var myJSON = thisInterpreter.createObjectProto(this.OBJECT_PROTO);
                    this.setProperty(globalObject, 'JSON', myJSON, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    var wrapper = function parse(text) {
                        try {
                            var nativeObj = JSON.parse(String(text));
                        } catch (e) {
                            thisInterpreter.throwException(thisInterpreter.SYNTAX_ERROR, e.message);
                        }
                        return thisInterpreter.nativeToPseudo(nativeObj);
                    };
                    this.setProperty(myJSON, 'parse', this.createNativeFunction(wrapper, false));
                    wrapper = function stringify(value, replacer, space) {
                        if (replacer && replacer.class === 'Function') thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, 'Function replacer on JSON.stringify not supported');
                        else if (replacer && replacer.class === 'Array') {
                            replacer = thisInterpreter.arrayPseudoToNative(replacer);
                            replacer = replacer.filter(function(word) {
                                // Spec says we should also support boxed primitives here.
                                return typeof word === 'string' || typeof word === 'number';
                            });
                        } else replacer = null;
                        // Spec says we should also support boxed primitives here.
                        if (typeof space !== 'string' && typeof space !== 'number') space = undefined;
                        var nativeObj = thisInterpreter.pseudoToNative(value);
                        try {
                            var str = JSON.stringify(nativeObj, replacer, space);
                        } catch (e) {
                            thisInterpreter.throwException(thisInterpreter.TYPE_ERROR, e.message);
                        }
                        return str;
                    };
                    this.setProperty(myJSON, 'stringify', this.createNativeFunction(wrapper, false));
                };
                /**
 * Is an object of a certain class?
 * @param {Interpreter.Value} child Object to check.
 * @param {Interpreter.Object} constructor Constructor of object.
 * @return {boolean} True if object is the class or inherits from it.
 *     False otherwise.
 */ Interpreter.prototype.isa = function(child, constructor) {
                    if (child === null || child === undefined || !constructor) return false;
                    var proto = constructor.properties['prototype'];
                    if (child === proto) return true;
                    // The first step up the prototype chain is harder since the child might be
                    // a primitive value.  Subsequent steps can just follow the .proto property.
                    child = this.getPrototype(child);
                    while(child){
                        if (child === proto) return true;
                        child = child.proto;
                    }
                    return false;
                };
                /**
 * Initialize a pseudo regular expression object based on a native regular
 * expression object.
 * @param {!Interpreter.Object} pseudoRegexp The existing object to set.
 * @param {!RegExp} nativeRegexp The native regular expression.
 */ Interpreter.prototype.populateRegExp = function(pseudoRegexp, nativeRegexp) {
                    pseudoRegexp.data = new RegExp(nativeRegexp.source, nativeRegexp.flags);
                    // lastIndex is settable, all others are read-only attributes
                    this.setProperty(pseudoRegexp, 'lastIndex', nativeRegexp.lastIndex, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, 'source', nativeRegexp.source, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, 'global', nativeRegexp.global, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, 'ignoreCase', nativeRegexp.ignoreCase, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    this.setProperty(pseudoRegexp, 'multiline', nativeRegexp.multiline, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Create a Web Worker to execute regular expressions.
 * Using a separate file fails in Chrome when run locally on a file:// URI.
 * Using a data encoded URI fails in IE and Edge.
 * Using a blob works in IE11 and all other browsers.
 * @return {!Worker} Web Worker with regexp execution code loaded.
 */ Interpreter.prototype.createWorker = function() {
                    var blob = this.createWorker.blob_;
                    if (!blob) {
                        blob = new Blob([
                            Interpreter.WORKER_CODE.join('\n')
                        ], {
                            type: 'application/javascript'
                        });
                        // Cache the blob, so it doesn't need to be created next time.
                        this.createWorker.blob_ = blob;
                    }
                    return new Worker(URL.createObjectURL(blob));
                };
                /**
 * Execute regular expressions in a node vm.
 * @param {string} code Code to execute.
 * @param {!Object} sandbox Global variables for new vm.
 * @param {!RegExp} nativeRegExp Regular expression.
 * @param {!Function} callback Asynchronous callback function.
 */ Interpreter.prototype.vmCall = function(code, sandbox, nativeRegExp, callback) {
                    var options = {
                        'timeout': this['REGEXP_THREAD_TIMEOUT']
                    };
                    try {
                        return Interpreter.vm['runInNewContext'](code, sandbox, options);
                    } catch (e) {
                        callback(null);
                        this.throwException(this.ERROR, 'RegExp Timeout: ' + nativeRegExp);
                    }
                    return Interpreter.REGEXP_TIMEOUT;
                };
                /**
 * If REGEXP_MODE is 0, then throw an error.
 * Also throw if REGEXP_MODE is 2 and JS doesn't support Web Workers or vm.
 * @param {!RegExp} nativeRegExp Regular expression.
 * @param {!Function} callback Asynchronous callback function.
 */ Interpreter.prototype.maybeThrowRegExp = function(nativeRegExp, callback) {
                    var ok;
                    if (this['REGEXP_MODE'] === 0) // Fail: No RegExp support.
                    ok = false;
                    else if (this['REGEXP_MODE'] === 1) // Ok: Native RegExp support.
                    ok = true;
                    else {
                        // Sandboxed RegExp handling.
                        if (Interpreter.vm) // Ok: Node's vm module already loaded.
                        ok = true;
                        else if (typeof Worker === 'function' && typeof URL === 'function') // Ok: Web Workers available.
                        ok = true;
                        else {
                            // Try to load Node's vm module.
                            try {
                                Interpreter.vm = __webpack_require__(/*! vm */ "./node_modules/vm-browserify/index.js");
                            } catch (e) {}
                            ok = !!Interpreter.vm;
                        }
                    }
                    if (!ok) {
                        callback(null);
                        this.throwException(this.ERROR, 'Regular expressions not supported: ' + nativeRegExp);
                    }
                };
                /**
 * Set a timeout for regular expression threads.  Unless cancelled, this will
 * terminate the thread and throw an error.
 * @param {!RegExp} nativeRegExp Regular expression (used for error message).
 * @param {!Worker} worker Thread to terminate.
 * @param {!Function} callback Async callback function to continue execution.
 * @return {number} PID of timeout.  Used to cancel if thread completes.
 */ Interpreter.prototype.regExpTimeout = function(nativeRegExp, worker, callback) {
                    var thisInterpreter = this;
                    return setTimeout(function() {
                        worker.terminate();
                        callback(null);
                        try {
                            thisInterpreter.throwException(thisInterpreter.ERROR, 'RegExp Timeout: ' + nativeRegExp);
                        } catch (e) {
                        // Eat the expected Interpreter.STEP_ERROR.
                        }
                    }, this['REGEXP_THREAD_TIMEOUT']);
                };
                /**
 * Create a new data object based on a constructor's prototype.
 * @param {Interpreter.Object} constructor Parent constructor function,
 *     or null if scope object.
 * @return {!Interpreter.Object} New data object.
 */ Interpreter.prototype.createObject = function(constructor) {
                    return this.createObjectProto(constructor && constructor.properties['prototype']);
                };
                /**
 * Create a new data object based on a prototype.
 * @param {Interpreter.Object} proto Prototype object.
 * @return {!Interpreter.Object} New data object.
 */ Interpreter.prototype.createObjectProto = function(proto) {
                    if (typeof proto !== 'object') throw Error('Non object prototype');
                    var obj = new Interpreter.Object(proto);
                    if (this.isa(obj, this.ERROR)) // Record this object as being an error so that its toString function can
                    // process it correctly (toString has no access to the interpreter and could
                    // not otherwise determine that the object is an error).
                    obj.class = 'Error';
                    return obj;
                };
                /**
 * Create a new array.
 * @return {!Interpreter.Object} New array.
 */ Interpreter.prototype.createArray = function() {
                    var array = this.createObjectProto(this.ARRAY_PROTO);
                    // Arrays have length.
                    this.setProperty(array, 'length', 0, {
                        configurable: false,
                        enumerable: false,
                        writable: true
                    });
                    array.class = 'Array';
                    return array;
                };
                /**
 * Create a new function object (could become interpreted or native or async).
 * @param {number} argumentLength Number of arguments.
 * @param {boolean} isConstructor True if function can be used with 'new'.
 * @return {!Interpreter.Object} New function.
 * @private
 */ Interpreter.prototype.createFunctionBase_ = function(argumentLength, isConstructor) {
                    var func = this.createObjectProto(this.FUNCTION_PROTO);
                    if (isConstructor) {
                        var proto = this.createObjectProto(this.OBJECT_PROTO);
                        this.setProperty(func, 'prototype', proto, Interpreter.NONENUMERABLE_DESCRIPTOR);
                        this.setProperty(proto, 'constructor', func, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    } else func.illegalConstructor = true;
                    this.setProperty(func, 'length', argumentLength, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    func.class = 'Function';
                    // When making changes to this function, check to see if those changes also
                    // need to be made to the creation of FUNCTION_PROTO in initFunction.
                    return func;
                };
                /**
 * Create a new interpreted function.
 * @param {!Object} node AST node defining the function.
 * @param {!Interpreter.Scope} scope Parent scope.
 * @param {string=} opt_name Optional name for function.
 * @return {!Interpreter.Object} New function.
 */ Interpreter.prototype.createFunction = function(node, scope, opt_name) {
                    var func = this.createFunctionBase_(node['params'].length, true);
                    func.parentScope = scope;
                    func.node = node;
                    // Choose a name for this function.
                    // function foo() {}             -> 'foo'
                    // var bar = function() {};      -> 'bar'
                    // var bar = function foo() {};  -> 'foo'
                    // foo.bar = function() {};      -> ''
                    // var bar = new Function('');   -> 'anonymous'
                    var name = node['id'] ? String(node['id']['name']) : opt_name || '';
                    this.setProperty(func, 'name', name, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    return func;
                };
                /**
 * Create a new native function.
 * @param {!Function} nativeFunc JavaScript function.
 * @param {boolean} isConstructor True if function can be used with 'new'.
 * @return {!Interpreter.Object} New function.
 */ Interpreter.prototype.createNativeFunction = function(nativeFunc, isConstructor) {
                    var func = this.createFunctionBase_(nativeFunc.length, isConstructor);
                    func.nativeFunc = nativeFunc;
                    nativeFunc.id = this.functionCounter_++;
                    this.setProperty(func, 'name', nativeFunc.name, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    return func;
                };
                /**
 * Create a new native asynchronous function.
 * @param {!Function} asyncFunc JavaScript function.
 * @return {!Interpreter.Object} New function.
 */ Interpreter.prototype.createAsyncFunction = function(asyncFunc) {
                    var func = this.createFunctionBase_(asyncFunc.length, true);
                    func.asyncFunc = asyncFunc;
                    asyncFunc.id = this.functionCounter_++;
                    this.setProperty(func, 'name', asyncFunc.name, Interpreter.READONLY_NONENUMERABLE_DESCRIPTOR);
                    return func;
                };
                /**
 * Converts from a native JavaScript object or value to a JS-Interpreter object.
 * Can handle JSON-style values, regular expressions, dates and functions.
 * Does NOT handle cycles.
 * @param {*} nativeObj The native JavaScript object to be converted.
 * @return {Interpreter.Value} The equivalent JS-Interpreter object.
 */ Interpreter.prototype.nativeToPseudo = function(nativeObj) {
                    if (nativeObj instanceof Interpreter.Object) throw Error('Object is already pseudo');
                    if (typeof nativeObj !== 'object' && typeof nativeObj !== 'function' || nativeObj === null) return nativeObj;
                    if (nativeObj instanceof RegExp) {
                        var pseudoRegexp = this.createObjectProto(this.REGEXP_PROTO);
                        this.populateRegExp(pseudoRegexp, nativeObj);
                        return pseudoRegexp;
                    }
                    if (nativeObj instanceof Date) {
                        var pseudoDate = this.createObjectProto(this.DATE_PROTO);
                        pseudoDate.data = new Date(nativeObj.valueOf());
                        return pseudoDate;
                    }
                    if (typeof nativeObj === 'function') {
                        var thisInterpreter = this;
                        var wrapper = function() {
                            var args = Array.prototype.slice.call(arguments).map(function(i) {
                                return thisInterpreter.pseudoToNative(i);
                            });
                            var value = nativeObj.apply(thisInterpreter, args);
                            return thisInterpreter.nativeToPseudo(value);
                        };
                        var prototype = Object.getOwnPropertyDescriptor(nativeObj, 'prototype');
                        return this.createNativeFunction(wrapper, !!prototype);
                    }
                    if (Array.isArray(nativeObj)) {
                        var pseudoArray = this.createArray();
                        for(var i = 0; i < nativeObj.length; i++)if (i in nativeObj) this.setProperty(pseudoArray, i, this.nativeToPseudo(nativeObj[i]));
                        return pseudoArray;
                    }
                    // Object.
                    var pseudoObj = this.createObjectProto(this.OBJECT_PROTO);
                    for(var key in nativeObj)this.setProperty(pseudoObj, key, this.nativeToPseudo(nativeObj[key]));
                    return pseudoObj;
                };
                /**
 * Converts from a JS-Interpreter object to native JavaScript object.
 * Can handle JSON-style values, regular expressions, and dates.
 * Does handle cycles.
 * @param {Interpreter.Value} pseudoObj The JS-Interpreter object to be
 * converted.
 * @param {Object=} opt_cycles Cycle detection (used in recursive calls).
 * @return {*} The equivalent native JavaScript object or value.
 */ Interpreter.prototype.pseudoToNative = function(pseudoObj, opt_cycles) {
                    if (typeof pseudoObj !== 'object' && typeof pseudoObj !== 'function' || pseudoObj === null) return pseudoObj;
                    if (!(pseudoObj instanceof Interpreter.Object)) throw Error('Object is not pseudo');
                    if (this.isa(pseudoObj, this.REGEXP)) {
                        var nativeRegExp = new RegExp(pseudoObj.data.source, pseudoObj.data.flags);
                        nativeRegExp.lastIndex = pseudoObj.data.lastIndex;
                        return nativeRegExp;
                    }
                    if (this.isa(pseudoObj, this.DATE)) return new Date(pseudoObj.data.valueOf());
                    var cycles = opt_cycles || {
                        pseudo: [],
                        native: []
                    };
                    var i = cycles.pseudo.indexOf(pseudoObj);
                    if (i !== -1) return cycles.native[i];
                    cycles.pseudo.push(pseudoObj);
                    var nativeObj;
                    if (this.isa(pseudoObj, this.ARRAY)) {
                        nativeObj = [];
                        cycles.native.push(nativeObj);
                        var len = this.getProperty(pseudoObj, 'length');
                        for(var i = 0; i < len; i++)if (this.hasProperty(pseudoObj, i)) nativeObj[i] = this.pseudoToNative(this.getProperty(pseudoObj, i), cycles);
                    } else {
                        nativeObj = {};
                        cycles.native.push(nativeObj);
                        var val;
                        for(var key in pseudoObj.properties){
                            val = this.pseudoToNative(pseudoObj.properties[key], cycles);
                            // Use defineProperty to avoid side effects if setting '__proto__'.
                            Object.defineProperty(nativeObj, key, {
                                value: val,
                                writable: true,
                                enumerable: true,
                                configurable: true
                            });
                        }
                    }
                    cycles.pseudo.pop();
                    cycles.native.pop();
                    return nativeObj;
                };
                /**
 * Converts from a native JavaScript array to a JS-Interpreter array.
 * Does handle non-numeric properties (like str.match's index prop).
 * Does NOT recurse into the array's contents.
 * @param {!Array} nativeArray The JavaScript array to be converted.
 * @return {!Interpreter.Object} The equivalent JS-Interpreter array.
 */ Interpreter.prototype.arrayNativeToPseudo = function(nativeArray) {
                    var pseudoArray = this.createArray();
                    var props = Object.getOwnPropertyNames(nativeArray);
                    for(var i = 0; i < props.length; i++)this.setProperty(pseudoArray, props[i], nativeArray[props[i]]);
                    return pseudoArray;
                };
                /**
 * Converts from a JS-Interpreter array to native JavaScript array.
 * Does handle non-numeric properties (like str.match's index prop).
 * Does NOT recurse into the array's contents.
 * @param {!Interpreter.Object} pseudoArray The JS-Interpreter array,
 *     or JS-Interpreter object pretending to be an array.
 * @return {!Array} The equivalent native JavaScript array.
 */ Interpreter.prototype.arrayPseudoToNative = function(pseudoArray) {
                    var nativeArray = [];
                    for(var key in pseudoArray.properties)nativeArray[key] = this.getProperty(pseudoArray, key);
                    // pseudoArray might be an object pretending to be an array.  In this case
                    // it's possible that length is non-existent, invalid, or smaller than the
                    // largest defined numeric property.  Set length explicitly here.
                    nativeArray.length = Interpreter.legalArrayLength(this.getProperty(pseudoArray, 'length')) || 0;
                    return nativeArray;
                };
                /**
 * Look up the prototype for this value.
 * @param {Interpreter.Value} value Data object.
 * @return {Interpreter.Object} Prototype object, null if none.
 */ Interpreter.prototype.getPrototype = function(value) {
                    switch(typeof value){
                        case 'number':
                            return this.NUMBER.properties['prototype'];
                        case 'boolean':
                            return this.BOOLEAN.properties['prototype'];
                        case 'string':
                            return this.STRING.properties['prototype'];
                    }
                    if (value) return value.proto;
                    return null;
                };
                /**
 * Fetch a property value from a data object.
 * @param {Interpreter.Value} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @return {Interpreter.Value} Property value (may be undefined).
 */ Interpreter.prototype.getProperty = function(obj, name) {
                    if (this.getterStep_) throw Error('Getter not supported in that context');
                    name = String(name);
                    if (obj === undefined || obj === null) this.throwException(this.TYPE_ERROR, "Cannot read property '" + name + "' of " + obj);
                    if (typeof obj === 'object' && !(obj instanceof Interpreter.Object)) throw TypeError('Expecting native value or pseudo object');
                    if (name === 'length') {
                        // Special cases for magic length property.
                        if (this.isa(obj, this.STRING)) return String(obj).length;
                    } else if (name.charCodeAt(0) < 0x40) // Might have numbers in there?
                    // Special cases for string array indexing
                    {
                        if (this.isa(obj, this.STRING)) {
                            var n = Interpreter.legalArrayIndex(name);
                            if (!isNaN(n) && n < String(obj).length) return String(obj)[n];
                        }
                    }
                    do if (obj.properties && name in obj.properties) {
                        var getter = obj.getter[name];
                        if (getter) {
                            // Flag this function as being a getter and thus needing immediate
                            // execution (rather than being the value of the property).
                            this.getterStep_ = true;
                            return getter;
                        }
                        return obj.properties[name];
                    }
                    while (obj = this.getPrototype(obj));
                    return undefined;
                };
                /**
 * Does the named property exist on a data object.
 * @param {!Interpreter.Object} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @return {boolean} True if property exists.
 */ Interpreter.prototype.hasProperty = function(obj, name) {
                    if (!(obj instanceof Interpreter.Object)) throw TypeError('Primitive data type has no properties');
                    name = String(name);
                    if (name === 'length' && this.isa(obj, this.STRING)) return true;
                    if (this.isa(obj, this.STRING)) {
                        var n = Interpreter.legalArrayIndex(name);
                        if (!isNaN(n) && n < String(obj).length) return true;
                    }
                    do {
                        if (obj.properties && name in obj.properties) return true;
                    }while (obj = this.getPrototype(obj));
                    return false;
                };
                /**
 * Set a property value on a data object.
 * @param {Interpreter.Value} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @param {Interpreter.Value} value New property value.
 *     Use Interpreter.VALUE_IN_DESCRIPTOR if value is handled by
 *     descriptor instead.
 * @param {Object=} opt_descriptor Optional descriptor object.
 * @return {!Interpreter.Object|undefined} Returns a setter function if one
 *     needs to be called, otherwise undefined.
 */ Interpreter.prototype.setProperty = function(obj, name, value, opt_descriptor) {
                    if (this.setterStep_) // Getter from previous call to setProperty was not handled.
                    throw Error('Setter not supported in that context');
                    name = String(name);
                    if (obj === undefined || obj === null) this.throwException(this.TYPE_ERROR, "Cannot set property '" + name + "' of " + obj);
                    if (typeof obj === 'object' && !(obj instanceof Interpreter.Object)) throw TypeError('Expecting native value or pseudo object');
                    if (opt_descriptor && ('get' in opt_descriptor || 'set' in opt_descriptor) && ('value' in opt_descriptor || 'writable' in opt_descriptor)) this.throwException(this.TYPE_ERROR, "Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
                    var strict = !this.stateStack || this.getScope().strict;
                    if (!(obj instanceof Interpreter.Object)) {
                        if (strict) this.throwException(this.TYPE_ERROR, "Can't create property '" + name + "' on '" + obj + "'");
                        return;
                    }
                    if (this.isa(obj, this.STRING)) {
                        var n = Interpreter.legalArrayIndex(name);
                        if (name === 'length' || !isNaN(n) && n < String(obj).length) {
                            // Can't set length or letters on String objects.
                            if (strict) this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + name + "' of String '" + obj.data + "'");
                            return;
                        }
                    }
                    if (obj.class === 'Array') {
                        // Arrays have a magic length variable that is bound to the elements.
                        var len = obj.properties.length;
                        var i;
                        if (name === 'length') {
                            // Delete elements if length is smaller.
                            if (opt_descriptor) {
                                if (!('value' in opt_descriptor)) return;
                                value = opt_descriptor.value;
                            }
                            value = Interpreter.legalArrayLength(value);
                            if (isNaN(value)) this.throwException(this.RANGE_ERROR, 'Invalid array length');
                            if (value < len) for(i in obj.properties){
                                i = Interpreter.legalArrayIndex(i);
                                if (!isNaN(i) && value <= i) delete obj.properties[i];
                            }
                        } else if (!isNaN(i = Interpreter.legalArrayIndex(name))) // Increase length if this index is larger.
                        obj.properties.length = Math.max(len, i + 1);
                    }
                    if (obj.preventExtensions && !(name in obj.properties)) {
                        if (strict) this.throwException(this.TYPE_ERROR, "Can't add property '" + name + "', object is not extensible");
                        return;
                    }
                    if (opt_descriptor) {
                        // Define the property.
                        var descriptor = {};
                        if ('get' in opt_descriptor && opt_descriptor.get) {
                            obj.getter[name] = opt_descriptor.get;
                            descriptor.get = this.setProperty.placeholderGet_;
                        }
                        if ('set' in opt_descriptor && opt_descriptor.set) {
                            obj.setter[name] = opt_descriptor.set;
                            descriptor.set = this.setProperty.placeholderSet_;
                        }
                        if ('configurable' in opt_descriptor) descriptor.configurable = opt_descriptor.configurable;
                        if ('enumerable' in opt_descriptor) descriptor.enumerable = opt_descriptor.enumerable;
                        if ('writable' in opt_descriptor) {
                            descriptor.writable = opt_descriptor.writable;
                            delete obj.getter[name];
                            delete obj.setter[name];
                        }
                        if ('value' in opt_descriptor) {
                            descriptor.value = opt_descriptor.value;
                            delete obj.getter[name];
                            delete obj.setter[name];
                        } else if (value !== Interpreter.VALUE_IN_DESCRIPTOR) {
                            descriptor.value = value;
                            delete obj.getter[name];
                            delete obj.setter[name];
                        }
                        try {
                            Object.defineProperty(obj.properties, name, descriptor);
                        } catch (e) {
                            this.throwException(this.TYPE_ERROR, 'Cannot redefine property: ' + name);
                        }
                        // Now that the definition has suceeded, clean up any obsolete get/set funcs.
                        if ('get' in opt_descriptor && !opt_descriptor.get) delete obj.getter[name];
                        if ('set' in opt_descriptor && !opt_descriptor.set) delete obj.setter[name];
                    } else {
                        // Set the property.
                        if (value === Interpreter.VALUE_IN_DESCRIPTOR) throw ReferenceError('Value not specified.');
                        // Determine the parent (possibly self) where the property is defined.
                        var defObj = obj;
                        while(!(name in defObj.properties)){
                            defObj = this.getPrototype(defObj);
                            if (!defObj) {
                                // This is a new property.
                                defObj = obj;
                                break;
                            }
                        }
                        if (defObj.setter && defObj.setter[name]) {
                            this.setterStep_ = true;
                            return defObj.setter[name];
                        }
                        if (defObj.getter && defObj.getter[name]) {
                            if (strict) this.throwException(this.TYPE_ERROR, "Cannot set property '" + name + "' of object '" + obj + "' which only has a getter");
                        } else // No setter, simple assignment.
                        try {
                            obj.properties[name] = value;
                        } catch (e) {
                            if (strict) this.throwException(this.TYPE_ERROR, "Cannot assign to read only property '" + name + "' of object '" + obj + "'");
                        }
                    }
                };
                Interpreter.prototype.setProperty.placeholderGet_ = function() {
                    throw Error('Placeholder getter');
                };
                Interpreter.prototype.setProperty.placeholderSet_ = function() {
                    throw Error('Placeholder setter');
                };
                /**
 * Convenience method for adding a native function as a non-enumerable property
 * onto an object's prototype.
 * @param {!Interpreter.Object} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @param {!Function} wrapper Function object.
 */ Interpreter.prototype.setNativeFunctionPrototype = function(obj, name, wrapper) {
                    this.setProperty(obj.properties['prototype'], name, this.createNativeFunction(wrapper, false), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Convenience method for adding an async function as a non-enumerable property
 * onto an object's prototype.
 * @param {!Interpreter.Object} obj Data object.
 * @param {Interpreter.Value} name Name of property.
 * @param {!Function} wrapper Function object.
 */ Interpreter.prototype.setAsyncFunctionPrototype = function(obj, name, wrapper) {
                    this.setProperty(obj.properties['prototype'], name, this.createAsyncFunction(wrapper), Interpreter.NONENUMERABLE_DESCRIPTOR);
                };
                /**
 * Returns the current scope from the stateStack.
 * @return {!Interpreter.Scope} Current scope.
 */ Interpreter.prototype.getScope = function() {
                    var scope = this.stateStack[this.stateStack.length - 1].scope;
                    if (!scope) throw Error('No scope found.');
                    return scope;
                };
                /**
 * Create a new scope dictionary.
 * @param {!Object} node AST node defining the scope container
 *     (e.g. a function).
 * @param {Interpreter.Scope} parentScope Scope to link to.
 * @return {!Interpreter.Scope} New scope.
 */ Interpreter.prototype.createScope = function(node, parentScope) {
                    // Determine if this scope starts with `use strict`.
                    var strict = false;
                    if (parentScope && parentScope.strict) strict = true;
                    else {
                        var firstNode = node['body'] && node['body'][0];
                        if (firstNode && firstNode.expression && firstNode.expression['type'] === 'Literal' && firstNode.expression.value === 'use strict') strict = true;
                    }
                    var object = this.createObjectProto(null);
                    var scope = new Interpreter.Scope(parentScope, strict, object);
                    if (!parentScope) this.initGlobal(scope.object);
                    this.populateScope_(node, scope);
                    return scope;
                };
                /**
 * Create a new special scope dictionary. Similar to createScope(), but
 * doesn't assume that the scope is for a function body.
 * This is used for 'catch' clauses and 'with' statements.
 * @param {!Interpreter.Scope} parentScope Scope to link to.
 * @param {Interpreter.Object=} opt_object Optional object to transform into
 *     scope.
 * @return {!Interpreter.Scope} New scope.
 */ Interpreter.prototype.createSpecialScope = function(parentScope, opt_object) {
                    if (!parentScope) throw Error('parentScope required');
                    var object = opt_object || this.createObjectProto(null);
                    return new Interpreter.Scope(parentScope, parentScope.strict, object);
                };
                /**
 * Retrieves a value from the scope chain.
 * @param {string} name Name of variable.
 * @return {Interpreter.Value} Any value.
 *   May be flagged as being a getter and thus needing immediate execution
 *   (rather than being the value of the property).
 */ Interpreter.prototype.getValueFromScope = function(name) {
                    var scope = this.getScope();
                    while(scope && scope !== this.globalScope){
                        if (name in scope.object.properties) return scope.object.properties[name];
                        scope = scope.parentScope;
                    }
                    // The root scope is also an object which has inherited properties and
                    // could also have getters.
                    if (scope === this.globalScope && this.hasProperty(scope.object, name)) return this.getProperty(scope.object, name);
                    // Typeof operator is unique: it can safely look at non-defined variables.
                    var prevNode = this.stateStack[this.stateStack.length - 1].node;
                    if (prevNode['type'] === 'UnaryExpression' && prevNode['operator'] === 'typeof') return undefined;
                    this.throwException(this.REFERENCE_ERROR, name + ' is not defined');
                };
                /**
 * Sets a value to the current scope.
 * @param {string} name Name of variable.
 * @param {Interpreter.Value} value Value.
 * @return {!Interpreter.Object|undefined} Returns a setter function if one
 *     needs to be called, otherwise undefined.
 */ Interpreter.prototype.setValueToScope = function(name, value) {
                    var scope = this.getScope();
                    var strict = scope.strict;
                    while(scope && scope !== this.globalScope){
                        if (name in scope.object.properties) {
                            scope.object.properties[name] = value;
                            return undefined;
                        }
                        scope = scope.parentScope;
                    }
                    // The root scope is also an object which has readonly properties and
                    // could also have setters.
                    if (scope === this.globalScope && (!strict || this.hasProperty(scope.object, name))) return this.setProperty(scope.object, name, value);
                    this.throwException(this.REFERENCE_ERROR, name + ' is not defined');
                };
                /**
 * Create a new scope for the given node.
 * @param {!Object} node AST node (program or function).
 * @param {!Interpreter.Scope} scope Scope dictionary to populate.
 * @private
 */ Interpreter.prototype.populateScope_ = function(node, scope) {
                    if (node['type'] === 'VariableDeclaration') for(var i = 0; i < node['declarations'].length; i++)this.setProperty(scope.object, node['declarations'][i]['id']['name'], undefined, Interpreter.VARIABLE_DESCRIPTOR);
                    else if (node['type'] === 'FunctionDeclaration') {
                        this.setProperty(scope.object, node['id']['name'], this.createFunction(node, scope), Interpreter.VARIABLE_DESCRIPTOR);
                        return; // Do not recurse into function.
                    } else if (node['type'] === 'FunctionExpression') return; // Do not recurse into function.
                    else if (node['type'] === 'ExpressionStatement') return; // Expressions can't contain variable/function declarations.
                    var nodeClass = node['constructor'];
                    for(var name in node){
                        var prop = node[name];
                        if (prop && typeof prop === 'object') {
                            if (Array.isArray(prop)) {
                                for(var i = 0; i < prop.length; i++)if (prop[i] && prop[i].constructor === nodeClass) this.populateScope_(prop[i], scope);
                            } else if (prop.constructor === nodeClass) this.populateScope_(prop, scope);
                        }
                    }
                };
                /**
 * Is the current state directly being called with as a construction with 'new'.
 * @return {boolean} True if 'new foo()', false if 'foo()'.
 */ Interpreter.prototype.calledWithNew = function() {
                    return this.stateStack[this.stateStack.length - 1].isConstructor;
                };
                /**
 * Gets a value from the scope chain or from an object property.
 * @param {!Array} ref Name of variable or object/propname tuple.
 * @return {Interpreter.Value} Any value.
 *   May be flagged as being a getter and thus needing immediate execution
 *   (rather than being the value of the property).
 */ Interpreter.prototype.getValue = function(ref) {
                    if (ref[0] === Interpreter.SCOPE_REFERENCE) // A null/varname variable lookup.
                    return this.getValueFromScope(ref[1]);
                    else // An obj/prop components tuple (foo.bar).
                    return this.getProperty(ref[0], ref[1]);
                };
                /**
 * Sets a value to the scope chain or to an object property.
 * @param {!Array} ref Name of variable or object/propname tuple.
 * @param {Interpreter.Value} value Value.
 * @return {!Interpreter.Object|undefined} Returns a setter function if one
 *     needs to be called, otherwise undefined.
 */ Interpreter.prototype.setValue = function(ref, value) {
                    if (ref[0] === Interpreter.SCOPE_REFERENCE) // A null/varname variable lookup.
                    return this.setValueToScope(ref[1], value);
                    else // An obj/prop components tuple (foo.bar).
                    return this.setProperty(ref[0], ref[1], value);
                };
                /**
 * Throw an exception in the interpreter that can be handled by an
 * interpreter try/catch statement.  If unhandled, a real exception will
 * be thrown.  Can be called with either an error class and a message, or
 * with an actual object to be thrown.
 * @param {!Interpreter.Object|Interpreter.Value} errorClass Type of error
 *   (if message is provided) or the value to throw (if no message).
 * @param {string=} opt_message Message being thrown.
 */ Interpreter.prototype.throwException = function(errorClass, opt_message) {
                    if (opt_message === undefined) var error = errorClass; // This is a value to throw, not an error class.
                    else {
                        var error = this.createObject(errorClass);
                        this.setProperty(error, 'message', opt_message, Interpreter.NONENUMERABLE_DESCRIPTOR);
                    }
                    this.unwind(Interpreter.Completion.THROW, error, undefined);
                    // Abort anything related to the current step.
                    throw Interpreter.STEP_ERROR;
                };
                /**
 * Unwind the stack to the innermost relevant enclosing TryStatement,
 * For/ForIn/WhileStatement or Call/NewExpression.  If this results in
 * the stack being completely unwound the thread will be terminated
 * and the appropriate error being thrown.
 * @param {Interpreter.Completion} type Completion type.
 * @param {Interpreter.Value} value Value computed, returned or thrown.
 * @param {string|undefined} label Target label for break or return.
 */ Interpreter.prototype.unwind = function(type, value, label) {
                    if (type === Interpreter.Completion.NORMAL) throw TypeError('Should not unwind for NORMAL completions');
                    loop: for(var stack = this.stateStack; stack.length > 0; stack.pop()){
                        var state = stack[stack.length - 1];
                        switch(state.node['type']){
                            case 'TryStatement':
                                state.cv = {
                                    type: type,
                                    value: value,
                                    label: label
                                };
                                return;
                            case 'CallExpression':
                            case 'NewExpression':
                                if (type === Interpreter.Completion.RETURN) {
                                    state.value = value;
                                    return;
                                } else if (type !== Interpreter.Completion.THROW) throw Error('Unsynatctic break/continue not rejected by Acorn');
                                break;
                            case 'Program':
                                // Don't pop the stateStack.
                                // Leave the root scope on the tree in case the program is appended to.
                                state.done = true;
                                break loop;
                        }
                        if (type === Interpreter.Completion.BREAK) {
                            if (label ? state.labels && state.labels.indexOf(label) !== -1 : state.isLoop || state.isSwitch) {
                                stack.pop();
                                return;
                            }
                        } else if (type === Interpreter.Completion.CONTINUE) {
                            if (label ? state.labels && state.labels.indexOf(label) !== -1 : state.isLoop) return;
                        }
                    }
                    // Unhandled completion.  Throw a real error.
                    var realError;
                    if (this.isa(value, this.ERROR)) {
                        var errorTable = {
                            'EvalError': EvalError,
                            'RangeError': RangeError,
                            'ReferenceError': ReferenceError,
                            'SyntaxError': SyntaxError,
                            'TypeError': TypeError,
                            'URIError': URIError
                        };
                        var name = String(this.getProperty(value, 'name'));
                        var message = this.getProperty(value, 'message').valueOf();
                        var errorConstructor = errorTable[name] || Error;
                        realError = errorConstructor(message);
                    } else realError = String(value);
                    throw realError;
                };
                /**
 * Create a call to a getter function.
 * @param {!Interpreter.Object} func Function to execute.
 * @param {!Interpreter.Object|!Array} left
 *     Name of variable or object/propname tuple.
 * @private
 */ Interpreter.prototype.createGetter_ = function(func, left) {
                    if (!this.getterStep_) throw Error('Unexpected call to createGetter');
                    // Clear the getter flag.
                    this.getterStep_ = false;
                    // Normally `this` will be specified as the object component (o.x).
                    // Sometimes `this` is explicitly provided (o).
                    var funcThis = Array.isArray(left) ? left[0] : left;
                    var node = new this.nodeConstructor({
                        options: {}
                    });
                    node['type'] = 'CallExpression';
                    var state = new Interpreter.State(node, this.stateStack[this.stateStack.length - 1].scope);
                    state.doneCallee_ = true;
                    state.funcThis_ = funcThis;
                    state.func_ = func;
                    state.doneArgs_ = true;
                    state.arguments_ = [];
                    return state;
                };
                /**
 * Create a call to a setter function.
 * @param {!Interpreter.Object} func Function to execute.
 * @param {!Interpreter.Object|!Array} left
 *     Name of variable or object/propname tuple.
 * @param {Interpreter.Value} value Value to set.
 * @private
 */ Interpreter.prototype.createSetter_ = function(func, left, value) {
                    if (!this.setterStep_) throw Error('Unexpected call to createSetter');
                    // Clear the setter flag.
                    this.setterStep_ = false;
                    // Normally `this` will be specified as the object component (o.x).
                    // Sometimes `this` is implicitly the global object (x).
                    var funcThis = Array.isArray(left) ? left[0] : this.globalObject;
                    var node = new this.nodeConstructor({
                        options: {}
                    });
                    node['type'] = 'CallExpression';
                    var state = new Interpreter.State(node, this.stateStack[this.stateStack.length - 1].scope);
                    state.doneCallee_ = true;
                    state.funcThis_ = funcThis;
                    state.func_ = func;
                    state.doneArgs_ = true;
                    state.arguments_ = [
                        value
                    ];
                    return state;
                };
                /**
 * In non-strict mode `this` must be an object.
 * Must not be called in strict mode.
 * @param {Interpreter.Value} value Proposed value for `this`.
 * @return {!Interpreter.Object} Final value for `this`.
 * @private
 */ Interpreter.prototype.boxThis_ = function(value) {
                    if (value === undefined || value === null) // `Undefined` and `null` are changed to the global object.
                    return this.globalObject;
                    if (!(value instanceof Interpreter.Object)) {
                        // Primitives must be boxed.
                        var box = this.createObjectProto(this.getPrototype(value));
                        box.data = value;
                        return box;
                    }
                    return value;
                };
                /**
 * Typedef for JS values.
 * @typedef {!Interpreter.Object|boolean|number|string|undefined|null}
 */ Interpreter.Value;
                /**
 * Class for a state.
 * @param {!Object} node AST node for the state.
 * @param {!Interpreter.Scope} scope Scope object for the state.
 * @constructor
 */ Interpreter.State = function(node, scope) {
                    this.node = node;
                    this.scope = scope;
                };
                /**
 * Class for a scope.
 * @param {Interpreter.Scope} parentScope Parent scope.
 * @param {boolean} strict True if "use strict".
 * @param {!Interpreter.Object} object Object containing scope's variables.
 * @struct
 * @constructor
 */ Interpreter.Scope = function(parentScope, strict, object) {
                    this.parentScope = parentScope;
                    this.strict = strict;
                    this.object = object;
                };
                /**
 * Class for an object.
 * @param {Interpreter.Object} proto Prototype object or null.
 * @constructor
 */ Interpreter.Object = function(proto) {
                    this.getter = Object.create(null);
                    this.setter = Object.create(null);
                    this.properties = Object.create(null);
                    this.proto = proto;
                };
                /** @type {Interpreter.Object} */ Interpreter.Object.prototype.proto = null;
                /** @type {string} */ Interpreter.Object.prototype.class = 'Object';
                /** @type {Date|RegExp|boolean|number|string|null} */ Interpreter.Object.prototype.data = null;
                /**
 * Convert this object into a string.
 * @return {string} String value.
 * @override
 */ Interpreter.Object.prototype.toString = function() {
                    if (!(this instanceof Interpreter.Object)) // Primitive value.
                    return String(this);
                    if (this.class === 'Array') {
                        // Array contents must not have cycles.
                        var cycles = Interpreter.toStringCycles_;
                        cycles.push(this);
                        try {
                            var strs = [];
                            // Truncate very long strings.  This is not part of the spec,
                            // but it prevents hanging the interpreter for gigantic arrays.
                            var maxLength = this.properties.length;
                            var truncated = false;
                            if (maxLength > 1024) {
                                maxLength = 1000;
                                truncated = true;
                            }
                            for(var i = 0; i < maxLength; i++){
                                var value = this.properties[i];
                                strs[i] = value instanceof Interpreter.Object && cycles.indexOf(value) !== -1 ? '...' : value;
                            }
                            if (truncated) strs.push('...');
                        } finally{
                            cycles.pop();
                        }
                        return strs.join(',');
                    }
                    if (this.class === 'Error') {
                        // Error name and message properties must not have cycles.
                        var cycles = Interpreter.toStringCycles_;
                        if (cycles.indexOf(this) !== -1) return '[object Error]';
                        var name, message;
                        // Bug: Does not support getters and setters for name or message.
                        var obj = this;
                        do if ('name' in obj.properties) {
                            name = obj.properties['name'];
                            break;
                        }
                        while (obj = obj.proto);
                        var obj = this;
                        do if ('message' in obj.properties) {
                            message = obj.properties['message'];
                            break;
                        }
                        while (obj = obj.proto);
                        cycles.push(this);
                        try {
                            name = name && String(name);
                            message = message && String(message);
                        } finally{
                            cycles.pop();
                        }
                        return message ? name + ': ' + message : String(name);
                    }
                    if (this.data !== null) // RegExp, Date, and boxed primitives.
                    return String(this.data);
                    return '[object ' + this.class + ']';
                };
                /**
 * Return the object's value.
 * @return {Interpreter.Value} Value.
 * @override
 */ Interpreter.Object.prototype.valueOf = function() {
                    if (this.data === undefined || this.data === null || this.data instanceof RegExp) return this; // An Object, RegExp, or primitive.
                    if (this.data instanceof Date) return this.data.valueOf(); // Milliseconds.
                    return /** @type {(boolean|number|string)} */ this.data; // Boxed primitive.
                };
                ///////////////////////////////////////////////////////////////////////////////
                // Functions to handle each node type.
                ///////////////////////////////////////////////////////////////////////////////
                Interpreter.prototype['stepArrayExpression'] = function(stack, state, node) {
                    var elements = node['elements'];
                    var n = state.n_ || 0;
                    if (!state.array_) {
                        state.array_ = this.createArray();
                        state.array_.properties.length = elements.length;
                    } else {
                        this.setProperty(state.array_, n, state.value);
                        n++;
                    }
                    while(n < elements.length){
                        // Skip missing elements - they're not defined, not undefined.
                        if (elements[n]) {
                            state.n_ = n;
                            return new Interpreter.State(elements[n], state.scope);
                        }
                        n++;
                    }
                    stack.pop();
                    stack[stack.length - 1].value = state.array_;
                };
                Interpreter.prototype['stepAssignmentExpression'] = function(stack, state, node) {
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        var nextState = new Interpreter.State(node['left'], state.scope);
                        nextState.components = true;
                        return nextState;
                    }
                    if (!state.doneRight_) {
                        if (!state.leftReference_) state.leftReference_ = state.value;
                        if (state.doneGetter_) state.leftValue_ = state.value;
                        if (!state.doneGetter_ && node['operator'] !== '=') {
                            var leftValue = this.getValue(state.leftReference_);
                            state.leftValue_ = leftValue;
                            if (this.getterStep_) {
                                // Call the getter function.
                                state.doneGetter_ = true;
                                var func = /** @type {!Interpreter.Object} */ leftValue;
                                return this.createGetter_(func, state.leftReference_);
                            }
                        }
                        state.doneRight_ = true;
                        // When assigning an unnamed function to a variable, the function's name
                        // is set to the variable name.  Record the variable name in case the
                        // right side is a functionExpression.
                        // E.g. foo = function() {};
                        if (node['operator'] === '=' && node['left']['type'] === 'Identifier') state.destinationName = node['left']['name'];
                        return new Interpreter.State(node['right'], state.scope);
                    }
                    if (state.doneSetter_) {
                        // Return if setter function.
                        // Setter method on property has completed.
                        // Ignore its return value, and use the original set value instead.
                        stack.pop();
                        stack[stack.length - 1].value = state.setterValue_;
                        return;
                    }
                    var value = state.leftValue_;
                    var rightValue = state.value;
                    switch(node['operator']){
                        case '=':
                            value = rightValue;
                            break;
                        case '+=':
                            value += rightValue;
                            break;
                        case '-=':
                            value -= rightValue;
                            break;
                        case '*=':
                            value *= rightValue;
                            break;
                        case '/=':
                            value /= rightValue;
                            break;
                        case '%=':
                            value %= rightValue;
                            break;
                        case '<<=':
                            value <<= rightValue;
                            break;
                        case '>>=':
                            value >>= rightValue;
                            break;
                        case '>>>=':
                            value >>>= rightValue;
                            break;
                        case '&=':
                            value &= rightValue;
                            break;
                        case '^=':
                            value ^= rightValue;
                            break;
                        case '|=':
                            value |= rightValue;
                            break;
                        default:
                            throw SyntaxError('Unknown assignment expression: ' + node['operator']);
                    }
                    var setter = this.setValue(state.leftReference_, value);
                    if (setter) {
                        state.doneSetter_ = true;
                        state.setterValue_ = value;
                        return this.createSetter_(setter, state.leftReference_, value);
                    }
                    // Return if no setter function.
                    stack.pop();
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype['stepBinaryExpression'] = function(stack, state, node) {
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        return new Interpreter.State(node['left'], state.scope);
                    }
                    if (!state.doneRight_) {
                        state.doneRight_ = true;
                        state.leftValue_ = state.value;
                        return new Interpreter.State(node['right'], state.scope);
                    }
                    stack.pop();
                    var leftValue = state.leftValue_;
                    var rightValue = state.value;
                    var value;
                    switch(node['operator']){
                        case '==':
                            value = leftValue == rightValue;
                            break;
                        case '!=':
                            value = leftValue != rightValue;
                            break;
                        case '===':
                            value = leftValue === rightValue;
                            break;
                        case '!==':
                            value = leftValue !== rightValue;
                            break;
                        case '>':
                            value = leftValue > rightValue;
                            break;
                        case '>=':
                            value = leftValue >= rightValue;
                            break;
                        case '<':
                            value = leftValue < rightValue;
                            break;
                        case '<=':
                            value = leftValue <= rightValue;
                            break;
                        case '+':
                            value = leftValue + rightValue;
                            break;
                        case '-':
                            value = leftValue - rightValue;
                            break;
                        case '*':
                            value = leftValue * rightValue;
                            break;
                        case '/':
                            value = leftValue / rightValue;
                            break;
                        case '%':
                            value = leftValue % rightValue;
                            break;
                        case '&':
                            value = leftValue & rightValue;
                            break;
                        case '|':
                            value = leftValue | rightValue;
                            break;
                        case '^':
                            value = leftValue ^ rightValue;
                            break;
                        case '<<':
                            value = leftValue << rightValue;
                            break;
                        case '>>':
                            value = leftValue >> rightValue;
                            break;
                        case '>>>':
                            value = leftValue >>> rightValue;
                            break;
                        case 'in':
                            if (!(rightValue instanceof Interpreter.Object)) this.throwException(this.TYPE_ERROR, "'in' expects an object, not '" + rightValue + "'");
                            value = this.hasProperty(rightValue, leftValue);
                            break;
                        case 'instanceof':
                            if (!this.isa(rightValue, this.FUNCTION)) this.throwException(this.TYPE_ERROR, 'Right-hand side of instanceof is not an object');
                            value = leftValue instanceof Interpreter.Object ? this.isa(leftValue, rightValue) : false;
                            break;
                        default:
                            throw SyntaxError('Unknown binary operator: ' + node['operator']);
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype['stepBlockStatement'] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var expression = node['body'][n];
                    if (expression) {
                        state.n_ = n + 1;
                        return new Interpreter.State(expression, state.scope);
                    }
                    stack.pop();
                };
                Interpreter.prototype['stepBreakStatement'] = function(stack, state, node) {
                    var label = node['label'] && node['label']['name'];
                    this.unwind(Interpreter.Completion.BREAK, undefined, label);
                };
                Interpreter.prototype['stepCallExpression'] = function(stack, state, node) {
                    if (!state.doneCallee_) {
                        state.doneCallee_ = 1;
                        // Components needed to determine value of `this`.
                        var nextState = new Interpreter.State(node['callee'], state.scope);
                        nextState.components = true;
                        return nextState;
                    }
                    if (state.doneCallee_ === 1) {
                        // Determine value of the function.
                        state.doneCallee_ = 2;
                        var func = state.value;
                        if (Array.isArray(func)) {
                            state.func_ = this.getValue(func);
                            if (func[0] === Interpreter.SCOPE_REFERENCE) // (Globally or locally) named function.  Is it named 'eval'?
                            state.directEval_ = func[1] === 'eval';
                            else // Method function, `this` is object (ignored if invoked as `new`).
                            state.funcThis_ = func[0];
                            func = state.func_;
                            if (this.getterStep_) {
                                // Call the getter function.
                                state.doneCallee_ = 1;
                                return this.createGetter_(/** @type {!Interpreter.Object} */ func, state.value);
                            }
                        } else // Already evaluated function: (function(){...})();
                        state.func_ = func;
                        state.arguments_ = [];
                        state.n_ = 0;
                    }
                    var func = state.func_;
                    if (!state.doneArgs_) {
                        if (state.n_ !== 0) state.arguments_.push(state.value);
                        if (node['arguments'][state.n_]) return new Interpreter.State(node['arguments'][state.n_++], state.scope);
                        // Determine value of `this` in function.
                        if (node['type'] === 'NewExpression') {
                            if (!(func instanceof Interpreter.Object) || func.illegalConstructor) // Illegal: new escape();
                            this.throwException(this.TYPE_ERROR, func + ' is not a constructor');
                            // Constructor, `this` is new object.
                            if (func === this.ARRAY) state.funcThis_ = this.createArray();
                            else {
                                var proto = func.properties['prototype'];
                                if (typeof proto !== 'object' || proto === null) // Non-object prototypes default to `Object.prototype`.
                                proto = this.OBJECT_PROTO;
                                state.funcThis_ = this.createObjectProto(proto);
                            }
                            state.isConstructor = true;
                        }
                        state.doneArgs_ = true;
                    }
                    if (!state.doneExec_) {
                        state.doneExec_ = true;
                        if (!(func instanceof Interpreter.Object)) this.throwException(this.TYPE_ERROR, func + ' is not a function');
                        var funcNode = func.node;
                        if (funcNode) {
                            var scope = this.createScope(funcNode['body'], func.parentScope);
                            // Add all arguments.
                            for(var i = 0; i < funcNode['params'].length; i++){
                                var paramName = funcNode['params'][i]['name'];
                                var paramValue = state.arguments_.length > i ? state.arguments_[i] : undefined;
                                this.setProperty(scope.object, paramName, paramValue);
                            }
                            // Build arguments variable.
                            var argsList = this.createArray();
                            for(var i = 0; i < state.arguments_.length; i++)this.setProperty(argsList, i, state.arguments_[i]);
                            this.setProperty(scope.object, 'arguments', argsList);
                            // Add the function's name (var x = function foo(){};)
                            var name = funcNode['id'] && funcNode['id']['name'];
                            if (name) this.setProperty(scope.object, name, func);
                            if (!scope.strict) state.funcThis_ = this.boxThis_(state.funcThis_);
                            this.setProperty(scope.object, 'this', state.funcThis_, Interpreter.READONLY_DESCRIPTOR);
                            state.value = undefined; // Default value if no explicit return.
                            return new Interpreter.State(funcNode['body'], scope);
                        } else if (func.eval) {
                            var code = state.arguments_[0];
                            if (typeof code !== 'string') // JS does not parse String objects:
                            // eval(new String('1 + 1')) -> '1 + 1'
                            state.value = code;
                            else {
                                try {
                                    var ast = acorn.parse(String(code), Interpreter.PARSE_OPTIONS);
                                } catch (e) {
                                    // Acorn threw a SyntaxError.  Rethrow as a trappable error.
                                    this.throwException(this.SYNTAX_ERROR, 'Invalid code: ' + e.message);
                                }
                                var evalNode = new this.nodeConstructor({
                                    options: {}
                                });
                                evalNode['type'] = 'EvalProgram_';
                                evalNode['body'] = ast['body'];
                                Interpreter.stripLocations_(evalNode, node['start'], node['end']);
                                // Create new scope and update it with definitions in eval().
                                var scope = state.directEval_ ? state.scope : this.globalScope;
                                if (scope.strict) // Strict mode get its own scope in eval.
                                scope = this.createScope(ast, scope);
                                else // Non-strict mode pollutes the current scope.
                                this.populateScope_(ast, scope);
                                this.value = undefined; // Default value if no code.
                                return new Interpreter.State(evalNode, scope);
                            }
                        } else if (func.nativeFunc) {
                            if (!state.scope.strict) state.funcThis_ = this.boxThis_(state.funcThis_);
                            state.value = func.nativeFunc.apply(state.funcThis_, state.arguments_);
                        } else if (func.asyncFunc) {
                            var thisInterpreter = this;
                            var callback = function(value) {
                                state.value = value;
                                thisInterpreter.paused_ = false;
                            };
                            // Force the argument lengths to match, then append the callback.
                            var argLength = func.asyncFunc.length - 1;
                            var argsWithCallback = state.arguments_.concat(new Array(argLength)).slice(0, argLength);
                            argsWithCallback.push(callback);
                            this.paused_ = true;
                            if (!state.scope.strict) state.funcThis_ = this.boxThis_(state.funcThis_);
                            func.asyncFunc.apply(state.funcThis_, argsWithCallback);
                            return;
                        } else /* A child of a function is a function but is not callable.  For example:
      var F = function() {};
      F.prototype = escape;
      var f = new F();
      f();
      */ this.throwException(this.TYPE_ERROR, func.class + ' is not callable');
                    } else {
                        // Execution complete.  Put the return value on the stack.
                        stack.pop();
                        if (state.isConstructor && typeof state.value !== 'object') // Normal case for a constructor is to use the `this` value.
                        stack[stack.length - 1].value = state.funcThis_;
                        else // Non-constructors or constructions explicitly returning objects use
                        // the return value.
                        stack[stack.length - 1].value = state.value;
                    }
                };
                Interpreter.prototype['stepCatchClause'] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        // Create an empty scope.
                        var scope = this.createSpecialScope(state.scope);
                        // Add the argument.
                        this.setProperty(scope.object, node['param']['name'], state.throwValue);
                        // Execute catch clause.
                        return new Interpreter.State(node['body'], scope);
                    } else stack.pop();
                };
                Interpreter.prototype['stepConditionalExpression'] = function(stack, state, node) {
                    var mode = state.mode_ || 0;
                    if (mode === 0) {
                        state.mode_ = 1;
                        return new Interpreter.State(node['test'], state.scope);
                    }
                    if (mode === 1) {
                        state.mode_ = 2;
                        var value = Boolean(state.value);
                        if (value && node['consequent']) // Execute `if` block.
                        return new Interpreter.State(node['consequent'], state.scope);
                        else if (!value && node['alternate']) // Execute `else` block.
                        return new Interpreter.State(node['alternate'], state.scope);
                        // eval('1;if(false){2}') -> undefined
                        this.value = undefined;
                    }
                    stack.pop();
                    if (node['type'] === 'ConditionalExpression') stack[stack.length - 1].value = state.value;
                };
                Interpreter.prototype['stepContinueStatement'] = function(stack, state, node) {
                    var label = node['label'] && node['label']['name'];
                    this.unwind(Interpreter.Completion.CONTINUE, undefined, label);
                };
                Interpreter.prototype['stepDebuggerStatement'] = function(stack, state, node) {
                    // Do nothing.  May be overridden by developers.
                    stack.pop();
                };
                Interpreter.prototype['stepDoWhileStatement'] = function(stack, state, node) {
                    if (node['type'] === 'DoWhileStatement' && state.test_ === undefined) {
                        // First iteration of do/while executes without checking test.
                        state.value = true;
                        state.test_ = true;
                    }
                    if (!state.test_) {
                        state.test_ = true;
                        return new Interpreter.State(node['test'], state.scope);
                    }
                    if (!state.value) stack.pop();
                    else if (node['body']) {
                        state.test_ = false;
                        state.isLoop = true;
                        return new Interpreter.State(node['body'], state.scope);
                    }
                };
                Interpreter.prototype['stepEmptyStatement'] = function(stack, state, node) {
                    stack.pop();
                };
                Interpreter.prototype['stepEvalProgram_'] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var expression = node['body'][n];
                    if (expression) {
                        state.n_ = n + 1;
                        return new Interpreter.State(expression, state.scope);
                    }
                    stack.pop();
                    stack[stack.length - 1].value = this.value;
                };
                Interpreter.prototype['stepExpressionStatement'] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        return new Interpreter.State(node['expression'], state.scope);
                    }
                    stack.pop();
                    // Save this value to interpreter.value for use as a return value if
                    // this code is inside an eval function.
                    this.value = state.value;
                };
                Interpreter.prototype['stepForInStatement'] = function(stack, state, node) {
                    // First, initialize a variable if exists.  Only do so once, ever.
                    if (!state.doneInit_) {
                        state.doneInit_ = true;
                        if (node['left']['declarations'] && node['left']['declarations'][0]['init']) {
                            if (state.scope.strict) this.throwException(this.SYNTAX_ERROR, 'for-in loop variable declaration may not have an initializer.');
                            // Variable initialization: for (var x = 4 in y)
                            return new Interpreter.State(node['left'], state.scope);
                        }
                    }
                    // Second, look up the object.  Only do so once, ever.
                    if (!state.doneObject_) {
                        state.doneObject_ = true;
                        if (!state.variable_) state.variable_ = state.value;
                        return new Interpreter.State(node['right'], state.scope);
                    }
                    if (!state.isLoop) {
                        // First iteration.
                        state.isLoop = true;
                        state.object_ = state.value;
                        state.visited_ = Object.create(null);
                    }
                    // Third, find the property name for this iteration.
                    if (state.name_ === undefined) gotPropName: while(true){
                        if (state.object_ instanceof Interpreter.Object) {
                            if (!state.props_) state.props_ = Object.getOwnPropertyNames(state.object_.properties);
                            while(true){
                                var prop = state.props_.shift();
                                if (prop === undefined) break; // Reached end of this object's properties.
                                if (!Object.prototype.hasOwnProperty.call(state.object_.properties, prop)) continue; // Property has been deleted in the loop.
                                if (state.visited_[prop]) continue; // Already seen this property on a child.
                                state.visited_[prop] = true;
                                if (!Object.prototype.propertyIsEnumerable.call(state.object_.properties, prop)) continue; // Skip non-enumerable property.
                                state.name_ = prop;
                                break gotPropName;
                            }
                        } else if (state.object_ !== null && state.object_ !== undefined) {
                            // Primitive value (other than null or undefined).
                            if (!state.props_) state.props_ = Object.getOwnPropertyNames(state.object_);
                            while(true){
                                var prop = state.props_.shift();
                                if (prop === undefined) break; // Reached end of this value's properties.
                                state.visited_[prop] = true;
                                if (!Object.prototype.propertyIsEnumerable.call(state.object_, prop)) continue; // Skip non-enumerable property.
                                state.name_ = prop;
                                break gotPropName;
                            }
                        }
                        state.object_ = this.getPrototype(state.object_);
                        state.props_ = null;
                        if (state.object_ === null) {
                            // Done, exit loop.
                            stack.pop();
                            return;
                        }
                    }
                    // Fourth, find the variable
                    if (!state.doneVariable_) {
                        state.doneVariable_ = true;
                        var left = node['left'];
                        if (left['type'] === 'VariableDeclaration') // Inline variable declaration: for (var x in y)
                        state.variable_ = [
                            Interpreter.SCOPE_REFERENCE,
                            left['declarations'][0]['id']['name']
                        ];
                        else {
                            // Arbitrary left side: for (foo().bar in y)
                            state.variable_ = null;
                            var nextState = new Interpreter.State(left, state.scope);
                            nextState.components = true;
                            return nextState;
                        }
                    }
                    if (!state.variable_) state.variable_ = state.value;
                    // Fifth, set the variable.
                    if (!state.doneSetter_) {
                        state.doneSetter_ = true;
                        var value = state.name_;
                        var setter = this.setValue(state.variable_, value);
                        if (setter) return this.createSetter_(setter, state.variable_, value);
                    }
                    // Next step will be step three.
                    state.name_ = undefined;
                    // Reevaluate the variable since it could be a setter on the global object.
                    state.doneVariable_ = false;
                    state.doneSetter_ = false;
                    // Sixth and finally, execute the body if there was one.  this.
                    if (node['body']) return new Interpreter.State(node['body'], state.scope);
                };
                Interpreter.prototype['stepForStatement'] = function(stack, state, node) {
                    var mode = state.mode_ || 0;
                    if (mode === 0) {
                        state.mode_ = 1;
                        if (node['init']) return new Interpreter.State(node['init'], state.scope);
                    } else if (mode === 1) {
                        state.mode_ = 2;
                        if (node['test']) return new Interpreter.State(node['test'], state.scope);
                    } else if (mode === 2) {
                        state.mode_ = 3;
                        if (node['test'] && !state.value) // Done, exit loop.
                        stack.pop();
                        else {
                            state.isLoop = true;
                            return new Interpreter.State(node['body'], state.scope);
                        }
                    } else if (mode === 3) {
                        state.mode_ = 1;
                        if (node['update']) return new Interpreter.State(node['update'], state.scope);
                    }
                };
                Interpreter.prototype['stepFunctionDeclaration'] = function(stack, state, node) {
                    // This was found and handled when the scope was populated.
                    stack.pop();
                };
                Interpreter.prototype['stepFunctionExpression'] = function(stack, state, node) {
                    stack.pop();
                    state = stack[stack.length - 1];
                    state.value = this.createFunction(node, state.scope, state.destinationName);
                };
                Interpreter.prototype['stepIdentifier'] = function(stack, state, node) {
                    stack.pop();
                    if (state.components) {
                        stack[stack.length - 1].value = [
                            Interpreter.SCOPE_REFERENCE,
                            node['name']
                        ];
                        return;
                    }
                    var value = this.getValueFromScope(node['name']);
                    // An identifier could be a getter if it's a property on the global object.
                    if (this.getterStep_) {
                        // Call the getter function.
                        var func = /** @type {!Interpreter.Object} */ value;
                        return this.createGetter_(func, this.globalObject);
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype['stepIfStatement'] = Interpreter.prototype['stepConditionalExpression'];
                Interpreter.prototype['stepLabeledStatement'] = function(stack, state, node) {
                    // No need to hit this node again on the way back up the stack.
                    stack.pop();
                    // Note that a statement might have multiple labels.
                    var labels = state.labels || [];
                    labels.push(node['label']['name']);
                    var nextState = new Interpreter.State(node['body'], state.scope);
                    nextState.labels = labels;
                    return nextState;
                };
                Interpreter.prototype['stepLiteral'] = function(stack, state, node) {
                    stack.pop();
                    var value = node['value'];
                    if (value instanceof RegExp) {
                        var pseudoRegexp = this.createObjectProto(this.REGEXP_PROTO);
                        this.populateRegExp(pseudoRegexp, value);
                        value = pseudoRegexp;
                    }
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype['stepLogicalExpression'] = function(stack, state, node) {
                    if (node['operator'] !== '&&' && node['operator'] !== '||') throw SyntaxError('Unknown logical operator: ' + node['operator']);
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        return new Interpreter.State(node['left'], state.scope);
                    }
                    if (!state.doneRight_) {
                        if (node['operator'] === '&&' && !state.value || node['operator'] === '||' && state.value) {
                            // Shortcut evaluation.
                            stack.pop();
                            stack[stack.length - 1].value = state.value;
                        } else {
                            state.doneRight_ = true;
                            return new Interpreter.State(node['right'], state.scope);
                        }
                    } else {
                        stack.pop();
                        stack[stack.length - 1].value = state.value;
                    }
                };
                Interpreter.prototype['stepMemberExpression'] = function(stack, state, node) {
                    if (!state.doneObject_) {
                        state.doneObject_ = true;
                        return new Interpreter.State(node['object'], state.scope);
                    }
                    var propName;
                    if (!node['computed']) {
                        state.object_ = state.value;
                        // obj.foo -- Just access `foo` directly.
                        propName = node['property']['name'];
                    } else if (!state.doneProperty_) {
                        state.object_ = state.value;
                        // obj[foo] -- Compute value of `foo`.
                        state.doneProperty_ = true;
                        return new Interpreter.State(node['property'], state.scope);
                    } else propName = state.value;
                    stack.pop();
                    if (state.components) stack[stack.length - 1].value = [
                        state.object_,
                        propName
                    ];
                    else {
                        var value = this.getProperty(state.object_, propName);
                        if (this.getterStep_) {
                            // Call the getter function.
                            var func = /** @type {!Interpreter.Object} */ value;
                            return this.createGetter_(func, state.object_);
                        }
                        stack[stack.length - 1].value = value;
                    }
                };
                Interpreter.prototype['stepNewExpression'] = Interpreter.prototype['stepCallExpression'];
                Interpreter.prototype['stepObjectExpression'] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var property = node['properties'][n];
                    if (!state.object_) {
                        // First execution.
                        state.object_ = this.createObjectProto(this.OBJECT_PROTO);
                        state.properties_ = Object.create(null);
                    } else {
                        // Set the property computed in the previous execution.
                        var propName = state.destinationName;
                        if (!state.properties_[propName]) // Create temp object to collect value, getter, and/or setter.
                        state.properties_[propName] = {};
                        state.properties_[propName][property['kind']] = state.value;
                        state.n_ = ++n;
                        property = node['properties'][n];
                    }
                    if (property) {
                        // Determine property name.
                        var key = property['key'];
                        if (key['type'] === 'Identifier') var propName = key['name'];
                        else if (key['type'] === 'Literal') var propName = key['value'];
                        else throw SyntaxError('Unknown object structure: ' + key['type']);
                        // When assigning an unnamed function to a property, the function's name
                        // is set to the property name.  Record the property name in case the
                        // value is a functionExpression.
                        // E.g. {foo: function() {}}
                        state.destinationName = propName;
                        return new Interpreter.State(property['value'], state.scope);
                    }
                    for(var key in state.properties_){
                        var kinds = state.properties_[key];
                        if ('get' in kinds || 'set' in kinds) {
                            // Set a property with a getter or setter.
                            var descriptor = {
                                configurable: true,
                                enumerable: true,
                                get: kinds['get'],
                                set: kinds['set']
                            };
                            this.setProperty(state.object_, key, Interpreter.VALUE_IN_DESCRIPTOR, descriptor);
                        } else // Set a normal property with a value.
                        this.setProperty(state.object_, key, kinds['init']);
                    }
                    stack.pop();
                    stack[stack.length - 1].value = state.object_;
                };
                Interpreter.prototype['stepProgram'] = function(stack, state, node) {
                    var expression = node['body'].shift();
                    if (expression) {
                        state.done = false;
                        return new Interpreter.State(expression, state.scope);
                    }
                    state.done = true;
                // Don't pop the stateStack.
                // Leave the root scope on the tree in case the program is appended to.
                };
                Interpreter.prototype['stepReturnStatement'] = function(stack, state, node) {
                    if (node['argument'] && !state.done_) {
                        state.done_ = true;
                        return new Interpreter.State(node['argument'], state.scope);
                    }
                    this.unwind(Interpreter.Completion.RETURN, state.value, undefined);
                };
                Interpreter.prototype['stepSequenceExpression'] = function(stack, state, node) {
                    var n = state.n_ || 0;
                    var expression = node['expressions'][n];
                    if (expression) {
                        state.n_ = n + 1;
                        return new Interpreter.State(expression, state.scope);
                    }
                    stack.pop();
                    stack[stack.length - 1].value = state.value;
                };
                Interpreter.prototype['stepSwitchStatement'] = function(stack, state, node) {
                    if (!state.test_) {
                        state.test_ = 1;
                        return new Interpreter.State(node['discriminant'], state.scope);
                    }
                    if (state.test_ === 1) {
                        state.test_ = 2;
                        // Preserve switch value between case tests.
                        state.switchValue_ = state.value;
                        state.defaultCase_ = -1;
                    }
                    while(true){
                        var index = state.index_ || 0;
                        var switchCase = node['cases'][index];
                        if (!state.matched_ && switchCase && !switchCase['test']) {
                            // Test on the default case is null.
                            // Bypass (but store) the default case, and get back to it later.
                            state.defaultCase_ = index;
                            state.index_ = index + 1;
                            continue;
                        }
                        if (!switchCase && !state.matched_ && state.defaultCase_ !== -1) {
                            // Ran through all cases, no match.  Jump to the default.
                            state.matched_ = true;
                            state.index_ = state.defaultCase_;
                            continue;
                        }
                        if (switchCase) {
                            if (!state.matched_ && !state.tested_ && switchCase['test']) {
                                state.tested_ = true;
                                return new Interpreter.State(switchCase['test'], state.scope);
                            }
                            if (state.matched_ || state.value === state.switchValue_) {
                                state.matched_ = true;
                                var n = state.n_ || 0;
                                if (switchCase['consequent'][n]) {
                                    state.isSwitch = true;
                                    state.n_ = n + 1;
                                    return new Interpreter.State(switchCase['consequent'][n], state.scope);
                                }
                            }
                            // Move on to next case.
                            state.tested_ = false;
                            state.n_ = 0;
                            state.index_ = index + 1;
                        } else {
                            stack.pop();
                            return;
                        }
                    }
                };
                Interpreter.prototype['stepThisExpression'] = function(stack, state, node) {
                    stack.pop();
                    stack[stack.length - 1].value = this.getValueFromScope('this');
                };
                Interpreter.prototype['stepThrowStatement'] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        return new Interpreter.State(node['argument'], state.scope);
                    } else this.throwException(state.value);
                };
                Interpreter.prototype['stepTryStatement'] = function(stack, state, node) {
                    if (!state.doneBlock_) {
                        state.doneBlock_ = true;
                        return new Interpreter.State(node['block'], state.scope);
                    }
                    if (state.cv && state.cv.type === Interpreter.Completion.THROW && !state.doneHandler_ && node['handler']) {
                        state.doneHandler_ = true;
                        var nextState = new Interpreter.State(node['handler'], state.scope);
                        nextState.throwValue = state.cv.value;
                        state.cv = undefined; // This error has been handled, don't rethrow.
                        return nextState;
                    }
                    if (!state.doneFinalizer_ && node['finalizer']) {
                        state.doneFinalizer_ = true;
                        return new Interpreter.State(node['finalizer'], state.scope);
                    }
                    stack.pop();
                    if (state.cv) // There was no catch handler, or the catch/finally threw an error.
                    // Throw the error up to a higher try.
                    this.unwind(state.cv.type, state.cv.value, state.cv.label);
                };
                Interpreter.prototype['stepUnaryExpression'] = function(stack, state, node) {
                    if (!state.done_) {
                        state.done_ = true;
                        var nextState = new Interpreter.State(node['argument'], state.scope);
                        nextState.components = node['operator'] === 'delete';
                        return nextState;
                    }
                    stack.pop();
                    var value = state.value;
                    if (node['operator'] === '-') value = -value;
                    else if (node['operator'] === '+') value = +value;
                    else if (node['operator'] === '!') value = !value;
                    else if (node['operator'] === '~') value = ~value;
                    else if (node['operator'] === 'delete') {
                        var result = true;
                        // If value is not an array, then it is a primitive, or some other value.
                        // If so, skip the delete and return true.
                        if (Array.isArray(value)) {
                            var obj = value[0];
                            if (obj === Interpreter.SCOPE_REFERENCE) // `delete foo;` is the same as `delete window.foo;`.
                            obj = state.scope;
                            var name = String(value[1]);
                            try {
                                delete obj.properties[name];
                            } catch (e) {
                                if (state.scope.strict) this.throwException(this.TYPE_ERROR, "Cannot delete property '" + name + "' of '" + obj + "'");
                                else result = false;
                            }
                        }
                        value = result;
                    } else if (node['operator'] === 'typeof') value = value && value.class === 'Function' ? 'function' : typeof value;
                    else if (node['operator'] === 'void') value = undefined;
                    else throw SyntaxError('Unknown unary operator: ' + node['operator']);
                    stack[stack.length - 1].value = value;
                };
                Interpreter.prototype['stepUpdateExpression'] = function(stack, state, node) {
                    if (!state.doneLeft_) {
                        state.doneLeft_ = true;
                        var nextState = new Interpreter.State(node['argument'], state.scope);
                        nextState.components = true;
                        return nextState;
                    }
                    if (!state.leftSide_) state.leftSide_ = state.value;
                    if (state.doneGetter_) state.leftValue_ = state.value;
                    if (!state.doneGetter_) {
                        var leftValue = this.getValue(state.leftSide_);
                        state.leftValue_ = leftValue;
                        if (this.getterStep_) {
                            // Call the getter function.
                            state.doneGetter_ = true;
                            var func = /** @type {!Interpreter.Object} */ leftValue;
                            return this.createGetter_(func, state.leftSide_);
                        }
                    }
                    if (state.doneSetter_) {
                        // Return if setter function.
                        // Setter method on property has completed.
                        // Ignore its return value, and use the original set value instead.
                        stack.pop();
                        stack[stack.length - 1].value = state.setterValue_;
                        return;
                    }
                    var leftValue = Number(state.leftValue_);
                    var changeValue;
                    if (node['operator'] === '++') changeValue = leftValue + 1;
                    else if (node['operator'] === '--') changeValue = leftValue - 1;
                    else throw SyntaxError('Unknown update expression: ' + node['operator']);
                    var returnValue = node['prefix'] ? changeValue : leftValue;
                    var setter = this.setValue(state.leftSide_, changeValue);
                    if (setter) {
                        state.doneSetter_ = true;
                        state.setterValue_ = returnValue;
                        return this.createSetter_(setter, state.leftSide_, changeValue);
                    }
                    // Return if no setter function.
                    stack.pop();
                    stack[stack.length - 1].value = returnValue;
                };
                Interpreter.prototype['stepVariableDeclaration'] = function(stack, state, node) {
                    var declarations = node['declarations'];
                    var n = state.n_ || 0;
                    var declarationNode = declarations[n];
                    if (state.init_ && declarationNode) {
                        // This setValue call never needs to deal with calling a setter function.
                        // Note that this is setting the init value, not defining the variable.
                        // Variable definition is done when scope is populated.
                        this.setValueToScope(declarationNode['id']['name'], state.value);
                        state.init_ = false;
                        declarationNode = declarations[++n];
                    }
                    while(declarationNode){
                        // Skip any declarations that are not initialized.  They have already
                        // been defined as undefined in populateScope_.
                        if (declarationNode['init']) {
                            state.n_ = n;
                            state.init_ = true;
                            // When assigning an unnamed function to a variable, the function's name
                            // is set to the variable name.  Record the variable name in case the
                            // right side is a functionExpression.
                            // E.g. var foo = function() {};
                            state.destinationName = declarationNode['id']['name'];
                            return new Interpreter.State(declarationNode['init'], state.scope);
                        }
                        declarationNode = declarations[++n];
                    }
                    stack.pop();
                };
                Interpreter.prototype['stepWithStatement'] = function(stack, state, node) {
                    if (!state.doneObject_) {
                        state.doneObject_ = true;
                        return new Interpreter.State(node['object'], state.scope);
                    } else if (!state.doneBody_) {
                        state.doneBody_ = true;
                        var scope = this.createSpecialScope(state.scope, state.value);
                        return new Interpreter.State(node['body'], scope);
                    } else stack.pop();
                };
                Interpreter.prototype['stepWhileStatement'] = Interpreter.prototype['stepDoWhileStatement'];
                // Preserve top-level API functions from being pruned/renamed by JS compilers.
                // Add others as needed.
                // The global object (`window` in a browser, `global` in node.js) is `this`.
                this['Interpreter'] = Interpreter;
                Interpreter.prototype['step'] = Interpreter.prototype.step;
                Interpreter.prototype['run'] = Interpreter.prototype.run;
                Interpreter.prototype['appendCode'] = Interpreter.prototype.appendCode;
                Interpreter.prototype['createObject'] = Interpreter.prototype.createObject;
                Interpreter.prototype['createObjectProto'] = Interpreter.prototype.createObjectProto;
                Interpreter.prototype['createAsyncFunction'] = Interpreter.prototype.createAsyncFunction;
                Interpreter.prototype['createNativeFunction'] = Interpreter.prototype.createNativeFunction;
                Interpreter.prototype['getProperty'] = Interpreter.prototype.getProperty;
                Interpreter.prototype['setProperty'] = Interpreter.prototype.setProperty;
                Interpreter.prototype['nativeToPseudo'] = Interpreter.prototype.nativeToPseudo;
                Interpreter.prototype['pseudoToNative'] = Interpreter.prototype.pseudoToNative;
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(/*! ./original-repo/acorn.js */ "./original-repo/acorn.js"));
        /***/ },
        /***/ "./src/js-interpreter.js": /*!*******************************!*\
  !*** ./src/js-interpreter.js ***!
  \*******************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _original_repo_interpreter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../original-repo/interpreter */ "./original-repo/interpreter.js");
            /* harmony import */ var _original_repo_interpreter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_original_repo_interpreter__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony default export */ __webpack_exports__["default"] = _original_repo_interpreter__WEBPACK_IMPORTED_MODULE_0__["Interpreter"];
        /***/ }
    })["default"];
});

});

// The programming goals of Split.js are to deliver readable, understandable and
// maintainable code, while at the same time manually optimizing for tiny minified file size,
// browser compatibility without additional requirements
// and very few assumptions about the user's page layout.
var $408146dfdc361670$var$global = typeof window !== 'undefined' ? window : null;
var $408146dfdc361670$var$ssr = $408146dfdc361670$var$global === null;
var $408146dfdc361670$var$document = !$408146dfdc361670$var$ssr ? $408146dfdc361670$var$global.document : undefined;
// Save a couple long function names that are used frequently.
// This optimization saves around 400 bytes.
var $408146dfdc361670$var$addEventListener = 'addEventListener';
var $408146dfdc361670$var$removeEventListener = 'removeEventListener';
var $408146dfdc361670$var$getBoundingClientRect = 'getBoundingClientRect';
var $408146dfdc361670$var$gutterStartDragging = '_a';
var $408146dfdc361670$var$aGutterSize = '_b';
var $408146dfdc361670$var$bGutterSize = '_c';
var $408146dfdc361670$var$HORIZONTAL = 'horizontal';
var $408146dfdc361670$var$NOOP = function() {
    return false;
};
// Helper function determines which prefixes of CSS calc we need.
// We only need to do this once on startup, when this anonymous function is called.
//
// Tests -webkit, -moz and -o prefixes. Modified from StackOverflow:
// http://stackoverflow.com/questions/16625140/js-feature-detection-to-detect-the-usage-of-webkit-calc-over-calc/16625167#16625167
var $408146dfdc361670$var$calc = $408146dfdc361670$var$ssr ? 'calc' : [
    '',
    '-webkit-',
    '-moz-',
    '-o-'
].filter(function(prefix) {
    var el = $408146dfdc361670$var$document.createElement('div');
    el.style.cssText = "width:" + prefix + "calc(9px)";
    return !!el.style.length;
}).shift() + "calc";
// Helper function checks if its argument is a string-like type
var $408146dfdc361670$var$isString = function(v) {
    return typeof v === 'string' || v instanceof String;
};
// Helper function allows elements and string selectors to be used
// interchangeably. In either case an element is returned. This allows us to
// do `Split([elem1, elem2])` as well as `Split(['#id1', '#id2'])`.
var $408146dfdc361670$var$elementOrSelector = function(el) {
    if ($408146dfdc361670$var$isString(el)) {
        var ele = $408146dfdc361670$var$document.querySelector(el);
        if (!ele) throw new Error("Selector " + el + " did not match a DOM element");
        return ele;
    }
    return el;
};
// Helper function gets a property from the properties object, with a default fallback
var $408146dfdc361670$var$getOption = function(options, propName, def) {
    var value = options[propName];
    if (value !== undefined) return value;
    return def;
};
var $408146dfdc361670$var$getGutterSize = function(gutterSize, isFirst, isLast, gutterAlign) {
    if (isFirst) {
        if (gutterAlign === 'end') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    } else if (isLast) {
        if (gutterAlign === 'start') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    }
    return gutterSize;
};
// Default options
var $408146dfdc361670$var$defaultGutterFn = function(i, gutterDirection) {
    var gut = $408146dfdc361670$var$document.createElement('div');
    gut.className = "gutter gutter-" + gutterDirection;
    return gut;
};
var $408146dfdc361670$var$defaultElementStyleFn = function(dim, size, gutSize) {
    var style = {};
    if (!$408146dfdc361670$var$isString(size)) style[dim] = $408146dfdc361670$var$calc + "(" + size + "% - " + gutSize + "px)";
    else style[dim] = size;
    return style;
};
var $408146dfdc361670$var$defaultGutterStyleFn = function(dim, gutSize) {
    var obj;
    return obj = {}, obj[dim] = gutSize + "px", obj;
};
// The main function to initialize a split. Split.js thinks about each pair
// of elements as an independant pair. Dragging the gutter between two elements
// only changes the dimensions of elements in that pair. This is key to understanding
// how the following functions operate, since each function is bound to a pair.
//
// A pair object is shaped like this:
//
// {
//     a: DOM element,
//     b: DOM element,
//     aMin: Number,
//     bMin: Number,
//     dragging: Boolean,
//     parent: DOM element,
//     direction: 'horizontal' | 'vertical'
// }
//
// The basic sequence:
//
// 1. Set defaults to something sane. `options` doesn't have to be passed at all.
// 2. Initialize a bunch of strings based on the direction we're splitting.
//    A lot of the behavior in the rest of the library is paramatized down to
//    rely on CSS strings and classes.
// 3. Define the dragging helper functions, and a few helpers to go with them.
// 4. Loop through the elements while pairing them off. Every pair gets an
//    `pair` object and a gutter.
// 5. Actually size the pair elements, insert gutters and attach event listeners.
var $408146dfdc361670$var$Split = function(idsOption, options) {
    if (options === void 0) options = {};
    if ($408146dfdc361670$var$ssr) return {};
    var ids = idsOption;
    var dimension;
    var clientAxis;
    var position;
    var positionEnd;
    var clientSize;
    var elements;
    // Allow HTMLCollection to be used as an argument when supported
    if (Array.from) ids = Array.from(ids);
    // All DOM elements in the split should have a common parent. We can grab
    // the first elements parent and hope users read the docs because the
    // behavior will be whacky otherwise.
    var firstElement = $408146dfdc361670$var$elementOrSelector(ids[0]);
    var parent = firstElement.parentNode;
    var parentStyle = getComputedStyle ? getComputedStyle(parent) : null;
    var parentFlexDirection = parentStyle ? parentStyle.flexDirection : null;
    // Set default options.sizes to equal percentages of the parent element.
    var sizes = $408146dfdc361670$var$getOption(options, 'sizes') || ids.map(function() {
        return 100 / ids.length;
    });
    // Standardize minSize and maxSize to an array if it isn't already.
    // This allows minSize and maxSize to be passed as a number.
    var minSize = $408146dfdc361670$var$getOption(options, 'minSize', 100);
    var minSizes = Array.isArray(minSize) ? minSize : ids.map(function() {
        return minSize;
    });
    var maxSize = $408146dfdc361670$var$getOption(options, 'maxSize', Infinity);
    var maxSizes = Array.isArray(maxSize) ? maxSize : ids.map(function() {
        return maxSize;
    });
    // Get other options
    var expandToMin = $408146dfdc361670$var$getOption(options, 'expandToMin', false);
    var gutterSize = $408146dfdc361670$var$getOption(options, 'gutterSize', 10);
    var gutterAlign = $408146dfdc361670$var$getOption(options, 'gutterAlign', 'center');
    var snapOffset = $408146dfdc361670$var$getOption(options, 'snapOffset', 30);
    var snapOffsets = Array.isArray(snapOffset) ? snapOffset : ids.map(function() {
        return snapOffset;
    });
    var dragInterval = $408146dfdc361670$var$getOption(options, 'dragInterval', 1);
    var direction = $408146dfdc361670$var$getOption(options, 'direction', $408146dfdc361670$var$HORIZONTAL);
    var cursor = $408146dfdc361670$var$getOption(options, 'cursor', direction === $408146dfdc361670$var$HORIZONTAL ? 'col-resize' : 'row-resize');
    var gutter = $408146dfdc361670$var$getOption(options, 'gutter', $408146dfdc361670$var$defaultGutterFn);
    var elementStyle = $408146dfdc361670$var$getOption(options, 'elementStyle', $408146dfdc361670$var$defaultElementStyleFn);
    var gutterStyle = $408146dfdc361670$var$getOption(options, 'gutterStyle', $408146dfdc361670$var$defaultGutterStyleFn);
    // 2. Initialize a bunch of strings based on the direction we're splitting.
    // A lot of the behavior in the rest of the library is paramatized down to
    // rely on CSS strings and classes.
    if (direction === $408146dfdc361670$var$HORIZONTAL) {
        dimension = 'width';
        clientAxis = 'clientX';
        position = 'left';
        positionEnd = 'right';
        clientSize = 'clientWidth';
    } else if (direction === 'vertical') {
        dimension = 'height';
        clientAxis = 'clientY';
        position = 'top';
        positionEnd = 'bottom';
        clientSize = 'clientHeight';
    }
    // 3. Define the dragging helper functions, and a few helpers to go with them.
    // Each helper is bound to a pair object that contains its metadata. This
    // also makes it easy to store references to listeners that that will be
    // added and removed.
    //
    // Even though there are no other functions contained in them, aliasing
    // this to self saves 50 bytes or so since it's used so frequently.
    //
    // The pair object saves metadata like dragging state, position and
    // event listener references.
    function setElementSize(el, size, gutSize, i) {
        // Split.js allows setting sizes via numbers (ideally), or if you must,
        // by string, like '300px'. This is less than ideal, because it breaks
        // the fluid layout that `calc(% - px)` provides. You're on your own if you do that,
        // make sure you calculate the gutter size by hand.
        var style = elementStyle(dimension, size, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            el.style[prop] = style[prop];
        });
    }
    function setGutterSize(gutterElement, gutSize, i) {
        var style = gutterStyle(dimension, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            gutterElement.style[prop] = style[prop];
        });
    }
    function getSizes() {
        return elements.map(function(element) {
            return element.size;
        });
    }
    // Supports touch events, but not multitouch, so only the first
    // finger `touches[0]` is counted.
    function getMousePosition(e) {
        if ('touches' in e) return e.touches[0][clientAxis];
        return e[clientAxis];
    }
    // Actually adjust the size of elements `a` and `b` to `offset` while dragging.
    // calc is used to allow calc(percentage + gutterpx) on the whole split instance,
    // which allows the viewport to be resized without additional logic.
    // Element a's size is the same as offset. b's size is total size - a size.
    // Both sizes are calculated from the initial parent percentage,
    // then the gutter size is subtracted.
    function adjust(offset) {
        var a = elements[this.a];
        var b = elements[this.b];
        var percentage = a.size + b.size;
        a.size = offset / this.size * percentage;
        b.size = percentage - offset / this.size * percentage;
        setElementSize(a.element, a.size, this[$408146dfdc361670$var$aGutterSize], a.i);
        setElementSize(b.element, b.size, this[$408146dfdc361670$var$bGutterSize], b.i);
    }
    // drag, where all the magic happens. The logic is really quite simple:
    //
    // 1. Ignore if the pair is not dragging.
    // 2. Get the offset of the event.
    // 3. Snap offset to min if within snappable range (within min + snapOffset).
    // 4. Actually adjust each element in the pair to offset.
    //
    // ---------------------------------------------------------------------
    // |    | <- a.minSize               ||              b.minSize -> |    |
    // |    |  | <- this.snapOffset      ||     this.snapOffset -> |  |    |
    // |    |  |                         ||                        |  |    |
    // |    |  |                         ||                        |  |    |
    // ---------------------------------------------------------------------
    // | <- this.start                                        this.size -> |
    function drag(e) {
        var offset;
        var a = elements[this.a];
        var b = elements[this.b];
        if (!this.dragging) return;
        // Get the offset of the event from the first side of the
        // pair `this.start`. Then offset by the initial position of the
        // mouse compared to the gutter size.
        offset = getMousePosition(e) - this.start + (this[$408146dfdc361670$var$aGutterSize] - this.dragOffset);
        if (dragInterval > 1) offset = Math.round(offset / dragInterval) * dragInterval;
        // If within snapOffset of min or max, set offset to min or max.
        // snapOffset buffers a.minSize and b.minSize, so logic is opposite for both.
        // Include the appropriate gutter sizes to prevent overflows.
        if (offset <= a.minSize + a.snapOffset + this[$408146dfdc361670$var$aGutterSize]) offset = a.minSize + this[$408146dfdc361670$var$aGutterSize];
        else if (offset >= this.size - (b.minSize + b.snapOffset + this[$408146dfdc361670$var$bGutterSize])) offset = this.size - (b.minSize + this[$408146dfdc361670$var$bGutterSize]);
        if (offset >= a.maxSize - a.snapOffset + this[$408146dfdc361670$var$aGutterSize]) offset = a.maxSize + this[$408146dfdc361670$var$aGutterSize];
        else if (offset <= this.size - (b.maxSize - b.snapOffset + this[$408146dfdc361670$var$bGutterSize])) offset = this.size - (b.maxSize + this[$408146dfdc361670$var$bGutterSize]);
        // Actually adjust the size.
        adjust.call(this, offset);
        // Call the drag callback continously. Don't do anything too intensive
        // in this callback.
        $408146dfdc361670$var$getOption(options, 'onDrag', $408146dfdc361670$var$NOOP)(getSizes());
    }
    // Cache some important sizes when drag starts, so we don't have to do that
    // continously:
    //
    // `size`: The total size of the pair. First + second + first gutter + second gutter.
    // `start`: The leading side of the first element.
    //
    // ------------------------------------------------
    // |      aGutterSize -> |||                      |
    // |                     |||                      |
    // |                     |||                      |
    // |                     ||| <- bGutterSize       |
    // ------------------------------------------------
    // | <- start                             size -> |
    function calculateSizes() {
        // Figure out the parent size minus padding.
        var a = elements[this.a].element;
        var b = elements[this.b].element;
        var aBounds = a[$408146dfdc361670$var$getBoundingClientRect]();
        var bBounds = b[$408146dfdc361670$var$getBoundingClientRect]();
        this.size = aBounds[dimension] + bBounds[dimension] + this[$408146dfdc361670$var$aGutterSize] + this[$408146dfdc361670$var$bGutterSize];
        this.start = aBounds[position];
        this.end = aBounds[positionEnd];
    }
    function innerSize(element) {
        // Return nothing if getComputedStyle is not supported (< IE9)
        // Or if parent element has no layout yet
        if (!getComputedStyle) return null;
        var computedStyle = getComputedStyle(element);
        if (!computedStyle) return null;
        var size = element[clientSize];
        if (size === 0) return null;
        if (direction === $408146dfdc361670$var$HORIZONTAL) size -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        else size -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
        return size;
    }
    // When specifying percentage sizes that are less than the computed
    // size of the element minus the gutter, the lesser percentages must be increased
    // (and decreased from the other elements) to make space for the pixels
    // subtracted by the gutters.
    function trimToMin(sizesToTrim) {
        // Try to get inner size of parent element.
        // If it's no supported, return original sizes.
        var parentSize = innerSize(parent);
        if (parentSize === null) return sizesToTrim;
        if (minSizes.reduce(function(a, b) {
            return a + b;
        }, 0) > parentSize) return sizesToTrim;
        // Keep track of the excess pixels, the amount of pixels over the desired percentage
        // Also keep track of the elements with pixels to spare, to decrease after if needed
        var excessPixels = 0;
        var toSpare = [];
        var pixelSizes = sizesToTrim.map(function(size, i) {
            // Convert requested percentages to pixel sizes
            var pixelSize = parentSize * size / 100;
            var elementGutterSize = $408146dfdc361670$var$getGutterSize(gutterSize, i === 0, i === sizesToTrim.length - 1, gutterAlign);
            var elementMinSize = minSizes[i] + elementGutterSize;
            // If element is too smal, increase excess pixels by the difference
            // and mark that it has no pixels to spare
            if (pixelSize < elementMinSize) {
                excessPixels += elementMinSize - pixelSize;
                toSpare.push(0);
                return elementMinSize;
            }
            // Otherwise, mark the pixels it has to spare and return it's original size
            toSpare.push(pixelSize - elementMinSize);
            return pixelSize;
        });
        // If nothing was adjusted, return the original sizes
        if (excessPixels === 0) return sizesToTrim;
        return pixelSizes.map(function(pixelSize, i) {
            var newPixelSize = pixelSize;
            // While there's still pixels to take, and there's enough pixels to spare,
            // take as many as possible up to the total excess pixels
            if (excessPixels > 0 && toSpare[i] - excessPixels > 0) {
                var takenPixels = Math.min(excessPixels, toSpare[i] - excessPixels);
                // Subtract the amount taken for the next iteration
                excessPixels -= takenPixels;
                newPixelSize = pixelSize - takenPixels;
            }
            // Return the pixel size adjusted as a percentage
            return newPixelSize / parentSize * 100;
        });
    }
    // stopDragging is very similar to startDragging in reverse.
    function stopDragging() {
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        if (self.dragging) $408146dfdc361670$var$getOption(options, 'onDragEnd', $408146dfdc361670$var$NOOP)(getSizes());
        self.dragging = false;
        // Remove the stored event listeners. This is why we store them.
        $408146dfdc361670$var$global[$408146dfdc361670$var$removeEventListener]('mouseup', self.stop);
        $408146dfdc361670$var$global[$408146dfdc361670$var$removeEventListener]('touchend', self.stop);
        $408146dfdc361670$var$global[$408146dfdc361670$var$removeEventListener]('touchcancel', self.stop);
        $408146dfdc361670$var$global[$408146dfdc361670$var$removeEventListener]('mousemove', self.move);
        $408146dfdc361670$var$global[$408146dfdc361670$var$removeEventListener]('touchmove', self.move);
        // Clear bound function references
        self.stop = null;
        self.move = null;
        a[$408146dfdc361670$var$removeEventListener]('selectstart', $408146dfdc361670$var$NOOP);
        a[$408146dfdc361670$var$removeEventListener]('dragstart', $408146dfdc361670$var$NOOP);
        b[$408146dfdc361670$var$removeEventListener]('selectstart', $408146dfdc361670$var$NOOP);
        b[$408146dfdc361670$var$removeEventListener]('dragstart', $408146dfdc361670$var$NOOP);
        a.style.userSelect = '';
        a.style.webkitUserSelect = '';
        a.style.MozUserSelect = '';
        a.style.pointerEvents = '';
        b.style.userSelect = '';
        b.style.webkitUserSelect = '';
        b.style.MozUserSelect = '';
        b.style.pointerEvents = '';
        self.gutter.style.cursor = '';
        self.parent.style.cursor = '';
        $408146dfdc361670$var$document.body.style.cursor = '';
    }
    // startDragging calls `calculateSizes` to store the inital size in the pair object.
    // It also adds event listeners for mouse/touch events,
    // and prevents selection while dragging so avoid the selecting text.
    function startDragging(e) {
        // Right-clicking can't start dragging.
        if ('button' in e && e.button !== 0) return;
        // Alias frequently used variables to save space. 200 bytes.
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        // Call the onDragStart callback.
        if (!self.dragging) $408146dfdc361670$var$getOption(options, 'onDragStart', $408146dfdc361670$var$NOOP)(getSizes());
        // Don't actually drag the element. We emulate that in the drag function.
        e.preventDefault();
        // Set the dragging property of the pair object.
        self.dragging = true;
        // Create two event listeners bound to the same pair object and store
        // them in the pair object.
        self.move = drag.bind(self);
        self.stop = stopDragging.bind(self);
        // All the binding. `window` gets the stop events in case we drag out of the elements.
        $408146dfdc361670$var$global[$408146dfdc361670$var$addEventListener]('mouseup', self.stop);
        $408146dfdc361670$var$global[$408146dfdc361670$var$addEventListener]('touchend', self.stop);
        $408146dfdc361670$var$global[$408146dfdc361670$var$addEventListener]('touchcancel', self.stop);
        $408146dfdc361670$var$global[$408146dfdc361670$var$addEventListener]('mousemove', self.move);
        $408146dfdc361670$var$global[$408146dfdc361670$var$addEventListener]('touchmove', self.move);
        // Disable selection. Disable!
        a[$408146dfdc361670$var$addEventListener]('selectstart', $408146dfdc361670$var$NOOP);
        a[$408146dfdc361670$var$addEventListener]('dragstart', $408146dfdc361670$var$NOOP);
        b[$408146dfdc361670$var$addEventListener]('selectstart', $408146dfdc361670$var$NOOP);
        b[$408146dfdc361670$var$addEventListener]('dragstart', $408146dfdc361670$var$NOOP);
        a.style.userSelect = 'none';
        a.style.webkitUserSelect = 'none';
        a.style.MozUserSelect = 'none';
        a.style.pointerEvents = 'none';
        b.style.userSelect = 'none';
        b.style.webkitUserSelect = 'none';
        b.style.MozUserSelect = 'none';
        b.style.pointerEvents = 'none';
        // Set the cursor at multiple levels
        self.gutter.style.cursor = cursor;
        self.parent.style.cursor = cursor;
        $408146dfdc361670$var$document.body.style.cursor = cursor;
        // Cache the initial sizes of the pair.
        calculateSizes.call(self);
        // Determine the position of the mouse compared to the gutter
        self.dragOffset = getMousePosition(e) - self.end;
    }
    // adjust sizes to ensure percentage is within min size and gutter.
    sizes = trimToMin(sizes);
    // 5. Create pair and element objects. Each pair has an index reference to
    // elements `a` and `b` of the pair (first and second elements).
    // Loop through the elements while pairing them off. Every pair gets a
    // `pair` object and a gutter.
    //
    // Basic logic:
    //
    // - Starting with the second element `i > 0`, create `pair` objects with
    //   `a = i - 1` and `b = i`
    // - Set gutter sizes based on the _pair_ being first/last. The first and last
    //   pair have gutterSize / 2, since they only have one half gutter, and not two.
    // - Create gutter elements and add event listeners.
    // - Set the size of the elements, minus the gutter sizes.
    //
    // -----------------------------------------------------------------------
    // |     i=0     |         i=1         |        i=2       |      i=3     |
    // |             |                     |                  |              |
    // |           pair 0                pair 1             pair 2           |
    // |             |                     |                  |              |
    // -----------------------------------------------------------------------
    var pairs = [];
    elements = ids.map(function(id, i) {
        // Create the element object.
        var element = {
            element: $408146dfdc361670$var$elementOrSelector(id),
            size: sizes[i],
            minSize: minSizes[i],
            maxSize: maxSizes[i],
            snapOffset: snapOffsets[i],
            i: i
        };
        var pair;
        if (i > 0) {
            // Create the pair object with its metadata.
            pair = {
                a: i - 1,
                b: i,
                dragging: false,
                direction: direction,
                parent: parent
            };
            pair[$408146dfdc361670$var$aGutterSize] = $408146dfdc361670$var$getGutterSize(gutterSize, i - 1 === 0, false, gutterAlign);
            pair[$408146dfdc361670$var$bGutterSize] = $408146dfdc361670$var$getGutterSize(gutterSize, false, i === ids.length - 1, gutterAlign);
            // if the parent has a reverse flex-direction, switch the pair elements.
            if (parentFlexDirection === 'row-reverse' || parentFlexDirection === 'column-reverse') {
                var temp = pair.a;
                pair.a = pair.b;
                pair.b = temp;
            }
        }
        // Determine the size of the current element. IE8 is supported by
        // staticly assigning sizes without draggable gutters. Assigns a string
        // to `size`.
        //
        // Create gutter elements for each pair.
        if (i > 0) {
            var gutterElement = gutter(i, direction, element.element);
            setGutterSize(gutterElement, gutterSize, i);
            // Save bound event listener for removal later
            pair[$408146dfdc361670$var$gutterStartDragging] = startDragging.bind(pair);
            // Attach bound event listener
            gutterElement[$408146dfdc361670$var$addEventListener]('mousedown', pair[$408146dfdc361670$var$gutterStartDragging]);
            gutterElement[$408146dfdc361670$var$addEventListener]('touchstart', pair[$408146dfdc361670$var$gutterStartDragging]);
            parent.insertBefore(gutterElement, element.element);
            pair.gutter = gutterElement;
        }
        setElementSize(element.element, element.size, $408146dfdc361670$var$getGutterSize(gutterSize, i === 0, i === ids.length - 1, gutterAlign), i);
        // After the first iteration, and we have a pair object, append it to the
        // list of pairs.
        if (i > 0) pairs.push(pair);
        return element;
    });
    function adjustToMin(element) {
        var isLast = element.i === pairs.length;
        var pair = isLast ? pairs[element.i - 1] : pairs[element.i];
        calculateSizes.call(pair);
        var size = isLast ? pair.size - element.minSize - pair[$408146dfdc361670$var$bGutterSize] : element.minSize + pair[$408146dfdc361670$var$aGutterSize];
        adjust.call(pair, size);
    }
    elements.forEach(function(element) {
        var computedSize = element.element[$408146dfdc361670$var$getBoundingClientRect]()[dimension];
        if (computedSize < element.minSize) {
            if (expandToMin) adjustToMin(element);
            else // eslint-disable-next-line no-param-reassign
            element.minSize = computedSize;
        }
    });
    function setSizes(newSizes) {
        var trimmed = trimToMin(newSizes);
        trimmed.forEach(function(newSize, i) {
            if (i > 0) {
                var pair = pairs[i - 1];
                var a = elements[pair.a];
                var b = elements[pair.b];
                a.size = trimmed[i - 1];
                b.size = newSize;
                setElementSize(a.element, a.size, pair[$408146dfdc361670$var$aGutterSize], a.i);
                setElementSize(b.element, b.size, pair[$408146dfdc361670$var$bGutterSize], b.i);
            }
        });
    }
    function destroy(preserveStyles, preserveGutter) {
        pairs.forEach(function(pair) {
            if (preserveGutter !== true) pair.parent.removeChild(pair.gutter);
            else {
                pair.gutter[$408146dfdc361670$var$removeEventListener]('mousedown', pair[$408146dfdc361670$var$gutterStartDragging]);
                pair.gutter[$408146dfdc361670$var$removeEventListener]('touchstart', pair[$408146dfdc361670$var$gutterStartDragging]);
            }
            if (preserveStyles !== true) {
                var style = elementStyle(dimension, pair.a.size, pair[$408146dfdc361670$var$aGutterSize]);
                Object.keys(style).forEach(function(prop) {
                    elements[pair.a].element.style[prop] = '';
                    elements[pair.b].element.style[prop] = '';
                });
            }
        });
    }
    return {
        setSizes: setSizes,
        getSizes: getSizes,
        collapse: function collapse(i) {
            adjustToMin(elements[i]);
        },
        destroy: destroy,
        parent: parent,
        pairs: pairs
    };
};
var $408146dfdc361670$export$2e2bcd8739ae039 = $408146dfdc361670$var$Split;


var $2192b685fd074ac6$exports = {};
/*! lozad.js - v1.16.0 - 2020-09-06
* https://github.com/ApoorvSaxena/lozad.js
* Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ !function(t, e) {
    $2192b685fd074ac6$exports = e();
}($2192b685fd074ac6$exports, function() {
    "use strict";
    /**
   * Detect IE browser
   * @const {boolean}
   * @private
   */ var g = "undefined" != typeof document && document.documentMode, f = {
        rootMargin: "0px",
        threshold: 0,
        load: function(t) {
            if ("picture" === t.nodeName.toLowerCase()) {
                var e = t.querySelector("img"), r = !1;
                null === e && (e = document.createElement("img"), r = !0), g && t.getAttribute("data-iesrc") && (e.src = t.getAttribute("data-iesrc")), t.getAttribute("data-alt") && (e.alt = t.getAttribute("data-alt")), r && t.append(e);
            }
            if ("video" === t.nodeName.toLowerCase() && !t.getAttribute("data-src") && t.children) {
                for(var a = t.children, o = void 0, i = 0; i <= a.length - 1; i++)(o = a[i].getAttribute("data-src")) && (a[i].src = o);
                t.load();
            }
            t.getAttribute("data-poster") && (t.poster = t.getAttribute("data-poster")), t.getAttribute("data-src") && (t.src = t.getAttribute("data-src")), t.getAttribute("data-srcset") && t.setAttribute("srcset", t.getAttribute("data-srcset"));
            var n = ",";
            if (t.getAttribute("data-background-delimiter") && (n = t.getAttribute("data-background-delimiter")), t.getAttribute("data-background-image")) t.style.backgroundImage = "url('" + t.getAttribute("data-background-image").split(n).join("'),url('") + "')";
            else if (t.getAttribute("data-background-image-set")) {
                var d = t.getAttribute("data-background-image-set").split(n), u = d[0].substr(0, d[0].indexOf(" ")) || d[0]; // Substring before ... 1x
                u = -1 === u.indexOf("url(") ? "url(" + u + ")" : u, 1 === d.length ? t.style.backgroundImage = u : t.setAttribute("style", (t.getAttribute("style") || "") + "background-image: " + u + "; background-image: -webkit-image-set(" + d + "); background-image: image-set(" + d + ")");
            }
            t.getAttribute("data-toggle-class") && t.classList.toggle(t.getAttribute("data-toggle-class"));
        },
        loaded: function() {}
    };
    function A(t) {
        t.setAttribute("data-loaded", !0);
    }
    var m = function(t) {
        return "true" === t.getAttribute("data-loaded");
    }, v = function(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document;
        return t instanceof Element ? [
            t
        ] : t instanceof NodeList ? t : e.querySelectorAll(t);
    };
    return function() {
        var r, a, o = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : ".lozad", t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, e = Object.assign({}, f, t), i = e.root, n = e.rootMargin, d = e.threshold, u = e.load, g = e.loaded, s = void 0;
        "undefined" != typeof window && window.IntersectionObserver && (s = new IntersectionObserver((r = u, a = g, function(t, e) {
            t.forEach(function(t) {
                (0 < t.intersectionRatio || t.isIntersecting) && (e.unobserve(t.target), m(t.target) || (r(t.target), A(t.target), a(t.target)));
            });
        }), {
            root: i,
            rootMargin: n,
            threshold: d
        }));
        for(var c, l = v(o, i), b = 0; b < l.length; b++)(c = l[b]).getAttribute("data-placeholder-background") && (c.style.background = c.getAttribute("data-placeholder-background"));
        return {
            observe: function() {
                for(var t = v(o, i), e = 0; e < t.length; e++)m(t[e]) || (s ? s.observe(t[e]) : (u(t[e]), A(t[e]), g(t[e])));
            },
            triggerLoad: function(t) {
                m(t) || (u(t), A(t), g(t));
            },
            observer: s
        };
    };
});


parcelRequire("dw2Ek");

var $gnVfA = parcelRequire("gnVfA");
var $6413746d743b245e$exports = {};
$6413746d743b245e$exports = JSON.parse('{"@metadata":{"authors":["Nikolas Dahn"],"last-updated":"2021-07-17","locale":"de","message-documentation":"qqq"},"seo-description":"Rocksi ist ein kostenloser Roboter-Simulator, mit dem du einen virtuellen 3D-Roboter in deinem Browser programmieren kannst!","seo-header":"Programmiere deinen Roboter im Browser!","seo-text":"Rocksi ist ein Simulator, mit dem du einen virtuellen 3D-Roboter \xe4hnlich wie in Scratch oder Lego Mindstorms programmieren kannst. Rocksi l\xe4uft auf jedem modernen Browser (Firefox, Chrome, Safari...) und Ger\xe4t (iPhone, iPad, IOS, Android, Linux, Windows, ...) - ohne Download oder Installation! Rocksi ist au\xdferdem v\xf6llig kostenlos und erfordert keine Registrierung.<br>Rocksi wurde geschrieben, um mehr Menschen Zugang zu Robotern zu geben, insbesondere f\xfcr den Bildungsbereich. Egal ob Schulklassen, Vorlesungen, Workshops oder Messen, Rocksi bringt Menschen und Roboter n\xe4her zusammen! Bisher wurden Roboter von Franka Emika und Niryo eingebaut, und es ist relativ einfach, weitere hinzuzuf\xfcgen (siehe Quellcode).","robot-loading":"Lade Roboter...","warn-unsaved":"Der aktuelle Zustand wird nicht gespeichert. Fortfahren?","note-code-export":"Code exportiert! Sei vorsichtig, wenn du ihn auf einem Roboter ausprobierst.","tutorial-0-heading":"Willkommen zu Rocksi!","tutorial-0-intro":"Roboter sind teuer, weshalb es f\xfcr die meisten Menschen sehr schwer ist, sie wirklich kennenzulernen. Doch Menschen lieben es, etwas anzufassen! Genau daf\xfcr wurde Rocksi geschrieben - um Menschen mit Robotern in Ber\xfchrung zu bringen. Egal ob Lehrer, Sch\xfcler, Fachkraft oder einfach nur technik-affin, Rocksi hilft, die Grundlagen der Robotik zu verstehen und mit anderen zu teilen.","tutorial-0-start":"Mit dem Pfeil rechts kommst du zum ersten Tutorial.<br><i>Viel Spa\xdf!</i>","tutorial-0-social":"Updates & Feedback","tutorial-1-heading":"Behalte den \xdcberblick","tutorial-1":"\xdcber das Men\xfc links kannst du schnell zwischen den Ansichten wechseln.","tutorial-2-heading":"Voll im Bilde","tutorial-2-desktop":"Mit Links- und Rechtsklick drehst du dir die Welt, wie sie dir gef\xe4llt.","tutorial-2-mobile":"Mit den gewohnten Touch-Gesten findest du jedes Detail.","tutorial-3-heading":"Handzahm","tutorial-3":"Den Roboter kannst du direkt in der 3D-Ansicht bewegen. \xdcber das Men\xfc kannst du auch gezielt einzelne Gelenke steuern.","tutorial-4-heading":"Das Leben ist ein Puzzle-Spiel","tutorial-4":"Mithilfe der Puzzleteile kannst du dir schnell ein Programm f\xfcr den Roboter zusammenzubauen.","tutorial-5-heading":"Haltung Wahren","tutorial-5":"Nutze die Pfeile um Posen des Roboters zwischen Bl\xf6cken und Roboter zu \xfcbertragen.","tutorial-6-heading":"Let it go","tutorial-6":"Um ein Programm auszuf\xfchren klickst du in der 3D-Ansicht auf den Play-Button.","tutorial-7-heading":"Aus dem Kontext gerissen","tutorial-7":"Das Kontext-Men\xfc gibt dir weitere Optionen. Au\xdferdem kannst du so deine Programme speichern und laden.","tutorial-rf-heading":"Roboterf\xfchrerschein","tutorial-rf":"Du m\xf6chtest noch mehr wissen oder dir war etwas unklar? Auf {{link:robotikschulungen.de|https://www.robotikschulungen.de}} findest du verschiedene kostenlose Kurse!","license-note":"Rocksi wird unter der <a href=\\"https://tldrlegal.com/license/mit-license\\" target=\\"_blank\\">MIT Lizenz</a> ver\xf6ffentlicht<br>","imprint":"Impressum","privacy":"Datenschutz","software":"Software","robots":"Roboter","imprint-content":"i18n/imprint_de.html","privacy-content":"i18n/privacy_de.html","software-content":"i18n/software_de.html","robots-content":"i18n/robots_de.html","gui-robot":"Rocksi","gui-language":"Sprache","gui-gripper":"Greifer","gui-gripper-open":"\xd6ffnen","gui-gripper-close":"Schlie\xdfen","gui-advanced-gripping":"Reales Greifen","gui-joints":"Gelenkwinkel","gui-ik-joints":"IK Gelenke","gui-reset-robot":"Roboter zur\xfccksetzen","gui-reset-view":"Ansicht zur\xfccksetzen","gui-close":"Schlie\xdfen","gui-confirm-switch-robot":"M\xf6chtest du den $1 Roboter laden? Dein aktuelles Programm geht dabei verloren!","gui-confirm-switch-language":"M\xf6chtest du die Sprache wechseln? Dein aktuelles Programm geht dabei verloren!","gui-robot-info":"Info","franka-info":"Der Roboter von Franka Emika zeichnet sich durch 7 Gelenkfreiheitsgrade und einen hohen Grad von Feingef\xfchl aus. Dadurch kann sich Franka \xe4hnlich wie der menschliche Arm bewegen und auch auf leichte Ber\xfchrungen reagieren. <p><a href=\\"https://franka.de/\\" target=\\"_blank\\">www.franka.de</a></p>","niryo-info":"Niryo stellt kleine Desktoproboter mit 6 Gelenken her, die vor allem f\xfcr den Bildungsbereich gedacht sind. Mit einem 3D-Drucker k\xf6nnen technisch Begeisterte den Roboter sogar selbst bauen! <p><a href=\\"https://niryo.com/\\" target=\\"_blank\\">www.niryo.com</a></p>","sawyer-info":"Der Sawyer ist der Nachfolger des bekannten zweiarmigen Baxter Roboters und ist \xe4u\xdferst beliebt in der Forschung. Die Anordnung der Gelenke f\xfchrt zu einigen sehr ungew\xf6hnlichen Bewegungen! <p><a href=\\"https://www.rethinkrobotics.com/de/sawyer/\\" target=\\"_blank\\">www.rethinkrobotics.com/de/sawyer/</a></p>"}');


var $5a09c60466480564$exports = {};
$5a09c60466480564$exports = JSON.parse("{\"@metadata\":{\"authors\":[\"Nikolas Dahn\"],\"last-updated\":\"2021-07-17\",\"locale\":\"en\",\"message-documentation\":\"qqq\"},\"seo-description\":\"Rocksi is a free robot simulator that runs in any modern browser and allows you to program a 3D robot arm using blockly visual programming.\",\"seo-header\":\"Simulate and program virtual robots in your browser!\",\"seo-text\":\"Rocksi is a simulator that allows you to freely program a 3D virtual robot similar to scratch or Lego Mindstorms. Rocksi runs on any modern browser (Firefox, Chrome, Safari...) and device (iPhone, iPad, IOS, Android, Linux, Windows, ...) - no download or installation! Rocksi is also completely free of charge with no registration required.<br>Rocksi was written to make robots more accessible for everybody, and especially with education in mind. Use it however you see fit, e.g. school classes, university lectures, workshops, fairs, etc.!At the moments robots by Franka Emika and Niryo are included, but it's easy to add new robots yourself (check the source code).\",\"robot-loading\":\"Loading Robot...\",\"warn-unsaved\":\"The current state will not be saved. Continue?\",\"note-code-export\":\"Code exported! Be careful before running this on your robot.\",\"tutorial-0-heading\":\"Welcome to Rocksi!\",\"tutorial-0-intro\":\"Robots are expensive, so for many people it's impossible to get to know them properly. But humans love touching things! Rocksi was created to make robots more accessible. Whether you're a teacher, a student, a specialist worker or just interested, Rocksi enables you to understand and share the very core concepts of robotics.\",\"tutorial-0-start\":\"To get started, click the arrow on the right to jump to the first tutorial.<br><i>I hope you enjoy!</i>\",\"tutorial-0-social\":\"Updates & Feedback\",\"tutorial-1-heading\":\"Organizing Yourself\",\"tutorial-1\":\"Quickly switch between views using the menu on the left.\",\"tutorial-2-heading\":\"Taking Perspective\",\"tutorial-2-desktop\":\"Use left click, right click and mouse wheel to move around.\",\"tutorial-2-mobile\":\"Use finger gestures to move around.\",\"tutorial-3-heading\":\"Taming the Robot\",\"tutorial-3\":\"Control the robot by clicking and dragging its gripper. You can control individual joints through the GUI in the top right.\",\"tutorial-4-heading\":\"Those Who Program\",\"tutorial-4\":\"By combining puzzle pieces from the toolbox you can quickly create a program for the robot.\",\"tutorial-5-heading\":\"Maintaining Posture\",\"tutorial-5\":\"Use the arrows to transfer poses between blocks and the robot.\",\"tutorial-6-heading\":\"Let it go\",\"tutorial-6\":\"To run your program just click the large play button in the 3D view.\",\"tutorial-7-heading\":\"Context is Everything\",\"tutorial-7\":\"The context menus give you additional control over your program. You can also load and save programs there!\",\"tutorial-rf-heading\":\"Robot Driver's License\",\"tutorial-rf\":\"You want to know more about robots? You can find some decent basic courses on {{link:robotikschulungen.de|https://www.robotikschulungen.de}} (unfortunately only in German right now).\",\"license-note\":\"Rocksi is distributed under the <a href=\\\"https://tldrlegal.com/license/mit-license\\\" target=\\\"_blank\\\">MIT license</a><br>\",\"imprint\":\"Imprint\",\"privacy\":\"Privacy Policy\",\"software\":\"Software\",\"robots\":\"Robots\",\"imprint-content\":\"i18n/imprint_en.html\",\"privacy-content\":\"i18n/privacy_en.html\",\"software-content\":\"i18n/software_en.html\",\"robots-content\":\"i18n/robots_en.html\",\"gui-robot\":\"Rocksi\",\"gui-language\":\"Language\",\"gui-gripper\":\"Gripper\",\"gui-gripper-open\":\"Open\",\"gui-gripper-close\":\"Close\",\"gui-advanced-gripping\":\"Realistic Grip\",\"gui-joints\":\"Joint Values\",\"gui-ik-joints\":\"IK Joints\",\"gui-reset-robot\":\"Reset Robot\",\"gui-reset-view\":\"Reset Viewport\",\"gui-close\":\"Close\",\"gui-confirm-switch-robot\":\"Are you sure you want to load the $1 robot? Any unsaved programs will be lost!\",\"gui-confirm-switch-language\":\"Are you sure you want to change language? Any unsaved programs will be lost!\",\"gui-robot-info\":\"Info\",\"franka-info\":\"Franka Emika's robot features 7 joint degrees of freedem as well as a high degree of sensitivity. This allows it to move similar to a human arm and react to even light touches. <p><a href=\\\"https://franka.de/\\\" target=\\\"_blank\\\">www.franka.de</a></p>\",\"niryo-info\":\"Niryo creates robots with 6 joints that are meant to be used in education. The robot is open source, so if you have the parts and a 3d printer you can even build it yourself! <p><a href=\\\"https://niryo.com/\\\" target=\\\"_blank\\\">www.niryo.com</a></p>\",\"sawyer-info\":\"The Sawyer is the successor of the two-armed Baxter robot and is very popular in research. The arrangements of joints creates some very unusual movement patterns! <p><a href=\\\"https://www.rethinkrobotics.com/sawyer/\\\" target=\\\"_blank\\\">www.rethinkrobotics.com/sawyer/</a></p>\"}");


parcelRequire("kFmW2");

var $kFmW2 = parcelRequire("kFmW2");
// blockly/core/field.js
$kFmW2.Field.prototype.fromXml = function(fieldElement) {
    this.setValue($kFmW2.utils.replaceMessageReferences(fieldElement.textContent));
};
// blockly/core/xml.js
$kFmW2.Xml.domToVariables = function(xmlVariables, workspace) {
    for(var i = 0, xmlChild; xmlChild = xmlVariables.childNodes[i]; i++){
        if (xmlChild.nodeType != $kFmW2.utils.dom.NodeType.ELEMENT_NODE) continue; // Skip text nodes.
        var type = xmlChild.getAttribute("type");
        var id = xmlChild.getAttribute("id");
        var name = $kFmW2.utils.replaceMessageReferences(xmlChild.textContent);
        workspace.createVariable(name, type, id);
    }
};
// blockly/core/xml.js
$kFmW2.Xml.applyCommentTagNodes_ = function(xmlChildren, block) {
    for(var i = 0, xmlChild; xmlChild = xmlChildren[i]; i++){
        var text = $kFmW2.utils.replaceMessageReferences(xmlChild.textContent);
        var pinned = xmlChild.getAttribute("pinned") == "true";
        var width = parseInt(xmlChild.getAttribute("w"), 10);
        var height = parseInt(xmlChild.getAttribute("h"), 10);
        block.setCommentText(text);
        block.commentModel.pinned = pinned;
        if (!isNaN(width) && !isNaN(height)) block.commentModel.size = new $kFmW2.utils.Size(width, height);
        if (pinned && block.getCommentIcon && !block.isInFlyout) setTimeout(function() {
            block.getCommentIcon().setVisible(true);
        }, 1);
    }
};
// blockly/core/xml.js
$kFmW2.Xml.applyDataTagNodes_ = function(xmlChildren, block) {
    for(var i = 0, xmlChild; xmlChild = xmlChildren[i]; i++)block.data = $kFmW2.utils.replaceMessageReferences(xmlChild.textContent);
};


parcelRequire("cxq7w");

var $460Qg = parcelRequire("460Qg");

var $gnVfA = parcelRequire("gnVfA");
parcelRequire("67PMQ");
parcelRequire("cK1vO");

var $460Qg = parcelRequire("460Qg");

var $kFmW2 = parcelRequire("kFmW2");
// Palette: https://coolors.co/4c97ff-5cc15c-ff9f29-ff6680-7875ff
(0, $kFmW2.Msg).MOVEMENT_HEX = "#4c97ff";
(0, $kFmW2.Msg).OBJECTS_HEX = "#59c059";
(0, $kFmW2.Msg).LOGIC_HEX = "#ff9f29";
(0, $kFmW2.Msg).EXTRAS_HEX = "#ff6680";
(0, $kFmW2.Msg).MATH_HEX = "#7875FF";
(0, $kFmW2.Msg).EXAMPLES_HEX = '#888888';
(0, $kFmW2.Msg).STRUCTURE_HEX = '#888888';
// Reference: https://blocklycodelabs.dev/codelabs/theme-extension-identifier/index.html#0
$460Qg.Themes.Rocksi = $460Qg.Theme.defineTheme('rocksi', {
    'base': $460Qg.Themes.Modern,
    'blockStyles': {
        'movement_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).MOVEMENT_HEX
        },
        'objects_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).OBJECTS_HEX
        },
        'colour_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).OBJECTS_HEX
        },
        'logic_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).LOGIC_HEX
        },
        'loop_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).LOGIC_HEX
        },
        'extras_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).EXTRAS_HEX
        },
        'examples_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).EXAMPLES_HEX
        },
        'structure_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).STRUCTURE_HEX
        },
        'math_blocks': {
            'colourPrimary': (0, $kFmW2.Msg).MATH_HEX
        }
    },
    'categoryStyles': {}
});



var $kFmW2 = parcelRequire("kFmW2");
(0, $kFmW2.FieldAngle).WRAP = 180;



var $kFmW2 = parcelRequire("kFmW2");
$kFmW2.Blocks["scale"] = {
    init: function() {
        this.jsonInit({
            type: "scale",
            message0: "%{BKY_ROCKSI_BLOCK_SCALE}",
            args0: [
                {
                    type: "field_slider",
                    name: "NUM",
                    value: 1,
                    min: 0.01,
                    max: 10,
                    precision: 0.1
                }
            ],
            output: 'Number',
            style: 'math_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_SCALE_TOOLTIP}",
            helpUrl: ""
        });
    }
};



var $kFmW2 = parcelRequire("kFmW2");

var $8TfIJ = parcelRequire("8TfIJ");

var $3z8rE = parcelRequire("3z8rE");

var $kFmW2 = parcelRequire("kFmW2");
const $f6ff4ca4ddd3105c$var$FIELD_ID_LEFT = 'LeftMutatorField';
const $f6ff4ca4ddd3105c$var$FIELD_ID_RIGHT = 'RightMutatorField';
// TODO Use a custom field to avoid field spacing
// See https://developers.google.com/blockly/guides/create-custom-blocks/fields/customizing-fields/extending
function $f6ff4ca4ddd3105c$var$createButton(iconPath, altText, tooltip) {
    let icon = $kFmW2.utils.dom.createSvgElement($kFmW2.utils.Svg.SVG, {}, null);
    // Square with rounded corners
    $kFmW2.utils.dom.createSvgElement($kFmW2.utils.Svg.RECT, {
        'class': 'blocklyIconShape',
        'rx': '4',
        'ry': '4',
        'height': '18',
        'width': '18',
        'fill': '#00f'
    }, icon);
    // Circle
    $kFmW2.utils.dom.createSvgElement($kFmW2.utils.Svg.CIRCLE, {
        'class': 'blocklyIconSymbol',
        'r': '6',
        'cx': '9',
        'cy': '9',
        'fill': '#fff'
    }, icon);
    // Downwards arrow
    $kFmW2.utils.dom.createSvgElement($kFmW2.utils.Svg.PATH, {
        'class': 'blocklyIconShape',
        'd': iconPath,
        'style': 'stroke: none;',
        'fill': '#00f'
    }, icon);
    let icon_src = $kFmW2.utils.xml.domToText(icon);
    icon_src = 'data:image/svg+xml;base64,' + btoa(icon_src);
    const button = new $kFmW2.FieldImage(icon_src, 18, 18, altText, undefined, {
        'tooltip': tooltip
    });
    button.initModel = function() {
        $kFmW2.utils.dom.addClass(button.fieldGroup_, 'leftRightMutatorButton');
    };
    return button;
}
function $f6ff4ca4ddd3105c$var$createLeft() {
    return $f6ff4ca4ddd3105c$var$createButton('M 4 9 l 6 -5 v 3 h 3 v 4 h -3 v 3 Z', '\u25C0', "\xdcbernehme die Werte aus der 3D-Ansicht");
}
function $f6ff4ca4ddd3105c$var$createRight() {
    return $f6ff4ca4ddd3105c$var$createButton('M 13 9 l -6 -5 v 3 h -3 v 4 h 3 v 3 Z', '\u25B6', 'Aktualisiere das Objekt in der 3D-Ansicht');
}
const $f6ff4ca4ddd3105c$var$LeftRightMutator = {
    // Just an empty element for parameter storage so blockly is happy and we can use the mutator
    domToMutation: function() {},
    mutationToDom: function() {
        return document.createElement('mutation');
    },
    addButtons: function() {
        if (!this.getField($f6ff4ca4ddd3105c$var$FIELD_ID_LEFT)) {
            const left = $f6ff4ca4ddd3105c$var$createLeft();
            left.setOnClickHandler(this.left);
            this.inputList[0].appendField(left, $f6ff4ca4ddd3105c$var$FIELD_ID_LEFT);
        }
        if (!this.getField($f6ff4ca4ddd3105c$var$FIELD_ID_RIGHT)) {
            const right = $f6ff4ca4ddd3105c$var$createRight();
            right.setOnClickHandler(this.right);
            this.inputList[0].appendField(right, $f6ff4ca4ddd3105c$var$FIELD_ID_RIGHT);
        }
    },
    left: function(e) {
        const block = this.sourceBlock_;
        if (typeof block.onLeft === 'function') block.onLeft(e);
    },
    right: function(e) {
        const block = this.sourceBlock_;
        if (typeof block.onRight === 'function') block.onRight(e);
    }
};
const $f6ff4ca4ddd3105c$var$leftRightHelper = function() {
    this.addButtons();
};
$kFmW2.Extensions.registerMutator('left_right_mutator', $f6ff4ca4ddd3105c$var$LeftRightMutator, $f6ff4ca4ddd3105c$var$leftRightHelper);
var $f6ff4ca4ddd3105c$export$2e2bcd8739ae039 = $f6ff4ca4ddd3105c$var$LeftRightMutator;


$kFmW2.Blocks["move"] = {
    init: function() {
        this.jsonInit({
            type: "move",
            message0: "%{BKY_ROCKSI_BLOCK_MOVE}",
            args0: [
                {
                    type: "input_value",
                    name: "POSE",
                    check: [
                        "TaskspacePose",
                        "JointspacePose"
                    ]
                }
            ],
            inputsInline: false,
            previousStatement: null,
            nextStatement: "Array",
            style: 'movement_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_MOVE_TOOLTIP}",
            helpUrl: ""
        });
    },
    getJointspacePose: function() {
        const jpose = (0, $3z8rE.default).instance.getJointSpacePose();
        for(let j = 0; j < jpose.length; j++)jpose[j] = jpose[j] * 180.0 / Math.PI;
        return jpose;
    },
    setJointspacePose: function(degrees) {
        for(let i = 0; i < degrees.length; i++)degrees[i] *= Math.PI / 180.0;
        (0, $3z8rE.default).instance.robot.setPose(degrees);
        (0, $3z8rE.default).instance.renderCallback();
    },
    getTaskspacePose: function() {
        let tpose = (0, $3z8rE.default).instance.getTaskSpacePose();
        for(let j = 3; j < 6; j++)tpose[j] = tpose[j] * 180.0 / Math.PI;
        return tpose;
    },
    setTaskspacePose: function(pose) {
        const robot = (0, $3z8rE.default).instance.robot;
        const ikTarget = new (0, $8TfIJ.Object3D)();
        ikTarget.position.set(pose[0], pose[1], pose[2]);
        if (pose.length > 3) ikTarget.setRotationFromEuler(new (0, $8TfIJ.Euler)(pose[3], pose[4], pose[5]));
        else ikTarget.setRotationFromQuaternion(robot.tcp.object.quaternion);
        const solution = (0, $3z8rE.default).instance.ik.solve(ikTarget, robot, robot.ikEnabled, {
            // This should be precise to avoid surprises for the user
            maxIterations: 30,
            stopDistance: 0.05,
            jointLimits: robot.interactionJointLimits,
            apply: false
        });
        this.setJointspacePose(solution);
    }
};
$kFmW2.Blocks["default_pose"] = {
    init: function() {
        this.jsonInit({
            type: "default_pose",
            message0: "%{BKY_ROCKSI_BLOCK_DEFAULTPOSE}",
            output: "JointspacePose",
            style: 'movement_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_DEFAULTPOSE_TOOLTIP}",
            helpUrl: ""
        });
        const sim = (0, $3z8rE.default).instance;
        const pose = [];
        const robot = sim.robot;
        const defaults = robot.defaultPose;
        for (const joint of robot.arm.movable){
            let angle = defaults[joint.name] || 0.0;
            angle *= 180 / Math.PI;
            pose.push(angle);
        }
        let tooltip = '';
        for(let i = 0; i < pose.length; i++)tooltip += 'j' + (i + 1) + ': ' + pose[i].toFixed(0) + "\xb0\n";
        this.setTooltip(tooltip);
        this.defaultPose = pose;
    }
};
$kFmW2.Blocks["joint_space_pose"] = {
    init: function() {
        const sim = (0, $3z8rE.default).instance;
        this.numJoints = sim.robot.arm.movable.length;
        let the_message = '';
        let the_args = [];
        // 1-based
        for(let i = 1; i <= this.numJoints; i++){
            the_message += 'j' + i + ' %' + i;
            the_args.push({
                type: "field_angle",
                name: "JOINT_" + i,
                angle: 0
            });
        }
        this.jsonInit({
            type: "joint_space_pose",
            message0: the_message,
            args0: the_args,
            inputsInline: true,
            output: "JointspacePose",
            style: 'movement_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_JOINTSPACEPOSE_TOOLTIP}",
            helpUrl: "",
            mutator: 'left_right_mutator'
        });
    },
    onLeft: function(e) {
        var parent = this.getParent();
        if (parent != null && typeof parent.getJointspacePose === 'function') {
            var fieldValues = parent.getJointspacePose();
            for(var i = 0; i < fieldValues.length; i++)this.setFieldValue(fieldValues[i].toFixed(0), 'JOINT_' + (i + 1));
        }
    },
    onRight: function(e) {
        var parent = this.getParent();
        if (parent != null && typeof parent.setJointspacePose === 'function') {
            let pose = [];
            for(let i = 1; i <= this.numJoints; i++)pose.push(this.getFieldValue('JOINT_' + i));
            parent.setJointspacePose(pose);
        }
    }
};
$kFmW2.Blocks["task_space_pose"] = {
    init: function() {
        let i = 0;
        this.jsonInit({
            type: "pose",
            message0: "x %1 y %2 z %3 \u03D5 %4 \u03B8 %5 \u03C8 %6",
            args0: [
                {
                    "type": "field_number",
                    "name": "X",
                    "value": 0,
                    "precision": 0.1
                },
                {
                    "type": "field_number",
                    "name": "Y",
                    "value": 0,
                    "precision": 0.1
                },
                {
                    "type": "field_number",
                    "name": "Z",
                    "value": 0,
                    "min": 0,
                    "precision": 0.1
                },
                {
                    "type": "field_angle",
                    "name": "ROLL",
                    "angle": 0,
                    "precision": 0.1
                },
                {
                    "type": "field_angle",
                    "name": "PITCH",
                    "angle": 0,
                    "precision": 0.1
                },
                {
                    "type": "field_angle",
                    "name": "YAW",
                    "angle": 0,
                    "precision": 0.1
                }
            ],
            inputsInline: true,
            output: "TaskspacePose",
            style: 'movement_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_TASKSPACEPOSE_TOOLTIP}",
            helpUrl: "",
            mutator: 'left_right_mutator'
        });
    },
    onLeft: function(e) {
        const fieldKeys = [
            'X',
            'Y',
            'Z',
            'ROLL',
            'PITCH',
            'YAW'
        ];
        var parent = this.getParent();
        if (parent != null && typeof parent.getTaskspacePose === 'function') {
            var fieldValues = parent.getTaskspacePose();
            for(var i = 0; i < fieldValues.length; i++){
                let val = i < 3 ? fieldValues[i].toFixed(1) : fieldValues[i].toFixed(0);
                this.setFieldValue(val, fieldKeys[i]);
            }
        }
    },
    onRight: function(e) {
        var parent = this.getParent();
        if (parent != null && typeof parent.setTaskspacePose === 'function') {
            let pose = [];
            for (const key of [
                'X',
                'Y',
                'Z',
                'ROLL',
                'PITCH',
                'YAW'
            ])pose.push(this.getFieldValue(key));
            parent.setTaskspacePose(pose);
        }
    }
};
$kFmW2.Blocks["joint_absolute"] = {
    init: function() {
        const sim = (0, $3z8rE.default).instance;
        this.numJoints = sim.robot.arm.movable.length;
        let the_options = [];
        for(let i = 1; i <= this.numJoints; i++)the_options.push([
            'j' + i,
            i.toString()
        ]);
        this.jsonInit({
            type: "joint_absolute",
            message0: "%{BKY_ROCKSI_BLOCK_JOINTABSOLUTE}",
            args0: [
                {
                    "type": "field_dropdown",
                    "name": "JOINT",
                    "options": the_options
                },
                {
                    "type": "field_angle",
                    "name": "DEGREES",
                    "angle": 0
                }
            ],
            inputsInline: false,
            previousStatement: null,
            nextStatement: null,
            style: 'movement_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_JOINTABSOLUTE_TOOLTIP}",
            helpUrl: ""
        });
    }
};
$kFmW2.Blocks["joint_relative"] = {
    init: function() {
        const sim = (0, $3z8rE.default).instance;
        this.numJoints = sim.robot.arm.movable.length;
        let the_options = [];
        for(let i = 1; i <= this.numJoints; i++)the_options.push([
            'j' + i,
            i.toString()
        ]);
        this.jsonInit({
            type: "joint_relative",
            message0: "%{BKY_ROCKSI_BLOCK_JOINTRELATIVE}",
            args0: [
                {
                    "type": "field_dropdown",
                    "name": "JOINT",
                    "options": the_options
                },
                {
                    "type": "field_angle",
                    "name": "DEGREES",
                    "angle": 0
                }
            ],
            inputsInline: false,
            previousStatement: null,
            nextStatement: null,
            style: "movement_blocks",
            tooltip: "%{BKY_ROCKSI_BLOCK_JOINTRELATIVE_TOOLTIP}",
            helpUrl: ""
        });
    }
};



var $kFmW2 = parcelRequire("kFmW2");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * @fileoverview Number slider input field.
 * @author kozbial@google.com (Monica Kozbial)
 */ 
var $460Qg = parcelRequire("460Qg");
class $13d684822b8dfb0a$export$571c372b93e1f7d0 extends $460Qg.FieldNumber {
    /**
   * Constructs a FieldSlider from a JSON arg object.
   * @param {!Object} options A JSON object with options (value, min, max, and
   *                          precision).
   * @return {!FieldSlider} The new field instance.
   * @package
   * @nocollapse
   */ static fromJson(options) {
        return new $13d684822b8dfb0a$export$571c372b93e1f7d0(options['value'], undefined, undefined, undefined, undefined, options);
    }
    /**
   * Show the inline free-text editor on top of the text along with the slider
   *    editor.
   * @param {Event=} e Optional mouse event that triggered the field to
   *     open, or undefined if triggered programmatically.
   * @param {boolean=} _quietInput Quiet input.
   * @protected
   * @override
   */ showEditor_(e, _quietInput) {
        // Mobile browsers have issues with in-line textareas (focus & keyboards).
        const noFocus = $460Qg.utils.userAgent.MOBILE || $460Qg.utils.userAgent.ANDROID || $460Qg.utils.userAgent.IPAD;
        super.showEditor_(e, noFocus);
        // Build the DOM.
        const editor = this.dropdownCreate_();
        $460Qg.DropDownDiv.getContentDiv().appendChild(editor);
        $460Qg.DropDownDiv.setColour(this.sourceBlock_.style.colourPrimary, this.sourceBlock_.style.colourTertiary);
        $460Qg.DropDownDiv.showPositionedByField(this, this.dropdownDispose_.bind(this));
    }
    /**
   * Updates the slider when the field rerenders.
   * @protected
   * @override
   */ render_() {
        super.render_();
        this.updateSlider_();
    }
    /**
   * Creates the slider editor and add event listeners.
   * @return {!Element} The newly created slider.
   * @private
   */ dropdownCreate_() {
        const wrapper = document.createElement('div');
        wrapper.className = 'fieldSliderContainer';
        const sliderInput = document.createElement('input');
        sliderInput.setAttribute('type', 'range');
        sliderInput.setAttribute('min', this.min_);
        sliderInput.setAttribute('max', this.max_);
        sliderInput.setAttribute('step', this.precision_);
        sliderInput.setAttribute('value', this.getValue());
        sliderInput.className = 'fieldSlider';
        wrapper.appendChild(sliderInput);
        this.sliderInput_ = sliderInput;
        this.boundEvents_.push($460Qg.bindEventWithChecks_(sliderInput, 'input', this, this.onSliderChange_));
        return wrapper;
    }
    /**
   * Disposes of events belonging to the slider editor.
   * @private
   */ dropdownDispose_() {
        for (const event of this.boundEvents_)$460Qg.unbindEvent_(event);
        this.sliderInput_ = null;
    }
    /**
   * Sets the text to match the slider's position.
   * @private
   */ onSliderChange_() {
        this.setEditorValue_(this.sliderInput_.value);
    }
    /**
   * Updates the slider when the field rerenders.
   * @private
   */ updateSlider_() {
        if (!this.sliderInput_) return;
        this.sliderInput_.setAttribute('value', this.getValue());
    }
    /**
   * Class for an number slider field.
   * @param {string|number=} value The initial value of the field. Should
   *    cast to a number. Defaults to 0.
   * @param {?(string|number)=} min Minimum value.
   * @param {?(string|number)=} max Maximum value.
   * @param {?(string|number)=} precision Precision for value.
   * @param {?Function=} validator A function that is called to validate
   *    changes to the field's value. Takes in a number & returns a validated
   *    number, or null to abort the change.
   * @param {Object=} config A map of options used to configure the field.
   *    See the [field creation documentation]{@link
   * https://developers.google.com/blockly/guides/create-custom-blocks/fields/built-in-fields/number#creation}
   *    for a list of properties this parameter supports.
   * @extends {Blockly.FieldNumber}
   * @constructor
   */ constructor(value, min, max, precision, validator, config){
        super(value, min, max, precision, validator, config);
        /**
     * Array holding info needed to unbind events.
     * Used for disposing.
     * Ex: [[node, name, func], [node, name, func]].
     * @type {!Array.<Array<?>>}
     * @private
     */ this.boundEvents_ = [];
        /**
     * The HTML range input element.
     * @type {?HTMLInputElement}
     * @private
     */ this.sliderInput_ = null;
    }
}
$460Qg.fieldRegistry.register('field_slider', $13d684822b8dfb0a$export$571c372b93e1f7d0);
/**
 * CSS for slider field.
 */ $460Qg.Css.register([
    /* eslint-disable indent */ `.fieldSliderContainer {
      align-items: center;
      display: flex;
      height: 32px;
      justify-content: center;
      width: 150px;
    }
    .fieldSlider {
      -webkit-appearance: none;
      background: transparent; /* override white in chrome */
      margin: 4px;
      padding: 0;
      width: 100%;
    }
    .fieldSlider:focus {
      outline: none;
    }
    /* Webkit */
    .fieldSlider::-webkit-slider-runnable-track {
      background: #ddd;
      border-radius: 5px;
      height: 10px;
    }
    .fieldSlider::-webkit-slider-thumb {
      -webkit-appearance: none;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 0 0 4px rgba(255,255,255,.15);
      cursor: pointer;
      height: 24px;
      margin-top: -7px;
      width: 24px;
    }
    /* Firefox */
    .fieldSlider::-moz-range-track {
      background: #ddd;
      border-radius: 5px;
      height: 10px;
    }
    .fieldSlider::-moz-range-thumb {
      background: #fff;
      border: none;
      border-radius: 50%;
      box-shadow: 0 0 0 4px rgba(255,255,255,.15);
      cursor: pointer;
      height: 24px;
      width: 24px;
    }
    .fieldSlider::-moz-focus-outer {
      /* override the focus border style */
      border: 0;
    }
    /* IE */
    .fieldSlider::-ms-track {
      /* IE wont let the thumb overflow the track, so fake it */
      background: transparent;
      border-color: transparent;
      border-width: 15px 0;
      /* remove default tick marks */
      color: transparent;
      height: 10px;
      width: 100%;
      margin: -4px 0;
    }
    .fieldSlider::-ms-fill-lower  {
      background: #ddd;
      border-radius: 5px;
    }
    .fieldSlider::-ms-fill-upper  {
      background: #ddd;
      border-radius: 5px;
    }
    .fieldSlider::-ms-thumb {
      background: #fff;
      border: none;
      border-radius: 50%;
      box-shadow: 0 0 0 4px rgba(255,255,255,.15);
      cursor: pointer;
      height: 24px;
      width: 24px;
    }`
]);





var $29ZVX = parcelRequire("29ZVX");

var $3z8rE = parcelRequire("3z8rE");
const $752ab02cd7558945$var$fieldKeys = [
    'X',
    'Y',
    'Z',
    'ROLL',
    'PITCH',
    'YAW'
];
$kFmW2.Blocks["gripper_open"] = {
    init: function() {
        this.jsonInit({
            type: "gripper_open",
            message0: "%{BKY_ROCKSI_BLOCK_GRIPPEROPEN}",
            previousStatement: null,
            nextStatement: null,
            style: 'objects_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_GRIPPEROPEN_TOOLTIP}",
            helpUrl: ""
        });
    }
};
$kFmW2.Blocks["gripper_close"] = {
    init: function() {
        this.jsonInit({
            type: "gripper_close",
            message0: "%{BKY_ROCKSI_BLOCK_GRIPPERCLOSE}",
            previousStatement: null,
            nextStatement: null,
            style: 'objects_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_GRIPPERCLOSE_TOOLTIP}",
            helpUrl: ""
        });
    }
};
//Spawn block definition and other 3D-object interaction blocks
//The SimObject spawn block:
$kFmW2.Blocks['add_sim_object'] = {
    init: function() {
        this.jsonInit({
            type: "add_sim_object",
            message0: "%{BKY_ROCKSI_BLOCK_SIMOBJECT}",
            args0: [
                {
                    "type": "field_dropdown",
                    "name": "OBJECT_SHAPE",
                    "options": [
                        [
                            "%{BKY_ROCKSI_BLOCK_SIMOBJECT_CUBE}",
                            "cube"
                        ],
                        [
                            "%{BKY_ROCKSI_BLOCK_SIMOBJECT_SPHERE}",
                            "sphere"
                        ],
                        [
                            "%{BKY_ROCKSI_BLOCK_SIMOBJECT_ROCK}",
                            "rock"
                        ],
                        [
                            "%{BKY_ROCKSI_BLOCK_SIMOBJECT_SHAFT}",
                            "shaft"
                        ],
                        [
                            "%{BKY_ROCKSI_BLOCK_SIMOBJECT_CUSTOM}",
                            "custom"
                        ]
                    ]
                }
            ],
            message1: "%{BKY_ROCKSI_BLOCK_SIMOBJECT_COLOR}",
            args1: [
                {
                    type: "input_value",
                    name: "COLOUR",
                    check: "Colour"
                }
            ],
            message2: "%{BKY_ROCKSI_BLOCK_SIMOBJECT_POSITION}",
            args2: [
                {
                    type: "input_value",
                    name: "POSE",
                    check: "TaskspacePose"
                }
            ],
            message3: "%{BKY_ROCKSI_BLOCK_SIMOBJECT_SCALE}",
            args3: [
                {
                    type: "input_value",
                    name: "SCALE",
                    check: "Number"
                }
            ],
            inputsInline: false,
            previousStatement: null,
            nextStatement: null,
            style: 'objects_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_SIMOBJECT_TOOLTIP}",
            helpUrl: ""
        });
    },
    getTaskspacePose: function() {
        let fieldValues = [];
        const simObject = (0, $29ZVX.getSimObject)(this.id);
        if (simObject != undefined) {
            simObject.updateFieldValues();
            fieldValues = simObject.getFieldValues();
        }
        return fieldValues;
    },
    setTaskspacePose: function(pose) {
        const simObject = (0, $29ZVX.getSimObject)(this.id);
        if (simObject !== undefined) {
            //simObject.setFieldValues(pose);
            simObject.updateFromFieldValues();
            (0, $3z8rE.default).instance.renderCallback();
        }
    },
    onchange: function(event) {
        let simObject = (0, $29ZVX.getSimObject)(this.id);
        if (!simObject) return;
        const poseBlock = this.getInputTargetBlock('POSE');
        const colorBlock = this.getInputTargetBlock('COLOUR');
        const scaleBlock = this.getInputTargetBlock('SCALE');
        if (event.blockId === this.id && event.name == 'OBJECT_SHAPE') simObject.changeShape(event.newValue);
        if (poseBlock !== null && event.blockId === poseBlock.id && $752ab02cd7558945$var$fieldKeys.includes(event.name)) {
            let fieldValues = [];
            for(let i = 0; i < $752ab02cd7558945$var$fieldKeys.length; i++)fieldValues.push(poseBlock.getFieldValue($752ab02cd7558945$var$fieldKeys[i]));
            simObject.setFieldValues(fieldValues);
            simObject.updateFromFieldValues();
            (0, $3z8rE.default).instance.renderCallback();
        }
        if (scaleBlock !== null && event.blockId === scaleBlock.id) simObject.setScale(event.newValue);
        if (colorBlock != null) {
            let color = simObject.color;
            if (event.blockId === colorBlock.id) {
                if (colorBlock.type == 'colour_random') color = (0, $29ZVX.randomColour)();
                else if (colorBlock.type == 'colour_picker') color = colorBlock.getFieldValue('COLOUR');
            }
            // Do this no matter what so the simObject updates its texture
            simObject.setColor(color);
            (0, $3z8rE.default).instance.renderCallback();
            if (colorBlock.type == 'colour_random') colorBlock.setColour(simObject.color);
        }
    }
};
//The physics_done block
$kFmW2.Blocks["physics_done"] = {
    init: function() {
        this.jsonInit({
            type: "physics_done",
            message0: "%{BKY_ROCKSI_BLOCK_PHYSICSDONE}",
            output: "Boolean",
            style: 'objects_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_PHYSICSDONE_TOOLTIP}",
            helpUrl: ""
        });
    }
};
//The is_attached block
$kFmW2.Blocks["is_attached"] = {
    init: function() {
        this.jsonInit({
            type: "is_attached",
            message0: "%{BKY_ROCKSI_BLOCK_HOLDING}",
            output: "Boolean",
            style: 'objects_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_HOLDING_TOOLTIP}",
            helpUrl: ""
        });
    }
};



var $kFmW2 = parcelRequire("kFmW2");

var $3z8rE = parcelRequire("3z8rE");
$kFmW2.Blocks["comment"] = {
    init: function() {
        this.jsonInit({
            type: "comment",
            message0: "%{BKY_ROCKSI_BLOCK_COMMENT}",
            args0: [
                {
                    type: "field_input",
                    name: "COMMENT",
                    text: ""
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: 'structure_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_COMMENT_TOOLTIP}",
            helpUrl: ""
        });
    }
};
$kFmW2.Blocks["wait"] = {
    init: function() {
        this.jsonInit({
            type: "wait",
            message0: "%{BKY_ROCKSI_BLOCK_WAIT}",
            args0: [
                {
                    "type": "field_number",
                    "name": "SECONDS",
                    "value": 1,
                    "min": 0,
                    "precision": 1
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: 'extras_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_WAIT_TOOLTIP}",
            helpUrl: ""
        });
    }
};
$kFmW2.Blocks["set_speed"] = {
    init: function() {
        this.jsonInit({
            "type": "set_speed",
            "message0": "%{BKY_ROCKSI_BLOCK_SETSPEED}",
            "args0": [
                {
                    "type": "field_dropdown",
                    "name": "MOTION_TYPE",
                    "options": [
                        [
                            "%{BKY_ROCKSI_BLOCK_SETSPEED_MOVE}",
                            "move"
                        ],
                        [
                            "%{BKY_ROCKSI_BLOCK_SETSPEED_GRIPPER}",
                            "gripper"
                        ]
                    ]
                },
                {
                    "type": "field_number",
                    "name": "SPEED",
                    "value": 50,
                    "min": 1,
                    "max": 100,
                    "precision": 1
                }
            ],
            previousStatement: null,
            nextStatement: null,
            style: 'extras_blocks',
            "tooltip": "%{BKY_ROCKSI_BLOCK_SETSPEED_TOOLTIP}",
            "helpUrl": ""
        });
    }
};
$kFmW2.Blocks["joint_lock"] = {
    init: function() {
        const sim = (0, $3z8rE.default).instance;
        this.numJoints = sim.robot.arm.movable.length;
        let the_options = [];
        for(let i = 1; i <= this.numJoints; i++)the_options.push([
            'j' + i,
            i.toString()
        ]);
        this.jsonInit({
            type: "joint_lock",
            message0: "%{BKY_ROCKSI_BLOCK_JOINTLOCK}",
            args0: [
                {
                    "type": "field_dropdown",
                    "name": "JOINT",
                    "options": the_options
                }
            ],
            inputsInline: false,
            previousStatement: null,
            nextStatement: null,
            style: 'extras_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_JOINTLOCK_TOOLTIP}",
            helpUrl: ""
        });
    }
};
$kFmW2.Blocks["joint_unlock"] = {
    init: function() {
        const sim = (0, $3z8rE.default).instance;
        this.numJoints = sim.robot.arm.movable.length;
        let the_options = [];
        for(let i = 1; i <= this.numJoints; i++)the_options.push([
            'j' + i,
            i.toString()
        ]);
        this.jsonInit({
            type: "joint_unlock",
            message0: "%{BKY_ROCKSI_BLOCK_JOINTUNLOCK}",
            args0: [
                {
                    "type": "field_dropdown",
                    "name": "JOINT",
                    "options": the_options
                }
            ],
            inputsInline: false,
            previousStatement: null,
            nextStatement: null,
            style: 'extras_blocks',
            tooltip: "%{BKY_ROCKSI_BLOCK_JOINTUNLOCK_TOOLTIP}",
            helpUrl: ""
        });
    }
};



var $kFmW2 = parcelRequire("kFmW2");
parcelRequire("3z8rE");

var $29ZVX = parcelRequire("29ZVX");
/* ========
 * MOVEMENT
 * ======== */ $kFmW2.JavaScript["move"] = function(block) {
    let pose = $kFmW2.JavaScript.valueToCode(block, 'POSE', $kFmW2.JavaScript.ORDER_COMMA) || 0;
    let poseType = block.getInputTargetBlock('POSE').outputConnection.getCheck()[0];
    var code = 'robot("move", "' + poseType + '", ' + pose + ');\n';
    return code;
};
$kFmW2.JavaScript["default_pose"] = function(block) {
    let ret = '[' + this.defaultPose.toString() + ']';
    return [
        ret,
        $kFmW2.JavaScript.ORDER_ATOMIC
    ];
};
$kFmW2.JavaScript["joint_space_pose"] = function(block) {
    let pose = [];
    for(let i = 1; i < 8; i++)pose.push(block.getFieldValue('JOINT_' + i));
    let code = '[' + pose.toString() + ']';
    return [
        code,
        $kFmW2.JavaScript.ORDER_ATOMIC
    ];
};
$kFmW2.JavaScript["task_space_pose"] = function(block) {
    let pose = [];
    for (const key of [
        'X',
        'Y',
        'Z',
        'ROLL',
        'PITCH',
        'YAW'
    ])pose.push(block.getFieldValue(key));
    let code = '[' + pose.toString() + ']';
    return [
        code,
        $kFmW2.JavaScript.ORDER_ATOMIC
    ];
};
$kFmW2.JavaScript["joint_absolute"] = function(block) {
    let joint = block.getFieldValue('JOINT');
    let angle = block.getFieldValue('DEGREES');
    let code = 'robot("joint_absolute", ' + joint + ', ' + angle + ');\n';
    return code;
};
$kFmW2.JavaScript["joint_relative"] = function(block) {
    let joint = block.getFieldValue('JOINT');
    let angle = block.getFieldValue('DEGREES');
    let code = 'robot("joint_relative", ' + joint + ', ' + angle + ');\n';
    return code;
};
/* =======
 * OBJECTS
 * ======= */ $kFmW2.JavaScript["gripper_open"] = function(block) {
    var code = 'robot("gripper_open");\n';
    return code;
};
$kFmW2.JavaScript["gripper_close"] = function(block) {
    var code = 'robot("gripper_close");\n';
    return code;
};
$kFmW2.JavaScript["add_sim_object"] = function(block) {
    var idx = (0, $29ZVX.getSimObjectIdx)(this.id);
    var simObject = (0, $29ZVX.getSimObject)(this.id);
    simObject.updateFromFieldValues();
    var code = 'robot("startPhysicalBody", ' + idx + ');';
    return code;
};
$kFmW2.JavaScript["physics_done"] = function(block) {
    let code = 'robot("getPhysicsDone")';
    return [
        code,
        $kFmW2.JavaScript.ORDER_ATOMIC
    ];
};
$kFmW2.JavaScript["is_attached"] = function(block) {
    let ret = '["is_attached", ' + (0, $29ZVX.isAttached)() + ']';
    console.log(ret);
    return [
        ret,
        $kFmW2.JavaScript.ORDER_ATOMIC
    ];
};
/* ======
 * EXTRAS
 * ====== */ $kFmW2.JavaScript["comment"] = function(block) {
    return "// " + block.getFieldValue('COMMENT') + '\n';
};
$kFmW2.JavaScript["wait"] = function(block) {
    let time = block.getFieldValue('SECONDS');
    return 'robot("wait", ' + time * 1000 + ');\n';
};
$kFmW2.JavaScript["set_speed"] = function(block) {
    var motion = block.getFieldValue('MOTION_TYPE');
    var speed = block.getFieldValue('SPEED');
    var code = 'robot("setParam", "velocity/' + motion + '", ' + speed / 100 + ');\n';
    return code;
};
$kFmW2.JavaScript["joint_lock"] = function(block) {
    var joint = block.getFieldValue('JOINT');
    var code = 'robot("lockJoint", ' + joint + ');\n';
    return code;
};
$kFmW2.JavaScript["joint_unlock"] = function(block) {
    var joint = block.getFieldValue('JOINT');
    var code = 'robot("unlockJoint", ' + joint + ');\n';
    return code;
};


var $2bbdba0a13385d43$exports = {};
$2bbdba0a13385d43$exports = "<xml id=\"blocks-toolbox\" style=\"display: none\">\n    <!-- Bewegung des Roboters -->\n    <category name=\"%{BKY_ROCKSI_CATEGORY_MOVE}\" categorystyle=\"movement_category\">\n        <block type=\"move\"/>\n        <block type=\"default_pose\"/>\n        <block type=\"joint_space_pose\"/>\n        <block type=\"task_space_pose\"/>\n        <block type=\"joint_absolute\"/>\n        <block type=\"joint_relative\"/>\n    </category>\n\n    <!-- 3D-Objekte und Greifer -->\n    <category name=\"%{BKY_ROCKSI_CATEGORY_OBJECTS}\" categorystyle=\"objects_category\">\n        <block type=\"add_sim_object\">\n            <value name=\"COLOUR\">\n                <block type=\"colour_random\"/>\n            </value>\n            <value name=\"POSE\">\n                <block type=\"task_space_pose\">\n                    <field name=\"X\">5</field>\n                </block>\n            </value>\n            <value name=\"SCALE\">\n                <block type=\"scale\">\n                    <field name=\"NUM\">1</field>\n                </block>\n            </value>\n        </block>\n        <block type=\"is_attached\"/>\n        <block type=\"gripper_open\"/>\n        <block type=\"gripper_close\"/>\n        <block type=\"colour_picker\"/>\n        <block type=\"colour_random\"/>\n        <block type=\"physics_done\"/>\n    </category>\n\n    <!-- Schleifen & co -->\n    <category name=\"%{BKY_ROCKSI_CATEGORY_LOGIC}\" categorystyle=\"logic_category\">\n        <block type=\"controls_if\"/>\n        <block type=\"controls_whileUntil\"/>\n        <block type=\"controls_repeat\">\n            <value name=\"TIMES\">\n                <shadow type=\"math_number\">\n                    <field name=\"NUM\">10</field>\n                </shadow>\n            </value>\n        </block>\n        <block type=\"logic_boolean\"/>\n        <block type=\"logic_negate\"/>\n        <block type=\"controls_flow_statements\"/>\n    </category>\n\n    <!-- Kommentare, Einstellungen, etc. -->\n    <category name=\"%{BKY_ROCKSI_CATEGORY_EXTRAS}\" categorystyle=\"extras_category\">\n        <block type=\"comment\"/>\n        <block type=\"wait\"/>\n        <block type=\"set_speed\"/>\n        <block type=\"joint_lock\"/>\n        <block type=\"joint_unlock\"/>\n    </category>\n    \n    <!-- Beispielprogramme-->\n    <category name=\"%{BKY_ROCKSI_CATEGORY_EXAMPLES}\" categorystyle=\"examples_category\">\n        <!-- Pick & Place -->\n        <block type=\"comment\">\n            <field name=\"COMMENT\">%{BKY_ROCKSI_EXAMPLE_PICK_N_PLACE}</field>\n            <next>\n                <block type=\"move\">\n                    <value name=\"POSE\">\n                        <block type=\"default_pose\"/>\n                    </value>\n                    <next>\n                        <block type=\"add_sim_object\">\n                            <field name=\"OBJECT_SHAPE\">cube</field>\n                            <value name=\"COLOUR\">\n                                <block type=\"colour_random\"/>\n                            </value>\n                            <value name=\"SCALE\">\n                                <block type=\"scale\">\n                                    <field name=\"NUM\">1</field>\n                                </block>\n                            </value>\n                            <value name=\"POSE\">\n                                <block type=\"task_space_pose\">\n                                    <field name=\"X\">5</field>\n                                    <field name=\"Y\">0</field>\n                                    <field name=\"Z\">0</field>\n                                    <field name=\"ROLL\">0</field>\n                                    <field name=\"PITCH\">0</field>\n                                    <field name=\"YAW\">0</field>\n                                </block>\n                            </value>\n                            <next>\n                                <block type=\"gripper_open\">\n                                    <next>\n                                        <block type=\"wait\">\n                                            <field name=\"SECONDS\">1</field>\n                                            <next>\n                                                <block type=\"move\">\n                                                    <comment pinned=\"false\">%{BKY_ROCKSI_EXAMPLE_PICK_N_PLACE_COMMENT_1}</comment>\n                                                    <value name=\"POSE\">\n                                                        <block type=\"task_space_pose\">\n                                                            <field name=\"X\">5</field>\n                                                            <field name=\"Y\">0</field>\n                                                            <field name=\"Z\">0.3</field>\n                                                            <field name=\"ROLL\">0</field>\n                                                            <field name=\"PITCH\">0</field>\n                                                            <field name=\"YAW\">0</field>\n                                                        </block>\n                                                    </value>\n                                                    <next>\n                                                        <block type=\"gripper_close\">\n                                                            <next>\n                                                                <block type=\"move\">\n                                                                    <value name=\"POSE\">\n                                                                        <block type=\"default_pose\"/>\n                                                                    </value>\n                                                                    <next>\n                                                                        <block type=\"gripper_open\">\n                                                                            <next>\n                                                                                <block type=\"wait\">\n                                                                                    <field name=\"SECONDS\">3</field>\n                                                                                </block>\n                                                                            </next>\n                                                                        </block>\n                                                                    </next>\n                                                                </block>\n                                                            </next>\n                                                        </block>\n                                                    </next>\n                                                </block>\n                                            </next>\n                                        </block>\n                                    </next>\n                                </block>\n                            </next>\n                        </block>\n                    </next>\n                </block>\n            </next>\n        </block>\n    </category>\n</xml>";



var $29ZVX = parcelRequire("29ZVX");

var $gxi2A = parcelRequire("gxi2A");

var $3z8rE = parcelRequire("3z8rE");

var $cxq7w = parcelRequire("cxq7w");
const $75d3d815980f42e1$var$language = (0, $gnVfA.getDesiredLanguage)();
let $75d3d815980f42e1$var$BlocklyLang = null;
let $75d3d815980f42e1$var$BlocklyLangCustom = null;




switch($75d3d815980f42e1$var$language){
    case 'de':
        $75d3d815980f42e1$var$BlocklyLang = (parcelRequire("jxVWf"));
        $75d3d815980f42e1$var$BlocklyLangCustom = (parcelRequire("hFAmA")).BlocklyCustomDE;
        break;
    case 'en':
    default:
        $75d3d815980f42e1$var$BlocklyLang = (parcelRequire("8c7aX"));
        $75d3d815980f42e1$var$BlocklyLangCustom = (parcelRequire("ex1TO")).BlocklyCustomEN;
}
$460Qg.setLocale($75d3d815980f42e1$var$BlocklyLang);
$460Qg.setLocale($75d3d815980f42e1$var$BlocklyLangCustom);
const $75d3d815980f42e1$var$generator = $460Qg.JavaScript;
$75d3d815980f42e1$var$generator.STATEMENT_PREFIX = 'highlightBlock(%1);\n';
$75d3d815980f42e1$var$generator.addReservedWords('highlightBlock');
$75d3d815980f42e1$var$generator.addReservedWords('sendRobotCommand');
$75d3d815980f42e1$var$generator.addReservedWords('code');

var $kw6y2 = parcelRequire("kw6y2");

var $5X33T = parcelRequire("5X33T");
var $75d3d815980f42e1$var$blocklyArea = document.querySelector('.blocks-container');
var $75d3d815980f42e1$var$blocklyDiv = document.getElementById('blocks-canvas');
var $75d3d815980f42e1$var$workspace = $460Qg.inject($75d3d815980f42e1$var$blocklyDiv, {
    toolbox: (0, (/*@__PURE__*/$parcel$interopDefault($2bbdba0a13385d43$exports))),
    renderer: 'geras',
    horizontalLayout: false,
    grid: {
        spacing: 20,
        length: 3,
        colour: '#ddd',
        snap: true
    },
    move: {
        drag: true,
        scrollbars: true
    },
    zoom: {
        controls: true,
        wheel: false,
        startScale: 1.0,
        maxScale: 3,
        minScale: 0.3,
        scaleSpeed: 1.1,
        pinch: true
    },
    trashcan: false,
    collapse: false,
    disable: true,
    theme: $460Qg.Themes.Rocksi
});
// Open the toolbox and keep it open
//workspace.getToolbox().getFlyout().autoClose = false;
//$('blockly-0').click();
// Blockly is not using parenting for its HTML code, so we have to do some manual adjustments.
// TODO For some reason there is a second toolboxFlyout that is never used -> blockly bug?
var $75d3d815980f42e1$var$toolboxFlyout = $('.blocklyFlyout');
var $75d3d815980f42e1$var$toolboxScrollbar = $('.blocklyFlyoutScrollbar');
$75d3d815980f42e1$var$toolboxFlyout.each((idx, element)=>{
    var observer = new MutationObserver((mutations, observer)=>{
        let flyout = $(element);
        if (flyout.css('display') !== 'none') {
            let scrollbarX = parseInt(flyout.css('left')) + flyout.width() - $75d3d815980f42e1$var$toolboxScrollbar.width() + 2;
            $75d3d815980f42e1$var$toolboxScrollbar.css('transform', 'translate(' + scrollbarX + 'px, 2.5px)');
        }
    });
    observer.observe(element, {
        attributes: true
    });
});
// React to resize events
var $75d3d815980f42e1$var$onresize = function() {
    // Compute the absolute coordinates and dimensions of blocklyArea.
    var element = $75d3d815980f42e1$var$blocklyArea;
    var x = 0;
    var y = 0;
    do {
        x += element.offsetLeft;
        y += element.offsetTop;
        element = element.offsetParent;
    }while (element);
    // Position blocklyDiv over blocklyArea.
    $75d3d815980f42e1$var$blocklyDiv.style.left = x + 'px';
    $75d3d815980f42e1$var$blocklyDiv.style.top = y + 'px';
    $75d3d815980f42e1$var$blocklyDiv.style.width = $75d3d815980f42e1$var$blocklyArea.offsetWidth + 'px';
    $75d3d815980f42e1$var$blocklyDiv.style.height = $75d3d815980f42e1$var$blocklyArea.offsetHeight + 'px';
    $460Qg.svgResize($75d3d815980f42e1$var$workspace);
};
new $5X33T($75d3d815980f42e1$var$blocklyArea, $75d3d815980f42e1$var$onresize);
$75d3d815980f42e1$var$blocklyArea.addEventListener('resize', $75d3d815980f42e1$var$onresize, false);
$75d3d815980f42e1$var$onresize();
$460Qg.svgResize($75d3d815980f42e1$var$workspace);
// Blockly does not open context menus on long presses, so we provide an alternative
if (window.matchMedia('(hover: none)')) $('#blockly-mobile-menu').on('click', (evt)=>{
    console.log($460Qg.selected);
    if ($460Qg.selected !== null) {
        console.log('block');
        $75d3d815980f42e1$var$workspace.getBlockById($460Qg.selected.id).showContextMenu(evt);
    } else {
        console.log('workspace');
        $75d3d815980f42e1$var$workspace.showContextMenu(evt);
    }
});
// Right click menu item for exporting the workspace
var $75d3d815980f42e1$var$contextSaveWorkspace = {
    displayText: function() {
        return $460Qg.Msg['SAVE'] || 'Save workspace';
    },
    preconditionFn: function(scope) {
        if (scope.workspace.getTopBlocks(false).length > 0) return 'enabled';
        return 'disabled';
    },
    callback: function(scope) {
        let xml = $460Qg.Xml.workspaceToDom(scope.workspace);
        let text = $460Qg.Xml.domToText(xml);
        let download = document.createElement('a');
        download.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        download.setAttribute('download', 'workspace.xml');
        download.style.display = 'none';
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
    },
    scopeType: $460Qg.ContextMenuRegistry.ScopeType.WORKSPACE,
    id: 'saveWorkspace',
    weight: 99
};
$460Qg.ContextMenuRegistry.registry.register($75d3d815980f42e1$var$contextSaveWorkspace);
// Right click menu item for loading a workspace
var $75d3d815980f42e1$var$contextLoadWorkspace = {
    displayText: function() {
        return $460Qg.Msg['LOAD'] || 'Load workspace';
    },
    preconditionFn: function(scope) {
        return 'enabled';
    },
    callback: function(scope) {
        let upload = document.createElement('input');
        upload.setAttribute('type', 'file');
        upload.setAttribute('accept', '.xml');
        upload.style.display = 'none';
        upload.onchange = (fileSelectedEvent)=>{
            try {
                let file = fileSelectedEvent.target.files[0];
                let reader = new FileReader();
                reader.readAsText(file, 'UTF-8');
                reader.onload = (readerEvent)=>{
                    let text = readerEvent.target.result;
                    let xml = $460Qg.Xml.textToDom(text);
                    //workspace.clear();
                    $460Qg.Xml.domToWorkspace(scope.workspace, xml);
                };
            } catch (e) {
                console.log(e);
            }
        };
        document.body.appendChild(upload);
        upload.click();
        document.body.removeChild(upload);
    },
    scopeType: $460Qg.ContextMenuRegistry.ScopeType.WORKSPACE,
    id: 'loadWorkspace',
    weight: 99
};
$460Qg.ContextMenuRegistry.registry.register($75d3d815980f42e1$var$contextLoadWorkspace);
// Robot specific code export
(0, $3z8rE.default).getInstance().then((sim)=>{
    const robot = sim.robot;
    const generator = robot.generator;
    if (!generator) return;
    let contextExportRobotCode = {
        displayText: function() {
            return $460Qg.Msg['CODE_EXPORT'] || 'Code Export';
        },
        preconditionFn: function(scope) {
            if (scope.workspace.getTopBlocks(false).length > 0) return 'enabled';
            return 'disabled';
        },
        callback: function(scope) {
            generator.init(scope.workspace);
            let code = generator.workspaceToCode(scope.workspace);
            console.log(code);
            let download = document.createElement('a');
            download.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(code));
            download.setAttribute('download', robot.name + (generator.FILE_EXTENSION || '.txt'));
            download.style.display = 'none';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
            alert((0, $gnVfA.localize)('note-code-export'));
        },
        scopeType: $460Qg.ContextMenuRegistry.ScopeType.WORKSPACE,
        id: 'codeExport',
        weight: 99
    };
    $460Qg.ContextMenuRegistry.registry.register(contextExportRobotCode);
});
// Run button
const $75d3d815980f42e1$var$runButton = document.querySelector('.run-button');
$75d3d815980f42e1$var$runButton.onclick = function() {
    $75d3d815980f42e1$var$runButton.classList.toggle('running');
    if ($75d3d815980f42e1$var$runButton.classList.contains('running')) {
        if ($75d3d815980f42e1$var$workspace.getTopBlocks(false).length == 0) (0, $gxi2A.popWarning)($460Qg.Msg['EMPTY_PROGRAM'] || "Empty program");
        //event listener off
        $75d3d815980f42e1$var$compileProgram();
        $75d3d815980f42e1$var$executeProgram();
    } else {
        $75d3d815980f42e1$var$pauseExecution();
        $75d3d815980f42e1$var$simulation.cancel();
    }
    return false;
};
// Get simulation instance - this is the interface to our 3D robot
var $75d3d815980f42e1$var$simulation = null;
(0, $3z8rE.default).getInstance().then((sim)=>{
    // Once the simulation is available we can enable the run button
    $75d3d815980f42e1$var$simulation = sim;
    $75d3d815980f42e1$var$runButton.disabled = false;
});
function $75d3d815980f42e1$var$simulationAPI(interpreter, globalObject) {
    let wrapper = function(id) {
        return $75d3d815980f42e1$var$workspace.highlightBlock(id);
    };
    interpreter.setProperty(globalObject, 'highlightBlock', interpreter.createNativeFunction(wrapper));
    wrapper = async function(command, ...args) {
        try {
            $75d3d815980f42e1$var$pauseExecution();
            await $75d3d815980f42e1$var$simulation.run(command, ...args);
            $75d3d815980f42e1$var$executeProgram();
        } catch (e) {
            $75d3d815980f42e1$var$onProgramError(e);
        }
    };
    interpreter.setProperty(globalObject, 'robot', interpreter.createNativeFunction(wrapper));
}
var $75d3d815980f42e1$var$interpreter = null;
function $75d3d815980f42e1$var$compileProgram() {
    $75d3d815980f42e1$var$simulation.reset();
    const visible = false;
    $75d3d815980f42e1$var$simulation.resetSimObjects(visible);
    try {
        let code = $460Qg.JavaScript.workspaceToCode($75d3d815980f42e1$var$workspace);
        console.log(code);
        $75d3d815980f42e1$var$interpreter = new $kw6y2(code, $75d3d815980f42e1$var$simulationAPI);
    } catch (e) {
        $75d3d815980f42e1$var$onProgramError(e);
        throw e;
    }
}
function $75d3d815980f42e1$var$pauseExecution() {
    if ($75d3d815980f42e1$var$interpreter) $75d3d815980f42e1$var$interpreter.paused_ = true;
}
function $75d3d815980f42e1$var$executeProgram() {
    if (!$75d3d815980f42e1$var$interpreter) throw new Error('Program has not been compiled yet');
    (0, $cxq7w.disablePointerEvents)();
    (0, $29ZVX.remControledSimObject)();
    $75d3d815980f42e1$var$interpreter.paused_ = false;
    try {
        // Blocks are being executed until a block interacts with the robot, which will
        // pause execution until the robot is done and then calls run() again.
        // See simulationAPI above.
        let hasMore = $75d3d815980f42e1$var$interpreter.run();
        if (!hasMore) $75d3d815980f42e1$var$waitForPhysicsSim();
    } catch (e) {
        $75d3d815980f42e1$var$onProgramError(e);
    }
}
//Waits until physics are done
function $75d3d815980f42e1$var$waitForPhysicsSim() {
    if (!$75d3d815980f42e1$var$simulation.getPhysicsDone()) setTimeout(()=>{
        $75d3d815980f42e1$var$waitForPhysicsSim();
    }, 200);
    else $75d3d815980f42e1$var$onProgramFinished();
}
function $75d3d815980f42e1$var$onProgramError(e) {
    $75d3d815980f42e1$var$interpreter = null;
    $75d3d815980f42e1$var$workspace.highlightBlock(null);
    $75d3d815980f42e1$var$simulation.resetSimObjects(true);
    $75d3d815980f42e1$var$runButton.classList.remove('running');
    console.error('Program execution failed: ', e);
    (0, $gxi2A.popError)(e + '\n' + ($460Qg.Msg['SEE_CONSOLE'] || 'See console for additional details.'));
    (0, $cxq7w.enablePointerEvents)();
}
function $75d3d815980f42e1$var$onProgramFinished() {
    // The generator may add some finalizing code in generator.finish(code), but if we
    // got this far it is most likely not required. Previous commit has a version executing
    // These final statements.
    $75d3d815980f42e1$var$interpreter = null;
    $75d3d815980f42e1$var$workspace.highlightBlock(null);
    $75d3d815980f42e1$var$simulation.resetSimObjects(true);
    $75d3d815980f42e1$var$runButton.classList.remove('running');
    console.log('Execution finished');
    (0, $gxi2A.popSuccess)($460Qg.Msg['EXEC_SUCCESS'] || "Program finished");
    (0, $cxq7w.enablePointerEvents)();
}
//Determin if a add_sim_object-block was added or removed form the Blockly Workspace.
//If added, add a new 3D-object. If removed remove the 3D-object assosiated with the block.
function $75d3d815980f42e1$var$watchSpawnBlocks(event) {
    if ($460Qg.Events.BLOCK_CREATE === event.type) for(let i = 0; i < event.ids.length; i++){
        const newBlock = $75d3d815980f42e1$var$workspace.getBlockById(event.ids[i]);
        if (newBlock.type === 'add_sim_object') {
            const shape = newBlock.getFieldValue('OBJECT_SHAPE');
            const pose = newBlock.getInputTargetBlock('POSE');
            const color = newBlock.getInputTargetBlock('COLOUR');
            const scaleBlock = newBlock.getInputTargetBlock('SCALE');
            const fieldKeys = [
                'X',
                'Y',
                'Z',
                'ROLL',
                'PITCH',
                'YAW'
            ];
            let fieldValues = [];
            let pickedColor;
            let scale;
            if (pose != null) for(let i = 0; i < fieldKeys.length; i++)fieldValues.push(pose.getFieldValue(fieldKeys[i]));
            else fieldValues = undefined;
            if (color != null) {
                if (color.type === 'colour_picker') pickedColor = color.getFieldValue('COLOUR');
                if (color.type === 'colour_random') pickedColor = (0, $29ZVX.randomColour)();
            } else pickedColor = undefined;
            if (scaleBlock != null) scale = scaleBlock.getFieldValue('NUM');
            else scale = 1;
            (0, $29ZVX.addSimObject)(newBlock.id, fieldValues, pickedColor, shape, scale);
        }
    }
    if ($460Qg.Events.BLOCK_DELETE === event.type) (0, $29ZVX.remSimObjects)(event.ids);
}
$75d3d815980f42e1$var$workspace.addChangeListener($75d3d815980f42e1$var$watchSpawnBlocks);


// Initialize localization so it's immediately available
$.extend($.i18n.parser.emitter, {
    link: function(nodes) {
        let target = nodes[2] || "_blank";
        // requires the data-i18n tag to start with [html]
        return '<a href="' + nodes[1] + '" target ="' + target + '">' + nodes[0] + '</a>';
    }
});
$.i18n().load({
    'en': (0, (/*@__PURE__*/$parcel$interopDefault($5a09c60466480564$exports))),
    'de': (0, (/*@__PURE__*/$parcel$interopDefault($6413746d743b245e$exports)))
});
const $d6d19fb8b2c9490c$var$lang = (0, $gnVfA.getDesiredLanguage)();
$.i18n().locale = $d6d19fb8b2c9490c$var$lang;
// Localize the page
jQuery(document).ready(function() {
    $('body').i18n();
    $('.i18n-only').hide();
    $('.i18n-only.' + $d6d19fb8b2c9490c$var$lang).show();
    // In some caces localizations are saved as external resources
    let loadExternal = document.querySelectorAll('[load-i18n]');
    for(let i = loadExternal.length; i--;){
        let elem = loadExternal[i];
        let key = elem.getAttribute('load-i18n');
        let val = $.i18n(key);
        $(elem).load(val, function(res, status, xhr) {
            if (status == 'error') $(elem).append('Error: ' + xhr.status + ':: ' + xhr.statusText);
        });
    }
});
// Accordion handlers
let $d6d19fb8b2c9490c$var$accordions = document.getElementsByClassName("accordion");
function $d6d19fb8b2c9490c$var$setAccordionVisible(accordion, visible) {
    let panel = document.querySelector(accordion.getAttribute('panel'));
    if (visible) {
        // Calculate available space taking into account any already open active panels
        let maxHeight = Math.min(window.outerHeight, document.documentElement.clientHeight) - 60;
        maxHeight += $(panel.parentNode).find('.accordion-panel.active').height() || 0;
        // Subtract the height of all siblings of this node's parents
        let sibling = panel.parentNode.parentNode.firstElementChild;
        do maxHeight -= sibling.offsetHeight;
        while (sibling = sibling.nextElementSibling);
        maxHeight = Math.min(maxHeight, panel.scrollHeight);
        accordion.classList.add('active');
        panel.classList.add('active');
        panel.style.maxHeight = maxHeight + 'px';
    } else {
        accordion.classList.remove('active');
        panel.classList.remove('active');
        panel.style.maxHeight = null;
    }
}
for(let i = 0; i < $d6d19fb8b2c9490c$var$accordions.length; i++)$d6d19fb8b2c9490c$var$accordions[i].addEventListener("click", function(event) {
    event.stopPropagation();
    let show = !this.classList.contains('active');
    // Show the revealed panel first so that it can take already open panels into account 
    // before they become animated.
    $d6d19fb8b2c9490c$var$setAccordionVisible(this, show);
    for (let acc of $d6d19fb8b2c9490c$var$accordions)if (acc !== this) $d6d19fb8b2c9490c$var$setAccordionVisible(acc, false);
});
// Split panes
(0, $408146dfdc361670$export$2e2bcd8739ae039)([
    '#split-pane-1',
    '#split-pane-2'
], {
    minSize: 0,
    snapOffset: 20,
    gutterStyle: function(dim, size, index) {
        // return an empty style, we do everything in CSS
        return {};
    }
});
// Tabs
let $d6d19fb8b2c9490c$var$animDuration = 200;
function $d6d19fb8b2c9490c$var$getSplitpaneRatio() {
    return (0, $gnVfA.isNarrowScreen)() ? 100 : 50;
}
// On narrow screens show a full pane
if ((0, $gnVfA.isNarrowScreen)()) {
    // If not hidden the initial expansion will not work correctly
    $('#split-pane-1').hide();
    $('#split-pane-2').css('width', '100%');
}
$('#blocks-btn').on('click', (evt)=>{
    let view = $('#split-pane-2');
    if (view.width() > 0) {
        // Shrink blocks view to 0, expand 3D view
        view.animate({
            width: 0
        }, $d6d19fb8b2c9490c$var$animDuration);
        $('#split-pane-1').show().animate({
            width: '100%'
        }, $d6d19fb8b2c9490c$var$animDuration);
    // GUI.hide();
    } else {
        // Expand blocks view to targetRatio, 3D view will take up the rest
        let targetRatio = $d6d19fb8b2c9490c$var$getSplitpaneRatio();
        view.animate({
            width: targetRatio + '%'
        }, $d6d19fb8b2c9490c$var$animDuration);
        $('#split-pane-1').animate({
            width: 100 - targetRatio + '%'
        }, $d6d19fb8b2c9490c$var$animDuration);
    // GUI.show();
    }
});
$('#viewport-btn').on('click', (evt)=>{
    let view = $('#split-pane-1');
    if (view.width() > 0) {
        // Shrink 3D view to 0, expand blocks view
        view.animate({
            width: 0
        }, $d6d19fb8b2c9490c$var$animDuration);
        $('#split-pane-2').show().animate({
            width: '100%'
        }, $d6d19fb8b2c9490c$var$animDuration);
    // GUI.show();
    } else {
        // Expand 3D view to targetRatio, blocks view will take up the rest
        let targetRatio = $d6d19fb8b2c9490c$var$getSplitpaneRatio();
        view.animate({
            width: targetRatio + '%'
        }, $d6d19fb8b2c9490c$var$animDuration);
        $('#split-pane-2').animate({
            width: 100 - targetRatio + '%'
        }, $d6d19fb8b2c9490c$var$animDuration);
    // GUI.hide();
    }
});
// Add prev/next buttons to each tutorial slide
let $d6d19fb8b2c9490c$var$slides = $('#tutorial-container .tutorial-slide');
$d6d19fb8b2c9490c$var$slides.each((idx, elem)=>{
    let prev = idx === 0 ? $d6d19fb8b2c9490c$var$slides.length - 1 : idx - 1;
    let next = idx === $d6d19fb8b2c9490c$var$slides.length - 1 ? 0 : idx + 1;
    // <label for="tutorial-radio-1" class="prev"></label>
    let prevLabel = document.createElement('label');
    prevLabel.setAttribute('for', 'tutorial-radio-' + prev);
    prevLabel.classList.add('prev');
    // <label for="tutorial-radio-3" class="prev"></label>
    let nextLabel = document.createElement('label');
    nextLabel.setAttribute('for', 'tutorial-radio-' + next);
    nextLabel.classList.add('next');
    elem.appendChild(prevLabel);
    elem.appendChild(nextLabel);
});
$('#tutorial-btn').on('click', (evt)=>{
    $('#tutorial-container').show();
    $('#robot-gui').hide();
});
$('#tutorial-close-btn').on('click', (evt)=>{
    $('#tutorial-container').hide();
    $('#robot-gui').show();
    $('.tutorial-slide video').each((idx, video)=>{
        // Unload the video to save some resources
        video.pause();
        video.removeAttribute('src');
        video.load();
    });
});
$('#about-btn').on('click', (evt)=>{
    $('#robot-gui').hide();
    $('#about-lightbox').show();
});
$('#about-lightbox').click(function(evt) {
    // Only react to clicks outside #about-box
    let box = $('#about-box');
    if (box.is(evt.target) || box.has(evt.target).length > 0) return;
    let about = $('#about-lightbox');
    about.hide();
    $('#robot-gui').show();
    // Close all about section accordions
    for (let acc of $d6d19fb8b2c9490c$var$accordions)if (about.find(acc).length) $d6d19fb8b2c9490c$var$setAccordionVisible(acc, false);
});
// Hide the first time hint on the first click anywhere
$('body').on('click.first-time-hint', (evt)=>{
    $('#first-time-hint').hide();
    $(undefined).off('click.first-time-hint');
});
// Lazy loads everything with css class 'lozad', e.g. tutorial videos
const $d6d19fb8b2c9490c$var$lazyObserver = (0, (/*@__PURE__*/$parcel$interopDefault($2192b685fd074ac6$exports)))();
$d6d19fb8b2c9490c$var$lazyObserver.observe();
// Warn user before navigating away
window.onbeforeunload = function() {
    return (0, $gnVfA.localize)('warn-unsaved');
};
// Hide our URL hint if we are not inside an iframe
try {
    // Will fail because of cross origin access if we're inside an iframe - in that 
    // case we want the message to stay
    if (document.location.hostname == window.parent.location.hostname) $('#iframe-notice').hide();
} catch (e) {}

})();
//# sourceMappingURL=Rocksi.43ac67e7.js.map
